{
    "20": {
      "PGN": 65172,
      "PGN_Name": "Engine Auxiliary Coolant",
      "PGN_Description": "EAC",
      "first_bit": 24,
      "SPN": 20,
      "SPN_Name": "Engine Coolant Pressure 1 (Extended Range)",
      "SPN_Description": "Gage pressure of liquid found in engine cooling system.\r\n\r\nSee also SPN 109 for alternate range and resolution.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "22": {
      "PGN": 65263,
      "PGN_Name": "Engine Fluid Level/Pressure 1",
      "PGN_Description": "EFL/P1",
      "first_bit": 8,
      "SPN": 22,
      "SPN_Name": "Engine Extended Crankcase Blow-by Pressure",
      "SPN_Description": "Differential crankcase blow-by pressure as measured through a tube with a venturi. \r\n\r\n(SPN 1264 is not to be used – obsolete)",
      "bit_length": 8,
      "scaling": 0.05,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 48
    },
    "27": {
      "PGN": 64916,
      "PGN_Name": "Electronic Engine Controller 7",
      "PGN_Description": "EEC7",
      "first_bit": 0,
      "SPN": 27,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Valve Position",
      "SPN_Description": "The position of the exhaust gas recirculation valve expressed as a percentage of full travel. Zero percent means the valve is closed and no exhaust gas is flowing into the intake air stream. One hundred percent means the valve is fully opened.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "28": {
      "PGN": 3072,
      "PGN_Name": "Electronic Engine Controller 16",
      "PGN_Description": "EEC16",
      "first_bit": 0,
      "SPN": 28,
      "SPN_Name": "Accelerator Pedal Position 3",
      "SPN_Description": "The ratio of actual position of the third analog engine speed/torque request input device (such as an accelerator pedal or throttle lever) to the maximum position of the input device.  This parameter is intended for the third accelerator control in an application.  If an application has only one accelerator control, use SPN 91.    \r\n.\r\nIn marine applications, this will typically be the operator’s third throttle lever.\r\n\r\nIf a low idle validation switch is used in conjunction with accelerator pedal position 3, use Accelerator Pedal Low Idle Switch 3, SPN 2971.\r\n\r\nNOTE—See SPNs 91 and 974 for additional accelerator position parameters.  SPN 28 is an additional SPN for accelerator position.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "29": {
      "PGN": 61443,
      "PGN_Name": "Electronic Engine Controller 2",
      "PGN_Description": "EEC2",
      "first_bit": 32,
      "SPN": 29,
      "SPN_Name": "Accelerator Pedal Position 2",
      "SPN_Description": "The ratio of actual position of the second analog engine speed/torque request input device (such as an accelerator pedal or throttle lever) to the maximum position of the input device.  This parameter is intended for secondary accelerator control in an application.  If an application has only one accelerator control, use SPN 91.    \r\n\r\nIn marine applications, this will typically be the operator’s second throttle lever.\r\n\r\nIf a low idle validation switch is used in conjunction with accelerator pedal position 2, use Accelerator Pedal Low Idle Switch 2, SPN 2970.\r\n\r\nNOTE—See SPNs 91 and 974 for additional accelerator position parameters.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "38": {
      "PGN": 65276,
      "PGN_Name": "Dash Display 1",
      "PGN_Description": "DD1",
      "first_bit": 48,
      "SPN": 38,
      "SPN_Name": "Fuel Level 2",
      "SPN_Description": "Ratio of volume of fuel to the total volume of fuel in the second or right-side storage container.  When Fuel Level 2 is not used, Fuel Level 1 (SPN 96) represents the total fuel in all fuel storage containers.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "39": {
      "PGN": 65144,
      "PGN_Name": "Tire Pressure Control Unit Mode and Status",
      "PGN_Description": "TP1",
      "first_bit": 0,
      "SPN": 39,
      "SPN_Name": "Tire Pressure Check Interval",
      "SPN_Description": "The interval at which the system will check the tire pressures (e.g., 5, 10, 15 min.).\r\n\r\nNOTE - A value of 0 indicates continuous (real time) pressure readings.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "min",
      "SLOT_ID": 61
    },
    "46": {
      "PGN": 65198,
      "PGN_Name": "Air Supply Pressure",
      "PGN_Description": "AIR1",
      "first_bit": 0,
      "SPN": 46,
      "SPN_Name": "Pneumatic Supply Pressure",
      "SPN_Description": "The pneumatic pressure in the main reservoir, sometimes referred to as the wet tank.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "51": {
      "PGN": 65266,
      "PGN_Name": "Fuel Economy (Liquid)",
      "PGN_Description": "LFE1",
      "first_bit": 48,
      "SPN": 51,
      "SPN_Name": "Engine Throttle Valve 1 Position 1",
      "SPN_Description": "The position of the valve used to regulate the supply of a fluid, usually air or fuel/air mixture, to an engine.  0% represents no supply and 100% is full supply.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "52": {
      "PGN": 65262,
      "PGN_Name": "Engine Temperature 1",
      "PGN_Description": "ET1",
      "first_bit": 48,
      "SPN": 52,
      "SPN_Name": "Engine Intercooler Temperature",
      "SPN_Description": "Temperature of liquid found in the intercooler located after the turbocharger.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "53": {
      "PGN": 65221,
      "PGN_Name": "Electronic Transmission Controller 4",
      "PGN_Description": "ETC4",
      "first_bit": 0,
      "SPN": 53,
      "SPN_Name": "Transmission Synchronizer Clutch Value",
      "SPN_Description": "The current modulated value for the air supply to the synchronizer clutch.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "54": {
      "PGN": 65221,
      "PGN_Name": "Electronic Transmission Controller 4",
      "PGN_Description": "ETC4",
      "first_bit": 8,
      "SPN": 54,
      "SPN_Name": "Transmission Synchronizer Brake Value",
      "SPN_Description": "The current modulated value for the air supply to the synchronizer brake.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "59": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 0,
      "SPN": 59,
      "SPN_Name": "Transmission Shift Finger Gear Position",
      "SPN_Description": "The current position of the shift finger in the gear direction.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "60": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 8,
      "SPN": 60,
      "SPN_Name": "Transmission Shift Finger Rail Position",
      "SPN_Description": "The current position of the shift finger in the rail direction.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "69": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 0,
      "SPN": 69,
      "SPN_Name": "Two Speed Axle Switch",
      "SPN_Description": "Switch signal which indicates the current axle range.\r\n\r\n00 - Low speed range\r\n01 - High speed range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "70": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 2,
      "SPN": 70,
      "SPN_Name": "Parking Brake Switch",
      "SPN_Description": "Switch signal which indicates when the parking brake is set. In general the switch actuated by the operator's park brake control, whether a pedal, lever or other control mechanism  (see also SPN 619 and 5275).\r\n\r\n00 - Parking brake not set\r\n01 - Parking brake set\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "72": {
      "PGN": 65277,
      "PGN_Name": "Alternate Fuel 1",
      "PGN_Description": "AF1",
      "first_bit": 0,
      "SPN": 72,
      "SPN_Name": "Engine Blower Bypass Valve Position",
      "SPN_Description": "Relative position of the blower bypass valve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "73": {
      "PGN": 65278,
      "PGN_Name": "Auxiliary Water Pump Pressure",
      "PGN_Description": "AWPP",
      "first_bit": 0,
      "SPN": 73,
      "SPN_Name": "Auxiliary Pump Pressure",
      "SPN_Description": "Gage pressure of auxiliary water pump driven as a PTO device.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 49
    },
    "74": {
      "PGN": 65261,
      "PGN_Name": "Cruise Control/Vehicle Speed Setup",
      "PGN_Description": "CCSS",
      "first_bit": 0,
      "SPN": 74,
      "SPN_Name": "Maximum Vehicle Speed Limit",
      "SPN_Description": "Maximum vehicle velocity allowed.   See SPN 6808 for an alternate resolution.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 73
    },
    "75": {
      "PGN": 65273,
      "PGN_Name": "Axle Information",
      "PGN_Description": "AI",
      "first_bit": 0,
      "SPN": 75,
      "SPN_Name": "Steering Axle Temperature",
      "SPN_Description": "Temperature of lubricant in steering axle.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "79": {
      "PGN": 65269,
      "PGN_Name": "Ambient Conditions",
      "PGN_Description": "AMB",
      "first_bit": 48,
      "SPN": 79,
      "SPN_Name": "Road Surface Temperature",
      "SPN_Description": "Indicated temperature of road surface over which vehicle is operating.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "80": {
      "PGN": 65276,
      "PGN_Name": "Dash Display 1",
      "PGN_Description": "DD1",
      "first_bit": 0,
      "SPN": 80,
      "SPN_Name": "Washer Fluid Level",
      "SPN_Description": "Ratio of volume of liquid to total container volume of fluid reservoir in windshield wash system.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "81": {
      "PGN": 65270,
      "PGN_Name": "Intake/Exhaust Conditions 1",
      "PGN_Description": "IC1",
      "first_bit": 0,
      "SPN": 81,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Intake Pressure (use SPN 3609)",
      "SPN_Description": "Exhaust pressure as a result of particle accumulation on filter media placed in the exhaust stream.  It is recommended that SPN 3609 be used as it has better resolution.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 54
    },
    "82": {
      "PGN": 65246,
      "PGN_Name": "Engine Air Start Pressure",
      "PGN_Description": "AIR2",
      "first_bit": 0,
      "SPN": 82,
      "SPN_Name": "Engine Air Start Pressure",
      "SPN_Description": "Gage pressure of air in an engine starting system that utilizes compressed air to provide the force required to rotate the crankshaft.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "84": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 8,
      "SPN": 84,
      "SPN_Name": "Wheel-Based Vehicle Speed",
      "SPN_Description": "Speed of the vehicle as calculated from wheel or tailshaft speed.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 71
    },
    "86": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 40,
      "SPN": 86,
      "SPN_Name": "Cruise Control Set Speed",
      "SPN_Description": "Value of set (chosen) velocity of velocity control system.  See SPN 6809 for an alternate resolution.\r\n\r\nIf an algorithm that can modify the cruise control set point exists in the system, such as Predictive Cruise Control or Adaptive Cruise Control, then Cruise Control Set Speed (SPN 86) will not include the speed adjustment made by that algorithm. For the parameter that includes the adjustment, see Cruise Control Speed (SPN 7319) for the final speed used by the cruise control algorithm.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 73
    },
    "87": {
      "PGN": 65261,
      "PGN_Name": "Cruise Control/Vehicle Speed Setup",
      "PGN_Description": "CCSS",
      "first_bit": 8,
      "SPN": 87,
      "SPN_Name": "Cruise Control High Set Limit Speed",
      "SPN_Description": "Maximum vehicle velocity at which cruise can be set.\r\n\r\nIf Cruise Control Adjusted Maximum Speed (SPN 7495) is supported, then SPN 7495 has priority over SPN 87. See the definition for SPN 7495 for more details.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 73
    },
    "88": {
      "PGN": 65261,
      "PGN_Name": "Cruise Control/Vehicle Speed Setup",
      "PGN_Description": "CCSS",
      "first_bit": 16,
      "SPN": 88,
      "SPN_Name": "Cruise Control Low Set Limit Speed",
      "SPN_Description": "Minimum vehicle velocity at which cruise can be set or minimum vehicle velocity for cruise operation before it will exit cruise control operation.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 73
    },
    "90": {
      "PGN": 65264,
      "PGN_Name": "Power Takeoff Information",
      "PGN_Description": "PTO",
      "first_bit": 0,
      "SPN": 90,
      "SPN_Name": "Power Takeoff Oil Temperature",
      "SPN_Description": "Temperature of lubricant in device used to transmit engine power to auxiliary equipment.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "91": {
      "PGN": 61443,
      "PGN_Name": "Electronic Engine Controller 2",
      "PGN_Description": "EEC2",
      "first_bit": 8,
      "SPN": 91,
      "SPN_Name": "Accelerator Pedal Position 1",
      "SPN_Description": "The ratio of actual position of the analog engine speed/torque request input device (such as an accelerator pedal or throttle lever) to the maximum position of the input device.  This parameter is intended for the primary accelerator control in an application.  If an application has only one accelerator control, use SPN 91.    \r\n\r\nFor on-highway vehicles, this will typically be the operator’s accelerator pedal.  Although it is used as an input to determine powertrain demand, it also provides anticipatory information to transmission and ASR algorithms about driver actions.\r\n\r\nIn marine applications, this will typically be the operator’s throttle lever.\r\n\r\nIf a low idle validation switch is used in conjunction with accelerator pedal position 1, use Accelerator Pedal Low Idle Switch 1, SPN 558.\r\n\r\nNOTE—See SPNs 29 and 974 for additional accelerator position parameters.  SPN 28 is an additional diagnostic SPN for accelerator position.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "92": {
      "PGN": 61443,
      "PGN_Name": "Electronic Engine Controller 2",
      "PGN_Description": "EEC2",
      "first_bit": 16,
      "SPN": 92,
      "SPN_Name": "Engine Percent Load At Current Speed",
      "SPN_Description": "The ratio of actual engine percent torque (indicated) to maximum indicated torque available at the current engine speed, clipped to zero torque during engine braking.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "94": {
      "PGN": 65263,
      "PGN_Name": "Engine Fluid Level/Pressure 1",
      "PGN_Description": "EFL/P1",
      "first_bit": 0,
      "SPN": 94,
      "SPN_Name": "Engine Fuel Delivery Pressure",
      "SPN_Description": "Gage pressure of fuel in system as delivered from supply pump to the injection pump.  See SPN 7469 for alternate resolution.\r\n\r\nSee also SPN 5578 for Fuel Delivery Absolute Pressure.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "95": {
      "PGN": 65276,
      "PGN_Name": "Dash Display 1",
      "PGN_Description": "DD1",
      "first_bit": 16,
      "SPN": 95,
      "SPN_Name": "Engine Fuel Filter Differential Pressure",
      "SPN_Description": "Change in fuel delivery pressure, measured across the filter, due to accumulation of solid or semisolid matter on the filter element.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "96": {
      "PGN": 65276,
      "PGN_Name": "Dash Display 1",
      "PGN_Description": "DD1",
      "first_bit": 8,
      "SPN": 96,
      "SPN_Name": "Fuel Level 1",
      "SPN_Description": "Ratio of volume of fuel to the total volume of fuel storage container.\r\n\r\nWhen Fuel Level 2 (SPN 38) is not used, Fuel Level 1 represents the total fuel in all fuel storage containers.  When Fuel Level 2 is used, Fuel Level 1 represents the fuel level in the primary or left-side fuel storage container.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "97": {
      "PGN": 65279,
      "PGN_Name": "Operator indicators",
      "PGN_Description": "OI",
      "first_bit": 0,
      "SPN": 97,
      "SPN_Name": "Water In Fuel Indicator 1",
      "SPN_Description": "Signal which indicates the presence of water in the fuel.\r\n\r\n00 - No\r\n01 - Yes\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "98": {
      "PGN": 65263,
      "PGN_Name": "Engine Fluid Level/Pressure 1",
      "PGN_Description": "EFL/P1",
      "first_bit": 16,
      "SPN": 98,
      "SPN_Name": "Engine Oil Level",
      "SPN_Description": "Ratio of current volume of engine sump oil to maximum required volume.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "99": {
      "PGN": 65276,
      "PGN_Name": "Dash Display 1",
      "PGN_Description": "DD1",
      "first_bit": 24,
      "SPN": 99,
      "SPN_Name": "Engine Oil Filter Differential Pressure",
      "SPN_Description": "Change in engine oil pressure, measured across the filter, due to the filter and any accumulation of solid or semisolid material on or in the filter.  See SPN 7471 for alternate resolution.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 54
    },
    "100": {
      "PGN": 65263,
      "PGN_Name": "Engine Fluid Level/Pressure 1",
      "PGN_Description": "EFL/P1",
      "first_bit": 24,
      "SPN": 100,
      "SPN_Name": "Engine Oil Pressure",
      "SPN_Description": "Gage pressure of oil in engine lubrication system as provided by oil pump.  See SPN 7468 for alternate resolution.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "101": {
      "PGN": 65263,
      "PGN_Name": "Engine Fluid Level/Pressure 1",
      "PGN_Description": "EFL/P1",
      "first_bit": 32,
      "SPN": 101,
      "SPN_Name": "Engine Crankcase Pressure 1",
      "SPN_Description": "First instance of the gage pressure inside engine crankcase.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "kPa",
      "SLOT_ID": 52
    },
    "102": {
      "PGN": 65270,
      "PGN_Name": "Intake/Exhaust Conditions 1",
      "PGN_Description": "IC1",
      "first_bit": 8,
      "SPN": 102,
      "SPN_Name": "Engine Intake Manifold #1 Pressure",
      "SPN_Description": "The gage pressure measurement of the air intake manifold. If there are multiple air pressure sensors in the intake stream, this is the last one in flow direction before entering the combustion chamber.  This should be the pressure used to drive gauges and displays. See also SPNs 1127-1130 and SPN 3562  for alternate range and resolution. If there is only one pressure measurement of the air intake manifold to report and this range and resolution is adequate, this parameter should be used.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "103": {
      "PGN": 65245,
      "PGN_Name": "Turbocharger",
      "PGN_Description": "TC",
      "first_bit": 8,
      "SPN": 103,
      "SPN_Name": "Engine Turbocharger 1 Speed",
      "SPN_Description": "Rotational velocity of rotor in the turbocharger.",
      "bit_length": 16,
      "scaling": 4,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 77
    },
    "104": {
      "PGN": 65245,
      "PGN_Name": "Turbocharger",
      "PGN_Description": "TC",
      "first_bit": 0,
      "SPN": 104,
      "SPN_Name": "Engine Turbocharger Lube Oil Pressure 1",
      "SPN_Description": "Gage pressure of oil in turbocharger lubrication system.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "105": {
      "PGN": 65270,
      "PGN_Name": "Intake/Exhaust Conditions 1",
      "PGN_Description": "IC1",
      "first_bit": 16,
      "SPN": 105,
      "SPN_Name": "Engine Intake Manifold 1 Temperature",
      "SPN_Description": "Temperature of pre-combustion air found in intake manifold of engine air supply system.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "106": {
      "PGN": 65270,
      "PGN_Name": "Intake/Exhaust Conditions 1",
      "PGN_Description": "IC1",
      "first_bit": 24,
      "SPN": 106,
      "SPN_Name": "Engine Intake Air Pressure",
      "SPN_Description": "Absolute air pressure at input port to intake manifold or air box.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "107": {
      "PGN": 65270,
      "PGN_Name": "Intake/Exhaust Conditions 1",
      "PGN_Description": "IC1",
      "first_bit": 32,
      "SPN": 107,
      "SPN_Name": "Engine Air Filter 1 Differential Pressure",
      "SPN_Description": "Change in engine air system pressure, measured across the filter, due to the filter and any accumulation of solid foreign matter on or in the filter.\r\n\r\nThis is the measurement of the first filter in a multiple air filter system.  In a single air filter application, this is the only SPN used. Filter numbering follows the guidelines noted in section, Naming Convention For Engine Parameters.",
      "bit_length": 8,
      "scaling": 0.05,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 48
    },
    "108": {
      "PGN": 65269,
      "PGN_Name": "Ambient Conditions",
      "PGN_Description": "AMB",
      "first_bit": 0,
      "SPN": 108,
      "SPN_Name": "Barometric Pressure",
      "SPN_Description": "Absolute air pressure of the atmosphere.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 54
    },
    "109": {
      "PGN": 65263,
      "PGN_Name": "Engine Fluid Level/Pressure 1",
      "PGN_Description": "EFL/P1",
      "first_bit": 48,
      "SPN": 109,
      "SPN_Name": "Engine Coolant Pressure 1",
      "SPN_Description": "Gage pressure of liquid found in engine cooling system.\r\n\r\nSee SPN 20 for alternate range and resolution.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "110": {
      "PGN": 65262,
      "PGN_Name": "Engine Temperature 1",
      "PGN_Description": "ET1",
      "first_bit": 0,
      "SPN": 110,
      "SPN_Name": "Engine Coolant Temperature",
      "SPN_Description": "Temperature of liquid found in engine cooling system.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "111": {
      "PGN": 65263,
      "PGN_Name": "Engine Fluid Level/Pressure 1",
      "PGN_Description": "EFL/P1",
      "first_bit": 56,
      "SPN": 111,
      "SPN_Name": "Engine Coolant Level 1",
      "SPN_Description": "Ratio of volume of liquid found in engine cooling system to total cooling system volume.  Typical monitoring location is in the coolant expansion tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "112": {
      "PGN": 65270,
      "PGN_Name": "Intake/Exhaust Conditions 1",
      "PGN_Description": "IC1",
      "first_bit": 56,
      "SPN": 112,
      "SPN_Name": "Engine Coolant Filter Differential Pressure",
      "SPN_Description": "Change in coolant pressure, measured across the filter, due to the filter and any accumulation of solid or semisolid matter on or in the filter.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 54
    },
    "114": {
      "PGN": 65271,
      "PGN_Name": "Vehicle Electrical Power 1",
      "PGN_Description": "VEP1",
      "first_bit": 0,
      "SPN": 114,
      "SPN_Name": "SLI Battery 1 Net Current",
      "SPN_Description": "Net flow of electrical current into/out of the first battery or first set of batteries used for starting the engine, for lighting, and for ignition (SLI).  If more than one battery is included in the first set of batteries and the net current for each battery is desired, then SPNs 7900, 7908, 7916, & 7924 shall be used.\r\n\r\nSee SPN 2579 for alternate range and resolution.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "A",
      "SLOT_ID": 40
    },
    "115": {
      "PGN": 65271,
      "PGN_Name": "Vehicle Electrical Power 1",
      "PGN_Description": "VEP1",
      "first_bit": 8,
      "SPN": 115,
      "SPN_Name": "Alternator Current",
      "SPN_Description": "Measure of electrical current flow from the alternator.  Alternator Current (High Range/Resolution) parameter SPN 1795 has a higher range and resolution of the same parameter.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 41
    },
    "116": {
      "PGN": 65274,
      "PGN_Name": "Brakes 1",
      "PGN_Description": "B1",
      "first_bit": 0,
      "SPN": 116,
      "SPN_Name": "Brake Application Pressure",
      "SPN_Description": "Gage pressure of compressed air or fluid in vehicle braking system measured at the brake chamber when brake shoe (or pad) is placed against brake drum (or disc).",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "117": {
      "PGN": 65274,
      "PGN_Name": "Brakes 1",
      "PGN_Description": "B1",
      "first_bit": 8,
      "SPN": 117,
      "SPN_Name": "Brake Primary Pressure",
      "SPN_Description": "Gage pressure of air in the primary, or supply side, of the air brake system.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "118": {
      "PGN": 65274,
      "PGN_Name": "Brakes 1",
      "PGN_Description": "B1",
      "first_bit": 16,
      "SPN": 118,
      "SPN_Name": "Brake Secondary Pressure",
      "SPN_Description": "Gage pressure of air in the secondary, or service side, of the air brake system.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "119": {
      "PGN": 65275,
      "PGN_Name": "Retarder fluids",
      "PGN_Description": "RF",
      "first_bit": 0,
      "SPN": 119,
      "SPN_Name": "Hydraulic Retarder Pressure",
      "SPN_Description": "Gage pressure of oil in hydraulic retarder system.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 49
    },
    "120": {
      "PGN": 65275,
      "PGN_Name": "Retarder fluids",
      "PGN_Description": "RF",
      "first_bit": 8,
      "SPN": 120,
      "SPN_Name": "Hydraulic Retarder Oil Temperature",
      "SPN_Description": "Temperature of oil found in a hydraulic retarder.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "123": {
      "PGN": 65272,
      "PGN_Name": "Transmission Fluids 1",
      "PGN_Description": "TRF1",
      "first_bit": 0,
      "SPN": 123,
      "SPN_Name": "Clutch Pressure",
      "SPN_Description": "Gage pressure of oil within a wet clutch.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 49
    },
    "124": {
      "PGN": 65272,
      "PGN_Name": "Transmission Fluids 1",
      "PGN_Description": "TRF1",
      "first_bit": 8,
      "SPN": 124,
      "SPN_Name": "Transmission Oil Level 1",
      "SPN_Description": "First instance of a transmission oil level indicator. Conveys the ratio of volume of transmission sump oil to recommended volume.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "126": {
      "PGN": 65272,
      "PGN_Name": "Transmission Fluids 1",
      "PGN_Description": "TRF1",
      "first_bit": 16,
      "SPN": 126,
      "SPN_Name": "Transmission Filter Differential Pressure",
      "SPN_Description": "Change in transmission fluid pressure, measured after the filter, due to accumulation of solid or semisolid material on or in the filter.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "127": {
      "PGN": 65272,
      "PGN_Name": "Transmission Fluids 1",
      "PGN_Description": "TRF1",
      "first_bit": 24,
      "SPN": 127,
      "SPN_Name": "Transmission Oil Pressure",
      "SPN_Description": "Gage pressure of lubrication fluid in transmission, measured after pump.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 49
    },
    "132": {
      "PGN": 61450,
      "PGN_Name": "Engine Gas Flow Rate",
      "PGN_Description": "EGF1",
      "first_bit": 16,
      "SPN": 132,
      "SPN_Name": "Engine Intake Air Mass Flow Rate",
      "SPN_Description": "Mass flow rate of fresh air entering the engine air intake, before any EGR mixer, if used.  Flow rate of fresh air conducted to the engine cylinders to support combustion.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "kg/h",
      "SLOT_ID": 18
    },
    "136": {
      "PGN": 65143,
      "PGN_Name": "Auxiliary Pressures",
      "PGN_Description": "AP",
      "first_bit": 0,
      "SPN": 136,
      "SPN_Name": "Auxiliary Vacuum Pressure Reading",
      "SPN_Description": "Identifies the current vacuum pressure (relative to atmosphere) that is configured uniquely per application.  Not to be used in place of defined parameters.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "137": {
      "PGN": 65143,
      "PGN_Name": "Auxiliary Pressures",
      "PGN_Description": "AP",
      "first_bit": 16,
      "SPN": 137,
      "SPN_Name": "Auxiliary Gage Pressure Reading 1",
      "SPN_Description": "Identifies the current gage pressure (relative to atmosphere) that is configured uniquely per application.  Not to be used in place of defined parameters.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "138": {
      "PGN": 65143,
      "PGN_Name": "Auxiliary Pressures",
      "PGN_Description": "AP",
      "first_bit": 32,
      "SPN": 138,
      "SPN_Name": "Auxiliary Absolute Pressure Reading",
      "SPN_Description": "Identifies the current absolute pressure (relative to 0 pressure) that is configured uniquely per application.  Not to be used in place of defined parameters.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "141": {
      "PGN": 65145,
      "PGN_Name": "Tire Pressure Control Unit Target Pressures",
      "PGN_Description": "TP2",
      "first_bit": 0,
      "SPN": 141,
      "SPN_Name": "Trailer, Tag Or Push Channel Tire Pressure Target",
      "SPN_Description": "The tire pressure control system’s target gage pressure for the trailer, tag, or push group of tires.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "142": {
      "PGN": 65145,
      "PGN_Name": "Tire Pressure Control Unit Target Pressures",
      "PGN_Description": "TP2",
      "first_bit": 16,
      "SPN": 142,
      "SPN_Name": "Drive Channel Tire Pressure Target",
      "SPN_Description": "The tire pressure control system’s target gage pressure for the drive group of tires.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "143": {
      "PGN": 65145,
      "PGN_Name": "Tire Pressure Control Unit Target Pressures",
      "PGN_Description": "TP2",
      "first_bit": 32,
      "SPN": 143,
      "SPN_Name": "Steer Channel Tire Pressure Target",
      "SPN_Description": "The tire pressure control system’s target gage pressure for the steer group of tires.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "144": {
      "PGN": 65146,
      "PGN_Name": "Tire Pressure Control Unit Current Pressures",
      "PGN_Description": "TP3",
      "first_bit": 0,
      "SPN": 144,
      "SPN_Name": "Trailer, Tag Or Push Channel Tire Pressure",
      "SPN_Description": "The latest gage pressure reading of the trailer, tag, or push group of tires, as opposed to the pressure in each tire.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "145": {
      "PGN": 65146,
      "PGN_Name": "Tire Pressure Control Unit Current Pressures",
      "PGN_Description": "TP3",
      "first_bit": 16,
      "SPN": 145,
      "SPN_Name": "Drive Channel Tire Pressure",
      "SPN_Description": "The latest gage pressure reading of the drive group of tires, as opposed to the pressure in each tire.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "146": {
      "PGN": 65146,
      "PGN_Name": "Tire Pressure Control Unit Current Pressures",
      "PGN_Description": "TP3",
      "first_bit": 32,
      "SPN": 146,
      "SPN_Name": "Steer Channel Tire Pressure",
      "SPN_Description": "The latest gage pressure reading of the steer group of tires, as opposed to the pressure in each tire.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "156": {
      "PGN": 65243,
      "PGN_Name": "Engine Fluid Level/Pressure 2",
      "PGN_Description": "EFL/P2",
      "first_bit": 32,
      "SPN": 156,
      "SPN_Name": "Engine Fuel 1 Injector Timing Rail 1 Pressure",
      "SPN_Description": "The gage pressure of fuel in the timing rail delivered from the supply pump to the injector timing intake.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 51
    },
    "157": {
      "PGN": 65243,
      "PGN_Name": "Engine Fluid Level/Pressure 2",
      "PGN_Description": "EFL/P2",
      "first_bit": 16,
      "SPN": 157,
      "SPN_Name": "Engine Fuel 1 Injector Metering Rail 1 Pressure",
      "SPN_Description": "The gage pressure of fuel in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 51
    },
    "158": {
      "PGN": 65271,
      "PGN_Name": "Vehicle Electrical Power 1",
      "PGN_Description": "VEP1",
      "first_bit": 48,
      "SPN": 158,
      "SPN_Name": "Key Switch Battery Potential",
      "SPN_Description": "Battery potential measured at the input of the electronic control unit supplied through a key switch or similar switching device.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "159": {
      "PGN": 65277,
      "PGN_Name": "Alternate Fuel 1",
      "PGN_Description": "AF1",
      "first_bit": 8,
      "SPN": 159,
      "SPN_Name": "Engine Gaseous Fuel Supply Pressure 1",
      "SPN_Description": "Gage pressure of gaseous fuel supply to fuel metering device.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "160": {
      "PGN": 61538,
      "PGN_Name": "Electronic Transmission Controller #12",
      "PGN_Description": "ETC12",
      "first_bit": 48,
      "SPN": 160,
      "SPN_Name": "Transmission Intermediate Shaft Speed",
      "SPN_Description": "Rotational velocity of the first intermediate shaft of the transmission.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "161": {
      "PGN": 61442,
      "PGN_Name": "Electronic Transmission Controller 1",
      "PGN_Description": "ETC1",
      "first_bit": 40,
      "SPN": 161,
      "SPN_Name": "Transmission Input Shaft Speed",
      "SPN_Description": "Rotational velocity of the primary shaft transferring power into the transmission.  When a torque converter is present, it is the output of the torque converter.\r\n\r\nNote:\r\n\r\nSingle input shaft transmissions should use SPN 161 (Transmission Input Shaft Speed).\r\nMultiple input shaft transmissions should use SPN 5960 and 5961 (DCT Input Shaft 1 and 2 Speeds).\r\n\r\nFor maximum compatibility, a multiple input shaft speed transmission may also broadcast SPN 161 as a\r\nvirtual or current inputshaft speed with the following logic:\r\n\r\nTransmission Input Shaft Speed = DCT Input Shaft 1 Speed when shaft 1 is engaged.\r\nTransmission Input Shaft Speed = DCT Input Shaft 2 Speed when shaft 2 is engaged.\r\nTransmission Input Shaft Speed = Transitional interpolated value when shifting between shaft 1 and 2.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "162": {
      "PGN": 61445,
      "PGN_Name": "Electronic Transmission Controller 2",
      "PGN_Description": "ETC2",
      "first_bit": 32,
      "SPN": 162,
      "SPN_Name": "Transmission Requested Range",
      "SPN_Description": "Range selected by the operator.  Characters may include P, Rx, Rx-1...R2, R1, R, Nx, Nx-1...N2, N1, N, D, D1, D2..., Dx, L, L1, L2..., Lx-1, 1, 2, 3,...  If only one displayed character is required, the second character shall be used and the first character shall be a space (ASCII 32) or a control character (ASCII 0 to 31).  If the first character is a control character, refer to the manufacturer’s application document for definition.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "ASCII",
      "SLOT_ID": 131
    },
    "163": {
      "PGN": 61445,
      "PGN_Name": "Electronic Transmission Controller 2",
      "PGN_Description": "ETC2",
      "first_bit": 48,
      "SPN": 163,
      "SPN_Name": "Transmission Current Range",
      "SPN_Description": "Range currently being commanded by the transmission control system. Characters may include P, Rx, Rx-1...R2, R1, R, Nx, Nx-1...N2, N1, N, D, D1, D2..., Dx, L, L1, L2..., Lx-1, 1, 2, 3,... If only one displayed character is required, the second character shall be used and the first character shall be a space (ASCII 32) or a control character (ASCII 0 to 31).  If the first character is a control character, refer to the manufacturer’s application document for definition.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "ASCII",
      "SLOT_ID": 131
    },
    "164": {
      "PGN": 65243,
      "PGN_Name": "Engine Fluid Level/Pressure 2",
      "PGN_Description": "EFL/P2",
      "first_bit": 0,
      "SPN": 164,
      "SPN_Name": "Engine Fuel Injection Control Pressure",
      "SPN_Description": "The gage pressure of the engine oil in the hydraulic accumulator that powers an intensifier used for fuel injection.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 51
    },
    "165": {
      "PGN": 65256,
      "PGN_Name": "Vehicle Direction/Speed",
      "PGN_Description": "VDS",
      "first_bit": 0,
      "SPN": 165,
      "SPN_Name": "Compass Bearing",
      "SPN_Description": "Present compass bearing of vehicle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "166": {
      "PGN": 65214,
      "PGN_Name": "Electronic Engine Controller 4",
      "PGN_Description": "EEC4",
      "first_bit": 0,
      "SPN": 166,
      "SPN_Name": "Engine Rated Power",
      "SPN_Description": "Net brake power that the engine will deliver continuously, specified for a given application at a rated speed.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kW",
      "SLOT_ID": 55
    },
    "167": {
      "PGN": 65271,
      "PGN_Name": "Vehicle Electrical Power 1",
      "PGN_Description": "VEP1",
      "first_bit": 16,
      "SPN": 167,
      "SPN_Name": "Charging System Potential (Voltage)",
      "SPN_Description": "Electrical potential measured at the charging system output.  The charging system may be any device charging the batteries.  This includes alternators, generators, solid state charger and other charging devices.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "168": {
      "PGN": 65271,
      "PGN_Name": "Vehicle Electrical Power 1",
      "PGN_Description": "VEP1",
      "first_bit": 32,
      "SPN": 168,
      "SPN_Name": "Battery Potential / Power Input 1",
      "SPN_Description": "This parameter measures the first source of battery potential as measured at the input of the ECU/actuator etc. coming from one or more batteries, irrespective of the distance between the component and the battery.  This SPN is also used when ECUs are interconnected in a series configuration, where the source of power is coming directly or indirectly from the same battery/batteries.\r\n\r\nIf more than one battery is included in the first set of batteries and the potential for each battery is desired, then SPNs 7902, 7910, 7918, & 7926 shall be used.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "169": {
      "PGN": 65276,
      "PGN_Name": "Dash Display 1",
      "PGN_Description": "DD1",
      "first_bit": 32,
      "SPN": 169,
      "SPN_Name": "Cargo Ambient Temperature",
      "SPN_Description": "Temperature of air inside vehicle container used to accommodate cargo.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "170": {
      "PGN": 65269,
      "PGN_Name": "Ambient Conditions",
      "PGN_Description": "AMB",
      "first_bit": 8,
      "SPN": 170,
      "SPN_Name": "Cab Interior Temperature",
      "SPN_Description": "Temperature of air inside the part of the vehicle that encloses the driver and vehicle operating controls.\r\n\r\nNote: See also SPN 1691.  SPN 1662 is an additional diagnostic SPN associated with cab temperature.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "171": {
      "PGN": 65269,
      "PGN_Name": "Ambient Conditions",
      "PGN_Description": "AMB",
      "first_bit": 24,
      "SPN": 171,
      "SPN_Name": "Ambient Air Temperature",
      "SPN_Description": "Temperature of air surrounding vehicle.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "172": {
      "PGN": 65269,
      "PGN_Name": "Ambient Conditions",
      "PGN_Description": "AMB",
      "first_bit": 40,
      "SPN": 172,
      "SPN_Name": "Engine Intake 1 Air Temperature",
      "SPN_Description": "Temperature of air entering vehicle air induction system.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "173": {
      "PGN": 65270,
      "PGN_Name": "Intake/Exhaust Conditions 1",
      "PGN_Description": "IC1",
      "first_bit": 40,
      "SPN": 173,
      "SPN_Name": "Engine Exhaust Temperature",
      "SPN_Description": "Temperature of combustion byproducts leaving the engine.  See SPNs 2433, 2434, 5969 and 5970 for engines with more than one exhaust temperature measurement.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "174": {
      "PGN": 65262,
      "PGN_Name": "Engine Temperature 1",
      "PGN_Description": "ET1",
      "first_bit": 8,
      "SPN": 174,
      "SPN_Name": "Engine Fuel 1 Temperature 1",
      "SPN_Description": "Temperature of fuel (or gas) of the first fuel type. See SPN 3468 for a second temperature measurement of the first fuel type.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "175": {
      "PGN": 65262,
      "PGN_Name": "Engine Temperature 1",
      "PGN_Description": "ET1",
      "first_bit": 16,
      "SPN": 175,
      "SPN_Name": "Engine Oil Temperature 1",
      "SPN_Description": "Temperature of the engine lubricant.\r\n\r\nNote:  If there is only one engine oil temperature measurement, this SPN should be used.  This is the SPN that is typically displayed on an on-highway truck instrument cluster.\r\n\r\nSee also SPNs 1135 and 5925 for additional engine oil temperature measurements.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "176": {
      "PGN": 65262,
      "PGN_Name": "Engine Temperature 1",
      "PGN_Description": "ET1",
      "first_bit": 32,
      "SPN": 176,
      "SPN_Name": "Engine Turbocharger Oil Temperature",
      "SPN_Description": "Temperature of the turbocharger lubricant.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "177": {
      "PGN": 65272,
      "PGN_Name": "Transmission Fluids 1",
      "PGN_Description": "TRF1",
      "first_bit": 32,
      "SPN": 177,
      "SPN_Name": "Transmission Oil Temperature 1",
      "SPN_Description": "First instance of transmission lubricant temperature.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "180": {
      "PGN": 65258,
      "PGN_Name": "Vehicle Weight",
      "PGN_Description": "VW",
      "first_bit": 24,
      "SPN": 180,
      "SPN_Name": "Trailer Weight",
      "SPN_Description": "Total mass of freight-carrying vehicle designed to be pulled by truck, including the weight of the contents.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 28
    },
    "181": {
      "PGN": 65258,
      "PGN_Name": "Vehicle Weight",
      "PGN_Description": "VW",
      "first_bit": 40,
      "SPN": 181,
      "SPN_Name": "Cargo Weight",
      "SPN_Description": "The mass of freight carried.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 28
    },
    "182": {
      "PGN": 65257,
      "PGN_Name": "Fuel Consumption (Liquid) 1",
      "PGN_Description": "LFC1",
      "first_bit": 0,
      "SPN": 182,
      "SPN_Name": "Engine Trip Fuel",
      "SPN_Description": "Fuel consumed during all or part of a journey.  See SPN 5053 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 20
    },
    "183": {
      "PGN": 65266,
      "PGN_Name": "Fuel Economy (Liquid)",
      "PGN_Description": "LFE1",
      "first_bit": 0,
      "SPN": 183,
      "SPN_Name": "Engine Fuel Rate",
      "SPN_Description": "Amount of fuel consumed by engine per unit of time.\r\n\r\nNOTE - See SPN 1600 for alternate resolution.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "l/h",
      "SLOT_ID": 42
    },
    "184": {
      "PGN": 65266,
      "PGN_Name": "Fuel Economy (Liquid)",
      "PGN_Description": "LFE1",
      "first_bit": 16,
      "SPN": 184,
      "SPN_Name": "Engine Instantaneous Fuel Economy",
      "SPN_Description": "Current fuel economy at current vehicle velocity.\r\n\r\n0xFB00 = Infinite (for example, during engine motoring)",
      "bit_length": 16,
      "scaling": 0.001953125,
      "offset": 0,
      "unit": "km/L",
      "SLOT_ID": 16
    },
    "185": {
      "PGN": 65266,
      "PGN_Name": "Fuel Economy (Liquid)",
      "PGN_Description": "LFE1",
      "first_bit": 32,
      "SPN": 185,
      "SPN_Name": "Engine Average Fuel Economy",
      "SPN_Description": "Average of instantaneous fuel economy for that segment of vehicle operation of interest.",
      "bit_length": 16,
      "scaling": 0.001953125,
      "offset": 0,
      "unit": "km/L",
      "SLOT_ID": 16
    },
    "186": {
      "PGN": 65264,
      "PGN_Name": "Power Takeoff Information",
      "PGN_Description": "PTO",
      "first_bit": 8,
      "SPN": 186,
      "SPN_Name": "Power Takeoff Speed",
      "SPN_Description": "Rotational velocity of device used to transmit engine power to auxiliary equipment.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "187": {
      "PGN": 65264,
      "PGN_Name": "Power Takeoff Information",
      "PGN_Description": "PTO",
      "first_bit": 24,
      "SPN": 187,
      "SPN_Name": "Power Takeoff Set Speed",
      "SPN_Description": "Rotational velocity selected by operator for device used to transmit engine power to auxiliary equipment.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "188": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 0,
      "SPN": 188,
      "SPN_Name": "Engine Speed At Idle, Point 1",
      "SPN_Description": "Stationary low idle speed of engine which includes influences due to engine temperature (after power up) and other stationary changes (calibration offsets, sensor failures, etc).  This parameter is point 1 of the engine configuration map (see PGN 65251).",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "189": {
      "PGN": 65214,
      "PGN_Name": "Electronic Engine Controller 4",
      "PGN_Description": "EEC4",
      "first_bit": 16,
      "SPN": 189,
      "SPN_Name": "Engine Rated Speed",
      "SPN_Description": "The maximum governed rotational velocity of the engine crankshaft under full load conditions.  Note that the engine speed at point 2 (SPN 528) is equal to rated engine speed only in the case when the engine has not been derated.  Please also reference PGN 65251.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "190": {
      "PGN": 61444,
      "PGN_Name": "Electronic Engine Controller 1",
      "PGN_Description": "EEC1",
      "first_bit": 24,
      "SPN": 190,
      "SPN_Name": "Engine Speed",
      "SPN_Description": "Actual engine speed which is calculated over a minimum crankshaft angle of 720 degrees divided by the number of cylinders.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "191": {
      "PGN": 61442,
      "PGN_Name": "Electronic Transmission Controller 1",
      "PGN_Description": "ETC1",
      "first_bit": 8,
      "SPN": 191,
      "SPN_Name": "Transmission Output Shaft Speed",
      "SPN_Description": "Calculated speed of the transmission output shaft.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "235": {
      "PGN": 65244,
      "PGN_Name": "Idle Operation",
      "PGN_Description": "IO",
      "first_bit": 32,
      "SPN": 235,
      "SPN_Name": "Engine Total Idle Hours",
      "SPN_Description": "Accumulated time of operation of the engine while under idle conditions.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "236": {
      "PGN": 65244,
      "PGN_Name": "Idle Operation",
      "PGN_Description": "IO",
      "first_bit": 0,
      "SPN": 236,
      "SPN_Name": "Engine Total Idle Fuel Used",
      "SPN_Description": "Accumulated amount of fuel used during vehicle operation while under idle conditions.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 20
    },
    "241": {
      "PGN": 65268,
      "PGN_Name": "Tire Condition Message 1",
      "PGN_Description": "TIRE1",
      "first_bit": 8,
      "SPN": 241,
      "SPN_Name": "Tire Pressure",
      "SPN_Description": "Pressure at which air is contained in cavity formed by tire and rim.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "242": {
      "PGN": 65268,
      "PGN_Name": "Tire Condition Message 1",
      "PGN_Description": "TIRE1",
      "first_bit": 16,
      "SPN": 242,
      "SPN_Name": "Tire Temperature",
      "SPN_Description": "Temperature at the surface of the tire sidewall.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "244": {
      "PGN": 65248,
      "PGN_Name": "Vehicle Distance",
      "PGN_Description": "VD",
      "first_bit": 0,
      "SPN": 244,
      "SPN_Name": "Trip Distance",
      "SPN_Description": "Distance traveled during all or part of a journey.\r\n\r\nNOTE See SPN 918 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.125,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 36
    },
    "245": {
      "PGN": 65248,
      "PGN_Name": "Vehicle Distance",
      "PGN_Description": "VD",
      "first_bit": 32,
      "SPN": 245,
      "SPN_Name": "Total Vehicle Distance",
      "SPN_Description": "Accumulated distance traveled by vehicle during its operation.\r\n\r\nNOTE See SPN 917 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.125,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 36
    },
    "246": {
      "PGN": 65255,
      "PGN_Name": "Vehicle Hours",
      "PGN_Description": "VH",
      "first_bit": 0,
      "SPN": 246,
      "SPN_Name": "Total Vehicle Hours",
      "SPN_Description": "Accumulated time of operation of vehicle.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "247": {
      "PGN": 65253,
      "PGN_Name": "Engine Hours, Revolutions",
      "PGN_Description": "HOURS",
      "first_bit": 0,
      "SPN": 247,
      "SPN_Name": "Engine Total Hours of Operation",
      "SPN_Description": "Accumulated time of operation of engine.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "248": {
      "PGN": 65255,
      "PGN_Name": "Vehicle Hours",
      "PGN_Description": "VH",
      "first_bit": 32,
      "SPN": 248,
      "SPN_Name": "Total Power Takeoff Hours",
      "SPN_Description": "Accumulated time of operation of power takeoff device.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "249": {
      "PGN": 65253,
      "PGN_Name": "Engine Hours, Revolutions",
      "PGN_Description": "HOURS",
      "first_bit": 32,
      "SPN": 249,
      "SPN_Name": "Engine Total Revolutions",
      "SPN_Description": "Accumulated number of revolutions of engine crankshaft during its operation.",
      "bit_length": 32,
      "scaling": 1000,
      "offset": 0,
      "unit": "r",
      "SLOT_ID": 34
    },
    "250": {
      "PGN": 65257,
      "PGN_Name": "Fuel Consumption (Liquid) 1",
      "PGN_Description": "LFC1",
      "first_bit": 32,
      "SPN": 250,
      "SPN_Name": "Engine Total Fuel Used",
      "SPN_Description": "Accumulated amount of fuel used during vehicle operation.  See SPN 5054 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 20
    },
    "354": {
      "PGN": 65164,
      "PGN_Name": "Auxiliary Analog Information",
      "PGN_Description": "AAI",
      "first_bit": 48,
      "SPN": 354,
      "SPN_Name": "Relative Humidity",
      "SPN_Description": "Measures humidity of combustion air prior to entry into turbocharger",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "407": {
      "PGN": 64873,
      "PGN_Name": "Axle Group Calibration Weights",
      "PGN_Description": "AGCW",
      "first_bit": 24,
      "SPN": 407,
      "SPN_Name": "Axle Group Full Weight Calibration",
      "SPN_Description": "The full weight calibration measurement of an axle group",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 28
    },
    "408": {
      "PGN": 64873,
      "PGN_Name": "Axle Group Calibration Weights",
      "PGN_Description": "AGCW",
      "first_bit": 8,
      "SPN": 408,
      "SPN_Name": "Axle Group Empty Weight Calibration",
      "SPN_Description": "The empty weight calibration measurement of an axle group",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 28
    },
    "409": {
      "PGN": 64874,
      "PGN_Name": "Axle Group Weight",
      "PGN_Description": "AGW",
      "first_bit": 8,
      "SPN": 409,
      "SPN_Name": "Axle Group Weight",
      "SPN_Description": "Total mass imposed on the road surface by all the tires in the axle group",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 28
    },
    "411": {
      "PGN": 65188,
      "PGN_Name": "Engine Temperature 2",
      "PGN_Description": "ET2",
      "first_bit": 32,
      "SPN": 411,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Differential Pressure",
      "SPN_Description": "Differential pressure across the Exhaust Gas Recirculation (EGR) system",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "kPa",
      "SLOT_ID": 52
    },
    "412": {
      "PGN": 65188,
      "PGN_Name": "Engine Temperature 2",
      "PGN_Description": "ET2",
      "first_bit": 48,
      "SPN": 412,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Temperature",
      "SPN_Description": "Temperature of Recirculated Exhaust Gas.  This should not be used for Exhaust Gas Recirculation Mixer Intake Temperature.  See SPN 5020.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "413": {
      "PGN": 64872,
      "PGN_Name": "Gross Combination Vehicle Weight",
      "PGN_Description": "GCVW",
      "first_bit": 24,
      "SPN": 413,
      "SPN_Name": "Net Vehicle Weight Change",
      "SPN_Description": "Identifies the net vehicle weight change from the time of last vehicle net weight zeroing.",
      "bit_length": 24,
      "scaling": 2,
      "offset": -16449535,
      "unit": "kg",
      "SLOT_ID": 267
    },
    "417": {
      "PGN": 64872,
      "PGN_Name": "Gross Combination Vehicle Weight",
      "PGN_Description": "GCVW",
      "first_bit": 0,
      "SPN": 417,
      "SPN_Name": "Gross Combination Weight",
      "SPN_Description": "Total weight of the truck and all the trailers with on-board scales.",
      "bit_length": 24,
      "scaling": 2,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 122
    },
    "441": {
      "PGN": 65164,
      "PGN_Name": "Auxiliary Analog Information",
      "PGN_Description": "AAI",
      "first_bit": 0,
      "SPN": 441,
      "SPN_Name": "Auxiliary Temperature 1",
      "SPN_Description": "Temperature measured by auxiliary temperature sensor #1.  Not to be used in place of existing SPNs.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "442": {
      "PGN": 65164,
      "PGN_Name": "Auxiliary Analog Information",
      "PGN_Description": "AAI",
      "first_bit": 8,
      "SPN": 442,
      "SPN_Name": "Auxiliary Temperature 2",
      "SPN_Description": "Temperature measured by auxiliary temperature sensor #2.  Not to be used in place of existing SPNs.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "444": {
      "PGN": 65165,
      "PGN_Name": "Vehicle Electrical Power 2",
      "PGN_Description": "VEP2",
      "first_bit": 0,
      "SPN": 444,
      "SPN_Name": "Battery Potential / Power Input 2",
      "SPN_Description": "This parameter measures the second source of battery potential as measured at the input of the ECU/actuator etc. coming from one or more batteries, irrespective of the distance between the component and the battery.  This SPN is also used when ECUs are interconnected in a series configuration, where the source of power is coming directly or indirectly from the same battery/batteries.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "512": {
      "PGN": 61444,
      "PGN_Name": "Electronic Engine Controller 1",
      "PGN_Description": "EEC1",
      "first_bit": 8,
      "SPN": 512,
      "SPN_Name": "Driver's Demand Engine - Percent Torque",
      "SPN_Description": "The requested torque output of the engine by the driver. It is based on input from the following requestors external to the powertrain: operator (via the accelerator pedal), cruise control and/or road speed limit governor. Dynamic commands from internal powertrain functions such as smoke control, low- and high-speed engine governing; ASR and shift control are excluded from this calculation. The data is transmitted in indicated torque as a percent of the reference engine torque. See PGN 65251 for the engine configuration message. Several status bits are defined separately to indicate the request which is currently being honored. This parameter may be used for shift scheduling.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "513": {
      "PGN": 61444,
      "PGN_Name": "Electronic Engine Controller 1",
      "PGN_Description": "EEC1",
      "first_bit": 16,
      "SPN": 513,
      "SPN_Name": "Actual Engine - Percent Torque",
      "SPN_Description": "The calculated output torque of the engine.  The data is transmitted in indicated torque as a percent of reference engine torque (see the engine configuration message, PGN 65251).  The engine percent torque value will not be less than zero and it includes the torque developed in the cylinders required to overcome friction.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "514": {
      "PGN": 65247,
      "PGN_Name": "Electronic Engine Controller 3",
      "PGN_Description": "EEC3",
      "first_bit": 0,
      "SPN": 514,
      "SPN_Name": "Nominal Friction - Percent Torque",
      "SPN_Description": "The calculated torque that indicates the amount of torque required by the basic engine itself added by the loss torque of accessories.  It contains the frictional and thermodynamic loss of the engine itself, pumping torque loss (SPN 5398), and the losses of fuel, oil and cooling pumps.  The data is transmitted as a percent of reference engine torque (see the engine configuration message, PGN 65251).\r\n\r\nThe realization can be done by a map dependent on engine speed and engine temperature and an offset value for additional loss torques.\r\n\r\nSee SPN 2978 for an indicator that describes the possible inclusion of engine parasitic losses such as cooling fan, etc. in this parameter value.\r\n\r\nNote:  Refer to section 5.2.1 in SAE J1939-71.\r\n\r\nNote: Beginning in 2016,  HD-OBD requires reporting of engine torque to Portable Emissions Measurement System (PEMS) equipment that is representative of torque as measured by the engine dynamometer during the emissions certification process. Therefore, for applications that are subject to HD-OBD regulations in 2016 or later, estimated parasitic losses shall no longer be included in SPN 514 Nominal Friction - Percent Torque and must be included in SPN 2978 Estimated Engine Parasitic Losses - Percent Torque.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "515": {
      "PGN": 65247,
      "PGN_Name": "Electronic Engine Controller 3",
      "PGN_Description": "EEC3",
      "first_bit": 8,
      "SPN": 515,
      "SPN_Name": "Engine's Desired Operating Speed",
      "SPN_Description": "An indication by the engine of the optimal operating speed of the engine for the current existing conditions.  These conditions may include the torque generated to accommodate powertrain demands from the operator (via the accelerator pedal), cruise control, road speed limit governors, or ASR.  Dynamic commands from functions such as smoke control or shift control are excluded from this calculation.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "517": {
      "PGN": 65256,
      "PGN_Name": "Vehicle Direction/Speed",
      "PGN_Description": "VDS",
      "first_bit": 16,
      "SPN": 517,
      "SPN_Name": "Navigation-Based Vehicle Speed",
      "SPN_Description": "Speed of the vehicle as calculated from a device such as a Global Positioning System (GPS).",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 71
    },
    "518": {
      "PGN": 0,
      "PGN_Name": "Torque/Speed Control 1",
      "PGN_Description": "TSC1",
      "first_bit": 24,
      "SPN": 518,
      "SPN_Name": "Engine Requested Torque/Torque Limit",
      "SPN_Description": "Parameter provided to the engine or retarder in the torque/speed control message for controlling or limiting the output torque.\r\n\r\nRequested torque to the engine is measured in indicated torque as a percentage of reference engine torque (see the engine configuration message, PGN 65251).  This is the engine torque at which the engine is expected to operate if the torque control mode is active or the engine torque which the engine is not expected to exceed if the torque limit mode is active.\r\n\r\nZero torque can be requested which implies zero fuel and, according to Figures SPN512_A and SPN512_B, the engine will not be allowed to stall.  The actual engine percent torque (SPN 513) should be zero and the engine should decelerate until the low idle governor kicks in, at which time the actual engine percent torque will be calculated as shown in Figures SPN512_A and SPN512_B and the engine torque mode bits (SPN 899) should be equal to 0000b - Low Idle Governor.\r\n\r\nRequested torque to the retarder is measured in indicated torque as a percentage of reference retarder torque (see the retarder configuration message,  PGN 65249).  The logic used in enabling or disabling the retarder is based on the override control mode priority bits (SPN 897).\r\n\r\nA zero torque request to the retarder is a disable request, and is used by a J1939 node to prevent the retarder from being activated by other combinations of inputs outside of J1939 commands. The Torque Limit Mode is commonly used for this purpose.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "519": {
      "PGN": 65247,
      "PGN_Name": "Electronic Engine Controller 3",
      "PGN_Description": "EEC3",
      "first_bit": 24,
      "SPN": 519,
      "SPN_Name": "Engine's Desired Operating Speed Asymmetry Adjustment",
      "SPN_Description": "This byte is utilized in transmission gear selection routines and indicates the engine's preference of lower versus higher engine speeds should its desired speed not be achievable.  This is a scaled ratio such that 125 represents an equal preference for a speed lower or higher that the engine's indicated desired speed.  The higher the asymmetry adjustment value is above 125, the more the engine prefers to be operated at or above its indicated desired speed.  Conversely, the lower the asymmetry adjustment value is below 125, the more the engine prefers to operate at or below its indicated desired speed.  Typically, the engine's asymmetry adjustment will be predicated on fuel consumption considerations, and under these conditions, the method for computing the asymmetry adjustment is indicated in Figure SPN519_A. The engine may include other factors into its asymmetry adjustment calculation such as temperatures, pressures, and other operating parameters.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 56
    },
    "520": {
      "PGN": 61440,
      "PGN_Name": "Electronic Retarder Controller 1",
      "PGN_Description": "ERC1",
      "first_bit": 8,
      "SPN": 520,
      "SPN_Name": "Actual Retarder - Percent Torque",
      "SPN_Description": "Actual braking torque of the retarder as a percent of retarder configuration reference torque SPN 556.\r\n\r\nNote:  Refer to section 5.2.1 in SAE J1939-71.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "521": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 8,
      "SPN": 521,
      "SPN_Name": "Brake Pedal Position",
      "SPN_Description": "Ratio of brake pedal position to maximum pedal position.  Used for electric brake applications. 0% means no braking. Also when there are two brake pedals on the machine (Left Brake Pedal Position SPN 3033 and Right Brake Pedal Position SPN 3032) the maximum of the two should be transmitted for Brake Pedal Position.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "522": {
      "PGN": 61442,
      "PGN_Name": "Electronic Transmission Controller 1",
      "PGN_Description": "ETC1",
      "first_bit": 24,
      "SPN": 522,
      "SPN_Name": "Percent Clutch Slip",
      "SPN_Description": "Parameter which represents the ratio of input shaft speed to current engine speed (in percent).\r\n\r\nPercent Clutch Slip = ((Engine rpm - Input shaft rpm)/(Engine rpm)) x 100",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "523": {
      "PGN": 61445,
      "PGN_Name": "Electronic Transmission Controller 2",
      "PGN_Description": "ETC2",
      "first_bit": 24,
      "SPN": 523,
      "SPN_Name": "Transmission Current Gear",
      "SPN_Description": "The gear currently engaged in the transmission or the last gear engaged while the transmission is in the process of shifting to the new or selected gear.  Transitions toward a destination gear will not be indicated.  Once the selected gear has been engaged then Transmission Current Gear (SPN 523) will reflect that gear.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "gear value",
      "SLOT_ID": 24
    },
    "524": {
      "PGN": 61445,
      "PGN_Name": "Electronic Transmission Controller 2",
      "PGN_Description": "ETC2",
      "first_bit": 0,
      "SPN": 524,
      "SPN_Name": "Transmission Selected Gear",
      "SPN_Description": "The gear that the transmission will attempt to achieve during the current shift if a shift is in progress, or the next shift if one is pending (i.e., waiting for torque reduction to initiate the shift).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "gear value",
      "SLOT_ID": 24
    },
    "525": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 16,
      "SPN": 525,
      "SPN_Name": "Transmission Requested Gear",
      "SPN_Description": "Gear requested by the operator, ABS, or engine.\r\n\r\nNegative values are reverse gears, positive values are forward gears, zero is neutral, parameter specific indicators are listed below.\r\n\r\nParameter specific values for this parameter are as follows:\r\n0xFD (253 dec) = Hold current gear\r\n0xFC (252 dec) = Forward Drive Position\r\n0xFB (251 dec) = ‘Park’ position\r\n0xFA (250 dec) = Forward ‘Low’ position\r\n0xF9 (249 dec) = Upshift 1 gear from current position\r\n0xF8 (248 dec) = Upshift 2 gears from current position\r\n0xF7 (247 dec) = Downshift 1 gear from current position\r\n0xF6 (246 dec) = Downshift 2 gears from current position\r\n0xF5 (245 dec) = D-1: 1st forward selector position referenced from ‘Drive’\r\n0xF4 (244 dec) = D-2: 2nd forward selector position referenced from ‘Drive’\r\n0xF3 (243 dec) = D-3: 3rd forward selector position referenced from ‘Drive’\r\n0xF2 (242 dec) = D-4: 4th forward selector position referenced from ‘Drive’\r\n0xF1 (241 dec) = D-5: 5th forward selector position referenced from ‘Drive’\r\n0xF0 (240 dec) = D-6: 6th forward selector position referenced from ‘Drive’\r\n0xEF (239 dec) = D-7: 7th forward selector position referenced from ‘Drive’\r\n0xEE (238 dec) = Between two shift selector positions (if detail is unknown)\r\n0xED (237 dec) = Between two reverse shift selector positions\r\n0xEC (236 dec) = Between two forward shift selector positions\r\n0xEB (235 dec) = Between D-7 and D-6 shift selector positions\r\n0xEA (234 dec) = Between D-6 and D-5 shift selector positions\r\n0xE9 (233 dec) = Between D-5 and D-4 shift selector positions\r\n0xE8 (232 dec) = Between D-4 and D-3 shift selector positions\r\n0xE7 (231 dec) = Between D-3 and D-2 shift selector positions\r\n0xE6 (230 dec) = Between D-2 and D-1 shift selector positions\r\n0xE5 (229 dec) = Between D-1 and ‘Drive’ shift selector positions\r\n0xE4 (228 dec) = Between ‘Drive’ and ‘Neutral’ shift selector positions\r\n0xE3 (227 dec) = Between ‘Neutral’ and ‘Reverse’ shift selector positions\r\n0xE2 (226 dec) = Between ‘Reverse’ and ‘Park’ shift selector positions\r\n0xE1 (225 dec) = Press of momentary button to reselect current position\r\n0xE0 (224 dec) = Position unknown and/or no buttons pressed\r\n0xDF (223 dec) = Reverse Selector Position\r\n\r\n0xDE - 0xBE  (222 dec - 190 dec) = Reserved\r\n0x3C - 0x00   (60 dec  - 0 dec)  = Reserved\r\n\r\nForward selector position from drive (0xF5 to 0xEF) – Indicates shift selector position in reference to the ‘Drive’ position on the selector.  It is possible that the shift selector software may not know the number of forward ranges.  The shift selector may identify the position selected by the operator while the transmission ECU determines what range or gear that represents.  If there is a digital display, the transmission ECU would communicate what is to be displayed via another message such as ETC#2 or ETC#7.\r\n\r\nFor example:  Consider a vehicle with a 5-speed automatic transmission with the shift lever on the column. Suppose that shift selector has a limited number of positions, such that having positions for D-4-3-2-1 is not an option. For this example, assume there are only have enough lever positions for D-3-2-1. Pulling the lever into \"D\" will put the transmission in 5th (highest gear).  It is desired that pulling the lever to the physical “3” position will limit the transmission to a maximum range of 3rd gear.\r\n\r\nWhen the selector is pulled down into \"3\", the shifter selector itself has no way of correlating this physical lever position to the desired gear; it would have to be calibrated with software to tell it this information. If not calibrated, the shift selector cannot directly command the transmission to go to 3rd gear; it only knows it's one notch below drive.\r\n\r\nHowever, if \"D-1\" (lever position, as opposed to desired gear) is broadcast by the selector, the transmission ECU can receive this and then make the determination of what range is desired. The benefit is that no specific calibration of the shift selector is required. \r\n\r\nBetween selector positions (0xEE to 0xE2) – Indicates the shift selector is not in an appropriate position.  If a lever-type shift selector with a mechanical display is stuck between detents, it may appear to the operator that it is in the desired position when in fact it is not. The shift selector may be capable of reporting only that it is between positions or that it is between forward or reverse positions. If known, the transmission ECU may respond differently depending on which positions are involved.\r\n\r\nReselect current position (0xE1) - If the TC1 message continues to send the position last selected, then a capability to reselect the same position is required.  For example:  If a ‘Neutral to Drive’ shift is selected and that shift is inhibited (say for high engine speed), it may be necessary for the operator to reselect ‘Drive’ after the inhibit conditions pass in order for the transmission ECU to honor the request.\r\n\r\nPosition unknown and/or no buttons pressed (0xE0) - A push-button style shift selector with momentary contact buttons may send this indicator after initialization before any buttons are pressed, or before the transmission ECU determines and communicates the initial selection.  This indicator could also be sent between button presses as an alternative to sending the last button press.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "gear value",
      "SLOT_ID": 24
    },
    "526": {
      "PGN": 61445,
      "PGN_Name": "Electronic Transmission Controller 2",
      "PGN_Description": "ETC2",
      "first_bit": 8,
      "SPN": 526,
      "SPN_Name": "Transmission Actual Gear Ratio",
      "SPN_Description": "Actual ratio of input shaft speed to output shaft speed.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 32
    },
    "527": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 53,
      "SPN": 527,
      "SPN_Name": "Cruise Control States",
      "SPN_Description": "This parameter is used to indicate the current state, or mode, of operation by the cruise control device.  This is a status parameter.\r\n\r\n000 - Off/Disabled\r\n001 - Hold\r\n010 - Accelerate\r\n011 - Decelerate\r\n100 - Resume\r\n101 - Set\r\n110 - Accelerator Override\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "528": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 24,
      "SPN": 528,
      "SPN_Name": "Engine Speed At Point 2",
      "SPN_Description": "Engine speed of point 2 of the engine torque map (see PGN 65251 and supporting document).  In engine configuration mode 1 and 3, point 2 is defined as the kick-in point from which torque is reduced to zero.  In mode 2 (see Table PGN65251_A), there are no special requirements for the definition of this point.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "529": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 48,
      "SPN": 529,
      "SPN_Name": "Engine Speed At Point 3",
      "SPN_Description": "Engine speed of point 3, 4, and 5 of the engine torque map (see PGN 65251 and supporting document).  It is recommended that one of these points indicate the peak torque point for the current engine torque map.  Points 3, 4, and 5 are optional and lie between idle and point 2.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "530": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 72,
      "SPN": 530,
      "SPN_Name": "Engine Speed At Point 4",
      "SPN_Description": "Engine speed of point 3, 4, and 5 of the engine torque map (see PGN 65251 and supporting document).  It is recommended that one of these points indicate the peak torque point for the current engine torque map.  Points 3, 4, and 5 are optional and lie between idle and point 2.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "531": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 96,
      "SPN": 531,
      "SPN_Name": "Engine Speed At Point 5",
      "SPN_Description": "Engine speed of point 3, 4, and 5 of the engine torque map (see PGN 65251 and supporting document).  It is recommended that one of these points indicate the peak torque point for the current engine torque map.  Points 3, 4, and 5 are optional and lie between idle and point 2.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "532": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 120,
      "SPN": 532,
      "SPN_Name": "Engine Speed At High Idle, Point 6",
      "SPN_Description": "Engine speed of high idle (point 6) of the engine torque map (see PGN 65251 and supporting document).  In engine configuration mode 3 (see Figure PGN65251_C), point 6 is not defined by the engine torque map but by the governor characteristic and the zero torque line.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "533": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 168,
      "SPN": 533,
      "SPN_Name": "Engine Maximum Momentary Override Speed, Point 7",
      "SPN_Description": "The maximum engine speed above high idle allowed by the engine control during a momentary high idle override.  This duration of the override is limited by the maximum momentary override time limit, SPN 534.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "534": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 184,
      "SPN": 534,
      "SPN_Name": "Engine Maximum Momentary Override Time Limit",
      "SPN_Description": "The maximum time limit allowed to override the engine's high idle speed.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 59
    },
    "535": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 192,
      "SPN": 535,
      "SPN_Name": "Engine Requested Speed Control Range Lower Limit",
      "SPN_Description": "The minimum engine speed that the engine will allow when operating in a speed control/limit mode.",
      "bit_length": 8,
      "scaling": 10,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 79
    },
    "536": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 200,
      "SPN": 536,
      "SPN_Name": "Engine Requested Speed Control Range Upper Limit",
      "SPN_Description": "The maximum engine speed regardless of load that the engine will allow when operating in a speed control/limit mode, excluding any maximum momentary engine override speed, if supported.",
      "bit_length": 8,
      "scaling": 10,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 79
    },
    "537": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 208,
      "SPN": 537,
      "SPN_Name": "Engine Requested Torque Control Range Lower Limit",
      "SPN_Description": "The minimum engine torque that the engine will allow when operating in a torque control/limit mode.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "538": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 216,
      "SPN": 538,
      "SPN_Name": "Engine Requested Torque Control Range Upper Limit",
      "SPN_Description": "The maximum engine torque that the engine will allow when operating in a torque control/limit mode.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "539": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 16,
      "SPN": 539,
      "SPN_Name": "Engine Percent Torque At Idle, Point 1",
      "SPN_Description": "The torque limit that indicates the available engine torque which can be provided by the engine at idle speed.  This parameter may be influenced by engine temperature (after power up) and other stationary changes (calibration offsets, sensor failures, etc.)  See also SPN 188.  The data is transmitted in indicated torque as a percent of the reference engine torque.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "540": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 40,
      "SPN": 540,
      "SPN_Name": "Engine Percent Torque At Point 2",
      "SPN_Description": "The torque limit that indicates the available engine torque which can be provided by the engine at point 2 of the engine map (see PGN 65251 and supporting documents).  In engine configuration mode 1 and 3 (see Table PGN65251_A see PGN 65251), point 2 is defined as the kick-in point from which torque is reduced to zero.  In mode 2, there are no special requirements for the definition of this point.  The data is transmitted in indicated torque as a percent of the reference engine torque.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "541": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 64,
      "SPN": 541,
      "SPN_Name": "Engine Percent Torque At Point 3",
      "SPN_Description": "The torque limit that indicates the available engine torque which can be provided by the engine at point 3, 4, and 5 of the engine map (see PGN 65251 and supporting documents)..  It is required that one of these points indicate the peak torque point for the current engine torque map.  Points 3, 4, and 5 lie between idle and point 2.  The data is transmitted in indicated torque as a percent of the reference engine torque.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "542": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 88,
      "SPN": 542,
      "SPN_Name": "Engine Percent Torque At Point 4",
      "SPN_Description": "The torque limit that indicates the available engine torque which can be provided by the engine at point 3, 4, and 5 of the engine map (see PGN 65251 and supporting documents).  It is required that one of these points indicate the peak torque point for the current engine torque map.  Points 3, 4, and 5 lie between idle and point 2.  The data is transmitted in indicated torque as a percent of the reference engine torque.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "543": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 112,
      "SPN": 543,
      "SPN_Name": "Engine Percent Torque At Point 5",
      "SPN_Description": "The torque limit that indicates the available engine torque which can be provided by the engine at point 3, 4, and 5 of the engine map (see PGN 65251 and supporting documents).  It is required that one of these points indicate the peak torque point for the current engine torque map.  Points 3, 4, and 5 lie between idle and point 2.  The data is transmitted in indicated torque as a percent of the reference engine torque.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "544": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 152,
      "SPN": 544,
      "SPN_Name": "Engine Reference Torque",
      "SPN_Description": "This parameter is the 100% reference value for all defined indicated engine torque parameters.  It is only defined once and doesn't change if a different engine torque map becomes valid.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Nm",
      "SLOT_ID": 70
    },
    "545": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 136,
      "SPN": 545,
      "SPN_Name": "Engine Gain (Kp) Of The Endspeed Governor",
      "SPN_Description": "The endspeed governor is defined as a linear line with the following equations (Capital letters mean physical values, small letters mean normalized values).  Refer to Figures PGN65251_A and PGN65251_B.\r\n\r\nThe gain KP/kp is defined as a positive value.  The factor 4096 is necessary for realizing flat curves with sufficient resolution as well as very steep curves.\r\n\r\nKP = delta Torque / delta Speed\r\nkp (normalized) = KP * 250/100% * 8031 rpm/64255 * 4096 = KP * 1280 rpm/%",
      "bit_length": 16,
      "scaling": 0.00078125,
      "offset": 0,
      "unit": "%/rpm",
      "SLOT_ID": 22
    },
    "546": {
      "PGN": 65249,
      "PGN_Name": "Retarder Configuration",
      "PGN_Description": "RC",
      "first_bit": 16,
      "SPN": 546,
      "SPN_Name": "Retarder Speed At Idle, Point 1",
      "SPN_Description": "Please reference PGN 65249",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "547": {
      "PGN": 65249,
      "PGN_Name": "Retarder Configuration",
      "PGN_Description": "RC",
      "first_bit": 112,
      "SPN": 547,
      "SPN_Name": "Retarder Speed At Peak Torque, Point 5",
      "SPN_Description": "Please reference PGN 65249",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "548": {
      "PGN": 65249,
      "PGN_Name": "Retarder Configuration",
      "PGN_Description": "RC",
      "first_bit": 40,
      "SPN": 548,
      "SPN_Name": "Maximum Retarder Speed, Point 2",
      "SPN_Description": "Maximum speed of retarder (Please reference PGN 65249).",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "549": {
      "PGN": 65249,
      "PGN_Name": "Retarder Configuration",
      "PGN_Description": "RC",
      "first_bit": 64,
      "SPN": 549,
      "SPN_Name": "Retarder Speed At Point 3",
      "SPN_Description": "Retarder speed of point 3 of the engine retarder torque map.  Please reference PGN 65249.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "550": {
      "PGN": 65249,
      "PGN_Name": "Retarder Configuration",
      "PGN_Description": "RC",
      "first_bit": 88,
      "SPN": 550,
      "SPN_Name": "Retarder Speed At Point 4",
      "SPN_Description": "Retarder speed of point 4 of the engine retarder torque map.  Please reference PGN 65249.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "551": {
      "PGN": 65249,
      "PGN_Name": "Retarder Configuration",
      "PGN_Description": "RC",
      "first_bit": 32,
      "SPN": 551,
      "SPN_Name": "Retarder Percent Torque At Idle, Point 1",
      "SPN_Description": "The torque limit that indicates the available retarder torque which can be provided by the retarder at idle speed.  The data is transmitted in indicated torque as a percent of the reference retarder torque.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "552": {
      "PGN": 65249,
      "PGN_Name": "Retarder Configuration",
      "PGN_Description": "RC",
      "first_bit": 56,
      "SPN": 552,
      "SPN_Name": "Retarder Percent Torque At Maximum Speed, Point 2",
      "SPN_Description": "The torque limit that indicates the available retarder torque which can be provided by the retarder at its maximum speed.  Please reference PGN 65249.  The data is transmitted in indicated torque as a percent of the reference retarder torque.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "553": {
      "PGN": 65249,
      "PGN_Name": "Retarder Configuration",
      "PGN_Description": "RC",
      "first_bit": 80,
      "SPN": 553,
      "SPN_Name": "Retarder Percent Torque At Point 3",
      "SPN_Description": "The torque limit that indicates the available retarder torque which can be provided by the retarder at points 3 and 4 of the retarder torque map.  Please reference PGN 65249.  The data is transmitted in indicated torque as a percent of the reference retarder torque.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "554": {
      "PGN": 65249,
      "PGN_Name": "Retarder Configuration",
      "PGN_Description": "RC",
      "first_bit": 104,
      "SPN": 554,
      "SPN_Name": "Retarder Percent Torque At Point 4",
      "SPN_Description": "The torque limit that indicates the available retarder torque which can be provided by the retarder at points 3 and 4 of the retarder torque map.  Please reference PGN 65249.  The data is transmitted in indicated torque as a percent of the reference retarder torque.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "555": {
      "PGN": 65249,
      "PGN_Name": "Retarder Configuration",
      "PGN_Description": "RC",
      "first_bit": 144,
      "SPN": 555,
      "SPN_Name": "Retarder Percent Torque At Peak Torque, Point 5",
      "SPN_Description": "The torque limit that indicates the available retarder torque which can be provided by the retarder at point 5 of the retarder torque map.  Please reference PGN 65249.  The data is transmitted in indicated torque as a percent of the reference retarder torque.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "556": {
      "PGN": 65249,
      "PGN_Name": "Retarder Configuration",
      "PGN_Description": "RC",
      "first_bit": 128,
      "SPN": 556,
      "SPN_Name": "Retarder Reference Torque",
      "SPN_Description": "This parameter is the 100% reference value for all defined indicated retarder torque parameters.  It is only defined once and doesn't change if a different retarder torque map becomes valid.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Nm",
      "SLOT_ID": 70
    },
    "557": {
      "PGN": 65249,
      "PGN_Name": "Retarder Configuration",
      "PGN_Description": "RC",
      "first_bit": 8,
      "SPN": 557,
      "SPN_Name": "Retarder Control Method",
      "SPN_Description": "This parameter identifies the number of steps used by the retarder.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "step",
      "SLOT_ID": 84
    },
    "558": {
      "PGN": 61443,
      "PGN_Name": "Electronic Engine Controller 2",
      "PGN_Description": "EEC2",
      "first_bit": 0,
      "SPN": 558,
      "SPN_Name": "Accelerator Pedal 1 Low Idle Switch",
      "SPN_Description": "Switch signal which indicates the state of the accelerator pedal 1 low idle switch.  The low idle switch is defined in SAE Recommended Practice J1843.\r\n  \r\n00 - Accelerator pedal 1 not in low idle condition\r\n01 - Accelerator pedal 1 in low idle condition\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "559": {
      "PGN": 61443,
      "PGN_Name": "Electronic Engine Controller 2",
      "PGN_Description": "EEC2",
      "first_bit": 2,
      "SPN": 559,
      "SPN_Name": "Accelerator Pedal Kickdown Switch",
      "SPN_Description": "Switch signal which indicates whether the accelerator pedal kickdown switch is opened or closed.  The kickdown switch is defined in SAE J1843.\r\n\r\n00 - Kickdown passive\r\n01 - Kickdown active\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "560": {
      "PGN": 61442,
      "PGN_Name": "Electronic Transmission Controller 1",
      "PGN_Description": "ETC1",
      "first_bit": 0,
      "SPN": 560,
      "SPN_Name": "Transmission Driveline Engaged",
      "SPN_Description": "Driveline engaged indicates the transmission controlled portion of the driveline is engaged sufficiently to allow a transfer of torque through the transmission.  Driveline engaged is ACTIVE whenever the transmission is in gear and the clutch (if controlled by the transmission controller) is less than 100% clutch slip (clutch able to transfer torque).  This parameter should be used in conjunction with the parameter “Shift in Process” (SPN 574).  While a shift is in process, the receiver should not assume that the driveline is either fully engaged or disengaged (i.e., cruise control).\r\n\r\n00 - Driveline disengaged\r\n01 - Driveline engaged\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "561": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 0,
      "SPN": 561,
      "SPN_Name": "ASR Engine Control Active",
      "SPN_Description": "State signal which indicates that ASR engine control has been commanded to be active. Active means that ASR actually tries to control the engine. This state signal is independent of other control commands to the engine (e.g., from the transmission) which may have higher priority.\r\n\r\n00 - ASR engine control passive but installed\r\n01 - ASR engine control active\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "562": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 2,
      "SPN": 562,
      "SPN_Name": "ASR Brake Control Active",
      "SPN_Description": "State signal which indicates that ASR brake control is active. Active means that ASR actually controls wheel brake pressure at one or more wheels of the driven axle(s).\r\n\r\n00 - ASR brake control passive but installed\r\n01 - ASR brake control active\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "563": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 4,
      "SPN": 563,
      "SPN_Name": "Anti-Lock Braking (ABS) Active",
      "SPN_Description": "State signal which indicates that the ABS is active.  The signal is set active when wheel brake pressure actually starts to be modulated by ABS and is reset to passive when all wheels are in a stable condition for a certain time.  The signal can also be set active when driven wheels are in high slip  (e.g., caused by retarder).  Whenever the ABS system is not fully operational (due to a defect or during off-road ABS operation) , this signal is only valid for that part of the system that is still working.  When ABS is switched off completely, the flag is set to passive regardless of the current wheel slip conditions.\r\n\r\n00 - ABS passive but installed\r\n01 - ABS active\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "564": {
      "PGN": 61446,
      "PGN_Name": "Electronic Axle Controller 1",
      "PGN_Description": "EAC1",
      "first_bit": 16,
      "SPN": 564,
      "SPN_Name": "Differential Lock State - Central",
      "SPN_Description": "State used which indicates the condition of the central differential lock.  The differential locks are located as defined in attached figure SPN564_A.\r\n\r\n00 Differential lock disengaged\r\n01 Differential lock engaged\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "565": {
      "PGN": 61446,
      "PGN_Name": "Electronic Axle Controller 1",
      "PGN_Description": "EAC1",
      "first_bit": 18,
      "SPN": 565,
      "SPN_Name": "Differential Lock State - Central Front",
      "SPN_Description": "State used which indicates the condition of the central front differential lock.  The differential locks are located as defined in figure SPN564_A.\r\n\r\n00 Differential lock disengaged\r\n01 Differential lock engaged\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "566": {
      "PGN": 61446,
      "PGN_Name": "Electronic Axle Controller 1",
      "PGN_Description": "EAC1",
      "first_bit": 20,
      "SPN": 566,
      "SPN_Name": "Differential Lock State - Central Rear",
      "SPN_Description": "State used which indicates the condition of the central rear differential lock.  The differential locks are located as defined in figure SPN564_A.\r\n\r\n00 Differential lock disengaged\r\n01 Differential lock engaged\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "567": {
      "PGN": 61446,
      "PGN_Name": "Electronic Axle Controller 1",
      "PGN_Description": "EAC1",
      "first_bit": 8,
      "SPN": 567,
      "SPN_Name": "Differential Lock State - Front Axle 1",
      "SPN_Description": "State used which indicates the condition of the front axle 1 differential lock.  The differential locks are located as defined in figure SPN564_A.\r\n\r\n00 Differential lock disengaged\r\n01 Differential lock engaged\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "568": {
      "PGN": 61446,
      "PGN_Name": "Electronic Axle Controller 1",
      "PGN_Description": "EAC1",
      "first_bit": 10,
      "SPN": 568,
      "SPN_Name": "Differential Lock State - Front Axle 2",
      "SPN_Description": "State used which indicates the condition of the front axle 2 differential lock. The differential locks are located as defined in figure SPN 564_A.\r\n\r\n00 Differential lock disengaged\r\n01 Differential lock engaged\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "569": {
      "PGN": 61446,
      "PGN_Name": "Electronic Axle Controller 1",
      "PGN_Description": "EAC1",
      "first_bit": 12,
      "SPN": 569,
      "SPN_Name": "Differential Lock State - Rear Axle 1",
      "SPN_Description": "State used which indicates the condition of the rear axle 1 differential lock.  The differential locks are located as defined in figure SPN 564_A.\r\n\r\n00 Differential lock disengaged\r\n01 Differential lock engaged\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "570": {
      "PGN": 61446,
      "PGN_Name": "Electronic Axle Controller 1",
      "PGN_Description": "EAC1",
      "first_bit": 14,
      "SPN": 570,
      "SPN_Name": "Differential Lock State - Rear Axle 2",
      "SPN_Description": "State used which indicates the condition of the rear axle 2 differential lock.  The differential locks are located as defined in figure SPN 564_A.\r\n\r\n00 Differential lock disengaged\r\n01 Differential lock engaged\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "571": {
      "PGN": 61440,
      "PGN_Name": "Electronic Retarder Controller 1",
      "PGN_Description": "ERC1",
      "first_bit": 4,
      "SPN": 571,
      "SPN_Name": "Retarder Enable - Brake Assist Switch",
      "SPN_Description": "Switch signal which indicates whether the operator wishes the retarder to be enabled for vehicle braking assist. The retarder does not check this switch, nor does the enabling of this switch engage the retarder. When this switch is “enabled,” the devices constructing TSC1 – destination retarder messages may command retarder torque for braking. For example, the cruise control should not request retarder torque if this switch is not “enabled.” The switch exists to prevent the engine retarder from being asked to be engaged via TSC1 in a noise sensitive area. See also SPN 572\r\n\r\n00 Retarder - brake assist disabled\r\n01 Retarder - brake assist enabled\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "572": {
      "PGN": 61440,
      "PGN_Name": "Electronic Retarder Controller 1",
      "PGN_Description": "ERC1",
      "first_bit": 6,
      "SPN": 572,
      "SPN_Name": "Retarder Enable - Shift Assist Switch",
      "SPN_Description": "Switch signal which indicates whether the operator wishes the retarder to be enabled for transmission shift assist.  The retarder does not check this switch, nor does the enabling of this switch engage the retarder.  When this switch is “enabled,” the transmission may activate the retarder (via the TSC1 message) to increase the rate of engine deceleration to assist in shift control.  The switch exists to prevent the engine retarder from being asked to be engaged via TSC1 in a noise sensitive area.  See SPN 571.\r\n\r\n00 Retarder - shift assist disabled\r\n01 Retarder - shift assist enabled\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "573": {
      "PGN": 61442,
      "PGN_Name": "Electronic Transmission Controller 1",
      "PGN_Description": "ETC1",
      "first_bit": 2,
      "SPN": 573,
      "SPN_Name": "Transmission Torque Converter Lockup Engaged",
      "SPN_Description": "State signal which indicates whether the torque converter lockup is engaged.\r\n\r\n00 Torque converter lockup disengaged\r\n01 Torque converter lockup engaged\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "574": {
      "PGN": 61442,
      "PGN_Name": "Electronic Transmission Controller 1",
      "PGN_Description": "ETC1",
      "first_bit": 4,
      "SPN": 574,
      "SPN_Name": "Transmission Shift In Process",
      "SPN_Description": "Indicates that the transmission is in process of shifting from the current gear to the selected gear. This state is generally ACTIVE during the entire time that the transmission controls the vehicle during a shift. This includes any transmission clutch control, all engine control sequences, pulling to transmission neutral, and engaging the destination gear (e.g., until it is no longer sending commands and/or limits to the engine). See also SPN 560. (See Figure SPN574_A)\r\n\r\nThis state is INACTIVE during other engine control such as torque limiting outside of a shift.\r\n\r\n00  -  Shift is not in process \r\n01  -  Shift in process\r\n10  -  Error\r\n11  -  Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "575": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 16,
      "SPN": 575,
      "SPN_Name": "ABS Off-road Switch",
      "SPN_Description": "Switch signal which indicates the position of the ABS off-road switch.\r\n\r\n00 - ABS off-road switch passive\r\n01 - ABS off-road switch active\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "576": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 18,
      "SPN": 576,
      "SPN_Name": "ASR Off-road Switch",
      "SPN_Description": "Switch signal which indicates the position of the ASR off-road switch.\r\n\r\n00 - ASR off-road switch passive\r\n01 - ASR off-road switch active\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "577": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 20,
      "SPN": 577,
      "SPN_Name": "ASR \"Hill Holder\" Switch",
      "SPN_Description": "Switch signal which indicates the position of the ASR “hill holder” switch.\r\n\r\n00 - ASR “hill holder” switch passive\r\n01 - ASR “hill holder” switch active\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "578": {
      "PGN": 65273,
      "PGN_Name": "Axle Information",
      "PGN_Description": "AI",
      "first_bit": 24,
      "SPN": 578,
      "SPN_Name": "Drive Axle Temperature",
      "SPN_Description": "Temperature of axle lubricant in drive axle.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "579": {
      "PGN": 65273,
      "PGN_Name": "Axle Information",
      "PGN_Description": "AI",
      "first_bit": 16,
      "SPN": 579,
      "SPN_Name": "Drive Axle Lift Air Pressure",
      "SPN_Description": "Gage pressure of air in system that utilizes compressed air to provide force between axle and frame.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "580": {
      "PGN": 65256,
      "PGN_Name": "Vehicle Direction/Speed",
      "PGN_Description": "VDS",
      "first_bit": 48,
      "SPN": 580,
      "SPN_Name": "Altitude",
      "SPN_Description": "Altitude of the vehicle referenced to sea level at standard atmospheric pressure and temperature.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": -2500,
      "unit": "m",
      "SLOT_ID": 39
    },
    "581": {
      "PGN": 65250,
      "PGN_Name": "Transmission Configuration",
      "PGN_Description": "TCFG",
      "first_bit": 16,
      "SPN": 581,
      "SPN_Name": "Transmission Gear Ratio",
      "SPN_Description": "The transmission configuration describes the number of forward gears, the number of reverse gears, and the ratio of each gear with the following resolution.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 32
    },
    "582": {
      "PGN": 65258,
      "PGN_Name": "Vehicle Weight",
      "PGN_Description": "VW",
      "first_bit": 8,
      "SPN": 582,
      "SPN_Name": "Axle Weight",
      "SPN_Description": "Total mass imposed by the tires on the road surface at the specified axle.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 27
    },
    "583": {
      "PGN": 65256,
      "PGN_Name": "Vehicle Direction/Speed",
      "PGN_Description": "VDS",
      "first_bit": 32,
      "SPN": 583,
      "SPN_Name": "Pitch",
      "SPN_Description": "Pitch (rotation about the y-axis) of the vehicle as calculated by the navigation device(s).  The pitch angle for an angle of ascent is reported with a positive value. This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "584": {
      "PGN": 65267,
      "PGN_Name": "Vehicle Position 1",
      "PGN_Description": "VP1",
      "first_bit": 0,
      "SPN": 584,
      "SPN_Name": "Latitude",
      "SPN_Description": "Latitude position of the vehicle.",
      "bit_length": 32,
      "scaling": 1e-7,
      "offset": -210,
      "unit": "deg",
      "SLOT_ID": 7
    },
    "585": {
      "PGN": 65267,
      "PGN_Name": "Vehicle Position 1",
      "PGN_Description": "VP1",
      "first_bit": 32,
      "SPN": 585,
      "SPN_Name": "Longitude",
      "SPN_Description": "Longitude position of the vehicle.",
      "bit_length": 32,
      "scaling": 1e-7,
      "offset": -210,
      "unit": "deg",
      "SLOT_ID": 7
    },
    "589": {
      "PGN": 65237,
      "PGN_Name": "Alternator Information",
      "PGN_Description": "AS",
      "first_bit": 0,
      "SPN": 589,
      "SPN_Name": "Alternator Speed",
      "SPN_Description": "Actual rotation speed of the alternator.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "590": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 6,
      "SPN": 590,
      "SPN_Name": "Engine Idle Shutdown Timer State",
      "SPN_Description": "Status signal which indicates the current mode of operation of the idle shutdown timer system.  See Figure SPN590_A.\r\n\r\n00 - Inactive\r\n01 - Active\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "591": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 14,
      "SPN": 591,
      "SPN_Name": "Engine Idle Shutdown Timer Function",
      "SPN_Description": "Parameter which indicates the configuration of the idle shutdown timer system.\r\n\r\n00 - Disabled in calibration\r\n01 - Enabled in calibration\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "592": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 4,
      "SPN": 592,
      "SPN_Name": "Engine Idle Shutdown Timer Override",
      "SPN_Description": "Status signal which indicates the status of the override feature of the idle shutdown timer system.  See Figure SPN590_A.\r\n\r\n00 - Inactive\r\n01 - Active\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "593": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 0,
      "SPN": 593,
      "SPN_Name": "Engine Idle Shutdown has Shutdown Engine",
      "SPN_Description": "Status signal which identifies whether or not the engine has been shutdown by the idle shutdown timer system.  See Figure SPN590_A.\r\n\r\n00 - No\r\n01 - Yes\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "594": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 2,
      "SPN": 594,
      "SPN_Name": "Engine Idle Shutdown Driver Alert Mode",
      "SPN_Description": "Status signal which indicates the status of the driver alert mode of the idle shutdown timer system.  While the driver alert mode is active, the idle shutdown timer may be overridden.  See Figure SPN590_A.\r\n\r\n00 - Inactive\r\n01 - Active\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "595": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 24,
      "SPN": 595,
      "SPN_Name": "Cruise Control Active",
      "SPN_Description": "Cruise control is switched on.  It is not ensured that the engine is controlled by cruise control, as in the case of a large driver's demand the engine is controlled by the driver while cruise control is active (maximum selection of cruise control and driver’s demand).  The cruise control is set to 0 if a switch off condition occurs.\r\n\r\n00 - Cruise control switched off\r\n01 - Cruise control switched on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "596": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 26,
      "SPN": 596,
      "SPN_Name": "Cruise Control Enable Switch",
      "SPN_Description": "Switch signal which indicates that it is possible to manage the cruise control function.\r\n\r\n00 - Cruise control disabled\r\n01 - Cruise control enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "597": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 28,
      "SPN": 597,
      "SPN_Name": "Brake Switch",
      "SPN_Description": "Switch signal which indicates that the driver operated brake foot pedal is being pressed.  This brake foot pedal is controlling the vehicles’ service brake (total vehicle braking application, not park brakes).  It is necessary for safe drivetrain behavior that the switch activates before the physical braking components are activated (i.e. Disengage the cruise control function prior to the activation of friction brakes).\r\n\r\n00 - Brake pedal released\r\n01 - Brake pedal depressed\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "598": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 30,
      "SPN": 598,
      "SPN_Name": "Clutch Switch",
      "SPN_Description": "Switch signal which indicates that the clutch pedal is being pressed. It is necessary for a safe drivetrain behavior that the clutch switch is set before the clutch is opened (cruise control function).\r\n\r\n00 - Clutch pedal released\r\n01 - Clutch pedal depressed\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "599": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 32,
      "SPN": 599,
      "SPN_Name": "Cruise Control Set Switch",
      "SPN_Description": "Switch signal of the cruise control activator which indicates that the activator is in the position “set.”\r\n\r\n00 - Cruise control activator not in the position “set”\r\n01 - Cruise control activator in position “set”\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "600": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 34,
      "SPN": 600,
      "SPN_Name": "Cruise Control Coast (Decelerate) Switch",
      "SPN_Description": "Switch signal of the cruise control activator which indicates that the activator is in the position “coast (decelerate).”\r\n\r\n00 - Cruise control activator not in the position “coast”\r\n01 - Cruise control activator in position “coast”\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "601": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 36,
      "SPN": 601,
      "SPN_Name": "Cruise Control Resume Switch",
      "SPN_Description": "Switch signal of the cruise control activator which indicates that the activator is in the position “resume.”\r\n\r\n00 - Cruise control activator not in the position “resume”\r\n01 - Cruise control activator in position “resume”\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "602": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 38,
      "SPN": 602,
      "SPN_Name": "Cruise Control Accelerate Switch",
      "SPN_Description": "Switch signal of the cruise control activator which indicates that the activator is in the position “accelerate.”\r\n\r\n00 - Cruise control activator not in the position “accelerate”\r\n01 - Cruise control activator in position “accelerate”\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "604": {
      "PGN": 65219,
      "PGN_Name": "Electronic Transmission Controller 5",
      "PGN_Description": "ETC5",
      "first_bit": 10,
      "SPN": 604,
      "SPN_Name": "Transmission Neutral Switch",
      "SPN_Description": "Identifies the status of the switch that indicates neutral.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "605": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 20,
      "SPN": 605,
      "SPN_Name": "Refrigerant High Pressure Switch",
      "SPN_Description": "Switch signal which indicates the position of the high pressure switch in the coolant circuit of an air conditioning system.  When the switch is enabled, the pressure inside the circuit is too high and the compressor clutch may be disengaged.\r\n\r\n00 - Pressure normal\r\n01 - Pressure too high, compressor clutch may be disengaged\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "606": {
      "PGN": 61442,
      "PGN_Name": "Electronic Transmission Controller 1",
      "PGN_Description": "ETC1",
      "first_bit": 32,
      "SPN": 606,
      "SPN_Name": "Engine Momentary Overspeed Enable",
      "SPN_Description": "Command signal used to indicate that the engine speed may be boosted up to the maximum engine overspeed value to accommodate transmission downshifts.  The maximum time for overspeed is limited by the time defined in the engine configuration message (see PGN 65,251).  The transmission module must command a “override disabled” state at least once before the engine will accept a subsequent request for overspeed.\r\n\r\n00 Momentary engine overspeed is disabled\r\n01 Momentary engine overspeed is enabled\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "607": {
      "PGN": 61442,
      "PGN_Name": "Electronic Transmission Controller 1",
      "PGN_Description": "ETC1",
      "first_bit": 34,
      "SPN": 607,
      "SPN_Name": "Progressive Shift Disable",
      "SPN_Description": "Command signal used to indicate that progressive shifting by the engine should be disallowed.\r\n\r\n00 Progressive shift is not disabled\r\n01 Progressive shift is disabled\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "619": {
      "PGN": 65274,
      "PGN_Name": "Brakes 1",
      "PGN_Description": "B1",
      "first_bit": 24,
      "SPN": 619,
      "SPN_Name": "Parking Brake Actuator",
      "SPN_Description": "Signal which indicates the current state of the actuator(s) that control the parking brake (see also SPN 70 and 5275).\r\n\r\n00 - Parking brake actuator inactive\r\n01 - Parking brake actuator active\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "626": {
      "PGN": 64966,
      "PGN_Name": "Cold Start Aids",
      "PGN_Description": "CSA",
      "first_bit": 0,
      "SPN": 626,
      "SPN_Name": "Engine Start Enable Device 1",
      "SPN_Description": "Devices that assist an Engine in starting, e.g. intake heaters and ether.  Primary starting aid.\r\nParameter indicating whether the start enable device 1 is ON or OFF\r\n\r\n00 - start enable OFF\r\n01 - start enable ON\r\n10 - reserved\r\n11 - not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "632": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 26,
      "SPN": 632,
      "SPN_Name": "Engine Fuel Shutoff 1 Control",
      "SPN_Description": "Control setting for fuel shutoff 1.  The second instance is SPN 2807.  For a single fuel shutoff system, this represents its commanded position.  For a dual fuel shutoff system, this SPN is representative of the upstream fuel shutoff commanded position.  When fuel (gas) is desired at the engine, the fuel shutoff is opened.  Otherwise, it is closed.\r\n\r\n00 = Open (fuel supplied to engine)\r\n01 = Closed (no fuel supplied to engine)\r\n10 = Reserved\r\n11 = Don't care / take no action\r\n\r\nIn addition to communicating desired action of fuel shutoff 1 and its driver status, this new SPN can be used to communicate whether fuel shutoff 1 feedback position (if available) matches the commanded position, through the use of FMIs.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "633": {
      "PGN": 61466,
      "PGN_Name": "Engine Throttle / Fuel Actuator Control Command",
      "PGN_Description": "TFAC",
      "first_bit": 32,
      "SPN": 633,
      "SPN_Name": "Engine Fuel Actuator 1 Control Command",
      "SPN_Description": "The control command to fuel actuator 1, normalized to percent, where 0% represents fully closed and 100% represents fully open. In applications where the fuel actuator controls to differential pressure, 0% represents minimum differential pressure and 100% represents maximum differential pressure. Typically, this fuel actuator is used to regulate low pressure natural gas flow rate, mixing into the air flow, which together then come into the engine. Using the standard convention for determining the position. If only 2 actuators are present, then left/front is #1 (SPN 633) and right/rear is #2 (SPN 1244). If more than two actuators are present, then left/front is #1 (SPN 633), left/rear is #2 (SPN 1244), right/front is #3 (SPN 7593) and right/rear is #4 (SPN 7594).\r\n\r\nThe values of 0xFB00 - 0xFB64 are sent to initiate the self calibration of the fuel actuator. The LSB specifies the % to calibrate to with a resolution of 1%/bit (eg, 0xFB32 is sent to calibrate the actuator to 50%). In the case of a differential pressure control, this calibration is in terms of differential pressure.\r\n\r\nThe value of 0xFBFF is sent to command the fully closed position for differential pressure control applications.\r\n\r\nNote:  Existing applications of this SPN may not support the calibration or forced closure features.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "635": {
      "PGN": 64670,
      "PGN_Name": "Engine Timing Actuator Position",
      "PGN_Description": "ETAP",
      "first_bit": 0,
      "SPN": 635,
      "SPN_Name": "Engine Timing Actuator 1",
      "SPN_Description": "The detected position of actuator 1 on the Engine Timing System, where the system has different timing positions depending on current operating status of the engine. Timing positions may be used to determine intake and outlet valve timings.\r\n\r\n000 - Unknown Position\r\n001 - Diesel Mode Position\r\n010 - Diesel Part Load Position\r\n011 - Gas Mode Position\r\n100 - Diesel Part Load / Gas Mode Position\r\n101 - 110 - Reserved\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "641": {
      "PGN": 64931,
      "PGN_Name": "Electronic Engine Controller 6",
      "PGN_Description": "EEC6",
      "first_bit": 16,
      "SPN": 641,
      "SPN_Name": "Engine Variable Geometry Turbocharger Actuator #1",
      "SPN_Description": "Actuator that controls the variable geometry turbocharger geometry.The control command to the actuator, normalized to percent, where 0% nominally represents fully closed (smallest turbocharger geometry) and 100% represents fully open (largest geometry turbocharger).",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "649": {
      "PGN": 61486,
      "PGN_Name": "Engine Turbocharger Control",
      "PGN_Description": "ETCC",
      "first_bit": 32,
      "SPN": 649,
      "SPN_Name": "Engine Exhaust Bank 1 Pressure Regulator Control Command",
      "SPN_Description": "The control command to the Engine Exhaust Pressure Regulator in bank 1, normalized to percent.  100 percent means the regulator is fully closed, providing the maximum restriction to exhaust gas flow from the engine.  Zero percent means the regulator is fully open, providing the minimum available restriction.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "681": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 0,
      "SPN": 681,
      "SPN_Name": "Transmission Gear Shift Inhibit Request",
      "SPN_Description": "Command signal to inhibit gear shifts.\r\n\r\n00 Gear shifts are allowed  (disable function)\r\n01 Gear shifts are inhibited  (enable function)\r\n10 Reserved\r\n11 Take no action  (leave function as is)",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "682": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 2,
      "SPN": 682,
      "SPN_Name": "Transmission Torque Converter Lockup Disable Request",
      "SPN_Description": "Command signal to prevent torque converter lockup, which may cause problems in certain circumstances for ASR.\r\n\r\n00 Allow torque converter lockup\r\n01 Disable torque converter lockup\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "683": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 4,
      "SPN": 683,
      "SPN_Name": "Disengage Driveline Request",
      "SPN_Description": "Command signal used to simply disengage the driveline, e.g., to prevent engine drag torque from causing high wheel slip on slippery surfaces.\r\n\r\n00 Allow driveline engagement\r\n01 Disengage driveline\r\n10 Reserved\r\n11 Take no action\r\n\r\nNote:  If this signal is used to disengage the driveline for fuel economy purposes, the sender should consider SPN 7430 PCC Driveline Disengage Inhibit Request.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "684": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 8,
      "SPN": 684,
      "SPN_Name": "Requested Percent Clutch Slip",
      "SPN_Description": "Parameter which represents the percent clutch slip requested by a device.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "685": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 24,
      "SPN": 685,
      "SPN_Name": "Disengage Differential Lock Request - Front Axle 1",
      "SPN_Description": "Command signal used to disengage the various differential locks, e.g., to allow an undistributed individual wheel control by ABS.  The differential locks are located as defined in Figure SPN564_A.\r\n\r\n00 Engage differential lock\r\n01 Disengage differential lock\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "686": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 26,
      "SPN": 686,
      "SPN_Name": "Disengage Differential Lock Request - Front Axle 2",
      "SPN_Description": "Command signal used to disengage the various differential locks, e.g., to allow an undistributed individual wheel control by ABS.  The differential locks are located as defined in Figure SPN564_A.\r\n\r\n00 Engage differential lock\r\n01 Disengage differential lock\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "687": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 28,
      "SPN": 687,
      "SPN_Name": "Disengage Differential Lock Request - Rear Axle 1",
      "SPN_Description": "Command signal used to disengage the various differential locks, e.g., to allow an undistributed individual wheel control by ABS.  The differential locks are located as defined in Figure SPN564_A.\r\n\r\n00 Engage differential lock\r\n01 Disengage differential lock\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "688": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 30,
      "SPN": 688,
      "SPN_Name": "Disengage Differential Lock Request - Rear Axle 2",
      "SPN_Description": "Command signal used to disengage the various differential locks, e.g., to allow an undistributed individual wheel control by ABS.  The differential locks are located as defined in Figure SPN564_A.\r\n\r\n00 Engage differential lock\r\n01 Disengage differential lock\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "689": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 32,
      "SPN": 689,
      "SPN_Name": "Disengage Differential Lock Request - Central",
      "SPN_Description": "Command signal used to disengage the various differential locks, e.g., to allow an undistributed individual wheel control by ABS.  The differential locks are located as defined in Figure SPN564_A.\r\n\r\n00 Engage differential lock\r\n01 Disengage differential lock\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "690": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 34,
      "SPN": 690,
      "SPN_Name": "Disengage Differential Lock Request - Central Front",
      "SPN_Description": "Command signal used to disengage the various differential locks, e.g., to allow an undistributed individual wheel control by ABS.  The differential locks are located as defined in Figure SPN564_A.\r\n\r\n00 Engage differential lock\r\n01 Disengage differential lock\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "691": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 36,
      "SPN": 691,
      "SPN_Name": "Disengage Differential Lock Request - Central Rear",
      "SPN_Description": "Command signal used to disengage the various differential locks, e.g., to allow an undistributed individual wheel control by ABS.  The differential locks are located as defined in Figure SPN564_A.\r\n\r\n00 Engage differential lock\r\n01 Disengage differential lock\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "695": {
      "PGN": 0,
      "PGN_Name": "Torque/Speed Control 1",
      "PGN_Description": "TSC1",
      "first_bit": 0,
      "SPN": 695,
      "SPN_Name": "Engine Override Control Mode",
      "SPN_Description": "The override control mode defines which sort of command is used:\r\n\r\n00 Override disabled - Disable any existing control commanded by the source of this command.\r\n01 Speed control - Govern speed to the included “desired speed” value.\r\n10 Torque control - Control torque to the included “desired torque” value.\r\n11 Speed/torque limit control - Limit speed and/or torque based on the included limit values.  The speed limit governor is a droop governor where the speed limit value defines the speed at the maximum torque available during this operation.\r\n\r\nIf a device wants to know whether it has access to the engine, there are several possibilities:\r\n\r\na. Comparing its command with the actual engine broadcasts.\r\nb. Looking at command modes from other devices.\r\nc. Looking to the engine and retarder torque mode.\r\n\r\nRemarks:\r\n\r\na. The realization of a torque limit (minimum selection) is possible by setting the speed limit to a high value (0xFAFF).\r\nb. The realization of a speed limit (minimum selection) is possible by setting the torque limit to a high value (0xFA).\r\nc. Limiting the retarder torque means to limit the magnitude of the torque request.  As the brake torque is represented by negative torque values, the limitation must be done by a maximum selection of the requested torque and the retarder internal torque signals.\r\nd. For torque increasing functions, time limits for the torque or speed value (command) and the direct modes are desirable.\r\n\r\ne. The selection of which device has control of the engine's speed or torque depends on the override mode priority (see SPN 897) with the highest priority device gaining control.  In the case of two devices with identical priority, the engine responds to speed/torque control commands over speed/torque limit commands and will act on the speed or torque commands on a first come, first served basis.  The torque limit will be a “lowest wins” selection (e.g., if one device commands 60% limit and another 80% limit, then the engine will limit torque to 60%).  Figure SPN695_A provides a flowchart of the torque/speed control priority selection logic.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "696": {
      "PGN": 0,
      "PGN_Name": "Torque/Speed Control 1",
      "PGN_Description": "TSC1",
      "first_bit": 2,
      "SPN": 696,
      "SPN_Name": "Engine Requested Speed Control Conditions",
      "SPN_Description": "This mode tells the engine control system the governor characteristics that are desired during speed control.  The four characteristics defined are:\r\n\r\n00 Transient Optimized for driveline disengaged and non-lockup conditions\r\n01 Stability Optimized for driveline disengaged and non-lockup conditions\r\n10 Stability Optimized for driveline engaged and/or in lockup condition 1 (e.g., vehicle driveline)\r\n11 Stability Optimized for driveline engaged and/or in lockup condition 2 (e.g., PTO driveline)\r\n\r\n00b - This speed governor gain selection is adjusted to provide rapid transition between speed setpoints.  RPM overshoot and undershoot may be greater than what is seen when the “speed control characteristic” is set to be stability optimized.\r\n\r\n01b - This control condition has been optimized to minimize rpm overshoot and undershoot given an expected plant consisting of the engine and its accessory loads.  This gain adjustment is not intended to compensate for driveline characteristics.  This characteristic is most appropriate when no driveline is connected.\r\n\r\n10b - This control condition has been optimized to minimize rpm overshoot and undershoot given a more complex plant.  For instance, the more complex plant would contain the engine, its accessory loads and the driveline characteristics.  As an example, the driveline characteristics might include the effective spring mass relationship of pumps, tires, clutches, axles, driveshafts, and multiple gear ratios.  This characteristic is most appropriate when a driveline is engaged.\r\n\r\n11b - This speed control characteristic is available for applications requiring compensation for more than one driveline characteristic.  It has been optimized to minimize rpm overshoot and undershoot given a more complex plant of the second variety.  This more complex plant would again contain the engine, its accessory loads and a second driveline characteristic unique from the one described in speed control characteristic 10b.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "701": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 6,
      "SPN": 701,
      "SPN_Name": "Auxiliary I/O #01",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "702": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 4,
      "SPN": 702,
      "SPN_Name": "Auxiliary I/O #02",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "703": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 2,
      "SPN": 703,
      "SPN_Name": "Auxiliary I/O #03",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "704": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 0,
      "SPN": 704,
      "SPN_Name": "Auxiliary I/O #04",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "705": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 14,
      "SPN": 705,
      "SPN_Name": "Auxiliary I/O #05",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "706": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 12,
      "SPN": 706,
      "SPN_Name": "Auxiliary I/O #06",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "707": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 10,
      "SPN": 707,
      "SPN_Name": "Auxiliary I/O #07",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "708": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 8,
      "SPN": 708,
      "SPN_Name": "Auxiliary I/O #08",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "709": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 22,
      "SPN": 709,
      "SPN_Name": "Auxiliary I/O #09",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "710": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 20,
      "SPN": 710,
      "SPN_Name": "Auxiliary I/O #10",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "711": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 18,
      "SPN": 711,
      "SPN_Name": "Auxiliary I/O #11",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "712": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 16,
      "SPN": 712,
      "SPN_Name": "Auxiliary I/O #12",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "713": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 30,
      "SPN": 713,
      "SPN_Name": "Auxiliary I/O #13",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "714": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 28,
      "SPN": 714,
      "SPN_Name": "Auxiliary I/O #14",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "715": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 26,
      "SPN": 715,
      "SPN_Name": "Auxiliary I/O #15",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "716": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 24,
      "SPN": 716,
      "SPN_Name": "Auxiliary I/O #16",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "723": {
      "PGN": 61473,
      "PGN_Name": "Engine Speed Sensor Information 1",
      "PGN_Description": "ESSI1",
      "first_bit": 16,
      "SPN": 723,
      "SPN_Name": "Engine Speed 2",
      "SPN_Description": "The engine speed as measured by speed sensor 2\r\n\r\nNote:  This is for the engine speed from the 2nd engine speed sensor.  This may be different than SPN 190 when used in multiple engine speed sensor configurations.   In an application with multiple engine speed sensors, SPN 190 data can be derived from any of the speed sensors.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "728": {
      "PGN": 64480,
      "PGN_Name": "Aftercooler and Oil Cooler Fluids 1",
      "PGN_Description": "ACOCF1",
      "first_bit": 32,
      "SPN": 728,
      "SPN_Name": "Engine Oil Cooler Coolant Outlet Temperature",
      "SPN_Description": "Temperature of liquid after it exits the engine oil cooler.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "740": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 42,
      "SPN": 740,
      "SPN_Name": "Transmission Torque Converter Lockup Clutch Actuator",
      "SPN_Description": "Identifies the status of the actuator that controls the torque converter lockup clutch.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "748": {
      "PGN": 65218,
      "PGN_Name": "Electronic Retarder Controller 2",
      "PGN_Description": "ERC2",
      "first_bit": 0,
      "SPN": 748,
      "SPN_Name": "Transmission Output Retarder",
      "SPN_Description": "Identifies the status of the transmission output retarder.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "767": {
      "PGN": 65219,
      "PGN_Name": "Electronic Transmission Controller 5",
      "PGN_Description": "ETC5",
      "first_bit": 8,
      "SPN": 767,
      "SPN_Name": "Transmission Reverse Direction Switch",
      "SPN_Description": "Identifies the status of the switch that indicates reverse direction.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "768": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 32,
      "SPN": 768,
      "SPN_Name": "Transmission Range High Actuator",
      "SPN_Description": "Identifies the status of the range high actuator in the auxiliary unit.\r\n\r\n00 -Off\r\n01 -On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "769": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 34,
      "SPN": 769,
      "SPN_Name": "Transmission Range Low Actuator",
      "SPN_Description": "Identifies the status of the range low actuator in the auxiliary unit.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "770": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 36,
      "SPN": 770,
      "SPN_Name": "Transmission Splitter Direct Actuator",
      "SPN_Description": "Identifies the status of the splitter direct actuator in the auxiliary unit.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "771": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 38,
      "SPN": 771,
      "SPN_Name": "Transmission Splitter Indirect Actuator",
      "SPN_Description": "Identifies the status of the splitter indirect actuator in the auxiliary unit.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "772": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 24,
      "SPN": 772,
      "SPN_Name": "Transmission Shift Finger Rail Actuator 1",
      "SPN_Description": "Identifies the status of the actuator that moves the shift finger identified as rail actuator #1.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "773": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 26,
      "SPN": 773,
      "SPN_Name": "Transmission Shift Finger Gear Actuator 1",
      "SPN_Description": "Identifies the status of the actuator that moves the shift finger identified as gear actuator #1.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "778": {
      "PGN": 65219,
      "PGN_Name": "Electronic Transmission Controller 5",
      "PGN_Description": "ETC5",
      "first_bit": 0,
      "SPN": 778,
      "SPN_Name": "Transmission High Range Sense Switch",
      "SPN_Description": "Identifies the status of the switch that represents high range.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "779": {
      "PGN": 65219,
      "PGN_Name": "Electronic Transmission Controller 5",
      "PGN_Description": "ETC5",
      "first_bit": 2,
      "SPN": 779,
      "SPN_Name": "Transmission Low Range Sense Switch",
      "SPN_Description": "Identifies the status of the switch that represents low range.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "780": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 16,
      "SPN": 780,
      "SPN_Name": "Transmission Shift Finger Neutral Indicator",
      "SPN_Description": "Indicates the status of the shift finger in the neutral position.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "781": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 18,
      "SPN": 781,
      "SPN_Name": "Transmission Shift Finger Engagement Indicator",
      "SPN_Description": "Identifies the status of the shift finger in the engagement position.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "782": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 20,
      "SPN": 782,
      "SPN_Name": "Transmission Shift Finger Center Rail Indicator",
      "SPN_Description": "Identifies the status of the shift finger in the center rail position.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "783": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 28,
      "SPN": 783,
      "SPN_Name": "Transmission Shift Finger Rail Actuator 2",
      "SPN_Description": "Identifies the status of the actuator that moves the shift finger identified as rail actuator #2.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "784": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 30,
      "SPN": 784,
      "SPN_Name": "Transmission Shift Finger Gear Actuator 2",
      "SPN_Description": "Identifies the status of the actuator that moves the shift finger identified as gear actuator #2.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "786": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 44,
      "SPN": 786,
      "SPN_Name": "Transmission Defuel Actuator",
      "SPN_Description": "Identifies the status of the actuator that controls the engine defuel mechanism.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "787": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 46,
      "SPN": 787,
      "SPN_Name": "Transmission Inertia Brake Actuator",
      "SPN_Description": "Identifies the status of the actuator that controls the inertia brake.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "788": {
      "PGN": 65223,
      "PGN_Name": "Electronic Transmission Controller 3",
      "PGN_Description": "ETC3",
      "first_bit": 40,
      "SPN": 788,
      "SPN_Name": "Transmission Clutch Actuator",
      "SPN_Description": "Identifies the status of the actuator that controls the clutch.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "875": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 18,
      "SPN": 875,
      "SPN_Name": "Refrigerant Low Pressure Switch",
      "SPN_Description": "Switch signal which indicates the position of the low pressure switch in the coolant circuit of an air conditioning system.  When the switch is enabled, the pressure inside the circuit is too low and the compressor clutch may be disengaged.\r\n\r\n00 - Pressure normal\r\n01 - Pressure too low, compressor clutch may be disengaged\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "897": {
      "PGN": 0,
      "PGN_Name": "Torque/Speed Control 1",
      "PGN_Description": "TSC1",
      "first_bit": 4,
      "SPN": 897,
      "SPN_Name": "Override Control Mode Priority",
      "SPN_Description": "This field is used as an input to the engine or retarder to determine the priority of the Override Control Mode received in the Torque/Speed Control message (see PGN 0).  The default is 11 (Low priority).  It is not required to use the same priority during the entire override function.  For example, the transmission can use priority 01 (High priority) during a shift, but can set the priority to 11 (Low priority) at the end of the shift to allow traction control to also interact with the torque limit of the engine.\r\n\r\nThe four priority levels defined are:\r\n\r\n00 Highest priority\r\n01 High priority\r\n10 Medium priority\r\n11 Low priority\r\n\r\n00b - Highest Priority = Used for situations that require immediate action by the receiving device in order to provide safe vehicle operation (i.e., braking systems).  This level of priority should only be used in safety critical conditions.\r\n\r\n01b -  High Priority  =  Used for control situations that require prompt action in order to provide safe vehicle operation.  An example is when the transmission is performing a shift and requires control of the engine in order to control driveline reengagement.\r\n\r\n10b - Medium Priority = Used for powertrain control operations which are related to assuring that the vehicle is in a stable operating condition.  An example is when the traction control system is commanding the engine in order to achieve traction stability.\r\n\r\n11b - Low Priority = Used to indicate that the associated command desires powertrain control but is needed for function which improves the driver comfort which may be overridden by other devices.  An example is cruise control or the non-critical part of a transmission shift to a new gear.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "898": {
      "PGN": 0,
      "PGN_Name": "Torque/Speed Control 1",
      "PGN_Description": "TSC1",
      "first_bit": 8,
      "SPN": 898,
      "SPN_Name": "Engine Requested Speed/Speed Limit",
      "SPN_Description": "Parameter provided to the engine from external sources in the torque/speed control message.  This is the engine speed which the engine is expected to operate at if the speed control mode is active or the engine speed which the engine is not expected to exceed if the speed limit mode is active.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "899": {
      "PGN": 61444,
      "PGN_Name": "Electronic Engine Controller 1",
      "PGN_Description": "EEC1",
      "first_bit": 0,
      "SPN": 899,
      "SPN_Name": "Engine Torque Mode",
      "SPN_Description": "State signal which indicates which engine torque mode is currently generating, limiting, or controlling the torque.  Note that the modes are not in prioritized order. Not all modes may be relevant for a given device.  Some devices may not implement all functions.  For typical priorities refer to Figures SPN512_A and SPN512_B for engine control.  The data type of this parameter is measured.  \r\n\r\nMode 0000b means “No request”: engine torque may range from 0 to full load only due to low idle governor output.\r\n\r\nModes 0001b to 1110b indicate that there is either a torque request or the identified function is currently controlling the engine: engine torque may range from 0 (no fueling) to the upper limit.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "900": {
      "PGN": 61440,
      "PGN_Name": "Electronic Retarder Controller 1",
      "PGN_Description": "ERC1",
      "first_bit": 0,
      "SPN": 900,
      "SPN_Name": "Retarder Torque Mode",
      "SPN_Description": "State signal which indicates which retarder torque mode is currently generating, limiting, or controlling the torque.  Note that the modes are not in prioritized order. Not all modes may be relevant for a given device.  Some devices may not implement all functions.  For typical priorities refer to Tables SPN518_A to SPN518_B for retarder control.  The data type of this parameter is measured. \r\n\r\nMode 0000b means “No request”: retarder torque = 0 (no braking).\r\n\r\nModes 0001b to 1110b indicate that there is either a torque request or the identified function is currently controlling the retarder: retarder torque may range from 0 (no braking) to the upper limit.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "901": {
      "PGN": 65249,
      "PGN_Name": "Retarder Configuration",
      "PGN_Description": "RC",
      "first_bit": 0,
      "SPN": 901,
      "SPN_Name": "Retarder Type",
      "SPN_Description": "A vehicle retarder is a supplementary device to the wheel brakes for the driver to better control the vehicle.  The wheel brakes used in the vehicle are not designed for continuous retarding operation.  In a prolonged period of braking, the brakes can be thermally over-stressed, causing the braking effect to be reduced or even lead to complete braking system failure.  The vehicle retarder is designed for continuous operation for braking during downhill operation and is also used for braking the vehicle to comply with speed limits and traffic conditions.\r\n\r\nThis parameter provides some indication of the retarder dynamics.  It is used in the retarder configuration message.  The data type of this parameter is measured.\r\n\r\n0000      Electric/Magnetic\r\n0001      Hydraulic\r\n0010      Cooled Friction\r\n0011      Compression Release (Engine retarder) or Combined Compression Release with Exhaust\r\n0100      Exhaust\r\n0101-1101   Not defined\r\n1110      Other\r\n1111      Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "902": {
      "PGN": 65249,
      "PGN_Name": "Retarder Configuration",
      "PGN_Description": "RC",
      "first_bit": 4,
      "SPN": 902,
      "SPN_Name": "Retarder Location",
      "SPN_Description": "This parameter defines whether the “torque/speed curve” defined by the retarder configuration message (PGN 65249) is dependent on engine rpm, output shaft rpm, or other parameter.  The data type of this parameter is measured.\r\n\r\n0000  (Primary)        Engine Compression Release Brake or Engine Compression Release Brake Combined with Engine Exhaust Brake (Engine rpm)\r\n0001   (Primary)         Engine Exhaust Brake (Exhaust pressure)\r\n0010   (Primary)         Transmission Input (Engine rpm)\r\n0011   (Secondary)    Transmission Output (Output Shaft rpm)\r\n0100   (Secondary)    Driveline (Output Shaft rpm)\r\n0101                           Trailer (Vehicle speed)\r\n0110-1101                  Not defined\r\n1110                           Other\r\n1111                           Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "903": {
      "PGN": 65219,
      "PGN_Name": "Electronic Transmission Controller 5",
      "PGN_Description": "ETC5",
      "first_bit": 12,
      "SPN": 903,
      "SPN_Name": "Transmission Forward Direction Switch",
      "SPN_Description": "Identifies the status of the switch that indicates forward direction.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "904": {
      "PGN": 65215,
      "PGN_Name": "Wheel Speed Information",
      "PGN_Description": "EBC2",
      "first_bit": 0,
      "SPN": 904,
      "SPN_Name": "Front Axle Speed",
      "SPN_Description": "The average speed of the two front wheels.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 71
    },
    "905": {
      "PGN": 65215,
      "PGN_Name": "Wheel Speed Information",
      "PGN_Description": "EBC2",
      "first_bit": 16,
      "SPN": 905,
      "SPN_Name": "Relative Speed; Front Axle, Left Wheel",
      "SPN_Description": "The speed of the front axle, left wheel relative to the front axle speed, SPN 904.",
      "bit_length": 8,
      "scaling": 0.0625,
      "offset": -7.8125,
      "unit": "km/h",
      "SLOT_ID": 74
    },
    "906": {
      "PGN": 65215,
      "PGN_Name": "Wheel Speed Information",
      "PGN_Description": "EBC2",
      "first_bit": 24,
      "SPN": 906,
      "SPN_Name": "Relative Speed; Front Axle, Right Wheel",
      "SPN_Description": "The speed of the front axle, right wheel relative to the front axle speed, SPN 904.",
      "bit_length": 8,
      "scaling": 0.0625,
      "offset": -7.8125,
      "unit": "km/h",
      "SLOT_ID": 74
    },
    "907": {
      "PGN": 65215,
      "PGN_Name": "Wheel Speed Information",
      "PGN_Description": "EBC2",
      "first_bit": 32,
      "SPN": 907,
      "SPN_Name": "Relative Speed; Rear Axle #1, Left Wheel",
      "SPN_Description": "The speed of the rear axle #1, left wheel relative to the front axle speed, SPN 904.",
      "bit_length": 8,
      "scaling": 0.0625,
      "offset": -7.8125,
      "unit": "km/h",
      "SLOT_ID": 74
    },
    "908": {
      "PGN": 65215,
      "PGN_Name": "Wheel Speed Information",
      "PGN_Description": "EBC2",
      "first_bit": 40,
      "SPN": 908,
      "SPN_Name": "Relative Speed; Rear Axle #1, Right Wheel",
      "SPN_Description": "The speed of the rear axle #1, right wheel relative to the front axle speed, SPN 904.",
      "bit_length": 8,
      "scaling": 0.0625,
      "offset": -7.8125,
      "unit": "km/h",
      "SLOT_ID": 74
    },
    "909": {
      "PGN": 65215,
      "PGN_Name": "Wheel Speed Information",
      "PGN_Description": "EBC2",
      "first_bit": 48,
      "SPN": 909,
      "SPN_Name": "Relative Speed; Rear Axle #2, Left Wheel",
      "SPN_Description": "The speed of the rear axle #2, left wheel relative to the front axle speed, SPN 904.",
      "bit_length": 8,
      "scaling": 0.0625,
      "offset": -7.8125,
      "unit": "km/h",
      "SLOT_ID": 74
    },
    "910": {
      "PGN": 65215,
      "PGN_Name": "Wheel Speed Information",
      "PGN_Description": "EBC2",
      "first_bit": 56,
      "SPN": 910,
      "SPN_Name": "Relative Speed; Rear Axle #2, Right Wheel",
      "SPN_Description": "The speed of the rear axle #2, right wheel relative to the front axle speed, SPN 904.",
      "bit_length": 8,
      "scaling": 0.0625,
      "offset": -7.8125,
      "unit": "km/h",
      "SLOT_ID": 74
    },
    "911": {
      "PGN": 65216,
      "PGN_Name": "Service Information",
      "PGN_Description": "SERV",
      "first_bit": 0,
      "SPN": 911,
      "SPN_Name": "Service Component Identification",
      "SPN_Description": "Identification of component needing service.  See Table SPN911_A.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "ID",
      "SLOT_ID": 25
    },
    "912": {
      "PGN": 65216,
      "PGN_Name": "Service Information",
      "PGN_Description": "SERV",
      "first_bit": 24,
      "SPN": 912,
      "SPN_Name": "Service Component Identification",
      "SPN_Description": "Identification of component needing service.  See Table SPN911_A.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "ID",
      "SLOT_ID": 25
    },
    "913": {
      "PGN": 65216,
      "PGN_Name": "Service Information",
      "PGN_Description": "SERV",
      "first_bit": 40,
      "SPN": 913,
      "SPN_Name": "Service Component Identification",
      "SPN_Description": "Identification of component needing service.  See Table SPN911_A.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "ID",
      "SLOT_ID": 25
    },
    "914": {
      "PGN": 65216,
      "PGN_Name": "Service Information",
      "PGN_Description": "SERV",
      "first_bit": 8,
      "SPN": 914,
      "SPN_Name": "Service Distance",
      "SPN_Description": "The distance which can be traveled by the vehicle before the next service inspection is required.  A negative distance is transmitted if the service inspection has been passed.  The component that requires service is identified by the service component identification (see SPN 911-913, 1379, and 1584).",
      "bit_length": 16,
      "scaling": 5,
      "offset": -160635,
      "unit": "km",
      "SLOT_ID": 37
    },
    "915": {
      "PGN": 65216,
      "PGN_Name": "Service Information",
      "PGN_Description": "SERV",
      "first_bit": 32,
      "SPN": 915,
      "SPN_Name": "Service Delay/Calendar Time Based",
      "SPN_Description": "The time in weeks until the next vehicle service inspection is required.  A negative value is transmitted if the service inspection has been passed.  The component that requires service is identified by the service component identification (see SPN 911-913, 1379, and 1584).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "weeks",
      "SLOT_ID": 65
    },
    "916": {
      "PGN": 65216,
      "PGN_Name": "Service Information",
      "PGN_Description": "SERV",
      "first_bit": 48,
      "SPN": 916,
      "SPN_Name": "Service Delay/Operational Time Based",
      "SPN_Description": "The time in vehicle operational time until the next vehicle service inspection is required.  A negative value is transmitted if the service inspection has been passed.  The component that requires service is identified by the service component identification (see SPN 911-913, 1379, and 1584).",
      "bit_length": 16,
      "scaling": 1,
      "offset": -32127,
      "unit": "h",
      "SLOT_ID": 5
    },
    "917": {
      "PGN": 65217,
      "PGN_Name": "High Resolution Vehicle Distance",
      "PGN_Description": "VDHR",
      "first_bit": 0,
      "SPN": 917,
      "SPN_Name": "Total Vehicle Distance (High Resolution)",
      "SPN_Description": "Accumulated distance traveled by the vehicle during its operation.\r\n\r\nNOTE - See SPN 245 for alternate resolution.",
      "bit_length": 32,
      "scaling": 5,
      "offset": 0,
      "unit": "m",
      "SLOT_ID": 38
    },
    "918": {
      "PGN": 65217,
      "PGN_Name": "High Resolution Vehicle Distance",
      "PGN_Description": "VDHR",
      "first_bit": 32,
      "SPN": 918,
      "SPN_Name": "Trip Distance (High Resolution)",
      "SPN_Description": "Distance traveled during all or part of a journey.\r\n\r\nNOTE - See SPN 244 for alternate resolution.",
      "bit_length": 32,
      "scaling": 5,
      "offset": 0,
      "unit": "m",
      "SLOT_ID": 38
    },
    "927": {
      "PGN": 61446,
      "PGN_Name": "Electronic Axle Controller 1",
      "PGN_Description": "EAC1",
      "first_bit": 0,
      "SPN": 927,
      "SPN_Name": "Location",
      "SPN_Description": "To identify to which of several similar devices (such as tires or fuel tanks) the information applies.\r\n\r\nThe low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward).\r\n\r\nThe high order 4 bits represent a position number, counting front to back on the vehicle.\r\n\r\nThe value 0xFF indicates not available.\r\n\r\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\r\n\r\nExamples: Tire pressure for location 0x00 would be left front tire.\r\n\r\nTire pressure for location 0x23 would be right outside rear rear on a 3-axle tractor with dual axle per side (3rd axle, 4th tire).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "928": {
      "PGN": 65258,
      "PGN_Name": "Vehicle Weight",
      "PGN_Description": "VW",
      "first_bit": 0,
      "SPN": 928,
      "SPN_Name": "Axle Location",
      "SPN_Description": "To identify to which of several similar devices (such as tires or fuel tanks) the information applies.\r\n\r\nThe low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward).\r\n\r\nThe high order 4 bits represent a position number, counting front to back on the vehicle.\r\n\r\nThe value 0xFF indicates not available.\r\n\r\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\r\n\r\nExamples: Tire pressure for location 0x00 would be left front tire.\r\n\r\nTire pressure for location 0x23 would be right outside rear rear on a 3-axle tractor with dual axle per side (3rd axle, 4th tire).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "929": {
      "PGN": 65268,
      "PGN_Name": "Tire Condition Message 1",
      "PGN_Description": "TIRE1",
      "first_bit": 0,
      "SPN": 929,
      "SPN_Name": "Tire Location",
      "SPN_Description": "Identifies which tire is associated with the parametric data in this PGN.\r\n\r\nThe low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward).\r\n\r\nThe high order 4 bits represent a position number, counting front to back on the vehicle.\r\n\r\nThe value 0xFF indicates not available.\r\n\r\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\r\n\r\nExamples: Tire pressure for location 0x00 would be left front tire.\r\n\r\nTire pressure for location 0x23 would be right outside rear rear on a 3-axle tractor with dual axle per side (3rd axle, 4th tire).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "930": {
      "PGN": 65273,
      "PGN_Name": "Axle Information",
      "PGN_Description": "AI",
      "first_bit": 8,
      "SPN": 930,
      "SPN_Name": "Drive Axle Location",
      "SPN_Description": "To identify to which of several similar devices (such as tires or fuel tanks) the information applies.\r\n\r\nThe low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward).\r\n\r\nThe high order 4 bits represent a position number, counting front to back on the vehicle.\r\n\r\nThe value 0xFF indicates not available.\r\n\r\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\r\n\r\nExamples: Tire pressure for location 0x00 would be left front tire.\r\n\r\nTire pressure for location 0x23 would be right outside rear rear on a 3-axle tractor with dual axle per side (3rd axle, 4th tire).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "957": {
      "PGN": 65250,
      "PGN_Name": "Transmission Configuration",
      "PGN_Description": "TCFG",
      "first_bit": 8,
      "SPN": 957,
      "SPN_Name": "Number of Forward Gear Ratios",
      "SPN_Description": "Number of forward gear ratios in the transmission, provided as part of the configuration.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "gear value",
      "SLOT_ID": 101
    },
    "958": {
      "PGN": 65250,
      "PGN_Name": "Transmission Configuration",
      "PGN_Description": "TCFG",
      "first_bit": 0,
      "SPN": 958,
      "SPN_Name": "Number of Reverse Gear Ratios",
      "SPN_Description": "Number of reverse gear ratios in the transmission, provided as part of the transmission configuration.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "gear value",
      "SLOT_ID": 101
    },
    "959": {
      "PGN": 65254,
      "PGN_Name": "Time/Date",
      "PGN_Description": "TD",
      "first_bit": 0,
      "SPN": 959,
      "SPN_Name": "Seconds",
      "SPN_Description": "The seconds component of the current time of day.  This should be reported as the seconds component of the current time at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the seconds component of the current time at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the time of day (SPNs 959, 960, and 961) is the current UTC time or a local time zone time.  Refer to SPN 1602 for details.",
      "bit_length": 8,
      "scaling": 0.25,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 63
    },
    "960": {
      "PGN": 65254,
      "PGN_Name": "Time/Date",
      "PGN_Description": "TD",
      "first_bit": 8,
      "SPN": 960,
      "SPN_Name": "Minutes",
      "SPN_Description": "The minutes component of the current time of day.  This should be reported as the minutes component of the current time at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the minutes component of the current time at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the time of day (SPNs 959, 960, and 961) is the current UTC time or a local time zone time.  Refer to SPN 1602 for details.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "min",
      "SLOT_ID": 61
    },
    "961": {
      "PGN": 65254,
      "PGN_Name": "Time/Date",
      "PGN_Description": "TD",
      "first_bit": 16,
      "SPN": 961,
      "SPN_Name": "Hours",
      "SPN_Description": "The hour component of the current time of day.  This should be reported as the hour component of the current time at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the hour component of the current time at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if time of day (SPNs 959, 960, and 961) is the current UTC time or a local time zone time.  Refer to SPN 1602 for details.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 3
    },
    "962": {
      "PGN": 65254,
      "PGN_Name": "Time/Date",
      "PGN_Description": "TD",
      "first_bit": 32,
      "SPN": 962,
      "SPN_Name": "Day",
      "SPN_Description": "The day component of the current calendar date.  This should be reported as the day component of the current date at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the day component of the current date at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the calendar date (SPNs 962, 963, and 964) is the current UTC date or a local time zone date.  Refer to SPN 1602 for details.\r\n\r\nNOTE - A value of 0 for the date is null.  The values 1, 2, 3, and 4 are used to identify the first day of the month; 5, 6, 7, and 8 identify the second day of the month; etc.  Multiples of 4 are a common encoding use.",
      "bit_length": 8,
      "scaling": 0.25,
      "offset": 0,
      "unit": "days",
      "SLOT_ID": 60
    },
    "963": {
      "PGN": 65254,
      "PGN_Name": "Time/Date",
      "PGN_Description": "TD",
      "first_bit": 24,
      "SPN": 963,
      "SPN_Name": "Month",
      "SPN_Description": "The month component of the current calendar date.  This should be reported as the month component of the current date at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the month component of the current date at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the calendar date (SPNs 962, 963, and 964) is the current UTC date or a local time zone date.  Refer to SPN 1602 for details.\r\n\r\nNOTE - A value of 0 for the month is null.  The value 1 identifies January; 2 identifies February; etc.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "months",
      "SLOT_ID": 62
    },
    "964": {
      "PGN": 65254,
      "PGN_Name": "Time/Date",
      "PGN_Description": "TD",
      "first_bit": 40,
      "SPN": 964,
      "SPN_Name": "Year",
      "SPN_Description": "The year component of the current calendar date.  This should be reported as the year component of the current date at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the year component of the current date at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the calendar date (SPNs 962, 963, and 964) is the current UTC date or a local time zone date.  Refer to SPN 1602 for details.\r\n\r\nNOTE - A value of 0 for the year identifies the year 1985; a value of 1 identifies 1986; etc.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 1985,
      "unit": "years",
      "SLOT_ID": 66
    },
    "965": {
      "PGN": 65242,
      "PGN_Name": "Software Identification",
      "PGN_Description": "SOFT",
      "first_bit": 0,
      "SPN": 965,
      "SPN_Name": "Number of Software Identification Fields",
      "SPN_Description": "Number of software identification designators represented in the software identification parameter group.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "step",
      "SLOT_ID": 84
    },
    "966": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 60,
      "SPN": 966,
      "SPN_Name": "Engine Diagnostic Test Mode Switch",
      "SPN_Description": "Switch signal which indicates the position of the engine diagnostic test mode switch.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "967": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 58,
      "SPN": 967,
      "SPN_Name": "Engine Idle Decrement Switch",
      "SPN_Description": "Switch signal which indicates the position of the idle decrement switch.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "968": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 56,
      "SPN": 968,
      "SPN_Name": "Engine Idle Increment Switch",
      "SPN_Description": "Switch signal which indicates the position of the idle increment switch.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "969": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 30,
      "SPN": 969,
      "SPN_Name": "Remote Accelerator Enable Switch",
      "SPN_Description": "Switch signal which indicates that the remote accelerator has been enabled and controls the engine.  \r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available\r\n\r\nNOTE—The accelerator interlock switch (see SPN 972) must be disabled in order for the remote accelerator to perform engine control.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "970": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 28,
      "SPN": 970,
      "SPN_Name": "Engine Auxiliary Shutdown Switch",
      "SPN_Description": "Switch signal which requests that all engine fueling stop.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "971": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 26,
      "SPN": 971,
      "SPN_Name": "Engine Derate Switch",
      "SPN_Description": "Switch signal used to activate the torque limiting feature of the engine.  The specific nature of torque limiting should be verified with the manufacturer.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "972": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 24,
      "SPN": 972,
      "SPN_Name": "Accelerator Interlock Switch",
      "SPN_Description": "Switch signal used to disable the accelerator and remote accelerator inputs, causing the engine to return to idle.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "973": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 32,
      "SPN": 973,
      "SPN_Name": "Engine Retarder Selection",
      "SPN_Description": "The position of the operator controlled selector, expressed as a percentage and determined by the ratio of the current position of the selector to its maximum possible position. Zero percent means no braking torque is requested by the operator from the engine while 100% means maximum braking.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "974": {
      "PGN": 61443,
      "PGN_Name": "Electronic Engine Controller 2",
      "PGN_Description": "EEC2",
      "first_bit": 24,
      "SPN": 974,
      "SPN_Name": "Remote Accelerator Pedal Position",
      "SPN_Description": "The ratio of actual position of the remote analog engine speed/torque request input device (such as an accelerator pedal or throttle lever) to the maximum position of the input device.     \r\n\r\nFor example, in on-highway vehicles this could be an accelerator control device that is external to the drivers cab or an accelerator that is controlled by a hand lever from the operators seat. \r\n\r\nThe Remote Accelerator Enable Switch is SPN 969. This parameter enables the remote accelerator operation.\r\n\r\nNOTE—See SPNs 29 and 91 for additional accelerator position parameters. If only one accelerator\r\nposition exists on a vehicle, SPN 91 shall be used.  SPN 28 is an additional diagnostic SPN for accelerator position.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "975": {
      "PGN": 65213,
      "PGN_Name": "Fan Drive #1",
      "PGN_Description": "FD1",
      "first_bit": 0,
      "SPN": 975,
      "SPN_Name": "Engine Fan 1 Estimated Percent Speed",
      "SPN_Description": "Estimated fan speed as a ratio of the fan drive (current speed) to the fully engaged fan drive (maximum fan speed).  A two state fan (off/on) will use 0% and 100% respectively.  A three state fan (off/intermediate/on) will use 0%, 50% and 100% respectively.  A variable speed fan will use 0% to 100%. Multiple fan systems will use 0 to 100% to indicate the percent cooling capacity being provided.\r\n\r\nNote that the intermediate fan speed of a three state fan will vary with different fan drives, therefore 50% is being used to indicate that the intermediate speed is required from the fan drive.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "976": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 48,
      "SPN": 976,
      "SPN_Name": "PTO Governor State",
      "SPN_Description": "This parameter is used to indicate the current state or mode of operation by the power takeoff (PTO) governor.  In lieu of support for PTO Drive Engagement parameters, this parameter may represent the status of a PTO drive.  The broadcasting device must ensure that each achieved state is conveyed in at least one message broadcast before a transition to another state is allowed.\r\n  \r\n00000     Off/Disabled\r\n00001     Hold\r\n00010     Remote Hold\r\n00011     Standby\r\n00100     Remote Standby\r\n00101     Set\r\n00110     Decelerate/Coast\r\n00111     Resume\r\n01000     Accelerate\r\n01001     Accelerator Override\r\n01010     Preprogrammed set speed 1\r\n01011     Preprogrammed set speed 2\r\n01100     Preprogrammed set speed 3\r\n01101     Preprogrammed set speed 4\r\n01110     Preprogrammed set speed 5\r\n01111     Preprogrammed set speed 6\r\n10000     Preprogrammed set speed 7\r\n10001     Preprogrammed set speed 8\r\n10010     PTO set speed memory 1\r\n10011     PTO set speed memory 2\r\n10100     PTO set speed memory 3\r\n10101-11110      Not defined\r\n11111     Not available\r\n\r\nOff/Disabled 00000b — Used to indicate that the PTO governor enable switch is in the off position.\r\n\r\nHold 00001b — Used to indicate that the PTO governor is active and currently maintaining a captured operating speed.\r\n\r\nRemote Hold 00010b — Used to indicate that the remote PTO governor is active and the PTO governor is currently maintaining a captured operating speed.\r\n\r\nStandby 00011b — Used to indicate that the PTO governor device enable switch is in the ON position and it is possible to manage the PTO governor.\r\n\r\nRemote Standby 00100b — Used to indicate that the remote PTO governor device enable switch is in the ON position and it is possible to manage the PTO governor.\r\n\r\nSet 00101b — Used to indicate that the PTO governor is establishing current speed as the operating speed (captured value).\r\n\r\nDecelerate/Coast 00110b — Used to indicate that the PTO governor is in the process of ramping down, or coasting, from the current operating speed.\r\n\r\nResume 00111b — Used to indicate that the PTO governor is in the process of resuming the operating speed to a previously captured value.\r\n\r\nAccelerate 01000b — Used to indicate that the PTO governor is in the process of ramping up the operating speed.\r\n\r\nAccelerator Override 01001b—Used to indicate that the PTO governor is active but for the present time the engine is controlled by a large driver's demand.\r\n\r\nPreprogrammed PTO Governor Set Speed 1  01010b—Used to indicate that the PTO device is establishing a first preprogrammed PTO governor set speed (user programmable) as the current operating speed.\r\n\r\nPreprogrammed PTO Governor Set Speed 2  01011b—Used to indicate that the PTO device is establishing a second preprogrammed PTO governor set speed (user programmable) as the current operating speed.\r\n\r\nPreprogrammed PTO Governor Set Speed 3  01100b —Used to indicate that the remote PTO device is establishing a third preprogrammed PTO governor set speed (user programmable) as the current operating speed.\r\n\r\nPreprogrammed PTO Governor Set Speed 4  01101b —Used to indicate that the remote PTO device is establishing a fourth preprogrammed PTO governor set speed (user programmable) as the current operating speed.\r\n\r\nPreprogrammed PTO Governor Set Speed 5  01110b —Used to indicate that the remote PTO device is establishing a fifth preprogrammed PTO governor set speed (user programmable) as the current operating speed.\r\n\r\nPreprogrammed PTO Governor Set Speed 6  01111b—Used to indicate that the remote PTO device is establishing a sixth preprogrammed PTO governor set speed (user programmable) as the current operating speed.\r\n\r\nPreprogrammed PTO Governor Set Speed 7  10000b —Used to indicate that the remote PTO device is establishing a seventh preprogrammed PTO governor set speed (user programmable) as the current operating speed.\r\n\r\nPreprogrammed PTO Governor Set Speed 8  10001b —Used to indicate that the remote PTO device is establishing a eighth preprogrammed PTO governor set speed (user programmable) as the current operating speed.\r\n\r\nPTO set speed memory 1  10010b —Used to indicate that PTO set speed memory one set state is active.\r\n\r\nPTO set speed memory 2  10011b — Used to indicate that PTO set speed memory two set state is active.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 90
    },
    "977": {
      "PGN": 65213,
      "PGN_Name": "Fan Drive #1",
      "PGN_Description": "FD1",
      "first_bit": 8,
      "SPN": 977,
      "SPN_Name": "Fan Drive State",
      "SPN_Description": "This parameter is used to indicate the current state or mode of operation by the fan drive.\r\n\r\n0000 Fan off\r\n0001 Engine system–General\r\n0010 Excessive engine air temperature\r\n0011 Excessive engine oil temperature\r\n0100 Excessive engine coolant temperature\r\n0101 Excessive transmission oil temperature\r\n0110 Excessive hydraulic oil temperature\r\n0111 Default Operation\r\n1000 Reverse Operation\r\n1001 Manual control\r\n1010 Transmission retarder\r\n1011 A/C system\r\n1100 Timer\r\n1101 Engine brake\r\n1110 Other\r\n1111 Not available\r\n\r\nFan off  0000b —Used to indicate that the fan clutch is disengaged and the fan is inactive\r\n\r\nEngine system–General  0001b —Used to indicate that the fan is active due to an engine system not otherwise defined.\r\n\r\nExcessive engine air temperature  0010b —Used to indicate that the fan is active due to high air temperature.\r\n\r\nExcessive engine oil temperature  0011b —Used to indicate that the fan is active due to high oil temperature.\r\n\r\nExcessive engine coolant temperature  0100b —Used to indicate that the fan is active due to high coolant temperature.\r\n\r\nReverse Operation  1000b — Used to indicate that the fan is in reverse direction of operation compared to the normal direction of operation \r\n\r\nManual control  1001b —Used to indicate that the fan is active as requested by the operator.\r\n\r\nTransmission retarder  1010b —Used to indicate that the fan is active as required by the transmission retarder.\r\n\r\nA/C system  1011b —Used to indicate that the fan is active as required by the air conditioning system.\r\n\r\nTimer  1100b —Used to indicate that the fan is active as required by a timing function.\r\n\r\nEngine brake  1101b —Used to indicate that the fan is active as required to assist engine braking.\r\n\r\nExcessive transmission oil temperature - 0101b  - Used to indicate fan is active due to excessive transmission oil temperature.\r\n\r\nExcessive hydraulic oil temperature - 0110b - Used to indicate fan is active due to excessive hydraulic oil temperature.\r\n\r\nDefault Operation - 0111b - Used to indicate fan is active due to a error condition resulting in default operation",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "978": {
      "PGN": 65264,
      "PGN_Name": "Power Takeoff Information",
      "PGN_Description": "PTO",
      "first_bit": 44,
      "SPN": 978,
      "SPN_Name": "Engine Remote PTO Governor Variable Speed Control Switch",
      "SPN_Description": "Switch signal which indicates that the remote PTO governor toggle switch is in the enabled (ON) position.  If the toggle switch is enabled and other conditions are satisfied then the remote PTO governor feature is activated and the PTO governor will control at a variable speed.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "979": {
      "PGN": 65264,
      "PGN_Name": "Power Takeoff Information",
      "PGN_Description": "PTO",
      "first_bit": 42,
      "SPN": 979,
      "SPN_Name": "Engine Remote PTO Governor Preprogrammed Speed Control Switch",
      "SPN_Description": "Switch signal which indicates that the remote PTO governor  toggle switch is in the enabled (ON) position.  If the toggle switch is enabled and other conditions are satisfied then the remote PTO governor feature is activated and the PTO governor will control at the preprogrammed speed.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "980": {
      "PGN": 65264,
      "PGN_Name": "Power Takeoff Information",
      "PGN_Description": "PTO",
      "first_bit": 40,
      "SPN": 980,
      "SPN_Name": "Engine PTO Governor Enable Switch",
      "SPN_Description": "Switch signal which indicates that the PTO governor toggle switch is in the enabled (ON) position and therefore it is possible to manage the PTO control function.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "981": {
      "PGN": 65264,
      "PGN_Name": "Power Takeoff Information",
      "PGN_Description": "PTO",
      "first_bit": 54,
      "SPN": 981,
      "SPN_Name": "Engine PTO Governor Accelerate Switch",
      "SPN_Description": "Switch signal of the PTO control activator which indicates that the activator is in the position to \"accelerate\" the PTO governor set speed.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "982": {
      "PGN": 65264,
      "PGN_Name": "Power Takeoff Information",
      "PGN_Description": "PTO",
      "first_bit": 52,
      "SPN": 982,
      "SPN_Name": "Engine PTO Governor Resume Switch",
      "SPN_Description": "Switch signal of the PTO control activator which indicates that the activator is in the position to \"resume\" a previously established PTO governor set speed.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "983": {
      "PGN": 65264,
      "PGN_Name": "Power Takeoff Information",
      "PGN_Description": "PTO",
      "first_bit": 50,
      "SPN": 983,
      "SPN_Name": "Engine PTO Governor Coast/Decelerate Switch",
      "SPN_Description": "Switch signal of the PTO control activator which indicates that the activator is in the position to \"coast/decelerate\" the PTO governor set speed.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "984": {
      "PGN": 65264,
      "PGN_Name": "Power Takeoff Information",
      "PGN_Description": "PTO",
      "first_bit": 48,
      "SPN": 984,
      "SPN_Name": "Engine PTO Governor Set Switch",
      "SPN_Description": "Switch signal of the PTO control activator which indicates that the activator is in the position to \"set\" the engine PTO governor set speed.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "985": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 16,
      "SPN": 985,
      "SPN_Name": "A/C High Pressure Fan Switch",
      "SPN_Description": "Switch signal which indicates that the pressure in the coolant circuit of an air conditioning system is high and the fan may be engaged.\r\n\r\n00 - Pressure normal\r\n01 - Pressure high, fan may be engaged\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "986": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 0,
      "SPN": 986,
      "SPN_Name": "Engine Fan 1 Requested Percent Speed",
      "SPN_Description": "Fan speed of the first or only fan in the system as a ratio of the actual fan drive (current speed) to the fully engaged fan drive (maximum fan speed). A two state fan (off/on) will use 0% and 100% respectively. A three state fan (off/intermediate/on) will use 0%, 50% and 100% respectively. A variable speed fan will use 0% to 100%. Multiple fan systems will use 0 to 100% to indicate the percent cooling capacity being provided. Feedback to this request is provided using the estimated fan speed (see SPN 975). \r\n\r\nNote that the intermediate fan speed of a three state fan will vary with different fan drives, therefore 50% is being used to indicate that the intermediate speed is required from the fan drive. Typically, the first fan in a system will be the fan closest to the radiator. The second fan will be located farthest from the radiator.\r\n\r\nSee SPN 6730 for systems that have two fans.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "988": {
      "PGN": 56832,
      "PGN_Name": "Reset",
      "PGN_Description": "RESET",
      "first_bit": 0,
      "SPN": 988,
      "SPN_Name": "Trip Group 1",
      "SPN_Description": "Command signal used to reset the PGNs and parameters as defined in Table SPN988_A.\r\n\r\n00 Take no action\r\n01 Reset\r\n10 Reserved\r\n11 Not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "989": {
      "PGN": 56832,
      "PGN_Name": "Reset",
      "PGN_Description": "RESET",
      "first_bit": 2,
      "SPN": 989,
      "SPN_Name": "Trip Group 2 - Proprietary",
      "SPN_Description": "Command signal used to reset proprietary parameters associated with a trip but not defined within this document.\r\n\r\n00 Take no action\r\n01 Reset\r\n10 Reserved\r\n11 Not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "990": {
      "PGN": 65212,
      "PGN_Name": "Compression/Service Brake Information",
      "PGN_Description": "CBI",
      "first_bit": 0,
      "SPN": 990,
      "SPN_Name": "Total Compression Brake Distance",
      "SPN_Description": "Total distance over which the compression brakes have been active for the life of the engine.",
      "bit_length": 32,
      "scaling": 0.125,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 36
    },
    "991": {
      "PGN": 65212,
      "PGN_Name": "Compression/Service Brake Information",
      "PGN_Description": "CBI",
      "first_bit": 32,
      "SPN": 991,
      "SPN_Name": "Trip Compression Brake Distance",
      "SPN_Description": "Total distance over which the compression brakes have been active since the last trip reset.",
      "bit_length": 32,
      "scaling": 0.125,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 36
    },
    "992": {
      "PGN": 65212,
      "PGN_Name": "Compression/Service Brake Information",
      "PGN_Description": "CBI",
      "first_bit": 64,
      "SPN": 992,
      "SPN_Name": "Trip Service Brake Distance",
      "SPN_Description": "Total distance over which the service brakes have been active since the last trip reset.",
      "bit_length": 32,
      "scaling": 0.125,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 36
    },
    "993": {
      "PGN": 65212,
      "PGN_Name": "Compression/Service Brake Information",
      "PGN_Description": "CBI",
      "first_bit": 96,
      "SPN": 993,
      "SPN_Name": "Trip Service Brake Applications",
      "SPN_Description": "Total number of times the service brakes have been activated since the last trip reset.  Brake applications of less than 0.5 s are not counted and lengthy brake applications (longer than 0.5 s) are counted as a single event.\r\n\r\nNOTE - Definition and resolution shall stay the same if brakes are applied by only the tractor, only the trailer or both.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "brake appl",
      "SLOT_ID": 81
    },
    "994": {
      "PGN": 65211,
      "PGN_Name": "Trip Fan Information",
      "PGN_Description": "TFI",
      "first_bit": 0,
      "SPN": 994,
      "SPN_Name": "Trip Fan On Time",
      "SPN_Description": "Total time the fan has been on (due to an automatic trigger or manual trigger) since the last trip reset.  The fan could be requested to be on by the engine system, a manual switch, and/or the A/C system.  Whichever system requests the fan activation first shall have the time accumulated against it.  The sum total of these three values shall equal the trip fan on time.\r\n\r\nNOTE—If the fan has been requested to be on by a component that is not one of the defined categories, this time shall be accumulated in the Engine System category by default.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "995": {
      "PGN": 65211,
      "PGN_Name": "Trip Fan Information",
      "PGN_Description": "TFI",
      "first_bit": 32,
      "SPN": 995,
      "SPN_Name": "Trip Fan On Time Due to the Engine System",
      "SPN_Description": "Total time the fan has been on due to engine triggers (i.e., excluding time on due to an operator manual switch or A/C system) since the last trip reset.  For the time to be accumulated against the engine system, it is necessary that it be the first to request the fan activation or it be the only system requesting fan activation.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "996": {
      "PGN": 65211,
      "PGN_Name": "Trip Fan Information",
      "PGN_Description": "TFI",
      "first_bit": 64,
      "SPN": 996,
      "SPN_Name": "Trip Fan On Time Due to a Manual Switch",
      "SPN_Description": "Total time the fan has been on due to manual activation by the operator (i.e., excluding time on due to automatic triggers) since the last trip reset.  For the time to be accumulated against the manual switch, it is necessary that it be the first to request the fan activation or it be the only system requesting fan activation.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "997": {
      "PGN": 65211,
      "PGN_Name": "Trip Fan Information",
      "PGN_Description": "TFI",
      "first_bit": 96,
      "SPN": 997,
      "SPN_Name": "Trip Fan On Time Due to the A/C System",
      "SPN_Description": "Total time the fan has been on due to the A/C system since the last trip reset.  For the time to be accumulated against the A/C system, it is necessary that it be the first to request the fan activation or it be the only system requesting fan activation.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "998": {
      "PGN": 65210,
      "PGN_Name": "Trip Distance Information",
      "PGN_Description": "TDI",
      "first_bit": 0,
      "SPN": 998,
      "SPN_Name": "Trip Distance on VSL",
      "SPN_Description": "Total distance accumulated while the engine torque mode is road speed governing since the last trip reset.",
      "bit_length": 32,
      "scaling": 0.125,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 36
    },
    "999": {
      "PGN": 65210,
      "PGN_Name": "Trip Distance Information",
      "PGN_Description": "TDI",
      "first_bit": 32,
      "SPN": 999,
      "SPN_Name": "Trip Gear Down Distance",
      "SPN_Description": "Total distance accumulated while the vehicle has operated in the gear which is one gear down from top gear and exceeds a calibrated minimum time (typically the time to shift the transmission) since the last trip reset.",
      "bit_length": 32,
      "scaling": 0.125,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 36
    },
    "1000": {
      "PGN": 65210,
      "PGN_Name": "Trip Distance Information",
      "PGN_Description": "TDI",
      "first_bit": 64,
      "SPN": 1000,
      "SPN_Name": "Trip Distance in Top Gear",
      "SPN_Description": "Total distance accumulated while the vehicle has operated in top gear for a calibrated minimum time since the last trip reset.",
      "bit_length": 32,
      "scaling": 0.125,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 36
    },
    "1001": {
      "PGN": 65209,
      "PGN_Name": "Trip Fuel Information (Liquid)",
      "PGN_Description": "LTFI",
      "first_bit": 0,
      "SPN": 1001,
      "SPN_Name": "Trip Drive Fuel Used",
      "SPN_Description": "Total fuel consumed while the engine speed is greater than zero, vehicle speed is greater than or equal to 2 km/h, and neither the PTO or the remote PTO is controlling the engine power output, since the last trip reset.\r\n\r\nNOTE—This parameter is intended for liquid fueled engines.  See SPN 1007 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 20
    },
    "1002": {
      "PGN": 65209,
      "PGN_Name": "Trip Fuel Information (Liquid)",
      "PGN_Description": "LTFI",
      "first_bit": 32,
      "SPN": 1002,
      "SPN_Name": "Trip PTO Governor Moving Fuel Used",
      "SPN_Description": "Total fuel consumed while either the PTO or remote PTO governors are in the hold state, the engine speed is greater than zero, and vehicle speed is greater than or equal to 2 km/h, since the last trip reset.\r\n\r\nNOTE—This parameter is intended for liquid fueled engines.  See SPN 1008 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 20
    },
    "1003": {
      "PGN": 65209,
      "PGN_Name": "Trip Fuel Information (Liquid)",
      "PGN_Description": "LTFI",
      "first_bit": 64,
      "SPN": 1003,
      "SPN_Name": "Trip PTO Governor Non-moving Fuel Used",
      "SPN_Description": "Total fuel consumed while either the PTO or remote PTO governors are in the hold state, the engine speed is greater than zero, and vehicle speed is less than 2 km/h, since the last trip reset.\r\n\r\nNOTE—This parameter is intended for liquid fueled engines.  See SPN 1009 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 20
    },
    "1004": {
      "PGN": 65209,
      "PGN_Name": "Trip Fuel Information (Liquid)",
      "PGN_Description": "LTFI",
      "first_bit": 96,
      "SPN": 1004,
      "SPN_Name": "Trip Vehicle Idle Fuel Used",
      "SPN_Description": "Total fuel consumed while neither the PTO or remote PTO governor is in the hold state, the engine speed is greater than zero, and vehicle speed is less than 2 km/h, since the last trip reset.\r\n\r\nIn marine applications, this parameter is defined as the total fuel consumed while the engine speed is greater than zero, and less than or equal to 50 RPM greater than low idle, since the last trip reset.\r\n\r\nNOTE—This parameter is intended for liquid fueled engines.  See SPN 1010 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 20
    },
    "1005": {
      "PGN": 65209,
      "PGN_Name": "Trip Fuel Information (Liquid)",
      "PGN_Description": "LTFI",
      "first_bit": 128,
      "SPN": 1005,
      "SPN_Name": "Trip Cruise Fuel Used",
      "SPN_Description": "Total fuel consumed while the engine is in the cruise hold state since the last trip reset.  If both cruise control and VSL (vehicle speed limiter) are commanding the same amount of fuel, the cruise control is deemed the active torque mode and fuel will be accumulated in \"trip cruise fuel used\" parameter.  If fuel commanded due to the accelerator pedal position is larger than fuel commanded by cruise control (e.g., accelerator override torque mode), the cruise control is not deemed the active torque mode and fuel will not be accumulated in the \"trip cruise fuel used\" parameter.\r\n\r\nNOTE—This parameter is intended for liquid fueled engines.  See SPN 1011 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 20
    },
    "1006": {
      "PGN": 65209,
      "PGN_Name": "Trip Fuel Information (Liquid)",
      "PGN_Description": "LTFI",
      "first_bit": 160,
      "SPN": 1006,
      "SPN_Name": "Trip Drive Fuel Economy",
      "SPN_Description": "Trip drive fuel economy is equal to the distance traveled by vehicle in the drive state (engine speed greater than zero, vehicle speed greater than or equal to 2 km/h, and neither the PTO or remote PTO governors are controlling engine power output) divided by trip drive fuel used (SPN 1001), since the last trip reset.\r\n\r\nNOTE—This parameter is intended for liquid fueled engines.  See SPN 1012 for alternate resolution.",
      "bit_length": 16,
      "scaling": 0.001953125,
      "offset": 0,
      "unit": "km/L",
      "SLOT_ID": 16
    },
    "1007": {
      "PGN": 65208,
      "PGN_Name": "Trip Fuel Information (Gaseous)",
      "PGN_Description": "GTFI",
      "first_bit": 0,
      "SPN": 1007,
      "SPN_Name": "Trip Drive Fuel Used (Gaseous)",
      "SPN_Description": "Total fuel consumed while the engine speed is greater than zero, vehicle speed is greater than or equal to 2 km/h, and neither the PTO or the remote PTO governors are controlling the engine power output, since the last trip reset.\r\n\r\nNOTE—This parameter is intended for gaseous fueled engines.  See SPN 1001 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 21
    },
    "1008": {
      "PGN": 65208,
      "PGN_Name": "Trip Fuel Information (Gaseous)",
      "PGN_Description": "GTFI",
      "first_bit": 32,
      "SPN": 1008,
      "SPN_Name": "Trip PTO Governor Moving Fuel Used (Gaseous)",
      "SPN_Description": "Total fuel consumed while the PTO or remote PTO governors are in the hold state, the engine speed is greater than zero, and vehicle speed is greater than or equal to 2 km/h, since the last trip reset.\r\n\r\nNOTE—This parameter is intended for gaseous fueled engines.  See SPN 1002 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 21
    },
    "1009": {
      "PGN": 65208,
      "PGN_Name": "Trip Fuel Information (Gaseous)",
      "PGN_Description": "GTFI",
      "first_bit": 64,
      "SPN": 1009,
      "SPN_Name": "Trip PTO Governor Non-moving Fuel Used (Gaseous)",
      "SPN_Description": "Total fuel consumed while the PTO or remote PTO governors are in the hold state, the engine speed is greater than zero, and vehicle speed is less than to 2 km/h, since the last trip reset.\r\n\r\nNOTE—This parameter is intended for gaseous fueled engines.  See SPN 1003 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 21
    },
    "1010": {
      "PGN": 65208,
      "PGN_Name": "Trip Fuel Information (Gaseous)",
      "PGN_Description": "GTFI",
      "first_bit": 96,
      "SPN": 1010,
      "SPN_Name": "Trip Vehicle Idle Fuel Used (Gaseous)",
      "SPN_Description": "Total fuel consumed while neither the PTO or remote PTO governors are active, the engine speed is greater than zero, and vehicle speed is less than to 2 km/h, since the last trip reset.\r\n\r\nNOTE—This parameter is intended for gaseous fueled engines.  See SPN 1004 for alternate resolution.  Trip vehicle idle fuel while in fast idle (vehicle speed less than 2 km/h with engine speed greater than 700 rpm) shall be accumulated in the trip vehicle idle fuel category.  All other fuel usage scenarios that do not fall directly in the categories defined shall be accumulated in trip drive fuel used.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 21
    },
    "1011": {
      "PGN": 65208,
      "PGN_Name": "Trip Fuel Information (Gaseous)",
      "PGN_Description": "GTFI",
      "first_bit": 128,
      "SPN": 1011,
      "SPN_Name": "Trip Cruise Fuel Used (Gaseous)",
      "SPN_Description": "Total fuel consumed while the engine is in the cruise hold state since the last trip reset.  If both cruise control and VSL (vehicle speed limiter) are commanding the same amount of fuel, the cruise control is deemed the active torque mode and fuel will be accumulated in \"trip cruise fuel used\" parameter.  If fuel commanded due to the accelerator pedal position is larger than fuel commanded by cruise control (e.g., accelerator override torque mode), the cruise control is not deemed the active torque mode and fuel will not be accumulated in the \"trip cruise fuel used\" parameter.\r\n\r\nNOTE—This parameter is intended for gaseous fueled engines.  See SPN 1005 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 21
    },
    "1012": {
      "PGN": 65208,
      "PGN_Name": "Trip Fuel Information (Gaseous)",
      "PGN_Description": "GTFI",
      "first_bit": 160,
      "SPN": 1012,
      "SPN_Name": "Trip Drive Fuel Economy (Gaseous)",
      "SPN_Description": "Trip drive fuel economy is equal to the distance traveled by vehicle in the drive state (engine speed greater than zero, vehicle speed greater than or equal to 2 km/h, and neither the PTO or remote PTO governors are controlling engine power output) divided by trip drive fuel used (SPN 1007), since the last trip reset.\r\n\r\nNOTE—This parameter is intended for gaseous fueled engines.  See SPN 1006 for alternate resolution.",
      "bit_length": 16,
      "scaling": 0.001953125,
      "offset": 0,
      "unit": "km/kg",
      "SLOT_ID": 17
    },
    "1013": {
      "PGN": 65207,
      "PGN_Name": "Engine Speed/Load Factor Information",
      "PGN_Description": "LF",
      "first_bit": 0,
      "SPN": 1013,
      "SPN_Name": "Trip Maximum Engine Speed",
      "SPN_Description": "Maximum engine speed achieved since the last trip reset.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "1014": {
      "PGN": 65207,
      "PGN_Name": "Engine Speed/Load Factor Information",
      "PGN_Description": "LF",
      "first_bit": 16,
      "SPN": 1014,
      "SPN_Name": "Trip Average Engine Speed",
      "SPN_Description": "Average speed of the engine since the last trip reset.\r\n\r\nNOTE — Excludes ignition-on time without the engine speed above zero.  Includes idle, engine PTO governor (moving and non-moving), and drive operation.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "1015": {
      "PGN": 65207,
      "PGN_Name": "Engine Speed/Load Factor Information",
      "PGN_Description": "LF",
      "first_bit": 32,
      "SPN": 1015,
      "SPN_Name": "Trip Drive Average Load Factor",
      "SPN_Description": "Average engine load factor while engine speed is greater than zero, vehicle speed is greater than or equal to 2 km/h, and both the PTO (moving/non-moving) and remote PTO governors are not in the hold state, since the last trip reset.  Engine operation during cruise control operation is included.\r\n\r\nIn marine applications, this parameter is defined as the average engine load factor while engine speed is greater than zero, since last trip reset.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1016": {
      "PGN": 65207,
      "PGN_Name": "Engine Speed/Load Factor Information",
      "PGN_Description": "LF",
      "first_bit": 40,
      "SPN": 1016,
      "SPN_Name": "Total Drive Average Load Factor",
      "SPN_Description": "Average engine load factor while engine speed is greater than zero, vehicle speed is greater than or equal to 2 km/h, and both the PTO (moving/non-moving) and remote PTO governors are not in the hold state, over the life of the engine.  Engine operation during cruise control operation is included.\r\n\r\nIn marine applications, this parameter is defined as the average engine load factor while engine speed is greater than zero.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1017": {
      "PGN": 65207,
      "PGN_Name": "Engine Speed/Load Factor Information",
      "PGN_Description": "LF",
      "first_bit": 48,
      "SPN": 1017,
      "SPN_Name": "Total Engine Cruise Time",
      "SPN_Description": "Total time that the engine has operated in the cruise hold state, excluding time in accelerator override, over the life of the engine.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "1018": {
      "PGN": 65206,
      "PGN_Name": "Trip Vehicle Speed/Cruise Distance Information",
      "PGN_Description": "TVI",
      "first_bit": 0,
      "SPN": 1018,
      "SPN_Name": "Trip Maximum Vehicle Speed",
      "SPN_Description": "Maximum vehicle speed achieved while the engine speed is greater than zero and the accelerator pedal position (APS) is at a value greater than 0%, since the last trip reset.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 71
    },
    "1019": {
      "PGN": 65206,
      "PGN_Name": "Trip Vehicle Speed/Cruise Distance Information",
      "PGN_Description": "TVI",
      "first_bit": 16,
      "SPN": 1019,
      "SPN_Name": "Trip Cruise Distance",
      "SPN_Description": "Total distance that the engine has operated in the cruise hold state, excluding time in accelerator override, since the last trip reset.",
      "bit_length": 32,
      "scaling": 0.125,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 36
    },
    "1020": {
      "PGN": 65205,
      "PGN_Name": "Trip Shutdown Information",
      "PGN_Description": "TSI",
      "first_bit": 0,
      "SPN": 1020,
      "SPN_Name": "Trip Number of Hot Shutdowns",
      "SPN_Description": "Total number of hot shutdowns since the last trip reset.  A hot shutdown is based on operation at high load or high engine speed or for long operating periods without allowing the engine to cool sufficiently.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "1021": {
      "PGN": 65205,
      "PGN_Name": "Trip Shutdown Information",
      "PGN_Description": "TSI",
      "first_bit": 16,
      "SPN": 1021,
      "SPN_Name": "Trip Number of Idle Shutdowns",
      "SPN_Description": "Total number of times the engine has been shutdown due to idling too long (at normal idle or fast idle) since the last trip reset.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "1022": {
      "PGN": 65205,
      "PGN_Name": "Trip Shutdown Information",
      "PGN_Description": "TSI",
      "first_bit": 32,
      "SPN": 1022,
      "SPN_Name": "Trip Number of Idle Shutdown Overrides",
      "SPN_Description": "Total number of times an operator disables idle shutdown to prevent an engine shutdown, since the last trip reset.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "1023": {
      "PGN": 65205,
      "PGN_Name": "Trip Shutdown Information",
      "PGN_Description": "TSI",
      "first_bit": 48,
      "SPN": 1023,
      "SPN_Name": "Trip Sudden Decelerations",
      "SPN_Description": "Total number of decelerations whenever the vehicle deceleration is more than XYZ km/h/sec (where XYZ is a calibratible threshold), since the last trip reset.  A lengthy deceleration shall be counted as one sudden deceleration.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "1024": {
      "PGN": 65204,
      "PGN_Name": "Trip Time Information 1",
      "PGN_Description": "TTI1",
      "first_bit": 0,
      "SPN": 1024,
      "SPN_Name": "Trip Time in VSL",
      "SPN_Description": "Total time accumulated when the engine has operated on the vehicle speed limiter (VSL) while not in the cruise hold state, since the last trip reset.  The engine torque mode is equal to road speed governor during this operation.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "1025": {
      "PGN": 65204,
      "PGN_Name": "Trip Time Information 1",
      "PGN_Description": "TTI1",
      "first_bit": 32,
      "SPN": 1025,
      "SPN_Name": "Trip Time in Top Gear",
      "SPN_Description": "Total time accumulated when the vehicle has operated in top gear for a calibrated minimum time, since the last trip reset.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "1026": {
      "PGN": 65204,
      "PGN_Name": "Trip Time Information 1",
      "PGN_Description": "TTI1",
      "first_bit": 64,
      "SPN": 1026,
      "SPN_Name": "Trip Time in Gear Down",
      "SPN_Description": "Total time accumulated when the vehicle has operated in one gear down from the top gear for a calibrated minimum time, since the last trip reset.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "1027": {
      "PGN": 65204,
      "PGN_Name": "Trip Time Information 1",
      "PGN_Description": "TTI1",
      "first_bit": 96,
      "SPN": 1027,
      "SPN_Name": "Trip Time in Derate by Engine",
      "SPN_Description": "Total time accumulated when the engine final fueling has been derated due to an engine protection algorithm, since the last reset.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "1028": {
      "PGN": 65203,
      "PGN_Name": "Fuel Information 1 (Liquid)",
      "PGN_Description": "LFI1",
      "first_bit": 0,
      "SPN": 1028,
      "SPN_Name": "Total Engine PTO Governor Fuel Used",
      "SPN_Description": "Total fuel used while the PTO or remote PTO governors are in the hold state and engine speed is above zero, over the life of the engine.\r\n\r\nNOTE—This parameter is intended for liquid fueled engines.  See SPN 1030 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 20
    },
    "1029": {
      "PGN": 65203,
      "PGN_Name": "Fuel Information 1 (Liquid)",
      "PGN_Description": "LFI1",
      "first_bit": 32,
      "SPN": 1029,
      "SPN_Name": "Trip Average Fuel Rate",
      "SPN_Description": "Average fuel rate, equal to trip fuel divided by trip time while the engine speed is above zero, since the last trip reset.  This includes idle, engine PTO governor (both moving and non-moving) and drive operation but excludes ignition-on time while the engine speed is at zero rpm.\r\n\r\nNOTE—This parameter is intended for liquid fueled engines.  See SPN 1031 for alternate resolution.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "l/h",
      "SLOT_ID": 42
    },
    "1030": {
      "PGN": 65202,
      "PGN_Name": "Fuel Information 1 (Gaseous)",
      "PGN_Description": "GFI1",
      "first_bit": 0,
      "SPN": 1030,
      "SPN_Name": "Total Engine PTO Governor Fuel Used (Gaseous)",
      "SPN_Description": "Total fuel used while the PTO or remote PTO governors are in the hold state and engine speed is above zero, over the life of the engine.\r\n\r\nNOTE—This parameter is intended for gaseous fueled engines.  See SPN 1028 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 21
    },
    "1031": {
      "PGN": 65202,
      "PGN_Name": "Fuel Information 1 (Gaseous)",
      "PGN_Description": "GFI1",
      "first_bit": 32,
      "SPN": 1031,
      "SPN_Name": "Trip Average Fuel Rate (Gaseous)",
      "SPN_Description": "Average fuel rate, equal to trip fuel divided by trip time while the engine speed is above zero, since the last trip reset.  This includes idle, engine PTO governor (both moving and non-moving) and drive operation but excludes ignition-on time while the engine speed is at zero rpm.\r\n\r\nNOTE—This parameter is intended for gaseous fueled engines.  See SPN 1029 for alternate resolution.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "kg/h",
      "SLOT_ID": 18
    },
    "1032": {
      "PGN": 65201,
      "PGN_Name": "ECU History",
      "PGN_Description": "EH",
      "first_bit": 0,
      "SPN": 1032,
      "SPN_Name": "Total ECU Distance",
      "SPN_Description": "Total distance accumulated over the life of the ECU.  When the ECU is replaced this value shall be reset.",
      "bit_length": 32,
      "scaling": 0.125,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 36
    },
    "1033": {
      "PGN": 65201,
      "PGN_Name": "ECU History",
      "PGN_Description": "EH",
      "first_bit": 32,
      "SPN": 1033,
      "SPN_Name": "Total ECU Run Time",
      "SPN_Description": "Total time accumulated over the life of the ECU, from ignition switch ON to ignition switch OFF.  When the ECU is replaced this value shall be reset.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "1034": {
      "PGN": 65200,
      "PGN_Name": "Trip Time Information 2",
      "PGN_Description": "TTI2",
      "first_bit": 0,
      "SPN": 1034,
      "SPN_Name": "Trip Cruise Time",
      "SPN_Description": "Total time accumulated while the engine is in the cruise hold state, excluding time in accelerator override, since the last trip reset.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "1035": {
      "PGN": 65200,
      "PGN_Name": "Trip Time Information 2",
      "PGN_Description": "TTI2",
      "first_bit": 32,
      "SPN": 1035,
      "SPN_Name": "Trip PTO Governor Time",
      "SPN_Description": "Total time accumulated while the engine is in the PTO or remote PTO governor hold state since the last trip reset.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "1036": {
      "PGN": 65200,
      "PGN_Name": "Trip Time Information 2",
      "PGN_Description": "TTI2",
      "first_bit": 64,
      "SPN": 1036,
      "SPN_Name": "Trip Engine Running Time",
      "SPN_Description": "Total time accumulated while the engine speed is greater than zero since the last trip reset.  Note that time with the ignition switch on but engine speed at zero is not included.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "1037": {
      "PGN": 65200,
      "PGN_Name": "Trip Time Information 2",
      "PGN_Description": "TTI2",
      "first_bit": 96,
      "SPN": 1037,
      "SPN_Name": "Trip Idle Time",
      "SPN_Description": "Total time accumulated while the engine speed is greater than zero, both the PTO and remote PTO governors are inactive, and the vehicle speed is less than 2 km/h, since the last trip reset.\r\n\r\nIn marine applications, this parameter is defined as the total time accumulated while the engine speed is greater than zero, and less than or equal to 50 RPM greater than low idle, since the last trip reset.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "1038": {
      "PGN": 65200,
      "PGN_Name": "Trip Time Information 2",
      "PGN_Description": "TTI2",
      "first_bit": 128,
      "SPN": 1038,
      "SPN_Name": "Trip Air Compressor On Time",
      "SPN_Description": "Total time that the air compressor is on and compressing air since the last trip reset.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "1039": {
      "PGN": 65199,
      "PGN_Name": "Fuel Consumption (Gaseous)",
      "PGN_Description": "GFC",
      "first_bit": 0,
      "SPN": 1039,
      "SPN_Name": "Trip Fuel (Gaseous)",
      "SPN_Description": "Total fuel consumed (trip drive fuel + trip PTO governor moving fuel + trip PTO governor non-moving fuel + trip idle fuel) since the last trip reset.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 21
    },
    "1040": {
      "PGN": 65199,
      "PGN_Name": "Fuel Consumption (Gaseous)",
      "PGN_Description": "GFC",
      "first_bit": 32,
      "SPN": 1040,
      "SPN_Name": "Total Fuel Used (Gaseous)",
      "SPN_Description": "Total fuel consumed (trip drive fuel + trip PTO governor moving fuel + trip PTO governor non-moving fuel + trip idle fuel) over the life of the engine.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 21
    },
    "1081": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 24,
      "SPN": 1081,
      "SPN_Name": "Engine Wait to Start Lamp",
      "SPN_Description": "Lamp signal which indicates that the engine is too cold to start and the operator should wait until the signal becomes inactive (turns off).  See SPN 5416 for the lamp operating condition.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1082": {
      "PGN": 61440,
      "PGN_Name": "Electronic Retarder Controller 1",
      "PGN_Description": "ERC1",
      "first_bit": 24,
      "SPN": 1082,
      "SPN_Name": "Engine Coolant Load Increase",
      "SPN_Description": "Status of an event, external to the engine, that may increase the nominal temperature of the engine coolant liquid.\r\n\r\n00 - No coolant load increase\r\n01 - Coolant load increase possible\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1083": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 32,
      "SPN": 1083,
      "SPN_Name": "Auxiliary I/O Channel #1",
      "SPN_Description": "Auxiliary channel of data (16 bit) read by the ECU.  This data is in A/D counts and is manufacturer specific.  It may be configured uniquely per application.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "1084": {
      "PGN": 65241,
      "PGN_Name": "Auxiliary Input/Output Status 1",
      "PGN_Description": "AUXIO1",
      "first_bit": 48,
      "SPN": 1084,
      "SPN_Name": "Auxiliary I/O Channel #2",
      "SPN_Description": "Auxiliary channel of data (16 bit) read by the ECU.  This data is in A/D counts and is manufacturer specific.  It may be configured uniquely per application.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "1085": {
      "PGN": 61440,
      "PGN_Name": "Electronic Retarder Controller 1",
      "PGN_Description": "ERC1",
      "first_bit": 16,
      "SPN": 1085,
      "SPN_Name": "Intended Retarder Percent Torque",
      "SPN_Description": "Braking torque of retarder that the retarder is currently trying to achieve.  This value takes into account all static limitations, but not the limitations due to the dynamic behavior of the retarder.  This value, if unchanged over a certain time, can and will be reached by the actual retarder - percent torque (See SPN 520).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1086": {
      "PGN": 65198,
      "PGN_Name": "Air Supply Pressure",
      "PGN_Description": "AIR1",
      "first_bit": 8,
      "SPN": 1086,
      "SPN_Name": "Parking and/or Trailer Air Pressure",
      "SPN_Description": "The pneumatic pressure in the circuit or reservoir for the parking brake and/or the trailer supply.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "1087": {
      "PGN": 65198,
      "PGN_Name": "Air Supply Pressure",
      "PGN_Description": "AIR1",
      "first_bit": 16,
      "SPN": 1087,
      "SPN_Name": "Service Brake Circuit 1 Air Pressure",
      "SPN_Description": "The pneumatic pressure in the primary service brake circuit or reservoir, supplying the rear axle.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "1088": {
      "PGN": 65198,
      "PGN_Name": "Air Supply Pressure",
      "PGN_Description": "AIR1",
      "first_bit": 24,
      "SPN": 1088,
      "SPN_Name": "Service Brake Circuit 2 Air Pressure",
      "SPN_Description": "The pneumatic pressure in the secondary service brake circuit or reservoir, supplying the front axle.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "1089": {
      "PGN": 65198,
      "PGN_Name": "Air Supply Pressure",
      "PGN_Description": "AIR1",
      "first_bit": 32,
      "SPN": 1089,
      "SPN_Name": "Auxiliary Equipment Supply Pressure",
      "SPN_Description": "The pneumatic pressure in the auxiliary circuit.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "1090": {
      "PGN": 65198,
      "PGN_Name": "Air Supply Pressure",
      "PGN_Description": "AIR1",
      "first_bit": 40,
      "SPN": 1090,
      "SPN_Name": "Air Suspension Supply Pressure",
      "SPN_Description": "The pneumatic pressure in the circuit for the electronically controlled air suspension system.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "1091": {
      "PGN": 65197,
      "PGN_Name": "Wheel Application Pressure High Range Information",
      "PGN_Description": "EBC3",
      "first_bit": 0,
      "SPN": 1091,
      "SPN_Name": "Brake Application Pressure High Range, Front Axle, Left Wheel",
      "SPN_Description": "The brake application pressure for the left wheel on the front axle.",
      "bit_length": 8,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 1
    },
    "1092": {
      "PGN": 65197,
      "PGN_Name": "Wheel Application Pressure High Range Information",
      "PGN_Description": "EBC3",
      "first_bit": 8,
      "SPN": 1092,
      "SPN_Name": "Brake Application Pressure High Range, Front Axle, Right Wheel",
      "SPN_Description": "The brake application pressure for the right wheel on the front axle.",
      "bit_length": 8,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 1
    },
    "1093": {
      "PGN": 65197,
      "PGN_Name": "Wheel Application Pressure High Range Information",
      "PGN_Description": "EBC3",
      "first_bit": 16,
      "SPN": 1093,
      "SPN_Name": "Brake Application Pressure High Range, Rear Axle #1, Left Wheel",
      "SPN_Description": "The brake application pressure for the left wheel on the rear axle #1.",
      "bit_length": 8,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 1
    },
    "1094": {
      "PGN": 65197,
      "PGN_Name": "Wheel Application Pressure High Range Information",
      "PGN_Description": "EBC3",
      "first_bit": 24,
      "SPN": 1094,
      "SPN_Name": "Brake Application Pressure High Range, Rear Axle #1, Right Wheel",
      "SPN_Description": "The brake application pressure for the right wheel on the rear axle #1.",
      "bit_length": 8,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 1
    },
    "1095": {
      "PGN": 65197,
      "PGN_Name": "Wheel Application Pressure High Range Information",
      "PGN_Description": "EBC3",
      "first_bit": 32,
      "SPN": 1095,
      "SPN_Name": "Brake Application Pressure High Range, Rear Axle #2, Left Wheel",
      "SPN_Description": "The brake application pressure for the left wheel on the rear axle #2.",
      "bit_length": 8,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 1
    },
    "1096": {
      "PGN": 65197,
      "PGN_Name": "Wheel Application Pressure High Range Information",
      "PGN_Description": "EBC3",
      "first_bit": 40,
      "SPN": 1096,
      "SPN_Name": "Brake Application Pressure High Range, Rear Axle #2, Right Wheel",
      "SPN_Description": "The brake application pressure for the right wheel on the rear axle #2.",
      "bit_length": 8,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 1
    },
    "1097": {
      "PGN": 65197,
      "PGN_Name": "Wheel Application Pressure High Range Information",
      "PGN_Description": "EBC3",
      "first_bit": 48,
      "SPN": 1097,
      "SPN_Name": "Brake Application Pressure High Range, Rear Axle #3, Left Wheel",
      "SPN_Description": "The brake application pressure for the left wheel on the rear axle #3.",
      "bit_length": 8,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 1
    },
    "1098": {
      "PGN": 65197,
      "PGN_Name": "Wheel Application Pressure High Range Information",
      "PGN_Description": "EBC3",
      "first_bit": 56,
      "SPN": 1098,
      "SPN_Name": "Brake Application Pressure High Range, Rear Axle #3, Right Wheel",
      "SPN_Description": "The brake application pressure for the right wheel on the rear axle #3.",
      "bit_length": 8,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 1
    },
    "1099": {
      "PGN": 65196,
      "PGN_Name": "Wheel Brake Lining Remaining Information",
      "PGN_Description": "EBC4",
      "first_bit": 0,
      "SPN": 1099,
      "SPN_Name": "Brake Lining Remaining, Front Axle, Left Wheel",
      "SPN_Description": "The percentage of brake lining which can still be measured for the left wheel on the front axle.  100% represents new brake linings, 0% represents totally worn brake linings.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1100": {
      "PGN": 65196,
      "PGN_Name": "Wheel Brake Lining Remaining Information",
      "PGN_Description": "EBC4",
      "first_bit": 8,
      "SPN": 1100,
      "SPN_Name": "Brake Lining Remaining, Front Axle, Right Wheel",
      "SPN_Description": "The percentage of brake lining which can still be measured for the right wheel on the front axle.  100% represents new brake linings, 0% represents totally worn brake linings.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1101": {
      "PGN": 65196,
      "PGN_Name": "Wheel Brake Lining Remaining Information",
      "PGN_Description": "EBC4",
      "first_bit": 16,
      "SPN": 1101,
      "SPN_Name": "Brake Lining Remaining, Rear Axle #1, Left Wheel",
      "SPN_Description": "The percentage of brake lining which can still be measured for the left wheel on the rear axle #1.  100% represents new brake linings, 0% represents totally worn brake linings.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1102": {
      "PGN": 65196,
      "PGN_Name": "Wheel Brake Lining Remaining Information",
      "PGN_Description": "EBC4",
      "first_bit": 24,
      "SPN": 1102,
      "SPN_Name": "Brake Lining Remaining, Rear Axle #1, Right Wheel",
      "SPN_Description": "The percentage of brake lining which can still be measured for the right wheel on the rear axle #1.  100% represents new brake linings, 0% represents totally worn brake linings.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1103": {
      "PGN": 65196,
      "PGN_Name": "Wheel Brake Lining Remaining Information",
      "PGN_Description": "EBC4",
      "first_bit": 32,
      "SPN": 1103,
      "SPN_Name": "Brake Lining Remaining, Rear Axle #2, Left Wheel",
      "SPN_Description": "The percentage of brake lining which can still be measured for the left wheel on the rear axle #2.  100% represents new brake linings, 0% represents totally worn brake linings.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1104": {
      "PGN": 65196,
      "PGN_Name": "Wheel Brake Lining Remaining Information",
      "PGN_Description": "EBC4",
      "first_bit": 40,
      "SPN": 1104,
      "SPN_Name": "Brake Lining Remaining, Rear Axle #2, Right Wheel",
      "SPN_Description": "The percentage of brake lining which can still be measured for the right wheel on the rear axle #2.  100% represents new brake linings, 0% represents totally worn brake linings.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1105": {
      "PGN": 65196,
      "PGN_Name": "Wheel Brake Lining Remaining Information",
      "PGN_Description": "EBC4",
      "first_bit": 48,
      "SPN": 1105,
      "SPN_Name": "Brake Lining Remaining, Rear Axle #3, Left Wheel",
      "SPN_Description": "The percentage of brake lining which can still be measured for the left wheel on the rear axle #3.  100% represents new brake linings, 0% represents totally worn brake linings.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1106": {
      "PGN": 65196,
      "PGN_Name": "Wheel Brake Lining Remaining Information",
      "PGN_Description": "EBC4",
      "first_bit": 56,
      "SPN": 1106,
      "SPN_Name": "Brake Lining Remaining, Rear Axle #3, Right Wheel",
      "SPN_Description": "The percentage of brake lining which can still be measured for the right wheel on the rear axle #3.  100% represents new brake linings, 0% represents totally worn brake linings.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1107": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 38,
      "SPN": 1107,
      "SPN_Name": "Engine Protection System Timer State",
      "SPN_Description": "Status signal which indicates the current mode of the engine protection system timer system.  See Figure SPN1107_A.\r\n\r\n00 - Inactive\r\n01 - Active\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1108": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 36,
      "SPN": 1108,
      "SPN_Name": "Engine Protection System Timer Override",
      "SPN_Description": "Status signal which indicates the status of the override feature of the engine protection system timer. See Figure SPN1107_A.\r\n\r\n00 - Inactive\r\n01 - Active\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1109": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 34,
      "SPN": 1109,
      "SPN_Name": "Engine Protection System Approaching Shutdown",
      "SPN_Description": "Status signal which indicates that engine shutdown is imminent.  This engine protection signal can be a result of different systems failing, i.e., engine overheating. See Figure SPN1107_A.\r\n\r\n00 - Not approaching\r\n01 - Approaching\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1110": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 32,
      "SPN": 1110,
      "SPN_Name": "Engine Protection System has Shutdown Engine",
      "SPN_Description": "Status signal which indicates whether or not the engine protection system has shutdown the engine.  See Figure SPN1107_A.\r\n\r\n00 - No\r\n01 - Yes\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1111": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 46,
      "SPN": 1111,
      "SPN_Name": "Engine Protection System Configuration",
      "SPN_Description": "Parameter which indicates the configuration of the engine shutdown system.\r\n\r\n00 - Disabled in calibration\r\n01 - Enabled in calibration\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1113": {
      "PGN": 65195,
      "PGN_Name": "Electronic Transmission Controller 6",
      "PGN_Description": "ETC6",
      "first_bit": 0,
      "SPN": 1113,
      "SPN_Name": "Recommended Gear",
      "SPN_Description": "The transmission calculates this gear continuously.  In dangerous situations this gear may be selected to gain back vehicle control.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "gear value",
      "SLOT_ID": 24
    },
    "1114": {
      "PGN": 65195,
      "PGN_Name": "Electronic Transmission Controller 6",
      "PGN_Description": "ETC6",
      "first_bit": 16,
      "SPN": 1114,
      "SPN_Name": "Lowest Possible Gear",
      "SPN_Description": "The transmission calculates this gear continuously.  Together with the highest possible gear (see SPN 1115), it enables a management computer to know the exact range of available gears.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "gear value",
      "SLOT_ID": 24
    },
    "1115": {
      "PGN": 65195,
      "PGN_Name": "Electronic Transmission Controller 6",
      "PGN_Description": "ETC6",
      "first_bit": 8,
      "SPN": 1115,
      "SPN_Name": "Highest Possible Gear",
      "SPN_Description": "The transmission calculates this gear continuously.  Together with the lowest possible gear (see  SPN 1114), it enables a management computer to know the exact range of available gears.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "gear value",
      "SLOT_ID": 24
    },
    "1116": {
      "PGN": 65194,
      "PGN_Name": "Alternate Fuel 2",
      "PGN_Description": "AF2",
      "first_bit": 0,
      "SPN": 1116,
      "SPN_Name": "Gaseous Fuel Correction Factor",
      "SPN_Description": "A correction to a predefined gaseous fuel energy (expressed in energy per unit volume) represented as a percentage.  The actual fuel energy used to control the engine is the product of the gaseous fuel correction factor and the energy of the gas.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1117": {
      "PGN": 65193,
      "PGN_Name": "Exhaust Oxygen 1",
      "PGN_Description": "EO1",
      "first_bit": 0,
      "SPN": 1117,
      "SPN_Name": "Engine Desired Rated Exhaust Oxygen",
      "SPN_Description": "The desired amount of oxygen in the exhaust at rated conditions represented as a percentage by volume with respect to the total volume of exhaust gases leaving the engine.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "1118": {
      "PGN": 65193,
      "PGN_Name": "Exhaust Oxygen 1",
      "PGN_Description": "EO1",
      "first_bit": 16,
      "SPN": 1118,
      "SPN_Name": "Engine Desired Exhaust Oxygen",
      "SPN_Description": "The desired amount of oxygen in the exhaust represented as a percentage by volume with respect to the total volume of exhaust gases leaving the engine.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "1119": {
      "PGN": 65193,
      "PGN_Name": "Exhaust Oxygen 1",
      "PGN_Description": "EO1",
      "first_bit": 32,
      "SPN": 1119,
      "SPN_Name": "Engine Actual Exhaust Oxygen",
      "SPN_Description": "The actual amount of oxygen in the exhaust represented as a percentage by volume with respect to the total volume of exhaust gases leaving the engine.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "1120": {
      "PGN": 65192,
      "PGN_Name": "Articulation Control",
      "PGN_Description": "ACTL",
      "first_bit": 0,
      "SPN": 1120,
      "SPN_Name": "Articulation Angle",
      "SPN_Description": "Angle of deflection of an articulated transit vehicle (rotation angle about the vehicles z-axis). A right turn (clockwise) is indicated with a positive angle and a left turn is indicated with a negative angle.  This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "deg",
      "SLOT_ID": 11
    },
    "1121": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 6,
      "SPN": 1121,
      "SPN_Name": "EBS Brake Switch",
      "SPN_Description": "Switch signal which indicates that the brake pedal is being pressed.  The EBS brake switch is independent of the brake light switch and has no provisions for external connections.\r\n\r\n00 - Brake pedal is not being pressed\r\n01 - Brake pedal is being pressed\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1122": {
      "PGN": 65191,
      "PGN_Name": "Alternator Temperature 1",
      "PGN_Description": "AT1",
      "first_bit": 0,
      "SPN": 1122,
      "SPN_Name": "Engine Alternator Bearing 1 Temperature",
      "SPN_Description": "Temperature of the bearing inside the alternator.  Bearing 1 is the left or rear bearing.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1123": {
      "PGN": 65191,
      "PGN_Name": "Alternator Temperature 1",
      "PGN_Description": "AT1",
      "first_bit": 8,
      "SPN": 1123,
      "SPN_Name": "Engine Alternator Bearing 2 Temperature",
      "SPN_Description": "Temperature of the bearing inside the alternator.  Bearing 2 is the right or front bearing.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1124": {
      "PGN": 65191,
      "PGN_Name": "Alternator Temperature 1",
      "PGN_Description": "AT1",
      "first_bit": 16,
      "SPN": 1124,
      "SPN_Name": "Engine Alternator Winding 1 Temperature",
      "SPN_Description": "Temperature of the windings inside the alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1125": {
      "PGN": 65191,
      "PGN_Name": "Alternator Temperature 1",
      "PGN_Description": "AT1",
      "first_bit": 24,
      "SPN": 1125,
      "SPN_Name": "Engine Alternator Winding 2 Temperature",
      "SPN_Description": "Temperature of the windings inside the alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1126": {
      "PGN": 65191,
      "PGN_Name": "Alternator Temperature 1",
      "PGN_Description": "AT1",
      "first_bit": 32,
      "SPN": 1126,
      "SPN_Name": "Engine Alternator Winding 3 Temperature",
      "SPN_Description": "Temperature of the windings inside the alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1127": {
      "PGN": 65190,
      "PGN_Name": "Intake Manifold Information 1",
      "PGN_Description": "IMT1",
      "first_bit": 0,
      "SPN": 1127,
      "SPN_Name": "Engine Turbocharger 1 Boost Pressure",
      "SPN_Description": "Gage pressure of air measured downstream of the compressor discharge side of the turbocharger.  See also SPN 102 for alternate range and resolution. If there is only one boost pressure to report and the range and resolution in SPN 102 is adequate, then it should be used.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 138
    },
    "1128": {
      "PGN": 65190,
      "PGN_Name": "Intake Manifold Information 1",
      "PGN_Description": "IMT1",
      "first_bit": 16,
      "SPN": 1128,
      "SPN_Name": "Engine Turbocharger 2 Boost Pressure",
      "SPN_Description": "Gage pressure of air measured downstream of the compressor discharge side of the turbocharger.  See also SPN 102 for alternate range and resolution. If there is only one boost pressure to report and the range and resolution in SPN 102  is adequate, then it should be used.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 138
    },
    "1129": {
      "PGN": 65190,
      "PGN_Name": "Intake Manifold Information 1",
      "PGN_Description": "IMT1",
      "first_bit": 32,
      "SPN": 1129,
      "SPN_Name": "Engine Turbocharger 3 Boost Pressure",
      "SPN_Description": "Gage pressure of air measured downstream of the compressor discharge side of the turbocharger.  See also SPN 102 for alternate range and resolution. If there is only one boost pressure to report and the range and resolution in SPN 102 is adequate, then it should be used.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 138
    },
    "1130": {
      "PGN": 65190,
      "PGN_Name": "Intake Manifold Information 1",
      "PGN_Description": "IMT1",
      "first_bit": 48,
      "SPN": 1130,
      "SPN_Name": "Engine Turbocharger 4 Boost Pressure",
      "SPN_Description": "Gage pressure of air measured downstream of the compressor discharge side of the turbocharger.  See also SPN 102 for alternate range and resolution. If there is only one boost pressure to report and the range and resolution in SPN 102 is adequate, then it should be used.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 138
    },
    "1131": {
      "PGN": 65189,
      "PGN_Name": "Intake Manifold Information 2",
      "PGN_Description": "IMT2",
      "first_bit": 0,
      "SPN": 1131,
      "SPN_Name": "Engine Intake Manifold 2 Temperature",
      "SPN_Description": "Temperature of pre-combustion air found in intake manifold of engine air supply system.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1132": {
      "PGN": 65189,
      "PGN_Name": "Intake Manifold Information 2",
      "PGN_Description": "IMT2",
      "first_bit": 8,
      "SPN": 1132,
      "SPN_Name": "Engine Intake Manifold 3 Temperature",
      "SPN_Description": "Temperature of pre-combustion air found in intake manifold of engine air supply system.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1133": {
      "PGN": 65189,
      "PGN_Name": "Intake Manifold Information 2",
      "PGN_Description": "IMT2",
      "first_bit": 16,
      "SPN": 1133,
      "SPN_Name": "Engine Intake Manifold 4 Temperature",
      "SPN_Description": "Temperature of pre-combustion air found in intake manifold of engine air supply system.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1134": {
      "PGN": 65262,
      "PGN_Name": "Engine Temperature 1",
      "PGN_Description": "ET1",
      "first_bit": 56,
      "SPN": 1134,
      "SPN_Name": "Engine Charge Air Cooler Thermostat Opening",
      "SPN_Description": "The current position of the thermostat used to regulate the temperature of the engine charge air cooler.  A value of 0% represents the thermostat being completely closed and 100% represents the thermostat being completely open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1135": {
      "PGN": 65188,
      "PGN_Name": "Engine Temperature 2",
      "PGN_Description": "ET2",
      "first_bit": 0,
      "SPN": 1135,
      "SPN_Name": "Engine Oil Temperature 2",
      "SPN_Description": "Temperature of the engine lubricant.\r\n\r\nNote:  If there is only one engine oil temperature measurement, SPN 175 should be used. \r\n\r\nSee also SPNs 175 and 5925 for additional engine oil temperature measurements.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1136": {
      "PGN": 65188,
      "PGN_Name": "Engine Temperature 2",
      "PGN_Description": "ET2",
      "first_bit": 16,
      "SPN": 1136,
      "SPN_Name": "Engine ECU Temperature",
      "SPN_Description": "Temperature of the engine electronic control unit.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1137": {
      "PGN": 65187,
      "PGN_Name": "Exhaust Port Temperature 1",
      "PGN_Description": "EPT1",
      "first_bit": 0,
      "SPN": 1137,
      "SPN_Name": "Engine Exhaust Gas Port 1 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1138": {
      "PGN": 65187,
      "PGN_Name": "Exhaust Port Temperature 1",
      "PGN_Description": "EPT1",
      "first_bit": 16,
      "SPN": 1138,
      "SPN_Name": "Engine Exhaust Gas Port 2 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1139": {
      "PGN": 65187,
      "PGN_Name": "Exhaust Port Temperature 1",
      "PGN_Description": "EPT1",
      "first_bit": 32,
      "SPN": 1139,
      "SPN_Name": "Engine Exhaust Gas Port 3 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1140": {
      "PGN": 65187,
      "PGN_Name": "Exhaust Port Temperature 1",
      "PGN_Description": "EPT1",
      "first_bit": 48,
      "SPN": 1140,
      "SPN_Name": "Engine Exhaust Gas Port 4 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1141": {
      "PGN": 65186,
      "PGN_Name": "Exhaust Port Temperature 2",
      "PGN_Description": "EPT2",
      "first_bit": 0,
      "SPN": 1141,
      "SPN_Name": "Engine Exhaust Gas Port 5 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1142": {
      "PGN": 65186,
      "PGN_Name": "Exhaust Port Temperature 2",
      "PGN_Description": "EPT2",
      "first_bit": 16,
      "SPN": 1142,
      "SPN_Name": "Engine Exhaust Gas Port 6 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1143": {
      "PGN": 65186,
      "PGN_Name": "Exhaust Port Temperature 2",
      "PGN_Description": "EPT2",
      "first_bit": 32,
      "SPN": 1143,
      "SPN_Name": "Engine Exhaust Gas Port 7 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1144": {
      "PGN": 65186,
      "PGN_Name": "Exhaust Port Temperature 2",
      "PGN_Description": "EPT2",
      "first_bit": 48,
      "SPN": 1144,
      "SPN_Name": "Engine Exhaust Gas Port 8 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1145": {
      "PGN": 65185,
      "PGN_Name": "Exhaust Port Temperature 3",
      "PGN_Description": "EPT3",
      "first_bit": 0,
      "SPN": 1145,
      "SPN_Name": "Engine Exhaust Gas Port 9 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1146": {
      "PGN": 65185,
      "PGN_Name": "Exhaust Port Temperature 3",
      "PGN_Description": "EPT3",
      "first_bit": 16,
      "SPN": 1146,
      "SPN_Name": "Engine Exhaust Gas Port 10 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1147": {
      "PGN": 65185,
      "PGN_Name": "Exhaust Port Temperature 3",
      "PGN_Description": "EPT3",
      "first_bit": 32,
      "SPN": 1147,
      "SPN_Name": "Engine Exhaust Gas Port 11 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1148": {
      "PGN": 65185,
      "PGN_Name": "Exhaust Port Temperature 3",
      "PGN_Description": "EPT3",
      "first_bit": 48,
      "SPN": 1148,
      "SPN_Name": "Engine Exhaust Gas Port 12 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1149": {
      "PGN": 65184,
      "PGN_Name": "Exhaust Port Temperature 4",
      "PGN_Description": "EPT4",
      "first_bit": 0,
      "SPN": 1149,
      "SPN_Name": "Engine Exhaust Gas Port 13 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1150": {
      "PGN": 65184,
      "PGN_Name": "Exhaust Port Temperature 4",
      "PGN_Description": "EPT4",
      "first_bit": 16,
      "SPN": 1150,
      "SPN_Name": "Engine Exhaust Gas Port 14 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1151": {
      "PGN": 65184,
      "PGN_Name": "Exhaust Port Temperature 4",
      "PGN_Description": "EPT4",
      "first_bit": 32,
      "SPN": 1151,
      "SPN_Name": "Engine Exhaust Gas Port 15 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1152": {
      "PGN": 65184,
      "PGN_Name": "Exhaust Port Temperature 4",
      "PGN_Description": "EPT4",
      "first_bit": 48,
      "SPN": 1152,
      "SPN_Name": "Engine Exhaust Gas Port 16 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1153": {
      "PGN": 65183,
      "PGN_Name": "Exhaust Port Temperature 5",
      "PGN_Description": "EPT5",
      "first_bit": 0,
      "SPN": 1153,
      "SPN_Name": "Engine Exhaust Gas Port 17 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1154": {
      "PGN": 65183,
      "PGN_Name": "Exhaust Port Temperature 5",
      "PGN_Description": "EPT5",
      "first_bit": 16,
      "SPN": 1154,
      "SPN_Name": "Engine Exhaust Gas Port 18 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1155": {
      "PGN": 65183,
      "PGN_Name": "Exhaust Port Temperature 5",
      "PGN_Description": "EPT5",
      "first_bit": 32,
      "SPN": 1155,
      "SPN_Name": "Engine Exhaust Gas Port 19 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1156": {
      "PGN": 65183,
      "PGN_Name": "Exhaust Port Temperature 5",
      "PGN_Description": "EPT5",
      "first_bit": 48,
      "SPN": 1156,
      "SPN_Name": "Engine Exhaust Gas Port 20 Temperature",
      "SPN_Description": "Temperature at the cylinder exhaust port of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1157": {
      "PGN": 65182,
      "PGN_Name": "Main Bearing Temperature 1",
      "PGN_Description": "MBT1",
      "first_bit": 0,
      "SPN": 1157,
      "SPN_Name": "Engine Main Bearing 1 Temperature",
      "SPN_Description": "Temperature of the main bearing which supports the crankshaft of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1158": {
      "PGN": 65182,
      "PGN_Name": "Main Bearing Temperature 1",
      "PGN_Description": "MBT1",
      "first_bit": 16,
      "SPN": 1158,
      "SPN_Name": "Engine Main Bearing 2 Temperature",
      "SPN_Description": "Temperature of the main bearing which supports the crankshaft of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1159": {
      "PGN": 65182,
      "PGN_Name": "Main Bearing Temperature 1",
      "PGN_Description": "MBT1",
      "first_bit": 32,
      "SPN": 1159,
      "SPN_Name": "Engine Main Bearing 3 Temperature",
      "SPN_Description": "Temperature of the main bearing which supports the crankshaft of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1160": {
      "PGN": 65182,
      "PGN_Name": "Main Bearing Temperature 1",
      "PGN_Description": "MBT1",
      "first_bit": 48,
      "SPN": 1160,
      "SPN_Name": "Engine Main Bearing 4 Temperature",
      "SPN_Description": "Temperature of the main bearing which supports the crankshaft of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1161": {
      "PGN": 65181,
      "PGN_Name": "Main Bearing Temperature 2",
      "PGN_Description": "MBT2",
      "first_bit": 0,
      "SPN": 1161,
      "SPN_Name": "Engine Main Bearing 5 Temperature",
      "SPN_Description": "Temperature of the main bearing which supports the crankshaft of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1162": {
      "PGN": 65181,
      "PGN_Name": "Main Bearing Temperature 2",
      "PGN_Description": "MBT2",
      "first_bit": 16,
      "SPN": 1162,
      "SPN_Name": "Engine Main Bearing 6 Temperature",
      "SPN_Description": "Temperature of the main bearing which supports the crankshaft of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1163": {
      "PGN": 65181,
      "PGN_Name": "Main Bearing Temperature 2",
      "PGN_Description": "MBT2",
      "first_bit": 32,
      "SPN": 1163,
      "SPN_Name": "Engine Main Bearing 7 Temperature",
      "SPN_Description": "Temperature of the main bearing which supports the crankshaft of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1164": {
      "PGN": 65181,
      "PGN_Name": "Main Bearing Temperature 2",
      "PGN_Description": "MBT2",
      "first_bit": 48,
      "SPN": 1164,
      "SPN_Name": "Engine Main Bearing 8 Temperature",
      "SPN_Description": "Temperature of the main bearing which supports the crankshaft of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1165": {
      "PGN": 65180,
      "PGN_Name": "Main Bearing Temperature 3",
      "PGN_Description": "MBT3",
      "first_bit": 0,
      "SPN": 1165,
      "SPN_Name": "Engine Main Bearing 9 Temperature",
      "SPN_Description": "Temperature of the main bearing which supports the crankshaft of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1166": {
      "PGN": 65180,
      "PGN_Name": "Main Bearing Temperature 3",
      "PGN_Description": "MBT3",
      "first_bit": 16,
      "SPN": 1166,
      "SPN_Name": "Engine Main Bearing 10 Temperature",
      "SPN_Description": "Temperature of the main bearing which supports the crankshaft of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1167": {
      "PGN": 65180,
      "PGN_Name": "Main Bearing Temperature 3",
      "PGN_Description": "MBT3",
      "first_bit": 32,
      "SPN": 1167,
      "SPN_Name": "Engine Main Bearing 11 Temperature",
      "SPN_Description": "Temperature of the main bearing which supports the crankshaft of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1168": {
      "PGN": 65179,
      "PGN_Name": "Turbocharger Information 1",
      "PGN_Description": "TCI1",
      "first_bit": 0,
      "SPN": 1168,
      "SPN_Name": "Engine Turbocharger Lube Oil Pressure 2",
      "SPN_Description": "Gage pressure of oil in turbocharger lubrication system.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "1169": {
      "PGN": 65179,
      "PGN_Name": "Turbocharger Information 1",
      "PGN_Description": "TCI1",
      "first_bit": 8,
      "SPN": 1169,
      "SPN_Name": "Engine Turbocharger 2 Speed",
      "SPN_Description": "Rotational velocity of rotor in the turbocharger.",
      "bit_length": 16,
      "scaling": 4,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 77
    },
    "1170": {
      "PGN": 65179,
      "PGN_Name": "Turbocharger Information 1",
      "PGN_Description": "TCI1",
      "first_bit": 24,
      "SPN": 1170,
      "SPN_Name": "Engine Turbocharger 3 Speed",
      "SPN_Description": "Rotational velocity of rotor in the turbocharger.",
      "bit_length": 16,
      "scaling": 4,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 77
    },
    "1171": {
      "PGN": 65179,
      "PGN_Name": "Turbocharger Information 1",
      "PGN_Description": "TCI1",
      "first_bit": 40,
      "SPN": 1171,
      "SPN_Name": "Engine Turbocharger 4 Speed",
      "SPN_Description": "Rotational velocity of rotor in the turbocharger.",
      "bit_length": 16,
      "scaling": 4,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 77
    },
    "1172": {
      "PGN": 65178,
      "PGN_Name": "Turbocharger Information 2",
      "PGN_Description": "TCI2",
      "first_bit": 0,
      "SPN": 1172,
      "SPN_Name": "Engine Turbocharger 1 Compressor Intake Temperature",
      "SPN_Description": "Temperature of the air entering the compressor side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1173": {
      "PGN": 65178,
      "PGN_Name": "Turbocharger Information 2",
      "PGN_Description": "TCI2",
      "first_bit": 16,
      "SPN": 1173,
      "SPN_Name": "Engine Turbocharger 2 Compressor Intake Temperature",
      "SPN_Description": "Temperature of the air entering the compressor side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1174": {
      "PGN": 65178,
      "PGN_Name": "Turbocharger Information 2",
      "PGN_Description": "TCI2",
      "first_bit": 32,
      "SPN": 1174,
      "SPN_Name": "Engine Turbocharger 3 Compressor Intake Temperature",
      "SPN_Description": "Temperature of the air entering the compressor side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1175": {
      "PGN": 65178,
      "PGN_Name": "Turbocharger Information 2",
      "PGN_Description": "TCI2",
      "first_bit": 48,
      "SPN": 1175,
      "SPN_Name": "Engine Turbocharger 4 Compressor Intake Temperature",
      "SPN_Description": "Temperature of the air entering the compressor side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1176": {
      "PGN": 65177,
      "PGN_Name": "Turbocharger Information 3",
      "PGN_Description": "TCI3",
      "first_bit": 0,
      "SPN": 1176,
      "SPN_Name": "Engine Turbocharger 1 Compressor Intake Pressure",
      "SPN_Description": "Gage pressure of the air entering the compressor side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "kPa",
      "SLOT_ID": 52
    },
    "1177": {
      "PGN": 65177,
      "PGN_Name": "Turbocharger Information 3",
      "PGN_Description": "TCI3",
      "first_bit": 16,
      "SPN": 1177,
      "SPN_Name": "Engine Turbocharger 2 Compressor Intake Pressure",
      "SPN_Description": "Gage pressure of the air entering the compressor side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "kPa",
      "SLOT_ID": 52
    },
    "1178": {
      "PGN": 65177,
      "PGN_Name": "Turbocharger Information 3",
      "PGN_Description": "TCI3",
      "first_bit": 32,
      "SPN": 1178,
      "SPN_Name": "Engine Turbocharger 3 Compressor Intake Pressure",
      "SPN_Description": "Gage pressure of the air entering the compressor side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "kPa",
      "SLOT_ID": 52
    },
    "1179": {
      "PGN": 65177,
      "PGN_Name": "Turbocharger Information 3",
      "PGN_Description": "TCI3",
      "first_bit": 48,
      "SPN": 1179,
      "SPN_Name": "Engine Turbocharger 4 Compressor Intake Pressure",
      "SPN_Description": "Gage pressure of the air entering the compressor side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "kPa",
      "SLOT_ID": 52
    },
    "1180": {
      "PGN": 65176,
      "PGN_Name": "Turbocharger Information 4",
      "PGN_Description": "TCI4",
      "first_bit": 0,
      "SPN": 1180,
      "SPN_Name": "Engine Turbocharger 1 Turbine Intake Temperature",
      "SPN_Description": "Temperature of the combustion by-products entering the turbine side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1181": {
      "PGN": 65176,
      "PGN_Name": "Turbocharger Information 4",
      "PGN_Description": "TCI4",
      "first_bit": 16,
      "SPN": 1181,
      "SPN_Name": "Engine Turbocharger 2 Turbine Intake Temperature",
      "SPN_Description": "Temperature of the combustion by-products entering the turbine side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1182": {
      "PGN": 65176,
      "PGN_Name": "Turbocharger Information 4",
      "PGN_Description": "TCI4",
      "first_bit": 32,
      "SPN": 1182,
      "SPN_Name": "Engine Turbocharger 3 Turbine Intake Temperature",
      "SPN_Description": "Temperature of the combustion by-products entering the turbine side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1183": {
      "PGN": 65176,
      "PGN_Name": "Turbocharger Information 4",
      "PGN_Description": "TCI4",
      "first_bit": 48,
      "SPN": 1183,
      "SPN_Name": "Engine Turbocharger 4 Turbine Intake Temperature",
      "SPN_Description": "Temperature of the combustion by-products entering the turbine side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1184": {
      "PGN": 65175,
      "PGN_Name": "Turbocharger Information 5",
      "PGN_Description": "TCI5",
      "first_bit": 0,
      "SPN": 1184,
      "SPN_Name": "Engine Turbocharger 1 Turbine Outlet Temperature",
      "SPN_Description": "Temperature of the combustion by-products exiting the turbine side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1185": {
      "PGN": 65175,
      "PGN_Name": "Turbocharger Information 5",
      "PGN_Description": "TCI5",
      "first_bit": 16,
      "SPN": 1185,
      "SPN_Name": "Engine Turbocharger 2 Turbine Outlet Temperature",
      "SPN_Description": "Temperature of the combustion by-products exiting the turbine side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1186": {
      "PGN": 65175,
      "PGN_Name": "Turbocharger Information 5",
      "PGN_Description": "TCI5",
      "first_bit": 32,
      "SPN": 1186,
      "SPN_Name": "Engine Turbocharger 3 Turbine Outlet Temperature",
      "SPN_Description": "Temperature of the combustion by-products exiting the turbine side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1187": {
      "PGN": 65175,
      "PGN_Name": "Turbocharger Information 5",
      "PGN_Description": "TCI5",
      "first_bit": 48,
      "SPN": 1187,
      "SPN_Name": "Engine Turbocharger 4 Turbine Outlet Temperature",
      "SPN_Description": "Temperature of the combustion by-products exiting the turbine side of the turbocharger.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1188": {
      "PGN": 65174,
      "PGN_Name": "Turbocharger Wastegate",
      "PGN_Description": "TCW",
      "first_bit": 0,
      "SPN": 1188,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 1 Position",
      "SPN_Description": "Position of the wastegate drive.  A value of 0% represents fully closed and a value of 100% represents fully open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1189": {
      "PGN": 65174,
      "PGN_Name": "Turbocharger Wastegate",
      "PGN_Description": "TCW",
      "first_bit": 8,
      "SPN": 1189,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 2 Position",
      "SPN_Description": "Position of the wastegate drive.  A value of 0% represents fully closed and a value of 100% represents fully open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1190": {
      "PGN": 65174,
      "PGN_Name": "Turbocharger Wastegate",
      "PGN_Description": "TCW",
      "first_bit": 16,
      "SPN": 1190,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 3 Position",
      "SPN_Description": "Position of the wastegate drive.  A value of 0% represents fully closed and a value of 100% represents fully open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1191": {
      "PGN": 65174,
      "PGN_Name": "Turbocharger Wastegate",
      "PGN_Description": "TCW",
      "first_bit": 24,
      "SPN": 1191,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 4 Position",
      "SPN_Description": "Position of the wastegate drive.  A value of 0% represents fully closed and a value of 100% represents fully open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1192": {
      "PGN": 65174,
      "PGN_Name": "Turbocharger Wastegate",
      "PGN_Description": "TCW",
      "first_bit": 32,
      "SPN": 1192,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator Control Air Pressure",
      "SPN_Description": "Gage pressure of the air used to control the actuator which opens and closes the wastegate valve.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "1193": {
      "PGN": 65173,
      "PGN_Name": "Rebuild Information",
      "PGN_Description": "RBI",
      "first_bit": 0,
      "SPN": 1193,
      "SPN_Name": "Engine Operation Time Since Rebuild",
      "SPN_Description": "The time in engine operation since the last engine rebuild.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "1194": {
      "PGN": 56320,
      "PGN_Name": "Anti-theft Status",
      "PGN_Description": "ATS",
      "first_bit": 0,
      "SPN": 1194,
      "SPN_Name": "Anti-theft Encryption Seed Present Indicator",
      "SPN_Description": "Indicates the presence of the encryption seed random number.\r\n\r\n00 - Random number is not present\r\n01 - Random number is present\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1195": {
      "PGN": 56320,
      "PGN_Name": "Anti-theft Status",
      "PGN_Description": "ATS",
      "first_bit": 2,
      "SPN": 1195,
      "SPN_Name": "Anti-theft Password Valid Indicator",
      "SPN_Description": "Indicates the presence of a validated password.\r\n\r\n00 - Password is not a validated password\r\n01 - Password is a validated password\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1196": {
      "PGN": 56320,
      "PGN_Name": "Anti-theft Status",
      "PGN_Description": "ATS",
      "first_bit": 4,
      "SPN": 1196,
      "SPN_Name": "Anti-theft Component Status States",
      "SPN_Description": "Indicates whether or not the component can be started.  \r\n\r\n00 Unlocked\r\n01 Locked\r\n10 Blocked\r\n11 Not defined\r\n\r\n00b -  Unlocked = This state indicates that the component can be started without the end user being required to enter a password.\r\n\r\n01b - Locked = This state indicates that the component can NOT be started (i.e., Unlocked) without the end user being required to enter a password.\r\n\r\n10b - Blocked = This state indicates that a Lock or Unlock command cannot be executed because some other algorithm or command of higher priority is commanding differently.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1197": {
      "PGN": 56320,
      "PGN_Name": "Anti-theft Status",
      "PGN_Description": "ATS",
      "first_bit": 6,
      "SPN": 1197,
      "SPN_Name": "Anti-theft Modify Password States",
      "SPN_Description": "This parameter is used to indicate whether a password request was successfully performed, or if the request could not be perform due to system constraints or if the request was not a valid request.  \r\n\r\n00 Ok\r\n01 Full_of_Passwords\r\n10 Empty_of_Passwords\r\n11 Not_valid\r\n\r\n00b - Ok = This state indicates that the request was successfully performed.\r\n\r\n01b - Full_Of_Passwords = This state indicates that the component can NOT store any additional passwords in its memory.\r\n\r\n10b - Empty_Of_Passwords = This state indicates that the component would be empty of passwords (an unacceptable condition) if the password under which the end user is logged in, is deleted.  Thus the delete password command is not successfully executed.\r\n\r\nNote that if the Delete_Password command is sent to a component that does not currently have a password the Empty_Of_Passwords state indicator shall be used.\r\n\r\n11b -  Not_Valid = This state indicates that the request is not a valid one.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1198": {
      "PGN": 56320,
      "PGN_Name": "Anti-theft Status",
      "PGN_Description": "ATS",
      "first_bit": 8,
      "SPN": 1198,
      "SPN_Name": "Anti-theft Random Number",
      "SPN_Description": "A seven byte random numeric code provided by the component in response to an anti-theft request.  This parameter is sent as a numeric value utilizing the full range of 0 to 0xFFFFFFFFFFFFFF.  The most significant byte is sent first, not following the rules of Table 1 found in J1939-71.",
      "bit_length": 56,
      "scaling": 1,
      "offset": 0,
      "unit": "ASCII",
      "SLOT_ID": 110
    },
    "1199": {
      "PGN": 56576,
      "PGN_Name": "Anti-theft Request",
      "PGN_Description": "ATR",
      "first_bit": 1,
      "SPN": 1199,
      "SPN_Name": "Anti-theft Encryption Indicator States",
      "SPN_Description": "This parameter is used to indicate if a random number seed is being requested, or if an encrypted password is being provided to the component. \r\n\r\n00 Encryption_Seed_Request\r\n01 Encrypted_Code_Present\r\n10 Not defined\r\n11 Not_Available\r\n\r\n00b - Encryption_Seed_Request = This state represents a request to the component to provide a random number seed.\r\n\r\n01b - Encrypted_Code_Present = This state is used to indicate that an encrypted password is being provided to the component.\r\n\r\n11b - Not_Available = This state is used to indicate that a random number is NOT being requested nor is an encrypted password being provided to the component.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1200": {
      "PGN": 56576,
      "PGN_Name": "Anti-theft Request",
      "PGN_Description": "ATR",
      "first_bit": 3,
      "SPN": 1200,
      "SPN_Name": "Anti-theft Desired Exit Mode States",
      "SPN_Description": "This parameter is used to specify the desired triggers that are to be used by the component in deciding when to transition to the Locked state. \r\n\r\n00 Lock_Upon_Operator_Request\r\n01 Lock_When_Key_Off\r\n10 Not defined\r\n11 Not_Available\r\n\r\n00b -   Lock_Upon_Operator_Request—This state is used to indicate that the end user would have to manually enter a password to Lock the engine.\r\n\r\n01b -  Lock_When_Keyoff—This state is used to indicate that the component would automatically transition to the Locked state when the end user turns off the engine (i.e. without the end user being required to manually enter the password).\r\n\r\n11b - Not_Available—This state is indicates that the option is not selectable or changeable by the operator via using current tool.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1201": {
      "PGN": 56576,
      "PGN_Name": "Anti-theft Request",
      "PGN_Description": "ATR",
      "first_bit": 5,
      "SPN": 1201,
      "SPN_Name": "Anti-theft Command States",
      "SPN_Description": "This parameter is used to identify the specific requests being sent to the component. \r\n\r\n000 Add_Password\r\n001 Delete_Password\r\n010 Change_Password\r\n011 Lock_or_Unlock\r\n100 Check_Status\r\n101 Login\r\n110-111 Not defined\r\n\r\n000b - Add_Password—This state represents a request to the component to add a password to the list of passwords that the component has stored as valid codes.  This command will not be performed if the component has already stored, the maximum number of passwords that it is capable of storing.  The Login command must precede this command.\r\n\r\n001b - Delete_Password—This state represents a request to the component to delete the password (the same one used when the end-user logged in).  See SPN 1197 for limitations.\r\n\r\n010b - Change_Password—This state represents a request to the component to change the password (the same one that the end-user logged in with) to a different password, which is to be specified by the end user.  The Login command must precede this command.\r\n\r\n011b - Lock_Or_Unlock—This state represents a request to the component to change from the Locked state to the Unlocked state or from the Unlocked state to the Locked state.\r\n\r\n100b - Check_Status—This state represents a request to check to see if the component is in the Locked or Unlocked state.\r\n\r\n101b -  Login—This state represents a request to validate the end user, before performing commands such as Add_Password and Change_Password.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "1202": {
      "PGN": 56576,
      "PGN_Name": "Anti-theft Request",
      "PGN_Description": "ATR",
      "first_bit": 8,
      "SPN": 1202,
      "SPN_Name": "Anti-theft Password Representation",
      "SPN_Description": "This parameter is the seven byte numeric code (i.e., ‘encrypted password’ or ‘key’) that is generated based on the encryption algorithm, the password supplied by the end user, and the random number seed given by the component.  This parameter is sent as a numeric value utilizing the full range of 0 to 0xFFFFFFFFFFFFFF.  The most significant byte is sent first, not following the rules of Table 1 found in J1939-71.",
      "bit_length": 56,
      "scaling": 1,
      "offset": 0,
      "unit": "ASCII",
      "SLOT_ID": 110
    },
    "1203": {
      "PGN": 65172,
      "PGN_Name": "Engine Auxiliary Coolant",
      "PGN_Description": "EAC",
      "first_bit": 0,
      "SPN": 1203,
      "SPN_Name": "Engine Auxiliary Coolant Pressure",
      "SPN_Description": "Gage pressure of coolant found in the intercooler which is located after the turbocharger.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "1204": {
      "PGN": 65171,
      "PGN_Name": "Engine Electrical System/Module Information",
      "PGN_Description": "EES",
      "first_bit": 0,
      "SPN": 1204,
      "SPN_Name": "Electrical Load",
      "SPN_Description": "Electrical power delivered by the engine to the electrical system connected to the generator.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kW",
      "SLOT_ID": 55
    },
    "1205": {
      "PGN": 65171,
      "PGN_Name": "Engine Electrical System/Module Information",
      "PGN_Description": "EES",
      "first_bit": 16,
      "SPN": 1205,
      "SPN_Name": "Safety Wire Status",
      "SPN_Description": "Status signal which indicates that the safety wire has been activated.  When the safety wire is activated, the engine will not operate.  This is used for maintenance purposes.\r\n\r\n00 - Safety wire has not been activated\r\n01 - Safety wire has been activated\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1206": {
      "PGN": 65171,
      "PGN_Name": "Engine Electrical System/Module Information",
      "PGN_Description": "EES",
      "first_bit": 18,
      "SPN": 1206,
      "SPN_Name": "Engine Turning Gear Engaged",
      "SPN_Description": "Status signal which indicates that the turning gear is engaged.  The turning gear is used to turn the flywheel/crankshaft, for maintenance purposes, while the engine is not running.\r\n\r\n00 - Not engaged\r\n01 - Engaged\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1208": {
      "PGN": 65170,
      "PGN_Name": "Engine Information 1",
      "PGN_Description": "EI1",
      "first_bit": 0,
      "SPN": 1208,
      "SPN_Name": "Engine Oil Filter Intake Pressure",
      "SPN_Description": "Gage pressure of the engine oil before the oil reaches the oil filter.   See SPN 7470 for alternate resolution.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "1209": {
      "PGN": 65170,
      "PGN_Name": "Engine Information 1",
      "PGN_Description": "EI1",
      "first_bit": 8,
      "SPN": 1209,
      "SPN_Name": "Engine Exhaust Pressure 1",
      "SPN_Description": "Gage pressure of the exhaust gases as measured at the turbine intake of the turbocharger. This SPN to be used for inline engines or exhaust bank 1 of multiple bank engines.  See SPN 5749 for exhaust bank 2 and See SPN 6384 for alternate range and resolution.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "kPa",
      "SLOT_ID": 52
    },
    "1210": {
      "PGN": 65170,
      "PGN_Name": "Engine Information 1",
      "PGN_Description": "EI1",
      "first_bit": 24,
      "SPN": 1210,
      "SPN_Name": "Engine Fuel Rack Position",
      "SPN_Description": "Measured position of the engine fuel rack.  A value of 0% rack represents no fueling and a value of 100% rack represents maximum fueling.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1211": {
      "PGN": 56832,
      "PGN_Name": "Reset",
      "PGN_Description": "RESET",
      "first_bit": 16,
      "SPN": 1211,
      "SPN_Name": "Engine Build Hours Reset",
      "SPN_Description": "Command signal used to reset the engine rebuild hours.\r\n\r\n00 Do not reset\r\n01 Reset\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1212": {
      "PGN": 65172,
      "PGN_Name": "Engine Auxiliary Coolant",
      "PGN_Description": "EAC",
      "first_bit": 8,
      "SPN": 1212,
      "SPN_Name": "Engine Auxiliary Coolant Temperature",
      "SPN_Description": "Temperature of coolant found in the intercooler which is located after the turbocharger.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1237": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 62,
      "SPN": 1237,
      "SPN_Name": "Engine Shutdown Override Switch",
      "SPN_Description": "Switch signal which indicates the position of the engine shutdown override switch.  This switch function allows the operator to override an impending engine shutdown.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1238": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 22,
      "SPN": 1238,
      "SPN_Name": "Traction Control Override Switch",
      "SPN_Description": "Switch signal which indicates the position of the traction control override switch.  The traction control override signal disables the automatic traction control function allowing the wheels to spin.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available or not installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1239": {
      "PGN": 65169,
      "PGN_Name": "Fuel Leakage",
      "PGN_Description": "FL",
      "first_bit": 0,
      "SPN": 1239,
      "SPN_Name": "Engine Fuel Leakage 1",
      "SPN_Description": "Status signal which indicates fuel leakage in the fuel rail of the engine. Location can be either before or after the fuel pump.  \r\n\r\n00 - no leakage detected\r\n01 - leakage detected\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1240": {
      "PGN": 65169,
      "PGN_Name": "Fuel Leakage",
      "PGN_Description": "FL",
      "first_bit": 2,
      "SPN": 1240,
      "SPN_Name": "Engine Fuel Leakage 2",
      "SPN_Description": "Status signal which indicates fuel leakage in the fuel rail of the engine. Location can be either before or after the fuel pump.  \r\n\r\n00 - no leakage detected\r\n01 - leakage detected\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1241": {
      "PGN": 65170,
      "PGN_Name": "Engine Information 1",
      "PGN_Description": "EI1",
      "first_bit": 32,
      "SPN": 1241,
      "SPN_Name": "Engine Fuel System 1 Gas Mass Flow Rate",
      "SPN_Description": "Gas mass flow rate delivered to an engine through its first fuel control system.  See SPN 3467 for the second fuel control system.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "kg/h",
      "SLOT_ID": 18
    },
    "1242": {
      "PGN": 65170,
      "PGN_Name": "Engine Information 1",
      "PGN_Description": "EI1",
      "first_bit": 48,
      "SPN": 1242,
      "SPN_Name": "Instantaneous Estimated Brake Power",
      "SPN_Description": "Estimate of the power developed by the engine.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kW",
      "SLOT_ID": 55
    },
    "1243": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 40,
      "SPN": 1243,
      "SPN_Name": "ABS Fully Operational",
      "SPN_Description": "Signal which indicates whether an ABS system is fully operational or whether its functionality is reduced by a defect or by an intended action (e.g., by activation of an ABS-off-road switch or during special diagnostic procedures).  There are cases where the signal is necessary to fulfill legal regulations for special applications (e.g., switching off integrated retarders).\r\n\r\n00 - Not Fully Operational\r\n01 - Fully Operational\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1244": {
      "PGN": 61466,
      "PGN_Name": "Engine Throttle / Fuel Actuator Control Command",
      "PGN_Description": "TFAC",
      "first_bit": 48,
      "SPN": 1244,
      "SPN_Name": "Engine Fuel Actuator 2 Control Command",
      "SPN_Description": "The control command to fuel actuator 2, normalized to percent, where 0% represents fully closed and 100% represents fully open. Typically, this fuel actuator is used to regulate low pressure natural gas flow rate, mixing into the air flow, which together then come into the engine. Using the standard convention for determining the position. If only 2 actuators are present, then left/front is #1 (SPN 633) and right/rear is #2 (SPN 1244). If more than two actuators are present, then left/front is #1 (SPN 633), left/rear is #2 (SPN 1244), right/front is #3 (SPN 7593) and right/rear is #4 (SPN 7594).",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "1245": {
      "PGN": 64670,
      "PGN_Name": "Engine Timing Actuator Position",
      "PGN_Description": "ETAP",
      "first_bit": 3,
      "SPN": 1245,
      "SPN_Name": "Engine Timing Actuator 2",
      "SPN_Description": "The detected position of actuator 2 on the Engine Timing System, where the system has different timing positions depending on current operating status of the engine. Timing positions may be used to determine intake and outlet valve timings.\r\n\r\n000 - Unknown Position\r\n001 - Diesel Mode Position\r\n010 - Diesel Part Load Position\r\n011 - Gas Mode Position\r\n100 - Diesel Part Load / Gas Mode Position\r\n101 - 110 - Reserved\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "1246": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 0,
      "SPN": 1246,
      "SPN_Name": "Number of Engine Torque History Records",
      "SPN_Description": "Number of torque history records contained in the engine torque history PGN.  A value of 0 is broadcast if no torque history records are stored in the ECU.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Record",
      "SLOT_ID": 33
    },
    "1247": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 8,
      "SPN": 1247,
      "SPN_Name": "Engine Power",
      "SPN_Description": "Advertised engine power capability.  Advertised power is what a customer will find on a sales sheet for an engine with a certain calibration.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kW",
      "SLOT_ID": 55
    },
    "1248": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 24,
      "SPN": 1248,
      "SPN_Name": "Engine Peak Torque 1",
      "SPN_Description": "Maximum torque output of the current ECU calibration when the engine operates on torque curve 1.  For calibrations that support two torque curves, this parameter shall be assigned the value of the lower curve.  For calibrations that support only one curve, this parameter should be used.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Nm",
      "SLOT_ID": 70
    },
    "1249": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 40,
      "SPN": 1249,
      "SPN_Name": "Engine Peak Torque 2",
      "SPN_Description": "Maximum torque output of the current ECU calibration when the engine operates on torque curve 2.  For calibrations that support two torque curves, this parameter shall be assigned the value of the higher curve.  For calibrations that support only one curve, this parameter should to set to “not available”.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Nm",
      "SLOT_ID": 70
    },
    "1250": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 56,
      "SPN": 1250,
      "SPN_Name": "Calibration Record Start Month",
      "SPN_Description": "Calendar month timestamp when an ECU record was established.\r\n\r\nNOTE - A value of 0 for the month is null.  The value 1 identifies January; 2 identifies February; etc.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "months",
      "SLOT_ID": 62
    },
    "1251": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 64,
      "SPN": 1251,
      "SPN_Name": "Calibration Record Start Day",
      "SPN_Description": "Calendar day timestamp when an ECU record was established.\r\n\r\nNOTE - A value of 0 for the date is null.  The values 1, 2, 3, and 4 are used to identify the first day of the month; 5, 6, 7, and 8 identify the second day of the month; etc.",
      "bit_length": 8,
      "scaling": 0.25,
      "offset": 0,
      "unit": "days",
      "SLOT_ID": 60
    },
    "1252": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 72,
      "SPN": 1252,
      "SPN_Name": "Calibration Record Start Year",
      "SPN_Description": "Calendar year timestamp when an ECU record was established.\r\n\r\nNOTE - A value of 0 for the year identifies the year 1985; a value of 1 identifies 1986; etc.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 1985,
      "unit": "years",
      "SLOT_ID": 66
    },
    "1253": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 80,
      "SPN": 1253,
      "SPN_Name": "Calibration Record Duration Time",
      "SPN_Description": "Duration in hours for which the engine operated in the conditions captured in the current record.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "1254": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 112,
      "SPN": 1254,
      "SPN_Name": "Torque Limiting Feature Status",
      "SPN_Description": "Status of an ECU feature which limits the torque output of the engine. \r\n\r\n00 - Disabled\r\n01 - Enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1255": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 120,
      "SPN": 1255,
      "SPN_Name": "Transmission Gear Ratio 1",
      "SPN_Description": "Gear ratio value stored in the ECU that is used to define a range of transmission gears for which a limit is applied to the engine output torque.  Transmission gear ratio 1 should be the numerically highest transmission gear ratio breakpoint that defines ratio ranges for torque limits.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": null,
      "SLOT_ID": 23
    },
    "1256": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 136,
      "SPN": 1256,
      "SPN_Name": "Engine Torque Limit 1, Transmission",
      "SPN_Description": "Limit applied to the engine output torque during vehicle operation in transmission gear ratios numerically greater than transmission gear ratio 1 (see SPN 1255).",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Nm",
      "SLOT_ID": 70
    },
    "1257": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 152,
      "SPN": 1257,
      "SPN_Name": "Transmission Gear Ratio 2",
      "SPN_Description": "Gear ratio value stored in the ECU that is used to define a range of transmission gears for which a limit is applied to the engine output torque.  Transmission gear ratio 2 should be the numerically highest transmission gear ratio breakpoint less than transmission gear ratio 1 (see SPN 1255) that defines ratio ranges for torque limits.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": null,
      "SLOT_ID": 23
    },
    "1258": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 168,
      "SPN": 1258,
      "SPN_Name": "Engine Torque Limit 2, Transmission",
      "SPN_Description": "Limit applied to the engine output torque during vehicle operation in transmission gear ratios numerically less than or equal to transmission gear ratio 1 (see SPN 1255) and numerically greater than transmission gear ratio 2 (see.SPN 1257).  For example, with transmission gear ratio 1 equal to 12.0:1 and transmission gear ratio 2 equal to 5.0:1, vehicle operation in a transmission gear with a ratio of 6.0:1 will result in the application of engine torque limit 2, transmission.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Nm",
      "SLOT_ID": 70
    },
    "1259": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 184,
      "SPN": 1259,
      "SPN_Name": "Transmission Gear Ratio 3",
      "SPN_Description": "Gear ratio value stored in the ECU that is used to define a range of transmission gears for which a limit is applied to the engine output torque.  Transmission gear ratio 3 should be the numerically highest transmission gear ratio breakpoint less than transmission gear ratio 2 (see SPN 1257) that defines ratio ranges for torque limits.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": null,
      "SLOT_ID": 23
    },
    "1260": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 200,
      "SPN": 1260,
      "SPN_Name": "Engine Torque Limit 3, Transmission",
      "SPN_Description": "Limit applied to the engine output torque during vehicle operation in transmission gear ratios numerically less than or equal to transmission gear ratio 2 (see SPN 1257) and numerically greater than transmission gear ratio 3 (see.SPN 1259).  For example, with transmission gear ratio 2 equal to 5.0:1 and transmission gear ratio 3 equal to 2.0:1, vehicle operation in a transmission gear with a ratio of 3.0:1 will result in the application of engine torque limit 3, transmission.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Nm",
      "SLOT_ID": 70
    },
    "1261": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 216,
      "SPN": 1261,
      "SPN_Name": "Engine Torque Limit 4, Transmission",
      "SPN_Description": "Limit applied to the engine output torque during vehicle operation in transmission gear ratios numerically less than or equal to transmission gear ratio 3 (see SPN 1259).",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Nm",
      "SLOT_ID": 70
    },
    "1262": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 232,
      "SPN": 1262,
      "SPN_Name": "Engine Torque Limit 5, Switch",
      "SPN_Description": "Limit applied to the engine output torque based on activation of an ECU switch input.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Nm",
      "SLOT_ID": 70
    },
    "1263": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 248,
      "SPN": 1263,
      "SPN_Name": "Engine Torque Limit 6, Axle Input",
      "SPN_Description": "Limit applied to the engine output torque based on the maximum allowable axle input torque.  Axle input torque is calculated as the current engine torque output multiplied by the transmission gear ratio.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "Nm",
      "SLOT_ID": 98
    },
    "1294": {
      "PGN": 64887,
      "PGN_Name": "Engine Spark Voltage 1",
      "PGN_Description": "ESV1",
      "first_bit": 0,
      "SPN": 1294,
      "SPN_Name": "Engine Spark Plug 1",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #1",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1295": {
      "PGN": 64887,
      "PGN_Name": "Engine Spark Voltage 1",
      "PGN_Description": "ESV1",
      "first_bit": 16,
      "SPN": 1295,
      "SPN_Name": "Engine Spark Plug 2",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #2",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1296": {
      "PGN": 64887,
      "PGN_Name": "Engine Spark Voltage 1",
      "PGN_Description": "ESV1",
      "first_bit": 32,
      "SPN": 1296,
      "SPN_Name": "Engine Spark Plug 3",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #3",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1297": {
      "PGN": 64887,
      "PGN_Name": "Engine Spark Voltage 1",
      "PGN_Description": "ESV1",
      "first_bit": 48,
      "SPN": 1297,
      "SPN_Name": "Engine Spark Plug 4",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #4",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1298": {
      "PGN": 64886,
      "PGN_Name": "Engine Spark Voltage 2",
      "PGN_Description": "ESV2",
      "first_bit": 0,
      "SPN": 1298,
      "SPN_Name": "Engine Spark Plug 5",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #5",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1299": {
      "PGN": 64886,
      "PGN_Name": "Engine Spark Voltage 2",
      "PGN_Description": "ESV2",
      "first_bit": 16,
      "SPN": 1299,
      "SPN_Name": "Engine Spark Plug 6",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #6",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1300": {
      "PGN": 64886,
      "PGN_Name": "Engine Spark Voltage 2",
      "PGN_Description": "ESV2",
      "first_bit": 32,
      "SPN": 1300,
      "SPN_Name": "Engine Spark Plug 7",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #7",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1301": {
      "PGN": 64886,
      "PGN_Name": "Engine Spark Voltage 2",
      "PGN_Description": "ESV2",
      "first_bit": 48,
      "SPN": 1301,
      "SPN_Name": "Engine Spark Plug 8",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #8",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1302": {
      "PGN": 64885,
      "PGN_Name": "Engine Spark Voltage 3",
      "PGN_Description": "ESV3",
      "first_bit": 0,
      "SPN": 1302,
      "SPN_Name": "Engine Spark Plug 9",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #9",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1303": {
      "PGN": 64885,
      "PGN_Name": "Engine Spark Voltage 3",
      "PGN_Description": "ESV3",
      "first_bit": 16,
      "SPN": 1303,
      "SPN_Name": "Engine Spark Plug 10",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #10",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1304": {
      "PGN": 64885,
      "PGN_Name": "Engine Spark Voltage 3",
      "PGN_Description": "ESV3",
      "first_bit": 32,
      "SPN": 1304,
      "SPN_Name": "Engine Spark Plug 11",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #11",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1305": {
      "PGN": 64885,
      "PGN_Name": "Engine Spark Voltage 3",
      "PGN_Description": "ESV3",
      "first_bit": 48,
      "SPN": 1305,
      "SPN_Name": "Engine Spark Plug 12",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #12",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1306": {
      "PGN": 64884,
      "PGN_Name": "Engine Spark Voltage 4",
      "PGN_Description": "ESV4",
      "first_bit": 0,
      "SPN": 1306,
      "SPN_Name": "Engine Spark Plug 13",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #13",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1307": {
      "PGN": 64884,
      "PGN_Name": "Engine Spark Voltage 4",
      "PGN_Description": "ESV4",
      "first_bit": 16,
      "SPN": 1307,
      "SPN_Name": "Engine Spark Plug 14",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #14",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1308": {
      "PGN": 64884,
      "PGN_Name": "Engine Spark Voltage 4",
      "PGN_Description": "ESV4",
      "first_bit": 32,
      "SPN": 1308,
      "SPN_Name": "Engine Spark Plug 15",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #15",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1309": {
      "PGN": 64884,
      "PGN_Name": "Engine Spark Voltage 4",
      "PGN_Description": "ESV4",
      "first_bit": 48,
      "SPN": 1309,
      "SPN_Name": "Engine Spark Plug 16",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #16",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1310": {
      "PGN": 64883,
      "PGN_Name": "Engine Spark Voltage 5",
      "PGN_Description": "ESV5",
      "first_bit": 0,
      "SPN": 1310,
      "SPN_Name": "Engine Spark Plug 17",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #17",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1311": {
      "PGN": 64883,
      "PGN_Name": "Engine Spark Voltage 5",
      "PGN_Description": "ESV5",
      "first_bit": 16,
      "SPN": 1311,
      "SPN_Name": "Engine Spark Plug 18",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #18",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1312": {
      "PGN": 64883,
      "PGN_Name": "Engine Spark Voltage 5",
      "PGN_Description": "ESV5",
      "first_bit": 32,
      "SPN": 1312,
      "SPN_Name": "Engine Spark Plug 19",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #19",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1313": {
      "PGN": 64883,
      "PGN_Name": "Engine Spark Voltage 5",
      "PGN_Description": "ESV5",
      "first_bit": 48,
      "SPN": 1313,
      "SPN_Name": "Engine Spark Plug 20",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #20",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1314": {
      "PGN": 64882,
      "PGN_Name": "Engine Spark Voltage 6",
      "PGN_Description": "ESV6",
      "first_bit": 0,
      "SPN": 1314,
      "SPN_Name": "Engine Spark Plug 21",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #21",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1315": {
      "PGN": 64882,
      "PGN_Name": "Engine Spark Voltage 6",
      "PGN_Description": "ESV6",
      "first_bit": 16,
      "SPN": 1315,
      "SPN_Name": "Engine Spark Plug 22",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #22",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1316": {
      "PGN": 64882,
      "PGN_Name": "Engine Spark Voltage 6",
      "PGN_Description": "ESV6",
      "first_bit": 32,
      "SPN": 1316,
      "SPN_Name": "Engine Spark Plug 23",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #23",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1317": {
      "PGN": 64882,
      "PGN_Name": "Engine Spark Voltage 6",
      "PGN_Description": "ESV6",
      "first_bit": 48,
      "SPN": 1317,
      "SPN_Name": "Engine Spark Plug 24",
      "SPN_Description": "The measured voltage of the spark event on Cylinder #24",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "1320": {
      "PGN": 65167,
      "PGN_Name": "Supply Pressure 2",
      "PGN_Description": "SP2",
      "first_bit": 0,
      "SPN": 1320,
      "SPN_Name": "Engine External Shutdown Air Supply Pressure",
      "SPN_Description": "Pressure of the air used to shut off the fuel supply to the engine.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "1349": {
      "PGN": 65243,
      "PGN_Name": "Engine Fluid Level/Pressure 2",
      "PGN_Description": "EFL/P2",
      "first_bit": 48,
      "SPN": 1349,
      "SPN_Name": "Engine Fuel 1 Injector Metering Rail 2 Pressure",
      "SPN_Description": "The gage pressure of fuel in the metering rail #2 as delivered from the supply pump to the injector metering intake.  See Figure SPN16_A for fuel system related parameters.  Although the figure does not show rail #2 it does show the relationship of rail pressure to other signals.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 51
    },
    "1350": {
      "PGN": 65166,
      "PGN_Name": "Service 2",
      "PGN_Description": "S2",
      "first_bit": 8,
      "SPN": 1350,
      "SPN_Name": "Time Since Last Service",
      "SPN_Description": "The vehicle operation time since the last service was performed.  The type of service information is identified by the service component identification number.",
      "bit_length": 16,
      "scaling": 1,
      "offset": -32127,
      "unit": "h",
      "SLOT_ID": 5
    },
    "1351": {
      "PGN": 65198,
      "PGN_Name": "Air Supply Pressure",
      "PGN_Description": "AIR1",
      "first_bit": 48,
      "SPN": 1351,
      "SPN_Name": "Air Compressor Status",
      "SPN_Description": "Indicates whether the air compressor is actively compressing air.  \r\n\r\n00     Compressor not active\r\n01     Compressor active\r\n10     Error indicator\r\n11     Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1352": {
      "PGN": 61463,
      "PGN_Name": "Engine Knock Level #1",
      "PGN_Description": "KL1",
      "first_bit": 0,
      "SPN": 1352,
      "SPN_Name": "Engine Cylinder 1 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 1. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6398 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1353": {
      "PGN": 61463,
      "PGN_Name": "Engine Knock Level #1",
      "PGN_Description": "KL1",
      "first_bit": 8,
      "SPN": 1353,
      "SPN_Name": "Engine Cylinder 2 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 2. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6402 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1354": {
      "PGN": 61463,
      "PGN_Name": "Engine Knock Level #1",
      "PGN_Description": "KL1",
      "first_bit": 16,
      "SPN": 1354,
      "SPN_Name": "Engine Cylinder 3 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 3. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6406 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1355": {
      "PGN": 61463,
      "PGN_Name": "Engine Knock Level #1",
      "PGN_Description": "KL1",
      "first_bit": 24,
      "SPN": 1355,
      "SPN_Name": "Engine Cylinder 4 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 4. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6410 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1356": {
      "PGN": 61463,
      "PGN_Name": "Engine Knock Level #1",
      "PGN_Description": "KL1",
      "first_bit": 32,
      "SPN": 1356,
      "SPN_Name": "Engine Cylinder 5 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 5. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6414 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1357": {
      "PGN": 61463,
      "PGN_Name": "Engine Knock Level #1",
      "PGN_Description": "KL1",
      "first_bit": 40,
      "SPN": 1357,
      "SPN_Name": "Engine Cylinder 6 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 6. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6418 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1358": {
      "PGN": 61463,
      "PGN_Name": "Engine Knock Level #1",
      "PGN_Description": "KL1",
      "first_bit": 48,
      "SPN": 1358,
      "SPN_Name": "Engine Cylinder 7 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 7. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6422 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1359": {
      "PGN": 61463,
      "PGN_Name": "Engine Knock Level #1",
      "PGN_Description": "KL1",
      "first_bit": 56,
      "SPN": 1359,
      "SPN_Name": "Engine Cylinder 8 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 8. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6426 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1360": {
      "PGN": 61464,
      "PGN_Name": "Engine Knock Level #2",
      "PGN_Description": "KL2",
      "first_bit": 0,
      "SPN": 1360,
      "SPN_Name": "Engine Cylinder 9 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 9. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6430 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1361": {
      "PGN": 61464,
      "PGN_Name": "Engine Knock Level #2",
      "PGN_Description": "KL2",
      "first_bit": 8,
      "SPN": 1361,
      "SPN_Name": "Engine Cylinder 10 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 10. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6434 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1362": {
      "PGN": 61464,
      "PGN_Name": "Engine Knock Level #2",
      "PGN_Description": "KL2",
      "first_bit": 16,
      "SPN": 1362,
      "SPN_Name": "Engine Cylinder 11 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 11. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6438 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1363": {
      "PGN": 61464,
      "PGN_Name": "Engine Knock Level #2",
      "PGN_Description": "KL2",
      "first_bit": 24,
      "SPN": 1363,
      "SPN_Name": "Engine Cylinder 12 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 12. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6442 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1364": {
      "PGN": 61464,
      "PGN_Name": "Engine Knock Level #2",
      "PGN_Description": "KL2",
      "first_bit": 32,
      "SPN": 1364,
      "SPN_Name": "Engine Cylinder 13 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 13. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6446 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1365": {
      "PGN": 61464,
      "PGN_Name": "Engine Knock Level #2",
      "PGN_Description": "KL2",
      "first_bit": 40,
      "SPN": 1365,
      "SPN_Name": "Engine Cylinder 14 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 14. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6450 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1366": {
      "PGN": 61464,
      "PGN_Name": "Engine Knock Level #2",
      "PGN_Description": "KL2",
      "first_bit": 48,
      "SPN": 1366,
      "SPN_Name": "Engine Cylinder 15 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 15. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6454 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1367": {
      "PGN": 61464,
      "PGN_Name": "Engine Knock Level #2",
      "PGN_Description": "KL2",
      "first_bit": 56,
      "SPN": 1367,
      "SPN_Name": "Engine Cylinder 16 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 16. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6458 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1368": {
      "PGN": 61465,
      "PGN_Name": "Engine Knock Level #3",
      "PGN_Description": "KL3",
      "first_bit": 0,
      "SPN": 1368,
      "SPN_Name": "Engine Cylinder 17 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 17. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6462 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1369": {
      "PGN": 61465,
      "PGN_Name": "Engine Knock Level #3",
      "PGN_Description": "KL3",
      "first_bit": 8,
      "SPN": 1369,
      "SPN_Name": "Engine Cylinder 18 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 18. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6466 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1370": {
      "PGN": 61465,
      "PGN_Name": "Engine Knock Level #3",
      "PGN_Description": "KL3",
      "first_bit": 16,
      "SPN": 1370,
      "SPN_Name": "Engine Cylinder 19 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 19. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6470 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1371": {
      "PGN": 61465,
      "PGN_Name": "Engine Knock Level #3",
      "PGN_Description": "KL3",
      "first_bit": 24,
      "SPN": 1371,
      "SPN_Name": "Engine Cylinder 20 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 20. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nUse SPN 6474 if knock level information is time critical or needs to be combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1372": {
      "PGN": 61465,
      "PGN_Name": "Engine Knock Level #3",
      "PGN_Description": "KL3",
      "first_bit": 32,
      "SPN": 1372,
      "SPN_Name": "Engine Cylinder 21 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 21. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1373": {
      "PGN": 61465,
      "PGN_Name": "Engine Knock Level #3",
      "PGN_Description": "KL3",
      "first_bit": 40,
      "SPN": 1373,
      "SPN_Name": "Engine Cylinder 22 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 22. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1374": {
      "PGN": 61465,
      "PGN_Name": "Engine Knock Level #3",
      "PGN_Description": "KL3",
      "first_bit": 48,
      "SPN": 1374,
      "SPN_Name": "Engine Cylinder 23 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 23. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1375": {
      "PGN": 61465,
      "PGN_Name": "Engine Knock Level #3",
      "PGN_Description": "KL3",
      "first_bit": 56,
      "SPN": 1375,
      "SPN_Name": "Engine Cylinder 24 Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 24. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1377": {
      "PGN": 64971,
      "PGN_Name": "Off-Highway Engine Control Selection",
      "PGN_Description": "OHECS",
      "first_bit": 2,
      "SPN": 1377,
      "SPN_Name": "Engine Synchronization Switch",
      "SPN_Description": "This is the On/Off operation of the Multiple Unit Synchronization functionality. When it is enabled (i.e. On) the master engine will synchronize one or more slave engines to operate at the same speed. This switch position indicates whether this feature is disabled (off) or enabled (on). \r\n\r\n\r\n00 Functionality is disabled (off)\r\n01 Functionality is enabled (on)\r\n10 Error\r\n11 Not available or Unused",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1379": {
      "PGN": 65166,
      "PGN_Name": "Service 2",
      "PGN_Description": "S2",
      "first_bit": 0,
      "SPN": 1379,
      "SPN_Name": "Service Component Identification",
      "SPN_Description": "Identification of component needing service.  See Table SPN911_A.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "ID",
      "SLOT_ID": 25
    },
    "1380": {
      "PGN": 65130,
      "PGN_Name": "Engine Fuel/Lube Systems",
      "PGN_Description": "EFS",
      "first_bit": 0,
      "SPN": 1380,
      "SPN_Name": "Engine Oil Level Remote Reservoir",
      "SPN_Description": "Ratio of current volume of engine oil in a remote reservoir to the maximum required volume.  If a single switch (on/off) is used, 20% and 100% respectively will be used where 100% means no oil needs to be added and 20% means oil needs to be added.  If two switches are used, 20%, 50%, and 100% will be used where 20% indicates the oil is critically low, 50% indicates the oil level is low, and 100% means no oil needs to be added.  For continuous sensors, the actual measured percent will be used.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1381": {
      "PGN": 65130,
      "PGN_Name": "Engine Fuel/Lube Systems",
      "PGN_Description": "EFS",
      "first_bit": 8,
      "SPN": 1381,
      "SPN_Name": "Engine Fuel Supply Pump Intake Absolute Pressure",
      "SPN_Description": "Absolute pressure of fuel at the fuel supply pump intake.  See Figures SPN16_A & SPN16_B.  See SPN 7472 for alternate resolution.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "1382": {
      "PGN": 65130,
      "PGN_Name": "Engine Fuel/Lube Systems",
      "PGN_Description": "EFS",
      "first_bit": 16,
      "SPN": 1382,
      "SPN_Name": "Engine Fuel Filter (suction side) Differential Pressure",
      "SPN_Description": "Differential pressure measured across the fuel filter located between the fuel tank and the supply pump.  See Figures SPN16_A and SPN16_B.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "1387": {
      "PGN": 65164,
      "PGN_Name": "Auxiliary Analog Information",
      "PGN_Description": "AAI",
      "first_bit": 16,
      "SPN": 1387,
      "SPN_Name": "Auxiliary Pressure #1",
      "SPN_Description": "Pressure measured by auxiliary pressure sensor #1.  Not to be used in place of existing SPNs.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 49
    },
    "1388": {
      "PGN": 65164,
      "PGN_Name": "Auxiliary Analog Information",
      "PGN_Description": "AAI",
      "first_bit": 24,
      "SPN": 1388,
      "SPN_Name": "Auxiliary Pressure #2",
      "SPN_Description": "Pressure measured by auxiliary pressure sensor #2.  Not to be used in place of existing SPNs.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 49
    },
    "1389": {
      "PGN": 65202,
      "PGN_Name": "Fuel Information 1 (Gaseous)",
      "PGN_Description": "GFI1",
      "first_bit": 48,
      "SPN": 1389,
      "SPN_Name": "Engine Fuel Specific Gravity",
      "SPN_Description": "This parameter conveys the specific gravity of the gaseous fuel being used by the engine.  The specific gravity of the fuel can then be used to compute the density of the fuel.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": null,
      "SLOT_ID": 82
    },
    "1390": {
      "PGN": 65163,
      "PGN_Name": "Gaseous Fuel Pressure 1",
      "PGN_Description": "GFP1",
      "first_bit": 0,
      "SPN": 1390,
      "SPN_Name": "Engine Fuel Valve 1 Intake Absolute Pressure",
      "SPN_Description": "The absolute pressure of gas on the intake side of the first system control valve.  See SPN 3466 for Engine Fuel Valve 2, 7505 for Engine Fuel Valve 3 & 7506 for Engine Fuel Valve 4.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "1391": {
      "PGN": 65163,
      "PGN_Name": "Gaseous Fuel Pressure 1",
      "PGN_Description": "GFP1",
      "first_bit": 16,
      "SPN": 1391,
      "SPN_Name": "Engine Fuel Valve 1 Differential Pressure",
      "SPN_Description": "The differential pressure between the intake and the outlet of the first or only gaseous fuel valve.\r\n\r\nSee SPN 8494 for alternate range and resolution.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "1392": {
      "PGN": 65163,
      "PGN_Name": "Gaseous Fuel Pressure 1",
      "PGN_Description": "GFP1",
      "first_bit": 32,
      "SPN": 1392,
      "SPN_Name": "Engine Air to Fuel Differential Pressure",
      "SPN_Description": "The differential pressure between the gaseous fuel and the air intake manifold.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "1393": {
      "PGN": 65160,
      "PGN_Name": "Ignition Transformer Secondary Output 1",
      "PGN_Description": "ISO1",
      "first_bit": 0,
      "SPN": 1393,
      "SPN_Name": "Engine Cylinder 1 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1394": {
      "PGN": 65160,
      "PGN_Name": "Ignition Transformer Secondary Output 1",
      "PGN_Description": "ISO1",
      "first_bit": 8,
      "SPN": 1394,
      "SPN_Name": "Engine Cylinder 2 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1395": {
      "PGN": 65160,
      "PGN_Name": "Ignition Transformer Secondary Output 1",
      "PGN_Description": "ISO1",
      "first_bit": 16,
      "SPN": 1395,
      "SPN_Name": "Engine Cylinder 3 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1396": {
      "PGN": 65160,
      "PGN_Name": "Ignition Transformer Secondary Output 1",
      "PGN_Description": "ISO1",
      "first_bit": 24,
      "SPN": 1396,
      "SPN_Name": "Engine Cylinder 4 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1397": {
      "PGN": 65160,
      "PGN_Name": "Ignition Transformer Secondary Output 1",
      "PGN_Description": "ISO1",
      "first_bit": 32,
      "SPN": 1397,
      "SPN_Name": "Engine Cylinder 5 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1398": {
      "PGN": 65160,
      "PGN_Name": "Ignition Transformer Secondary Output 1",
      "PGN_Description": "ISO1",
      "first_bit": 40,
      "SPN": 1398,
      "SPN_Name": "Engine Cylinder 6 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1399": {
      "PGN": 65160,
      "PGN_Name": "Ignition Transformer Secondary Output 1",
      "PGN_Description": "ISO1",
      "first_bit": 48,
      "SPN": 1399,
      "SPN_Name": "Engine Cylinder 7 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1400": {
      "PGN": 65160,
      "PGN_Name": "Ignition Transformer Secondary Output 1",
      "PGN_Description": "ISO1",
      "first_bit": 56,
      "SPN": 1400,
      "SPN_Name": "Engine Cylinder 8 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1401": {
      "PGN": 65161,
      "PGN_Name": "Ignition Transformer Secondary Output 2",
      "PGN_Description": "ISO2",
      "first_bit": 0,
      "SPN": 1401,
      "SPN_Name": "Engine Cylinder 9 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1402": {
      "PGN": 65161,
      "PGN_Name": "Ignition Transformer Secondary Output 2",
      "PGN_Description": "ISO2",
      "first_bit": 8,
      "SPN": 1402,
      "SPN_Name": "Engine Cylinder 10 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1403": {
      "PGN": 65161,
      "PGN_Name": "Ignition Transformer Secondary Output 2",
      "PGN_Description": "ISO2",
      "first_bit": 16,
      "SPN": 1403,
      "SPN_Name": "Engine Cylinder 11 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1404": {
      "PGN": 65161,
      "PGN_Name": "Ignition Transformer Secondary Output 2",
      "PGN_Description": "ISO2",
      "first_bit": 24,
      "SPN": 1404,
      "SPN_Name": "Engine Cylinder 12 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1405": {
      "PGN": 65161,
      "PGN_Name": "Ignition Transformer Secondary Output 2",
      "PGN_Description": "ISO2",
      "first_bit": 32,
      "SPN": 1405,
      "SPN_Name": "Engine Cylinder 13 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1406": {
      "PGN": 65161,
      "PGN_Name": "Ignition Transformer Secondary Output 2",
      "PGN_Description": "ISO2",
      "first_bit": 40,
      "SPN": 1406,
      "SPN_Name": "Engine Cylinder 14 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1407": {
      "PGN": 65161,
      "PGN_Name": "Ignition Transformer Secondary Output 2",
      "PGN_Description": "ISO2",
      "first_bit": 48,
      "SPN": 1407,
      "SPN_Name": "Engine Cylinder 15 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1408": {
      "PGN": 65161,
      "PGN_Name": "Ignition Transformer Secondary Output 2",
      "PGN_Description": "ISO2",
      "first_bit": 56,
      "SPN": 1408,
      "SPN_Name": "Engine Cylinder 16 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1409": {
      "PGN": 65162,
      "PGN_Name": "Ignition Transformer Secondary Output 3",
      "PGN_Description": "ISO3",
      "first_bit": 0,
      "SPN": 1409,
      "SPN_Name": "Engine Cylinder 17 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1410": {
      "PGN": 65162,
      "PGN_Name": "Ignition Transformer Secondary Output 3",
      "PGN_Description": "ISO3",
      "first_bit": 8,
      "SPN": 1410,
      "SPN_Name": "Engine Cylinder 18 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1411": {
      "PGN": 65162,
      "PGN_Name": "Ignition Transformer Secondary Output 3",
      "PGN_Description": "ISO3",
      "first_bit": 16,
      "SPN": 1411,
      "SPN_Name": "Engine Cylinder 19 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1412": {
      "PGN": 65162,
      "PGN_Name": "Ignition Transformer Secondary Output 3",
      "PGN_Description": "ISO3",
      "first_bit": 24,
      "SPN": 1412,
      "SPN_Name": "Engine Cylinder 20 Ignition Transformer Secondary Output",
      "SPN_Description": "This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1413": {
      "PGN": 65154,
      "PGN_Name": "Ignition Timing 1",
      "PGN_Description": "IT1",
      "first_bit": 0,
      "SPN": 1413,
      "SPN_Name": "Engine Cylinder 1 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1414": {
      "PGN": 65154,
      "PGN_Name": "Ignition Timing 1",
      "PGN_Description": "IT1",
      "first_bit": 16,
      "SPN": 1414,
      "SPN_Name": "Engine Cylinder 2 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1415": {
      "PGN": 65154,
      "PGN_Name": "Ignition Timing 1",
      "PGN_Description": "IT1",
      "first_bit": 32,
      "SPN": 1415,
      "SPN_Name": "Engine Cylinder 3 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1416": {
      "PGN": 65154,
      "PGN_Name": "Ignition Timing 1",
      "PGN_Description": "IT1",
      "first_bit": 48,
      "SPN": 1416,
      "SPN_Name": "Engine Cylinder 4 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1417": {
      "PGN": 65155,
      "PGN_Name": "Ignition Timing 2",
      "PGN_Description": "IT2",
      "first_bit": 0,
      "SPN": 1417,
      "SPN_Name": "Engine Cylinder 5 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1418": {
      "PGN": 65155,
      "PGN_Name": "Ignition Timing 2",
      "PGN_Description": "IT2",
      "first_bit": 16,
      "SPN": 1418,
      "SPN_Name": "Engine Cylinder 6 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1419": {
      "PGN": 65155,
      "PGN_Name": "Ignition Timing 2",
      "PGN_Description": "IT2",
      "first_bit": 32,
      "SPN": 1419,
      "SPN_Name": "Engine Cylinder 7 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1420": {
      "PGN": 65155,
      "PGN_Name": "Ignition Timing 2",
      "PGN_Description": "IT2",
      "first_bit": 48,
      "SPN": 1420,
      "SPN_Name": "Engine Cylinder 8 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1421": {
      "PGN": 65156,
      "PGN_Name": "Ignition Timing 3",
      "PGN_Description": "IT3",
      "first_bit": 0,
      "SPN": 1421,
      "SPN_Name": "Engine Cylinder 9 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1422": {
      "PGN": 65156,
      "PGN_Name": "Ignition Timing 3",
      "PGN_Description": "IT3",
      "first_bit": 16,
      "SPN": 1422,
      "SPN_Name": "Engine Cylinder 10 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1423": {
      "PGN": 65156,
      "PGN_Name": "Ignition Timing 3",
      "PGN_Description": "IT3",
      "first_bit": 32,
      "SPN": 1423,
      "SPN_Name": "Engine Cylinder 11 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1424": {
      "PGN": 65156,
      "PGN_Name": "Ignition Timing 3",
      "PGN_Description": "IT3",
      "first_bit": 48,
      "SPN": 1424,
      "SPN_Name": "Engine Cylinder 12 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1425": {
      "PGN": 65157,
      "PGN_Name": "Ignition Timing 4",
      "PGN_Description": "IT4",
      "first_bit": 0,
      "SPN": 1425,
      "SPN_Name": "Engine Cylinder 13 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1426": {
      "PGN": 65157,
      "PGN_Name": "Ignition Timing 4",
      "PGN_Description": "IT4",
      "first_bit": 16,
      "SPN": 1426,
      "SPN_Name": "Engine Cylinder 14 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1427": {
      "PGN": 65157,
      "PGN_Name": "Ignition Timing 4",
      "PGN_Description": "IT4",
      "first_bit": 32,
      "SPN": 1427,
      "SPN_Name": "Engine Cylinder 15 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1428": {
      "PGN": 65157,
      "PGN_Name": "Ignition Timing 4",
      "PGN_Description": "IT4",
      "first_bit": 48,
      "SPN": 1428,
      "SPN_Name": "Engine Cylinder 16 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1429": {
      "PGN": 65158,
      "PGN_Name": "Ignition Timing 5",
      "PGN_Description": "IT5",
      "first_bit": 0,
      "SPN": 1429,
      "SPN_Name": "Engine Cylinder 17 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1430": {
      "PGN": 65158,
      "PGN_Name": "Ignition Timing 5",
      "PGN_Description": "IT5",
      "first_bit": 16,
      "SPN": 1430,
      "SPN_Name": "Engine Cylinder 18 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1431": {
      "PGN": 65158,
      "PGN_Name": "Ignition Timing 5",
      "PGN_Description": "IT5",
      "first_bit": 32,
      "SPN": 1431,
      "SPN_Name": "Engine Cylinder 19 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1432": {
      "PGN": 65158,
      "PGN_Name": "Ignition Timing 5",
      "PGN_Description": "IT5",
      "first_bit": 48,
      "SPN": 1432,
      "SPN_Name": "Engine Cylinder 20 Ignition Timing",
      "SPN_Description": "The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1433": {
      "PGN": 65159,
      "PGN_Name": "Ignition Timing 6",
      "PGN_Description": "IT6",
      "first_bit": 0,
      "SPN": 1433,
      "SPN_Name": "Engine Desired Ignition Timing 1",
      "SPN_Description": "A programmable timing value specific to the engine’s application. Factors affecting this value include both fuel type and the nature of the load being driven. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1434": {
      "PGN": 65159,
      "PGN_Name": "Ignition Timing 6",
      "PGN_Description": "IT6",
      "first_bit": 16,
      "SPN": 1434,
      "SPN_Name": "Engine Desired Ignition Timing 2",
      "SPN_Description": "A programmable timing value specific to the engine’s application. Factors affecting this value include both fuel type and the nature of the load being driven. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1435": {
      "PGN": 65159,
      "PGN_Name": "Ignition Timing 6",
      "PGN_Description": "IT6",
      "first_bit": 32,
      "SPN": 1435,
      "SPN_Name": "Engine Desired Ignition Timing 3",
      "SPN_Description": "A programmable timing value specific to the engine’s application. Factors affecting this value include both fuel type and the nature of the load being driven. Positive values indicate an increasingly advanced timing from TDC.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1436": {
      "PGN": 65159,
      "PGN_Name": "Ignition Timing 6",
      "PGN_Description": "IT6",
      "first_bit": 48,
      "SPN": 1436,
      "SPN_Name": "Engine Actual Ignition Timing",
      "SPN_Description": "The actual ignition timing at the current engine conditions. This parameter may or may not be equal to one of the desired timing parameters (see SPNs 1433-1435), depending on the status of the engine. Positive values indicate an increasingly advanced timing from TDC. See SPN 7355 for commanded ignition timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "1437": {
      "PGN": 61443,
      "PGN_Name": "Electronic Engine Controller 2",
      "PGN_Description": "EEC2",
      "first_bit": 4,
      "SPN": 1437,
      "SPN_Name": "Road Speed Limit Status",
      "SPN_Description": "Status (active or not active) of the system used to limit maximum vehicle velocity.\r\n\r\n00 - Active\r\n01 - Not Active\r\n10 - Error\r\n11 - Not available\r\n\r\nNOTE - While somewhat inconsistent with other J1939 status parameters, the states defining 00 = active and 01 = inactive for Road Speed Limit Status are NOT typographical errors, and should be implemented as stated.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1438": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 44,
      "SPN": 1438,
      "SPN_Name": "ABS/EBS Amber Warning Signal (Powered Vehicle)",
      "SPN_Description": "This parameter commands the ABS/EBS amber/yellow optical warning signal\r\n\r\n00 Off\r\n01 On\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1439": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 42,
      "SPN": 1439,
      "SPN_Name": "EBS Red Warning Signal",
      "SPN_Description": "This parameter commands the EBS red optical warning signal\r\n\r\n00 Off\r\n01 On\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1440": {
      "PGN": 65153,
      "PGN_Name": "Fuel Information 2 (Gaseous)",
      "PGN_Description": "GFI2",
      "first_bit": 0,
      "SPN": 1440,
      "SPN_Name": "Engine Fuel Flow Rate 1",
      "SPN_Description": "The rate at which the fuel is flowing through a fuel valve.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "m³/h",
      "SLOT_ID": 19
    },
    "1441": {
      "PGN": 65153,
      "PGN_Name": "Fuel Information 2 (Gaseous)",
      "PGN_Description": "GFI2",
      "first_bit": 16,
      "SPN": 1441,
      "SPN_Name": "Engine Fuel Flow Rate 2",
      "SPN_Description": "The rate at which the fuel is flowing through a fuel valve.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "m³/h",
      "SLOT_ID": 19
    },
    "1442": {
      "PGN": 65153,
      "PGN_Name": "Fuel Information 2 (Gaseous)",
      "PGN_Description": "GFI2",
      "first_bit": 32,
      "SPN": 1442,
      "SPN_Name": "Engine Fuel Valve 1 Position",
      "SPN_Description": "The position of a gaseous fuel valve that is metering the fuel flow to the engine.  0% indicates no fuel flow through valve and 100% means maximum fuel flow through valve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1443": {
      "PGN": 65153,
      "PGN_Name": "Fuel Information 2 (Gaseous)",
      "PGN_Description": "GFI2",
      "first_bit": 40,
      "SPN": 1443,
      "SPN_Name": "Engine Fuel Valve 2 Position",
      "SPN_Description": "The position of a gaseous fuel valve that is metering the fuel flow to the engine.  0% indicates no fuel flow through valve and 100% means maximum fuel flow through valve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1444": {
      "PGN": 65147,
      "PGN_Name": "Combustion Time 1",
      "PGN_Description": "CT1",
      "first_bit": 0,
      "SPN": 1444,
      "SPN_Name": "Engine Cylinder #1 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1445": {
      "PGN": 65147,
      "PGN_Name": "Combustion Time 1",
      "PGN_Description": "CT1",
      "first_bit": 16,
      "SPN": 1445,
      "SPN_Name": "Engine Cylinder #2 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1446": {
      "PGN": 65147,
      "PGN_Name": "Combustion Time 1",
      "PGN_Description": "CT1",
      "first_bit": 32,
      "SPN": 1446,
      "SPN_Name": "Engine Cylinder #3 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1447": {
      "PGN": 65147,
      "PGN_Name": "Combustion Time 1",
      "PGN_Description": "CT1",
      "first_bit": 48,
      "SPN": 1447,
      "SPN_Name": "Engine Cylinder #4 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1448": {
      "PGN": 65148,
      "PGN_Name": "Combustion Time 2",
      "PGN_Description": "CT2",
      "first_bit": 0,
      "SPN": 1448,
      "SPN_Name": "Engine Cylinder #5 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1449": {
      "PGN": 65148,
      "PGN_Name": "Combustion Time 2",
      "PGN_Description": "CT2",
      "first_bit": 16,
      "SPN": 1449,
      "SPN_Name": "Engine Cylinder #6 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1450": {
      "PGN": 65148,
      "PGN_Name": "Combustion Time 2",
      "PGN_Description": "CT2",
      "first_bit": 32,
      "SPN": 1450,
      "SPN_Name": "Engine Cylinder #7 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1451": {
      "PGN": 65148,
      "PGN_Name": "Combustion Time 2",
      "PGN_Description": "CT2",
      "first_bit": 48,
      "SPN": 1451,
      "SPN_Name": "Engine Cylinder #8 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1452": {
      "PGN": 65149,
      "PGN_Name": "Combustion Time 3",
      "PGN_Description": "CT3",
      "first_bit": 0,
      "SPN": 1452,
      "SPN_Name": "Engine Cylinder #9 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1453": {
      "PGN": 65149,
      "PGN_Name": "Combustion Time 3",
      "PGN_Description": "CT3",
      "first_bit": 16,
      "SPN": 1453,
      "SPN_Name": "Engine Cylinder #10 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1454": {
      "PGN": 65149,
      "PGN_Name": "Combustion Time 3",
      "PGN_Description": "CT3",
      "first_bit": 32,
      "SPN": 1454,
      "SPN_Name": "Engine Cylinder #11 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1455": {
      "PGN": 65149,
      "PGN_Name": "Combustion Time 3",
      "PGN_Description": "CT3",
      "first_bit": 48,
      "SPN": 1455,
      "SPN_Name": "Engine Cylinder #12 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1456": {
      "PGN": 65150,
      "PGN_Name": "Combustion Time 4",
      "PGN_Description": "CT4",
      "first_bit": 0,
      "SPN": 1456,
      "SPN_Name": "Engine Cylinder #13 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1457": {
      "PGN": 65150,
      "PGN_Name": "Combustion Time 4",
      "PGN_Description": "CT4",
      "first_bit": 16,
      "SPN": 1457,
      "SPN_Name": "Engine Cylinder #14 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1458": {
      "PGN": 65150,
      "PGN_Name": "Combustion Time 4",
      "PGN_Description": "CT4",
      "first_bit": 32,
      "SPN": 1458,
      "SPN_Name": "Engine Cylinder #15 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1459": {
      "PGN": 65150,
      "PGN_Name": "Combustion Time 4",
      "PGN_Description": "CT4",
      "first_bit": 48,
      "SPN": 1459,
      "SPN_Name": "Engine Cylinder #16 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1460": {
      "PGN": 65151,
      "PGN_Name": "Combustion Time 5",
      "PGN_Description": "CT5",
      "first_bit": 0,
      "SPN": 1460,
      "SPN_Name": "Engine Cylinder #17 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1461": {
      "PGN": 65151,
      "PGN_Name": "Combustion Time 5",
      "PGN_Description": "CT5",
      "first_bit": 16,
      "SPN": 1461,
      "SPN_Name": "Engine Cylinder #18 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1462": {
      "PGN": 65151,
      "PGN_Name": "Combustion Time 5",
      "PGN_Description": "CT5",
      "first_bit": 32,
      "SPN": 1462,
      "SPN_Name": "Engine Cylinder #19 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1463": {
      "PGN": 65151,
      "PGN_Name": "Combustion Time 5",
      "PGN_Description": "CT5",
      "first_bit": 48,
      "SPN": 1463,
      "SPN_Name": "Engine Cylinder #20 Combustion Time",
      "SPN_Description": "The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1464": {
      "PGN": 65152,
      "PGN_Name": "Combustion Time 6",
      "PGN_Description": "CT6",
      "first_bit": 0,
      "SPN": 1464,
      "SPN_Name": "Engine Desired Combustion Time",
      "SPN_Description": "The desired combustion time based upon engine load and speed lookup maps.",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1465": {
      "PGN": 65152,
      "PGN_Name": "Combustion Time 6",
      "PGN_Description": "CT6",
      "first_bit": 16,
      "SPN": 1465,
      "SPN_Name": "Engine Average Combustion Time",
      "SPN_Description": "The average combustion time of all cylinders of an engine.",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 57
    },
    "1466": {
      "PGN": 65144,
      "PGN_Name": "Tire Pressure Control Unit Mode and Status",
      "PGN_Description": "TP1",
      "first_bit": 8,
      "SPN": 1466,
      "SPN_Name": "Steer Channel Mode",
      "SPN_Description": "Indicates the functional mode of steer channel of the tire pressure control system. \r\n\r\n0000 Maintain\r\n0001 Inflate\r\n0010 Deflate\r\n0011 Confirm\r\n0100 Inflate Wait – System will inflate when conditions allow\r\n0101 Deflate Wait – System will deflate when conditions allow\r\n0110 Pressure Check\r\n0111-1101 Reserved\r\n1110 Error Condition\r\n1111 Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1467": {
      "PGN": 65144,
      "PGN_Name": "Tire Pressure Control Unit Mode and Status",
      "PGN_Description": "TP1",
      "first_bit": 16,
      "SPN": 1467,
      "SPN_Name": "Trailer/tag Channel Mode",
      "SPN_Description": "Indicates the functional mode of trailer/tag channel of the tire pressure control system.\r\n\r\n0000 Maintain\r\n0001 Inflate\r\n0010 Deflate\r\n0011 Confirm\r\n0100 Inflate Wait – System will inflate when conditions allow\r\n0101 Deflate Wait – System will deflate when conditions allow\r\n0110 Pressure Check\r\n0111-1101 Reserved\r\n1110 Error Condition\r\n1111 Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1468": {
      "PGN": 65144,
      "PGN_Name": "Tire Pressure Control Unit Mode and Status",
      "PGN_Description": "TP1",
      "first_bit": 20,
      "SPN": 1468,
      "SPN_Name": "Drive Channel Mode",
      "SPN_Description": "Indicates the functional mode of trailer/tag channel of the tire pressure control system.  \r\n\r\n0000 Maintain\r\n0001 Inflate\r\n0010 Deflate\r\n0011 Confirm\r\n0100 Inflate Wait – System will inflate when conditions allow\r\n0101 Deflate Wait – System will deflate when conditions allow\r\n0110 Pressure Check\r\n0111-1101 Reserved\r\n1110 Error Condition\r\n1111 Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1469": {
      "PGN": 65144,
      "PGN_Name": "Tire Pressure Control Unit Mode and Status",
      "PGN_Description": "TP1",
      "first_bit": 24,
      "SPN": 1469,
      "SPN_Name": "PCU Drive Solenoid Status",
      "SPN_Description": "Current state of the drive solenoid used to implement a tire pressure control system in its pneumatic control unit (PCU).\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1470": {
      "PGN": 65144,
      "PGN_Name": "Tire Pressure Control Unit Mode and Status",
      "PGN_Description": "TP1",
      "first_bit": 26,
      "SPN": 1470,
      "SPN_Name": "PCU Steer Solenoid Status",
      "SPN_Description": "Current state of the steer solenoid used to implement a tire pressure control system in its pneumatic control unit (PCU).\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1471": {
      "PGN": 65144,
      "PGN_Name": "Tire Pressure Control Unit Mode and Status",
      "PGN_Description": "TP1",
      "first_bit": 28,
      "SPN": 1471,
      "SPN_Name": "Tire Pressure Supply Switch Status",
      "SPN_Description": "Current state of an open/closed type switch used to determine if adequate pressure exists for system implementation.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1472": {
      "PGN": 65144,
      "PGN_Name": "Tire Pressure Control Unit Mode and Status",
      "PGN_Description": "TP1",
      "first_bit": 32,
      "SPN": 1472,
      "SPN_Name": "PCU Deflate Solenoid Status",
      "SPN_Description": "Current state of the deflate solenoid used to implement a tire pressure control system in its pneumatic control unit (PCU).\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1473": {
      "PGN": 65144,
      "PGN_Name": "Tire Pressure Control Unit Mode and Status",
      "PGN_Description": "TP1",
      "first_bit": 34,
      "SPN": 1473,
      "SPN_Name": "PCU Control Solenoid Status",
      "SPN_Description": "Current state of the control solenoid used to implement a tire pressure control system in its pneumatic control unit (PCU).\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1474": {
      "PGN": 65144,
      "PGN_Name": "Tire Pressure Control Unit Mode and Status",
      "PGN_Description": "TP1",
      "first_bit": 36,
      "SPN": 1474,
      "SPN_Name": "PCU Supply Solenoid Status",
      "SPN_Description": "Current state of the supply solenoid used to implement a tire pressure control system in its pneumatic control unit (PCU).\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1475": {
      "PGN": 65144,
      "PGN_Name": "Tire Pressure Control Unit Mode and Status",
      "PGN_Description": "TP1",
      "first_bit": 38,
      "SPN": 1475,
      "SPN_Name": "PCU Trailer, Tag or Push Solenoid Status",
      "SPN_Description": "Current state of the trailer, tag, or push solenoid used to implement a tire pressure control system in its pneumatic control unit (PCU).\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1480": {
      "PGN": 61440,
      "PGN_Name": "Electronic Retarder Controller 1",
      "PGN_Description": "ERC1",
      "first_bit": 32,
      "SPN": 1480,
      "SPN_Name": "Source Address of Controlling Device for Retarder Control",
      "SPN_Description": "The source address of the SAE J1939 device currently controlling the retarder.  It is used to expand the torque mode parameter (see SPN 899) in cases where control is in response to an ECU that is not listed in Table SPN899_A.  Its value may be the source address of the ECU transmitting the message (which means that no external SAE J1939 message is providing the active command) or the source address of the SAE J1939 ECU that is currently providing the active command in a TSC1 (see PGN 0) or similar message.  Note that if this parameter value is the same as the source address of the device transmitting it, the control may be due to a message on a non-SAE J1939 data link such as SAE J1922 or a proprietary link.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "SA",
      "SLOT_ID": 35
    },
    "1481": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 48,
      "SPN": 1481,
      "SPN_Name": "Source Address of Controlling Device for Brake Control",
      "SPN_Description": "The source address of the SAE J1939 device currently controlling the brake system. Its value may be the source address of the ECU transmitting the message (which means that no external SAE J1939 message is providing the active command) or the source address of the SAE J1939 ECU that is currently providing the active command in a TSC1 (see PGN 0) or similar message.  Note that if this parameter value is the same as the source address of the device transmitting it, the control may be due to a message on a non-SAE J1939 data link such as SAE J1922 or a proprietary link.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "SA",
      "SLOT_ID": 35
    },
    "1482": {
      "PGN": 61442,
      "PGN_Name": "Electronic Transmission Controller 1",
      "PGN_Description": "ETC1",
      "first_bit": 56,
      "SPN": 1482,
      "SPN_Name": "Source Address of Controlling Device for Transmission Control",
      "SPN_Description": "The source address of the SAE J1939 device currently controlling the transmission. Its value may be the source address of the ECU transmitting the message (which means that no external SAE J1939 message is providing the active command) or the source address of the SAE J1939 ECU that is currently providing the active command in a TSC1 (see PGN 0) or similar message.  Note that if this parameter value is the same as the source address of the device transmitting it, the control may be due to a message on a non-SAE J1939 data link such as SAE J1922 or a proprietary link.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "SA",
      "SLOT_ID": 35
    },
    "1483": {
      "PGN": 61444,
      "PGN_Name": "Electronic Engine Controller 1",
      "PGN_Description": "EEC1",
      "first_bit": 40,
      "SPN": 1483,
      "SPN_Name": "Source Address of Controlling Device for Engine Control",
      "SPN_Description": "The source address of the SAE J1939 device currently controlling the engine.  It is used to expand the torque mode parameter (see SPN 899) in cases where control is in response to an ECU that is not listed in Table SPN899_A.  Its value may be the source address of the ECU transmitting the message (which means that no external SAE J1939 message is providing the active command) or the source address of the SAE J1939 ECU that is currently providing the active command in a TSC1 (see PGN 0) or similar message.  Note that if this parameter value is the same as the source address of the device transmitting it, the control may be due to a message on a non-J1939 data link such as SAE J1922 or a proprietary link.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "SA",
      "SLOT_ID": 35
    },
    "1487": {
      "PGN": 53248,
      "PGN_Name": "Cab Illumination Message",
      "PGN_Description": "CL",
      "first_bit": 0,
      "SPN": 1487,
      "SPN_Name": "Illumination Brightness Percent",
      "SPN_Description": "Commanded backlight brightness level for all cab displays.  \r\n\r\nNote:  If a separate device is used to independently control the switch backlight brightness level, see SPN 5532.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1503": {
      "PGN": 64745,
      "PGN_Name": "Armrest Switch Matrix Commands",
      "PGN_Description": "ARMSWIMC",
      "first_bit": 0,
      "SPN": 1503,
      "SPN_Name": "Armrest 1 Switch 1",
      "SPN_Description": "Status of the first switch located in armrest 1.\r\n\r\n00: Off\r\n01: On\r\n10: Reserved\r\n11: Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1550": {
      "PGN": 64817,
      "PGN_Name": "Fan Drive #2",
      "PGN_Description": "FD2",
      "first_bit": 0,
      "SPN": 1550,
      "SPN_Name": "Estimated Percent Fan 2 Speed",
      "SPN_Description": "Estimated fan speed as a ratio of the fan drive (current speed) to the fully engaged fan drive (maximum fan speed).  A two state fan (off/on) will use 0% and 100% respectively.  A three state fan (off/intermediate/on) will use 0%, 50% and 100% respectively.  A variable speed fan will use 0% to 100%. Multiple fan systems will use 0 to 100% to indicate the percent cooling capacity being provided.\r\n\r\nNote that the intermediate fan speed of a three state fan will vary with different fan drives, therefore 50% is being used to indicate that the intermediate speed is required from the fan drive.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1557": {
      "PGN": 64817,
      "PGN_Name": "Fan Drive #2",
      "PGN_Description": "FD2",
      "first_bit": 8,
      "SPN": 1557,
      "SPN_Name": "Fan 2 Drive State",
      "SPN_Description": "This parameter is used to indicate the current state or mode of operation by the second fan drive.\r\n\r\n0000 Fan off\r\n0001 Engine system–General\r\n0010 Excessive engine air temperature\r\n0011 Excessive engine oil temperature\r\n0100 Excessive engine coolant temperature\r\n0101 Excessive transmission oil temperature\r\n0110 Excessive hydraulic oil temperature\r\n0111 Default Operation\r\n1000 Reverse Operation\r\n1001 Manual control\r\n1010 Transmission retarder\r\n1011 A/C system\r\n1100 Timer\r\n1101 Engine brake\r\n1110 Other\r\n1111 Not available\r\n\r\nFan off  0000b —Used to indicate that the fan clutch is disengaged and the fan is inactive\r\n\r\nEngine system–General  0001b —Used to indicate that the fan is active due to an engine system not otherwise defined.\r\n\r\nExcessive engine air temperature  0010b —Used to indicate that the fan is active due to high air temperature.\r\n\r\nExcessive engine oil temperature  0011b —Used to indicate that the fan is active due to high oil temperature.\r\n\r\nExcessive engine coolant temperature  0100b —Used to indicate that the fan is active due to high coolant temperature.\r\n\r\nReverse Operation  1000b — Used to indicate that the fan is in reverse direction of operation compared to the normal direction of operation \r\n\r\nManual control  1001b —Used to indicate that the fan is active as requested by the operator.\r\n\r\nTransmission retarder  1010b —Used to indicate that the fan is active as required by the transmission retarder.\r\n\r\nA/C system  1011b —Used to indicate that the fan is active as required by the air conditioning system.\r\n\r\nTimer  1100b —Used to indicate that the fan is active as required by a timing function.\r\n\r\nEngine brake  1101b —Used to indicate that the fan is active as required to assist engine braking.\r\n\r\nExcessive transmission oil temperature - 0101b  - Used to indicate fan is active due to excessive transmission oil temperature.\r\n\r\nExcessive hydraulic oil temperature - 0110b - Used to indicate fan is active due to excessive hydraulic oil temperature.\r\n\r\nDefault Operation - 0111b - Used to indicate fan is active due to a error condition resulting in default operation",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1568": {
      "PGN": 64967,
      "PGN_Name": "Off-Highway Engine Control Selection States",
      "PGN_Description": "OHCSS",
      "first_bit": 32,
      "SPN": 1568,
      "SPN_Name": "Engine Torque Curve Selection",
      "SPN_Description": "This parameter will report the selected torque curve, as indicated by SPN 6796.\r\n\r\n0 - Indicates that the engine is using a torque that is not presently selected by SPN 6796\r\n1 - Indicates that Torque Curve 1 is selected\r\n2 - Indicates that Torque Curve 2 is selected\r\n3 to 13 - Indicates that Torque Curve 3 through 13 is selected\r\n14 - Error\r\n15 - Not supported",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1573": {
      "PGN": 65142,
      "PGN_Name": "Laser Leveling System Vertical Position Display Data",
      "PGN_Description": "LVDD",
      "first_bit": 0,
      "SPN": 1573,
      "SPN_Name": "LED Display Data #1",
      "SPN_Description": "Informs display devices how to display the current vertical position.\r\n\r\nValues which are less than 128 decimal are bit-mapped values and any combination of these values is considered a valid value.  For example communicating the \"High Fine LED on\" value to the display would result in the High Fine LED being turned on.  Communicating a value with the \"High Fine LED on\" bit set to \"1\" and the \"On-Grade LED on\" bit set to \"1\" should result in the display turning on the High Fine LED AND the On-Grade LED.  \r\n\r\nValues 128 decimal and above are discrete states.  Any bit-mapped combination of these states are invalid unless the results correspond to one of the states defined.  For example, the result of adding the \"Low Coarse\" and \"Low Medium\" states results in the \"Low Medium\" state, which is valid.  However, adding the \"Low Medium\" and the \"Low Fine\" states results in an value which does not have a defined state and is invalid.\r\n\r\n00000010 High Coarse LED on\r\n00000100 High Fine LED on\r\n00001000 On-grade LED on\r\n00010000 Low Fine LED on\r\n00100000 Low Coarse LED on\r\n\r\n10000000 Low Coarse\r\n10000001 Low Medium/Coarse\r\n10000010 Low Medium\r\n10000011 Low Medium/Fine\r\n10000100 Low Fine\r\n10010000 On Grade\r\n10010001 High Fine\r\n10010010 High Medium/Fine\r\n10010011 High Medium\r\n10010100 High Medium/Coarse\r\n10010101 High Coarse\r\n10011111 No data (i.e. no laser strikes)\r\n11111110 Error\r\n11111111 Not Available\r\n\r\nUndefined values between 10100000 binary and 11111101 binary are reserved for future use.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "1574": {
      "PGN": 65141,
      "PGN_Name": "Laser Leveling System Vertical Deviation",
      "PGN_Description": "LVD",
      "first_bit": 0,
      "SPN": 1574,
      "SPN_Name": "Laser Strike Vertical Deviation",
      "SPN_Description": "The calculated distance from the laser strike position to the current land leveling system reference point.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3200,
      "unit": "mm",
      "SLOT_ID": 13
    },
    "1575": {
      "PGN": 65140,
      "PGN_Name": "Modify Leveling System Control Set Point",
      "PGN_Description": "LSP",
      "first_bit": 0,
      "SPN": 1575,
      "SPN_Name": "Modify Leveling System Set Point",
      "SPN_Description": "Used to control and coordinate the set point for the leveling system.\r\n\r\nOperating Range: -3200 to +3200 mm, negative values are below current position, positive values are above current position, zero is no change.\r\nParameter specific parameter:\r\n0xFE01 indicates Stop modifying the set point\r\n0xFE03 indicates Raise the current set point by 5 mm\r\n0xFE11 indicates Lower the current set point by 5 mm\r\n0xFE13 indicates Search for laser or target\r\n0xFE15 indicates go to the Park position\r\n0xFE17 indicates go to the Bench position",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3200,
      "unit": "mm",
      "SLOT_ID": 13
    },
    "1576": {
      "PGN": 65139,
      "PGN_Name": "Laser Receiver Mast Position",
      "PGN_Description": "LMP",
      "first_bit": 0,
      "SPN": 1576,
      "SPN_Name": "Mast Position",
      "SPN_Description": "Used to monitor the position of the sensor attached to the land leveling mast.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3200,
      "unit": "mm",
      "SLOT_ID": 13
    },
    "1577": {
      "PGN": 65138,
      "PGN_Name": "Laser Leveling System Blade Control",
      "PGN_Description": "LBC",
      "first_bit": 0,
      "SPN": 1577,
      "SPN_Name": "Blade Duration and Direction",
      "SPN_Description": "Used to indicate the duration and direction that the land leveling system blade moves.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3276.8,
      "unit": "s",
      "SLOT_ID": 10
    },
    "1578": {
      "PGN": 65138,
      "PGN_Name": "Laser Leveling System Blade Control",
      "PGN_Description": "LBC",
      "first_bit": 16,
      "SPN": 1578,
      "SPN_Name": "Blade Control Mode",
      "SPN_Description": "Allows the user to select the type of blade control for the land leveling system.  \r\n\r\n00000000 Manual mode\r\n00000001 Automatic mode\r\n00000010 Inactive automatic mode\r\nAll other values Reserved",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "1579": {
      "PGN": 65137,
      "PGN_Name": "Laser Tracer Position",
      "PGN_Description": "LTP",
      "first_bit": 0,
      "SPN": 1579,
      "SPN_Name": "Laser Tracer Target Deviation",
      "SPN_Description": "The calculated distance for the laser target to the current laser tracer reference point.\r\n\r\nParameter specific parameter: 0xFE03 indicates that the sensor can not sense the laser",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3200,
      "unit": "mm",
      "SLOT_ID": 13
    },
    "1580": {
      "PGN": 65137,
      "PGN_Name": "Laser Tracer Position",
      "PGN_Description": "LTP",
      "first_bit": 16,
      "SPN": 1580,
      "SPN_Name": "Laser Tracer Vertical Distance",
      "SPN_Description": "The elevation of the laser tracer sensor in a laser leveling system.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "mm",
      "SLOT_ID": 14
    },
    "1581": {
      "PGN": 65137,
      "PGN_Name": "Laser Tracer Position",
      "PGN_Description": "LTP",
      "first_bit": 32,
      "SPN": 1581,
      "SPN_Name": "Laser Tracer Horizontal Deviation",
      "SPN_Description": "The calculated percent deviation between the target distance and the center of the laser tracer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "1582": {
      "PGN": 65137,
      "PGN_Name": "Laser Tracer Position",
      "PGN_Description": "LTP",
      "first_bit": 40,
      "SPN": 1582,
      "SPN_Name": "LED Display Data #2",
      "SPN_Description": "Informs display devices how to display the current position of the laser tracer.\r\n\r\nValues which are less than 128 decimal are bit-mapped values and any combination of these values is considered a valid value.  For example communicating the \"Up LED on\" value to the display would result in the Up LED being turned on.  Communicating a value with the \"Up LED on\" bit set to \"1\" and thet \"On-Grade 'A' LED on\" bit set to \"1\" should result in the display turning on the Up LED AND the On-Grade \"A\" LED.  \r\n\r\nValues 128 decimal and above are discrete states.  Any bit-mapped combination of these states are invalid unless the results correspond to one of the states defined.  For example, the result of adding the \"Low Coarse\" and \"Low Medium\" states results in the \"Low Medium\" state, which is valid.  However, adding the \"Low Medium\" and the \"Low Fine\" states results in an value which does not have a defined state and is invalid.\r\n\r\n00000001 On-grade “A” LED on\r\n00000010 On-grade “B” LED on\r\n00000100 On-grade “C” LED on\r\n00001000 Up LED on\r\n00010000 Down LED on\r\n00100000 Left LED on\r\n01000000 Right LED on\r\n\r\n00000001 On-grade “A” LED on\r\n00000010 On-grade “B” LED on\r\n00000100 On-grade “C” LED on\r\n00001000 Up LED on\r\n00010000 Down LED on\r\n00100000 Left LED on\r\n01000000 Right LED on\r\n\r\n10000000 Low Coarse\r\n10000001 Low Medium/Coarse\r\n10000010 Low Medium\r\n10000011 Low Medium/Fine\r\n10000100 Low Fine\r\n10010000 On Grade\r\n10010001 High Fine\r\n10010010 High Medium/Fine\r\n10010011 High Medium\r\n10010100 High Medium/Coarse\r\n10010101 High Coarse\r\n10011111 No data (i.e. no laser strikes)\r\n11111110 Error\r\n11111111 Not Available\r\n\r\nUndefined values between 10100000 binary and 11111101 binary are reserved for future use.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "1583": {
      "PGN": 65137,
      "PGN_Name": "Laser Tracer Position",
      "PGN_Description": "LTP",
      "first_bit": 48,
      "SPN": 1583,
      "SPN_Name": "Laser Tracer Information",
      "SPN_Description": "Provides the status of the laser tracer to the operator. \r\n\r\n00000001 Laser power is on\r\n00000010 Laser is ready\r\n00000100 Valid target (1 = yes)\r\n00001000 Previous pass (1 = yes)\r\n00010000 Stringline (1 = yes)\r\n00100000 Curb (1 = yes)\r\nAll other values Reserved",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "1584": {
      "PGN": 56832,
      "PGN_Name": "Reset",
      "PGN_Description": "RESET",
      "first_bit": 8,
      "SPN": 1584,
      "SPN_Name": "Service Component Identification",
      "SPN_Description": "Identification of component needing service.  See Table SPN911_A.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "ID",
      "SLOT_ID": 25
    },
    "1585": {
      "PGN": 65136,
      "PGN_Name": "Combination Vehicle Weight",
      "PGN_Description": "CVW",
      "first_bit": 0,
      "SPN": 1585,
      "SPN_Name": "Powered Vehicle Weight",
      "SPN_Description": "Total mass imposed by the tires of the powered vehicle on the road surface.  Does not include the trailer.",
      "bit_length": 16,
      "scaling": 10,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 29
    },
    "1586": {
      "PGN": 65135,
      "PGN_Name": "Adaptive Cruise Control 1",
      "PGN_Description": "ACC1",
      "first_bit": 0,
      "SPN": 1586,
      "SPN_Name": "Speed of forward vehicle",
      "SPN_Description": "Absolute velocity of the preceding vehicle situated within 250 m in the same lane and moving in the same direction.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 73
    },
    "1587": {
      "PGN": 65135,
      "PGN_Name": "Adaptive Cruise Control 1",
      "PGN_Description": "ACC1",
      "first_bit": 8,
      "SPN": 1587,
      "SPN_Name": "Distance to forward vehicle",
      "SPN_Description": "Distance to the preceding vehicle situated within 250 m in the same lane and moving in the same direction.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "m",
      "SLOT_ID": 95
    },
    "1588": {
      "PGN": 65135,
      "PGN_Name": "Adaptive Cruise Control 1",
      "PGN_Description": "ACC1",
      "first_bit": 16,
      "SPN": 1588,
      "SPN_Name": "Adaptive Cruise Control Set Speed",
      "SPN_Description": "Value of the desired (chosen) velocity of the adaptive cruise control system.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 73
    },
    "1589": {
      "PGN": 65135,
      "PGN_Name": "Adaptive Cruise Control 1",
      "PGN_Description": "ACC1",
      "first_bit": 27,
      "SPN": 1589,
      "SPN_Name": "Adaptive cruise control set distance mode",
      "SPN_Description": "Selected distance mode for adaptive cruise control. \r\n\r\n000 ACC Distance mode #1 (largest distance)\r\n001 ACC Distance mode #2\r\n010 ACC Distance mode #3\r\n011 ACC Distance mode #4\r\n100 ACC Distance mode #5 (shortest distance)\r\n101 Conventional cruise control mode\r\n110 Error condition\r\n111 Not available/not valid",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "1590": {
      "PGN": 65135,
      "PGN_Name": "Adaptive Cruise Control 1",
      "PGN_Description": "ACC1",
      "first_bit": 24,
      "SPN": 1590,
      "SPN_Name": "Adaptive Cruise Control Mode",
      "SPN_Description": "This parameter is used to indicate the current state, or mode, of operation by the Adaptive Cruise Control (ACC) device. The states characterize independent system states (e.g., it is not possible to express distance control active and overtake mode simultaneously). ACC must not switch itself off while active because the driver expects it to work. So if an error occurs, the ACC must signal that to the driver so that the driver knows that he has to switch off the ACC.\r\n\r\n000 Off (Standby, enabled, ready for activation)\r\n001 Speed control active\r\n010 Distance control active\r\n011 Overtake mode\r\n100 Hold mode\r\n101 Finish mode\r\n110 Disabled or error condition\r\n111 Not available/not valid\r\n\r\n000b - Off—Used to indicate the ACC is enabled in calibration or configuration and there are no faults that would prevent the system from operating.\r\n001b - Speed Control Active—Used to indicate that ACC is on but not currently sending control messages.  In other words, there is no target ahead and regular vehicle cruise control is controlling the vehicle speed to the driver’s set speed.\r\n010b - Distance Control Active—Used to indicate that ACC is on and actively sending control messages to maintain the appropriate following interval.\r\n011b - Overtake Mode—Used to indicate that ACC is on but temporarily disabled because the driver is manually overriding cruise control by using either the accelerator pedal or the cruise control “accel” switch.\r\n100b - Hold Mode—Used to indicate that the ACC has lost the previous target vehicle and is in HOLD mode. In this mode, the ACC shall limit the speed to the speed held when the target was lost. For example,  if the driver activates the typical cruise buttons (Resume/Inc/Dec) the HOLD mode shall be exited and normal cruise functionality resumed. If a new target is detected, the Distance Control Active mode (010b) is again entered, unless existing conditions prohibit this.\r\n101b - Finish Mode—Used to indicate that ACC is on with no target ahead, and ACC is currently sending control messages to return to the driver’s set speed. This occurs when the target the ACC system was tracking moves out of the way so ACC returns the vehicle to the driver’s set speed.\r\n110b - Disabled or Error Condition—Used to indicate that ACC is in an error state and can not operate.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "1591": {
      "PGN": 65135,
      "PGN_Name": "Adaptive Cruise Control 1",
      "PGN_Description": "ACC1",
      "first_bit": 32,
      "SPN": 1591,
      "SPN_Name": "Road curvature",
      "SPN_Description": "Estimated value of the current road curvature for use by the adaptive cruise control system.  Positive values are used for left curves.  Curvature is the inverse of the radius and is zero for straight roads.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "1/km",
      "SLOT_ID": 96
    },
    "1592": {
      "PGN": 65134,
      "PGN_Name": "High Resolution Wheel Speed",
      "PGN_Description": "HRW",
      "first_bit": 0,
      "SPN": 1592,
      "SPN_Name": "Front Axle, Left Wheel Speed",
      "SPN_Description": "High resolution measurement of the speed of the left wheel on the front axle.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 71
    },
    "1593": {
      "PGN": 65134,
      "PGN_Name": "High Resolution Wheel Speed",
      "PGN_Description": "HRW",
      "first_bit": 16,
      "SPN": 1593,
      "SPN_Name": "Front axle, right wheel speed",
      "SPN_Description": "High resolution measurement of the speed of the right wheel on the front axle.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 71
    },
    "1594": {
      "PGN": 65134,
      "PGN_Name": "High Resolution Wheel Speed",
      "PGN_Description": "HRW",
      "first_bit": 32,
      "SPN": 1594,
      "SPN_Name": "Rear axle, left wheel speed",
      "SPN_Description": "High resolution measurement of the speed of the left wheel on the rear axle.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 71
    },
    "1595": {
      "PGN": 65134,
      "PGN_Name": "High Resolution Wheel Speed",
      "PGN_Description": "HRW",
      "first_bit": 48,
      "SPN": 1595,
      "SPN_Name": "Rear axle, right wheel speed",
      "SPN_Description": "High resolution measurement of the speed of the right wheel on the rear axle.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 71
    },
    "1598": {
      "PGN": 64817,
      "PGN_Name": "Fan Drive #2",
      "PGN_Description": "FD2",
      "first_bit": 16,
      "SPN": 1598,
      "SPN_Name": "Fan 2 Speed",
      "SPN_Description": "The speed of the second fan associated with engine coolant system.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "1600": {
      "PGN": 64737,
      "PGN_Name": "Fuel Economy 2 (Liquid)",
      "PGN_Description": "LFE2",
      "first_bit": 0,
      "SPN": 1600,
      "SPN_Name": "Engine Fuel Rate (High Resolution)",
      "SPN_Description": "Amount of fuel consumed by engine per unit of time.  \r\n\r\nNOTE - See SPN 183 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.001,
      "offset": 0,
      "unit": "l/h",
      "SLOT_ID": 321
    },
    "1601": {
      "PGN": 65254,
      "PGN_Name": "Time/Date",
      "PGN_Description": "TD",
      "first_bit": 48,
      "SPN": 1601,
      "SPN_Name": "Local minute offset",
      "SPN_Description": "The minute component of the offset between the UTC time and date and a local time zone time and date.  This is the number of minutes to add to UTC (Universal Time Coordinate) time and date to convert to the time and date in the local time zone .  The Local Offset is a positive value for time zones East of the Prime Meridian to the International Date Line.  The Local Offset is a negative value for time zones West of the Prime Meridian to the International Date Line.\r\nThe Local Minute Offset is only applicable when the Time and Date parameters are reported as UTC time and date.  Refer to SPN 1602 for details.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "min",
      "SLOT_ID": 99
    },
    "1602": {
      "PGN": 65254,
      "PGN_Name": "Time/Date",
      "PGN_Description": "TD",
      "first_bit": 56,
      "SPN": 1602,
      "SPN_Name": "Local hour offset",
      "SPN_Description": "The hour component of the offset between the UTC (Universal Time Coordinate) time and date and a local time zone time and date.  This is the number of hours to add to UTC, a.k.a. GMT, time and date to convert to the time and date in the local time zone.  This parameter indicates the time reference of the data reported in the Time and Date SPNs 959, 960. 961, 962, 963, and 964.  The Local Offset is a positive value for time zones East of the Prime Meridian to the International Date Line.  The Local Offset is a negative value for time zones West of the Prime Meridian to the International Date Line. \r\nThe Local Hour Offset is only applicable when the Time and Date parameters are reported as UTC time and date.  \r\n\r\nRecommended Settings:\r\n\r\nApplications should not use the $FF 'Not Available' if using the Time and Date parameters due to some ambiguity of the time standard for the reported time and date values.  The recommended settings for the Local Hour Offset settings are: \r\nIf reporting the Time and Date as Local time, then Local Hour Offset must be reported as $FA.\r\nIf reporting the Time and Date as UTC time and Local Hour Offset is not supported or not known, then Local Hour Offset must be reported as $F9.\r\nIf reporting the Time and Date as UTC time and Local Hour Offset is known, then Local Hour Offset must be reported as a value between $66 and $94.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "h",
      "SLOT_ID": 4
    },
    "1603": {
      "PGN": 54528,
      "PGN_Name": "Time/Date Adjust",
      "PGN_Description": "TDA",
      "first_bit": 0,
      "SPN": 1603,
      "SPN_Name": "Adjust seconds",
      "SPN_Description": "The seconds component for setting the current time of day.  This should be reported as the seconds component of the current time according to the time of day standard indicated with the Local Hour Offset parameter (SPN 1602).  The time of day should be reported as the current time at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the current time at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the time of day (SPNs 959, 960, and 961) is the current UTC time or a local time zone time.  Refer to SPN 1602 for details.",
      "bit_length": 8,
      "scaling": 0.25,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 63
    },
    "1604": {
      "PGN": 54528,
      "PGN_Name": "Time/Date Adjust",
      "PGN_Description": "TDA",
      "first_bit": 8,
      "SPN": 1604,
      "SPN_Name": "Adjust minutes",
      "SPN_Description": "The minutes component for setting the current time of day.  This should be reported as the minutes component of the current time according to the time of day standard indicated with the Local Hour Offset parameter (SPN 1602).  The time of day should be reported as the current time at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the current time at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the time of day (SPNs 959, 960, and 961) is the current UTC time or a local time zone time.  Refer to SPN 1602 for details.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "min",
      "SLOT_ID": 61
    },
    "1605": {
      "PGN": 54528,
      "PGN_Name": "Time/Date Adjust",
      "PGN_Description": "TDA",
      "first_bit": 16,
      "SPN": 1605,
      "SPN_Name": "Adjust hours",
      "SPN_Description": "The hours component for setting the current time of day.  This should be reported as the hours component of the current time according to the time of day standard indicated with the Local Hour Offset parameter (SPN 1602).  The time of day should be reported as the current time at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the current time at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the time of day (SPNs 959, 960, and 961) is the current UTC time or a local time zone time.  Refer to SPN 1602 for details.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 3
    },
    "1606": {
      "PGN": 54528,
      "PGN_Name": "Time/Date Adjust",
      "PGN_Description": "TDA",
      "first_bit": 24,
      "SPN": 1606,
      "SPN_Name": "Adjust month",
      "SPN_Description": "The month component for setting the current calendar date.  This should be reported as the month component of the current date according to the calendar date standard indicated with the Local Hour Offset parameter (SPN 1602).  The calendar date should be reported as the current date at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the current date at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the calendar date (SPNs 962, 963, and 964) is the current UTC date or a local time zone date.  Refer to SPN 1602 for details.\r\n\r\nNOTE - A value of 0 for the month is null.  The value 1 identifies January; 2 identifies February; etc.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "months",
      "SLOT_ID": 62
    },
    "1607": {
      "PGN": 54528,
      "PGN_Name": "Time/Date Adjust",
      "PGN_Description": "TDA",
      "first_bit": 32,
      "SPN": 1607,
      "SPN_Name": "Adjust day",
      "SPN_Description": "The day component for setting the current calendar date.  This should be reported as the day component of the current date according to the calendar date standard indicated with the Local Hour Offset parameter (SPN 1602).  The calendar date should be reported as the current date at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the current date at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the calendar date (SPNs 962, 963, and 964) is the current UTC date or a local time zone date.  Refer to SPN 1602 for details.\r\n\r\nNOTE - A value of 0 for the date is null.  The values 1, 2, 3, and 4 are used to identify the first day of the month; 5, 6, 7, and 8 identify the second day of the month; etc.",
      "bit_length": 8,
      "scaling": 0.25,
      "offset": 0,
      "unit": "days",
      "SLOT_ID": 60
    },
    "1608": {
      "PGN": 54528,
      "PGN_Name": "Time/Date Adjust",
      "PGN_Description": "TDA",
      "first_bit": 40,
      "SPN": 1608,
      "SPN_Name": "Adjust year",
      "SPN_Description": "The year component for setting the current calendar date.  This should be reported as the year component of the current date according to the calendar date standard indicated with the Local Hour Offset parameter (SPN 1602).  The calendar date should be reported as the current date at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the current date at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the calendar date (SPNs 962, 963, and 964) is the current UTC date or a local time zone date.  Refer to SPN 1602 for details.\r\n\r\nNOTE - A value of 0 for the year identifies the year 1985; a value of 1 identifies 1986; etc.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 1985,
      "unit": "years",
      "SLOT_ID": 66
    },
    "1609": {
      "PGN": 54528,
      "PGN_Name": "Time/Date Adjust",
      "PGN_Description": "TDA",
      "first_bit": 48,
      "SPN": 1609,
      "SPN_Name": "Adjust local minute offset",
      "SPN_Description": "The minute component for setting the offset between the UTC (Universal Time Coordinate) time and date and a the local time zone time and date.  This is the number of minutes to add to UTC, a.k.a. GMT, time and date to convert to the time and date in the Local Time Zone.  The Local Offset is a positive value for time zones East of the Prime Meridian to the International Date Line.  The Local Offset is a negative value for time zones West of the Prime Meridian to the International Date Line.\r\n\r\nThe Local Minute Offset is only applicable when the Time and Date parameters are reported as UTC time and date.  Refer to SPN 1602 for details.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "min",
      "SLOT_ID": 99
    },
    "1610": {
      "PGN": 54528,
      "PGN_Name": "Time/Date Adjust",
      "PGN_Description": "TDA",
      "first_bit": 56,
      "SPN": 1610,
      "SPN_Name": "Adjust local hour offset",
      "SPN_Description": "The hour component for setting the offset between the UTC (Universal Time Coordinate) time and date and a the local time zone time and date.  This is the number of minutes to add to UTC, a.k.a. GMT, time and date to convert to the time and date in the Local Time Zone.  The Local Offset is a positive value for time zones East of the Prime Meridian to the International Date Line.  The Local Offset is a negative value for time zones West of the Prime Meridian to the International Date Line.\r\n\r\nThe Local Hour Offset is only applicable when the Time and Date parameters are reported as UTC time and date.  Refer to SPN 1602 for details.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "h",
      "SLOT_ID": 4
    },
    "1611": {
      "PGN": 65132,
      "PGN_Name": "Tachograph",
      "PGN_Description": "TCO1",
      "first_bit": 6,
      "SPN": 1611,
      "SPN_Name": "Vehicle motion",
      "SPN_Description": "Indicates whether motion of the vehicle is detected or not.\r\n\r\n00 Vehicle motion not detected\r\n01 Vehicle motion detected\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1612": {
      "PGN": 65132,
      "PGN_Name": "Tachograph",
      "PGN_Description": "TCO1",
      "first_bit": 0,
      "SPN": 1612,
      "SPN_Name": "Driver 1 working state",
      "SPN_Description": "State of work of the driver.  \r\n\r\n000 Rest - sleeping\r\n001 Driver available – short break\r\n010 Work – loading, unloading, working in an office\r\n011 Drive – behind wheel \r\n100-101 Reserved\r\n110 Error\r\n111 Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "1613": {
      "PGN": 65132,
      "PGN_Name": "Tachograph",
      "PGN_Description": "TCO1",
      "first_bit": 3,
      "SPN": 1613,
      "SPN_Name": "Driver 2 working state",
      "SPN_Description": "State of work of the driver.  \r\n\r\n000 Rest - sleeping\r\n001 Driver available – short break\r\n010 Work – loading, unloading, working in an office\r\n011 Drive – behind wheel \r\n100-101 Reserved\r\n110 Error\r\n111 Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "1614": {
      "PGN": 65132,
      "PGN_Name": "Tachograph",
      "PGN_Description": "TCO1",
      "first_bit": 14,
      "SPN": 1614,
      "SPN_Name": "Vehicle Overspeed",
      "SPN_Description": "Indicates whether the vehicle is exceeding the legal speed limit set in the tachograph.\r\n\r\n00 No overspeed\r\n01 Overspeed\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1615": {
      "PGN": 65132,
      "PGN_Name": "Tachograph",
      "PGN_Description": "TCO1",
      "first_bit": 12,
      "SPN": 1615,
      "SPN_Name": "Driver card, driver 1",
      "SPN_Description": "Indicates the presence of a driver card\r\n\r\n00 - Driver card not present\r\n01 - Driver card present\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1616": {
      "PGN": 65132,
      "PGN_Name": "Tachograph",
      "PGN_Description": "TCO1",
      "first_bit": 20,
      "SPN": 1616,
      "SPN_Name": "Driver card, driver 2",
      "SPN_Description": "Indicates the presence of a driver card\r\n\r\n00 - Driver card not present\r\n01 - Driver card present\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1617": {
      "PGN": 65132,
      "PGN_Name": "Tachograph",
      "PGN_Description": "TCO1",
      "first_bit": 8,
      "SPN": 1617,
      "SPN_Name": "Driver 1 Time Related States",
      "SPN_Description": "Indicates if the driver approaches or exceeds working time limits (or other limits).  \r\n\r\n0000 Normal/No limits reached\r\n0001 Limit #1 – 15 min before 4 ½ h\r\n0010 Limit #2 – 4 ½ h reached\r\n0011 Limit #3 – 15 min before 9 h\r\n0100 Limit #4 – 9 h reached\r\n0101 Limit #5 – 15 min before 16 h (not having 8h rest during the last 24h)\r\n0110 Limit #6 – 16 h reached\r\n0111-1100 Reserved\r\n1101 Other\r\n1110 Error\r\n1111 Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1618": {
      "PGN": 65132,
      "PGN_Name": "Tachograph",
      "PGN_Description": "TCO1",
      "first_bit": 16,
      "SPN": 1618,
      "SPN_Name": "Driver 2 Time Related States",
      "SPN_Description": "Indicates if the driver approaches or exceeds working time limits (or other limits).  \r\n\r\n0000 Normal/No limits reached\r\n0001 Limit #1 – 15 min before 4 ½ h\r\n0010 Limit #2 – 4 ½ h reached\r\n0011 Limit #3 – 15 min before 9 h\r\n0100 Limit #4 – 9 h reached\r\n0101 Limit #5 – 15 min before 16 h (not having 8h rest during the last 24h)\r\n0110 Limit #6 – 16 h reached\r\n0111-1100 Reserved\r\n1101 Other\r\n1110 Error\r\n1111 Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1619": {
      "PGN": 65132,
      "PGN_Name": "Tachograph",
      "PGN_Description": "TCO1",
      "first_bit": 30,
      "SPN": 1619,
      "SPN_Name": "Direction indicator",
      "SPN_Description": "Indicates the direction of the vehicle.\r\n\r\n00 - Forward\r\n01 - Reverse\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1620": {
      "PGN": 65132,
      "PGN_Name": "Tachograph",
      "PGN_Description": "TCO1",
      "first_bit": 28,
      "SPN": 1620,
      "SPN_Name": "Tachograph performance",
      "SPN_Description": "Indicates the tachograph performance; including electronic or mechanical analysis, instrument analysis, speed sensor analysis, mass storage analysis, and printer analysis.\r\n\r\n00 - Normal performance\r\n01 - Performance analysis\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1621": {
      "PGN": 65132,
      "PGN_Name": "Tachograph",
      "PGN_Description": "TCO1",
      "first_bit": 26,
      "SPN": 1621,
      "SPN_Name": "Handling information",
      "SPN_Description": "Indicates that handling information is present.  Information could include “no printer paper”, “no driver card”, etc.\r\n\r\n00 - No handling information\r\n01 - Handling information\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1622": {
      "PGN": 65132,
      "PGN_Name": "Tachograph",
      "PGN_Description": "TCO1",
      "first_bit": 24,
      "SPN": 1622,
      "SPN_Name": "System event",
      "SPN_Description": "Indicates that a tachograph event has occurred.  This may include power supply interruption, interruption of the speed sensor, incorrect data on the driver card, driving without a driver card, illegal removal of a driver card, insertion of a driver card during driving, and time adjustment.\r\n\r\n00 - No tachograph event\r\n01 - Tachograph event\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1623": {
      "PGN": 65132,
      "PGN_Name": "Tachograph",
      "PGN_Description": "TCO1",
      "first_bit": 32,
      "SPN": 1623,
      "SPN_Name": "Tachograph output shaft speed",
      "SPN_Description": "Calculated speed of the transmission output shaft.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "1624": {
      "PGN": 65132,
      "PGN_Name": "Tachograph",
      "PGN_Description": "TCO1",
      "first_bit": 48,
      "SPN": 1624,
      "SPN_Name": "Tachograph vehicle speed",
      "SPN_Description": "Speed of the vehicle registered by the tachograph.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 71
    },
    "1632": {
      "PGN": 65168,
      "PGN_Name": "Engine Torque History",
      "PGN_Description": "ETH",
      "first_bit": 114,
      "SPN": 1632,
      "SPN_Name": "Engine Torque Limit Feature",
      "SPN_Description": "Torque limit rating described in the current record. \r\n\r\n000 Reserved\r\n001 Highest torque rating\r\n010 First torque rating\r\n011 Previous torque rating (rating prior to the current rating)\r\n100 Current torque rating\r\n101-110 Reserved\r\n111 Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "1633": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 4,
      "SPN": 1633,
      "SPN_Name": "Cruise Control Pause Switch",
      "SPN_Description": "Switch signal which indicates the position of the Cruise Control Pause Switch used on Remote Cruise Control applications. The Cruise Control Pause Switch signal temporarily disables the Cruise Control function.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error Indicator\r\n11 -Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1636": {
      "PGN": 65129,
      "PGN_Name": "Engine Temperature 3",
      "PGN_Description": "ET3",
      "first_bit": 0,
      "SPN": 1636,
      "SPN_Name": "Engine Intake Manifold 1 Temperature (High Resolution)",
      "SPN_Description": "Temperature of pre-combustion air found in intake manifold of engine air supply system. The higher resolution is required for control purposes.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1637": {
      "PGN": 65129,
      "PGN_Name": "Engine Temperature 3",
      "PGN_Description": "ET3",
      "first_bit": 16,
      "SPN": 1637,
      "SPN_Name": "Engine Coolant Temperature (High Resolution)",
      "SPN_Description": "Temperature of liquid found in engine cooling system. The higher resolution is required for control purposes.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1638": {
      "PGN": 65128,
      "PGN_Name": "Vehicle Fluids",
      "PGN_Description": "VF",
      "first_bit": 0,
      "SPN": 1638,
      "SPN_Name": "Hydraulic Temperature",
      "SPN_Description": "Temperature of hydraulic fluid.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1639": {
      "PGN": 65213,
      "PGN_Name": "Fan Drive #1",
      "PGN_Description": "FD1",
      "first_bit": 16,
      "SPN": 1639,
      "SPN_Name": "Fan Speed",
      "SPN_Description": "The speed of the fan associated with engine coolant system.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "1653": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 38,
      "SPN": 1653,
      "SPN_Name": "Vehicle Limiting Speed Governor Enable Switch",
      "SPN_Description": "Switch signal which enables the Vehicle Limiting Speed Governor (VLSG) such that the vehicle speed may be either increased or decreased when the engine is off idle.\r\n\r\n00 - Switch disabled\r\n01 - Switched enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1654": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 36,
      "SPN": 1654,
      "SPN_Name": "Vehicle Limiting Speed Governor Increment Switch",
      "SPN_Description": "Switch signal which increases the Vehicle Limiting Speed Governor (VLSG).\r\n\r\n00 - Switch in the off state\r\n01 - Switch in the on state - increase\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1655": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 34,
      "SPN": 1655,
      "SPN_Name": "Vehicle Limiting Speed Governor Decrement Switch",
      "SPN_Description": "Switch signal which decreases the Vehicle Limiting Speed Governor (VLSG).\r\n\r\n00 - Switch in the off state\r\n01 - Switch in the on state - decrease\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1656": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 46,
      "SPN": 1656,
      "SPN_Name": "Engine Automatic Start Enable Switch",
      "SPN_Description": "Switch signal which enables the idle management system to be enabled. When this system is enabled with the engine in an idle mode and safe operating conditions existing, then the engine may be started or stopped automatically.\r\n\r\n00 - Switch in the off state\r\n01 - Switch in the on state\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1665": {
      "PGN": 65245,
      "PGN_Name": "Turbocharger",
      "PGN_Description": "TC",
      "first_bit": 30,
      "SPN": 1665,
      "SPN_Name": "Engine Turbocharger Oil Level Switch",
      "SPN_Description": "Switch signal which indicates the presence of oil at the turbocharger\r\n\r\n     00 = No oil present at turbocharger\r\n     01 = Oil present at turbocharger\r\n     10 = Error\r\n     11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1666": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 44,
      "SPN": 1666,
      "SPN_Name": "Automatic Gear Shifting Enable Switch",
      "SPN_Description": "Indicates that automated gear shifting is enabled via a switch\r\n\r\n    00 = Automated Gear Shifting is disabled\r\n    01 = Automated Gear Shifting is enabled\r\n    10 = Error\r\n    11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1667": {
      "PGN": 61440,
      "PGN_Name": "Electronic Retarder Controller 1",
      "PGN_Description": "ERC1",
      "first_bit": 26,
      "SPN": 1667,
      "SPN_Name": "Retarder Requesting Brake Light",
      "SPN_Description": "Indicates that whether the retarder is requesting that the brake lights are illuminated.\r\n\r\n     00 - Retarder is not requesting that the brake lights are illuminated\r\n     01 - Retarder is requesting that the brake lights are illuminated\r\n     10 - Reserved\r\n     11 - Not available/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1675": {
      "PGN": 61444,
      "PGN_Name": "Electronic Engine Controller 1",
      "PGN_Description": "EEC1",
      "first_bit": 48,
      "SPN": 1675,
      "SPN_Name": "Engine Starter Mode",
      "SPN_Description": "There are several phases in a starting action and different reasons why a start cannot take place.\r\n\r\n0000 start not requested\r\n0001 starter active, gear not engaged\r\n0010 starter active, gear engaged\r\n0011 start finished; starter not active after having been actively engaged (after 50ms mode goes to 0000)\r\n0100 starter inhibited due to engine already running\r\n0101 starter inhibited due to engine not ready for start (preheating)\r\n0110 starter inhibited due to driveline engaged or other transmission inhibit\r\n0111 starter inhibited due to active immobilizer\r\n1000 starter inhibited due to starter over-temp\r\n1001 starter inhibited due to intake air shutoff valve being active\r\n1010 starter inhibited due to active SCR inducement\r\n1011 Reserved\r\n1100 starter inhibited - reason unknown\r\n1101 error (legacy implementation only, use 1110)\r\n1110 error\r\n1111 not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1676": {
      "PGN": 65133,
      "PGN_Name": "Heater Information",
      "PGN_Description": "HTR",
      "first_bit": 32,
      "SPN": 1676,
      "SPN_Name": "Auxiliary Heater Water Pump Status",
      "SPN_Description": "Parameter indicating whether the auxiliary heater water pump is running\r\n\r\n00 Water Pump is not running\r\n01 Water Pump is  running\r\n10 Reserved\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1677": {
      "PGN": 65133,
      "PGN_Name": "Heater Information",
      "PGN_Description": "HTR",
      "first_bit": 24,
      "SPN": 1677,
      "SPN_Name": "Auxiliary Heater Mode",
      "SPN_Description": "State of the auxiliary heater\r\n\r\n0000 Heater not active\r\n0001 Off due to ADR per European Regulations for Transport of hazardous materials\r\n0010 Economy mode\r\n0011 Normal mode\r\n0100 Heater pump up-keep   (running the equipment in order to keep it in good condition)\r\n0101 Heater Starting - Indicates the start-phase of the heater which can be used to control the fan and circulation air flaps.\r\n0110 Heater Stopping - Indicates the burn-out phase of the heater which can be used to control the fan and circulation air flaps.\r\n0111 Diagnose Active - Indicates any active/running diagnostic service/routine/IO-control without the normal heater burn taking place.\r\n1000 Heater Locked - Indicates a sticky error state after running a number of failed heater start attempts.  Heater will need to be unlocked at a workshop.\r\n1001-1101 Not defined\r\n1110 Error\r\n1111 Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1678": {
      "PGN": 65133,
      "PGN_Name": "Heater Information",
      "PGN_Description": "HTR",
      "first_bit": 34,
      "SPN": 1678,
      "SPN_Name": "Cab Ventilation",
      "SPN_Description": "Indicates whether the cab is being ventilated or not.\r\n\r\n00 Cab not ventilated\r\n01 Cab is ventilated\r\n10 Reserved\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1679": {
      "PGN": 65133,
      "PGN_Name": "Heater Information",
      "PGN_Description": "HTR",
      "first_bit": 36,
      "SPN": 1679,
      "SPN_Name": "Engine Heating Zone",
      "SPN_Description": "Parameter indicating whether the engine zone is being heated.\r\n\r\n00 Engine heating zone off\r\n01 Engine heating zone on\r\n10 Reserved\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1680": {
      "PGN": 65133,
      "PGN_Name": "Heater Information",
      "PGN_Description": "HTR",
      "first_bit": 38,
      "SPN": 1680,
      "SPN_Name": "Cab Heating Zone",
      "SPN_Description": "Parameter indicating whether the cab zone is being heated.\r\n\r\n00 Cab heating zone off\r\n01 Cab heating zone on\r\n10 Reserved\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1681": {
      "PGN": 65126,
      "PGN_Name": "Battery Main Switch Information",
      "PGN_Description": "BM",
      "first_bit": 0,
      "SPN": 1681,
      "SPN_Name": "Battery Main Switch Hold State",
      "SPN_Description": "Parameter indicating whether the battery main switch is held due to an external request or not. The state battery main switch held indicates that the battery main switch is about to switch off.\r\n\r\n00 Battery main switch not held\r\n01 Battery main switch held\r\n10 Reserved\r\n11 Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1682": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 26,
      "SPN": 1682,
      "SPN_Name": "Battery Main Switch Hold Request",
      "SPN_Description": "Request to hold the battery main switch.\r\n\r\n00 Release Battery Main Switch\r\n01 Hold Battery Main Switch\r\n10 undefined\r\n11 Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1683": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 48,
      "SPN": 1683,
      "SPN_Name": "Auxiliary Heater Mode Request",
      "SPN_Description": "Request to activate the auxiliary heater.\r\n\r\n0000 De-activate auxiliary heater\r\n0001 Off due to ADR per European Regulations for Transport of hazardous materials\r\n0010 Economy mode\r\n0011 Normal mode\r\n0100 Heater pump up-keep\r\n0101-1000 Reserved\r\n1001-1101 Not defined\r\n1110 Reserved\r\n1111 Don't care/take no action",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1684": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 24,
      "SPN": 1684,
      "SPN_Name": "Auxiliary Heater Coolant Pump Request",
      "SPN_Description": "Indicates whether to activate the auxiliary heater coolant water pump.\r\n\r\n00 Deactivate water pump\r\n01 Activate water pump\r\n10 Reserved\r\n11 Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1685": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 52,
      "SPN": 1685,
      "SPN_Name": "Request Engine Zone Heating",
      "SPN_Description": "Request to activate engine zone heating.\r\n\r\n00 Do not heat engine zone\r\n01 Heat engine zone\r\n10 Reserved\r\n11 Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1686": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 54,
      "SPN": 1686,
      "SPN_Name": "Request Cab Zone Heating",
      "SPN_Description": "Request to activate cab zone heating.\r\n\r\n00 Do not heat cab engine zone\r\n01 Heat cab zone\r\n10 Reserved\r\n11 Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1687": {
      "PGN": 65133,
      "PGN_Name": "Heater Information",
      "PGN_Description": "HTR",
      "first_bit": 0,
      "SPN": 1687,
      "SPN_Name": "Auxiliary Heater Output Coolant Temperature",
      "SPN_Description": "Temperature of the auxiliary heater output coolant (I.e. water in a water heater system.)",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1688": {
      "PGN": 65133,
      "PGN_Name": "Heater Information",
      "PGN_Description": "HTR",
      "first_bit": 8,
      "SPN": 1688,
      "SPN_Name": "Auxiliary Heater Input Air Temperature",
      "SPN_Description": "Temperature of the input air in an auxiliary heater system.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1689": {
      "PGN": 65133,
      "PGN_Name": "Heater Information",
      "PGN_Description": "HTR",
      "first_bit": 16,
      "SPN": 1689,
      "SPN_Name": "Auxiliary Heater Output Power Percent",
      "SPN_Description": "Current auxiliary heater output power, relative to the auxiliary heater maximum output power.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1690": {
      "PGN": 65127,
      "PGN_Name": "Climate Control Configuration",
      "PGN_Description": "CCC",
      "first_bit": 0,
      "SPN": 1690,
      "SPN_Name": "Auxiliary Heater Maximum Output Power",
      "SPN_Description": "The maximum output power of the auxiliary heater.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "W",
      "SLOT_ID": 107
    },
    "1691": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 8,
      "SPN": 1691,
      "SPN_Name": "Cab Interior Temperature Command",
      "SPN_Description": "Parameter used to command a certain cab interior temperature.\r\n\r\nNote: See also SPN 170.  SPN 1662 is an additional diagnostic SPN associated with cab temperature.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "1692": {
      "PGN": 65194,
      "PGN_Name": "Alternate Fuel 2",
      "PGN_Description": "AF2",
      "first_bit": 8,
      "SPN": 1692,
      "SPN_Name": "Engine Intake Manifold Desired Absolute Pressure",
      "SPN_Description": "The desired absolute intake manifold pressure (turbo boost limit) of the engine.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "1693": {
      "PGN": 65194,
      "PGN_Name": "Alternate Fuel 2",
      "PGN_Description": "AF2",
      "first_bit": 24,
      "SPN": 1693,
      "SPN_Name": "Engine Turbocharger Wastegate Valve Position",
      "SPN_Description": "The position of the turbocharger wastegate valve (not the electronic wastegate control valve).",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1694": {
      "PGN": 65194,
      "PGN_Name": "Alternate Fuel 2",
      "PGN_Description": "AF2",
      "first_bit": 32,
      "SPN": 1694,
      "SPN_Name": "Engine Fuel System Gas Mass Flow Rate Sensor Fueling Correction",
      "SPN_Description": "The amount of fuel the Gas Mass Flow Rate Sensor is sensing should be added or subtracted compared to the maximum amount of fuel the control system allows the sensor to add or subtract.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1695": {
      "PGN": 65193,
      "PGN_Name": "Exhaust Oxygen 1",
      "PGN_Description": "EO1",
      "first_bit": 48,
      "SPN": 1695,
      "SPN_Name": "Engine Exhaust O2 Sensor Fueling Correction",
      "SPN_Description": "The amount of fueling change required by the system based on the measured exhaust oxygen value compared to the maximum fueling change permitted by the system, expressed as percentages.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1696": {
      "PGN": 65193,
      "PGN_Name": "Exhaust Oxygen 1",
      "PGN_Description": "EO1",
      "first_bit": 62,
      "SPN": 1696,
      "SPN_Name": "Engine Exhaust O2 Sensor Closed Loop Operation",
      "SPN_Description": "Indicates whether the engine is using the exhaust oxygen sensor to control the air/fuel ratio.\r\n\r\n00 Engine not using the exhaust oxygen sensor (open loop)\r\n01 Engine using the exhaust oxygen sensor for a closed loop operation\r\n10 Reserved\r\n11 Don't Care/take no action\r\n\r\nSee also SPN 4240 for an implementation with more states.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1697": {
      "PGN": 65268,
      "PGN_Name": "Tire Condition Message 1",
      "PGN_Description": "TIRE1",
      "first_bit": 36,
      "SPN": 1697,
      "SPN_Name": "Tire Sensor Electrical Fault",
      "SPN_Description": "Indicates the status of electrical fault on the tire sensor.\r\n\r\n00 Ok (No Fault)\r\n01 Not Defined (Fault)\r\n10 Error\r\n11 Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1698": {
      "PGN": 65268,
      "PGN_Name": "Tire Condition Message 1",
      "PGN_Description": "TIRE1",
      "first_bit": 34,
      "SPN": 1698,
      "SPN_Name": "Tire Status",
      "SPN_Description": "Indicates the status of the tire.\r\n\r\n00 Ok (no fault)\r\n01 Tire leak detected\r\n10 Error\r\n11 Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1699": {
      "PGN": 65268,
      "PGN_Name": "Tire Condition Message 1",
      "PGN_Description": "TIRE1",
      "first_bit": 32,
      "SPN": 1699,
      "SPN_Name": "Tire Sensor Enable Status",
      "SPN_Description": "Indicates whether the tire sensor is being monitored by the controller or is Enabled/Disabled.\r\n\r\n00 Off / Isolated / Disabled\r\n01 On (tire is polled) / Enabled\r\n10 Not Defined\r\n11 Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1700": {
      "PGN": 61447,
      "PGN_Name": "Forward Lane Image 1",
      "PGN_Description": "FLI1",
      "first_bit": 6,
      "SPN": 1700,
      "SPN_Name": "Lane Departure Imminent, Left Side",
      "SPN_Description": "Indicates departure imminent on left side of lane.\r\n\r\n00 Not imminent\r\n01 Imminent\r\n10 Reserved\r\n11 Not used",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1701": {
      "PGN": 61447,
      "PGN_Name": "Forward Lane Image 1",
      "PGN_Description": "FLI1",
      "first_bit": 4,
      "SPN": 1701,
      "SPN_Name": "Lane Departure Imminent, Right Side",
      "SPN_Description": "Indicates departure imminent on right side of lane.\r\n\r\n00 Not imminent\r\n01 Imminent\r\n10 Reserved\r\n11 Not Used",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1702": {
      "PGN": 65115,
      "PGN_Name": "Forward Lane Image 2",
      "PGN_Description": "FLI2",
      "first_bit": 6,
      "SPN": 1702,
      "SPN_Name": "Lane Departure Indication Enable Status",
      "SPN_Description": "Indicates whether lane departure indication is active.\r\n\r\n00 Lane Departure indication disabled\r\n01 Lane Departure Indication enabled \r\n10 Reserved\r\n11 Not Used",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1707": {
      "PGN": 64817,
      "PGN_Name": "Fan Drive #2",
      "PGN_Description": "FD2",
      "first_bit": 32,
      "SPN": 1707,
      "SPN_Name": "Hydraulic Fan 2 Motor Pressure",
      "SPN_Description": "The hydraulic pressure used to drive the second fan system, sensed before the hydraulic fan motor.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "1708": {
      "PGN": 64817,
      "PGN_Name": "Fan Drive #2",
      "PGN_Description": "FD2",
      "first_bit": 48,
      "SPN": 1708,
      "SPN_Name": "Fan 2 Drive Bypass Command Status",
      "SPN_Description": "Status of the Fan Drive Bypass Command for the second fan as being commanded by the ECU.  The fan drive bypass diverts pump pressure away from the hydraulic motor to maintain the fan drive pressure.  0% is defined as no bypass (i.e. diverting no fan drive pressure) and 100% is defined as full bypass (i.e. diverting the maximum fan drive pressure) from the fan motor.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1710": {
      "PGN": 65115,
      "PGN_Name": "Forward Lane Image 2",
      "PGN_Description": "FLI2",
      "first_bit": 4,
      "SPN": 1710,
      "SPN_Name": "Lane Tracking Status Left Side",
      "SPN_Description": "Indicates whether the left side is tracking lane.\r\n\r\n00 Not Tracking Left side\r\n01 Tracking Left side\r\n10 Reserved\r\n11 Don't care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1711": {
      "PGN": 65115,
      "PGN_Name": "Forward Lane Image 2",
      "PGN_Description": "FLI2",
      "first_bit": 2,
      "SPN": 1711,
      "SPN_Name": "Lane Tracking Status Right Side",
      "SPN_Description": "Indicates whether right side is tracking lane.\r\n\r\n00 Not Tracking Right side\r\n01 Tracking Right side\r\n10 Reserved\r\n11 Don't Care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1712": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 224,
      "SPN": 1712,
      "SPN_Name": "Engine Requested Speed Control Range Upper Limit (Extended Range)",
      "SPN_Description": "The maximum engine speed regardless of load that the engine will allow when operating in a speed control/limit mode, excluding any maximum momentary engine override speed, if supported.  \r\n\r\nWhen the limit is higher than 2500 RPM the 'Requested Speed Control Range Upper Limit (Engine Configuration)' parameter (see SPN 536) will be transmitted with a value of 2500 RPM.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "1713": {
      "PGN": 65128,
      "PGN_Name": "Vehicle Fluids",
      "PGN_Description": "VF",
      "first_bit": 8,
      "SPN": 1713,
      "SPN_Name": "Hydraulic Oil Filter Restriction Switch",
      "SPN_Description": "This switch indicates whether hydraulic oil filter is clogged. This is not the transmission oil filter restriction switch, which is SPN 3359.\r\n\r\n00 No restriction\r\n01 Restriction exists on oil filter\r\n10 Error\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1714": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 28,
      "SPN": 1714,
      "SPN_Name": "Operator Seat Direction Switch",
      "SPN_Description": "Senses whether the operator seat is in the forward driving position\r\n\r\n00 Operator seat not facing forward\r\n01 Operator seat is facing forward\r\n10 Error\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1715": {
      "PGN": 61440,
      "PGN_Name": "Electronic Retarder Controller 1",
      "PGN_Description": "ERC1",
      "first_bit": 40,
      "SPN": 1715,
      "SPN_Name": "Drivers Demand Retarder -  Percent Torque",
      "SPN_Description": "The Drivers demand retarder – percent torque is the maximum torque selected by the driver when one or more modes  are selected by the driver, such as hand lever, switch, constant torque, constant velocity, etc.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1716": {
      "PGN": 61440,
      "PGN_Name": "Electronic Retarder Controller 1",
      "PGN_Description": "ERC1",
      "first_bit": 48,
      "SPN": 1716,
      "SPN_Name": "Retarder Selection, non-engine",
      "SPN_Description": "The “Retarder Selection, non-engine” is the position of the driver’s selector for retarders that are not part of the engine system, expressed as percent and determined by the ratio of current position to the maximum possible position. The physical device may be a lever, rotary dial, combination of switches, or other device that the driver can use to select the type or amount of retardation needed.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1717": {
      "PGN": 61440,
      "PGN_Name": "Electronic Retarder Controller 1",
      "PGN_Description": "ERC1",
      "first_bit": 56,
      "SPN": 1717,
      "SPN_Name": "Actual Maximum Available Retarder - Percent Torque",
      "SPN_Description": "This is the maximum amount of torque that the retarder can immediately deliver.   It is the same as the maximum torque shown in the Retarder’s Configuration message, but allows for a much faster rate of change than could be communicated by reissuing the configuration message. \r\nApplication Note: The purpose for this parameter is to allow a “Master” retarder controller to more accurately allocate the vehicle’s retarder requirements among multiple retarders. Its value should be the same as the value in the Configuration message at the time that message is assembled for broadcast, but may vary between those broadcasts.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1718": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 24,
      "SPN": 1718,
      "SPN_Name": "Damper Stiffness Request Front Axle",
      "SPN_Description": "Demand value for the shock absorber control at the front axle.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1719": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 32,
      "SPN": 1719,
      "SPN_Name": "Damper Stiffness Request Rear Axle",
      "SPN_Description": "Demand value for the shock absorber control at the rear  axle.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1720": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 40,
      "SPN": 1720,
      "SPN_Name": "Damper Stiffness Request Lift / Tag Axle",
      "SPN_Description": "Demand value for the shock absorber control at the lift or tag axle",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1721": {
      "PGN": 65113,
      "PGN_Name": "Air Suspension Control 3",
      "PGN_Description": "ASC3",
      "first_bit": 0,
      "SPN": 1721,
      "SPN_Name": "Relative Level Front Axle Left",
      "SPN_Description": "Information of the height at the left side of the front axle referred to normal level 1.  For explanations of normal level 1 see SPN 1734 - Nominal Level Front Axle.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3200,
      "unit": "mm",
      "SLOT_ID": 13
    },
    "1722": {
      "PGN": 65113,
      "PGN_Name": "Air Suspension Control 3",
      "PGN_Description": "ASC3",
      "first_bit": 16,
      "SPN": 1722,
      "SPN_Name": "Relative Level Front Axle Right",
      "SPN_Description": "Information of the height at the right side of the front axle referred to normal level 1.  For explanations of normal level 1 see SPN 1734 - Nominal Level Front Axle.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3200,
      "unit": "mm",
      "SLOT_ID": 13
    },
    "1723": {
      "PGN": 65113,
      "PGN_Name": "Air Suspension Control 3",
      "PGN_Description": "ASC3",
      "first_bit": 48,
      "SPN": 1723,
      "SPN_Name": "Relative Level Rear Axle Right",
      "SPN_Description": "Information of the height at the left side of the rear axle referred to normal level 1.  For explanations of normal level 1 see parameter SPN 1734 - Nominal Level Front Axle.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3200,
      "unit": "mm",
      "SLOT_ID": 13
    },
    "1724": {
      "PGN": 65113,
      "PGN_Name": "Air Suspension Control 3",
      "PGN_Description": "ASC3",
      "first_bit": 32,
      "SPN": 1724,
      "SPN_Name": "Relative Level Rear Axle Left",
      "SPN_Description": "Information of the height at the left side of the rear axle referred to normal level 1.  For explanations of normal level 1 see parameter SPN 1734 - Nominal Level Front Axle.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3200,
      "unit": "mm",
      "SLOT_ID": 13
    },
    "1725": {
      "PGN": 65112,
      "PGN_Name": "Air Suspension Control 4",
      "PGN_Description": "ASC4",
      "first_bit": 0,
      "SPN": 1725,
      "SPN_Name": "Bellow Pressure Front Axle Left",
      "SPN_Description": "Information of the pressure of the air suspension bellow at the left side of the front axle",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "1726": {
      "PGN": 65112,
      "PGN_Name": "Air Suspension Control 4",
      "PGN_Description": "ASC4",
      "first_bit": 16,
      "SPN": 1726,
      "SPN_Name": "Bellow Pressure Front Axle Right",
      "SPN_Description": "Information of the pressure of the air suspension bellow at the right side of the front axle",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "1727": {
      "PGN": 65112,
      "PGN_Name": "Air Suspension Control 4",
      "PGN_Description": "ASC4",
      "first_bit": 32,
      "SPN": 1727,
      "SPN_Name": "Bellow Pressure Rear Axle Left",
      "SPN_Description": "Information of the pressure of the air suspension bellow at the left side of the rear axle",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "1728": {
      "PGN": 65112,
      "PGN_Name": "Air Suspension Control 4",
      "PGN_Description": "ASC4",
      "first_bit": 48,
      "SPN": 1728,
      "SPN_Name": "Bellow Pressure Rear Axle Right",
      "SPN_Description": "Information of the pressure of the air suspension bellow at the right side of the rear axle",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "1729": {
      "PGN": 65111,
      "PGN_Name": "Air Suspension Control 5",
      "PGN_Description": "ASC5",
      "first_bit": 0,
      "SPN": 1729,
      "SPN_Name": "Damper Stiffness Front Axle",
      "SPN_Description": "Damper stiffness information of the shock absorber control at the front axle",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1730": {
      "PGN": 65111,
      "PGN_Name": "Air Suspension Control 5",
      "PGN_Description": "ASC5",
      "first_bit": 8,
      "SPN": 1730,
      "SPN_Name": "Damper Stiffness Rear Axle",
      "SPN_Description": "Damper stiffness information of the shock absorber control at the rear axle",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1731": {
      "PGN": 65111,
      "PGN_Name": "Air Suspension Control 5",
      "PGN_Description": "ASC5",
      "first_bit": 16,
      "SPN": 1731,
      "SPN_Name": "Damper Stiffness Lift / Tag Axle",
      "SPN_Description": "Damper stiffness information of the shock absorber control at the lift of tag axle",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1732": {
      "PGN": 53504,
      "PGN_Name": "Air Suspension Control 6",
      "PGN_Description": "ASC6",
      "first_bit": 0,
      "SPN": 1732,
      "SPN_Name": "Level Preset Front Axle Left",
      "SPN_Description": "Set value for nominal level 'preset level' at the left side of the front axle. This value is referred to 'Normal level 1'.  For explanations of normal level 1 see parameter SPN 1734 - Nominal Level Front Axle.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3200,
      "unit": "mm",
      "SLOT_ID": 13
    },
    "1733": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 4,
      "SPN": 1733,
      "SPN_Name": "Nominal Level Rear Axle",
      "SPN_Description": "Signal which indicates the nominal (desired) height of the rear axle to be controlled by the suspension system.\r\n\r\nFor further explanations see SPN 1734 - Nominal Level Front Axle.\r\n\r\n0000 Level not specified,(i.e. the nominal level is none of the specified levels, no error condition)\r\n0001 \"Normal Level 1,(i.e. the level prescribed for normal driving, given by design)\r\n0010 \"Normal Level 2,(i.e. a level permitted for driving, for example to lower the vehicle in case of high speed)\r\n0011 \"Normal Level 3,(i.e. a level permitted for driving, for example to lift the vehicle in case of offroad)\r\n0100 \"Preset Level,(i.e. a level to be defined externally via CAN)\r\n0101 \"Customer Level,(i.e. a level to be defined by customer via parameter setting)\r\n0110 \"Upper Level,(i.e. the highest level to be controlled)\r\n0111 \"Lower Level,(i.e. the lowest level to be controlled)\r\n1000 Level change stopped\r\n1001 Raising\r\n1010 Lowering\r\n1011-1101 Reserved\r\n1110 Error\r\n1111 Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1734": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 0,
      "SPN": 1734,
      "SPN_Name": "Nominal Level Front Axle",
      "SPN_Description": "Signal which indicates the nominal (desired) height of the front axle to be controlled by the suspension system.\r\n\r\nThese heights are discrete levels.  They are the upper level, lower level, normal level 1, normal level 2, normal level 3, customer level, and preset level.  Refer to Figure SPN1734_A.\r\n\r\n· Upper Level is the highest mechanically available height of the vehicle.  \r\n· Lower Level is the lowest mechanically available height of the vehicle.  \r\n\r\nNormal Levels 1, 2 and 3 are heights normally used during driving.\r\n· Normal Level 1 is most often used and is given by design.  \r\n· Normal Level 2 may be chosen, for example, to be lower than Normal Level 1 for the purpose of reducing fuel consumption while driving on highways.  \r\n· Normal Level 3 may be chosen above Normal Level 1 for driving off road.\r\n\r\nThe preset level has to be set by means of ASC 6 (PGN: 53504).\r\n\r\nStates 'Raising' and 'Lowering' are only active when corresponding states are requested in SPN 1751.  This provides the possibility to adjust vehicle to a level other than the predefined levels.\r\n\r\n0000 Level not specified,(i.e. the nominal level is none of the specified levels, no error condition)\r\n0001 \"Normal Level 1,(i.e. the level prescribed for normal driving, given by design)\r\n0010 \"Normal Level 2,(i.e. a level permitted for driving, for example to lower the vehicle in case of high speed)\r\n0011 \"Normal Level 3,(i.e. a level permitted for driving, for example to lift the vehicle in case of offroad)\r\n0100 \"Preset Level,(i.e. a level to be defined externally via CAN)\r\n0101 \"Customer Level,(i.e. a level to be defined by customer via parameter setting)\r\n0110 \"Upper Level,(i.e. the highest level to be controlled)\r\n0111 \"Lower Level,(i.e. the lowest level to be controlled)\r\n1000 Level change stopped\r\n1001 Raising\r\n1010 Lowering\r\n1011-1101 Reserved\r\n1110 Error\r\n1111 Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1735": {
      "PGN": 53504,
      "PGN_Name": "Air Suspension Control 6",
      "PGN_Description": "ASC6",
      "first_bit": 48,
      "SPN": 1735,
      "SPN_Name": "Level Preset Rear Axle Right",
      "SPN_Description": "Set value for nominal level 'preset level' at the right side of the rear axle. This value is referred to 'Normal level 1'.  For explanations of normal level 1 see SPN 1734 - Nominal Level Front Axle.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3200,
      "unit": "mm",
      "SLOT_ID": 13
    },
    "1736": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 14,
      "SPN": 1736,
      "SPN_Name": "Above Nominal Level Rear Axle",
      "SPN_Description": "Signal which indicates whether the actual height of the rear axle is above the nominal (desired) level of the rear axle. For explanations of nominal level see parameter SPN 1734 - Nominal Level Front Axle.\r\n\r\n00 Not above\r\n01 Above\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1737": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 12,
      "SPN": 1737,
      "SPN_Name": "Above Nominal Level Front Axle",
      "SPN_Description": "Signal which indicates whether the actual height of the front axle is above the nominal (desired) level of the front axle. For explanations of nominal level see SPN 1734 - Nominal Level Front Axle.\r\n\r\n00 Not above\r\n01 Above\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1738": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 8,
      "SPN": 1738,
      "SPN_Name": "Below Nominal Level Front Axle",
      "SPN_Description": "Signal which indicates whether the actual height of the front axle is below the nominal (desired) level for the front axle. For explanations of nominal level see parameter SPN 1734 - Nominal Level Front Axle.\r\n\r\n00 Not below\r\n01 Below\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1739": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 20,
      "SPN": 1739,
      "SPN_Name": "Lifting Control Mode Front Axle",
      "SPN_Description": "Signal which indicates the actual lifting level change at the front axle\r\n\r\n00 Lifting not active\r\n01 Lifting active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1740": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 16,
      "SPN": 1740,
      "SPN_Name": "Lowering Control Mode Front Axle",
      "SPN_Description": "Signal which indicates the actual lowering level change at the front axle\r\n\r\n00 Lowering not active\r\n01 Lowering active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1741": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 28,
      "SPN": 1741,
      "SPN_Name": "Level Control Mode",
      "SPN_Description": "Signal which indicates the actual control mode of the air suspension system\r\n\r\n0000    Normal operation; i.e. the system performs a \"pure\" control of the vehicle height\r\n0001    Traction help (load transfer); i.e. the driven axle is loaded to a maximum value given by legislation or design\r\n0010    Load fixing; i.e. the driven axlen is loaded to a value defined by the driver\r\n0011    Pressure ratio 1; i.e. the ratio between the pressures at the driven axle and at the third axle is controlled, so that the ratio equals a fixed value 1\r\n0100    Pressure ratio 2; i.e. the ratio between the pressures at the driven axle and at the third axle is controlled, so that the ratio equals a fixed value 2\r\n0101    Optimum traction 1; i.e. the pressure at the driven axle is controlled at a fixed value 1\r\n0110    Optimum traction 2; i.e. the pressure at the driven axle is controlled at a fixed value 2\r\n0111    Traction help - load reduce; (i.e. the driven axle load is reduced to normal load condition)\r\n1000    Exhausting bellow function; i.e. the bellows are exhausted totally\r\n1001    Air suspension control prohibited ( i.e. hold current pressures in all suspension devices.)\r\n1010    Automatic air suspension control prohibited\r\n1011    Force to bumper level request is in effect\r\n1100-1101    Not defined\r\n1110    Error\r\n1111    Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1742": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 24,
      "SPN": 1742,
      "SPN_Name": "Kneeling Information",
      "SPN_Description": "Signal which indicates the actual level change in case of kneeling function\r\n\r\n0000 Not active,(i.e. the kneeling function is not active\")\r\n0001 Lowering active,(i.e. the vehicle is lowered due to a kneeling request)\r\n0010 Kneeling level reached,(i.e. the vehicle is at the fixed kneeling level)\r\n0011 Lifting active,(i.e. the vehicle is lifted due to a recover request)\r\n0100 Kneeling aborted,(i.e. in case of manual actuation the request was dropped before the kneeling level was reached)\r\n0101-1101 Not defined\r\n1110 Error\r\n1111 Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1743": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 38,
      "SPN": 1743,
      "SPN_Name": "Lift Axle 1 Position",
      "SPN_Description": "Signal which indicates the position / load condition of lift axle / tag axle 1.   Numbering of lift/tag axles starts at front axle.  See SPN 6843 for more detail.\r\n\r\n00 Lift axle position down / tag axle laden\r\n01 Lift axle position up / tag axle unladen\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1744": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 36,
      "SPN": 1744,
      "SPN_Name": "Door Release",
      "SPN_Description": "Signal which indicates that the doors may be opened. [Please note: doors instead of door!]\r\nIn case a kneeling request is active the ASC indicates during lowering the vehicle \"doors shall not be opened\" as a security information until the kneeling level is reached. Then \"doors may be opened\" is sent.\r\n\r\n00 Doors may not be opened\r\n01 Doors may be opened\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1745": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 34,
      "SPN": 1745,
      "SPN_Name": "Vehicle Motion Inhibit",
      "SPN_Description": "Signal which indicates whether vehicle motion is inhibited.\r\n\r\n00 Vehicle may be moved\r\n01 Vehicle motion is inhibited\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1746": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 32,
      "SPN": 1746,
      "SPN_Name": "Security Device",
      "SPN_Description": "The signal which indicates the status of the security device.  An example of a security device is a curbstone feeler installed beneath the doors of a bus. If the security device becomes active during kneeling the kneeling process (lowering) is stopped and the vehicle lifts back to the starting level.\r\n\r\n00 Not active\r\n01 Active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1747": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 6,
      "SPN": 1747,
      "SPN_Name": "Kneeling Control Mode Request",
      "SPN_Description": "Command signal to select the kneeling functionality\r\n\r\n00 Automatically actuated\r\n01 Manually actuated\r\n10 Reserved\r\n11 Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1748": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 4,
      "SPN": 1748,
      "SPN_Name": "Kneeling Request Right Side",
      "SPN_Description": "Command signal to activate the kneeling functionality on the right side of the vehicle\r\n\r\n00 No kneeling request\r\n01 Kneeling request\r\n10 Reserved\r\n11 Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1749": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 2,
      "SPN": 1749,
      "SPN_Name": "Kneeling Request Left Side",
      "SPN_Description": "Command signal to activate the kneeling functionality on the left side of the vehicle\r\n\r\n00 No kneeling request\r\n01 Kneeling request\r\n10 Reserved\r\n11 Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1750": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 12,
      "SPN": 1750,
      "SPN_Name": "Nominal Level Request Rear Axle",
      "SPN_Description": "Command signal to activate a level of the rear axle programmed and/or memorized in the ECU.  For explanations of nominal level see SPN 1734 - Nominal Level Front Axle.\r\n\r\n0000 No level request\r\n0001 Normal Level 1,(i.e. the level prescribed for normal driving, given by design)\r\n0010 Normal Level 2,(i.e. a level permitted for driving, for example to lower the vehicle in case of high speed)\r\n0011 Normal Level 3,(i.e. a level permitted for driving, for example to lift the vehicle in case of offroad)\r\n0100 Preset Level,(i.e. a level to be defined externally via CAN)\r\n0101 Customer Level,(i.e. a level to be defined by customer via parameter setting)\r\n0110 Upper Level,(i.e. the highest level to be controlled)\r\n0111 Lower Level,(i.e. the lowest level to be controlled)\r\n1000 Stop level change,(i.e. the level change in process shall be stopped immediately)\r\n1001  Raise Request (Continuously raising front axle, as long as active).\r\n1010  Lower Request (Continuously lowering front axle, as long as active).\r\n1011-1101 Not defined\r\n1110 Reserved\r\n1111 Don't care/take no action",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1751": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 8,
      "SPN": 1751,
      "SPN_Name": "Nominal Level Request Front Axle",
      "SPN_Description": "Command signal to activate a level of the front axle programmed and/or memorized in the ECU   For explanations of nominal level see SPN 1734 - Nominal Level Front Axle.\r\n\r\n0000 No level request\r\n0001 Normal Level 1,(i.e. the level prescribed for normal driving, given by design)\r\n0010 Normal Level 2,(i.e. a level permitted for driving, for example to lower the vehicle in case of high speed)\r\n0011 Normal Level 3,(i.e. a level permitted for driving, for example to lift the vehicle in case of offroad)\r\n0100 Preset Level,(i.e. a level to be defined externally via CAN)\r\n0101 Customer Level,(i.e. a level to be defined by customer via parameter setting)\r\n0110 Upper Level,(i.e. the highest level to be controlled)\r\n0111 Lower Level,(i.e. the lowest level to be controlled)\r\n1000 Stop level change,(i.e. the level change in process shall be stopped immediately)\r\n1001  Raise Request (Continuously raising front axle, as long as active).\r\n1010  Lower Request (Continuously lowering front axle, as long as active).\r\n1011-1101 Not defined\r\n1110 Reserved\r\n1111 Don't care/take no action",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1752": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 20,
      "SPN": 1752,
      "SPN_Name": "Lift Axle 1 Position Command",
      "SPN_Description": "Signal to command the position/load condition of lift/tag axle #1.  Numbering of lift/tag axles starts at front axle.\r\n\r\n00 Lift axle position down / tag axle laden\r\n01 Lift axle position up / tag axle unladen\r\n10 Reserved\r\n11 Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1753": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 16,
      "SPN": 1753,
      "SPN_Name": "Level Control Mode Request",
      "SPN_Description": "Command signal to activate a level control mode\r\n\r\n0000    Normal operation; i.e. the system performs a \"pure\" control of the vehicle height\r\n0001    Traction help (load transfer); i.e. the driven axle is loaded to a maximum value given by legislation or design\r\n0010    Load fixing; i.e. the driven axle is loaded to a value defined by the driver\r\n0011    Pressure ratio 1; i.e. the ratio between the pressures at the driven axle and at the third axle is controlled, so that the ratio equals a fixed value 1\r\n0100    Pressure ratio 2; i.e. the ratio between the pressures at the driven axle and at the third axle is controlled, so that the ratio equals a fixed value 2\r\n0101    Optimum traction 1; i.e. the pressure at the driven axle is controlled at a fixed value 1\r\n0110    Optimum traction 2; i.e. the pressure at the driven axle is controlled at a fixed value 2\r\n0111    Traction help - load reduce; (i.e. reduce axle load of driven axle to normal load condition)\r\n1000    Exhaust bellows\r\n1001    Force to bumper level\r\n1010 -1101    Not defined\r\n1110    Reserved\r\n1111    Don't care/take no action\r\n\r\nMode 1001 would be used to override other level change requests and force an immediate return to bumper level, e.g. in a situation where the vehicle is in danger of tilting.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1754": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 10,
      "SPN": 1754,
      "SPN_Name": "Below Nominal Level Rear Axle",
      "SPN_Description": "Signal which indicates whether the actual height of the rear axle is below the nominal (desired) level for the rear axle. For explanations of nominal level see SPN 1734 - Nominal Level Front Axle.\r\n\r\n00 Not below\r\n01 Below\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1755": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 18,
      "SPN": 1755,
      "SPN_Name": "Lowering Control Mode Rear Axle",
      "SPN_Description": "Signal which indicates the actual lowering level change at the rear axle\r\n\r\n00 Lowering not active\r\n01 Lowering active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1756": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 22,
      "SPN": 1756,
      "SPN_Name": "Lifting Control Mode Rear Axle",
      "SPN_Description": "Signal which indicates the actual lifting level change at the rear axle\r\n\r\n00 Lifting not active\r\n01 Lifting active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1757": {
      "PGN": 53504,
      "PGN_Name": "Air Suspension Control 6",
      "PGN_Description": "ASC6",
      "first_bit": 16,
      "SPN": 1757,
      "SPN_Name": "Level Preset Front Axle Right",
      "SPN_Description": "Set value for nominal level 'preset level' at the right side of the front axle. This value is referred to 'Normal level 1'.  For explanations of normal level 1 see SPN 1734 - Nominal Level Front Axle.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3200,
      "unit": "mm",
      "SLOT_ID": 13
    },
    "1758": {
      "PGN": 53504,
      "PGN_Name": "Air Suspension Control 6",
      "PGN_Description": "ASC6",
      "first_bit": 32,
      "SPN": 1758,
      "SPN_Name": "Level Preset Rear Axle Left",
      "SPN_Description": "Set value for nominal level 'preset level' at the left side of the rear axle. This value is referred to 'Normal level 1'.  For explanations of normal level 1 see SPN 1734 - Nominal Level Front Axle.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3200,
      "unit": "mm",
      "SLOT_ID": 13
    },
    "1759": {
      "PGN": 65140,
      "PGN_Name": "Modify Leveling System Control Set Point",
      "PGN_Description": "LSP",
      "first_bit": 16,
      "SPN": 1759,
      "SPN_Name": "Blade Height Set Point (High Resolution)",
      "SPN_Description": "High resolution for the laser guided blade set point.  The high resolution required for more accurate control and 'accurate' unit conversions.\r\n\r\nNegative values are below grade, positive values are above grade, zero is on grade.",
      "bit_length": 32,
      "scaling": 1e-7,
      "offset": -209.7152,
      "unit": "m",
      "SLOT_ID": 142
    },
    "1760": {
      "PGN": 65136,
      "PGN_Name": "Combination Vehicle Weight",
      "PGN_Description": "CVW",
      "first_bit": 16,
      "SPN": 1760,
      "SPN_Name": "Gross Combination Vehicle Weight",
      "SPN_Description": "The total weight of the truck and all attached trailers.",
      "bit_length": 16,
      "scaling": 10,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 29
    },
    "1761": {
      "PGN": 65110,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "AT1T1I1",
      "first_bit": 0,
      "SPN": 1761,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank Volume",
      "SPN_Description": "Ratio of volume of diesel exhaust fluid to the total volume of diesel exhaust fluid storage container for aftertreatment system 1 (exhaust bank 1).  0% is empty and 100% is full.  See SPN 3517 and SPN 7530 for alternate measurements.\r\n\r\nParameter Specific Indicator:\r\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1762": {
      "PGN": 61448,
      "PGN_Name": "Hydraulic Pressure Governor Info",
      "PGN_Description": "HPG",
      "first_bit": 0,
      "SPN": 1762,
      "SPN_Name": "Hydraulic Pressure",
      "SPN_Description": "Hydraulic pressure measured at the output of the hydraulic pump.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 106
    },
    "1763": {
      "PGN": 61448,
      "PGN_Name": "Hydraulic Pressure Governor Info",
      "PGN_Description": "HPG",
      "first_bit": 16,
      "SPN": 1763,
      "SPN_Name": "Engine Hydraulic Pressure Governor Mode Indicator",
      "SPN_Description": "Mode for governor operation is hydraulic pressure control.\r\n\r\n00 Disabled\r\n01 Enabled\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1764": {
      "PGN": 61448,
      "PGN_Name": "Hydraulic Pressure Governor Info",
      "PGN_Description": "HPG",
      "first_bit": 18,
      "SPN": 1764,
      "SPN_Name": "Engine Hydraulic Pressure Governor Switch",
      "SPN_Description": "Switch that sets the  mode of hydraulic governor\r\n\r\n00 Pressure Mode Inactive\r\n01 Pressure Mode Active\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1765": {
      "PGN": 65153,
      "PGN_Name": "Fuel Information 2 (Gaseous)",
      "PGN_Description": "GFI2",
      "first_bit": 48,
      "SPN": 1765,
      "SPN_Name": "Engine Fuel Valve 1 Commanded Position",
      "SPN_Description": "The commanded position of the first fuel valve that is metering the fuel flow to the engine.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1766": {
      "PGN": 65153,
      "PGN_Name": "Fuel Information 2 (Gaseous)",
      "PGN_Description": "GFI2",
      "first_bit": 56,
      "SPN": 1766,
      "SPN_Name": "Engine Fuel Valve 2 Commanded Position",
      "SPN_Description": "The commanded position of the second fuel valve that is metering the fuel flow to the engine.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1767": {
      "PGN": 65109,
      "PGN_Name": "Gaseous Fuel Properties",
      "PGN_Description": "GFD",
      "first_bit": 0,
      "SPN": 1767,
      "SPN_Name": "Specific Heat Ratio",
      "SPN_Description": "The specific heat ratio of the fuel.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 32
    },
    "1768": {
      "PGN": 65108,
      "PGN_Name": "Engine Continuous Torque & Speed Limit",
      "PGN_Description": "ECT1",
      "first_bit": 0,
      "SPN": 1768,
      "SPN_Name": "Engine Low Limit Threshold for Maximum RPM from Engine",
      "SPN_Description": "Minimum allowable value for maximum continuous RPM from engine",
      "bit_length": 8,
      "scaling": 32,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 97
    },
    "1769": {
      "PGN": 65108,
      "PGN_Name": "Engine Continuous Torque & Speed Limit",
      "PGN_Description": "ECT1",
      "first_bit": 8,
      "SPN": 1769,
      "SPN_Name": "Engine High Limit Threshold for Minimum Continuous Engine RPM",
      "SPN_Description": "Maximum allowable value for minimum continuous RPM from engine",
      "bit_length": 8,
      "scaling": 32,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 97
    },
    "1770": {
      "PGN": 65108,
      "PGN_Name": "Engine Continuous Torque & Speed Limit",
      "PGN_Description": "ECT1",
      "first_bit": 16,
      "SPN": 1770,
      "SPN_Name": "Engine Low Limit Threshold for Maximum Torque from Engine",
      "SPN_Description": "Minimum allowable value for maximum continuous torque from engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1771": {
      "PGN": 65108,
      "PGN_Name": "Engine Continuous Torque & Speed Limit",
      "PGN_Description": "ECT1",
      "first_bit": 24,
      "SPN": 1771,
      "SPN_Name": "Engine High Limit Threshold for Minimum Continuous Torque from Engine",
      "SPN_Description": "Maximum allowable value for minimum continuous torque from engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1772": {
      "PGN": 65108,
      "PGN_Name": "Engine Continuous Torque & Speed Limit",
      "PGN_Description": "ECT1",
      "first_bit": 32,
      "SPN": 1772,
      "SPN_Name": "Engine Maximum Continuous RPM",
      "SPN_Description": "Applied limit for maximum continuous engine RPM",
      "bit_length": 8,
      "scaling": 32,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 97
    },
    "1773": {
      "PGN": 65108,
      "PGN_Name": "Engine Continuous Torque & Speed Limit",
      "PGN_Description": "ECT1",
      "first_bit": 40,
      "SPN": 1773,
      "SPN_Name": "Engine Minimum Continuous RPM",
      "SPN_Description": "Applied limit for minimum continuous engine RPM",
      "bit_length": 8,
      "scaling": 32,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 97
    },
    "1774": {
      "PGN": 65108,
      "PGN_Name": "Engine Continuous Torque & Speed Limit",
      "PGN_Description": "ECT1",
      "first_bit": 48,
      "SPN": 1774,
      "SPN_Name": "Engine Maximum Continuous Torque",
      "SPN_Description": "Applied limit for maximum continuous engine torque.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1775": {
      "PGN": 65108,
      "PGN_Name": "Engine Continuous Torque & Speed Limit",
      "PGN_Description": "ECT1",
      "first_bit": 56,
      "SPN": 1775,
      "SPN_Name": "Engine Minimum Continuous Torque",
      "SPN_Description": "Applied limit for minimum continuous engine torque",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1776": {
      "PGN": 65107,
      "PGN_Name": "Retarder Continuous Torque & Speed Limit",
      "PGN_Description": "RTC1",
      "first_bit": 0,
      "SPN": 1776,
      "SPN_Name": "Low Limit Threshold for Maximum RPM from Retarder",
      "SPN_Description": "Minimum allowable value for maximum continuous retarder speed",
      "bit_length": 8,
      "scaling": 32,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 97
    },
    "1777": {
      "PGN": 65107,
      "PGN_Name": "Retarder Continuous Torque & Speed Limit",
      "PGN_Description": "RTC1",
      "first_bit": 8,
      "SPN": 1777,
      "SPN_Name": "High Limit Threshold for Minimum Continuous RPM from Retarder",
      "SPN_Description": "Maximum allowable value for minimum continuous retarder speed",
      "bit_length": 8,
      "scaling": 32,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 97
    },
    "1778": {
      "PGN": 65107,
      "PGN_Name": "Retarder Continuous Torque & Speed Limit",
      "PGN_Description": "RTC1",
      "first_bit": 16,
      "SPN": 1778,
      "SPN_Name": "Low Limit Threshold for Maximum Torque from Retarder",
      "SPN_Description": "Minimum allowable value for maximum continuous retarder torque.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1779": {
      "PGN": 65107,
      "PGN_Name": "Retarder Continuous Torque & Speed Limit",
      "PGN_Description": "RTC1",
      "first_bit": 24,
      "SPN": 1779,
      "SPN_Name": "High Limit Threshold for Minimum Continuous Torque from Retarder",
      "SPN_Description": "Maximum allowable value for minimum continuous retarder torque.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1780": {
      "PGN": 65107,
      "PGN_Name": "Retarder Continuous Torque & Speed Limit",
      "PGN_Description": "RTC1",
      "first_bit": 32,
      "SPN": 1780,
      "SPN_Name": "Maximum Continuous Retarder Speed ",
      "SPN_Description": "Applied limit for maximum continuous retarder RPM",
      "bit_length": 8,
      "scaling": 32,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 97
    },
    "1781": {
      "PGN": 65107,
      "PGN_Name": "Retarder Continuous Torque & Speed Limit",
      "PGN_Description": "RTC1",
      "first_bit": 40,
      "SPN": 1781,
      "SPN_Name": "Minimum Continuous Retarder Speed",
      "SPN_Description": "Applied limit for minimum continuous retarder RPM",
      "bit_length": 8,
      "scaling": 32,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 97
    },
    "1782": {
      "PGN": 65107,
      "PGN_Name": "Retarder Continuous Torque & Speed Limit",
      "PGN_Description": "RTC1",
      "first_bit": 48,
      "SPN": 1782,
      "SPN_Name": "Maximum Continuous Retarder Torque",
      "SPN_Description": "Applied limit for maximum continuous retarder torque.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1783": {
      "PGN": 65107,
      "PGN_Name": "Retarder Continuous Torque & Speed Limit",
      "PGN_Description": "RTC1",
      "first_bit": 56,
      "SPN": 1783,
      "SPN_Name": "Minimum Continuous Retarder Torque",
      "SPN_Description": "Applied limit for minimum continuous retarder torque",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1784": {
      "PGN": 52992,
      "PGN_Name": "Continuous Torque & Speed Limit Request",
      "PGN_Description": "CTL",
      "first_bit": 0,
      "SPN": 1784,
      "SPN_Name": "Engine Speed Limit Request - Minimum Continuous",
      "SPN_Description": "Requested minimum continuous engine speed",
      "bit_length": 8,
      "scaling": 32,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 97
    },
    "1785": {
      "PGN": 52992,
      "PGN_Name": "Continuous Torque & Speed Limit Request",
      "PGN_Description": "CTL",
      "first_bit": 8,
      "SPN": 1785,
      "SPN_Name": "Engine Speed Limit Request - Maximum Continuous",
      "SPN_Description": "Requested maximum continuous engine speed",
      "bit_length": 8,
      "scaling": 32,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 97
    },
    "1786": {
      "PGN": 52992,
      "PGN_Name": "Continuous Torque & Speed Limit Request",
      "PGN_Description": "CTL",
      "first_bit": 16,
      "SPN": 1786,
      "SPN_Name": "Engine Torque Limit Request - Minimum Continuous",
      "SPN_Description": "Requested minimum continuous engine torque (operating range: 0 to 125%)",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1787": {
      "PGN": 52992,
      "PGN_Name": "Continuous Torque & Speed Limit Request",
      "PGN_Description": "CTL",
      "first_bit": 24,
      "SPN": 1787,
      "SPN_Name": "Engine Torque Limit Request - Maximum Continuous",
      "SPN_Description": "Requested maximum continuous engine torque (operating range: 0 to 125%)",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1788": {
      "PGN": 52992,
      "PGN_Name": "Continuous Torque & Speed Limit Request",
      "PGN_Description": "CTL",
      "first_bit": 32,
      "SPN": 1788,
      "SPN_Name": "Minimum Continuous Retarder Speed Limit Request",
      "SPN_Description": "Requested minimum continuous retarder speed",
      "bit_length": 8,
      "scaling": 32,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 97
    },
    "1789": {
      "PGN": 52992,
      "PGN_Name": "Continuous Torque & Speed Limit Request",
      "PGN_Description": "CTL",
      "first_bit": 40,
      "SPN": 1789,
      "SPN_Name": "Maximum Continuous Retarder Speed Limit Request",
      "SPN_Description": "Requested maximum continuous retarder speed",
      "bit_length": 8,
      "scaling": 32,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 97
    },
    "1790": {
      "PGN": 52992,
      "PGN_Name": "Continuous Torque & Speed Limit Request",
      "PGN_Description": "CTL",
      "first_bit": 48,
      "SPN": 1790,
      "SPN_Name": "Minimum Continuous Retarder Torque Limit Request",
      "SPN_Description": "Requested minimum continuous retarder torque (operating range: -125 to 0%)",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1791": {
      "PGN": 52992,
      "PGN_Name": "Continuous Torque & Speed Limit Request",
      "PGN_Description": "CTL",
      "first_bit": 56,
      "SPN": 1791,
      "SPN_Name": "Maximum Continuous Retarder Torque Limit Request",
      "SPN_Description": "Requested maximum continuous retarder torque (operating range: -125 to 0%)",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "1792": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 62,
      "SPN": 1792,
      "SPN_Name": "Tractor-Mounted Trailer ABS Warning Signal",
      "SPN_Description": "This parameter commands the tractor-mounted trailer ABS optical warning signal.\r\n\r\n00 Off\r\n01 On \r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1793": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 46,
      "SPN": 1793,
      "SPN_Name": "ATC/ASR Information Signal",
      "SPN_Description": "This parameter commands the ATC/ASR driver information signal, for example a dash lamp.\r\n\r\n00 Off\r\n01 On \r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1794": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 240,
      "SPN": 1794,
      "SPN_Name": "Engine Moment of Inertia",
      "SPN_Description": "Moment of inertia for the engine, including items driven full-time by the engine such as fuel, oil and cooling pumps.  The inertia from the following items are not included: flywheel, alternator, compressor, fan, and other engine-driven accessories.",
      "bit_length": 16,
      "scaling": 0.004,
      "offset": 0,
      "unit": "kg•m²",
      "SLOT_ID": 112
    },
    "1795": {
      "PGN": 65106,
      "PGN_Name": "Vehicle Electrical Power 3",
      "PGN_Description": "VEP3",
      "first_bit": 0,
      "SPN": 1795,
      "SPN_Name": "Alternator Current (High Range/Resolution)",
      "SPN_Description": "This parameter indicates the amount of electrical current output from the alternator of the main vehicle.  Alternator Current (SPN 115) has a lower range and resolution.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -1600,
      "unit": "A",
      "SLOT_ID": 104
    },
    "1796": {
      "PGN": 65135,
      "PGN_Name": "Adaptive Cruise Control 1",
      "PGN_Description": "ACC1",
      "first_bit": 52,
      "SPN": 1796,
      "SPN_Name": "ACC Distance Alert Signal",
      "SPN_Description": "Signal to indicate to the operator that the ACC system is not able to maintain the distance to the target. Example: Target stopping rapidly. This signal may be used to activate warning sounds or indicators.\r\n\r\n00 ACC DAS Not Active\r\n01 ACC DAS Active\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1797": {
      "PGN": 65135,
      "PGN_Name": "Adaptive Cruise Control 1",
      "PGN_Description": "ACC1",
      "first_bit": 50,
      "SPN": 1797,
      "SPN_Name": "ACC System Shutoff Warning",
      "SPN_Description": "Signal to warn the driver of system deactivation due to non-driver actions. Example: Attempting to control vehicle speed below or above limits of ACC. This signal may be used to activate warning sounds or indicators.\r\n\r\n00 ACC SSOW Not Active\r\n01 ACC SSOW Active\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1798": {
      "PGN": 65135,
      "PGN_Name": "Adaptive Cruise Control 1",
      "PGN_Description": "ACC1",
      "first_bit": 48,
      "SPN": 1798,
      "SPN_Name": "ACC Target Detected",
      "SPN_Description": "Signal to indicate to the driver that the ACC system has detected a target. \r\n\r\n00 No targets detected\r\n01 Target detected\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1799": {
      "PGN": 65105,
      "PGN_Name": "Adaptive Cruise Control, Operator Input",
      "PGN_Description": "ACC2",
      "first_bit": 5,
      "SPN": 1799,
      "SPN_Name": "Requested ACC Distance Mode",
      "SPN_Description": "The Requested Distance Control Mode to the ACC system from the operators interface.\r\n\r\nThe ACC Set Distance Mode (SPN 1589) indicates the selected Distance Control Mode for the ACC system. This parameter is the driver requested setting for this.\r\n\r\n000 Requested ACC Distance Mode #1 (largest distance)\r\n001 Requested ACC Distance Mode #2\r\n010 Requested ACC Distance Mode #3\r\n011 Requested ACC Distance Mode #4\r\n100 Requested ACC Distance Mode #5 (shortest distance)\r\n101 not defined\r\n110 error condition\r\n111 not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "1800": {
      "PGN": 65104,
      "PGN_Name": "Battery Temperature",
      "PGN_Description": "BT1",
      "first_bit": 0,
      "SPN": 1800,
      "SPN_Name": "SLI Battery 1 Temperature",
      "SPN_Description": "Temperature of the battery 1 used for starting the engine, for lighting, and for ignition (SLI). \r\n\r\nThe relation to physical location is determined by the equipment manufacturer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1801": {
      "PGN": 65104,
      "PGN_Name": "Battery Temperature",
      "PGN_Description": "BT1",
      "first_bit": 8,
      "SPN": 1801,
      "SPN_Name": "SLI Battery 2 Temperature",
      "SPN_Description": "Temperature of the second battery or second set of batteries used for starting the engine, for lighting, and for ignition (SLI). \r\n\r\nThe relation to physical location is determined by the equipment manufacturer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1802": {
      "PGN": 65189,
      "PGN_Name": "Intake Manifold Information 2",
      "PGN_Description": "IMT2",
      "first_bit": 24,
      "SPN": 1802,
      "SPN_Name": "Engine Intake Manifold 5 Temperature",
      "SPN_Description": "Temperature of pre-combustion air found in intake manifold number 5 of engine air supply system.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1803": {
      "PGN": 65189,
      "PGN_Name": "Intake Manifold Information 2",
      "PGN_Description": "IMT2",
      "first_bit": 32,
      "SPN": 1803,
      "SPN_Name": "Engine Intake Manifold 6 Temperature",
      "SPN_Description": "Temperature of pre-combustion air found in intake manifold  number 6 of engine air supply system.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "1804": {
      "PGN": 64966,
      "PGN_Name": "Cold Start Aids",
      "PGN_Description": "CSA",
      "first_bit": 2,
      "SPN": 1804,
      "SPN_Name": "Engine Start Enable Device 2",
      "SPN_Description": "Devices that assist an engine in starting, e.g. intake heaters, ether, or an alternate/secondary starting aid.  May be of the same type or different than Start Enable Device 1 (SPN 626). Parameter indicating whether the start enable device 2 is ON or OFF.\r\n\r\n00 - start enable OFF\r\n01 - start enable ON\r\n10 - reserved\r\n11 - not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1805": {
      "PGN": 65142,
      "PGN_Name": "Laser Leveling System Vertical Position Display Data",
      "PGN_Description": "LVDD",
      "first_bit": 8,
      "SPN": 1805,
      "SPN_Name": "LED Display Mode Control",
      "SPN_Description": "This parameter informs the system what the selected Display mode will be.\r\n\r\n0000 - Center On-Grade Display Mode 1 ( 5 CHANNEL )\r\n0001 - Offset On-Grade Display Mode \r\n0010 - Center On-Grade Display Mode 2 ( 7 CHANNEL )\r\n0011 - 1110 Reserved\r\n1111 - Not Available or Not Applicable",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1806": {
      "PGN": 65142,
      "PGN_Name": "Laser Leveling System Vertical Position Display Data",
      "PGN_Description": "LVDD",
      "first_bit": 12,
      "SPN": 1806,
      "SPN_Name": "LED Display Deadband Control",
      "SPN_Description": "This parameter informs the system what the selected Display deadband will be.\r\n\r\n0000    +/- 4.5 mm  (0.015 feet, 0.18 inches)\r\n0001    +/- 12 mm   (0.040 feet, 0.45 inches)\r\n0010    +/- 24 mm   (0.080 feet, 0.96 inches)\r\n0011    +/- 5  mm    (0.017 feet, 0.2 inches)\r\n0100    +/- 1 mm     (0.003 feet, 0.04 inches)\r\n0101  - 1110  Reserved\r\n1111    Not Available or Not applicable",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1807": {
      "PGN": 61449,
      "PGN_Name": "Vehicle Dynamic Stability Control 2",
      "PGN_Description": "VDC2",
      "first_bit": 0,
      "SPN": 1807,
      "SPN_Name": "Steering Wheel Angle",
      "SPN_Description": "The main operator`s steering wheel angle (on the steering column, not the actual wheel angle).  The vehicle being steered to the left (counterclockwise) results in a positive steering wheel angle.  This is the yaw angle of the steering wheel with the z-axis along the centerline of the steering column. This parameter is defined according to a Z-Up axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Up Axis System has positive X directed forward, positive Y to the left, and positive Z directed up.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": -31.374,
      "unit": "rad",
      "SLOT_ID": 113
    },
    "1808": {
      "PGN": 61449,
      "PGN_Name": "Vehicle Dynamic Stability Control 2",
      "PGN_Description": "VDC2",
      "first_bit": 24,
      "SPN": 1808,
      "SPN_Name": "Yaw Rate",
      "SPN_Description": "Indicates the rate of rotation about the vertical axis (i.e. the z-axis).  A positive yaw rate signal results when the vehicle turns counter-clockwise.   This parameter is defined according to a Z-Up axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Up Axis System has positive X directed forward, positive Y to the left, and positive Z directed up.  See SPN 4985 for an alternate range and resolution using a Z-Down Axis System.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -3.92,
      "unit": "rad/s",
      "SLOT_ID": 114
    },
    "1809": {
      "PGN": 61449,
      "PGN_Name": "Vehicle Dynamic Stability Control 2",
      "PGN_Description": "VDC2",
      "first_bit": 40,
      "SPN": 1809,
      "SPN_Name": "Lateral Acceleration",
      "SPN_Description": "Indicates a lateral acceleration of the vehicle (the component of vehicle acceleration vector along the Y-axis). A positive lateral acceleration signal results when the vehicle is accelerated to the left.  This parameter is defined according to a Z-Up axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Up Axis System has positive X directed forward, positive Y to the left, and positive Z directed up.  See SPN 5347 for an alternate range and resolution.",
      "bit_length": 16,
      "scaling": 0.00048828125,
      "offset": -15.687,
      "unit": "m/s²",
      "SLOT_ID": 115
    },
    "1810": {
      "PGN": 61449,
      "PGN_Name": "Vehicle Dynamic Stability Control 2",
      "PGN_Description": "VDC2",
      "first_bit": 56,
      "SPN": 1810,
      "SPN_Name": "Longitudinal Acceleration",
      "SPN_Description": "Indicates the longitudinal acceleration of the vehicle. A positive longitudinal acceleration signal results when the vehicle speed increases, regardless of driving the vehicle forward or backward.  This parameter is applicable to vehicle speed measurement systems, such as passive wheel speed sensors, that are not capable of determining the direction of the vehicle motion.  See SPN 5348 for an alternate longitudinal acceleration.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "m/s²",
      "SLOT_ID": 140
    },
    "1811": {
      "PGN": 61449,
      "PGN_Name": "Vehicle Dynamic Stability Control 2",
      "PGN_Description": "VDC2",
      "first_bit": 16,
      "SPN": 1811,
      "SPN_Name": "Steering Wheel Turn Counter",
      "SPN_Description": "Indicates number of steering wheel turns, absolute position or relative position at ignition on. Positive values indicate left turns.",
      "bit_length": 6,
      "scaling": 1,
      "offset": -32,
      "unit": "turns",
      "SLOT_ID": 141
    },
    "1812": {
      "PGN": 61449,
      "PGN_Name": "Vehicle Dynamic Stability Control 2",
      "PGN_Description": "VDC2",
      "first_bit": 22,
      "SPN": 1812,
      "SPN_Name": "Steering Wheel Angle Sensor Type",
      "SPN_Description": "Indicates whether the steering wheel angle sensor is capable of absolute measuring of the number of steering wheel turns or not (relative measuring to position at ignition on).\r\n\r\n00 Relative measuring principle\r\n01 Absolute measuring principle\r\n10 Reserved\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1813": {
      "PGN": 65103,
      "PGN_Name": "Vehicle Dynamic Stability Control 1",
      "PGN_Description": "VDC1",
      "first_bit": 0,
      "SPN": 1813,
      "SPN_Name": "VDC Information Signal",
      "SPN_Description": "This parameter commands the VDC information signal, for example a dash lamp.\r\n\r\n00 Off\r\n01 On\r\n10 Reserved\r\n11 Don't care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1814": {
      "PGN": 65103,
      "PGN_Name": "Vehicle Dynamic Stability Control 1",
      "PGN_Description": "VDC1",
      "first_bit": 2,
      "SPN": 1814,
      "SPN_Name": "VDC Fully Operational",
      "SPN_Description": "Signal that indicates whether VDC is fully operational or whether its functionality is reduced by a permanent or temporary (e.g. low voltage) defect, by intended action (e.g. disabled by a switch or during special diagnostic procedures), not configured or not yet fully initialized (e.g. missing initialization or configuration message). VDC contains ROP and YC.\r\n\r\n00 Not fully operational\r\n01 Fully operational\r\n10 Reserved\r\n11 Don't care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1815": {
      "PGN": 65103,
      "PGN_Name": "Vehicle Dynamic Stability Control 1",
      "PGN_Description": "VDC1",
      "first_bit": 4,
      "SPN": 1815,
      "SPN_Name": "VDC brake light request",
      "SPN_Description": "Indicates whether VDC requests to turn the vehicle brake lights on\r\n\r\n00 Turn brake light not on\r\n01 Turn brake light on\r\n10 Reserved\r\n11 Don't care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1816": {
      "PGN": 65103,
      "PGN_Name": "Vehicle Dynamic Stability Control 1",
      "PGN_Description": "VDC1",
      "first_bit": 8,
      "SPN": 1816,
      "SPN_Name": "ROP Engine Control active",
      "SPN_Description": "State Signal which indicates that the Roll Over Prevention (ROP) has commanded engine control to be active. Within the physical limits, ROP attempts to prevent rolling over of the vehicle. Active means that ROP actually tries to control the engine. This state signal is independent of other control commands to the engine which may have higher priority.\r\n\r\n00 ROP engine control passive but installed\r\n01 ROP engine control active\r\n10 Reserved\r\n11 Don't care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1817": {
      "PGN": 65103,
      "PGN_Name": "Vehicle Dynamic Stability Control 1",
      "PGN_Description": "VDC1",
      "first_bit": 12,
      "SPN": 1817,
      "SPN_Name": "YC Engine Control active",
      "SPN_Description": "State Signal which indicates that the Yaw Control (YC) has commanded engine control to be active. Within the physical limits, YC attempts to prevent yawing of the vehicle. Active means that YC actually tries to control the engine. This state signal is independent of other control commands to the engine which may have higher priority.\r\n\r\n00 YC engine control passive but installed\r\n01 YC engine control active\r\n10 Reserved\r\n11 Don't care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1818": {
      "PGN": 65103,
      "PGN_Name": "Vehicle Dynamic Stability Control 1",
      "PGN_Description": "VDC1",
      "first_bit": 10,
      "SPN": 1818,
      "SPN_Name": "ROP Brake Control active",
      "SPN_Description": "State signal which indicates that Roll over Prevention (ROP) has activated brake control. Active means that ROP actually controls wheel brake pressure at one or more wheels of the vehicle or vehicle combination. Within the physical limits, ROP attempts to prevent rolling over of the vehicle.\r\n\r\n00 ROP brake control passive but installed\r\n01 ROP brake control active\r\n10 Reserved\r\n11 Don't care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1819": {
      "PGN": 65103,
      "PGN_Name": "Vehicle Dynamic Stability Control 1",
      "PGN_Description": "VDC1",
      "first_bit": 14,
      "SPN": 1819,
      "SPN_Name": "YC Brake Control active",
      "SPN_Description": "State signal which indicates that Yaw Control (YC) has activated brake control. Active means that YC actually controls wheel brake pressure at one or more wheels of the vehicle or vehicle combination. Within the physical limits, YC attempts to prevent yawing of the vehicle.\r\n\r\n00 YC brake control passive but installed\r\n01 YC brake control active\r\n10 Reserved\r\n11 Don't care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1820": {
      "PGN": 65102,
      "PGN_Name": "Door Control 1",
      "PGN_Description": "DC1",
      "first_bit": 4,
      "SPN": 1820,
      "SPN_Name": "Ramp / Wheel Chair Lift Position",
      "SPN_Description": "Signal which indicates the actual position of the ramp / wheel chair lift.\r\n\r\n00 Inside bus\r\n01 Outside bus\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1821": {
      "PGN": 65102,
      "PGN_Name": "Door Control 1",
      "PGN_Description": "DC1",
      "first_bit": 0,
      "SPN": 1821,
      "SPN_Name": "Position of doors",
      "SPN_Description": "Signal which indicates the actual position of the doors.\r\n\r\n0000 At least 1 door is open\r\n0001 Closing last door\r\n0010 All doors closed\r\n0011-1101 Not defined\r\n1110 Error\r\n1111 Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1822": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 46,
      "SPN": 1822,
      "SPN_Name": "Lift Axle 2 Position",
      "SPN_Description": "Signal which indicates the position / load condition of lift axle / tag axle #2.   Numbering of lift/tag axles starts at front axle.  See SPN 6844 for more detail.\r\n\r\n00 Lift axle position down / tag axle laden\r\n01 Lift axle position up / tag axle unladen\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1823": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 42,
      "SPN": 1823,
      "SPN_Name": "Rear Axle in Bumper Range",
      "SPN_Description": "Signal which indicates that the vehicle height at the rear axle (SPNs 1723 and 1724) is within the bumper range.\r\n\r\n00 Actual level out of bumper range\r\n01 Actual level within bumper range\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1824": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 40,
      "SPN": 1824,
      "SPN_Name": "Front Axle in Bumper Range",
      "SPN_Description": "Signal which indicates that the vehicle height at the front axle (SPNs 1721 and 1722) is within the bumper range.\r\n\r\n00 Actual level out of bumper range\r\n01 Actual level within bumper range\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1825": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 50,
      "SPN": 1825,
      "SPN_Name": "Suspension Remote control 2",
      "SPN_Description": "Signal which indicates that the suspension system is controlled by remote control #2. Remote control is an external unit to operate the suspension system.\r\n\r\n00 Not active\r\n01 Active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1826": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 48,
      "SPN": 1826,
      "SPN_Name": "Suspension Remote Control 1",
      "SPN_Description": "Signal which indicates that the suspension system is controlled by remote control #1. Remote control is an external unit to operate the suspension system.\r\n\r\n00 Not active\r\n01 Active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1827": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 56,
      "SPN": 1827,
      "SPN_Name": "Suspension Control Refusal Information",
      "SPN_Description": "Signal which indicates that the air suspension control cannot perform a request due to the operating conditions. It also provides a reason for the refusal.\r\n\r\n0000 Actual request not refused\r\n0001 Axle load limit reached  (load transfer)\r\n0010 Would exceed axle load limit (tag axle)\r\n0011 Bogie differential not locked\r\n0100 Above speed limit\r\n0101 Below speed limit\r\n0110 General reject; I.e. no specified reason applies\r\n0111 Requested level not available\r\n1000 - 1101  Not defined\r\n1110 Error\r\n1111 Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "1828": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 22,
      "SPN": 1828,
      "SPN_Name": "Lift Axle 2 Position Command",
      "SPN_Description": "Signal to command the position / load condition of lift / tag axle #2.  Numbering of lift/tag axles starts at front axle.\r\n\r\n00 Lift axle position down / tag axle laden\r\n01 Lift axle position up / tag axle unladen\r\n10 Reserved\r\n11 Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1829": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 50,
      "SPN": 1829,
      "SPN_Name": "Kneeling Command - Rear Axle",
      "SPN_Description": "Command signal to activate the kneeling functionality at the rear axle of the vehicle.\r\n\r\n00 Deactivate kneeling\r\n01 Activate kneeling\r\n10 Reserved\r\n11 Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1830": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 48,
      "SPN": 1830,
      "SPN_Name": "Kneeling Command - Front Axle",
      "SPN_Description": "Command signal to activate the kneeling functionality at the front axle of the vehicle\r\n\r\n00 Deactivate kneeling\r\n01 Activate kneeling\r\n10 Reserved\r\n11 Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1831": {
      "PGN": 65111,
      "PGN_Name": "Air Suspension Control 5",
      "PGN_Description": "ASC5",
      "first_bit": 28,
      "SPN": 1831,
      "SPN_Name": "Electronic Shock Absorber Control Mode - Lift/Tag Axle",
      "SPN_Description": "Signal which indicates the current mode of operation of the electronic shock absorber control at the lift/tag axle.\r\n\r\n00 Normal operation dampers passive\r\n01 Normal operation dampers active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1832": {
      "PGN": 65111,
      "PGN_Name": "Air Suspension Control 5",
      "PGN_Description": "ASC5",
      "first_bit": 26,
      "SPN": 1832,
      "SPN_Name": "Electronic Shock Absorber Control Mode - Rear Axle",
      "SPN_Description": "Signal which indicates the current mode of operation of the electronic shock absorber control at the rear axle.\r\n\r\n00 Normal operation dampers passive\r\n01 Normal operation dampers active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1833": {
      "PGN": 65111,
      "PGN_Name": "Air Suspension Control 5",
      "PGN_Description": "ASC5",
      "first_bit": 24,
      "SPN": 1833,
      "SPN_Name": "Electronic Shock Absorber Control Mode -  Front Axle",
      "SPN_Description": "Signal which indicates the current mode of operation of the electronic shock absorber control at the front axle.\r\n\r\n00 Normal operation dampers passive\r\n01 Normal operation dampers active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1834": {
      "PGN": 65101,
      "PGN_Name": "Total Averaged Information",
      "PGN_Description": "TAVG",
      "first_bit": 0,
      "SPN": 1834,
      "SPN_Name": "Engine Total Average Fuel Rate",
      "SPN_Description": "Average fuel rate, equal to total fuel used divided by total engine hours, over the life of the engine",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "l/h",
      "SLOT_ID": 42
    },
    "1835": {
      "PGN": 65101,
      "PGN_Name": "Total Averaged Information",
      "PGN_Description": "TAVG",
      "first_bit": 16,
      "SPN": 1835,
      "SPN_Name": "Engine Total Average Fuel Economy",
      "SPN_Description": "Average fuel economy, equal to total vehicle distance divided by total fuel used, over the life of the engine",
      "bit_length": 16,
      "scaling": 0.001953125,
      "offset": 0,
      "unit": "km/L",
      "SLOT_ID": 16
    },
    "1836": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 60,
      "SPN": 1836,
      "SPN_Name": "Trailer ABS Status",
      "SPN_Description": "State signal which indicates that ABS in the trailer is actively controlling the brakes.  A message is sent to the tractor from the trailer (i.e. by PLC). The receiving device in the tractor transfers this information to the J1939 network.  At the beginning of power on the message is sent by the trailer to indicate if this status information is supported. Timeout of the trailer ABS active can be done by monitoring of the Trailer warning light information.\r\n\r\n00 Trailer ABS Status Information Available But Not Active\r\n01 Trailer ABS Active\r\n10 Reserved\r\n11 Trailer ABS Status Information Not Available or Parameter Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1837": {
      "PGN": 65100,
      "PGN_Name": "Military Lighting Command",
      "PGN_Description": "ML",
      "first_bit": 6,
      "SPN": 1837,
      "SPN_Name": "Convoy Driving Lamp Select",
      "SPN_Description": "Black Out Convoy Driving Lamp Selection\r\n\r\n00 Off\r\n01 On\r\n10 Reserved\r\n11 Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1838": {
      "PGN": 65100,
      "PGN_Name": "Military Lighting Command",
      "PGN_Description": "ML",
      "first_bit": 4,
      "SPN": 1838,
      "SPN_Name": "Convoy Lamp Select",
      "SPN_Description": "Black Out Convoy Lamp Selection\r\n\r\n00 Off\r\n01 On\r\n10 Reserved\r\n11 Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1839": {
      "PGN": 65100,
      "PGN_Name": "Military Lighting Command",
      "PGN_Description": "ML",
      "first_bit": 2,
      "SPN": 1839,
      "SPN_Name": "Front Black Out Marker Lamp Select",
      "SPN_Description": "Front Black Out Marker Lamp Selection\r\n\r\n00 Off\r\n01 On\r\n10 Reserved\r\n11 Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1840": {
      "PGN": 65100,
      "PGN_Name": "Military Lighting Command",
      "PGN_Description": "ML",
      "first_bit": 0,
      "SPN": 1840,
      "SPN_Name": "Rear Black Out Marker Select",
      "SPN_Description": "Rear Black Out Marker Selection\r\n\r\n00 Off\r\n01 On\r\n10 Reserved\r\n11 Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1841": {
      "PGN": 65100,
      "PGN_Name": "Military Lighting Command",
      "PGN_Description": "ML",
      "first_bit": 22,
      "SPN": 1841,
      "SPN_Name": "Black Out Brake/Stop Lamp Select",
      "SPN_Description": "Black Out Brake/Stop Lamp Selection\r\n\r\n00 Off\r\n01 On\r\n10 Reserved\r\n11 Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1842": {
      "PGN": 65100,
      "PGN_Name": "Military Lighting Command",
      "PGN_Description": "ML",
      "first_bit": 30,
      "SPN": 1842,
      "SPN_Name": "Black Out Work Lamp Select",
      "SPN_Description": "Black Out Work Lamp Selection\r\n\r\n00 Off\r\n01 On\r\n10 Reserved\r\n11 Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1843": {
      "PGN": 65100,
      "PGN_Name": "Military Lighting Command",
      "PGN_Description": "ML",
      "first_bit": 24,
      "SPN": 1843,
      "SPN_Name": "Night Vision Illuminator Select",
      "SPN_Description": "Night Vision Illuminator Selection\r\n\r\n00 Off\r\n01 On\r\n10 Reserved\r\n11 Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1844": {
      "PGN": 65100,
      "PGN_Name": "Military Lighting Command",
      "PGN_Description": "ML",
      "first_bit": 56,
      "SPN": 1844,
      "SPN_Name": "Operators Black Out Intensity Selection",
      "SPN_Description": "Operators Selection of lamp intensity in black out mode.  This parameter provides the operators selected illumination intensity as a percentage of available full scale.  This parameter would be typically used as a dash or instrument cluster intensity adjustment.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "1845": {
      "PGN": 65099,
      "PGN_Name": "Transmission Configuration 2",
      "PGN_Description": "TCFG2",
      "first_bit": 0,
      "SPN": 1845,
      "SPN_Name": "Transmission Torque Limit",
      "SPN_Description": "Parameter provided to the engine from the transmission as a torque limit to be invoked by the engine in the event that J1939 communication with the transmission is lost.\r\n\r\nThe intention is to protect transmissions that use a continuous torque limit during torque converter mode or operation in specific lower gears, where stall or drivetrain torque may reach levels higher than the gearbox capacity.  If communication is lost during torque limited operation, unrestricted engine torque output could harm the transmission.\r\n\r\nIt is recommended that engines use reception of the ETC#1 message as a transmission “heartbeat”.  In the event that the ETC#1 message is not received in a time period of 5 times its’ broadcast rate (5 x 10 ms = 50 ms), the engine should invoke a torque limit holding the engine to less than or equal to the value of the Transmission Torque Limit parameter.  The engine may release the limit when transmission-to-engine communication is re-established.\r\n\r\nA value of 0xFF00 to 0xFFFF indicates that no transmission torque limit is desired.\r\n\r\nIt is expected that the engine will record this torque value in non-volatile memory and will include this in the engine configuration PGN as parameter Engine Default Torque Limit (SPN 1846)\r\n\r\nIf the engine observes change in this parameter value on power-up, the engine should record the new value.\r\n\r\nSPN 7827 provides an idle torque limit for the transmission in case of communications failure.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Nm",
      "SLOT_ID": 70
    },
    "1846": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 256,
      "SPN": 1846,
      "SPN_Name": "Engine Default Torque Limit",
      "SPN_Description": "Companion parameter to Transmission Torque Limit (SPN 1845).  This “echo” parameter provides confirmation to the transmission that the engine has received and will invoke the requested Transmission Torque Limit in the event that J1939 communication is lost between the two devices.\r\n\r\nIf the engine supports this protection logic, the Engine Default Torque Limit parameter should be set equal to the Transmission Torque Limit parameter as received in the Transmission Configuration 2 message (PGN 65099).  Otherwise, an Engine Default Torque Limit value of FF00 to FFFF indicates that no engine default torque limit has been received or set.\r\n\r\nThe intention is to protect transmissions that use a continuous torque limit during torque converter mode or operation in specific lower gears, where stall or drivetrain torque may reach levels higher than the gearbox capacity.  If communication is lost during torque limited operation, unrestricted engine torque output could harm the transmission.\r\n\r\nIt is recommended that engines use reception of the ETC#1 message as a transmission “heartbeat”.  In the event that the ETC#1 message is not received in a time period of 5 times its’ broadcast rate (5 x 10 ms = 50 ms), the engine should invoke a torque limit holding the engine to less than or equal to the value of the Transmission Torque Limit parameter.  The engine may release the limit when engine-to-transmission communication is re-established.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Nm",
      "SLOT_ID": 70
    },
    "1847": {
      "PGN": 64774,
      "PGN_Name": "Direct Lamp Control Command 2",
      "PGN_Description": "DLCC2",
      "first_bit": 10,
      "SPN": 1847,
      "SPN_Name": "Hill Holder Lamp Command",
      "SPN_Description": "Command signal directly controlling Hill Holder Lamp.\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Lamp Flash (1 Hz)\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1848": {
      "PGN": 64772,
      "PGN_Name": "Direct Lamp Control Data 2",
      "PGN_Description": "DLCD2",
      "first_bit": 10,
      "SPN": 1848,
      "SPN_Name": "Hill Holder Lamp Data",
      "SPN_Description": "This message will be transmitted by the controller that is illuminating the lamps.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1849": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 6,
      "SPN": 1849,
      "SPN_Name": "Transmission Requested Range Display Flash State",
      "SPN_Description": "State signal indicating a transmission request for the display of the Transmission Requested Range parameter (SPN 162) to flash or not to flash. The ‘Transmission Requested Range Display Flash State’ indicator can be utilized by (but not limited to) the shift console, instrument cluster, or cab display.  Definition of the cause of this state is at the discretion of the transmission manufacturer. The flash period shall be 700 ms @ 50% duty cycle.\r\n\r\nTransmission manufacturers may want to flash the Transmission Requested Range display depending on certain events.  It could be because a gear could not be attained, or because fluid is low, etc.  Indicator should be on for 350 ms and off for 350 ms.\r\n\r\nTransmissions supporting both this parameter and the Transmission Requested Range Display Blank \r\nState should treat the active states of these parameters as mutually exclusive; both parameters should not indicate \"active\" at the same time.\r\n\r\n00 Inactive; Transmission Requested Range display should not be flashing\r\n01 Active; Transmission Requested Range display should be flashing\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1850": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 4,
      "SPN": 1850,
      "SPN_Name": "Transmission Requested Range Display Blank State",
      "SPN_Description": "State signal indicating a transmission request for the display of the Transmission Requested Range parameter (SPN162) to be blanked or not blanked.  The ‘Transmission Requested Range Display Blank State’ indicator can be utilized by (but not limited to) the shift console, instrument cluster, or cab display.  Definition of the cause of this state is at the discretion of the transmission manufacturer\r\n\r\nTransmission manufacturers may want to blank the Transmission Requested Range display depending on certain events.  Typically it is an indication of a shift selector problem.\r\n\r\nTransmissions supporting both this parameter and the Transmission Requested Range Display Flash \r\nState should treat the active states of these parameters as mutually exclusive; both parameters should not indicate \"active\" at the same time.\r\n\r\n00 Inactive; Transmission Requested Range display should not be blanked\r\n01 Active; Transmission Requested Range display should be blanked\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1851": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 14,
      "SPN": 1851,
      "SPN_Name": "Transmission Shift Inhibit Indicator",
      "SPN_Description": "State signal indicating a transmission request for the Shift Inhibit Indicator to be active or inactive. The shift inhibit indicator can be of lamp or text form, located on (but not limited to) the shift console, instrument cluster, or cab display.  Definition of the cause of the ‘range inhibit’ state is at the discretion of the transmission manufacturer.\r\n\r\nTransmission manufacturers may want to indicate that they currently cannot make a requested shift. This could be due to inappropriate vehicle speed or other restrictions.\r\n\r\nDistinctions in meaning between the continuous and flashing are left to the transmission manufacturer.\r\n\r\n00 Inactive; shift is not inhibited\r\n01 Active (on continuously); shift is inhibited\r\n10 Active (flashing)\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1852": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 40,
      "SPN": 1852,
      "SPN_Name": "Transmission Mode 1",
      "SPN_Description": "Indicates whether transmission mode 1 is enabled.  Modes are manufacturer specific and are not necessarily mutually exclusive.  See also SPN 2536.\r\n\r\n00 Disable\r\n01 Enable\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1853": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 42,
      "SPN": 1853,
      "SPN_Name": "Transmission Mode 2",
      "SPN_Description": "Indicates whether transmission mode 2 is enabled.  Modes are manufacturer specific and are not necessarily mutually exclusive.  See also SPN 2537.\r\n\r\n00 Disable\r\n01 Enable\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1854": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 44,
      "SPN": 1854,
      "SPN_Name": "Transmission Mode 3",
      "SPN_Description": "Indicates whether transmission mode 3 is enabled.  Modes are manufacturer specific and are not necessarily mutually exclusive.  See also SPN 2538.\r\n\r\n00 Disable\r\n01 Enable\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1855": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 46,
      "SPN": 1855,
      "SPN_Name": "Transmission Mode 4",
      "SPN_Description": "Indicates whether transmission mode 4 is enabled.  Modes are manufacturer specific and are not necessarily mutually exclusive.  See also SPN 2539.\r\n\r\n00 Disable\r\n01 Enable\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1856": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 30,
      "SPN": 1856,
      "SPN_Name": "Seat Belt Switch",
      "SPN_Description": "State of switch used to determine if Seat Belt is buckled\r\n\r\n00 NOT Buckled\r\n01 OK - Seat Belt is buckled\r\n10 Error - Switch state cannot be determined\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "1857": {
      "PGN": 65128,
      "PGN_Name": "Vehicle Fluids",
      "PGN_Description": "VF",
      "first_bit": 10,
      "SPN": 1857,
      "SPN_Name": "Winch Oil Pressure Switch",
      "SPN_Description": "State of switch used to determine if Winch Oil Pressure is above desired minimum\r\n\r\n00 NOT OK- Oil pressure is too low\r\n01 OK - Oil pressure is above minimum\r\n10 Error - Switch state cannot be determined\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2347": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 6,
      "SPN": 2347,
      "SPN_Name": "High Beam Head Light Command",
      "SPN_Description": "Command to activate or de-activate the tractor high beam head light lamps. \r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2348": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 6,
      "SPN": 2348,
      "SPN_Name": "High Beam Head Light Data",
      "SPN_Description": "This parameter provides measured data from the tractor high beam head light lamps. \r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2349": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 4,
      "SPN": 2349,
      "SPN_Name": "Low Beam Head Light Command",
      "SPN_Description": "Command to activate or de-activate the tractor low beam head light lamps. \r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2350": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 4,
      "SPN": 2350,
      "SPN_Name": "Low Beam Head Light Data",
      "SPN_Description": "This parameter provides measured data from the tractor low beam head light lamps. \r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2351": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 2,
      "SPN": 2351,
      "SPN_Name": "Alternate Beam Head Light Command",
      "SPN_Description": "Command to activate or de-activate the tractor alternate head lights (only low beam is available on alternate head lights).  The alternate position lights are intended for use with loader and snow plows that tend to block the primary head lights.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2352": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 2,
      "SPN": 2352,
      "SPN_Name": "Alternate Beam Head Light Data",
      "SPN_Description": "This parameter provides measured data from the tractor alternate beam head light lamps. \r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2353": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 44,
      "SPN": 2353,
      "SPN_Name": "Tractor Front Low Mounted Work Lights Command",
      "SPN_Description": "Command to activate or de-activate the tractor front low mounted work lights.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2354": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 44,
      "SPN": 2354,
      "SPN_Name": "Tractor Front Low Mounted Work Lights",
      "SPN_Description": "This parameter provides measured data from the tractor front low mounted work lights. \r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2355": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 46,
      "SPN": 2355,
      "SPN_Name": "Tractor Front High Mounted Work Lights Command",
      "SPN_Description": "Command to activate or de-activate the tractor front high mounted work lights.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2356": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 46,
      "SPN": 2356,
      "SPN_Name": "Tractor Front High Mounted Work Lights",
      "SPN_Description": "This parameter provides measured data from the tractor front high mounted work lights. \r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2357": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 34,
      "SPN": 2357,
      "SPN_Name": "Tractor Underside Mounted Work Lights Command",
      "SPN_Description": "Command to activate or de-activate the tractor underside mounted work lights.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2358": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 34,
      "SPN": 2358,
      "SPN_Name": "Tractor Underside Mounted Work Lights",
      "SPN_Description": "This parameter provides measured data from the tractor underside mounted work lights. \r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2359": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 36,
      "SPN": 2359,
      "SPN_Name": "Tractor Rear Low Mounted Work Lights Command",
      "SPN_Description": "Command to activate or de-activate the tractor rear low  mounted work lights.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2360": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 36,
      "SPN": 2360,
      "SPN_Name": "Tractor Rear Low Mounted Work Lights",
      "SPN_Description": "This parameter provides measured data from the tractor rear low mounted work lights.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2361": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 38,
      "SPN": 2361,
      "SPN_Name": "Tractor Rear High Mounted Work Lights Command",
      "SPN_Description": "Command to activate or de-activate the tractor rear high  mounted work lights.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2362": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 38,
      "SPN": 2362,
      "SPN_Name": "Tractor Rear High Mounted Work Lights",
      "SPN_Description": "This parameter provides measured data from the tractor rear high mounted work lights. \r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2363": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 40,
      "SPN": 2363,
      "SPN_Name": "Tractor Side Low Mounted Work Lights Command",
      "SPN_Description": "Command to activate or de-activate the tractor side low mounted work lights.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2364": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 40,
      "SPN": 2364,
      "SPN_Name": "Tractor Side Low Mounted Work Lights",
      "SPN_Description": "This parameter provides measured data from the tractor side low mounted work lights. \r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2365": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 42,
      "SPN": 2365,
      "SPN_Name": "Tractor Side High Mounted Work Lights Command",
      "SPN_Description": "Command to activate or de-activate the tractor side high mounted work lights.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2366": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 42,
      "SPN": 2366,
      "SPN_Name": "Tractor Side High Mounted Work Lights",
      "SPN_Description": "This parameter provides measured data from the tractor side high mounted work lights. \r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2367": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 14,
      "SPN": 2367,
      "SPN_Name": "Left Turn Signal Lights Command",
      "SPN_Description": "Command to activate or de-activate left turn signal lights on the tractor and all connected implements\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2368": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 14,
      "SPN": 2368,
      "SPN_Name": "Left Turn Signal Lights",
      "SPN_Description": "This parameter provides measured data from the tractor and attached implement left turn signal lights.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2369": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 12,
      "SPN": 2369,
      "SPN_Name": "Right Turn Signal Lights Command",
      "SPN_Description": "Command to activate or de-activate right turn signal lights on the tractor and all connected implements\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2370": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 12,
      "SPN": 2370,
      "SPN_Name": "Right Turn Signal Lights",
      "SPN_Description": "This parameter provides measured data from the tractor and attached implement right turn signal lights.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2371": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 22,
      "SPN": 2371,
      "SPN_Name": "Left Stop Light Command",
      "SPN_Description": "Command to activate or de-activate the tractor and implement left stop lights\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2372": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 22,
      "SPN": 2372,
      "SPN_Name": "Left Stop Light",
      "SPN_Description": "This parameter provides measured data from the tractor and attached implement left stop lights.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2373": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 20,
      "SPN": 2373,
      "SPN_Name": "Right Stop Light Command",
      "SPN_Description": "Command to activate or de-activate the tractor and implement right stop light\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2374": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 20,
      "SPN": 2374,
      "SPN_Name": "Right Stop Light",
      "SPN_Description": "This parameter provides measured data from the tractor and attached implement right stop lights.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2375": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 18,
      "SPN": 2375,
      "SPN_Name": "Center Stop Light Command",
      "SPN_Description": "Command to activate or de-activate the tractor and implement center stop light\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2376": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 18,
      "SPN": 2376,
      "SPN_Name": "Center Stop Light",
      "SPN_Description": "This parameter provides measured data from the tractor and attached implement center stop lights.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2377": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 30,
      "SPN": 2377,
      "SPN_Name": "Tractor Marker Light Command",
      "SPN_Description": "Command to activate or de-activate tractor and implement front position lights, rear red tail lights, side amber running lights, license plate lights and instrument and switch back lights.  \r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2378": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 30,
      "SPN": 2378,
      "SPN_Name": "Tractor Marker Light",
      "SPN_Description": "This parameter provides measured data from the tractor and attached implement marker lights, including front position lights, rear tail lights, side running lights, license plate lights and instruments and switch back lights.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2379": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 28,
      "SPN": 2379,
      "SPN_Name": "Implement Marker Light Command",
      "SPN_Description": "Command to activate or de-activate implement front position lights, rear red tail lights, side amber running lights, license plate lights and instrument and switch back lights.  \r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2380": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 28,
      "SPN": 2380,
      "SPN_Name": "Implement Marker Light",
      "SPN_Description": "This parameter provides measured data from an attached implement marker lights, including front position lights, rear tail lights, side running lights, license plate lights and instruments and switch back lights.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2381": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 26,
      "SPN": 2381,
      "SPN_Name": "Tractor Clearance Light Command",
      "SPN_Description": "Command to activate or de-activate the tractor high mounted clearance and center ID lights\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2382": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 26,
      "SPN": 2382,
      "SPN_Name": "Tractor Clearance Light",
      "SPN_Description": "This parameter provides measured data from the tractor high mounted clearance and center ID lights.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2383": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 24,
      "SPN": 2383,
      "SPN_Name": "Implement Clearance Light Command",
      "SPN_Description": "Command to activate or de-activate the implement high mounted clearance and lights.  \r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2384": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 24,
      "SPN": 2384,
      "SPN_Name": "Implement Clearance Light",
      "SPN_Description": "This parameter provides measured data from an attached implement high mounted clearance lights.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2385": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 10,
      "SPN": 2385,
      "SPN_Name": "Rotating Beacon Light Command",
      "SPN_Description": "Command to activate or de-activate slow moving vehicle indicator lights on tractor and/or implements.  Activation of the slow moving vehicle lights implies that the controller should manipulate the lighting as appropriate to provide the slow moving vehicle lighting function.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2386": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 10,
      "SPN": 2386,
      "SPN_Name": "Rotating Beacon Light",
      "SPN_Description": "This parameter provides measured data from the beacon light on tractor or attached implements.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2387": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 8,
      "SPN": 2387,
      "SPN_Name": "Tractor Front Fog Lights Command",
      "SPN_Description": "Command to activate or de-activate tractor front fog lights.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2388": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 8,
      "SPN": 2388,
      "SPN_Name": "Tractor Front Fog Lights",
      "SPN_Description": "This parameter provides measured data from the tractor front fog lights.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2389": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 32,
      "SPN": 2389,
      "SPN_Name": "Rear Fog Light Command",
      "SPN_Description": "Command to activate or de-activate tractor or implement rear fog lights.  \r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2390": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 32,
      "SPN": 2390,
      "SPN_Name": "Rear Fog Lights",
      "SPN_Description": "This parameter provides measured data from the tractor and/or implement rear fog lights.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2391": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 16,
      "SPN": 2391,
      "SPN_Name": "Back Up Light and Alarm Horn Command",
      "SPN_Description": "Command to activate or de-activate the back up lights and/ or associated alarm if required\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2392": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 16,
      "SPN": 2392,
      "SPN_Name": "Back Up Light and Alarm Horn",
      "SPN_Description": "This parameter provides measured data from the back up lights and/ or associated alarm.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2393": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 56,
      "SPN": 2393,
      "SPN_Name": "Lighting Data Request Command",
      "SPN_Description": "Command to provide a response of the light state\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2394": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 62,
      "SPN": 2394,
      "SPN_Name": "Implement Rear Work Light",
      "SPN_Description": "This parameter provides measured data from the implement rear work lamps.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2395": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 50,
      "SPN": 2395,
      "SPN_Name": "Implement OEM Option 1 Light Command",
      "SPN_Description": "Command to activate or de-activate an implement OEM option 1 light.  This is provided to meet special needs on implements, such as tank inspection or filling lights.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2396": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 50,
      "SPN": 2396,
      "SPN_Name": "Implement OEM Option 1 Light",
      "SPN_Description": "This parameter provides measured data from the implement OEM option 1 light.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2397": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 48,
      "SPN": 2397,
      "SPN_Name": "Implement OEM Option 2 Light Command",
      "SPN_Description": "Command to activate or de-activate an implement OEM option 2 light.  This is provided to meet special needs on implements, such as tank inspection or filling lights.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2398": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 48,
      "SPN": 2398,
      "SPN_Name": "Implement OEM Option 2 Light",
      "SPN_Description": "This parameter provides measured data from the implement OEM option 2 light.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2399": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 60,
      "SPN": 2399,
      "SPN_Name": "Implement Left Facing Work Light Command",
      "SPN_Description": "Command to activate or de-activate the left facing work lights toward the left end of the implement.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2400": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 60,
      "SPN": 2400,
      "SPN_Name": "Implement Left Facing Work Light",
      "SPN_Description": "This parameter provides measured data from the left facing work lights toward the left end of the implement.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2401": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 58,
      "SPN": 2401,
      "SPN_Name": "Implement Right Forward Work Light Command",
      "SPN_Description": "Command to activate or de-activate the forward facing work lights toward the right end of the implement.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2402": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 58,
      "SPN": 2402,
      "SPN_Name": "Implement Right Forward Work Light",
      "SPN_Description": "This parameter provides measured data from the forward facing work lights toward the right end of the implement.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2403": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 0,
      "SPN": 2403,
      "SPN_Name": "Running Light Command",
      "SPN_Description": "Command to activate or de-activate the tractor or powered vehicle running lights.  Usually only used for on road vehicles.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2404": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 0,
      "SPN": 2404,
      "SPN_Name": "Running Light",
      "SPN_Description": "This parameter provides measured data from the vehicle’s running lights.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2405": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 62,
      "SPN": 2405,
      "SPN_Name": "Implement Rear Work Light Command",
      "SPN_Description": "Command to activate or de-activate implement rear work lights.  (This is also the same as Reversing Lights for truck applications.)  \r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2406": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 52,
      "SPN": 2406,
      "SPN_Name": "Implement Right Facing Work Light Command",
      "SPN_Description": "Command to activate or de-activate work lights mounted on an implement to illuminate beyond right end of the implement.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2407": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 52,
      "SPN": 2407,
      "SPN_Name": "Implement Right Facing Work Light",
      "SPN_Description": "This parameter provides measured data from the work lights mounted on an implement to illuminate beyond right end of the implement.\r\n\r\n00 De-activated\r\n01 Activated\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2432": {
      "PGN": 61444,
      "PGN_Name": "Electronic Engine Controller 1",
      "PGN_Description": "EEC1",
      "first_bit": 56,
      "SPN": 2432,
      "SPN_Name": "Engine Demand – Percent Torque",
      "SPN_Description": "The requested torque output of the engine by all dynamic internal inputs, including smoke control, noise control and low and high speed governing.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "2433": {
      "PGN": 65031,
      "PGN_Name": "Exhaust Temperature",
      "PGN_Description": "ET",
      "first_bit": 0,
      "SPN": 2433,
      "SPN_Name": "Engine Exhaust Manifold Bank 2 Temperature 1",
      "SPN_Description": "Temperature of combustion byproducts measured in engine bank 2 (right bank) exhaust manifold.  Single manifold engines should use exhaust temperature (SPN 173).",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "2434": {
      "PGN": 65031,
      "PGN_Name": "Exhaust Temperature",
      "PGN_Description": "ET",
      "first_bit": 16,
      "SPN": 2434,
      "SPN_Name": "Engine Exhaust Manifold Bank 1 Temperature 1",
      "SPN_Description": "Temperature of combustion byproducts measured in engine bank 1 (left bank) exhaust manifold.  Single manifold engines should use exhaust temperature (SPN 173).",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "2435": {
      "PGN": 65172,
      "PGN_Name": "Engine Auxiliary Coolant",
      "PGN_Description": "EAC",
      "first_bit": 16,
      "SPN": 2435,
      "SPN_Name": "Sea Water Pump Outlet Pressure",
      "SPN_Description": "Gauge pressure of liquid found at outlet of sea water pump in sea water cooling system.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "2436": {
      "PGN": 65030,
      "PGN_Name": "Generator Average Basic AC Quantities",
      "PGN_Description": "GAAC",
      "first_bit": 32,
      "SPN": 2436,
      "SPN_Name": "Generator Average AC Frequency",
      "SPN_Description": "Average AC frequency measured at the generator output.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 144
    },
    "2437": {
      "PGN": 65027,
      "PGN_Name": "Generator Phase A Basic AC Quantities",
      "PGN_Description": "GPAAC",
      "first_bit": 32,
      "SPN": 2437,
      "SPN_Name": "Generator Phase A AC Frequency",
      "SPN_Description": "AC frequency measured at the generator phase A output.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 144
    },
    "2438": {
      "PGN": 65024,
      "PGN_Name": "Generator Phase B Basic AC Quantities",
      "PGN_Description": "GPBAC",
      "first_bit": 32,
      "SPN": 2438,
      "SPN_Name": "Generator Phase B AC Frequency",
      "SPN_Description": "AC frequency measured at the generator phase B output.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 144
    },
    "2439": {
      "PGN": 65021,
      "PGN_Name": "Generator Phase C Basic AC Quantities",
      "PGN_Description": "GPCAC",
      "first_bit": 32,
      "SPN": 2439,
      "SPN_Name": "Generator Phase C AC Frequency",
      "SPN_Description": "AC frequency measured at the generator phase C output.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 144
    },
    "2440": {
      "PGN": 65030,
      "PGN_Name": "Generator Average Basic AC Quantities",
      "PGN_Description": "GAAC",
      "first_bit": 0,
      "SPN": 2440,
      "SPN_Name": "Generator Average Line-Line AC RMS Voltage",
      "SPN_Description": "Average Line to Line RMS voltage measured at the generator output.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2441": {
      "PGN": 65027,
      "PGN_Name": "Generator Phase A Basic AC Quantities",
      "PGN_Description": "GPAAC",
      "first_bit": 0,
      "SPN": 2441,
      "SPN_Name": "Generator Phase AB Line-Line AC RMS Voltage",
      "SPN_Description": "Line to Line RMS voltage measured at the generator phase AB output.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2442": {
      "PGN": 65024,
      "PGN_Name": "Generator Phase B Basic AC Quantities",
      "PGN_Description": "GPBAC",
      "first_bit": 0,
      "SPN": 2442,
      "SPN_Name": "Generator Phase BC Line-Line AC RMS Voltage",
      "SPN_Description": "Line to Line RMS voltage measured at the generator phase BC output.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2443": {
      "PGN": 65021,
      "PGN_Name": "Generator Phase C Basic AC Quantities",
      "PGN_Description": "GPCAC",
      "first_bit": 0,
      "SPN": 2443,
      "SPN_Name": "Generator Phase CA Line-Line AC RMS Voltage",
      "SPN_Description": "Line to Line RMS voltage measured at the generator phase CA output.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2444": {
      "PGN": 65030,
      "PGN_Name": "Generator Average Basic AC Quantities",
      "PGN_Description": "GAAC",
      "first_bit": 16,
      "SPN": 2444,
      "SPN_Name": "Generator Average Line-Neutral AC RMS Voltage",
      "SPN_Description": "The average Line to Neutral AC RMS voltage measured at the Generator output.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2445": {
      "PGN": 65027,
      "PGN_Name": "Generator Phase A Basic AC Quantities",
      "PGN_Description": "GPAAC",
      "first_bit": 16,
      "SPN": 2445,
      "SPN_Name": "Generator Phase A Line-Neutral AC RMS Voltage",
      "SPN_Description": "Line to Neutral RMS voltage measured at the generator phase A output.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2446": {
      "PGN": 65024,
      "PGN_Name": "Generator Phase B Basic AC Quantities",
      "PGN_Description": "GPBAC",
      "first_bit": 16,
      "SPN": 2446,
      "SPN_Name": "Generator Phase B Line-Neutral AC RMS Voltage",
      "SPN_Description": "Line to Neutral RMS voltage measured at the generator phase B output.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2447": {
      "PGN": 65021,
      "PGN_Name": "Generator Phase C Basic AC Quantities",
      "PGN_Description": "GPCAC",
      "first_bit": 16,
      "SPN": 2447,
      "SPN_Name": "Generator Phase C Line-Neutral AC RMS Voltage",
      "SPN_Description": "Line to Neutral RMS voltage measured at the generator phase C output.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2448": {
      "PGN": 65030,
      "PGN_Name": "Generator Average Basic AC Quantities",
      "PGN_Description": "GAAC",
      "first_bit": 48,
      "SPN": 2448,
      "SPN_Name": "Generator Average AC RMS Current",
      "SPN_Description": "Average RMS current measured at the generator output.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 146
    },
    "2449": {
      "PGN": 65027,
      "PGN_Name": "Generator Phase A Basic AC Quantities",
      "PGN_Description": "GPAAC",
      "first_bit": 48,
      "SPN": 2449,
      "SPN_Name": "Generator Phase A AC RMS Current",
      "SPN_Description": "RMS current measured at the generator phase A output.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 146
    },
    "2450": {
      "PGN": 65024,
      "PGN_Name": "Generator Phase B Basic AC Quantities",
      "PGN_Description": "GPBAC",
      "first_bit": 48,
      "SPN": 2450,
      "SPN_Name": "Generator Phase B AC RMS Current",
      "SPN_Description": "RMS current measured at the generator phase B output.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 146
    },
    "2451": {
      "PGN": 65021,
      "PGN_Name": "Generator Phase C Basic AC Quantities",
      "PGN_Description": "GPCAC",
      "first_bit": 48,
      "SPN": 2451,
      "SPN_Name": "Generator Phase C AC RMS Current",
      "SPN_Description": "RMS current measured at the generator phase C output.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 146
    },
    "2452": {
      "PGN": 65029,
      "PGN_Name": "Generator Total AC Power",
      "PGN_Description": "GTACP",
      "first_bit": 0,
      "SPN": 2452,
      "SPN_Name": "Generator Total Real Power",
      "SPN_Description": "Total real power delivered by the generator.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "W",
      "SLOT_ID": 147
    },
    "2453": {
      "PGN": 65026,
      "PGN_Name": "Generator Phase A AC Power",
      "PGN_Description": "GPAACP",
      "first_bit": 0,
      "SPN": 2453,
      "SPN_Name": "Generator Phase A Real Power",
      "SPN_Description": "The real power delivered by phase A of the generator.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "W",
      "SLOT_ID": 147
    },
    "2454": {
      "PGN": 65023,
      "PGN_Name": "Generator Phase B AC Power",
      "PGN_Description": "GPBACP",
      "first_bit": 0,
      "SPN": 2454,
      "SPN_Name": "Generator Phase B Real Power",
      "SPN_Description": "The real power delivered by phase B of the generator.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "W",
      "SLOT_ID": 147
    },
    "2455": {
      "PGN": 65020,
      "PGN_Name": "Generator Phase C AC Power",
      "PGN_Description": "GPCACP",
      "first_bit": 0,
      "SPN": 2455,
      "SPN_Name": "Generator Phase C Real Power",
      "SPN_Description": "The real power delivered by phase C of the generator.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "W",
      "SLOT_ID": 147
    },
    "2456": {
      "PGN": 65028,
      "PGN_Name": "Generator Total AC Reactive Power",
      "PGN_Description": "GTACR",
      "first_bit": 0,
      "SPN": 2456,
      "SPN_Name": "Generator Total Reactive Power",
      "SPN_Description": "The total reactive power delivered by the generator",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VAr",
      "SLOT_ID": 149
    },
    "2457": {
      "PGN": 65025,
      "PGN_Name": "Generator Phase A AC Reactive Power",
      "PGN_Description": "GPAACR",
      "first_bit": 0,
      "SPN": 2457,
      "SPN_Name": "Generator Phase A Reactive Power",
      "SPN_Description": "The reactive power delivered by phase A of the generator",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VAr",
      "SLOT_ID": 149
    },
    "2458": {
      "PGN": 65022,
      "PGN_Name": "Generator Phase B AC Reactive Power",
      "PGN_Description": "GPBACRP",
      "first_bit": 0,
      "SPN": 2458,
      "SPN_Name": "Generator Phase B Reactive Power",
      "SPN_Description": "The reactive power delivered by phase B of the generator",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VAr",
      "SLOT_ID": 149
    },
    "2459": {
      "PGN": 65019,
      "PGN_Name": "Generator Phase C AC Reactive Power",
      "PGN_Description": "GPCACR",
      "first_bit": 0,
      "SPN": 2459,
      "SPN_Name": "Generator Phase C Reactive Power",
      "SPN_Description": "The reactive power delivered by phase C of the generator",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VAr",
      "SLOT_ID": 149
    },
    "2460": {
      "PGN": 65029,
      "PGN_Name": "Generator Total AC Power",
      "PGN_Description": "GTACP",
      "first_bit": 32,
      "SPN": 2460,
      "SPN_Name": "Generator Total Apparent Power",
      "SPN_Description": "The total apparent power delivered by the generator.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VA",
      "SLOT_ID": 148
    },
    "2461": {
      "PGN": 65026,
      "PGN_Name": "Generator Phase A AC Power",
      "PGN_Description": "GPAACP",
      "first_bit": 32,
      "SPN": 2461,
      "SPN_Name": "Generator Phase A Apparent Power",
      "SPN_Description": "The apparent power delivered by phase A of the generator.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VA",
      "SLOT_ID": 148
    },
    "2462": {
      "PGN": 65023,
      "PGN_Name": "Generator Phase B AC Power",
      "PGN_Description": "GPBACP",
      "first_bit": 32,
      "SPN": 2462,
      "SPN_Name": "Generator Phase B Apparent Power",
      "SPN_Description": "The apparent power delivered by phase B of the generator.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VA",
      "SLOT_ID": 148
    },
    "2463": {
      "PGN": 65020,
      "PGN_Name": "Generator Phase C AC Power",
      "PGN_Description": "GPCACP",
      "first_bit": 32,
      "SPN": 2463,
      "SPN_Name": "Generator Phase C Apparent Power",
      "SPN_Description": "The apparent power delivered by phase C of the generator.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VA",
      "SLOT_ID": 148
    },
    "2464": {
      "PGN": 65028,
      "PGN_Name": "Generator Total AC Reactive Power",
      "PGN_Description": "GTACR",
      "first_bit": 32,
      "SPN": 2464,
      "SPN_Name": "Generator Overall Power Factor",
      "SPN_Description": "The average power factor of the generator.",
      "bit_length": 16,
      "scaling": 0.00006103515625,
      "offset": -1,
      "unit": null,
      "SLOT_ID": 151
    },
    "2465": {
      "PGN": 65025,
      "PGN_Name": "Generator Phase A AC Reactive Power",
      "PGN_Description": "GPAACR",
      "first_bit": 32,
      "SPN": 2465,
      "SPN_Name": "Generator Phase A Power Factor",
      "SPN_Description": "The power factor of phase A of the generator.",
      "bit_length": 16,
      "scaling": 0.00006103515625,
      "offset": -1,
      "unit": null,
      "SLOT_ID": 151
    },
    "2466": {
      "PGN": 65022,
      "PGN_Name": "Generator Phase B AC Reactive Power",
      "PGN_Description": "GPBACRP",
      "first_bit": 32,
      "SPN": 2466,
      "SPN_Name": "Generator Phase B Power Factor",
      "SPN_Description": "The power factor of phases B of the generator.",
      "bit_length": 16,
      "scaling": 0.00006103515625,
      "offset": -1,
      "unit": null,
      "SLOT_ID": 151
    },
    "2467": {
      "PGN": 65019,
      "PGN_Name": "Generator Phase C AC Reactive Power",
      "PGN_Description": "GPCACR",
      "first_bit": 32,
      "SPN": 2467,
      "SPN_Name": "Generator Phase C Power Factor",
      "SPN_Description": "The power factor of phases C of the generator.",
      "bit_length": 16,
      "scaling": 0.00006103515625,
      "offset": -1,
      "unit": null,
      "SLOT_ID": 151
    },
    "2468": {
      "PGN": 65018,
      "PGN_Name": "Generator Total AC Energy",
      "PGN_Description": "GTACE",
      "first_bit": 0,
      "SPN": 2468,
      "SPN_Name": "Generator Total kW Hours Export",
      "SPN_Description": "The total kilowatt-hours that have been exported by the generator.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "kWh",
      "SLOT_ID": 150
    },
    "2469": {
      "PGN": 65018,
      "PGN_Name": "Generator Total AC Energy",
      "PGN_Description": "GTACE",
      "first_bit": 32,
      "SPN": 2469,
      "SPN_Name": "Generator Total kW Hours Import",
      "SPN_Description": "The total kilowatt-hours that have been imported by the generator.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "kWh",
      "SLOT_ID": 150
    },
    "2470": {
      "PGN": 65017,
      "PGN_Name": "Utility Average Basic AC Quantities",
      "PGN_Description": "UAAC",
      "first_bit": 32,
      "SPN": 2470,
      "SPN_Name": "Utility Average AC Frequency",
      "SPN_Description": "Average AC frequency measured at the utility incomer.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 144
    },
    "2471": {
      "PGN": 65014,
      "PGN_Name": "Utility Phase A Basic AC Quantities",
      "PGN_Description": "UPAAC",
      "first_bit": 32,
      "SPN": 2471,
      "SPN_Name": "Utility Phase A AC Frequency",
      "SPN_Description": "AC frequency measured at the utility incomer phase A.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 144
    },
    "2472": {
      "PGN": 65011,
      "PGN_Name": "Utility Phase B AC Basic Quantities",
      "PGN_Description": "UPBAC",
      "first_bit": 32,
      "SPN": 2472,
      "SPN_Name": "Utility Phase B AC Frequency",
      "SPN_Description": "AC frequency measured at the utility incomer phase B.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 144
    },
    "2473": {
      "PGN": 65008,
      "PGN_Name": "Utility Phase C AC Basic Quantities",
      "PGN_Description": "UPCAC",
      "first_bit": 32,
      "SPN": 2473,
      "SPN_Name": "Utility Phase C AC Frequency",
      "SPN_Description": "AC frequency measured at the utility incomer phase C.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 144
    },
    "2474": {
      "PGN": 65017,
      "PGN_Name": "Utility Average Basic AC Quantities",
      "PGN_Description": "UAAC",
      "first_bit": 0,
      "SPN": 2474,
      "SPN_Name": "Utility Average Line-Line AC RMS Voltage",
      "SPN_Description": "Average Line to Line RMS voltage measured at the utility incomer .",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2475": {
      "PGN": 65014,
      "PGN_Name": "Utility Phase A Basic AC Quantities",
      "PGN_Description": "UPAAC",
      "first_bit": 0,
      "SPN": 2475,
      "SPN_Name": "Utility Phase AB Line-Line AC RMS Voltage",
      "SPN_Description": "Line to Line RMS voltage measured at the utility incomer phase AB.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2476": {
      "PGN": 65011,
      "PGN_Name": "Utility Phase B AC Basic Quantities",
      "PGN_Description": "UPBAC",
      "first_bit": 0,
      "SPN": 2476,
      "SPN_Name": "Utility Phase BC Line-Line AC RMS Voltage",
      "SPN_Description": "Line to Line RMS voltage measured at the utility incomer phase BC.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2477": {
      "PGN": 65008,
      "PGN_Name": "Utility Phase C AC Basic Quantities",
      "PGN_Description": "UPCAC",
      "first_bit": 0,
      "SPN": 2477,
      "SPN_Name": "Utility Phase CA Line-Line AC RMS Voltage",
      "SPN_Description": "Line to Line RMS voltage measured at the utility incomer phase CA.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2478": {
      "PGN": 65017,
      "PGN_Name": "Utility Average Basic AC Quantities",
      "PGN_Description": "UAAC",
      "first_bit": 16,
      "SPN": 2478,
      "SPN_Name": "Utility Average Line-Neutral AC RMS Voltage",
      "SPN_Description": "The average Line to Neutral AC RMS voltage measured at the utility incomer .",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2479": {
      "PGN": 65014,
      "PGN_Name": "Utility Phase A Basic AC Quantities",
      "PGN_Description": "UPAAC",
      "first_bit": 16,
      "SPN": 2479,
      "SPN_Name": "Utility Phase A Line-Neutral AC RMS Voltage",
      "SPN_Description": "Line to Neutral RMS voltage measured at the utility incomer phase A.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2480": {
      "PGN": 65011,
      "PGN_Name": "Utility Phase B AC Basic Quantities",
      "PGN_Description": "UPBAC",
      "first_bit": 16,
      "SPN": 2480,
      "SPN_Name": "Utility Phase B Line-Neutral AC RMS Voltage",
      "SPN_Description": "Line to Neutral RMS voltage measured at the utility incomer phase B.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2481": {
      "PGN": 65008,
      "PGN_Name": "Utility Phase C AC Basic Quantities",
      "PGN_Description": "UPCAC",
      "first_bit": 16,
      "SPN": 2481,
      "SPN_Name": "Utility Phase C Line-Neutral AC RMS Voltage",
      "SPN_Description": "Line to Neutral RMS voltage measured at the utility incomer phase C.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2482": {
      "PGN": 65017,
      "PGN_Name": "Utility Average Basic AC Quantities",
      "PGN_Description": "UAAC",
      "first_bit": 48,
      "SPN": 2482,
      "SPN_Name": "Utility Average AC RMS Current",
      "SPN_Description": "Average RMS current measured at the utility incomer.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 146
    },
    "2483": {
      "PGN": 65014,
      "PGN_Name": "Utility Phase A Basic AC Quantities",
      "PGN_Description": "UPAAC",
      "first_bit": 48,
      "SPN": 2483,
      "SPN_Name": "Utility Phase A AC RMS Current",
      "SPN_Description": "RMS current measured at the utility incomer phase A.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 146
    },
    "2484": {
      "PGN": 65011,
      "PGN_Name": "Utility Phase B AC Basic Quantities",
      "PGN_Description": "UPBAC",
      "first_bit": 48,
      "SPN": 2484,
      "SPN_Name": "Utility Phase B AC RMS Current",
      "SPN_Description": "RMS current measured at the utility incomer phase B.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 146
    },
    "2485": {
      "PGN": 65008,
      "PGN_Name": "Utility Phase C AC Basic Quantities",
      "PGN_Description": "UPCAC",
      "first_bit": 48,
      "SPN": 2485,
      "SPN_Name": "Utility Phase C AC RMS Current",
      "SPN_Description": "RMS current measured at the utility incomer phase C.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 146
    },
    "2486": {
      "PGN": 65016,
      "PGN_Name": "Utility Total AC Power",
      "PGN_Description": "UTACP",
      "first_bit": 0,
      "SPN": 2486,
      "SPN_Name": "Utility Total Real Power",
      "SPN_Description": "Total real power delivered by the utility incomer.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "W",
      "SLOT_ID": 147
    },
    "2487": {
      "PGN": 65013,
      "PGN_Name": "Utility Phase A AC Power",
      "PGN_Description": "UPAACP",
      "first_bit": 0,
      "SPN": 2487,
      "SPN_Name": "Utility Phase A Real Power",
      "SPN_Description": "The real power delivered by phase A of the utility incomer.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "W",
      "SLOT_ID": 147
    },
    "2488": {
      "PGN": 65010,
      "PGN_Name": "Utility Phase B AC Power",
      "PGN_Description": "UPBACP",
      "first_bit": 0,
      "SPN": 2488,
      "SPN_Name": "Utility Phase B Real Power",
      "SPN_Description": "The real power delivered by phase B of the utility incomer.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "W",
      "SLOT_ID": 147
    },
    "2489": {
      "PGN": 65007,
      "PGN_Name": "Utility Phase C AC Power",
      "PGN_Description": "UPCACP",
      "first_bit": 0,
      "SPN": 2489,
      "SPN_Name": "Utility Phase C Real Power",
      "SPN_Description": "The real power delivered by phase C of the utility incomer.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "W",
      "SLOT_ID": 147
    },
    "2490": {
      "PGN": 65015,
      "PGN_Name": "Utility Total AC Reactive Power",
      "PGN_Description": "UTACR",
      "first_bit": 0,
      "SPN": 2490,
      "SPN_Name": "Utility Total Reactive Power",
      "SPN_Description": "The total reactive power delivered by the utility incomer",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VAr",
      "SLOT_ID": 149
    },
    "2491": {
      "PGN": 65012,
      "PGN_Name": "Utility Phase A AC Reactive Power",
      "PGN_Description": "UPACCR",
      "first_bit": 0,
      "SPN": 2491,
      "SPN_Name": "Utility Phase A Reactive Power",
      "SPN_Description": "The reactive power delivered by phase A of the utility incomer",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VAr",
      "SLOT_ID": 149
    },
    "2492": {
      "PGN": 65009,
      "PGN_Name": "Utility Phase B AC Reactive Power",
      "PGN_Description": "UPBACR",
      "first_bit": 0,
      "SPN": 2492,
      "SPN_Name": "Utility Phase B Reactive Power",
      "SPN_Description": "The reactive power delivered by phase B of the utility incomer",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VAr",
      "SLOT_ID": 149
    },
    "2493": {
      "PGN": 65006,
      "PGN_Name": "Utility Phase C AC Reactive Power",
      "PGN_Description": "UPCACR",
      "first_bit": 0,
      "SPN": 2493,
      "SPN_Name": "Utility Phase C Reactive Power",
      "SPN_Description": "The reactive power delivered by phase C of the utility incomer",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VAr",
      "SLOT_ID": 149
    },
    "2494": {
      "PGN": 65016,
      "PGN_Name": "Utility Total AC Power",
      "PGN_Description": "UTACP",
      "first_bit": 32,
      "SPN": 2494,
      "SPN_Name": "Utility Total Apparent Power",
      "SPN_Description": "The total apparent power delivered by the utility incomer.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VA",
      "SLOT_ID": 148
    },
    "2495": {
      "PGN": 65013,
      "PGN_Name": "Utility Phase A AC Power",
      "PGN_Description": "UPAACP",
      "first_bit": 32,
      "SPN": 2495,
      "SPN_Name": "Utility Phase A Apparent Power",
      "SPN_Description": "The apparent power delivered by phase A of the utility incomer.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VA",
      "SLOT_ID": 148
    },
    "2496": {
      "PGN": 65010,
      "PGN_Name": "Utility Phase B AC Power",
      "PGN_Description": "UPBACP",
      "first_bit": 32,
      "SPN": 2496,
      "SPN_Name": "Utility Phase B Apparent Power",
      "SPN_Description": "The apparent power delivered by phase B of the utility incomer.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VA",
      "SLOT_ID": 148
    },
    "2497": {
      "PGN": 65007,
      "PGN_Name": "Utility Phase C AC Power",
      "PGN_Description": "UPCACP",
      "first_bit": 32,
      "SPN": 2497,
      "SPN_Name": "Utility Phase C Apparent Power",
      "SPN_Description": "The apparent power delivered by phase C of the utility incomer.",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VA",
      "SLOT_ID": 148
    },
    "2498": {
      "PGN": 65015,
      "PGN_Name": "Utility Total AC Reactive Power",
      "PGN_Description": "UTACR",
      "first_bit": 32,
      "SPN": 2498,
      "SPN_Name": "Utility Overall Power Factor",
      "SPN_Description": "The average power factor of the utility incomer.",
      "bit_length": 16,
      "scaling": 0.00006103515625,
      "offset": -1,
      "unit": null,
      "SLOT_ID": 151
    },
    "2499": {
      "PGN": 65012,
      "PGN_Name": "Utility Phase A AC Reactive Power",
      "PGN_Description": "UPACCR",
      "first_bit": 32,
      "SPN": 2499,
      "SPN_Name": "Utility Phase A Power Factor",
      "SPN_Description": "The power factor of phase A of the utility incomer.",
      "bit_length": 16,
      "scaling": 0.00006103515625,
      "offset": -1,
      "unit": null,
      "SLOT_ID": 151
    },
    "2500": {
      "PGN": 65009,
      "PGN_Name": "Utility Phase B AC Reactive Power",
      "PGN_Description": "UPBACR",
      "first_bit": 32,
      "SPN": 2500,
      "SPN_Name": "Utility Phase B Power Factor",
      "SPN_Description": "The power factor of phases B of the utility incomer.",
      "bit_length": 16,
      "scaling": 0.00006103515625,
      "offset": -1,
      "unit": null,
      "SLOT_ID": 151
    },
    "2501": {
      "PGN": 65006,
      "PGN_Name": "Utility Phase C AC Reactive Power",
      "PGN_Description": "UPCACR",
      "first_bit": 32,
      "SPN": 2501,
      "SPN_Name": "Utility Phase C Power Factor",
      "SPN_Description": "The power factor of phases C of the utility incomer.",
      "bit_length": 16,
      "scaling": 0.00006103515625,
      "offset": -1,
      "unit": null,
      "SLOT_ID": 151
    },
    "2502": {
      "PGN": 65005,
      "PGN_Name": "Utility Total AC Energy",
      "PGN_Description": "UTACE",
      "first_bit": 0,
      "SPN": 2502,
      "SPN_Name": "Utility Total kW Hours Export",
      "SPN_Description": "The total kilowatt-hours that have been exported by the utility incomer.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "kWh",
      "SLOT_ID": 150
    },
    "2503": {
      "PGN": 65005,
      "PGN_Name": "Utility Total AC Energy",
      "PGN_Description": "UTACE",
      "first_bit": 32,
      "SPN": 2503,
      "SPN_Name": "Utility Total kW Hours Import",
      "SPN_Description": "The total kilowatt-hours that have been imported by the utility incomer.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "kWh",
      "SLOT_ID": 150
    },
    "2504": {
      "PGN": 65004,
      "PGN_Name": "Bus #1 Average Basic AC Quantities",
      "PGN_Description": "BAAC",
      "first_bit": 32,
      "SPN": 2504,
      "SPN_Name": "Bus #1 Average AC Frequency",
      "SPN_Description": "Average AC frequency measured at bus #1.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 144
    },
    "2505": {
      "PGN": 65003,
      "PGN_Name": "Bus #1 Phase A  Basic AC Quantities",
      "PGN_Description": "BPAAC",
      "first_bit": 32,
      "SPN": 2505,
      "SPN_Name": "Bus #1 Phase A AC Frequency",
      "SPN_Description": "AC frequency measured at bus #1 phase A.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 144
    },
    "2506": {
      "PGN": 65002,
      "PGN_Name": "Bus #1 Phase B  Basic AC Quantities",
      "PGN_Description": "BPBAC",
      "first_bit": 32,
      "SPN": 2506,
      "SPN_Name": "Bus #1 Phase B AC Frequency",
      "SPN_Description": "AC frequency measured at bus #1 phase B.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 144
    },
    "2507": {
      "PGN": 65001,
      "PGN_Name": "Bus #1 Phase C  Basic AC Quantities",
      "PGN_Description": "BPCAC",
      "first_bit": 32,
      "SPN": 2507,
      "SPN_Name": "Bus #1 Phase C AC Frequency",
      "SPN_Description": "AC frequency measured at bus #1 phase C.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 144
    },
    "2508": {
      "PGN": 65004,
      "PGN_Name": "Bus #1 Average Basic AC Quantities",
      "PGN_Description": "BAAC",
      "first_bit": 0,
      "SPN": 2508,
      "SPN_Name": "Bus #1 Average Line-Line AC RMS Voltage",
      "SPN_Description": "Average Line to Line RMS voltage measured at bus #1 .",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2509": {
      "PGN": 65003,
      "PGN_Name": "Bus #1 Phase A  Basic AC Quantities",
      "PGN_Description": "BPAAC",
      "first_bit": 0,
      "SPN": 2509,
      "SPN_Name": "Bus #1 Phase AB Line-Line AC RMS Voltage",
      "SPN_Description": "Line to Line RMS voltage measured at bus #1 phase AB.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2510": {
      "PGN": 65002,
      "PGN_Name": "Bus #1 Phase B  Basic AC Quantities",
      "PGN_Description": "BPBAC",
      "first_bit": 0,
      "SPN": 2510,
      "SPN_Name": "Bus #1 Phase BC Line-Line AC RMS Voltage",
      "SPN_Description": "Line to Line RMS voltage measured at bus #1 phase BC.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2511": {
      "PGN": 65001,
      "PGN_Name": "Bus #1 Phase C  Basic AC Quantities",
      "PGN_Description": "BPCAC",
      "first_bit": 0,
      "SPN": 2511,
      "SPN_Name": "Bus #1 Phase CA Line-Line AC RMS Voltage",
      "SPN_Description": "Line to Line RMS voltage measured at bus #1 phase CA.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2512": {
      "PGN": 65004,
      "PGN_Name": "Bus #1 Average Basic AC Quantities",
      "PGN_Description": "BAAC",
      "first_bit": 16,
      "SPN": 2512,
      "SPN_Name": "Bus #1 Average Line-Neutral AC RMS Voltage",
      "SPN_Description": "The average Line to Neutral AC RMS voltage measured at bus #1 .",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2513": {
      "PGN": 65003,
      "PGN_Name": "Bus #1 Phase A  Basic AC Quantities",
      "PGN_Description": "BPAAC",
      "first_bit": 16,
      "SPN": 2513,
      "SPN_Name": "Bus #1 Phase A Line-Neutral AC RMS Voltage",
      "SPN_Description": "Line to Neutral RMS voltage measured at bus #1 phase A.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2514": {
      "PGN": 65002,
      "PGN_Name": "Bus #1 Phase B  Basic AC Quantities",
      "PGN_Description": "BPBAC",
      "first_bit": 16,
      "SPN": 2514,
      "SPN_Name": "Bus #1 Phase B Line-Neutral AC RMS Voltage",
      "SPN_Description": "Line to Neutral RMS voltage measured at bus #1 phase B.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2515": {
      "PGN": 65001,
      "PGN_Name": "Bus #1 Phase C  Basic AC Quantities",
      "PGN_Description": "BPCAC",
      "first_bit": 16,
      "SPN": 2515,
      "SPN_Name": "Bus #1 Phase C Line-Neutral AC RMS Voltage",
      "SPN_Description": "Line to Neutral RMS voltage measured at bus #1 phase C.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "2516": {
      "PGN": 65000,
      "PGN_Name": "Bus #1/Generator Sync Check Status",
      "PGN_Description": "BGSC",
      "first_bit": 16,
      "SPN": 2516,
      "SPN_Name": "Bus #1/Generator AC Phase Difference",
      "SPN_Description": "The phase difference between the Bus #1 voltage and Generator voltage.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "2517": {
      "PGN": 64999,
      "PGN_Name": "Bus #1/Utility Sync Check Status",
      "PGN_Description": "BUSC",
      "first_bit": 16,
      "SPN": 2517,
      "SPN_Name": "Bus #1/Utility AC Phase Difference",
      "SPN_Description": "The phase difference between the Bus #1 voltage and Utility voltage.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "2518": {
      "PGN": 65028,
      "PGN_Name": "Generator Total AC Reactive Power",
      "PGN_Description": "GTACR",
      "first_bit": 48,
      "SPN": 2518,
      "SPN_Name": "Generator Overall Power Factor Lagging",
      "SPN_Description": "Lead/lag status for generator average power factor.\r\n\r\n00 Leading\r\n01 Lagging\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2519": {
      "PGN": 65025,
      "PGN_Name": "Generator Phase A AC Reactive Power",
      "PGN_Description": "GPAACR",
      "first_bit": 48,
      "SPN": 2519,
      "SPN_Name": "Generator Phase A Power Factor Lagging",
      "SPN_Description": "Lead/lag status for generator phase A power factor.\r\n\r\n00 Leading\r\n01 Lagging\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2520": {
      "PGN": 65022,
      "PGN_Name": "Generator Phase B AC Reactive Power",
      "PGN_Description": "GPBACRP",
      "first_bit": 48,
      "SPN": 2520,
      "SPN_Name": "Generator Phase B Power Factor Lagging",
      "SPN_Description": "Lead/lag status for generator phase B power factor.\r\n\r\n00 Leading\r\n01 Lagging\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2521": {
      "PGN": 65019,
      "PGN_Name": "Generator Phase C AC Reactive Power",
      "PGN_Description": "GPCACR",
      "first_bit": 48,
      "SPN": 2521,
      "SPN_Name": "Generator Phase C Power Factor Lagging",
      "SPN_Description": "Lead/lag status for generator phase C power factor.\r\n\r\n00 Leading\r\n01 Lagging\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2522": {
      "PGN": 65015,
      "PGN_Name": "Utility Total AC Reactive Power",
      "PGN_Description": "UTACR",
      "first_bit": 48,
      "SPN": 2522,
      "SPN_Name": "Utility Overall Power Factor Lagging",
      "SPN_Description": "Lead/lag status for utility incomer average power factor.\r\n\r\n00 Leading\r\n01 Lagging\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2523": {
      "PGN": 65012,
      "PGN_Name": "Utility Phase A AC Reactive Power",
      "PGN_Description": "UPACCR",
      "first_bit": 48,
      "SPN": 2523,
      "SPN_Name": "Utility Phase A Power Factor Lagging",
      "SPN_Description": "Lead/lag status for utility incomer phase A power factor.\r\n\r\n00 Leading\r\n01 Lagging\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2524": {
      "PGN": 65009,
      "PGN_Name": "Utility Phase B AC Reactive Power",
      "PGN_Description": "UPBACR",
      "first_bit": 48,
      "SPN": 2524,
      "SPN_Name": "Utility Phase B Power Factor Lagging",
      "SPN_Description": "Lead/lag status for utility incomer phase B power factor.\r\n\r\n00 Leading\r\n01 Lagging\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2525": {
      "PGN": 65006,
      "PGN_Name": "Utility Phase C AC Reactive Power",
      "PGN_Description": "UPCACR",
      "first_bit": 48,
      "SPN": 2525,
      "SPN_Name": "Utility Phase C Power Factor Lagging",
      "SPN_Description": "Lead/lag status for utility incomer phase C power factor.\r\n\r\n00 Leading\r\n01 Lagging\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2526": {
      "PGN": 65000,
      "PGN_Name": "Bus #1/Generator Sync Check Status",
      "PGN_Description": "BGSC",
      "first_bit": 2,
      "SPN": 2526,
      "SPN_Name": "Bus #1/Generator Phase Match",
      "SPN_Description": "Indicator of whether phase difference between Bus #1 and Generator is adequate for paralleling. This indicator will be based on the measured AC phase difference qualified using parameters such as Phase Tolerance and Dwell Time.\r\n\r\n00 Phases do not match\r\n01 Phases match\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2527": {
      "PGN": 65000,
      "PGN_Name": "Bus #1/Generator Sync Check Status",
      "PGN_Description": "BGSC",
      "first_bit": 6,
      "SPN": 2527,
      "SPN_Name": "Bus #1/Generator Voltage Match",
      "SPN_Description": "Indicator of whether voltage difference between Bus #1 and Generator is adequate for paralleling. This indicator will be based on the measured AC voltages qualified using parameters such as Voltage Tolerance.\r\n\r\n00 Voltages do not match\r\n01 Voltages match\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2528": {
      "PGN": 65000,
      "PGN_Name": "Bus #1/Generator Sync Check Status",
      "PGN_Description": "BGSC",
      "first_bit": 4,
      "SPN": 2528,
      "SPN_Name": "Bus #1/Generator Frequency Match",
      "SPN_Description": "Indicator of whether frequency difference between Bus #1 and Generator is adequate for paralleling. This indicator will be based on the measured AC frequencies qualified using parameters such as Frequency Tolerance, Phase Tolerance, and Dwell Time.\r\n\r\n00 Frequencies do not match\r\n01 Frequencies match\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2529": {
      "PGN": 65000,
      "PGN_Name": "Bus #1/Generator Sync Check Status",
      "PGN_Description": "BGSC",
      "first_bit": 8,
      "SPN": 2529,
      "SPN_Name": "Bus #1/Generator In Sync",
      "SPN_Description": "Indicator of whether Bus #1 and Generator are properly synchronized for paralleling. This indicator will be based on parameters such as Voltage Match, Frequency Match, and Phase Match.\r\n\r\n00 Not synchronized\r\n01 Synchronized\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2530": {
      "PGN": 65000,
      "PGN_Name": "Bus #1/Generator Sync Check Status",
      "PGN_Description": "BGSC",
      "first_bit": 0,
      "SPN": 2530,
      "SPN_Name": "Bus #1/Generator Dead Bus",
      "SPN_Description": "Indicator of whether Bus #1 is considered dead for closing to the generator. This indicator will be based on parameters such as Bus #1 Voltage and dead bus threshold values.\r\n\r\n00 Bus is not dead\r\n01 Bus is dead\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2531": {
      "PGN": 64999,
      "PGN_Name": "Bus #1/Utility Sync Check Status",
      "PGN_Description": "BUSC",
      "first_bit": 2,
      "SPN": 2531,
      "SPN_Name": "Bus #1/Utility Phase Match",
      "SPN_Description": "Indicator of whether phase difference between Bus #1 and Utility is adequate for paralleling. This indicator will be based on the measured AC phase difference qualified using parameters such as Phase Tolerance and Dwell Time.\r\n\r\n00 Phases do not match\r\n01 Phases match\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2532": {
      "PGN": 64999,
      "PGN_Name": "Bus #1/Utility Sync Check Status",
      "PGN_Description": "BUSC",
      "first_bit": 6,
      "SPN": 2532,
      "SPN_Name": "Bus #1/Utility Voltage Match",
      "SPN_Description": "Indicator of whether voltage difference between Bus #1 and Utility is adequate for paralleling. This indicator will be based on the measured AC voltages qualified using parameters such as Voltage Tolerance.\r\n\r\n00 Voltages do not match\r\n01 Voltages match\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2533": {
      "PGN": 64999,
      "PGN_Name": "Bus #1/Utility Sync Check Status",
      "PGN_Description": "BUSC",
      "first_bit": 4,
      "SPN": 2533,
      "SPN_Name": "Bus #1/Utility Frequency Match",
      "SPN_Description": "Indicator of whether frequency difference between Bus #1 and Utility is adequate for paralleling. This indicator will be based on the measured AC frequencies qualified using parameters such as Frequency Tolerance, Phase Tolerance, and Dwell Time.\r\n\r\n00 Frequencies do not match\r\n01 Frequencies match\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2534": {
      "PGN": 64999,
      "PGN_Name": "Bus #1/Utility Sync Check Status",
      "PGN_Description": "BUSC",
      "first_bit": 8,
      "SPN": 2534,
      "SPN_Name": "Bus #1/Utility In Sync",
      "SPN_Description": "Indicator of whether Bus #1 and Utility are properly synchronized for paralleling. This indicator will be based on parameters such as Voltage Match, Frequency Match, and Phase Match.\r\n\r\n00 Not synchronized\r\n01 Synchronized\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2535": {
      "PGN": 64999,
      "PGN_Name": "Bus #1/Utility Sync Check Status",
      "PGN_Description": "BUSC",
      "first_bit": 0,
      "SPN": 2535,
      "SPN_Name": "Bus #1/Utility Dead Bus",
      "SPN_Description": "Indicator of whether Bus #1 is considered dead for closing to the utility. This indicator will be based on parameters such as Bus #1 Voltage and dead bus threshold values.\r\n\r\n00 Bus is not dead\r\n01 Bus is dead\r\n10 Error\r\n11 Not Available or Not Installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2536": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 22,
      "SPN": 2536,
      "SPN_Name": "Transmission Mode 1 Indicator",
      "SPN_Description": "This state signal is the transmission’s indication that it is operating under transmission mode 1 (SPN 1852) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\r\n  \r\n00 Transmission Mode 1 not active\r\n01 Transmission Mode 1 Active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2537": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 20,
      "SPN": 2537,
      "SPN_Name": "Transmission Mode 2 Indicator",
      "SPN_Description": "This state signal is the transmission’s indication that it is operating under transmission mode 2 (SPN 1853) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\r\n\r\n00 Transmission Mode 2 not active\r\n01 Transmission Mode 2 Active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2538": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 18,
      "SPN": 2538,
      "SPN_Name": "Transmission Mode 3 Indicator",
      "SPN_Description": "This state signal is the transmission’s indication that it is operating under transmission mode 3 (SPN 1854) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\r\n\r\n00 Transmission Mode 3 not active\r\n01 Transmission Mode 3 Active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2539": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 16,
      "SPN": 2539,
      "SPN_Name": "Transmission Mode 4 Indicator",
      "SPN_Description": "This state signal is the transmission’s indication that it is operating under transmission mode 4 (SPN 1855) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\r\n\r\n00 Transmission Mode 4 not active\r\n01 Transmission Mode 4 Active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2576": {
      "PGN": 65141,
      "PGN_Name": "Laser Leveling System Vertical Deviation",
      "PGN_Description": "LVD",
      "first_bit": 16,
      "SPN": 2576,
      "SPN_Name": "Laser Receiver Type",
      "SPN_Description": "Identifies which type of Laser Receiver transmitted the message.\r\n\r\n0 = Reserved \r\n1 = Linear Laser Receiver\r\n2 = 1 Meter Survey Receiver\r\n3 = 2 Meter Survey Receiver\r\n4 = 2.5 Meter Survey Receiver\r\n5-250 = Reserved",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "2577": {
      "PGN": 65142,
      "PGN_Name": "Laser Leveling System Vertical Position Display Data",
      "PGN_Description": "LVDD",
      "first_bit": 20,
      "SPN": 2577,
      "SPN_Name": "Display Deadbands",
      "SPN_Description": "Sets Display Deadbands mode.\r\n\r\n0000 - Narrow = +/- 4.5mm\r\n0001 - Standard = +/- 12mm\r\n0010 - Wide = +/- 24mm\r\n0011 - 1110 Reserved\r\n1111 Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2578": {
      "PGN": 65142,
      "PGN_Name": "Laser Leveling System Vertical Position Display Data",
      "PGN_Description": "LVDD",
      "first_bit": 16,
      "SPN": 2578,
      "SPN_Name": "LED Pattern Control",
      "SPN_Description": "Sets LED Pattern control mode on laser leveling systems.\r\n\r\n0000 - 5 Channel\r\n0001 - Offset\r\n0010 - 7 Channel\r\n0011 - 1110 Reserved\r\n1111 Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2579": {
      "PGN": 65106,
      "PGN_Name": "Vehicle Electrical Power 3",
      "PGN_Description": "VEP3",
      "first_bit": 16,
      "SPN": 2579,
      "SPN_Name": "SLI Battery 1 Net Current (High Range/Resolution)",
      "SPN_Description": "Net flow of electrical current into/out of the first battery or first set of batteries used for starting the engine, for lighting, and for ignition (SLI).  If more than one battery is included in the first set of batteries and the net current for each battery is desired, then SPNs 7900, 7908, 7916, & 7924 shall be used.\r\n\n\nSee SPN 114 for alternate range and resolution.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -1600,
      "unit": "A",
      "SLOT_ID": 104
    },
    "2580": {
      "PGN": 64998,
      "PGN_Name": "Hydraulic Braking System",
      "PGN_Description": "HBS",
      "first_bit": 0,
      "SPN": 2580,
      "SPN_Name": "Hydraulic Brake Pressure Circuit 1",
      "SPN_Description": "Gage hydraulic pressure in circuit 1 of the hydraulic brake system",
      "bit_length": 8,
      "scaling": 100,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 161
    },
    "2581": {
      "PGN": 64998,
      "PGN_Name": "Hydraulic Braking System",
      "PGN_Description": "HBS",
      "first_bit": 8,
      "SPN": 2581,
      "SPN_Name": "Hydraulic Brake Pressure Circuit 2",
      "SPN_Description": "Gage hydraulic pressure in circuit 2 of the hydraulic brake system",
      "bit_length": 8,
      "scaling": 100,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 161
    },
    "2582": {
      "PGN": 64998,
      "PGN_Name": "Hydraulic Braking System",
      "PGN_Description": "HBS",
      "first_bit": 20,
      "SPN": 2582,
      "SPN_Name": "Hydraulic Brake Pressure Supply State Circuit 1",
      "SPN_Description": "Signal which indicates whether the hydraulic brake pressure supply of circuit 1 is reliable; that is, able to support continued braking.\r\n\r\n00 Supply is not reliable\r\n01 Supply is reliable\r\n10 Error indicator\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2583": {
      "PGN": 64998,
      "PGN_Name": "Hydraulic Braking System",
      "PGN_Description": "HBS",
      "first_bit": 22,
      "SPN": 2583,
      "SPN_Name": "Hydraulic Brake Pressure Supply State Circuit 2",
      "SPN_Description": "Signal which indicates whether the hydraulic brake pressure supply of circuit 2 is reliable; that is, able to support continued braking.\r\n\r\n00 Supply is not reliable\r\n01 Supply is reliable\r\n10 Error indicator\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2584": {
      "PGN": 64998,
      "PGN_Name": "Hydraulic Braking System",
      "PGN_Description": "HBS",
      "first_bit": 16,
      "SPN": 2584,
      "SPN_Name": "Hydraulic Brake Pressure Warning State Circuit 1",
      "SPN_Description": "Signal which indicates whether the hydraulic brake pressure of circuit 1 is below the warning level\r\n\r\n00 Pressure level sufficient\r\n01 Pressure level below warning level\r\n10 Error indicator\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2585": {
      "PGN": 64998,
      "PGN_Name": "Hydraulic Braking System",
      "PGN_Description": "HBS",
      "first_bit": 18,
      "SPN": 2585,
      "SPN_Name": "Hydraulic Brake Pressure Warning State Circuit 2",
      "SPN_Description": "Signal which indicates whether the hydraulic brake pressure of circuit 2 is below the warning level\r\n\r\n00 Pressure level sufficient\r\n01 Pressure level below warning level\r\n10 Error indicator\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2586": {
      "PGN": 65268,
      "PGN_Name": "Tire Condition Message 1",
      "PGN_Description": "TIRE1",
      "first_bit": 40,
      "SPN": 2586,
      "SPN_Name": "Tire Air Leakage Rate",
      "SPN_Description": "The pressure loss rate of a tire.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "Pa/s",
      "SLOT_ID": 162
    },
    "2587": {
      "PGN": 65268,
      "PGN_Name": "Tire Condition Message 1",
      "PGN_Description": "TIRE1",
      "first_bit": 61,
      "SPN": 2587,
      "SPN_Name": "Tire Pressure Threshold Detection",
      "SPN_Description": "Signal indicating the pressure level of the tire.  The levels defined represent different pressure conditions of the tire:\r\n\r\n000 Extreme over pressure - The tire pressure is at a level where the safety of the vehicle may be jeopardised.\r\n001 Over pressure - The tire pressure is higher than the pressure defined by the vehicle or tire manufacturer.\r\n010 No warning pressure - The tire pressure is within the thresholds defined by the vehicle or tire manufacturer.\r\n011 Under pressure - The tire pressure is lower than the pressure defined by the vehicle or tire manufacturer.\r\n100 Extreme under pressure - The tire pressure is at a level where the safety of the vehicle may be jeopardised.\r\n101 Not defined\r\n110 Error indicator\r\n111 Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "2588": {
      "PGN": 64997,
      "PGN_Name": "Maximum Vehicle Speed Limit Status",
      "PGN_Description": "MVS",
      "first_bit": 0,
      "SPN": 2588,
      "SPN_Name": "Maximum Vehicle Speed Limit 1",
      "SPN_Description": "The lowest Maximum Vehicle Speed Limit. This value is the similar to SPN 74. However, SPN 74 was not specifically defined to convey  the applied vehicle speed limit or what was possible to be applied. This new SPN is the lowest vehicle speed limit that is possible. Additionally, the lowest vehicle speed limit shall be applied when the J1939 network is no longer providing input regarding the Selected Maximum Vehicle Speed Limit. Exceptions to this exist when the device performing the maximum vehicle speed limiting function has methods of selecting the thresholds separately from the Selected Maximum Vehicle Speed Limit parameter.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 73
    },
    "2589": {
      "PGN": 64997,
      "PGN_Name": "Maximum Vehicle Speed Limit Status",
      "PGN_Description": "MVS",
      "first_bit": 8,
      "SPN": 2589,
      "SPN_Name": "Maximum Vehicle Speed Limit 2",
      "SPN_Description": "The highest of the two lowest vehicle speed limits",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 73
    },
    "2590": {
      "PGN": 64997,
      "PGN_Name": "Maximum Vehicle Speed Limit Status",
      "PGN_Description": "MVS",
      "first_bit": 16,
      "SPN": 2590,
      "SPN_Name": "Maximum Vehicle Speed Limit 3",
      "SPN_Description": "The highest of the three lowest vehicle speed limits",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 73
    },
    "2591": {
      "PGN": 64997,
      "PGN_Name": "Maximum Vehicle Speed Limit Status",
      "PGN_Description": "MVS",
      "first_bit": 24,
      "SPN": 2591,
      "SPN_Name": "Maximum Vehicle Speed Limit 4",
      "SPN_Description": "The highest of the four lowest vehicle speed limits",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 73
    },
    "2592": {
      "PGN": 64997,
      "PGN_Name": "Maximum Vehicle Speed Limit Status",
      "PGN_Description": "MVS",
      "first_bit": 32,
      "SPN": 2592,
      "SPN_Name": "Maximum Vehicle Speed Limit 5",
      "SPN_Description": "The highest of the five lowest vehicle speed limits",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 73
    },
    "2593": {
      "PGN": 64997,
      "PGN_Name": "Maximum Vehicle Speed Limit Status",
      "PGN_Description": "MVS",
      "first_bit": 40,
      "SPN": 2593,
      "SPN_Name": "Maximum Vehicle Speed Limit 6",
      "SPN_Description": "The highest of the six lowest vehicle speed limits",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 73
    },
    "2594": {
      "PGN": 64997,
      "PGN_Name": "Maximum Vehicle Speed Limit Status",
      "PGN_Description": "MVS",
      "first_bit": 48,
      "SPN": 2594,
      "SPN_Name": "Maximum Vehicle Speed Limit 7",
      "SPN_Description": "The highest of the seven lowest vehicle speed limits",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 73
    },
    "2595": {
      "PGN": 64997,
      "PGN_Name": "Maximum Vehicle Speed Limit Status",
      "PGN_Description": "MVS",
      "first_bit": 56,
      "SPN": 2595,
      "SPN_Name": "Applied Vehicle Speed Limit",
      "SPN_Description": "The vehicle speed limit in effect.\r\n\r\n251 (0xFB) is used to indicate that a maximum vehicle speed limit is not selected.\r\n\r\nSee SPN 7420 for alternate resolution.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 73
    },
    "2596": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 56,
      "SPN": 2596,
      "SPN_Name": "Selected Maximum Vehicle Speed Limit",
      "SPN_Description": "User selected maximum vehicle speed.  If one is selected, then this SPN must equal one of the maximum vehicle speeds #1-#7 from PGN 64997 - Maximum Vehicle Speed Limit Status . If different maximum vehicle speed requests are present from different devices, the lowest requested value should be used.\r\n\r\n0 is used to indicate that a maximum vehicle speed is not selected.  1 through 7 are valid selectable speed limits. 8 through 250 are not allowed.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "2597": {
      "PGN": 65089,
      "PGN_Name": "Lighting Command",
      "PGN_Description": "LCMD",
      "first_bit": 54,
      "SPN": 2597,
      "SPN_Name": "Implement Left Forward Work Light Command",
      "SPN_Description": "Command to activate or de-activate work lights mounted on an implement to illuminate beyond left end of the implement.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Reserved\r\n11 Don’t Care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2598": {
      "PGN": 65088,
      "PGN_Name": "Lighting Data",
      "PGN_Description": "LD",
      "first_bit": 54,
      "SPN": 2598,
      "SPN_Name": "Implement Left Forward Work Light",
      "SPN_Description": "This parameter provides measured data from the work lights mounted on an implement to illuminate the forward left end of the implement.\r\n\r\n00 De-activate\r\n01 Activate\r\n10 Fault Detected\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2599": {
      "PGN": 61448,
      "PGN_Name": "Hydraulic Pressure Governor Info",
      "PGN_Description": "HPG",
      "first_bit": 20,
      "SPN": 2599,
      "SPN_Name": "Fire Apparatus Pump Engagement",
      "SPN_Description": "The measured status of the pump used to provide water in fire fighting apparatus for distribution of water through water cannons or fire hoses.\r\n\r\n00 Pump not engaged\r\n01 Pump engaged\r\n10 Error\r\n11 Not available or not installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2600": {
      "PGN": 64996,
      "PGN_Name": "Equipment Performance Data",
      "PGN_Description": "EPD",
      "first_bit": 0,
      "SPN": 2600,
      "SPN_Name": "Payload Percentage",
      "SPN_Description": "The current payload of the equipment, reported as a percentage of the equipment's rated payload limit.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "2601": {
      "PGN": 64995,
      "PGN_Name": "Equipment Operation and Control",
      "PGN_Description": "EOAC",
      "first_bit": 0,
      "SPN": 2601,
      "SPN_Name": "Travel Velocity Control Position",
      "SPN_Description": "The position of the travel velocity control component reported as a percentage of the control's full displacement in each direction respectively.  Positive position values indicate forward travel direction;  negative position values indicate reverse, or backward, travel direction; and zero (0) percent position indicates the control device is in the neutral position.  Higher percent for a particular travel direction indicates a higher desired travel speed in that direction.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "2602": {
      "PGN": 65128,
      "PGN_Name": "Vehicle Fluids",
      "PGN_Description": "VF",
      "first_bit": 16,
      "SPN": 2602,
      "SPN_Name": "Hydraulic Oil Level",
      "SPN_Description": "This parameter indicates the level of the hydraulic fluid in tank as a ratio of current volume to total tank volume.  This parameter is intended for reporting the hydraulic fluid level in the system tank or reservoir.  This hydraulic fluid is for the entire hydraulics system of a piece of equipment.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "2603": {
      "PGN": 64994,
      "PGN_Name": "Supply Pressure Demand",
      "PGN_Description": "SPR",
      "first_bit": 0,
      "SPN": 2603,
      "SPN_Name": "Pneumatic Supply Pressure Request",
      "SPN_Description": "Command signal to influence the pneumatic pressure in the main reservoir.  This parameter is the setpoint for the parameter SPN 46.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "2604": {
      "PGN": 64994,
      "PGN_Name": "Supply Pressure Demand",
      "PGN_Description": "SPR",
      "first_bit": 8,
      "SPN": 2604,
      "SPN_Name": "Parking and/or Trailer Air Pressure Request",
      "SPN_Description": "Command signal to influence the pneumatic pressure in the circuit or reservoir for the parking brake and/or the trailer supply.  This parameter is the setpoint for the parameter SPN 1086.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "2605": {
      "PGN": 64994,
      "PGN_Name": "Supply Pressure Demand",
      "PGN_Description": "SPR",
      "first_bit": 16,
      "SPN": 2605,
      "SPN_Name": "Service Brake Air Pressure Request, Circuit #1",
      "SPN_Description": "Command signal to influence the pneumatic pressure in the service brake circuit or reservoir #1.  This parameter is the setpoint for the parameter SPN 1087.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "2606": {
      "PGN": 64994,
      "PGN_Name": "Supply Pressure Demand",
      "PGN_Description": "SPR",
      "first_bit": 24,
      "SPN": 2606,
      "SPN_Name": "Service Brake Air Pressure Request, Circuit #2",
      "SPN_Description": "Command signal to influence the pneumatic pressure in the service brake circuit or reservoir #2.  This parameter is the setpoint for the parameter SPN 1088.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "2607": {
      "PGN": 64994,
      "PGN_Name": "Supply Pressure Demand",
      "PGN_Description": "SPR",
      "first_bit": 32,
      "SPN": 2607,
      "SPN_Name": "Auxiliary Equipment Supply Pressure Request",
      "SPN_Description": "Command signal to influence the pneumatic pressure in the auxiliary circuit.   This parameter is the setpoint for the parameter SPN 1089.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "2608": {
      "PGN": 64994,
      "PGN_Name": "Supply Pressure Demand",
      "PGN_Description": "SPR",
      "first_bit": 40,
      "SPN": 2608,
      "SPN_Name": "Air Suspension Supply Pressure Request",
      "SPN_Description": "Command signal to influence the pneumatic pressure in the circuit for the electronically controlled air suspension system.   This parameter is the setpoint for the parameter SPN 1090.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "2609": {
      "PGN": 64993,
      "PGN_Name": "Cab A/C Climate System Information",
      "PGN_Description": "CACI",
      "first_bit": 0,
      "SPN": 2609,
      "SPN_Name": "Cab A/C Refrigerant Compressor Outlet Pressure",
      "SPN_Description": "This is the gage pressure at the compressor outlet in the cab air conditioning system.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 49
    },
    "2610": {
      "PGN": 64992,
      "PGN_Name": "Ambient Conditions 2",
      "PGN_Description": "AMB2",
      "first_bit": 0,
      "SPN": 2610,
      "SPN_Name": "Solar Intensity Percent",
      "SPN_Description": "This is the solar radiation (power density) falling on the vehicle in percent of the maximum sensor value (SPN 2611).  Currently this is in the infra-red spectrum.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "2611": {
      "PGN": 64992,
      "PGN_Name": "Ambient Conditions 2",
      "PGN_Description": "AMB2",
      "first_bit": 8,
      "SPN": 2611,
      "SPN_Name": "Solar Sensor Maximum",
      "SPN_Description": "This is the maximum value which can be reported by the sensor for the solar intensity. (This is a configuration parameter)",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "mW/cm²",
      "SLOT_ID": 204
    },
    "2612": {
      "PGN": 64991,
      "PGN_Name": "Front Wheel Drive Status",
      "PGN_Description": "FWD",
      "first_bit": 0,
      "SPN": 2612,
      "SPN_Name": "Front Wheel Drive Actuator Status",
      "SPN_Description": "Feedback on the front wheel drive actuator.\r\n\r\n00 Front Wheel Drive Actuator not engaged\r\n01 Front Wheel Drive Actuator engaged\r\n10 Error\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2613": {
      "PGN": 65273,
      "PGN_Name": "Axle Information",
      "PGN_Description": "AI",
      "first_bit": 32,
      "SPN": 2613,
      "SPN_Name": "Drive Axle Lube Pressure",
      "SPN_Description": "The drive axle lubricant pressure with location determined by Drive Axle Location (SPN 930).",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "2614": {
      "PGN": 65273,
      "PGN_Name": "Axle Information",
      "PGN_Description": "AI",
      "first_bit": 56,
      "SPN": 2614,
      "SPN_Name": "Steering Axle Lube Pressure",
      "SPN_Description": "The steering axle lubricant pressure.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "2615": {
      "PGN": 64988,
      "PGN_Name": "Marine Control Information",
      "PGN_Description": "MCI",
      "first_bit": 0,
      "SPN": 2615,
      "SPN_Name": "Engine Throttle Synchronization Mode Status",
      "SPN_Description": "The status of the Throttle Synchronization Mode. Throttle Synchronization Mode is used to indicate which throttle, if any, is currently being used for the synchronized throttle.  \r\n\r\n0000 Not Synchronized\r\n0001 Synchronized Center\r\n0010 Synchronized Port\r\n0011 Synchronized Starboard\r\n0100 Synchronized Master\r\n0101-1110 Reserved\r\n1111 Take no action",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2616": {
      "PGN": 64988,
      "PGN_Name": "Marine Control Information",
      "PGN_Description": "MCI",
      "first_bit": 4,
      "SPN": 2616,
      "SPN_Name": "Trolling Mode Status",
      "SPN_Description": "The status of the Trolling Mode.  Trolling mode limits the top speed.  Full range travel of the throttle level spans from low idle engine speed to maximum trolling speed.\r\n\r\n00 Trolling mode is OFF.\r\n01 Trolling mode is ACTIVE.\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2617": {
      "PGN": 64988,
      "PGN_Name": "Marine Control Information",
      "PGN_Description": "MCI",
      "first_bit": 6,
      "SPN": 2617,
      "SPN_Name": "Slow Vessel Mode Status",
      "SPN_Description": "The status of the Slow Vessel Mode.  Slow Vessel Mode puts the engine in a lower-than-normal low idle speed during docking or other slow vessel operations.\r\n\r\n00 Slow vessel mode is OFF.\r\n01 Slow vessel mode is ACTIVE.\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2623": {
      "PGN": 64963,
      "PGN_Name": "Electronic Engine Controller 15",
      "PGN_Description": "EEC15",
      "first_bit": 0,
      "SPN": 2623,
      "SPN_Name": "Accelerator Pedal #1 Channel 2",
      "SPN_Description": "Sensor output 2 for the accelerator pedal #1 position when using a redundant-style sensor.  The ratio of actual accelerator pedal position to maximum pedal position. This is for the first occurrence of the accelerator pedal. Although it is used as an input to determine powertrain demand, it also provides anticipatory information to transmission and ASR algorithms about driver actions.  This is the second sensor output when a multiple output (redundant) sensor is used for Accelerator Pedal #1 position.  Sensor outputs 1 & 3 (for accelerator pedal #1 position) are SPNs 91 & 2624.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "2624": {
      "PGN": 64963,
      "PGN_Name": "Electronic Engine Controller 15",
      "PGN_Description": "EEC15",
      "first_bit": 8,
      "SPN": 2624,
      "SPN_Name": "Accelerator Pedal #1 Channel 3",
      "SPN_Description": "Sensor output 3 for the accelerator pedal #1 position when using a redundant-style sensor.  The ratio of actual accelerator pedal position to maximum pedal position. This is for the first occurrence of the accelerator pedal. Although it is used as an input to determine powertrain demand, it also provides anticipatory information to transmission and ASR algorithms about driver actions.  This is the third sensor output when a multiple output (redundant) sensor is used for Accelerator Pedal #1 position.  Sensor outputs 1 & 2 (for accelerator pedal #1 position) are SPNs 91 & 2623.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "2625": {
      "PGN": 64963,
      "PGN_Name": "Electronic Engine Controller 15",
      "PGN_Description": "EEC15",
      "first_bit": 16,
      "SPN": 2625,
      "SPN_Name": "Accelerator Pedal #2 Channel 2",
      "SPN_Description": "Sensor output 2 for the accelerator pedal #2 position when using a redundant-style sensor.  The ratio of actual accelerator pedal position to maximum pedal position. This is for the second occurrence of the accelerator pedal. Although it is used as an input to determine powertrain demand, it also provides anticipatory information to transmission and ASR algorithms about driver actions.  This is the second sensor output when a multiple output (redundant) sensor is used for Accelerator Pedal # 2 position.  Sensor outputs 1 & 3 (for accelerator pedal #2 position) are SPNs 29 & 2626.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "2626": {
      "PGN": 64963,
      "PGN_Name": "Electronic Engine Controller 15",
      "PGN_Description": "EEC15",
      "first_bit": 24,
      "SPN": 2626,
      "SPN_Name": "Accelerator Pedal #2 Channel 3",
      "SPN_Description": "Sensor output 3 for the accelerator pedal #2 position when using a redundant-style sensor.  The ratio of actual accelerator pedal position to maximum pedal position. This is for the second occurrence of the accelerator pedal. Although it is used as an input to determine powertrain demand, it also provides anticipatory information to transmission and ASR algorithms about driver actions.  This is the third sensor output when a multiple output (redundant) sensor is used for Accelerator Pedal # 2 position.  Sensor outputs 1 & 2 (for accelerator pedal #2 position) are SPNs 29 & 2625.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "2629": {
      "PGN": 64979,
      "PGN_Name": "Turbocharger Information 6",
      "PGN_Description": "TCI6",
      "first_bit": 0,
      "SPN": 2629,
      "SPN_Name": "Engine Turbocharger 1 Compressor Outlet Temperature",
      "SPN_Description": "Temperature of the air or air/fuel mixture exiting the turbocharger 1 compressor outlet",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "2630": {
      "PGN": 65129,
      "PGN_Name": "Engine Temperature 3",
      "PGN_Description": "ET3",
      "first_bit": 48,
      "SPN": 2630,
      "SPN_Name": "Engine Charge Air Cooler 1 Outlet Temperature",
      "SPN_Description": "Temperature of combustion air after it exits from the Charge Air Cooler 1 but before any mixing of recirculated exhaust gas.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "2631": {
      "PGN": 64938,
      "PGN_Name": "Engine Fluid Level/Pressure 4",
      "PGN_Description": "EFL/P4",
      "first_bit": 56,
      "SPN": 2631,
      "SPN_Name": "Engine Charge Air Cooler Outlet Pressure",
      "SPN_Description": "Measures pressure of air at outlet from charge air cooler",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "2659": {
      "PGN": 61450,
      "PGN_Name": "Engine Gas Flow Rate",
      "PGN_Description": "EGF1",
      "first_bit": 0,
      "SPN": 2659,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Mass Flow Rate",
      "SPN_Description": "Flow rate of gas through the EGR system. Flow rate of the exhaust gas being recirculated into the combustion air.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "kg/h",
      "SLOT_ID": 18
    },
    "2660": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 6,
      "SPN": 2660,
      "SPN_Name": "Joystick 1 X-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "2661": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 22,
      "SPN": 2661,
      "SPN_Name": "Joystick 1 Y-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "2662": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 6,
      "SPN": 2662,
      "SPN_Name": "Joystick 1 Grip X-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "2663": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 22,
      "SPN": 2663,
      "SPN_Name": "Joystick 1 Grip Y-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "2664": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 38,
      "SPN": 2664,
      "SPN_Name": "Joystick 1 Theta-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "2665": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 4,
      "SPN": 2665,
      "SPN_Name": "Joystick 1 X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2666": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 20,
      "SPN": 2666,
      "SPN_Name": "Joystick 1 Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2667": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 4,
      "SPN": 2667,
      "SPN_Name": "Joystick 1 Grip X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2668": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 20,
      "SPN": 2668,
      "SPN_Name": "Joystick 1 Grip Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2669": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 36,
      "SPN": 2669,
      "SPN_Name": "Joystick 1 Theta-Axis Clockwise Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2670": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 2,
      "SPN": 2670,
      "SPN_Name": "Joystick 1 X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2671": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 18,
      "SPN": 2671,
      "SPN_Name": "Joystick 1 Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2672": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 2,
      "SPN": 2672,
      "SPN_Name": "Joystick 1 Grip X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2673": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 18,
      "SPN": 2673,
      "SPN_Name": "Joystick 1 Grip Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2674": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 34,
      "SPN": 2674,
      "SPN_Name": "Joystick 1 Theta-Axis Counter Clockwise Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2675": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 0,
      "SPN": 2675,
      "SPN_Name": "Joystick 1 X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2676": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 16,
      "SPN": 2676,
      "SPN_Name": "Joystick 1 Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2677": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 0,
      "SPN": 2677,
      "SPN_Name": "Joystick 1 Grip X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2678": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 16,
      "SPN": 2678,
      "SPN_Name": "Joystick 1 Grip Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2679": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 32,
      "SPN": 2679,
      "SPN_Name": "Joystick 1 Theta-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2680": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 38,
      "SPN": 2680,
      "SPN_Name": "Joystick 1 X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2681": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 36,
      "SPN": 2681,
      "SPN_Name": "Joystick 1 Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2682": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 54,
      "SPN": 2682,
      "SPN_Name": "Joystick 1 Grip X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2683": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 52,
      "SPN": 2683,
      "SPN_Name": "Joystick 1 Grip Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2684": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 50,
      "SPN": 2684,
      "SPN_Name": "Joystick 1 Theta-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2685": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 46,
      "SPN": 2685,
      "SPN_Name": "Joystick 1 Button 1 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2686": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 44,
      "SPN": 2686,
      "SPN_Name": "Joystick 1 Button 2 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2687": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 42,
      "SPN": 2687,
      "SPN_Name": "Joystick 1 Button 3 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2688": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 40,
      "SPN": 2688,
      "SPN_Name": "Joystick 1 Button 4 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2689": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 54,
      "SPN": 2689,
      "SPN_Name": "Joystick 1 Button 5 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2690": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 52,
      "SPN": 2690,
      "SPN_Name": "Joystick 1 Button 6 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2691": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 50,
      "SPN": 2691,
      "SPN_Name": "Joystick 1 Button 7 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2692": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 48,
      "SPN": 2692,
      "SPN_Name": "Joystick 1 Button 8 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2693": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 62,
      "SPN": 2693,
      "SPN_Name": "Joystick 1 Button 9 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2694": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 60,
      "SPN": 2694,
      "SPN_Name": "Joystick 1 Button 10 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2695": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 58,
      "SPN": 2695,
      "SPN_Name": "Joystick 1 Button 11 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2696": {
      "PGN": 64982,
      "PGN_Name": "Basic Joystick Message 1",
      "PGN_Description": "BJM1",
      "first_bit": 56,
      "SPN": 2696,
      "SPN_Name": "Joystick 1 Button 12 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2697": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 6,
      "SPN": 2697,
      "SPN_Name": "Joystick 2 X-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "2698": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 22,
      "SPN": 2698,
      "SPN_Name": "Joystick 2 Y-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "2699": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 6,
      "SPN": 2699,
      "SPN_Name": "Joystick 2 Grip X-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "2700": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 22,
      "SPN": 2700,
      "SPN_Name": "Joystick 2 Grip Y-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "2701": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 38,
      "SPN": 2701,
      "SPN_Name": "Joystick 2 Theta-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "2702": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 4,
      "SPN": 2702,
      "SPN_Name": "Joystick 2 X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2703": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 20,
      "SPN": 2703,
      "SPN_Name": "Joystick 2 Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2704": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 4,
      "SPN": 2704,
      "SPN_Name": "Joystick 2 Grip X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2705": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 20,
      "SPN": 2705,
      "SPN_Name": "Joystick 2 Grip Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2706": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 36,
      "SPN": 2706,
      "SPN_Name": "Joystick 2 Theta-Axis Clockwise Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2707": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 2,
      "SPN": 2707,
      "SPN_Name": "Joystick 2 X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2708": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 18,
      "SPN": 2708,
      "SPN_Name": "Joystick 2 Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2709": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 2,
      "SPN": 2709,
      "SPN_Name": "Joystick 2 Grip X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2710": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 18,
      "SPN": 2710,
      "SPN_Name": "Joystick 2 Grip Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2711": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 34,
      "SPN": 2711,
      "SPN_Name": "Joystick 2 Theta-Axis Counter Clockwise Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2712": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 0,
      "SPN": 2712,
      "SPN_Name": "Joystick 2 X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2713": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 16,
      "SPN": 2713,
      "SPN_Name": "Joystick 2 Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2714": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 0,
      "SPN": 2714,
      "SPN_Name": "Joystick 2 Grip X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.\r\n  \r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2715": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 16,
      "SPN": 2715,
      "SPN_Name": "Joystick 2 Grip Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2716": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 32,
      "SPN": 2716,
      "SPN_Name": "Joystick 2 Theta-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2717": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 38,
      "SPN": 2717,
      "SPN_Name": "Joystick 2 X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2718": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 36,
      "SPN": 2718,
      "SPN_Name": "Joystick 2 Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2719": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 54,
      "SPN": 2719,
      "SPN_Name": "Joystick 2 Grip X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2720": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 52,
      "SPN": 2720,
      "SPN_Name": "Joystick 2 Grip Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2721": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 50,
      "SPN": 2721,
      "SPN_Name": "Joystick 2 Theta-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2722": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 46,
      "SPN": 2722,
      "SPN_Name": "Joystick 2 Button 1 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2723": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 44,
      "SPN": 2723,
      "SPN_Name": "Joystick 2 Button 2 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2724": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 42,
      "SPN": 2724,
      "SPN_Name": "Joystick 2 Button 3 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2725": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 40,
      "SPN": 2725,
      "SPN_Name": "Joystick 2 Button 4 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2726": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 54,
      "SPN": 2726,
      "SPN_Name": "Joystick 2 Button 5 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2727": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 52,
      "SPN": 2727,
      "SPN_Name": "Joystick 2 Button 6 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2728": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 50,
      "SPN": 2728,
      "SPN_Name": "Joystick 2 Button 7 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2729": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 48,
      "SPN": 2729,
      "SPN_Name": "Joystick 2 Button 8 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2730": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 62,
      "SPN": 2730,
      "SPN_Name": "Joystick 2 Button 9 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2731": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 60,
      "SPN": 2731,
      "SPN_Name": "Joystick 2 Button 10 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2732": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 58,
      "SPN": 2732,
      "SPN_Name": "Joystick 2 Button 11 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2733": {
      "PGN": 64984,
      "PGN_Name": "Basic Joystick Message 2",
      "PGN_Description": "BJM2",
      "first_bit": 56,
      "SPN": 2733,
      "SPN_Name": "Joystick 2 Button 12 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2734": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 6,
      "SPN": 2734,
      "SPN_Name": "Joystick 3 X-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "2735": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 22,
      "SPN": 2735,
      "SPN_Name": "Joystick 3 Y-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "2736": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 6,
      "SPN": 2736,
      "SPN_Name": "Joystick 3 Grip X-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "2737": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 22,
      "SPN": 2737,
      "SPN_Name": "Joystick 3 Grip Y-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "2738": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 38,
      "SPN": 2738,
      "SPN_Name": "Joystick 3 Theta-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "2739": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 4,
      "SPN": 2739,
      "SPN_Name": "Joystick 3 X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2740": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 20,
      "SPN": 2740,
      "SPN_Name": "Joystick 3 Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2741": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 4,
      "SPN": 2741,
      "SPN_Name": "Joystick 3 Grip X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2742": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 20,
      "SPN": 2742,
      "SPN_Name": "Joystick 3 Grip Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2743": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 36,
      "SPN": 2743,
      "SPN_Name": "Joystick 3 Theta-Axis Clockwise Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2744": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 2,
      "SPN": 2744,
      "SPN_Name": "Joystick 3 X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2745": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 18,
      "SPN": 2745,
      "SPN_Name": "Joystick 3 Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2746": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 2,
      "SPN": 2746,
      "SPN_Name": "Joystick 3 Grip X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2747": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 18,
      "SPN": 2747,
      "SPN_Name": "Joystick 3 Grip Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2748": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 34,
      "SPN": 2748,
      "SPN_Name": "Joystick 3 Theta-Axis Counter Clockwise Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2749": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 0,
      "SPN": 2749,
      "SPN_Name": "Joystick 3 X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2750": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 16,
      "SPN": 2750,
      "SPN_Name": "Joystick 3 Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2751": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 0,
      "SPN": 2751,
      "SPN_Name": "Joystick 3 Grip X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2752": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 16,
      "SPN": 2752,
      "SPN_Name": "Joystick 3 Grip Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2753": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 32,
      "SPN": 2753,
      "SPN_Name": "Joystick 3 Theta-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2754": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 38,
      "SPN": 2754,
      "SPN_Name": "Joystick 3 X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2755": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 36,
      "SPN": 2755,
      "SPN_Name": "Joystick 3 Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2756": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 54,
      "SPN": 2756,
      "SPN_Name": "Joystick 3 Grip X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2757": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 52,
      "SPN": 2757,
      "SPN_Name": "Joystick 3 Grip Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2758": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 50,
      "SPN": 2758,
      "SPN_Name": "Joystick 3 Theta-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2759": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 46,
      "SPN": 2759,
      "SPN_Name": "Joystick 3 Button 1 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2760": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 44,
      "SPN": 2760,
      "SPN_Name": "Joystick 3 Button 2 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2761": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 42,
      "SPN": 2761,
      "SPN_Name": "Joystick 3 Button 3 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2762": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 40,
      "SPN": 2762,
      "SPN_Name": "Joystick 3 Button 4 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2763": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 54,
      "SPN": 2763,
      "SPN_Name": "Joystick 3 Button 5 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2764": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 52,
      "SPN": 2764,
      "SPN_Name": "Joystick 3 Button 6 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2765": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 50,
      "SPN": 2765,
      "SPN_Name": "Joystick 3 Button 7 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2766": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 48,
      "SPN": 2766,
      "SPN_Name": "Joystick 3 Button 8 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2767": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 62,
      "SPN": 2767,
      "SPN_Name": "Joystick 3 Button 9 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2768": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 60,
      "SPN": 2768,
      "SPN_Name": "Joystick 3 Button 10 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2769": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 58,
      "SPN": 2769,
      "SPN_Name": "Joystick 3 Button 11 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2770": {
      "PGN": 64986,
      "PGN_Name": "Basic Joystick Message 3",
      "PGN_Description": "BJM3",
      "first_bit": 56,
      "SPN": 2770,
      "SPN_Name": "Joystick 3 Button 12 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2773": {
      "PGN": 64918,
      "PGN_Name": "Fuel Information 2 (Liquid)",
      "PGN_Description": "LFI2",
      "first_bit": 0,
      "SPN": 2773,
      "SPN_Name": "Engine Fuel Supply Flow Rate",
      "SPN_Description": "The rate of fuel flowing through a fuel supply line carrying fuel from the fuel tank to the engine.",
      "bit_length": 32,
      "scaling": 0.001,
      "offset": 0,
      "unit": "l/h",
      "SLOT_ID": 321
    },
    "2774": {
      "PGN": 64918,
      "PGN_Name": "Fuel Information 2 (Liquid)",
      "PGN_Description": "LFI2",
      "first_bit": 32,
      "SPN": 2774,
      "SPN_Name": "Engine Fuel Return Flow Rate",
      "SPN_Description": "The rate of fuel flowing through a fuel return line carrying fuel from the engine back to fuel tank.",
      "bit_length": 32,
      "scaling": 0.001,
      "offset": 0,
      "unit": "l/h",
      "SLOT_ID": 321
    },
    "2775": {
      "PGN": 64919,
      "PGN_Name": "Fuel Information 3 (Liquid)",
      "PGN_Description": "LFI3",
      "first_bit": 0,
      "SPN": 2775,
      "SPN_Name": "Engine Fuel Supply Temperature",
      "SPN_Description": "The temperature of the fuel flowing through a fuel supply line from the fuel tank to the engine.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "2776": {
      "PGN": 64919,
      "PGN_Name": "Fuel Information 3 (Liquid)",
      "PGN_Description": "LFI3",
      "first_bit": 8,
      "SPN": 2776,
      "SPN_Name": "Engine Fuel Return Temperature",
      "SPN_Description": "The temperature of the fuel flowing through a fuel return line from the engine back to the fuel tank.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "2777": {
      "PGN": 64940,
      "PGN_Name": "Engine Fuel Information",
      "PGN_Description": "EFI",
      "first_bit": 0,
      "SPN": 2777,
      "SPN_Name": "Number of Fuel Consumption Monitoring Transducers",
      "SPN_Description": "The number of fuel consumption monitoring transducers installed in the fuel consumption monitoring system.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "2778": {
      "PGN": 64940,
      "PGN_Name": "Engine Fuel Information",
      "PGN_Description": "EFI",
      "first_bit": 8,
      "SPN": 2778,
      "SPN_Name": "Engine Idle Fuel Flow Rate Threshold",
      "SPN_Description": "A configuration value that indicates the maximum flow rate for engine idle operation.",
      "bit_length": 32,
      "scaling": 0.001,
      "offset": 0,
      "unit": "l/h",
      "SLOT_ID": 321
    },
    "2779": {
      "PGN": 65104,
      "PGN_Name": "Battery Temperature",
      "PGN_Description": "BT1",
      "first_bit": 16,
      "SPN": 2779,
      "SPN_Name": "SLI Battery 3 Temperature",
      "SPN_Description": "Temperature of the third battery or third set of batteries used for starting the engine, for lighting, and for ignition (SLI). \r\n\r\nThe relation to physical location is determined by the equipment manufacturer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "2780": {
      "PGN": 65104,
      "PGN_Name": "Battery Temperature",
      "PGN_Description": "BT1",
      "first_bit": 24,
      "SPN": 2780,
      "SPN_Name": "SLI Battery 4 Temperature",
      "SPN_Description": "Temperature of the fourth battery or fourth set of batteries used for starting the engine, for lighting, and for ignition (SLI). \r\n\r\nThe relation to physical location is determined by the equipment manufacturer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "2789": {
      "PGN": 64981,
      "PGN_Name": "Electronic Engine Controller 5",
      "PGN_Description": "EEC5",
      "first_bit": 0,
      "SPN": 2789,
      "SPN_Name": "Engine Turbocharger 1 Calculated Turbine Intake Temperature",
      "SPN_Description": "Calculated value of turbine intake temperature based on engine operating conditions, such as intake manifold temperature, charge fuel ratio, injection timing, and engine speed.  Use SPN 1180 for actual measured intake temperature.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "2790": {
      "PGN": 64981,
      "PGN_Name": "Electronic Engine Controller 5",
      "PGN_Description": "EEC5",
      "first_bit": 16,
      "SPN": 2790,
      "SPN_Name": "Engine Turbocharger 1 Calculated Turbine Outlet Temperature",
      "SPN_Description": "Calculated value of turbocharger compressor outlet air temperature.  Temperature of air exiting the turbocharger compressor and before entering charge air cooler.  The estimate is based on turbo speed and measured turbocharger compressor intake temperature.  Use SPN 1184 for actual measured outlet temperature.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "2791": {
      "PGN": 64981,
      "PGN_Name": "Electronic Engine Controller 5",
      "PGN_Description": "EEC5",
      "first_bit": 32,
      "SPN": 2791,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Valve 1 Control 1",
      "SPN_Description": "Desired percentage of maximum Exhaust Gas Recirculation (EGR) valve 1 opening.  0% means valve is closed. 100% means maximum valve opening (full gas flow).",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "2792": {
      "PGN": 64981,
      "PGN_Name": "Electronic Engine Controller 5",
      "PGN_Description": "EEC5",
      "first_bit": 48,
      "SPN": 2792,
      "SPN_Name": "Engine Variable Geometry Turbocharger (VGT) Air Control Shutoff Valve",
      "SPN_Description": "Isolates vehicle brake air from the Variable Geometry Turbocharger (VGT) system when engine is not running.  This valve prevents vehicle air from bleeding off through the VGT Control Valve when engine is not in use.  Primary vehicle air system from air tanks feed the VGT Air Control Shutoff Valve, which in turn provides air to the VGT Control Valve when the key switch is 'ON'.  The VGT Control Valve delivers air to the VGT actuator to adjust turbocharger geometry.\r\n\r\n00   VGT Air Control Shutoff Valve is Off\r\n01   VGT Air Control Shutoff Valve is On\r\n10   Reserved\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2793": {
      "PGN": 65141,
      "PGN_Name": "Laser Leveling System Vertical Deviation",
      "PGN_Description": "LVD",
      "first_bit": 24,
      "SPN": 2793,
      "SPN_Name": "Laser Strike Data Latency",
      "SPN_Description": "Time from laser strike to CAN message transmission.  This parameter will be reported by survey receiver type devices only. Byte 3 (SPN 2576) of  PGN 65141 identifies the type of Laser Receiver.",
      "bit_length": 16,
      "scaling": 0.0000512,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 206
    },
    "2794": {
      "PGN": 65141,
      "PGN_Name": "Laser Leveling System Vertical Deviation",
      "PGN_Description": "LVD",
      "first_bit": 40,
      "SPN": 2794,
      "SPN_Name": "Absolute Laser Strike Position",
      "SPN_Description": "Laser Strike location on the survey type  laser receiver.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "mm",
      "SLOT_ID": 14
    },
    "2795": {
      "PGN": 64981,
      "PGN_Name": "Electronic Engine Controller 5",
      "PGN_Description": "EEC5",
      "first_bit": 56,
      "SPN": 2795,
      "SPN_Name": "Engine Variable Geometry Turbocharger (VGT) 1 Actuator Position",
      "SPN_Description": "Sensor that measures the position of the variable geometry turbocharger actuator.  A  position of 0% indicates the actuator is in the position creating the smallest geometry turbocharger. A position of 100% represents the largest geometry turbocharger.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "2796": {
      "PGN": 64980,
      "PGN_Name": "Cab Message 3",
      "PGN_Description": "CM3",
      "first_bit": 0,
      "SPN": 2796,
      "SPN_Name": "Transfer Case Selector Switch",
      "SPN_Description": "Operator switch to select the condition of the transfer case.  States 000 and 001 should be used if the transfer case only functions to switch between 2-wheel and 4-wheel drive.  If the transfer case includes a High / Low Range function, states 011 and 100 should be supported as well.  For reporting the status of the transfer case, see SPN 3645.\r\n\r\n000:  \t2 wheel high (Normal or ‘On Highway’ Range)\r\n001:  \t4 wheel high (Normal or ‘On Highway’ Range)\r\n010:  \tNeutral\r\n011:\t2 wheel low (or ‘Off Highway’ Range)\r\n100:\t4 wheel low (or ‘Off Highway’ Range)\r\n101:  \tReserved for SAE assignment\r\n110:  \tError indicator\r\n111:  \tNot available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "2799": {
      "PGN": 64979,
      "PGN_Name": "Turbocharger Information 6",
      "PGN_Description": "TCI6",
      "first_bit": 16,
      "SPN": 2799,
      "SPN_Name": "Engine Turbocharger 2 Compressor Outlet Temperature",
      "SPN_Description": "Temperature of the air or air/fuel mixture exiting the turbocharger 2 compressor outlet.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "2800": {
      "PGN": 64979,
      "PGN_Name": "Turbocharger Information 6",
      "PGN_Description": "TCI6",
      "first_bit": 32,
      "SPN": 2800,
      "SPN_Name": "Engine Turbocharger 3 Compressor Outlet Temperature",
      "SPN_Description": "Temperature of the air or air/fuel mixture exiting the turbocharger 3 compressor outlet.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "2801": {
      "PGN": 64979,
      "PGN_Name": "Turbocharger Information 6",
      "PGN_Description": "TCI6",
      "first_bit": 48,
      "SPN": 2801,
      "SPN_Name": "Engine Turbocharger 4 Compressor Outlet Temperature",
      "SPN_Description": "Temperature of the air or air/fuel mixture exiting the turbocharger 4 compressor outlet.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "2802": {
      "PGN": 64978,
      "PGN_Name": "ECU Performance",
      "PGN_Description": "EP",
      "first_bit": 16,
      "SPN": 2802,
      "SPN_Name": "Data Memory Usage",
      "SPN_Description": "The used storage capacity of the data buffer memory internal to an ECU, such as a data logger.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "2803": {
      "PGN": 64978,
      "PGN_Name": "ECU Performance",
      "PGN_Description": "EP",
      "first_bit": 0,
      "SPN": 2803,
      "SPN_Name": "Keep-Alive Battery Consumption",
      "SPN_Description": "The capacity consumed from the direct battery connection since the key was last turned off.  This value is maintained and does not accumulate while the key switch is on.  The value is reset to 0 when the key switch is turned to the off position.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "mAh",
      "SLOT_ID": 211
    },
    "2804": {
      "PGN": 64977,
      "PGN_Name": "FMS-standard Interface Identity/Capabilities",
      "PGN_Description": "FMS",
      "first_bit": 0,
      "SPN": 2804,
      "SPN_Name": "FMS-standard Diagnostics Supported",
      "SPN_Description": "Status signal which indicates if the FMS Vehicle Interface (FMS Gateway) supports the handling of diagnostic messages from the vehicle network onto the FMS network.\r\n\r\nThe FMS gateway does NOT support the re-broadcast of diagnostics messages present on the vehicle network.\r\n\r\nIf this 'FMS-standard Diagnostics Supported' feature is supported by the FMS Gateway, the FMS Gateway will support the requests for  diagnostics information (from the FMS device) onto the vehicle network and pass the responses onto the FMS network.\r\n\r\nNote: This feature of the FMS Gateway is independent of the 'FMS-standard Requests Supported'. The FMS Gateway may support diagnostics without supporting the 'FMS-standard Requests Supported' function, or visa-versa.\r\n\r\n00 Diagnostics Is Not Supported\r\n01 Diagnostics Is Supported\r\n10 Reserved\r\n11 Don't care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2805": {
      "PGN": 64977,
      "PGN_Name": "FMS-standard Interface Identity/Capabilities",
      "PGN_Description": "FMS",
      "first_bit": 2,
      "SPN": 2805,
      "SPN_Name": "FMS-standard Requests Supported",
      "SPN_Description": "Status signal which indicates if the FMS Vehicle Interface (FMS Gateway) will respond to requests from the FMS device for the PGNs listed in the FMS Interface Specification.\r\n\r\nThis mode is to support FMS  gateway devices that only operate in a 'Request' mode.\r\n\r\nThe FMS PGNs may also be broadcast periodically in this mode.\r\n\r\nThe FMS Gateway will NOT support the requests for information not included in the FMS Interface Specification onto the vehicle network.\"\r\n\r\n\r\n00 On request mode is not supported\r\n01 On request mode is supported\r\n10 Reserved\r\n11 Don't care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2806": {
      "PGN": 64977,
      "PGN_Name": "FMS-standard Interface Identity/Capabilities",
      "PGN_Description": "FMS",
      "first_bit": 8,
      "SPN": 2806,
      "SPN_Name": "FMS-standard SW-version supported.",
      "SPN_Description": "Information that identifies which issue level of the FMS-standard document the software included in the FMS gateway supports. Four bytes, representing xx.yy type revision level identification.\r\n\r\nInformation to be ASCII equivalent of the numeric revision level of the FMS document, 00.01 to 99.99. The first released version will be 01.00.\r\n\r\nNote:\r\n\r\nByte 2 and byte 3 represents the SW version supported for trucks. Version number in the format ab.cd where Byte 2 represents \"a\" ASCII and Byte 3 represents \"b\" ASCII.\r\n\r\nByte 4 and byte 5 represents the SW version supported for bus and coaches; version number in the format ab.cd where Byte 4 represents \"c\" ASCII and Byte 5 represents \"d\" ASCII.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "ASCII",
      "SLOT_ID": 212
    },
    "2807": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 28,
      "SPN": 2807,
      "SPN_Name": "Engine Fuel Shutoff 2 Control",
      "SPN_Description": "Control setting for fuel shutoff 2.  First instance is SPN 632.  For a dual fuel shutoff system, this SPN is representative of the downstream fuel shutoff commanded position.  When fuel (gas) is desired at the engine, the fuel shutoff is opened.  Otherwise, it is closed.\r\n\r\n00 = Open (fuel supplied to engine)\r\n01 = Closed (no fuel supplied to engine)\r\n10 = Reserved\r\n11 = Don't care / take no action\r\n\r\nIn addition to communicating desired action of fuel shutoff 2 and its driver status, this new SPN can be used to communicate whether fuel shutoff 2 feedback position (if available) matches the commanded position, through the use of FMIs.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2809": {
      "PGN": 64976,
      "PGN_Name": "Intake/Exhaust Conditions 2",
      "PGN_Description": "IC2",
      "first_bit": 0,
      "SPN": 2809,
      "SPN_Name": "Engine Air Filter 2 Differential Pressure",
      "SPN_Description": "Change in engine air system pressure, measured across the second air filter, due to the filter and any accumulation of solid foreign matter on or in the filter.\r\n\r\nThis is for monitoring the air filter on the intake to the second turbocharger. Filter numbering follows the guidelines noted in section Naming Convention For Engine Parameters.",
      "bit_length": 8,
      "scaling": 0.05,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 48
    },
    "2810": {
      "PGN": 64976,
      "PGN_Name": "Intake/Exhaust Conditions 2",
      "PGN_Description": "IC2",
      "first_bit": 8,
      "SPN": 2810,
      "SPN_Name": "Engine Air Filter 3 Differential Pressure",
      "SPN_Description": "Change in engine air system pressure, measured across the third air filter, due to the filter and any accumulation of solid foreign matter on or in the filter.\r\n\r\nThis is for monitoring the air filter on the intake to the third turbocharger. Filter numbering follows the guidelines noted in section Naming Convention For Engine Parameters.",
      "bit_length": 8,
      "scaling": 0.05,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 48
    },
    "2811": {
      "PGN": 64976,
      "PGN_Name": "Intake/Exhaust Conditions 2",
      "PGN_Description": "IC2",
      "first_bit": 16,
      "SPN": 2811,
      "SPN_Name": "Engine Air Filter 4 Differential Pressure",
      "SPN_Description": "Change in engine air system pressure, measured across the fourth air filter, due to the filter and any accumulation of solid foreign matter on or in the filter.\r\n\r\nThis is for monitoring the air filter on the intake to the fourth turbocharger. Filter numbering follows the guidelines noted in section Naming Convention For Engine Parameters.",
      "bit_length": 8,
      "scaling": 0.05,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 48
    },
    "2812": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 54,
      "SPN": 2812,
      "SPN_Name": "Engine Overspeed Test",
      "SPN_Description": "The engine overspeed test signal as measured by the reporting ECM.  Engine Overspeed Test is a mechanism to simulate engine overspeed situations, while operating the engine within the engine's safe operating range.\r\n\r\nState signal which indicates when the overspeed test input to the ECM is being driven.\r\n\r\n00 Engine Overspeed Test Not Active\r\n01 Engine Overspeed Test Active\r\n10 Reserved\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2813": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 52,
      "SPN": 2813,
      "SPN_Name": "Engine Air Shutoff Command Status",
      "SPN_Description": "State signal which indicates when the Air Shutoff  driver output is being driven. Disabled means controller wants air flowing to the engine. Status of the airflow  shutoff as being commanded by the ECU.\r\n\r\n00 Air Shutoff Disabled, not attempting to shutoff engine air supply\r\n01 Air Shutoff Enabled, attempting to shutoff engine air supply\r\n10 Reserved\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2814": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 50,
      "SPN": 2814,
      "SPN_Name": "Engine Alarm Output Command Status",
      "SPN_Description": "State signal which indicates when the Alarm driver output is being driven. Not active means the Controller has no alarm level conditions.\r\n\r\n00 Engine Alarm Output Command Not Active\r\n01 Engine Alarm Output Command Active\r\n10 Reserved\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2815": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 48,
      "SPN": 2815,
      "SPN_Name": "Engine Alarm Acknowledge",
      "SPN_Description": "The Engine Alarm Acknowledge Input signal as measured by the reporting ECU.  The Engine Alarm Acknowledge is a mechanism for external acknowledgement of the SPN 2814,  Engine Alarm Output Command. \r\n\r\n00 Engine Alarm Acknowledge  Not Active \r\n01 Engine Alarm Acknowledge Active\r\n10 Error\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2863": {
      "PGN": 64973,
      "PGN_Name": "Operator Wiper and Washer Controls Message",
      "PGN_Description": "OWW",
      "first_bit": 4,
      "SPN": 2863,
      "SPN_Name": "Front Operator Wiper Switch",
      "SPN_Description": "State of operation selected by operator switch for the Wiper in front of the operator position. This parameter, 'Front Operator Wiper Switch' should be used for the control information if either of the other wiper switch parameters is 'Not Available' and the associated wiper still needs to be controlled.\r\n\r\n0000 Off\r\n0001 Low\r\n0010 Medium\r\n0011 High\r\n0100 Delayed 1 (used for the first delay choice when the wiper switch position controls the delay)\r\n0101 Delayed 2 (used for the second delay choice when the wiper switch position controls the delay)\r\n0110 Mist (position where external sensor  controls wiper rate)\r\n0111 - 1110   Reserved   \r\n1111 Not available (do not change)",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2864": {
      "PGN": 64973,
      "PGN_Name": "Operator Wiper and Washer Controls Message",
      "PGN_Description": "OWW",
      "first_bit": 0,
      "SPN": 2864,
      "SPN_Name": "Front Non-operator Wiper Switch",
      "SPN_Description": "State of operation selected by operator switch for the front wiper not in front of the operator position.  The parameter, 'Front Operator Washer Switch' should be used for the control information if this parameter is 'Not Available' and the associated washer still needs to be controlled.\r\n\r\n0000 Off\r\n0001 Low\r\n0010 Medium\r\n0011 High\r\n0100 Delayed 1 (used for the first delay choice when the wiper switch position controls the delay)\r\n0101 Delayed 2 (used for the second delay choice when the wiper switch position controls the delay)\r\n0110 Mist (position where external sensor  controls wiper rate)\r\n0111 - 1110   Reserved   \r\n1111 Not available (do not change)",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2865": {
      "PGN": 64973,
      "PGN_Name": "Operator Wiper and Washer Controls Message",
      "PGN_Description": "OWW",
      "first_bit": 12,
      "SPN": 2865,
      "SPN_Name": "Rear Wiper Switch",
      "SPN_Description": "State of operation selected by operator switch for the rear wiper.  The parameter, 'Front Operator Washer Switch' should be used for the control information if this parameter is 'Not Available' and the associated washer still needs to be controlled.\r\n\r\n0000 Off\r\n0001 Low\r\n0010 Medium\r\n0011 High\r\n0100 Delayed 1 (used for the first delay choice when the wiper switch position controls the delay)\r\n0101 Delayed 2 (used for the second delay choice when the wiper switch position controls the delay)\r\n0110 Mist (position where external sensor  controls wiper rate)\r\n0111 - 1110   Reserved   \r\n1111 Not available (do not change)",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2866": {
      "PGN": 64973,
      "PGN_Name": "Operator Wiper and Washer Controls Message",
      "PGN_Description": "OWW",
      "first_bit": 45,
      "SPN": 2866,
      "SPN_Name": "Front Operator Washer Switch",
      "SPN_Description": "State of operation selected by operator switch for the washer in front of the operator position. This parameter, 'Front Operator Washer Switch’ should be used for the control information if either of the other washer switch parameters  is 'Not Available' and the associated washer still needs to be controlled.\r\n\r\n000 Off\r\n001 Low\r\n010 Medium\r\n011 High\r\n100 - 110   Reserved   \r\n111 Not available (do not change)",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "2867": {
      "PGN": 64973,
      "PGN_Name": "Operator Wiper and Washer Controls Message",
      "PGN_Description": "OWW",
      "first_bit": 42,
      "SPN": 2867,
      "SPN_Name": "Front Non-operator Washer Switch",
      "SPN_Description": "State of operation selected by operator switch for the front washer not in front of the operator position.  The parameter, 'Front Operator Washer Switch’ should be used for the control information if this parameter  is 'Not Available' and the associated washer still needs to be controlled.\r\n\r\n000 Off\r\n001 Low\r\n010 Medium\r\n011 High\r\n100 - 110   Reserved   \r\n111 Not available (do not change)",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "2868": {
      "PGN": 64973,
      "PGN_Name": "Operator Wiper and Washer Controls Message",
      "PGN_Description": "OWW",
      "first_bit": 53,
      "SPN": 2868,
      "SPN_Name": "Rear Washer Function",
      "SPN_Description": "State of operation selected by operator switch for the rear washer.   The parameter, 'Front Operator Washer Switch’ should be used for the control information if this parameter is 'Not Available' and the associated washer still needs to be controlled.\r\n\r\n000 Off\r\n001 Low\r\n010 Medium\r\n011 High\r\n100 - 110   Reserved   \r\n111 Not available (do not change)",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "2869": {
      "PGN": 64973,
      "PGN_Name": "Operator Wiper and Washer Controls Message",
      "PGN_Description": "OWW",
      "first_bit": 16,
      "SPN": 2869,
      "SPN_Name": "Front Operator Wiper Delay Control",
      "SPN_Description": "Time between cycles of the front operator side wiper (i.e. from end of cycle 'n' to start of cycle 'n+1') as selected by the operator control (switch, etc.) in percentage of position with maximum position corresponding to maximum delay selectable.  This parameter, 'Front Operator Wiper Delay Control' should be used for the delay information if either of the other delay parameters is 'Not Available' and the function needs to be provided.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "2870": {
      "PGN": 64973,
      "PGN_Name": "Operator Wiper and Washer Controls Message",
      "PGN_Description": "OWW",
      "first_bit": 24,
      "SPN": 2870,
      "SPN_Name": "Front Non-operator Wiper Delay Control",
      "SPN_Description": "Time between cycles of the front non-operator side wiper (i.e. from end of cycle 'n' to start of cycle 'n+1') as selected by the operator control (switch, etc.) in percentage of position with maximum position corresponding to maximum delay selectable.  The parameter, 'Front Operator Wiper Delay Control' should be used for the delay information if this parameter is 'Not Available' and the function needs to be provided.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "2871": {
      "PGN": 64973,
      "PGN_Name": "Operator Wiper and Washer Controls Message",
      "PGN_Description": "OWW",
      "first_bit": 32,
      "SPN": 2871,
      "SPN_Name": "Rear Wiper Delay Control",
      "SPN_Description": "Time between cycles of the rear wiper (i.e. from end of cycle 'n' to start of cycle 'n+1') as selected by the operator control (switch, etc.) in percentage of position with maximum position corresponding to maximum delay selectable.  The parameter, 'Front Operator Wiper Delay Control' should be used for the delay information if this parameter is 'Not Available' and the function needs to be provided.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "2872": {
      "PGN": 64972,
      "PGN_Name": "Operators External Light Controls Message",
      "PGN_Description": "OEL",
      "first_bit": 4,
      "SPN": 2872,
      "SPN_Name": "Main Light Switch",
      "SPN_Description": "A 4 bit parameter to indicate the selected position of the operator's main light switch.\r\n\r\n0000  Off - The position by which the operator selects that none of the lamps are to be on.\r\n0001  Park On - The position by which the operator selects that the park lamps are to be on. \r\n0010  Headlight On - The position by which the operator selects that the headlamps are to be on.\r\n0011  Headlight and Park On - The position by which the operator selects that Both the Headlamps and the Park lamps are to be on.\r\n0100  Automatic Lights - The position by which the operator selects that the Headlamps and Park Lamps turn on and off due to outside ambient light conditions\r\n0101  Reserved\r\n0110  Reserved\r\n0111  Reserved   \r\n1000  Delayed Off - The position by which the operator selects that a certain set of lamps are to come On and then are to be turned Off following a delay time (Operators Desired - Delayed Lamp Off Time).\r\n1001  Reserved\r\n1010  Reserved\r\n1011  Reserved\r\n1100  Reserved\r\n1101  Reserved\r\n1110  Error\r\n1111  Not available (do not change)",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2873": {
      "PGN": 64972,
      "PGN_Name": "Operators External Light Controls Message",
      "PGN_Description": "OEL",
      "first_bit": 0,
      "SPN": 2873,
      "SPN_Name": "Work Light Switch",
      "SPN_Description": "A 4 bit parameter to indicate the selected position of the operator's work light switch. In Ag applications the work lights are often refereed to as field lights.  In on-highway applications the work lights are often referred to as clearance lights and may or may not be operated by a switch separate from the main light switch.\r\n \r\n0000   Off - The position by which the operator selects that none of the work lamps are to be on.\r\n0001   Work Light Combination #1 On - The position by which the operator selects that the lamps in the combination defined as Work Light Combination #1 are to be on.\r\n0010   Work Light Combination #2 On - The position by which the operator selects that the lamps in the combination defined as Work Light Combination #2 are to be on.\r\n0011   Work Light Combination #3 On - The position by which the operator selects that the lamps in the combination defined as Work Light Combination #3 are to be on.\r\n0100   Work Light Combination #4 On - The position by which the operator selects that the lamps in the combination defined as Work Light Combination #4 are to be on.\r\n0101-1101    Reserved   \r\n1110   Error\r\n1111   Not available (do not change)",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2874": {
      "PGN": 64972,
      "PGN_Name": "Operators External Light Controls Message",
      "PGN_Description": "OEL",
      "first_bit": 14,
      "SPN": 2874,
      "SPN_Name": "High-Low Beam Switch",
      "SPN_Description": "A 2 bit parameter to indicate the selected position of the operator's high/low beam select switch.\r\n\r\n00  Low Beam Selected\r\n01  High Beam Selected\r\n10  Error\r\n11  Not available (do not change)",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2875": {
      "PGN": 64972,
      "PGN_Name": "Operators External Light Controls Message",
      "PGN_Description": "OEL",
      "first_bit": 12,
      "SPN": 2875,
      "SPN_Name": "Hazard Light Switch",
      "SPN_Description": "A 2 bit parameter to indicate the selected position of the operator's hazard light switch.\r\n\r\n00   Hazard Lamps to be Off\r\n01   Hazard Lamps to be Flashing\r\n10   Error\r\n11   Not available (do not change)",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2876": {
      "PGN": 64972,
      "PGN_Name": "Operators External Light Controls Message",
      "PGN_Description": "OEL",
      "first_bit": 8,
      "SPN": 2876,
      "SPN_Name": "Turn Signal Switch",
      "SPN_Description": "A 4 bit parameter to indicate the selected position of the operator's turn signal switch.\r\n\r\n0000   No Turn being signaled\r\n0001   Left Turn to be Flashing\r\n0010   Right turn to be Flashing\r\n0011 - 1101   Reserved   \r\n1110   Error (to include both left and right selected simultaneously)\r\n1111   Not available (do not change)",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2877": {
      "PGN": 64972,
      "PGN_Name": "Operators External Light Controls Message",
      "PGN_Description": "OEL",
      "first_bit": 24,
      "SPN": 2877,
      "SPN_Name": "Operators Desired - Delayed Lamp Off Time",
      "SPN_Description": "A 16 bit parameter to be associated with Delayed Off position (1000 binary) of the Main Light Switch.  This parameter indicates the time the operator wishes to have elapse following the Main Light switch being placed in Delayed Off position before the defined lights turn back off.  The Operator's definition as to which lamps are to turn On (and then Off of course) when the Main Light Switch is in the Delayed Off position.  The specific lamps are not identified within this message, but are to be stored by whatever device (ecu) is planning to send the lamp command message for said lamps.  Said device must also provide the means for the operator to enter and/or adjust said definition.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 64
    },
    "2878": {
      "PGN": 64972,
      "PGN_Name": "Operators External Light Controls Message",
      "PGN_Description": "OEL",
      "first_bit": 16,
      "SPN": 2878,
      "SPN_Name": "Operators Desired Back-light",
      "SPN_Description": "A 8 bit parameter to indicate the level of back lighting the operator has selected for displays.  This is to be differentiated from the Illumination Brightness Percent (SPN:1487 PGN:53248 Cab Illumination Message) which is sent to the displays to tell them what level to be at.  This is the operator desired level (as sensed by operator controls) for those system where the operator controls are monitored by an ecu separate from the ecu sending the command to the displays.  Note each display (if appropriate) will need to have its own balance function to compensate its nominal brightness to the same level of that of all other displays.  This is especially important for systems with back-lights which may change noticeable with aging.  In other words it will be necessary within a vehicle to scale all of the displays down to the same level as the dimmest display (since, obviously you can not make the dimmest brighter).",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "2879": {
      "PGN": 64971,
      "PGN_Name": "Off-Highway Engine Control Selection",
      "PGN_Description": "OHECS",
      "first_bit": 20,
      "SPN": 2879,
      "SPN_Name": "Engine Droop Accelerator 2 Select",
      "SPN_Description": "In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching. The selections apply to Accelerator 2.\r\n\r\n0000 – Normal Droop Setting is selected\r\n0001 thru 1101 – One of Droop Setting 1 through 13 (in sequential order) is selected\r\n1110 –  Error condition\r\n1111  – Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2880": {
      "PGN": 64970,
      "PGN_Name": "Intermediate Speed Control",
      "PGN_Description": "ISC",
      "first_bit": 0,
      "SPN": 2880,
      "SPN_Name": "Engine Operator Primary Intermediate Speed Select",
      "SPN_Description": "Allows the operator to select one of 13 preprogrammed Intermediate Speed Control settings. If no speed setting is requested, the engine operates normally. The Intermediate Speed Control is widely used in the Industrial application to control the engine to an intermediate speed setting which can either replace the accelerator position control altogether, or limit the accelerator position control to a selectable speed point minimum or maximum.\r\n\r\n0000 – indicates that the ISC functionality is not requested, engine operates normally\r\n0001 thru 1101 – indicates that the ISC Setting 1 thru 13 (in sequential order) is selected\r\n1110 – error condition\r\n1111 – not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2881": {
      "PGN": 64971,
      "PGN_Name": "Off-Highway Engine Control Selection",
      "PGN_Description": "OHECS",
      "first_bit": 16,
      "SPN": 2881,
      "SPN_Name": "Engine Droop Accelerator 1 Select",
      "SPN_Description": "In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching. The selections apply to Accelerator 1.\r\n\r\n0000 – Normal Droop Setting is selected\r\n0001 thru 1101 – One of Droop Setting 1 through 13 (in sequential order) is selected\r\n1110 –  Error condition\r\n1111  – Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2882": {
      "PGN": 64971,
      "PGN_Name": "Off-Highway Engine Control Selection",
      "PGN_Description": "OHECS",
      "first_bit": 8,
      "SPN": 2882,
      "SPN_Name": "Engine Alternate Rating Select",
      "SPN_Description": "In some off-highway applications it may be desirable to have multiple engine ratings available for selection by the operator. There is the default engine rating, which provides the maximum available power across the range of operation. There are additional engine ratings which the user can select that allow for alternate fueling across the operational range.  Engine rating selection number 0 is the maximum rating. Selection number 1 is the next highest, selection 2 next highest, etc. The selection impacts the operating points in the Engine Configuration.\r\n\r\n0 – indicates that Maximum Power Fueling is selected\r\n1 – indicates that the Alternate Power Fueling 1 is selected\r\n2 – indicates that the Alternate Power Fueling 2 is selected\r\n3 – indicates that the Alternate Power Fueling 3 is selected\r\n4 thru 253 - indicates that the Alternate Power Fueling 4 thru 253 (in sequential order) is selected.\r\n254 – Error condition.\r\n255 – Not available",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "selection",
      "SLOT_ID": 259
    },
    "2883": {
      "PGN": 64971,
      "PGN_Name": "Off-Highway Engine Control Selection",
      "PGN_Description": "OHECS",
      "first_bit": 4,
      "SPN": 2883,
      "SPN_Name": "Engine Alternate Low Idle Switch",
      "SPN_Description": "Operator switch which selects between two low idle speeds, default and alternate.\r\n\r\nThe normal programmed low idle is the default low idle, and when the Alternate Low Idle switch is activated, a alternate preprogrammed low idle speed is selected. The accelerator position control operates as normal but is now bounded to a different low idle speed. This selection impacts Point 1 on the Engine Configuration.\r\n\r\n\r\n00 Default low idle point is selected\r\n01 Alternate low idle point is selected\r\n10 Error\r\n11 Not available or Unused",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2884": {
      "PGN": 64971,
      "PGN_Name": "Off-Highway Engine Control Selection",
      "PGN_Description": "OHECS",
      "first_bit": 0,
      "SPN": 2884,
      "SPN_Name": "Engine Auxiliary Governor Switch",
      "SPN_Description": "This is the On/Off operation of the Auxiliary Governor feature switch. This feature is used to allow engine speed to be controlled by an auxiliary input such as pressure or tailshaft speed. This switch position indicates whether this feature is requested or not. \r\n\r\n00 – Auxiliary Governor is disabled\r\n01 – Auxiliary Governor is enabled\r\n10 – Error condition\r\n11 – Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2885": {
      "PGN": 64971,
      "PGN_Name": "Off-Highway Engine Control Selection",
      "PGN_Description": "OHECS",
      "first_bit": 28,
      "SPN": 2885,
      "SPN_Name": "Engine Droop Auxiliary Input Select",
      "SPN_Description": "In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the alternate droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching. The selections apply to the engine droop auxiliary input.\r\n\r\n0000 – Normal Droop Setting is selected\r\n0001 thru 1101 – One of Droop Setting 1 through 13 (in sequential order) is selected\r\n1110 –  Error condition\r\n1111 –  Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2886": {
      "PGN": 64971,
      "PGN_Name": "Off-Highway Engine Control Selection",
      "PGN_Description": "OHECS",
      "first_bit": 24,
      "SPN": 2886,
      "SPN_Name": "Engine Droop Remote Accelerator Select",
      "SPN_Description": "In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the alternate droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching. The selections apply to the remote accelerator.\r\n\r\n0000 – Normal Droop Setting is selected\r\n0001 thru 1101 – One of Droop Setting 1 through 13 (in sequential order) is selected\r\n1110 –  Error condition\r\n1111 –  Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2887": {
      "PGN": 64969,
      "PGN_Name": "Electronic Control Module Information",
      "PGN_Description": "CMI",
      "first_bit": 0,
      "SPN": 2887,
      "SPN_Name": "Total Count of Configuration Changes Made",
      "SPN_Description": "Total number of times changes have been made to any of the configurable parameters.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "2888": {
      "PGN": 64967,
      "PGN_Name": "Off-Highway Engine Control Selection States",
      "PGN_Description": "OHCSS",
      "first_bit": 8,
      "SPN": 2888,
      "SPN_Name": "Engine Alternate Rating Select State",
      "SPN_Description": "This parameter reflects the control state that has been achieved based on the input from the SPN 2882.  In some off-highway applications it may be desirable to have multiple engine ratings available for selection by the operator.  There is the default engine rating, which provides the maximum available power across the range of operation. There are additional engine ratings which the engine controller may use that allow for alternate fueling across the operational range.  Engine rating  number 1 is the maximum rating. Rating number 2 is the next highest, rating 3 next highest, etc.\r\n\r\n00 – Control state is Maximum Power Fueling\r\n01 – Control state is Alternate Power Fueling 1 \r\n02 – Control state is Alternate Power Fueling 2 \r\n03 – Control state is Alternate Power Fueling 3\r\n04 thru 253 - Control state is Alternate Power Fueling 4 thru 253 (in sequential order) \r\n254 – SAE reserved\r\n255 – Not available",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "2889": {
      "PGN": 64967,
      "PGN_Name": "Off-Highway Engine Control Selection States",
      "PGN_Description": "OHCSS",
      "first_bit": 16,
      "SPN": 2889,
      "SPN_Name": "Engine Droop Accelerator 1 Select State",
      "SPN_Description": "In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the alternate droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching. The selections may apply to Accelerator 1. This parameter indicates which state has been selected by the controlling ECM.\r\n\r\n0000 – Control state is Normal Droop Setting\r\n0001 thru 1101 – Control state is one of Droop Setting 1 through 13 (in sequential order) \r\n1110 –  SAE reserved\r\n1111 –  Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2890": {
      "PGN": 64967,
      "PGN_Name": "Off-Highway Engine Control Selection States",
      "PGN_Description": "OHCSS",
      "first_bit": 2,
      "SPN": 2890,
      "SPN_Name": "Engine Multi-Unit Sync State",
      "SPN_Description": "This feature is widely used in Industry to operate multiple engines from a single command source. A master engine will “synchronize” one or more slave engines to operate at the same speed. This feature is requested by an operator switch, this parameter indictes the state of the feature as determined by the controlling ECM.\r\n\r\n00 Control State is Functionality disabled (off)\r\n01 Control State is Functionality enabled (on)\r\n10 SAE reserved\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2891": {
      "PGN": 64967,
      "PGN_Name": "Off-Highway Engine Control Selection States",
      "PGN_Description": "OHCSS",
      "first_bit": 4,
      "SPN": 2891,
      "SPN_Name": "Engine Alternate Low Idle Select State",
      "SPN_Description": "In many applications, it is desirable that an alternate low idle speed setting be made available via switch input. The normal programmed low idle is the default low idle, and when the Alternate Low Idle feature is activated, an alternate preprogrammed low idle speed is selected. The accelerator position control operates as normal but is now bounded to a different low idle speed. This selection impacts Point 1 on the Engine Configuration.\r\n\r\n00 – Normal idle state\r\n01 – Alternate idle state\r\n10 – SAE reserved\r\n11 – not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2892": {
      "PGN": 64968,
      "PGN_Name": "Operator Primary Intermediate Speed Control state",
      "PGN_Description": "ISCS",
      "first_bit": 0,
      "SPN": 2892,
      "SPN_Name": "Engine Operator Primary Intermediate Speed Select State",
      "SPN_Description": "13 preprogrammed intermediate speed control settings are available for the controlling ECM to select.  If no speed setting is requested, the engine operates normally. The Intermediate Speed Control is widely used in the Industrial application to control the engine to an intermediate speed setting which can either replace the accelerator position control altogether, or limit the accelerator position control to a selectable speed point minimum or maximum. This parameter indicates which state has been selected by the controlling ECM.\r\n\r\n0000 – Control state is ISC functionality is not requested, engine operates normally\r\n0001 thru 1101 – Control state is  ISC Setting 1 thru 13 (in sequential order) \r\n1110 – SAE reserved\r\n1111 – not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2893": {
      "PGN": 64967,
      "PGN_Name": "Off-Highway Engine Control Selection States",
      "PGN_Description": "OHCSS",
      "first_bit": 20,
      "SPN": 2893,
      "SPN_Name": "Engine Alternate Droop Accelerator 2 Select State",
      "SPN_Description": "In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the alternate droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching. The selections apply to Accelerator 2.\r\n\r\n0000 – Control's state is Normal Droop Setting\r\n0001 thru 1101 – Control's state is One of Alternate Droop Setting 1 through 13 (in sequential order)\r\n1110 –  SAE reserved\r\n1111 –  Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2894": {
      "PGN": 64967,
      "PGN_Name": "Off-Highway Engine Control Selection States",
      "PGN_Description": "OHCSS",
      "first_bit": 24,
      "SPN": 2894,
      "SPN_Name": "Engine Droop Remote Accelerator Select State",
      "SPN_Description": "In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the alternate droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching.  The selections apply to Remote Accelerator.\r\n\r\n0000 – Control state is Normal Droop Setting\r\n0001 thru 1101 – Control state is One of Droop Setting 1 through 13 (in sequential order) \r\n1110 –  SAE reserved\r\n1111 –  Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2895": {
      "PGN": 64967,
      "PGN_Name": "Off-Highway Engine Control Selection States",
      "PGN_Description": "OHCSS",
      "first_bit": 28,
      "SPN": 2895,
      "SPN_Name": "Engine Droop Auxiliary Input Select State",
      "SPN_Description": "In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the alternate droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching.  The selections apply to Auxiliary Input.\r\n\r\n0000 – Control state is Normal Droop Setting\r\n0001 thru 1101 – Control state is One of Droop Setting 1 through 13 (in sequential order)\r\n1110 –  SAE reserved\r\n1111 –  Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2896": {
      "PGN": 64967,
      "PGN_Name": "Off-Highway Engine Control Selection States",
      "PGN_Description": "OHCSS",
      "first_bit": 0,
      "SPN": 2896,
      "SPN_Name": "Engine Auxiliary Governor State",
      "SPN_Description": "This is the Engine Auxiliary Governor feature. This feature is used to allow engine speed to be controlled by an auxiliary input such as pressure or tailshaft speed. This feature is requested by an operator switch, this parameter indicates the state of the feature as determined by the controlling ECM.\r\n\r\n00 – Control State is Auxiliary Governor disabled\r\n01 – Control State is Auxiliary Governor enabled\r\n10 – SAE reserved\r\n11 – Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2897": {
      "PGN": 65264,
      "PGN_Name": "Power Takeoff Information",
      "PGN_Description": "PTO",
      "first_bit": 56,
      "SPN": 2897,
      "SPN_Name": "Operator Engine PTO Governor Memory Select Switch",
      "SPN_Description": "Measured state of the operator’s engine PTO governor memory select switch. This switch selects which of the two available memory locations is to be used to store the dynamically assigned value. This speed will be set using the PTO governor set switch and modified using the PTO governor accelerate and coast/decelerate switches.\r\n\r\n00 PTO set speed memory 1 selected\r\n01 PTO set speed memory 2 selected\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2898": {
      "PGN": 64966,
      "PGN_Name": "Cold Start Aids",
      "PGN_Description": "CSA",
      "first_bit": 12,
      "SPN": 2898,
      "SPN_Name": "Engine Start Enable Device 2 Configuration",
      "SPN_Description": "The start enable device installed for start enable device 2.\r\n\r\n0000 - no start enable device 2 installed\r\n0001 - glow plugs installed\r\n0010 - fuelled start installed\r\n0011 - ether injection installed\r\n0100 - electric intake air heater installed\r\n0101 - 1110 - reserved\r\n1111 - not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2899": {
      "PGN": 64966,
      "PGN_Name": "Cold Start Aids",
      "PGN_Description": "CSA",
      "first_bit": 8,
      "SPN": 2899,
      "SPN_Name": "Engine Start Enable Device 1 Configuration",
      "SPN_Description": "The start enable device installed for start enable device 1.\r\n\r\n0000 - no start enable device 1 installed\r\n0001 - glow plugs installed\r\n0010 - fuelled start installed\r\n0011 - ether injection installed\r\n0100 - electric intake air heater installed\r\n0101 - 1110 - reserved\r\n1111 - not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2900": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 12,
      "SPN": 2900,
      "SPN_Name": "Transmission Engine Crank Enable",
      "SPN_Description": "State signal from the transmission indicating if the transmission’s status is such that engine cranking is allowed (i.e.  at a minimum, transmission is in neutral and the driveline is disengaged).  As sender of this information, the transmission is responsible for correct indication immediately upon first broadcast of this parameter.  \r\n\r\nAs with hard-wired neutral start implementations, those utilizing this parameter should consider the impact of the transmission or other controllers ‘resetting’ due to voltage drops during the engine start sequence.\r\n\r\nThe vehicle system design should also consider the impact of timing latency in the engine starting sequence.  For example, the turn of an ignition key from ‘off’ to ‘start’ may happen more quickly than the transmission controller can boot up, determine its’ current state of being, and begin broadcasting information over the J1939 datalink. \r\n\r\n00 - Cranking disabled; engine cranking is prohibited by the transmission\r\n01 - Cranking enabled; engine cranking is allowed by the transmission\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2911": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 58,
      "SPN": 2911,
      "SPN_Name": "Halt brake switch",
      "SPN_Description": "Switch signal which indicates the position of the halt brake switch.\r\n\r\n00    Halt brake switch passive\r\n01    Halt brake switch active\r\n10    Error\r\n11    Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2912": {
      "PGN": 64964,
      "PGN_Name": "Electronic Brake Controller 5",
      "PGN_Description": "EBC5",
      "first_bit": 5,
      "SPN": 2912,
      "SPN_Name": "Hill holder mode",
      "SPN_Description": "Signal which indicates the current mode of the hill holder function.\r\n\r\n000            Inactive\r\n001            Active\r\n010            Active, but will change to inactive in a short time.  (This mode may be used to warn the driver)\r\n011            Active, but may activate parking brake if needed.\r\n100            Reserved\r\n101            Reserved\r\n110            Hill holder not functional\r\n111            Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "2913": {
      "PGN": 64964,
      "PGN_Name": "Electronic Brake Controller 5",
      "PGN_Description": "EBC5",
      "first_bit": 2,
      "SPN": 2913,
      "SPN_Name": "Halt brake mode",
      "SPN_Description": "Signal which indicates the current mode of the halt brake function.\r\n\r\n000            Inactive\r\n001            Active\r\n010            Active, but not functioning properly.  (This mode may be used to warn the driver)\r\n011 - 101  Not defined\r\n110            Halt brake not functional\r\n111            Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "2914": {
      "PGN": 1024,
      "PGN_Name": "External Brake Request",
      "PGN_Description": "XBR",
      "first_bit": 16,
      "SPN": 2914,
      "SPN_Name": "XBR EBI Mode",
      "SPN_Description": "The XBR EBI (Endurance Brake Integration) Mode is used as an input for the brake system to prescribe the use of endurance brakes like retarders or engine brakes.\r\n\r\n00 - No Endurance Brake Integration allowed\r\nThe demanded acceleration must be realized by the brake system by using only the foundation brakes. During an active XBR request, the brake system must not actively demand brake torque from other braking devices like retarders or engine brakes.\r\n01 - Only Endurance Brakes allowed\r\nThe demanded acceleration must be realized by the brake system by demanding brake torque from other brake devices like retarders or engine brakes. The foundation brake itself must not be used (e.g. to reduce brake lining wear).\r\n10 - Endurance Brake Integration allowed\r\nThe demanded acceleration may be realized by the brake system by using the foundation brakes and/or by demanding brake torque from other brake devices like retarders or engine brakes.\r\n11 - Not defined",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2915": {
      "PGN": 1024,
      "PGN_Name": "External Brake Request",
      "PGN_Description": "XBR",
      "first_bit": 18,
      "SPN": 2915,
      "SPN_Name": "XBR Priority",
      "SPN_Description": "The XBR Priority is used as an input to the brake system to manage the priority of overlapping external and internal requests.\r\n\r\n00 - Highest priority – used for emergency situations, e.g. for future Collision Avoidance System.  This mode overrides any brake protection measures of the brake system.\r\n01 - High priority – not defined\r\n10 - Medium priority – used for ACC-Systems. This mode does not override brake protection measures of the brake system.\r\n11 - Low priority – used in ”override disabled” XBR Control Mode",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2916": {
      "PGN": 1024,
      "PGN_Name": "External Brake Request",
      "PGN_Description": "XBR",
      "first_bit": 20,
      "SPN": 2916,
      "SPN_Name": "XBR Control Mode",
      "SPN_Description": "The XBR Control Mode is used as an input to the brake system and defines how the external acceleration demand has to be realized.\r\n\r\n00 - Override disabled – Disable any existing control commanded by the source of this command.\r\n01 - Acceleration control with addition mode - Add the XBR acceleration demand to the driver’s acceleration demand.\r\n10 - Acceleration control with maximum mode - Execute the XBR acceleration demand if it is higher than the driver’s acceleration demand.\r\n11 - Not defined",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2917": {
      "PGN": 64964,
      "PGN_Name": "Electronic Brake Controller 5",
      "PGN_Description": "EBC5",
      "first_bit": 10,
      "SPN": 2917,
      "SPN_Name": "XBR System State",
      "SPN_Description": "This parameter indicates which external brake control is allowed.\r\n\r\n00 - Any external brake demand will be accepted (brake system fully operational)\r\n01 - Only external brake demand of highest XBR Priority (00) will be accepted  (e.g. because the temperature limit of the brake system is exceeded)\r\n10 - No external brake demand will be accepted (e.g. because of fault in brake system)\r\n11 - not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2918": {
      "PGN": 64964,
      "PGN_Name": "Electronic Brake Controller 5",
      "PGN_Description": "EBC5",
      "first_bit": 12,
      "SPN": 2918,
      "SPN_Name": "XBR Active Control Mode",
      "SPN_Description": "This parameter indicates which XBR Control Mode is executed by the brake system.\r\n\r\n0000                No brake demand being executed (default mode)\r\n0001                Driver's brake demand being executed, no external brake demand\r\n0010                Addition mode of XBR acceleration control being executed\r\n0011                Maximum mode of XBR acceleration control being executed\r\n0100 - 1110    Reserved for SAE assignment\r\n1111                Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2919": {
      "PGN": 64964,
      "PGN_Name": "Electronic Brake Controller 5",
      "PGN_Description": "EBC5",
      "first_bit": 8,
      "SPN": 2919,
      "SPN_Name": "Foundation Brake Use",
      "SPN_Description": "This parameter indicates if the brake system presently uses the foundation brakes.\r\n\r\n00   Foundation brakes not in use\r\n01   Foundation brakes in use\r\n10   Reserved\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2920": {
      "PGN": 1024,
      "PGN_Name": "External Brake Request",
      "PGN_Description": "XBR",
      "first_bit": 0,
      "SPN": 2920,
      "SPN_Name": "External Acceleration Demand",
      "SPN_Description": "Parameter provided to the brake system from external sources. This is the acceleration which the brake system is expected to realize. It is specified as an absolute acceleration in reference to the road.  Positive values lead to increasing vehicle speed, negative values lead to decreasing vehicle speed.  Note: Normally only the negative data range is used, but e.g. in case of downhill driving also positive values are possible.",
      "bit_length": 16,
      "scaling": 0.00048828125,
      "offset": -15.687,
      "unit": "m/s²",
      "SLOT_ID": 115
    },
    "2921": {
      "PGN": 64964,
      "PGN_Name": "Electronic Brake Controller 5",
      "PGN_Description": "EBC5",
      "first_bit": 16,
      "SPN": 2921,
      "SPN_Name": "XBR Acceleration Limit",
      "SPN_Description": "The brake system may temporarily or generally limit the maximum brake performance available for external systems. A temporary limit may be nessary due to high brake temperature; a general limit may be defined by the vehicle manufacturer, e.g. a value of -2.5 m/s² due to liability reasons. The actual limit is communicated to the external systems that request braking. The limit is only effective in the XBR Priorities 01 to 11. It is specified as an absolute acceleration in reference to the road.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "m/s²",
      "SLOT_ID": 140
    },
    "2922": {
      "PGN": 61451,
      "PGN_Name": "Electronic Steering Control",
      "PGN_Description": "ESC1",
      "first_bit": 28,
      "SPN": 2922,
      "SPN_Name": "Steerable Lift Axle Lowering Inhibit",
      "SPN_Description": "A signal which indicates if lowering of lifted axle is allowed or inhibited.\r\n\r\n00      Lowering allowed\r\n01      Lowering inhibited\r\n10      Reserved\r\n11      Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2923": {
      "PGN": 61451,
      "PGN_Name": "Electronic Steering Control",
      "PGN_Description": "ESC1",
      "first_bit": 24,
      "SPN": 2923,
      "SPN_Name": "Status of Steering Axle",
      "SPN_Description": "A signal which indicates different states of the steering axle\r\n\r\n0000               Axle steering not active (adhesion steering)\r\n0001               Axle steering active\r\n0010               Axle centered\r\n0011               Axle centered, because of an error\r\n0100               Axle not active because of an error (adhesion steering)\r\n0101               Axle steering in special mode (diagnosis, calibration mode)\r\n0110-1110     Reserved for SAE Assignment\r\n1111               Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2924": {
      "PGN": 61451,
      "PGN_Name": "Electronic Steering Control",
      "PGN_Description": "ESC1",
      "first_bit": 32,
      "SPN": 2924,
      "SPN_Name": "Steering Type",
      "SPN_Description": "Indicates the different types of steering systems (ref. ECE Regulation 79 paragraph 2.5)\r\n\r\n0000             Main steering system\r\n0001             Auxiliary steering equipment\r\n0010-1110   Reserved for Assignment by SAE\r\n1111             Not Available\r\n\r\n\r\n0000    Main steering system - The steering equipment of a vehicle which is mainly responsible for determining the direction of travel.\r\n\r\n0001    Auxiliary steering equipment - A system in which the wheels on axle(s) of vehicles of categories M and N are steered in addition to the wheels of the main steering equipment in the same or opposite direction to those of the main steering equipment and/or the steering angle of the front and/or the rear wheels may be adjusted relative to vehicle behaviour.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2925": {
      "PGN": 61451,
      "PGN_Name": "Electronic Steering Control",
      "PGN_Description": "ESC1",
      "first_bit": 36,
      "SPN": 2925,
      "SPN_Name": "Type of Steering Forces",
      "SPN_Description": "Type of Steering Forces (Ref. ECE Regulation 79 paragraph 2.5)\r\n\r\n0000             Manual steering equipment\r\n0001             Power assisted steering equipment\r\n0010             Full power steering equipment\r\n0011             Self tracking steering equipment\r\n0100-1110   Reserved for SAE assignment\r\n1111             Not Available\r\n\r\n0000  Manual steering equipment - The steering forces result solely from the muscular effort of the driver.\r\n0001  Power assisted steering equipment - The steering forces result from both the muscular effort of the driver and the energy supply or supplies.\r\n0010  Full power steering equipment - The steering forces are provided solely by one or more energy supplies.\r\n0011  Self tracking steering equipment - A system designed to create a change of steering angle on one or more wheels only when acted upon by forces and/or moments applied through the tire to road contact.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2926": {
      "PGN": 61451,
      "PGN_Name": "Electronic Steering Control",
      "PGN_Description": "ESC1",
      "first_bit": 40,
      "SPN": 2926,
      "SPN_Name": "Type of Steering Transmission",
      "SPN_Description": "Type of Steering Transmission (Ref. ECE Regulation 79 paragraph 2.6)\r\n\r\n0000             Purely mechanical steering transmission\r\n0001             Purely hydraulic steering transmission\r\n0010             Purely electric steering transmission\r\n0011             Hybrid steering transmission\r\n0100-1110   Reserved for SAE assignment\r\n1111             Not available\r\n\r\n0000    Purely mechanical steering transmission - A steering transmission in which the steering forces are transmitted entirely by mechanical means.\r\n0001    Purely hydraulic steering transmission - A steering transmission in which the steering forces, somewhere in the transmission, are transmitted only by hydraulic means.\r\n0010    Purely electric steering transmission - A steering transmission in which the steering forces, somewhere in the transmission, are transmitted only through electric means.\r\n0011    Hybrid steering transmission - A steering transmission in which part of the steering forces is transmitted through one and the other part through another of the above mentioned means.  However, in the case where any mechanical part of the transmission is designed only to give position feedback and is too weak to transmit the total sum of the steering forces, this system shall be considered to be purely hydraulic or purely electric steering transmission.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "2927": {
      "PGN": 61451,
      "PGN_Name": "Electronic Steering Control",
      "PGN_Description": "ESC1",
      "first_bit": 0,
      "SPN": 2927,
      "SPN_Name": "Actual Inner wheel steering angle",
      "SPN_Description": "Signal which indicates the actual inner wheel steering angle.  The steering angle is the angle of wheel turn relative to the vehicle x-axis (yaw angle of inner wheel). See Figure SPN2927_A for explanation of positive and negative angles.  This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": -125,
      "unit": "deg",
      "SLOT_ID": 136
    },
    "2928": {
      "PGN": 61451,
      "PGN_Name": "Electronic Steering Control",
      "PGN_Description": "ESC1",
      "first_bit": 16,
      "SPN": 2928,
      "SPN_Name": "Axle Location",
      "SPN_Description": "To identify to which of several similar devices (such as tires or fuel tanks) the information applies.\r\n\r\nThe low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward).\r\n\r\nThe high order 4 bits represent a position number, counting front to back on the vehicle.\r\n\r\nThe value 0xFF indicates not available.\r\n\r\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\r\n\r\nExamples: Tire pressure for location 0x00 would be left front tire.\r\n\r\nTire pressure for location 0x23 would be right outside rear rear on a 3-axle tractor with dual axle per side (3rd axle, 4th tire).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "2930": {
      "PGN": 64998,
      "PGN_Name": "Hydraulic Braking System",
      "PGN_Description": "HBS",
      "first_bit": 24,
      "SPN": 2930,
      "SPN_Name": "Hydraulic Brake System Audible Warning Command",
      "SPN_Description": "Signal which commands an audible warning by the hydraulic braking system.\r\n\r\n00       Audible warning off\r\n01       Audible warning on\r\n10       Reserved\r\n11       Don't care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2931": {
      "PGN": 64998,
      "PGN_Name": "Hydraulic Braking System",
      "PGN_Description": "HBS",
      "first_bit": 26,
      "SPN": 2931,
      "SPN_Name": "Hydraulic Brake Fluid Level Switch",
      "SPN_Description": "Signal which indicates whether the hydraulic fluid level in the reservoir(s) is sufficient.\r\n\r\n00      Fluid level is not sufficient\r\n01      Fluid level is sufficient\r\n10      Error indicator\r\n11      Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2945": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 10,
      "SPN": 2945,
      "SPN_Name": "Active Shift Console Indicator",
      "SPN_Description": "Signal from transmission control unit indicating which shift console (primary or secondary) it currently considers as the active shift selector input.\r\n\r\n00        Primary shift console is active\r\n01        Secondary shift console is active\r\n10        Reserved\r\n11        Not available\r\n\r\nNote:  In some applications such as refuse trucks, the transmission can be operated from two positions in the vehicle.  The transmission control unit will accept changes in transmission requested gear (SPN 525) from the operator only from the active shift console.  The transmission control unit determines which shift console is active based on a switch input controlled by the operator and transmission system state criteria.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2948": {
      "PGN": 64961,
      "PGN_Name": "Engine Fluid Level/Pressure 3",
      "PGN_Description": "EFL/P3",
      "first_bit": 0,
      "SPN": 2948,
      "SPN_Name": "Engine Intake Valve Actuation System Oil Pressure",
      "SPN_Description": "The gage pressure of the oil in the hydraulic system that powers the engine intake valve actuation system",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 51
    },
    "2970": {
      "PGN": 61443,
      "PGN_Name": "Electronic Engine Controller 2",
      "PGN_Description": "EEC2",
      "first_bit": 6,
      "SPN": 2970,
      "SPN_Name": "Accelerator Pedal 2 Low Idle Switch",
      "SPN_Description": "Switch signal which indicates the state of the accelerator pedal 2 low idle switch.  The low idle switch is defined in SAE J1843.\r\n\r\n00    Accelerator pedal 2 not in low idle condition\r\n01    Accelerator pedal 2 in low idle condition\r\n10    Error\r\n11    Not available\r\n\r\nNote:  Also refer to SPN 558 Accelerator Pedal 1 Low Idle Switch and SPN 2971 Accelerator Pedal 3 Low Idle Switch.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2978": {
      "PGN": 65247,
      "PGN_Name": "Electronic Engine Controller 3",
      "PGN_Description": "EEC3",
      "first_bit": 32,
      "SPN": 2978,
      "SPN_Name": "Estimated Engine Parasitic Losses - Percent Torque",
      "SPN_Description": "The calculated torque that indicates the estimated amount of torque loss due to engine parasitics, such as cooling fan, air compressor, air conditioning, etc. It is expressed as a percent of Engine Reference Torque.  \r\n\r\nIf there are multiple devices on a network that provide this parameter, then users of this data shall add each of these values to determine the total torque loss due to engine parasitics.  Devices that provide this parameter shall use the value of Engine Reference Torque transmitted by the engine during the current key cycle to determine the percent torque loss as seen by the engine.\r\n\r\nWhen the data value of this parameter is equal to 0xFB it means that all parasitic losses calculated by the engine are included in the Engine's Nominal Friction Percent Torque (SPN 514).\r\n\r\nNote:  Refer to section 5.2.1 in SAE J1939-71.\r\n\r\nNote: Beginning in 2016,  HD-OBD requires reporting of engine torque to Portable Emissions Measurement System (PEMS) equipment that is representative of torque as measured by the engine dynamometer during the emissions certification process. Therefore, for applications that are subject to HD-OBD regulations in 2016 or later, estimated parasitic losses shall no longer be included in SPN 514 Nominal Friction - Percent Torque and must be included in SPN 2978 Estimated Engine Parasitic Losses - Percent Torque.\r\n\r\nSee SPN 7837 for alternate resolution.  If both SPN 2978 and SPN 7837 are supported by a single source address, consumers of the parasitic data should only use one of these values.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "2979": {
      "PGN": 61443,
      "PGN_Name": "Electronic Engine Controller 2",
      "PGN_Description": "EEC2",
      "first_bit": 40,
      "SPN": 2979,
      "SPN_Name": "Vehicle Acceleration Rate Limit Status",
      "SPN_Description": "Status (active or not active) of the system used to limit maximum forward vehicle acceleration.\r\n\r\n00     Limit not active\r\n01     Limit active\r\n10     Reserved\r\n11     Not available\r\n\r\nNOTE:  The effects of emission control limits, such as engine exhaust smoke control, are specifically excluded; they are not considered to be part of a function to limit vehicle acceleration.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2980": {
      "PGN": 65163,
      "PGN_Name": "Gaseous Fuel Pressure 1",
      "PGN_Description": "GFP1",
      "first_bit": 48,
      "SPN": 2980,
      "SPN_Name": "Engine Fuel Valve 1 Outlet Absolute Pressure",
      "SPN_Description": "Absolute Pressure of gas on outlet side of the first or only fuel system control valve.  See SPN 3469 for the second fuel control valve.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "2983": {
      "PGN": 65195,
      "PGN_Name": "Electronic Transmission Controller 6",
      "PGN_Description": "ETC6",
      "first_bit": 24,
      "SPN": 2983,
      "SPN_Name": "Clutch Life Remaining",
      "SPN_Description": "Signal which indicates the actual clutch life remaining in percent. One hundred percent means the clutch is brand new and zero percent means the clutch is at the end of its life.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "2984": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 0,
      "SPN": 2984,
      "SPN_Name": "Automatic traction help (load transfer)",
      "SPN_Description": "This signal enables the traction help (load transfer) in case of an active ASR function\r\n\r\n00   Disable automatic traction help \r\n01   Enable automatic traction help \r\n10   Reserved\r\n11   Don't care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2985": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 54,
      "SPN": 2985,
      "SPN_Name": "Transmission Shift Selector Display Mode Switch",
      "SPN_Description": "Status of the operator’s switch used to ‘toggle’ through multiple display modes of a shift selector display.  \r\n\r\nWhen a shift selector display is capable of displaying more than just range information, this switch is toggled by the operator to move through the different display modes.   If the selector has only two display modes, this switch may behave as a typical SPST switch.  If the selector has more than two display modes, the switch may be momentary, where each activation indicates that the selector has scrolled through to the next subsequent display mode. \r\n\r\n00 Off\r\n01 On\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "2986": {
      "PGN": 65129,
      "PGN_Name": "Engine Temperature 3",
      "PGN_Description": "ET3",
      "first_bit": 32,
      "SPN": 2986,
      "SPN_Name": "Engine Intake Valve Actuation System Oil Temperature",
      "SPN_Description": "The temperature of the oil in the hydraulic system that powers the intake valve actuation system.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3026": {
      "PGN": 65272,
      "PGN_Name": "Transmission Fluids 1",
      "PGN_Description": "TRF1",
      "first_bit": 60,
      "SPN": 3026,
      "SPN_Name": "Transmission Oil Level 1 Measurement Status",
      "SPN_Description": "Measurement status for the first instance of a transmission oil level indicator.  Indicates if conditions are acceptable to obtain a valid transmission oil level measurement as conveyed in SPN 124 Transmission Oil Level or SPN 3027 Transmission Oil Level 1 High / Low.  If conditions are not acceptable, this parameter conveys to the operator what prevents conditions from being acceptable.  Only one condition can be conveyed in this parameter at any given point in time.  If multiple conditions exist, it is not important which condition is actually broadcast, as the driver must ‘correct’ each and every condition as it is presented before a valid oil level reading can be made.  If multiple conditions exist that prevent a valid reading, the sender should broadcast one of those conditions until it is corrected; then the next condition can be conveyed to the operator, and so on.\r\n\r\n0000 Conditions valid for transmission oil level measurement\r\n0001 Conditions not valid – Settling timer still counting down\r\n0010 Conditions not valid – Transmission in gear\r\n0011 Conditions not valid – Transmission fluid temperature too low\r\n0100 Conditions not valid – Transmission fluid temperature too high\r\n0101 Conditions not valid – Vehicle moving; output shaft speed too high\r\n0110 Conditions not valid – Vehicle not level\r\n0111 Conditions not valid – Engine speed too low\r\n1000 Conditions not valid – Engine speed too high\r\n1001 Conditions not valid – No request for reading\r\n1010 Not defined\r\n1011 Not defined\r\n1100 Not defined\r\n1101 Conditions not valid - Other\r\n1110 Error\r\n1111 Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3027": {
      "PGN": 65272,
      "PGN_Name": "Transmission Fluids 1",
      "PGN_Description": "TRF1",
      "first_bit": 48,
      "SPN": 3027,
      "SPN_Name": "Transmission Oil Level 1 High / Low",
      "SPN_Description": "First instance of a transmission oil level indicator. Conveys the amount of current volume of transmission sump oil compared to recommended volume. Positive values indicate overfill. Zero means the transmission fluild is filled to the recommended level.\r\n\r\nParameter Specific Indicator:\r\nA value of 0xFB indicates conditions are not acceptable for a valid fluid level measurement.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": -62.5,
      "unit": "l",
      "SLOT_ID": 225
    },
    "3028": {
      "PGN": 65272,
      "PGN_Name": "Transmission Fluids 1",
      "PGN_Description": "TRF1",
      "first_bit": 56,
      "SPN": 3028,
      "SPN_Name": "Transmission Oil Level 1 Countdown Timer",
      "SPN_Description": "Countdown timer for the first instance of a transmission oil level indicator.  Once all vehicle conditions (such as vehicle stopped, etc) are met, some transmissions may require a ‘settling time’ to allow the fluid level to normalize.  This parameter indicates how much of the required settling time remains.  When time reaches 0, a valid oil level measurement value will be broadcast in SPN 3027 Transmission Oil Level 1 High / Low.\r\n\r\n0000 less than 1 minute\r\n0001 One minute\r\n0010 Two minutes\r\n0011 Three minutes\r\n0100 Four minutes\r\n0101 Five minutes\r\n0110 Six minutes\r\n0111 Seven minutes\r\n1000 Eight minutes\r\n1001 Nine minutes\r\n1010 Ten minutes\r\n1011 Eleven minutes\r\n1100 Twelve minutes\r\n1101 Thirteen minutes\r\n1110 Error\r\n1111 Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3030": {
      "PGN": 61452,
      "PGN_Name": "Electronic Transmission Controller #8",
      "PGN_Description": "ETC8",
      "first_bit": 0,
      "SPN": 3030,
      "SPN_Name": "Transmission Torque Converter Ratio",
      "SPN_Description": "Ratio of the transmissions torque converter output torque to torque converter input torque at current speed.\r\n\r\nThe ratio of 1.000 ( 03 E8 hex ) indicates torque converter lockup.\r\nIf the ratio is less than 1 and the ratio can not be properly determined it shall be set to a value of FB00 hex.\r\nRatios above 1 indicate torque converter multiplication.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 32
    },
    "3031": {
      "PGN": 65110,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "AT1T1I1",
      "first_bit": 8,
      "SPN": 3031,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank Temperature 1",
      "SPN_Description": "Temperature of the diesel exhaust fluid in the storage tank.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "3043": {
      "PGN": 64960,
      "PGN_Name": "Passenger Counter",
      "PGN_Description": "TR7",
      "first_bit": 0,
      "SPN": 3043,
      "SPN_Name": "Type of Passenger Count",
      "SPN_Description": "Used to notify transit link devices of the type of passenger counting system used in the vehicle.  Some passenger counting systems indicate real-time boarding and exiting data for other devices to accumulate. Other types of passenger counters report a current on-board total relative to a transit door status,  a fare collection status, or other signal which can define the end of the boarding/exiting period and a stable underway totalized passenger count.\r\n\r\n0 - absolute passenger count\r\n1 - boarding passenger\r\n2 - exiting passenger\r\n3 - boarding passenger (second passenger stream)\r\n4 - exiting passenger (second passenger stream)\r\n5 to 250 - reserved for future assignment\r\n251 to 253 - reserved\r\n254 - error indicator\r\n255 - not available",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3044": {
      "PGN": 64960,
      "PGN_Name": "Passenger Counter",
      "PGN_Description": "TR7",
      "first_bit": 16,
      "SPN": 3044,
      "SPN_Name": "Silent Alarm Status",
      "SPN_Description": "Used to report silent alarm push button status.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error condition\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3045": {
      "PGN": 64960,
      "PGN_Name": "Passenger Counter",
      "PGN_Description": "TR7",
      "first_bit": 18,
      "SPN": 3045,
      "SPN_Name": "Vehicle Use Status",
      "SPN_Description": "Used to indicate the proper or unauthorized use of the vehicle. The administrative control device or any device issuing the vehicle use status PID should be sensitive to the run switch status (SPN 3046) and any other locally defined criteria for authorized use (i.e., driver log-ons) before the vehicle use status PID is used to generate an unauthorized use alarm.\r\n\r\n00 - Normal use\r\n01 - Unauthorized use\r\n10 - Error condition\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3046": {
      "PGN": 64960,
      "PGN_Name": "Passenger Counter",
      "PGN_Description": "TR7",
      "first_bit": 20,
      "SPN": 3046,
      "SPN_Name": "Transit Run Status",
      "SPN_Description": "Status of the run switch for the vehicle.\r\n\r\n00 - Off\r\n01- On\r\n10 - Error condition\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3047": {
      "PGN": 64960,
      "PGN_Name": "Passenger Counter",
      "PGN_Description": "TR7",
      "first_bit": 8,
      "SPN": 3047,
      "SPN_Name": "Patron Count",
      "SPN_Description": "Count of the number of passengers on a transit vehicle.  If the type of passenger count (SPN 3043) is 0, the patron count indicates the number of patrons currently on vehicle after the door has closed.  If the type of passenger count is 1 to 4, \r\nthe patron count indicates an incremental count of passengers since the last data transmittal.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "3070": {
      "PGN": 64959,
      "PGN_Name": "Transit Milepost",
      "PGN_Description": "TR2",
      "first_bit": 0,
      "SPN": 3070,
      "SPN_Name": "Number of bytes in the Milepost Identification",
      "SPN_Description": "Number of bytes in the Milepost Identification.  This parameter identifies the length, in bytes, of the data in SPN 509 (Milepost Identification).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "byte",
      "SLOT_ID": 239
    },
    "3071": {
      "PGN": 64958,
      "PGN_Name": "Transit Route",
      "PGN_Description": "TR1",
      "first_bit": 8,
      "SPN": 3071,
      "SPN_Name": "Number of bytes in the Transit Assigned Route Identity",
      "SPN_Description": "Number of bytes in the Transit Assigned Route Identity.  This parameter identifies the length, in bytes, of the data in SPN 3074 (Transit Assigned Route Identity).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "byte",
      "SLOT_ID": 239
    },
    "3072": {
      "PGN": 64958,
      "PGN_Name": "Transit Route",
      "PGN_Description": "TR1",
      "first_bit": 16,
      "SPN": 3072,
      "SPN_Name": "Number of bytes in the Transit Assigned Run Identity",
      "SPN_Description": "Number of bytes in the Transit Assigned Run Identity.  This parameter identifies the length, in bytes, of the data in SPN 3075 (Transit Assigned Run Identity).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "byte",
      "SLOT_ID": 239
    },
    "3073": {
      "PGN": 64958,
      "PGN_Name": "Transit Route",
      "PGN_Description": "TR1",
      "first_bit": 24,
      "SPN": 3073,
      "SPN_Name": "Number of bytes in the Transit Assigned Block Identity",
      "SPN_Description": "Number of bytes in the Transit Assigned Block Identity.  This parameter identifies the length, in bytes, of the data in SPN 3076 (Transit Assigned Block Identity).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "byte",
      "SLOT_ID": 239
    },
    "3078": {
      "PGN": 64958,
      "PGN_Name": "Transit Route",
      "PGN_Description": "TR1",
      "first_bit": 0,
      "SPN": 3078,
      "SPN_Name": "Agency",
      "SPN_Description": "The identity of the agency involved in this transaction",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "3079": {
      "PGN": 64957,
      "PGN_Name": "Signal Preemption",
      "PGN_Description": "TR3",
      "first_bit": 6,
      "SPN": 3079,
      "SPN_Name": "Intersection Preemption Request/Response",
      "SPN_Description": "Status of the intersection signal preemption\r\n\r\n00 - Message is a request directed to the emitter\r\n01 - Message is a response from the emitter\r\n10 - Error condition\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3080": {
      "PGN": 64957,
      "PGN_Name": "Signal Preemption",
      "PGN_Description": "TR3",
      "first_bit": 4,
      "SPN": 3080,
      "SPN_Name": "Transit Route ID Usage",
      "SPN_Description": "Transit route ID usage\r\n\r\n00 - Transit route ID not used for interleaved data\r\n01 - Transit route ID used for interleaved data (if range code not enabled)\r\n10 - Error condition\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3081": {
      "PGN": 64957,
      "PGN_Name": "Signal Preemption",
      "PGN_Description": "TR3",
      "first_bit": 2,
      "SPN": 3081,
      "SPN_Name": "Range Code Enable",
      "SPN_Description": "Range code enable\r\n\r\n00 - Range code not used for interleaved data\r\n01 - Range code used for interleaved data\r\n10 - Error condition\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3082": {
      "PGN": 64957,
      "PGN_Name": "Signal Preemption",
      "PGN_Description": "TR3",
      "first_bit": 14,
      "SPN": 3082,
      "SPN_Name": "Strobe Activation Control Status",
      "SPN_Description": "Strobe activation control status\r\n\r\n00 - Deactivate strobe\r\n01 - Activate strobe\r\n10 - Error condition\r\n11 - Not available\r\n\r\nNote: Strobe will flash if not overridden by transit door status, strobe is working, and emitter is in the normal mode.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3083": {
      "PGN": 64957,
      "PGN_Name": "Signal Preemption",
      "PGN_Description": "TR3",
      "first_bit": 12,
      "SPN": 3083,
      "SPN_Name": "Transit Door Enable",
      "SPN_Description": "Transit door enable\r\n\r\n00 - Ignore transit door status\r\n01 - Transit door status will override strobe activation\r\n10 - Error condition\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3084": {
      "PGN": 64957,
      "PGN_Name": "Signal Preemption",
      "PGN_Description": "TR3",
      "first_bit": 8,
      "SPN": 3084,
      "SPN_Name": "Priority of Response Sent by Emitter",
      "SPN_Description": "Priority of response sent by emitter\r\n\r\n0000               - Reserved\r\n0001               - Low priority\r\n0010               - Probe priority\r\n0011               - High priority\r\n0100 to 1000 - Reserved\r\n1001               - Priority set by hardware to low priority\r\n1010               - Priority set by hardware to probe priority\r\n1011               - Priority set by hardware to high priority\r\n1100 to 1101 - Reserved\r\n1110               - Error condition\r\n1111               - Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3085": {
      "PGN": 64957,
      "PGN_Name": "Signal Preemption",
      "PGN_Description": "TR3",
      "first_bit": 16,
      "SPN": 3085,
      "SPN_Name": "Vehicle ID",
      "SPN_Description": "Numerical designation of the vehicle.   65535 is used to represent the vehicle ID is not available.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 208
    },
    "3086": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 8,
      "SPN": 3086,
      "SPN_Name": "Transmission Ready for Brake Release",
      "SPN_Description": "This parameter indicates that enough torque / motive force is available at the transmission output shaft to release all the brakes without a risk of unintentional movement in the opposite direction.\r\n\r\n00 - Transmission Not Ready for Brake Release\r\n01 - Transmission Ready for Brake Release\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3087": {
      "PGN": 65164,
      "PGN_Name": "Auxiliary Analog Information",
      "PGN_Description": "AAI",
      "first_bit": 32,
      "SPN": 3087,
      "SPN_Name": "Auxiliary Level",
      "SPN_Description": "Level measured by a sensor.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "mm",
      "SLOT_ID": 14
    },
    "3156": {
      "PGN": 61453,
      "PGN_Name": "Land Leveling System Operational Information",
      "PGN_Description": "LOI",
      "first_bit": 0,
      "SPN": 3156,
      "SPN_Name": "Blade Control Mode Switch",
      "SPN_Description": "Indicates the blade control mode switch state the user has set for the land leveling system.  The switch value directly correlates to the current switch state, regardless of the switch being used.  This parameter is intended for use in systems using only one parameter to control the blade movement (i.e. elevation).  Systems using two independent parameters to control blade position, i.e. one blade edge maintains a constant elevation and the other blade edge maintains a constant blade angle, should use parameters specific to that usage. Only one of the following states will be active at a time.   Below are the data values defined for each switch type that may be used in this application.  The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\r\n\r\n1.  A toggle button with two states can be used, in which the button is either in the manual or the auto position at all times.  Toggle button usage is as follows:\r\n        Manual Position  = 0010 Manual button pressed\r\n        Auto Position       = 0011 Automatic button pressed\r\n\r\n2.   The momentary rocker switch may be used, where the default is the no button pressed position.  The user can press the rocker into the manual position, and when pressure is released, it will return to the no button pressed position.  The user may also press the rocker into the auto position, and when pressure is released, it will return to the no button pressed position.  Momentary rocker button usage is as follows:\r\n        No Button Pressed = 0000 No button pressed\r\n        Manual Button Pressed  = 0010 Manual button pressed\r\n        Auto Button Pressed  = 0011 Automatic button pressed\r\n\r\n3.    The momentary contact button pair may be used, where the default is no buttons being pressed.  The user can press the manual button, and when pressure is released, it will return to the no button pressed position.  The user may press the auto button, and when pressure is released, it will return to the no button pressed position.  Momentary contact buttons (button pair) usage is as follows:\r\n\r\n        No Button Pressed = 0000 No button pressed\r\n        Manual Button Pressed  = 0010 Manual button pressed\r\n        Auto Button Pressed  = 0011 Automatic button pressed\r\n\r\n4.    The momentary contact single button may be used, where the default is no button being pressed.  The user can press the button, which is the button pressed position, and when pressure is released, it will return to the no button pressed position.  The controller receiving this command will keep track of what mode the blade is in, auto or manual.  When the button is pressed, the \"mode button pressed\" state is reported and the receiving controller then changes the current mode to its opposite value (i.e. manual to automatic or vise-versa).  Momentary contact button (single button) usage is as follows:\r\n\r\n        No Button Pressed = 0000 No button pressed\r\n        Button Pressed  = 0001 Mode button pressed\r\n\r\nData Values and Descriptions:\r\n\r\n0000 No button pressed\r\n0001 Mode button pressed\r\n0010 Manual button pressed\r\n0011 Automatic button pressed\r\n1110 Error Indicator\r\n1111 Not Installed\r\nAll other values are reserved\r\n\r\nNotes:\r\n1.   The switch state can be read in two ways.  One method uses the direct analog switch input to determine the switch state, while the second method relies on a secondary control to read the analog input, then relay the information on the data link.  The parameter is designed to provide the actual switch state to other controls that need the information.\r\n2.   Other systems with automated blade controls should be able to use this parameter, since it is a measured switch value.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3157": {
      "PGN": 61453,
      "PGN_Name": "Land Leveling System Operational Information",
      "PGN_Description": "LOI",
      "first_bit": 4,
      "SPN": 3157,
      "SPN_Name": "Desired Grade Offset Switch",
      "SPN_Description": "Indicates the grade offset switch state the user has set for the land leveling system.  The desired grade offset value is the vertical offset measured from a given elevation reference point to the bottom edge of the blade.  This parameter is intended for use in systems using only elevation offset to control the blade movement (i.e. elevation).  Systems using two independent parameters to control blade position, i.e. one edge maintains a constant elevation and the other blade edge maintains a constant angle, should use parameters specific to that usage. Only one of the following states will be active at a time.   Below are the data values defined for each switch type that may be used in this application.  The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\r\n\r\n1.  The momentary rocker switch may be used, where the default is the no button pressed position.  The user can press the rocker into the increment button pressed position, and when pressure is released, it will return to the no button pressed position.  The user may also press the rocker into the decrement button pressed position, and when pressure is released, it will return to the no button pressed position.  Momentary rocker button usage is as follows:\r\n\r\n     No Button Pressed = 0000 No button pressed\r\n     Increment Button Pressed  = 0001 Increment button pressed\r\n     Decrement Button Pressed  = 0010 Decrement button pressed\r\n\r\n2.  The momentary contact button pair may be used, where the default is the no buttons pressed position.  The user can press the increment button, and when pressure is released, it will return to the no buttons pressed position.  The user may press the decrement button, and when pressure is released, it will return to the no buttons pressed position.  Momentary contact button (button pair) usage is as follows:\r\n\r\n     No Button Pressed = 0000 No button pressed\r\n     Increment Button Pressed  = 0001 Increment button pressed\r\n     Decrement Button Pressed  = 0010 Decrement button pressed\r\n\r\nData Values and Descriptions:\r\n0000 No button pressed\r\n0001 Increment button pressed\r\n0010 Decrement button pressed\r\n1110 Error Indicator\r\n1111 Not installed\r\nAll other values are reserved\r\n\r\nNotes:\r\n\r\n1.   The switch state can be read in two ways.  One method uses the direct analog switch input to determine the switch state, while the second method relies on a secondary control to read the analog input, then relay the information on the data link.  The parameter is designed to provide the actual switch state to other controls that need the information.\r\n2.   Other systems with automated blade controls should be able to use this parameter, since it is a measured switch value.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3158": {
      "PGN": 61453,
      "PGN_Name": "Land Leveling System Operational Information",
      "PGN_Description": "LOI",
      "first_bit": 8,
      "SPN": 3158,
      "SPN_Name": "Blade Auto Mode Command",
      "SPN_Description": "Allows other controllers to command to the primary control system what they think is the appropriate auto control mode to be engaged in, based on the information they have available to them.  When in automatic mode, the blade automatically adjusts its position to the center of the blade to maintain a desired grade offset.  Only one of the following states will be active at a time.  Below is extended information describing each command.  The purpose of this information is to define what command state should be reported based on what auto control mode command is deemed appropriate by the operational specifications of the system.\r\n\r\n   0000 Auto Allowed - Auto mode permitted as appropriate (auto button was pushed or directly returned from Suspend Auto condition)\r\n   0001 Activity Allows Auto - Auto mode permitted only if the primary control system detects operator activity.  The control issuing this command does not have sufficient information/reason to absolutely allow Auto mode (state 0000) or not allow Auto mode (state 0100).  The control issuing this command is permitting the primary control system to operate in auto mode only if the primary control system detects operator activity, such as direct input to the primary control system.  If the primary control system does not detect operator activity, then the control issuing this command is not allowing auto mode. For example, the control issuing this command has detected no operator activity yet it acknowledges that there may be other sources of operator activity that might make auto mode permissible.\r\n   0010 Suspend Auto - Auto mode is temporarily not allowed and the control issuing this command wants the primary control system to automatically return to the previous state (Auto or Manual) when the suspend auto condition is removed.\r\n   0011 Service Mode - Auto mode is permitted only for special services such as calibrations.\r\n   0100 Auto Not Allowed - Auto mode is not allowed under any condition\r\n\r\nData Values and Descriptions:\r\n0000 Auto Allowed\r\n0001 Activity Allows Auto - must detect operator before auto allowed\r\n0010 Suspend Auto - temporarily suspend auto mode\r\n0011 Service Mode - auto allowed only during service modes\r\n0100 Auto Not Allowed\r\n1110 Error Indicator\r\n1111 Not Supported\r\nAll other values are reserved\r\n\r\nNote:  \r\nThe control issuing this command is aware that it does not have access to all information that the primary controller of the Land Leveling System attachment has access to.  Therefore, it commands the Land Leveling system to activate a auto blade mode based on the input it has access to.  In some cases, like in the \"Activity Allows Auto\" situation, the control knows the Land Leveling system has access to an additional display (which has switches and several buttons) which may help determine if an operator is present.  On the other hand, the control may also have information the primary controller of the Land Leveling System does not have access to, like the parking brake status.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3159": {
      "PGN": 64956,
      "PGN_Name": "Farebox Service Detail",
      "PGN_Description": "TR4",
      "first_bit": 24,
      "SPN": 3159,
      "SPN_Name": "Trip Number",
      "SPN_Description": "The identity number assigned to this trip.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 208
    },
    "3160": {
      "PGN": 64956,
      "PGN_Name": "Farebox Service Detail",
      "PGN_Description": "TR4",
      "first_bit": 56,
      "SPN": 3160,
      "SPN_Name": "Assigned Route",
      "SPN_Description": "The identity number assigned to this route.\r\n\r\nNote:  This is the numerical value for the route as opposed to the \"Transit Assigned Route Identity\" (SPN 3074) which is variable length ASCII or the \"Route number\" (SPN 3169) which is 12 bit numeric.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 208
    },
    "3161": {
      "PGN": 64956,
      "PGN_Name": "Farebox Service Detail",
      "PGN_Description": "TR4",
      "first_bit": 40,
      "SPN": 3161,
      "SPN_Name": "Pattern Number ",
      "SPN_Description": "The agency defined pattern number for this trip",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 208
    },
    "3162": {
      "PGN": 64956,
      "PGN_Name": "Farebox Service Detail",
      "PGN_Description": "TR4",
      "first_bit": 72,
      "SPN": 3162,
      "SPN_Name": "Assigned Run",
      "SPN_Description": "The agency defined run number for this trip",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 208
    },
    "3163": {
      "PGN": 64956,
      "PGN_Name": "Farebox Service Detail",
      "PGN_Description": "TR4",
      "first_bit": 88,
      "SPN": 3163,
      "SPN_Name": "Assigned Block",
      "SPN_Description": "The agency defined block number for this trip",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 208
    },
    "3164": {
      "PGN": 64956,
      "PGN_Name": "Farebox Service Detail",
      "PGN_Description": "TR4",
      "first_bit": 104,
      "SPN": 3164,
      "SPN_Name": "Driver's farebox security code",
      "SPN_Description": "Security code for the farebox, numerical only.\r\n\r\nNote:  0 = Farebox is in reporting status\r\n           1 - 65535 = security code",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 208
    },
    "3165": {
      "PGN": 64955,
      "PGN_Name": "Farebox Point of Sale",
      "PGN_Description": "TR5",
      "first_bit": 16,
      "SPN": 3165,
      "SPN_Name": "Fare Validity",
      "SPN_Description": "Agency defined value indicating validity of this fare",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 220
    },
    "3166": {
      "PGN": 64955,
      "PGN_Name": "Farebox Point of Sale",
      "PGN_Description": "TR5",
      "first_bit": 20,
      "SPN": 3166,
      "SPN_Name": "Pass Category",
      "SPN_Description": "Agency defined value indicating the category of the passenger associated with this fare",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 220
    },
    "3167": {
      "PGN": 64955,
      "PGN_Name": "Farebox Point of Sale",
      "PGN_Description": "TR5",
      "first_bit": 24,
      "SPN": 3167,
      "SPN_Name": "Initial Fare Agency",
      "SPN_Description": "Identifies where the initial fare is paid\r\n\r\nNote:  The definition of the agency numbering plan shall be agreed by the operating agency and the farebox manufacturer.  The value of 0 is reserved, the usable range is 1 to 31.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 232
    },
    "3168": {
      "PGN": 64955,
      "PGN_Name": "Farebox Point of Sale",
      "PGN_Description": "TR5",
      "first_bit": 56,
      "SPN": 3168,
      "SPN_Name": "Transfer Sold",
      "SPN_Description": "Indicates that a transfer was sold or issued on this transaction including its type and/or restrictions. The final definitions of the transfer issued information shall be agreed by the operating agency and the farebox manufacturer.\r\n\r\nNote:  A non-zero value indicates that a transfer was sold or issued.  The value of zero is reserved to indicate that no transfer has been sold or issued.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "3169": {
      "PGN": 64955,
      "PGN_Name": "Farebox Point of Sale",
      "PGN_Description": "TR5",
      "first_bit": 40,
      "SPN": 3169,
      "SPN_Name": "Route Number",
      "SPN_Description": "The route number issuing the transfer.",
      "bit_length": 12,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 233
    },
    "3170": {
      "PGN": 64955,
      "PGN_Name": "Farebox Point of Sale",
      "PGN_Description": "TR5",
      "first_bit": 0,
      "SPN": 3170,
      "SPN_Name": "Transaction Type",
      "SPN_Description": "Enumerated value representing the type of transaction completed\r\n\r\n0000 = Cash\r\n0001 = Token\r\n0010 = Ticket\r\n0011 = Pass\r\n0100 = Card\r\n0101 = Permit\r\n0110 = Transfer\r\n0111 = Free\r\n1000-1011 = Reserved for assignment\r\n1100-1111 = Agency defined",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3171": {
      "PGN": 64955,
      "PGN_Name": "Farebox Point of Sale",
      "PGN_Description": "TR5",
      "first_bit": 4,
      "SPN": 3171,
      "SPN_Name": "Passenger Type",
      "SPN_Description": "Enumerated value representing the type/class of passenger, as defined by the agency.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3172": {
      "PGN": 64955,
      "PGN_Name": "Farebox Point of Sale",
      "PGN_Description": "TR5",
      "first_bit": 32,
      "SPN": 3172,
      "SPN_Name": "Type of Service",
      "SPN_Description": "The type of service provided\r\n\r\n000 = Local service\r\n001 = Express service\r\n010-111 = Agency defined",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3173": {
      "PGN": 64955,
      "PGN_Name": "Farebox Point of Sale",
      "PGN_Description": "TR5",
      "first_bit": 35,
      "SPN": 3173,
      "SPN_Name": "Transfer Type",
      "SPN_Description": "The kind of transfer used\r\n\r\n00000 = North\r\n00001 = South\r\n00010 = East\r\n00011 = West\r\n00100 = In\r\n00101 = Out\r\n00110-11111 = Agency defined",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 90
    },
    "3174": {
      "PGN": 64956,
      "PGN_Name": "Farebox Service Detail",
      "PGN_Description": "TR4",
      "first_bit": 8,
      "SPN": 3174,
      "SPN_Name": "Trip Direction",
      "SPN_Description": "The general direction of travel for this trip.\r\n\r\n0000 = North\r\n0001 = South\r\n0010 = East\r\n0011 = West\r\n0100 = In\r\n0101 = Out\r\n0110-1111 = Agency defined",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3175": {
      "PGN": 64956,
      "PGN_Name": "Farebox Service Detail",
      "PGN_Description": "TR4",
      "first_bit": 16,
      "SPN": 3175,
      "SPN_Name": "Fare Presets",
      "SPN_Description": "Fare Presets\r\n\r\n00000000 to 00001111 = Agency defined\r\n00010000 to 11111111 = Reserved for assignment",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3176": {
      "PGN": 64955,
      "PGN_Name": "Farebox Point of Sale",
      "PGN_Description": "TR5",
      "first_bit": 8,
      "SPN": 3176,
      "SPN_Name": "Type of Fare",
      "SPN_Description": "Type of Fare\r\n\r\n0000 = Cash/No detail\r\n0001 = Token A\r\n0010 = Token B\r\n0011 = Ticket A\r\n0100 = Ticket B\r\n0101 = Pass A\r\n0110 = Pass B\r\n0111-1010 = Reserved for assignment\r\n1011-1111 = Agency defined",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3177": {
      "PGN": 64955,
      "PGN_Name": "Farebox Point of Sale",
      "PGN_Description": "TR5",
      "first_bit": 12,
      "SPN": 3177,
      "SPN_Name": "Payment Details",
      "SPN_Description": "Payment details.\r\n\r\n0000 = Not an upgrade\r\n0001 = Cash\r\n0010 = Token\r\n0011 = Ticket\r\n0100 = Pass\r\n0101 = Card\r\n0110-1010 = Reserved for assignment\r\n1011-1111 = Agency defined",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3178": {
      "PGN": 64956,
      "PGN_Name": "Farebox Service Detail",
      "PGN_Description": "TR4",
      "first_bit": 0,
      "SPN": 3178,
      "SPN_Name": "Farebox Service Status",
      "SPN_Description": "Indicates if the farebox is in or out of service.\r\n\r\n00 = Farebox out of service\r\n01 = Farebox in service\r\n10 = Error Condition\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3179": {
      "PGN": 64954,
      "PGN_Name": "Farebox Status",
      "PGN_Description": "TR6",
      "first_bit": 0,
      "SPN": 3179,
      "SPN_Name": "Farebox Emergency Status",
      "SPN_Description": "Indicates if a farebox emergency condition exists.\r\n\r\n00 = Non-emergency condition\r\n01 = Emergency condition\r\n10 = Error Condition\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3180": {
      "PGN": 64956,
      "PGN_Name": "Farebox Service Detail",
      "PGN_Description": "TR4",
      "first_bit": 2,
      "SPN": 3180,
      "SPN_Name": "Trip Status",
      "SPN_Description": "Trip Status\r\n\r\n000 = Undefined\r\n001 = Trip start\r\n010 = Trip end\r\n011 = Undefined\r\n100 = Undefined\r\n101 = Layover start\r\n110 = Layover end\r\n111 = Undefined",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3181": {
      "PGN": 64954,
      "PGN_Name": "Farebox Status",
      "PGN_Description": "TR6",
      "first_bit": 8,
      "SPN": 3181,
      "SPN_Name": "Farebox Alarm Identifier",
      "SPN_Description": "Indicates the nature of the farebox alarm condition.\r\n\r\n0000000 = Voltage dropout\r\n0000001 = Voltage restored\r\n0000010 = Probe started\r\n0000011 = Probe completed\r\n0000100 = Cashbox removed\r\n0000101 = Cashbox restored\r\n0000110 = Cashbox door timeout\r\n0000111 = Cashbox opened in service, considered an alarm condition\r\n0001000 = Insufficient fare accepted\r\n0001001 = Coinbox 75% full\r\n0001010 = Coinbox full\r\n0001011 = Currency box 75% full\r\n0001100 = Currency box less than 75% full\r\n0001101 = Currency box full\r\n0001110 = Card/pass box 75% full\r\n0001111 = Card/pass box less than 75% full\r\n0010000 = Card/pass box full\r\n0010001 = Coin de-jam operated\r\n0010010 = Farebox set in manual bypass\r\n0010011 = Farebox reset to automatic mode\r\n0010100 = Pass/transfer jam\r\n0010101 = Pass/transfer jam cleared\r\n0010110 = Paper currency jam\r\n0010111 = Paper currency jam cleared\r\n0011000 = Maintenance access in service, considered an alarm condition\r\n0011001 = Maintenance access out of service\r\n0011010-1100000 = Reserved - to be assigned\r\n1100001-1111111 = Agency defined",
      "bit_length": 7,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 92
    },
    "3188": {
      "PGN": 1024,
      "PGN_Name": "External Brake Request",
      "PGN_Description": "XBR",
      "first_bit": 60,
      "SPN": 3188,
      "SPN_Name": "XBR Message Checksum",
      "SPN_Description": "The XBR message checksum is used to verify the signal path from the demanding device to the brake controller on electronic brake systems.  The support of this parameter is mandatory if PGN 1024 is supported as there is no means to indicate “not available”.\r\n\r\nThe 4 bit XBR message checksum is calculated using the first 7 data bytes, the 4 bit message counter and the bytes of the message identifier.  It is calculated as follows:\r\n\r\nChecksum = (Byte1 + Byte2 + Byte3 + Byte4 + Byte5 + Byte6 + Byte7 + (message counter & 0x0F) + message ID low byte + message ID mid low byte + message ID mid high byte + message ID high byte)\r\n\r\nXBR Message Checksum = ((Checksum >> 4) + Checksum) & 0x0F\r\n\r\n\r\nNote:  A failure in the communication sets the XBR system state:\r\n    - to '01' for failed XBR 'priority 01, 10 or 11' messages\r\n    - to '10' for failed XBR 'priority 00' messages.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 220
    },
    "3189": {
      "PGN": 1024,
      "PGN_Name": "External Brake Request",
      "PGN_Description": "XBR",
      "first_bit": 56,
      "SPN": 3189,
      "SPN_Name": "XBR Message Counter",
      "SPN_Description": "The XBR message counter is to verify the signal path from the demanding device to the brake controller on electronic brake systems..  The support of this parameter is mandatory.\r\n\r\nNote:  The initial value of the 4 bit message counter for the first message during a driving cycle is arbitrary. In every following message the counter is incremented by 1  (0 follows 15).",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 220
    },
    "3190": {
      "PGN": 64953,
      "PGN_Name": "Tire Pressure Reference Information",
      "PGN_Description": "TPRI",
      "first_bit": 0,
      "SPN": 3190,
      "SPN_Name": "Tire Location",
      "SPN_Description": "Identifies which tire is associated with the parametric data in this PGN.\r\n\r\nThe low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward).\r\n\r\nThe high order 4 bits represent a position number, counting front to back on the vehicle.\r\n\r\nThe value 0xFF indicates not available.\r\n\r\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\r\n\r\nExamples: Tire pressure for location 0x00 would be left front tire.\r\n\r\nTire pressure for location 0x23 would be right outside rear rear on a 3-axle tractor with dual axle per side (3rd axle, 4th tire).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3191": {
      "PGN": 64953,
      "PGN_Name": "Tire Pressure Reference Information",
      "PGN_Description": "TPRI",
      "first_bit": 8,
      "SPN": 3191,
      "SPN_Name": "Reference Tire Pressure",
      "SPN_Description": "Reference value of the tire pressure as basis for the tire pressure monitoring",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "3192": {
      "PGN": 44544,
      "PGN_Name": "Tire Pressure Reference Setting",
      "PGN_Description": "TPRS",
      "first_bit": 0,
      "SPN": 3192,
      "SPN_Name": "Tire Location",
      "SPN_Description": "Identifies which tire is associated with the parametric data in this PGN.\r\n\r\nThe low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward).\r\n\r\nThe high order 4 bits represent a position number, counting front to back on the vehicle.\r\n\r\nThe value 0xFF indicates not available.\r\n\r\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\r\n\r\nExamples: Tire pressure for location 0x00 would be left front tire.\r\n\r\nTire pressure for location 0x23 would be right outside rear rear on a 3-axle tractor with dual axle per side (3rd axle, 4th tire).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3193": {
      "PGN": 44544,
      "PGN_Name": "Tire Pressure Reference Setting",
      "PGN_Description": "TPRS",
      "first_bit": 8,
      "SPN": 3193,
      "SPN_Name": "Reference Tire Pressure Setting",
      "SPN_Description": "Reference value of the tire pressure setting as basis for the tire pressure monitoring",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "3215": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 52,
      "SPN": 3215,
      "SPN_Name": "Prohibit air suspension control",
      "SPN_Description": "This parameter is an external request to the air suspension control system to prohibit all air suspension control.  If the request is accepted,  response intended to be sent in  ASC1 (additional status requested in ASC1), there will be no control either for height changes or axle load distribution changes, i.e. hold current pressures in all suspension devices.\r\n\r\n\r\n00 No request \r\n01 Request prohibit air suspension control \r\n10 Error indicator \r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3216": {
      "PGN": 61454,
      "PGN_Name": "Aftertreatment 1 Intake Gas 1",
      "PGN_Description": "AT1IG1",
      "first_bit": 0,
      "SPN": 3216,
      "SPN_Name": "Aftertreatment 1 SCR Intake NOx 1",
      "SPN_Description": "The amount of combined NO and NO2 in the exhaust entering the aftertreatment system measured by a NOx sensor at the aftertreatment intake, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 1 Dosing Unit 1.\r\n\r\nSPN 3216 shall display the raw, uncorrected NOx sensor signal. 2016 MY and later engines with NOx sensors may be required to output a ‘corrected’ NOx sensor signal (see SPN 7353) in addition to the raw NOx sensor signal output using SPN 3216.\r\n\r\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "3217": {
      "PGN": 61454,
      "PGN_Name": "Aftertreatment 1 Intake Gas 1",
      "PGN_Description": "AT1IG1",
      "first_bit": 16,
      "SPN": 3217,
      "SPN_Name": "Aftertreatment 1 Intake Percent Oxygen 1",
      "SPN_Description": "The actual oxidation factor (Percent Oxygen) of the gas within the exhaust stream. For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion. For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor. This value is measured by a sensor at the aftertreatment intake in exhaust bank 1.\r\n\r\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \"Rich\" or \"Lean\" in place of the implied %O2 values which would also be acceptable for display.",
      "bit_length": 16,
      "scaling": 0.000514,
      "offset": -12,
      "unit": "%",
      "SLOT_ID": 237
    },
    "3218": {
      "PGN": 61454,
      "PGN_Name": "Aftertreatment 1 Intake Gas 1",
      "PGN_Description": "AT1IG1",
      "first_bit": 32,
      "SPN": 3218,
      "SPN_Name": "Aftertreatment 1 Intake Gas Sensor 1 Power In Range",
      "SPN_Description": "Indicates that the power supplied to the aftertreatment intake gas sensor, either NOx or O2, is within the manufacturer’s specification in exhaust bank 1.  This parameter reports the status as reported by the sensor.\r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3219": {
      "PGN": 61454,
      "PGN_Name": "Aftertreatment 1 Intake Gas 1",
      "PGN_Description": "AT1IG1",
      "first_bit": 34,
      "SPN": 3219,
      "SPN_Name": "Aftertreatment 1 Intake Gas Sensor 1 at Temperature",
      "SPN_Description": "Indicates that the heater element of the aftertreatment intake gas sensor, either NOx or O2, is within the manufacturer’s specified range for accurate measurements in exhaust bank 1.\r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3220": {
      "PGN": 61454,
      "PGN_Name": "Aftertreatment 1 Intake Gas 1",
      "PGN_Description": "AT1IG1",
      "first_bit": 36,
      "SPN": 3220,
      "SPN_Name": "Aftertreatment 1 SCR Intake NOx 1 Reading Stable",
      "SPN_Description": "Indicates that the NOx reading of the aftertreatment intake NOx sensor is stable as determined by the manufacturer’s control software in exhaust bank 1.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3221": {
      "PGN": 61454,
      "PGN_Name": "Aftertreatment 1 Intake Gas 1",
      "PGN_Description": "AT1IG1",
      "first_bit": 38,
      "SPN": 3221,
      "SPN_Name": "Aftertreatment 1 Intake Wide-Range Percent Oxygen 1 Reading Stable",
      "SPN_Description": "Indicates that the percent oxygen reading of the aftertreatment intake gas sensor, either NOx or O2, is stable as determined by the manufacturer's control software in exhaust bank 1.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3222": {
      "PGN": 61454,
      "PGN_Name": "Aftertreatment 1 Intake Gas 1",
      "PGN_Description": "AT1IG1",
      "first_bit": 40,
      "SPN": 3222,
      "SPN_Name": "Aftertreatment 1 Intake Gas Sensor 1 Heater Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the heater of the intake exhaust gas sensor, either NOx or O2, by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3223": {
      "PGN": 61454,
      "PGN_Name": "Aftertreatment 1 Intake Gas 1",
      "PGN_Description": "AT1IG1",
      "first_bit": 45,
      "SPN": 3223,
      "SPN_Name": "Aftertreatment 1 Intake Gas Sensor 1 Heater Control",
      "SPN_Description": "Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the gas sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1.\r\n\r\n00 - Automatic\r\n01 - Preheat 2\r\n10 - Preheat 1\r\n11 - Heater off",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3224": {
      "PGN": 61454,
      "PGN_Name": "Aftertreatment 1 Intake Gas 1",
      "PGN_Description": "AT1IG1",
      "first_bit": 48,
      "SPN": 3224,
      "SPN_Name": "Aftertreatment 1 SCR Intake NOx Sensor 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment intake NOx sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3225": {
      "PGN": 61454,
      "PGN_Name": "Aftertreatment 1 Intake Gas 1",
      "PGN_Description": "AT1IG1",
      "first_bit": 56,
      "SPN": 3225,
      "SPN_Name": "Aftertreatment 1 Intake Oxygen  Sensor 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment intake oxygen sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3226": {
      "PGN": 61455,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 1",
      "PGN_Description": "AT1OG1",
      "first_bit": 0,
      "SPN": 3226,
      "SPN_Name": "Aftertreatment 1 Outlet NOx 1",
      "SPN_Description": "The amount of combined NO and NO2 in the exhaust exiting the aftertreatment system measured by a NOx sensor at the aftertreatment outlet, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 1.\r\n\r\nSPN 3226 shall display the raw, uncorrected NOx sensor signal. 2016 MY and later engines with NOx sensors may be required to output a ‘corrected’ NOx sensor signal (see SPN 7351) in addition to the raw NOx sensor signal output using SPN 3226.\r\n\r\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "3227": {
      "PGN": 61455,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 1",
      "PGN_Description": "AT1OG1",
      "first_bit": 16,
      "SPN": 3227,
      "SPN_Name": "Aftertreatment 1 Outlet Percent Oxygen 1",
      "SPN_Description": "The actual oxidation factor (percent oxygen) of the gas within the exhaust stream.  For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion.  For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor.  This value is measured by a sensor at the aftertreatment outlet in exhaust bank 1.\r\n\r\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \"Rich\" or \"Lean\" in place of the implied %O2 values which would also be acceptable for display.",
      "bit_length": 16,
      "scaling": 0.000514,
      "offset": -12,
      "unit": "%",
      "SLOT_ID": 237
    },
    "3228": {
      "PGN": 61455,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 1",
      "PGN_Description": "AT1OG1",
      "first_bit": 32,
      "SPN": 3228,
      "SPN_Name": "Aftertreatment 1 Outlet Gas Sensor 1 Power In Range",
      "SPN_Description": "Indicates that the power supplied to the aftertreatment outlet gas sensor, either NOx or O2, is within the manufacturer’s specification in exhaust bank 1. This parameter reports the status as reported by the sensor.\r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3229": {
      "PGN": 61455,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 1",
      "PGN_Description": "AT1OG1",
      "first_bit": 34,
      "SPN": 3229,
      "SPN_Name": "Aftertreatment 1 Outlet Gas Sensor 1 at Temperature",
      "SPN_Description": "Indicates that the heater element of the aftertreatment outlet gas sensor, either NOx or O2, is within the manufacturer’s specified range for accurate measurements in exhaust bank 1.\r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3230": {
      "PGN": 61455,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 1",
      "PGN_Description": "AT1OG1",
      "first_bit": 36,
      "SPN": 3230,
      "SPN_Name": "Aftertreatment 1 Outlet NOx 1 Reading Stable",
      "SPN_Description": "Indicates that the NOx reading of the aftertreatment outlet NOx sensor is stable as determined by the manufacturer’s control software in exhaust bank 1.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3231": {
      "PGN": 61455,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 1",
      "PGN_Description": "AT1OG1",
      "first_bit": 38,
      "SPN": 3231,
      "SPN_Name": "Aftertreatment 1 Outlet Wide-Range Percent Oxygen 1 Reading Stable",
      "SPN_Description": "Indicates that the percent oxygen reading of the aftertreatment outlet gas sensor, either NOx or O2, is stable as determined by the manufacturer's control software in exhaust bank 1.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3232": {
      "PGN": 61455,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 1",
      "PGN_Description": "AT1OG1",
      "first_bit": 40,
      "SPN": 3232,
      "SPN_Name": "Aftertreatment 1 Outlet Gas Sensor 1 Heater Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the heater of the outlet exhaust gas sensor, either NOx or O2, by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3233": {
      "PGN": 61455,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 1",
      "PGN_Description": "AT1OG1",
      "first_bit": 45,
      "SPN": 3233,
      "SPN_Name": "Aftertreatment 1 Outlet Gas Sensor 1 Heater Control",
      "SPN_Description": "Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the gas sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1.\r\n\r\n00 - Automatic\r\n01 - Preheat 2\r\n10 - Preheat 1\r\n11 - Heater off",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3234": {
      "PGN": 61455,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 1",
      "PGN_Description": "AT1OG1",
      "first_bit": 48,
      "SPN": 3234,
      "SPN_Name": "Aftertreatment 1 Outlet NOx Sensor 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet NOx sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3235": {
      "PGN": 61455,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 1",
      "PGN_Description": "AT1OG1",
      "first_bit": 56,
      "SPN": 3235,
      "SPN_Name": "Aftertreatment 1 Outlet Oxygen Sensor 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet oxygen sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3236": {
      "PGN": 65247,
      "PGN_Name": "Electronic Engine Controller 3",
      "PGN_Description": "EEC3",
      "first_bit": 40,
      "SPN": 3236,
      "SPN_Name": "Aftertreatment 1 Exhaust Gas Mass Flow Rate",
      "SPN_Description": "Measured/calculated exhaust gas mass upstream of the aftertreatment system in exhaust bank 1 and 2.",
      "bit_length": 16,
      "scaling": 0.2,
      "offset": 0,
      "unit": "kg/h",
      "SLOT_ID": 262
    },
    "3237": {
      "PGN": 65247,
      "PGN_Name": "Electronic Engine Controller 3",
      "PGN_Description": "EEC3",
      "first_bit": 56,
      "SPN": 3237,
      "SPN_Name": "Aftertreatment 1 Intake Dew Point",
      "SPN_Description": "Indicates that the temperature on the intake side of the aftertreatment system has exceeded the dew point, as estimated by the ECU in exhaust bank 1.\r\n\r\n00 - Not exceeded the dew point\r\n01 - Exceeded the dew point\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3238": {
      "PGN": 65247,
      "PGN_Name": "Electronic Engine Controller 3",
      "PGN_Description": "EEC3",
      "first_bit": 58,
      "SPN": 3238,
      "SPN_Name": "Aftertreatment 1 Exhaust Dew Point",
      "SPN_Description": "Indicates that the temperature on the exhaust side of the aftertreatment has exceeded the dew point, as estimated by the ECU in exhaust bank 1.\r\n\r\n00 - Not exceeded the dew point\r\n01 - Exceeded the dew point\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3239": {
      "PGN": 65247,
      "PGN_Name": "Electronic Engine Controller 3",
      "PGN_Description": "EEC3",
      "first_bit": 60,
      "SPN": 3239,
      "SPN_Name": "Aftertreatment 2 Intake Dew Point",
      "SPN_Description": "Indicates that the temperature on the intake side of the aftertreatment system has exceeded the dew point, as estimated by the ECU in exhaust bank 2.\r\n\r\n00 - Not exceeded the dew point\r\n01 - Exceeded the dew point\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3240": {
      "PGN": 65247,
      "PGN_Name": "Electronic Engine Controller 3",
      "PGN_Description": "EEC3",
      "first_bit": 62,
      "SPN": 3240,
      "SPN_Name": "Aftertreatment 2 Exhaust Dew Point",
      "SPN_Description": "Indicates that the temperature on the exhaust side of the aftertreatment has exceeded the dew point, as estimated by the ECU in exhaust bank 2.\r\n\r\n00 - Not exceeded the dew point\r\n01 - Exceeded the dew point\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3241": {
      "PGN": 64948,
      "PGN_Name": "Aftertreatment 1 Intake Gas 2",
      "PGN_Description": "AT1IG2",
      "first_bit": 0,
      "SPN": 3241,
      "SPN_Name": "Aftertreatment 1 Exhaust Temperature 1",
      "SPN_Description": "The reading from the exhaust temperature sensor located farthest upstream in the aftertreatment system in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3242": {
      "PGN": 64948,
      "PGN_Name": "Aftertreatment 1 Intake Gas 2",
      "PGN_Description": "AT1IG2",
      "first_bit": 16,
      "SPN": 3242,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Intake Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts entering the diesel particulate filter in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3243": {
      "PGN": 64948,
      "PGN_Name": "Aftertreatment 1 Intake Gas 2",
      "PGN_Description": "AT1IG2",
      "first_bit": 32,
      "SPN": 3243,
      "SPN_Name": "Aftertreatment 1 Exhaust Temperature 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the exhaust temperature 1 sensor by the manufacturer’s sensor control software in exhaust bank 1.   In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3244": {
      "PGN": 64948,
      "PGN_Name": "Aftertreatment 1 Intake Gas 2",
      "PGN_Description": "AT1IG2",
      "first_bit": 40,
      "SPN": 3244,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Intake Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter intake temperature sensor by the manufacturer’s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3245": {
      "PGN": 64947,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 2",
      "PGN_Description": "AT1OG2",
      "first_bit": 0,
      "SPN": 3245,
      "SPN_Name": "Aftertreatment 1 Exhaust Temperature 3",
      "SPN_Description": "The reading from the exhaust temperature sensor located farthest downstream in the aftertreatment system in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3246": {
      "PGN": 64947,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 2",
      "PGN_Description": "AT1OG2",
      "first_bit": 16,
      "SPN": 3246,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Outlet Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts leaving the diesel particulate filter exhaust in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3247": {
      "PGN": 64947,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 2",
      "PGN_Description": "AT1OG2",
      "first_bit": 32,
      "SPN": 3247,
      "SPN_Name": "Aftertreatment 1 Exhaust Temperature 3 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the exhaust temperature 3 sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3248": {
      "PGN": 64947,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 2",
      "PGN_Description": "AT1OG2",
      "first_bit": 40,
      "SPN": 3248,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Outlet Exhaust Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter outlet temperature sensor by the manufacturer’s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3249": {
      "PGN": 64946,
      "PGN_Name": "Aftertreatment 1 Intermediate Gas",
      "PGN_Description": "AT1IMG",
      "first_bit": 0,
      "SPN": 3249,
      "SPN_Name": "Aftertreatment 1 Exhaust Temperature 2",
      "SPN_Description": "The reading from the exhaust temperature sensor located midstream of the other two temperature sensors in the aftertreatment system in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3250": {
      "PGN": 64946,
      "PGN_Name": "Aftertreatment 1 Intermediate Gas",
      "PGN_Description": "AT1IMG",
      "first_bit": 16,
      "SPN": 3250,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Intermediate Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts at a mid-point in the diesel particulate filter in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3251": {
      "PGN": 64946,
      "PGN_Name": "Aftertreatment 1 Intermediate Gas",
      "PGN_Description": "AT1IMG",
      "first_bit": 32,
      "SPN": 3251,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Differential Pressure",
      "SPN_Description": "Exhaust differential pressure measured between the intake and exhaust of a diesel particulate filter in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3252": {
      "PGN": 64946,
      "PGN_Name": "Aftertreatment 1 Intermediate Gas",
      "PGN_Description": "AT1IMG",
      "first_bit": 48,
      "SPN": 3252,
      "SPN_Name": "Aftertreatment 1 Exhaust Temperature 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the exhaust temperature 2 sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3253": {
      "PGN": 64946,
      "PGN_Name": "Aftertreatment 1 Intermediate Gas",
      "PGN_Description": "AT1IMG",
      "first_bit": 53,
      "SPN": 3253,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Differential Pressure Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter differential pressure sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3254": {
      "PGN": 64946,
      "PGN_Name": "Aftertreatment 1 Intermediate Gas",
      "PGN_Description": "AT1IMG",
      "first_bit": 58,
      "SPN": 3254,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Intermediate Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter intermediate temperature sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3255": {
      "PGN": 61456,
      "PGN_Name": "Aftertreatment 2 Intake Gas 1",
      "PGN_Description": "AT2IG1",
      "first_bit": 0,
      "SPN": 3255,
      "SPN_Name": "Aftertreatment 2 SCR Intake NOx 1",
      "SPN_Description": "The amount of combined NO and NO2 in the exhaust entering the aftertreatment system measured by a NOx sensor at the aftertreatment intake, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\r\n\r\nSPN 3255 shall display the raw, uncorrected NOx sensor signal. 2016 MY and later engines with NOx sensors may be required to output a ‘corrected’ NOx sensor signal (see SPN 7354) in addition to the raw NOx sensor signal output using SPN 3255.\r\n\r\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "3256": {
      "PGN": 61456,
      "PGN_Name": "Aftertreatment 2 Intake Gas 1",
      "PGN_Description": "AT2IG1",
      "first_bit": 16,
      "SPN": 3256,
      "SPN_Name": "Aftertreatment 2 Intake Percent Oxygen 1",
      "SPN_Description": "The actual oxidation factor (percent oxygen) of the gas within the exhaust stream.  For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion.  For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor.  This value is measured by a sensor at the aftertreatment intake in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\r\n\r\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \"Rich\" or \"Lean\" in place of the implied %O2 values which would also be acceptable for display.",
      "bit_length": 16,
      "scaling": 0.000514,
      "offset": -12,
      "unit": "%",
      "SLOT_ID": 237
    },
    "3257": {
      "PGN": 61456,
      "PGN_Name": "Aftertreatment 2 Intake Gas 1",
      "PGN_Description": "AT2IG1",
      "first_bit": 32,
      "SPN": 3257,
      "SPN_Name": "Aftertreatment 2 Intake Gas Sensor 1 Power In Range",
      "SPN_Description": "Indicates that the power supplied to the aftertreatment intake gas sensor, either NOx or O2, is within the manufacturer’s specification in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\r\n\r\nThis parameter reports the status as reported by the sensor.\r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3258": {
      "PGN": 61456,
      "PGN_Name": "Aftertreatment 2 Intake Gas 1",
      "PGN_Description": "AT2IG1",
      "first_bit": 34,
      "SPN": 3258,
      "SPN_Name": "Aftertreatment 2 Intake Gas Sensor 1 at Temperature",
      "SPN_Description": "Indicates that the heater element of the aftertreatment intake gas sensor, either NOx or O2, is within the manufacturer’s specified range for accurate measurements in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.  \r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3259": {
      "PGN": 61456,
      "PGN_Name": "Aftertreatment 2 Intake Gas 1",
      "PGN_Description": "AT2IG1",
      "first_bit": 36,
      "SPN": 3259,
      "SPN_Name": "Aftertreatment 2 SCR Intake NOx 1 Reading Stable",
      "SPN_Description": " Indicates that the NOx reading of the aftertreatment intake NOx sensor is stable as determined by the manufacturer’s control software in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3260": {
      "PGN": 61456,
      "PGN_Name": "Aftertreatment 2 Intake Gas 1",
      "PGN_Description": "AT2IG1",
      "first_bit": 38,
      "SPN": 3260,
      "SPN_Name": "Aftertreatment 2 Intake Wide-Range Percent Oxygen 1 Reading Stable",
      "SPN_Description": "Indicates that the percent oxygen reading of the aftertreatment intake gas sensor, either NOx or O2, is stable as determined by the manufacturer's control software in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3261": {
      "PGN": 61456,
      "PGN_Name": "Aftertreatment 2 Intake Gas 1",
      "PGN_Description": "AT2IG1",
      "first_bit": 40,
      "SPN": 3261,
      "SPN_Name": "Aftertreatment 2 Intake Gas Sensor 1 Heater Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the heater of the intake exhaust gas sensor, either NOx or O2, by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3262": {
      "PGN": 61456,
      "PGN_Name": "Aftertreatment 2 Intake Gas 1",
      "PGN_Description": "AT2IG1",
      "first_bit": 45,
      "SPN": 3262,
      "SPN_Name": "Aftertreatment 2 Intake Gas Sensor 1 Heater Control",
      "SPN_Description": "Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the gas sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\r\n\r\n00 - Automatic\r\n01 - Preheat 2\r\n10 - Preheat 1\r\n11 - Heater off",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3263": {
      "PGN": 61456,
      "PGN_Name": "Aftertreatment 2 Intake Gas 1",
      "PGN_Description": "AT2IG1",
      "first_bit": 48,
      "SPN": 3263,
      "SPN_Name": "Aftertreatment 2 SCR Intake NOx Sensor 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment intake NOx sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3264": {
      "PGN": 61456,
      "PGN_Name": "Aftertreatment 2 Intake Gas 1",
      "PGN_Description": "AT2IG1",
      "first_bit": 56,
      "SPN": 3264,
      "SPN_Name": "Aftertreatment 2 Intake Oxygen Sensor 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment intake oxygen sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3265": {
      "PGN": 61457,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 1",
      "PGN_Description": "AT2OG1",
      "first_bit": 0,
      "SPN": 3265,
      "SPN_Name": "Aftertreatment 2 Outlet NOx 1",
      "SPN_Description": "The amount of combined NO and NO2 in the exhaust entering the aftertreatment system measured by a NOx sensor at the aftertreatment outlet, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\r\n\r\nSPN 3265 shall display the raw, uncorrected NOx sensor signal. 2016 MY and later engines with NOx sensors may be required to output a ‘corrected’ NOx sensor signal (see SPN 7352) in addition to the raw NOx sensor signal output using SPN 3265.\r\n\r\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "3266": {
      "PGN": 61457,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 1",
      "PGN_Description": "AT2OG1",
      "first_bit": 16,
      "SPN": 3266,
      "SPN_Name": "Aftertreatment 2 Outlet Percent Oxygen 1",
      "SPN_Description": "The actual oxidation factor (percent oxygen) of the gas within the exhaust stream.  For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion.  For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor.  This value is measured by a sensor at the aftertreatment outlet in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\r\n\r\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \"Rich\" or \"Lean\" in place of the implied %O2 values which would also be acceptable for display.",
      "bit_length": 16,
      "scaling": 0.000514,
      "offset": -12,
      "unit": "%",
      "SLOT_ID": 237
    },
    "3267": {
      "PGN": 61457,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 1",
      "PGN_Description": "AT2OG1",
      "first_bit": 32,
      "SPN": 3267,
      "SPN_Name": "Aftertreatment 2 Outlet Gas Sensor 1 Power In Range",
      "SPN_Description": " Indicates that the power supplied to the aftertreatment outlet gas sensor, either NOx or O2, is within the manufacturer’s specification in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\r\n\r\nThis parameter reports the status as reported by the sensor.\r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3268": {
      "PGN": 61457,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 1",
      "PGN_Description": "AT2OG1",
      "first_bit": 34,
      "SPN": 3268,
      "SPN_Name": "Aftertreatment 2 Outlet Gas Sensor 1 at Temperature",
      "SPN_Description": "Indicates that the heater element of the aftertreatment outlet gas sensor, either NOx or O2, is within the manufacturer’s specified range for accurate measurements in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3269": {
      "PGN": 61457,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 1",
      "PGN_Description": "AT2OG1",
      "first_bit": 36,
      "SPN": 3269,
      "SPN_Name": "Aftertreatment 2 Outlet NOx 1 Reading Stable",
      "SPN_Description": "Indicates that the NOx reading of the aftertreatment outlet NOx sensor is stable as determined by the manufacturer’s control software in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3270": {
      "PGN": 61457,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 1",
      "PGN_Description": "AT2OG1",
      "first_bit": 38,
      "SPN": 3270,
      "SPN_Name": "Aftertreatment 2 Outlet Wide-Range Percent Oxygen 1 Reading Stable",
      "SPN_Description": "Indicates that the percent oxygen reading of the aftertreatment outlet gas sensor, either NOx or O2, is stable as determined by the manufacturer's control software in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3271": {
      "PGN": 61457,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 1",
      "PGN_Description": "AT2OG1",
      "first_bit": 40,
      "SPN": 3271,
      "SPN_Name": "Aftertreatment 2 Outlet Gas Sensor 1 Heater Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the heater of the outlet exhaust gas sensor, either NOx or O2, by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3272": {
      "PGN": 61457,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 1",
      "PGN_Description": "AT2OG1",
      "first_bit": 45,
      "SPN": 3272,
      "SPN_Name": "Aftertreatment 2 Outlet Gas Sensor 1 Heater Control",
      "SPN_Description": "Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the gas sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\r\n\r\n00 - Automatic\r\n01 - Preheat 2\r\n10 - Preheat 1\r\n11 - Heater off",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3273": {
      "PGN": 61457,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 1",
      "PGN_Description": "AT2OG1",
      "first_bit": 48,
      "SPN": 3273,
      "SPN_Name": "Aftertreatment 2 Outlet NOx Sensor 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet NOx sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3274": {
      "PGN": 61457,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 1",
      "PGN_Description": "AT2OG1",
      "first_bit": 56,
      "SPN": 3274,
      "SPN_Name": "Aftertreatment 2 Outlet Oxygen Sensor 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet oxygen sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3275": {
      "PGN": 64945,
      "PGN_Name": "Aftertreatment 2 Intake Gas 2",
      "PGN_Description": "AT2IG2",
      "first_bit": 0,
      "SPN": 3275,
      "SPN_Name": "Aftertreatment 2 Exhaust Temperature 1",
      "SPN_Description": "The reading from the exhaust temperature sensor located farthest upstream in the aftertreatment system in exhaust bank 2.  (For a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247)",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3276": {
      "PGN": 64945,
      "PGN_Name": "Aftertreatment 2 Intake Gas 2",
      "PGN_Description": "AT2IG2",
      "first_bit": 16,
      "SPN": 3276,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Intake Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts entering the diesel particulate filter in exhaust bank 2.  (For a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247)",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3277": {
      "PGN": 64945,
      "PGN_Name": "Aftertreatment 2 Intake Gas 2",
      "PGN_Description": "AT2IG2",
      "first_bit": 32,
      "SPN": 3277,
      "SPN_Name": "Aftertreatment 2 Exhaust Temperature 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the exhaust temperature 1 sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3278": {
      "PGN": 64945,
      "PGN_Name": "Aftertreatment 2 Intake Gas 2",
      "PGN_Description": "AT2IG2",
      "first_bit": 40,
      "SPN": 3278,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Intake Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter intake temperature sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3279": {
      "PGN": 64944,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 2",
      "PGN_Description": "AT2OG2",
      "first_bit": 0,
      "SPN": 3279,
      "SPN_Name": "Aftertreatment 2 Exhaust Temperature 3",
      "SPN_Description": "The reading from the exhaust temperature sensor located farthest downstream in the aftertreatment system in exhaust bank 2.  (For a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247)",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3280": {
      "PGN": 64944,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 2",
      "PGN_Description": "AT2OG2",
      "first_bit": 16,
      "SPN": 3280,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Outlet Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts leaving the diesel particulate filter exhaust in exhaust bank 2.  (For a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247)",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3281": {
      "PGN": 64944,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 2",
      "PGN_Description": "AT2OG2",
      "first_bit": 32,
      "SPN": 3281,
      "SPN_Name": "Aftertreatment 2 Exhaust Temperature 3 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the exhaust temperature 3 sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3282": {
      "PGN": 64944,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 2",
      "PGN_Description": "AT2OG2",
      "first_bit": 40,
      "SPN": 3282,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Exhaust Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter outlet temperature sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3283": {
      "PGN": 64943,
      "PGN_Name": "Aftertreatment 2 Intermediate Gas",
      "PGN_Description": "AT2IMG",
      "first_bit": 0,
      "SPN": 3283,
      "SPN_Name": "Aftertreatment 2 Exhaust Temperature 2",
      "SPN_Description": "The reading from the exhaust temperature sensor located midstream of the other two temperature sensors in the aftertreatment system in exhaust bank 2.  (For a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247)",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3284": {
      "PGN": 64943,
      "PGN_Name": "Aftertreatment 2 Intermediate Gas",
      "PGN_Description": "AT2IMG",
      "first_bit": 16,
      "SPN": 3284,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Intermediate Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts at a mid-point in the diesel particulate filter in exhaust bank 2.  (For a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247)",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3285": {
      "PGN": 64943,
      "PGN_Name": "Aftertreatment 2 Intermediate Gas",
      "PGN_Description": "AT2IMG",
      "first_bit": 32,
      "SPN": 3285,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Differential Pressure",
      "SPN_Description": "Exhaust differential pressure measured between the intake and exhaust of a diesel particulate filter in exhaust bank 2.  (For a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247)",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3286": {
      "PGN": 64943,
      "PGN_Name": "Aftertreatment 2 Intermediate Gas",
      "PGN_Description": "AT2IMG",
      "first_bit": 48,
      "SPN": 3286,
      "SPN_Name": "Aftertreatment 2 Exhaust Temperature 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the exhaust temperature 2 sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3287": {
      "PGN": 64943,
      "PGN_Name": "Aftertreatment 2 Intermediate Gas",
      "PGN_Description": "AT2IMG",
      "first_bit": 53,
      "SPN": 3287,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Differential Pressure Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter differential pressure sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3288": {
      "PGN": 64943,
      "PGN_Name": "Aftertreatment 2 Intermediate Gas",
      "PGN_Description": "AT2IMG",
      "first_bit": 58,
      "SPN": 3288,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Intermediate Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter intermediate temperature sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3289": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 24,
      "SPN": 3289,
      "SPN_Name": "Transmission Requested Gear Feedback",
      "SPN_Description": "Feedback of the SPN 525 Transmission Requested Gear input as received from the shift selector, ABS or engine via PGN 256, Transmission Control 1 (TC1) or other transmission selector input.  Scaling, values and parameter specific indicators are identical to those listed for SPN 525 Requested Gear.\r\n\r\nThis feedback from the transmission allows shift selectors and other TC1 input devices to verify that their Transmission Requested Gear command has been properly received by the transmission.  (This parameter is not intended for driver display purposes).\r\n\r\nIn systems with mechanical or electrical shift selectors which do not support J1939 communication, this parameter allows the transmission ECU to convey the requested gear as interpreted by the transmission from its mechanical or electrical input.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "gear value",
      "SLOT_ID": 24
    },
    "3307": {
      "PGN": 64942,
      "PGN_Name": "Fifth Wheel Smart Systems 2",
      "PGN_Description": "FWSS2",
      "first_bit": 0,
      "SPN": 3307,
      "SPN_Name": "Fifth Wheel Error Status",
      "SPN_Description": "Fifth wheel error state which conveys information when coupling status is incomplete or bad.\r\n\r\n0000    0 - Improper Couple\r\n0001    1 - Locks Closed / No Kingpin at Startup\r\n0010    2 - Kingpin / Locks Open at Startup\r\n0011    3 - Not Used\r\n0100    4 - Not Used\r\n0101    5 - Coupling Sequence Error\r\n0110    6 - Coupling Sequence Error / Kingpin\r\n0111    7 - Coupling Timing Error\r\n1000    8 - Kingpin Missing More Than 5 Seconds\r\n1001    9 - Kingpin / Lock Open (Handle Pulled)\r\n1010    10 - Not Used\r\n1011    11 - Not Used\r\n1100    12 - Not Used\r\n1101    13 - Not Used\r\n1110    14 - Not Used\r\n1111    15 - Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3308": {
      "PGN": 61458,
      "PGN_Name": "Fifth Wheel Smart Systems 1",
      "PGN_Description": "FWSS1",
      "first_bit": 0,
      "SPN": 3308,
      "SPN_Name": "Fifth Wheel Vertical Force",
      "SPN_Description": "The amount of load being applied to the fifth wheel by the trailer. Zero load is indicated without a trailer.",
      "bit_length": 16,
      "scaling": 5,
      "offset": 0,
      "unit": "N",
      "SLOT_ID": 43
    },
    "3309": {
      "PGN": 61458,
      "PGN_Name": "Fifth Wheel Smart Systems 1",
      "PGN_Description": "FWSS1",
      "first_bit": 16,
      "SPN": 3309,
      "SPN_Name": "Fifth Wheel Drawbar Force",
      "SPN_Description": "Fifth wheel drawbar force, with the trailer held stationary a positive force is generated by the vehicle pulling forward.",
      "bit_length": 16,
      "scaling": 10,
      "offset": -320000,
      "unit": "N",
      "SLOT_ID": 127
    },
    "3310": {
      "PGN": 61458,
      "PGN_Name": "Fifth Wheel Smart Systems 1",
      "PGN_Description": "FWSS1",
      "first_bit": 32,
      "SPN": 3310,
      "SPN_Name": "Fifth Wheel Roll Moment ",
      "SPN_Description": "Fifth wheel roll moment force - If the moment is positive, the trailer is rolling clockwise relative to the normal vehicle forward motion.",
      "bit_length": 16,
      "scaling": 10,
      "offset": -320000,
      "unit": "N",
      "SLOT_ID": 127
    },
    "3311": {
      "PGN": 64942,
      "PGN_Name": "Fifth Wheel Smart Systems 2",
      "PGN_Description": "FWSS2",
      "first_bit": 8,
      "SPN": 3311,
      "SPN_Name": "Fifth Wheel Slider Position",
      "SPN_Description": "Slider position measurement. Zero equals fully back position, that is, the farthest to the rear of the vehicle.",
      "bit_length": 8,
      "scaling": 10,
      "offset": 0,
      "unit": "mm",
      "SLOT_ID": 234
    },
    "3312": {
      "PGN": 64942,
      "PGN_Name": "Fifth Wheel Smart Systems 2",
      "PGN_Description": "FWSS2",
      "first_bit": 4,
      "SPN": 3312,
      "SPN_Name": "Fifth Wheel Lock Ready to Couple Indicator",
      "SPN_Description": "Indicates to the vehicle operator that the fifth wheel lock is open and ready to couple.\r\n\r\n00   Lock not open, not ready to couple\r\n01   Lock open, ready to couple\r\n10   Error\r\n11   Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3313": {
      "PGN": 64942,
      "PGN_Name": "Fifth Wheel Smart Systems 2",
      "PGN_Description": "FWSS2",
      "first_bit": 6,
      "SPN": 3313,
      "SPN_Name": "Fifth Wheel Lock Couple Status Indicator",
      "SPN_Description": "Indicates results of coupling operation to the vehicle operator. For incomplete couples further information can be obtained from the fifth wheel error status SPN.\r\n\r\n00   Incomplete or bad couple, truck should not be moved\r\n01   Successful couple detected\r\n10   Error\r\n11   Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3314": {
      "PGN": 64980,
      "PGN_Name": "Cab Message 3",
      "PGN_Description": "CM3",
      "first_bit": 8,
      "SPN": 3314,
      "SPN_Name": "Fifth Wheel Release Control",
      "SPN_Description": "Operator input used to release the fifth wheel. Fifth Wheel Release Control Security Lockout and other conditions must be properly enabled before this will function.\r\n\r\n00   Coupler Locked\r\n01   Coupler Unlocked, trailer can be unhitched or hitched\r\n10   Error\r\n11   Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3315": {
      "PGN": 64980,
      "PGN_Name": "Cab Message 3",
      "PGN_Description": "CM3",
      "first_bit": 10,
      "SPN": 3315,
      "SPN_Name": "Fifth Wheel Release Control Security Lockout",
      "SPN_Description": "Operator's fifth wheel release control interlock. This operator input must be enabled prior to activating the fifth wheel release control (SPN 3314). \r\n\r\n00    Fifth wheel release Disabled\r\n01    Fifth wheel release Enabled\r\n10    Error   \r\n11    Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3316": {
      "PGN": 64942,
      "PGN_Name": "Fifth Wheel Smart Systems 2",
      "PGN_Description": "FWSS2",
      "first_bit": 16,
      "SPN": 3316,
      "SPN_Name": "Fifth Wheel Slider Lock Indicator",
      "SPN_Description": "Indicates to vehicle operator that the fifth wheel slider is in position and locked. \r\n\n00 Not Locked\r\n01 Locked\r\n10 Error\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3317": {
      "PGN": 61458,
      "PGN_Name": "Fifth Wheel Smart Systems 1",
      "PGN_Description": "FWSS1",
      "first_bit": 48,
      "SPN": 3317,
      "SPN_Name": "Fifth Wheel Roll Warning Indicator",
      "SPN_Description": "Indicates to the vehicle operator that the roll moment has exceeded a preset limit. \r\n\n00 Limit not exceeded\r\n01 Limit exceeded\r\n10 error\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3318": {
      "PGN": 61459,
      "PGN_Name": "Slope Sensor Information",
      "PGN_Description": "SSI",
      "first_bit": 0,
      "SPN": 3318,
      "SPN_Name": "Pitch Angle",
      "SPN_Description": "The angle between the vehicle x-axis and the ground plane (i.e. rotation about the vehicle Y-axis).  The pitch angle for an angle of ascent is reported with a positive value. This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.  See SPN 4976 for an alternate range and resolution.",
      "bit_length": 16,
      "scaling": 0.002,
      "offset": -64,
      "unit": "deg",
      "SLOT_ID": 242
    },
    "3319": {
      "PGN": 61459,
      "PGN_Name": "Slope Sensor Information",
      "PGN_Description": "SSI",
      "first_bit": 16,
      "SPN": 3319,
      "SPN_Name": "Roll Angle",
      "SPN_Description": "The angle between the vehicle y-axis and the ground plane (i.e. rotation about the X-axis).  The roll angle for a roll to the right is reported with a positive value. Roll angle is the same for both Z-Down and Z-Up axis systems, since both systems have positive X axis directed forward.  The sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  See SPN 4977 for an alternate range and resolution.",
      "bit_length": 16,
      "scaling": 0.002,
      "offset": -64,
      "unit": "deg",
      "SLOT_ID": 242
    },
    "3322": {
      "PGN": 61459,
      "PGN_Name": "Slope Sensor Information",
      "PGN_Description": "SSI",
      "first_bit": 32,
      "SPN": 3322,
      "SPN_Name": "Pitch Rate",
      "SPN_Description": "Pitch rate is the rate-of-change of the pitch angle over time, where the pitch angle vector is in the direction of travel of the vehicle. The pitch rate for increasing ascent over time is reported with a positive value. This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.  See SPN 4983 for an alternate range and resolution.",
      "bit_length": 16,
      "scaling": 0.002,
      "offset": -64,
      "unit": "deg/s",
      "SLOT_ID": 243
    },
    "3323": {
      "PGN": 61459,
      "PGN_Name": "Slope Sensor Information",
      "PGN_Description": "SSI",
      "first_bit": 48,
      "SPN": 3323,
      "SPN_Name": "Pitch Angle Figure of Merit",
      "SPN_Description": "Figure of merit for pitch angle measurement.\r\n\r\n00 - Pitch angle fully functional.  Data is within sensor specification. \r\n01 - Pitch angle degraded.  Data is suspect due to environmental conditions.\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3324": {
      "PGN": 61459,
      "PGN_Name": "Slope Sensor Information",
      "PGN_Description": "SSI",
      "first_bit": 50,
      "SPN": 3324,
      "SPN_Name": "Roll Angle Figure of Merit",
      "SPN_Description": "Figure of merit for roll angle measurement.\r\n\r\n00 - Roll angle fully functional.  Data is within sensor specification.   \r\n01 - Roll angle degraded.  Data is suspect due to environmental conditions.\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3325": {
      "PGN": 61459,
      "PGN_Name": "Slope Sensor Information",
      "PGN_Description": "SSI",
      "first_bit": 52,
      "SPN": 3325,
      "SPN_Name": "Pitch Rate Figure of Merit",
      "SPN_Description": "Figure of merit for the pitch rate measurement.\r\n\n00 - Pitch rate fully functional.  Data is within sensor specification.   \r\n01 - Pitch rate degraded.  Data is suspect due to environmental conditions.\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3326": {
      "PGN": 61459,
      "PGN_Name": "Slope Sensor Information",
      "PGN_Description": "SSI",
      "first_bit": 54,
      "SPN": 3326,
      "SPN_Name": "Pitch and Roll Compensated",
      "SPN_Description": "Compensated mode for the pitch and roll measurements.  Compensation is the use of multiple sensors together to enhance the output of pitch and roll measurements.\r\n\r\n00 - Compensation Off\r\n01 - Compensation On\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3327": {
      "PGN": 61459,
      "PGN_Name": "Slope Sensor Information",
      "PGN_Description": "SSI",
      "first_bit": 56,
      "SPN": 3327,
      "SPN_Name": "Roll and Pitch Measurement Latency",
      "SPN_Description": "The estimated measurement latency of the measurement.  NOTE: This is only the sensor latency and does not include any additional latencies that might exist because of the CAN Bus or overall system implementation. \nLatency is the time from sensor readings to the queuing of the message data for CAN transmission.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 241
    },
    "3331": {
      "PGN": 61460,
      "PGN_Name": "Blade Information",
      "PGN_Description": "BI",
      "first_bit": 16,
      "SPN": 3331,
      "SPN_Name": "Blade Rotation Angle",
      "SPN_Description": "The blade rotation angle measurement around the yaw (z-axis).  The Blade Rotation Angle is defined to be the angle from the null position on the machine.  The null position is orthogonal from the z-axis along the x-axis.  A positive blade angle results when the blade is rotated clockwise from the null position. This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "3332": {
      "PGN": 61460,
      "PGN_Name": "Blade Information",
      "PGN_Description": "BI",
      "first_bit": 42,
      "SPN": 3332,
      "SPN_Name": "Blade Rotation Angle Figure of Merit",
      "SPN_Description": "Figure of merit for blade rotation measurement.\r\n\r\nBits\r\n00  Blade Rotation Angle fully functional.  Data is within sensor specification.   \r\n01  Blade Rotation Angle  degraded.  Data is suspect due to environmental conditions.\r\n10  Blade Rotation Angle failed.  Roll sensor failed to operate correctly.\r\n11  Blade Rotation Angle not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3334": {
      "PGN": 61453,
      "PGN_Name": "Land Leveling System Operational Information",
      "PGN_Description": "LOI",
      "first_bit": 12,
      "SPN": 3334,
      "SPN_Name": "Left Blade Control Mode Operator Control",
      "SPN_Description": "This parameter indicates the left blade control mode operator control state the user has set for the land leveling system.  The operator control value directly relates to the current operator control state correlating to the left edge of the blade.  The purpose of this parameter is to set the control mode (auto/manual) for the left side of the blade. For this system, the left and right side of the blade can be adjusted independently of each other to either change the elevation from a given reference point or the blade angle (also known as blade tilt)/cross slope depending on the function requested by the operator.\r\n\r\nThis parameter is intended for use in systems using two parameters (right/left) to control the blade as described above.  Systems using only one parameter to control blade position, i.e. elevation, should use the Blade Control Mode Switch parameter. Only one of the following states will be active at a time.   In the example below, data values are defined for each switch type that may be used in an application.  The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\r\n\r\n1.  A toggle button with two states can be used, in which the button is either in the manual or the auto position at all times.  \r\n\r\nToggle button usage is as follows:\r\n     Manual Button Pressed       = 0010    Manual Operator Control Request\r\n     Automatic Button Pressed  = 0011    Automatic Operator Control Request\r\n     Invalid Switch Input(ex. auto and manual read/pressed simultaneously)  = 1110    Error Indicator\r\n\r\n2. The momentary rocker switch may be used, where the default is the no button pressed position.  The user can press the rocker into the manual position, and when pressure is released, it will return to the no button pressed position.  The user may also press the rocker into the auto position, and when pressure is released, it will return to the no button pressed position.\r\n\r\nMomentary rocker button usage is as follows:\r\n\r\n     No button pressed                = 0000    No change\r\n     Manual Button Pressed       = 0010    Manual Operator Control Request\r\n     Automatic Button Pressed  = 0011    Automatic Operator Control Request\r\n     Invalid Switch Input(ex. auto and manual read/pressed simultaneously)  = 1110    Error Indicator\r\n\r\n3.  The momentary contact button pair may be used, where the default is no buttons being pressed.  The user can press the manual button, and when pressure is released, it will return to the no button pressed position.  The user may press the auto button, and when pressure is released, it will return to the no button pressed position.\r\n\r\nMomentary contact buttons (button pair) usage is as follows:\r\n\r\n     No button pressed                = 0000    No change\r\n     Manual Button Pressed       = 0010    Manual Operator Control Request\r\n     Automatic Button Pressed  = 0011    Automatic Operator Control Request\r\n     Invalid Switch Input(ex. auto and manual read/pressed simultaneously)  = 1110    Error Indicator\r\n\r\n4.  The momentary contact single button may be used, where the default is no button being pressed.  The user can press the button, which is the button pressed position, and when pressure is released, it will return to the no button pressed position.  The controller receiving this command will keep track of what mode the blade is in, auto or manual.  If the blade is in manual mode to begin with, one press of the button will change to mode to auto.  If the button is pressed again, the blade will be put into manual mode.\r\n\r\nMomentary contact button (single button) usage is as follows:\r\n\r\n    No button pressed                = 0000    No change\r\n    Mode Button Pressed          = 0001    Momentary Operator Control Request\r\n\r\n\r\nData Values and Descriptions:\r\n\r\n0000    No Change\r\n0001    Momentary Operator Control Request\r\n0010    Manual Operator Control Request\r\n0011    Automatic Operator Control Request\r\n1100 - 1101   Reserved\r\n1110    Error Indicator\r\n1111    Not Installed\r\n\r\nNotes:\r\n1.  The operator control state can be read in two ways.  One method uses the direct operator control input to determine the operator control state, while the second method relies on a secondary control to read the operator control input, then relay the information on the data link.  The parameter is designed to provide the actual operator control state to other controls that need the information.\r\n2.  Other systems with automated blade controls should be able to use this parameter, since it is an actual operator control value.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3335": {
      "PGN": 61453,
      "PGN_Name": "Land Leveling System Operational Information",
      "PGN_Description": "LOI",
      "first_bit": 16,
      "SPN": 3335,
      "SPN_Name": "Right Blade Control Mode Operator Control",
      "SPN_Description": "This parameter indicates the right blade control mode operator control state the user has set for the land leveling system.  The operator control value directly relates to the current operator control state correlating to the left edge of the blade.  The purpose of this parameter is to set the control mode (auto/manual) for the left side of the blade. For this system, the left and right side of the blade can be adjusted independently of each other to either change the elevation from a given reference point or the blade angle (also known as blade tilt)/cross slope depending on the function requested by the operator.\r\n\r\nThis parameter is intended for use in systems using two parameters(right/left) to control the blade as described above.  Systems using only one parameter to control blade position, i.e. elevation, should use the Blade Control Mode Switch parameter. Only one of the following states will be active at a time.   In the example below, data values are defined for each switch type that may be used in an application.  The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\r\n\r\n1.  A toggle button with two states can be used, in which the button is either in the manual or the auto position at all times.  \r\n\r\nToggle button usage is as follows:\r\n     Manual Button Pressed       = 0010    Manual Operator Control Request\r\n     Automatic Button Pressed  = 0011    Automatic Operator Control Request\r\n     Invalid Switch Input(ex. auto and manual read/pressed simultaneously)  = 1110    Error Indicator\r\n\r\n2. The momentary rocker switch may be used, where the default is the no button pressed position.  The user can press the rocker into the manual position, and when pressure is released, it will return to the no button pressed position.  The user may also press the rocker into the auto position, and when pressure is released, it will return to the no button pressed position.\r\n\r\nMomentary rocker button usage is as follows:\r\n     No button pressed                = 0000    No change\r\n     Manual Button Pressed       = 0010    Manual Operator Control Request\r\n     Automatic Button Pressed  = 0011    Automatic Operator Control Request\r\n     Invalid Switch Input(ex. auto and manual read/pressed simultaneously)  = 1110    Error Indicator\r\n\r\n3.  The momentary contact button pair may be used, where the default is no buttons being pressed.  The user can press the manual button, and when pressure is released, it will return to the no button pressed position.  The user may press the auto button, and when pressure is released, it will return to the no button pressed position.\r\n\r\nMomentary contact buttons (button pair) usage is as follows:\r\n     No button pressed                = 0000    No change\r\n     Manual Button Pressed       = 0010    Manual Operator Control Request\r\n     Automatic Button Pressed  = 0011    Automatic Operator Control Request\r\n     Invalid Switch Input(ex. auto and manual read/pressed simultaneously)  = 1110    Error Indicator\r\n\r\n4.  The momentary contact single button may be used, where the default is no button being pressed.  The user can press the button, which is the button pressed position, and when pressure is released, it will return to the no button pressed position.  The controller receiving this command will keep track of what mode the blade is in, auto or manual.  If the blade is in manual mode to begin with, one press of the button will change to mode to auto.  If the button is pressed again, the blade will be put into manual mode.\r\n\r\nMomentary contact button (single button) usage is as follows:\r\n    No button pressed                = 0000    No change\r\n    Mode Button Pressed          = 0001    Momentary Operator Control Request\r\n\r\nData Values and Descriptions:\r\n0000    No Change\r\n0001    Momentary Operator Control Request\r\n0010    Manual Operator Control Request\r\n0011    Automatic Operator Control Request\r\n1110    Error Indicator\r\n1111    Not Installed\r\nAll other values reserved",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3336": {
      "PGN": 61453,
      "PGN_Name": "Land Leveling System Operational Information",
      "PGN_Description": "LOI",
      "first_bit": 20,
      "SPN": 3336,
      "SPN_Name": "Left Desired Blade Offset Operator Control",
      "SPN_Description": "This parameter indicates the left blade offset operator control state the user has set for the land leveling system.  The left desired blade offset value is the offset measured from a given reference point to the bottom left edge of the blade. This parameter will only be used when the control mode for land leveling system has been set to auto. The purpose of this parameter is to adjust the elevation from a given reference point or the blade angle(also known as blade tilt)/cross slope depending on the function being requested by the operator for the left side of the blade.\r\n\r\nThis parameter is intended for use in systems using two parameters(left/right) to control the blade as described above.  Systems using only one parameter to control blade position, i.e. elevation, should use the Desired Blade Offset Switch parameter. Only one of the following states will be active at a time.\r\n\r\nIn the example below, data values are defined for each switch type that may be used in an application.  The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\r\n\r\n1. The momentary rocker switch may be used, where the default is the neutral position with no buttons pressed.  The user can press the rocker into the increment button pressed position, and when pressure is released, it will return to the neutral position.  The user may also press the rocker into the decrement button pressed position, and when pressure is released, it will return to the neutral position.  Momentary rocker button usage is as follows:\r\n\r\n     Neutral position = 0000  No Operator Control Request\r\n     Increment Button Pressed  = 0001   Increment Operator Control Request\r\n     Decrement Button Pressed  = 0010   Decrement Operator Control Request\r\n     Invalid Switch Input(ex. inc./dec. values read simultaneously)  = 1110    Error Indicator\r\n\r\n2. The momentary contact button pair may be used, where the default is the neutral position with no buttons pressed.  The user can press the increment button, and when pressure is released, it will return to the neutral position.  The user may press the decrement button, and when pressure is released, it will return to the neutral position.  Momentary contact button (button pair) usage is as follows:\r\n\r\n      No Button Pressed = 0000 No Operator Control Request\r\n      Increment Button Pressed  = 0001 Increment Operator Control Request\r\n      Decrement Button Pressed  = 0010 Decrement Operator Control Request\r\n      Invalid Switch Input(ex. inc./dec. values read simultaneously)  = 1110 Error Indicator\r\n\r\nData Values and Descriptions:\r\n0000 No Operator Control Request\r\n0001 Increment Operator Control Request\r\n0010 Decrement Operator Control Request\r\n0011 - 1101  Reserved\r\n1110 Error Indicator\r\n1111 Not installed\r\n\r\nNotes:  \r\n\r\n1.  The operator control state can be read in two ways.  One method uses the direct operator control input to determine the operator control state, while the second method relies on a secondary control to read the operator control input, then relay the information on the data link.  The parameter is designed to provide the actual operator control state to other controls that need the information.\r\n2.  Other systems with automated blade controls should be able to use this parameter, since it is an actual operator control value.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3337": {
      "PGN": 61453,
      "PGN_Name": "Land Leveling System Operational Information",
      "PGN_Description": "LOI",
      "first_bit": 24,
      "SPN": 3337,
      "SPN_Name": "Right Desired Blade Offset Operator Control",
      "SPN_Description": "This parameter indicates the right blade offset operator control state the user has set for the land leveling system.  The right desired blade offset value is the offset measured from a given reference point to the bottom right edge of the blade. This parameter will only be used when the control mode for land leveling system has been set to auto. The purpose of this parameter is to adjust the elevation from a given reference point or the blade angle(also known as blade tilt)/cross slope depending on the function being requested by the operator for the left side of the blade.\r\n\r\nThis parameter is intended for use in systems using two parameters(left/right) to control the blade as described above.  Systems using only one parameter to control blade position, i.e. elevation, should use the Desired Blade Offset Switch parameter. Only one of the following states will be active at a time.\r\n\r\nIn the example below, data values are defined for each switch type that may be used in an application.  The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\r\n\r\n1. The momentary rocker switch may be used, where the default is the neutral position with no buttons pressed.  The user can press the rocker into the increment button pressed position, and when pressure is released, it will return to the neutral position.  The user may also press the rocker into the decrement button pressed position, and when pressure is released, it will return to the neutral position.  Momentary rocker button usage is as follows:\r\n\r\n     Neutral position = 0000  No Operator Control Request\r\n     Increment Button Pressed  = 0001   Increment Operator Control Request\r\n     Decrement Button Pressed  = 0010   Decrement Operator Control Request\r\n     Invalid Switch Input(ex. inc./dec. values read simultaneously)  = 1110    Error Indicator\r\n\r\n2. The momentary contact button pair may be used, where the default is the neutral position with no buttons pressed.  The user can press the increment button, and when pressure is released, it will return to the neutral position.  The user may press the decrement button, and when pressure is released, it will return to the neutral position.  Momentary contact button (button pair) usage is as follows:\r\n\r\n      No Button Pressed = 0000 No Operator Control Request\r\n      Increment Button Pressed  = 0001 Increment Operator Control Request\r\n      Decrement Button Pressed  = 0010 Decrement Operator Control Request\r\n      Invalid Switch Input(ex. inc./dec. values read simultaneously)  = 1110 Error Indicator\r\n\r\nData Values and Descriptions:\r\n0000 No Operator Control Request\r\n0001 Increment Operator Control Request\r\n0010 Decrement Operator Control Request\r\n0011 - 1101  Reserved\r\n1110 Error Indicator\r\n1111 Not installed\r\n\r\nNotes:  \r\n\r\n1.  The operator control state can be read in two ways.  One method uses the direct operator control input to determine the operator control state, while the second method relies on a secondary control to read the operator control input, then relay the information on the data link.  The parameter is designed to provide the actual operator control state to other controls that need the information.\r\n2.  Other systems with automated blade controls should be able to use this parameter, since it is an actual operator control value.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3338": {
      "PGN": 61453,
      "PGN_Name": "Land Leveling System Operational Information",
      "PGN_Description": "LOI",
      "first_bit": 28,
      "SPN": 3338,
      "SPN_Name": "Side-shift Blade Control Mode Operator Control",
      "SPN_Description": "This parameter indicates the side-shift offset operator control state the user has set for the land leveling system. When an implement moves in a side-shift direction, it moves from side to side, usually along its longitudinal axis. The desired side-shift offset value is the offset measured from a given vertical reference point to the center of the blade.\r\n\r\nOnly one of the following states will be active at a time. In the example below, the data values are defined for each switch type that may be used in an application. The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\r\n\r\n1. The momentary rocker switch may be used, where the default is the neutral position with no buttons pressed. The user can press the rocker into the increment button pressed position, and when pressure is released, it will return to the neutral position. The user may also press the rocker into the decrement button pressed position, and when pressure is released, it will return to the neutral position.  Momentary rocker button usage is as follows:\r\n\r\n - Neutral position = 0000   No Operator Control Request\r\n - Increment Button Pressed = 0001 Increment Operator Control Request\r\n - Decrement Button Pressed = 0010 Decrement Operator Control Request\r\n\r\n2. The momentary contact button pair may be used, where the default is the neutral position with no buttons pressed. The user can press the increment button, and when pressure is released, it will return to the neutral position. The user may press the decrement button, and when pressure is released, it will return to the neutral position. Momentary contact button (button pair) usage is as follows:\r\n\r\n - No Button Pressed = 0000 No Operator Control Request\r\n - Increment Button Pressed = 0001 Increment Operator Control Request\r\n - Decrement Button Pressed = 0010 Decrement Operator Control Request\r\n\r\nData Values and Descriptions:\r\n\r\n0000 No Operator Control Request\r\n0001 Increment Operator Control Request\r\n0010 Decrement Operator Control Request\r\n0011-1101 Reserved\r\n1110 Error Indicator\r\n1111 Not installed",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3339": {
      "PGN": 61453,
      "PGN_Name": "Land Leveling System Operational Information",
      "PGN_Description": "LOI",
      "first_bit": 32,
      "SPN": 3339,
      "SPN_Name": "Side-shift Desired Blade Offset Operator Control",
      "SPN_Description": "This parameter indicates the side-shift blade control mode operator control state the user has set for the land leveling system.  When an implement moves in a side-shift direction, it moves from side to side, usually along its longitudinal axis.\r\n\r\nThe operator control value directly correlates to the current operator control state.  Only one of the following states will be active at a time.  In the example below, the data values are defined for each switch type that may be used in an application.  The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\r\n\r\n1.  A toggle button with two states can be used, in which the button is either in the manual or the auto position at all times.  Toggle button usage is as follows:\r\n     Manual Position  = 0010 Manual Operator Control Request\r\n     Auto Position  = 0011 Automatic Operator Control Request\r\n\r\n2.  The momentary rocker switch may be used, where the default is the no button pressed position.  The user can press the rocker into the manual position, and when pressure is released, it will return to the no button pressed position.  The user may also press the rocker into the auto position, and when pressure is released, it will return to the no button pressed position.  Momentary rocker button usage is as follows:\r\n     No Button Pressed = 0000 No Operator Control Request\r\n     Manual Button Pressed  = 0010 Manual Operator Control Request\r\n     Auto Button Pressed  = 0011 Automatic Operator Control Request\r\n\r\n3.  The momentary contact button pair may be used, where the default is no buttons being pressed.  The user can press the manual button, and when pressure is released, it will return to the no button pressed position.  The user may press the auto button, and when pressure is released, it will return to the no button pressed position.  Momentary contact buttons (button pair) usage is as follows:\r\n     No Button Pressed = 0000 No Operator Control Request\r\n     Manual Button Pressed  = 0010 Manual Operator Control Request\r\n     Auto Button Pressed  = 0011 Automatic Operator Control Request\r\n\r\n4.  The momentary contact single button may be used, where the default is no button being pressed.  The user can press the button, which is the button pressed position, and when pressure is released, it will return to the no button pressed position.  The controller receiving this command will keep track of what mode the blade is in, auto or manual.  If the blade is in manual mode to begin with, one press of the button will change to mode to auto.  If the button is pressed again, the blade will be put into manual mode.  Momentary contact button (single button) usage is as follows:\r\n     No Button Pressed = 0000 No Operator Control Request\r\n     Button Pressed  = 0001 Momentary Operator Control Request\r\n\r\nData Values and Descriptions:\r\n0000 No Operator Control Request\r\n0001 Momentary Operator Control Request\r\n0010 Manual Operator Control Request\r\n0011 Automatic Operator Control Request\r\n0100 - 1101   Reserved\r\n1110 Error Indicator\r\n1111 Not Installed",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3340": {
      "PGN": 64938,
      "PGN_Name": "Engine Fluid Level/Pressure 4",
      "PGN_Description": "EFL/P4",
      "first_bit": 0,
      "SPN": 3340,
      "SPN_Name": "Engine Charge Air Cooler 1 Intake Pressure",
      "SPN_Description": "Pressure of air at intake to 1st or only charge air cooler, from multiple first stage turbochargers being cooled and feeding multiple second stage turbochargers.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "3341": {
      "PGN": 64938,
      "PGN_Name": "Engine Fluid Level/Pressure 4",
      "PGN_Description": "EFL/P4",
      "first_bit": 8,
      "SPN": 3341,
      "SPN_Name": "Engine Charge Air Cooler 2 Intake Pressure",
      "SPN_Description": "Pressure of air at intake to 2nd charge air cooler, from multiple first stage turbochargers being cooled and feeding multiple second stage turbochargers.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "3342": {
      "PGN": 64938,
      "PGN_Name": "Engine Fluid Level/Pressure 4",
      "PGN_Description": "EFL/P4",
      "first_bit": 16,
      "SPN": 3342,
      "SPN_Name": "Engine Coolant Pump Differential Pressure",
      "SPN_Description": "The differential pressure measured across the input and output of the engine coolant pump.",
      "bit_length": 8,
      "scaling": 1.64,
      "offset": -7,
      "unit": "kPa",
      "SLOT_ID": 246
    },
    "3343": {
      "PGN": 64938,
      "PGN_Name": "Engine Fluid Level/Pressure 4",
      "PGN_Description": "EFL/P4",
      "first_bit": 24,
      "SPN": 3343,
      "SPN_Name": "Engine Centrifugal Oil Filter speed",
      "SPN_Description": "The speed of a rotating (centrifugal) engine oil filter.",
      "bit_length": 16,
      "scaling": 4,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 77
    },
    "3344": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 272,
      "SPN": 3344,
      "SPN_Name": "Support Variable Rate TSC1 Message",
      "SPN_Description": "This parameter indicates which TSC1 transmission rates are supported by the engine ECU in addition to the required 10ms transmission rate for temporary powertrain control purposes. \r\n\r\nBit Position      Transmission Rate\r\n1                      1000 ms transmission rate    \r\n2                        750 ms transmission rate\r\n3                        500 ms transmission rate\r\n4                        250 ms transmission rate\r\n5                        100 ms transmission rate\r\n6                          50 ms transmission rate\r\n7                          20 ms transmission rate\r\n8                         Reserved for SAE assignment (set to one)\r\n\r\nWhere 0 = Transmission Rate Supported by Engine and 1 = Transmission Rate Not supported by Engine\r\n\r\nNote:  FF for this byte implies that the engine only supports standard temporary power train control (e.g. 10 ms)",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3345": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 280,
      "SPN": 3345,
      "SPN_Name": "Support TSC1 Control Purpose Group 1",
      "SPN_Description": "This parameter indicates which TSC1 control purposes are supported in group 1 of 4. One bit is used to convey the support of each Control Purpose. A value of 0 equals supported and a value of 1 equals not supported. This bit logic is used to allow the default to FF to be backward compatible.\r\n\r\nThis group of 4 parameters (SPNs 3345, 3346, 3347, and 3348) indicates which TSC1 Control Purposes are supported by the engine ECU in addition to the Temporary Powertrain Control Purpose (which is denoted as control purpose P32). All ones in the Group 1 through 4 parameters indicates the engine only supports Temporary Powertrain Control.\r\n\r\n\r\nGroup 1 of 4\r\nBit Position    Control Purpose Value      Control Purpose Description\r\n       1                             P1                          Accelerator Pedal/Operator Selection\r\n       2                             P2                          Cruise Control\r\n       3                             P3                          PTO Governor\r\n       4                             P4                          Road Speed Governor\r\n       5                             P5                          Engine protection\r\n       6                             P6                          Reserved for assignment by SAE\r\n       7                             P7                          Reserved for assignment by SAE\r\n       8                             P8                          Reserved for assignment by SAE\r\n  \r\n\r\nWhere 0 = Control Purpose is supported and 1 = Control Purpose is not supported",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3346": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 288,
      "SPN": 3346,
      "SPN_Name": "Support TSC1 Control Purpose Group 2",
      "SPN_Description": "This parameter indicates which TSC1 control purposes are supported in group 2 of 4. One bit is used to convey the support of each Control Purpose. A value of 0 equals supported and a value of 1 equals not supported. This bit logic is used to allow the default to FF to be backward compatible.\r\n\r\nThis group of 4 parameters (SPNs 3345, 3346, 3347, and 3348) indicates which TSC1 Control Purposes are supported by the engine ECU in addition to the Temporary Powertrain Control Purpose (which is denoted as control purpose P32). All ones in the Group 1 through 4 parameters indicates the engine only supports Temporary Powertrain Control.\r\n\r\n\r\nGroup 2 of 4\r\nBit Position    Control Purpose Value      Control Purpose Description\r\n       1                             P9                          Reserved for assignment by SAE\r\n       2                             P10                          Reserved for assignment by SAE\r\n       3                             P11                        Reserved for assignment by SAE\r\n       4                             P12                        Reserved for assignment by SAE\r\n       5                             P13                        Reserved for assignment by SAE\r\n       6                             P14                        Reserved for assignment by SAE\r\n       7                             P15                        Reserved for assignment by SAE\r\n       8                             P16                        Reserved for assignment by SAE\r\n  \r\n\r\nWhere 0 = Control Purpose is supported and 1 = Control Purpose is not supported",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3347": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 296,
      "SPN": 3347,
      "SPN_Name": "Support TSC1 Control Purpose Group 3",
      "SPN_Description": "This parameter indicates which TSC1 control purposes are supported in group 3 of 4. One bit is used to convey the support of each Control Purpose. A value of 0 equals supported and a value of 1 equals not supported. This bit logic is used to allow the default to FF to be backward compatible.\r\n\r\nThis group of 4 parameters (SPNs 3345, 3346, 3347, and 3348) indicates which TSC1 Control Purposes are supported by the engine ECU in addition to the Temporary Powertrain Control Purpose (which is denoted as control purpose P32). All ones in the Group 1 through 4 parameters indicates the engine only supports Temporary Powertrain Control.\r\n\r\nGroup 3 of 4\r\nBit Position    Control Purpose Value      Control Purpose Description\r\n       1                             P17                        Reserved for assignment by SAE\r\n       2                             P18                        Reserved for assignment by SAE\r\n       3                             P19                        Reserved for assignment by SAE\r\n       4                             P20                        Reserved for assignment by SAE\r\n       5                             P21                        Reserved for assignment by SAE\r\n       6                             P22                        Reserved for assignment by SAE\r\n       7                             P23                        Reserved for assignment by SAE\r\n       8                             P24                        Reserved for assignment by SAE\r\n  \r\n\r\nWhere 0 = Control Purpose is supported and 1 = Control Purpose is not supported",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3348": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 304,
      "SPN": 3348,
      "SPN_Name": "Support TSC1 Control Purpose Group 4",
      "SPN_Description": "This parameter indicates which TSC1 control purposes are supported in group 4 of 4. One bit is used to convey the support of each Control Purpose. A value of 0 equals supported and a value of 1 equals not supported. This bit logic is used to allow the default to FF to be backward compatible.\r\n\r\nThis group of 4 parameters (SPNs 3345, 3346, 3347, and 3348) indicates which TSC1 Control Purposes are supported by the engine ECU in addition to the Temporary Powertrain Control Purpose (which is denoted as control purpose P32). All ones in the Group 1 through 4 parameters indicates the engine only supports Temporary Powertrain Control.\r\n\r\nGroup 4 of 4\r\nBit Position    Control Purpose Value      Control Purpose Description\r\n       1                             P25                        Reserved for assignment by SAE\r\n       2                             P26                        Reserved for assignment by SAE\r\n       3                             P27                        Reserved for assignment by SAE\r\n       4                             P28                        Reserved for assignment by SAE\r\n       5                             P29                        Reserved for assignment by SAE\r\n       6                             P30                        Reserved for assignment by SAE\r\n       7                             P31                        Reserved for assignment by SAE\r\n       8                             See Note               Not assignable, must always be set to 1.       \r\n\r\nWhere 0 = Control Purpose is supported and 1 = Control Purpose is not supported\r\n\r\nNOTE: P32 is always supported and is Temporary Power Train Control (the original use of the TSC1 Command).\r\nThe engine configuration will not indicate separate support of Temporary Power Train Control mode.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3349": {
      "PGN": 0,
      "PGN_Name": "Torque/Speed Control 1",
      "PGN_Description": "TSC1",
      "first_bit": 32,
      "SPN": 3349,
      "SPN_Name": "TSC1 Transmission Rate",
      "SPN_Description": "This parameter indicates the transmission rate at which the sending device will transmit the TSC1 message.  The engine shall adjust its timeout for TSC1 messages accordingly. Variable TSC1 transmission rates shall only apply to messages sent to the engine.  \r\n\r\nA value of all ones is to be used in TSC1 messages directed to retarders because the TSC1 Transmission Rate parameter is not applicable for retarders. All TSC1 messages sent to the retarder shall use the standard 50 ms rate.\r\n\r\nDevices sending TSC1 messages to the engine should only invoke alternative transmission rates which the engine has indicated it supports in SPN 3344 – Support Variable Rate TSC1 Message.\r\n\r\n000 = 1000 ms transmission rate\r\n001 =   750 ms transmission rate\r\n010 =   500 ms transmission rate\r\n011 =   250 ms transmission rate\r\n100 =   100 ms transmission rate\r\n101 =     50 ms transmission rate\r\n110 =     20 ms transmission rate\r\n111 =   Use standard TSC1 transmission rates of 10 ms to engine\r\n\r\nNote:  Sending devices shall not send variable rate TSC1 messages to the engine for unsupported control purposes.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3350": {
      "PGN": 0,
      "PGN_Name": "Torque/Speed Control 1",
      "PGN_Description": "TSC1",
      "first_bit": 35,
      "SPN": 3350,
      "SPN_Name": "TSC1 Control Purpose",
      "SPN_Description": "State signal which indicates which control mode the sending device is using to generate the TSC1 command.  Note that the modes are not in prioritized order. Not all modes may be relevant for a given device. Some devices may not implement all functions. For typical priorities refer to Figures SPN512_A, SPN512_B for engine control and Figure SPN695_A.  The TSC1 control purpose shall only apply to messages sent to the engine.  \r\n\r\nA value of all ones is to be used in TSC1 messages directed to retarders because the TSC1 Control Purpose parameter is not applicable for retarders.\r\n\r\n00000 =   P1 = Accelerator Pedal/Operator Selection\r\n00001 =   P2 = Cruise Control\r\n00010 =   P3 = PTO Governor\r\n00011 =   P4 = Road Speed Governor\r\n00100 =   P5 = Engine Protection\r\n00101 - 11110 =   P6-P31 = Reserved for SAE Assignment \r\n11111 = P32 = Temporary Power Train Control (Original use of TSC1 Command) \r\n\r\nNote:  Sending devices shall not send variable rate TSC1 messages to the engine for unsupported control purposes.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 90
    },
    "3353": {
      "PGN": 65237,
      "PGN_Name": "Alternator Information",
      "PGN_Description": "AS",
      "first_bit": 16,
      "SPN": 3353,
      "SPN_Name": "Alternator 1 Status",
      "SPN_Description": "Alternator 1 operating status.\r\n\r\n00 Alternator 1 not charging\r\n01 Alternator 1 charging\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3354": {
      "PGN": 65237,
      "PGN_Name": "Alternator Information",
      "PGN_Description": "AS",
      "first_bit": 18,
      "SPN": 3354,
      "SPN_Name": "Alternator 2 Status",
      "SPN_Description": "Alternator 2 operating status.\r\n\r\n00 Alternator 2 not charging\r\n01 Alternator 2 charging\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3355": {
      "PGN": 65237,
      "PGN_Name": "Alternator Information",
      "PGN_Description": "AS",
      "first_bit": 20,
      "SPN": 3355,
      "SPN_Name": "Alternator 3 Status",
      "SPN_Description": "Alternator 3 operating status.\r\n\r\n00 Alternator 3 not charging\r\n01 Alternator 3 charging\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3356": {
      "PGN": 65237,
      "PGN_Name": "Alternator Information",
      "PGN_Description": "AS",
      "first_bit": 22,
      "SPN": 3356,
      "SPN_Name": "Alternator 4 Status",
      "SPN_Description": "Alternator 4 operating status.\r\n\r\n00 Alternator 4 not charging\r\n01 Alternator 4 charging\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3357": {
      "PGN": 61443,
      "PGN_Name": "Electronic Engine Controller 2",
      "PGN_Description": "EEC2",
      "first_bit": 48,
      "SPN": 3357,
      "SPN_Name": "Actual Maximum Available Engine - Percent Torque",
      "SPN_Description": "This is the maximum amount of torque that the engine can immediately deliver as a percentage of the reference engine torque (SPN 544).  The Actual Maximum Available Engine - Percent Torque shall take into consideration all engine torque derates (e.g. air fuel ratio control (AFC), noise control, etc.) that could potentially be active in the system.  This parameter differentiates itself from the engine percent torque points 1 through 5 of the engine configuration map because it takes into account all dynamic internal inputs such as  AFC and that it is updated on a 50ms basis.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "3358": {
      "PGN": 64961,
      "PGN_Name": "Engine Fluid Level/Pressure 3",
      "PGN_Description": "EFL/P3",
      "first_bit": 16,
      "SPN": 3358,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Intake Pressure",
      "SPN_Description": "EGR intake gage pressure is measured after the EGR cooler and before the EGR valve.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "3359": {
      "PGN": 64917,
      "PGN_Name": "Transmission Fluids 2",
      "PGN_Description": "TRF2",
      "first_bit": 0,
      "SPN": 3359,
      "SPN_Name": "Transmission Oil Filter Restriction Switch",
      "SPN_Description": "This switch indicates whether the transmission oil filter is clogged.\r\n\r\n00 - No restriction\r\n01 - Restriction exists on oil filter\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3363": {
      "PGN": 65110,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "AT1T1I1",
      "first_bit": 48,
      "SPN": 3363,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank Heater",
      "SPN_Description": "Percentage of heating applied to the aftertreatment 1 diesel exhaust fluid tank heater.  A value of 0% means no heating applied, a value of 100% means full heating applied.  The diesel exhaust fluid tank heater warms the diesel exhaust fluid in the diesel exhaust fluid tank.  See SPN 5137 for the command for this tank heater.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "3365": {
      "PGN": 61460,
      "PGN_Name": "Blade Information",
      "PGN_Description": "BI",
      "first_bit": 0,
      "SPN": 3365,
      "SPN_Name": "Relative Blade Height",
      "SPN_Description": "The measured vertical distance from a fixed location on the machine blade to a ground-based reference (i.e. relative height).  Examples of a ground based reference include a curb, a stringline or the ground itself.  The measurement may be positive or negative based on the initial reference used.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3200,
      "unit": "mm",
      "SLOT_ID": 13
    },
    "3366": {
      "PGN": 61460,
      "PGN_Name": "Blade Information",
      "PGN_Description": "BI",
      "first_bit": 32,
      "SPN": 3366,
      "SPN_Name": "Relative Blade Height and Blade Rotation Angle Measurement Latency",
      "SPN_Description": "The estimated measurement latency of the measurement.\r\n\r\nNOTE: This is only the sensor latency and does not include any additional latencies that might exist because of the CAN Bus or overall system implementation.\r\n\r\nFor example, if the technique used is a sonic pulse/echo system, the round trip time divided by two will be a reasonably accurate estimate of the measurement latency if the processing time is small with respect to the propagation time.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 241
    },
    "3367": {
      "PGN": 61460,
      "PGN_Name": "Blade Information",
      "PGN_Description": "BI",
      "first_bit": 40,
      "SPN": 3367,
      "SPN_Name": "Relative Blade Height Figure of Merit",
      "SPN_Description": "Figure of merit for blade height measurement.\r\n\r\nBits\r\n00  Relative Blade Height fully functional.  Data is within sensor specification.   \r\n01  Relative Blade Height degraded.  Data is suspect due to environmental conditions.\r\n10  Relative Blade Height failed.  \r\n11  Relative Blade Height not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3368": {
      "PGN": 64937,
      "PGN_Name": "Wireless Communications Message 1",
      "PGN_Description": "WCM1",
      "first_bit": 0,
      "SPN": 3368,
      "SPN_Name": "Network Transceiver Status 1",
      "SPN_Description": "Indicates the status of the transceiver for the wireless communications network type\r\n\r\n0 = Off\r\n1 = On\r\n2 = Not Authorized to Operate on Network\r\n3-250 = Reserved for Future Assignment\r\n251-253 = Reserved\r\n254 = Error\r\n255 = Not Available",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3369": {
      "PGN": 64937,
      "PGN_Name": "Wireless Communications Message 1",
      "PGN_Description": "WCM1",
      "first_bit": 8,
      "SPN": 3369,
      "SPN_Name": "Network Service Status 1",
      "SPN_Description": "Indicates the status of the Service for the wireless communications network type\r\n\r\n0 = Local Service\r\n1 = Roaming Service\r\n2 = Service not available\r\n3 = Not Authorized to Operate on Service\r\n4-250 = Reserved for Future Assignment\r\n251-253 = Reserved\r\n254 = Error\r\n255 = Not Available",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3370": {
      "PGN": 64937,
      "PGN_Name": "Wireless Communications Message 1",
      "PGN_Description": "WCM1",
      "first_bit": 16,
      "SPN": 3370,
      "SPN_Name": "Network Antenna Status 1",
      "SPN_Description": "Indicates the status of the antenna for the wireless communications network type\r\n\r\n0 = Off\r\n1 = On\r\n2-250 = Reserved for Future Assignment\r\n251-253 = Reserved\r\n254 = Error\r\n255 = Not Available",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3371": {
      "PGN": 64937,
      "PGN_Name": "Wireless Communications Message 1",
      "PGN_Description": "WCM1",
      "first_bit": 24,
      "SPN": 3371,
      "SPN_Name": "Network Signal Strength 1",
      "SPN_Description": "Indicates the signal strength for the wireless communications network type.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "3372": {
      "PGN": 64937,
      "PGN_Name": "Wireless Communications Message 1",
      "PGN_Description": "WCM1",
      "first_bit": 32,
      "SPN": 3372,
      "SPN_Name": "Wireless Communication Network Type 1",
      "SPN_Description": "Type of Wireless Communication Network\r\n\r\n0 = Cellular network #1\r\n1 = Cellular network #2\r\n2 = Wireless LAN #1\r\n3 = Wireless LAN #2\r\n4 = Satellite network\r\n5-250 = Reserved for Future Assignment\r\n251-253 = Reserved\r\n254 = Error\r\n255 = Not Available",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3375": {
      "PGN": 64935,
      "PGN_Name": "Voltage Regulator Operating Mode",
      "PGN_Description": "VROM",
      "first_bit": 0,
      "SPN": 3375,
      "SPN_Name": "Voltage Regulator Load Compensation Mode",
      "SPN_Description": "State signal indicating the voltage regulator load compensation mode.  Load compensation is when the voltage is adjusted based on the magnitude of load current\r\n\r\n000 - load compensation disabled\r\n001 - Voltage droop compensation enabled\r\n010 - IR line drop compensation enabled\r\n011 - Reserved\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Reserved\r\n111 - Not available\r\n\r\nNotes:\r\n\r\nVoltage droop compensation is used to minimize the amount of reactive current that flows between generators when they are parallelled together.  Excessive reactive current will result in the eventual failure of the generator exciter.\r\n\r\nIR line compensation increases the generator output voltage as the load increases so the voltage measured at the load will remain constant.  Without IR compensation, the voltage measured at the load drops due the IR losses in the power line.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3376": {
      "PGN": 64935,
      "PGN_Name": "Voltage Regulator Operating Mode",
      "PGN_Description": "VROM",
      "first_bit": 3,
      "SPN": 3376,
      "SPN_Name": "Voltage Regulator VAr/Power Factor operating mode",
      "SPN_Description": "State signal indicating the operating mode for the Voltage regulator VAr/Power Factor \r\n\r\n000 - VAr/Power Factor regulation disabled\r\n001 - Power factor regulation enabled\r\n010 - VAr regulation enabled\r\n011 - Reserved\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Reserved\r\n111 - Not available\r\n\r\nNote:\r\n\r\nThis parameter sets the mode of regulation for the voltage regulator.  The voltage regulator can regulate the generator AC output voltage by using the generator AC output voltage, the generator power factor, or the generator reactive power (VAr).  The generator AC output voltage, the generator power factor, and the generator reactive power (VAr) are defined in SAE J1939 - 75",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3377": {
      "PGN": 64935,
      "PGN_Name": "Voltage Regulator Operating Mode",
      "PGN_Description": "VROM",
      "first_bit": 6,
      "SPN": 3377,
      "SPN_Name": "Voltage Regulator Underfrequency Compensation enabled",
      "SPN_Description": "State signal indicating the operating mode for underfrequency compensation.\r\n\r\n00 - Underfrequency compensation disabled\r\n01 - Underfrequency compensation enabled\r\n10 - Reserved\r\n11 - Not available\r\n\r\nNote:\r\n\r\nUnderfrequency compensation is when the generator voltage is adjusted based on the generator frequency.  Typically generator voltage decreases as frequency decreases.  A frequency decrease occurs when load is increased on the genset.  Underfrequency compensation decreases the load by reducing the voltage as frequency decreases until a point is reached where the engine can accept more load.  Load is applied to the engine when the voltage increases with frequency.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3378": {
      "PGN": 64935,
      "PGN_Name": "Voltage Regulator Operating Mode",
      "PGN_Description": "VROM",
      "first_bit": 8,
      "SPN": 3378,
      "SPN_Name": "Voltage Regulator Soft Start State",
      "SPN_Description": "State signal indicating the mode of the Voltage regulator soft start function.  Soft start controls the generator voltage overshoot by controlling the rate of rise of the generator output voltage at generator start up.\r\n\r\n00 - Soft start is inactive\r\n01 - Soft start is active\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3379": {
      "PGN": 64935,
      "PGN_Name": "Voltage Regulator Operating Mode",
      "PGN_Description": "VROM",
      "first_bit": 10,
      "SPN": 3379,
      "SPN_Name": "Voltage Regulator Enabled",
      "SPN_Description": "State signal indicating the Voltage Regulator is enabled.  This parameter indicates whether the regulator is regulating or not regulating generator output voltage.\r\n\r\n00 - Not regulating voltage - unit disabled\r\n01 - Regulating voltage\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3380": {
      "PGN": 64934,
      "PGN_Name": "Voltage Regulator Excitation Status",
      "PGN_Description": "VREP",
      "first_bit": 0,
      "SPN": 3380,
      "SPN_Name": "Generator Excitation Field Voltage",
      "SPN_Description": "Measured signal that represents the generator excitation field voltage.  Generator excitation field voltage is indicative of the amount of excitation current being supplied by the voltage regulator to the generator field.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -1606,
      "unit": "V",
      "SLOT_ID": 249
    },
    "3381": {
      "PGN": 64934,
      "PGN_Name": "Voltage Regulator Excitation Status",
      "PGN_Description": "VREP",
      "first_bit": 16,
      "SPN": 3381,
      "SPN_Name": "Generator Excitation Field Current",
      "SPN_Description": "Measured signal that represents the generator excitation field current.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 250
    },
    "3382": {
      "PGN": 64934,
      "PGN_Name": "Voltage Regulator Excitation Status",
      "PGN_Description": "VREP",
      "first_bit": 32,
      "SPN": 3382,
      "SPN_Name": "Generator Output Voltage Bias Percentage",
      "SPN_Description": "Measured signal that represents the voltage bias percentage of the generator ouptput voltage being requested by external to the voltage regulator.  \r\n\r\nGenerator output voltage bias percentage is the amount of voltage in percent the generator output voltage will vary from the generator nominal setpoint.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -100,
      "unit": "%",
      "SLOT_ID": 251
    },
    "3383": {
      "PGN": 61461,
      "PGN_Name": "Requested Generator Total AC Reactive Power",
      "PGN_Description": "RGTACRP",
      "first_bit": 0,
      "SPN": 3383,
      "SPN_Name": "Requested Generator Total AC Reactive Power",
      "SPN_Description": "The total reactive power requested to be delivered by the generator",
      "bit_length": 32,
      "scaling": 1,
      "offset": -2000000000,
      "unit": "VA",
      "SLOT_ID": 148
    },
    "3384": {
      "PGN": 61461,
      "PGN_Name": "Requested Generator Total AC Reactive Power",
      "PGN_Description": "RGTACRP",
      "first_bit": 32,
      "SPN": 3384,
      "SPN_Name": "Requested Generator Overall Power Factor",
      "SPN_Description": "The requested average power factor of the generator.",
      "bit_length": 16,
      "scaling": 0.00006103515625,
      "offset": -1,
      "unit": null,
      "SLOT_ID": 151
    },
    "3385": {
      "PGN": 61461,
      "PGN_Name": "Requested Generator Total AC Reactive Power",
      "PGN_Description": "RGTACRP",
      "first_bit": 48,
      "SPN": 3385,
      "SPN_Name": "Requested Generator Overall Power Factor Lagging",
      "SPN_Description": "The requested lead/lag status for the generator average AC power factor\r\n\r\n00 - Leading\r\n01 - Lagging\r\n10 - Reserved\r\n11 - Not available or Not installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3386": {
      "PGN": 61468,
      "PGN_Name": "Requested Generator Average Basic AC Quantities",
      "PGN_Description": "RGAAC",
      "first_bit": 0,
      "SPN": 3386,
      "SPN_Name": "Requested Generator Average Line-Line AC RMS Voltage",
      "SPN_Description": "The requested average AC RMS voltage to be delivered by the generator.",
      "bit_length": 32,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 252
    },
    "3387": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 0,
      "SPN": 3387,
      "SPN_Name": "Engine Cylinder 1 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #1\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3388": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 2,
      "SPN": 3388,
      "SPN_Name": "Engine Cylinder 2 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #2\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3389": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 4,
      "SPN": 3389,
      "SPN_Name": "Engine Cylinder 3 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #3\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3390": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 6,
      "SPN": 3390,
      "SPN_Name": "Engine Cylinder 4 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #4\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3391": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 8,
      "SPN": 3391,
      "SPN_Name": "Engine Cylinder 5 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #5\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3392": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 10,
      "SPN": 3392,
      "SPN_Name": "Engine Cylinder 6 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #6\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3393": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 12,
      "SPN": 3393,
      "SPN_Name": "Engine Cylinder 7 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #7\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3394": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 14,
      "SPN": 3394,
      "SPN_Name": "Engine Cylinder 8 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #8\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3395": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 16,
      "SPN": 3395,
      "SPN_Name": "Engine Cylinder 9 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #9\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3396": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 18,
      "SPN": 3396,
      "SPN_Name": "Engine Cylinder 10 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #10\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3397": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 20,
      "SPN": 3397,
      "SPN_Name": "Engine Cylinder 11 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #11\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3398": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 22,
      "SPN": 3398,
      "SPN_Name": "Engine Cylinder 12 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #12\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3399": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 24,
      "SPN": 3399,
      "SPN_Name": "Engine Cylinder 13 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #13\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3400": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 26,
      "SPN": 3400,
      "SPN_Name": "Engine Cylinder 14 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #14\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3401": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 28,
      "SPN": 3401,
      "SPN_Name": "Engine Cylinder 15 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #15\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3402": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 30,
      "SPN": 3402,
      "SPN_Name": "Engine Cylinder 16 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #16\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3403": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 32,
      "SPN": 3403,
      "SPN_Name": "Engine Cylinder 17 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #17\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3404": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 34,
      "SPN": 3404,
      "SPN_Name": "Engine Cylinder 18 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #18\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3405": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 36,
      "SPN": 3405,
      "SPN_Name": "Engine Cylinder 19 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #19\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3406": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 38,
      "SPN": 3406,
      "SPN_Name": "Engine Cylinder 20 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #20\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3407": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 40,
      "SPN": 3407,
      "SPN_Name": "Engine Cylinder 21 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #21\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3408": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 42,
      "SPN": 3408,
      "SPN_Name": "Engine Cylinder 22 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #22\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3409": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 44,
      "SPN": 3409,
      "SPN_Name": "Engine Cylinder 23 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #23\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3410": {
      "PGN": 61462,
      "PGN_Name": "Cylinder Combustion Status",
      "PGN_Description": "CCS",
      "first_bit": 46,
      "SPN": 3410,
      "SPN_Name": "Engine Cylinder 24 Combustion Status",
      "SPN_Description": "This parameter is used to indicate state of combustion in engine cylinder #24\r\n\r\n00        No combustion\r\n01        Combustion exists\r\n10        Error\r\n11        Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3411": {
      "PGN": 65102,
      "PGN_Name": "Door Control 1",
      "PGN_Description": "DC1",
      "first_bit": 6,
      "SPN": 3411,
      "SPN_Name": "Status 2 of doors",
      "SPN_Description": "Composite indication of all bus door statuses. Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00   all bus doors are disabled\r\n01   at least 1 bus door enabled \r\n10   error\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3412": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 0,
      "SPN": 3412,
      "SPN_Name": "Lock Status of Door 1",
      "SPN_Description": "Lock status of bus door 1\r\n\r\n00  unlocked \r\n01  locked\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3413": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 2,
      "SPN": 3413,
      "SPN_Name": "Open Status of Door 1",
      "SPN_Description": "Open status of bus door 1\r\n\r\n00  door closed\r\n01  door opened\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3414": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 4,
      "SPN": 3414,
      "SPN_Name": "Enable Status of Door 1",
      "SPN_Description": "Enable status of bus door 1.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00  door disabled\r\n01  door enabled\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3415": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 6,
      "SPN": 3415,
      "SPN_Name": "Lock Status of Door 2",
      "SPN_Description": "Lock status of bus door 2\r\n\r\n00  unlocked \r\n01  locked\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3416": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 8,
      "SPN": 3416,
      "SPN_Name": "Open Status of Door 2",
      "SPN_Description": "Open status of bus door 2\r\n\r\n00  door closed\r\n01  door opened\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3417": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 10,
      "SPN": 3417,
      "SPN_Name": "Enable Status of Door 2",
      "SPN_Description": "Enable status of bus door 2.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00  door disabled\r\n01  door enabled\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3418": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 12,
      "SPN": 3418,
      "SPN_Name": "Lock Status of Door 3",
      "SPN_Description": "Lock status of bus door 3\r\n\r\n00  unlocked \r\n01  locked\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3419": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 14,
      "SPN": 3419,
      "SPN_Name": "Open Status of Door 3",
      "SPN_Description": "Open status of bus door 3\r\n\r\n00  door closed\r\n01  door opened\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3420": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 16,
      "SPN": 3420,
      "SPN_Name": "Enable Status of Door 3",
      "SPN_Description": "Enable status of bus door 3.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00  door disabled\r\n01  door enabled\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3421": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 18,
      "SPN": 3421,
      "SPN_Name": "Lock Status of Door 4",
      "SPN_Description": "Lock status of bus door 4\r\n\r\n00  unlocked \r\n01  locked\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3422": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 20,
      "SPN": 3422,
      "SPN_Name": "Open Status of Door 4",
      "SPN_Description": "Open status of bus door 4\r\n\r\n00  door closed\r\n01  door opened\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3423": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 22,
      "SPN": 3423,
      "SPN_Name": "Enable Status of Door 4",
      "SPN_Description": "Enable status of bus door 4.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00  door disabled\r\n01  door enabled\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3424": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 24,
      "SPN": 3424,
      "SPN_Name": "Lock Status of Door 5",
      "SPN_Description": "Lock status of bus door 5\r\n\r\n00  unlocked \r\n01  locked\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3425": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 26,
      "SPN": 3425,
      "SPN_Name": "Open Status of Door 5",
      "SPN_Description": "Open status of bus door 5\r\n\r\n00  door closed\r\n01  door opened\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3426": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 28,
      "SPN": 3426,
      "SPN_Name": "Enable Status of Door 5",
      "SPN_Description": "Enable status of bus door 5.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00  door disabled\r\n01  door enabled\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3427": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 30,
      "SPN": 3427,
      "SPN_Name": "Lock Status of Door 6",
      "SPN_Description": "Lock status of bus door 6\r\n\r\n00  unlocked \r\n01  locked\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3428": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 32,
      "SPN": 3428,
      "SPN_Name": "Open Status of Door 6",
      "SPN_Description": "Open status of bus door 6\r\n\r\n00  door closed\r\n01  door opened\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3429": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 34,
      "SPN": 3429,
      "SPN_Name": "Enable Status of Door 6",
      "SPN_Description": "Enable status of bus door 6.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00  door disabled\r\n01  door enabled\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3430": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 36,
      "SPN": 3430,
      "SPN_Name": "Lock Status of Door 7",
      "SPN_Description": "Lock status of bus door 7\r\n\r\n00  unlocked \r\n01  locked\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3431": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 38,
      "SPN": 3431,
      "SPN_Name": "Open Status of Door 7",
      "SPN_Description": "Open status of bus door 7\r\n\r\n00  door closed\r\n01  door opened\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3432": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 40,
      "SPN": 3432,
      "SPN_Name": "Enable Status of Door 7",
      "SPN_Description": "Enable status of bus door 7.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00  door disabled\r\n01  door enabled\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3433": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 42,
      "SPN": 3433,
      "SPN_Name": "Lock Status of Door 8",
      "SPN_Description": "Lock status of bus door 8\r\n\r\n00  unlocked \r\n01  locked\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3434": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 44,
      "SPN": 3434,
      "SPN_Name": "Open Status of Door 8",
      "SPN_Description": "Open status of bus door 8\r\n\r\n00  door closed\r\n01  door opened\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3435": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 46,
      "SPN": 3435,
      "SPN_Name": "Enable Status of Door 8",
      "SPN_Description": "Enable status of bus door 8.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00  door disabled\r\n01  door enabled\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3436": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 48,
      "SPN": 3436,
      "SPN_Name": "Lock Status of Door 9",
      "SPN_Description": "Lock status of bus door 9\r\n\r\n00  unlocked \r\n01  locked\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3437": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 50,
      "SPN": 3437,
      "SPN_Name": "Open Status of Door 9",
      "SPN_Description": "Open status of bus door 9\r\n\r\n00  door closed\r\n01  door opened\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3438": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 52,
      "SPN": 3438,
      "SPN_Name": "Enable Status of Door 9",
      "SPN_Description": "Enable status of bus door 9.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00  door disabled\r\n01  door enabled\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3439": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 54,
      "SPN": 3439,
      "SPN_Name": "Lock Status of Door 10",
      "SPN_Description": "Lock status of bus door 10\r\n\r\n00  unlocked \r\n01  locked\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3440": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 56,
      "SPN": 3440,
      "SPN_Name": "Open Status of Door 10",
      "SPN_Description": "Open status of bus door 10\r\n\r\n00  door closed\r\n01  door opened\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3441": {
      "PGN": 64933,
      "PGN_Name": "Door Control 2",
      "PGN_Description": "DC2",
      "first_bit": 58,
      "SPN": 3441,
      "SPN_Name": "Enable Status of Door 10",
      "SPN_Description": "Enable status of bus door 10.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00  door disabled\r\n01  door enabled\r\n10  error\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3442": {
      "PGN": 64936,
      "PGN_Name": "Wireless Communications Message 2",
      "PGN_Description": "WCM2",
      "first_bit": 0,
      "SPN": 3442,
      "SPN_Name": "Network Transceiver Status 2",
      "SPN_Description": "Indicates the status of the transceiver for the wireless communications network type\r\n\r\n0 = Off\r\n1 = On\r\n2 = Not Authorized to Operate on Network\r\n3-250 = Reserved for Future Assignment\r\n251-253 = Reserved\r\n254 = Error\r\n255 = Not Available",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3443": {
      "PGN": 64936,
      "PGN_Name": "Wireless Communications Message 2",
      "PGN_Description": "WCM2",
      "first_bit": 8,
      "SPN": 3443,
      "SPN_Name": "Network Service Status 2",
      "SPN_Description": "Indicates the status of the Service for the wireless communications network type\r\n\r\n0 = Local Service\r\n1 = Roaming Service\r\n2 = Service not available\r\n3 = Not Authorized to Operate on Service\r\n4-250 = Reserved for Future Assignment\r\n251-253 = Reserved\r\n254 = Error\r\n255 = Not Available",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3444": {
      "PGN": 64936,
      "PGN_Name": "Wireless Communications Message 2",
      "PGN_Description": "WCM2",
      "first_bit": 16,
      "SPN": 3444,
      "SPN_Name": "Network Antenna Status 2",
      "SPN_Description": "Indicates the status of the antenna for the wireless communications network type\r\n\r\n0 = Off\r\n1 = On\r\n2-250 = Reserved for Future Assignment\r\n251-253 = Reserved\r\n254 = Error\r\n255 = Not Available",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3445": {
      "PGN": 64936,
      "PGN_Name": "Wireless Communications Message 2",
      "PGN_Description": "WCM2",
      "first_bit": 24,
      "SPN": 3445,
      "SPN_Name": "Network Signal Strength 2",
      "SPN_Description": "Indicates the signal strength for the wireless communications network type.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "3446": {
      "PGN": 64936,
      "PGN_Name": "Wireless Communications Message 2",
      "PGN_Description": "WCM2",
      "first_bit": 32,
      "SPN": 3446,
      "SPN_Name": "Wireless Communication Network Type 2",
      "SPN_Description": "Type of Wireless Communication Network\r\n\r\n0 = Cellular network #1\r\n1 = Cellular network #2\r\n2 = Wireless LAN #1\r\n3 = Wireless LAN #2\r\n4 = Satellite network\r\n5-250 = Reserved for Future Assignment\r\n251-253 = Reserved\r\n254 = Error\r\n255 = Not Available",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "3447": {
      "PGN": 65264,
      "PGN_Name": "Power Takeoff Information",
      "PGN_Description": "PTO",
      "first_bit": 58,
      "SPN": 3447,
      "SPN_Name": "Remote PTO Governor Preprogrammed Speed Control Switch #2",
      "SPN_Description": "Switch signal which indicates that the remote PTO governor toggle switch #2 is in the enabled (ON) position. If the toggle switch is enabled and other conditions are satisfied then the remote PTO governor control feature is activated and the PTO governor will control at the preprogrammed speed #2.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not Available\r\n\r\nNote:  This switch is different than the 1-8 Preprogrammed Set Speeds because this is a physical switch input, not a user programmable set speed (although the associated PTO set speed for this toggle switch is user defined).",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3448": {
      "PGN": 65264,
      "PGN_Name": "Power Takeoff Information",
      "PGN_Description": "PTO",
      "first_bit": 60,
      "SPN": 3448,
      "SPN_Name": "Auxiliary Input Ignore Switch",
      "SPN_Description": "Switch signal which overrides other switch input's ability to disable an engine's operating condition.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not Available\r\n\r\nThis switch input can be used to prevent the PTO from disengaging if another switch input's state changes.  For example, if the PTO is normally disengaged when the clutch is depressed, then this switch would allow the user to use PTO while depressing the clutch.\r\n\r\nInterlock switches which are specifically intended to inhibit PTO operation have priority over this parameter.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3452": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 6,
      "SPN": 3452,
      "SPN_Name": "Enable Switch – Transmission input shaft PTO 1",
      "SPN_Description": "Status of the operator’s switch or other input which indicates the desire for engaging the first PTO drive mounted on the transmission case.  There may be more than one PTO drive mounted on the transmission case. \r\n\r\n00   Enable switch off – PTO operation not desired\r\n01   Enable switch on – PTO operation desired\r\n10   Error\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3453": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 4,
      "SPN": 3453,
      "SPN_Name": "Enable Switch – Transmission input shaft PTO 2",
      "SPN_Description": "Status of the operator’s switch or other input which indicates the desire for engaging the second PTO drive mounted on the transmission case.   If there is only one PTO drive on the transmission case, use SPN 3452 Enable Switch – Transmission input shaft PTO 1.\r\n\r\n00   Enable switch off – PTO operation not desired\r\n01   Enable switch on – PTO operation desired\r\n10   Error\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3454": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 2,
      "SPN": 3454,
      "SPN_Name": "Enable Switch – Transmission output shaft PTO",
      "SPN_Description": "Status of the operator’s switch or other input which indicates the desire for engaging the PTO drive mounted on the transmission output shaft. \r\n\r\n00   Enable switch off – PTO operation not desired\r\n01   Enable switch on – PTO operation desired\r\n10   Error\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3455": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 0,
      "SPN": 3455,
      "SPN_Name": "Enable Switch – Transfer case output shaft PTO",
      "SPN_Description": "Status of the operator’s switch or other input which indicates the desire for engaging the PTO drive mounted on the output shaft of the transfer case. \r\n\r\n00   Enable switch off – PTO operation not desired\r\n01   Enable switch on – PTO operation desired\r\n10   Error\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3456": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 22,
      "SPN": 3456,
      "SPN_Name": "Engagement Consent – Transmission input shaft PTO 1",
      "SPN_Description": "Status of the transmission controller’s consent to engage the first or sole PTO drive mounted on the transmission case.  The controller in charge of the PTO drive should monitor this parameter and only engage the drive when consent is given.  If consent is removed, while the PTO drive is engaged, the drive controller should disengage the drive as soon as possible.  Engaging the drive or continuing drive engagement when consent is removed may result in damage to the transmission and / or the PTO drive mechanism.\r\n\r\n00   Consent not given – PTO drive should not be engaged\r\n01   Consent given – PTO drive may be engaged\r\n10   Error\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3457": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 20,
      "SPN": 3457,
      "SPN_Name": "Engagement Consent – Transmission input shaft PTO 2",
      "SPN_Description": "Status of the transmission controller’s consent to engage the second PTO drive mounted on the transmission case.  The controller in charge of the PTO drive should monitor this parameter and only engage the drive when consent is given.  If consent is removed while the PTO drive is engaged, the drive controller should disengage the drive as soon as possible.  Engaging the drive or continuing drive engagement when consent is removed may result in damage to the transmission and / or the PTO drive mechanism.  If there is only one PTO drive on the transmission case, use SPN 3456 Engagement Consent – Transmission input shaft PTO 1.\r\n\r\n00   Consent not given – PTO drive should not be engaged\r\n01   Consent given – PTO drive may be engaged\r\n10   Error\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3458": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 18,
      "SPN": 3458,
      "SPN_Name": "Engagement Consent – Transmission output shaft PTO",
      "SPN_Description": "Status of the transmission controller’s consent to engage the PTO drive connected to the transmission output shaft.  The controller in charge of the PTO drive should monitor this parameter and only engage the drive when consent is given.  If consent is removed, while the PTO drive is engaged, the drive controller should disengage the drive as soon as possible.  Engaging the drive or continuing drive engagement when consent is removed may result in damage to the transmission and / or the PTO drive mechanism.\r\n\r\n00   Consent not given – PTO drive should not be engaged\r\n01   Consent given – PTO drive may be engaged\r\n10   Error\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3459": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 16,
      "SPN": 3459,
      "SPN_Name": "Engagement Consent – Transfer case output shaft PTO",
      "SPN_Description": "Status of the transmission controller’s consent to engage the PTO drive connected to the transfer case output shaft.  The controller in charge of the PTO drive should monitor this parameter and only engage the drive when consent is given.  If consent is removed, while the PTO drive is engaged, the drive controller should disengage the drive as soon as possible.  Engaging the drive or continuing drive engagement when consent is removed may result in damage to the transmission and / or the PTO drive mechanism.\r\n\r\n00   Consent not given – PTO drive should not be engaged\r\n01   Consent given – PTO drive may be engaged\r\n10   Error\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3460": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 38,
      "SPN": 3460,
      "SPN_Name": "Engagement Status – Transmission input shaft PTO 1",
      "SPN_Description": "Reports if this specific PTO drive is engaged.  This parameter should be broadcast only by the controller(s) receiving feedback about the specific drive.  \r\n\r\nFor example, a pressure switch may be used to determine if a PTO-driven pump has been engaged.  If the Body Controller (SA33) were monitoring this feedback signal, it should be the node broadcasting this parameter.  \r\n\r\n00   Drive not engaged\r\n01   Drive is engaged\r\n10   Error\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3461": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 36,
      "SPN": 3461,
      "SPN_Name": "Engagement Status – Transmission input shaft PTO 2",
      "SPN_Description": "Reports if this specific PTO drive is engaged.  This parameter should be broadcast only by the controller(s) receiving feedback about the specific drive.  \r\n\r\nFor example, a pressure switch may be used to determine if a PTO-driven pump has been engaged.  If the Body Controller (SA33) were monitoring this feedback signal, it should be the node broadcasting this parameter.\r\n\r\nIf there is only one PTO drive on the transmission case, SPN 3460 Engagement Status – Transmission input shaft PTO 1 should be used.  \r\n\r\n00   Drive not engaged\r\n01   Drive is engaged\r\n10   Error\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3462": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 34,
      "SPN": 3462,
      "SPN_Name": "Engagement Status – Transmission output shaft PTO",
      "SPN_Description": "Reports if this specific PTO drive is engaged.  This parameter should be broadcast only by the controller(s) receiving feedback about the specific drive.  \r\n\r\nFor example, a pressure switch may be used to determine if a PTO-driven pump has been engaged.  If the Body Controller (SA33) were monitoring this feedback signal, it should be the node broadcasting this parameter.  \r\n\r\n\r\n00   Drive not engaged\r\n01   Drive is engaged\r\n10   Error\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3463": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 32,
      "SPN": 3463,
      "SPN_Name": "Engagement Status – Transfer case output shaft PTO",
      "SPN_Description": "Reports if this specific PTO drive is engaged.  This parameter should be broadcast only by the controller(s) receiving feedback about the specific drive.  \r\n\r\nFor example, a pressure switch may be used to determine if a PTO-driven pump has been engaged.  If the Body Controller (SA33) were monitoring this feedback signal, it should be the node broadcasting this parameter.  \r\n\r\n\r\n00   Drive not engaged\r\n01   Drive is engaged\r\n10   Error\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3464": {
      "PGN": 61466,
      "PGN_Name": "Engine Throttle / Fuel Actuator Control Command",
      "PGN_Description": "TFAC",
      "first_bit": 0,
      "SPN": 3464,
      "SPN_Name": "Engine Throttle Actuator 1 Control Command",
      "SPN_Description": "The control command to throttle actuator 1, normalized to percent, where 0% represents fully closed and 100% represents fully open.  Typically, this throttle actuator is used to regulate air or air / fuel mix to the engine. Using the standard convention for determining the position.  Left/front is #1 and right/rear is #2 (SPN 3465).\r\n\r\n0xFB00 - 0xFB64 is sent to calibrate to a specific position.  The LSB specifies the position with a resolution of 1%/bit  (eg, 0xFB32 is sent to calibrate the actuator to 50%).  \r\n\r\n0xFBFF is sent to calibrate the actuator using its own algorithm.  \r\n\r\nCalibration status from the actuator is received on SPN 5445.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "3465": {
      "PGN": 61466,
      "PGN_Name": "Engine Throttle / Fuel Actuator Control Command",
      "PGN_Description": "TFAC",
      "first_bit": 16,
      "SPN": 3465,
      "SPN_Name": "Engine Throttle Actuator 2 Control Command",
      "SPN_Description": "The control command to throttle actuator 2, normalized to percent, where 0% represents fully closed and 100% represents fully open.  Typically, this throttle actuator is used to regulate air or air / fuel mix to the engine. Using the standard convention for determining the position.  Left/front is #1 (SPN 3464) and right/rear is #2.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "3466": {
      "PGN": 64930,
      "PGN_Name": "Fuel Information 3 (Gaseous)",
      "PGN_Description": "GFI3",
      "first_bit": 0,
      "SPN": 3466,
      "SPN_Name": "Engine Fuel Valve 2 Intake Absolute Pressure",
      "SPN_Description": "Absolute pressure of gas on intake side of the second fuel system control valve, using standard convention for determining position.\r\n\r\nIn a system with two fuel system control valves, left/front is #1 (SPN 1390) and right/rear is #2 (SPN 3466).\r\n\r\nIn a system with more than 2 fuel system control valves, the front left is #1 (SPN 1390), the front right is #2 (SPN 3466), the rear left is #3 (SPN 7505), and the rear right is #4 (SPN 7506).",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3467": {
      "PGN": 64930,
      "PGN_Name": "Fuel Information 3 (Gaseous)",
      "PGN_Description": "GFI3",
      "first_bit": 16,
      "SPN": 3467,
      "SPN_Name": "Engine Fuel System 2 Gas Mass Flow Rate",
      "SPN_Description": "Gas mass flow rate delivered to an engine through its second fuel control system, using standard convention for determining position.\r\n\r\nIn a system with two fuel system control valves, left/front is #1 (SPN 1241) and right/rear is #2 (SPN 3467).\r\n\r\nIn a system with more than 2 fuel systems, the front left is #1 (SPN 1241), the front right is #2 (SPN 3467), the rear left is #3 (SPN 7509), and the rear right is #4 (SPN 7510).",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "kg/h",
      "SLOT_ID": 18
    },
    "3468": {
      "PGN": 64930,
      "PGN_Name": "Fuel Information 3 (Gaseous)",
      "PGN_Description": "GFI3",
      "first_bit": 32,
      "SPN": 3468,
      "SPN_Name": "Engine Fuel 1 Temperature 2",
      "SPN_Description": "Second Temperature measurement of fuel (or gas) of the first fuel type. See SPN 174 for first fuel temperature measurement.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "3469": {
      "PGN": 64930,
      "PGN_Name": "Fuel Information 3 (Gaseous)",
      "PGN_Description": "GFI3",
      "first_bit": 48,
      "SPN": 3469,
      "SPN_Name": "Engine Fuel Valve 2 Outlet Absolute Pressure",
      "SPN_Description": "Absolute pressure of gas on outlet side of the second fuel system control valve.  See SPN 2980 for the first or only fuel system control valve.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3470": {
      "PGN": 64931,
      "PGN_Name": "Electronic Engine Controller 6",
      "PGN_Description": "EEC6",
      "first_bit": 0,
      "SPN": 3470,
      "SPN_Name": "Engine Turbocharger Compressor Bypass Actuator 1 Command",
      "SPN_Description": "The command to a compressor bypass actuator, normalized to percent, where 0% nominally represents fully closed and 100% represents fully open.  Typically, the turbocharger compressor bypass actuator is used to keep the engine out of surge by metering compressed air (charge).",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "3479": {
      "PGN": 64929,
      "PGN_Name": "Aftertreatment 1 Fuel Control 1",
      "PGN_Description": "AT1FC1",
      "first_bit": 32,
      "SPN": 3479,
      "SPN_Name": "Aftertreatment 1 Fuel Pressure 1 Control",
      "SPN_Description": "Position that the controller is commanding the aftertreatment 1 fuel pressure control to maintain.  0% = fully closed, 100% = fully open.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "3480": {
      "PGN": 64929,
      "PGN_Name": "Aftertreatment 1 Fuel Control 1",
      "PGN_Description": "AT1FC1",
      "first_bit": 0,
      "SPN": 3480,
      "SPN_Name": "Aftertreatment 1 Fuel Pressure 1",
      "SPN_Description": "First fuel pressure measurement for the aftertreatment 1 system",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3481": {
      "PGN": 64929,
      "PGN_Name": "Aftertreatment 1 Fuel Control 1",
      "PGN_Description": "AT1FC1",
      "first_bit": 16,
      "SPN": 3481,
      "SPN_Name": "Aftertreatment 1 Fuel Rate",
      "SPN_Description": "Rate of fuel being delivered to aftertreatment 1 for regeneration",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "l/h",
      "SLOT_ID": 42
    },
    "3482": {
      "PGN": 64929,
      "PGN_Name": "Aftertreatment 1 Fuel Control 1",
      "PGN_Description": "AT1FC1",
      "first_bit": 54,
      "SPN": 3482,
      "SPN_Name": "Aftertreatment 1 Fuel Enable Actuator",
      "SPN_Description": "Indicates whether aftertreatment 1 fuel enable actuator is on or off\r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3483": {
      "PGN": 64929,
      "PGN_Name": "Aftertreatment 1 Fuel Control 1",
      "PGN_Description": "AT1FC1",
      "first_bit": 52,
      "SPN": 3483,
      "SPN_Name": "Aftertreatment 1 Regeneration Status",
      "SPN_Description": "Indicates whether regeneration is active or inactive in aftertreatment 1.  \r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3484": {
      "PGN": 64929,
      "PGN_Name": "Aftertreatment 1 Fuel Control 1",
      "PGN_Description": "AT1FC1",
      "first_bit": 50,
      "SPN": 3484,
      "SPN_Name": "Aftertreatment 1 Ignition",
      "SPN_Description": "Indicates whether aftertreatment 1 ignition circuit is energized by the ECU.\r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3485": {
      "PGN": 64927,
      "PGN_Name": "Aftertreatment 1 Air Control 1",
      "PGN_Description": "AT1AC1",
      "first_bit": 0,
      "SPN": 3485,
      "SPN_Name": "Aftertreatment 1 Supply Air Pressure",
      "SPN_Description": "Pressure of the supply air for aftertreatment 1.  Supply air is the air supplied from a pneumatic line for an air-assisted or pneumatic actuator.  One example is an air assisted fuel injector (the supply air assists in the atomization of fuel).",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3486": {
      "PGN": 64927,
      "PGN_Name": "Aftertreatment 1 Air Control 1",
      "PGN_Description": "AT1AC1",
      "first_bit": 16,
      "SPN": 3486,
      "SPN_Name": "Aftertreatment 1 Purge Air Pressure",
      "SPN_Description": "Pressure of the purge air supply for aftertreatment 1",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3487": {
      "PGN": 64927,
      "PGN_Name": "Aftertreatment 1 Air Control 1",
      "PGN_Description": "AT1AC1",
      "first_bit": 32,
      "SPN": 3487,
      "SPN_Name": "Aftertreatment 1 Air Pressure Control",
      "SPN_Description": "Position that the controller is commanding the aftertreatment 1 air pressure control to maintain.  0% = fully closed, 100% = fully open",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "3488": {
      "PGN": 64927,
      "PGN_Name": "Aftertreatment 1 Air Control 1",
      "PGN_Description": "AT1AC1",
      "first_bit": 48,
      "SPN": 3488,
      "SPN_Name": "Aftertreatment 1 Air Pressure Actuator Position",
      "SPN_Description": "Position of the aftertreatment 1 air pressure actuator as measured by a position feedback sensor.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "3489": {
      "PGN": 64927,
      "PGN_Name": "Aftertreatment 1 Air Control 1",
      "PGN_Description": "AT1AC1",
      "first_bit": 62,
      "SPN": 3489,
      "SPN_Name": "Aftertreatment 1 Air Enable Actuator",
      "SPN_Description": "Indicates whether aftertreatment 1 air enable actuator is on or off\r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3490": {
      "PGN": 64927,
      "PGN_Name": "Aftertreatment 1 Air Control 1",
      "PGN_Description": "AT1AC1",
      "first_bit": 60,
      "SPN": 3490,
      "SPN_Name": "Aftertreatment 1 Purge Air Actuator",
      "SPN_Description": "Indicates whether aftertreatment 1 purge air actuator is on or off\r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3491": {
      "PGN": 64927,
      "PGN_Name": "Aftertreatment 1 Air Control 1",
      "PGN_Description": "AT1AC1",
      "first_bit": 58,
      "SPN": 3491,
      "SPN_Name": "Aftertreatment 1 Atomization Air Actuator",
      "SPN_Description": "Indicates whether aftertreatment 1 atomization air actuator is on or off\r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3492": {
      "PGN": 64927,
      "PGN_Name": "Aftertreatment 1 Air Control 1",
      "PGN_Description": "AT1AC1",
      "first_bit": 56,
      "SPN": 3492,
      "SPN_Name": "Aftertreatment 1 Air System Relay",
      "SPN_Description": "Indicates whether aftertreatment 1 air system relay is on or off\r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3493": {
      "PGN": 64928,
      "PGN_Name": "Aftertreatment 2 Fuel Control 1",
      "PGN_Description": "AT2FC1",
      "first_bit": 32,
      "SPN": 3493,
      "SPN_Name": "Aftertreatment 2 Fuel Pressure 1 Control",
      "SPN_Description": "Position that the controller is commanding the aftertreatment 2 fuel pressure control to maintain.  0% = fully closed, 100% = fully open.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "3494": {
      "PGN": 64928,
      "PGN_Name": "Aftertreatment 2 Fuel Control 1",
      "PGN_Description": "AT2FC1",
      "first_bit": 0,
      "SPN": 3494,
      "SPN_Name": "Aftertreatment 2 Fuel Pressure 1",
      "SPN_Description": "Pressure of the fuel for Aftertreatment 2.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3495": {
      "PGN": 64928,
      "PGN_Name": "Aftertreatment 2 Fuel Control 1",
      "PGN_Description": "AT2FC1",
      "first_bit": 16,
      "SPN": 3495,
      "SPN_Name": "Aftertreatment 2 Fuel Rate",
      "SPN_Description": "Rate of fuel being delivered to aftertreatment 2 for regeneration",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "l/h",
      "SLOT_ID": 42
    },
    "3496": {
      "PGN": 64928,
      "PGN_Name": "Aftertreatment 2 Fuel Control 1",
      "PGN_Description": "AT2FC1",
      "first_bit": 54,
      "SPN": 3496,
      "SPN_Name": "Aftertreatment 2 Fuel Enable Actuator",
      "SPN_Description": "Indicates whether aftertreatment 2 fuel enable actuator is on or off\r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3497": {
      "PGN": 64928,
      "PGN_Name": "Aftertreatment 2 Fuel Control 1",
      "PGN_Description": "AT2FC1",
      "first_bit": 52,
      "SPN": 3497,
      "SPN_Name": "Aftertreatment 2 Regeneration Status",
      "SPN_Description": "Indicates whether regeneration is active or inactive in aftertreatment 2.  \r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3498": {
      "PGN": 64928,
      "PGN_Name": "Aftertreatment 2 Fuel Control 1",
      "PGN_Description": "AT2FC1",
      "first_bit": 50,
      "SPN": 3498,
      "SPN_Name": "Aftertreatment 2 Ignition",
      "SPN_Description": "Indicates whether aftertreatment 2 ignition circuit is energized by the ECU.\r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3499": {
      "PGN": 64926,
      "PGN_Name": "Aftertreatment 2 Air Control 1",
      "PGN_Description": "AT2AC1",
      "first_bit": 0,
      "SPN": 3499,
      "SPN_Name": "Aftertreatment 2 Supply Air Pressure",
      "SPN_Description": "Pressure of the supply air for aftertreatment 2.  Supply air is the air supplied from a pneumatic line for an air-assisted or pneumatic actuator.  One example is an air assisted fuel injector (the supply air assists in the atomization of fuel).",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3500": {
      "PGN": 64926,
      "PGN_Name": "Aftertreatment 2 Air Control 1",
      "PGN_Description": "AT2AC1",
      "first_bit": 16,
      "SPN": 3500,
      "SPN_Name": "Aftertreatment 2 Purge Air Pressure",
      "SPN_Description": "Pressure of the purge air supply for aftertreatment 2",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3501": {
      "PGN": 64926,
      "PGN_Name": "Aftertreatment 2 Air Control 1",
      "PGN_Description": "AT2AC1",
      "first_bit": 32,
      "SPN": 3501,
      "SPN_Name": "Aftertreatment 2 Air Pressure Control",
      "SPN_Description": "Position that the controller is commanding the aftertreatment 2 air pressure control to maintain.  0% = fully closed, 100% = fully open",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "3502": {
      "PGN": 64926,
      "PGN_Name": "Aftertreatment 2 Air Control 1",
      "PGN_Description": "AT2AC1",
      "first_bit": 48,
      "SPN": 3502,
      "SPN_Name": "Aftertreatment 2 Air Pressure Actuator Position",
      "SPN_Description": "Position of the aftertreatment 2 air pressure actuator as measured by a position feedback sensor.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "3503": {
      "PGN": 64926,
      "PGN_Name": "Aftertreatment 2 Air Control 1",
      "PGN_Description": "AT2AC1",
      "first_bit": 62,
      "SPN": 3503,
      "SPN_Name": "Aftertreatment 2 Air Enable Actuator",
      "SPN_Description": "Indicates whether aftertreatment 2 air enable actuator is on or off\r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3504": {
      "PGN": 64926,
      "PGN_Name": "Aftertreatment 2 Air Control 1",
      "PGN_Description": "AT2AC1",
      "first_bit": 60,
      "SPN": 3504,
      "SPN_Name": "Aftertreatment 2 Purge Air Actuator",
      "SPN_Description": "Indicates whether aftertreatment 2 purge air actuator is on or off\r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3505": {
      "PGN": 64926,
      "PGN_Name": "Aftertreatment 2 Air Control 1",
      "PGN_Description": "AT2AC1",
      "first_bit": 58,
      "SPN": 3505,
      "SPN_Name": "Aftertreatment 2 Atomization Air Actuator",
      "SPN_Description": "Indicates whether aftertreatment 2 atomization air actuator is on or off\r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3506": {
      "PGN": 64926,
      "PGN_Name": "Aftertreatment 2 Air Control 1",
      "PGN_Description": "AT2AC1",
      "first_bit": 56,
      "SPN": 3506,
      "SPN_Name": "Aftertreatment 2 Air System Relay",
      "SPN_Description": "Indicates whether aftertreatment 2 air system relay is on or off\r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3509": {
      "PGN": 64925,
      "PGN_Name": "Sensor Electrical Power #1",
      "PGN_Description": "SEP1",
      "first_bit": 0,
      "SPN": 3509,
      "SPN_Name": "Sensor supply voltage 1",
      "SPN_Description": "Sensor ECU supply voltage 1",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "3510": {
      "PGN": 64925,
      "PGN_Name": "Sensor Electrical Power #1",
      "PGN_Description": "SEP1",
      "first_bit": 16,
      "SPN": 3510,
      "SPN_Name": "Sensor supply voltage 2",
      "SPN_Description": "Sensor ECU supply voltage 2",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "3511": {
      "PGN": 64925,
      "PGN_Name": "Sensor Electrical Power #1",
      "PGN_Description": "SEP1",
      "first_bit": 32,
      "SPN": 3511,
      "SPN_Name": "Sensor supply voltage 3",
      "SPN_Description": "Sensor ECU supply voltage 3",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "3512": {
      "PGN": 64925,
      "PGN_Name": "Sensor Electrical Power #1",
      "PGN_Description": "SEP1",
      "first_bit": 48,
      "SPN": 3512,
      "SPN_Name": "Sensor supply voltage 4",
      "SPN_Description": "Sensor ECU supply voltage 4",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "3513": {
      "PGN": 64924,
      "PGN_Name": "Sensor Electrical Power #2",
      "PGN_Description": "SEP2",
      "first_bit": 0,
      "SPN": 3513,
      "SPN_Name": "Sensor supply voltage 5",
      "SPN_Description": "Sensor ECU supply voltage 5",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "3514": {
      "PGN": 64924,
      "PGN_Name": "Sensor Electrical Power #2",
      "PGN_Description": "SEP2",
      "first_bit": 16,
      "SPN": 3514,
      "SPN_Name": "Sensor supply voltage 6",
      "SPN_Description": "Sensor ECU supply voltage 6",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "3515": {
      "PGN": 64923,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Information 1",
      "PGN_Description": "A1DEFI1",
      "first_bit": 0,
      "SPN": 3515,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Temperature 2",
      "SPN_Description": "Temperature of the diesel exhaust fluid at the device measuring diesel exhaust fluid quality",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "3516": {
      "PGN": 64923,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Information 1",
      "PGN_Description": "A1DEFI1",
      "first_bit": 8,
      "SPN": 3516,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Concentration",
      "SPN_Description": "A measure of the concentration of urea in water.  Zero percent means that the tank contains no urea.  A 32.5% value indicates that the diesel exhaust fluid is of the proper concentration.  The 32.5% value indicates that the concentration is highest quality.\r\n\r\nParameter Specific Indicator:\r\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.25,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 254
    },
    "3517": {
      "PGN": 65110,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "AT1T1I1",
      "first_bit": 16,
      "SPN": 3517,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank Level",
      "SPN_Description": "The diesel exhaust fluid level height in mm in the diesel exhaust fluid storage container for aftertreatment system 1 (exhaust bank 1).  See SPN 1761 and SPN 7530 for alternate measurements. \r\n\r\nParameter Specific Indicator:\r\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "mm",
      "SLOT_ID": 14
    },
    "3518": {
      "PGN": 64923,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Information 1",
      "PGN_Description": "A1DEFI1",
      "first_bit": 16,
      "SPN": 3518,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Conductivity",
      "SPN_Description": "A measure of the conductivity of the diesel exhaust fluid at the sensor.  The conductivity is an indication of the diesel exhaust fluid's chemical make up.",
      "bit_length": 8,
      "scaling": 5,
      "offset": 0,
      "unit": "µSiemens/mm",
      "SLOT_ID": 255
    },
    "3519": {
      "PGN": 64923,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Information 1",
      "PGN_Description": "A1DEFI1",
      "first_bit": 24,
      "SPN": 3519,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Temperature 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI that applies to the most significant failure of the diesel exhaust fluid temperature sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3520": {
      "PGN": 64923,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Information 1",
      "PGN_Description": "A1DEFI1",
      "first_bit": 32,
      "SPN": 3520,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Properties Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI that applies to the most significant failure of the diesel exhaust fluid properties sensor.  This may be used for indicating failures of the diesel exhaust fluid concentration, diesel exhaust fluid conductivity or diesel exhaust fluid type. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3521": {
      "PGN": 64923,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Information 1",
      "PGN_Description": "A1DEFI1",
      "first_bit": 40,
      "SPN": 3521,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Property",
      "SPN_Description": "This parameter indicates the property of the fluid compound in the tank.  A value of 0011 indicates uncontaminated Diesel Exhaust Fluid.\r\n\r\n0000 - Urea concentration too high\r\n0001 - Urea concentration too low\r\n0010 - Fluid is diesel\r\n0011 - Diesel exhaust fluid is proper mixture\r\n0100 to 1011 - Reserved for SAE assignment\r\n1100 - Diesel exhaust fluid, but concentration cannot be determined\r\n1101 - Not able to determine fluid property (fluid type unknown)\r\n1110 - Error with diesel exhaust fluid property detection\r\n1111 - Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3522": {
      "PGN": 64920,
      "PGN_Name": "Aftertreatment 1 Historical Information 1",
      "PGN_Description": "AT1HI1",
      "first_bit": 0,
      "SPN": 3522,
      "SPN_Name": "Aftertreatment 1 Total Fuel Used",
      "SPN_Description": "Total amount of fuel used by aftertreatment device 1 over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 75
    },
    "3523": {
      "PGN": 64920,
      "PGN_Name": "Aftertreatment 1 Historical Information 1",
      "PGN_Description": "AT1HI1",
      "first_bit": 32,
      "SPN": 3523,
      "SPN_Name": "Aftertreatment 1 Total Regeneration Time",
      "SPN_Description": "Total amount of time that aftertreatment device 1 has been regenerating over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "3524": {
      "PGN": 64920,
      "PGN_Name": "Aftertreatment 1 Historical Information 1",
      "PGN_Description": "AT1HI1",
      "first_bit": 64,
      "SPN": 3524,
      "SPN_Name": "Aftertreatment 1 Total Disabled Time",
      "SPN_Description": "Total amount of time that aftertreatment 1 regeneration has been manually disabled.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "3525": {
      "PGN": 64920,
      "PGN_Name": "Aftertreatment 1 Historical Information 1",
      "PGN_Description": "AT1HI1",
      "first_bit": 96,
      "SPN": 3525,
      "SPN_Name": "Aftertreatment 1 Total Number of Active Regenerations",
      "SPN_Description": "Total number of active regenerations by aftertreatment device 1 over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3526": {
      "PGN": 64921,
      "PGN_Name": "Aftertreatment 2 Historical information 1",
      "PGN_Description": "AT2HI1",
      "first_bit": 0,
      "SPN": 3526,
      "SPN_Name": "Aftertreatment 2 Total Fuel Used",
      "SPN_Description": "Total amount of fuel used by aftertreatment device 2 over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 75
    },
    "3527": {
      "PGN": 64921,
      "PGN_Name": "Aftertreatment 2 Historical information 1",
      "PGN_Description": "AT2HI1",
      "first_bit": 32,
      "SPN": 3527,
      "SPN_Name": "Aftertreatment 2 Total Regeneration Time",
      "SPN_Description": "Total amount of time that aftertreatment device 2 has been regenerating over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "3528": {
      "PGN": 64921,
      "PGN_Name": "Aftertreatment 2 Historical information 1",
      "PGN_Description": "AT2HI1",
      "first_bit": 64,
      "SPN": 3528,
      "SPN_Name": "Aftertreatment 2 Total Disabled Time",
      "SPN_Description": "Total amount of time that aftertreatment 2 regeneration has been manually disabled.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "3529": {
      "PGN": 64921,
      "PGN_Name": "Aftertreatment 2 Historical information 1",
      "PGN_Description": "AT2HI1",
      "first_bit": 96,
      "SPN": 3529,
      "SPN_Name": "Aftertreatment 2 Total Number of Active Regenerations",
      "SPN_Description": "Total number of active regenerations by aftertreatment device 2 over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3532": {
      "PGN": 65110,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "AT1T1I1",
      "first_bit": 32,
      "SPN": 3532,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank Level/Volume Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid tank level sensor by the manufacturer's sensor control software.  This FMI is applicable to either the diesel exhaust fluid tank level or diesel exhaust fluid tank volume parameters.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "3533": {
      "PGN": 64917,
      "PGN_Name": "Transmission Fluids 2",
      "PGN_Description": "TRF2",
      "first_bit": 2,
      "SPN": 3533,
      "SPN_Name": "Transmission Oil Level Switch",
      "SPN_Description": "This switch indicates whether transmission oil level is full or empty.\r\n\r\n00 - Empty\r\n01 - Full or not empty\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3542": {
      "PGN": 64915,
      "PGN_Name": "Generator Control 1",
      "PGN_Description": "GC1",
      "first_bit": 0,
      "SPN": 3542,
      "SPN_Name": "Requested Engine Control Mode",
      "SPN_Description": "This parameter is used to request a change to the engine control mode.  This is a status parameter.  \r\nBit state 0000 = Normal Engine Shutdown\r\nBit state 0001 = Rapid Engine Shutdown\r\nBit state 0010 = Emergency Engine Shutdown\r\nBit state 0011 = Normal Engine Start\r\nBit state 0100 = Rapid Engine Start\r\nBit states 0101-1101 = available for SAE assignment\r\nBit state 1110 = <reserved>\r\nBit state 1111 = Don't Care / Take No Action\r\n\n\nNormal Engine Shutdown - \nUsed to request that the engine control system shut down the engine, using the normal shutdown sequence for the engine.  The shutdown sequence might include cool down or other intermediate states that delay stopping the engine.\r\n\nRapid Engine Shutdown - \nUsed to request that the engine control system shut down the engine, using an abbreviated shutdown sequence for the engine.  The intent is that the rapid engine shutdown take less time than a normal engine shutdown, but the specific shutdown sequence will depend on the configuration of the engine control system.\r\n\nEmergency Engine Shutdown - \nUsed to request that the engine control system shut down the engine, using the emergency shutdown sequence for the engine.  The intent is to shut down the engine in the fastest possible manner, using all mechanisms available.  All intermediate states that delay stopping the engine must be skipped for an emergency engine shutdown.  In addition, any installed emergency stop aids (such as air shutoff, Jake Brakes, etc.) must be activated for an emergency shutdown.\r\n\nNormal Engine Start - \nUsed to request that the engine control system start the engine, using the normal starting sequence for the engine.  All starting aids and pre-start states will be employed as appropriate for the engine and the current operating conditions.\r\n\nRapid Engine Start - \nUsed to request that the engine control system start the engine, using an abbreviated starting sequence for the engine.  The intent is that the rapid engine start take less time than a normal engine start, but the specific starting sequence will depend on the configuration of the engine control system.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3543": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 0,
      "SPN": 3543,
      "SPN_Name": "Engine Operating State",
      "SPN_Description": "This parameter is used to indicate the current state, or mode, of operation by the engine.  This is a status parameter.\r\n\r\nBit state 0000 = Engine Stopped\r\nBit state 0001 = Pre-Start\r\nBit state 0010 = Starting\r\nBit state 0011 = Warm-Up\r\nBit state 0100 = Running\r\nBit state 0101 = Cool-down\r\nBit state 0110 = Engine Stopping\r\nBit state 0111 = Post-Run\r\nBit states 1000-1101 = available for SAE assignment\r\nBit state 1110 = <reserved>\r\nBit state 1111 = not available\r\n\n\nSTOPPED - \nIn the stopped state, the ECM is powered and the engine is not turning.  The engine is ready to start.\r\n\nPRE-START - \nIn the PRE-START state, the engine is not running.  Actions are taken by various subsystem controls to prepare the engine for cranking and starting.  This may include any priming, prelubrication, preheating sequences, interlocks or other start permissives.  These subsystems have their own state based control and communicate their status to the engine state control logic.\r\n\nSTARTING - \nDuring the STARTING state, actions are taken by various subsystem controls to attempt to start the engine.\r\n\nWARM-UP - \nDuring the WARM-UP state, the engine operates at reduced speed and / or load to allow the engine to come up to operating temperature.\r\n\nRUNNING - \nIn the RUNNING state, the engine is turning and is prepared to output power.\r\n\nCOOL-DOWN - \nDuring the COOLDOWN state, the engine operates at reduced speed and / or load to allow the engine to cool off before the engine is stopped.\r\n\nSTOPPING - \nIn the STOPPING state, actions are taken by various subsystem controls to attempt to stop the engine.\r\n\nPOST-RUN - \nDuring the POST-RUN state, the engine is not turning.  Actions are taken by various subsystem controls to prevent engine damage and extend component life.  The engine is not ready to start.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3544": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 8,
      "SPN": 3544,
      "SPN_Name": "Time Remaining in Engine Operating State",
      "SPN_Description": "This parameter is used to indicate the time remaining in the current engine operating state, based on the state defined in the SPN \"Engine Operating State\" (SPN 3543). For the states in which time remaining is not applicable, use 65535 ($FFFF).",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 64
    },
    "3545": {
      "PGN": 64913,
      "PGN_Name": "AC Switching Device Status",
      "PGN_Description": "ACS",
      "first_bit": 0,
      "SPN": 3545,
      "SPN_Name": "Generator Circuit Breaker Status",
      "SPN_Description": "This parameter indicates the measured state of the generator circuit breaker.\n \r\n\r\n000 - Open\r\n001 - Closed\r\n010 - Locked Out\r\n011 - Transitioning to Open state\r\n100 - Transitioning to Closed state\r\n101 - Available for SAE assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3546": {
      "PGN": 64913,
      "PGN_Name": "AC Switching Device Status",
      "PGN_Description": "ACS",
      "first_bit": 3,
      "SPN": 3546,
      "SPN_Name": "Utility Circuit Breaker Status",
      "SPN_Description": "This parameter indicates the measured state of the utility circuit breaker.\r\n\n\n000 - Open\r\n001 - Closed\r\n010 - Locked Out\r\n011 - Transitioning to Open state\r\n100 - Transitioning to Closed state\r\n101 - Available for SAE assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3547": {
      "PGN": 64913,
      "PGN_Name": "AC Switching Device Status",
      "PGN_Description": "ACS",
      "first_bit": 8,
      "SPN": 3547,
      "SPN_Name": "Automatic Transfer Switch Status",
      "SPN_Description": "This parameter indicates the measured state of the automatic transfer switch.\r\r\n\r\n000 - Normal position\r\r\n001 - Emergency position\r\n010 - Available for SAE assignment\r\n011 - Transitioning to Normal position\r\n100 - Transitioning to Emergency position\r\n101 - Available for SAE assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3548": {
      "PGN": 65130,
      "PGN_Name": "Engine Fuel/Lube Systems",
      "PGN_Description": "EFS",
      "first_bit": 24,
      "SPN": 3548,
      "SPN_Name": "Engine Waste Oil Reservoir Level",
      "SPN_Description": "Level of crankcase blowby emulsion collected by a container.  Normalized to percent, 0% represents completely empty and 100% represents completely full.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "3549": {
      "PGN": 65130,
      "PGN_Name": "Engine Fuel/Lube Systems",
      "PGN_Description": "EFS",
      "first_bit": 32,
      "SPN": 3549,
      "SPN_Name": "Engine Oil Filter Outlet Pressure",
      "SPN_Description": "Oil pressure (gage) measured just downstream of oil filter.Used in conjunction with SPN1208 (pre-filter oil pressure) to determine oil filter health.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "3550": {
      "PGN": 65130,
      "PGN_Name": "Engine Fuel/Lube Systems",
      "PGN_Description": "EFS",
      "first_bit": 40,
      "SPN": 3550,
      "SPN_Name": "Engine Oil Priming Pump Switch",
      "SPN_Description": "Switch input for activating the engine oil priming pump.\r\n\r\n00 = Off\r\n01 = On\r\n10 = Error\r\n11 = Not available or not installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3551": {
      "PGN": 65130,
      "PGN_Name": "Engine Fuel/Lube Systems",
      "PGN_Description": "EFS",
      "first_bit": 42,
      "SPN": 3551,
      "SPN_Name": "Engine Oil Priming State",
      "SPN_Description": "Determination of whether or not the engine is (or has recently been) sufficiently lubricated for starting purposes.\r\n\r\n00 = Not sufficiently lubricated\r\n01 = Sufficiently lubricated\r\n10 = Unable to determine if sufficiently lubricated\r\n11 = Not available or not installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3552": {
      "PGN": 65130,
      "PGN_Name": "Engine Fuel/Lube Systems",
      "PGN_Description": "EFS",
      "first_bit": 44,
      "SPN": 3552,
      "SPN_Name": "Engine Oil Pre-Heated State",
      "SPN_Description": "Indicates whether the engine oil pre-heated sufficiently for starting purposes.\r\n\r\n00 = Not sufficiently pre-heated\r\n01 = Sufficiently pre-heated\r\n10 = Unable to determine if engine oil is pre-heated sufficiently\r\n11 = Not available or not installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3553": {
      "PGN": 65130,
      "PGN_Name": "Engine Fuel/Lube Systems",
      "PGN_Description": "EFS",
      "first_bit": 46,
      "SPN": 3553,
      "SPN_Name": "Engine Coolant Pre-heated State",
      "SPN_Description": "Indicates whether the engine coolant is pre-heated sufficiently for starting purposes.\r\n\r\n00 = Not sufficiently pre-heated\r\n01 = Sufficiently pre-heated\r\n10 = Unable to determine  engine coolant pre-heated sufficiently\r\n11 = Not available or not installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3554": {
      "PGN": 65130,
      "PGN_Name": "Engine Fuel/Lube Systems",
      "PGN_Description": "EFS",
      "first_bit": 48,
      "SPN": 3554,
      "SPN_Name": "Engine Ventilation Status",
      "SPN_Description": "Engine ventilation control states.\r\n\r\n000 = Sufficiently vented (all combustible gases have been evacuated from intake and exhaust systems)\r\n001 = Ventilation needed (combustible gases may be present in intake and exhaust systems)\r\n010 = Ventilation delay (delay without cranking between ventilation and start engine states)\r\n011 = Currently venting (engine cranks w/o gas or ignition to clear intake and exhaust systems with air)\r\n100 = Reserved for SAE assignment\r\n101 = Reserved for SAE assignment \r\n110 = Not able to determine if sufficiently vented\r\n111 = Not available or not installe",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3557": {
      "PGN": 65274,
      "PGN_Name": "Brakes 1",
      "PGN_Description": "B1",
      "first_bit": 26,
      "SPN": 3557,
      "SPN_Name": "Parking Brake Red Warning Signal",
      "SPN_Description": "This parameter commands the Parking Brake red optical warning signal.\r\n\r\n00 – off\r\n01 – on\r\n10 – Reserved \r\n11 – Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3558": {
      "PGN": 64912,
      "PGN_Name": "Advertised Engine Torque Curve",
      "PGN_Description": "AETC",
      "first_bit": 0,
      "SPN": 3558,
      "SPN_Name": "AETC Data Collection Standard",
      "SPN_Description": "Indicates the standardized method by which torque data was obtained for the Advertised Engine Torque Curve (AETC).  For example, in North America, heavy duty diesel engine specifications are typically based on SAE J1995.  Other applicable SAE, ISO, or DIN standards may be added as necessary in the future.\r\n\r\n0000             SAE J1995\r\n0001-1101   Not Defined\r\n1111             Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3559": {
      "PGN": 64912,
      "PGN_Name": "Advertised Engine Torque Curve",
      "PGN_Description": "AETC",
      "first_bit": 4,
      "SPN": 3559,
      "SPN_Name": "Number of AETC data points",
      "SPN_Description": "Indicates the number of speed / torque data points contained in the Advertised Engine Torque Curve broadcast (AETC).  A minimum of 5 points is required, with a maximum of 15 points available as needed to accurately convey the curve.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3562": {
      "PGN": 64976,
      "PGN_Name": "Intake/Exhaust Conditions 2",
      "PGN_Description": "IC2",
      "first_bit": 24,
      "SPN": 3562,
      "SPN_Name": "Engine Intake Manifold #2 Pressure",
      "SPN_Description": "The gage pressure measurement of the air intake manifold for bank #2 or the second air intake manifold. If there are multiple air pressure sensors in the second intake stream, this is the last one in flow direction before entering the combustion chamber. See also SPNs 1127-1130 and SPN 102 for alternate range and resolution.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "3563": {
      "PGN": 64976,
      "PGN_Name": "Intake/Exhaust Conditions 2",
      "PGN_Description": "IC2",
      "first_bit": 32,
      "SPN": 3563,
      "SPN_Name": "Engine Intake Manifold #1 Absolute Pressure",
      "SPN_Description": "The absolute pressure measurement of the air intake manifold. If there are multiple air pressure sensors in the intake stream, this is the last one in flow direction before entering the combustion chamber.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "3564": {
      "PGN": 43264,
      "PGN_Name": "Forward Lane Image Command",
      "PGN_Description": "FLIC",
      "first_bit": 0,
      "SPN": 3564,
      "SPN_Name": "Lane Departure Warning Enable Command",
      "SPN_Description": "Command to enable/disable Lane Departure Indication\r\n\r\n00   Disable Lane Departure Warning\r\n01   Enable Lane Departure Warning\r\n10   Reserved\r\n11   Don´t care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3565": {
      "PGN": 61447,
      "PGN_Name": "Forward Lane Image 1",
      "PGN_Description": "FLI1",
      "first_bit": 0,
      "SPN": 3565,
      "SPN_Name": "Lane Departure Left",
      "SPN_Description": "Indicates that the middle of vehicle departs the lane on the left side. The parameter indicates that the vehicle is changing the lane to the left.\r\n\r\n00   Middle of the vehicle does not depart the lane to the left side\r\n01   Middle of the vehicle departs the lane to the left side\r\n10   Reserved\r\n11   Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3566": {
      "PGN": 61447,
      "PGN_Name": "Forward Lane Image 1",
      "PGN_Description": "FLI1",
      "first_bit": 2,
      "SPN": 3566,
      "SPN_Name": "Lane Departure Right",
      "SPN_Description": "Indicates that the middle of vehicle departs the lane on the right side. The parameter indicates that the vehicle is changing the lane to the right.\r\n\r\n00   Middle of the vehicle does not depart the lane to the right side\r\n01   Middle of the vehicle departs the lane to the right side\r\n10   Reserved\r\n11   Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3567": {
      "PGN": 64915,
      "PGN_Name": "Generator Control 1",
      "PGN_Description": "GC1",
      "first_bit": 4,
      "SPN": 3567,
      "SPN_Name": "Generator Control Not In Automatic Start State",
      "SPN_Description": "This parameter indicates whether or not the generator set is in a condition to automatically start up and provide power. If not, this status parameter is in the ACTIVE state.\r\n\r\n00 = inactive (ready to start automatically)\r\n01 = active (not ready to start automatically)\r\n10 = error\r\n11 = not available\r\n\r\nNote:  Legislative requirements for generator sets require that this condition be visually indicated (alarmed) on the local generator set control and remotely indicated on ancillary monitoring devices. The state has been defined in this manner ('Not in automatic start\") to allow the use of FMI 31 to indicate NOT ready to automatically start up and provide power, which is an undesired condition.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3568": {
      "PGN": 64915,
      "PGN_Name": "Generator Control 1",
      "PGN_Description": "GC1",
      "first_bit": 6,
      "SPN": 3568,
      "SPN_Name": "Generator Not Ready to Automatically Parallel State",
      "SPN_Description": "This parameter indicates whether or not all systems required to start the engine and close to the bus are prepared to operate automatically. If not, the generator is not ready to automatically parallel, and the status parameter is in the ACTIVE state.\r\n\r\n00 = inactive (ready to parallel)\r\n01 = active (not ready to parallel)\r\n10 = error\r\n11 = not available\r\n\r\nNote:  Legislative requirements for generator sets require that this condition be visually indicated (alarmed) on the local generator set control and remotely indicated on ancillary monitoring devices. The state has been defined in this manner (\"Not ready\") to allow the use of FMI 31 to indicate NOT ready to automatically parallel, which is an undesired condition.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3589": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 32,
      "SPN": 3589,
      "SPN_Name": "Engine Oil Priming Pump Control",
      "SPN_Description": "This control is used to activate a pump that lubricates the engine, particularly prior to initial engine startup.\r\n\r\n00 = Off\r\n01 = On\r\n10 = Reserved\r\n11 = unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3590": {
      "PGN": 64911,
      "PGN_Name": "Generator Total AC Percent Power",
      "PGN_Description": "GTACPP",
      "first_bit": 0,
      "SPN": 3590,
      "SPN_Name": "Generator Total Percent kW",
      "SPN_Description": "This parameter reports the generator total AC power, as a percentage of rated power.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -251,
      "unit": "%",
      "SLOT_ID": 256
    },
    "3591": {
      "PGN": 64911,
      "PGN_Name": "Generator Total AC Percent Power",
      "PGN_Description": "GTACPP",
      "first_bit": 16,
      "SPN": 3591,
      "SPN_Name": "Generator Total Percent kVA",
      "SPN_Description": "This parameter reports the generator total AC apparent power, as a percentage of rated power.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -251,
      "unit": "%",
      "SLOT_ID": 256
    },
    "3592": {
      "PGN": 64911,
      "PGN_Name": "Generator Total AC Percent Power",
      "PGN_Description": "GTACPP",
      "first_bit": 32,
      "SPN": 3592,
      "SPN_Name": "Generator Total Percent kVAr",
      "SPN_Description": "This parameter reports the generator total AC reactive power, as a percentage of rated power.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -251,
      "unit": "%",
      "SLOT_ID": 256
    },
    "3593": {
      "PGN": 64910,
      "PGN_Name": "Generator Total AC Reactive Energy",
      "PGN_Description": "GTACER",
      "first_bit": 0,
      "SPN": 3593,
      "SPN_Name": "Generator Total kVAr Hours Export",
      "SPN_Description": "This parameter reports the cumulative total AC reactive energy exported from the generator.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "kVArh",
      "SLOT_ID": 257
    },
    "3594": {
      "PGN": 64910,
      "PGN_Name": "Generator Total AC Reactive Energy",
      "PGN_Description": "GTACER",
      "first_bit": 32,
      "SPN": 3594,
      "SPN_Name": "Generator Total kVAr Hours Import",
      "SPN_Description": "This parameter reports the cumulative total AC reactive energy imported to the generator.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "kVArh",
      "SLOT_ID": 257
    },
    "3595": {
      "PGN": 64909,
      "PGN_Name": "Utility Total AC Reactive Energy",
      "PGN_Description": "UTACER",
      "first_bit": 0,
      "SPN": 3595,
      "SPN_Name": "Utility Total kVAr Hours Export",
      "SPN_Description": "This parameter reports the cumulative total AC reactive energy exported from the utility.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "kVArh",
      "SLOT_ID": 257
    },
    "3596": {
      "PGN": 64909,
      "PGN_Name": "Utility Total AC Reactive Energy",
      "PGN_Description": "UTACER",
      "first_bit": 32,
      "SPN": 3596,
      "SPN_Name": "Utility Total kVAr Hours Import",
      "SPN_Description": "This parameter reports the cumulative total AC reactive energy imported to the utility.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "kVArh",
      "SLOT_ID": 257
    },
    "3597": {
      "PGN": 65165,
      "PGN_Name": "Vehicle Electrical Power 2",
      "PGN_Description": "VEP2",
      "first_bit": 16,
      "SPN": 3597,
      "SPN_Name": "ECU Power Output Supply Voltage #1",
      "SPN_Description": "The first power output from an ECU.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "3598": {
      "PGN": 65165,
      "PGN_Name": "Vehicle Electrical Power 2",
      "PGN_Description": "VEP2",
      "first_bit": 32,
      "SPN": 3598,
      "SPN_Name": "ECU Power Output Supply Voltage #2",
      "SPN_Description": "The second power output from an ECU.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "3599": {
      "PGN": 65165,
      "PGN_Name": "Vehicle Electrical Power 2",
      "PGN_Description": "VEP2",
      "first_bit": 48,
      "SPN": 3599,
      "SPN_Name": "ECU Power Output Supply Voltage #3",
      "SPN_Description": "The third power output from an ECU.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "3600": {
      "PGN": 56832,
      "PGN_Name": "Reset",
      "PGN_Description": "RESET",
      "first_bit": 18,
      "SPN": 3600,
      "SPN_Name": "Steering Straight Ahead Position Reset",
      "SPN_Description": "Used to reset the straight ahead position for a steering sensor in the steering column or a steering controller's straight ahead position on any steerable axle.\r\n\r\n00 Take no action - Do not Reset\r\n01 Reset\r\n10 Reserved, take no action\r\n11 Not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3601": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 30,
      "SPN": 3601,
      "SPN_Name": "Engine Fuel Shutoff Valve Leak Test Control",
      "SPN_Description": "Control setting for fuel shutoff valve proving system test.  Typically, this type of system can only be used with a dual fuel shutoff system.  The test consists of a small pump to pressurize the chamber between the dual fuel shutoffs when they are closed.  After pressurizing, the test is passed if the pressure is above a certain threshold, indicating the fuel shutoffs are sealed completely shut without leaks.  Otherwise, a low pressure indicates a leak is present past one or both of the fuel shutoffs. \r\n\r\n00 = Off (reset / no test in process)\r\n01 = On (test in process / test complete)\r\n10 = Reserved\r\n11 = Don't care / take no action\r\n\r\nIn addition to communicating desired action of the fuel shutoff valve proving system test and its driver status, this new SPN can be used to communicate whether the fuel shutoff valve proving system test failed, through the use of FMIs.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3602": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 34,
      "SPN": 3602,
      "SPN_Name": "Engine Oil Pre-heater Control",
      "SPN_Description": "Control setting for an electrically actuated oil pre-heating device.\r\n\r\n00 = Off\r\n01 = On\r\n10 = Reserved\r\n11 = Don't care / take no action\r\n\r\nIn addition to communicating desired action of the electrically actuated oil pre-heater and its driver status, this new SPN can be used to communicate if any attempts to adequately pre-heat the oil are unsuccessful, through the use of FMIs.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3603": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 36,
      "SPN": 3603,
      "SPN_Name": "Engine Electrical System Power Conservation Control",
      "SPN_Description": "Control setting for cutting power to various devices when the engine is not in use.  Useful if it is desired to keep the engine in standby, with main control ECU still powered on and communictaing with outside world, but actuators and certain other ECUs can be de-powered.\r\n\r\n00 - Off (No Power conservation; all systems with supply power available)\r\n01 - On (power conservation active; certain systems have supply power witheld)\r\n10 - Reserved\r\n11 - Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3604": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 38,
      "SPN": 3604,
      "SPN_Name": "Engine Pre-Heater Control",
      "SPN_Description": "Control setting for an electrically actuated engine block or coolant pre-heating device.\r\n\r\n00 - Off \r\n01 - On\r\n10 - Reserved\r\n11 - Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3605": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 40,
      "SPN": 3605,
      "SPN_Name": "Engine Coolant Pump Control",
      "SPN_Description": "Control setting for an electrically actuated engine coolant circulating pump. \r\n\r\n00 = Off\r\n01 = On\r\n10 = Reserved\r\n11 = Don't care / take no action\r\n.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3606": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 42,
      "SPN": 3606,
      "SPN_Name": "Engine Controlled Shutdown Request",
      "SPN_Description": "A signal issued by the engine control system to a user or external system requesting for a controlled shutdown.  This request is made when engine protection diagnostics determine a condition warrants a shutdown soon, but it is not severe enough to necessitate an immediate shutdown.  This function gives notice such that the engine can be unloaded and cooled down before stopping.\r\n\r\n00 = Off (No Shutdown Requested)\r\n01 = On (Shutdown Requested)\r\n10 = Reserved\r\n11 = Don't care / take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3607": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 44,
      "SPN": 3607,
      "SPN_Name": "Engine Emergency (Immediate) Shutdown Indication",
      "SPN_Description": "A signal issued by the engine control system to a user or external system indicating that it is immediately shutting the engine down.  This indication is made when engine protection diagnostics determine a condition necessitates an immediate shutdown.  This function gives notice that this has occurred.\r\n\r\n00 = Off (No Shutdown Requested)\r\n01 = On (Shutdown Requested)\r\n10 = Reserved\r\n11 = Don't care / take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3608": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 24,
      "SPN": 3608,
      "SPN_Name": "Engine Fuel Shutoff Vent Control",
      "SPN_Description": "Control setting for a fuel shutoff vent.  Typically, for a dual fuel shutoff system, the vent line is located between them and is plumbed to vent outside to atmosphere.  The vent control typically always actuates opposite to that of the fuel shutoff(s) control.  Thus, when the fuel shutoff(s) are closed, the vent is open, thereby 'ventilating' any leftover or leaking gas from the fuel shutoff.  When the fuel shutoff(s) are open, the vent is closed, thereby all gas passes through to the engine.\r\n\r\n00 = Closed (vent closed)\r\n01 = Open (vent open)\r\n10 = Reserved\r\n11 = Don't care / take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3609": {
      "PGN": 64908,
      "PGN_Name": "Aftertreatment 1 Gas Parameters",
      "PGN_Description": "AT1GP",
      "first_bit": 0,
      "SPN": 3609,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Intake Pressure",
      "SPN_Description": "This parameter indicates the diesel particulate filter intake gage pressure 1 (bank 1).",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3610": {
      "PGN": 64908,
      "PGN_Name": "Aftertreatment 1 Gas Parameters",
      "PGN_Description": "AT1GP",
      "first_bit": 16,
      "SPN": 3610,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Outlet Pressure",
      "SPN_Description": "This parameter indicates the diesel particulate filter outlet gage pressure 1 (bank 1).",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3611": {
      "PGN": 64907,
      "PGN_Name": "Aftertreatment 2 Gas Parameters",
      "PGN_Description": "AT2GP",
      "first_bit": 0,
      "SPN": 3611,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Intake Pressure",
      "SPN_Description": "This parameter indicates the diesel particulate filter intake gage pressure 2 (bank 2).",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3612": {
      "PGN": 64907,
      "PGN_Name": "Aftertreatment 2 Gas Parameters",
      "PGN_Description": "AT2GP",
      "first_bit": 16,
      "SPN": 3612,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Outlet Pressure",
      "SPN_Description": "This parameter indicates the diesel particulate filter outlet gage pressure 2 (bank 2).",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3613": {
      "PGN": 43008,
      "PGN_Name": "Text Display",
      "PGN_Description": "DISP1",
      "first_bit": 0,
      "SPN": 3613,
      "SPN_Name": "Text Display Instructions",
      "SPN_Description": "This parameter describes the status for the display how to show the information.\r\n\r\n0000 Clear display - The displayed information should be deleted or not displayed any more.\r\n0001 Hold display - The presently displayed information should be retained\r\n0010 Append at end of display - The transmitted information should be displayed at the end of the presently displayed information\r\n0011 Overwrite display - The presently displayed information is to be overwritten with the transmitted information\r\n0100 Overwrite substring - A portion of the presently displayed information is to be overwritten with the transmitted information starting at display text index (SPN 3614)\r\n0101 Highlight substring\r\n0110 Blink substring\r\n0111-1110  Reserved\r\n1111 - Not applicable",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3614": {
      "PGN": 43008,
      "PGN_Name": "Text Display",
      "PGN_Description": "DISP1",
      "first_bit": 16,
      "SPN": 3614,
      "SPN_Name": "Text Display Index",
      "SPN_Description": "Used for overwriting consecutive bytes of a displayed string when byte 1 \"Text Display Instructions\" state is set for \"overwrite substring\" mode.  When used, this byte declares where in the text string that the new text will start overwriting, this number is also known as the start byte.  As usual for the transmitted text string, the Text Display Characters will be sent and then terminated by the null character, this will be the stop byte indicator to declare when to stop overwriting.\r\n\r\nEXAMPLE: To only modify 3 bytes (50, 51, 52) of an 87 byte character string.\r\n  Text Display Instructions - set to 0100b (Overwrite substring)\r\n  Text Display Index - set to 50d (starting byte of desired overwrite)\r\n  Text Display Characters - 3 characters sent, then the null ending byte",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "3619": {
      "PGN": 64906,
      "PGN_Name": "SAE J2012 DTC Display",
      "PGN_Description": "J2012",
      "first_bit": 0,
      "SPN": 3619,
      "SPN_Name": "Number of J2012 DTCs",
      "SPN_Description": "The number J2012 DTCs being conveyed in PGN 64906.  If the value of this parameter is zero, the device broadcasting PGN 64906 has no active or previously active J2012 DTCs.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "3620": {
      "PGN": 64906,
      "PGN_Name": "SAE J2012 DTC Display",
      "PGN_Description": "J2012",
      "first_bit": 8,
      "SPN": 3620,
      "SPN_Name": "J2012 DTC",
      "SPN_Description": "Five character ASCII SAE J2012 DTC, sent most significant byte first.",
      "bit_length": 40,
      "scaling": 1,
      "offset": 0,
      "unit": "ASCII",
      "SLOT_ID": 273
    },
    "3621": {
      "PGN": 64906,
      "PGN_Name": "SAE J2012 DTC Display",
      "PGN_Description": "J2012",
      "first_bit": 48,
      "SPN": 3621,
      "SPN_Name": "J2012 DTC Status",
      "SPN_Description": "Indicates if the respective SAE J2012 DTC is active or previously active.\r\n\r\n0 - DTC is previously active\r\n1 - DTC is active",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "3622": {
      "PGN": 64906,
      "PGN_Name": "SAE J2012 DTC Display",
      "PGN_Description": "J2012",
      "first_bit": 49,
      "SPN": 3622,
      "SPN_Name": "J2012 DTC Occurrence Count",
      "SPN_Description": "Number of occurrences of the respective SAE J2012 DTC being conveyed.\r\nIf more than 126 occurrences happen the value shall be set to 126.\r\nIf the occurrence count is not available to be sent then this value shall be set to 127.",
      "bit_length": 7,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 260
    },
    "3623": {
      "PGN": 64905,
      "PGN_Name": "Vehicle Direction/Speed 2",
      "PGN_Description": "VDS2",
      "first_bit": 0,
      "SPN": 3623,
      "SPN_Name": "Vehicle Roll",
      "SPN_Description": "This parameter indicates the roll in degrees from level.  Facing the direction of travel a tip to the left would be indicated by a negative number and a tip to the right would be indicated by a positive number.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "3624": {
      "PGN": 64904,
      "PGN_Name": "Engine Fluid Level/Pressure 5",
      "PGN_Description": "EFL/P5",
      "first_bit": 0,
      "SPN": 3624,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #1",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #1.  \r\n\r\nThis intake valve pressure is at the first cylinder in the engine, while SPN 2948 reflects the intake valve pressure of the entire engine system.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3625": {
      "PGN": 64904,
      "PGN_Name": "Engine Fluid Level/Pressure 5",
      "PGN_Description": "EFL/P5",
      "first_bit": 16,
      "SPN": 3625,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #2",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #2.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3626": {
      "PGN": 64904,
      "PGN_Name": "Engine Fluid Level/Pressure 5",
      "PGN_Description": "EFL/P5",
      "first_bit": 32,
      "SPN": 3626,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #3",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #3.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3627": {
      "PGN": 64904,
      "PGN_Name": "Engine Fluid Level/Pressure 5",
      "PGN_Description": "EFL/P5",
      "first_bit": 48,
      "SPN": 3627,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #4",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #4.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3628": {
      "PGN": 64903,
      "PGN_Name": "Engine Fluid Level/Pressure 6",
      "PGN_Description": "EFL/P6",
      "first_bit": 0,
      "SPN": 3628,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #5",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #5.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3629": {
      "PGN": 64903,
      "PGN_Name": "Engine Fluid Level/Pressure 6",
      "PGN_Description": "EFL/P6",
      "first_bit": 16,
      "SPN": 3629,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #6",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #6.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3630": {
      "PGN": 64903,
      "PGN_Name": "Engine Fluid Level/Pressure 6",
      "PGN_Description": "EFL/P6",
      "first_bit": 32,
      "SPN": 3630,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #7",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #7.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3631": {
      "PGN": 64903,
      "PGN_Name": "Engine Fluid Level/Pressure 6",
      "PGN_Description": "EFL/P6",
      "first_bit": 48,
      "SPN": 3631,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #8",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #8.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3632": {
      "PGN": 64902,
      "PGN_Name": "Engine Fluid Level/Pressure 7",
      "PGN_Description": "EFL/P7",
      "first_bit": 0,
      "SPN": 3632,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #9",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #9.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3633": {
      "PGN": 64902,
      "PGN_Name": "Engine Fluid Level/Pressure 7",
      "PGN_Description": "EFL/P7",
      "first_bit": 16,
      "SPN": 3633,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #10",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #10.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3634": {
      "PGN": 64902,
      "PGN_Name": "Engine Fluid Level/Pressure 7",
      "PGN_Description": "EFL/P7",
      "first_bit": 32,
      "SPN": 3634,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #11",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #11.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3635": {
      "PGN": 64902,
      "PGN_Name": "Engine Fluid Level/Pressure 7",
      "PGN_Description": "EFL/P7",
      "first_bit": 48,
      "SPN": 3635,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #12",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #12.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3636": {
      "PGN": 64901,
      "PGN_Name": "Engine Fluid Level/Pressure 8",
      "PGN_Description": "EFL/P8",
      "first_bit": 0,
      "SPN": 3636,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #13",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #13.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3637": {
      "PGN": 64901,
      "PGN_Name": "Engine Fluid Level/Pressure 8",
      "PGN_Description": "EFL/P8",
      "first_bit": 16,
      "SPN": 3637,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #14",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #14.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3638": {
      "PGN": 64901,
      "PGN_Name": "Engine Fluid Level/Pressure 8",
      "PGN_Description": "EFL/P8",
      "first_bit": 32,
      "SPN": 3638,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #15",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #15.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3639": {
      "PGN": 64901,
      "PGN_Name": "Engine Fluid Level/Pressure 8",
      "PGN_Description": "EFL/P8",
      "first_bit": 48,
      "SPN": 3639,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #16",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #16.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3640": {
      "PGN": 64900,
      "PGN_Name": "Engine Fluid Level/Pressure 9",
      "PGN_Description": "EFL/P9",
      "first_bit": 0,
      "SPN": 3640,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #17",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #17.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3641": {
      "PGN": 64900,
      "PGN_Name": "Engine Fluid Level/Pressure 9",
      "PGN_Description": "EFL/P9",
      "first_bit": 16,
      "SPN": 3641,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #18",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #18.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3642": {
      "PGN": 64900,
      "PGN_Name": "Engine Fluid Level/Pressure 9",
      "PGN_Description": "EFL/P9",
      "first_bit": 32,
      "SPN": 3642,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #19",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #19.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3643": {
      "PGN": 64900,
      "PGN_Name": "Engine Fluid Level/Pressure 9",
      "PGN_Description": "EFL/P9",
      "first_bit": 48,
      "SPN": 3643,
      "SPN_Name": "Engine Intake Valve Actuation Oil Pressure for Cylinder #20",
      "SPN_Description": "The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #20.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3644": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 56,
      "SPN": 3644,
      "SPN_Name": "Engine Derate Request",
      "SPN_Description": "This parameter is a derate request made from the engine control system to an external system, where the engine is requesting an external device to reduce the load being applied.  A zero value indicates that there is no derate being requested and 100% means full derate being requested.  Any non-zero value represents a derate is being requested, at a percentage of full load.  The engine control system identifies any problems and determines the amount of derate the situation calls for. This parameter can be useful to customer applications that prefer awareness and control of the engine derate.\r\n\r\nSee also SPN 8436 for a Derate Request in kW.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "3645": {
      "PGN": 64899,
      "PGN_Name": "Transfer Case Information",
      "PGN_Description": "TCI",
      "first_bit": 0,
      "SPN": 3645,
      "SPN_Name": "Transfer case status",
      "SPN_Description": "This parameter describes the feedback from the  transfer case controller . Used by instrument clusters,  tachographs, PTOs , etc.\r\n\r\n000 2 wheel high (normal or `'On Highway' Range)\r\n001 4 wheel high (normal or  'On Highway' Range\r\n010 neutral\r\n011 2 wheel low (or `'Off Highway' Range)\r\n100 4 wheel low (or `'Off Highway' Range)\r\n101 Transfer Case Shift in Progress or gear not confirmed\r\n110 error\r\n111 not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3667": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 56,
      "SPN": 3667,
      "SPN_Name": "Engine Air Shutoff Status",
      "SPN_Description": "State signal which indicates the actual measured position of the Air Shutoff.\r\n\r\n00 - Air flow allowed to engine\r\n01 - Air flow restricted\r\n10 - Error\r\n11 - Not Available\r\n\r\nNote:   This parameter, in conjunction with SPN 2813 - \"Engine Air Shutoff Command Status\", is provided to allow an external system to annunciate and/or alarm on either an accidental air shutoff (shutoff detected but not commanded), or a failed air shutoff (shutoff commanded but not detected).",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3668": {
      "PGN": 64938,
      "PGN_Name": "Engine Fluid Level/Pressure 4",
      "PGN_Description": "EFL/P4",
      "first_bit": 40,
      "SPN": 3668,
      "SPN_Name": "Engine Charge Air Cooler Coolant Level",
      "SPN_Description": "Ratio of volume of liquid found in an engine charge air cooler cooling system to total engine charge air cooler cooling system volume.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "3669": {
      "PGN": 65214,
      "PGN_Name": "Electronic Engine Controller 4",
      "PGN_Description": "EEC4",
      "first_bit": 32,
      "SPN": 3669,
      "SPN_Name": "Engine Rotation Direction",
      "SPN_Description": "Direction of engine rotation, as reported by the engine.  Direction convention as viewed by an observer standing at the rear of the engine, viewing the flywheel.\r\n\r\n00 - CounterClockWise (CCW)\r\n01 - ClockWise (CW)\r\n10 - Unknown  (Rotation Direction Unknown)\r\n11 - Not Available\r\n\r\nWhen the rotation direction is yet to be detected, Unknown will be reported.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3670": {
      "PGN": 64895,
      "PGN_Name": "Engine Configuration 2",
      "PGN_Description": "EC2",
      "first_bit": 0,
      "SPN": 3670,
      "SPN_Name": "Maximum Crank Attempts per Start Attempt",
      "SPN_Description": "The number of cranking cycles that will be performed before ending the start attempt.  This is intended to be used in conjunction with Crank Attempt Count on Present Start Attempt, in order to give a FMI 0 diagnostic on the latter.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "3671": {
      "PGN": 65214,
      "PGN_Name": "Electronic Engine Controller 4",
      "PGN_Description": "EEC4",
      "first_bit": 40,
      "SPN": 3671,
      "SPN_Name": "Crank Attempt Count on Present Start Attempt",
      "SPN_Description": "Reports the number of cranking cycles undergone during the present start attempt.\r\n\r\nNote:  This is intended to be used in conjunction with Maximum Crank Attempts per Start Attempt, in order to give a FMI 0 diagnostic on this parameter when the count exceeds the maximum.  When the engine is not in a start attempt, this parameter can either hold the last value or return a Not Available (0xFF).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "3672": {
      "PGN": 64897,
      "PGN_Name": "EGR Cooler Bypass",
      "PGN_Description": "EGRBV",
      "first_bit": 0,
      "SPN": 3672,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Cooler Bypass Actuator Postion",
      "SPN_Description": "The parameter gives the % open of the exhaust gas recirculation cooler bypass actuator, where 0% = Fully Closed (no gas flowing through the bypass), and 100% = Fully Open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "3673": {
      "PGN": 65266,
      "PGN_Name": "Fuel Economy (Liquid)",
      "PGN_Description": "LFE1",
      "first_bit": 56,
      "SPN": 3673,
      "SPN_Name": "Engine Throttle Valve 2 Position",
      "SPN_Description": "The sensed position feedback of the valve, coming from a second electrical actuator for a second throttle plate, used to regulate the supply of a fluid, usually air or fuel//air mixture.  0% represents no supply and 100% is full supply. SPN 51 is used for the first throttle position feedback.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "3675": {
      "PGN": 64931,
      "PGN_Name": "Electronic Engine Controller 6",
      "PGN_Description": "EEC6",
      "first_bit": 24,
      "SPN": 3675,
      "SPN_Name": "Engine Turbocharger Compressor Bypass Actuator 1 Position",
      "SPN_Description": "Measures the position of the turbocharger compressor bypass actuator, where 0% represents bypass fully closed and 100% represents bypass fully open.  Typically, the compressor bypass is used to lower the compressor outlet pressure and/or intake manifold pressure during situations where too much boost is being generated by the turbocharger.  Typically, a compressor bypass will be plumbed from the compressor outlet or intake manifold back to the compressor intake, with the compressor bypass actuator and valve in place to regulate bypass flow.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "3676": {
      "PGN": 64938,
      "PGN_Name": "Engine Fluid Level/Pressure 4",
      "PGN_Description": "EFL/P4",
      "first_bit": 48,
      "SPN": 3676,
      "SPN_Name": "Engine Aftercooler Coolant Level",
      "SPN_Description": "Ratio of aftercooler coolant system volume of liquid to total cooling system volume.  The engine aftercooler coolant level is for  the low temperature (LT) cooling circuit used for the compressor outlet air or charge aftercooling.  \r\n\r\nSPN 111 \"Coolant Level\" is assumed to represent a high temperature (HT) cooling circuit used for cooling the engine and its various components.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "3683": {
      "PGN": 61469,
      "PGN_Name": "Steering Angle Sensor Information",
      "PGN_Description": "SAS",
      "first_bit": 0,
      "SPN": 3683,
      "SPN_Name": "Steering Wheel Angle",
      "SPN_Description": "The main operator`s steering wheel angle (on the steering column, not the actual wheel angle). The vehicle being steered to the left (counterclockwise) results in a positive steering wheel angle.  This is the yaw angle of the steering wheel with the z-axis along the centerline of the steering column. This parameter is defined according to a Z-Up axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Up Axis System has positive X directed forward, positive Y to the left, and positive Z directed up.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": -31.374,
      "unit": "rad",
      "SLOT_ID": 113
    },
    "3684": {
      "PGN": 61469,
      "PGN_Name": "Steering Angle Sensor Information",
      "PGN_Description": "SAS",
      "first_bit": 16,
      "SPN": 3684,
      "SPN_Name": "Steering Wheel Angle Range Counter",
      "SPN_Description": "The signal indicates the number of steering wheel angle range overflows if the operating range of steering wheel is greater than the measuring range of sensor element. Positive values indicate left turns (counterclockwise). If the steering wheel angle range is +/-180 degrees this signal is equivalent to a steering wheel turn counter.  This parameter is defined according to a Z-Up axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Up Axis System has positive X directed forward, positive Y to the left, and positive Z directed up.",
      "bit_length": 6,
      "scaling": 1,
      "offset": -32,
      "unit": "range",
      "SLOT_ID": 263
    },
    "3685": {
      "PGN": 61469,
      "PGN_Name": "Steering Angle Sensor Information",
      "PGN_Description": "SAS",
      "first_bit": 22,
      "SPN": 3685,
      "SPN_Name": "Steering Wheel Angle Range Counter Type",
      "SPN_Description": "The signal indicates whether the steering wheel angle sensor is capable of absolute measuring of the number of steering wheel angle ranges or not.  Absolute measuring means that the steering wheel angle range counter signal indicates the real position of steering wheel at ignition on.  Relative measuring means that the steering wheel angle range counter signal is zero at ignition on independent of the real position of steering wheel.\r\n\r\n00 - relative number of counts\r\n01 - absolute number of counts\r\n10 - not defined\r\n11 - signal not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3686": {
      "PGN": 61469,
      "PGN_Name": "Steering Angle Sensor Information",
      "PGN_Description": "SAS",
      "first_bit": 32,
      "SPN": 3686,
      "SPN_Name": "Steering Wheel Angle Range",
      "SPN_Description": "The signal indicates the range of  the steering wheel angle the sensor element is capable to measure. The steering wheel angle signal ranges between the negative and the positive value of the steering wheel angle range.\r\n\r\nFor example, a steering angle sensor transmits +13.6 rad to indicate a range of +/- 13.6 rad.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": -31.374,
      "unit": "rad",
      "SLOT_ID": 113
    },
    "3687": {
      "PGN": 61469,
      "PGN_Name": "Steering Angle Sensor Information",
      "PGN_Description": "SAS",
      "first_bit": 48,
      "SPN": 3687,
      "SPN_Name": "Steering Angle Sensor Active Mode",
      "SPN_Description": "This signal indicates the operational mode of the steering angle sensor.\r\n\r\n00 – Programming mode active\r\n01 – Normal mode active\r\n10 – Reserved\r\n11 – Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3688": {
      "PGN": 61469,
      "PGN_Name": "Steering Angle Sensor Information",
      "PGN_Description": "SAS",
      "first_bit": 50,
      "SPN": 3688,
      "SPN_Name": "Steering Angle Sensor Calibrated",
      "SPN_Description": "This signal indicates the calibration status of the steering angle sensor.\r\n\r\n00 – SAS not calibrated\r\n01 – SAS calibrated\r\n10 – Reserved\r\n11 – Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3689": {
      "PGN": 61469,
      "PGN_Name": "Steering Angle Sensor Information",
      "PGN_Description": "SAS",
      "first_bit": 56,
      "SPN": 3689,
      "SPN_Name": "Message Counter",
      "SPN_Description": "The message counter is to verify the signal path from the demanding device to the steering controller.  The support of this parameter is mandatory.\r\n\r\nNote:  The initial value of the 4 bit message counter for the first message during a driving cycle is arbitrary. In every following message the counter is incremented by 1  (0 follows 15).",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 220
    },
    "3690": {
      "PGN": 61469,
      "PGN_Name": "Steering Angle Sensor Information",
      "PGN_Description": "SAS",
      "first_bit": 60,
      "SPN": 3690,
      "SPN_Name": "Message Checksum",
      "SPN_Description": "The message checksum is used to verify the signal path from the demanding device to the steering controller.  The support of this parameter is mandatory if PGN 61469 is supported as there is no means to indicate “not available”.\r\n\r\nThe 4 bit checksum is the sum of the high nibble and the low nibble of the sum of the identifier, the first 7 data bytes and the 4 bit message counter.  It is calculated as follows:\r\n\r\nChecksum = (Byte1 + Byte2 + Byte3 + Byte4 + Byte5 + Byte6 + Byte7 + (message counter & 0x0F) + message ID low byte + message ID mid low byte + message ID mid high byte + message ID high byte)\r\n\r\nChecksum = ((Checksum >> 4) + Checksum) & 0x0F",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 220
    },
    "3691": {
      "PGN": 64894,
      "PGN_Name": "Adaptive Front-Lighting System Status",
      "PGN_Description": "AFSS",
      "first_bit": 0,
      "SPN": 3691,
      "SPN_Name": "Left Headlamp Dynamic Bending Light",
      "SPN_Description": "This parameter indicates whether the dynamic bending light of the left headlamp is working properly.\r\n\r\n000   Dynamic bending light deactivated.  There is no problem but for some reasons (e.g. daylight present) the bending light is deactivated.\r\n001   Dynamic bending light is working properly.  Normal operation mode. Bending light is working properly.\r\n010   Dynamic bending light fail safe position.  Bending light is damaged, current position does not affect oncoming traffic.\r\n011   Dynamic bending light failure.  Bending light does not work, current position may affect oncoming traffic.\r\n100 – 110 Reserved\r\n111   Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3692": {
      "PGN": 64894,
      "PGN_Name": "Adaptive Front-Lighting System Status",
      "PGN_Description": "AFSS",
      "first_bit": 3,
      "SPN": 3692,
      "SPN_Name": "Right Headlamp Dynamic Bending Light",
      "SPN_Description": "This parameter indicates whether the dynamic bending light of the left headlamp is working properly.\r\n\r\n000   Dynamic bending light deactivated.  There is no problem but for some reasons (e.g. daylight present) the bending light is deactivated.\r\n001   Dynamic bending light is working properly.  Normal operation mode. Bending light is working properly.\r\n010   Dynamic bending light fail safe position.  Bending light is damaged, current position does not affect oncoming traffic.\r\n011   Dynamic bending light failure.  Bending light does not work, current position may affect oncoming traffic.\r\n100 – 110 Reserved\r\n111   Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3693": {
      "PGN": 64894,
      "PGN_Name": "Adaptive Front-Lighting System Status",
      "PGN_Description": "AFSS",
      "first_bit": 8,
      "SPN": 3693,
      "SPN_Name": "Left Headlamp Light Distribution",
      "SPN_Description": "This parameter indicates what kind of light distribution is set by the AFS system for the left headlamp.\r\n\r\n0000   Light distribution town - The basic light distribution for town light is generated with a symmetrical cut-off line (Class V)\r\n0001   Light distribution country - Country light is mostly similar to the actual SAE low beam pattern. (Class C)\r\n0010   Light distribution motorway - The task of motorway light is an improved overall viewing distance and an optimum of illumination of the second lane on roads with more than one lane and without oncoming traffic. (Class E)\r\n0011   Light distribution high beam - The high beam distribution of the module generates an illumination level that an additional high beam spot is not necessary.\r\n0100   Light distribution adverse weather - The adverse weather light improves the viewing situation for the driver on wet roads and reduces the amount of glare from reflections on wed reads for the oncoming traffic. (Class W) \r\n0101   Light distribution fail safe position - Module is damaged, current light distribution does not affect oncoming traffic.\r\n0110   Light distribution failure - Module is damaged, current position may affect oncoming traffic.\r\n0111   Different light distributions not available -  No AFS distributions available. Head lamp has only one distribution.\r\n1000 – 1110   Reserved\r\n1111   Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3694": {
      "PGN": 64894,
      "PGN_Name": "Adaptive Front-Lighting System Status",
      "PGN_Description": "AFSS",
      "first_bit": 12,
      "SPN": 3694,
      "SPN_Name": "Right Headlamp Light Distribution",
      "SPN_Description": "This parameter indicates what kind of light distribution is set by the AFS system for the right headlamp.\r\n\r\n0000   Light distribution town - The basic light distribution for town light is generated with a symmetrical cut-off line (Class V)\r\n0001   Light distribution country - Country light is mostly similar to the actual SAE low beam pattern. (Class C)\r\n0010   Light distribution motorway - The task of motorway light is an improved overall viewing distance and an optimum of illumination of the second lane on roads with more than one lane and without oncoming traffic. (Class E)\r\n0011   Light distribution high beam - The high beam distribution of the module generates an illumination level that an additional high beam spot is not necessary.\r\n0100   Light distribution adverse weather - The adverse weather light improves the viewing situation for the driver on wet roads and reduces the amount of glare from reflections on wed reads for the oncoming traffic. (Class W) \r\n0101   Light distribution fail safe position - Module is damaged, current light distribution does not affect oncoming traffic.\r\n0110   Light distribution failure - Module is damaged, current position may affect oncoming traffic.\r\n0111   Different light distributions not available -  No AFS distributions available. Head lamp has only one distribution.\r\n1000 – 1110   Reserved\r\n1111   Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "3695": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 40,
      "SPN": 3695,
      "SPN_Name": "Aftertreatment Regeneration Inhibit Switch",
      "SPN_Description": "Indicates the state of a switch available to the operator that inhibits aftertreatment regeneration. \r\n \r\n00 not active \r\n01 active \r\n10 error \r\n11 not available \r\n \r\nThis SPN would be “not active” when aftertreatment regeneration is allowed to occur normally (aftertreatment regeneration is not inhibited). \r\n \r\nThe engine controller shall inhibit regeneration when SPN 3695 is in the ON state.  Regeneration shall be activated by SPN 3696 when it is in the ON state and SPN 3695 is in the OFF state.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3696": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 42,
      "SPN": 3696,
      "SPN_Name": "Aftertreatment Regeneration Force Switch",
      "SPN_Description": "Indicates the state of a switch available to the operator that forces aftertreatment regeneration. \r\n \r\n00 not active \r\n01 active \r\n10 error \r\n11 not available \r\n \r\nThis SPN would be “not active” when aftertreatment regeneration is allowed to occur normally (aftertreatment regeneration is not being forced). \r\n \r\nThe engine controller shall inhibit regeneration when SPN 3695 is in the ON state.  Regeneration shall be activated by SPN 3696 when it is in the ON state and SPN 3695 is in the OFF state.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3697": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 0,
      "SPN": 3697,
      "SPN_Name": "Diesel Particulate Filter Lamp Command",
      "SPN_Description": "Command to control the diesel particulate filter lamp.\r\n\r\n000 Off\r\n001 On – solid\r\n010 reserved for SAE assignment \r\n011 reserved for SAE assignment\r\n100 On – fast blink (1 HZ)\r\n101 reserved for SAE assignment\r\n110 reserved for SAE assignment\r\n111 not available\r\n\r\nThis SPN would be “off” when diesel particulate filter lamp is unlit.  The \"on - solid\" should indicate that diesel particulate filter active regeneration is needed at the lowest level of urgency and that operator intervention is required.  The flashing state indicates a more severe condition requiring regeneration.  \r\n\r\nThis SPN shall not be used to convey information regarding operator switch feedback from SPNs 3695 and 3696.\r\n\r\nThe ISO 2575 Symbol F21 is recommended for use with this message.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3698": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 50,
      "SPN": 3698,
      "SPN_Name": "Exhaust System High Temperature Lamp Command",
      "SPN_Description": "Command to control the exhaust system high temperature lamp.  This lamp indicates that the exhaust system temperature is high.\r\n\r\n000 Off\r\n001 On – solid \r\n010 reserved for SAE assignment \r\n011 reserved for SAE assignment\r\n100 reserved for SAE assignment\r\n101 reserved for SAE assignment\r\n110 reserved for SAE assignment\r\n111 not available\r\n\r\nThis SPN would be “off” when the lamp is unlit.  The \"on - solid\" status indicates that the exhaust gas temperature is high.\r\n\r\nThis SPN shall not be used to convey information regarding operator switch feedback from SPNs 3695 and 3696.\r\n  \r\nThe ISO 2575 Symbol \"F.26\" is recommended for use with this message.  This symbol is the ISO exhaust gas symbol with the temperature symbol added to it.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3699": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 8,
      "SPN": 3699,
      "SPN_Name": "Aftertreatment Diesel Particulate Filter Passive Regeneration Status",
      "SPN_Description": "Indicates the state of diesel particulate filter passive regeneration.  This is an aggregate of bank 1 and bank 2.  It is a system status and not individual bank status.\r\n\r\n\r\n00 not active\r\n01 active\r\n10 reserved for SAE assignment\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3700": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 10,
      "SPN": 3700,
      "SPN_Name": "Aftertreatment Diesel Particulate Filter Active Regeneration Status",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration.  This is an aggregate of bank 1 and bank 2.  It is a system status and not individual bank status.\r\n\r\n00 not active\r\n01 active\r\n10 regeneration needed - automatically initiated active regeneration imminent\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3701": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 12,
      "SPN": 3701,
      "SPN_Name": "Aftertreatment Diesel Particulate Filter Status",
      "SPN_Description": "Indicates the state of the diesel particulate filter regeneration need and urgency.  This is an aggregate of bank 1 and bank 2.  It is a system status and not individual bank status.\r\n\r\n000 Regeneration not needed\r\n001 Regeneration needed - lowest level\r\n010 Regeneration needed - moderate level\r\n011 Regeneration needed - highest level\r\n100 reserved for SAE assignment\r\n101 reserved for SAE assignment\r\n110 reserved for SAE assignment\r\n111 not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3702": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 16,
      "SPN": 3702,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Status",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an active regeneration or will exit an active regeneration.  If the reason for inhibiting is not covered by SPNs 3703 thru 3717 or 5629, a request for a status parameter should be submitted to the SAE Truck and Bus J1939 Request Processing Group to have the reason added.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3703": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 18,
      "SPN": 3703,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to Inhibit Switch",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to the Diesel Particulate Filter Regeneration Inhibit Switch.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3704": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 20,
      "SPN": 3704,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to Clutch Disengaged",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to the clutch being disengaged.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3705": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 22,
      "SPN": 3705,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to Service Brake Active",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to the service brake being active.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3706": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 24,
      "SPN": 3706,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to PTO Active",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to the PTO being active.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3707": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 26,
      "SPN": 3707,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to Accelerator Pedal Off Idle",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to the accelerator pedal being off idle.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3708": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 28,
      "SPN": 3708,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to Out of Neutral",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to the transmission being out of neutral.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3709": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 30,
      "SPN": 3709,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to Vehicle Speed Above Allowed Speed",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to the vehicle speed being above an allowed limit.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3710": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 32,
      "SPN": 3710,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to Parking Brake Not Set",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to the parking brake being not set.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3711": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 34,
      "SPN": 3711,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to Low Exhaust Temperature",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to the exhaust temperature being too low.  This implies that the diesel particulate filter and/or oxidation catalyst are likewise too cold for active regeneration.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3712": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 36,
      "SPN": 3712,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to System Fault Active",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to a system fault being active.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3713": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 38,
      "SPN": 3713,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to System Timeout",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to a system timeout.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3714": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 40,
      "SPN": 3714,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to Temporary System Lockout",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to a temporary system lockout.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3715": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 42,
      "SPN": 3715,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to Permanent System Lockout",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to a permanent system lockout.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3716": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 44,
      "SPN": 3716,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to Engine Not Warmed Up",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to the engine not being warmed up.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3717": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 46,
      "SPN": 3717,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to Vehicle Speed Below Allowed Speed",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to vehicle speed being less than the allowed vehicle speed.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3718": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 48,
      "SPN": 3718,
      "SPN_Name": "Diesel Particulate Filter Automatic Active Regeneration Initiation Configuration",
      "SPN_Description": "Indicates the configuration of diesel particulate filter active regeneration automatic initiation.\r\n\r\n00 not enabled\r\n01 enabled\r\n10 reserved for SAE assignment\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3719": {
      "PGN": 64891,
      "PGN_Name": "Aftertreatment 1 Service 1",
      "PGN_Description": "AT1S1",
      "first_bit": 0,
      "SPN": 3719,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Soot Load Percent",
      "SPN_Description": "Indicates the soot load percent of diesel particulate filter 1.  100% is the level at which active diesel particulate filter regeneration should be triggered.\r\n\r\n100% level is the active regeneration trigger level (and if conditions are not favorable for regeneration, soot loading can continue beyond 100%).  During normal operation and regeneration a value 0% will indicate a fully regenerated diesel particulate filter.  Values of 25%, 50% and 75% will indicate the general level of soot prior to the 100% level where an active regeneration is needed.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "3720": {
      "PGN": 64891,
      "PGN_Name": "Aftertreatment 1 Service 1",
      "PGN_Description": "AT1S1",
      "first_bit": 8,
      "SPN": 3720,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Ash Load Percent",
      "SPN_Description": "Indicates the ash load percent of diesel particulate filter 1.  100% is the level at which diesel particulate filter ash service should be performed.\r\n\r\n\r\n100% level is the target ash service interval (and if ash service is not immediately performed, ash loading can continue beyond 100%).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "3721": {
      "PGN": 64891,
      "PGN_Name": "Aftertreatment 1 Service 1",
      "PGN_Description": "AT1S1",
      "first_bit": 16,
      "SPN": 3721,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Time Since Last Active Regeneration",
      "SPN_Description": "Indicates the time since the last active regeneration event of diesel particulate filter 1.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "3722": {
      "PGN": 64890,
      "PGN_Name": "Aftertreatment 2 Service 1",
      "PGN_Description": "AT2S1",
      "first_bit": 0,
      "SPN": 3722,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Soot Load Percent",
      "SPN_Description": "Indicates the soot load percent of diesel particulate filter 2.  100% is the level at which active diesel particulate filter regeneration should be triggered.\r\n\r\n\r\n100% level is the active regeneration trigger level (and if conditions are not favorable for regeneration, soot loading can continue beyond 100%).  During normal operation and regeneration a value 0% will indicate a fully regenerated diesel particulate filter.  Values of 25%, 50% and 75% will indicate the general level of soot prior to the 100% level where an active regeneration is needed.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "3723": {
      "PGN": 64890,
      "PGN_Name": "Aftertreatment 2 Service 1",
      "PGN_Description": "AT2S1",
      "first_bit": 8,
      "SPN": 3723,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Ash Load Percent",
      "SPN_Description": "Indicates the ash load percent of diesel particulate filter 2.  100% is the level at which diesel particulate filter ash service should be performed.\r\n\r\n100% level is the target ash service interval (and if ash service is not immediately performed, ash loading can continue beyond 100%).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "3724": {
      "PGN": 64890,
      "PGN_Name": "Aftertreatment 2 Service 1",
      "PGN_Description": "AT2S1",
      "first_bit": 16,
      "SPN": 3724,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Time Since Last Active Regeneration",
      "SPN_Description": "Indicates the time since the last active regeneration event of diesel particulate filter 2.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "3725": {
      "PGN": 64920,
      "PGN_Name": "Aftertreatment 1 Historical Information 1",
      "PGN_Description": "AT1HI1",
      "first_bit": 128,
      "SPN": 3725,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Total Passive Regeneration Time",
      "SPN_Description": "Total amount of time that aftertreatment 1 diesel particulate filter has been in passive regeneration over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "3726": {
      "PGN": 64920,
      "PGN_Name": "Aftertreatment 1 Historical Information 1",
      "PGN_Description": "AT1HI1",
      "first_bit": 160,
      "SPN": 3726,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Total Number of Passive Regenerations",
      "SPN_Description": "Total number of passive regenerations by aftertreatment device 1 over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3727": {
      "PGN": 64920,
      "PGN_Name": "Aftertreatment 1 Historical Information 1",
      "PGN_Description": "AT1HI1",
      "first_bit": 192,
      "SPN": 3727,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Total Number of Active Regeneration Inhibit Requests",
      "SPN_Description": "Total number of aftertreatment device 1 active regeneration inhibit requests by the operator over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3728": {
      "PGN": 64920,
      "PGN_Name": "Aftertreatment 1 Historical Information 1",
      "PGN_Description": "AT1HI1",
      "first_bit": 224,
      "SPN": 3728,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Total Number of Active Regeneration Manual Requests",
      "SPN_Description": "Total number of aftertreatment device 1 active regeneration manual requests by the operator over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3729": {
      "PGN": 64921,
      "PGN_Name": "Aftertreatment 2 Historical information 1",
      "PGN_Description": "AT2HI1",
      "first_bit": 128,
      "SPN": 3729,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Total Passive Regeneration Time",
      "SPN_Description": "Total amount of time that Aftertreatment device 2 has been in passive regeneration over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "3730": {
      "PGN": 64921,
      "PGN_Name": "Aftertreatment 2 Historical information 1",
      "PGN_Description": "AT2HI1",
      "first_bit": 160,
      "SPN": 3730,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Total Number of Passive Regenerations",
      "SPN_Description": "Total number of passive regenerations by Aftertreatment device 2 over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3731": {
      "PGN": 64921,
      "PGN_Name": "Aftertreatment 2 Historical information 1",
      "PGN_Description": "AT2HI1",
      "first_bit": 192,
      "SPN": 3731,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Total Number of Active Regeneration Inhibit Requests",
      "SPN_Description": "Total number of Aftertreatment device 2 active regeneration inhibit requests by the operator over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3732": {
      "PGN": 64921,
      "PGN_Name": "Aftertreatment 2 Historical information 1",
      "PGN_Description": "AT2HI1",
      "first_bit": 224,
      "SPN": 3732,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Total Number of Active Regeneration Manual Requests",
      "SPN_Description": "Total number of Aftertreatment device 2 active regeneration manual requests by the operator over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3733": {
      "PGN": 64889,
      "PGN_Name": "Aftertreatment 1 Trip Information",
      "PGN_Description": "AT1TI",
      "first_bit": 0,
      "SPN": 3733,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Trip Fuel Used",
      "SPN_Description": "Total amount of fuel used by the aftertreatment 1 diesel particulate filter during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 75
    },
    "3734": {
      "PGN": 64889,
      "PGN_Name": "Aftertreatment 1 Trip Information",
      "PGN_Description": "AT1TI",
      "first_bit": 32,
      "SPN": 3734,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Trip Active Regeneration Time",
      "SPN_Description": "Total amount of time that the aftertreatment 1 diesel particulate filter has been in active regeneration during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "3735": {
      "PGN": 64889,
      "PGN_Name": "Aftertreatment 1 Trip Information",
      "PGN_Description": "AT1TI",
      "first_bit": 64,
      "SPN": 3735,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Trip Disabled Time",
      "SPN_Description": "Total amount of time that aftertreatment 1 diesel particulate filter regeneration has been manually disabled during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "3736": {
      "PGN": 64889,
      "PGN_Name": "Aftertreatment 1 Trip Information",
      "PGN_Description": "AT1TI",
      "first_bit": 96,
      "SPN": 3736,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Trip Number of Active Regenerations",
      "SPN_Description": "Total number of active regenerations of the aftertreatment 1 diesel particulate filter during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3737": {
      "PGN": 64889,
      "PGN_Name": "Aftertreatment 1 Trip Information",
      "PGN_Description": "AT1TI",
      "first_bit": 128,
      "SPN": 3737,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Trip Passive Regeneration Time",
      "SPN_Description": "Total amount of time that the aftertreatment 1 diesel particulate filter has been in passive regeneration during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "3738": {
      "PGN": 64889,
      "PGN_Name": "Aftertreatment 1 Trip Information",
      "PGN_Description": "AT1TI",
      "first_bit": 160,
      "SPN": 3738,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Trip Number of Passive Regenerations",
      "SPN_Description": "Total number of passive regenerations of the aftertreatment 1 diesel particulate filter during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3739": {
      "PGN": 64889,
      "PGN_Name": "Aftertreatment 1 Trip Information",
      "PGN_Description": "AT1TI",
      "first_bit": 192,
      "SPN": 3739,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Trip Number of Active Regeneration Inhibit Requests",
      "SPN_Description": "Total number of aftertreatment 1 diesel particulate filter active regeneration inhibit requests by the operator during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3740": {
      "PGN": 64889,
      "PGN_Name": "Aftertreatment 1 Trip Information",
      "PGN_Description": "AT1TI",
      "first_bit": 224,
      "SPN": 3740,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Trip Number of Active Regeneration Manual Requests",
      "SPN_Description": "Total number of aftertreatment 1 diesel particulate filter active regeneration manual requests by the operator during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3741": {
      "PGN": 64888,
      "PGN_Name": "Aftertreatment 2 Trip Information",
      "PGN_Description": "AT2TI",
      "first_bit": 0,
      "SPN": 3741,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Trip Fuel Used",
      "SPN_Description": "Total amount of fuel used by the aftertreatment 2 diesel particulate filter during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 75
    },
    "3742": {
      "PGN": 64888,
      "PGN_Name": "Aftertreatment 2 Trip Information",
      "PGN_Description": "AT2TI",
      "first_bit": 32,
      "SPN": 3742,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Trip Active Regeneration Time",
      "SPN_Description": "Total amount of time that the aftertreatment 2 diesel particulate filter has been in active regeneration during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "3743": {
      "PGN": 64888,
      "PGN_Name": "Aftertreatment 2 Trip Information",
      "PGN_Description": "AT2TI",
      "first_bit": 64,
      "SPN": 3743,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Trip Disabled Time",
      "SPN_Description": "Total amount of time that aftertreatment 2 diesel particulate filter regeneration has been manually disabled during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "3744": {
      "PGN": 64888,
      "PGN_Name": "Aftertreatment 2 Trip Information",
      "PGN_Description": "AT2TI",
      "first_bit": 96,
      "SPN": 3744,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Trip Number of Active Regenerations",
      "SPN_Description": "Total number of active regenerations of the aftertreatment 2 diesel particulate filter during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3745": {
      "PGN": 64888,
      "PGN_Name": "Aftertreatment 2 Trip Information",
      "PGN_Description": "AT2TI",
      "first_bit": 128,
      "SPN": 3745,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Trip Passive Regeneration Time",
      "SPN_Description": "Total amount of time that the aftertreatment 2 diesel particulate filter has been in passive regeneration during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "3746": {
      "PGN": 64888,
      "PGN_Name": "Aftertreatment 2 Trip Information",
      "PGN_Description": "AT2TI",
      "first_bit": 160,
      "SPN": 3746,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Trip Number of Passive Regenerations",
      "SPN_Description": "Total number of passive regenerations of the aftertreatment 2 diesel particulate filter during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3747": {
      "PGN": 64888,
      "PGN_Name": "Aftertreatment 2 Trip Information",
      "PGN_Description": "AT2TI",
      "first_bit": 192,
      "SPN": 3747,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Trip Number of Active Regeneration Inhibit Requests",
      "SPN_Description": "Total number of aftertreatment 2 diesel particulate filter active regeneration inhibit requests by the operator during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3748": {
      "PGN": 64888,
      "PGN_Name": "Aftertreatment 2 Trip Information",
      "PGN_Description": "AT2TI",
      "first_bit": 224,
      "SPN": 3748,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Trip Number of Active Regeneration Manual Requests",
      "SPN_Description": "Total number of aftertreatment 2 diesel particulate filter active regeneration manual requests by the operator during the current trip period.\r\n\r\nNOTE: This SPN needs to be reset by the reset PGN 56832.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "3750": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 60,
      "SPN": 3750,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Conditions Not Met for Active Regeneration",
      "SPN_Description": "Indicates that diesel particulate filter 1 is not able to begin or continue an active regenerate event at the current engine operating conditions.\r\n\r\n00 active DPF regeneration not inhibited\r\n01 active DPF regeneration inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN would indicate that the diesel particulate filter (bank 1) is not able to begin or continue an active regeneration event due to current engine operating conditions.\r\n\r\nThe conditions on these SPNs are exclusive to the conditions in the PGN 64892\r\n\r\nExamples of these other conditions are:\r\n- Engine Speed/Load Conditions not met\r\n- Soot Load Percent not high enough\r\n- Engine is a working mode senario\r\n\r\nSPN 3702 should be set to inhibited when SPN 3750 goes to inhibited status.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3785": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 0,
      "SPN": 3785,
      "SPN_Name": "Tractor Brake Stroke Axle 1 Left",
      "SPN_Description": "Brake stroke status for left brake actuator on tractor axle 1. \r\n\r\n000 - OK (Normal operation)  \r\n001 - Non-functioning\r\n010 - Overstroke \r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3786": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 3,
      "SPN": 3786,
      "SPN_Name": "Tractor Brake Stroke Axle 1 Right",
      "SPN_Description": "Brake stroke status for right brake actuator on tractor axle 1. \r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3787": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 6,
      "SPN": 3787,
      "SPN_Name": "Tractor Brake Stroke Axle 2 Left",
      "SPN_Description": "Brake stroke status for left brake actuator on tractor axle 2. \r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3788": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 9,
      "SPN": 3788,
      "SPN_Name": "Tractor Brake Stroke Axle 2 Right",
      "SPN_Description": "Brake stroke status for right brake actuator on tractor axle 2.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3789": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 12,
      "SPN": 3789,
      "SPN_Name": "Tractor Brake Stroke Axle 3 Left",
      "SPN_Description": "Brake stroke status for left brake actuator on tractor axle 3.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3790": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 15,
      "SPN": 3790,
      "SPN_Name": "Tractor Brake Stroke Axle 3 Right",
      "SPN_Description": "Brake stroke status for right brake actuator on tractor axle 3.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3791": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 18,
      "SPN": 3791,
      "SPN_Name": "Tractor Brake Stroke Axle 4 Left",
      "SPN_Description": "Brake stroke status for left brake actuator on tractor axle 4.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3792": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 21,
      "SPN": 3792,
      "SPN_Name": "Tractor Brake Stroke Axle 4 Right",
      "SPN_Description": "Brake stroke status for right brake actuator on tractor axle 4.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3793": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 24,
      "SPN": 3793,
      "SPN_Name": "Tractor Brake Stroke Axle 5 Left",
      "SPN_Description": "Brake stroke status for left brake actuator on tractor axle 5.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3794": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 27,
      "SPN": 3794,
      "SPN_Name": "Tractor Brake Stroke Axle 5 Right",
      "SPN_Description": "Brake stroke status for right brake actuator on tractor axle 5.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3795": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 30,
      "SPN": 3795,
      "SPN_Name": "Trailer Brake Stroke Axle 1 Left",
      "SPN_Description": "Brake stroke status for left brake actuator on trailerr axle 1.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3796": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 33,
      "SPN": 3796,
      "SPN_Name": "Trailer Brake Stroke Axle 1 Right",
      "SPN_Description": "Brake stroke status for right brake actuator on trailer axle 1.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3797": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 36,
      "SPN": 3797,
      "SPN_Name": "Trailer Brake Stroke Axle 2 Left",
      "SPN_Description": "Brake stroke status for left brake actuator on trailer axle 2.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3798": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 39,
      "SPN": 3798,
      "SPN_Name": "Trailer Brake Stroke Axle 2 Right",
      "SPN_Description": "Brake stroke status for right brake actuator on trailer axle 2.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3799": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 42,
      "SPN": 3799,
      "SPN_Name": "Trailer Brake Stroke Axle 3 Left",
      "SPN_Description": "Brake stroke status for left brake actuator on trailer axle 3.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3800": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 45,
      "SPN": 3800,
      "SPN_Name": "Trailer Brake Stroke Axle 3 Right",
      "SPN_Description": "Brake stroke status for right brake actuator on trailer axle 3.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3801": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 48,
      "SPN": 3801,
      "SPN_Name": "Trailer Brake Stroke Axle 4 Left",
      "SPN_Description": "Brake stroke status for left brake actuator on trailer axle 4.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3802": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 51,
      "SPN": 3802,
      "SPN_Name": "Trailer Brake Stroke Axle 4 Right",
      "SPN_Description": "Brake stroke status for right brake actuator on trailer axle 4.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3803": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 54,
      "SPN": 3803,
      "SPN_Name": "Trailer Brake Stroke Axle 5 Left",
      "SPN_Description": "Brake stroke status for left brake actuator on trailer axle 5.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3804": {
      "PGN": 64881,
      "PGN_Name": "Brake actuator stroke status",
      "PGN_Description": "BSA",
      "first_bit": 57,
      "SPN": 3804,
      "SPN_Name": "Trailer Brake Stroke Axle 5 Right",
      "SPN_Description": "Brake stroke status for right brake actuator on trailer axle 5.\r\n\r\n000 - OK (Normal operation)\r\n001 - Non-functioning\r\n010 - Overstroke\r\n011 - Dragging brake\r\n100 - Reserved\r\n101 - Reserved\r\n110 - Sensor error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "3807": {
      "PGN": 65265,
      "PGN_Name": "Cruise Control/Vehicle Speed 1",
      "PGN_Description": "CCVS1",
      "first_bit": 6,
      "SPN": 3807,
      "SPN_Name": "Park Brake Release Inhibit Request",
      "SPN_Description": "Park Brake Release Inhibit Request signals the desire that an applied park brake remain applied and limit the ability of the vehicle to be moved.  \r\n\r\n00 - Park Brake Release Inhibit not requested\r\n01 - Park Brake Release Inhibit requested\r\n10 - SAE reserved\r\n11 - Unavailable\r\n\r\nThis parameter provides the capability to request the device controlling a parking brake to inhibit its release. This is intended for devices to request the park brake remain applied.  Status 00b is provided when conditions recommending the application of the park brake no longer exist for the sender.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3808": {
      "PGN": 65274,
      "PGN_Name": "Brakes 1",
      "PGN_Description": "B1",
      "first_bit": 28,
      "SPN": 3808,
      "SPN_Name": "Park Brake Release Inhibit Status",
      "SPN_Description": "This parameter provides reports on the status of the Park Brake Release Inhibit function.\r\n\r\n00 - Park Brake release is not inhibited\r\n01 - Park Brake release is inhibited\r\n10 - Error (for example: Park Brake release is not inhibited, but is requested to be inhibited)\r\n11 - Unavailable\r\n\r\nThe device controlling the Park Brake sends a status of the inhibit function.  The allowed release of the park brake is provided as status 00b.  01b indicates that the release of the park brake is inhibited.  The release may be inhibited by either an external request or by local information available to the controlling device.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3809": {
      "PGN": 64980,
      "PGN_Name": "Cab Message 3",
      "PGN_Description": "CM3",
      "first_bit": 16,
      "SPN": 3809,
      "SPN_Name": "Transmission Oil Level Request",
      "SPN_Description": "Conveys operator or vehicle system desire for a transmission oil level reading to be taken. \r\n\r\n00 - No transmission oil level reading desired\r\n01 - Transmission oil level reading desired\r\n10 - Reserved\r\n11 - Don't care / take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3810": {
      "PGN": 64880,
      "PGN_Name": "Door ramp control",
      "PGN_Description": "DRC",
      "first_bit": 0,
      "SPN": 3810,
      "SPN_Name": "Retract Status of ramp 1",
      "SPN_Description": "Retract status of ramp at doorway 1, counting from front to back on the vehicle.\r\n \r\n00 ramp retracted\r\n01 ramp extended\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3811": {
      "PGN": 64880,
      "PGN_Name": "Door ramp control",
      "PGN_Description": "DRC",
      "first_bit": 2,
      "SPN": 3811,
      "SPN_Name": "Enable status of ramp 1",
      "SPN_Description": "Enable status of ramp at doorway 1, counting from front to back on the vehicle.\r\n\r\n        00 ramp disabled\r\n        01 ramp enabled \r\n       10 error \r\n       11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3812": {
      "PGN": 64880,
      "PGN_Name": "Door ramp control",
      "PGN_Description": "DRC",
      "first_bit": 4,
      "SPN": 3812,
      "SPN_Name": "Movement status of ramp 1",
      "SPN_Description": "Movement status of ramp at doorway 1, counting from front to back on the vehicle.\r\n\r\n00 ramp not being moved\r\n01 ramp being moved\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3813": {
      "PGN": 64880,
      "PGN_Name": "Door ramp control",
      "PGN_Description": "DRC",
      "first_bit": 8,
      "SPN": 3813,
      "SPN_Name": "Retract Status of ramp 2",
      "SPN_Description": "Retract status of ramp at doorway 2, counting from front to back on the vehicle.\r\n\r\n00 ramp retracted\r\n01 ramp extended\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3814": {
      "PGN": 64880,
      "PGN_Name": "Door ramp control",
      "PGN_Description": "DRC",
      "first_bit": 10,
      "SPN": 3814,
      "SPN_Name": "Enable status of ramp 2",
      "SPN_Description": "Enable status of ramp at doorway 2, counting from front to back on the vehicle.\r\n\r\n00 ramp disabled\r\n01 ramp enabled \r\n10 error \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3815": {
      "PGN": 64880,
      "PGN_Name": "Door ramp control",
      "PGN_Description": "DRC",
      "first_bit": 12,
      "SPN": 3815,
      "SPN_Name": "Movement status of ramp 2",
      "SPN_Description": "Movement status of ramp at doorway 2, counting from front to back on the vehicle.\r\n\r\n00 ramp not being moved\r\n01 ramp being moved\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3816": {
      "PGN": 64880,
      "PGN_Name": "Door ramp control",
      "PGN_Description": "DRC",
      "first_bit": 16,
      "SPN": 3816,
      "SPN_Name": "Retract Status of ramp 3",
      "SPN_Description": "Retract status of ramp at doorway 3, counting from front to back on the vehicle.\r\n\r\n00 ramp retracted\r\n01 ramp extended\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3817": {
      "PGN": 64880,
      "PGN_Name": "Door ramp control",
      "PGN_Description": "DRC",
      "first_bit": 18,
      "SPN": 3817,
      "SPN_Name": "Enable status of ramp 3",
      "SPN_Description": "Enable status of ramp at doorway 3, counting from front to back on the vehicle.\r\n\r\n00 ramp disabled\r\n01 ramp enabled \r\n10 error \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3818": {
      "PGN": 64880,
      "PGN_Name": "Door ramp control",
      "PGN_Description": "DRC",
      "first_bit": 20,
      "SPN": 3818,
      "SPN_Name": "Movement status of ramp 3",
      "SPN_Description": "Movement status of ramp at doorway 3, counting from front to back on the vehicle.\r\n\r\n00 ramp not being moved\r\n01 ramp being moved\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3819": {
      "PGN": 61446,
      "PGN_Name": "Electronic Axle Controller 1",
      "PGN_Description": "EAC1",
      "first_bit": 24,
      "SPN": 3819,
      "SPN_Name": "Front axle group engagement status",
      "SPN_Description": "Front axle group engagement status \r\n\r\n00 front axle group disengaged \r\n01 front axle group engaged\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3820": {
      "PGN": 61446,
      "PGN_Name": "Electronic Axle Controller 1",
      "PGN_Description": "EAC1",
      "first_bit": 26,
      "SPN": 3820,
      "SPN_Name": "Rear axle group engagement status",
      "SPN_Description": "Rear axle group engagement status\r\n\r\n00 rear axle group disengaged \r\n01 rear axle group engaged\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3821": {
      "PGN": 64879,
      "PGN_Name": "Electronic Engine Controller 8",
      "PGN_Description": "EEC8",
      "first_bit": 0,
      "SPN": 3821,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1  Valve 2 Control",
      "SPN_Description": "Desired percentage of maximum Exhaust Gas Recirculation (EGR) valve opening for valve 2.  0% means valve is closed. 100% means maximum valve opening (full gas flow).",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "3822": {
      "PGN": 64916,
      "PGN_Name": "Electronic Engine Controller 7",
      "PGN_Description": "EEC7",
      "first_bit": 16,
      "SPN": 3822,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Valve 2 Position",
      "SPN_Description": "The position of the second exhaust gas recirculation valve expressed as a percentage of full travel. Zero percent means the valve is closed and no exhaust gas is flowing into the intake air stream. One hundred percent means the valve is fully opened.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "3823": {
      "PGN": 64917,
      "PGN_Name": "Transmission Fluids 2",
      "PGN_Description": "TRF2",
      "first_bit": 8,
      "SPN": 3823,
      "SPN_Name": "Transmission Torque Converter Oil Outlet Temperature",
      "SPN_Description": "Temperature of transmission torque converter outlet oil.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3826": {
      "PGN": 64878,
      "PGN_Name": "Aftertreatment 1 SCR Service Information 1",
      "PGN_Description": "A1SCRSI1",
      "first_bit": 0,
      "SPN": 3826,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Average Consumption",
      "SPN_Description": "Measured use of diesel exhaust fluid by a Selective Catalytic Reduction system for exhaust emission control, averaged over the previous 15 hours of engine operation.\r\n\r\nUsed to determine whether the SCR system is using an appropriate amount of diesel exhaust fluid, by comparing with the Aftertreatment 1 Commanded Diesel Exhaust Fluid Consumption parameter (SPN 3828).",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "l/h",
      "SLOT_ID": 42
    },
    "3828": {
      "PGN": 64878,
      "PGN_Name": "Aftertreatment 1 SCR Service Information 1",
      "PGN_Description": "A1SCRSI1",
      "first_bit": 16,
      "SPN": 3828,
      "SPN_Name": "Aftertreatment 1 SCR Commanded Diesel Exhaust Fluid Consumption",
      "SPN_Description": "This parameter transmits the amount of diesel exhaust fluid that the emissions control system has requested to be used, averaged over the past 15 hours of engine operation.\r\n\r\nUsed to determine whether the SCR system is using an appropriate amount of diesel exhaust fluid, by comparing with the Aftertreatment 1 Average Diesel Exhaust Fluid Consumption parameter (SPN 3826).",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "l/h",
      "SLOT_ID": 42
    },
    "3830": {
      "PGN": 64877,
      "PGN_Name": "Aftertreatment 1 Air Control 2",
      "PGN_Description": "AT1AC2",
      "first_bit": 0,
      "SPN": 3830,
      "SPN_Name": "Aftertreatment 1 Secondary Air Differential Pressure",
      "SPN_Description": "Indicates the secondary air differential pressure for aftertreatment 1.  Secondary air is air provided to the exhaust system (per SAE J2403).",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "kPa",
      "SLOT_ID": 52
    },
    "3831": {
      "PGN": 64877,
      "PGN_Name": "Aftertreatment 1 Air Control 2",
      "PGN_Description": "AT1AC2",
      "first_bit": 16,
      "SPN": 3831,
      "SPN_Name": "Aftertreatment 1 Secondary Air Temperature",
      "SPN_Description": "Indicates the secondary air temperature for aftertreatment 1.  Secondary air is air provided to the exhaust system (per SAE J2403).",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3832": {
      "PGN": 64877,
      "PGN_Name": "Aftertreatment 1 Air Control 2",
      "PGN_Description": "AT1AC2",
      "first_bit": 32,
      "SPN": 3832,
      "SPN_Name": "Aftertreatment 1 Secondary Air Mass Flow Rate",
      "SPN_Description": "Indicates the secondary air mass flow for aftertreatment 1.  Secondary air is the air provided to the exhaust system (per SAE J2403).",
      "bit_length": 16,
      "scaling": 0.2,
      "offset": 0,
      "unit": "kg/h",
      "SLOT_ID": 262
    },
    "3833": {
      "PGN": 64876,
      "PGN_Name": "Aftertreatment 2 Air Control 2",
      "PGN_Description": "AT2AC2",
      "first_bit": 0,
      "SPN": 3833,
      "SPN_Name": "Aftertreatment 2 Secondary Air Differential Pressure",
      "SPN_Description": "Indicates the secondary air differential pressure for aftertreatment 2.  Secondary air is air provided to the exhaust system (per SAE J2403).",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "kPa",
      "SLOT_ID": 52
    },
    "3834": {
      "PGN": 64876,
      "PGN_Name": "Aftertreatment 2 Air Control 2",
      "PGN_Description": "AT2AC2",
      "first_bit": 16,
      "SPN": 3834,
      "SPN_Name": "Aftertreatment 2 Secondary Air Temperature",
      "SPN_Description": "Indicates the secondary air temperature for aftertreatment 2.  Secondary air is air provided to the exhaust system (per SAE J2403).",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "3835": {
      "PGN": 64876,
      "PGN_Name": "Aftertreatment 2 Air Control 2",
      "PGN_Description": "AT2AC2",
      "first_bit": 32,
      "SPN": 3835,
      "SPN_Name": "Aftertreatment 2 Secondary Air Mass Flow Rate",
      "SPN_Description": "Indicates the secondary air mass flow for aftertreatment 2.  Secondary air is the air provided to the exhaust system (per SAE J2403).",
      "bit_length": 16,
      "scaling": 0.2,
      "offset": 0,
      "unit": "kg/h",
      "SLOT_ID": 262
    },
    "3837": {
      "PGN": 64877,
      "PGN_Name": "Aftertreatment 1 Air Control 2",
      "PGN_Description": "AT1AC2",
      "first_bit": 48,
      "SPN": 3837,
      "SPN_Name": "Aftertreatment 1 Secondary Air Pressure",
      "SPN_Description": "Pressure of the secondary air for aftertreatment 1.  Secondary air is air provided to the exhaust system (per SAE J2403).\r\n\r\nFor absolute pressure, see SPN 5589.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3838": {
      "PGN": 64876,
      "PGN_Name": "Aftertreatment 2 Air Control 2",
      "PGN_Description": "AT2AC2",
      "first_bit": 48,
      "SPN": 3838,
      "SPN_Name": "Aftertreatment 2 Secondary Air Pressure",
      "SPN_Description": "Pressure of the secondary air for aftertreatment 2.  Secondary air is air provided to the exhaust system (per SAE J2403).\r\n\r\nFor absolute pressure, see SPN 5590.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "3839": {
      "PGN": 64964,
      "PGN_Name": "Electronic Brake Controller 5",
      "PGN_Description": "EBC5",
      "first_bit": 0,
      "SPN": 3839,
      "SPN_Name": "Brake Temperature Warning",
      "SPN_Description": "This parameter indicates if the temperature in the service brakes exceeds a certain value. It can be used for a warning information for the driver. The temperature warning value is vehicle manufacturer specific.\r\n\r\n00 Not Active\r\n01 Active\r\n10 Reserved\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3840": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 6,
      "SPN": 3840,
      "SPN_Name": "Auxiliary I/O #17",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3841": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 4,
      "SPN": 3841,
      "SPN_Name": "Auxiliary I/O #18",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3842": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 2,
      "SPN": 3842,
      "SPN_Name": "Auxiliary I/O #19",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3843": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 0,
      "SPN": 3843,
      "SPN_Name": "Auxiliary I/O #20",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3844": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 14,
      "SPN": 3844,
      "SPN_Name": "Auxiliary I/O #21",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3845": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 12,
      "SPN": 3845,
      "SPN_Name": "Auxiliary I/O #22",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3846": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 10,
      "SPN": 3846,
      "SPN_Name": "Auxiliary I/O #23",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3847": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 8,
      "SPN": 3847,
      "SPN_Name": "Auxiliary I/O #24",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3848": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 22,
      "SPN": 3848,
      "SPN_Name": "Auxiliary I/O #25",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3849": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 20,
      "SPN": 3849,
      "SPN_Name": "Auxiliary I/O #26",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3850": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 18,
      "SPN": 3850,
      "SPN_Name": "Auxiliary I/O #27",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3851": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 16,
      "SPN": 3851,
      "SPN_Name": "Auxiliary I/O #28",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3852": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 30,
      "SPN": 3852,
      "SPN_Name": "Auxiliary I/O #29",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3853": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 28,
      "SPN": 3853,
      "SPN_Name": "Auxiliary I/O #30",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3854": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 26,
      "SPN": 3854,
      "SPN_Name": "Auxiliary I/O #31",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3855": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 24,
      "SPN": 3855,
      "SPN_Name": "Auxiliary I/O #32",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3856": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 38,
      "SPN": 3856,
      "SPN_Name": "Auxiliary I/O #33",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3857": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 36,
      "SPN": 3857,
      "SPN_Name": "Auxiliary I/O #34",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3858": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 34,
      "SPN": 3858,
      "SPN_Name": "Auxiliary I/O #35",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3859": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 32,
      "SPN": 3859,
      "SPN_Name": "Auxiliary I/O #36",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3860": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 46,
      "SPN": 3860,
      "SPN_Name": "Auxiliary I/O #37",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3861": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 44,
      "SPN": 3861,
      "SPN_Name": "Auxiliary I/O #38",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3862": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 42,
      "SPN": 3862,
      "SPN_Name": "Auxiliary I/O #39",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3863": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 40,
      "SPN": 3863,
      "SPN_Name": "Auxiliary I/O #40",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3864": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 54,
      "SPN": 3864,
      "SPN_Name": "Auxiliary I/O #41",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3865": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 52,
      "SPN": 3865,
      "SPN_Name": "Auxiliary I/O #42",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3866": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 50,
      "SPN": 3866,
      "SPN_Name": "Auxiliary I/O #43",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3867": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 48,
      "SPN": 3867,
      "SPN_Name": "Auxiliary I/O #44",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3868": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 62,
      "SPN": 3868,
      "SPN_Name": "Auxiliary I/O #45",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3869": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 60,
      "SPN": 3869,
      "SPN_Name": "Auxiliary I/O #46",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3870": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 58,
      "SPN": 3870,
      "SPN_Name": "Auxiliary I/O #47",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3871": {
      "PGN": 42752,
      "PGN_Name": "Auxiliary Input/Output Status 2",
      "PGN_Description": "AUXIO2",
      "first_bit": 56,
      "SPN": 3871,
      "SPN_Name": "Auxiliary I/O #48",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3872": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 6,
      "SPN": 3872,
      "SPN_Name": "Auxiliary I/O #49",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3873": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 4,
      "SPN": 3873,
      "SPN_Name": "Auxiliary I/O #50",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3874": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 2,
      "SPN": 3874,
      "SPN_Name": "Auxiliary I/O #51",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3875": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 0,
      "SPN": 3875,
      "SPN_Name": "Auxiliary I/O #52",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3876": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 14,
      "SPN": 3876,
      "SPN_Name": "Auxiliary I/O #53",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3877": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 12,
      "SPN": 3877,
      "SPN_Name": "Auxiliary I/O #54",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3878": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 10,
      "SPN": 3878,
      "SPN_Name": "Auxiliary I/O #55",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3879": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 8,
      "SPN": 3879,
      "SPN_Name": "Auxiliary I/O #56",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3880": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 22,
      "SPN": 3880,
      "SPN_Name": "Auxiliary I/O #57",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3881": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 20,
      "SPN": 3881,
      "SPN_Name": "Auxiliary I/O #58",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3882": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 18,
      "SPN": 3882,
      "SPN_Name": "Auxiliary I/O #59",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3883": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 16,
      "SPN": 3883,
      "SPN_Name": "Auxiliary I/O #60",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3884": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 30,
      "SPN": 3884,
      "SPN_Name": "Auxiliary I/O #61",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3885": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 28,
      "SPN": 3885,
      "SPN_Name": "Auxiliary I/O #62",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3886": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 26,
      "SPN": 3886,
      "SPN_Name": "Auxiliary I/O #63",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3887": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 24,
      "SPN": 3887,
      "SPN_Name": "Auxiliary I/O #64",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3888": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 38,
      "SPN": 3888,
      "SPN_Name": "Auxiliary I/O #65",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3889": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 36,
      "SPN": 3889,
      "SPN_Name": "Auxiliary I/O #66",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3890": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 34,
      "SPN": 3890,
      "SPN_Name": "Auxiliary I/O #67",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3891": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 32,
      "SPN": 3891,
      "SPN_Name": "Auxiliary I/O #68",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3892": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 46,
      "SPN": 3892,
      "SPN_Name": "Auxiliary I/O #69",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3893": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 44,
      "SPN": 3893,
      "SPN_Name": "Auxiliary I/O #70",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3894": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 42,
      "SPN": 3894,
      "SPN_Name": "Auxiliary I/O #71",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3895": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 40,
      "SPN": 3895,
      "SPN_Name": "Auxiliary I/O #72",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3896": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 54,
      "SPN": 3896,
      "SPN_Name": "Auxiliary I/O #73",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3897": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 52,
      "SPN": 3897,
      "SPN_Name": "Auxiliary I/O #74",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3898": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 50,
      "SPN": 3898,
      "SPN_Name": "Auxiliary I/O #75",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3899": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 48,
      "SPN": 3899,
      "SPN_Name": "Auxiliary I/O #76",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3900": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 62,
      "SPN": 3900,
      "SPN_Name": "Auxiliary I/O #77",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3901": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 60,
      "SPN": 3901,
      "SPN_Name": "Auxiliary I/O #78",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3902": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 58,
      "SPN": 3902,
      "SPN_Name": "Auxiliary I/O #79",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3903": {
      "PGN": 42496,
      "PGN_Name": "Auxiliary Input/Output Status 3",
      "PGN_Description": "AUXIO3",
      "first_bit": 56,
      "SPN": 3903,
      "SPN_Name": "Auxiliary I/O #80",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3904": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 6,
      "SPN": 3904,
      "SPN_Name": "Auxiliary I/O #81",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3905": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 4,
      "SPN": 3905,
      "SPN_Name": "Auxiliary I/O #82",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3906": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 2,
      "SPN": 3906,
      "SPN_Name": "Auxiliary I/O #83",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3907": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 0,
      "SPN": 3907,
      "SPN_Name": "Auxiliary I/O #84",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3908": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 14,
      "SPN": 3908,
      "SPN_Name": "Auxiliary I/O #85",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3909": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 12,
      "SPN": 3909,
      "SPN_Name": "Auxiliary I/O #86",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3910": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 10,
      "SPN": 3910,
      "SPN_Name": "Auxiliary I/O #87",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3911": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 8,
      "SPN": 3911,
      "SPN_Name": "Auxiliary I/O #88",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3912": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 22,
      "SPN": 3912,
      "SPN_Name": "Auxiliary I/O #89",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3913": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 20,
      "SPN": 3913,
      "SPN_Name": "Auxiliary I/O #90",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3914": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 18,
      "SPN": 3914,
      "SPN_Name": "Auxiliary I/O #91",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3915": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 16,
      "SPN": 3915,
      "SPN_Name": "Auxiliary I/O #92",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3916": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 30,
      "SPN": 3916,
      "SPN_Name": "Auxiliary I/O #93",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3917": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 28,
      "SPN": 3917,
      "SPN_Name": "Auxiliary I/O #94",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3918": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 26,
      "SPN": 3918,
      "SPN_Name": "Auxiliary I/O #95",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3919": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 24,
      "SPN": 3919,
      "SPN_Name": "Auxiliary I/O #96",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3920": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 38,
      "SPN": 3920,
      "SPN_Name": "Auxiliary I/O #97",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3921": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 36,
      "SPN": 3921,
      "SPN_Name": "Auxiliary I/O #98",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3922": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 34,
      "SPN": 3922,
      "SPN_Name": "Auxiliary I/O #99",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3923": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 32,
      "SPN": 3923,
      "SPN_Name": "Auxiliary I/O #100",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3924": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 46,
      "SPN": 3924,
      "SPN_Name": "Auxiliary I/O #101",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3925": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 44,
      "SPN": 3925,
      "SPN_Name": "Auxiliary I/O #102",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3926": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 42,
      "SPN": 3926,
      "SPN_Name": "Auxiliary I/O #103",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3927": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 40,
      "SPN": 3927,
      "SPN_Name": "Auxiliary I/O #104",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3928": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 54,
      "SPN": 3928,
      "SPN_Name": "Auxiliary I/O #105",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3929": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 52,
      "SPN": 3929,
      "SPN_Name": "Auxiliary I/O #106",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3930": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 50,
      "SPN": 3930,
      "SPN_Name": "Auxiliary I/O #107",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3931": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 48,
      "SPN": 3931,
      "SPN_Name": "Auxiliary I/O #108",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3932": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 62,
      "SPN": 3932,
      "SPN_Name": "Auxiliary I/O #109",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3933": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 60,
      "SPN": 3933,
      "SPN_Name": "Auxiliary I/O #110",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3934": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 58,
      "SPN": 3934,
      "SPN_Name": "Auxiliary I/O #111",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3935": {
      "PGN": 42240,
      "PGN_Name": "Auxiliary Input/Output Status 4",
      "PGN_Description": "AUXIO4",
      "first_bit": 56,
      "SPN": 3935,
      "SPN_Name": "Auxiliary I/O #112",
      "SPN_Description": "Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\r\n\r\n00 - Auxiliary channel off\r\n01 - Auxiliary channel on\r\n10 - Error Indicator or Not Used , depending on application\r\n11 - Not Available or Take No Action, depending on application",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3938": {
      "PGN": 61470,
      "PGN_Name": "Generator Control 2",
      "PGN_Description": "GC2",
      "first_bit": 0,
      "SPN": 3938,
      "SPN_Name": "Generator Governing Bias",
      "SPN_Description": "Control signal used to govern the genset's speed or load (depending on isochronous or utility parallel operation, respectively)\r\n\r\nNOTE:  If this method of engine control is used, the PGN 0 (TSC1) is not expected to be received by the engine controller and it will not be processed.",
      "bit_length": 16,
      "scaling": 0.004,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 264
    },
    "3939": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 8,
      "SPN": 3939,
      "SPN_Name": "Enable Switch - PTO Engine Flywheel",
      "SPN_Description": "Status of the PTO Engine Flywheel enable switch\r\n\r\n00 Enable switch off – PTO operation not desired\r\n01 Enable switch on – PTO operation desired \r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3940": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 24,
      "SPN": 3940,
      "SPN_Name": "Engagement Consent - PTO Engine Flywheel",
      "SPN_Description": "Engagement Consent status for the PTO Engine Flywheel\r\n\r\n00 Consent not given – PTO drive may not be engaged\r\n01 Consent given – PTO drive may be engaged\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3941": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 40,
      "SPN": 3941,
      "SPN_Name": "Engagement Status - PTO Engine Flywheel",
      "SPN_Description": "Engagement status of the PTO Engine Flywheel\r\n\r\n00 Drive not engaged\r\n01 Drive engaged\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3942": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 10,
      "SPN": 3942,
      "SPN_Name": "Enable Switch - PTO Engine Accessory Drive 1",
      "SPN_Description": "Status of the PTO engine accessory drive 1 enable switch\r\n\r\n00 Enable switch off – PTO operation not desired\r\n01 Enable switch on – PTO operation desired\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3943": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 26,
      "SPN": 3943,
      "SPN_Name": "Engagement Consent - PTO Engine Accessory Drive 1",
      "SPN_Description": "Engagement consent status for the PTO engine accessory drive 1\r\n\r\n00 Consent not given – PTO drive may not be engaged\r\n01 Consent given – PTO drive may be engaged\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3944": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 42,
      "SPN": 3944,
      "SPN_Name": "Engagement Status - PTO Engine Accessory Drive 1",
      "SPN_Description": "Engagement status of the PTO engine accessory drive 1\r\n\r\n00 Drive not engaged\r\n01 Drive engaged\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3945": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 12,
      "SPN": 3945,
      "SPN_Name": "Enable Switch - PTO Engine Accessory Drive 2",
      "SPN_Description": "Status of the PTO engine accessory drive 2 enable switch\r\n\r\n00 Enable switch off – PTO operation not desired\r\n01 Enable switch on – PTO operation desired\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3946": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 28,
      "SPN": 3946,
      "SPN_Name": "Engagement Consent - PTO Engine Accessory Drive 2",
      "SPN_Description": "Engagement Consent status for the PTO engine accessory drive 2 \r\n\r\n00 Consent not given – PTO drive may not be engaged\r\n01 Consent given – PTO drive may be engaged\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3947": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 44,
      "SPN": 3947,
      "SPN_Name": "Engagement Status - PTO Engine Accessory Drive 2",
      "SPN_Description": "Engagement status of the PTO engine accessory drive 2\r\n\r\n00 Drive not engaged\r\n01 Drive engaged\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3948": {
      "PGN": 64932,
      "PGN_Name": "PTO Drive Engagement",
      "PGN_Description": "PTODE",
      "first_bit": 48,
      "SPN": 3948,
      "SPN_Name": "At least one PTO engaged",
      "SPN_Description": "Indicates that at least one PTO is engaged\r\n\r\n00 No PTO drive is engaged\r\n01 At least one PTO drive is engaged\r\n10 Error\r\n11 Not available\r\n\r\nNote:  This parameter should only be sent by the controller that has knowledge of all PTO drives on the vehicle (e.g, the FMS gateway).  Individual PTO drive controllers should broadcast this parameter as \"not available\".",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "3987": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 10,
      "SPN": 3987,
      "SPN_Name": "Compression Brake Enable Switch Indicator Lamp Command",
      "SPN_Description": "Command signal directly controlling Compression Brake Enable Switch Indicator Lamp.  The compression brake switch indicator signals the status of the compression brake enable switch to the operator.\r\n \r\n00 - Lamp OFF\r\n01 - Lamp ON\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4010": {
      "PGN": 64752,
      "PGN_Name": "Engine Fuel/lube systems 2",
      "PGN_Description": "EFS2",
      "first_bit": 16,
      "SPN": 4010,
      "SPN_Name": "Fuel Tank Transfer Pump",
      "SPN_Description": "Operating state of the fuel tank transfer pump. The fuel tank transfer pump transfers fuel from the secondary fuel tank to the primary fuel tank.\r\n\r\n00 = Off\r\n01 = On\r\n10 = Error\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4059": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 0,
      "SPN": 4059,
      "SPN_Name": "Sole or Forward-most Steer Axle Group Weight Available",
      "SPN_Description": "Indicates the availability of the sole or forward-most steer axle group for purposes of weight measurement\r\n\r\n00 = Steer axle group not present\r\n01 = Steer axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable\r\n\r\nIf there is only one steer axle, this SPN should be used.  See also SPN 5933 for a second steer axle.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4060": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 2,
      "SPN": 4060,
      "SPN_Name": "Lift Axle Group Weight Available",
      "SPN_Description": "Indicates the availability of the lift axle group for purposes of weight measurement\r\n\r\n00 = Lift axle group not present\r\n01 = Lift axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4061": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 4,
      "SPN": 4061,
      "SPN_Name": "Sole or Forward-most Drive Axle Group Weight Available",
      "SPN_Description": "Indicates the availability of the sole or forward-most drive axle group for purposes of weight measurement\r\n\r\n00 = Drive axle group not present\r\n01 = Drive axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable\r\n\r\nIf there is only one drive axle, this SPN should be used.  See also SPN 5934 for a second drive axle.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4062": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 6,
      "SPN": 4062,
      "SPN_Name": "Tag Axle Group Weight Available",
      "SPN_Description": "Indicates the availability of the tag axle group for purposes of weight measurement\r\n\r\n00 = Tag axle group not present\r\n01 = Tag axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4063": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 8,
      "SPN": 4063,
      "SPN_Name": "Additional Tractor Axle Group Weight Available",
      "SPN_Description": "Indicates the availability of the additional tractor axle group for purposes of weight measurement\r\n\r\n00 = Additional tractor axle group not present\r\n01 = Additional tractor axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4064": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 10,
      "SPN": 4064,
      "SPN_Name": "Trailer A Axle Group Weight Available",
      "SPN_Description": "Indicates the availability of the trailer A axle group for purposes of weight measurement\r\n\r\n00 = Trailer A axle group not present\r\n01 = Trailer A axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4065": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 12,
      "SPN": 4065,
      "SPN_Name": "Trailer B Axle Group Weight Available",
      "SPN_Description": "Indicates the availability of the trailer B axle group for purposes of weight measurement\r\n\r\n00 = Trailer B axle group not present\r\n01 = Trailer B axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4066": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 14,
      "SPN": 4066,
      "SPN_Name": "Trailer C Axle Group Weight Available",
      "SPN_Description": "Indicates the availability of the trailer C axle group for purposes of weight measurement\r\n\r\n00 = Trailer C axle group not present\r\n01 = Trailer C axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4067": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 16,
      "SPN": 4067,
      "SPN_Name": "Trailer D Axle Group Weight Available",
      "SPN_Description": "Indicates the availability of the trailer D axle group for purposes of weight measurement\r\n\r\n00 = Trailer D axle group not present\r\n01 = Trailer D axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4068": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 18,
      "SPN": 4068,
      "SPN_Name": "Trailer E Axle Group Weight Available",
      "SPN_Description": "Indicates the availability of the trailer E axle group for purposes of weight measurement\r\n\r\n00 = Trailer E axle group not present\r\n01 = Trailer E axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4069": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 20,
      "SPN": 4069,
      "SPN_Name": "Trailer F Axle Group Weight Available",
      "SPN_Description": "Indicates the availability of the trailer F axle group for purposes of weight measurement\r\n\r\n00 = Trailer F axle group not present\r\n01 = Trailer F axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4070": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 22,
      "SPN": 4070,
      "SPN_Name": "Trailer G Axle Group Weight Available",
      "SPN_Description": "Indicates the availability of the trailer G axle group for purposes of weight measurement\r\n\r\n00 = Trailer G axle group not present\r\n01 = Trailer G axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4071": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 24,
      "SPN": 4071,
      "SPN_Name": "Trailer H Axle Group Weight Available",
      "SPN_Description": "Indicates the availability of the trailer H axle group for purposes of weight measurement\r\n\r\n00 = Trailer H axle group not present\r\n01 = Trailer H axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4072": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 26,
      "SPN": 4072,
      "SPN_Name": "Additional Trailer Axle Group Weight Available",
      "SPN_Description": "Indicates the availability of the additional trailer axle group for purposes of weight measurement\r\n\r\n00 = Additional trailer axle group not present\r\n01 = Additional trailer axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4073": {
      "PGN": 64874,
      "PGN_Name": "Axle Group Weight",
      "PGN_Description": "AGW",
      "first_bit": 0,
      "SPN": 4073,
      "SPN_Name": "Axle Group Location",
      "SPN_Description": "Specific axle group used in conjunction with and when communicating the axle group weight, listed from the front of the vehicle to the rear.\r\n\r\nIf the value of SPN 5935 is 15, then this SPN is used to indicate the axle group referred to by this PGN. Otherwise, this SPN should be broadcast as 15.\r\n\r\n0 = Reserved\r\n1 = Sole or Forward-most Steer axle group\r\n2 = Lift axle group\r\n3 = Sole or Forward-most Drive axle group\r\n4 = Tag axle group\r\n5 = Additional tractor axle group\r\n6 = Trailer A axle group\r\n7 = Trailer B axle group\r\n8 = Trailer C axle group\r\n9 = Trailer D axle group\r\n10 = Trailer E axle group\r\n11 = Trailer F axle group\r\n12 = Trailer G axle group\r\n13 = Trailer H axle group\r\n14 = Additional trailer axle group\r\n15 = Reserved",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4074": {
      "PGN": 64873,
      "PGN_Name": "Axle Group Calibration Weights",
      "PGN_Description": "AGCW",
      "first_bit": 0,
      "SPN": 4074,
      "SPN_Name": "Axle Group Location",
      "SPN_Description": "Specific axle group used in conjunction with and when communicating the axle group calibration, listed from the front of the vehicle to the rear.\r\n\r\nIf the value of SPN 5936 is 15, then this SPN is used to indicate the axle group referred to by this PGN. Otherwise, this SPN should be broadcast as 15.\r\n\r\n0 = Reserved\r\n1 = Sole or Forward-most Steer axle group\r\n2 = Lift axle group\r\n3 = Sole or Forward-most Drive axle group\r\n4 = Tag axle group\r\n5 = Additional tractor axle group\r\n6 = Trailer A axle group\r\n7 = Trailer B axle group\r\n8 = Trailer C axle group\r\n9 = Trailer D axle group\r\n10 = Trailer E axle group\r\n11 = Trailer F axle group\r\n12 = Trailer G axle group\r\n13 = Trailer H axle group\r\n14 = Additional trailer axle group\r\n15 = Reserved",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4075": {
      "PGN": 64871,
      "PGN_Name": "Zero Net Vehicle Weight Change",
      "PGN_Description": "ZNVW",
      "first_bit": 0,
      "SPN": 4075,
      "SPN_Name": "Zero Net Vehicle Weight Change",
      "SPN_Description": "Zero Net Vehicle Weight Change command.  A controller receiving this command will record the current Gross Combination Weight as the new Zero, and future requests for Net Vehicle Weight Change will be answered with the difference between the (then) current Gross Combination Weight and the recorded value.\r\n\r\n00 - No change to Net Vehicle Weight Change \r\n01 - Zero Net Vehicle Weight Change\r\n10 - Reserved\r\n11 - Not available / Not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4076": {
      "PGN": 64870,
      "PGN_Name": "Engine Temperature 4",
      "PGN_Description": "ET4",
      "first_bit": 0,
      "SPN": 4076,
      "SPN_Name": "Engine Coolant Temperature 2",
      "SPN_Description": "Second temperature of liquid found in the engine cooling system.   See also SPNs 110, 4193 and 6209.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "4077": {
      "PGN": 64869,
      "PGN_Name": "Aftertreatment 1 Fuel Control 2",
      "PGN_Description": "AT1FC2",
      "first_bit": 0,
      "SPN": 4077,
      "SPN_Name": "Aftertreatment 1 Fuel Pressure 2",
      "SPN_Description": "Second fuel pressure measurement for the aftertreatment 1 system",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "4078": {
      "PGN": 64915,
      "PGN_Name": "Generator Control 1",
      "PGN_Description": "GC1",
      "first_bit": 8,
      "SPN": 4078,
      "SPN_Name": "Generator Alternator Efficiency",
      "SPN_Description": "Measured, calculated, and/or estimated operating efficiency of the generator alternator.  Percentage reflects ratio of power output divided by power input, multiplied by 100.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "4079": {
      "PGN": 64915,
      "PGN_Name": "Generator Control 1",
      "PGN_Description": "GC1",
      "first_bit": 24,
      "SPN": 4079,
      "SPN_Name": "Generator Governing Speed Command",
      "SPN_Description": "Command from user and/or generator control system for the genset (engine) to govern to low idle or rated base speed setpoints.  If this method of engine control is used, then the PGN 0 (TSC1) is not expected to be received by the engine controller and it will not be processed.\r\n\r\n00 = Rated Speed\r\n01 = Low Idle Speed\r\n10 = Reserved\r\n11 = Don't care / take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4080": {
      "PGN": 64915,
      "PGN_Name": "Generator Control 1",
      "PGN_Description": "GC1",
      "first_bit": 26,
      "SPN": 4080,
      "SPN_Name": "Generator Frequency Selection",
      "SPN_Description": "Command from user and/or generator control system for the genset (engine) to target operations for 50 Hz, 60 Hz, or 400 Hz.\r\n\r\n0000 = 50 Hz\r\n0001 = 60 Hz\r\n0010 = 400 Hz\r\n0011 - 1101 = SAE Reserved\r\n1110 = Unknown\r\n1111= Don't care /take no action",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4082": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 4,
      "SPN": 4082,
      "SPN_Name": "Fuel Pump Primer Control",
      "SPN_Description": "Parameter used to activate or deactivate a priming system on the fuel transfer system. The fuel priming system is a system that purges air in the fuel lines and may assist fuel delivery to a second pump at lower speeds.\r\n\r\n00 = Deactivate\r\n01 = Activate\r\n10 = Reserved\r\n11 = Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4083": {
      "PGN": 65130,
      "PGN_Name": "Engine Fuel/Lube Systems",
      "PGN_Description": "EFS",
      "first_bit": 51,
      "SPN": 4083,
      "SPN_Name": "Fuel Pump Primer Status",
      "SPN_Description": "Parameter used to transmit the actual status of the fuel priming system.  The fuel priming system is a system that purges air in the fuel lines and may assist fuel delivery to a second pump at lower speeds.\r\n\r\n00 – Off\r\n01 – On\r\n10 – Error\r\n11 – Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4086": {
      "PGN": 1792,
      "PGN_Name": "General Purpose Valve Pressure",
      "PGN_Description": "GPV4",
      "first_bit": 0,
      "SPN": 4086,
      "SPN_Name": "Valve Load Sense Pressure",
      "SPN_Description": "The maximum of the currently measured pressures of a valve's work port A and work port B.",
      "bit_length": 16,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 130
    },
    "4087": {
      "PGN": 1792,
      "PGN_Name": "General Purpose Valve Pressure",
      "PGN_Description": "GPV4",
      "first_bit": 16,
      "SPN": 4087,
      "SPN_Name": "Valve Pilot Pressure",
      "SPN_Description": "Pressure of a valve's pilot supply port.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 49
    },
    "4088": {
      "PGN": 1792,
      "PGN_Name": "General Purpose Valve Pressure",
      "PGN_Description": "GPV4",
      "first_bit": 24,
      "SPN": 4088,
      "SPN_Name": "Valve Assembly Load sense Pressure",
      "SPN_Description": "The maximum pressure of a valve assembly's current collective load sense pressures where a valve assembly can consist of two or more valves.",
      "bit_length": 16,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 130
    },
    "4089": {
      "PGN": 1792,
      "PGN_Name": "General Purpose Valve Pressure",
      "PGN_Description": "GPV4",
      "first_bit": 40,
      "SPN": 4089,
      "SPN_Name": "Valve Assembly Supply Pressure",
      "SPN_Description": "Pressure of the hydraulic supply port to a valve assembly.",
      "bit_length": 16,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 130
    },
    "4097": {
      "PGN": 64929,
      "PGN_Name": "Aftertreatment 1 Fuel Control 1",
      "PGN_Description": "AT1FC1",
      "first_bit": 48,
      "SPN": 4097,
      "SPN_Name": "Aftertreatment 1 Fuel Drain Actuator",
      "SPN_Description": "Indicates whether aftertreatment 1 fuel drain actuator is on or off\r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4098": {
      "PGN": 64928,
      "PGN_Name": "Aftertreatment 2 Fuel Control 1",
      "PGN_Description": "AT2FC1",
      "first_bit": 48,
      "SPN": 4098,
      "SPN_Name": "Aftertreatment 2 Fuel Drain Actuator",
      "SPN_Description": "Indicates whether aftertreatment 2 fuel drain actuator is on or off\r\n\r\n00   not active\r\n01   active\r\n10   reserved for SAE assignment\r\n11   not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4099": {
      "PGN": 1024,
      "PGN_Name": "External Brake Request",
      "PGN_Description": "XBR",
      "first_bit": 24,
      "SPN": 4099,
      "SPN_Name": "XBR urgency",
      "SPN_Description": "The idea of the urgency value is to adjust the endurance brake integration behavior in the EBS system according to the traffic situation.\r\n\r\nOn low urgency values (0%, e.g. downhill cruise control or preceding vehicle far ahead) the brake system shall primarily use endurance brakes to reduce lining wear.\r\n\r\nOn high urgency values (100%, e.g. vehicle close up or a vehicle cuts into the traffic line just before host vehicle) the brake system is expected to gain the demanded deceleration (acceleration) as fast as possible.\r\n\r\nValues:\r\n0% - Situation not critical; low retarder dynamics are tolerated. Activation of the foundation brakes after a time if retarder performance is insufficient\r\ny % - Faster activation of foundation brakes to compensate retarder performance, linear interpolation between 0 and  100%\r\n100% - Low retarder dynamics shall be fully compensated by the foundation brakes\r\n\r\nNotes:\r\n- This parameter has only an effect if XBR EBI switch is set to \"10: endurance brake integration allowed\"\r\n- XBR urgency makes sense only if the XBR request(s) is (are) processed in one device like the EBS controller which also sends TSC1 to the retarder(s). Such a data flow diagram is shown in figure PGN1024_A. When the Retarder is controlled directly by the XBR transmitter XBR urgency should be set to not available.\r\n\r\nIn adaptive cruise control (ACC) operation there are situations where it is useful to have as less lining wear as possible like keeping the set speed on going downhill. It would not be useful to activate foundation brakes in such a situation except when the capabilities of the endurance brakes are not sufficient.\r\n \r\nIn other situations like emergency braking or fast reaction on a car that cut in at a short distance in front of the own vehicle a reaction as fast as possible is needed. In such cases low retarder dynamics must be compensated by the foundation brakes.\r\n\r\nThere are two different ways to integrate the endurance brakes into the adaptive cruise control.\r\na) the request for deceleration could be processed by the EBS system completely. This means that the EBS receives the deceleration demand and activates the friction and/or the endurance brakes accordingly. EBS is sending the TSC1 to the retarder. (see figure PGN1024_A dataflow diagram for external brake request)\r\nb) the ACC sends XBR to the brake controller and TSC1 to the endurance brakes.\r\n\r\nIn case \"a)\" the ACC system does not have direct control of the endurance brakes. To adjust the endurance brakes according to the traffic situation (high or low urgency values see above) this new SPN is needed.\r\n\r\nIf the retarder performance is not sufficient (e.g. because of high retarder temperature) the foundation brakes will be added automatically. This case of not sufficient retarder performance cannot be covered by switching EBI mode from 01 (endurance brakes only) to EBI mode 10 (endurance brake integration allowed) because the actual deceleration caused by the retarder is less than the requested decelleration. A simple switching (01 to 10) would cause an uncomfortable jerk.\r\n\r\n\r\nNOTE:  This parameter is defined in European patent EP 1 386 774 B1 (see reference in section 2.1.3) and is included with permission from the patent holder.  The patent holder is prepared to grant a free license to an unrestricted number of applicants on a worldwide, non-discriminatory basis to comply with this recommended practice.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4151": {
      "PGN": 64851,
      "PGN_Name": "Engine Average Information",
      "PGN_Description": "EAI",
      "first_bit": 0,
      "SPN": 4151,
      "SPN_Name": "Engine Exhaust Temperature Average",
      "SPN_Description": "The calculated average temperature based upon all of the engine exhaust port temperatures.  This is the average temperature based upon the exhaust port temperature measurements at each of the engine cylinders.\r\n\r\nNotes: \r\n\r\nUse SPN 173 - Engine Exhaust Temperature to report the actual measured temperature of the exhaust for the entire engine, after the turbocharger.\r\n\r\nSee SPN 2433 - Engine Exhaust Manifold Bank 2 Temperature 1, and SPN 2434 - Engine Exhaust Manifold Bank 1 Temperature 1 to report the actual measured temperature of the manifold for engines requiring more than one exhaust temperature measurement.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4152": {
      "PGN": 64851,
      "PGN_Name": "Engine Average Information",
      "PGN_Description": "EAI",
      "first_bit": 32,
      "SPN": 4152,
      "SPN_Name": "Engine Exhaust Bank 2 Temperature Average",
      "SPN_Description": "The calculated average temperature based upon all of the Bank 2 (right bank) engine exhaust port temperatures.  This is the average temperature based upon the exhaust port temperature measurements of each of the engine cylinders on the right bank before the turbocharger.\r\n\r\nUse SPN 2433 Engine Exhaust Manifold Bank 2 Temperature 1 to report the actual measured temperature of the manifold on the right side as seen from the flywheel end of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4153": {
      "PGN": 64851,
      "PGN_Name": "Engine Average Information",
      "PGN_Description": "EAI",
      "first_bit": 16,
      "SPN": 4153,
      "SPN_Name": "Engine Exhaust Bank 1 Temperature Average",
      "SPN_Description": "The calculated average temperature based upon all of the Bank 1 (left bank) engine exhaust port temperatures.  This is the average temperature based upon the exhaust port temperature measurements of each of the engine cylinders on the left bank prior to the turbocharger.\r\n\r\nUse SPN 2434 Engine Exhaust Manifold Bank 1 Temperature 1 to report the actual measured temperature of the manifold on the left side as seen from the flywheel end of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4154": {
      "PGN": 61444,
      "PGN_Name": "Electronic Engine Controller 1",
      "PGN_Description": "EEC1",
      "first_bit": 4,
      "SPN": 4154,
      "SPN_Name": "Actual Engine - Percent Torque (Fractional)",
      "SPN_Description": "This parameter displays an additional torque in percent of the reference engine torque. \r\n\r\nWhen the MSB is set to 1, this parameter is not available.  When the MSB is set to 0, bits 1 to 3 indicate the desired torque with resolution of 0.125%/bit . Range is from 0 to 0.875% of reference torque.  \r\n\r\nThe parameter is used in combination with SPN 513 Actual Engine Torque. The resulting actual engine torque will be calculated by adding these two parameters. \r\n\r\nAdditional torque representations\r\n\r\n0000 = +0.000%\r\n0001 = +0.125%\r\n.\r\n.\r\n.\r\n0111 = +0.875%\r\n1000 - 1111 = not available\r\n\r\nFor example, if SPN 513 = 150 (or 25%) and this parameter is 0100, the torque would be 25.5%.\r\nIf SPN 513 = 175 (or 50%) and this parameter is 0001, the torque would be 50.125%\r\nIf SPN 513 = 175 (or 50%) and this parameter is 1111, the torque would remain 50% (no high resolution available)",
      "bit_length": 4,
      "scaling": 0.125,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 268
    },
    "4155": {
      "PGN": 2048,
      "PGN_Name": "Auxiliary Input/Output Status 5",
      "PGN_Description": "AUXIO5",
      "first_bit": 0,
      "SPN": 4155,
      "SPN_Name": "Auxiliary I/O Channel #6",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "4156": {
      "PGN": 2048,
      "PGN_Name": "Auxiliary Input/Output Status 5",
      "PGN_Description": "AUXIO5",
      "first_bit": 16,
      "SPN": 4156,
      "SPN_Name": "Auxiliary I/O Channel #5",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "4157": {
      "PGN": 2048,
      "PGN_Name": "Auxiliary Input/Output Status 5",
      "PGN_Description": "AUXIO5",
      "first_bit": 32,
      "SPN": 4157,
      "SPN_Name": "Auxiliary I/O Channel #4",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "4158": {
      "PGN": 2048,
      "PGN_Name": "Auxiliary Input/Output Status 5",
      "PGN_Description": "AUXIO5",
      "first_bit": 48,
      "SPN": 4158,
      "SPN_Name": "Auxiliary I/O Channel #3",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "4159": {
      "PGN": 40192,
      "PGN_Name": "Auxiliary Input/Output Status 6",
      "PGN_Description": "AUXIO6",
      "first_bit": 0,
      "SPN": 4159,
      "SPN_Name": "Auxiliary I/O Channel #10",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4160": {
      "PGN": 40192,
      "PGN_Name": "Auxiliary Input/Output Status 6",
      "PGN_Description": "AUXIO6",
      "first_bit": 8,
      "SPN": 4160,
      "SPN_Name": "Auxiliary I/O Channel #9",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4161": {
      "PGN": 40192,
      "PGN_Name": "Auxiliary Input/Output Status 6",
      "PGN_Description": "AUXIO6",
      "first_bit": 16,
      "SPN": 4161,
      "SPN_Name": "Auxiliary I/O Channel #8",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4162": {
      "PGN": 40192,
      "PGN_Name": "Auxiliary Input/Output Status 6",
      "PGN_Description": "AUXIO6",
      "first_bit": 24,
      "SPN": 4162,
      "SPN_Name": "Auxiliary I/O Channel #7",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4163": {
      "PGN": 40192,
      "PGN_Name": "Auxiliary Input/Output Status 6",
      "PGN_Description": "AUXIO6",
      "first_bit": 32,
      "SPN": 4163,
      "SPN_Name": "Auxiliary I/O Channel #14",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4164": {
      "PGN": 40192,
      "PGN_Name": "Auxiliary Input/Output Status 6",
      "PGN_Description": "AUXIO6",
      "first_bit": 40,
      "SPN": 4164,
      "SPN_Name": "Auxiliary I/O Channel #13",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4165": {
      "PGN": 40192,
      "PGN_Name": "Auxiliary Input/Output Status 6",
      "PGN_Description": "AUXIO6",
      "first_bit": 48,
      "SPN": 4165,
      "SPN_Name": "Auxiliary I/O Channel #12",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4166": {
      "PGN": 40192,
      "PGN_Name": "Auxiliary Input/Output Status 6",
      "PGN_Description": "AUXIO6",
      "first_bit": 56,
      "SPN": 4166,
      "SPN_Name": "Auxiliary I/O Channel #11",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4167": {
      "PGN": 39936,
      "PGN_Name": "Auxiliary Input/Output Status 7",
      "PGN_Description": "AUXIO7",
      "first_bit": 0,
      "SPN": 4167,
      "SPN_Name": "Auxiliary I/O Channel #18",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4168": {
      "PGN": 39936,
      "PGN_Name": "Auxiliary Input/Output Status 7",
      "PGN_Description": "AUXIO7",
      "first_bit": 8,
      "SPN": 4168,
      "SPN_Name": "Auxiliary I/O Channel #17",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4169": {
      "PGN": 39936,
      "PGN_Name": "Auxiliary Input/Output Status 7",
      "PGN_Description": "AUXIO7",
      "first_bit": 16,
      "SPN": 4169,
      "SPN_Name": "Auxiliary I/O Channel #16",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4170": {
      "PGN": 39936,
      "PGN_Name": "Auxiliary Input/Output Status 7",
      "PGN_Description": "AUXIO7",
      "first_bit": 24,
      "SPN": 4170,
      "SPN_Name": "Auxiliary I/O Channel #15",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4171": {
      "PGN": 39936,
      "PGN_Name": "Auxiliary Input/Output Status 7",
      "PGN_Description": "AUXIO7",
      "first_bit": 32,
      "SPN": 4171,
      "SPN_Name": "Auxiliary I/O Channel #22",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4172": {
      "PGN": 39936,
      "PGN_Name": "Auxiliary Input/Output Status 7",
      "PGN_Description": "AUXIO7",
      "first_bit": 40,
      "SPN": 4172,
      "SPN_Name": "Auxiliary I/O Channel #21",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4173": {
      "PGN": 39936,
      "PGN_Name": "Auxiliary Input/Output Status 7",
      "PGN_Description": "AUXIO7",
      "first_bit": 48,
      "SPN": 4173,
      "SPN_Name": "Auxiliary I/O Channel #20",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4174": {
      "PGN": 39936,
      "PGN_Name": "Auxiliary Input/Output Status 7",
      "PGN_Description": "AUXIO7",
      "first_bit": 56,
      "SPN": 4174,
      "SPN_Name": "Auxiliary I/O Channel #19",
      "SPN_Description": "Identifies the current value of auxiliary input/output channels that are configured uniquely per application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "4175": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 53,
      "SPN": 4175,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Forced Status",
      "SPN_Description": "Indicates the forced execution status of diesel particulate filter regeneration.\r\n\r\n000 Not Active\r\n001 Active – Forced by Switch (See SPN 3696)\r\n010 Active – Forced by Service Tool \r\n011 Reserved for SAE Assignment\r\n100 Reserved for SAE Assignment\r\n101 Reserved for SAE Assignment\r\n110 Reserved for SAE Assignment\r\n111 not available\r\n\r\nThis SPN indicates the forced execution status of diesel particulate filter regeneration.  The SPN would be “Not Active” when the execution of diesel particulate filter regeneration has not been forced.  Either of the states “Active – Forced by Switch” and “Active – Forced by Service Tool” will be active when execution of diesel particulate filter regeneration is forced, providing feedback as to which entity forced the execution of diesel particulate filter regeneration.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "4176": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 0,
      "SPN": 4176,
      "SPN_Name": "Transmission Current Range Display Blank State",
      "SPN_Description": "State signal indicating a transmission request for the display of the Transmission Current Range parameter (SPN 163) to be blanked or not blanked.  The 'Transmission Current Range Display Blank State' indicator can be utilized by (but not limited to) the shift console, instrument cluster, or cab display.  Definition of the cause of this state is at the discretion of the transmission manufacturer.\r\n\r\n00=Not Blanked\r\n01=Blanked\r\n10=Error\r\n11=Not Supported\r\n\r\nNote:  This is a companion of SPN 1850, that will allow the \"current range\" display to be blanked as needed while still retaining a valid current range broadcast in SPN 163.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4177": {
      "PGN": 64917,
      "PGN_Name": "Transmission Fluids 2",
      "PGN_Description": "TRF2",
      "first_bit": 24,
      "SPN": 4177,
      "SPN_Name": "Transmission Oil Life Remaining",
      "SPN_Description": "Signal which indicates the actual oil life remaining in percent.  100% means the transmission oil is brand new, and 0% means the transmission oil is at the end of its life.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4178": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 2,
      "SPN": 4178,
      "SPN_Name": "Transmission Service Indicator",
      "SPN_Description": "Signal from transmission indicating that some aspect of the gearbox requires servicing, such as the oil, filter, clutch(es) or other component.\r\n\r\n00  Transmission Service Indicator is off\r\n01  Transmission Service Indicator is on continuously\r\n10  Transmission Service Indicator is flashing\r\n11  Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4180": {
      "PGN": 39680,
      "PGN_Name": "Proprietary Method Identification",
      "PGN_Description": "PMI",
      "first_bit": 0,
      "SPN": 4180,
      "SPN_Name": "Data Dictionary Manufacturer Code",
      "SPN_Description": "The J1939 Manufacturer Code (see J1939 Table B10) associated with the manufacturer who defined the proprietary communications method.  0x7FF reserved for \"Not Available\"",
      "bit_length": 11,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 218
    },
    "4181": {
      "PGN": 39680,
      "PGN_Name": "Proprietary Method Identification",
      "PGN_Description": "PMI",
      "first_bit": 11,
      "SPN": 4181,
      "SPN_Name": "Data Dictionary Method",
      "SPN_Description": "A manufacturer defined code to define the proprietary communications method.  The structure and interpretation of the code is manufacturer specific.  This allows manufacturers to establish their own methods for reporting proprietary support for PropA, PropA2, and PropB messages.",
      "bit_length": 21,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 217
    },
    "4191": {
      "PGN": 0,
      "PGN_Name": "Torque/Speed Control 1",
      "PGN_Description": "TSC1",
      "first_bit": 40,
      "SPN": 4191,
      "SPN_Name": "Engine Requested Torque (Fractional)",
      "SPN_Description": "This parameter displays an additional torque in percent of the reference engine torque. \r\n\r\nWhen the MSB is set to 1, this parameter is not available.  When the MSB is set to 0, bits 1 to 3 indicate the desired torque with resolution of 0.125%/bit . Range is from 0 to 0.875% of reference torque.  \r\n\r\nThe parameter is used in combination with SPN 518  Engine Requested Torque/Torque Limit. The resulting torque/torque limit will be calculated by adding these two parameters. \r\n\r\nValidity of Engine Requested Torque High Res has no effect on SPN 518. \r\n\r\nAdditional torque representations\r\n\r\n0000 = +0.000%\r\n0001 = +0.125%\r\n.\r\n.\r\n.\r\n0111 = +0.875%\r\n1000 - 1111 = not available\r\n\r\nFor example, if SPN 518 = 150 (or 25%) and this parameter is 0100, the torque would be 25.5%.\r\nIf SPN 518 = 175 (or 50%) and this parameter is 0001, the torque would be 50.125%\r\nIf SPN 518 = 175 (or 50%) and this parameter is 1111, the torque would remain 50% (no high resolution available)",
      "bit_length": 4,
      "scaling": 0.125,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 268
    },
    "4193": {
      "PGN": 64870,
      "PGN_Name": "Engine Temperature 4",
      "PGN_Description": "ET4",
      "first_bit": 8,
      "SPN": 4193,
      "SPN_Name": "Engine Coolant Pump Outlet Temperature",
      "SPN_Description": "The actual value of engine coolant temperature at the coolant pump outlet.  See also SPNs 110, 4076 and 6209 for additional coolant temperature parameters.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "4194": {
      "PGN": 64870,
      "PGN_Name": "Engine Temperature 4",
      "PGN_Description": "ET4",
      "first_bit": 16,
      "SPN": 4194,
      "SPN_Name": "Engine Coolant Thermostat Opening",
      "SPN_Description": "The current position of the Thermostat used to regulate the temperature of the engine coolant.  0% represents the thermostat allows flow to completely bypass the radiator and 100% represents the flow is fully through the radiator.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4195": {
      "PGN": 64850,
      "PGN_Name": "Engine Coolant Control Valve Command",
      "PGN_Description": "ECCVC",
      "first_bit": 0,
      "SPN": 4195,
      "SPN_Name": "Engine Coolant Thermostat Mode",
      "SPN_Description": "Specifies if the engine coolant thermostat valve will operate in temperature control mode or position control mode.\r\n\r\n00 = temperature control mode\r\n01 = position control mode (used for service only)\r\n10 = reserved\r\n11 = don't care/reserved",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4196": {
      "PGN": 64850,
      "PGN_Name": "Engine Coolant Control Valve Command",
      "PGN_Description": "ECCVC",
      "first_bit": 8,
      "SPN": 4196,
      "SPN_Name": "Desired Engine Coolant Pump Outlet Temperature",
      "SPN_Description": "Desired engine coolant temperature of the engine to an electronic thermostat.  If the electronic thermostat valve is operating in position control mode (see SPN 4195)  then transmit 0xFF.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "4197": {
      "PGN": 64850,
      "PGN_Name": "Engine Coolant Control Valve Command",
      "PGN_Description": "ECCVC",
      "first_bit": 16,
      "SPN": 4197,
      "SPN_Name": "Desired Engine Coolant Thermostat Opening",
      "SPN_Description": "Indicates the desired position of the engine coolant control valve.   0% represents the thermostat allows flow to completely bypass the radiator and 100% represents the flow is fully through the radiator.  If the electronic thermostat is operating in temperature control mode (SPN 4195) then transmit 0xFF.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4198": {
      "PGN": 64849,
      "PGN_Name": "Aftercooler Coolant Control Valve Command",
      "PGN_Description": "ACCVC",
      "first_bit": 0,
      "SPN": 4198,
      "SPN_Name": "Aftercooler Coolant Thermostat Mode",
      "SPN_Description": "Specifies if the aftercooler coolant thermostat valve will operate in temperature control mode or position control mode.\r\n\r\n00 = temperature control mode\r\n01 = position control mode (used for service only)\r\n10 = reserved\r\n11 = don't care/reserved",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4199": {
      "PGN": 64849,
      "PGN_Name": "Aftercooler Coolant Control Valve Command",
      "PGN_Description": "ACCVC",
      "first_bit": 8,
      "SPN": 4199,
      "SPN_Name": "Desired Aftercooler Coolant Intake Temperature",
      "SPN_Description": "Indicates the desired temperature of the fluid in the low temperature aftercooler circuit to an electronic thermostat.  If the aftercooler coolant thermostat valve is operating in position control mode (see SPN 4198) then this value should be 0xFF.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "4200": {
      "PGN": 64849,
      "PGN_Name": "Aftercooler Coolant Control Valve Command",
      "PGN_Description": "ACCVC",
      "first_bit": 16,
      "SPN": 4200,
      "SPN_Name": "Desired Aftercooler Coolant Thermostat Opening",
      "SPN_Description": "Used to transmit the desired position of the low temperature aftercooler temperature control valve.  0% represents the thermostat allows flow to completely bypass the aftercooler and 100% represents the flow is fully through the aftercooler.   If the aftercooler coolant thermostat is operating in temperature control mode (see SPN 4198)  then this value should be 0xFF.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4201": {
      "PGN": 61473,
      "PGN_Name": "Engine Speed Sensor Information 1",
      "PGN_Description": "ESSI1",
      "first_bit": 0,
      "SPN": 4201,
      "SPN_Name": "Engine Speed 1",
      "SPN_Description": "The engine speed as measured by speed sensor 1.\r\n\r\nNote:  This is for the engine speed from the 1st engine speed sensor.  This may be different than SPN 190 when used in multiple engine speed sensor configurations.   In an application with only one speed sensor, SPN 190 will represent both the speed and the sensor for diagnostic purposes and SPN 4201 will not be used. However, in an application with multiple engine speed sensors, SPN 190 data can be derived from any of the speed sensors.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "4202": {
      "PGN": 61473,
      "PGN_Name": "Engine Speed Sensor Information 1",
      "PGN_Description": "ESSI1",
      "first_bit": 32,
      "SPN": 4202,
      "SPN_Name": "Engine Speed 3",
      "SPN_Description": "The engine speed as measured by speed sensor 3.\r\n\r\nNote:  This is for the engine speed from the 3rd engine speed sensor.  This may be different than SPN 190 when used in multiple engine speed sensor configurations.   In an application with multiple engine speed sensors, SPN 190 data can be derived from any of the speed sensors.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "4203": {
      "PGN": 61473,
      "PGN_Name": "Engine Speed Sensor Information 1",
      "PGN_Description": "ESSI1",
      "first_bit": 54,
      "SPN": 4203,
      "SPN_Name": "Engine Speed Sensor 1 Timing Pattern Status",
      "SPN_Description": "This is the timing pattern status of the engine speed sensor signal for sensor 1.   The sensor may be sending a speed signal but the pattern may not be valid.  Since the speed is considered valid, the error indicator will not be used in the engine speed parameter (SPN 4201).  The sensor does give a speed but the pattern is not matched.  In this condition, the position of the crank has not been determined so injection is not enabled.  The engine speed signal provides both engine speed and crankshaft location information to the engine control.  A \"Not OK\" status may be caused by extra or missing teeth, gear runout, etc.\r\n\r\n00 = Not OK\r\n01 = OK\r\n10 = Error\r\n11 = Not available\r\n\r\nNote:  This is intended to be used on a service tool for troubleshooting a no start condition.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4204": {
      "PGN": 61473,
      "PGN_Name": "Engine Speed Sensor Information 1",
      "PGN_Description": "ESSI1",
      "first_bit": 52,
      "SPN": 4204,
      "SPN_Name": "Engine Speed Sensor 2 Timing Pattern Status",
      "SPN_Description": "This is the timing pattern status of the engine speed sensor signal for sensor 2.  The sensor may be sending a speed signal but the pattern may not be valid.  Since the speed is considered valid, the error indicator will not be used in the engine speed parameter (SPN 723).\r\n\r\n00 = Not OK\r\n01 = OK\r\n10 = Error\r\n11 = Not available\r\n\r\nNote:  This is intended to be used on a service tool for troubleshooting a no start condition.  The sensor does give a speed but the pattern is not matched.  In this condition, the position of the crank has not been determined so injection is not enabled.  The engine speed signal provides both engine speed and crankshaft location information to the engine control.  A \"Not OK\" status may be caused by extra or missing teeth, gear runout, etc.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4205": {
      "PGN": 61473,
      "PGN_Name": "Engine Speed Sensor Information 1",
      "PGN_Description": "ESSI1",
      "first_bit": 50,
      "SPN": 4205,
      "SPN_Name": "Engine Speed Sensor 3 Timing Pattern Status",
      "SPN_Description": "This is the timing pattern status of the engine speed sensor signal for sensor 3.  The sensor may be sending a speed signal but the pattern may not be valid.  Since the speed is considered valid, the error indicator will not be used in the engine speed parameter (SPN 4202).\r\n00 = Not OK\r\n01 = OK\r\n10 = Error\r\n11 = Not available\r\n\r\nNote:  This is intended to be used on a service tool for troubleshooting a no start condition.  The sensor does give a speed but the pattern is not matched.  In this condition, the position of the crank has not been determined so injection is not enabled.  The engine speed signal provides both engine speed and crankshaft location information to the engine control.  A \"Not OK\" status may be caused by extra or missing teeth, gear runout, etc.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4206": {
      "PGN": 0,
      "PGN_Name": "Torque/Speed Control 1",
      "PGN_Description": "TSC1",
      "first_bit": 56,
      "SPN": 4206,
      "SPN_Name": "Message Counter",
      "SPN_Description": "The message counter is used to detect situations where the transmitting ECU malfunction repeats the same frame all the time.  The receiver of the information may use the counter parameter to detect this situation.  The transmitting device will increase the message counter in every cycle. The message counter will count from 0 to 7 and then wrap. \r\n\r\nThe values 0x8 thru 0xE are SAE reserved and should be ignored by the receiver.\r\n\r\nValue 0xF (all bits set to 1) will indicate that the message counter is not available.  For compatibility purposes, TSC1 should also be honored if the message counter is not available from the transmitting device.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 220
    },
    "4207": {
      "PGN": 0,
      "PGN_Name": "Torque/Speed Control 1",
      "PGN_Description": "TSC1",
      "first_bit": 60,
      "SPN": 4207,
      "SPN_Name": "Message Checksum",
      "SPN_Description": "The message checksum is used to verify the signal path from the transmitting device to the receiving device.\r\n \r\nThe message checksum is calculated using the first 7 data bytes, the message counter and the bytes of the message identifier. It is calculated as follows:\r\n\r\nChecksum = (Byte1 + Byte2 + Byte3 + Byte4 + Byte5 + Byte6 + Byte7 + (message counter & 0x0F) + message ID low byte + message ID mid low byte + message ID mid high byte + message ID high byte)\r\n\r\nMessage Checksum = (((Checksum >> 6) & 0x03) + (Checksum >>3) +  Checksum) & 0x07\r\n\r\nValue 0xF (all bits set to 1) will indicate that the checksum is not available.  For compatibility purposes, TSC1 should also be honored if the checksum is not available from the transmitting device.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 220
    },
    "4211": {
      "PGN": 65213,
      "PGN_Name": "Fan Drive #1",
      "PGN_Description": "FD1",
      "first_bit": 32,
      "SPN": 4211,
      "SPN_Name": "Hydraulic Fan Motor Pressure",
      "SPN_Description": "The hydraulic pressure used to drive the fan system, sensed before the hydraulic fan motor.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "4212": {
      "PGN": 65213,
      "PGN_Name": "Fan Drive #1",
      "PGN_Description": "FD1",
      "first_bit": 48,
      "SPN": 4212,
      "SPN_Name": "Fan Drive Bypass Command Status",
      "SPN_Description": "Status of the Fan Drive Bypass Command as being commanded by the ECU.  The fan drive bypass diverts pump pressure away from the hydraulic motor to maintain the fan drive pressure.  0% is defined as no bypass (i.e. diverting no fan drive pressure) and 100% is defined as full bypass (i.e. diverting the maximum fan drive pressure) from the fan motor.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4218": {
      "PGN": 64704,
      "PGN_Name": "Electronic Transmission Controller #11",
      "PGN_Description": "ETC11",
      "first_bit": 0,
      "SPN": 4218,
      "SPN_Name": "Transmission Shift Rail 1 Position",
      "SPN_Description": "The current position of transmission shift rail identified as rail #1.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4219": {
      "PGN": 64704,
      "PGN_Name": "Electronic Transmission Controller #11",
      "PGN_Description": "ETC11",
      "first_bit": 8,
      "SPN": 4219,
      "SPN_Name": "Transmission Shift Rail 2 Position",
      "SPN_Description": "The current position of transmission shift rail identified as rail #2.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4220": {
      "PGN": 64704,
      "PGN_Name": "Electronic Transmission Controller #11",
      "PGN_Description": "ETC11",
      "first_bit": 16,
      "SPN": 4220,
      "SPN_Name": "Transmission Shift Rail 3 Position",
      "SPN_Description": "The current position of transmission shift rail identified as rail #3.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4233": {
      "PGN": 61440,
      "PGN_Name": "Electronic Retarder Controller 1",
      "PGN_Description": "ERC1",
      "first_bit": 28,
      "SPN": 4233,
      "SPN_Name": "Retarder Road Speed Limit Switch",
      "SPN_Description": "Retarder road speed limit switch states:\r\n\r\n00   Road speed limiting by retarder is disabled\r\n01   Road speed limiting by retarder is enabled.  The road speed that the retarder will limit will be determined when the switch transitions from 00 to 01\r\n10   Error Indicator\r\n11   Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4234": {
      "PGN": 61440,
      "PGN_Name": "Electronic Retarder Controller 1",
      "PGN_Description": "ERC1",
      "first_bit": 30,
      "SPN": 4234,
      "SPN_Name": "Retarder Road Speed Exceeded Status",
      "SPN_Description": "Retarder Road Speed Exceeded Status:\r\n\r\n00   Road speed is below threshold \r\n01   Road speed is above threshold and retarder is allowed to be activated\r\n10   Reserved\r\n11   Don't care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4236": {
      "PGN": 64841,
      "PGN_Name": "Engine Exhaust Bank 1 O2 Fuel Trim",
      "PGN_Description": "O2FT1",
      "first_bit": 16,
      "SPN": 4236,
      "SPN_Name": "Short-term Fuel Trim - Bank 1",
      "SPN_Description": "This parameter is the short-term percent change in fueling based on the O2 sensor feedback for cylinder bank 1, based on the operating point in the nominal fuel map.\r\n\r\nNote:  This is similar to SPN 1695, but with higher resolution.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -100,
      "unit": "%",
      "SLOT_ID": 251
    },
    "4237": {
      "PGN": 64841,
      "PGN_Name": "Engine Exhaust Bank 1 O2 Fuel Trim",
      "PGN_Description": "O2FT1",
      "first_bit": 0,
      "SPN": 4237,
      "SPN_Name": "Long-term Fuel Trim - Bank 1",
      "SPN_Description": "This parameter is the long-term percent change in fueling based on the O2 sensor feedback for cylinder bank 1, based on the operating point in the nominal fuel map.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -100,
      "unit": "%",
      "SLOT_ID": 251
    },
    "4238": {
      "PGN": 64840,
      "PGN_Name": "Engine Exhaust Bank 2 O2 Fuel Trim",
      "PGN_Description": "O2FT2",
      "first_bit": 16,
      "SPN": 4238,
      "SPN_Name": "Short-term Fuel Trim - Bank 2",
      "SPN_Description": "This parameter is the short-term percent change in fueling based on the O2 sensor feedback for cylinder bank 2, based on the operating point in the nominal fuel map.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -100,
      "unit": "%",
      "SLOT_ID": 251
    },
    "4239": {
      "PGN": 64840,
      "PGN_Name": "Engine Exhaust Bank 2 O2 Fuel Trim",
      "PGN_Description": "O2FT2",
      "first_bit": 0,
      "SPN": 4239,
      "SPN_Name": "Long-term Fuel Trim - Bank 2",
      "SPN_Description": "This parameter is the long-term percent change in fueling based on the O2 sensor feedback for cylinder bank 2, based on the operating point in the nominal fuel map.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -100,
      "unit": "%",
      "SLOT_ID": 251
    },
    "4240": {
      "PGN": 64841,
      "PGN_Name": "Engine Exhaust Bank 1 O2 Fuel Trim",
      "PGN_Description": "O2FT1",
      "first_bit": 32,
      "SPN": 4240,
      "SPN_Name": "Engine Exhaust Bank 1 O2 Sensor Closed Loop Operation",
      "SPN_Description": "This parameter indicates the status of the bank 1 O2 sensor feedback closed loop operation\r\n\r\n0000 = Open loop - has not yet satisfied conditions to go closed loop\r\n0001 = Closed loop - using oxygen sensor(s) as feedback for fuel control\r\n0010 = Open loop due to driving conditions (e.g., power enrichment, deceleration enleanment)\r\n0011 = Open loop - due to detected system fault \r\n0100 = Closed loop, but fault with at least one oxygen sensor - may be using single oxygen sensor for fuel control\r\n0101-1110 = reserved\r\n1111 = not supported\r\n\r\nSee also SPN 1696 as an prior implementation.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4241": {
      "PGN": 64840,
      "PGN_Name": "Engine Exhaust Bank 2 O2 Fuel Trim",
      "PGN_Description": "O2FT2",
      "first_bit": 32,
      "SPN": 4241,
      "SPN_Name": "Engine Exhaust Bank 2 O2 Sensor Closed Loop Operation",
      "SPN_Description": "This parameter indicates the status of the bank 2 O2 sensor feedback closed loop operation\r\n\r\n0000 = Open loop - has not yet satisfied conditions to go closed loop\r\n0001 = Closed loop - using oxygen sensor(s) as feedback for fuel control\r\n0010 = Open loop due to driving conditions (e.g., power enrichment, deceleration enleanment)\r\n0011 = Open loop - due to detected system fault \r\n0100 = Closed loop, but fault with at least one oxygen sensor - may be using single oxygen sensor for fuel control\r\n0101-1110 = reserved\r\n1111 = not supported",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4242": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 6,
      "SPN": 4242,
      "SPN_Name": "Transmission Reverse Gear Shift Inhibit Request",
      "SPN_Description": "Allows devices external to the normal transmission shift selector system to request the transmission to inhibit shifts into any Reverse gear and force the transmission into Neutral if it is currently in Reverse or attempting to shift to Reverse.  These transmission responses occur regardless of shift selector (Forward, Neutral or Reverse) position at the time the request is received.\r\n\r\nThis request would typically come from a component wishing to override the vehicle operator’s ability to shift or keep the transmission in Reverse.  For example, the control system of a rear-loading refuse packer may wish to prevent shifts to reverse when it detects the presence of someone behind the vehicle.\r\n\r\nReverse gear shift inhibits include all ‘Neutral-to-Reverse’ shifts and ‘Forward-to-Reverse’ shifts; the ability of the transmission to complete ‘Neutral-to-Forward’ or ‘Forward-to-Forward’ gear shifts is not impacted.\r\n\r\nIf the transmission is in Reverse or attempting to shift to Reverse and receives an active Reverse gear shift inhibit request (0b01), the transmission will shift to Neutral.  When the request subsequently goes inactive (0b00), the transmission will remain in Neutral until it receives a selector input from the vehicle operator requesting it to shift into a Non-Neutral gear.  The transmission should not automatically return to the previous gear when this signal goes inactive.\r\n\r\nTransmission response to this request can be monitored via SPN 4261 – Transmission Reverse Gear Shift Inhibit Status, SPN 523 Transmission Current Gear, and SPN 524 Transmission Selected Gear.\r\n\r\n00 = Allow shifts into Reverse gear\r\n01 = Inhibit shifts into Reverse gear, and shift transmission to Neutral if already in Reverse or attempting to shift to Reverse\r\n10 = Reserved \r\n11 = Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4245": {
      "PGN": 65109,
      "PGN_Name": "Gaseous Fuel Properties",
      "PGN_Description": "GFD",
      "first_bit": 32,
      "SPN": 4245,
      "SPN_Name": "Fuel energy content",
      "SPN_Description": "Energy content (lower heating value) of the gaseous fuel.\r\n\r\nNote:  For gaseous fuels, the fuel's energy content (lower heating value) is commonly defined in terms of energy / volume. The gas volume is defined for regular pressure and temperature conditions and is stated in terms of normal cubic meters.  For the purpose of measuring energy content in gaseous fuels, the normal conditions are defined to be 101.31 kPa and 0 degC as defined in ISO 10780:1994 – Stationary source emissions, Measurement of velocity and volume flowrate of gas streams in ducts",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "MJ/Nm³",
      "SLOT_ID": 323
    },
    "4246": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 56,
      "SPN": 4246,
      "SPN_Name": "Transmission Mode 5",
      "SPN_Description": "Indicates whether transmission mode 5 is enabled. Modes are manufacturer specific and are not necessarily mutually exclusive. See also SPN 4250.\r\n\r\n00  Disable\r\n01  Enable\r\n10  Reserved\r\n11  Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4247": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 58,
      "SPN": 4247,
      "SPN_Name": "Transmission Mode 6",
      "SPN_Description": "Indicates whether transmission mode 6 is enabled. Modes are manufacturer specific and are not necessarily mutually exclusive. See also SPN 4251.\r\n\r\n00  Disable\r\n01  Enable\r\n10  Reserved\r\n11  Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4248": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 60,
      "SPN": 4248,
      "SPN_Name": "Transmission Mode 7",
      "SPN_Description": "Indicates whether transmission mode 7 is enabled. Modes are manufacturer specific and are not necessarily mutually exclusive. See also SPN 4252.\r\n\r\n00  Disable\r\n01  Enable\r\n10  Reserved\r\n11  Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4249": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 62,
      "SPN": 4249,
      "SPN_Name": "Transmission Mode 8",
      "SPN_Description": "Indicates whether transmission mode 8 is enabled. Modes are manufacturer specific and are not necessarily mutually exclusive. See also SPN 4253.\r\n\r\n00  Disable\r\n01  Enable\r\n10  Reserved\r\n11  Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4250": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 32,
      "SPN": 4250,
      "SPN_Name": "Transmission Mode 5 Indicator",
      "SPN_Description": "This state signal is the transmission’s indication that it is operating under transmission mode 5 (SPN 4246) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\r\n\r\n00 Transmission Mode 5 not active\r\n01 Transmission Mode 5 active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4251": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 34,
      "SPN": 4251,
      "SPN_Name": "Transmission Mode 6 Indicator",
      "SPN_Description": "This state signal is the transmission’s indication that it is operating under transmission mode 6 (SPN 4247) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\r\n\r\n00 Transmission Mode 6 not active\r\n01 Transmission Mode 6 active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4252": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 36,
      "SPN": 4252,
      "SPN_Name": "Transmission Mode 7 Indicator",
      "SPN_Description": "This state signal is the transmission’s indication that it is operating under transmission mode 7 (SPN 4248) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\r\n\r\n00 Transmission Mode 7 not active\r\n01 Transmission Mode 7 active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4253": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 38,
      "SPN": 4253,
      "SPN_Name": "Transmission Mode 8 Indicator",
      "SPN_Description": "This state signal is the transmission’s indication that it is operating under transmission mode 8 (SPN 4249) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\r\n\r\n00 Transmission Mode 8 not active\r\n01 Transmission Mode 8 active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4255": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 50,
      "SPN": 4255,
      "SPN_Name": "Transmission Requested Launch Gear",
      "SPN_Description": "Initial gear for the transmission to start out in when the vehicle is launched from a standing stop, as specified by the vehicle operator or vehicle system.  Automatic transmissions typically default to starting out in 1st gear.  However, in applications such as those with very low gearing, it is desirable to launch the vehicle in a range higher than 1st.   For example, when the vehicle has little or no payload, the operator may wish to launch from 2nd or 3rd gear to avoid stacked, unnecessary shifts in the lower ranges.\r\n\r\nThe intent of SPN 4255 is to request the initial starting range to be used when the vehicle gets underway from a stop; it does not request direction changes (forward / reverse). SPN 525 sets the direction requested by the operator. For example, if SPN 525 is requesting a Reverse range, any SPN 4255 value indicating a desired forward launch gear would be ignored by the transmission controller. The SPN 4255 value is only utilized by the transmission controller when its direction matches that of the current SPN 525 value.\r\n\r\n0000 = No specific launch gear requested; use default launch gear\r\n0001 = Launch the vehicle in 1st gear\r\n0010 = Launch the vehicle in 2nd gear\r\n0011 = Launch the vehicle in 3rd gear\r\n0100 = Launch the vehicle in 4th gear\r\n0101 = Launch the vehicle in 5th gear\r\n0110 = Launch the vehicle in 6th gear\r\n0111 = Launch the vehicle in 7th gear\r\n1000 = Launch the vehicle in 8th gear\r\n1001 = Launch the vehicle in Reverse 1\r\n1010 = Launch the vehicle in Reverse 2\r\n1011 = Launch the vehicle in Reverse 3\r\n1100 = Launch the vehicle in Reverse 4 \r\n1101 = Allow transmission to select the optimum launch gear\r\n1110 = Error\r\n1111 = Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4261": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 40,
      "SPN": 4261,
      "SPN_Name": "Transmission Reverse Gear Shift Inhibit Status",
      "SPN_Description": "Reflects the status of transmission reverse inhibit activity in response to requests via SPN 4242 - Transmission Reverse Gear Shift Inhibit Request.  Typically broadcast by the transmission controller.\r\n\r\n00 = Reverse gear shifts are currently allowed\r\n01 = Reverse gear shifts are currently inhibited\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4287": {
      "PGN": 64961,
      "PGN_Name": "Engine Fluid Level/Pressure 3",
      "PGN_Description": "EFL/P3",
      "first_bit": 24,
      "SPN": 4287,
      "SPN_Name": "Engine Exhaust Valve Actuation System Oil Pressure",
      "SPN_Description": "The absolute pressure of the oil in the hydraulic system that powers the engine exhaust valve actuation system",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 51
    },
    "4288": {
      "PGN": 64870,
      "PGN_Name": "Engine Temperature 4",
      "PGN_Description": "ET4",
      "first_bit": 24,
      "SPN": 4288,
      "SPN_Name": "Engine Exhaust Valve Actuation System Oil Temperature",
      "SPN_Description": "The temperature of the oil in the hydraulic system that powers the engine exhaust valve actuation system",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4289": {
      "PGN": 64838,
      "PGN_Name": "Aftertreatment 1 Three Way Catalyst",
      "PGN_Description": "AT1TWC",
      "first_bit": 0,
      "SPN": 4289,
      "SPN_Name": "Aftertreatment 1 Three Way Catalyst Intake Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts entering the Three Way Catalyst in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4290": {
      "PGN": 64838,
      "PGN_Name": "Aftertreatment 1 Three Way Catalyst",
      "PGN_Description": "AT1TWC",
      "first_bit": 16,
      "SPN": 4290,
      "SPN_Name": "Aftertreatment 1 Three Way Catalyst Outlet Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts leaving the Three Way Catalyst in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4291": {
      "PGN": 64838,
      "PGN_Name": "Aftertreatment 1 Three Way Catalyst",
      "PGN_Description": "AT1TWC",
      "first_bit": 32,
      "SPN": 4291,
      "SPN_Name": "Aftertreatment 1 Three Way Catalyst Differential Pressure",
      "SPN_Description": "Exhaust differential pressure measured between the intake and exhaust of a Three Way Catalyst in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "4292": {
      "PGN": 64838,
      "PGN_Name": "Aftertreatment 1 Three Way Catalyst",
      "PGN_Description": "AT1TWC",
      "first_bit": 48,
      "SPN": 4292,
      "SPN_Name": "Aftertreatment 1 Three Way Catalyst Intake Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Three Way Catalyst intake temperature sensor by the manufacturer’s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4293": {
      "PGN": 64838,
      "PGN_Name": "Aftertreatment 1 Three Way Catalyst",
      "PGN_Description": "AT1TWC",
      "first_bit": 53,
      "SPN": 4293,
      "SPN_Name": "Aftertreatment 1 Three Way Catalyst Outlet Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Three Way Catalyst outlet temperature sensor by the manufacturer’s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4294": {
      "PGN": 64838,
      "PGN_Name": "Aftertreatment 1 Three Way Catalyst",
      "PGN_Description": "AT1TWC",
      "first_bit": 58,
      "SPN": 4294,
      "SPN_Name": "Aftertreatment 1 Three Way Catalytic Converter Differential Pressure Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Three Way Catalytic Converter differential pressure sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4295": {
      "PGN": 64837,
      "PGN_Name": "Aftertreatment 2 Three Way Catalyst",
      "PGN_Description": "AT2TWC",
      "first_bit": 0,
      "SPN": 4295,
      "SPN_Name": "Aftertreatment 2 Three Way Catalyst Intake Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts entering the Three Way Catalyst in exhaust bank 2.\r\n\r\n(For a single exhaust bank system, refer to parameters in PGN 64838.)",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4296": {
      "PGN": 64837,
      "PGN_Name": "Aftertreatment 2 Three Way Catalyst",
      "PGN_Description": "AT2TWC",
      "first_bit": 16,
      "SPN": 4296,
      "SPN_Name": "Aftertreatment 2 Three Way Catalyst Outlet Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts leaving the Three Way Catalyst in exhaust bank 2. \r\n \r\n(For a single exhaust bank system, refer to parameters in PGN 64838.)",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4297": {
      "PGN": 64837,
      "PGN_Name": "Aftertreatment 2 Three Way Catalyst",
      "PGN_Description": "AT2TWC",
      "first_bit": 32,
      "SPN": 4297,
      "SPN_Name": "Aftertreatment 2 Three Way Catalyst Differential Pressure",
      "SPN_Description": "Exhaust differential pressure measured between the intake and exhaust of a Three Way Catalyst in exhaust bank 2.\r\n\r\n(For a single exhaust bank system, refer to parameters in PGN 64838.)",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "4298": {
      "PGN": 64837,
      "PGN_Name": "Aftertreatment 2 Three Way Catalyst",
      "PGN_Description": "AT2TWC",
      "first_bit": 48,
      "SPN": 4298,
      "SPN_Name": "Aftertreatment 2 Three Way Catalyst Intake Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Three Way Catalyst intake temperature sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGN 64838.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4299": {
      "PGN": 64837,
      "PGN_Name": "Aftertreatment 2 Three Way Catalyst",
      "PGN_Description": "AT2TWC",
      "first_bit": 53,
      "SPN": 4299,
      "SPN_Name": "Aftertreatment 2 Three Way Catalyst Outlet Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Three Way Catalyst outlet temperature sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGN 64838.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4300": {
      "PGN": 64837,
      "PGN_Name": "Aftertreatment 2 Three Way Catalyst",
      "PGN_Description": "AT2TWC",
      "first_bit": 58,
      "SPN": 4300,
      "SPN_Name": "Aftertreatment 2 Three Way Catalytic Converter Differential Pressure Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Three Way Catalytic Converter differential pressure sensor by the manufacturer’s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGN AT1TWCC.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4301": {
      "PGN": 64929,
      "PGN_Name": "Aftertreatment 1 Fuel Control 1",
      "PGN_Description": "AT1FC1",
      "first_bit": 56,
      "SPN": 4301,
      "SPN_Name": "Aftertreatment 1 Fuel Injector 1 Heater Control",
      "SPN_Description": "Heating level that the controller is commanding the aftertreatment 1 fuel injector 1 heater control to maintain. 0% = off, 100% = maximum.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4302": {
      "PGN": 64928,
      "PGN_Name": "Aftertreatment 2 Fuel Control 1",
      "PGN_Description": "AT2FC1",
      "first_bit": 56,
      "SPN": 4302,
      "SPN_Name": "Aftertreatment 2 Fuel Injector 1 Heater Control",
      "SPN_Description": "Heating level that the controller is commanding the aftertreatment 2 fuel injector 1 heater control to maintain. 0% = off, 100% = maximum.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4303": {
      "PGN": 64836,
      "PGN_Name": "Aftertreatment 2 Fuel Control 2",
      "PGN_Description": "AT2FC2",
      "first_bit": 0,
      "SPN": 4303,
      "SPN_Name": "Aftertreatment 2 Fuel Pressure 2",
      "SPN_Description": "Second fuel pressure measurement for the aftertreatment 2 system.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "4331": {
      "PGN": 61475,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 1",
      "PGN_Description": "A1SCRDSI1",
      "first_bit": 0,
      "SPN": 4331,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Actual Dosing Quantity",
      "SPN_Description": "Actual reducing agent quantity of SCR-system",
      "bit_length": 16,
      "scaling": 0.3,
      "offset": 0,
      "unit": "g/h",
      "SLOT_ID": 272
    },
    "4332": {
      "PGN": 61475,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 1",
      "PGN_Description": "A1SCRDSI1",
      "first_bit": 16,
      "SPN": 4332,
      "SPN_Name": "Aftertreatment 1 SCR System 1 State",
      "SPN_Description": "Actual state of SCR system\r\n\r\n0000    Dormant (sleep mode)\r\n0001    Preparing dosing readiness (wake up; prepare to operate; wait for start)\r\n0010    Normal dosing operation\r\n0011    System error pending\r\n0100    Purging (SCR dosing system is removing residual DEF from system prior to shutdown)\r\n0101    Protect mode against heat  (pressure buildup)\r\n0110    Protect mode against cold  (defreeze)\r\n0111    Shutoff  (wait for after-run)\r\n1000    Diagnosis (after-run)\r\n1001    Service test mode, dosing allowed \r\n1010    Service test mode, dosing not allowed\r\n1011    Ok to Power Down (SCR dosing system has complete housekeeping and power may safely be removed.)\r\n1100    Priming (Pressure Buildup)\r\n1101    Reserved for future assignment by SAE\r\n1110    Error\r\n1111    Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4333": {
      "PGN": 61475,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 1",
      "PGN_Description": "A1SCRDSI1",
      "first_bit": 24,
      "SPN": 4333,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Actual Quantity of Integrator",
      "SPN_Description": "The SCR requested diesel exhaust fluid integrator total quantity for aftertreatment system 1 (exhaust bank 1).",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "g",
      "SLOT_ID": 227
    },
    "4334": {
      "PGN": 61475,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 1",
      "PGN_Description": "A1SCRDSI1",
      "first_bit": 40,
      "SPN": 4334,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Doser 1 Absolute Pressure",
      "SPN_Description": "The absolute pressure (measured closest to dosing valve) of the first or only DEF dosing unit for aftertreatment system 1 (exhaust bank 1).",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "4335": {
      "PGN": 64833,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 2",
      "PGN_Description": "A1SCRDSI2",
      "first_bit": 0,
      "SPN": 4335,
      "SPN_Name": "Aftertreatment 1 SCR Dosing Air Assist Absolute Pressure",
      "SPN_Description": "The SCR dosing system air assist absolute pressure for aftertreatment system 1 (exhaust bank 1).  The air assist system is used to improve the dosed reagent atomization.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "4336": {
      "PGN": 64833,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 2",
      "PGN_Description": "A1SCRDSI2",
      "first_bit": 8,
      "SPN": 4336,
      "SPN_Name": "Aftertreatment 1 SCR Dosing Air Assist Valve",
      "SPN_Description": "The position of the valve used to regulate the air supply of an air assist SCR dosing system for an engine. 0% represents no supply and 100% is full supply.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4337": {
      "PGN": 64833,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 2",
      "PGN_Description": "A1SCRDSI2",
      "first_bit": 16,
      "SPN": 4337,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Doser 1 Temperature",
      "SPN_Description": "The temperature (measured closest to dosing valve) of the first or only DEF dosing unit for aftertreatment system 1 (exhaust bank 1).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "4338": {
      "PGN": 64833,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 2",
      "PGN_Description": "A1SCRDSI2",
      "first_bit": 24,
      "SPN": 4338,
      "SPN_Name": "Aftertreatment 1 SCR Doser Valve Exhaust Temperature Reduction Request",
      "SPN_Description": "Protection request for the doser valve of the SCR system to prevent overheating\r\n\r\n  000:    no request \r\n  001:    reduction request stage 1\r\n  010:    reduction request stage 2\r\n  011:    reserved for future assignment by SAE\r\n  100:    reserved for future assignment by SAE\r\n  101:    reserved for future assignment by SAE\r\n  110:    error\r\n  111:    not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "4339": {
      "PGN": 64833,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 2",
      "PGN_Description": "A1SCRDSI2",
      "first_bit": 27,
      "SPN": 4339,
      "SPN_Name": "Aftertreatment 1 SCR Feedback Control Status",
      "SPN_Description": "The SCR feedback control status (open/closed loop) for aftertreatment system 1 (exhaust bank 1).\r\n \r\n000 open loop control active \r\n001 closed loop control active \r\n010 reserved for future assignment by SAE \r\n011 reserved for future assignment by SAE \r\n100 reserved for future assignment by SAE \r\n101 reserved for future assignment by SAE \r\n110 error \r\n111 not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "4340": {
      "PGN": 64833,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 2",
      "PGN_Description": "A1SCRDSI2",
      "first_bit": 32,
      "SPN": 4340,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 1 State",
      "SPN_Description": "The diesel exhaust fluid line heater 1 state for aftertreatment system 1 (exhaust bank 1). \r\n\r\n00 heater inactive \r\n01 heater active \r\n10 error \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4341": {
      "PGN": 64833,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 2",
      "PGN_Description": "A1SCRDSI2",
      "first_bit": 34,
      "SPN": 4341,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 1, by the manufacturer’s control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4342": {
      "PGN": 64833,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 2",
      "PGN_Description": "A1SCRDSI2",
      "first_bit": 40,
      "SPN": 4342,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 2 State",
      "SPN_Description": "The diesel exhaust fluid line heater 2 state for aftertreatment system 1 (exhaust bank 1). \r\n \r\n00 heater inactive \r\n01 heater active \r\n10 error \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4343": {
      "PGN": 64833,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 2",
      "PGN_Description": "A1SCRDSI2",
      "first_bit": 42,
      "SPN": 4343,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 2, by the manufacturer’s control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4344": {
      "PGN": 64833,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 2",
      "PGN_Description": "A1SCRDSI2",
      "first_bit": 48,
      "SPN": 4344,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 3 State",
      "SPN_Description": "The diesel exhaust fluid line heater 3 state for aftertreatment system 1 (exhaust bank 1). \r\n\r\n00 heater inactive \r\n01 heater active \r\n10 error \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4345": {
      "PGN": 64833,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 2",
      "PGN_Description": "A1SCRDSI2",
      "first_bit": 50,
      "SPN": 4345,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 3 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 3, by the manufacturer’s control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4346": {
      "PGN": 64833,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 2",
      "PGN_Description": "A1SCRDSI2",
      "first_bit": 56,
      "SPN": 4346,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 4 State",
      "SPN_Description": "The diesel exhaust fluid line heater 4 state for aftertreatment system 1 (exhaust bank 1). \r\n\r\n00 heater inactive \r\n01 heater active \r\n10 error \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4347": {
      "PGN": 64833,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 2",
      "PGN_Description": "A1SCRDSI2",
      "first_bit": 58,
      "SPN": 4347,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 4 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 4, by the manufacturer’s control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4348": {
      "PGN": 61476,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 1",
      "PGN_Description": "A1SCRDSR1",
      "first_bit": 0,
      "SPN": 4348,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Dosing Requested Quantity",
      "SPN_Description": "Actual requested dosing quantity of diesel exhaust fluid.",
      "bit_length": 16,
      "scaling": 0.3,
      "offset": 0,
      "unit": "g/h",
      "SLOT_ID": 272
    },
    "4349": {
      "PGN": 61476,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 1",
      "PGN_Description": "A1SCRDSR1",
      "first_bit": 16,
      "SPN": 4349,
      "SPN_Name": "Aftertreatment 1 SCR System Requested State",
      "SPN_Description": "Requested state of SCR system for aftertreatment system 1 (exhaust bank 1).\r\n \r\n0000 Dormant (sleep mode) \r\n0001 Preparing dosing readiness (wake up; prepare to operate; wait for start) \r\n0010 Normal dosing operation \r\n0011 System error pending \r\n0100 Reserved for future assignment by SAE \r\n0101 Protect mode against heat (pressure buildup) \r\n0110 Protect mode against cold (defreeze) \r\n0111 Shutoff (wait for after-run) \r\n1000 Diagnosis (after-run) \r\n1001 Service test mode, dosing allowed \r\n1010 Service test mode, dosing not allowed\r\n1011-1101 Reserved for future assignment by SAE\r\n1110 Error\r\n1111 Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4350": {
      "PGN": 61476,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 1",
      "PGN_Description": "A1SCRDSR1",
      "first_bit": 24,
      "SPN": 4350,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Requested Quantity of Integrator",
      "SPN_Description": "Represents the command for the diesel exhaust fluid quantity integrator in the dosing control unit.  See SPN 7783 for alternate resolution.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "g",
      "SLOT_ID": 227
    },
    "4352": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 2,
      "SPN": 4352,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Doser Fault Suppression Request",
      "SPN_Description": "Used if external devices can warn of conditions that require suppression of potential faults in the doser due to environmental conditions.\r\n\r\n00    Error suppression off\r\n01    Error suppression on\r\n10    Reserved\r\n11    Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4353": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 4,
      "SPN": 4353,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Doser Heating Mode Request",
      "SPN_Description": "Used if multiple heater modes are available in the Doser.\r\n\r\n000   Heater off\r\n001   Heater economy mode\r\n010   Heater automatic mode\r\n011   Heater on\r\n100 - 110    Reserved\r\n111   Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "4354": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 8,
      "SPN": 4354,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 1",
      "SPN_Description": "The diesel exhaust fluid line heater 1 request for aftertreatment system 1 (exhaust bank 1).\r\n \r\n00 request for heater to be inactive \r\n01 request for heater to be active \r\n10 reserved for future assignment by SAE \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4355": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 10,
      "SPN": 4355,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 2",
      "SPN_Description": "The diesel exhaust fluid line heater 2 request for aftertreatment system 1 (exhaust bank 1).\r\n \r\n00 request for heater to be inactive \r\n01 request for heater to be active \r\n10 reserved for future assignment by SAE \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4356": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 12,
      "SPN": 4356,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 3",
      "SPN_Description": "The diesel exhaust fluid line heater 3 request for aftertreatment system 1 (exhaust bank 1).\r\n \r\n00 request for heater to be inactive \r\n01 request for heater to be active \r\n10 reserved for future assignment by SAE \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4357": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 14,
      "SPN": 4357,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 4",
      "SPN_Description": "The diesel exhaust fluid line heater 4 request for aftertreatment system 1 (exhaust bank 1).\r\n \r\n00 request for heater to be inactive \r\n01 request for heater to be active \r\n10 reserved for future assignment by SAE \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4358": {
      "PGN": 64831,
      "PGN_Name": "Aftertreatment 1 SCR Exhaust Gas Pressures",
      "PGN_Description": "A1SCREGP",
      "first_bit": 0,
      "SPN": 4358,
      "SPN_Name": "Aftertreatment 1 SCR Differential Pressure",
      "SPN_Description": "Differential pressure measured between the intake and outlet of an SCR component in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "4359": {
      "PGN": 64831,
      "PGN_Name": "Aftertreatment 1 SCR Exhaust Gas Pressures",
      "PGN_Description": "A1SCREGP",
      "first_bit": 16,
      "SPN": 4359,
      "SPN_Name": "Aftertreatment 1 SCR Differential Pressure Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the SCR differential pressure sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 90
    },
    "4360": {
      "PGN": 64830,
      "PGN_Name": "Aftertreatment 1 SCR Exhaust Gas Temperature 1",
      "PGN_Description": "A1SCREGT1",
      "first_bit": 0,
      "SPN": 4360,
      "SPN_Name": "Aftertreatment 1 SCR Intake Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts entering the SCR in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4361": {
      "PGN": 64830,
      "PGN_Name": "Aftertreatment 1 SCR Exhaust Gas Temperature 1",
      "PGN_Description": "A1SCREGT1",
      "first_bit": 16,
      "SPN": 4361,
      "SPN_Name": "Aftertreatment 1 SCR Intake Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the SCR intake temperature sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 90
    },
    "4362": {
      "PGN": 64830,
      "PGN_Name": "Aftertreatment 1 SCR Exhaust Gas Temperature 1",
      "PGN_Description": "A1SCREGT1",
      "first_bit": 40,
      "SPN": 4362,
      "SPN_Name": "Aftertreatment 1 SCR Outlet Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the SCR outlet temperature sensor by the manufacturer’s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 90
    },
    "4363": {
      "PGN": 64830,
      "PGN_Name": "Aftertreatment 1 SCR Exhaust Gas Temperature 1",
      "PGN_Description": "A1SCREGT1",
      "first_bit": 24,
      "SPN": 4363,
      "SPN_Name": "Aftertreatment 1 SCR Outlet Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts leaving the SCR outlet in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4364": {
      "PGN": 64878,
      "PGN_Name": "Aftertreatment 1 SCR Service Information 1",
      "PGN_Description": "A1SCRSI1",
      "first_bit": 32,
      "SPN": 4364,
      "SPN_Name": "Aftertreatment 1 SCR Conversion Efficiency",
      "SPN_Description": "The SCR conversion efficiency percentage.  Calculated as 100 times the catalyst intake NOx minus the catalyst outlet NOx divided by the catalyst intake NOx.  The catalyst conversion efficiency number in itself does not imply emissions compliance or system function or system malfunction.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4365": {
      "PGN": 65110,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "AT1T1I1",
      "first_bit": 40,
      "SPN": 4365,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected for the diesel exhaust fluid tank temperature for aftertreatment system 1 (exhaust bank 1), as detected by the manufacturer’s control software. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4366": {
      "PGN": 65110,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "AT1T1I1",
      "first_bit": 56,
      "SPN": 4366,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Heater Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected for the heater of the diesel exhaust fluid tank for aftertreatment system 1 (exhaust bank 1), as detected by the manufacturer's control software.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4367": {
      "PGN": 64829,
      "PGN_Name": "Aftertreatment 1 SCR Reagant Tank 2 Information",
      "PGN_Description": "A1SCRRT2I",
      "first_bit": 0,
      "SPN": 4367,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Tank Volume",
      "SPN_Description": "Ratio of volume of diesel exhaust fluid to the total volume of the diesel exhaust fluid quick thaw tank for aftertreatment system 1 (exhaust bank 1).  0% is empty and 100% is full.  See SPN 4369 for an alternate measurement.\r\n\r\nParameter Specific Indicator:\r\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4368": {
      "PGN": 64829,
      "PGN_Name": "Aftertreatment 1 SCR Reagant Tank 2 Information",
      "PGN_Description": "A1SCRRT2I",
      "first_bit": 8,
      "SPN": 4368,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Temperature",
      "SPN_Description": "The diesel exhaust fluid quick thaw tank temperature for aftertreatment system 1 (exhaust bank 1).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "4369": {
      "PGN": 64829,
      "PGN_Name": "Aftertreatment 1 SCR Reagant Tank 2 Information",
      "PGN_Description": "A1SCRRT2I",
      "first_bit": 16,
      "SPN": 4369,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Tank Level",
      "SPN_Description": "The diesel exhaust fluid level height in mm in the diesel exhaust fluid quick thaw tank for aftertreatment system 1 (exhaust bank 1). See SPN 4367 for alternate measurement. \r\n\r\nParameter Specific Indicator:\r\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "mm",
      "SLOT_ID": 14
    },
    "4370": {
      "PGN": 64829,
      "PGN_Name": "Aftertreatment 1 SCR Reagant Tank 2 Information",
      "PGN_Description": "A1SCRRT2I",
      "first_bit": 32,
      "SPN": 4370,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Level/Volume Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected for the fluid level height of the diesel exhaust fluid quick thaw tank for aftertreatment system 1 (exhaust bank 1), as detected by the manufacturer's control software.  This FMI is applicable to either the diesel exhaust fluid quick thaw tank level or diesel exhaust fluid quick thaw tank volume parameters.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4371": {
      "PGN": 64829,
      "PGN_Name": "Aftertreatment 1 SCR Reagant Tank 2 Information",
      "PGN_Description": "A1SCRRT2I",
      "first_bit": 40,
      "SPN": 4371,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected for the diesel exhaust fluid quick thaw tank temperature for aftertreatment system 1 (exhaust bank 1), as detected by the manufacturer’s control software.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4372": {
      "PGN": 64829,
      "PGN_Name": "Aftertreatment 1 SCR Reagant Tank 2 Information",
      "PGN_Description": "A1SCRRT2I",
      "first_bit": 48,
      "SPN": 4372,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Heater",
      "SPN_Description": "The diesel exhaust fluid quick thaw tank heater percentage for aftertreatment system 1 (exhaust bank 1). 0% is off. See SPN 5414 for the command for this tank heater.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4373": {
      "PGN": 64829,
      "PGN_Name": "Aftertreatment 1 SCR Reagant Tank 2 Information",
      "PGN_Description": "A1SCRRT2I",
      "first_bit": 56,
      "SPN": 4373,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Heater Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected for the heater of the diesel exhaust fluid quick thaw tank for aftertreatment system 1 (exhaust bank 1), as detected by the manufacturer's control software.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4374": {
      "PGN": 64828,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A1DEFSI",
      "first_bit": 0,
      "SPN": 4374,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Pump 1 Motor Speed",
      "SPN_Description": "Rotational speed of the motor driving the first or only pump for the diesel exhaust fluid used in aftertreatment system 1 (exhaust bank 1).",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "4375": {
      "PGN": 64828,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A1DEFSI",
      "first_bit": 16,
      "SPN": 4375,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Pump Drive Percentage",
      "SPN_Description": "The percent (command) sent to the motor to control the speed of the diesel exhaust fluid pump.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4376": {
      "PGN": 64828,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A1DEFSI",
      "first_bit": 24,
      "SPN": 4376,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Dosing Unit 1 Diverter Valve",
      "SPN_Description": "Command to the valve which determines whether the diesel exhaust fluid on dosing unit 1 is delivered to the injector or is routed back to the diesel exhaust fluid tank. Zero directs all diesel exhaust fluid flow to the injector, 100% sends all diesel exhaust fluid back to the tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4377": {
      "PGN": 61477,
      "PGN_Name": "Aftertreatment 1 SCR Ammonia Information",
      "PGN_Description": "A1SCRAI",
      "first_bit": 0,
      "SPN": 4377,
      "SPN_Name": "Aftertreatment 1 Outlet NH3",
      "SPN_Description": "The amount of NH3 in the exhaust exiting the aftertreatment system measured by a NH3 sensor at the aftertreatment outlet, represented in NH3 molecule parts per million non-NH3 molecules in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "4378": {
      "PGN": 61477,
      "PGN_Name": "Aftertreatment 1 SCR Ammonia Information",
      "PGN_Description": "A1SCRAI",
      "first_bit": 16,
      "SPN": 4378,
      "SPN_Name": "Aftertreatment 1 Outlet NH3 Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet NH3 sensor by the manufacturer’s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4379": {
      "PGN": 61477,
      "PGN_Name": "Aftertreatment 1 SCR Ammonia Information",
      "PGN_Description": "A1SCRAI",
      "first_bit": 24,
      "SPN": 4379,
      "SPN_Name": "Aftertreatment 1 Outlet NH3 Reading Stable",
      "SPN_Description": "Indicates that the NH3 reading of the aftertreatment outlet NH3 sensor is stable as determined by the manufacturer’s control software in exhaust bank 1.\r\n\r\n00 - Reading is not stable\r\n01 - Reading is stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4380": {
      "PGN": 61477,
      "PGN_Name": "Aftertreatment 1 SCR Ammonia Information",
      "PGN_Description": "A1SCRAI",
      "first_bit": 26,
      "SPN": 4380,
      "SPN_Name": "Aftertreatment 1 Outlet NH3 Gas Sensor Power In Range",
      "SPN_Description": "Indicates that the power supplied to the aftertreatment outlet NH3 gas sensor is within the manufacturer’s specification in exhaust bank 1.\r\n\r\n00 - Power is not in range\r\n01 - Power is in range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4381": {
      "PGN": 61477,
      "PGN_Name": "Aftertreatment 1 SCR Ammonia Information",
      "PGN_Description": "A1SCRAI",
      "first_bit": 28,
      "SPN": 4381,
      "SPN_Name": "Aftertreatment 1 Outlet NH3 Gas Sensor at Temperature",
      "SPN_Description": "Indicates that the heater element of the aftertreatment outlet NH3 gas sensor is within the manufacturer’s specified range for accurate measurements in exhaust bank 1.\r\n\r\n00 - Heater element is not in range\r\n01 - Heater element is in range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4382": {
      "PGN": 61477,
      "PGN_Name": "Aftertreatment 1 SCR Ammonia Information",
      "PGN_Description": "A1SCRAI",
      "first_bit": 32,
      "SPN": 4382,
      "SPN_Name": "Aftertreatment 1 Outlet NH3 Gas Sensor Heater Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the heater of the outlet NH3 exhaust gas sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4383": {
      "PGN": 61477,
      "PGN_Name": "Aftertreatment 1 SCR Ammonia Information",
      "PGN_Description": "A1SCRAI",
      "first_bit": 40,
      "SPN": 4383,
      "SPN_Name": "Aftertreatment 1 Outlet NH3 Gas Sensor Heater Control",
      "SPN_Description": "Indicates the heater status in the warm-up process. Upon receiving a power-up command, the NH3 gas sensor ramps up according to a manufacturer defined profile. The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1. \r\n00 - Automatic \r\n01 - Preheat 2 \r\n10 - Preheat 1 \r\n11 - Heater off or not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4384": {
      "PGN": 61478,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 1",
      "PGN_Description": "A2SCRDSI1",
      "first_bit": 0,
      "SPN": 4384,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Actual Dosing Quantity",
      "SPN_Description": "Actual reducing agent quantity of SCR system.",
      "bit_length": 16,
      "scaling": 0.3,
      "offset": 0,
      "unit": "g/h",
      "SLOT_ID": 272
    },
    "4385": {
      "PGN": 61478,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 1",
      "PGN_Description": "A2SCRDSI1",
      "first_bit": 16,
      "SPN": 4385,
      "SPN_Name": "Aftertreatment 2 SCR System 1 State",
      "SPN_Description": "Actual state of SCR system 1.\r\n\r\n0000    Dormant (sleep mode)\r\n0001    Preparing dosing readiness (wake up; prepare to operate; wait for start)\r\n0010    Normal dosing operation\r\n0011    System error pending\r\n0100    Purging (SCR dosing system is removing residual DEF from system prior to shutdown)\r\n0101    Protect mode against heat (pressure buildup) \r\n0110    Protect mode against cold (defreeze) \r\n0111    Shutoff (wait for after-run) \r\n1000    Diagnosis (after-run)\r\n1001    Service test mode, dosing allowed \r\n1010    Service test mode, dosing not allowed\r\n1011    Ok to Power Down (SCR dosing system has complete housekeeping and power may safely be removed)\r\n1100    Priming (Pressure Buildup)\r\n1101    Reserved for future assignment by SAE\r\n1110    Error\r\n1111    Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4386": {
      "PGN": 61478,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 1",
      "PGN_Description": "A2SCRDSI1",
      "first_bit": 24,
      "SPN": 4386,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Actual Quantity of Integrator",
      "SPN_Description": "The SCR requested diesel exhaust fluid integrator total quantity for aftertreatment system 2 (exhaust bank 2).",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "g",
      "SLOT_ID": 227
    },
    "4387": {
      "PGN": 61478,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 1",
      "PGN_Description": "A2SCRDSI1",
      "first_bit": 40,
      "SPN": 4387,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Doser 1 Absolute Pressure",
      "SPN_Description": "The absolute pressure (measured closest to dosing valve) of the first or only DEF doser for aftertreatment system 2 (exhaust bank 2).",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "4388": {
      "PGN": 64827,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 2",
      "PGN_Description": "A2SCRDSI2",
      "first_bit": 0,
      "SPN": 4388,
      "SPN_Name": "Aftertreatment 2 SCR Dosing Air Assist Absolute Pressure",
      "SPN_Description": "The SCR dosing system air assist absolute pressure for aftertreatment system 2 (exhaust bank 2).  The air assist system is used to improve the dosed reagent atomization.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "4389": {
      "PGN": 64827,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 2",
      "PGN_Description": "A2SCRDSI2",
      "first_bit": 8,
      "SPN": 4389,
      "SPN_Name": "Aftertreatment 2 SCR Dosing Air Assist Valve",
      "SPN_Description": "The position of the valve used to regulate the air supply of an air assist SCR dosing system for an engine. 0% represents no supply and 100% is full supply.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4390": {
      "PGN": 64827,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 2",
      "PGN_Description": "A2SCRDSI2",
      "first_bit": 16,
      "SPN": 4390,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Doser 1 Temperature",
      "SPN_Description": "The temperature (measured closest to dosing valve) of the first or only DEF doser for aftertreatment system 2 (exhaust bank 2).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "4391": {
      "PGN": 64827,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 2",
      "PGN_Description": "A2SCRDSI2",
      "first_bit": 24,
      "SPN": 4391,
      "SPN_Name": "Aftertreatment 2 SCR Doser Valve Exhaust Temperature Reduction Request",
      "SPN_Description": "Protection request for the doser valve of the SCR system to prevent overheating\r\n\r\n  000:    no request \r\n  001:    reduction request stage 1\r\n  010:    reduction request stage 2\r\n  011:    reserved for future assignment by SAE\r\n  100:    reserved for future assignment by SAE\r\n  101:    reserved for future assignment by SAE\r\n  110:    error\r\n  111:    not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "4392": {
      "PGN": 64827,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 2",
      "PGN_Description": "A2SCRDSI2",
      "first_bit": 27,
      "SPN": 4392,
      "SPN_Name": "Aftertreatment 2 SCR Feedback Control Status",
      "SPN_Description": "The SCR feedback control status (open/closed loop) for aftertreatment system 2 (exhaust bank 2).\r\n \r\n000 open loop control active \r\n001 closed loop control active \r\n010 reserved for future assignment by SAE \r\n011 reserved for future assignment by SAE \r\n100 reserved for future assignment by SAE \r\n101 reserved for future assignment by SAE \r\n110 error \r\n111 not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "4393": {
      "PGN": 64827,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 2",
      "PGN_Description": "A2SCRDSI2",
      "first_bit": 32,
      "SPN": 4393,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 1 State",
      "SPN_Description": "The diesel exhaust fluid line heater 1 state for aftertreatment system 2 (exhaust bank 2).\r\n\r\n00 heater inactive \r\n01 heater active \r\n10 error \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4394": {
      "PGN": 64827,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 2",
      "PGN_Description": "A2SCRDSI2",
      "first_bit": 34,
      "SPN": 4394,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 1, by the manufacturer’s control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4395": {
      "PGN": 64827,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 2",
      "PGN_Description": "A2SCRDSI2",
      "first_bit": 40,
      "SPN": 4395,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 2 State",
      "SPN_Description": "The diesel exhaust fluid line heater 2 state for aftertreatment system 2 (exhaust bank 2).\r\n\r\n00 heater inactive \r\n01 heater active \r\n10 error \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4396": {
      "PGN": 64827,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 2",
      "PGN_Description": "A2SCRDSI2",
      "first_bit": 42,
      "SPN": 4396,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 2, by the manufacturer’s control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4397": {
      "PGN": 64827,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 2",
      "PGN_Description": "A2SCRDSI2",
      "first_bit": 48,
      "SPN": 4397,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 3 State",
      "SPN_Description": "The diesel exhaust fluid line heater 3 state for aftertreatment system 2 (exhaust bank 2).\r\n\r\n00 heater inactive \r\n01 heater active \r\n10 error \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4398": {
      "PGN": 64827,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 2",
      "PGN_Description": "A2SCRDSI2",
      "first_bit": 50,
      "SPN": 4398,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 3 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 3, by the manufacturer’s control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4399": {
      "PGN": 64827,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 2",
      "PGN_Description": "A2SCRDSI2",
      "first_bit": 56,
      "SPN": 4399,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 4 State",
      "SPN_Description": "The diesel exhaust fluid line heater 4 state for aftertreatment system 2 (exhaust bank 2).\r\n\r\n00 heater inactive \r\n01 heater active \r\n10 error \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4400": {
      "PGN": 64827,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 2",
      "PGN_Description": "A2SCRDSI2",
      "first_bit": 58,
      "SPN": 4400,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 4 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 4, by the manufacturer’s control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4401": {
      "PGN": 61479,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 1",
      "PGN_Description": "A2SCRDSR1",
      "first_bit": 0,
      "SPN": 4401,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Dosing Requested Quantity",
      "SPN_Description": "Actual requested dosing quantity of diesel exhaust fluid.",
      "bit_length": 16,
      "scaling": 0.3,
      "offset": 0,
      "unit": "g/h",
      "SLOT_ID": 272
    },
    "4402": {
      "PGN": 61479,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 1",
      "PGN_Description": "A2SCRDSR1",
      "first_bit": 16,
      "SPN": 4402,
      "SPN_Name": "Aftertreatment 2 SCR System Requested State",
      "SPN_Description": "Requested state of SCR system for aftertreatment system 2 (exhaust bank 2).\r\n\r\n0000 Dormant (sleep mode) \r\n0001 Preparing dosing readiness (wake up; prepare to operate; wait for start) \r\n0010 Normal dosing operation \r\n0011 System error pending \r\n0100 Reserved for future assignment by SAE \r\n0101 Protect mode against heat (pressure buildup) \r\n0110 Protect mode against cold (defreeze) \r\n0111 Shutoff (wait for after-run) \r\n1000 Diagnosis (after-run)\r\n1001 Service test mode, dosing allowed \r\n1010 Service test mode, dosing not allowed\r\n1011-1101 Reserved for future assignment by SAE\r\n1110 Error\r\n1111 Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4403": {
      "PGN": 61479,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 1",
      "PGN_Description": "A2SCRDSR1",
      "first_bit": 24,
      "SPN": 4403,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Requested Quantity of Integrator",
      "SPN_Description": "Represents the command for the diesel exhaust fluid quantity integrator in the dosing control unit. See SPN 7784 for alternate resolution.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "g",
      "SLOT_ID": 227
    },
    "4405": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 2,
      "SPN": 4405,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid  Doser Fault Suppression Request",
      "SPN_Description": "Used if external devices can warn of conditions that require suppression of potential faults in the doser due to environmental conditions.\r\n\n00    Error suppression off\r\n01    Error suppression on\r\n10    Reserved\r\n11    Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4406": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 4,
      "SPN": 4406,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Doser Heating Mode Request",
      "SPN_Description": "Used if multiple heater modes are available in the Doser.\r\n\r\n000   Heater off\r\n001   Heater economy mode\r\n010   Heater automatic mode\r\n011   Heater on\r\n100 - 110    Reserved\r\n111   Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "4407": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 8,
      "SPN": 4407,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 1",
      "SPN_Description": "The diesel exhaust fluid line heater 1 request for aftertreatment system 2 (exhaust bank 2). \r\n\r\n00 request for heater to be inactive \r\n01 request for heater to be active \r\n10 reserved for future assignment by SAE \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4408": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 10,
      "SPN": 4408,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 2",
      "SPN_Description": "The diesel exhaust fluid line heater 2 request for aftertreatment system 2 (exhaust bank 2). \r\n\r\n00 request for heater to be inactive \r\n01 request for heater to be active \r\n10 reserved for future assignment by SAE \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4409": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 12,
      "SPN": 4409,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 3",
      "SPN_Description": "The diesel exhaust fluid line heater 3 request for aftertreatment system 2 (exhaust bank 2). \r\n\r\n00 request for heater to be inactive \r\n01 request for heater to be active \r\n10 reserved for future assignment by SAE \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4410": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 14,
      "SPN": 4410,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 4",
      "SPN_Description": "The diesel exhaust fluid line heater 4 request for aftertreatment system 2 (exhaust bank 2). \r\n \r\n00 request for heater to be inactive \r\n01 request for heater to be active \r\n10 reserved for future assignment by SAE \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4411": {
      "PGN": 64825,
      "PGN_Name": "Aftertreatment 2 SCR Exhaust Gas Pressures",
      "PGN_Description": "A2SCREGP",
      "first_bit": 0,
      "SPN": 4411,
      "SPN_Name": "Aftertreatment 2 SCR Differential Pressure",
      "SPN_Description": "Differential pressure measured between the intake and exhaust of an SCR component in exhaust bank 2.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "4412": {
      "PGN": 64825,
      "PGN_Name": "Aftertreatment 2 SCR Exhaust Gas Pressures",
      "PGN_Description": "A2SCREGP",
      "first_bit": 16,
      "SPN": 4412,
      "SPN_Name": "Aftertreatment 2 SCR Differential Pressure Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the SCR differential pressure sensor by the manufacturer’s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 90
    },
    "4413": {
      "PGN": 64824,
      "PGN_Name": "Aftertreatment 2 SCR Exhaust Gas Temperature 1",
      "PGN_Description": "A2SCREGT1",
      "first_bit": 0,
      "SPN": 4413,
      "SPN_Name": "Aftertreatment 2 SCR Intake Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts entering the SCR in exhaust bank 2.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4414": {
      "PGN": 64824,
      "PGN_Name": "Aftertreatment 2 SCR Exhaust Gas Temperature 1",
      "PGN_Description": "A2SCREGT1",
      "first_bit": 16,
      "SPN": 4414,
      "SPN_Name": "Aftertreatment 2 SCR Intake Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the SCR intake temperature sensor by the manufacturer’s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 90
    },
    "4415": {
      "PGN": 64824,
      "PGN_Name": "Aftertreatment 2 SCR Exhaust Gas Temperature 1",
      "PGN_Description": "A2SCREGT1",
      "first_bit": 24,
      "SPN": 4415,
      "SPN_Name": "Aftertreatment 2 SCR Outlet Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts leaving the SCR exhaust in exhaust bank 2.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4416": {
      "PGN": 64824,
      "PGN_Name": "Aftertreatment 2 SCR Exhaust Gas Temperature 1",
      "PGN_Description": "A2SCREGT1",
      "first_bit": 40,
      "SPN": 4416,
      "SPN_Name": "Aftertreatment 2 SCR Outlet Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the SCR outlet temperature sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 90
    },
    "4417": {
      "PGN": 64823,
      "PGN_Name": "Aftertreatment 2 SCR Service Information 1",
      "PGN_Description": "A2SCRSI1",
      "first_bit": 0,
      "SPN": 4417,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Average Consumption",
      "SPN_Description": "Measured use of diesel exhaust fluid by a Selective Catalytic Reduction system for exhaust emission control, averaged over the previous 15 hours of engine operation.\r\n\r\nUsed to determine whether the SCR system is using an appropriate amount of diesel exhaust fluid, by comparing with the Aftertreatment 2 Commanded Diesel Exhaust Fluid Consumption parameter (SPN 4418).",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "l/h",
      "SLOT_ID": 42
    },
    "4418": {
      "PGN": 64823,
      "PGN_Name": "Aftertreatment 2 SCR Service Information 1",
      "PGN_Description": "A2SCRSI1",
      "first_bit": 16,
      "SPN": 4418,
      "SPN_Name": "Aftertreatment 2 SCR Commanded Diesel Exhaust Fluid Consumption",
      "SPN_Description": "This parameter transmits the amount of diesel exhaust fluid that the emissions control system has requested to be used, averaged over the past 15 hours of engine operation.\r\n\r\nUsed to determine whether the SCR system is using an appropriate amount of diesel exhaust fluid, by comparing with the Aftertreatment 2 Average Diesel Exhaust Fluid Consumption parameter (SPN 4417).",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "l/h",
      "SLOT_ID": 42
    },
    "4419": {
      "PGN": 64823,
      "PGN_Name": "Aftertreatment 2 SCR Service Information 1",
      "PGN_Description": "A2SCRSI1",
      "first_bit": 32,
      "SPN": 4419,
      "SPN_Name": "Aftertreatment 2 SCR Conversion Efficiency",
      "SPN_Description": "The SCR conversion efficiency percentage.  Calculated as 100 times the catalyst intake NOx minus the catalyst outlet NOx divided by the catalyst intake NOx.  The catalyst conversion efficiency number in itself does not imply emissions compliance or system function or system malfunction.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4420": {
      "PGN": 64822,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Information 1",
      "PGN_Description": "A2DEFI1",
      "first_bit": 0,
      "SPN": 4420,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Temperature 2",
      "SPN_Description": "Temperature of the diesel exhaust fluid at the device measuring diesel exhaust fluid quality",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "4421": {
      "PGN": 64822,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Information 1",
      "PGN_Description": "A2DEFI1",
      "first_bit": 8,
      "SPN": 4421,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Concentration",
      "SPN_Description": "A measure of the concentration of urea in water.  Zero percent means that the tank contains no urea.  A 32.5% value indicates that the reagent is of the proper concentration.  The 32.5% value indicates that the concentration is highest quality.\r\n\r\nParameter Specific Indicator:\r\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.25,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 254
    },
    "4422": {
      "PGN": 64822,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Information 1",
      "PGN_Description": "A2DEFI1",
      "first_bit": 16,
      "SPN": 4422,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Conductivity",
      "SPN_Description": "A measure of the conductivity of the diesel exhaust fluid at the sensor.  The conductivity is an indication of the diesel exhaust fluid's chemical make up.",
      "bit_length": 8,
      "scaling": 5,
      "offset": 0,
      "unit": "µSiemens/mm",
      "SLOT_ID": 255
    },
    "4423": {
      "PGN": 64822,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Information 1",
      "PGN_Description": "A2DEFI1",
      "first_bit": 24,
      "SPN": 4423,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Temperature 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI that applies to the most significant failure of the diesel exhaust fluid temperature sensor. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4424": {
      "PGN": 64822,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Information 1",
      "PGN_Description": "A2DEFI1",
      "first_bit": 32,
      "SPN": 4424,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Properties Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI that applies to the most significant failure of the diesel exhaust fluid properties sensor.  This may be used for indicating failures of the diesel exhaust fluid concentration, diesel exhaust fluid conductivity or diesel exhaust fluid type.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4425": {
      "PGN": 64822,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Information 1",
      "PGN_Description": "A2DEFI1",
      "first_bit": 40,
      "SPN": 4425,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Type Property",
      "SPN_Description": "This parameter indicates the property of the fluid compound in the tank.  A value of 0011 indicates uncontaminated Diesel Exhaust Fluid.\r\n\r\n0000 - Urea concentration too high\r\n0001 - Urea concentration too low\r\n0010 - Fluid is diesel\r\n0011 - Diesel exhaust fluid is proper mixture\r\n0100 to 1011 - Reserved for SAE assignment\r\n1100 - Diesel exhaust fluid, but concentration cannot be determined\r\n1101 - Not able to determine fluid property (fluid type unknown)\r\n1110 - Error with diesel exhaust fluid property detection\r\n1111 - Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4426": {
      "PGN": 64821,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "A2DEFT1I1",
      "first_bit": 0,
      "SPN": 4426,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank Volume",
      "SPN_Description": "Ratio of volume of diesel exhaust fluid to the total volume of the diesel exhaust fluid storage container for aftertreatment system 2 (exhaust bank 2).  0% is empty and 100% is full.  See SPN 4428 and SPN 7531 for alternate measurements.\r\n\r\nParameter Specific Indicator:\r\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4427": {
      "PGN": 64821,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "A2DEFT1I1",
      "first_bit": 8,
      "SPN": 4427,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank Temperature 1",
      "SPN_Description": "Temperature of the diesel exhaust fluid in the storage tank.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "4428": {
      "PGN": 64821,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "A2DEFT1I1",
      "first_bit": 16,
      "SPN": 4428,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank Level",
      "SPN_Description": "The diesel exhaust fluid level height in mm in the diesel exhaust fluid storage container for aftertreatment system 2 (exhaust bank 2).  See SPN 4426 and SPN 7531 for alternate measurements. \r\n\r\nParameter Specific Indicator:\r\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "mm",
      "SLOT_ID": 14
    },
    "4429": {
      "PGN": 64821,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "A2DEFT1I1",
      "first_bit": 32,
      "SPN": 4429,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank Level/Volume Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid tank level sensor by the manufacturer's sensor control software.  This FMI is applicable to either the diesel exhaust fluid tank level or diesel exhaust fluid tank volume parameters.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4430": {
      "PGN": 64821,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "A2DEFT1I1",
      "first_bit": 40,
      "SPN": 4430,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected for the diesel exhaust fluid tank temperature for aftertreatment system 2 (exhaust bank 2), as detected by the manufacturer’s control software. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4431": {
      "PGN": 64821,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "A2DEFT1I1",
      "first_bit": 48,
      "SPN": 4431,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank Heater",
      "SPN_Description": "Percentage of heating applied to the aftertreatment 2 diesel exhaust fluid tank heater.  A value of 0% means no heating applied, a value of 100% means full heating applied.  The diesel exhaust fluid tank heater warms the diesel exhaust fluid in the diesel exhaust fluid tank.  See SPN 5138 for the command for this tank heater.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4432": {
      "PGN": 64821,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "A2DEFT1I1",
      "first_bit": 56,
      "SPN": 4432,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Heater Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected for the heater of the diesel exhaust fluid tank for aftertreatment system 2 (exhaust bank 2), as detected by the manufacturer's control software.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4433": {
      "PGN": 64820,
      "PGN_Name": "Aftertreatment 2 SCR Reagant Tank 2 Information",
      "PGN_Description": "A2SCRRT2I",
      "first_bit": 0,
      "SPN": 4433,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Tank Volume",
      "SPN_Description": "Ratio of volume of diesel exhaust fluid to the total volume of diesel exhaust fluid storage container for aftertreatment system 2 (exhaust bank 2).  0% is empty and 100% is full.  An alternative to this SPN is SPN 4435.\r\n\r\nParameter Specific Indicator:\r\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4434": {
      "PGN": 64820,
      "PGN_Name": "Aftertreatment 2 SCR Reagant Tank 2 Information",
      "PGN_Description": "A2SCRRT2I",
      "first_bit": 8,
      "SPN": 4434,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Temperature",
      "SPN_Description": "The diesel exhaust fluid quick thaw tank temperature for aftertreatment system 2 (exhaust bank 2).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "4435": {
      "PGN": 64820,
      "PGN_Name": "Aftertreatment 2 SCR Reagant Tank 2 Information",
      "PGN_Description": "A2SCRRT2I",
      "first_bit": 16,
      "SPN": 4435,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Tank Level",
      "SPN_Description": "The diesel exhaust fluid level height in mm in the diesel exhaust fluid quick thaw tank for aftertreatment system 2 (exhaust bank 2).  See SPN 4433 for alternate measurement. \r\n\r\nParameter Specific Indicator:\r\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "mm",
      "SLOT_ID": 14
    },
    "4436": {
      "PGN": 64820,
      "PGN_Name": "Aftertreatment 2 SCR Reagant Tank 2 Information",
      "PGN_Description": "A2SCRRT2I",
      "first_bit": 32,
      "SPN": 4436,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Level Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected for the fluid level height of the diesel exhaust fluid quick thaw tank for aftertreatment system 2 (exhaust bank 2), as detected by the manufacturer's control software.  This FMI is applicable to either the diesel exhaust fluid quick thaw tank level or diesel exhaust fluid quick thaw tank volume parameters.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4437": {
      "PGN": 64820,
      "PGN_Name": "Aftertreatment 2 SCR Reagant Tank 2 Information",
      "PGN_Description": "A2SCRRT2I",
      "first_bit": 40,
      "SPN": 4437,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected for the diesel exhaust fluid quick thaw tank temperature for aftertreatment system 2 (exhaust bank 2), as detected by the manufacturer’s control software. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4438": {
      "PGN": 64820,
      "PGN_Name": "Aftertreatment 2 SCR Reagant Tank 2 Information",
      "PGN_Description": "A2SCRRT2I",
      "first_bit": 48,
      "SPN": 4438,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Heater",
      "SPN_Description": "The diesel exhaust fluid quick thaw tank heater percentage for aftertreatment system 2 (exhaust bank 2). 0% is off. See SPN 5415 for the command for this tank heater.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4439": {
      "PGN": 64820,
      "PGN_Name": "Aftertreatment 2 SCR Reagant Tank 2 Information",
      "PGN_Description": "A2SCRRT2I",
      "first_bit": 56,
      "SPN": 4439,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Heater Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected for the heater of the diesel exhaust fluid quick thaw tank for aftertreatment system 2 (exhaust bank 2), as detected by the manufacturer's control software.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4440": {
      "PGN": 64819,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A2DEFSI",
      "first_bit": 0,
      "SPN": 4440,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Pump 1 Motor Speed",
      "SPN_Description": "Rotational speed of the motor driving the first or only pump for the diesel exhaust fluid used in aftertreatment system 2 (exhaust bank 2).",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "4441": {
      "PGN": 64819,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A2DEFSI",
      "first_bit": 16,
      "SPN": 4441,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Pump Drive Percentage",
      "SPN_Description": "The percent (command) sent to the motor to control the speed of  the diesel exhaust fluid pump.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4442": {
      "PGN": 64819,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A2DEFSI",
      "first_bit": 24,
      "SPN": 4442,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Dosing Unit 1 Diverter Valve",
      "SPN_Description": "Command to the valve which determines whether the diesel exhaust fluid of dosing unit 1 is delivered to the injector or is routed back to the diesel exhaust fluid tank. Zero directs all diesel exhaust fluid flow to the injector, 100% sends all diesel exhaust fluid back to the tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4443": {
      "PGN": 61480,
      "PGN_Name": "Aftertreatment 2 SCR Ammonia Information",
      "PGN_Description": "A2SCRAI",
      "first_bit": 0,
      "SPN": 4443,
      "SPN_Name": "Aftertreatment 2 Outlet NH3",
      "SPN_Description": "The amount of NH3 in the exhaust exiting the aftertreatment system measured by a NH3 sensor at the aftertreatment outlet, represented in NH3 molecule parts per million non-NH3 molecules in exhaust bank 2.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "4444": {
      "PGN": 61480,
      "PGN_Name": "Aftertreatment 2 SCR Ammonia Information",
      "PGN_Description": "A2SCRAI",
      "first_bit": 16,
      "SPN": 4444,
      "SPN_Name": "Aftertreatment 2 Outlet NH3 Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet NH3 sensor by the manufacturer’s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4445": {
      "PGN": 61480,
      "PGN_Name": "Aftertreatment 2 SCR Ammonia Information",
      "PGN_Description": "A2SCRAI",
      "first_bit": 24,
      "SPN": 4445,
      "SPN_Name": "Aftertreatment 2 Outlet NH3 Reading Stable",
      "SPN_Description": "Indicates that the NH3 reading of the aftertreatment outlet NH3 sensor is stable as determined by the manufacturer’s control software in exhaust bank 2.\r\n\r\n00 - Reading is not stable\r\n01 - Reading is stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4446": {
      "PGN": 61480,
      "PGN_Name": "Aftertreatment 2 SCR Ammonia Information",
      "PGN_Description": "A2SCRAI",
      "first_bit": 26,
      "SPN": 4446,
      "SPN_Name": "Aftertreatment 2 Outlet NH3 Gas Sensor Power In Range",
      "SPN_Description": "Indicates that the power supplied to the aftertreatment outlet NH3 gas sensor is within the manufacturer’s specification in exhaust bank 2.\r\n\r\n00 - Heater element is not in range\r\n01 - Heater element is in range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4447": {
      "PGN": 61480,
      "PGN_Name": "Aftertreatment 2 SCR Ammonia Information",
      "PGN_Description": "A2SCRAI",
      "first_bit": 28,
      "SPN": 4447,
      "SPN_Name": "Aftertreatment 2 Outlet NH3 Gas Sensor at Temperature",
      "SPN_Description": "Indicates that the heater element of the aftertreatment outlet NH3 gas sensor is within the manufacturer’s specified range for accurate measurements in exhaust bank 2.\r\n\r\n00 - Heater element is not in range\r\n01 - Heater element is in range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4448": {
      "PGN": 61480,
      "PGN_Name": "Aftertreatment 2 SCR Ammonia Information",
      "PGN_Description": "A2SCRAI",
      "first_bit": 32,
      "SPN": 4448,
      "SPN_Name": "Aftertreatment 2 Outlet NH3 Gas Sensor Heater Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the heater of the outlet NH3 exhaust gas sensor by the manufacturer’s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4449": {
      "PGN": 61480,
      "PGN_Name": "Aftertreatment 2 SCR Ammonia Information",
      "PGN_Description": "A2SCRAI",
      "first_bit": 40,
      "SPN": 4449,
      "SPN_Name": "Aftertreatment 2 Outlet NH3 Gas Sensor Heater Control",
      "SPN_Description": "Indicates the heater status in the warm-up process. Upon receiving a power-up command, the NH3 gas sensor ramps up according to a manufacturer defined profile. The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1.\r\n \r\n00 - Automatic \r\n01 - Preheat 2 \r\n10 - Preheat 1 \r\n11 - Heater off or Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4454": {
      "PGN": 64880,
      "PGN_Name": "Door ramp control",
      "PGN_Description": "DRC",
      "first_bit": 24,
      "SPN": 4454,
      "SPN_Name": "Retract Status of ramp 4",
      "SPN_Description": "Retract status of ramp at doorway 4, counting from front to back on the vehicle.\r\n \r\n00 ramp retracted\r\n01 ramp extended\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4455": {
      "PGN": 64880,
      "PGN_Name": "Door ramp control",
      "PGN_Description": "DRC",
      "first_bit": 26,
      "SPN": 4455,
      "SPN_Name": "Enable status of ramp 4",
      "SPN_Description": "Enable status of ramp at doorway 4, counting from front to back on the vehicle.\r\n\r\n00 ramp disabled\r\n01 ramp enabled \r\n10 error \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4456": {
      "PGN": 64880,
      "PGN_Name": "Door ramp control",
      "PGN_Description": "DRC",
      "first_bit": 28,
      "SPN": 4456,
      "SPN_Name": "Movement status of ramp 4",
      "SPN_Description": "Movement status of ramp at doorway 4, counting from front to back on the vehicle.\r\n\r\n00 ramp not being moved\r\n01 ramp being moved\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4457": {
      "PGN": 64880,
      "PGN_Name": "Door ramp control",
      "PGN_Description": "DRC",
      "first_bit": 32,
      "SPN": 4457,
      "SPN_Name": "Retract Status of ramp 5",
      "SPN_Description": "Retract status of ramp at doorway 5, counting from front to back on the vehicle.\r\n \r\n00 ramp retracted\r\n01 ramp extended\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4458": {
      "PGN": 64880,
      "PGN_Name": "Door ramp control",
      "PGN_Description": "DRC",
      "first_bit": 34,
      "SPN": 4458,
      "SPN_Name": "Enable status of ramp 5",
      "SPN_Description": "Enable status of ramp at doorway 5, counting from front to back on the vehicle.\r\n\r\n00 ramp disabled\r\n01 ramp enabled \r\n10 error \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4459": {
      "PGN": 64880,
      "PGN_Name": "Door ramp control",
      "PGN_Description": "DRC",
      "first_bit": 36,
      "SPN": 4459,
      "SPN_Name": "Movement status of ramp 5",
      "SPN_Description": "Movement status of ramp at doorway 5, counting from front to back on the vehicle.\r\n\r\n00 ramp not being moved\r\n01 ramp being moved\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4460": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 0,
      "SPN": 4460,
      "SPN_Name": "Joystick 1 Lamp 1 Command",
      "SPN_Description": "Tells joystick 1 to switch on/off/blinking lamp 1.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4461": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 2,
      "SPN": 4461,
      "SPN_Name": "Joystick 1 Lamp 2 Command",
      "SPN_Description": "Tells joystick 1 to switch on/off/blinking lamp 2.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4462": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 4,
      "SPN": 4462,
      "SPN_Name": "Joystick 1 Lamp 3 Command",
      "SPN_Description": "Tells joystick 1 to switch on/off/blinking lamp 3.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4463": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 6,
      "SPN": 4463,
      "SPN_Name": "Joystick 1 Lamp 4 Command",
      "SPN_Description": "Tells joystick 1 to switch on/off/blinking lamp 4.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4464": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 8,
      "SPN": 4464,
      "SPN_Name": "Joystick 1 Lamp 5 Command",
      "SPN_Description": "Tells joystick 1 to switch on/off/blinking lamp 5.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4465": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 10,
      "SPN": 4465,
      "SPN_Name": "Joystick 1 Lamp 6 Command",
      "SPN_Description": "Tells joystick 1 to switch on/off/blinking lamp 6.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4466": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 12,
      "SPN": 4466,
      "SPN_Name": "Joystick 1 Lamp 7 Command",
      "SPN_Description": "Tells joystick 1 to switch on/off/blinking lamp 7.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4467": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 14,
      "SPN": 4467,
      "SPN_Name": "Joystick 1 Lamp 8 Command",
      "SPN_Description": "Tells joystick 1 to switch on/off/blinking lamp 8.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4468": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 16,
      "SPN": 4468,
      "SPN_Name": "Joystick 1 Lamp 9 Command",
      "SPN_Description": "Tells joystick 1 to switch on/off/blinking lamp 9.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4469": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 18,
      "SPN": 4469,
      "SPN_Name": "Joystick 1 Lamp 10 Command",
      "SPN_Description": "Tells joystick 1 to switch on/off/blinking lamp 10.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4470": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 20,
      "SPN": 4470,
      "SPN_Name": "Joystick 2 Lamp 1 Command",
      "SPN_Description": "Tells joystick 2 to switch on/off/blinking lamp 1.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4471": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 22,
      "SPN": 4471,
      "SPN_Name": "Joystick 2 Lamp 2 Command",
      "SPN_Description": "Tells joystick 2 to switch on/off/blinking lamp 2.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4472": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 24,
      "SPN": 4472,
      "SPN_Name": "Joystick 2 Lamp 3 Command",
      "SPN_Description": "Tells joystick 2 to switch on/off/blinking lamp 3.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4473": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 26,
      "SPN": 4473,
      "SPN_Name": "Joystick 2 Lamp 4 Command",
      "SPN_Description": "Tells joystick 2 to switch on/off/blinking lamp 4.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4474": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 28,
      "SPN": 4474,
      "SPN_Name": "Joystick 2 Lamp 5 Command",
      "SPN_Description": "Tells joystick 2 to switch on/off/blinking lamp 5.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4475": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 30,
      "SPN": 4475,
      "SPN_Name": "Joystick 2 Lamp 6 Command",
      "SPN_Description": "Tells joystick 2 to switch on/off/blinking lamp 6.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4476": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 32,
      "SPN": 4476,
      "SPN_Name": "Joystick 2 Lamp 7 Command",
      "SPN_Description": "Tells joystick 2 to switch on/off/blinking lamp 7.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4477": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 34,
      "SPN": 4477,
      "SPN_Name": "Joystick 2 Lamp 8 Command",
      "SPN_Description": "Tells joystick 2 to switch on/off/blinking lamp 8.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4478": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 36,
      "SPN": 4478,
      "SPN_Name": "Joystick 2 Lamp 9 Command",
      "SPN_Description": "Tells joystick 2 to switch on/off/blinking lamp 9.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4479": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 38,
      "SPN": 4479,
      "SPN_Name": "Joystick 2 Lamp 10 Command",
      "SPN_Description": "Tells joystick 2 to switch on/off/blinking lamp 10.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4480": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 40,
      "SPN": 4480,
      "SPN_Name": "Joystick 3 Lamp 1 Command",
      "SPN_Description": "Tells joystick 3 to switch on/off/blinking lamp 1.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4481": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 42,
      "SPN": 4481,
      "SPN_Name": "Joystick 3 Lamp 2 Command",
      "SPN_Description": "Tells joystick 3 to switch on/off/blinking lamp 2.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4482": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 44,
      "SPN": 4482,
      "SPN_Name": "Joystick 3 Lamp 3 Command",
      "SPN_Description": "Tells joystick 3 to switch on/off/blinking lamp 3.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4483": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 46,
      "SPN": 4483,
      "SPN_Name": "Joystick 3 Lamp 4 Command",
      "SPN_Description": "Tells joystick 3 to switch on/off/blinking lamp 4.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4484": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 48,
      "SPN": 4484,
      "SPN_Name": "Joystick 3 Lamp 5 Command",
      "SPN_Description": "Tells joystick 3 to switch on/off/blinking lamp 5.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4485": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 50,
      "SPN": 4485,
      "SPN_Name": "Joystick 3 Lamp 6 Command",
      "SPN_Description": "Tells joystick 3 to switch on/off/blinking lamp 6.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4486": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 52,
      "SPN": 4486,
      "SPN_Name": "Joystick 3 Lamp 7 Command",
      "SPN_Description": "Tells joystick 3 to switch on/off/blinking lamp 7.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4487": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 54,
      "SPN": 4487,
      "SPN_Name": "Joystick 3 Lamp 8 Command",
      "SPN_Description": "Tells joystick 3 to switch on/off/blinking lamp 8.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4488": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 56,
      "SPN": 4488,
      "SPN_Name": "Joystick 3 Lamp 9 Command",
      "SPN_Description": "Tells joystick 3 to switch on/off/blinking lamp 9.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4489": {
      "PGN": 39168,
      "PGN_Name": "Joystick Lamp Command Message",
      "PGN_Description": "JLCM",
      "first_bit": 58,
      "SPN": 4489,
      "SPN_Name": "Joystick 3 Lamp 10 Command",
      "SPN_Description": "Tells joystick 3 to switch on/off/blinking lamp 10.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Blinking\r\n11 - Don't care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4490": {
      "PGN": 64992,
      "PGN_Name": "Ambient Conditions 2",
      "PGN_Description": "AMB2",
      "first_bit": 16,
      "SPN": 4490,
      "SPN_Name": "Specific Humidity",
      "SPN_Description": "Specific humidity of the ambient intake air.",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "g/kg",
      "SLOT_ID": 285
    },
    "4491": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 0,
      "SPN": 4491,
      "SPN_Name": "Joystick 4 X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4492": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 2,
      "SPN": 4492,
      "SPN_Name": "Joystick 4 X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4493": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 4,
      "SPN": 4493,
      "SPN_Name": "Joystick 4 X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4494": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 6,
      "SPN": 4494,
      "SPN_Name": "Joystick 4 X-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4495": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 16,
      "SPN": 4495,
      "SPN_Name": "Joystick 4 Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4496": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 18,
      "SPN": 4496,
      "SPN_Name": "Joystick 4 Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4497": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 20,
      "SPN": 4497,
      "SPN_Name": "Joystick 4 Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4498": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 22,
      "SPN": 4498,
      "SPN_Name": "Joystick 4 Y-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4499": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 36,
      "SPN": 4499,
      "SPN_Name": "Joystick 4 Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4500": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 38,
      "SPN": 4500,
      "SPN_Name": "Joystick 4 X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4501": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 40,
      "SPN": 4501,
      "SPN_Name": "Joystick 4 Button 4 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4502": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 42,
      "SPN": 4502,
      "SPN_Name": "Joystick 4 Button 3 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4503": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 44,
      "SPN": 4503,
      "SPN_Name": "Joystick 4 Button 2 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4504": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 46,
      "SPN": 4504,
      "SPN_Name": "Joystick 4 Button 1 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4505": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 48,
      "SPN": 4505,
      "SPN_Name": "Joystick 4 Button 8 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4506": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 50,
      "SPN": 4506,
      "SPN_Name": "Joystick 4 Button 7 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4507": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 52,
      "SPN": 4507,
      "SPN_Name": "Joystick 4 Button 6 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4508": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 54,
      "SPN": 4508,
      "SPN_Name": "Joystick 4 Button 5 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4509": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 56,
      "SPN": 4509,
      "SPN_Name": "Joystick 4 Button 12 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4510": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 58,
      "SPN": 4510,
      "SPN_Name": "Joystick 4 Button 11 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4511": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 60,
      "SPN": 4511,
      "SPN_Name": "Joystick 4 Button 10 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4512": {
      "PGN": 64816,
      "PGN_Name": "Basic Joystick Message 4",
      "PGN_Description": "BJM4",
      "first_bit": 62,
      "SPN": 4512,
      "SPN_Name": "Joystick 4 Button 9 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4513": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 0,
      "SPN": 4513,
      "SPN_Name": "Joystick 4 Grip X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4514": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 2,
      "SPN": 4514,
      "SPN_Name": "Joystick 4 Grip X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4515": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 4,
      "SPN": 4515,
      "SPN_Name": "Joystick 4 Grip X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4516": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 6,
      "SPN": 4516,
      "SPN_Name": "Joystick 4 Grip X-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4517": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 16,
      "SPN": 4517,
      "SPN_Name": "Joystick 4 Grip Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4518": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 18,
      "SPN": 4518,
      "SPN_Name": "Joystick 4 Grip Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4519": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 20,
      "SPN": 4519,
      "SPN_Name": "Joystick 4 Grip Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4520": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 22,
      "SPN": 4520,
      "SPN_Name": "Joystick 4 Grip Y-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4521": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 32,
      "SPN": 4521,
      "SPN_Name": "Joystick 4 Theta-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4522": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 34,
      "SPN": 4522,
      "SPN_Name": "Joystick 4 Theta-Axis Counter Clockwise Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4523": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 36,
      "SPN": 4523,
      "SPN_Name": "Joystick 4 Theta-Axis Clockwise Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4524": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 38,
      "SPN": 4524,
      "SPN_Name": "Joystick 4 Theta-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4525": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 50,
      "SPN": 4525,
      "SPN_Name": "Joystick 4 Theta-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4526": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 52,
      "SPN": 4526,
      "SPN_Name": "Joystick 4 Grip Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4527": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 54,
      "SPN": 4527,
      "SPN_Name": "Joystick 4 Grip X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4528": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 0,
      "SPN": 4528,
      "SPN_Name": "Joystick 5 X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4529": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 2,
      "SPN": 4529,
      "SPN_Name": "Joystick 5 X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4530": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 4,
      "SPN": 4530,
      "SPN_Name": "Joystick 5 X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4531": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 6,
      "SPN": 4531,
      "SPN_Name": "Joystick 5 X-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4532": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 16,
      "SPN": 4532,
      "SPN_Name": "Joystick 5 Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4533": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 18,
      "SPN": 4533,
      "SPN_Name": "Joystick 5 Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4534": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 20,
      "SPN": 4534,
      "SPN_Name": "Joystick 5 Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4535": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 22,
      "SPN": 4535,
      "SPN_Name": "Joystick 5 Y-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4536": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 36,
      "SPN": 4536,
      "SPN_Name": "Joystick 5 Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4537": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 38,
      "SPN": 4537,
      "SPN_Name": "Joystick 5 X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4538": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 40,
      "SPN": 4538,
      "SPN_Name": "Joystick 5 Button 4 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4539": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 42,
      "SPN": 4539,
      "SPN_Name": "Joystick 5 Button 3 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4540": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 44,
      "SPN": 4540,
      "SPN_Name": "Joystick 5 Button 2 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4541": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 46,
      "SPN": 4541,
      "SPN_Name": "Joystick 5 Button 1 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4542": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 48,
      "SPN": 4542,
      "SPN_Name": "Joystick 5 Button 8 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4543": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 50,
      "SPN": 4543,
      "SPN_Name": "Joystick 5 Button 7 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4544": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 52,
      "SPN": 4544,
      "SPN_Name": "Joystick 5 Button 6 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4545": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 54,
      "SPN": 4545,
      "SPN_Name": "Joystick 5 Button 5 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4546": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 56,
      "SPN": 4546,
      "SPN_Name": "Joystick 5 Button 12 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4547": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 58,
      "SPN": 4547,
      "SPN_Name": "Joystick 5 Button 11 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4548": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 60,
      "SPN": 4548,
      "SPN_Name": "Joystick 5 Button 10 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4549": {
      "PGN": 64814,
      "PGN_Name": "Basic Joystick Message 5",
      "PGN_Description": "BJM5",
      "first_bit": 62,
      "SPN": 4549,
      "SPN_Name": "Joystick 5 Button 9 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4550": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 0,
      "SPN": 4550,
      "SPN_Name": "Joystick 5 Grip X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4551": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 2,
      "SPN": 4551,
      "SPN_Name": "Joystick 5 Grip X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4552": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 4,
      "SPN": 4552,
      "SPN_Name": "Joystick 5 Grip X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4553": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 6,
      "SPN": 4553,
      "SPN_Name": "Joystick 5 Grip X-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4554": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 16,
      "SPN": 4554,
      "SPN_Name": "Joystick 5 Grip Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4555": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 18,
      "SPN": 4555,
      "SPN_Name": "Joystick 5 Grip Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4556": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 20,
      "SPN": 4556,
      "SPN_Name": "Joystick 5 Grip Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4557": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 22,
      "SPN": 4557,
      "SPN_Name": "Joystick 5 Grip Y-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4558": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 32,
      "SPN": 4558,
      "SPN_Name": "Joystick 5 Theta-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4559": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 34,
      "SPN": 4559,
      "SPN_Name": "Joystick 5 Theta-Axis Counter Clockwise Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4560": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 36,
      "SPN": 4560,
      "SPN_Name": "Joystick 5 Theta-Axis Clockwise Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4561": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 38,
      "SPN": 4561,
      "SPN_Name": "Joystick 5 Theta-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4562": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 50,
      "SPN": 4562,
      "SPN_Name": "Joystick 5 Theta-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4563": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 52,
      "SPN": 4563,
      "SPN_Name": "Joystick 5 Grip Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4564": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 54,
      "SPN": 4564,
      "SPN_Name": "Joystick 5 Grip X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4565": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 0,
      "SPN": 4565,
      "SPN_Name": "Joystick 6 X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4566": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 2,
      "SPN": 4566,
      "SPN_Name": "Joystick 6 X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4567": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 4,
      "SPN": 4567,
      "SPN_Name": "Joystick 6 X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4568": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 6,
      "SPN": 4568,
      "SPN_Name": "Joystick 6 X-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4569": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 16,
      "SPN": 4569,
      "SPN_Name": "Joystick 6 Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4570": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 18,
      "SPN": 4570,
      "SPN_Name": "Joystick 6 Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4571": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 20,
      "SPN": 4571,
      "SPN_Name": "Joystick 6 Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4572": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 22,
      "SPN": 4572,
      "SPN_Name": "Joystick 6 Y-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4573": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 36,
      "SPN": 4573,
      "SPN_Name": "Joystick 6 Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4574": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 38,
      "SPN": 4574,
      "SPN_Name": "Joystick 6 X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4575": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 40,
      "SPN": 4575,
      "SPN_Name": "Joystick 6 Button 4 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4576": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 42,
      "SPN": 4576,
      "SPN_Name": "Joystick 6 Button 3 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4577": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 44,
      "SPN": 4577,
      "SPN_Name": "Joystick 6 Button 2 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4578": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 46,
      "SPN": 4578,
      "SPN_Name": "Joystick 6 Button 1 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4579": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 48,
      "SPN": 4579,
      "SPN_Name": "Joystick 6 Button 8 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4580": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 50,
      "SPN": 4580,
      "SPN_Name": "Joystick 6 Button 7 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4581": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 52,
      "SPN": 4581,
      "SPN_Name": "Joystick 6 Button 6 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4582": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 54,
      "SPN": 4582,
      "SPN_Name": "Joystick 6 Button 5 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4583": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 56,
      "SPN": 4583,
      "SPN_Name": "Joystick 6 Button 12 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4584": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 58,
      "SPN": 4584,
      "SPN_Name": "Joystick 6 Button 11 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4585": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 60,
      "SPN": 4585,
      "SPN_Name": "Joystick 6 Button 10 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4586": {
      "PGN": 64812,
      "PGN_Name": "Basic Joystick Message 6",
      "PGN_Description": "BJM6",
      "first_bit": 62,
      "SPN": 4586,
      "SPN_Name": "Joystick 6 Button 9 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4587": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 0,
      "SPN": 4587,
      "SPN_Name": "Joystick 6 Grip X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4588": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 2,
      "SPN": 4588,
      "SPN_Name": "Joystick 6 Grip X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4589": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 4,
      "SPN": 4589,
      "SPN_Name": "Joystick 6 Grip X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4590": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 6,
      "SPN": 4590,
      "SPN_Name": "Joystick 6 Grip X-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4591": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 16,
      "SPN": 4591,
      "SPN_Name": "Joystick 6 Grip Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4592": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 18,
      "SPN": 4592,
      "SPN_Name": "Joystick 6 Grip Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4593": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 20,
      "SPN": 4593,
      "SPN_Name": "Joystick 6 Grip Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4594": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 22,
      "SPN": 4594,
      "SPN_Name": "Joystick 6 Grip Y-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4595": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 32,
      "SPN": 4595,
      "SPN_Name": "Joystick 6 Theta-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4596": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 34,
      "SPN": 4596,
      "SPN_Name": "Joystick 6 Theta-Axis Counter Clockwise Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4597": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 36,
      "SPN": 4597,
      "SPN_Name": "Joystick 6 Theta-Axis Clockwise Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4598": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 38,
      "SPN": 4598,
      "SPN_Name": "Joystick 6 Theta-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4599": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 50,
      "SPN": 4599,
      "SPN_Name": "Joystick 6 Theta-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4600": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 52,
      "SPN": 4600,
      "SPN_Name": "Joystick 6 Grip Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4601": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 54,
      "SPN": 4601,
      "SPN_Name": "Joystick 6 Grip X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4602": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 0,
      "SPN": 4602,
      "SPN_Name": "Joystick 7 X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4603": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 2,
      "SPN": 4603,
      "SPN_Name": "Joystick 7 X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4604": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 4,
      "SPN": 4604,
      "SPN_Name": "Joystick 7 X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4605": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 6,
      "SPN": 4605,
      "SPN_Name": "Joystick 7 X-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4606": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 16,
      "SPN": 4606,
      "SPN_Name": "Joystick 7 Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4607": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 18,
      "SPN": 4607,
      "SPN_Name": "Joystick 7 Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4608": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 20,
      "SPN": 4608,
      "SPN_Name": "Joystick 7 Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4609": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 22,
      "SPN": 4609,
      "SPN_Name": "Joystick 7 Y-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4610": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 36,
      "SPN": 4610,
      "SPN_Name": "Joystick 7 Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4611": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 38,
      "SPN": 4611,
      "SPN_Name": "Joystick 7 X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4612": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 40,
      "SPN": 4612,
      "SPN_Name": "Joystick 7 Button 4 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4613": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 42,
      "SPN": 4613,
      "SPN_Name": "Joystick 7 Button 3 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4614": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 44,
      "SPN": 4614,
      "SPN_Name": "Joystick 7 Button 2 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4615": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 46,
      "SPN": 4615,
      "SPN_Name": "Joystick 7 Button 1 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4616": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 48,
      "SPN": 4616,
      "SPN_Name": "Joystick 7 Button 8 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4617": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 50,
      "SPN": 4617,
      "SPN_Name": "Joystick 7 Button 7 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4618": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 52,
      "SPN": 4618,
      "SPN_Name": "Joystick 7 Button 6 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4619": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 54,
      "SPN": 4619,
      "SPN_Name": "Joystick 7 Button 5 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4620": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 56,
      "SPN": 4620,
      "SPN_Name": "Joystick 7 Button 12 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4621": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 58,
      "SPN": 4621,
      "SPN_Name": "Joystick 7 Button 11 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4622": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 60,
      "SPN": 4622,
      "SPN_Name": "Joystick 7 Button 10 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4623": {
      "PGN": 64810,
      "PGN_Name": "Basic Joystick Message 7",
      "PGN_Description": "BJM7",
      "first_bit": 62,
      "SPN": 4623,
      "SPN_Name": "Joystick 7 Button 9 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4624": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 0,
      "SPN": 4624,
      "SPN_Name": "Joystick 7 Grip X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4625": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 2,
      "SPN": 4625,
      "SPN_Name": "Joystick 7 Grip X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4626": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 4,
      "SPN": 4626,
      "SPN_Name": "Joystick 7 Grip X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4627": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 6,
      "SPN": 4627,
      "SPN_Name": "Joystick 7 Grip X-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4628": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 16,
      "SPN": 4628,
      "SPN_Name": "Joystick 7 Grip Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4629": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 18,
      "SPN": 4629,
      "SPN_Name": "Joystick 7 Grip Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4630": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 20,
      "SPN": 4630,
      "SPN_Name": "Joystick 7 Grip Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4631": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 22,
      "SPN": 4631,
      "SPN_Name": "Joystick 7 Grip Y-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4632": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 32,
      "SPN": 4632,
      "SPN_Name": "Joystick 7 Theta-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4633": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 34,
      "SPN": 4633,
      "SPN_Name": "Joystick 7 Theta-Axis Counter Clockwise Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4634": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 36,
      "SPN": 4634,
      "SPN_Name": "Joystick 7 Theta-Axis Clockwise Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4635": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 38,
      "SPN": 4635,
      "SPN_Name": "Joystick 7 Theta-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4636": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 50,
      "SPN": 4636,
      "SPN_Name": "Joystick 7 Theta-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4637": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 52,
      "SPN": 4637,
      "SPN_Name": "Joystick 7 Grip Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4638": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 54,
      "SPN": 4638,
      "SPN_Name": "Joystick 7 Grip X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4639": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 0,
      "SPN": 4639,
      "SPN_Name": "Joystick 8 X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4640": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 2,
      "SPN": 4640,
      "SPN_Name": "Joystick 8 X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4641": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 4,
      "SPN": 4641,
      "SPN_Name": "Joystick 8 X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4642": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 6,
      "SPN": 4642,
      "SPN_Name": "Joystick 8 X-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4643": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 16,
      "SPN": 4643,
      "SPN_Name": "Joystick 8 Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4644": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 18,
      "SPN": 4644,
      "SPN_Name": "Joystick 8 Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4645": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 20,
      "SPN": 4645,
      "SPN_Name": "Joystick 8 Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4646": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 22,
      "SPN": 4646,
      "SPN_Name": "Joystick 8 Y-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4647": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 36,
      "SPN": 4647,
      "SPN_Name": "Joystick 8 Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4648": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 38,
      "SPN": 4648,
      "SPN_Name": "Joystick 8 X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4649": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 40,
      "SPN": 4649,
      "SPN_Name": "Joystick 8 Button 4 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4650": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 42,
      "SPN": 4650,
      "SPN_Name": "Joystick 8 Button 3 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4651": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 44,
      "SPN": 4651,
      "SPN_Name": "Joystick 8 Button 2 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4652": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 46,
      "SPN": 4652,
      "SPN_Name": "Joystick 8 Button 1 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4653": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 48,
      "SPN": 4653,
      "SPN_Name": "Joystick 8 Button 8 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4654": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 50,
      "SPN": 4654,
      "SPN_Name": "Joystick 8 Button 7 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4655": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 52,
      "SPN": 4655,
      "SPN_Name": "Joystick 8 Button 6 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4656": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 54,
      "SPN": 4656,
      "SPN_Name": "Joystick 8 Button 5 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4657": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 56,
      "SPN": 4657,
      "SPN_Name": "Joystick 8 Button 12 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4658": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 58,
      "SPN": 4658,
      "SPN_Name": "Joystick 8 Button 11 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4659": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 60,
      "SPN": 4659,
      "SPN_Name": "Joystick 8 Button 10 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4660": {
      "PGN": 64808,
      "PGN_Name": "Basic Joystick Message 8",
      "PGN_Description": "BJM8",
      "first_bit": 62,
      "SPN": 4660,
      "SPN_Name": "Joystick 8 Button 9 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4661": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 0,
      "SPN": 4661,
      "SPN_Name": "Joystick 8 Grip X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4662": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 2,
      "SPN": 4662,
      "SPN_Name": "Joystick 8 Grip X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4663": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 4,
      "SPN": 4663,
      "SPN_Name": "Joystick 8 Grip X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4664": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 6,
      "SPN": 4664,
      "SPN_Name": "Joystick 8 Grip X-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4665": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 16,
      "SPN": 4665,
      "SPN_Name": "Joystick 8 Grip Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4666": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 18,
      "SPN": 4666,
      "SPN_Name": "Joystick 8 Grip Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4667": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 20,
      "SPN": 4667,
      "SPN_Name": "Joystick 8 Grip Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4668": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 22,
      "SPN": 4668,
      "SPN_Name": "Joystick 8 Grip Y-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4669": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 32,
      "SPN": 4669,
      "SPN_Name": "Joystick 8 Theta-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4670": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 34,
      "SPN": 4670,
      "SPN_Name": "Joystick 8 Theta-Axis Counter Clockwise Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4671": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 36,
      "SPN": 4671,
      "SPN_Name": "Joystick 8 Theta-Axis Clockwise Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4672": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 38,
      "SPN": 4672,
      "SPN_Name": "Joystick 8 Theta-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4673": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 50,
      "SPN": 4673,
      "SPN_Name": "Joystick 8 Theta-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4674": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 52,
      "SPN": 4674,
      "SPN_Name": "Joystick 8 Grip Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4675": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 54,
      "SPN": 4675,
      "SPN_Name": "Joystick 8 Grip X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4676": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 0,
      "SPN": 4676,
      "SPN_Name": "Joystick 9 X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4677": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 2,
      "SPN": 4677,
      "SPN_Name": "Joystick 9 X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4678": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 4,
      "SPN": 4678,
      "SPN_Name": "Joystick 9 X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4679": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 6,
      "SPN": 4679,
      "SPN_Name": "Joystick 9 X-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4680": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 16,
      "SPN": 4680,
      "SPN_Name": "Joystick 9 Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4681": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 18,
      "SPN": 4681,
      "SPN_Name": "Joystick 9 Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4682": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 20,
      "SPN": 4682,
      "SPN_Name": "Joystick 9 Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4683": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 22,
      "SPN": 4683,
      "SPN_Name": "Joystick 9 Y-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4684": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 36,
      "SPN": 4684,
      "SPN_Name": "Joystick 9 Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4685": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 38,
      "SPN": 4685,
      "SPN_Name": "Joystick 9 X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4686": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 40,
      "SPN": 4686,
      "SPN_Name": "Joystick 9 Button 4 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4687": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 42,
      "SPN": 4687,
      "SPN_Name": "Joystick 9 Button 3 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4688": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 44,
      "SPN": 4688,
      "SPN_Name": "Joystick 9 Button 2 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4689": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 46,
      "SPN": 4689,
      "SPN_Name": "Joystick 9 Button 1 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4690": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 48,
      "SPN": 4690,
      "SPN_Name": "Joystick 9 Button 8 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4691": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 50,
      "SPN": 4691,
      "SPN_Name": "Joystick 9 Button 7 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4692": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 52,
      "SPN": 4692,
      "SPN_Name": "Joystick 9 Button 6 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4693": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 54,
      "SPN": 4693,
      "SPN_Name": "Joystick 9 Button 5 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4694": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 56,
      "SPN": 4694,
      "SPN_Name": "Joystick 9 Button 12 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4695": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 58,
      "SPN": 4695,
      "SPN_Name": "Joystick 9 Button 11 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4696": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 60,
      "SPN": 4696,
      "SPN_Name": "Joystick 9 Button 10 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4697": {
      "PGN": 64806,
      "PGN_Name": "Basic Joystick Message 9",
      "PGN_Description": "BJM9",
      "first_bit": 62,
      "SPN": 4697,
      "SPN_Name": "Joystick 9 Button 9 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4698": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 0,
      "SPN": 4698,
      "SPN_Name": "Joystick 9 Grip X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4699": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 2,
      "SPN": 4699,
      "SPN_Name": "Joystick 9 Grip X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4700": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 4,
      "SPN": 4700,
      "SPN_Name": "Joystick 9 Grip X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4701": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 6,
      "SPN": 4701,
      "SPN_Name": "Joystick 9 Grip X-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4702": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 16,
      "SPN": 4702,
      "SPN_Name": "Joystick 9 Grip Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4703": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 18,
      "SPN": 4703,
      "SPN_Name": "Joystick 9 Grip Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4704": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 20,
      "SPN": 4704,
      "SPN_Name": "Joystick 9 Grip Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4705": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 22,
      "SPN": 4705,
      "SPN_Name": "Joystick 9 Grip Y-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4706": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 32,
      "SPN": 4706,
      "SPN_Name": "Joystick 9 Theta-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4707": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 34,
      "SPN": 4707,
      "SPN_Name": "Joystick 9 Theta-Axis Counter Clockwise Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4708": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 36,
      "SPN": 4708,
      "SPN_Name": "Joystick 9 Theta-Axis Clockwise Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4709": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 38,
      "SPN": 4709,
      "SPN_Name": "Joystick 9 Theta-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4710": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 50,
      "SPN": 4710,
      "SPN_Name": "Joystick 9 Theta-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4711": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 52,
      "SPN": 4711,
      "SPN_Name": "Joystick 9 Grip Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4712": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 54,
      "SPN": 4712,
      "SPN_Name": "Joystick 9 Grip X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4713": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 0,
      "SPN": 4713,
      "SPN_Name": "Joystick 10 X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4714": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 2,
      "SPN": 4714,
      "SPN_Name": "Joystick 10 X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4715": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 4,
      "SPN": 4715,
      "SPN_Name": "Joystick 10 X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4716": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 6,
      "SPN": 4716,
      "SPN_Name": "Joystick 10 X-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4717": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 16,
      "SPN": 4717,
      "SPN_Name": "Joystick 10 Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4718": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 18,
      "SPN": 4718,
      "SPN_Name": "Joystick 10 Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4719": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 20,
      "SPN": 4719,
      "SPN_Name": "Joystick 10 Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4720": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 22,
      "SPN": 4720,
      "SPN_Name": "Joystick 10 Y-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4721": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 36,
      "SPN": 4721,
      "SPN_Name": "Joystick 10 Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4722": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 38,
      "SPN": 4722,
      "SPN_Name": "Joystick 10 X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4723": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 40,
      "SPN": 4723,
      "SPN_Name": "Joystick 10 Button 4 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4724": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 42,
      "SPN": 4724,
      "SPN_Name": "Joystick 10 Button 3 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4725": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 44,
      "SPN": 4725,
      "SPN_Name": "Joystick 10 Button 2 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4726": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 46,
      "SPN": 4726,
      "SPN_Name": "Joystick 10 Button 1 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4727": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 48,
      "SPN": 4727,
      "SPN_Name": "Joystick 10 Button 8 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4728": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 50,
      "SPN": 4728,
      "SPN_Name": "Joystick 10 Button 7 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4729": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 52,
      "SPN": 4729,
      "SPN_Name": "Joystick 10 Button 6 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4730": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 54,
      "SPN": 4730,
      "SPN_Name": "Joystick 10 Button 5 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4731": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 56,
      "SPN": 4731,
      "SPN_Name": "Joystick 10 Button 12 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4732": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 58,
      "SPN": 4732,
      "SPN_Name": "Joystick 10 Button 11 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4733": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 60,
      "SPN": 4733,
      "SPN_Name": "Joystick 10 Button 10 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4734": {
      "PGN": 64804,
      "PGN_Name": "Basic Joystick Message 10",
      "PGN_Description": "BJM10",
      "first_bit": 62,
      "SPN": 4734,
      "SPN_Name": "Joystick 10 Button 9 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\r\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4735": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 0,
      "SPN": 4735,
      "SPN_Name": "Joystick 10 Grip X-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4736": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 2,
      "SPN": 4736,
      "SPN_Name": "Joystick 10 Grip X-Axis Lever Left Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4737": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 4,
      "SPN": 4737,
      "SPN_Name": "Joystick 10 Grip X-Axis Lever Right Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4738": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 6,
      "SPN": 4738,
      "SPN_Name": "Joystick 10 Grip X-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4739": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 16,
      "SPN": 4739,
      "SPN_Name": "Joystick 10 Grip Y-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4740": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 18,
      "SPN": 4740,
      "SPN_Name": "Joystick 10 Grip Y-Axis Lever Back Negative Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4741": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 20,
      "SPN": 4741,
      "SPN_Name": "Joystick 10 Grip Y-Axis Lever Forward Positive Position Status",
      "SPN_Description": "Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4742": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 22,
      "SPN": 4742,
      "SPN_Name": "Joystick 10 Grip Y-Axis Position",
      "SPN_Description": "The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4743": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 32,
      "SPN": 4743,
      "SPN_Name": "Joystick 10 Theta-Axis Neutral Position Status",
      "SPN_Description": "Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \r\n\r\n00 Not in Neutral Position\r\n01 In Neutral Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4744": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 34,
      "SPN": 4744,
      "SPN_Name": "Joystick 10 Theta-Axis Counter Clockwise Negative Position Status",
      "SPN_Description": "Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on negative side of Neutral\r\n01 On negative side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4745": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 36,
      "SPN": 4745,
      "SPN_Name": "Joystick 10 Theta-Axis Clockwise Positive Position Status",
      "SPN_Description": "Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \r\n\r\n00 Not on Positive side of Neutral\r\n01 On positive side of Neutral\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4746": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 38,
      "SPN": 4746,
      "SPN_Name": "Joystick 10 Theta-Axis Position",
      "SPN_Description": "The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.",
      "bit_length": 10,
      "scaling": 0.1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 205
    },
    "4747": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 50,
      "SPN": 4747,
      "SPN_Name": "Joystick 10 Theta-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4748": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 52,
      "SPN": 4748,
      "SPN_Name": "Joystick 10 Grip Y-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4749": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 54,
      "SPN": 4749,
      "SPN_Name": "Joystick 10 Grip X-Axis Detent Position Status",
      "SPN_Description": "Reports when the current joystick grip position is in the detent position for that axis of travel.\r\n\r\n00 Not in the Detent Position\r\n01 In the Detent Position\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4750": {
      "PGN": 64879,
      "PGN_Name": "Electronic Engine Controller 8",
      "PGN_Description": "EEC8",
      "first_bit": 16,
      "SPN": 4750,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Cooler Intake Temperature",
      "SPN_Description": "Exhaust Gas Recirculation (EGR) Temperature measured at the EGR cooler intake.  See SPN 412 for Engine EGR temperature which is typically measured at the EGR cooler outlet.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4751": {
      "PGN": 64879,
      "PGN_Name": "Electronic Engine Controller 8",
      "PGN_Description": "EEC8",
      "first_bit": 32,
      "SPN": 4751,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Cooler Intake Absolute Pressure",
      "SPN_Description": "Exhaust gas recirculation absolute pressure is measured at the EGR cooler intake. See SPN 3358 for EGR pressure measured at the EGR cooler outlet before the valve.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "4752": {
      "PGN": 64879,
      "PGN_Name": "Electronic Engine Controller 8",
      "PGN_Description": "EEC8",
      "first_bit": 48,
      "SPN": 4752,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Cooler Efficiency",
      "SPN_Description": "Exhaust Gas Recirculation cooler efficiency is an indication of the cooler’s ability to reduce the temperature of the exhaust gas that is being recirculated back to the intake. 0% = no reduction in temperature, 100% = maximum cooling.  The EGR cooler efficiency is calculated as (EGR cooler intake temperature minus EGR gas temperature) divided by (EGR cooler intake temperature minus engine coolant temperature).",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "4753": {
      "PGN": 64802,
      "PGN_Name": "Aftertreatment 1 Gas Oxidation Catalyst",
      "PGN_Description": "A1GOC",
      "first_bit": 0,
      "SPN": 4753,
      "SPN_Name": "Aftertreatment 1 Gas Oxidation Catalyst Intake Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts entering the gas oxidation catalyst in exhaust bank 1.  This parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4754": {
      "PGN": 64802,
      "PGN_Name": "Aftertreatment 1 Gas Oxidation Catalyst",
      "PGN_Description": "A1GOC",
      "first_bit": 16,
      "SPN": 4754,
      "SPN_Name": "Aftertreatment 1 Gas Oxidation Catalyst Outlet Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts leaving the gas oxidation catalyst in exhaust bank 1.  This parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4755": {
      "PGN": 64802,
      "PGN_Name": "Aftertreatment 1 Gas Oxidation Catalyst",
      "PGN_Description": "A1GOC",
      "first_bit": 32,
      "SPN": 4755,
      "SPN_Name": "Aftertreatment 1 Gas Oxidation Catalyst Differential Pressure",
      "SPN_Description": "Exhaust differential pressure measured between the intake and exhaust of the gas oxidation catalyst in exhaust bank 1.  This parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "4756": {
      "PGN": 64802,
      "PGN_Name": "Aftertreatment 1 Gas Oxidation Catalyst",
      "PGN_Description": "A1GOC",
      "first_bit": 48,
      "SPN": 4756,
      "SPN_Name": "Aftertreatment 1 Gas Oxidation Catalyst Intake Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the gas oxidation catalyst intake temperature sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4757": {
      "PGN": 64802,
      "PGN_Name": "Aftertreatment 1 Gas Oxidation Catalyst",
      "PGN_Description": "A1GOC",
      "first_bit": 53,
      "SPN": 4757,
      "SPN_Name": "Aftertreatment 1 Gas Oxidation Catalyst Outlet Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the gas oxidation catalyst outlet temperature sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4758": {
      "PGN": 64802,
      "PGN_Name": "Aftertreatment 1 Gas Oxidation Catalyst",
      "PGN_Description": "A1GOC",
      "first_bit": 58,
      "SPN": 4758,
      "SPN_Name": "Aftertreatment 1 Gas Oxidation Catalyst Differential Pressure Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the gas oxidation catalyst differential pressure sensor by the manufacturer’s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4759": {
      "PGN": 64801,
      "PGN_Name": "Aftertreatment 2 Gas Oxidation Catalyst",
      "PGN_Description": "A2GOC",
      "first_bit": 0,
      "SPN": 4759,
      "SPN_Name": "Aftertreatment 2 Gas Oxidation Catalyst Intake Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts entering the gas oxidation catalyst in exhaust bank 2.  This parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4760": {
      "PGN": 64801,
      "PGN_Name": "Aftertreatment 2 Gas Oxidation Catalyst",
      "PGN_Description": "A2GOC",
      "first_bit": 16,
      "SPN": 4760,
      "SPN_Name": "Aftertreatment 2 Gas Oxidation Catalyst Outlet Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts leaving the gas oxidation catalyst in exhaust bank 2.  This parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4761": {
      "PGN": 64801,
      "PGN_Name": "Aftertreatment 2 Gas Oxidation Catalyst",
      "PGN_Description": "A2GOC",
      "first_bit": 32,
      "SPN": 4761,
      "SPN_Name": "Aftertreatment 2 Gas Oxidation Catalyst Differential Pressure",
      "SPN_Description": "Exhaust differential pressure measured between the intake and exhaust of the gas oxidation catalyst in exhaust bank 2.  This parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "4762": {
      "PGN": 64801,
      "PGN_Name": "Aftertreatment 2 Gas Oxidation Catalyst",
      "PGN_Description": "A2GOC",
      "first_bit": 48,
      "SPN": 4762,
      "SPN_Name": "Aftertreatment 2 Gas Oxidation Catalyst Intake Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the gas oxidation catalyst intake gas temperature sensor by the manufacturer’s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4763": {
      "PGN": 64801,
      "PGN_Name": "Aftertreatment 2 Gas Oxidation Catalyst",
      "PGN_Description": "A2GOC",
      "first_bit": 53,
      "SPN": 4763,
      "SPN_Name": "Aftertreatment 2 Gas Oxidation Catalyst Outlet Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the gas oxidation catalyst outlet gas temperature sensor by the manufacturer’s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4764": {
      "PGN": 64801,
      "PGN_Name": "Aftertreatment 2 Gas Oxidation Catalyst",
      "PGN_Description": "A2GOC",
      "first_bit": 58,
      "SPN": 4764,
      "SPN_Name": "Aftertreatment 2 Gas Oxidation Catalyst Differential Pressure Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the gas oxidation catalyst differential pressure sensor by the manufacturer’s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4765": {
      "PGN": 64800,
      "PGN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst 1",
      "PGN_Description": "A1DOC1",
      "first_bit": 0,
      "SPN": 4765,
      "SPN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst Intake Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts entering the diesel oxidation catalyst in exhaust bank 1.  This parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4766": {
      "PGN": 64800,
      "PGN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst 1",
      "PGN_Description": "A1DOC1",
      "first_bit": 16,
      "SPN": 4766,
      "SPN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst Outlet Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts leaving the diesel oxidation catalyst exhaust in exhaust bank 1.  This parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4767": {
      "PGN": 64800,
      "PGN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst 1",
      "PGN_Description": "A1DOC1",
      "first_bit": 32,
      "SPN": 4767,
      "SPN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst Differential Pressure",
      "SPN_Description": "Exhaust differential pressure measured between the intake and exhaust of a diesel oxidation catalyst in exhaust bank 1.  This parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "4768": {
      "PGN": 64800,
      "PGN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst 1",
      "PGN_Description": "A1DOC1",
      "first_bit": 48,
      "SPN": 4768,
      "SPN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst Intake Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel oxidation catalyst intake temperature sensor by the manufacturer’s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nThis parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4769": {
      "PGN": 64800,
      "PGN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst 1",
      "PGN_Description": "A1DOC1",
      "first_bit": 53,
      "SPN": 4769,
      "SPN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst Outlet Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel oxidation catalyst outlet gas temperature sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4770": {
      "PGN": 64800,
      "PGN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst 1",
      "PGN_Description": "A1DOC1",
      "first_bit": 58,
      "SPN": 4770,
      "SPN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst Differential Pressure Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel oxidation catalyst differential pressure sensor by the manufacturer’s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nThis parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4771": {
      "PGN": 64799,
      "PGN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst 1",
      "PGN_Description": "A2DOC1",
      "first_bit": 0,
      "SPN": 4771,
      "SPN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst Intake Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts entering the diesel oxidation catalyst in exhaust bank 2.  This parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4772": {
      "PGN": 64799,
      "PGN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst 1",
      "PGN_Description": "A2DOC1",
      "first_bit": 16,
      "SPN": 4772,
      "SPN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst Outlet Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts leaving the diesel oxidation catalyst exhaust in exhaust bank 2.  This parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4773": {
      "PGN": 64799,
      "PGN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst 1",
      "PGN_Description": "A2DOC1",
      "first_bit": 32,
      "SPN": 4773,
      "SPN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst Differential Pressure",
      "SPN_Description": "Exhaust differential pressure measured between the intake and exhaust of a diesel oxidation catalyst in exhaust bank 2.  This parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "4774": {
      "PGN": 64799,
      "PGN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst 1",
      "PGN_Description": "A2DOC1",
      "first_bit": 48,
      "SPN": 4774,
      "SPN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst Intake Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel oxidation catalyst intake temperature sensor by the manufacturer’s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nThis parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4775": {
      "PGN": 64799,
      "PGN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst 1",
      "PGN_Description": "A2DOC1",
      "first_bit": 53,
      "SPN": 4775,
      "SPN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst Outlet Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel oxidation catalyst outlet gas temperature sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4776": {
      "PGN": 64799,
      "PGN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst 1",
      "PGN_Description": "A2DOC1",
      "first_bit": 58,
      "SPN": 4776,
      "SPN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst Differential Pressure Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the diesel oxidation catalyst differential pressure sensor by the manufacturer’s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nThis parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4777": {
      "PGN": 64798,
      "PGN_Name": "Aftertreatment Differential Temperature 1 ",
      "PGN_Description": "ATDT1",
      "first_bit": 0,
      "SPN": 4777,
      "SPN_Name": "Aftertreatment 1 Gas Oxidation Catalyst Differential Temperature",
      "SPN_Description": "The differential engine combustion byproducts gas temperature measured between the intake and outlet of the gas oxidation catalyst for exhaust bank 1.  This parameter should be used with engine fueled by gaseous fuel like natural gas or propane.  Diesel engines should not use this parameter.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4778": {
      "PGN": 64798,
      "PGN_Name": "Aftertreatment Differential Temperature 1 ",
      "PGN_Description": "ATDT1",
      "first_bit": 16,
      "SPN": 4778,
      "SPN_Name": "Aftertreatment 2 Gas Oxidation Catalyst Differential Temperature",
      "SPN_Description": "The differential engine combustion byproducts gas temperature measured between the intake and outlet of the gas oxidation catalyst for exhaust bank 2.  This parameter should be used with engine fueled by gaseous fuel like natural gas or propane.  Diesel engines should not use this parameter.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4779": {
      "PGN": 64797,
      "PGN_Name": "Aftertreatment Differential Temperature 2 ",
      "PGN_Description": "ATDT2",
      "first_bit": 0,
      "SPN": 4779,
      "SPN_Name": "Aftertreatment 1 Three Way Catalyst Differential Temperature",
      "SPN_Description": "The differential engine combustion byproducts gas temperature measured between the intake and outlet of the three way catalyst for exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4780": {
      "PGN": 64797,
      "PGN_Name": "Aftertreatment Differential Temperature 2 ",
      "PGN_Description": "ATDT2",
      "first_bit": 16,
      "SPN": 4780,
      "SPN_Name": "Aftertreatment 2 Three Way Catalyst Differential Temperature",
      "SPN_Description": "The differential engine combustion byproducts gas temperature measured between the intake and outlet of the three way catalyst for exhaust bank 2.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4781": {
      "PGN": 64796,
      "PGN_Name": "Diesel Particulate Filter 1 Soot",
      "PGN_Description": "DPF1S",
      "first_bit": 0,
      "SPN": 4781,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Soot Mass",
      "SPN_Description": "Soot mass in diesel particulate filter 1.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "g",
      "SLOT_ID": 286
    },
    "4782": {
      "PGN": 64796,
      "PGN_Name": "Diesel Particulate Filter 1 Soot",
      "PGN_Description": "DPF1S",
      "first_bit": 8,
      "SPN": 4782,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Soot Density",
      "SPN_Description": "Soot density in diesel particulate filter 1.",
      "bit_length": 8,
      "scaling": 0.08,
      "offset": 0,
      "unit": "g/L",
      "SLOT_ID": 287
    },
    "4783": {
      "PGN": 64796,
      "PGN_Name": "Diesel Particulate Filter 1 Soot",
      "PGN_Description": "DPF1S",
      "first_bit": 16,
      "SPN": 4783,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Mean Soot Signal",
      "SPN_Description": "Mean output signal level from diesel particulate filter 1 soot sensor.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "4784": {
      "PGN": 64796,
      "PGN_Name": "Diesel Particulate Filter 1 Soot",
      "PGN_Description": "DPF1S",
      "first_bit": 32,
      "SPN": 4784,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Median Soot Signal",
      "SPN_Description": "Median output signal level from diesel particulate filter 1 soot sensor.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "4785": {
      "PGN": 64796,
      "PGN_Name": "Diesel Particulate Filter 1 Soot",
      "PGN_Description": "DPF1S",
      "first_bit": 48,
      "SPN": 4785,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Soot Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the soot sensor signal by the manufacturer’s sensor control software in diesel particulate filter 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4786": {
      "PGN": 64795,
      "PGN_Name": "Diesel Particulate Filter 2 Soot",
      "PGN_Description": "DPF2S",
      "first_bit": 0,
      "SPN": 4786,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Soot Mass",
      "SPN_Description": "Soot mass in diesel particulate filter 2.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "g",
      "SLOT_ID": 286
    },
    "4787": {
      "PGN": 64795,
      "PGN_Name": "Diesel Particulate Filter 2 Soot",
      "PGN_Description": "DPF2S",
      "first_bit": 8,
      "SPN": 4787,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Soot Density",
      "SPN_Description": "Soot density in diesel particulate filter 2.",
      "bit_length": 8,
      "scaling": 0.08,
      "offset": 0,
      "unit": "g/L",
      "SLOT_ID": 287
    },
    "4788": {
      "PGN": 64795,
      "PGN_Name": "Diesel Particulate Filter 2 Soot",
      "PGN_Description": "DPF2S",
      "first_bit": 16,
      "SPN": 4788,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Mean Soot Signal",
      "SPN_Description": "Mean output signal level from diesel particulate filter 2 soot sensor.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "4789": {
      "PGN": 64795,
      "PGN_Name": "Diesel Particulate Filter 2 Soot",
      "PGN_Description": "DPF2S",
      "first_bit": 32,
      "SPN": 4789,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Median Soot Signal",
      "SPN_Description": "Median output signal level from diesel particulate filter 2 soot sensor.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "4790": {
      "PGN": 64795,
      "PGN_Name": "Diesel Particulate Filter 2 Soot",
      "PGN_Description": "DPF2S",
      "first_bit": 48,
      "SPN": 4790,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Soot Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the soot sensor signal by the manufacturer’s sensor control software in diesel particulate filter 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "4809": {
      "PGN": 64794,
      "PGN_Name": "Aftertreatment 1 Warm Up Diesel Oxidation Catalyst Information",
      "PGN_Description": "AT1WUDOC",
      "first_bit": 0,
      "SPN": 4809,
      "SPN_Name": "Aftertreatment 1 Warm Up Diesel Oxidation Catalyst Intake Temperature",
      "SPN_Description": "This is the temperature measured at the intake of the warm up oxidation catalytic converter in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4810": {
      "PGN": 64794,
      "PGN_Name": "Aftertreatment 1 Warm Up Diesel Oxidation Catalyst Information",
      "PGN_Description": "AT1WUDOC",
      "first_bit": 16,
      "SPN": 4810,
      "SPN_Name": "Aftertreatment 1 Warm Up Diesel Oxidation Catalyst Outlet Temperature",
      "SPN_Description": "This is the temperature measured at the outlet of the warm up oxidation catalytic converter in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "4816": {
      "PGN": 61442,
      "PGN_Name": "Electronic Transmission Controller 1",
      "PGN_Description": "ETC1",
      "first_bit": 6,
      "SPN": 4816,
      "SPN_Name": "Transmission Torque Converter Lockup Transition in Process",
      "SPN_Description": "State signal indicating whether or not the transmission torque converter lock up clutch is transitioning between being applied and being released.  The broadcast value should be set to 01 as soon as an apply or release of the lockup clutch is initiated, and then set to 00 once the given transition is complete.  This parameter is a companion to SPN 573 Transmission Torque Converter Lockup Engaged.\r\n\r\n00 - Transition is not in process\r\n01 - Transition is in process\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4817": {
      "PGN": 64976,
      "PGN_Name": "Intake/Exhaust Conditions 2",
      "PGN_Description": "IC2",
      "first_bit": 40,
      "SPN": 4817,
      "SPN_Name": "Engine Intake Manifold 1 Absolute Pressure (High Resolution)",
      "SPN_Description": "The absolute pressure measurement of the air intake manifold. If there are multiple air pressure sensors in the intake stream, this is the last one in flow direction before entering the combustion chamber.  This SPN is a high resolution measurement.  See SPN 3563 if high resolution is not needed.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "4818": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 0,
      "SPN": 4818,
      "SPN_Name": "Driver Airbag Ignitor Loop 1st Stage - Resistance",
      "SPN_Description": "Resistance of Driver Airbag Ignitor Loop 1st Stage.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4819": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 16,
      "SPN": 4819,
      "SPN_Name": "Passenger Airbag Ignitor Loop 1st Stage - Resistance",
      "SPN_Description": "Resistance of Passenger Airbag Ignitor Loop 1st Stage.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4820": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 32,
      "SPN": 4820,
      "SPN_Name": "Driver Airbag Ignitor Loop 2nd Stage - Resistance",
      "SPN_Description": "Resistance of Driver Airbag Ignitor Loop 2nd Stage.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4821": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 48,
      "SPN": 4821,
      "SPN_Name": "Passenger Airbag Ignitor Loop 2nd Stage - Resistance",
      "SPN_Description": "Resistance of Passenger Airbag Ignitor Loop 2nd Stage.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4822": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 64,
      "SPN": 4822,
      "SPN_Name": "Driver Belt Tensioner Ignitior Loop - Resistance",
      "SPN_Description": "Resistance of Driver Belt Tensioner Ignitor Loop 1st Stage.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4823": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 80,
      "SPN": 4823,
      "SPN_Name": "Passenger Belt Tensioner Ignitor Loop - Resistance",
      "SPN_Description": "Resistance of Passenger Belt Tensioner Ignitor Loop 1st Stage.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4824": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 96,
      "SPN": 4824,
      "SPN_Name": "Side Bag Ignitor Loop 1 - Left - Resistance",
      "SPN_Description": "Resistance of Side Bag Ignitor Loop 1 - Left.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4825": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 112,
      "SPN": 4825,
      "SPN_Name": "Side Bag Ignitor Loop 2 - Left - Resistance",
      "SPN_Description": "Resistance of Side Bag Ignitor Loop 2 - Left.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4826": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 128,
      "SPN": 4826,
      "SPN_Name": "Side Bag Ignitor Loop 1 - Right - Resistance",
      "SPN_Description": "Resistance of Side Bag Ignitor Loop 1 - Right.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4827": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 144,
      "SPN": 4827,
      "SPN_Name": "Side Bag Ignitor Loop 2 - Right - Resistance",
      "SPN_Description": "Resistance of Side Bag Ignitor Loop 2 - Right.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4828": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 160,
      "SPN": 4828,
      "SPN_Name": "Special Ignitor Loop 1 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 1.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4829": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 176,
      "SPN": 4829,
      "SPN_Name": "Special Ignitor Loop 2 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 2.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4830": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 192,
      "SPN": 4830,
      "SPN_Name": "Special Ignitor Loop 3 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 3.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4831": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 208,
      "SPN": 4831,
      "SPN_Name": "Special Ignitor Loop 4 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 4.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4832": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 224,
      "SPN": 4832,
      "SPN_Name": "Special Ignitor Loop 5 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 5.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4833": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 240,
      "SPN": 4833,
      "SPN_Name": "Special Ignitor Loop 6 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 6.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4834": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 256,
      "SPN": 4834,
      "SPN_Name": "Special Ignitor Loop 7 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 7.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4835": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 272,
      "SPN": 4835,
      "SPN_Name": "Special Ignitor Loop 8 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 8.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4836": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 288,
      "SPN": 4836,
      "SPN_Name": "Special Ignitor Loop 9 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 9.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4837": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 304,
      "SPN": 4837,
      "SPN_Name": "Special Ignitor Loop 10 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 10.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4838": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 320,
      "SPN": 4838,
      "SPN_Name": "Special Ignitor Loop 11 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 11.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4839": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 336,
      "SPN": 4839,
      "SPN_Name": "Special Ignitor Loop 12 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 12.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4840": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 352,
      "SPN": 4840,
      "SPN_Name": "Special Ignitor Loop 13 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 13.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4841": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 368,
      "SPN": 4841,
      "SPN_Name": "Special Ignitor Loop 14 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 14.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4842": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 384,
      "SPN": 4842,
      "SPN_Name": "Special Ignitor Loop 15 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 15.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4843": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 400,
      "SPN": 4843,
      "SPN_Name": "Special Ignitor Loop 16 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 16.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4844": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 416,
      "SPN": 4844,
      "SPN_Name": "Special Ignitor Loop 17 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 17.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4845": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 432,
      "SPN": 4845,
      "SPN_Name": "Special Ignitor Loop 18 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 18.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4846": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 448,
      "SPN": 4846,
      "SPN_Name": "Special Ignitor Loop 19 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 19.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4847": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 464,
      "SPN": 4847,
      "SPN_Name": "Special Ignitor Loop 20 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 20.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4848": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 480,
      "SPN": 4848,
      "SPN_Name": "Special Ignitor Loop 21 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 21.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4849": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 496,
      "SPN": 4849,
      "SPN_Name": "Special Ignitor Loop 22 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 22.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4850": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 512,
      "SPN": 4850,
      "SPN_Name": "Special Ignitor Loop 23 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 23.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4851": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 528,
      "SPN": 4851,
      "SPN_Name": "Special Ignitor Loop 24 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 24.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4852": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 544,
      "SPN": 4852,
      "SPN_Name": "Special Ignitor Loop 25 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 25.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4853": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 560,
      "SPN": 4853,
      "SPN_Name": "Special Ignitor Loop 26 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 26.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4854": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 576,
      "SPN": 4854,
      "SPN_Name": "Special Ignitor Loop 27 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 27.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4855": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 592,
      "SPN": 4855,
      "SPN_Name": "Special Ignitor Loop 28 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 28.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4856": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 608,
      "SPN": 4856,
      "SPN_Name": "Special Ignitor Loop 29 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 29.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4857": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 624,
      "SPN": 4857,
      "SPN_Name": "Special Ignitor Loop 30 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 30.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4858": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 640,
      "SPN": 4858,
      "SPN_Name": "Special Ignitor Loop 31 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 31.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4859": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 656,
      "SPN": 4859,
      "SPN_Name": "Special Ignitor Loop 32 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 32.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4860": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 672,
      "SPN": 4860,
      "SPN_Name": "Special Ignitor Loop 33 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 33.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4861": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 688,
      "SPN": 4861,
      "SPN_Name": "Special Ignitor Loop 34 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 34.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4862": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 704,
      "SPN": 4862,
      "SPN_Name": "Special Ignitor Loop 35 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 35.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4863": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 720,
      "SPN": 4863,
      "SPN_Name": "Special Ignitor Loop 36 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 36.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4864": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 736,
      "SPN": 4864,
      "SPN_Name": "Special Ignitor Loop 37 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 37.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4865": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 752,
      "SPN": 4865,
      "SPN_Name": "Special Ignitor Loop 38 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 38.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4866": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 768,
      "SPN": 4866,
      "SPN_Name": "Special Ignitor Loop 39 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 39.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4867": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 784,
      "SPN": 4867,
      "SPN_Name": "Special Ignitor Loop 40 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 40.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4868": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 800,
      "SPN": 4868,
      "SPN_Name": "Special Ignitor Loop 41 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 41.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4869": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 816,
      "SPN": 4869,
      "SPN_Name": "Special Ignitor Loop 42 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 42.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4870": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 832,
      "SPN": 4870,
      "SPN_Name": "Special Ignitor Loop 43 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 43.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4871": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 848,
      "SPN": 4871,
      "SPN_Name": "Special Ignitor Loop 44 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 44.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4872": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 864,
      "SPN": 4872,
      "SPN_Name": "Special Ignitor Loop 45 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 45.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4873": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 880,
      "SPN": 4873,
      "SPN_Name": "Special Ignitor Loop 46 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 46.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4874": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 896,
      "SPN": 4874,
      "SPN_Name": "Special Ignitor Loop 47 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 47.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4875": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 912,
      "SPN": 4875,
      "SPN_Name": "Special Ignitor Loop 48 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 48.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4876": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 928,
      "SPN": 4876,
      "SPN_Name": "Special Ignitor Loop 49 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 49.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4877": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 944,
      "SPN": 4877,
      "SPN_Name": "Special Ignitor Loop 50 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 50.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4878": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 960,
      "SPN": 4878,
      "SPN_Name": "Special Ignitor Loop 51 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 51.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4879": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 976,
      "SPN": 4879,
      "SPN_Name": "Special Ignitor Loop 52 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 52.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4880": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 992,
      "SPN": 4880,
      "SPN_Name": "Special Ignitor Loop 53 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 53.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4881": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1008,
      "SPN": 4881,
      "SPN_Name": "Special Ignitor Loop 54 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 54.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4882": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1024,
      "SPN": 4882,
      "SPN_Name": "Special Ignitor Loop 55 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 55.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4883": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1040,
      "SPN": 4883,
      "SPN_Name": "Special Ignitor Loop 56 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 56.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4884": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1056,
      "SPN": 4884,
      "SPN_Name": "Special Ignitor Loop 57 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 57.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4885": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1072,
      "SPN": 4885,
      "SPN_Name": "Special Ignitor Loop 58 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 58.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4886": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1088,
      "SPN": 4886,
      "SPN_Name": "Special Ignitor Loop 59 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 59.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4887": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1104,
      "SPN": 4887,
      "SPN_Name": "Special Ignitor Loop 60 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 60.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4888": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1120,
      "SPN": 4888,
      "SPN_Name": "Special Ignitor Loop 61 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 61.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4889": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1136,
      "SPN": 4889,
      "SPN_Name": "Special Ignitor Loop 62 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 62.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4890": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1152,
      "SPN": 4890,
      "SPN_Name": "Special Ignitor Loop 63 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 63.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4891": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1168,
      "SPN": 4891,
      "SPN_Name": "Special Ignitor Loop 64 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 64.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4892": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1184,
      "SPN": 4892,
      "SPN_Name": "Special Ignitor Loop 65 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 65.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4893": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1200,
      "SPN": 4893,
      "SPN_Name": "Special Ignitor Loop 66 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 66.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4894": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1216,
      "SPN": 4894,
      "SPN_Name": "Special Ignitor Loop 67 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 67.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4895": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1232,
      "SPN": 4895,
      "SPN_Name": "Special Ignitor Loop 68 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 68.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4896": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1248,
      "SPN": 4896,
      "SPN_Name": "Special Ignitor Loop 69 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 69.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4897": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1264,
      "SPN": 4897,
      "SPN_Name": "Special Ignitor Loop 70 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 70.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4898": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1280,
      "SPN": 4898,
      "SPN_Name": "Special Ignitor Loop 71 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 71.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4899": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1296,
      "SPN": 4899,
      "SPN_Name": "Special Ignitor Loop 72 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 72.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4900": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1312,
      "SPN": 4900,
      "SPN_Name": "Special Ignitor Loop 73 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 73.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4901": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1328,
      "SPN": 4901,
      "SPN_Name": "Special Ignitor Loop 74 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 74.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4902": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1344,
      "SPN": 4902,
      "SPN_Name": "Special Ignitor Loop 75 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 75.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4903": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1360,
      "SPN": 4903,
      "SPN_Name": "Special Ignitor Loop 76 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 76.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4904": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1376,
      "SPN": 4904,
      "SPN_Name": "Special Ignitor Loop 77 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 77.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4905": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1392,
      "SPN": 4905,
      "SPN_Name": "Special Ignitor Loop 78 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 78.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4906": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1408,
      "SPN": 4906,
      "SPN_Name": "Special Ignitor Loop 79 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 79.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4907": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1424,
      "SPN": 4907,
      "SPN_Name": "Special Ignitor Loop 80 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 80.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4908": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1440,
      "SPN": 4908,
      "SPN_Name": "Special Ignitor Loop 81 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 81.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4909": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1456,
      "SPN": 4909,
      "SPN_Name": "Special Ignitor Loop 82 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 82.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4910": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1472,
      "SPN": 4910,
      "SPN_Name": "Special Ignitor Loop 83 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 83.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4911": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1488,
      "SPN": 4911,
      "SPN_Name": "Special Ignitor Loop 84 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 84.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4912": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1504,
      "SPN": 4912,
      "SPN_Name": "Special Ignitor Loop 85 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 85.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4913": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1520,
      "SPN": 4913,
      "SPN_Name": "Special Ignitor Loop 86 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 86.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4914": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1536,
      "SPN": 4914,
      "SPN_Name": "Special Ignitor Loop 87 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 87.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4915": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1552,
      "SPN": 4915,
      "SPN_Name": "Special Ignitor Loop 88 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 88.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4916": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1568,
      "SPN": 4916,
      "SPN_Name": "Special Ignitor Loop 89 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 89.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4917": {
      "PGN": 64793,
      "PGN_Name": "Ignitor Loop Information",
      "PGN_Description": "ILI",
      "first_bit": 1584,
      "SPN": 4917,
      "SPN_Name": "Special Ignitor Loop 90 - Resistance",
      "SPN_Description": "Resistance of Special Ignitor Loop 90.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "4918": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 0,
      "SPN": 4918,
      "SPN_Name": "Frontal Collision Sensor 1 - Type",
      "SPN_Description": "Type of Frontal Collision Sensor 1.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4919": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 4,
      "SPN": 4919,
      "SPN_Name": "Frontal Collision Sensor 2 - Type",
      "SPN_Description": "Type of Frontal Collision Sensor 2.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4920": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 8,
      "SPN": 4920,
      "SPN_Name": "Frontal Collision Sensor 3 - Type",
      "SPN_Description": "Type of Frontal Collision Sensor 3.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4921": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 12,
      "SPN": 4921,
      "SPN_Name": "Frontal Collision Sensor 4 - Type",
      "SPN_Description": "Type of Frontal Collision Sensor 4.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4922": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 16,
      "SPN": 4922,
      "SPN_Name": "Side Collision Sensor Front Left - Type",
      "SPN_Description": "Type of Side Collision Sensor Front - Left.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4923": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 20,
      "SPN": 4923,
      "SPN_Name": "Side Collision Sensor Mid Front Left - Type",
      "SPN_Description": "Type of Side Collision Sensor Mid Front - Left.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4924": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 24,
      "SPN": 4924,
      "SPN_Name": "Side Collision Sensor Mid Rear Left - Type",
      "SPN_Description": "Type of Side Collision Sensor Mid Rear - Left.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4925": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 28,
      "SPN": 4925,
      "SPN_Name": "Side Collision Sensor Rear Left - Type",
      "SPN_Description": "Type of Side Collision Sensor Rear - Left.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4926": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 32,
      "SPN": 4926,
      "SPN_Name": "Side Collision Sensor Front Right - Type",
      "SPN_Description": "Type of Side Collision Sensor Front - Right.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4927": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 36,
      "SPN": 4927,
      "SPN_Name": "Side Collision Sensor Mid Front Right - Type",
      "SPN_Description": "Type of Side Collision Sensor Mid Front - Right.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4928": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 40,
      "SPN": 4928,
      "SPN_Name": "Side Collision Sensor Mid Rear Right - Type",
      "SPN_Description": "Type of Side Collision Sensor Mid Rear - Right.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4929": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 44,
      "SPN": 4929,
      "SPN_Name": "Side Collision Sensor Rear Right - Type",
      "SPN_Description": "Type of Side Collision Sensor Rear - Right.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4930": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 48,
      "SPN": 4930,
      "SPN_Name": "Rear Collision Sensor 1 - Type",
      "SPN_Description": "Type of Rear Collision Sensor 1.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4931": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 52,
      "SPN": 4931,
      "SPN_Name": "Rear Collision Sensor 2 - Type",
      "SPN_Description": "Type of Rear Collision Sensor 2.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4932": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 56,
      "SPN": 4932,
      "SPN_Name": "Rear Collision Sensor 3 - Type",
      "SPN_Description": "Type of Rear Collision Sensor 3.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4933": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 60,
      "SPN": 4933,
      "SPN_Name": "Rear Collision Sensor 4 - Type",
      "SPN_Description": "Type of Rear Collision Sensor 4.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4934": {
      "PGN": 64792,
      "PGN_Name": "Collision Sensor Information",
      "PGN_Description": "CSI",
      "first_bit": 64,
      "SPN": 4934,
      "SPN_Name": "Rollover Sensor - Type",
      "SPN_Description": "Type of Rollover Sensor.\r\n\r\n0000 = acceleration sensor\r\n0001 = pressure sensor\r\n0010 = rollrate sensor\r\n0011 = sonic sensor\r\n0100 = fiber-optic sensor\r\n0101 = radar sensor\r\n0110 = lidar sensor\r\n0111 = optical sensor\r\n1000-1101 =  Reserved\r\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\r\n1111 = not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4952": {
      "PGN": 64791,
      "PGN_Name": "Beltlock and Airbag Deactivation Switch Information",
      "PGN_Description": "BDS",
      "first_bit": 0,
      "SPN": 4952,
      "SPN_Name": "Driver Beltlock Status",
      "SPN_Description": "State of switch used to determine if Driver Beltlock is buckled.\r\n\r\n00 = unlocked\r\n01 = locked\r\n10 = Error - Beltlock state cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4953": {
      "PGN": 64791,
      "PGN_Name": "Beltlock and Airbag Deactivation Switch Information",
      "PGN_Description": "BDS",
      "first_bit": 2,
      "SPN": 4953,
      "SPN_Name": "Passenger Beltlock Status",
      "SPN_Description": "State of switch used to determine if Passenger Beltlock is buckled.\r\n\r\n00 = unlocked\r\n01 = locked\r\n10 = Error - Beltlock state cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4954": {
      "PGN": 64791,
      "PGN_Name": "Beltlock and Airbag Deactivation Switch Information",
      "PGN_Description": "BDS",
      "first_bit": 4,
      "SPN": 4954,
      "SPN_Name": "Beltlock 3 Status",
      "SPN_Description": "State of switch used to determine if Beltlock 3 is buckled.\r\n\r\n00 = unlocked\r\n01 = locked\r\n10 = Error - Beltlock state cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4955": {
      "PGN": 64791,
      "PGN_Name": "Beltlock and Airbag Deactivation Switch Information",
      "PGN_Description": "BDS",
      "first_bit": 6,
      "SPN": 4955,
      "SPN_Name": "Beltlock 4 Status",
      "SPN_Description": "State of switch used to determine if Beltlock 4 is buckled.\r\n\r\n00 = unlocked\r\n01 = locked\r\n10 = Error - Beltlock state cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4956": {
      "PGN": 64791,
      "PGN_Name": "Beltlock and Airbag Deactivation Switch Information",
      "PGN_Description": "BDS",
      "first_bit": 8,
      "SPN": 4956,
      "SPN_Name": "Beltlock 5 Status",
      "SPN_Description": "State of switch used to determine if Beltlock 5 is buckled.\r\n\r\n00 = unlocked\r\n01 = locked\r\n10 = Error - Beltlock state cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4957": {
      "PGN": 64791,
      "PGN_Name": "Beltlock and Airbag Deactivation Switch Information",
      "PGN_Description": "BDS",
      "first_bit": 10,
      "SPN": 4957,
      "SPN_Name": "Beltlock 6 Status",
      "SPN_Description": "State of switch used to determine if Beltlock 6 is buckled.\r\n\r\n00 = unlocked\r\n01 = locked\r\n10 = Error - Beltlock state cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4958": {
      "PGN": 64791,
      "PGN_Name": "Beltlock and Airbag Deactivation Switch Information",
      "PGN_Description": "BDS",
      "first_bit": 12,
      "SPN": 4958,
      "SPN_Name": "Beltlock 7 Status",
      "SPN_Description": "State of switch used to determine if Beltlock 7 is buckled.\r\n\r\n00 = unlocked\r\n01 = locked\r\n10 = Error - Beltlock state cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4959": {
      "PGN": 64791,
      "PGN_Name": "Beltlock and Airbag Deactivation Switch Information",
      "PGN_Description": "BDS",
      "first_bit": 14,
      "SPN": 4959,
      "SPN_Name": "Beltlock 8 Status",
      "SPN_Description": "State of switch used to determine if Beltlock 8 is buckled.\r\n\r\n00 = unlocked\r\n01 = locked\r\n10 = Error - Beltlock state cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4960": {
      "PGN": 64791,
      "PGN_Name": "Beltlock and Airbag Deactivation Switch Information",
      "PGN_Description": "BDS",
      "first_bit": 16,
      "SPN": 4960,
      "SPN_Name": "Beltlock 9 Status",
      "SPN_Description": "State of switch used to determine if Beltlock 9 is buckled.\r\n\r\n00 = unlocked\r\n01 = locked\r\n10 = Error - Beltlock state cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4961": {
      "PGN": 64791,
      "PGN_Name": "Beltlock and Airbag Deactivation Switch Information",
      "PGN_Description": "BDS",
      "first_bit": 18,
      "SPN": 4961,
      "SPN_Name": "Beltlock 10 Status",
      "SPN_Description": "State of switch used to determine if Beltlock 10 is buckled.\r\n\r\n00 = unlocked\r\n01 = locked\r\n10 = Error - Beltlock state cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4962": {
      "PGN": 64791,
      "PGN_Name": "Beltlock and Airbag Deactivation Switch Information",
      "PGN_Description": "BDS",
      "first_bit": 20,
      "SPN": 4962,
      "SPN_Name": "Passenger Airbag Deactivation Switch Status",
      "SPN_Description": "State of switch used to deactivate Passenger Airbag manually.\r\n\r\n00 = passenger airbag activated\r\n01 = passenger airbag deactivated\r\n10 = Error - State of deactivation switch cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4963": {
      "PGN": 64790,
      "PGN_Name": "Occupant Classification System Information",
      "PGN_Description": "OCSI",
      "first_bit": 0,
      "SPN": 4963,
      "SPN_Name": "Driver Occupant Classification System Status",
      "SPN_Description": "State of Occupant Classification System for driver.\r\n\r\n000 = empty\r\n001 = child\r\n010 = small adult\r\n011 = adult\r\n100 = large adult\r\n101 = reserved\r\n110 = Error - Classification of occupant cannot be determined\r\n111 = not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "4964": {
      "PGN": 64790,
      "PGN_Name": "Occupant Classification System Information",
      "PGN_Description": "OCSI",
      "first_bit": 3,
      "SPN": 4964,
      "SPN_Name": "Passenger Occupant Classification System Status",
      "SPN_Description": "State of Occupant Classification System for passenger.\r\n\r\n000 = empty\r\n001 = child\r\n010 = small adult\r\n011 = adult\r\n100 = large adult\r\n101 = Error - Classification of occupant cannot be determined\r\n110 = reserved\r\n111 = not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "4965": {
      "PGN": 64790,
      "PGN_Name": "Occupant Classification System Information",
      "PGN_Description": "OCSI",
      "first_bit": 8,
      "SPN": 4965,
      "SPN_Name": "Occupant Classification System 3 Status",
      "SPN_Description": "State of Occupant Classification System for seat position 3.\r\n\r\n00 = empty\r\n01 = occupied\r\n10 = Error - Classification cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4966": {
      "PGN": 64790,
      "PGN_Name": "Occupant Classification System Information",
      "PGN_Description": "OCSI",
      "first_bit": 10,
      "SPN": 4966,
      "SPN_Name": "Occupant Classification System 4 Status",
      "SPN_Description": "State of Occupant Classification System for seat position 4.\r\n\r\n00 = empty\r\n01 = occupied\r\n10 = Error - Classification cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4967": {
      "PGN": 64790,
      "PGN_Name": "Occupant Classification System Information",
      "PGN_Description": "OCSI",
      "first_bit": 12,
      "SPN": 4967,
      "SPN_Name": "Occupant Classification System 5 Status",
      "SPN_Description": "State of Occupant Classification System for seat position 5.\r\n\r\n00 = empty\r\n01 = occupied\r\n10 = Error - Classification cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4968": {
      "PGN": 64790,
      "PGN_Name": "Occupant Classification System Information",
      "PGN_Description": "OCSI",
      "first_bit": 14,
      "SPN": 4968,
      "SPN_Name": "Occupant Classification System 6 Status",
      "SPN_Description": "State of Occupant Classification System for seat position 6.\r\n\r\n00 = empty\r\n01 = occupied\r\n10 = Error - Classification cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4969": {
      "PGN": 64790,
      "PGN_Name": "Occupant Classification System Information",
      "PGN_Description": "OCSI",
      "first_bit": 16,
      "SPN": 4969,
      "SPN_Name": "Occupant Classification System 7 Status",
      "SPN_Description": "State of Occupant Classification System for seat position 7.\r\n\r\n00 = empty\r\n01 = occupied\r\n10 = Error - Classification cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4970": {
      "PGN": 64790,
      "PGN_Name": "Occupant Classification System Information",
      "PGN_Description": "OCSI",
      "first_bit": 18,
      "SPN": 4970,
      "SPN_Name": "Occupant Classification System 8 Status",
      "SPN_Description": "State of Occupant Classification System for seat position 8.\r\n\r\n00 = empty\r\n01 = occupied\r\n10 = Error - Classification cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4971": {
      "PGN": 64790,
      "PGN_Name": "Occupant Classification System Information",
      "PGN_Description": "OCSI",
      "first_bit": 20,
      "SPN": 4971,
      "SPN_Name": "Occupant Classification System 9 Status",
      "SPN_Description": "State of Occupant Classification System for seat position 9.\r\n\r\n00 = empty\r\n01 = occupied\r\n10 = Error - Classification cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4972": {
      "PGN": 64790,
      "PGN_Name": "Occupant Classification System Information",
      "PGN_Description": "OCSI",
      "first_bit": 22,
      "SPN": 4972,
      "SPN_Name": "Occupant Classification System 10 Status",
      "SPN_Description": "State of Occupant Classification System for seat position 10.\r\n\r\n00 = empty\r\n01 = occupied\r\n10 = Error - Classification cannot be determined\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4973": {
      "PGN": 61483,
      "PGN_Name": "Crash Notification",
      "PGN_Description": "CN",
      "first_bit": 0,
      "SPN": 4973,
      "SPN_Name": "Crash Type",
      "SPN_Description": "Type of crash event. \r\n\r\n00001 = frontal crash\r\n00010 = rear crash\r\n00100 = side crash (left)\r\n01000 = side crash (right)\r\n10000 = rollover\r\n\r\nIt is possible to combine different Crash Types. (e.g. frontal and side crash (left) = 00101)",
      "bit_length": 5,
      "scaling": 5,
      "offset": 0,
      "unit": "bit-mapped",
      "SLOT_ID": 292
    },
    "4974": {
      "PGN": 61483,
      "PGN_Name": "Crash Notification",
      "PGN_Description": "CN",
      "first_bit": 56,
      "SPN": 4974,
      "SPN_Name": "Crash Counter",
      "SPN_Description": "The Crash Counter prevents other ECUs from reacting to a faulty transmission of the Crash Notification PGN and serves as a safety mechanism. The Crash Counter becomes incremented by 1 for every sent message, starting with \"0\". (0 follows 15)",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 220
    },
    "4975": {
      "PGN": 61483,
      "PGN_Name": "Crash Notification",
      "PGN_Description": "CN",
      "first_bit": 60,
      "SPN": 4975,
      "SPN_Name": "Crash Checksum",
      "SPN_Description": "The Crash Checksum is used to verify the signal path from the airbag ECU to other devices in case of a crash.\r\n\r\nThe 4 bit checksum is the sum of the high nibble and the low nibble of the sum of the identifier, the first 7 data bytes and the 4 bit message counter. It is calculated as follows:\r\nChecksum = (Byte1 + Byte2 + Byte3 + Byte4 + Byte5 + Byte6 + Byte7 + (message counter & 0x0F) + message ID low byte + message ID mid low byte + message ID mid high byte + message ID high byte)\r\n\r\nChecksum = ((Checksum >> 4) + Checksum) & 0x0F",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 220
    },
    "4976": {
      "PGN": 61481,
      "PGN_Name": "Slope Sensor Information 2",
      "PGN_Description": "SSI2",
      "first_bit": 0,
      "SPN": 4976,
      "SPN_Name": "Pitch Angle (Extended Range)",
      "SPN_Description": "The angle between the vehicle x-axis and the ground plane (i.e. rotation about the vehicle Y-axis).  The pitch angle for an angle of ascent is reported with a positive value. This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.  See SPN 3318 for an alternate range and resolution.",
      "bit_length": 24,
      "scaling": 0.000030517578125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 294
    },
    "4977": {
      "PGN": 61481,
      "PGN_Name": "Slope Sensor Information 2",
      "PGN_Description": "SSI2",
      "first_bit": 24,
      "SPN": 4977,
      "SPN_Name": "Roll Angle (Extended Range)",
      "SPN_Description": "The angle between the vehicle y-axis and the ground plane (i.e. rotation about the X-axis).  The roll angle for a roll to the right is reported with a positive value. Roll angle is the same for both Z-Down and Z-Up axis systems, since both systems have positive X axis directed forward.  The sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  See SPN 3319 for an alternate range and resolution.",
      "bit_length": 24,
      "scaling": 0.000030517578125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 294
    },
    "4978": {
      "PGN": 61481,
      "PGN_Name": "Slope Sensor Information 2",
      "PGN_Description": "SSI2",
      "first_bit": 48,
      "SPN": 4978,
      "SPN_Name": "Pitch Angle Compensation (Extended Range)",
      "SPN_Description": "Compensated mode for the pitch measurement.  Compensation is the use of multiple sensors together to enhance the output of the pitch measurement.\r\n\r\n00 = On\r\n01 = Off\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4979": {
      "PGN": 61481,
      "PGN_Name": "Slope Sensor Information 2",
      "PGN_Description": "SSI2",
      "first_bit": 50,
      "SPN": 4979,
      "SPN_Name": "Pitch Angle Figure of Merit (Extended Range)",
      "SPN_Description": "Figure of merit for pitch angle measurement.\r\n\r\n00 = Pitch angle fully functional. Data is within sensor specification.\r\n01 = Pitch angle degraded. Data is suspect due to environmental conditions.\r\n10 = Error\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4980": {
      "PGN": 61481,
      "PGN_Name": "Slope Sensor Information 2",
      "PGN_Description": "SSI2",
      "first_bit": 52,
      "SPN": 4980,
      "SPN_Name": "Roll Angle Compensation (Extended Range)",
      "SPN_Description": "Compensated mode for the roll angle measurement.  Compensation is the use of multiple sensors together to enhance the output of the roll angle measurement.\r\n\r\n00 = On\r\n01 = Off\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4981": {
      "PGN": 61481,
      "PGN_Name": "Slope Sensor Information 2",
      "PGN_Description": "SSI2",
      "first_bit": 54,
      "SPN": 4981,
      "SPN_Name": "Roll Angle Figure of Merit (Extended Range)",
      "SPN_Description": "Figure of merit for roll angle measurement.\r\n\r\n00 = Roll angle fully functional. Data is within sensor specification.\r\n01 = Roll angle degraded. Data is suspect due to environmental conditions.\r\n10 = Error\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4982": {
      "PGN": 61481,
      "PGN_Name": "Slope Sensor Information 2",
      "PGN_Description": "SSI2",
      "first_bit": 56,
      "SPN": 4982,
      "SPN_Name": "Roll and Pitch Measurement Latency (Extended Range)",
      "SPN_Description": "Time between start of sensor processing and CAN transmission",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 241
    },
    "4983": {
      "PGN": 61482,
      "PGN_Name": "Angular Rate Information",
      "PGN_Description": "ARI",
      "first_bit": 0,
      "SPN": 4983,
      "SPN_Name": "Pitch Rate (Extended Range)",
      "SPN_Description": "Pitch rate is the rate-of-change of the pitch angle over time, where the pitch angle vector is in the direction of travel of the vehicle. The pitch rate for increasing ascent over time is reported with a positive value. This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.  See SPN 3322 for an alternate range and resolution.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg/s",
      "SLOT_ID": 288
    },
    "4984": {
      "PGN": 61482,
      "PGN_Name": "Angular Rate Information",
      "PGN_Description": "ARI",
      "first_bit": 16,
      "SPN": 4984,
      "SPN_Name": "Roll Rate (Extended Range)",
      "SPN_Description": "Roll rate is the rate-of-change of the roll angle over time.  The roll rate for increasing roll to the right is reported with a positive value. Roll angle is the same for both Z-Down and Z-Up axis systems, since both systems have positive X axis directed forward.  The sign of the value is in accordance to the right-hand rule, as specified in SAE J670.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg/s",
      "SLOT_ID": 288
    },
    "4985": {
      "PGN": 61482,
      "PGN_Name": "Angular Rate Information",
      "PGN_Description": "ARI",
      "first_bit": 32,
      "SPN": 4985,
      "SPN_Name": "Yaw Rate (Extended Range)",
      "SPN_Description": "Yaw rate is the rate-of-change of the yaw angle over time.  A positive yaw rate signal results when the object turns clockwise.  This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.  See SPN 1808 for Yaw Rate with an alternate range and resolution using a Z-Up Axis System.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg/s",
      "SLOT_ID": 288
    },
    "4986": {
      "PGN": 61482,
      "PGN_Name": "Angular Rate Information",
      "PGN_Description": "ARI",
      "first_bit": 48,
      "SPN": 4986,
      "SPN_Name": "Pitch Rate Figure of Merit (Extended Range)",
      "SPN_Description": "Figure of merit for pitch rate measurement.\r\n\r\n00 = Pitch rate fully functional. Data is within sensor specification.\r\n01 = Pitch rate degraded. Data is suspect due to environmental conditions.\r\n10 = Error\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4987": {
      "PGN": 61482,
      "PGN_Name": "Angular Rate Information",
      "PGN_Description": "ARI",
      "first_bit": 50,
      "SPN": 4987,
      "SPN_Name": "Roll Rate Figure of Merit (Extended Range)",
      "SPN_Description": "Figure of merit for roll rate measurement.\r\n\r\n00 = Roll rate fully functional. Data is within sensor specification.\r\n01 = Roll rate degraded. Data is suspect due to environmental conditions.\r\n10 = Error\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4988": {
      "PGN": 61482,
      "PGN_Name": "Angular Rate Information",
      "PGN_Description": "ARI",
      "first_bit": 52,
      "SPN": 4988,
      "SPN_Name": "Yaw Rate Figure of Merit (Extended Range)",
      "SPN_Description": "Figure of merit for yaw angle measurement.\r\n\r\n00 = Yaw rate fully functional. Data is within sensor specification.\r\n01 = Yaw rate degraded. Data is suspect due to environmental conditions.\r\n10 = Error\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4989": {
      "PGN": 61482,
      "PGN_Name": "Angular Rate Information",
      "PGN_Description": "ARI",
      "first_bit": 56,
      "SPN": 4989,
      "SPN_Name": "Angular Rate Measurement Latency",
      "SPN_Description": "The estimated measurement latency of the measurement.\r\n\r\nNOTE: This is only the sensor latency and does not include any additional latencies that might exist because of the CAN Bus or overall system implementation. Latency is the time from sensor readings to the queuing of the message data for CAN transmission.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "ms",
      "SLOT_ID": 241
    },
    "4990": {
      "PGN": 64789,
      "PGN_Name": "Battery Charger 1",
      "PGN_Description": "BCH1",
      "first_bit": 0,
      "SPN": 4990,
      "SPN_Name": "Battery Charger 1 State",
      "SPN_Description": "A state of the battery charger connected to the main battery.  \r\n\r\n0 - Idling. The power line or the battery is disconnected from the charger.\r\n1 - Charging the battery.\r\n2 - Stand-by or maintaining the battery charge.\r\n3 to 12 - Reserved\r\n13 - Battery failure. An error condition due to the battery state (high temperature, etc.)\r\n14 - Charger failure. An error condition due to the charger state.\r\n15 - Not available.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4991": {
      "PGN": 64789,
      "PGN_Name": "Battery Charger 1",
      "PGN_Description": "BCH1",
      "first_bit": 4,
      "SPN": 4991,
      "SPN_Name": "Battery Charger 1 Power Line State",
      "SPN_Description": "A state of the battery charger connection to the power line for the charger connected to the main battery.\r\n\r\n0 - Disconnected. The power line is disconnected from the charger.\r\n1 - Connected. The power line is connected to the charger.\r\n2 - Error\r\n3 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4992": {
      "PGN": 64789,
      "PGN_Name": "Battery Charger 1",
      "PGN_Description": "BCH1",
      "first_bit": 8,
      "SPN": 4992,
      "SPN_Name": "Battery Charger 1 Output Voltage",
      "SPN_Description": "Output voltage measured on the battery terminals of the battery charger connected to the main battery.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "4993": {
      "PGN": 64789,
      "PGN_Name": "Battery Charger 1",
      "PGN_Description": "BCH1",
      "first_bit": 24,
      "SPN": 4993,
      "SPN_Name": "Battery Charger 1 Output Current",
      "SPN_Description": "Output current of the battery charger connected to the main battery. If positive, this parameter shows the charging current of the battery charger connected to the main battery.  Otherwise, if the charger hardware permits, this parameter represents the current consumed by the battery charger ECU from the main battery.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -1600,
      "unit": "A",
      "SLOT_ID": 104
    },
    "4994": {
      "PGN": 64788,
      "PGN_Name": "Battery Charger 2",
      "PGN_Description": "BCH2",
      "first_bit": 0,
      "SPN": 4994,
      "SPN_Name": "Battery Charger 2 State",
      "SPN_Description": "A state of the offline battery charger connected to the auxiliary battery. \r\n\r\n0 - Idling. The power line or the battery is disconnected from the charger.\r\n1 - Charging the battery.\r\n2 - Stand-by or maintaining the battery charge.\r\n3 to 12 - Reserved\r\n13 - Battery failure. An error condition due to the battery state (high temperature, etc.)\r\n14 - Charger failure. An error condition due to the charger state.\r\n15 - Not available.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "4995": {
      "PGN": 64788,
      "PGN_Name": "Battery Charger 2",
      "PGN_Description": "BCH2",
      "first_bit": 4,
      "SPN": 4995,
      "SPN_Name": "Battery Charger 2 Power Line State",
      "SPN_Description": "A state of the battery charger connection to the power line for the charger connected to the auxiliary battery.\r\n\r\n0 - Disconnected. The power line is disconnected from the charger.\r\n1 - Connected. The power line is connected to the charger.\r\n2 - Error\r\n3 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "4996": {
      "PGN": 64788,
      "PGN_Name": "Battery Charger 2",
      "PGN_Description": "BCH2",
      "first_bit": 8,
      "SPN": 4996,
      "SPN_Name": "Battery Charger 2 Output Voltage",
      "SPN_Description": "Output voltage measured on the battery terminals of the offline battery charger connected to the auxiliary battery.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "4997": {
      "PGN": 64788,
      "PGN_Name": "Battery Charger 2",
      "PGN_Description": "BCH2",
      "first_bit": 24,
      "SPN": 4997,
      "SPN_Name": "Battery Charger 2 Output Current",
      "SPN_Description": "Output current of the battery charger connected to the main battery. If positive, this parameter shows the charging current of the battery charger connected to the main battery.  Otherwise, if the charger hardware permits, this parameter represents the current consumed by the battery charger ECU from the main battery.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -1600,
      "unit": "A",
      "SLOT_ID": 104
    },
    "4998": {
      "PGN": 64787,
      "PGN_Name": "Magnet System Configuration Information",
      "PGN_Description": "MSCI",
      "first_bit": 0,
      "SPN": 4998,
      "SPN_Name": "Magnet Boost Time",
      "SPN_Description": "The duration of time after the activation of the magnet circuit that a relatively high current is sent to the magnet for material pick up operations. This time is called boost time. After the boost time expires, a lower operation current is sent to the magnet to hold the material.",
      "bit_length": 8,
      "scaling": 0.25,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 63
    },
    "4999": {
      "PGN": 64787,
      "PGN_Name": "Magnet System Configuration Information",
      "PGN_Description": "MSCI",
      "first_bit": 8,
      "SPN": 4999,
      "SPN_Name": "Magnet Rated Power",
      "SPN_Description": "The rated power that the magnet can accept during material holding operations.  Note that the magnet may experience more power over short intervals, such as during initial activation of the magnet circuit to pick up material.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kW",
      "SLOT_ID": 55
    },
    "5000": {
      "PGN": 64786,
      "PGN_Name": "Magnet Status Information 1",
      "PGN_Description": "MSI1",
      "first_bit": 0,
      "SPN": 5000,
      "SPN_Name": "Generator Overheat Status",
      "SPN_Description": "The Status of Generator being Overheated.\r\n\r\n00 = Not Overheat\r\n01 = Overheat\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5001": {
      "PGN": 64786,
      "PGN_Name": "Magnet Status Information 1",
      "PGN_Description": "MSI1",
      "first_bit": 2,
      "SPN": 5001,
      "SPN_Name": "Genset System Output Voltage Range Status",
      "SPN_Description": "Status of generator voltage in or out of desired operating range.\r\n\r\n00 = Out of Range \r\n01 = In Range\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5002": {
      "PGN": 64786,
      "PGN_Name": "Magnet Status Information 1",
      "PGN_Description": "MSI1",
      "first_bit": 8,
      "SPN": 5002,
      "SPN_Name": "Reverse Current Range Setting",
      "SPN_Description": "The operator setting for the Reverse Current. The setting defines the maximum reverse current. The actual current limits are specific to the application.\r\n\r\n00000 = 1\r\n00001 = 2\r\n00010 = 3\r\n00011 = 4\r\n00100 = 5\r\n00101 = 6\r\n00110 = 7\r\n00111 = 8\r\n01000 = 9\r\n01001 = 10\r\n01010 =11\r\n01011 =12\r\n01100 = 13\r\n01101 = 14\r\n01110 = 15\r\n01111 = 16\r\n10000-11101 = Not used\r\n11110 = Error\r\n11111 = Not Available",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 90
    },
    "5003": {
      "PGN": 64786,
      "PGN_Name": "Magnet Status Information 1",
      "PGN_Description": "MSI1",
      "first_bit": 4,
      "SPN": 5003,
      "SPN_Name": "Grapple/Magnet Selection Switch",
      "SPN_Description": "This is a switch that can be used to select either the Grapple or Magnet function of the material handler machine.\r\n\r\n00 = Grapple Selected\r\n01 = Magnet Selected\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5004": {
      "PGN": 64786,
      "PGN_Name": "Magnet Status Information 1",
      "PGN_Description": "MSI1",
      "first_bit": 6,
      "SPN": 5004,
      "SPN_Name": "Genset Softstart Active Status",
      "SPN_Description": "The Genset Softstart Active Status refers to the status of the genset softstart relay. The moment the Genset System is started, this relay is activated. As a result, the hydraulic power is hold on for a short period of time, and this relay will be turned off once the genset hydraulic power become stable.\r\n\r\n00 = Off\r\n01 = On\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5005": {
      "PGN": 64786,
      "PGN_Name": "Magnet Status Information 1",
      "PGN_Description": "MSI1",
      "first_bit": 16,
      "SPN": 5005,
      "SPN_Name": "Genset Enable Active Status",
      "SPN_Description": "Status of the Genset Enable Relay that enables or disables the Genset.\r\n\r\n00 = Not Enabled\r\n01 = Enabled\r\n10 = Error\r\n11 = Not Avaialble",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5006": {
      "PGN": 64786,
      "PGN_Name": "Magnet Status Information 1",
      "PGN_Description": "MSI1",
      "first_bit": 18,
      "SPN": 5006,
      "SPN_Name": "Voltage Monitor Active Status",
      "SPN_Description": "Status of Voltage Monitor Relay. When it is activated, the Generator Voltage Monitor is connected to the generator output line so that the generator output voltage range could be monitored.\r\n\r\n00 = Monitor is Off\r\n01 = Monitor is On\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5007": {
      "PGN": 64786,
      "PGN_Name": "Magnet Status Information 1",
      "PGN_Description": "MSI1",
      "first_bit": 20,
      "SPN": 5007,
      "SPN_Name": "Generator Duty Cycle Exceeded Status",
      "SPN_Description": "The status of the duty cycle of the generator usage, indicating if the generator has been on for too much time within a defined time window.  The duty cycle is the ratio of the time the generator is on and the time the generator is off within a time window.\r\n\r\n00 = Duty Cycle Not Exceed\r\n01 = Duty Cycle Exceed\r\n10 = Error\r\n11 = Not Avaiable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5008": {
      "PGN": 61484,
      "PGN_Name": "Magnet Status Information 2",
      "PGN_Description": "MSI2",
      "first_bit": 0,
      "SPN": 5008,
      "SPN_Name": "Magnet Forward Current",
      "SPN_Description": "The forward current being supplied by the generator to the electric magnet to create a magnet field to lift material.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 146
    },
    "5009": {
      "PGN": 61484,
      "PGN_Name": "Magnet Status Information 2",
      "PGN_Description": "MSI2",
      "first_bit": 16,
      "SPN": 5009,
      "SPN_Name": "Magnet Reverse Current",
      "SPN_Description": "A reverse current being supplied to the electric magnet to reduce the forward current generated magnet field as quick as possible so that the magnet can release material as fast as possible.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 41
    },
    "5010": {
      "PGN": 61484,
      "PGN_Name": "Magnet Status Information 2",
      "PGN_Description": "MSI2",
      "first_bit": 24,
      "SPN": 5010,
      "SPN_Name": "Material Lift Switch",
      "SPN_Description": "This is a switch that can be used to enable the lift functionality of the Material Handler machine. When it is activated, the magnet is energized to pick up material.\r\n\r\n00 = Don't Lift\r\n01 = Lift\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5011": {
      "PGN": 61484,
      "PGN_Name": "Magnet Status Information 2",
      "PGN_Description": "MSI2",
      "first_bit": 26,
      "SPN": 5011,
      "SPN_Name": "Material Drop Switch",
      "SPN_Description": "This is a switch that can be used to enable the drop functionality of the Material Handler machine.\r\n\r\n00 = Don't Drop\r\n01 = Drop\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5012": {
      "PGN": 61484,
      "PGN_Name": "Magnet Status Information 2",
      "PGN_Description": "MSI2",
      "first_bit": 28,
      "SPN": 5012,
      "SPN_Name": "Generator Current Boost Active Status",
      "SPN_Description": "Status of generator current boost relay that can boost the generator output current for picking-up material operations. When this relay is \"on\", the generator is generating the maximum current for the material handler machine to pick-up material. When the relay is off, the genetator is generating normal current for the material handler machine to hold material.\r\n\r\n00 = Off\r\n01 = On\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5013": {
      "PGN": 61484,
      "PGN_Name": "Magnet Status Information 2",
      "PGN_Description": "MSI2",
      "first_bit": 30,
      "SPN": 5013,
      "SPN_Name": "Material Lift Active Status",
      "SPN_Description": "The status of Material Lift Relay. When it is on, the generator generates forward direction current so that the material handler machine can pick up material.\r\n\r\n00 = Off\r\n01 = On\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5014": {
      "PGN": 61484,
      "PGN_Name": "Magnet Status Information 2",
      "PGN_Description": "MSI2",
      "first_bit": 32,
      "SPN": 5014,
      "SPN_Name": "Material Drop Active Status",
      "SPN_Description": "The status of Material Drop Relay. When it is on, the generator generates reverse direction current so that the material handler machine can release material.\r\n\r\n00 = Off\r\n01 = On\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5015": {
      "PGN": 61442,
      "PGN_Name": "Electronic Transmission Controller 1",
      "PGN_Description": "ETC1",
      "first_bit": 36,
      "SPN": 5015,
      "SPN_Name": "Momentary Engine Maximum Power Enable",
      "SPN_Description": "Momentarily Requesting highest torque map from the engine control\r\n\r\n00 not requesting maximum power available\r\n01 momentarily requesting maximum power available\r\n10 fault\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5019": {
      "PGN": 64961,
      "PGN_Name": "Engine Fluid Level/Pressure 3",
      "PGN_Description": "EFL/P3",
      "first_bit": 40,
      "SPN": 5019,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Outlet Pressure",
      "SPN_Description": "EGR outlet pressure is measured immediately after the EGR valve.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "5020": {
      "PGN": 64870,
      "PGN_Name": "Engine Temperature 4",
      "PGN_Description": "ET4",
      "first_bit": 40,
      "SPN": 5020,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Mixer Intake Temperature",
      "SPN_Description": "The temperature of the EGR gas entering the intake mixer, measured after the intake throttle when provided.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5021": {
      "PGN": 61443,
      "PGN_Name": "Electronic Engine Controller 2",
      "PGN_Description": "EEC2",
      "first_bit": 42,
      "SPN": 5021,
      "SPN_Name": "Momentary Engine Maximum Power Enable Feedback",
      "SPN_Description": "Momentarily requesting Engine Maximum Power Enable - feature support feedback\r\n\r\n00 disabled\r\n01 supported \r\n10 reserved\r\n11 don't care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5022": {
      "PGN": 65135,
      "PGN_Name": "Adaptive Cruise Control 1",
      "PGN_Description": "ACC1",
      "first_bit": 54,
      "SPN": 5022,
      "SPN_Name": "Forward Collision Warning",
      "SPN_Description": "This parameter indicates if a collision is imminent and strong driver reaction either by braking hard or by an avoidance maneuver are imperative to prevent a collision.  \r\n\r\n00 No warning\r\n01 Collision is imminent\r\n10 Error indicator\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5023": {
      "PGN": 65105,
      "PGN_Name": "Adaptive Cruise Control, Operator Input",
      "PGN_Description": "ACC2",
      "first_bit": 0,
      "SPN": 5023,
      "SPN_Name": "ACC usage demand",
      "SPN_Description": "This parameter indicates the drivers demand to activate or deactivate ACC keeping distance control.\r\n\r\n00 driver demand for not using ACC distance keeping control\r\n01 driver demand for using ACC distance keeping control\r\n10 reserved\r\n11 don't care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5024": {
      "PGN": 64785,
      "PGN_Name": "Aftertreatment 1 Intake Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT1IGC1",
      "first_bit": 0,
      "SPN": 5024,
      "SPN_Name": "Aftertreatment 1 Intake NOx Sensor Heater Ratio",
      "SPN_Description": "Heater ratio to determine temperature at sensor tip.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 32
    },
    "5025": {
      "PGN": 64785,
      "PGN_Name": "Aftertreatment 1 Intake Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT1IGC1",
      "first_bit": 16,
      "SPN": 5025,
      "SPN_Name": "Aftertreatment 1 Intake NOx Sensor New part deviation NOx Gain",
      "SPN_Description": "New part deviation NOx_Gain to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -100,
      "unit": "%",
      "SLOT_ID": 295
    },
    "5026": {
      "PGN": 64785,
      "PGN_Name": "Aftertreatment 1 Intake Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT1IGC1",
      "first_bit": 32,
      "SPN": 5026,
      "SPN_Name": "Aftertreatment 1 Intake NOx Sensor New part deviation NOx Offset",
      "SPN_Description": "New part deviation NOx_Offset to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "ppm",
      "SLOT_ID": 296
    },
    "5027": {
      "PGN": 64784,
      "PGN_Name": "Aftertreatment 1 Intake Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT1IGC2",
      "first_bit": 0,
      "SPN": 5027,
      "SPN_Name": "Aftertreatment 1 Intake NOx Sensor O2 Pressure Correction",
      "SPN_Description": "Correction of pressure Lambda-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%/bar",
      "SLOT_ID": 298
    },
    "5028": {
      "PGN": 64784,
      "PGN_Name": "Aftertreatment 1 Intake Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT1IGC2",
      "first_bit": 8,
      "SPN": 5028,
      "SPN_Name": "Aftertreatment 1 Intake NOx Sensor NOx Pressure Correction",
      "SPN_Description": "Correction of pressure NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%/bar",
      "SLOT_ID": 298
    },
    "5029": {
      "PGN": 64784,
      "PGN_Name": "Aftertreatment 1 Intake Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT1IGC2",
      "first_bit": 16,
      "SPN": 5029,
      "SPN_Name": "Aftertreatment 1 Intake NOx Sensor NO2 Correction",
      "SPN_Description": "Correction of NO2 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "5030": {
      "PGN": 64784,
      "PGN_Name": "Aftertreatment 1 Intake Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT1IGC2",
      "first_bit": 24,
      "SPN": 5030,
      "SPN_Name": "Aftertreatment 1 Intake NOx Sensor NH3 Correction",
      "SPN_Description": "Correction of NH3 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "5031": {
      "PGN": 64783,
      "PGN_Name": "Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT1OGC1",
      "first_bit": 0,
      "SPN": 5031,
      "SPN_Name": "Aftertreatment 1 Outlet NOx Sensor Heater Ratio",
      "SPN_Description": "Heater ratio to determine temperature at sensor tip.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 32
    },
    "5032": {
      "PGN": 64783,
      "PGN_Name": "Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT1OGC1",
      "first_bit": 16,
      "SPN": 5032,
      "SPN_Name": "Aftertreatment 1 Outlet NOx Sensor New part deviation NOx Gain",
      "SPN_Description": "New part deviation NOx_Gain to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -100,
      "unit": "%",
      "SLOT_ID": 295
    },
    "5033": {
      "PGN": 64783,
      "PGN_Name": "Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT1OGC1",
      "first_bit": 32,
      "SPN": 5033,
      "SPN_Name": "Aftertreatment 1 Outlet NOx Sensor New part deviation NOx Offset",
      "SPN_Description": "New part deviation NOx_Offset to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "ppm",
      "SLOT_ID": 296
    },
    "5034": {
      "PGN": 64782,
      "PGN_Name": "Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT1OGC2",
      "first_bit": 0,
      "SPN": 5034,
      "SPN_Name": "Aftertreatment 1 Outlet NOx Sensor O2 Pressure Correction",
      "SPN_Description": "Correction of pressure Lambda-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%/bar",
      "SLOT_ID": 298
    },
    "5035": {
      "PGN": 64782,
      "PGN_Name": "Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT1OGC2",
      "first_bit": 8,
      "SPN": 5035,
      "SPN_Name": "Aftertreatment 1 Outlet NOx Sensor NOx Pressure Correction",
      "SPN_Description": "Correction of pressure NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%/bar",
      "SLOT_ID": 298
    },
    "5036": {
      "PGN": 64782,
      "PGN_Name": "Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT1OGC2",
      "first_bit": 16,
      "SPN": 5036,
      "SPN_Name": "Aftertreatment 1 Outlet NOx Sensor NO2 Correction",
      "SPN_Description": "Correction of NO2 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "5037": {
      "PGN": 64782,
      "PGN_Name": "Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT1OGC2",
      "first_bit": 24,
      "SPN": 5037,
      "SPN_Name": "Aftertreatment 1 Outlet NOx Sensor NH3 Correction",
      "SPN_Description": "Correction of NH3 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "5038": {
      "PGN": 64781,
      "PGN_Name": "Aftertreatment 2 Intake Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT2IGC1",
      "first_bit": 0,
      "SPN": 5038,
      "SPN_Name": "Aftertreatment 2 Intake NOx Sensor Heater Ratio",
      "SPN_Description": "Heater ratio to determine temperature at sensor tip.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 32
    },
    "5039": {
      "PGN": 64781,
      "PGN_Name": "Aftertreatment 2 Intake Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT2IGC1",
      "first_bit": 16,
      "SPN": 5039,
      "SPN_Name": "Aftertreatment 2 Intake NOx Sensor New part deviation NOx Gain",
      "SPN_Description": "New part deviation NOx_Gain to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -100,
      "unit": "%",
      "SLOT_ID": 295
    },
    "5040": {
      "PGN": 64781,
      "PGN_Name": "Aftertreatment 2 Intake Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT2IGC1",
      "first_bit": 32,
      "SPN": 5040,
      "SPN_Name": "Aftertreatment 2 Intake NOx Sensor New part deviation NOx Offset",
      "SPN_Description": "New part deviation NOx_Offset to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "ppm",
      "SLOT_ID": 296
    },
    "5041": {
      "PGN": 64780,
      "PGN_Name": "Aftertreatment 2 Intake Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT2IGC2",
      "first_bit": 0,
      "SPN": 5041,
      "SPN_Name": "Aftertreatment 2 Intake NOx Sensor O2 Pressure Correction",
      "SPN_Description": "Correction of pressure Lambda-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%/bar",
      "SLOT_ID": 298
    },
    "5042": {
      "PGN": 64780,
      "PGN_Name": "Aftertreatment 2 Intake Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT2IGC2",
      "first_bit": 8,
      "SPN": 5042,
      "SPN_Name": "Aftertreatment 2 Intake NOx Sensor NOx Pressure Correction",
      "SPN_Description": "Correction of pressure NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%/bar",
      "SLOT_ID": 298
    },
    "5043": {
      "PGN": 64780,
      "PGN_Name": "Aftertreatment 2 Intake Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT2IGC2",
      "first_bit": 16,
      "SPN": 5043,
      "SPN_Name": "Aftertreatment 2 Intake NOx Sensor NO2 Correction",
      "SPN_Description": "Correction of NO2 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "5044": {
      "PGN": 64780,
      "PGN_Name": "Aftertreatment 2 Intake Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT2IGC2",
      "first_bit": 24,
      "SPN": 5044,
      "SPN_Name": "Aftertreatment 2 Intake NOx Sensor NH3 Correction",
      "SPN_Description": "Correction of NH3 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "5045": {
      "PGN": 64779,
      "PGN_Name": "Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT2OGC1",
      "first_bit": 0,
      "SPN": 5045,
      "SPN_Name": "Aftertreatment 2 Outlet NOx Sensor Heater Ratio",
      "SPN_Description": "Heater ratio to determine temperature at sensor tip.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 32
    },
    "5046": {
      "PGN": 64779,
      "PGN_Name": "Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT2OGC1",
      "first_bit": 16,
      "SPN": 5046,
      "SPN_Name": "Aftertreatment 2 Outlet NOx Sensor New part deviation NOx Gain",
      "SPN_Description": "New part deviation NOx_Gain to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -100,
      "unit": "%",
      "SLOT_ID": 295
    },
    "5047": {
      "PGN": 64779,
      "PGN_Name": "Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT2OGC1",
      "first_bit": 32,
      "SPN": 5047,
      "SPN_Name": "Aftertreatment 2 Outlet NOx Sensor New part deviation NOx Offset",
      "SPN_Description": "New part deviation NOx_Offset to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "ppm",
      "SLOT_ID": 296
    },
    "5048": {
      "PGN": 64778,
      "PGN_Name": "Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT2OGC2",
      "first_bit": 0,
      "SPN": 5048,
      "SPN_Name": "Aftertreatment 2 Outlet NOx Sensor O2 Pressure Correction",
      "SPN_Description": "Correction of pressure Lambda-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%/bar",
      "SLOT_ID": 298
    },
    "5049": {
      "PGN": 64778,
      "PGN_Name": "Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT2OGC2",
      "first_bit": 8,
      "SPN": 5049,
      "SPN_Name": "Aftertreatment 2 Outlet NOx Sensor NOx Pressure Correction",
      "SPN_Description": "Correction of pressure NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%/bar",
      "SLOT_ID": 298
    },
    "5050": {
      "PGN": 64778,
      "PGN_Name": "Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT2OGC2",
      "first_bit": 16,
      "SPN": 5050,
      "SPN_Name": "Aftertreatment 2 Outlet NOx Sensor NO2 Correction",
      "SPN_Description": "Correction of NO2 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "5051": {
      "PGN": 64778,
      "PGN_Name": "Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT2OGC2",
      "first_bit": 24,
      "SPN": 5051,
      "SPN_Name": "Aftertreatment 2 Outlet NOx Sensor NH3 Correction",
      "SPN_Description": "Correction of NH3 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "5052": {
      "PGN": 61452,
      "PGN_Name": "Electronic Transmission Controller #8",
      "PGN_Description": "ETC8",
      "first_bit": 16,
      "SPN": 5052,
      "SPN_Name": "Transmission Clutch/Converter Input Speed",
      "SPN_Description": "Rotational velocity of the input to a transmission's master clutch or torque converter. In most cases the rotational velocity will be the same as engine flywheel speed unless there is an intermediate device, such as a power divider, between the engine and the clutch/converter.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "5053": {
      "PGN": 64777,
      "PGN_Name": "High Resolution Fuel Consumption (Liquid)",
      "PGN_Description": "HRLFC",
      "first_bit": 0,
      "SPN": 5053,
      "SPN_Name": "Engine Trip Fuel (High Resolution)",
      "SPN_Description": "Fuel consumed during all or part of a journey.   High resolution used for calculations and fleet management systems.  See SPN 182 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.001,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 300
    },
    "5054": {
      "PGN": 64777,
      "PGN_Name": "High Resolution Fuel Consumption (Liquid)",
      "PGN_Description": "HRLFC",
      "first_bit": 32,
      "SPN": 5054,
      "SPN_Name": "Engine Total Fuel Used (High Resolution)",
      "SPN_Description": "Accumulated amount of fuel used during vehicle operation.  High resolution used for calculations and fleet management systems.  See SPN 250 for alternate resolution.",
      "bit_length": 32,
      "scaling": 0.001,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 300
    },
    "5055": {
      "PGN": 64776,
      "PGN_Name": "Engine oil message",
      "PGN_Description": "EOM",
      "first_bit": 0,
      "SPN": 5055,
      "SPN_Name": "Engine Oil Viscosity",
      "SPN_Description": "Dynamic viscosity of the engine oil",
      "bit_length": 16,
      "scaling": 0.015625,
      "offset": 0,
      "unit": "Cp",
      "SLOT_ID": 301
    },
    "5056": {
      "PGN": 64776,
      "PGN_Name": "Engine oil message",
      "PGN_Description": "EOM",
      "first_bit": 16,
      "SPN": 5056,
      "SPN_Name": "Engine Oil Density",
      "SPN_Description": "Density of the engine oil",
      "bit_length": 16,
      "scaling": 0.00003052,
      "offset": 0,
      "unit": "g/cc",
      "SLOT_ID": 302
    },
    "5057": {
      "PGN": 38912,
      "PGN_Name": "Noise Control 1",
      "PGN_Description": "NC1",
      "first_bit": 0,
      "SPN": 5057,
      "SPN_Name": "Cab Noise Control Command",
      "SPN_Description": "Command signal to change the state of the Cab Noise Control System to on-line or off-line\r\n\r\n00 - Take Cab Noise Control System Off Line\r\n01 - Bring Cab Noise Control System On Line\r\n10 - Reserved\r\n11 - Don't Care/Not Commanded",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5058": {
      "PGN": 38912,
      "PGN_Name": "Noise Control 1",
      "PGN_Description": "NC1",
      "first_bit": 2,
      "SPN": 5058,
      "SPN_Name": "Cab Noise Control Tuning Command",
      "SPN_Description": "Command values for the Tuning State of the Cab Noise Control System.  The Tuning State allows the Cab Noise Control System to adjust certain system characteristics (e.g. to account for microphone or speaker degradation over time). \r\n\r\n000 - Activate Manual Tuning, Wait for Save and Exit Commands\r\n001 - Activate Automatic Tuning, Wait for Save and Exit Commands\r\n010 - Activate Automatic Tuning State, Saving Parameters, Exit on Completion\r\n011 - Remain In Tuning, Save Current Parameters\r\n100 - Exit Tuning, Not Saving Parameters\r\n101 - Exit Tuning, Saving Parameters\r\n110 - Reserved\r\n111 - Don't Care, NOT Commanded",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5059": {
      "PGN": 38656,
      "PGN_Name": "Noise Control Status",
      "PGN_Description": "NCS",
      "first_bit": 0,
      "SPN": 5059,
      "SPN_Name": "Cab Noise Control Status",
      "SPN_Description": "This parameter returns the current status of the Cab Noise Control system.\r\n\r\n00 - Cab Noise Control System ON-Line\r\n01 - Cab Noise Control System OFF-Line\r\n10 - Error Indicator\r\n11 - Not Available/Not Requested",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5060": {
      "PGN": 38656,
      "PGN_Name": "Noise Control Status",
      "PGN_Description": "NCS",
      "first_bit": 2,
      "SPN": 5060,
      "SPN_Name": "Cab Noise Control Tuning Status",
      "SPN_Description": "This parameter returns the current status of tuning function of the Cab Noise Control system.    When the tuning state is active, the Cab Noise Control System adjusts certain system characteristics (e.g. to account for sensor and/or transducer degradation over time). This adjustment may be automatic or under manual control.\r\n\r\n0000 – Manual Tuning Mode\r\n0001 – Manual Tuning Mode – Command Complete\r\n0010 – Manual Tuning Mode – Saving Data\r\n0011 – Reserved\r\n0100 – Reserved \r\n0101 – Reserved\r\n0110 – Reserved\r\n0111 – Manual Tuning Denied – Requires Security Verification\r\n1000 – Automatic Tuning Mode\r\n1001 – Automatic Tuning Mode – Command Complete\r\n1010 – Automatic Tuning Mode – Saving Data\r\n1011 – Reserved \r\n1100 – Reserved\r\n1101 – Reserved\r\n1110 – Tuning Mode – Error\r\n1111 – Not Available/Not Tuning/Not Requested",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5077": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 0,
      "SPN": 5077,
      "SPN_Name": "Engine Protect Lamp Command",
      "SPN_Description": "Command signal directly controlling the Engine Protect Lamp\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available\r\n\r\nNote:  SPN 987 should be used for reporting diagnostics of the Engine Protect Lamp.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5078": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 2,
      "SPN": 5078,
      "SPN_Name": "Engine Amber Warning Lamp Command",
      "SPN_Description": "Command signal directly controlling the Engine Amber Warning Lamp\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available\r\n\r\nNote:  SPN 624 should be used for reporting diagnostics of the Engine Amber Warning Lamp.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5079": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 4,
      "SPN": 5079,
      "SPN_Name": "Engine Red Stop Lamp Command",
      "SPN_Description": "Command signal directly controlling the Engine Red Stop Lamp\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available\r\n\r\nNote:  SPN 623 should be used for reporting diagnostics of the Engine Red Stop Lamp.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5080": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 6,
      "SPN": 5080,
      "SPN_Name": "OBD Malfunction Indicator Lamp Command",
      "SPN_Description": "Command signal directly controlling the OBD Malfunction Indicator Lamp\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available\r\n\r\nNote:  SPN 1213 should be used for reporting diagnostics of the OBD Malfunction Indicator Lamp.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5081": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 8,
      "SPN": 5081,
      "SPN_Name": "Engine Brake Active Lamp Command",
      "SPN_Description": "Command signal directly controlling the Engine Brake Active Lamp. This is used for engine based retarders.\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5082": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 12,
      "SPN": 5082,
      "SPN_Name": "Engine Oil Pressure Low Lamp Command",
      "SPN_Description": "Command signal directly controlling the Engine Oil Pressure Low Lamp\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5083": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 14,
      "SPN": 5083,
      "SPN_Name": "Engine Coolant Temperature High Lamp Command",
      "SPN_Description": "Command signal directly controlling the Engine Coolant Temperature High Lamp\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5084": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 16,
      "SPN": 5084,
      "SPN_Name": "Engine Coolant Level Low Lamp Command",
      "SPN_Description": "Command signal directly controlling the Engine Coolant Level Low Lamp\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5085": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 18,
      "SPN": 5085,
      "SPN_Name": "Engine Idle Management Active Lamp Command",
      "SPN_Description": "Command signal directly controlling the Engine Idle Management Active Lamp\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available\r\n\r\nNote:  SPN 1661 should be used for reporting diagnostics of the Engine Idle Management Active Lamp.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5086": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 20,
      "SPN": 5086,
      "SPN_Name": "Engine Air Filter Restriction Lamp Command",
      "SPN_Description": "Command signal directly controlling the Engine Air Filter Restriction Lamp.\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5087": {
      "PGN": 64774,
      "PGN_Name": "Direct Lamp Control Command 2",
      "PGN_Description": "DLCC2",
      "first_bit": 0,
      "SPN": 5087,
      "SPN_Name": "Vehicle Battery Voltage Low Lamp Command",
      "SPN_Description": "Command signal directly controlling the Vehicle Battery Voltage Low Lamp.\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5088": {
      "PGN": 64774,
      "PGN_Name": "Direct Lamp Control Command 2",
      "PGN_Description": "DLCC2",
      "first_bit": 2,
      "SPN": 5088,
      "SPN_Name": "Vehicle Fuel Level Low Lamp Command",
      "SPN_Description": "Command signal directly controlling the Vehicle Fuel Level Low Lamp.\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5089": {
      "PGN": 64774,
      "PGN_Name": "Direct Lamp Control Command 2",
      "PGN_Description": "DLCC2",
      "first_bit": 4,
      "SPN": 5089,
      "SPN_Name": "Vehicle Air Pressure Low Lamp Command",
      "SPN_Description": "Command signal directly controlling the Vehicle Air Pressure Low Lamp.\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5090": {
      "PGN": 64774,
      "PGN_Name": "Direct Lamp Control Command 2",
      "PGN_Description": "DLCC2",
      "first_bit": 6,
      "SPN": 5090,
      "SPN_Name": "Vehicle HVAC Recirculation Lamp Command",
      "SPN_Description": "Command signal directly controlling the Vehicle HVAC Recirculation Lamp.\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5091": {
      "PGN": 64774,
      "PGN_Name": "Direct Lamp Control Command 2",
      "PGN_Description": "DLCC2",
      "first_bit": 8,
      "SPN": 5091,
      "SPN_Name": "Vehicle Battery Charging Lamp Command",
      "SPN_Description": "Command signal directly controlling the Vehicle Battery Charging Lamp.\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5093": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 0,
      "SPN": 5093,
      "SPN_Name": "Engine Protect Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Protect Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5094": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 2,
      "SPN": 5094,
      "SPN_Name": "Engine Amber Warning Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Amber Warning Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5095": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 4,
      "SPN": 5095,
      "SPN_Name": "Engine Red Stop Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Red Stop Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5096": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 6,
      "SPN": 5096,
      "SPN_Name": "OBD Malfunction Indicator Lamp Data",
      "SPN_Description": "This parameter provides measured data from the OBD Malfunction Indicator Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5097": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 8,
      "SPN": 5097,
      "SPN_Name": "Engine Brake Active Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Brake Active Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5098": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 10,
      "SPN": 5098,
      "SPN_Name": "Compression Brake Enable Switch Indicator Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Compression Brake Enable Switch Indicator Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5099": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 12,
      "SPN": 5099,
      "SPN_Name": "Engine Oil Pressure Low Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Oil Pressure Low Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5100": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 14,
      "SPN": 5100,
      "SPN_Name": "Engine Coolant Temperature High Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Coolant Temperature High Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5101": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 16,
      "SPN": 5101,
      "SPN_Name": "Engine Coolant Level Low Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Coolant Level Low Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5102": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 18,
      "SPN": 5102,
      "SPN_Name": "Engine Idle Management Active Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Idle Management Active Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5103": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 20,
      "SPN": 5103,
      "SPN_Name": "Engine Air Filter Restriction Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Air Filter Restriction Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5104": {
      "PGN": 64772,
      "PGN_Name": "Direct Lamp Control Data 2",
      "PGN_Description": "DLCD2",
      "first_bit": 0,
      "SPN": 5104,
      "SPN_Name": "Vehicle Battery Voltage Low Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Vehicle Battery Voltage Low Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5105": {
      "PGN": 64772,
      "PGN_Name": "Direct Lamp Control Data 2",
      "PGN_Description": "DLCD2",
      "first_bit": 2,
      "SPN": 5105,
      "SPN_Name": "Vehicle Fuel Level Low Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Vehicle Fuel Level Low Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5106": {
      "PGN": 64772,
      "PGN_Name": "Direct Lamp Control Data 2",
      "PGN_Description": "DLCD2",
      "first_bit": 4,
      "SPN": 5106,
      "SPN_Name": "Vehicle Air Pressure Low Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Vehicle Air Pressure Low Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5107": {
      "PGN": 64772,
      "PGN_Name": "Direct Lamp Control Data 2",
      "PGN_Description": "DLCD2",
      "first_bit": 6,
      "SPN": 5107,
      "SPN_Name": "Vehicle HVAC Recirculation Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Vehicle HVAC Recirculation Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5108": {
      "PGN": 64772,
      "PGN_Name": "Direct Lamp Control Data 2",
      "PGN_Description": "DLCD2",
      "first_bit": 8,
      "SPN": 5108,
      "SPN_Name": "Vehicle Battery Charging Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Vehicle Battery Charging Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5125": {
      "PGN": 64924,
      "PGN_Name": "Sensor Electrical Power #2",
      "PGN_Description": "SEP2",
      "first_bit": 32,
      "SPN": 5125,
      "SPN_Name": "Sensor supply voltage 7",
      "SPN_Description": "Sensor ECU supply voltage 7",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "5126": {
      "PGN": 64924,
      "PGN_Name": "Sensor Electrical Power #2",
      "PGN_Description": "SEP2",
      "first_bit": 48,
      "SPN": 5126,
      "SPN_Name": "Sensor supply voltage 8",
      "SPN_Description": "Sensor ECU supply voltage 8",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "5137": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 16,
      "SPN": 5137,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank Heater Command",
      "SPN_Description": "Command for the Aftertreatment 1 Diesel Exhaust Fluid Tank Heater.  A value of 0% means no heating applied, a value of 100% means full heating applied.  See SPN 3363 for the measured value of the Aftertreatment 1 Diesel Exhaust Fluid Tank Heater.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5138": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 16,
      "SPN": 5138,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank Heater Command",
      "SPN_Description": "Command for the Aftertreatment 2 Diesel Exhaust Fluid Tank Heater.  A value of 0% means no heating applied, a value of 100% means full heating applied.  See SPN 4431 for the measured value of the Aftertreatment 2 Diesel Exhaust Fluid Tank Heater.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5141": {
      "PGN": 64769,
      "PGN_Name": "Low Voltage Disconnect  Status",
      "PGN_Description": "LVDS",
      "first_bit": 0,
      "SPN": 5141,
      "SPN_Name": "Low Voltage Disconnect Manual Disconnect State",
      "SPN_Description": "State of the Manual Disconnect hardwired input to the LVD.  Manual Disconnect is used to override the LVD's normal activlty and dicconnect all of the LVD outputs.  Manual Disconnect is lower in priority than the Manual Connect hardwired input, but has priority over all LVD Set Operating Mode messages.\r\n\r\n00 - Input off\r\n01 - Input on\r\n10 - Error\r\n11 - Not installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5142": {
      "PGN": 64769,
      "PGN_Name": "Low Voltage Disconnect  Status",
      "PGN_Description": "LVDS",
      "first_bit": 2,
      "SPN": 5142,
      "SPN_Name": "Low Voltage Disconnect Manual Connect State",
      "SPN_Description": "State of the Manual Connect hardwired input to the LVD.  Manual Connect is used to override the LVD's normal activlty and connect all of the LVD outputs.  Manual Connect has priority over the Manual Dicsonnect hardwired input and all LVD Set Operating Mode messages.\r\n\r\n00 - Input off\r\n01 - Input on\r\n10 - Error\r\n11 - Not installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5143": {
      "PGN": 64769,
      "PGN_Name": "Low Voltage Disconnect  Status",
      "PGN_Description": "LVDS",
      "first_bit": 4,
      "SPN": 5143,
      "SPN_Name": "Low Voltage Disconnect Current Operating Mode",
      "SPN_Description": "Current operating mode of the LVD.  The current mode is dependent on the state of the Manual Disconnect/Connect hardwired inputs and on the most-recent received LVD Set Desired Operating Mode message.  The hardwired inputs have priority over the LVD Set Operating Mode message, and Connects have priority over Disconnects.\r\n\r\n0000 - Automatic\r\n0001-0011 - Reserved\r\n0100 - Manual Disconnect via J1939 request\r\n0101 - Manual Connect via J1939 request\r\n0110-0111 - Reserved\r\n1000 - Manual Disconnect via hardwired input\r\n1001 - Manual Connect via hardwired input\r\n1010-1110 - Reserved\r\n1111 - Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5144": {
      "PGN": 64769,
      "PGN_Name": "Low Voltage Disconnect  Status",
      "PGN_Description": "LVDS",
      "first_bit": 8,
      "SPN": 5144,
      "SPN_Name": "Low Voltage Disconnect Output #3 State",
      "SPN_Description": "State of the Output #3 from the LVD.  Output #3 controls an external load or relay.  This external load could be independent of the main output, and may apply to an application specific circuit or zone.  If the LVD supports prioritization, this circuit will disconnect before Output #2 and reconnect after Output #2.\r\n\r\n0000 - Output off or disconnected\r\n0001 - Output on or connected\r\n0010 - Disconnect alarm expired, output off or disconnected\r\n0011 - Disconnect pending, alarm active\r\n0100 - Connect pending, alarm active\r\n0101-1101 - Reserved\r\n1110 - Output fault\r\n1111 - Not available or not installed",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5145": {
      "PGN": 64769,
      "PGN_Name": "Low Voltage Disconnect  Status",
      "PGN_Description": "LVDS",
      "first_bit": 12,
      "SPN": 5145,
      "SPN_Name": "Low Voltage Disconnect Output #2 State",
      "SPN_Description": "State of the Output #2 from the LVD.  Output #2 controls an external load or relay.  This external load could be independent of the main output, and may apply to an application specific circuit or zone.  If the LVD supports prioritization, this circuit will disconnect before Output #1 and reconnect after Output #1.\r\n\r\n0000 - Output off or disconnected\r\n0001 - Output on or connected\r\n0010 - Disconnect alarm expired, output off or disconnected\r\n0011 - Disconnect pending, alarm active\r\n0100 - Connect pending, alarm active\r\n0101-1101 - Reserved\r\n1110 - Output fault\r\n1111 - Not available or not installed",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5146": {
      "PGN": 64769,
      "PGN_Name": "Low Voltage Disconnect  Status",
      "PGN_Description": "LVDS",
      "first_bit": 16,
      "SPN": 5146,
      "SPN_Name": "Low Voltage Disconnect Output #1 State",
      "SPN_Description": "State of the Output #1 from the LVD.  Output #1 controls an external load or relay.  This external load could be independent of the main output, and may apply to an application specific circuit or zone.  If the LVD supports prioritization, this circuit will disconnect before the Vout output and reconnect after the Vout output.\r\n\r\n0000 - Output off or disconnected\r\n0001 - Output on or connected\r\n0010 - Disconnect alarm expired, output off or disconnected\r\n0011 - Disconnect pending, alarm active\r\n0100 - Connect pending, alarm active\r\n0101-1101 - Reserved\r\n1110 - Output fault\r\n1111 - Not available or not installed",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5147": {
      "PGN": 64769,
      "PGN_Name": "Low Voltage Disconnect  Status",
      "PGN_Description": "LVDS",
      "first_bit": 20,
      "SPN": 5147,
      "SPN_Name": "Low Voltage Disconnect Vout Output State",
      "SPN_Description": "State of the Vout Output from the LVD.  Vout is the LVD's main internal, controllable, high-current output.  If the LVD supports prioritization, this circuit will be the last to disconnect and the first to reconnect.\r\n\r\n0000 - Output off or disconnected\r\n0001 - Output on or connected\r\n0010 - Disconnect alarm expired, output off or disconnected\r\n0011 - Disconnect pending, alarm active\r\n0100 - Connect pending, alarm active\r\n0101-1101 - Reserved\r\n1110 - Output fault\r\n1111 - Not available or not installed",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5148": {
      "PGN": 64769,
      "PGN_Name": "Low Voltage Disconnect  Status",
      "PGN_Description": "LVDS",
      "first_bit": 24,
      "SPN": 5148,
      "SPN_Name": "Low Voltage Disconnect Temperature",
      "SPN_Description": "Internal temperature of the LVD.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5149": {
      "PGN": 38400,
      "PGN_Name": "Low Voltage Disconnect Set Operating Mode",
      "PGN_Description": "LVDSOM",
      "first_bit": 0,
      "SPN": 5149,
      "SPN_Name": "Low Voltage Disconnect Desired Operating Mode",
      "SPN_Description": "Desired Operating Mode of the LVD.  Used to issue a J1939 request to the LVD to change modes.\r\n\r\n0000 - Automatic\r\n0001-0011 - Reserved\r\n0100 - Manual Disconnect\r\n0101 - Manual Connect\r\n0110-1110 - Reserved\r\n1111 - No change",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5245": {
      "PGN": 65110,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "AT1T1I1",
      "first_bit": 37,
      "SPN": 5245,
      "SPN_Name": "Aftertreatment Diesel Exhaust Fluid Tank Low Level Indicator",
      "SPN_Description": "The desired illumination of the driver's warning indicator for diesel exhaust fluid (DEF) tank low level.\r\n\r\n000 - Off -  indicates adequate DEF level\r\n   e.g., for Euro VI this is used to indicate the driver warning system is non-active for diesel exhaust fluid level\r\n001 - On solid -  indicates low DEF level\r\n   e.g., for Euro VI this is used to indicate the driver warning system is initially activated for low diesel exhaust fluid level\r\n010 - reserved for SAE assignment\r\n011 - reserved for SAE assignment\r\n100 - On fast blink (1 Hz) indicates the DEF level is lower than the level indicated by the solid illumination (state 001)\r\n   e.g., for Euro VI this is used to indicate the second driver warning system detection threshold for diesel exhaust fluid level, where the visual alarm of the driver warning system is required to \"escalate in intensity\".\r\n101 - reserved for SAE assignment\r\n110 - reserved for SAE assignment\r\n111 - not available\r\n\r\nNote: SPN 5245 is similar to SPN 5825.  SPN 5245 is intended to be used in implementations where the warning indicator is used to convey diesel exhaust fluid tank low level information only, whereas SPN 5825 is intended to be used in implementations where the warning indicator is used to convey diesel exhaust fluid tank low level as well as specific emission control malfunction information.  Thus, SPN 5245 is a subset of SPN 5825, and if both are utilized, will match only under certain conditions.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5246": {
      "PGN": 65110,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1",
      "PGN_Description": "AT1T1I1",
      "first_bit": 45,
      "SPN": 5246,
      "SPN_Name": "Aftertreatment SCR Operator Inducement Severity",
      "SPN_Description": "Severity status of the operator inducement system for anomalies with the SCR system, such as tampering, low DEF quality, and DEF tank level.  Higher numerical levels indicate more severe levels of inducement.  Level 1 is the least severe.\r\n\r\n000 - Driver Warning, Low-Level Inducement, and Severe Inducement Non-Active\r\n001 - Inducement Level 1 … EPA defined SCR Inducement - DEF Warning  ...................... FMI 15\r\n                                             …Euro VI - Driver Warning System Active ................................... FMI 15\r\n                                             …Off Highway (Tier4) - DEF Warning…….................................... FMI 15\r\n010 - Inducement Level 2 … DEF Warning, second level (optional) ...................................... FMI 15\r\n                                             ... Euro VI - Low-Level Inducement Enabled ................................. FMI 15\r\n                                             …Off Highway (Tier4) - DEF Warning, second level.................... FMI 15\r\n011 - Inducement Level 3 … EPA defined SCR Inducement - Engine Derate ..................... FMI 16\r\n                                             ... Euro VI - Low-Level Inducement Active .................................... FMI 16\r\n                                             …Off Highway (Tier4) - Low-Level Inducement Active................. FMI 16\r\n100 - Inducement Level 4  ... Severe Inducement Pre-Trigger (optional) ….…….................. FMI 16\r\n                                             ... Euro VI - Severe Inducement Enabled ...................................... FMI 16\r\n                                             …Off Highway (Tier4) - Severe Inducement Enabled.................. FMI 16\r\n101 - Inducement Level 5  ... EPA defined SCR Inducement - Severe Inducement …........  FMI 0\r\n                                             ... Euro VI - Severe Inducement Active ......................................... FMI 0\r\n                                             …Off Highway (Tier4) - Final Inducement Enabled...................... FMI 0\r\n110 - Temporary Override of Inducement  -  The SCR inducement has been temporarily interrupted.\r\n111 - Not Available / Not Supported\r\n\r\nWhen SPN 5246 is used in a DTC the recommended FMI usage is as shown.\r\n\r\nReference EPA CISD-09-04-REVISED SCR Guidance document for more information regarding EPA implementations.\r\n\r\nReference Euro VI implementing regulation Annex XIII, Appendix 5, section 3.1.(b), 3.1.(c), and 3.1.(d) for more information regarding Euro VI implementations.\r\n\r\nReference EU directive 97/68/EC amendment (2012/46/EU), EPA webinar nrci-scr-web-conf.2011-07-25, and JMLIT \"Technical Guidelines for Urea Selective Catalytic Reduction System\" Kokujikan 132-3, Feb.16, 2012 for Off Highway (Tier4) implementations.\r\n\r\nJMLIT - Japan Ministry Of Land, Infrastructure, Transport and Tourism\r\n\r\nNote: SPN 5246 is similar to SPN 5826.  SPN 5246 is intended to be used to indicate the severity status of the operator inducement system for anomalies with the SCR system only, whereas SPN 5826 is intended to be used to indicate the severity status of the operator inducement system for anomalies with the SCR and EGR systems.  Thus, SPN 5246 is a subset of SPN 5826, and if both are utilized, will match only under certain conditions.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5252": {
      "PGN": 64768,
      "PGN_Name": "Engine Fluid Level/Pressure 10",
      "PGN_Description": "EFL/P10",
      "first_bit": 0,
      "SPN": 5252,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Differential Pressure",
      "SPN_Description": "Differential Pressure across the Exhaust Gas Recirculation 2 (EGR2) system.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "kPa",
      "SLOT_ID": 52
    },
    "5253": {
      "PGN": 64768,
      "PGN_Name": "Engine Fluid Level/Pressure 10",
      "PGN_Description": "EFL/P10",
      "first_bit": 16,
      "SPN": 5253,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Intake Pressure",
      "SPN_Description": "EGR2 intake gauge pressure is measured after EGR2 cooler and before EGR2 valve",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "5254": {
      "PGN": 64768,
      "PGN_Name": "Engine Fluid Level/Pressure 10",
      "PGN_Description": "EFL/P10",
      "first_bit": 24,
      "SPN": 5254,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Outlet Absolute Pressure",
      "SPN_Description": "Absolute Pressure immediately after the EGR2 valve",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "5255": {
      "PGN": 64767,
      "PGN_Name": "Engine Temperature 5",
      "PGN_Description": "ET5",
      "first_bit": 0,
      "SPN": 5255,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Temperature ",
      "SPN_Description": "Temperature of Recirculated Exhaust Gas of EGR2",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5256": {
      "PGN": 64767,
      "PGN_Name": "Engine Temperature 5",
      "PGN_Description": "ET5",
      "first_bit": 16,
      "SPN": 5256,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Mixer Intake Temperature",
      "SPN_Description": "The temperature of the EGR gas entering the intake of EGR2 system mixer.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5257": {
      "PGN": 61450,
      "PGN_Name": "Engine Gas Flow Rate",
      "PGN_Description": "EGF1",
      "first_bit": 32,
      "SPN": 5257,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Mass Flow Rate",
      "SPN_Description": "Flow rate of gas through the second EGR system. Flow rate of the exhaust gas being recirculated from the 2nd EGR system into combustion air.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "kg/h",
      "SLOT_ID": 18
    },
    "5258": {
      "PGN": 64766,
      "PGN_Name": "Electronic Engine Controller 10",
      "PGN_Description": "EEC10",
      "first_bit": 0,
      "SPN": 5258,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Cooler Intake Temperature",
      "SPN_Description": "Exhaust Gas Recirculation 2 (EGR2) Temperature measured at EGR2 cooler intake. See SPN 5255 for Engine EGR2 temperature.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5259": {
      "PGN": 64766,
      "PGN_Name": "Electronic Engine Controller 10",
      "PGN_Description": "EEC10",
      "first_bit": 16,
      "SPN": 5259,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Cooler Intake Gas Absolute Pressure",
      "SPN_Description": "Exhaust Gas Recirculation 2 gas absolute pressure is measured at EGR2 cooler intake. See SPN 5253 for EGR2 pressure measured at the EGR2 cooler outlet before the valve.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "5260": {
      "PGN": 64766,
      "PGN_Name": "Electronic Engine Controller 10",
      "PGN_Description": "EEC10",
      "first_bit": 32,
      "SPN": 5260,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Cooler Efficiency",
      "SPN_Description": "Exhaust Gas Recirculation 2 cooler efficiency is an indication of the cooler’s ability to reduce the temperature of the exhaust gas that is being recirculated back to the intake. 0% = no reduction in temperature, 100% = maximum cooling. The EGR 2 cooler efficiency is calculated as (EGR 2 cooler intake temperature minus EGR 2 gas temperature) divided by (EGR 2 cooler intake temperature minus engine coolant temperature).",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5261": {
      "PGN": 64766,
      "PGN_Name": "Electronic Engine Controller 10",
      "PGN_Description": "EEC10",
      "first_bit": 40,
      "SPN": 5261,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Cooler Bypass Actuator Position",
      "SPN_Description": "EGR2 Cooler Bypass Actuator position, where 0% = Fully Closed (no gas flowing through the bypass), and 100% = Fully Open..",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5262": {
      "PGN": 64765,
      "PGN_Name": "Electronic Engine Controller 9",
      "PGN_Description": "EEC9",
      "first_bit": 0,
      "SPN": 5262,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Valve Position",
      "SPN_Description": "Position of EGR2 valve expressed as a percentage of full travel. 0% means the valve is closed and no exhaust gas is flowing into the air stream. 100% means the valve is fully opened.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5263": {
      "PGN": 64765,
      "PGN_Name": "Electronic Engine Controller 9",
      "PGN_Description": "EEC9",
      "first_bit": 16,
      "SPN": 5263,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Valve 2 Position",
      "SPN_Description": "The position of the second exhaust gas recirculation valve of EGR 2 expressed as a percentage of full travel. 0% means the valve is closed and no exhaust gas is flowing into the air stream. 100% means the valve is fully opened.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5264": {
      "PGN": 64762,
      "PGN_Name": "Electronic Engine Controller 11",
      "PGN_Description": "EEC11",
      "first_bit": 0,
      "SPN": 5264,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Valve 1 Control",
      "SPN_Description": "Desired percentage of maximum Exhaust Gas Recirculation 2 (EGR2) valve opening. 0% means the valve is closed. 100% means maximum opening (full gas flow).",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5265": {
      "PGN": 64762,
      "PGN_Name": "Electronic Engine Controller 11",
      "PGN_Description": "EEC11",
      "first_bit": 16,
      "SPN": 5265,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Valve 2 Control",
      "SPN_Description": "Desired percentage of maximum Exhaust Gas Recirculation 2 (EGR2) valve 2 opening. 0% means the valve is closed. 100% means maximum opening (full gas flow).",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5266": {
      "PGN": 64761,
      "PGN_Name": "Diesel Particulate Filter 1 Soot 2",
      "PGN_Description": "DPF1S2",
      "first_bit": 0,
      "SPN": 5266,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Soot Signal Standard Deviation",
      "SPN_Description": "Standard deviation of the soot measurement from diesel particulate filter 1 soot sensor.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5267": {
      "PGN": 64761,
      "PGN_Name": "Diesel Particulate Filter 1 Soot 2",
      "PGN_Description": "DPF1S2",
      "first_bit": 16,
      "SPN": 5267,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Soot Signal Maximum",
      "SPN_Description": "Maximum output signal level of the current soot measurement from diesel particulate filter 1 soot sensor.  This is a statistical value, not the maximum sensing capability of the sensor.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5268": {
      "PGN": 64761,
      "PGN_Name": "Diesel Particulate Filter 1 Soot 2",
      "PGN_Description": "DPF1S2",
      "first_bit": 32,
      "SPN": 5268,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Soot Signal Minimum",
      "SPN_Description": "Minimum output signal level of the current soot measurement from diesel particulate filter 1 soot sensor.  This is a statistical value, not the minimum sensing capability of the sensor.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5269": {
      "PGN": 64760,
      "PGN_Name": "Diesel Particulate Filter 2 Soot 2",
      "PGN_Description": "DPF2S2",
      "first_bit": 0,
      "SPN": 5269,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Soot Signal Standard Deviation",
      "SPN_Description": "Standard deviation of the soot measurement from diesel particulate filter 2 soot sensor.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5270": {
      "PGN": 64760,
      "PGN_Name": "Diesel Particulate Filter 2 Soot 2",
      "PGN_Description": "DPF2S2",
      "first_bit": 16,
      "SPN": 5270,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Soot Signal Maximum",
      "SPN_Description": "Maximum output signal level of the current soot measurement from diesel particulate filter 2 soot sensor.  This is a statistical value, not the maximum sensing capability of the sensor.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5271": {
      "PGN": 64760,
      "PGN_Name": "Diesel Particulate Filter 2 Soot 2",
      "PGN_Description": "DPF2S2",
      "first_bit": 32,
      "SPN": 5271,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Soot Signal Minimum",
      "SPN_Description": "Minimum output signal level of the current soot measurement from diesel particulate filter 2 soot sensor.  This is a statistical value, not the minimum sensing capability of the sensor.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5274": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 58,
      "SPN": 5274,
      "SPN_Name": "Prohibit Automatic Air Suspension Control",
      "SPN_Description": "This parameter is an internal request to the air suspension control system to prohibit automatic air suspension control.  If the request is accepted,  response intended to be sent in  ASC1 (additional status requested in ASC1), there will be no automatic control either for height changes or axle load distribution changes, i.e. hold current pressures in all suspension devices.\r\n\r\nFor example, to prohibit automatic air suspension control when a wheelchair lift is in use.\r\n\r\n00 No request \r\n01 Request prohibit automatic air suspension control \r\n10 Error indicator \r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5275": {
      "PGN": 64964,
      "PGN_Name": "Electronic Brake Controller 5",
      "PGN_Description": "EBC5",
      "first_bit": 24,
      "SPN": 5275,
      "SPN_Name": "Parking Brake Actuator Fully Activated",
      "SPN_Description": "Signal which indicates when the parking brake actuator is fully activated.  (see also SPN 70 and 619).\r\n\r\n00 - Parking Brake Actuator not fully activated\r\n01 - Parking Brake Actuator fully activated\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5276": {
      "PGN": 64764,
      "PGN_Name": "Engine Manifold Actuator Control",
      "PGN_Description": "EMAC",
      "first_bit": 0,
      "SPN": 5276,
      "SPN_Name": "Engine Exhaust Manifold Bank 1 Flow Balance Valve Actuator Control",
      "SPN_Description": "Commanded percentage of maximum Engine Exhaust Manifold Bank 1 Balance valve opening. 0% means valve is closed. 100% means maximum valve opening (full gas flow).",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5277": {
      "PGN": 64763,
      "PGN_Name": "Engine Manifold Actuator Position",
      "PGN_Description": "EMAP",
      "first_bit": 0,
      "SPN": 5277,
      "SPN_Name": "Engine Exhaust Manifold Bank 1 Flow Balance Valve Actuator Position",
      "SPN_Description": "Actual percentage of maximum Engine Exhaust Manifold Bank 1 Balance valve opening. 0% means valve is closed. 100% means maximum valve opening (full gas flow).",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5278": {
      "PGN": 64764,
      "PGN_Name": "Engine Manifold Actuator Control",
      "PGN_Description": "EMAC",
      "first_bit": 16,
      "SPN": 5278,
      "SPN_Name": "Engine Exhaust Manifold Bank 2 Flow Balance Valve Actuator Control",
      "SPN_Description": "Commanded percentage of maximum Engine Ehaust Manifold Bank 2 Balance valve opening. 0% means valve is closed. 100% means maximum valve opening (full gas flow).",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5279": {
      "PGN": 64763,
      "PGN_Name": "Engine Manifold Actuator Position",
      "PGN_Description": "EMAP",
      "first_bit": 16,
      "SPN": 5279,
      "SPN_Name": "Engine Exhaust Manifold Bank 2 Flow Balance Valve Actuator Position",
      "SPN_Description": "Actual percentage of maximum Engine Manifold Bank 2 Balance valve opening. 0% means valve is closed. 100% means maximum valve opening (full gas flow).",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5280": {
      "PGN": 64759,
      "PGN_Name": "Charge Air Cooler 1 Precooler",
      "PGN_Description": "CAC1P",
      "first_bit": 0,
      "SPN": 5280,
      "SPN_Name": "Engine Charge Air Cooler 1 Precooler Intake Temperature",
      "SPN_Description": "Temperature of the combustion air measured at the charge air cooler 1 precooler intake.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5281": {
      "PGN": 64759,
      "PGN_Name": "Charge Air Cooler 1 Precooler",
      "PGN_Description": "CAC1P",
      "first_bit": 16,
      "SPN": 5281,
      "SPN_Name": "Engine Charge Air Cooler 1 Precooler Outlet Temperature",
      "SPN_Description": "Temperature of the combustion air measured at the charge air cooler 1 precooler outlet.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5282": {
      "PGN": 64759,
      "PGN_Name": "Charge Air Cooler 1 Precooler",
      "PGN_Description": "CAC1P",
      "first_bit": 32,
      "SPN": 5282,
      "SPN_Name": "Engine Charge Air Cooler 1 Precooler Efficiency",
      "SPN_Description": "Engine charge air cooler 1 (CAC1) precooler efficiency is an indication of the precooler’s ability to reduce the temperature of the combustion air that is being routed through the precooler. 0% = no reduction in temperature, 100% = maximum cooling. The CAC1 precooler efficiency is calculated as (CAC1 precooler Intake temperature minus CAC1 precooler outlet temperature) divided by (CAC1 precooler Intake temperature minus engine coolant temperature).  This calculation assumes that the precooler uses engine coolant as the cooling fluid.  ",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5283": {
      "PGN": 64758,
      "PGN_Name": "Charge Air Cooler 1",
      "PGN_Description": "CAC1",
      "first_bit": 0,
      "SPN": 5283,
      "SPN_Name": "Engine Charge Air Cooler 1 Intake Temperature",
      "SPN_Description": "Temperature of the combustion air measured at the CAC 1 Intake.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5284": {
      "PGN": 64758,
      "PGN_Name": "Charge Air Cooler 1",
      "PGN_Description": "CAC1",
      "first_bit": 16,
      "SPN": 5284,
      "SPN_Name": "Engine Charge Air Cooler 1 Ambient Air Temperature",
      "SPN_Description": "Temperature of the air surrounding charge air cooler 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5285": {
      "PGN": 64758,
      "PGN_Name": "Charge Air Cooler 1",
      "PGN_Description": "CAC1",
      "first_bit": 32,
      "SPN": 5285,
      "SPN_Name": "Engine Charge Air Cooler 1 Efficiency",
      "SPN_Description": "Engine charge air cooler 1(CAC1) efficiency is an indication of the CAC’s ability to reduce the temperature of the combustion air that is being routed through the CAC1. 0% = no reduction in temperature, 100% = maximum cooling. The CAC1 efficiency is calculated as (CAC1 Intake temperature minus CAC1 outlet temperature) divided by (CAC1 Intake temperature minus CAC1 ambient air temperature).  This calculation assumes that the CAC uses a measured or estimated ambient air temperature as the cooling fluid temperature.  ",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5286": {
      "PGN": 64757,
      "PGN_Name": "Charge Air Cooler 2 Precooler",
      "PGN_Description": "CAC2P",
      "first_bit": 0,
      "SPN": 5286,
      "SPN_Name": "Engine Charge Air Cooler 2 Precooler Intake Temperature",
      "SPN_Description": "Temperature of the combustion air measured at the charge air cooler 2 precooler Intake.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5287": {
      "PGN": 64757,
      "PGN_Name": "Charge Air Cooler 2 Precooler",
      "PGN_Description": "CAC2P",
      "first_bit": 16,
      "SPN": 5287,
      "SPN_Name": "Engine Charge Air Cooler 2 Precooler Outlet Temperature",
      "SPN_Description": "Temperature of the combustion air measured at the charge air cooler 2 precooler outlet.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5288": {
      "PGN": 64757,
      "PGN_Name": "Charge Air Cooler 2 Precooler",
      "PGN_Description": "CAC2P",
      "first_bit": 32,
      "SPN": 5288,
      "SPN_Name": "Engine Charge Air Cooler 2 Precooler Efficiency",
      "SPN_Description": "Engine charge air cooler 2 (CAC2) precooler efficiency is an indication of the precooler’s ability to reduce the temperature of the gas that is being routed through the precooler. 0% = no reduction in temperature, 100% = maximum cooling. The CAC2 precooler efficiency is calculated as (CAC2 precooler Intake temperature minus CAC2 precooler outlet temperature) divided by (CAC2 precooler Intake temperature minus engine coolant temperature).  This calculation assumes that the CAC2 precooler uses engine coolant as the cooling fluid.  ",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5289": {
      "PGN": 64756,
      "PGN_Name": "Charge Air Cooler 2",
      "PGN_Description": "CAC2",
      "first_bit": 0,
      "SPN": 5289,
      "SPN_Name": "Engine Charge Air Cooler 2 Intake Temperature",
      "SPN_Description": "Temperature of the combustion air measured at the charge air cooler 2 Intake.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5290": {
      "PGN": 64756,
      "PGN_Name": "Charge Air Cooler 2",
      "PGN_Description": "CAC2",
      "first_bit": 16,
      "SPN": 5290,
      "SPN_Name": "Engine Charge Air Cooler 2 Outlet Temperature",
      "SPN_Description": "Temperature of combustion air after it exits from the Charge Air Cooler 2 but before any mixing of recirculated exhaust gas.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5291": {
      "PGN": 64756,
      "PGN_Name": "Charge Air Cooler 2",
      "PGN_Description": "CAC2",
      "first_bit": 32,
      "SPN": 5291,
      "SPN_Name": "Engine Charge Air Cooler 2 Ambient Air Temperature",
      "SPN_Description": "Temperature of the air surrounding charge air cooler 2.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5292": {
      "PGN": 64756,
      "PGN_Name": "Charge Air Cooler 2",
      "PGN_Description": "CAC2",
      "first_bit": 48,
      "SPN": 5292,
      "SPN_Name": "Engine Charge Air Cooler 2 Efficiency",
      "SPN_Description": "Engine charge air cooler 2 (CAC2) is an indication of the CAC’s ability to reduce the temperature of the combustion air that is being routed through the CAC. 0% = no reduction in temperature, 100% = maximum cooling. The CAC2 efficiency is calculated as (CAC2 Intake temperature minus CAC2 outlet temperature) divided by (CAC2 Intake temperature minus CAC2 ambient air temperature).  This calculation assumes that the CAC uses a measured or estimated ambient air temperature as the cooling fluid temperature.  ",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5293": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 54,
      "SPN": 5293,
      "SPN_Name": "Allow Level Control During Braking Command",
      "SPN_Description": "This parameter overides the inhibit of level control during braking.\r\n\r\n00 = Disallow level control during braking (normal operation)\r\n01 = Allow level control during braking\r\n10 = Reserved\r\n11 = Don’t' care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5294": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 52,
      "SPN": 5294,
      "SPN_Name": "Allow Level Control During Braking Status",
      "SPN_Description": "This parameter indicates if the function Allow Level Control During Braking is active. Functions is activated by SPN 5293.\r\n\r\n00 = Deactivated\r\n01 = Activated\r\n10 = Reserved\r\n11 = Don’t care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5295": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 56,
      "SPN": 5295,
      "SPN_Name": "Speed Dependent Level Control Request",
      "SPN_Description": "This parameter activates speed dependent level control in suspension system.\r\n\r\n00 = Deactivate\r\n01 = Activate\r\n10 = Reserved\r\n11 = Don’t care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5296": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 54,
      "SPN": 5296,
      "SPN_Name": "Speed Dependant Level Control Status",
      "SPN_Description": "This parameter indicates if the function Speed Dependant Level Control is active. The function is activated by SPN 5295.\r\n\r\n00 = Inactive\r\n01 = Active\r\n10 = Reserved\r\n11 = Don’t' care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5312": {
      "PGN": 64916,
      "PGN_Name": "Electronic Engine Controller 7",
      "PGN_Description": "EEC7",
      "first_bit": 48,
      "SPN": 5312,
      "SPN_Name": "Engine Intake Manifold Commanded Pressure",
      "SPN_Description": "Provides the commanded set point value for the engine intake manifold pressure.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 138
    },
    "5313": {
      "PGN": 64765,
      "PGN_Name": "Electronic Engine Controller 9",
      "PGN_Description": "EEC9",
      "first_bit": 32,
      "SPN": 5313,
      "SPN_Name": "Commanded Engine Fuel Rail Pressure",
      "SPN_Description": "Provides the commanded set point value for the engine fuel rail gage pressure",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 51
    },
    "5314": {
      "PGN": 64765,
      "PGN_Name": "Electronic Engine Controller 9",
      "PGN_Description": "EEC9",
      "first_bit": 48,
      "SPN": 5314,
      "SPN_Name": "Commanded Engine Fuel Injection Control Pressure",
      "SPN_Description": "Provides the commanded set point value for the engine fuel injection control pressure.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 51
    },
    "5315": {
      "PGN": 64749,
      "PGN_Name": "Aftertreatment 2 Warm Up Diesel Oxidation Catalyst Information",
      "PGN_Description": "AT2WUDOC",
      "first_bit": 0,
      "SPN": 5315,
      "SPN_Name": "Aftertreatment 2 Warm Up Diesel Oxidation Catalyst Intake Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts entering the warm up Diesel Oxidation Catalyst in exhaust bank 2.  This diesel parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5316": {
      "PGN": 64749,
      "PGN_Name": "Aftertreatment 2 Warm Up Diesel Oxidation Catalyst Information",
      "PGN_Description": "AT2WUDOC",
      "first_bit": 16,
      "SPN": 5316,
      "SPN_Name": "Aftertreatment 2 Warm Up Diesel Oxidation Catalyst Outlet Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts leaving the warm up Diesel Oxidation Catalyst in exhaust bank 2.  This diesel parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5323": {
      "PGN": 64981,
      "PGN_Name": "Electronic Engine Controller 5",
      "PGN_Description": "EEC5",
      "first_bit": 50,
      "SPN": 5323,
      "SPN_Name": "Engine Fuel Control Mode",
      "SPN_Description": "Indicates whether the Engine Fuel Control System is in open loop or closed loop.\r\n\r\n00     Open loop\r\n01     Closed loop\r\n10     SAE reserved\r\n11     Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5344": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 42,
      "SPN": 5344,
      "SPN_Name": "Transmission Warning Indicator",
      "SPN_Description": "Signal from transmission indicating that some aspect of its operation is not functioning correctly, and as a result, transmission operation may be altered or restricted.  The indicator is typically a lamp.  Distinctions in meaning between the continuous and flashing are left to the transmission manufacturer.\r\n\r\n00 - Transmission Warning Indicator is off\r\n01 - Transmission Warning Indicator is on continuously\r\n10 - Transmission Warning Indicator is flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5345": {
      "PGN": 64917,
      "PGN_Name": "Transmission Fluids 2",
      "PGN_Description": "TRF2",
      "first_bit": 4,
      "SPN": 5345,
      "SPN_Name": "Transmission Overheat Indicator",
      "SPN_Description": "Signal from transmission indicating that its fluid temperature is above normal acceptable limits, and as a result, transmission operation may be altered or restricted.  The indicator is typically a lamp.  Distinctions in meaning between the continuous and flashing are left to the transmission manufacturer..\r\n\r\n00 - Transmission Overheat Indicator is off\r\n01 - Transmission Overheat Indicator is on continuously\r\n10 - Transmission Overheat Indicator is flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5346": {
      "PGN": 65275,
      "PGN_Name": "Retarder fluids",
      "PGN_Description": "RF",
      "first_bit": 16,
      "SPN": 5346,
      "SPN_Name": "Driveline Retarder Overheat Indicator",
      "SPN_Description": "Signal from the driveline retarder indicating that its fluid temperature is above normal acceptable limits, and as a result, retarder operation may be altered or restricted.  The indicator is typically a lamp.  Distinctions in meaning between the continuous and flashing are left to the transmission manufacturer.\r\n\r\n00 - Driveline Retarder Overheat Indicator is off\r\n01 - Driveline Retarder Overheat Indicator is on continuously\r\n10 - Driveline Retarder Overheat Indicator is flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5347": {
      "PGN": 61485,
      "PGN_Name": "Acceleration Sensor",
      "PGN_Description": "ACCS",
      "first_bit": 0,
      "SPN": 5347,
      "SPN_Name": "Lateral Acceleration (Extended Range)",
      "SPN_Description": "Indicates lateral acceleration of the vehicle (the component of vehicle acceleration vector along the Y-axis).  A positive lateral acceleration signal results when the vehicle is accelerated to the left.  This parameter is defined according to a Z-Up axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Up Axis System has positive X directed forward, positive Y to the left, and positive Z directed up.  See SPN 1809 for an alternate range and resolution.",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": -320,
      "unit": "m/s²",
      "SLOT_ID": 303
    },
    "5348": {
      "PGN": 61485,
      "PGN_Name": "Acceleration Sensor",
      "PGN_Description": "ACCS",
      "first_bit": 16,
      "SPN": 5348,
      "SPN_Name": "Longitudinal Acceleration (Extended Range)",
      "SPN_Description": "Indicates longitudinal acceleration of the vehicle (the component of vehicle acceleration vector along the X-axis).  A positive longitudinal acceleration signal results when the vehicle speed increases in the forward direction.  Longitudinal acceleration is the same for both Z-Down and Z-Up axis systems, since both systems have positive X axis directed forward.  The sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  See SPN 1810 for an alternate longitudinal acceleration.",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": -320,
      "unit": "m/s²",
      "SLOT_ID": 303
    },
    "5349": {
      "PGN": 61485,
      "PGN_Name": "Acceleration Sensor",
      "PGN_Description": "ACCS",
      "first_bit": 32,
      "SPN": 5349,
      "SPN_Name": "Vertical Acceleration (Extended Range)",
      "SPN_Description": "Indicates vertical acceleration of the vehicle and the effect of gravity (the component of vehicle acceleration vector along the Z-axis).  A positive vertical acceleration signal of 1 gravity results when the vehicle is stationary on a horizontal surface.  This parameter is defined according to a Z-Up axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Up Axis System has positive X directed forward, positive Y to the left, and positive Z directed up.",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": -320,
      "unit": "m/s²",
      "SLOT_ID": 303
    },
    "5350": {
      "PGN": 61485,
      "PGN_Name": "Acceleration Sensor",
      "PGN_Description": "ACCS",
      "first_bit": 48,
      "SPN": 5350,
      "SPN_Name": "Lateral Acceleration Figure of Merit (Extended Range)",
      "SPN_Description": "Figure of merit for lateral acceleration measurement.\r\n\r\n00 = lateral acceleration is fully functional.  Data is within sensor specification\r\n01 = lateral acceleration is degraded.  Data is suspect due to enviromental conditions\r\n10 = error\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5351": {
      "PGN": 61485,
      "PGN_Name": "Acceleration Sensor",
      "PGN_Description": "ACCS",
      "first_bit": 50,
      "SPN": 5351,
      "SPN_Name": "Longitudinal Acceleration Figure of Merit (Extended Range)",
      "SPN_Description": "Figure of merit for longitudinal acceleration measurement.\r\n\r\n00 = longitudinal acceleration is fully functional.  Data is within sensor specification\r\n01 = longitudinal acceleration is degraded.  Data is suspect due to enviromental conditions\r\n10 = error\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5352": {
      "PGN": 61485,
      "PGN_Name": "Acceleration Sensor",
      "PGN_Description": "ACCS",
      "first_bit": 52,
      "SPN": 5352,
      "SPN_Name": "Vertical Acceleration Figure of Merit (Extended Range)",
      "SPN_Description": "Figure of merit for vertical acceleration measurement.\r\n\r\n00 = vertical acceleration is fully functional.  Data is within sensor specification\r\n01 = verticalacceleration is degraded.  Data is suspect due to enviromental conditions\r\n10 = error\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5353": {
      "PGN": 61485,
      "PGN_Name": "Acceleration Sensor",
      "PGN_Description": "ACCS",
      "first_bit": 54,
      "SPN": 5353,
      "SPN_Name": "Support Variable Transmission Repetition Rate for Acceleration Sensor",
      "SPN_Description": "Indicates which acceleration transmission rate are supported by the ECU in addition to the required 10 ms transmission rate.\r\n\r\n00 - Reserve for SAE assignment\r\n01 - Reserved for SAE assignment\r\n10 - 20 ms rate supported\r\n11 - ECU only supports standard transmission rate of 10 ms",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5366": {
      "PGN": 64931,
      "PGN_Name": "Electronic Engine Controller 6",
      "PGN_Description": "EEC6",
      "first_bit": 48,
      "SPN": 5366,
      "SPN_Name": "Engine Turbocharger Compressor Bypass Actuator 1 Desired Position",
      "SPN_Description": "The requested position of the Engine Turbocharger Compressor Bypass actuator by the engine ECU, where 0% represents bypass fully closed and 100% represents bypass fully open.\r\n\r\nThis is the position that the device is attempting to achieve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5367": {
      "PGN": 64931,
      "PGN_Name": "Electronic Engine Controller 6",
      "PGN_Description": "EEC6",
      "first_bit": 56,
      "SPN": 5367,
      "SPN_Name": "Engine Turbocharger Compressor Bypass Actuator 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Engine Turbocharger Compressor Bypass Actuator 1 by the manufacturers software.  When there is multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5368": {
      "PGN": 64931,
      "PGN_Name": "Electronic Engine Controller 6",
      "PGN_Description": "EEC6",
      "first_bit": 61,
      "SPN": 5368,
      "SPN_Name": "Engine Turbocharger Compressor Bypass Actuator 1 Temperature Status",
      "SPN_Description": "Used to identify the status of the Engine Turbocharger Compresssor Bypass Actuator 1 drive circuitry temperature.  Temperature excursions may affect the torque output.\r\n\n000 – High Most severe\r\n001 – High Least severe\r\n010 – In Range\r\n011 – Low Least severe\r\n100 – Low Most severe\r\n101 – Not Defined\r\n110 – Error\r\n111 – Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5369": {
      "PGN": 64931,
      "PGN_Name": "Electronic Engine Controller 6",
      "PGN_Description": "EEC6",
      "first_bit": 32,
      "SPN": 5369,
      "SPN_Name": "Engine Turbocharger Compressor Bypass Actuator 2 Command",
      "SPN_Description": "The command to a compressor bypass actuator 2, normalized to percent, where 0% nominally represents fully closed and 100% represents fully open. Typically, the turbocharger compressor bypass actuator is used to keep the engine out of surge by metering compressed air (charge).",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5370": {
      "PGN": 65174,
      "PGN_Name": "Turbocharger Wastegate",
      "PGN_Description": "TCW",
      "first_bit": 40,
      "SPN": 5370,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 1 Desired Position",
      "SPN_Description": "The Requested Valve position of the Turbocharger Wastegate Valve 1, commanded by the engine ECU. A value of 0% represents fully closed and a value of 100% represents fully open.\r\n\r\nThis is the position that the device is attempting to achieve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5371": {
      "PGN": 65174,
      "PGN_Name": "Turbocharger Wastegate",
      "PGN_Description": "TCW",
      "first_bit": 48,
      "SPN": 5371,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Engine Turbocharger Wastegate Actuator 1 by the manufacturers software.  When there is multiple failures, the most severe is transmitted\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5372": {
      "PGN": 65174,
      "PGN_Name": "Turbocharger Wastegate",
      "PGN_Description": "TCW",
      "first_bit": 53,
      "SPN": 5372,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 1 Temperature Status",
      "SPN_Description": "Used to identify the status of the Engine Turbocharger Wastegate Actuator 1 drive circuitry temperature.  Temperature excursions may affect the torque output.\r\n\r\n000 – High Most severe\r\n001 – High Least severe\r\n010 – In Range\r\n011 – Low Least severe\r\n100 – Low Most severe\r\n101 – Not Defined\r\n110 – Error\r\n111 – Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5373": {
      "PGN": 65174,
      "PGN_Name": "Turbocharger Wastegate",
      "PGN_Description": "TCW",
      "first_bit": 56,
      "SPN": 5373,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 2 Desired Position",
      "SPN_Description": "The Requested Valve position of the Turbocharger Wastegate Valve 2, commanded by the engine ECU. A value of 0% represents fully closed and a value of 100% represents fully open.\r\n\r\nThis is the position that the device is attempting to achieve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5374": {
      "PGN": 64754,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 1",
      "PGN_Description": "EFTVI1",
      "first_bit": 0,
      "SPN": 5374,
      "SPN_Name": "Engine Desired Throttle Valve 1 Position ",
      "SPN_Description": "The desired position of the Throttle valve 1 (SPN 51) that is regulating the fluid, usually air/fuel mixture to the engine as commanded by the Engine Control unit.  0% represents no supply and 100% is full supply.\r\n\r\nThis is the position that the device is attempting to achieve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5375": {
      "PGN": 64754,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 1",
      "PGN_Description": "EFTVI1",
      "first_bit": 8,
      "SPN": 5375,
      "SPN_Name": "Engine Throttle Valve 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine throttle valve 1 (SPN 51) by the manufacturers software.  When there is multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5376": {
      "PGN": 64754,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 1",
      "PGN_Description": "EFTVI1",
      "first_bit": 13,
      "SPN": 5376,
      "SPN_Name": "Engine Throttle Valve 1 Temperature Status",
      "SPN_Description": "Used to identify the status of the engine throttle valve 1 (SPN 51) drive circuitry temperature.  Temperature excursions may affect the torque output.\r\n\r\n000 – High most severe\r\n001 – High Least severe\r\n010 – In Range\r\n011 – Low Least severe\r\n100 – Low Most severe\r\n101 – Not Defined\r\n110 – Error\r\n111 – Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5377": {
      "PGN": 64754,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 1",
      "PGN_Description": "EFTVI1",
      "first_bit": 16,
      "SPN": 5377,
      "SPN_Name": "Engine Desired Throttle Valve 2 Position",
      "SPN_Description": "The desired position of the engine throttle valve 2 (SPN 3673) that is regulating the fluid, usually air/fuel mixture to the engine as commanded by the Engine Control Unit.  0% represents no supply and 100% is full supply.\r\n\r\nThis is the position that the device is attempting to achieve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5378": {
      "PGN": 64754,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 1",
      "PGN_Description": "EFTVI1",
      "first_bit": 24,
      "SPN": 5378,
      "SPN_Name": "Engine Throttle Valve 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine throttle valve 2 (SPN 3673) by the manufacturers software.  When there is multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5379": {
      "PGN": 64754,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 1",
      "PGN_Description": "EFTVI1",
      "first_bit": 29,
      "SPN": 5379,
      "SPN_Name": "Engine Throttle Valve 2 Temperature status",
      "SPN_Description": "Used to identify the status of the Engine throttle valve 2 (SPN 3673) drive circuitry temperature.  Temperature excursions may affect the torque output.\r\n\r\n000 – High Most severe\r\n001 – High Least severe\r\n010 – In Range\r\n011 – Low Least severe\r\n100 – Low Most severe\r\n101 – Not Defined\r\n110 – Error\r\n111 – Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5380": {
      "PGN": 64754,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 1",
      "PGN_Description": "EFTVI1",
      "first_bit": 32,
      "SPN": 5380,
      "SPN_Name": "Engine Fuel Valve 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Engine Fuel Valve 1 by the manufacturers software. When there is multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5381": {
      "PGN": 64754,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 1",
      "PGN_Description": "EFTVI1",
      "first_bit": 37,
      "SPN": 5381,
      "SPN_Name": "Engine Fuel Valve 1 Temperature Status",
      "SPN_Description": "Used to identify the status of the Engine Fuel valve 1 drive circuitry temperature.  Temperature excursions may affect the torque output.\r\n\r\n000 – High Most severe\r\n001 – High Least severe\r\n010 – In Range\r\n011 – Low Least severe\r\n100 – Low Most severe\r\n101 – Not Defined\r\n110 – Error\r\n111 – Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5382": {
      "PGN": 64754,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 1",
      "PGN_Description": "EFTVI1",
      "first_bit": 40,
      "SPN": 5382,
      "SPN_Name": "Engine Fuel Valve 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Engine Fuel Valve 2 by the manufacturers software.  When there is multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5383": {
      "PGN": 64754,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 1",
      "PGN_Description": "EFTVI1",
      "first_bit": 45,
      "SPN": 5383,
      "SPN_Name": "Engine Fuel Valve 2 Temperature Status",
      "SPN_Description": "Used to identify the status of the Engine Fuel valve 2 drive circuitry temperature.  Temperature excursions may affect the torque output.\r\n\r\n000 – High most severe\r\n001 – High Least severe\r\n010 – In Range\r\n011 – Low Least severe\r\n100 – Low Most severe\r\n101 – Not Defined\r\n110 – Error\r\n111 – Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5384": {
      "PGN": 64753,
      "PGN_Name": "Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information",
      "PGN_Description": "ETWAI",
      "first_bit": 0,
      "SPN": 5384,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Engine Turbocharger Wastegate Actuator 2 by the manufacturers software. When there is multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5385": {
      "PGN": 64753,
      "PGN_Name": "Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information",
      "PGN_Description": "ETWAI",
      "first_bit": 5,
      "SPN": 5385,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 2 Temperature Status",
      "SPN_Description": "Used to identify the status of the Engine Turbocharger Wastegate Actuator 2 drive circuitry temperature.  Temperature excursions may affect the torque output.\r\n\r\n000 – High most severe\r\n001 – High Least severe\r\n010 – In Range\r\n011 – Low Least severe\r\n100 – Low Most severe\r\n101 – Not Defined\r\n110 – Error\r\n111 – Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5386": {
      "PGN": 61486,
      "PGN_Name": "Engine Turbocharger Control",
      "PGN_Description": "ETCC",
      "first_bit": 0,
      "SPN": 5386,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 1 Command",
      "SPN_Description": "The command to a Turbocharger Wastegate actuator 1, normalized to percent, where 0% nominally represents fully closed (No Flow) and 100% represents fully open (Max Flow).\r\n\r\n0xFB00 - 0xFB64 is sent to calibrate to a specific position.  The LSB specifies the position with a resolution of 1%/bit  (eg, 0xFB32 is sent to calibrate the actuator to 50%).  \r\n\r\n0xFBFF is sent to calibrate the actuator using its own algorithm.  \r\n\r\nCalibration status from the actuator is received on SPN 5451.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5387": {
      "PGN": 61486,
      "PGN_Name": "Engine Turbocharger Control",
      "PGN_Description": "ETCC",
      "first_bit": 16,
      "SPN": 5387,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 2 Command",
      "SPN_Description": "The command to a Turbocharger Wastegate actuator 2, normalized to percent, where 0% nominally represents fully closed (No Flow) and 100% represents fully open (Max Flow).",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5388": {
      "PGN": 64755,
      "PGN_Name": "Engine Turbocharger Compressor Bypass Information",
      "PGN_Description": "ETCBI",
      "first_bit": 0,
      "SPN": 5388,
      "SPN_Name": "Engine Turbocharger Compressor Bypass Actuator 2 Position",
      "SPN_Description": "Measures the position of the turbocharger compressor bypass actuator 2, where 0% represents bypass fully closed and 100% represents bypass fully open. Typically, the compressor bypass is used to lower the compressor outlet pressure and/or intake manifold pressure during situations where too much boost is being generated by the turbocharger. Typically, a compressor bypass will be plumbed from the compressor outlet or intake manifold back to the compressor inlet, with the compressor bypass actuator and valve in place to regulate bypass flow.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5389": {
      "PGN": 64755,
      "PGN_Name": "Engine Turbocharger Compressor Bypass Information",
      "PGN_Description": "ETCBI",
      "first_bit": 8,
      "SPN": 5389,
      "SPN_Name": "Engine Turbocharger Compressor Bypass Actuator 2 Desired Position",
      "SPN_Description": "The desired position of the Engine Turbocharger Compressor Bypass actuator 2 by the engine ECU, where 0% represents bypass fully closed and 100% represents bypass fully open.\r\n\r\nThis is the position that the device is attempting to achieve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5390": {
      "PGN": 64755,
      "PGN_Name": "Engine Turbocharger Compressor Bypass Information",
      "PGN_Description": "ETCBI",
      "first_bit": 16,
      "SPN": 5390,
      "SPN_Name": "Engine Turbocharger compressor Bypass Actuator 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Engine Turbocharger Compressor Bypass Actuator 1 by the manufacturers software.  When there is multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5391": {
      "PGN": 64755,
      "PGN_Name": "Engine Turbocharger Compressor Bypass Information",
      "PGN_Description": "ETCBI",
      "first_bit": 21,
      "SPN": 5391,
      "SPN_Name": "Engine Turbocharger Compressor Bypass Actuator 2 Temperature Status",
      "SPN_Description": "Used to identify the status of the Engine Turbocharger Compresssor Bypass Actuator 2 drive circuitry temperature.  Temperature excursions may affect the torque output.\r\n\r\n000 – High most severe\r\n001 – High Least severe\r\n010 – In Range\r\n011 – Low Least severe\r\n100 – Low Most severe\r\n101 – Not Defined\r\n110 – Error\r\n111 – Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5398": {
      "PGN": 61443,
      "PGN_Name": "Electronic Engine Controller 2",
      "PGN_Description": "EEC2",
      "first_bit": 56,
      "SPN": 5398,
      "SPN_Name": "Estimated Pumping - Percent Torque",
      "SPN_Description": "The calculated torque that indicates the estimated amount of torque loss due to the engine air handling system. The value transmitted in this parameter is included in SPN 514 (Nominal Friction - Percent Torque).  The data is transmitted as a percent of reference engine torque (see the engine configuration message, PGN 65251).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "5399": {
      "PGN": 61443,
      "PGN_Name": "Electronic Engine Controller 2",
      "PGN_Description": "EEC2",
      "first_bit": 44,
      "SPN": 5399,
      "SPN_Name": "DPF Thermal Management Active",
      "SPN_Description": "Indicates that the exhaust temperatures have been elevated for regeneration of the diesel particulate filter aftertreatment system or in preparation of regeneration of the diesel particulate aftertreatment system.\r\n\n00 - DPF Thermal Management is not active\r\n01 - DPF Thermal Management is active\r\n10 - Reserved\r\n11 - Don't care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5400": {
      "PGN": 61443,
      "PGN_Name": "Electronic Engine Controller 2",
      "PGN_Description": "EEC2",
      "first_bit": 46,
      "SPN": 5400,
      "SPN_Name": "SCR Thermal Management Active",
      "SPN_Description": "Indicates that the exhaust temperatures have been elevated for regeneration of the SCR aftertreatment system or in preparation of regeneration of the SCR aftertreatment system.\r\n\n00 - SCR Thermal Management is not active\r\n01 - SCR Thermal Management is active\r\n10 - Reserved\r\n11 - Don't care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5402": {
      "PGN": 61484,
      "PGN_Name": "Magnet Status Information 2",
      "PGN_Description": "MSI2",
      "first_bit": 34,
      "SPN": 5402,
      "SPN_Name": "Lift Relay Control",
      "SPN_Description": "Command signal used to Engage and Disengage the Lift Relay controlling a Steady-State Magnet.\r\n\n00 = Off, Disable Lift Relay Request \r\n01 = On, Enable Lift Relay Request\r\n10 = Reserved\r\n11 = Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5403": {
      "PGN": 61484,
      "PGN_Name": "Magnet Status Information 2",
      "PGN_Description": "MSI2",
      "first_bit": 36,
      "SPN": 5403,
      "SPN_Name": "Drop Relay Control",
      "SPN_Description": "Command signal used to Engage and Disengage the Drop Relay controlling a Steady-State Magnet.\r\n\n00 = Off, Disable Drop Relay Request\r\n01 = On, Enable Drop Relay Request\r\n10 = Reserved\r\n11 = Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5404": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 58,
      "SPN": 5404,
      "SPN_Name": "PTO Shutdown has Shutdown Engine",
      "SPN_Description": "Status signal which identifies whether or not the engine has been shutdown by the PTO shutdown system.\r\n\n00 - No\r\n01 - Yes\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5405": {
      "PGN": 61453,
      "PGN_Name": "Land Leveling System Operational Information",
      "PGN_Description": "LOI",
      "first_bit": 36,
      "SPN": 5405,
      "SPN_Name": "Set Elevation Sensor #1 Reference Elevation",
      "SPN_Description": "Command from a display or other external device (i.e. remote switch) to the land leveling system controller instructing the controller to set the reference elvation based on data received from the corresponding land leveling sensor.\r\n\n00 = Do not Set Reference Elevation\r\n01 = Set Reference Elevation\r\n10 = Reserved\r\n11 = Don't Care / Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5406": {
      "PGN": 61453,
      "PGN_Name": "Land Leveling System Operational Information",
      "PGN_Description": "LOI",
      "first_bit": 38,
      "SPN": 5406,
      "SPN_Name": "Set Elevation Sensor #2 Reference Elevation",
      "SPN_Description": "Command from a display or other external device (i.e. remote switch) to the land leveling system controller instructing the controller to set the reference elvation based on data received from the corresponding land leveling sensor.\r\n\r\n00 = Do not Set Reference Elevation\r\n01 = Set Reference Elevation\r\n10 = Reserved\r\n11 = Don't Care / Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5407": {
      "PGN": 65138,
      "PGN_Name": "Laser Leveling System Blade Control",
      "PGN_Description": "LBC",
      "first_bit": 24,
      "SPN": 5407,
      "SPN_Name": "Blade Control Mode - Left",
      "SPN_Description": "Indicate if the land leveling system's automatic control is active or inactive for the elevation sensor on the left side of the blade.  The \"left\" notation is applicable to grading machines such tractors and motor graders where \"left\" is the position of the elevation sensor as seen by the operator.\r\n\nIf the left sensor is not installed, then the value communicated should be \"1111\".  For systems with a single elevation sensor, the system should be flexible enough to be configured in a manner which most accurately represents what is installed on the machine.\r\n\nManual: Operator controls the position of the blade as normal\r\nAuto:  The grade control system is controlling the position of the blade without operator input\r\nInactive Auto: An operating condition exists which prevents the grade control system from allowing automatic controls to engage.  This would include conditions such as laser signal is not detected, but not faulty components.\r\nError:  A fault exists in the system.\r\n\r\n0000 = Manual\r\n0001 = Auto \r\n0010 = Inactive Auto\r\n0011-1101 = Reserved\r\n1110 = Error\r\n1111 = Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5408": {
      "PGN": 65138,
      "PGN_Name": "Laser Leveling System Blade Control",
      "PGN_Description": "LBC",
      "first_bit": 28,
      "SPN": 5408,
      "SPN_Name": "Blade Control Mode - Right",
      "SPN_Description": "Indicate if the land leveling system's automatic control is active or inactive for the elevation sensor on the right side of the blade.  The \"left\" notation is applicable to grading machines such tractors and motor graders where \"right\" is the position of the elevation sensor as seen by the operator.\r\n\r\nIf the right sensor is not installed, then the value communicated should be \"1111\".  For systems with a single elevation sensor, the system should be flexible enough to be configured in a manner which most accurately represents what is installed on the machine.\r\n\nManual: Operator controls the position of the blade as normal\r\nAuto:  The grade control system is controlling the position of the blade without operator input\r\nInactive Auto: An operating condition exists which prevents the grade control system from allowing automatic controls to engage.  This would include conditions such as laser signal is not detected, but not faulty components.\r\nError:  A fault exists in the system.\r\n\r\n0000 = Manual\r\n0001 = Auto \r\n0010 = Inactive Auto\r\n0011-1101 = Reserved\r\n1110 = Error\r\n1111 = Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5409": {
      "PGN": 65138,
      "PGN_Name": "Laser Leveling System Blade Control",
      "PGN_Description": "LBC",
      "first_bit": 32,
      "SPN": 5409,
      "SPN_Name": "Land Leveling System Enable Status",
      "SPN_Description": "Communicate the enable/disable status of the Land Leveling System.\r\n\n00 = Disabled\r\n01= Enabled\r\n10 = Error\r\n11 = Not available / Not installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5410": {
      "PGN": 64750,
      "PGN_Name": "Land Leveling System Reference Elevation Data",
      "PGN_Description": "LLRE",
      "first_bit": 0,
      "SPN": 5410,
      "SPN_Name": "Blade Elevation Deviation - Left",
      "SPN_Description": "Indicate the blade's left elevation deviation with respect to the reference elevation.  Serves as an indication of how far the left end of the blade is above or below grade.  A positive number indicates that the blade is above the desired grade.  A negative value indicates the blade is below the desired grade.",
      "bit_length": 16,
      "scaling": 1,
      "offset": -32000,
      "unit": "mm",
      "SLOT_ID": 235
    },
    "5411": {
      "PGN": 64750,
      "PGN_Name": "Land Leveling System Reference Elevation Data",
      "PGN_Description": "LLRE",
      "first_bit": 16,
      "SPN": 5411,
      "SPN_Name": "Blade Elevation Deviation - Right",
      "SPN_Description": "Indicate the blade's right elevation deviation with respect to the reference elevation.  Serves as an indication of how far the left end of the blade is above or below grade.  A positive number indicates that the blade is above the desired grade.  A negative value indicates the blade is below the desired grade.",
      "bit_length": 16,
      "scaling": 1,
      "offset": -32000,
      "unit": "mm",
      "SLOT_ID": 235
    },
    "5412": {
      "PGN": 64750,
      "PGN_Name": "Land Leveling System Reference Elevation Data",
      "PGN_Description": "LLRE",
      "first_bit": 32,
      "SPN": 5412,
      "SPN_Name": "Blade Reference Elevation Offset - Left",
      "SPN_Description": "Indicates the blade's left elevation offset with respect to the reference elevation.  An offset of 0 m represents no offset from the reference elevation.  A positive number indicates that the offset elevation is above the original reference elevation.  A negative value indicates the offset elevation is below the original reference elevation.",
      "bit_length": 16,
      "scaling": 1,
      "offset": -32000,
      "unit": "mm",
      "SLOT_ID": 235
    },
    "5413": {
      "PGN": 64750,
      "PGN_Name": "Land Leveling System Reference Elevation Data",
      "PGN_Description": "LLRE",
      "first_bit": 48,
      "SPN": 5413,
      "SPN_Name": "Blade Reference Elevation Offset - Right",
      "SPN_Description": "Indicates the blade's right elevation offset with respect to the reference elevation.  An offset of 0 m represents no offset from the reference elevation.  A positive number indicates that the offset elevation is above the original reference elevation.  A negative value indicates the offset elevation is below the original reference elevation.",
      "bit_length": 16,
      "scaling": 1,
      "offset": -32000,
      "unit": "mm",
      "SLOT_ID": 235
    },
    "5414": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 24,
      "SPN": 5414,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Heater Command",
      "SPN_Description": "The command for the heater of the diesel exhaust fluid quick thaw tank for aftertreatment system 1 (exhaust bank 1).  See SPN 4372 for the measured heater percentage for the heater of this same tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5415": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 24,
      "SPN": 5415,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Heater Command",
      "SPN_Description": "The command for the heater of the diesel exhaust fluid quick thaw tank for aftertreatment system 2 (exhaust bank 2).  See SPN 4438 for the measured heater percentage for the heater of this same tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5416": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 62,
      "SPN": 5416,
      "SPN_Name": "Engine Wait To Start Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Wait To Start Lamp.  See SPN 1081 for the command.\r\n\n00 - Lamp deactived (off)\r\n01 - Lamp actived (on)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5417": {
      "PGN": 64752,
      "PGN_Name": "Engine Fuel/lube systems 2",
      "PGN_Description": "EFS2",
      "first_bit": 0,
      "SPN": 5417,
      "SPN_Name": "Engine Fuel Filter (Suction Side) Intake Absolute Pressure",
      "SPN_Description": "Absolute pressure of fuel at the intake of the fuel filter (suction side) located between the fuel tank and the fuel supply pump.  See Figures SPN16_A & SPN16_B.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "5422": {
      "PGN": 64976,
      "PGN_Name": "Intake/Exhaust Conditions 2",
      "PGN_Description": "IC2",
      "first_bit": 56,
      "SPN": 5422,
      "SPN_Name": "Engine Intake Manifold 2 Absolute Pressure",
      "SPN_Description": "The absolute pressure measurement of the air intake manifold for bank 2 or the second air intake manifold. If there are multiple air pressure sensors in the intake stream, this is the last one in flow direction before entering the combustion chamber.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "5423": {
      "PGN": 64869,
      "PGN_Name": "Aftertreatment 1 Fuel Control 2",
      "PGN_Description": "AT1FC2",
      "first_bit": 16,
      "SPN": 5423,
      "SPN_Name": "Aftertreatment 1 Fuel Pump Relay Control",
      "SPN_Description": "Indicates how the device is controlling the aftertreatment 1 fuel pump relay.\r\n\r\n00 off\r\n01 on\r\n10 reserved for SAE assignment\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5424": {
      "PGN": 64869,
      "PGN_Name": "Aftertreatment 1 Fuel Control 2",
      "PGN_Description": "AT1FC2",
      "first_bit": 18,
      "SPN": 5424,
      "SPN_Name": "Aftertreatment 1 Fuel Flow Diverter Valve Control",
      "SPN_Description": "Indicates how the device is controlling the aftertreatment 1 fuel flow diverter valve. When this valve is on it diverts fuel flow from the Aftertreatment 1 Regeneration Device.\r\n\r\n00 off\r\n01 on\r\n10 reserved for SAE assignment\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5425": {
      "PGN": 64869,
      "PGN_Name": "Aftertreatment 1 Fuel Control 2",
      "PGN_Description": "AT1FC2",
      "first_bit": 24,
      "SPN": 5425,
      "SPN_Name": "Aftertreatment 1 Fuel Pressure 2 Actuator Control",
      "SPN_Description": "Indicates how the device is controlling the aftertreatment 1 fuel pressure 2 regulating control valve.   0% = fully closed, 100%=fully open.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5426": {
      "PGN": 64836,
      "PGN_Name": "Aftertreatment 2 Fuel Control 2",
      "PGN_Description": "AT2FC2",
      "first_bit": 16,
      "SPN": 5426,
      "SPN_Name": "Aftertreatment 2 Fuel Pump Relay Control",
      "SPN_Description": "Indicates how the device is controlling the aftertreatment 2 fuel pump relay.\r\n\r\n00 off\r\n01 on\r\n10 reserved for SAE assignment\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5427": {
      "PGN": 64836,
      "PGN_Name": "Aftertreatment 2 Fuel Control 2",
      "PGN_Description": "AT2FC2",
      "first_bit": 18,
      "SPN": 5427,
      "SPN_Name": "Aftertreatment 2 Fuel Flow Diverter Valve Control",
      "SPN_Description": "Indicates how the device is controlling the aftertreatment 2 fuel flow diverter valve. When this valve is on it diverts fuel flow from the Aftertreatment 2 Regeneration Device.\r\n\r\n00 off\r\n01 on\r\n10 reserved for SAE assignment\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5428": {
      "PGN": 64836,
      "PGN_Name": "Aftertreatment 2 Fuel Control 2",
      "PGN_Description": "AT2FC2",
      "first_bit": 24,
      "SPN": 5428,
      "SPN_Name": "Aftertreatment 2 Fuel Pressure 2 Control",
      "SPN_Description": "Indicates how the device is controlling the aftertreatment 2 fuel pressure 2 regulating control valve.   0% = fully closed, 100%=fully open.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5429": {
      "PGN": 64768,
      "PGN_Name": "Engine Fluid Level/Pressure 10",
      "PGN_Description": "EFL/P10",
      "first_bit": 40,
      "SPN": 5429,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Intake Absolute Pressure",
      "SPN_Description": "EGR intake absolute pressure measured before the EGR 2 valve.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "5430": {
      "PGN": 64751,
      "PGN_Name": "Engine Fluid Level/Pressure 11",
      "PGN_Description": "EFL/P11",
      "first_bit": 0,
      "SPN": 5430,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Intake Absolute Pressure",
      "SPN_Description": "EGR intake absolute pressure measured before the EGR 1 valve.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "5431": {
      "PGN": 64751,
      "PGN_Name": "Engine Fluid Level/Pressure 11",
      "PGN_Description": "EFL/P11",
      "first_bit": 16,
      "SPN": 5431,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Outlet Absolute Pressure (High Resolution)",
      "SPN_Description": "EGR outlet absolute pressure is measured after the EGR 1 valve. See SPN 5019 for 1 byte resolution.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "5432": {
      "PGN": 65114,
      "PGN_Name": "Air Suspension Control 1",
      "PGN_Description": "ASC1",
      "first_bit": 60,
      "SPN": 5432,
      "SPN_Name": "Memory level",
      "SPN_Description": "Signal which indicates that the air suspension control has memory levels selected or stored.\r\n\r\nResponse to memory level request in ASC2 (byte 8.5). If the request was executed the respective status will be set. If the request was not executed \"requested level not available\" will be set in Suspension control refusal information (ASC1 byte 8.1). \r\n\n0000: No memory level \r\n0001: Memory level 1 selected \r\n0010: Memory level 2 selected\r\n0011: Memory level 3 selected\r\n0100: Memory level 4 selected\r\n0101: Memory level 5 selected\r\n0110: reserved\r\n0111: reserved\r\n1000: reserved\r\n1001: Memory level  1 stored\r\n1010: Memory level  2 stored\r\n1011: Memory level  3 stored\r\n1100: Memory level  4 stored\r\n1101: Memory level  5 stored\r\n1110: Error indicator\r\n1111: not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5433": {
      "PGN": 53760,
      "PGN_Name": "Air Suspension Control 2",
      "PGN_Description": "ASC2",
      "first_bit": 60,
      "SPN": 5433,
      "SPN_Name": "Memory level request",
      "SPN_Description": "Signal which indicates that the air suspension control requests a memory level or a memory level shall be stored.\r\n\r\nThe storage of  the current memory level is requested by  \"Store memory level x\". The acknowledge is set in \"memory level x stored\" (ASC1 byte 8.5). A memory level demand is requested by \"Memory level x request\".  The acknowledge is set in \"memory level x selected\" (ASC1 byte 8.5)\r\n\n0000: No memory level request\r\n0001: Memory level 1 request\r\n0010: Memory level 2 request\r\n0011: Memory level 3 request\r\n0100: Memory level 4 request\r\n0101: Memory level 5 request\r\n0110: reserved\r\n0111: reserved\r\n1000: reserved\r\n1001: Store Memory level  1\r\n1010: Store Memory level  2\r\n1011: Store Memory level  3\r\n1100: Store Memory level  4\r\n1101: Store Memory level  5\r\n1110: Reserved\r\n1111: Don't care",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5434": {
      "PGN": 64828,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A1DEFSI",
      "first_bit": 32,
      "SPN": 5434,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank Fill Valve Command",
      "SPN_Description": "Commanded percentage of maximum Aftertreatment 1 Diesel Exhaust Fluid Tank Fill Valve opening. 100% means the fill valve is fully open providing maximum flow of diesel exhaust fluid into the diesel exhaust fluid tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5435": {
      "PGN": 64828,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A1DEFSI",
      "first_bit": 40,
      "SPN": 5435,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Pump State",
      "SPN_Description": "State of the aftertreatment 1 Diesel Exhaust Fluid dosing pump.  Indicates whether or not the pump is operational.\r\n\r\n00  pump operational\r\n01  pump error\r\n10  reserved for SAE assignment\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5436": {
      "PGN": 64828,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A1DEFSI",
      "first_bit": 48,
      "SPN": 5436,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank Drain Valve Command",
      "SPN_Description": "Commanded percentage of maximum Aftertreatment 1 Diesel Exhaust Fluid Tank Drain Valve opening. 100% means the drain valve is fully open providing maximum flow of diesel exhaust fluid out of the diesel exhaust fluid tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5437": {
      "PGN": 64819,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A2DEFSI",
      "first_bit": 32,
      "SPN": 5437,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank Fill Valve Command",
      "SPN_Description": "Commanded percentage of maximum Aftertreatment 2 Diesel Exhaust Fluid Tank Fill Valve opening. 100% means the fill valve is fully open providing maximum flow of diesel exhaust fluid into the diesel exhaust fluid tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5438": {
      "PGN": 64819,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A2DEFSI",
      "first_bit": 40,
      "SPN": 5438,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Pump State",
      "SPN_Description": "State of Aftertreatment 2 Diesel Exhaust Fluid dosing pump.\r\n\n00  pump operational\r\n01  pump error\r\n10  reserved for SAE assignment\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5439": {
      "PGN": 64819,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A2DEFSI",
      "first_bit": 48,
      "SPN": 5439,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank Drain Valve Command",
      "SPN_Description": "Commanded percentage of maximum Aftertreatment 2 Diesel Exhaust Fluid Tank Drain Valve opening. 100% means the the drain valve is fully open providing maximum flow of diesel exhaust fluid out of  the diesel exhaust fluid tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5444": {
      "PGN": 64916,
      "PGN_Name": "Electronic Engine Controller 7",
      "PGN_Description": "EEC7",
      "first_bit": 32,
      "SPN": 5444,
      "SPN_Name": "Engine Crankcase Breather Oil Separator Speed",
      "SPN_Description": "The speed of a rotating (centrifugal) crankcase oil separator.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 223
    },
    "5445": {
      "PGN": 64754,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 1",
      "PGN_Description": "EFTVI1",
      "first_bit": 48,
      "SPN": 5445,
      "SPN_Name": "Engine Throttle Valve 1 Operation Status",
      "SPN_Description": "Used to identify the status of engine throttle valve 1 (SPN 51).\r\n\r\n0000 – Normal\r\n0001 – Alarm (fully operational but needs service)\r\n0010 – Alarm High Severity (functional but transient performance may be reduced)\r\n0011 – Derate Active (torque output reduced due to environmental conditions)\r\n0100 – Controlled Shutdown Active (driving to the default position – usually this means closed)\r\n0101 – Uncontrolled Shutdown Active (actuator current is off so it is limp)\r\n0110 – Calibration in Progress (must be broadcast at least once per calibration process defined in SPN 3464)\r\n0111 – 1101   Reserved for future assignment\r\n1110 – Error\r\n1111 – Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5446": {
      "PGN": 64754,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 1",
      "PGN_Description": "EFTVI1",
      "first_bit": 52,
      "SPN": 5446,
      "SPN_Name": "Engine Throttle Valve 2 Operation Status",
      "SPN_Description": "Used to identify the status of engine throttle valve 2 (SPN 3673).\r\n\r\n0000 – Normal\r\n0001 – Alarm (fully operational but needs service)\r\n0010 – Alarm High Severity (functional but transient performance may be reduced)\r\n0011 – Derate Active (torque output reduced due to environmental conditions)\r\n0100 – Controlled Shutdown Active (driving to the default position – usually this means closed)\r\n0101 – Uncontrolled Shutdown Active (actuator current is off so it is limp)\r\n0110 – 1101   Reserved for future assignment\r\n1110 – Error",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5447": {
      "PGN": 64754,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 1",
      "PGN_Description": "EFTVI1",
      "first_bit": 56,
      "SPN": 5447,
      "SPN_Name": "Engine Fuel Valve 1 Operation Status",
      "SPN_Description": "Used to identify the status of Engine Fuel Valve 1.\r\n\r\n0000 – Normal\r\n0001 – Alarm (fully operational but needs service)\r\n0010 – Alarm High Severity (functional but transient performance may be reduced)\r\n0011 – Derate Active (torque output reduced due to environmental conditions)\r\n0100 – Controlled Shutdown Active (driving to the default position – usually this means closed)\r\n0101 – Uncontrolled Shutdown Active (actuator current is off so it is limp)\r\n0110 – Test Mode Active\r\n0111 – 1101   Reserved for future assignment\r\n1110 – Error",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5448": {
      "PGN": 64754,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 1",
      "PGN_Description": "EFTVI1",
      "first_bit": 60,
      "SPN": 5448,
      "SPN_Name": "Engine Fuel Valve 2 Operation Status",
      "SPN_Description": "Used to identify the status of Engine Fuel Valve 2.\r\n\r\n0000 – Normal\r\n0001 – Alarm (fully operational but needs service)\r\n0010 – Alarm High Severity (functional but transient performance may be reduced)\r\n0011 – Derate Active (torque output reduced due to environmental conditions)\r\n0100 – Controlled Shutdown Active (driving to the default position – usually this means closed)\r\n0101 – Uncontrolled Shutdown Active (actuator current is off so it is limp)\r\n0110 – Test Mode Active\r\n0111 – 1101   Reserved for future assignment\r\n1110 – Error",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5449": {
      "PGN": 64755,
      "PGN_Name": "Engine Turbocharger Compressor Bypass Information",
      "PGN_Description": "ETCBI",
      "first_bit": 24,
      "SPN": 5449,
      "SPN_Name": "Engine Turbocharger Compressor Bypass Actuator 1 Operation Status",
      "SPN_Description": "Used to identify the status of Engine Turbocharger Compressor Bypass Actuator 1.\r\n\r\n0000 – Normal\r\n0001 – Alarm (fully operational but needs service)\r\n0010 – Alarm High Severity (functional but transient performance may be reduced)\r\n0011 – Derate Active (torque output reduced due to environmental conditions)\r\n0100 – Controlled Shutdown Active (driving to the default position – usually this means closed)\r\n0101 – Uncontrolled Shutdown Active (actuator current is off so it is limp)\r\n0110 – 1101   Reserved for future assignment\r\n1110 – Error",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5450": {
      "PGN": 64755,
      "PGN_Name": "Engine Turbocharger Compressor Bypass Information",
      "PGN_Description": "ETCBI",
      "first_bit": 28,
      "SPN": 5450,
      "SPN_Name": "Engine Turbocharger Compressor Bypass Actuator 2 Operation Status",
      "SPN_Description": "Used to identify the status of Engine Turbocharger Compressor Bypass Actuator 2.\r\n\r\n0000 – Normal\r\n0001 – Alarm (fully operational but needs service)\r\n0010 – Alarm High Severity (functional but transient performance may be reduced)\r\n0011 – Derate Active (torque output reduced due to environmental conditions)\r\n0100 – Controlled Shutdown Active (driving to the default position – usually this means closed)\r\n0101 – Uncontrolled Shutdown Active (actuator current is off so it is limp)\r\n0110 – 1101   Reserved for future assignment\r\n1110 – Error",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5451": {
      "PGN": 64753,
      "PGN_Name": "Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information",
      "PGN_Description": "ETWAI",
      "first_bit": 8,
      "SPN": 5451,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 1 Operation Status",
      "SPN_Description": "Used to identify the status of Engine Turbocharger Wastegate Actuator 1.\r\n\r\n0000 – Normal\r\n0001 – Alarm (fully operational but needs service)\r\n0010 – Alarm High Severity (functional but transient performance may be reduced)\r\n0011 – Derate Active (torque output reduced due to environmental conditions)\r\n0100 – Controlled Shutdown Active (driving to the default position – usually this means closed)\r\n0101 – Uncontrolled Shutdown Active (actuator current is off so it is limp)\r\n0110 – Calibration in Progress (must be broadcast at least once per calibration process defined in SPN 5386)\r\n0111 – 1101   Reserved for future assignment\r\n1110 – Error",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5452": {
      "PGN": 64753,
      "PGN_Name": "Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information",
      "PGN_Description": "ETWAI",
      "first_bit": 12,
      "SPN": 5452,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 2 Operation Status",
      "SPN_Description": "Used to identify the status of Engine Turbocharger Wastegate Actuator 2.\r\n\r\n0000 – Normal\r\n0001 – Alarm (fully operational but needs service)\r\n0010 – Alarm High Severity (functional but transient performance may be reduced)\r\n0011 – Derate Active (torque output reduced due to environmental conditions)\r\n0100 – Controlled Shutdown Active (driving to the default position – usually this means closed)\r\n0101 – Uncontrolled Shutdown Active (actuator current is off so it is limp)\r\n0110 – 1101   Reserved for future assignment\r\n1110 – Error",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5454": {
      "PGN": 64920,
      "PGN_Name": "Aftertreatment 1 Historical Information 1",
      "PGN_Description": "AT1HI1",
      "first_bit": 256,
      "SPN": 5454,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Average Time Between Active Regenerations",
      "SPN_Description": "Indicates the average time since last reset between active regenerations, that have not been forced to occur by manual request, for Aftertreatment device 1.\r\n\r\nIf the manufacturer allows this parameter to be reset, this time is the average since last reset.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "5455": {
      "PGN": 64921,
      "PGN_Name": "Aftertreatment 2 Historical information 1",
      "PGN_Description": "AT2HI1",
      "first_bit": 256,
      "SPN": 5455,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Average Time Between Active Regenerations",
      "SPN_Description": "Indicates the average time since last reset between active regenerations, that have not been forced to occur by manual request, for Aftertreatment device 2.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "5456": {
      "PGN": 64869,
      "PGN_Name": "Aftertreatment 1 Fuel Control 2",
      "PGN_Description": "AT1FC2",
      "first_bit": 40,
      "SPN": 5456,
      "SPN_Name": "Aftertreatment 1 Hydrocarbon Doser Intake Fuel Temperature",
      "SPN_Description": "Measured temperature of the intake fuel to the hydrocarbon dosing device.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5457": {
      "PGN": 64981,
      "PGN_Name": "Electronic Engine Controller 5",
      "PGN_Description": "EEC5",
      "first_bit": 52,
      "SPN": 5457,
      "SPN_Name": "Engine Variable Geometry Turbocharger 1 Control Mode",
      "SPN_Description": "Indicates if the variable geometry turbocharger control status is either open loop or closed loop.\r\n\r\n00 open loop\r\n01 closed loop\r\n10 SAE reserved\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5458": {
      "PGN": 65203,
      "PGN_Name": "Fuel Information 1 (Liquid)",
      "PGN_Description": "LFI1",
      "first_bit": 48,
      "SPN": 5458,
      "SPN_Name": "Flexible Fuel Percentage",
      "SPN_Description": "Measured signal that indicates the percentage of alcohol in the fuel currently being used.  0% means no alcohol in fuel, 100% means alcohol as fuel and nothing else.\r\n\r\nEXAMPLE: If a Bi-fuel vehicle has less than 10% ethanol in the gasoline/petrol, then the external test equipment shall display state 0x09 (See SPN 5837). In such a case, the system would be using gasoline/petrol (fuel) tables and OBD thresholds. SPN 5458 should either artificially display 0% or some number 10% or less if the system has such resolution. If the ethanol in the gasoline/petrol is above 10%, then the external test equipment shall display state 0x0B. SPN 5458 shall report the calculated ethanol/alcohol percentage.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5459": {
      "PGN": 64748,
      "PGN_Name": "Aftertreatment 1 NOx Adsorber Information",
      "PGN_Description": "AFT1NAI",
      "first_bit": 0,
      "SPN": 5459,
      "SPN_Name": "Aftertreatment 1 NOx Adsorber Regeneration Status",
      "SPN_Description": "Indicates whether the NOx adsorber regeneration in the first aftertreatment system is active or inactive.\r\n\r\n00  Inactive\r\n01  Active\r\n10  Error indicator\r\n11  Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5460": {
      "PGN": 64747,
      "PGN_Name": "Aftertreatment 2 NOx Adsorber Information",
      "PGN_Description": "AFT2NAI",
      "first_bit": 0,
      "SPN": 5460,
      "SPN_Name": "Aftertreatment 2 NOx Adsorber Regeneration Status",
      "SPN_Description": "Indicates whether the NOx adsorber regeneration in the second aftertreatment system is active or inactive\r\n\r\n00  Inactive\r\n01  Active\r\n10  Error indicator\r\n11  Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5461": {
      "PGN": 64748,
      "PGN_Name": "Aftertreatment 1 NOx Adsorber Information",
      "PGN_Description": "AFT1NAI",
      "first_bit": 2,
      "SPN": 5461,
      "SPN_Name": "Aftertreatment 1 NOx Adsorber Desulfation Status",
      "SPN_Description": "Indicates whether the NOx adsorber desulfation regeneration in the first aftertreatment system is active or inactive\r\n\r\n00  Inactive\r\n01  Active\r\n10  Error indicator\r\n11  Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5462": {
      "PGN": 64747,
      "PGN_Name": "Aftertreatment 2 NOx Adsorber Information",
      "PGN_Description": "AFT2NAI",
      "first_bit": 2,
      "SPN": 5462,
      "SPN_Name": "Aftertreatment 2 NOx Adsorber Desulfation Status",
      "SPN_Description": "Indicates whether the NOx adsorber desulfation regeneration in the second aftertreatment system is active or inactive\r\n\r\n00  Inactive\r\n01  Active\r\n10  Error indicator\r\n11  Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5463": {
      "PGN": 64878,
      "PGN_Name": "Aftertreatment 1 SCR Service Information 1",
      "PGN_Description": "A1SCRSI1",
      "first_bit": 40,
      "SPN": 5463,
      "SPN_Name": "Aftertreatment SCR Operator Inducement Active Traveled Distance",
      "SPN_Description": "The distance traveled while SCR inducement (SPN 5246 is equal to level 1 to 5) is active.  Distance is reset once inducement is no longer active for SCR (SPN 5246 = 0).\r\n\r\nEmission Control System Operator Inducement Severity, SPN 5826, may be active (is equal to level 1 to 5) due to an SCR condition specified by emissions regulations that is associated with SPN 5246.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 270
    },
    "5464": {
      "PGN": 64695,
      "PGN_Name": "Hybrid System Status 2",
      "PGN_Description": "HSS2",
      "first_bit": 0,
      "SPN": 5464,
      "SPN_Name": "Hybrid Battery Pack Remaining Charge",
      "SPN_Description": "Indicates the hybrid battery pack remaining charge. 0% means no charge remaining, 100% means full charge remaining.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5465": {
      "PGN": 65214,
      "PGN_Name": "Electronic Engine Controller 4",
      "PGN_Description": "EEC4",
      "first_bit": 34,
      "SPN": 5465,
      "SPN_Name": "Engine Intake Manifold Pressure Control Mode",
      "SPN_Description": "Indicates that the Boost Pressure Closed Loop Control status either open loop or closed loop.\r\n\r\n00  Open loop \r\n01  Closed loop \r\n10  SAE reserved\r\n11  Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5466": {
      "PGN": 64891,
      "PGN_Name": "Aftertreatment 1 Service 1",
      "PGN_Description": "AT1S1",
      "first_bit": 48,
      "SPN": 5466,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Soot Load Regeneration Threshold",
      "SPN_Description": "This parameter indicates the value that will first cause DPF regeneration in aftertreatment 1. There may be multiple parameters that cause DPF regeneration (e.g. Percent Soot Load, DPF delta pressure converted to normalized percentage, etc.).  If there are multiple inputs to this parameter that may cause active DPF regeneration, the highest value shall always be reported.\r\n\r\n100% is the level at which active diesel particulate filter regeneration should be triggered. 100% level is the active regeneration trigger level (and if conditions are not favorable for regeneration, soot loading can continue beyond 100%). During normal operation and regeneration a value 0% will indicate a fully regenerated diesel particulate filter. Values of 25%, 50% and 75% will indicate the general level of soot prior to the 100% level where an active regeneration is needed.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5467": {
      "PGN": 64890,
      "PGN_Name": "Aftertreatment 2 Service 1",
      "PGN_Description": "AT2S1",
      "first_bit": 48,
      "SPN": 5467,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Soot Load Regeneration Threshold",
      "SPN_Description": "This parameter indicates the value that will first cause DPF regeneration in aftertreatment 2. There may be multiple parameters that cause DPF regeneration (e.g. Percent Soot Load, DPF delta pressure converted to normalized percentage, etc.).  If there are multiple inputs to this parameter that may cause active DPF regeneration, the highest value shall always be reported.\r\n\r\n100% is the level at which active diesel particulate filter regeneration should be triggered. 100% level is the active regeneration trigger level (and if conditions are not favorable for regeneration, soot loading can continue beyond 100%). During normal operation and regeneration a value 0% will indicate a fully regenerated diesel particulate filter. Values of 25%, 50% and 75% will indicate the general level of soot prior to the 100% level where an active regeneration is needed.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5468": {
      "PGN": 64776,
      "PGN_Name": "Engine oil message",
      "PGN_Description": "EOM",
      "first_bit": 32,
      "SPN": 5468,
      "SPN_Name": "Engine Oil Relative Dielectricity (High Resolution)",
      "SPN_Description": "Engine oil relative dielectricity used to describe the engine oil quality.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": 0,
      "unit": null,
      "SLOT_ID": 307
    },
    "5469": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 22,
      "SPN": 5469,
      "SPN_Name": "Engine Fuel Filter Restricted Lamp Command",
      "SPN_Description": "Command signal directly controlling the Engine Fuel Filter Restricted Lamp.\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5470": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 22,
      "SPN": 5470,
      "SPN_Name": "Engine Fuel Filter Restricted Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Fuel Filter Restricted Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5471": {
      "PGN": 64743,
      "PGN_Name": "Engine Configuration 3",
      "PGN_Description": "EC3",
      "first_bit": 0,
      "SPN": 5471,
      "SPN_Name": "Engine Friction Percent Torque At Idle, Point 1",
      "SPN_Description": "The static portion of the friction torque at speed point 1 (SPN 188) of the engine torque map in the engine configuration message.  This parameter does not include Estimated Pumping – Percent Torque (SPN 5398) and is expected to change with temperature.  The data is transmitted as a percent of the reference engine torque (SPN 544).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "5472": {
      "PGN": 64743,
      "PGN_Name": "Engine Configuration 3",
      "PGN_Description": "EC3",
      "first_bit": 8,
      "SPN": 5472,
      "SPN_Name": "Engine Friction Percent Torque, Point 2",
      "SPN_Description": "The static portion of the friction torque at speed point 2 (SPN 528) of the engine torque map in the engine configuration message.  This parameter does not include Estimated Pumping – Percent Torque (SPN 5398) and is expected to change with temperature.  The data is transmitted as a percent of the reference engine torque (SPN 544).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "5473": {
      "PGN": 64743,
      "PGN_Name": "Engine Configuration 3",
      "PGN_Description": "EC3",
      "first_bit": 16,
      "SPN": 5473,
      "SPN_Name": "Engine Friction Percent Torque, Point 3",
      "SPN_Description": "The static portion of the friction torque at speed point 3 (SPN 529) of the engine torque map in the engine configuration message.  This parameter does not include Estimated Pumping – Percent Torque (SPN 5398) and is expected to change with temperature.  The data is transmitted as a percent of the reference engine torque (SPN 544).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "5474": {
      "PGN": 64743,
      "PGN_Name": "Engine Configuration 3",
      "PGN_Description": "EC3",
      "first_bit": 24,
      "SPN": 5474,
      "SPN_Name": "Engine Friction Percent Torque, Point 4",
      "SPN_Description": "The static portion of the friction torque at speed point 4 (SPN 530) of the engine torque map in the engine configuration message.  This parameter does not include Estimated Pumping – Percent Torque (SPN 5398) and is expected to change with temperature.  The data is transmitted as a percent of the reference engine torque (SPN 544).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "5475": {
      "PGN": 64743,
      "PGN_Name": "Engine Configuration 3",
      "PGN_Description": "EC3",
      "first_bit": 32,
      "SPN": 5475,
      "SPN_Name": "Engine Friction Percent Torque, Point 5",
      "SPN_Description": "The static portion of the friction torque at speed point 5 (SPN 531) of the engine torque map in the engine configuration message.  This parameter does not include Estimated Pumping – Percent Torque (SPN 5398) and is expected to change with temperature.  The data is transmitted as a percent of the reference engine torque (SPN 544).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "5476": {
      "PGN": 64743,
      "PGN_Name": "Engine Configuration 3",
      "PGN_Description": "EC3",
      "first_bit": 40,
      "SPN": 5476,
      "SPN_Name": "Engine Friction Percent Torque, Point 6",
      "SPN_Description": "For engine configuration map modes 1 and 2, this is the static portion of the friction torque at speed point 6 (SPN 532) of the engine torque map.  For engine configuration map mode 3, this parameter is the static portion of the friction torque at the engine speed calculated by using Engine Gain (Kp) Of The Endspeed Governor (SPN 545) where torque is 0.  This parameter does not include Estimated Pumping – Percent Torque (SPN 5398) and is expected to change with temperature.  The data is transmitted as a percent of the reference engine torque (SPN 544)..",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "5477": {
      "PGN": 64743,
      "PGN_Name": "Engine Configuration 3",
      "PGN_Description": "EC3",
      "first_bit": 48,
      "SPN": 5477,
      "SPN_Name": "Engine Friction Percent Torque, Point 7",
      "SPN_Description": "The static portion of the friction torque at speed point 7 (SPN 533) of the engine torque map in the engine configuration message.  This parameter does not include Estimated Pumping – Percent Torque (SPN 5398) and is expected to change with temperature.  The data is transmitted as a percent of the reference engine torque (SPN 544).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "5480": {
      "PGN": 64551,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Information 2",
      "PGN_Description": "A1DEFI2",
      "first_bit": 0,
      "SPN": 5480,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Controller 1 Temperature",
      "SPN_Description": "Temperature of the diesel exhaust fluid at the aftertreatment 1 diesel exhaust fluid controller.\r\n\r\nFor controllers that have more exhaust emissions control functions than only diesel exhaust fluid control, see SPN 5486 - exhaust emission control ECU temperature or SPN 1136 - engine ECU temperature.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5490": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 38,
      "SPN": 5490,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 5",
      "SPN_Description": "Identifies the diesel exhaust fluid line heater 5 request for aftertreatment system 2 (exhaust bank 2).\r\n\r\n00 request for heater to be inactive \r\n01 request for heater to be active \r\n10 reserved for future assignment by SAE \r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5491": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 40,
      "SPN": 5491,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater Relay 1",
      "SPN_Description": "The Aftertreatment Diesel Exhaust Fluid Line Heater Relay 1 is used to energize one or more DEF line heaters.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5492": {
      "PGN": 64745,
      "PGN_Name": "Armrest Switch Matrix Commands",
      "PGN_Description": "ARMSWIMC",
      "first_bit": 2,
      "SPN": 5492,
      "SPN_Name": "Armrest 1 Switch 2",
      "SPN_Description": "Status of the second switch located in armrest 1.\r\n\r\n00: Off\r\n01: On\r\n10: Reserved\r\n11: Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5493": {
      "PGN": 64745,
      "PGN_Name": "Armrest Switch Matrix Commands",
      "PGN_Description": "ARMSWIMC",
      "first_bit": 4,
      "SPN": 5493,
      "SPN_Name": "Armrest 2 Switch 1",
      "SPN_Description": "Status of the first switch located in armrest 2.\r\n\r\n00: Off\r\n01: On\r\n10: Reserved\r\n11: Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5494": {
      "PGN": 64745,
      "PGN_Name": "Armrest Switch Matrix Commands",
      "PGN_Description": "ARMSWIMC",
      "first_bit": 6,
      "SPN": 5494,
      "SPN_Name": "Armrest 2 Switch 2",
      "SPN_Description": "Status of the second switch located in armrest 2.\r\n\r\n00: Off\r\n01: On\r\n10: Reserved\r\n11: Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5495": {
      "PGN": 37888,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter Soot Sensor Calibration",
      "PGN_Description": "AT1DPFSSC",
      "first_bit": 0,
      "SPN": 5495,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Soot Mean Calibration Offset",
      "SPN_Description": "Calibration offset for the soot Mean for Aftertreatment 1 Diesel Particulate Filter soot sensor.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5496": {
      "PGN": 37888,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter Soot Sensor Calibration",
      "PGN_Description": "AT1DPFSSC",
      "first_bit": 16,
      "SPN": 5496,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Soot Standard Deviation Calibration Offset",
      "SPN_Description": "Calibration offset for the soot standard deviation for Aftertreatment 1 Diesel Particulate Filter soot sensor.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5497": {
      "PGN": 38144,
      "PGN_Name": "Aftertreatment 2 Diesel Particulate Filter Soot Sensor Calibration",
      "PGN_Description": "AT2DPFSSC",
      "first_bit": 0,
      "SPN": 5497,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Soot Mean Calibration Offset",
      "SPN_Description": "Calibration offset for the soot Mean for Aftertreatment 2 Diesel Particulate Filter soot sensor.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5498": {
      "PGN": 38144,
      "PGN_Name": "Aftertreatment 2 Diesel Particulate Filter Soot Sensor Calibration",
      "PGN_Description": "AT2DPFSSC",
      "first_bit": 16,
      "SPN": 5498,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Soot Standard Deviation Calibration Offset",
      "SPN_Description": "Calibration offset for the soot standard deviation for Aftertreatment 2 Diesel Particulate Filter soot sensor.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5499": {
      "PGN": 64744,
      "PGN_Name": "Intake Valve Actuation Control",
      "PGN_Description": "IVAC",
      "first_bit": 0,
      "SPN": 5499,
      "SPN_Name": "Intake Valve Actuation System Oil Pressure 1 Solenoid Control",
      "SPN_Description": "Indicates the current command to the solenoid that controls the intake valve actuation system oil pressure 1 valve. This valve opens or closes a connection from the intake valve actuation oil rail to tank.\r\n\r\n00 off\r\n01 on\r\n10 reserved for SAE assignment\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5500": {
      "PGN": 64744,
      "PGN_Name": "Intake Valve Actuation Control",
      "PGN_Description": "IVAC",
      "first_bit": 2,
      "SPN": 5500,
      "SPN_Name": "Intake Valve Actuation System Oil Pressure 2 Solenoid Control",
      "SPN_Description": "Indicates the current command to the solenoid that controls the intake valve actuation system oil pressure 2 valve. This valve opens or closes a connection from the intake valve actuation oil rail to tank.\r\n\r\n00 off\r\n01 on\r\n10 reserved for SAE assignment\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5501": {
      "PGN": 64736,
      "PGN_Name": "Diesel Particulate Filter Control 2",
      "PGN_Description": "DPFC2",
      "first_bit": 0,
      "SPN": 5501,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Intake Temperature Set Point",
      "SPN_Description": "Set point temperature for the particulate filter (DPF) regeneration at the intake to the DPF for Exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5502": {
      "PGN": 64736,
      "PGN_Name": "Diesel Particulate Filter Control 2",
      "PGN_Description": "DPFC2",
      "first_bit": 16,
      "SPN": 5502,
      "SPN_Name": "Engine Unburned Fuel Percentage",
      "SPN_Description": "The unburned amount of diesel fuel coming out of the engine. This fuel increases the temperature while oxidated in the DOC. Therefore, this amount of fuel also needs to be taken into account of the HCD temperature controller.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5503": {
      "PGN": 64736,
      "PGN_Name": "Diesel Particulate Filter Control 2",
      "PGN_Description": "DPFC2",
      "first_bit": 32,
      "SPN": 5503,
      "SPN_Name": "Aftertreatment 1 Fuel Mass Rate",
      "SPN_Description": "Mass rate of total fuel being delivered to aftertreatment 1 for DPF regeneration.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "g/min",
      "SLOT_ID": 317
    },
    "5504": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 56,
      "SPN": 5504,
      "SPN_Name": "Hydrocarbon Doser Purging Enable",
      "SPN_Description": "Purging enable of the Hydrocarbon Doser (HCD).\r\n\r\n00 Purging not enabled\r\n01 Purging enabled - less urgent\r\n10 Purging enabled - urgent\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5505": {
      "PGN": 37376,
      "PGN_Name": "Aftertreatment 1 Hydrocarbon Doser Information 1",
      "PGN_Description": "HCDI1",
      "first_bit": 0,
      "SPN": 5505,
      "SPN_Name": "Requested Fuel Mass Rate",
      "SPN_Description": "Requested fuel dosing quantity from hydrocarbon doser.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "g/min",
      "SLOT_ID": 317
    },
    "5506": {
      "PGN": 37376,
      "PGN_Name": "Aftertreatment 1 Hydrocarbon Doser Information 1",
      "PGN_Description": "HCDI1",
      "first_bit": 16,
      "SPN": 5506,
      "SPN_Name": "HC Doser Status",
      "SPN_Description": "Indicates whether the HC Doser/ HC Dosing system is enabled or is waiting for regeneration.\r\n\r\n000 HC doser disabled\r\n001 HC doser active\r\n010 SAE reserved\r\n011 HC doser enabled, waiting for regeneration\r\n100 SAE reserved\r\n101 SAE reserved\r\n110 Error\r\n111 Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5507": {
      "PGN": 37376,
      "PGN_Name": "Aftertreatment 1 Hydrocarbon Doser Information 1",
      "PGN_Description": "HCDI1",
      "first_bit": 19,
      "SPN": 5507,
      "SPN_Name": "HC Doser Injecting Status",
      "SPN_Description": "Indicates whether the Hydrocarbon Doser (HCD) is presently injecting diesel fuel into the exhaust pipe.\r\n\r\n00 Injecting not active\r\n01 Injecting active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5508": {
      "PGN": 37376,
      "PGN_Name": "Aftertreatment 1 Hydrocarbon Doser Information 1",
      "PGN_Description": "HCDI1",
      "first_bit": 21,
      "SPN": 5508,
      "SPN_Name": "Diagnostic Status of HC Doser",
      "SPN_Description": "Indicates whether an error is active in the Hydrocarbon Doser (HCD) or whether the internal cyclic system test of the HCD is presently active.  \r\n\r\nThis is not intended to replace the DM8/DM30 - Test results requirement for OBD.\r\n\r\n\r\n000 System test has executed and passed or System test has not yet executed\r\n001 Internal system test is in process\r\n010 - 101  SAE reserved\r\n110 Error  --  System test has failed\r\n111 Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5509": {
      "PGN": 37376,
      "PGN_Name": "Aftertreatment 1 Hydrocarbon Doser Information 1",
      "PGN_Description": "HCDI1",
      "first_bit": 24,
      "SPN": 5509,
      "SPN_Name": "Hydrocarbon Doser Purging Required",
      "SPN_Description": "Purging of the Hydrocarbon Doser (HCD) is required.  Request could come from the HCD system.\r\n\r\n00   Purging not required\r\n01   Purging required - less urgent\r\n10   Purging required - urgent\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5510": {
      "PGN": 37120,
      "PGN_Name": "Vehicle/Chassis Lubrication System 1",
      "PGN_Description": "VLS1",
      "first_bit": 0,
      "SPN": 5510,
      "SPN_Name": "Lubrication Cycle Mode Lock Command",
      "SPN_Description": "Command signal to lock or unlock the ability to change the lubrication cycle mode.  Locking the lubrication mode would prevent the changing of the lubrication cycle mode, perhaps by an operator.\r\n\r\n00 - Not Locked\r\n01 - Locked\r\n10 - Reserved\r\n11 - No action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5511": {
      "PGN": 37120,
      "PGN_Name": "Vehicle/Chassis Lubrication System 1",
      "PGN_Description": "VLS1",
      "first_bit": 2,
      "SPN": 5511,
      "SPN_Name": "Lubrication Cycle Set Command",
      "SPN_Description": "Command signal to change the lubrication cycle. It gives the operator or technician the ability to the change the frequency of lubrication.\r\n\r\n000 - Cycle mode # 1 (Lowest Lubrication Frequency)\r\n001 - Cycle mode # 2\r\n010 - Cycle mode # 3 (Highest Lubrication Frequency)\r\n011 to 110 - Reserved \r\n111 - No action",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5512": {
      "PGN": 37120,
      "PGN_Name": "Vehicle/Chassis Lubrication System 1",
      "PGN_Description": "VLS1",
      "first_bit": 5,
      "SPN": 5512,
      "SPN_Name": "Lubrication Operation Mode Set Command",
      "SPN_Description": "Command signal to change lubrication system operational mode. The mode set command gives the operator and/or technician the ability to change the operational mode when diagnosing and servicing of the system is required.\r\n\r\nAutomatic is the normal operation mode of lubrication system. In this mode the operator has the privilege to change duty cycle mode, if the lubrication mode in not locked.\r\nIn manual service mode the service tool temporary takes control of the pump controller for service purposes.\r\n\r\nThe Test mode # x shall command the system to perform pre-defined greasing cycles in order to verify operation of the lubrication system.\r\n\r\n000 - Automatic Mode\r\n001 - Manual Service Mode\r\n010 - Test Mode # 1\r\n011 - Test Mode # 2\r\n100 - Test Mode # 3\r\n101-110 - Reserved\r\n111 - Take no action",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5513": {
      "PGN": 37120,
      "PGN_Name": "Vehicle/Chassis Lubrication System 1",
      "PGN_Description": "VLS1",
      "first_bit": 8,
      "SPN": 5513,
      "SPN_Name": "Lubrication Pump Enable Command",
      "SPN_Description": "Command signal to reset the lubrication pump.  It allows the operator and/or technician to reset the paused lubrication pump and clear lubrication system faults. This shall enable the lubrication system to resume its normal operation. \r\n\r\n00 - No action (Normal pump operation)\r\n01 - Reset pump operation  \r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5514": {
      "PGN": 37120,
      "PGN_Name": "Vehicle/Chassis Lubrication System 1",
      "PGN_Description": "VLS1",
      "first_bit": 10,
      "SPN": 5514,
      "SPN_Name": "Lubrication Timing Cycle Command",
      "SPN_Description": "Command signal to enable or pause the lubrication activation clock \r\n\r\n00 - Pause\r\n01 - Enable\r\n10 - Reserved \r\n11 - Take no action     \r\n\r\nNote:  In some vehicles or machines the lubrication is only required when the vehicle or machine is in certain state (such as when a certain gear is engaged, operator's armrest in place etc.). To prevent unwanted grease lubrication, a timing cycle clock is used. This clock is only ticked for the time the vehicle or machine is in the defined state. Starting or stopping of the clock is controlled using an external input.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5515": {
      "PGN": 64742,
      "PGN_Name": "Vehicle/Chassis Lubrication System 2",
      "PGN_Description": "VLS2",
      "first_bit": 0,
      "SPN": 5515,
      "SPN_Name": "Lubrication Cycle Mode Lock Status",
      "SPN_Description": "Reports status of the ability to change the lubrication cycle mode.  Locking the lubrication mode would prevent the changing of the lubrication cycle mode, perhaps by an operator\r\n\r\n00 - Not Locked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5516": {
      "PGN": 64742,
      "PGN_Name": "Vehicle/Chassis Lubrication System 2",
      "PGN_Description": "VLS2",
      "first_bit": 2,
      "SPN": 5516,
      "SPN_Name": "Lubrication Cycle Mode Status",
      "SPN_Description": "Reports the current lubrication cycle mode of the lubrication system\r\n\r\n000 - Cycle mode # 1 (Lowest Lubrication Frequency)\r\n001 - Cycle mode # 2\r\n010 - Cycle mode # 3 (Highest Lubrication Frequency)\r\n011 to 101 - Reserved \r\n110 - Error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5517": {
      "PGN": 64742,
      "PGN_Name": "Vehicle/Chassis Lubrication System 2",
      "PGN_Description": "VLS2",
      "first_bit": 5,
      "SPN": 5517,
      "SPN_Name": "Lubrication Operation Mode Status",
      "SPN_Description": "Reports the current operational mode status of the lubrication system.\r\n  \r\nAutomatic is the normal operation mode of lubrication system. In this mode the operator has the privilege to change duty cycle mode, if the lubrication mode in not locked.\r\n\r\nIn manual service mode the service tool temporary takes control of the pump controller for service purposes.\r\n\r\nThe test mode # x shall command the system to perform pre-defined greasing cycles in order to verify operation of the lubrication system.\r\n\r\n\r\n000 - Automatic Mode\r\n001 - Manual Service Mode\r\n010 - Test Mode # 1\r\n011 - Test Mode # 2\r\n100 - Test Mode # 3\r\n101 - Reserved\r\n110 - Error\r\n111 - Not Available\r\n\r\nNote:  In general the lubrication system shall be operating in automatic mode but, it may also be changed into manual or test mode. These test and manual modes are used to perform service and diagnostic tests on the lubrication system. This SPN shall be used to report the current operating status of grease lubrication system.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5518": {
      "PGN": 64742,
      "PGN_Name": "Vehicle/Chassis Lubrication System 2",
      "PGN_Description": "VLS2",
      "first_bit": 8,
      "SPN": 5518,
      "SPN_Name": "Lubrication Pump Enable Status",
      "SPN_Description": "Reports the operational status of the lubrication system pump.  In the disabled state, the lubrication pump will not run a lubrication cycle.  In the enabled state, the lubrication system will perform normal operations.\r\n\r\n00 - Disabled\r\n01 - Enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5519": {
      "PGN": 64742,
      "PGN_Name": "Vehicle/Chassis Lubrication System 2",
      "PGN_Description": "VLS2",
      "first_bit": 10,
      "SPN": 5519,
      "SPN_Name": "Lubrication Reservoir Level",
      "SPN_Description": "Reports the status of the lubrication system reservior level.  The lubrication reservoir stores the grease for the lubrication system. The lubrication pump draws grease from this reservoir and pushes it into the vehicle/chassis joints\r\n\r\n00 - Reservoir Not Low\r\n01 - Reservoir Low\r\n10 - Error \r\n11 - Not available or not installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5520": {
      "PGN": 64742,
      "PGN_Name": "Vehicle/Chassis Lubrication System 2",
      "PGN_Description": "VLS2",
      "first_bit": 12,
      "SPN": 5520,
      "SPN_Name": "Lubrication Timing Cycle Status",
      "SPN_Description": "Reports the status of the lubrication activation clock.\r\n\r\n00 - Paused \r\n01 - Enabled\r\n10 - Error \r\n11 - Not available or not installed\r\n     \r\nNote:  In some vehicles or machines, lubrication is only required when the vehicle or machine is in certain state e. g. when a certain gear is engaged. To prevent unwanted grease lubrication, a timing cycle clock is used. This clock only ticks for the time the vehicle or machine is in that defined state. Starting or stopping of the clock is controlled using an external input. The status of this timing cycle clock shall be reported to the operator by using this SPN.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5532": {
      "PGN": 53248,
      "PGN_Name": "Cab Illumination Message",
      "PGN_Description": "CL",
      "first_bit": 8,
      "SPN": 5532,
      "SPN_Name": "Switch Backlight Illumination Brightness Percent",
      "SPN_Description": "Commanded switch backlight brightness level for all operator control switches.  This is separate from the cab display illumination Brightness Percent parameter.\r\n\r\nNote:  If a single device is used to control both the backlight brightness level of the cab display and switches, see SPN 1487.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5533": {
      "PGN": 64741,
      "PGN_Name": "Hydraulic Oil Properties",
      "PGN_Description": "HOP",
      "first_bit": 0,
      "SPN": 5533,
      "SPN_Name": "Hydraulic Oil Dynamic Viscosity",
      "SPN_Description": "Dynamic viscosity of hydraulic oil.  This hydraulic fluid is for the entire hydraulics system of a piece of equipment.",
      "bit_length": 16,
      "scaling": 0.015625,
      "offset": 0,
      "unit": "Cp",
      "SLOT_ID": 301
    },
    "5534": {
      "PGN": 64741,
      "PGN_Name": "Hydraulic Oil Properties",
      "PGN_Description": "HOP",
      "first_bit": 16,
      "SPN": 5534,
      "SPN_Name": "Hydraulic Oil Density",
      "SPN_Description": "Density of hydraulic oil.  This hydraulic fluid is for the entire hydraulics system of a piece of equipment.",
      "bit_length": 16,
      "scaling": 0.00003052,
      "offset": 0,
      "unit": "g/cc",
      "SLOT_ID": 302
    },
    "5535": {
      "PGN": 64741,
      "PGN_Name": "Hydraulic Oil Properties",
      "PGN_Description": "HOP",
      "first_bit": 32,
      "SPN": 5535,
      "SPN_Name": "Hydraulic Oil Relative Dielectricity (High Resolution)",
      "SPN_Description": "Hydraulic oil relative dielectricity used to describe the hydraulic oil quality.  This hydraulic fluid is for the entire hydraulics system of a piece of equipment.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": 0,
      "unit": null,
      "SLOT_ID": 307
    },
    "5536": {
      "PGN": 64741,
      "PGN_Name": "Hydraulic Oil Properties",
      "PGN_Description": "HOP",
      "first_bit": 48,
      "SPN": 5536,
      "SPN_Name": "Hydraulic Oil Temperature (High Resolution)",
      "SPN_Description": "Hydraulic Oil Temperature.  This hydraulic fluid is for the entire hydraulics system of a piece of equipment.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5537": {
      "PGN": 64740,
      "PGN_Name": "Engine Fuel Properties",
      "PGN_Description": "EFP",
      "first_bit": 0,
      "SPN": 5537,
      "SPN_Name": "Engine Fuel Dynamic Viscosity",
      "SPN_Description": "Dynamic viscosity of engine fuel",
      "bit_length": 16,
      "scaling": 0.015625,
      "offset": 0,
      "unit": "Cp",
      "SLOT_ID": 301
    },
    "5538": {
      "PGN": 64740,
      "PGN_Name": "Engine Fuel Properties",
      "PGN_Description": "EFP",
      "first_bit": 16,
      "SPN": 5538,
      "SPN_Name": "Engine Fuel Density",
      "SPN_Description": "Density of engine fuel",
      "bit_length": 16,
      "scaling": 0.00003052,
      "offset": 0,
      "unit": "g/cc",
      "SLOT_ID": 302
    },
    "5539": {
      "PGN": 64740,
      "PGN_Name": "Engine Fuel Properties",
      "PGN_Description": "EFP",
      "first_bit": 32,
      "SPN": 5539,
      "SPN_Name": "Engine Fuel Dielectricity (High Resolution)",
      "SPN_Description": "Engine fuel relative dielectricity.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": 0,
      "unit": null,
      "SLOT_ID": 307
    },
    "5540": {
      "PGN": 64740,
      "PGN_Name": "Engine Fuel Properties",
      "PGN_Description": "EFP",
      "first_bit": 48,
      "SPN": 5540,
      "SPN_Name": "Engine Fuel 1 Temperature 1 (High Resolution)",
      "SPN_Description": "Engine Fuel Temperature of the first fuel type. See also SPNs 174 or 3468 for alternate resolution.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5541": {
      "PGN": 64739,
      "PGN_Name": "Engine Exhaust Brake Control",
      "PGN_Description": "EBCC",
      "first_bit": 0,
      "SPN": 5541,
      "SPN_Name": "Engine Turbocharger 1 Turbine Outlet Pressure",
      "SPN_Description": "Gage pressure of the combustion by-products exiting the turbine side of the turbocharger 1.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "5542": {
      "PGN": 64739,
      "PGN_Name": "Engine Exhaust Brake Control",
      "PGN_Description": "EBCC",
      "first_bit": 8,
      "SPN": 5542,
      "SPN_Name": "Engine Turbocharger 1 Turbine Desired Outlet Pressure",
      "SPN_Description": "The desired gage pressure of the combustion by-products exiting the turbine side of the turbocharger 1 at the current engine operating conditions.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "5543": {
      "PGN": 64739,
      "PGN_Name": "Engine Exhaust Brake Control",
      "PGN_Description": "EBCC",
      "first_bit": 16,
      "SPN": 5543,
      "SPN_Name": "Engine Exhaust Brake Actuator Command",
      "SPN_Description": "The control command applied to the engine exhaust brake actuator, where 0% represents no braking and 100% represents full braking.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5544": {
      "PGN": 64739,
      "PGN_Name": "Engine Exhaust Brake Control",
      "PGN_Description": "EBCC",
      "first_bit": 24,
      "SPN": 5544,
      "SPN_Name": "Engine Turbocharger 2 Turbine Outlet Pressure",
      "SPN_Description": "Gage pressure of the combustion by-products exiting the turbine side of the turbocharger 2.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "5545": {
      "PGN": 64739,
      "PGN_Name": "Engine Exhaust Brake Control",
      "PGN_Description": "EBCC",
      "first_bit": 32,
      "SPN": 5545,
      "SPN_Name": "Engine Turbocharger 2 Turbine Desired Outlet Pressure",
      "SPN_Description": "The desired gage pressure of the combustion by-products exiting the turbine side of the turbocharger 2 at the current engine operating conditions.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "5546": {
      "PGN": 64850,
      "PGN_Name": "Engine Coolant Control Valve Command",
      "PGN_Description": "ECCVC",
      "first_bit": 24,
      "SPN": 5546,
      "SPN_Name": "Engine Auxiliary Cooler Supply Valve 1 Actuator Command",
      "SPN_Description": "The control command applied to the engine auxiliary cooler supply valve 1 actuator, where 0% represents closed and 100% represents open.\r\n\r\nSee SPN 4197 for primary engine thermostat valve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5547": {
      "PGN": 64850,
      "PGN_Name": "Engine Coolant Control Valve Command",
      "PGN_Description": "ECCVC",
      "first_bit": 32,
      "SPN": 5547,
      "SPN_Name": "Engine Auxiliary Cooler Supply Valve 2 Actuator Command",
      "SPN_Description": "The control command applied to the engine auxiliary cooler supply valve 2 actuator, where 0% represents closed and 100% represents open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5548": {
      "PGN": 64966,
      "PGN_Name": "Cold Start Aids",
      "PGN_Description": "CSA",
      "first_bit": 16,
      "SPN": 5548,
      "SPN_Name": "Engine Cold Start Fuel Igniter Command",
      "SPN_Description": "The engine cold start fuel igniter control command, normalized to %, where 0% represents fully off and 100% represents fully on.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5549": {
      "PGN": 64966,
      "PGN_Name": "Cold Start Aids",
      "PGN_Description": "CSA",
      "first_bit": 24,
      "SPN": 5549,
      "SPN_Name": "Engine Cold Start Fuel Igniter Relay",
      "SPN_Description": "The engine cold start fuel igniter relay control command.  This command controls the relay, not the igniter.\r\n\r\n00  Off\r\n01  On\r\n10  Reserved\r\n11  Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5550": {
      "PGN": 64966,
      "PGN_Name": "Cold Start Aids",
      "PGN_Description": "CSA",
      "first_bit": 26,
      "SPN": 5550,
      "SPN_Name": "Engine Cold Start Fuel Igniter Relay Feedback",
      "SPN_Description": "Feedback state of the engine cold start fuel igniter relay which indicates the status of the relay output.\r\n\r\n00  Off\r\n01  On\r\n10  Error\r\n11  Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5551": {
      "PGN": 61484,
      "PGN_Name": "Magnet Status Information 2",
      "PGN_Description": "MSI2",
      "first_bit": 38,
      "SPN": 5551,
      "SPN_Name": "Magnet Generator Control",
      "SPN_Description": "Command signal used to Enable and Disable the Generator controlling a Magnet.\r\n\r\n00  Off, Disable Generator\r\n01  On, Enable Generator\r\n10  Reserved\r\n11  Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5552": {
      "PGN": 36864,
      "PGN_Name": "Supplemental Fan Command",
      "PGN_Description": "SFC",
      "first_bit": 0,
      "SPN": 5552,
      "SPN_Name": "Supplemental Fan Enable Command",
      "SPN_Description": "Enable/Disable command to Supplemental Fan.\r\n\r\n00  Disable \r\n01  Enable\r\n10  Reserved \r\n11  Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5553": {
      "PGN": 36864,
      "PGN_Name": "Supplemental Fan Command",
      "PGN_Description": "SFC",
      "first_bit": 2,
      "SPN": 5553,
      "SPN_Name": "Supplemental Fan Direction Command",
      "SPN_Description": "Direction command to the Supplemental Fan. Fan can be commanded to run forward or reverse.\r\n\r\n00   Forward\r\n01   Reverse\r\n10   Reserved\r\n11   Don't care/take no action (leave function as is)",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5554": {
      "PGN": 36864,
      "PGN_Name": "Supplemental Fan Command",
      "PGN_Description": "SFC",
      "first_bit": 8,
      "SPN": 5554,
      "SPN_Name": "Supplemental Fan Speed Command",
      "SPN_Description": "Speed command to Supplemental Fan.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "5555": {
      "PGN": 36864,
      "PGN_Name": "Supplemental Fan Command",
      "PGN_Description": "SFC",
      "first_bit": 24,
      "SPN": 5555,
      "SPN_Name": "Supplemental Fan Power Hold",
      "SPN_Description": "Command to allow the supplemental fan controller to remain alive independently of the electrical enable input to the fan. This allows the fan controller to remain alive after the key switch has disabled the electrical enable pin on the fan controller. For example, the fan can continue to run after a machine has been shutdown to provide cooling when the machine is no longer running\r\n\r\n00   Disable\r\n01   Enable\r\n10   Reserved\r\n11   Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5556": {
      "PGN": 64738,
      "PGN_Name": "Supplemental Fan Status",
      "PGN_Description": "SFS",
      "first_bit": 0,
      "SPN": 5556,
      "SPN_Name": "Supplemental Fan Enable Status",
      "SPN_Description": "Enable/Disable Status of Supplemental Fan.\r\n\r\n00   Disabled\r\n01   Enabled\r\n10   Error\r\n11   Not available/Not installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5557": {
      "PGN": 64738,
      "PGN_Name": "Supplemental Fan Status",
      "PGN_Description": "SFS",
      "first_bit": 2,
      "SPN": 5557,
      "SPN_Name": "Supplemental Fan Direction Status",
      "SPN_Description": "Rotational Direction of Supplemental Fan. Fan could be spinning forward or reverse.\r\n\r\n00   Forward\r\n01   Reverse\r\n10   Error\r\n11   Not available/Not installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5558": {
      "PGN": 64738,
      "PGN_Name": "Supplemental Fan Status",
      "PGN_Description": "SFS",
      "first_bit": 4,
      "SPN": 5558,
      "SPN_Name": "Supplemental Fan Velocity Status",
      "SPN_Description": "Status of the rotational velocity of Supplemental Fan. Used to indicate if the fan is spinning at the desired speed. If fan is not able to obtain the commanded speed, velocity error is indicated. If fan is unable to spin, the fan is in Fan Stall condition.\r\n\r\n0000   At Velocity (Fan OK)\r\n0001   Velocity Error  (unable to achieve commanded speed)\r\n0010   Fan Spin Up\r\n0011   Fan Spin Down\r\n0100   Fan Stall\r\n0101-1101   Reserved\r\n1110   Error\r\n1111   Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5559": {
      "PGN": 64738,
      "PGN_Name": "Supplemental Fan Status",
      "PGN_Description": "SFS",
      "first_bit": 8,
      "SPN": 5559,
      "SPN_Name": "Supplemental Fan Controller Temperature Status",
      "SPN_Description": "Internal Controller Temperature Status of Supplemental Fan.\r\n\r\n000   High most severe \r\n001   High Least severe \r\n010   In Range \r\n011   Low Least severe \r\n100   Low Most severe \r\n101   Not Defined \r\n110   Error \r\n111   Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5560": {
      "PGN": 64738,
      "PGN_Name": "Supplemental Fan Status",
      "PGN_Description": "SFS",
      "first_bit": 11,
      "SPN": 5560,
      "SPN_Name": "Supplemental Fan Drive Status",
      "SPN_Description": "The drive status of the Supplemental Fan. This status parameter indicates the overall health of the fan drive. It will indicate that the fan is working OK or if there is an internal fault such as open winding or internal short circuit.\r\n\r\n0000   Normal = \"OK\"\r\n0001   Alarm = Fully operational but needs service\r\n0010   Alarm High Severity = Functional but transient performance may be reduced\r\n0011   Derate Active = Torque output reduced due to environmental conditions\r\n0100   Controlled Shutdown Active = Driving to the default position – usually this means closed\r\n0101   Uncontrolled Shutdown Active = Actuator current is off so it is limp\r\n0110 - 1101   Reserved for future assignment = Not used\r\n1110   Error\r\n1111   Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5561": {
      "PGN": 64738,
      "PGN_Name": "Supplemental Fan Status",
      "PGN_Description": "SFS",
      "first_bit": 16,
      "SPN": 5561,
      "SPN_Name": "Supplemental Fan Controller ECU Temperature",
      "SPN_Description": "Measured temperature of Supplemental Fan Controller ECU.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5562": {
      "PGN": 64738,
      "PGN_Name": "Supplemental Fan Status",
      "PGN_Description": "SFS",
      "first_bit": 24,
      "SPN": 5562,
      "SPN_Name": "Supplemental Fan Speed",
      "SPN_Description": "Measured speed of supplemental fan.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "5563": {
      "PGN": 64738,
      "PGN_Name": "Supplemental Fan Status",
      "PGN_Description": "SFS",
      "first_bit": 40,
      "SPN": 5563,
      "SPN_Name": "Supplemental Fan Current",
      "SPN_Description": "Measured electrical current of supplemental fan drive.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "A",
      "SLOT_ID": 40
    },
    "5564": {
      "PGN": 64738,
      "PGN_Name": "Supplemental Fan Status",
      "PGN_Description": "SFS",
      "first_bit": 48,
      "SPN": 5564,
      "SPN_Name": "Supplemental Fan Power",
      "SPN_Description": "Estimated Power output of Supplemental Fan",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "W",
      "SLOT_ID": 305
    },
    "5565": {
      "PGN": 36608,
      "PGN_Name": "Engine Configuration Commands",
      "PGN_Description": "ECC",
      "first_bit": 0,
      "SPN": 5565,
      "SPN_Name": "Coolant Level Engine Protection Shutdown Override Command",
      "SPN_Description": "Overrides the engine protection shutdown functionality due to low coolant level.  \r\n\r\n00 - Disable engine protection shutdown override due to low coolant level\r\n01 - Enable engine protection shutdown override due to low coolant level\r\n10 - Reserved\r\n11 - Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5566": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 60,
      "SPN": 5566,
      "SPN_Name": "Coolant Level Engine Protection Shutdown Status",
      "SPN_Description": "Parameter which indicates the configuration of the coolant level engine protection shutdown.\r\n\r\n00 - Disabled - calibration does not allow engine protection due to low coolant level or the override is currently active\r\n01 - Enabled - calibration allows engine protection due to low coolant level and the override is currently not active\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5567": {
      "PGN": 64915,
      "PGN_Name": "Generator Control 1",
      "PGN_Description": "GC1",
      "first_bit": 32,
      "SPN": 5567,
      "SPN_Name": "Engine Speed Governor Gain Adjust",
      "SPN_Description": "This parameter is used to adjust multiple gains at same time to attain engine stability across a broader range of applications.  \r\n\r\n-32128 is least responsive\r\n0 is normal\r\n+32127 is most responsive",
      "bit_length": 16,
      "scaling": 1,
      "offset": -32128,
      "unit": "count",
      "SLOT_ID": 306
    },
    "5568": {
      "PGN": 64915,
      "PGN_Name": "Generator Control 1",
      "PGN_Description": "GC1",
      "first_bit": 48,
      "SPN": 5568,
      "SPN_Name": "Engine Speed Governor Droop",
      "SPN_Description": "This is the percent speed droop adjustment relative to rated speed setpoint. The Engine Speed Droop is equal to the following equation: \r\n\r\n100*[(Engine Speed at no load - Engine Speed at full rated load)/ (Engine Speed at full rated load)]. \r\n\r\nThe engine speed will slow down as load is added. Allows for inexpensive load sharing between multiple engines.",
      "bit_length": 8,
      "scaling": 0.04,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 308
    },
    "5569": {
      "PGN": 64796,
      "PGN_Name": "Diesel Particulate Filter 1 Soot",
      "PGN_Description": "DPF1S",
      "first_bit": 56,
      "SPN": 5569,
      "SPN_Name": "Diesel Particulate Filter 1 Soot Sensor ECU Internal Temperature",
      "SPN_Description": "Internal temperature of the diesel particulate filter 1 soot sensor ECU.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5570": {
      "PGN": 64795,
      "PGN_Name": "Diesel Particulate Filter 2 Soot",
      "PGN_Description": "DPF2S",
      "first_bit": 56,
      "SPN": 5570,
      "SPN_Name": "Diesel Particulate Filter 2 Soot Sensor ECU Internal Temperature",
      "SPN_Description": "Internal temperature of the diesel particulate filter 2 soot sensor ECU.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5578": {
      "PGN": 64735,
      "PGN_Name": "Engine Fluid Level/Pressure 12",
      "PGN_Description": "EFL/P12",
      "first_bit": 0,
      "SPN": 5578,
      "SPN_Name": "Engine Fuel Delivery Absolute Pressure",
      "SPN_Description": "Absolute pressure of fuel in system as delivered from supply pump to the injection pump.  See also SPN 94 for Fuel Delivery Pressure (Gage).",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "5579": {
      "PGN": 64735,
      "PGN_Name": "Engine Fluid Level/Pressure 12",
      "PGN_Description": "EFL/P12",
      "first_bit": 8,
      "SPN": 5579,
      "SPN_Name": "Engine Filtered Fuel Delivery Pressure",
      "SPN_Description": "Gage pressure of fuel in system as delivered from supply pump to the injection pump after the pressure side fuel filter.  See SPN 5580 for absolute pressure of fuel in system after the pressure side fuel filter.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "5580": {
      "PGN": 64735,
      "PGN_Name": "Engine Fluid Level/Pressure 12",
      "PGN_Description": "EFL/P12",
      "first_bit": 16,
      "SPN": 5580,
      "SPN_Name": "Engine Filtered Fuel Delivery Absolute Pressure",
      "SPN_Description": "Absolute pressure of fuel in system as delivered from supply pump to the injection pump after the pressure side fuel filter.  See SPN 5579 for gage pressure of fuel in system after the pressure side fuel filter.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "5581": {
      "PGN": 64992,
      "PGN_Name": "Ambient Conditions 2",
      "PGN_Description": "AMB2",
      "first_bit": 32,
      "SPN": 5581,
      "SPN_Name": "Calculated Ambient Air Temperature",
      "SPN_Description": "Calculated temperature of air surrounding vehicle.  Use SPN 171 for actual measured ambient air temperature.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5582": {
      "PGN": 2304,
      "PGN_Name": "Static Roll Angle Sensor Information",
      "PGN_Description": "SRASI",
      "first_bit": 0,
      "SPN": 5582,
      "SPN_Name": "Static Roll Angle",
      "SPN_Description": "The measured static roll angle between the vehicle y-axis and the ground plane about the X-axis.  The sign of the roll angle is determined in accordance to the right-hand rule about the X-axis, as specified in SAE J670.  Roll angle is the same for both Z-Down and Z-Up axis system, as specified in SAE J670, since both systems have positive X forward.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "deg",
      "SLOT_ID": 11
    },
    "5583": {
      "PGN": 2304,
      "PGN_Name": "Static Roll Angle Sensor Information",
      "PGN_Description": "SRASI",
      "first_bit": 8,
      "SPN": 5583,
      "SPN_Name": "Static Roll Angle Status",
      "SPN_Description": "Status of the transmitted roll angle data.\r\n\r\n000 = Sensor Busy\r\n001 = Sensor OK\r\n010 = Sensor Defect\r\n011 = Sensor Reboots\r\n100 = Angle Data Invalid\r\n101 = Reserved\r\n110 = Error\r\n111 = Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5584": {
      "PGN": 64735,
      "PGN_Name": "Engine Fluid Level/Pressure 12",
      "PGN_Description": "EFL/P12",
      "first_bit": 24,
      "SPN": 5584,
      "SPN_Name": "Engine Fuel Filter Degradation",
      "SPN_Description": "The estimated percentage relative to the useful life of the engine fuel filter. \r\n\r\nThis is not a calculation of the physical restriction of the filter.  0% is typical of a new filter.  100% is typical of an end of life filter, the filter should be replaced.  The filter can operate past 100%.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "5589": {
      "PGN": 64734,
      "PGN_Name": "Aftertreatment 1 Air Control 3",
      "PGN_Description": "AT1AC3",
      "first_bit": 0,
      "SPN": 5589,
      "SPN_Name": "Aftertreatment 1 Secondary Air Absolute Pressure",
      "SPN_Description": "Absolute pressure of the secondary air for aftertreatment 1. Secondary air is air provided to the exhaust system (per SAE J2403).\r\n\r\nFor gage pressure, see SPN 3837.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "5590": {
      "PGN": 64733,
      "PGN_Name": "Aftertreatment 2 Air Control 3",
      "PGN_Description": "AT2AC3",
      "first_bit": 0,
      "SPN": 5590,
      "SPN_Name": "Aftertreatment 2 Secondary Air Absolute Pressure",
      "SPN_Description": "Absolute pressure of the secondary air for aftertreatment 2. Secondary air is air provided to the exhaust system (per SAE J2403).\r\n\r\nFor gage pressure, see SPN 3838.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "5603": {
      "PGN": 2560,
      "PGN_Name": "Cruise Control / Vehicle Speed 2",
      "PGN_Description": "CCVS2",
      "first_bit": 0,
      "SPN": 5603,
      "SPN_Name": "Cruise Control Disable Command",
      "SPN_Description": "This parameter is used to disable cruise control from a source other than the driver controlled switch if cruise control is active.  It is also used to inhibit cruise control from becoming active if it is not currently active.  If this parameter is used to disable cruise control, then cruise control will need to be re-initialized and the previous set speed will not be retained.  \r\n\r\nThis parameter has priority over Cruise Control Resume Command (SPN 5604).  See Figure PGN2560_A for an explanation of how this relates to other parameters.\r\n\r\nUse of this parameter is in addition to Cruise Control Enable Switch (SPN 596).  The Cruise Control Enable Switch set to OFF has priority over the Cruise Control Disable Command set to allowed.\r\n\r\nThis parameter is not the physical switch that enables cruise control.  See SPN 596 for the physical switch.\r\n\r\n00 - Cruise Control is allowed\r\n01 - Cruise Control is not allowed\r\n10 - Reserved\r\n11 - Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5604": {
      "PGN": 2560,
      "PGN_Name": "Cruise Control / Vehicle Speed 2",
      "PGN_Description": "CCVS2",
      "first_bit": 2,
      "SPN": 5604,
      "SPN_Name": "Cruise Control Resume Command",
      "SPN_Description": "This parameter is used to request the cruise control to resume operation from a source other than the driver controlled switch.  Implementers may wish to restrict the conditions in which cruise control will be resumed due to this parameter.  Possible restrictions include only honoring this request if it is received within a certain time period after cruise control has been disabled, a vehicle speed differential has been exceeded since cruise control has been cancelled, etc. \r\n\r\nThis request will only be honored if it is received from the same device as the one that sent the Cruise Control Pause Command (SPN 5605).\r\n\r\nCruise Control Disable Command (SPN 5603) and Cruise Control Pause Command (SPN 5605) both have a higher priority than this parameter.  See Figure PGN2560_A for an explanation of how this relates to other parameters. \r\n\r\nThis parameter is not the physical switch that is used to resume cruise control.  See SPN 601 for the physical switch.\r\n\r\n\r\n00 - Cruise Control Resume not Requested\r\n01 - Cruise Control Resume Requested\r\n10 - Reserved\r\n11 - Don't Care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5605": {
      "PGN": 2560,
      "PGN_Name": "Cruise Control / Vehicle Speed 2",
      "PGN_Description": "CCVS2",
      "first_bit": 4,
      "SPN": 5605,
      "SPN_Name": "Cruise Control Pause Command",
      "SPN_Description": "This parameter is used to temporarily disable cruise control from a source other than the driver controlled switch if cruise control is active.  If this parameter is used to disable cruise control, then cruise control will not need to be re-initialized and the previous set speed will be retained.  In order for the cruise control system to resume to the previous set speed, a valid command must be received.  Valid commands include (1) the Cruise Control Resume Switch (SPN 601), (2) the Cruise Control Set Switch (SPN 599), or (3) Cruise Control Resume Command (SPN 5604).\r\n\r\nThis parameter has priority over Cruise Control Resume Command (SPN 5604).  See Figure PGN2560_A for an explanation of how this relates to other parameters. \r\n\r\nThis parameter is not the physical switch that is used to pause cruise control.  See SPN 1633 for the physical switch.\r\n\r\nReceiving this parameter to disable cruise control has the same effect on cruise control as tapping the brake pedal.\r\n\r\n\r\n00 - Cruise Control is allowed\r\n01 - Cruise Control is not allowed\r\n10 - Reserved\r\n11 - Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5606": {
      "PGN": 64732,
      "PGN_Name": "Cruise Control / Vehicle Speed 3",
      "PGN_Description": "CCVS3",
      "first_bit": 0,
      "SPN": 5606,
      "SPN_Name": "Adaptive Cruise Control Readiness Status",
      "SPN_Description": "This parameter is used to indicate an application's state of readiness for responding to commands from an adaptive cruise control system controller.\r\n\r\n00 - Off -- Cruise Control System is not configured to accept commands from an adaptive cruise controller\r\n01 - On -- Cruise Control System is configured to accept commands from an adaptive cruise controller.\r\n10 - Error Condition -- Prevents system from responding to adaptive cruise controller commands even though it is configured.\r\n11 - Not Available/Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5607": {
      "PGN": 64732,
      "PGN_Name": "Cruise Control / Vehicle Speed 3",
      "PGN_Description": "CCVS3",
      "first_bit": 2,
      "SPN": 5607,
      "SPN_Name": "Cruise Control System Command State",
      "SPN_Description": "Indicates the current state of the cruise control system due to the Cruise Control System Commands, which include Cruise Control Disable Command (SPN 5603), Cruise Control Resume Command (SPN 5604), and Cruise Control Pause Command (SPN 5605).\r\n\r\n000 - No Cruise Control System Command\r\n001 - Cruise control has been disabled by Cruise Control Disable Command (SPN 5603)\r\n010 - Cruise control  has been disabled by Cruise Control Pause Command (SPN 5605)\r\n011 - Cruise control has been re-activated by Cruise Control Resume Command (SPN 5604) and Cruise Control States (SPN 527) is equal to Resume (100).  Cruise Control System Command State will be equal to 011 as long as Cruise Control States is equal to Resume.  Cruise Control System Command State will change to the appropriate value when Cruise Control States is no longer equal to Resume.\r\n100 - Cruise control device has received a Cruise Control Resume Command (SPN 5604), but there is no previous set speed.\r\n101 - 110 -- SAE Reserved\r\n111 - Not Supported",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5608": {
      "PGN": 64732,
      "PGN_Name": "Cruise Control / Vehicle Speed 3",
      "PGN_Description": "CCVS3",
      "first_bit": 8,
      "SPN": 5608,
      "SPN_Name": "Source Address of Controlling Device for Disabling Cruise Control",
      "SPN_Description": "The source address of the SAE J1939 device that is currently sending the Cruise Control Disable Command (SPN 5603).\r\n\r\nIf there are multiple devices sending Cruise Control Disable Command with a value of 01, then the value transmitted for this parameter will be the source address of the device that first began sending 01 for the command.  If the device that first sent 01 for Cruise Control Disable Command is no longer sending 01 for the command, then the value of the Source Address of Controlling Device for Disabling Cruise Control shall be set to the source address of a device that is still sending the Cruise Control Disable Command with a value of 01.\r\n\r\nSee Figure PGN2560_A for an explanation of how this relates to other parameters.\r\n\r\nThis parameter is supported by the device that has the capability to receive and process the Cruise Control Disable Command (SPN 5603).\r\n\r\n254 (0xFE) is used to indicate that the Source Address of Controlling Device for Disabling Cruise Control parameter is supported, but no device is currently inhibiting cruise control with the Cruise Control Disable Command (SPN 5603).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "SA",
      "SLOT_ID": 35
    },
    "5609": {
      "PGN": 64732,
      "PGN_Name": "Cruise Control / Vehicle Speed 3",
      "PGN_Description": "CCVS3",
      "first_bit": 16,
      "SPN": 5609,
      "SPN_Name": "Source Address of Controlling Device for Pausing Cruise Control",
      "SPN_Description": "The source address of the SAE J1939 device that is currently sending the Cruise Control Pause Command (SPN 5605).\r\n\r\nIf there are multiple devices sending Cruise Control Pause Command with a value of 01, then the value transmitted for this parameter will be the source address of the device that first began sending 01 for the command.  If the device that first sent 01 for Cruise Control Pause Command is no longer sending 01 for the command, then the value of the Source Address of Controlling Device for Pausing Cruise Control shall be set to the source address of a device that is still sending the Cruise Control Disable Command with a value of 01.\r\n\r\nThis parameter is supported by the device that has the capability to receive and process the Cruise Control Pause Command (SPN 5605).\r\n\r\n254 (0xFE) is used to indicate that the Source Address of Controlling Device for Pausing Cruise Control parameter is supported, but no device is currently inhibiting cruise control with the Cruise Control Pause Command (SPN 5605).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "SA",
      "SLOT_ID": 35
    },
    "5624": {
      "PGN": 65103,
      "PGN_Name": "Vehicle Dynamic Stability Control 1",
      "PGN_Description": "VDC1",
      "first_bit": 16,
      "SPN": 5624,
      "SPN_Name": "Trailer-VDC Active",
      "SPN_Description": "The trailer-VDC (Vehicle Dynamic Control) is an electronic vehicle stability function within the (semi) trailer braking system. It acts to stabilize the (semi) trailer during dynamic maneuvers. VDC includes Roll Over Prevention (ROP) and/or Yaw Control (YC), However, the latter information is not individually available and the VDC active parameter will be set in both cases.\r\n\r\nThis parameter maps the 6.4.2.2.36 VDC active parameter of the ISO 11992_2 bus (trailer-bus) to the SAE J1939 (vehicle bus). This makes it possible to warn the driver if one of the trailers activate the brakes because of  an VDC function active in the trailer.\r\n\r\n00 - VDC passive, but installed\r\n01 - VDC active\r\n10 - Reserved\r\n11 - Not availble or not installed",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5625": {
      "PGN": 64753,
      "PGN_Name": "Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information",
      "PGN_Description": "ETWAI",
      "first_bit": 16,
      "SPN": 5625,
      "SPN_Name": "Engine Exhaust Bank 1 Pressure Regulator Position",
      "SPN_Description": "The position of the Exhaust Pressure Regulator (EPR) in bank 1 expressed as a percentage of full travel.  One hundred percent means the regulator is fully closed, providing the maximum restriction to exhaust gas flow from the engine.  Zero percent means the regulator is fully open, providing the minimum available restriction.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5626": {
      "PGN": 64753,
      "PGN_Name": "Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information",
      "PGN_Description": "ETWAI",
      "first_bit": 24,
      "SPN": 5626,
      "SPN_Name": "Engine Exhaust Pressure Regulator Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Engine Exhaust Pressure Regulator (EPR) by the manufacturers software.  When there are multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5627": {
      "PGN": 64753,
      "PGN_Name": "Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information",
      "PGN_Description": "ETWAI",
      "first_bit": 29,
      "SPN": 5627,
      "SPN_Name": "Engine Exhaust Pressure Regulator Temperature Status",
      "SPN_Description": "Used to identify the status of the Engine Exhaust Pressure Regulator (EPR) drive circuitry temperature. Temperature excursions may affect the torque output.\r\n\r\n000 – High most severe\r\n001 – High Least severe\r\n010 – In Range\r\n011 – Low Least severe\r\n100 – Low Most severe\r\n101 – Not Defined\r\n110 – Error\r\n111 – Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5628": {
      "PGN": 64753,
      "PGN_Name": "Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information",
      "PGN_Description": "ETWAI",
      "first_bit": 32,
      "SPN": 5628,
      "SPN_Name": "Engine Exhaust Pressure Regulator Control Operation Status",
      "SPN_Description": "Used to identify the status of Engine Exhaust Pressure Regulator.\r\n\r\n0000 – Normal\r\n0001 – Alarm (fully operational but needs service)\r\n0010 – Alarm High Severity (functional but transient performance may be reduced)\r\n0011 – Derate Active (torque output reduced due to environmental conditions)\r\n0100 – Controlled Shutdown Active (driving to the default position – usually this means closed)\r\n0101 – Uncontrolled Shutdown Active (actuator current is off so it is limp)\r\n0110 – 1101 Reserved for future assignment\r\n1110 – Error\r\n1111 – Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5629": {
      "PGN": 64892,
      "PGN_Name": "Diesel Particulate Filter Control 1",
      "PGN_Description": "DPFC1",
      "first_bit": 58,
      "SPN": 5629,
      "SPN_Name": "Diesel Particulate Filter Active Regeneration Inhibited Due to Low Exhaust Pressure",
      "SPN_Description": "Indicates the state of diesel particulate filter active regeneration inhibition due to low exhaust pressure.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5630": {
      "PGN": 57344,
      "PGN_Name": "Cab Message 1",
      "PGN_Description": "CM1",
      "first_bit": 32,
      "SPN": 5630,
      "SPN_Name": "Park Brake Command",
      "SPN_Description": "Request by a secondary device to command the Park Brake.  The Park Brake controller should treat this as a request and should apply the Park Brake as determined by the controller. \r\n\r\nFeedback of the park brake actuation may utilize SPN 70, SPN 619 or SPN 5275.\r\n\r\n00 - Park Brake apply not requested\r\n01 - Park Brake apply requested\r\n10 - SAE Reserved  \r\n11 - Don't care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5631": {
      "PGN": 64961,
      "PGN_Name": "Engine Fluid Level/Pressure 3",
      "PGN_Description": "EFL/P3",
      "first_bit": 48,
      "SPN": 5631,
      "SPN_Name": "Engine Throttle Valve 1 Differential Pressure",
      "SPN_Description": "The differential pressure between the intake and outlet of the throttle valve 1 (SPN 51).  The differential pressure is measured from the intake with respect to the outlet of the throttle valve.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "5632": {
      "PGN": 64731,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot 3",
      "PGN_Description": "AT1DPF1S3",
      "first_bit": 0,
      "SPN": 5632,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Request Frequency 1",
      "SPN_Description": "First requested analysis frequency for the diesel particulate filter 1 soot sensor.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5633": {
      "PGN": 64731,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot 3",
      "PGN_Description": "AT1DPF1S3",
      "first_bit": 16,
      "SPN": 5633,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Request Frequency 2",
      "SPN_Description": "Second requested analysis frequency for the diesel particulate filter 1 soot sensor.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5634": {
      "PGN": 64731,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot 3",
      "PGN_Description": "AT1DPF1S3",
      "first_bit": 32,
      "SPN": 5634,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Request Frequency 3",
      "SPN_Description": "Third requested analysis frequency for the diesel particulate filter 1 soot sensor.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5635": {
      "PGN": 64731,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot 3",
      "PGN_Description": "AT1DPF1S3",
      "first_bit": 48,
      "SPN": 5635,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Request Frequency 4",
      "SPN_Description": "Fourth requested analysis frequency for the diesel particulate filter 1 soot sensor.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5636": {
      "PGN": 64730,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot 4",
      "PGN_Description": "AT1DPF1S4",
      "first_bit": 0,
      "SPN": 5636,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Frequency 1",
      "SPN_Description": "The analysis frequency associated with the frequency 1 soot signal for the diesel particulate filter 1 soot sensor.  See SPN 5632.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5637": {
      "PGN": 64730,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot 4",
      "PGN_Description": "AT1DPF1S4",
      "first_bit": 16,
      "SPN": 5637,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Frequency 1 Soot Signal",
      "SPN_Description": "The soot signal attenuation measurement for analysis frequency 1 for the diesel particulate filter 1 soot sensor.  See SPN 5632.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5638": {
      "PGN": 64730,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot 4",
      "PGN_Description": "AT1DPF1S4",
      "first_bit": 32,
      "SPN": 5638,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Frequency 2",
      "SPN_Description": "The analysis frequency associated with the frequency 2 soot signal for the diesel particulate filter 1 soot sensor.  See SPN 5633.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5639": {
      "PGN": 64730,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot 4",
      "PGN_Description": "AT1DPF1S4",
      "first_bit": 48,
      "SPN": 5639,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Frequency 2 Soot Signal",
      "SPN_Description": "The soot signal attenuation measurement for analysis frequency 2 for the diesel particulate filter 1 soot sensor.  See SPN 5633.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5640": {
      "PGN": 64729,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot 5",
      "PGN_Description": "AT1DPF1S5",
      "first_bit": 0,
      "SPN": 5640,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Frequency 3",
      "SPN_Description": "The analysis frequency associated with the frequency 3 soot signal for the diesel particulate filter 1 soot sensor.  See SPN 5634.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5641": {
      "PGN": 64729,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot 5",
      "PGN_Description": "AT1DPF1S5",
      "first_bit": 16,
      "SPN": 5641,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Frequency 3 Soot Signal",
      "SPN_Description": "The soot signal attenuation measurement for analysis frequency 3 for the diesel particulate filter 1 soot sensor.  See SPN 5634.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5642": {
      "PGN": 64729,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot 5",
      "PGN_Description": "AT1DPF1S5",
      "first_bit": 32,
      "SPN": 5642,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Frequency 4",
      "SPN_Description": "The analysis frequency associated with the frequency 4 soot signal for the diesel particulate filter 1 soot sensor.  See SPN 5635.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5643": {
      "PGN": 64729,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot 5",
      "PGN_Description": "AT1DPF1S5",
      "first_bit": 48,
      "SPN": 5643,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Frequency 4 Soot Signal",
      "SPN_Description": "The soot signal attenuation measurement for analysis frequency 4 for the diesel particulate filter 1 soot sensor.  See SPN 5635.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5644": {
      "PGN": 64728,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot 3",
      "PGN_Description": "AT1DPF2S3",
      "first_bit": 0,
      "SPN": 5644,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Request Frequency 1",
      "SPN_Description": "First requested analysis frequency for the diesel particulate filter 2 soot sensor.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5645": {
      "PGN": 64728,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot 3",
      "PGN_Description": "AT1DPF2S3",
      "first_bit": 16,
      "SPN": 5645,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Request Frequency 2",
      "SPN_Description": "Second requested analysis frequency for the diesel particulate filter 2 soot sensor.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5646": {
      "PGN": 64728,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot 3",
      "PGN_Description": "AT1DPF2S3",
      "first_bit": 32,
      "SPN": 5646,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Request Frequency 3",
      "SPN_Description": "Third requested analysis frequency for the diesel particulate filter 2 soot sensor.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5647": {
      "PGN": 64728,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot 3",
      "PGN_Description": "AT1DPF2S3",
      "first_bit": 48,
      "SPN": 5647,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Request Frequency 4",
      "SPN_Description": "Fourth requested analysis frequency for the diesel particulate filter 2 soot sensor.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5648": {
      "PGN": 64727,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot 4",
      "PGN_Description": "AT1DPF2S4",
      "first_bit": 0,
      "SPN": 5648,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Frequency 1",
      "SPN_Description": "The analysis frequency associated with the frequency 1 soot signal for the diesel particulate filter 2 soot sensor.  See SPN 5644.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5649": {
      "PGN": 64727,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot 4",
      "PGN_Description": "AT1DPF2S4",
      "first_bit": 16,
      "SPN": 5649,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Frequency 1 Soot Signal",
      "SPN_Description": "The soot signal attenuation measurement for analysis frequency 1 for the diesel particulate filter 2 soot sensor.  See SPN 5644.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5650": {
      "PGN": 64727,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot 4",
      "PGN_Description": "AT1DPF2S4",
      "first_bit": 32,
      "SPN": 5650,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Frequency 2",
      "SPN_Description": "The analysis frequency associated with the frequency 2 soot signal for the diesel particulate filter 2 soot sensor.  See SPN 5645.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5651": {
      "PGN": 64727,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot 4",
      "PGN_Description": "AT1DPF2S4",
      "first_bit": 48,
      "SPN": 5651,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Frequency 2 Soot Signal",
      "SPN_Description": "The soot signal attenuation measurement for analysis frequency 2 for the diesel particulate filter 2 soot sensor.  See SPN 5645.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5652": {
      "PGN": 64726,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot 5",
      "PGN_Description": "AT1DPF2S5",
      "first_bit": 0,
      "SPN": 5652,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Frequency 3",
      "SPN_Description": "The analysis frequency associated with the frequency 3 soot signal for the diesel particulate filter 2 soot sensor.  See SPN 5646.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5653": {
      "PGN": 64726,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot 5",
      "PGN_Description": "AT1DPF2S5",
      "first_bit": 16,
      "SPN": 5653,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Frequency 3 Soot Signal",
      "SPN_Description": "The soot signal attenuation measurement for analysis frequency 3 for the diesel particulate filter 2 soot sensor.  See SPN 5646.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5654": {
      "PGN": 64726,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot 5",
      "PGN_Description": "AT1DPF2S5",
      "first_bit": 32,
      "SPN": 5654,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Frequency 4",
      "SPN_Description": "The analysis frequency associated with the frequency 4 soot signal for the diesel particulate filter 2 soot sensor.  See SPN 5647.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "MHz",
      "SLOT_ID": 320
    },
    "5655": {
      "PGN": 64726,
      "PGN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot 5",
      "PGN_Description": "AT1DPF2S5",
      "first_bit": 48,
      "SPN": 5655,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Frequency 4 Soot Signal",
      "SPN_Description": "The soot signal attenuation measurement for analysis frequency 4 for the diesel particulate filter 2 soot sensor.  See SPN 5647.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5656": {
      "PGN": 65275,
      "PGN_Name": "Retarder fluids",
      "PGN_Description": "RF",
      "first_bit": 24,
      "SPN": 5656,
      "SPN_Name": "Retarder Coolant Outlet Temperature",
      "SPN_Description": "Temperature of liquid found in retarder cooling system.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5675": {
      "PGN": 65279,
      "PGN_Name": "Operator indicators",
      "PGN_Description": "OI",
      "first_bit": 2,
      "SPN": 5675,
      "SPN_Name": "Operator Shift Prompt",
      "SPN_Description": "Command to activate an indicator that advises the operator to shift to a different gear.  Typically this would be used as part of a fuel economy improvement or drivability aid.\r\n\r\n00 - indicator(s) inactive\r\n01 - upshift indicator active\r\n10 - downshift indicator active\r\n11 - don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5676": {
      "PGN": 61487,
      "PGN_Name": "Advanced Emergency Braking System 1",
      "PGN_Description": "AEBS1",
      "first_bit": 0,
      "SPN": 5676,
      "SPN_Name": "Advanced emergency braking system state",
      "SPN_Description": "Current operational state of advanced emergency braking system\r\n\r\n0000 - system is not ready (initialization not finished)\r\n0001 - system is temporarily not available (e.g. due to boundary conditions necessary for operation)\r\n0010 - system is deactivated by driver\r\n0011 - system is ready and activated (no warning and no braking active)\r\n0100 - driver overrides system\r\n0101 - collision warning active (e.g. acoustic signal, cruise control turned off, torque limitation)\r\n0110 - collision warning with braking (e.g. brake jerk or partial braking)\r\n0111 - emergency braking active\r\n1000 - system performance and/or sensitivity limited (no warning and no braking active)\r\n1001 - 1101 - reserved for future use\r\n1110 - error indication\r\n1111 - not available / not installed\r\n\r\nNote:  State 1000 - Example Use Case: Used when system performance is limited but still able to meet minimum legal obligations present at the time of introduction or when one of a fused sensor is faulted but the Emergency Braking functionality is still available.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5677": {
      "PGN": 61487,
      "PGN_Name": "Advanced Emergency Braking System 1",
      "PGN_Description": "AEBS1",
      "first_bit": 4,
      "SPN": 5677,
      "SPN_Name": "Collision warning level",
      "SPN_Description": "To implement different HMI (human machine interface) concepts, e.g. visual only, visual/audible, different warning tones etc., the AEBS provides different levels of collision warning.\r\n\r\n0000 - no warning\r\n0001 - warning level 1 - lowest\r\n0010 - warning level 2\r\n0011 - warning level 3\r\n0100 - warning level 4\r\n0101 - warning level 5\r\n0110 - warning level 6\r\n0111 - warning level 7 - highest\r\n1000…1110 - reserved\r\n1111 - don’t care / take no action\r\n\r\nValues between 0001 (lowest warning level) and 0111 (highest warning level) are increasing.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5678": {
      "PGN": 61487,
      "PGN_Name": "Advanced Emergency Braking System 1",
      "PGN_Description": "AEBS1",
      "first_bit": 8,
      "SPN": 5678,
      "SPN_Name": "Relevant object detected for advanced emergency braking system",
      "SPN_Description": "Indication if the advanced emergency braking system (AEBS) is monitoring a relevant object\r\n\r\n000 - no relevant object monitored\r\n001 - relevant object is being monitored\r\n010 - relevant object is not being detected reliably\r\n011..101 - reserved\r\n110 - error indication\r\n111 - signal not available / not installed",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5679": {
      "PGN": 61487,
      "PGN_Name": "Advanced Emergency Braking System 1",
      "PGN_Description": "AEBS1",
      "first_bit": 11,
      "SPN": 5679,
      "SPN_Name": "Bend off probability of relevant object",
      "SPN_Description": "Probabilty if monitored relevant object might start a turning maneuver, which could clear the travelling path of the host vehicle.\r\n\r\n000 - no indication for a bend off maneuver of the relevant object\r\n001 - low probability for a bend off maneuver of the relevant object\r\n010 - medium probability for a bend off maneuver of the relevant object\r\n011 - high probability for a bend off maneuver of the relevant object\r\n100 - highest probability for a bend off maneuver of the relevant object\r\n101 - relevant object is already in a turning maneuver\r\n110 - error indication\r\n111 - signal not available / not installed",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5680": {
      "PGN": 61487,
      "PGN_Name": "Advanced Emergency Braking System 1",
      "PGN_Description": "AEBS1",
      "first_bit": 16,
      "SPN": 5680,
      "SPN_Name": "Time to collision with relevant object",
      "SPN_Description": "The time to collision is the duration after which the predicted travelling paths of host vehicle and relevant object lead to a distance of 0m between both.\r\n\r\nNote:  It is up to the system manufacturer to choose a suitable calculation method to predict the travelling paths of both host vehicle and relevant object.",
      "bit_length": 8,
      "scaling": 0.05,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 322
    },
    "5681": {
      "PGN": 2816,
      "PGN_Name": "Advanced Emergency Braking System 2",
      "PGN_Description": "AEBS2",
      "first_bit": 0,
      "SPN": 5681,
      "SPN_Name": "Driver activation demand for Advanced Emergency Braking System",
      "SPN_Description": "According to the Vienna world convention on road traffic the driver must be provided with means to deactivate an Advanced Emergency Braking System. This command is to be transmitted from the respective HMI unit to the AEBS unit.\r\n\r\n00 - the driver does not want the Advanced Emergency Braking System to warn or intervene at any time (deactivation of system)\r\n01 - the driver wants the Advanced Emergency Braking System to warn or intervene if necessary (no deactivation of system)\r\n10 - reserved\r\n11 - don’t' care / take no action\r\n\r\nNote:  The signal has to be transmitted permanently to the AEBS showing the state selected once by the driver.  Typically there is a deactivation push button present in the host vehicle for the driver to choose this state.\r\n\r\nExample: After ignition-on the signal is being transmitted as 01b (this will be the default state in Europe) all the time. As soon as the driver depresses the push button the signal's value has to change to 00b for the remaining ignition cycle as long as the driver does not depress the push button again.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5682": {
      "PGN": 2816,
      "PGN_Name": "Advanced Emergency Braking System 2",
      "PGN_Description": "AEBS2",
      "first_bit": 56,
      "SPN": 5682,
      "SPN_Name": "AEBS2 message Counter",
      "SPN_Description": "The message counter is increased with every transmitted AEBS2 message.  After reaching a value of 0xF the next value will be 0.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 220
    },
    "5683": {
      "PGN": 2816,
      "PGN_Name": "Advanced Emergency Braking System 2",
      "PGN_Description": "AEBS2",
      "first_bit": 60,
      "SPN": 5683,
      "SPN_Name": "AEBS2 message checksum",
      "SPN_Description": "Used to check the message checksum of the transmitting (HMI) unit within the AEBS2 system.\r\n\r\nChecksum = (Byte1 + Byte2 + Byte3 + Byte4 + Byte5 + Byte6 + Byte7 + (message counter & 0x0F) + message ID low byte + message ID mid low byte + message ID mid high byte + message ID high byte)\r\n\r\nMessage Checksum = ((Checksum >> 4) + Checksum) & 0x0F",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 220
    },
    "5684": {
      "PGN": 65109,
      "PGN_Name": "Gaseous Fuel Properties",
      "PGN_Description": "GFD",
      "first_bit": 16,
      "SPN": 5684,
      "SPN_Name": "Reference Engine Gas Mass Flow Rate",
      "SPN_Description": "Configuration of the mass flow rate of gaseous fuel expected for 100% engine fuel valve control command.\r\n\r\nNote:  The actuator will request this parameter from the ECU in order to determine what mass fuel flow to associate with a command of 100% from the ECU.  This value does not change during operation.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "kg/h",
      "SLOT_ID": 18
    },
    "5685": {
      "PGN": 64992,
      "PGN_Name": "Ambient Conditions 2",
      "PGN_Description": "AMB2",
      "first_bit": 48,
      "SPN": 5685,
      "SPN_Name": "Barometric Absolute Pressure (High Resolution)",
      "SPN_Description": "Barometric Absolute Pressure (High Resolution).  See SPN 108 if high resolution is not needed.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "5706": {
      "PGN": 64725,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Pump 1 Information",
      "PGN_Description": "AT1P1I",
      "first_bit": 0,
      "SPN": 5706,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Pump Heater",
      "SPN_Description": "Percentage of heating applied to the aftertreatment 1 diesel exhaust fluid pump heater. A value of 0% means no heating applied, a value of 100% means full heating applied. The diesel exhaust fluid pump heater warms the diesel exhaust fluid in the diesel exhaust fluid pump. See SPN 5707 for the command for this pump heater.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5707": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 32,
      "SPN": 5707,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Pump Heater Command",
      "SPN_Description": "Command for the Aftertreatment 1 Diesel Exhaust Fluid Pump Heater. A value of 0% means no heating commanded, a value of 100% means full heating commanded. See SPN 5706 for the measured value of the Aftertreatment 1 Diesel Exhaust Fluid Heater.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5708": {
      "PGN": 64768,
      "PGN_Name": "Engine Fluid Level/Pressure 10",
      "PGN_Description": "EFL/P10",
      "first_bit": 56,
      "SPN": 5708,
      "SPN_Name": "Engine Coolant Pressure 2",
      "SPN_Description": "Gage pressure of liquid found in the engine coolant system - second instance.\r\n\r\nSee SPN 7313 for alternate range and resolution.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "5713": {
      "PGN": 61455,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 1",
      "PGN_Description": "AT1OG1",
      "first_bit": 53,
      "SPN": 5713,
      "SPN_Name": "Aftertreatment 1 Outlet NOx Sensor 1 Self-diagnosis Status",
      "SPN_Description": "Self-diagnosis result status for NOx sensor ATO1 (Aftertreatment Outlet Bank 1)\r\n\r\n000 Diagnosis not active\r\n001 NOx Sensor ATO1 Self Diagnosis active flag\r\n010 NOx Sensor ATO1 Self Diagnosis Result Complete\r\n011 NOx Sensor ATO1 Self Diagnosis aborted\r\n100 NOx Sensor ATO1 Self Diagnosis not possible\r\n101 - 110 Reserved\r\n111 Not Supported",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5714": {
      "PGN": 61454,
      "PGN_Name": "Aftertreatment 1 Intake Gas 1",
      "PGN_Description": "AT1IG1",
      "first_bit": 53,
      "SPN": 5714,
      "SPN_Name": "Aftertreatment 1 Intake NOx Sensor 1 Self-diagnosis Status",
      "SPN_Description": "Self-diagnosis result status for the NOx sensor ATI1 (Aftertreatment Intake Bank 1)\r\n\r\n000 Diagnosis not active\r\n001 NOx Sensor ATI1 Self Diagnosis active flag\r\n010 NOx Sensor ATI1 Self Diagnosis Result Complete\r\n011 NOx Sensor ATI1 Self Diagnosis aborted\r\n100 NOx Sensor ATI1 Self Diagnosis not possible\r\n101 - 110 Reserved\r\n111 Not Supported",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5715": {
      "PGN": 61457,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 1",
      "PGN_Description": "AT2OG1",
      "first_bit": 53,
      "SPN": 5715,
      "SPN_Name": "Aftertreatment 2 Outlet NOx Sensor 1 Self-diagnosis Status",
      "SPN_Description": "Self-diagnosis result status for NOx sensor ATO2 (Aftertreatment Outlet Bank 2)\r\n\r\n000 Diagnosis not active\r\n001 NOx Sensor ATO2 Self Diagnosis active flag\r\n010 NOx Sensor ATO2 Self Diagnosis Result Complete\r\n011 NOx Sensor ATO2 Self Diagnosis aborted\r\n100 NOx Sensor ATO2 Self Diagnosis not possible\r\n101 - 110 Reserved\r\n111 Not Supported",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5716": {
      "PGN": 61456,
      "PGN_Name": "Aftertreatment 2 Intake Gas 1",
      "PGN_Description": "AT2IG1",
      "first_bit": 53,
      "SPN": 5716,
      "SPN_Name": "Aftertreatment 2 Intake NOx Sensor 1 Self-diagnosis Status",
      "SPN_Description": "Self-diagnosis result status for NOx sensor ATI2 (Aftertreatment Intake Bank 2)\r\n\r\n000 Diagnosis not active\r\n001 NOx Sensor ATI2 Self Diagnosis active flag\r\n010 NOx Sensor ATI2 Self Diagnosis Result Complete\r\n011 NOx Sensor ATI2 Self Diagnosis aborted\r\n100 NOx Sensor ATI2 Self Diagnosis not possible\r\n101 - 110 Reserved\r\n111 Not Supported",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5717": {
      "PGN": 64782,
      "PGN_Name": "Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT1OGC2",
      "first_bit": 32,
      "SPN": 5717,
      "SPN_Name": "Aftertreatment 1 Outlet NOx Sensor Self-diagnosis Final Result",
      "SPN_Description": "Self-diagnosis result for NOx sensor ATO1 (Aftertreatment Outlet Bank 1) as a ratio of detected value to reference value defined by supplier.\r\n\r\nThis result is used to determine if the signal resulting from the self-diagnosis test (as represented as a ratio to a reference value) is within an acceptable range.  This will be determined by the receiver of the information and may differ depending on how the sensor is used and/or sensor application.  This may mean that SPN 3226 may no longer be accurate as expected.\r\n\r\nThis parameter is valid while the diagnosis feedback status of SPN 5713 = 010b (Diagnosis complete).  It is broadcast as 0xFF at other times.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 56
    },
    "5718": {
      "PGN": 64784,
      "PGN_Name": "Aftertreatment 1 Intake Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT1IGC2",
      "first_bit": 32,
      "SPN": 5718,
      "SPN_Name": "Aftertreatment 1 Intake NOx Sensor Self-diagnosis Final Result",
      "SPN_Description": "Self-diagnosis result for NOx sensor ATI1 (Aftertreatment Intake Bank 1) as a ratio of detected value to reference value defined by supplier.\r\n\r\nThis result is used to determine if the signal resulting from the self-diagnosis test (as represented as a ratio to a reference value) is within an acceptable range.  This will be determined by the receiver of the information and may differ depending on how the sensor is used and/or sensor application.  This may mean that SPN 3216 may no longer be accurate as expected.\r\n\r\nThis parameter is valid while the diagnosis feedback status of SPN 5714 = 010b (Diagnosis complete).  It is broadcast as 0xFF at other times.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 56
    },
    "5719": {
      "PGN": 64778,
      "PGN_Name": "Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT2OGC2",
      "first_bit": 32,
      "SPN": 5719,
      "SPN_Name": "Aftertreatment 2 Outlet NOx Sensor Self-diagnosis Final Result",
      "SPN_Description": "Self-diagnosis result for NOx sensor ATO2 (Aftertreatment Outlet Bank 2) as a ratio of detected value to reference value defined by supplier.\r\n\r\nThis result is used to determine if the signal resulting from the self-diagnosis test (as represented as a ratio to a reference value) is within an acceptable range.  This will be determined by the receiver of the information and may differ depending on how the sensor is used and/or sensor application.  This may mean that SPN 3265 may no longer be accurate as expected.\r\n\r\nThis parameter is valid while the diagnosis feedback status of SPN 5715 = 010b (Diagnosis complete).  It is broadcast as 0xFF at other times.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 56
    },
    "5720": {
      "PGN": 64780,
      "PGN_Name": "Aftertreatment 2 Intake Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT2IGC2",
      "first_bit": 32,
      "SPN": 5720,
      "SPN_Name": "Aftertreatment 2 Intake NOx Sensor Self-diagnosis Final Result",
      "SPN_Description": "Self-diagnosis result for NOx sensor ATI2 (Aftertreatment Intake Bank 2) as a ratio of detected value to reference value defined by supplier.\r\n\r\nThis result is used to determine if the signal resulting from the self-diagnosis test (as represented as a ratio to a reference value) is within an acceptable range.  This will be determined by the receiver of the information and may differ depending on how the sensor is used and/or sensor application.  This may mean that SPN 3255 may no longer be accurate as expected.\r\n\r\nThis parameter is valid while the diagnosis feedback status of SPN 5716 = 010b (Diagnosis complete).  It is broadcast as 0xFF at other times.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 56
    },
    "5721": {
      "PGN": 64783,
      "PGN_Name": "Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT1OGC1",
      "first_bit": 40,
      "SPN": 5721,
      "SPN_Name": "Aftertreatment 1 Outlet NOx Sensor Operation Hours",
      "SPN_Description": "Counted hours that the NOx-sensor was operated with status \"dewpoint reached\"",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 324
    },
    "5722": {
      "PGN": 64785,
      "PGN_Name": "Aftertreatment 1 Intake Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT1IGC1",
      "first_bit": 40,
      "SPN": 5722,
      "SPN_Name": "Aftertreatment 1 Intake NOx Sensor Operation Hours",
      "SPN_Description": "Counted hours that the NOx-sensor was operated with status \"dewpoint reached\"",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 324
    },
    "5723": {
      "PGN": 64779,
      "PGN_Name": "Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT2OGC1",
      "first_bit": 40,
      "SPN": 5723,
      "SPN_Name": "Aftertreatment 2 Outlet NOx Sensor Operation Hours",
      "SPN_Description": "Counted hours that the NOx-sensor was operated with status \"dewpoint reached\"",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 324
    },
    "5724": {
      "PGN": 64781,
      "PGN_Name": "Aftertreatment 2 Intake Gas NOx Sensor Correction Data 1",
      "PGN_Description": "AT2IGC1",
      "first_bit": 40,
      "SPN": 5724,
      "SPN_Name": "Aftertreatment 2 Intake NOx Sensor Operation Hours",
      "SPN_Description": "Counted hours that the NOx-sensor was operated with status \"dewpoint reached\"",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 324
    },
    "5746": {
      "PGN": 64725,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Pump 1 Information",
      "PGN_Description": "AT1P1I",
      "first_bit": 24,
      "SPN": 5746,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Dosing Unit 1 Heater Relay",
      "SPN_Description": "The status of the relay that controls Aftertreatment 1 diesel exhaust fluid dosing Unit 1 Heater.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5749": {
      "PGN": 64662,
      "PGN_Name": "Engine Information 2",
      "PGN_Description": "EI2",
      "first_bit": 48,
      "SPN": 5749,
      "SPN_Name": "Engine Exhaust Pressure 2",
      "SPN_Description": "Gage pressure of the exhaust gasses as measured at the turbine intake of the turbocharger of exhaust bank 2. See SPN 1209 for exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "kPa",
      "SLOT_ID": 52
    },
    "5750": {
      "PGN": 61488,
      "PGN_Name": "Wireless Status",
      "PGN_Description": "WS",
      "first_bit": 0,
      "SPN": 5750,
      "SPN_Name": "Wireless Rolling Message Counter",
      "SPN_Description": "A counter incremented with each instance of the Wireless Status message. The counter shall increment from 0 to 64255, rolling over to 0 on the next increment after 64255. The enables recipients of the Wireless Status message to detect problems with the wireless transceiver if counter fails to increment or the counter prematurely resets to 0.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "5751": {
      "PGN": 61488,
      "PGN_Name": "Wireless Status",
      "PGN_Description": "WS",
      "first_bit": 20,
      "SPN": 5751,
      "SPN_Name": "Transmitter Command State",
      "SPN_Description": "The command contained in the signal received by the wireless transceiver from an off-board transmitter.\r\n\r\n0000b - Stop\r\n0001b - Clear\r\n0010b - Field Test\r\n0011b - Transmitter Test\r\n0100b - Standby\r\n0101b to 1101b - Reserved\r\n1110b - Error\r\n1111b - Don't Care\r\n\r\n0000b - Stop - Received an RF messsage from a transmitter requesting a machine level \"Stop.\"\r\n0001b - Clear - Received an RF message from a transmitter clearing a machine level \"Stop\" request.\r\n0010b - Field Test - Used to request an acknowledgement of an RF signal from the onboard ECU, without adversely affecting the operation of the vehicle\r\n0011b - Transmitter Test - A transmitter test RF message was requested by a transmitter, used to diagnose transmitter behaviors\r\n0100b - Standby - No new Status message received at the time the message was communicated\r\n1110b - Error - Device Error",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5752": {
      "PGN": 61488,
      "PGN_Name": "Wireless Status",
      "PGN_Description": "WS",
      "first_bit": 24,
      "SPN": 5752,
      "SPN_Name": "Transmitter ID 1",
      "SPN_Description": "The ID of the off-board transmitter that sent the incoming message received by the wireless transceiver.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "ID",
      "SLOT_ID": 325
    },
    "5753": {
      "PGN": 61488,
      "PGN_Name": "Wireless Status",
      "PGN_Description": "WS",
      "first_bit": 48,
      "SPN": 5753,
      "SPN_Name": "Wireless Signal Strength 1",
      "SPN_Description": "The absolute received signal strength of the signal received from the off-board transmitter. The signal strength is reported as a Received Signal Strength Indicator (RSSI) value calculated in dBm.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": -125,
      "unit": "dBm",
      "SLOT_ID": 326
    },
    "5754": {
      "PGN": 34816,
      "PGN_Name": "Radio Beacon Request",
      "PGN_Description": "RBR",
      "first_bit": 0,
      "SPN": 5754,
      "SPN_Name": "Unique Beacon Message Identifier Number",
      "SPN_Description": "The number is used to identify a wireless message originating from a device on a particular machine. Within a beacon request message (see SPN 5755 [Radio Beacon Direction]), this number is included in the transmitted beacon signal. Within a beacon request acknowledge (see SPN 5755 [Radio Beacon Direction]), this number is the number from the received beacon signal.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "5755": {
      "PGN": 34816,
      "PGN_Name": "Radio Beacon Request",
      "PGN_Description": "RBR",
      "first_bit": 22,
      "SPN": 5755,
      "SPN_Name": "Radio Beacon Direction",
      "SPN_Description": "Indicates the function of a particular instance of the Radio Beacon Request message. The 'Beacon Request' state indicates the message is sent to a wireless transceiver to request a transmit of the special beacon message. The 'Beacon Received Acknowledgement' is sent from a wireless transceiver to report the reception of a special beacon message.\r\n\r\n00b - Beacon Request - Beacon request coming from an ECU\r\n01b - Beacon Received Acknowledgement - Acknowledgement from wireless device\r\n10b - Reserved\r\n11b - Don't Care\r\n\r\n00b - Beacon Request - An ECU requests that a beacon message be transmitted from a wireless device on a machine. This status will always originate from the ECU, and be sent to a wireless device. The message associated with this state will not have an associated transmitter ID, or signal strength.\r\n01b - Beacon Received Acknowledgement - Acknowledgement of a beacon transmission detected by an onboard wireless device. This status will always originate from the wireless device, and be sent to the ECU. The message associated with this state will have an associated transmitter ID and signal strength.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5756": {
      "PGN": 34816,
      "PGN_Name": "Radio Beacon Request",
      "PGN_Description": "RBR",
      "first_bit": 24,
      "SPN": 5756,
      "SPN_Name": "Transmitter ID 2",
      "SPN_Description": "The ID of the off-board transmitter that sent the incoming special beacon message received by the wireless transceiver.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "ID",
      "SLOT_ID": 325
    },
    "5757": {
      "PGN": 34816,
      "PGN_Name": "Radio Beacon Request",
      "PGN_Description": "RBR",
      "first_bit": 48,
      "SPN": 5757,
      "SPN_Name": "Wireless Signal Strength 2",
      "SPN_Description": "The absolute received signal strength of the special beacon signal received from the off-board transmitter. The signal strength is reported as a Received Signal Strength Indicator (RSSI) value in dBm. This measurement method is identical to SPN 5753 [Wireless Signal Strength].",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": -125,
      "unit": "dBm",
      "SLOT_ID": 326
    },
    "5758": {
      "PGN": 64716,
      "PGN_Name": "Electronic Engine Controller 12",
      "PGN_Description": "EEC12",
      "first_bit": 0,
      "SPN": 5758,
      "SPN_Name": "Aftertreatment 1 Intake 1 Gas Sensor Power Supply",
      "SPN_Description": "State signal which indicates when the Aftertreatment 1 Intake 1 Gas Sensor driver output is being driven.  On means the ECU is powering the Aftertreatment 1 Intake 1 Gas Sensor.  Note that the ECU is external to the sensor.\r\n\r\n00 – Off\r\n01 – On: The ECU is powering the Aftertreatment 1 Intake 1 Gas Sensor\r\n10 – Error\r\n11 – Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5759": {
      "PGN": 64716,
      "PGN_Name": "Electronic Engine Controller 12",
      "PGN_Description": "EEC12",
      "first_bit": 2,
      "SPN": 5759,
      "SPN_Name": "Aftertreatment 1 Outlet 1 Gas Sensor Power Supply",
      "SPN_Description": "State signal which indicates when the Aftertreatment 1 Outlet 1 Gas Sensor driver output is being driven. On means the ECU is powering the Aftertreatment 1 Outlet 1 Gas Sensor. Note that the ECU is external to the sensor.\r\n\r\n00 - Off\r\n01 - On: The ECU is powering the Aftertreatment 1 Outlet 1 Gas Sensor\r\n10 - Error\r\n11 - Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5760": {
      "PGN": 64716,
      "PGN_Name": "Electronic Engine Controller 12",
      "PGN_Description": "EEC12",
      "first_bit": 4,
      "SPN": 5760,
      "SPN_Name": "Aftertreatment 2 Intake 1 Gas Sensor Power Supply",
      "SPN_Description": "State signal which indicates when the Aftertreatment 2 Intake 1 Gas Sensor driver output is being driven.  On means the ECU is powering the Aftertreatment 2 Intake 1 Gas Sensor.  Note that the ECU is external to the sensor.\r\n\r\n00 – Off\r\n01 – On: The ECU is powering the Aftertreatment 2 Intake 1 Gas Sensor\r\n10 – Error\r\n11 – Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5761": {
      "PGN": 64716,
      "PGN_Name": "Electronic Engine Controller 12",
      "PGN_Description": "EEC12",
      "first_bit": 6,
      "SPN": 5761,
      "SPN_Name": "Aftertreatment 2 Outlet 1 Gas Sensor Power Supply",
      "SPN_Description": "State signal which indicates when the Aftertreatment 2 Outlet 1 Gas Sensor driver output is being driven.  On means the ECU is powering the Aftertreatment 2 Outlet 1 Gas Sensor.  Note that the ECU is external to the sensor.\r\n\r\n00 – Off\r\n01 – On: The ECU is powering the Aftertreatment 2 Outlet 1 Gas Sensor\r\n10 – Error\r\n11 – Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5762": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 38,
      "SPN": 5762,
      "SPN_Name": "Transmission Load Reduction Inhibit Request",
      "SPN_Description": "Request signal to the transmission to inhibit activation of load reduction functions.\r\n\r\nAutomatic transmissions may incorporate functions designed to reduce engine load during certain operating conditions (vehicle standstill at bus stop, traffic stop, etc.) for improved fuel consumption. However, other vehicle systems may have an interest in regular (higher) engine load levels for comfort features or to assist with heat generation.  This signal requests that the transmission inhibit initiation of such load reduction functions or terminates their operation if they are already active. The transmission may choose to ignore this request during certain operating conditions as defined by the transmission manufacturer.\r\n\r\n00 = Allow or resume transmission load reduction functions\r\n01 = Inhibit or abort transmission load reduction functions\r\n10 = Reserved\r\n11 = Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5763": {
      "PGN": 64715,
      "PGN_Name": "Engine Exhaust Gas Recirculation 1 Actuator",
      "PGN_Description": "EEGR1A",
      "first_bit": 0,
      "SPN": 5763,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Actuator 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Engine Exhaust Gas Recirculation 1 Actuator 1 by the manufacturer’s software.  When there are multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5764": {
      "PGN": 64715,
      "PGN_Name": "Engine Exhaust Gas Recirculation 1 Actuator",
      "PGN_Description": "EEGR1A",
      "first_bit": 5,
      "SPN": 5764,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Actuator 1 Temperature Status",
      "SPN_Description": "Used to identify the status of the Engine Exhaust Gas Recirculation 1 Actuator 1 drive circuitry temperature.  Temperature excursions may affect the torque output.\r\n \r\n000 – High Most severe\r\n001 – High Least severe\r\n010 – In Range \r\n011 – Low Least severe\r\n100 – Low Most severe\r\n101 – Not Defined\r\n110 – Error\r\n111 – Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5765": {
      "PGN": 64715,
      "PGN_Name": "Engine Exhaust Gas Recirculation 1 Actuator",
      "PGN_Description": "EEGR1A",
      "first_bit": 8,
      "SPN": 5765,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Actuator 1 Temperature",
      "SPN_Description": "Temperature of the Engine Exhaust Gas Recirculation 1 Actuator 1 drive circuitry.  Temperature excursions may affect the torque output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5766": {
      "PGN": 64715,
      "PGN_Name": "Engine Exhaust Gas Recirculation 1 Actuator",
      "PGN_Description": "EEGR1A",
      "first_bit": 16,
      "SPN": 5766,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Actuator 1 Desired Position",
      "SPN_Description": "The requested position of the Engine Exhaust Gas Recirculation 1 Actuator 1 by the engine ECU, where 0% represents fully closed and 100% represents fully open.\r\n\r\nThis is the position that the device is attempting to achieve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5767": {
      "PGN": 64715,
      "PGN_Name": "Engine Exhaust Gas Recirculation 1 Actuator",
      "PGN_Description": "EEGR1A",
      "first_bit": 24,
      "SPN": 5767,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Actuator 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Engine Exhaust Gas Recirculation 1 Actuator 2 by the manufacturer’s software. When there are multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5768": {
      "PGN": 64715,
      "PGN_Name": "Engine Exhaust Gas Recirculation 1 Actuator",
      "PGN_Description": "EEGR1A",
      "first_bit": 29,
      "SPN": 5768,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Actuator 2 Temperature Status",
      "SPN_Description": "Used to identify the status of the Engine Exhaust Gas Recirculation 1 Actuator 2 drive circuitry temperature.  Temperature excursions may affect the torque output.\r\n \r\n000 – High Most severe\r\n001 – High Least severe\r\n010 – In Range \r\n011 – Low Least severe\r\n100 – Low Most severe\r\n101 – Not Defined\r\n110 – Error\r\n111 – Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5769": {
      "PGN": 64715,
      "PGN_Name": "Engine Exhaust Gas Recirculation 1 Actuator",
      "PGN_Description": "EEGR1A",
      "first_bit": 32,
      "SPN": 5769,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Actuator 2 Temperature",
      "SPN_Description": "Temperature of the Engine Exhaust Gas Recirculation 1 Actuator 2 drive circuitry.  Temperature excursions may affect the torque output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5770": {
      "PGN": 64715,
      "PGN_Name": "Engine Exhaust Gas Recirculation 1 Actuator",
      "PGN_Description": "EEGR1A",
      "first_bit": 40,
      "SPN": 5770,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Actuator 2 Desired Position",
      "SPN_Description": "The requested position of the Engine Exhaust Gas Recirculation 1 Actuator 2 by the engine ECU, where 0% represents fully closed and 100% represents fully open.\r\n\r\nThis is the position that the device is attempting to achieve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5771": {
      "PGN": 64715,
      "PGN_Name": "Engine Exhaust Gas Recirculation 1 Actuator",
      "PGN_Description": "EEGR1A",
      "first_bit": 48,
      "SPN": 5771,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Actuator 1 Operation Status",
      "SPN_Description": "Used to identify the status of Exhaust Gas Recirculation 1 Actuator 1\r\n\r\n0000 – Normal\r\n0001 – Alarm (fully operational but needs service)\r\n0010 – Alarm High Severity (functional but transient performance may be reduced)\r\n0011 – Derate Active (torque output reduced due to environmental conditions)\r\n0100 – Controlled Shutdown Active (driving to the default position – usually this means closed)\r\n0101 – Uncontrolled Shutdown Active (no torque is being applied from the actuator)\r\n0110 – 1101 Reserved for future assignment\r\n1110 – Error\r\n1111 – Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5772": {
      "PGN": 64715,
      "PGN_Name": "Engine Exhaust Gas Recirculation 1 Actuator",
      "PGN_Description": "EEGR1A",
      "first_bit": 52,
      "SPN": 5772,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Actuator 2 Operation Status",
      "SPN_Description": "Used to identify the status of Exhaust Gas Recirculation 1 Actuator 2\r\n\r\n0000 – Normal\r\n0001 – Alarm (fully operational but needs service)\r\n0010 – Alarm High Severity (functional but transient performance may be reduced)\r\n0011 – Derate Active (torque output reduced due to environmental conditions)\r\n0100 – Controlled Shutdown Active (driving to the default position – usually this means closed)\r\n0101 – Uncontrolled Shutdown Active (no torque is being applied from the actuator)\r\n0110 – 1101 Reserved for future assignment\r\n1110 – Error\r\n1111 – Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5773": {
      "PGN": 64714,
      "PGN_Name": "Engine Exhaust Gas Recirculation 2 Actuator",
      "PGN_Description": "EEGR2A",
      "first_bit": 0,
      "SPN": 5773,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Actuator 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Engine Exhaust Gas Recirculation 2 Actuator 1 by the manufacturer’s software.  When there are multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5774": {
      "PGN": 64714,
      "PGN_Name": "Engine Exhaust Gas Recirculation 2 Actuator",
      "PGN_Description": "EEGR2A",
      "first_bit": 5,
      "SPN": 5774,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Actuator 1 Temperature Status",
      "SPN_Description": "Used to identify the status of the Engine Exhaust Gas Recirculation 2 Actuator 1 drive circuitry temperature.  Temperature excursions may affect the torque output.\r\n \r\n000 – High Most severe\r\n001 – High Least severe\r\n010 – In Range \r\n011 – Low Least severe\r\n100 – Low Most severe\r\n101 – Not Defined\r\n110 – Error\r\n111 – Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5775": {
      "PGN": 64714,
      "PGN_Name": "Engine Exhaust Gas Recirculation 2 Actuator",
      "PGN_Description": "EEGR2A",
      "first_bit": 8,
      "SPN": 5775,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Actuator 1 Temperature",
      "SPN_Description": "Temperature of the Engine Exhaust Gas Recirculation 2 Actuator 1 drive circuitry.  Temperature excursions may affect the torque output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5776": {
      "PGN": 64714,
      "PGN_Name": "Engine Exhaust Gas Recirculation 2 Actuator",
      "PGN_Description": "EEGR2A",
      "first_bit": 16,
      "SPN": 5776,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Actuator 1 Desired Position",
      "SPN_Description": "The requested position of the Engine Exhaust Gas Recirculation 2 Actuator 1 by the engine ECU, where 0% represents fully closed and 100% represents fully open.\r\n\r\nThis is the position that the device is attempting to achieve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5777": {
      "PGN": 64714,
      "PGN_Name": "Engine Exhaust Gas Recirculation 2 Actuator",
      "PGN_Description": "EEGR2A",
      "first_bit": 24,
      "SPN": 5777,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Actuator 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Engine Exhaust Gas Recirculation 2 Actuator 2 by the manufacturer’s software. When there are multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5778": {
      "PGN": 64714,
      "PGN_Name": "Engine Exhaust Gas Recirculation 2 Actuator",
      "PGN_Description": "EEGR2A",
      "first_bit": 29,
      "SPN": 5778,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Actuator 2 Temperature Status",
      "SPN_Description": "Used to identify the status of the Engine Exhaust Gas Recirculation 2 Actuator 2 drive circuitry temperature.  Temperature excursions may affect the torque output.\r\n \r\n000 – High Most severe\r\n001 – High Least severe\r\n010 – In Range \r\n011 – Low Least severe\r\n100 – Low Most severe\r\n101 – Not Defined\r\n110 – Error\r\n111 – Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5779": {
      "PGN": 64714,
      "PGN_Name": "Engine Exhaust Gas Recirculation 2 Actuator",
      "PGN_Description": "EEGR2A",
      "first_bit": 32,
      "SPN": 5779,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Actuator 2 Temperature",
      "SPN_Description": "Temperature of the Engine Exhaust Gas Recirculation 2 Actuator 2 drive circuitry.  Temperature excursions may affect the torque output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5780": {
      "PGN": 64714,
      "PGN_Name": "Engine Exhaust Gas Recirculation 2 Actuator",
      "PGN_Description": "EEGR2A",
      "first_bit": 40,
      "SPN": 5780,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Actuator 2 Desired Position",
      "SPN_Description": "The requested position of the Engine Exhaust Gas Recirculation 2 Actuator 2 by the engine ECU, where 0% represents fully closed and 100% represents fully open.\r\n\r\nThis is the position that the device is attempting to achieve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5781": {
      "PGN": 64714,
      "PGN_Name": "Engine Exhaust Gas Recirculation 2 Actuator",
      "PGN_Description": "EEGR2A",
      "first_bit": 48,
      "SPN": 5781,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Actuator 1 Operation Status",
      "SPN_Description": "Used to identify the status of Exhaust Gas Recirculation 2 Actuator 1\r\n\r\n0000 – Normal\r\n0001 – Alarm (fully operational but needs service)\r\n0010 – Alarm High Severity (functional but transient performance may be reduced)\r\n0011 – Derate Active (torque output reduced due to environmental conditions)\r\n0100 – Controlled Shutdown Active (driving to the default position – usually this means closed)\r\n0101 – Uncontrolled Shutdown Active (no torque is being applied from the actuator)\r\n0110 – 1101 Reserved for future assignment\r\n1110 – Error\r\n1111 – Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5782": {
      "PGN": 64714,
      "PGN_Name": "Engine Exhaust Gas Recirculation 2 Actuator",
      "PGN_Description": "EEGR2A",
      "first_bit": 52,
      "SPN": 5782,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Actuator 2 Operation Status",
      "SPN_Description": "Used to identify the status of Exhaust Gas Recirculation 2 Actuator 2\r\n\r\n0000 – Normal\r\n0001 – Alarm (fully operational but needs service)\r\n0010 – Alarm High Severity (functional but transient performance may be reduced)\r\n0011 – Derate Active (torque output reduced due to environmental conditions)\r\n0100 – Controlled Shutdown Active (driving to the default position – usually this means closed)\r\n0101 – Uncontrolled Shutdown Active (no torque is being applied from the actuator)\r\n0110 – 1101 Reserved for future assignment\r\n1110 – Error\r\n1111 – Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5783": {
      "PGN": 64713,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 2",
      "PGN_Description": "EF/TVI2",
      "first_bit": 0,
      "SPN": 5783,
      "SPN_Name": "Engine Throttle Valve 1 Temperature",
      "SPN_Description": "Temperature of the engine throttle valve 1 drive circuitry (SPN 51).  Temperature excursions may affect the torque output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5784": {
      "PGN": 64713,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 2",
      "PGN_Description": "EF/TVI2",
      "first_bit": 8,
      "SPN": 5784,
      "SPN_Name": "Engine Throttle Valve 2 Temperature",
      "SPN_Description": "Temperature of the engine throttle valve 2 drive circuitry (SPN 3673).  Temperature excursions may affect the torque output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5785": {
      "PGN": 64713,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 2",
      "PGN_Description": "EF/TVI2",
      "first_bit": 16,
      "SPN": 5785,
      "SPN_Name": "Engine Fuel Valve 1 Temperature",
      "SPN_Description": "Temperature of the Engine Fuel Valve 1 drive circuitry. Temperature excursions may affect the torque output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5786": {
      "PGN": 64713,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 2",
      "PGN_Description": "EF/TVI2",
      "first_bit": 24,
      "SPN": 5786,
      "SPN_Name": "Engine Fuel Valve 2 Temperature",
      "SPN_Description": "Temperature of the Engine Fuel Valve 2 drive circuitry. Temperature excursions may affect the torque output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5787": {
      "PGN": 64713,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 2",
      "PGN_Description": "EF/TVI2",
      "first_bit": 32,
      "SPN": 5787,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 2 Temperature",
      "SPN_Description": "Temperature of the Engine Turbocharger Wastegate Actuator 2 drive circuitry.  Temperature excursions may affect the torque output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5788": {
      "PGN": 64753,
      "PGN_Name": "Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information",
      "PGN_Description": "ETWAI",
      "first_bit": 40,
      "SPN": 5788,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 1 Temperature",
      "SPN_Description": "Temperature of the Engine Turbocharger Wastegate Actuator 1 drive circuitry.  Temperature excursions may affect the torque output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5789": {
      "PGN": 64753,
      "PGN_Name": "Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information",
      "PGN_Description": "ETWAI",
      "first_bit": 48,
      "SPN": 5789,
      "SPN_Name": "Engine Exhaust Pressure Actuator 1 Desired Position",
      "SPN_Description": "The requested position of the Engine Exhaust Pressure Actuator 1 by the engine ECU, where 0% represents fully closed and 100% represents fully open.\r\n\r\nThis is the position that the device is attempting to achieve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5790": {
      "PGN": 64753,
      "PGN_Name": "Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information",
      "PGN_Description": "ETWAI",
      "first_bit": 56,
      "SPN": 5790,
      "SPN_Name": "Engine Exhaust Pressure Actuator 1 Temperature",
      "SPN_Description": "Temperature of the Engine Exhaust Pressure Actuator 1 drive circuitry.  Temperature excursions may affect the torque output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5791": {
      "PGN": 64755,
      "PGN_Name": "Engine Turbocharger Compressor Bypass Information",
      "PGN_Description": "ETCBI",
      "first_bit": 32,
      "SPN": 5791,
      "SPN_Name": "Engine Turbocharger Compressor Bypass Actuator 1 Temperature",
      "SPN_Description": "Temperature of the Engine Turbocharger Compressor Bypass Actuator 1 drive circuitry.    Temperature excursions may affect the torque output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5792": {
      "PGN": 64755,
      "PGN_Name": "Engine Turbocharger Compressor Bypass Information",
      "PGN_Description": "ETCBI",
      "first_bit": 40,
      "SPN": 5792,
      "SPN_Name": "Engine Turbocharger Compressor Bypass Actuator 2 Temperature",
      "SPN_Description": "Temperature of the Engine Turbocharger Compressor Bypass Actuator 2 drive circuitry.    Temperature excursions may affect the torque output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5793": {
      "PGN": 34560,
      "PGN_Name": "Engine State Requests",
      "PGN_Description": "ESR",
      "first_bit": 0,
      "SPN": 5793,
      "SPN_Name": "Desired Engine Fueling State",
      "SPN_Description": "Devices send this request to the engine controller to:\r\n\r\n(a) Shut off engine fueling, but remain prepared to re-start quickly by not shutting down the control system, or\r\n(b) Keep the engine running.\r\n\r\n00 Fueling not desired (shut off engine fueling)\r\n01 Fueling desired (keep engine running)\r\n10 Parameter supported, but no request\r\n11 Don't care / Take no action\r\n\r\nIf the engine controller receives this parameter from multiple sources, then '01-Fueling desired' shall have priority over '00-Fueling not desired'.\r\n\r\nIf this request can be honored by the receiving device as indicated by SPN 5795, then it shall be processed independently of other means to stop engine fueling (i.e., SPN 970 Engine Auxiliary Shutdown Switch or the Key switch). For example, if the engine is acting on SPN 5793 set to 01 (keep engine running) and the vehicle key switch is turned off, then the engine shall shut off.\r\n\r\nUse examples of this parameter include, but are not limited to:\r\n1. In applications or situations where the engine can be physically disconnected from the hybrid powertrain, a command of 00 could be used to request the engine to stop running, and as a result, stop rotating.\r\n2. In applications or situations where engine-driven accessories (power steering, etc.) must remain active while the engine is not running, a command of 00 could result in the engine no longer running even as it continues to be spun (motored) by the hybrid powertrain.\r\n3. In applications or situations where components want to keep the engine running, such as an aftertreatment system, a command of 01 could be used to prevent the engine from honoring requests from other devices using this parameter to shut off fueling.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5794": {
      "PGN": 64712,
      "PGN_Name": "Electronic Engine Controller 13",
      "PGN_Description": "EEC13",
      "first_bit": 0,
      "SPN": 5794,
      "SPN_Name": "Feedback Engine Fueling State",
      "SPN_Description": "This parameter provides feedback to the network that SPN 5793 Desired Engine Fueling State was honored. SPN 5795 Engine Fueling Inhibit Allowed indicates the engine’s current ability to honor requests via SPN 5793 Desired Engine Fueling State.\r\n\r\n00 = Fueling is or will be inhibited (SPN 5793 Desired Engine Fueling State = 00 from at least one network device and all other network devices have SPN 5793 Desired Engine Fueling State equal to something other than 01)\r\n01 = Engine will be kept running (SPN 5793 Desired Engine Fueling State = 01 from at least one network device)\r\n10 = No active request per SPN 5793 Desired Engine Fueling State or SPN 5795 Engine Fueling Inhibit Allowed = 00. When SPN 5795 = 00, then requests via SPN 5793 Desired Engine Fueling are ignored.\r\n11 = Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5795": {
      "PGN": 64712,
      "PGN_Name": "Electronic Engine Controller 13",
      "PGN_Description": "EEC13",
      "first_bit": 2,
      "SPN": 5795,
      "SPN_Name": "Engine Fueling Inhibit Allowed",
      "SPN_Description": "This parameter is broadcast by the engine control system, and indicates to other devices on the network whether or not it will respond to requests to inhibit engine fueling via SPN 5793 Desired Engine Fueling State. With this information, devices that may wish to inhibit engine fueling at some time in the future can know whether or not their request will be honored before they issue a request.\r\n \r\nThis parameter does not reflect the state of the engine controller due to requests received in SPN 5793 Desired Engine Fueling State.\r\n\r\nThis parameter is intended to be used in conjunction with SPN 5793 Desired Engine Fueling State and SPN 5794 Feedback Engine Fueling State.\r\n\r\n00 = Engine currently will not stop fueling in response to SPN 5793 Desired Engine Fueling State\r\n01 = Engine will stop fueling in response to SPN 5793 Desired Engine Fueling State\r\n10 = SAE Reserved\r\n11 = Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5821": {
      "PGN": 61489,
      "PGN_Name": "Wand Sensor",
      "PGN_Description": "WAND",
      "first_bit": 0,
      "SPN": 5821,
      "SPN_Name": "Wand Angle",
      "SPN_Description": "A wand sensor measures the angle of deflection of a wand from its null position. This parameter reports the measured angle of a wand sensor.",
      "bit_length": 16,
      "scaling": 0.002,
      "offset": -64,
      "unit": "deg",
      "SLOT_ID": 242
    },
    "5822": {
      "PGN": 61489,
      "PGN_Name": "Wand Sensor",
      "PGN_Description": "WAND",
      "first_bit": 16,
      "SPN": 5822,
      "SPN_Name": "Wand Sensor Figure of Merit",
      "SPN_Description": "Figure of Merit sensor status for a wand sensor.\r\n\r\n00    Sensor fully functional\r\n01    Sensor degraded\r\n10    Sensor failed\r\n11    Sensor not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5823": {
      "PGN": 61490,
      "PGN_Name": "Linear Displacement Sensor",
      "PGN_Description": "LDISP",
      "first_bit": 0,
      "SPN": 5823,
      "SPN_Name": "Measured Linear Displacement",
      "SPN_Description": "Distance to target as measured by the Linear Displacement Sensor.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "mm",
      "SLOT_ID": 14
    },
    "5824": {
      "PGN": 61490,
      "PGN_Name": "Linear Displacement Sensor",
      "PGN_Description": "LDISP",
      "first_bit": 16,
      "SPN": 5824,
      "SPN_Name": "Linear Displacement Sensor Sensor Figure of Merit",
      "SPN_Description": "Figure of Merit sensor status of Linear Displacement Sensor.\r\n\r\n00    Sensor fully functional\r\n01    Sensor degraded\r\n10    Sensor failed\r\n11    Sensor not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5825": {
      "PGN": 65279,
      "PGN_Name": "Operator indicators",
      "PGN_Description": "OI",
      "first_bit": 8,
      "SPN": 5825,
      "SPN_Name": "Driver Warning System Indicator Status",
      "SPN_Description": "The desired illumination of the Euro VI defined driver warning system indicator for relevant malfunctions and diesel exhaust fluid (reagent) tank low level.  Used for Euro VI implementations.  See Euro VI implementing regulation Annex XIII, Section 4 for usage requirements.\r\n\r\n000 - Off - Used when driver warning system is non-active - which, by requirement, means the low-level and severe inducement systems are also non-active\r\n001 - On – solid - Used when driver warning system is activated for any relevant malfunction\r\n010 - reserved for SAE assignment\r\n011 - reserved for SAE assignment\r\n100 - On – fast blink (1 Hz) - Used for the second driver warning system detection threshold for diesel exhaust fluid level, where the visual alarm of the driver warning system is required to \"escalate in intensity\"\r\n101 - reserved for SAE assignment\r\n110 - reserved for SAE assignment\r\n111 - not available\r\n\nNote: SPN 5825 is similar to SPN 5245.  SPN 5825 is intended to be used in implementations where the warning indicator is used to convey diesel exhaust fluid tank low level and specific emission control malfunction information, whereas SPN 5245 is intended to be used in implementations where the warning indicator is used to convey diesel exhaust fluid tank low level information only.  Thus, SPN 5825 is a superset of SPN 5245, and if both are utilized, will match only under certain conditions.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5826": {
      "PGN": 65279,
      "PGN_Name": "Operator indicators",
      "PGN_Description": "OI",
      "first_bit": 11,
      "SPN": 5826,
      "SPN_Name": "Emission Control System Operator Inducement Severity",
      "SPN_Description": "Severity status of the operator inducement system for anomalies with the emission control system, such as tampering, low diesel exhaust fluid (reagent) quality, diesel exhaust fluid (reagent) tank level, or EGR system errors.  Higher numerical levels indicate more severe levels of inducement.  Level 1 is the least severe.  Used for Euro VI and Tier 4 implementations.\r\n\r\n000 - Driver Warning, Low-Level Inducement, and Severe Inducement Non-Active\r\n001 - Inducement Level 1... Euro VI defined Driver Warning System Active ............................ FMI 15\r\n                                           … Off Highway (Tier4) - DEF Warning …………………………….. FMI 15\r\n010 - Inducement Level 2 ... Euro VI defined Low-Level Inducement Enabled ......................... FMI 15\r\n                                           … Off Highway (Tier4) - DEF Warning, second level .…………….. FMI 15\r\n011 - Inducement Level 3 ... Euro VI defined Low-Level Inducement Active ............................ FMI 16\r\n                                           … Off Highway (Tier4) - Low-Level Inducement Active ……..…….. FMI 16\r\n100 - Inducement Level 4 ... Euro VI defined Severe Inducement Enabled .............................. FMI 16\r\n                                           … Off Highway (Tier4) - Severe Inducement Active …….…..…….. FMI 16\r\n101 - Inducement Level 5 ... Euro VI defined Severe Inducement Active ................................. FMI 0\r\n                                           … Off Highway (Tier4) - Final Inducement Active …….…….…….. FMI 0\r\n110 - Temporary Override of Inducement\r\n111 - Not Available / Not Supported\r\n\r\nWhen this SPN is used in a DTC the recommended FMI usage is as shown.\r\n\r\nReference Euro VI implementing regulation Annex XIII, Appendix 5, section 3.1.(b), 3.1.(c), and 3.1.(d) for details.\r\n\r\nReference EU directive 97/68/EC amendment (2012/46/EU), EPA webinar nrci-scr-web-conf.2011-07-25, and JMLIT \"Technical Guidelines for Urea Selective Catalytic Reduction System\" Kokujikan 132-3, Feb.16, 2012 for Off Highway (Tier4) implementations.\r\n\r\nNote: SPN 5826 is similar to SPN 5246.  SPN 5826 is intended to be used to indicate the severity status of the operator inducement system for anomalies with the SCR and EGR systems, whereas SPN 5246 is intended to be used to indicate the severity status of the operator inducement system for anomalies with the SCR system only.  Thus, SPN 5826 is a superset of SPN 5246, and if both are utilized, will match only under certain conditions.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "5827": {
      "PGN": 64920,
      "PGN_Name": "Aftertreatment 1 Historical Information 1",
      "PGN_Description": "AT1HI1",
      "first_bit": 288,
      "SPN": 5827,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Average Distance Between Active Regenerations",
      "SPN_Description": "Indicates the average distance since last reset between active regenerations, that have not been forced to occur by manual request, for aftertreatment device 1.\r\n\r\nIf the manufacturer allows this parameter to be reset, this distance is the average since last reset.",
      "bit_length": 32,
      "scaling": 0.125,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 36
    },
    "5828": {
      "PGN": 64921,
      "PGN_Name": "Aftertreatment 2 Historical information 1",
      "PGN_Description": "AT2HI1",
      "first_bit": 288,
      "SPN": 5828,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Average Distance Between Active Regenerations",
      "SPN_Description": "Indicates the average distance since last reset between active regenerations, that have not been forced to occur by manual request, for aftertreatment device 2.\r\n\r\nIf the manufacturer allows this parameter to be reset, this distance is the average since last reset.",
      "bit_length": 32,
      "scaling": 0.125,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 36
    },
    "5829": {
      "PGN": 64962,
      "PGN_Name": "Electronic Engine Controller 14",
      "PGN_Description": "EEC14",
      "first_bit": 0,
      "SPN": 5829,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Valve 1 Position Error",
      "SPN_Description": "The position error of the Exhaust Gas Recirculation 1 valve, determined as the actual position (SPN 27) minus the commanded position (SPN 2791).",
      "bit_length": 16,
      "scaling": 0.004,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 264
    },
    "5830": {
      "PGN": 64962,
      "PGN_Name": "Electronic Engine Controller 14",
      "PGN_Description": "EEC14",
      "first_bit": 16,
      "SPN": 5830,
      "SPN_Name": "Engine Exhaust Gas Recirculation 1 Valve 2 Position Error",
      "SPN_Description": "The position error of the Exhaust Gas Recirculation 1 valve 2, determined as the actual position (SPN 3821) minus the commanded position (SPN 3822).",
      "bit_length": 16,
      "scaling": 0.004,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 264
    },
    "5831": {
      "PGN": 64762,
      "PGN_Name": "Electronic Engine Controller 11",
      "PGN_Description": "EEC11",
      "first_bit": 32,
      "SPN": 5831,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Valve 1 Position Error",
      "SPN_Description": "The position error of the Exhaust Gas Recirculation 2 valve, determined as the actual position (SPN 5264) minus the commanded position (SPN 5262).",
      "bit_length": 16,
      "scaling": 0.004,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 264
    },
    "5832": {
      "PGN": 64762,
      "PGN_Name": "Electronic Engine Controller 11",
      "PGN_Description": "EEC11",
      "first_bit": 48,
      "SPN": 5832,
      "SPN_Name": "Engine Exhaust Gas Recirculation 2 Valve 2 Position Error",
      "SPN_Description": "The position error of the Exhaust Gas Recirculation 2 valve 2, determined as the actual position (SPN 5265) minus the commanded position (SPN 5263).",
      "bit_length": 16,
      "scaling": 0.004,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 264
    },
    "5833": {
      "PGN": 64962,
      "PGN_Name": "Electronic Engine Controller 14",
      "PGN_Description": "EEC14",
      "first_bit": 32,
      "SPN": 5833,
      "SPN_Name": "Engine Fuel Mass Flow Rate",
      "SPN_Description": "Mass of liquid fuel consumed by engine per unit of time.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "g/s",
      "SLOT_ID": 336
    },
    "5834": {
      "PGN": 64736,
      "PGN_Name": "Diesel Particulate Filter Control 2",
      "PGN_Description": "DPFC2",
      "first_bit": 48,
      "SPN": 5834,
      "SPN_Name": "Aftertreatment 2 Fuel Mass Rate",
      "SPN_Description": "Mass rate of total fuel being delivered to Atertreatment 2 for DPF regeneration.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "g/min",
      "SLOT_ID": 317
    },
    "5835": {
      "PGN": 64720,
      "PGN_Name": "Engine Particulate Sensor Information",
      "PGN_Description": "EPSI",
      "first_bit": 0,
      "SPN": 5835,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor",
      "SPN_Description": "The particulate sensor measures the mass concentration of particulate matter in the exhaust downstream of the DPF in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.0125,
      "offset": 0,
      "unit": "mg/m³",
      "SLOT_ID": 337
    },
    "5836": {
      "PGN": 64720,
      "PGN_Name": "Engine Particulate Sensor Information",
      "PGN_Description": "EPSI",
      "first_bit": 16,
      "SPN": 5836,
      "SPN_Name": "Aftertreatment 2 Particulate Sensor",
      "SPN_Description": "The particulate sensor measures the mass concentration of particulate matter in the exhaust downstream of the DPF in exhaust bank 2.",
      "bit_length": 16,
      "scaling": 0.0125,
      "offset": 0,
      "unit": "mg/m³",
      "SLOT_ID": 337
    },
    "5837": {
      "PGN": 64962,
      "PGN_Name": "Electronic Engine Controller 14",
      "PGN_Description": "EEC14",
      "first_bit": 48,
      "SPN": 5837,
      "SPN_Name": "Fuel Type",
      "SPN_Description": "Type of fuel currently being utilized by the vehicle\r\n\r\nData Byte - Scaling - External Display\r\n\r\n0x00 - Not available - NONE\r\n0x01 - Gasoline/petrol - GAS\r\n0x02 - Methanol - METH\r\n0x03 - Ethanol - ETH\r\n0x04 - Diesel - DSL\r\n0x05 - Liquefied Petroleum Gas (LPG) - LPG\r\n0x06 - Compressed Natural Gas (CNG) - CNG\r\n0x07 - Propane - PROP\r\n0x08 - Battery/electric - ELEC\r\n0x09 - Bi-fuel vehicle using gasoline - BI_GAS\r\n0x0A - Bi-fuel vehicle using methanol - BI_METH\r\n0x0B - Bi-fuel vehicle using ethanol - BI_ETH\r\n0x0C - Bi-fuel vehicle using LPG - BI_LPG\r\n0x0D - Bi-fuel vehicle using CNG - BI_CNG\r\n0x0E - Bi-fuel vehicle using propane - BI_PROP\r\n0x0F - Bi-fuel vehicle using battery - BI_ELEC  [Not to be used]\r\n0x10 - Bi-fuel vehicle using battery and combustion engine - BI_MIX  [Not to be used]\r\n0x11 - Hybrid vehicle using gasoline engine - HYB_GAS  [Not to be used]\r\n0x12 - Hybrid vehicle using gasoline engine on ethanol - HYB_ETH  [Not to be used]\r\n0x13 - Hybrid vehicle using diesel engine - HYB_DSL  [Not to be used]\r\n0x14 - Hybrid vehicle using battery - HYB_ELEC  [Not to be used]\r\n0x15 - Hybrid vehicle using battery and combustion engine - HYB_MIX  [Not to be used]\r\n0x16 - Hybrid vehicle in regeneration mode - HYB_REG  [Not to be used]\r\n0x17 - Natural Gas (NG) - NG\r\n0x18 - Bi-fuel vehicle using NG – BI_NG\r\n0x19 - Bi-fuel using diesel\r\n0x1A - Natural Gas (Compressed or Liquefied Natural Gas)\r\n0x1B - Dual Fuel – Diesel and CNG\r\n0x1C - Dual Fuel – Diesel and LNG\r\n0x1D - 0xFD   ISO/SAE reserved\r\n0xFE - Error\r\n0xFF - Not available (Parameter not supported)\r\n\r\nEXAMPLE: If a Bi-fuel vehicle has less than 10% ethanol in the gasoline/petrol, then the external test equipment shall display state 0x09. In such a case, the system would be using gasoline/petrol (fuel) tables and OBD thresholds. SPN 5458 should either artificially display 0% or some number 10% or less if the system has such resolution. If the ethanol in the gasoline/petrol is above 10%, then the external test equipment shall display state 0x0B. SPN 5458 shall report the calculated ethanol/alcohol percentage.\r\n\r\nNote: \"Not available\" (Data 0x00) shall be used for the following conditions where no fuel is being utilized:\r\n\r\n   • Ignition Key On/Engine Off, for example, for bi-fuel vehicles when the vehicle cannot identify which fuel is being used before engine start\r\n   • Vehicle using Start/Stop strategy with engine stopped.   If FUEL_TYP is utilized on a single fuel vehicle, it can continue to indicate the previously utilized fuel type while the engine is in Decel Fuel Cut Off (DFCO) mode. It is not required to indicate 0x00 while in DFCO.\r\n\r\nFor hybrid or battery vehicles the states 0x0F through 0x16 shall not be used. Parameters within the HSS and HSC1 messages may be used to communicate hybrid related mode status.\r\n\r\nRegarding fuel type 0x17 - Natural Gas - this applies to any type of natural gaseous fuel when the source (CNG, LPG, or other) is not relevant.\r\n\r\nRegarding fuel type 0x18 - Bi-fuel vehicle using NG; this applies to bi-fuel vehicles running Diesel and Natural Gas, where the source of the natural gaseous fuel is not relevant.\r\n\r\nSee SPN 6317 for the requested fuel type.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "5847": {
      "PGN": 64964,
      "PGN_Name": "Electronic Brake Controller 5",
      "PGN_Description": "EBC5",
      "first_bit": 26,
      "SPN": 5847,
      "SPN_Name": "Emergency Braking Active",
      "SPN_Description": "Signal which indicates an emergency braking situation (ref. ECE Regulation 13 paragraph 5.2.1.31) with high  deceleration values.  This signal can be used to activate the hazard lights (ref ECE Regulation 48 paragraph 6.23) to\r\nindicate other road users to the rear and front of the vehicle that a high retardation force has been applied to the vehicle relative to the prevailing road conditions.\r\n\r\n00  inactive\r\n01  active\r\n10  reserved\r\n11  not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5848": {
      "PGN": 61491,
      "PGN_Name": "Aftertreatment 1 SCR Ammonia Information 2",
      "PGN_Description": "A1SCRAI2",
      "first_bit": 0,
      "SPN": 5848,
      "SPN_Name": "Aftertreatment 1 SCR Intermediate NH3",
      "SPN_Description": "The amount of NH3 in the exhaust aftertreatment system measured by a NH3 sensor at an intermediate point in the SCR system, represented in NH3 molecule parts per million non-NH3 molecules in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 348
    },
    "5849": {
      "PGN": 61491,
      "PGN_Name": "Aftertreatment 1 SCR Ammonia Information 2",
      "PGN_Description": "A1SCRAI2",
      "first_bit": 16,
      "SPN": 5849,
      "SPN_Name": "Aftertreatment 1 SCR Intermediate NH3 Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment SCR intermediate NH3 sensor by the manufacturer’s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5850": {
      "PGN": 61491,
      "PGN_Name": "Aftertreatment 1 SCR Ammonia Information 2",
      "PGN_Description": "A1SCRAI2",
      "first_bit": 24,
      "SPN": 5850,
      "SPN_Name": "Aftertreatment 1 SCR Intermediate NH3 Reading Stable",
      "SPN_Description": "Indicates that the NH3 reading of the aftertreatment SCR intermediate NH3 sensor is stable as determined by the manufacturer’s control software in exhaust bank 1.\r\n\r\n00 - Reading is not stable\r\n01 - Reading is stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5851": {
      "PGN": 61491,
      "PGN_Name": "Aftertreatment 1 SCR Ammonia Information 2",
      "PGN_Description": "A1SCRAI2",
      "first_bit": 26,
      "SPN": 5851,
      "SPN_Name": "Aftertreatment 1 SCR Intermediate NH3 Sensor Power In Range",
      "SPN_Description": "Indicates that the power supplied to the aftertreatment SCR intermediate NH3 sensor is within the manufacturer’s specification in exhaust bank 1.\r\n\r\n00 - Power is not in range\r\n01 - Power is in range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5852": {
      "PGN": 61491,
      "PGN_Name": "Aftertreatment 1 SCR Ammonia Information 2",
      "PGN_Description": "A1SCRAI2",
      "first_bit": 28,
      "SPN": 5852,
      "SPN_Name": "Aftertreatment 1 SCR Intermediate NH3 Sensor at Temperature",
      "SPN_Description": "Indicates that the heater element of the aftertreatment SCR intermediate NH3 sensor is within the manufacturer’s specified range for accurate measurements in exhaust bank 1.\r\n\r\n00 - Heater element is not in range\r\n01 - Heater element is in range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5853": {
      "PGN": 61491,
      "PGN_Name": "Aftertreatment 1 SCR Ammonia Information 2",
      "PGN_Description": "A1SCRAI2",
      "first_bit": 32,
      "SPN": 5853,
      "SPN_Name": "Aftertreatment 1 SCR Intermediate NH3 Sensor Heater Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the heater of the outlet NH3 exhaust sensor by the manufacturer’s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5854": {
      "PGN": 61491,
      "PGN_Name": "Aftertreatment 1 SCR Ammonia Information 2",
      "PGN_Description": "A1SCRAI2",
      "first_bit": 40,
      "SPN": 5854,
      "SPN_Name": "Aftertreatment 1 SCR Intermediate NH3 Sensor Heater Control",
      "SPN_Description": "Indicates the heater status in the warm-up process. Upon receiving a power-up command, the NH3 sensor ramps up according to a manufacturer defined profile. The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1. \r\n\r\n00 - Automatic \r\n01 - Preheat 2 \r\n10 - Preheat 1 \r\n11 - Heater off or not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5855": {
      "PGN": 61492,
      "PGN_Name": "Aftertreatment 2 SCR Ammonia Information 2",
      "PGN_Description": "A2SCRAI2",
      "first_bit": 0,
      "SPN": 5855,
      "SPN_Name": "Aftertreatment 2 SCR Intermediate NH3",
      "SPN_Description": "The amount of NH3 in the exhaust aftertreatment system measured by a NH3 sensor at an intermediate point in the SCR system, represented in NH3 molecule parts per million non-NH3 molecules in exhaust bank 2.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 348
    },
    "5856": {
      "PGN": 61492,
      "PGN_Name": "Aftertreatment 2 SCR Ammonia Information 2",
      "PGN_Description": "A2SCRAI2",
      "first_bit": 16,
      "SPN": 5856,
      "SPN_Name": "Aftertreatment 2 SCR Intermediate NH3 Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment SCR intermediate NH3 sensor by the manufacturer’s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5857": {
      "PGN": 61492,
      "PGN_Name": "Aftertreatment 2 SCR Ammonia Information 2",
      "PGN_Description": "A2SCRAI2",
      "first_bit": 24,
      "SPN": 5857,
      "SPN_Name": "Aftertreatment 2 SCR Intermediate NH3 Reading Stable",
      "SPN_Description": "Indicates that the NH3 reading of the aftertreatment SCR intermediate NH3 sensor is stable as determined by the manufacturer’s control software in exhaust bank 2.\r\n\r\n00 - Reading is not stable\r\n01 - Reading is stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5858": {
      "PGN": 61492,
      "PGN_Name": "Aftertreatment 2 SCR Ammonia Information 2",
      "PGN_Description": "A2SCRAI2",
      "first_bit": 26,
      "SPN": 5858,
      "SPN_Name": "Aftertreatment 2 SCR Intermediate NH3 Sensor Power In Range",
      "SPN_Description": "Indicates that the power supplied to the aftertreatment SCR intermediate NH3 sensor is within the manufacturer’s specification in exhaust bank 2.\r\n\r\n00 - Heater element is not in range\r\n01 - Heater element is in range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5859": {
      "PGN": 61492,
      "PGN_Name": "Aftertreatment 2 SCR Ammonia Information 2",
      "PGN_Description": "A2SCRAI2",
      "first_bit": 28,
      "SPN": 5859,
      "SPN_Name": "Aftertreatment 2 SCR Intermediate NH3 Sensor at Temperature",
      "SPN_Description": "Indicates that the heater element of the aftertreatment SCR intermediate NH3 sensor is within the manufacturer’s specified range for accurate measurements in exhaust bank 2.\r\n\r\n00 - Heater element is not in range\r\n01 - Heater element is in range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5860": {
      "PGN": 61492,
      "PGN_Name": "Aftertreatment 2 SCR Ammonia Information 2",
      "PGN_Description": "A2SCRAI2",
      "first_bit": 32,
      "SPN": 5860,
      "SPN_Name": "Aftertreatment 2 SCR Intermediate NH3 Sensor Heater Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the heater of the SCR intermediate NH3 exhaust sensor by the manufacturer’s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5861": {
      "PGN": 61492,
      "PGN_Name": "Aftertreatment 2 SCR Ammonia Information 2",
      "PGN_Description": "A2SCRAI2",
      "first_bit": 40,
      "SPN": 5861,
      "SPN_Name": "Aftertreatment 2 SCR Intermediate NH3 Sensor Heater Control",
      "SPN_Description": "Indicates the heater status in the warm-up process. Upon receiving a power-up command, the NH3 sensor ramps up according to a manufacturer defined profile. The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1.\r\n \r\n00 - Automatic \r\n01 - Preheat 2 \r\n10 - Preheat 1 \r\n11 - Heater off or Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5862": {
      "PGN": 64709,
      "PGN_Name": "Aftertreatment 1 SCR Exhaust Gas Temperature 2",
      "PGN_Description": "A1SCREGT2",
      "first_bit": 0,
      "SPN": 5862,
      "SPN_Name": "Aftertreatment 1 SCR Intermediate Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts at an intermediate point in the SCR component in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5863": {
      "PGN": 64709,
      "PGN_Name": "Aftertreatment 1 SCR Exhaust Gas Temperature 2",
      "PGN_Description": "A1SCREGT2",
      "first_bit": 16,
      "SPN": 5863,
      "SPN_Name": "Aftertreatment 1 SCR Intermediate Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment SCR intermediate temperature sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5864": {
      "PGN": 64708,
      "PGN_Name": "Aftertreatment 2 SCR Exhaust Gas Temperature 2",
      "PGN_Description": "A2SCREGT2",
      "first_bit": 0,
      "SPN": 5864,
      "SPN_Name": "Aftertreatment 2 SCR Intermediate Temperature",
      "SPN_Description": "Temperature of engine combustion byproducts at an intermediate point in the SCR component in exhaust bank 2.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5865": {
      "PGN": 64708,
      "PGN_Name": "Aftertreatment 2 SCR Exhaust Gas Temperature 2",
      "PGN_Description": "A2SCREGT2",
      "first_bit": 16,
      "SPN": 5865,
      "SPN_Name": "Aftertreatment 2 SCR Intermediate Temperature Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment SCR intermediate temperature sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "5866": {
      "PGN": 64712,
      "PGN_Name": "Electronic Engine Controller 13",
      "PGN_Description": "EEC13",
      "first_bit": 4,
      "SPN": 5866,
      "SPN_Name": "Engine Fueling Inhibit Prevented Reason",
      "SPN_Description": "If Engine Fueling Inhibit Allowed (SPN 5795) indicates that the engine will inhibit fueling, then this parameter and Engine Fueling Inhibit Prevented Reason Extension (SPN 8145) will indicate the reason.\r\n\r\nIf SPN 8145 is state 13 or lower, then SPN 5866, if supported, shall be set to the same value. If SPN 8145 is state 14 or higher, then SPN 5866, if supported, shall be set to 14.\r\n\r\nIf more than one reason exists at the same time, then it is up to the manufacturer to decide which one to select.\r\n\r\n0 – Fueling inhibit allowed (SPN 5795 = 01)\r\n1 – Aftertreatment regeneration is active or preparing to be active\r\n2 – Oil Distribution in engine is incomplete\r\n3 – Engine is cold\r\n4 – Service Override\r\n5 – Aftertreatment system is cold\r\n6 – Aftertreatment Protection\r\n7 – Engine load too high\r\n8 – Engine protection. Use other engine protection enumerations in this parameter when applicable. If the method of engine protection is not defined in other states, then use this state.\r\n9 – Insufficient SLI battery charge\r\n10 – Maximum number of engine fueling inhibit requests (SPN 5793 = 0) temporary limit exceeded.  The temporary limit may be bounded by elapsed time, distance travelled, driving conditions, or something else that the manufacturer has specified.\r\n11 – Engine driven fan request\r\n12 – Low idle governor operation required\r\n13 – Vehicle speed is greater than zero\r\n14 – See Engine Fueling Inhibit Prevented Reason Extension (SPN 8145)\r\n15 – Not Supported",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5867": {
      "PGN": 64707,
      "PGN_Name": "Fuel Information 4 (Gaseous)",
      "PGN_Description": "GFI4",
      "first_bit": 0,
      "SPN": 5867,
      "SPN_Name": "Supply Gas Methane Percentage",
      "SPN_Description": "The percentage of methane in the gas supplied to the engine.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5872": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 0,
      "SPN": 5872,
      "SPN_Name": "Hybrid System Warning Indicator",
      "SPN_Description": "Signal from a hybrid system indicating that some aspect of its operation is not functioning correctly, and as a result, hybrid system operation may be altered or restricted. The indicator is typically a lamp. Distinctions in meaning between the continuous and flashing states are left to the hybrid system manufacturer.\r\n\r\n00 - Hybrid System Warning Indicator is off\r\n01 - Hybrid System Warning Indicator is on continuously\r\n10 - Hybrid System Warning Indicator is flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5873": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 2,
      "SPN": 5873,
      "SPN_Name": "Hybrid System Overheat Indicator",
      "SPN_Description": "Signal from a hybrid system indicating that at least one of its monitored temperatures is above normal acceptable limits, and as a result, hybrid system operation may be altered or restricted. The indicator is typically a lamp. Distinctions in meaning between the continuous and flashing states are left to the hybrid system manufacturer.\r\n\r\n00 - Hybrid System Temperature Indicator is off\r\n01 - Hybrid System Temperature Indicator is on continuously\r\n10 - Hybrid System Temperature Indicator is flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5874": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 4,
      "SPN": 5874,
      "SPN_Name": "Hybrid System Stop Indicator",
      "SPN_Description": "Signal from a hybrid system indicating that some aspect of its operation is not functioning correctly, and as a result, the vehicle must be stopped. The indicator is typically a lamp. Distinctions in meaning between the continuous and flashing states are left to the hybrid system manufacturer.\r\n\r\n00 - Hybrid System Stop Indicator is off\r\n01 - Hybrid System Stop Indicator is on continuously\r\n10 - Hybrid System Stop Indicator is flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5913": {
      "PGN": 64917,
      "PGN_Name": "Transmission Fluids 2",
      "PGN_Description": "TRF2",
      "first_bit": 32,
      "SPN": 5913,
      "SPN_Name": "Transmission Oil Temperature 2",
      "SPN_Description": "Second instance of transmission lubricant temperature. This parameter may reflect the temperature of a second sump or oil supply. If only one instance of transmission lubricant temperature measurement exists, SPN 177 Transmission Oil Temperature 1 should be used.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5914": {
      "PGN": 64917,
      "PGN_Name": "Transmission Fluids 2",
      "PGN_Description": "TRF2",
      "first_bit": 48,
      "SPN": 5914,
      "SPN_Name": "Transmission Oil Level 2 High / Low",
      "SPN_Description": "Second instance of a transmission oil level indicator. Conveys the current volume of transmission sump oil compared to recommended volume. Positive values indicate overfill. Zero means the transmission fluid is filled to the recommended level. If only a one instance of transmission oil level measurement exists, SPN 3027 Transmission Oil Level 1 High / Low should be used.\r\n\r\nParameter Specific Indicator:\r\nA value of 0xFB indicates conditions are not acceptable for a valid fluid level measurement.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": -62.5,
      "unit": "l",
      "SLOT_ID": 225
    },
    "5915": {
      "PGN": 64917,
      "PGN_Name": "Transmission Fluids 2",
      "PGN_Description": "TRF2",
      "first_bit": 56,
      "SPN": 5915,
      "SPN_Name": "Transmission Oil Level 2 Countdown Timer",
      "SPN_Description": "Countdown timer for the second instance of a transmission oil level indicator. Once all vehicle conditions (such as vehicle stopped, etc) are met, some transmissions may require a ‘settling time’ to allow the fluid level to normalize. This parameter indicates how much of the required settling time remains. When time reaches 0, a valid oil level measurement value will be broadcast in SPN 5914 Transmission Oil Level 2 High / Low. If only a single oil level is measured, SPN 3028 Transmission Oil Level 1 Countdown Timer should be used.\r\n\r\n0000 less than 1 minute\r\n0001 One minute\r\n0010 Two minutes\r\n0011 Three minutes\r\n0100 Four minutes\r\n0101 Five minutes\r\n0110 Six minutes\r\n0111 Seven minutes\r\n1000 Eight minutes\r\n1001 Nine minutes\r\n1010 Ten minutes\r\n1011 Eleven minutes\r\n1100 Twelve minutes\r\n1101 Thirteen minutes\r\n1110 Error\r\n1111 Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5916": {
      "PGN": 64917,
      "PGN_Name": "Transmission Fluids 2",
      "PGN_Description": "TRF2",
      "first_bit": 60,
      "SPN": 5916,
      "SPN_Name": "Transmission Oil Level 2 Measurement Status",
      "SPN_Description": "Measurement status for the second instance of a transmission oil level indicator. Indicates if conditions are acceptable to obtain a valid transmission oil level measurement as conveyed in SPN 5914 Transmission Oil Level 2 High / Low. If conditions are not acceptable, this parameter conveys to the operator what prevents conditions from being acceptable. Only one condition can be conveyed in this parameter at any given point in time. If multiple conditions exist, it is not important which condition is actually broadcast, as the driver must ‘correct’ each and every condition as it is presented before a valid oil level reading can be made. If multiple conditions exist that prevent a valid reading, the sender should broadcast one of those conditions until it is corrected; then the next condition can be conveyed to the operator, and so on. If only a single oil level is measured, use SPN 3026 Transmission Oil Level 1 Measurement Status.\r\n\r\n0000 Conditions valid for transmission oil level measurement\r\n0001 Conditions not valid – Settling timer still counting down\r\n0010 Conditions not valid – Transmission in gear\r\n0011 Conditions not valid – Transmission fluid temperature too low\r\n0100 Conditions not valid – Transmission fluid temperature too high\r\n0101 Conditions not valid – Vehicle moving; output shaft speed too high\r\n0110 Conditions not valid – Vehicle not level\r\n0111 Conditions not valid – Engine speed too low\r\n1000 Conditions not valid – Engine speed too high\r\n1001 Conditions not valid – No request for reading\r\n1010 Not defined\r\n1011 Not defined\r\n1100 Not defined\r\n1101 Conditions not valid - Other\r\n1110 Error\r\n1111 Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5917": {
      "PGN": 61584,
      "PGN_Name": "High Voltage Energy Storage 1 Data 1",
      "PGN_Description": "HVES1D1",
      "first_bit": 0,
      "SPN": 5917,
      "SPN_Name": "HVES1 Available Discharge Power",
      "SPN_Description": "The rate at which the High Voltage Energy Storage 1 pack (or system) can currently provide energy for propulsion or other uses.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "kW",
      "SLOT_ID": 346
    },
    "5918": {
      "PGN": 61584,
      "PGN_Name": "High Voltage Energy Storage 1 Data 1",
      "PGN_Description": "HVES1D1",
      "first_bit": 16,
      "SPN": 5918,
      "SPN_Name": "HVES1 Available Charge Power",
      "SPN_Description": "The rate at which the High Voltage Energy Storage 1 pack (or system) can currently receive energy from a regenerative or recharging system.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "kW",
      "SLOT_ID": 346
    },
    "5919": {
      "PGN": 61584,
      "PGN_Name": "High Voltage Energy Storage 1 Data 1",
      "PGN_Description": "HVES1D1",
      "first_bit": 32,
      "SPN": 5919,
      "SPN_Name": "HVES1 Voltage Level",
      "SPN_Description": "The voltage level of the High Voltage Energy Storage 1 pack (or system).  This parameter should be synchronized with SPN 5920 (HVES1 Current) such that a realized power value can be calculated.  If the HVES component physically contains the contactors which connect it to the vehicle high voltage system, then this voltage is measured before those contactors.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "5920": {
      "PGN": 61584,
      "PGN_Name": "High Voltage Energy Storage 1 Data 1",
      "PGN_Description": "HVES1D1",
      "first_bit": 48,
      "SPN": 5920,
      "SPN_Name": "HVES1 Current",
      "SPN_Description": "The current in or out of the High Voltage Energy Storage 1 pack (or system).  This parameter should be synchronized with SPN 5919 (HVES1 Voltage Level) such that a realized power value can be calculated.  This parameter is defined from the high voltage energy storage system’s point of view.  A positive value represents current into (charging) the energy storage system.  A negative value represents current out of (discharging) the energy storage system.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -1600,
      "unit": "A",
      "SLOT_ID": 104
    },
    "5921": {
      "PGN": 61585,
      "PGN_Name": "High Voltage Energy Storage 1 Data 2",
      "PGN_Description": "HVES1D2",
      "first_bit": 0,
      "SPN": 5921,
      "SPN_Name": "HVES1 Fast Update State of Charge",
      "SPN_Description": "Indicates the High Voltage Energy Storage 1 pack (or system) state of charge.  0% means no charge remaining, 100% means the system is fully charged in terms of physical limits of the energy storage system.  Acceptable state of charge upper and lower boundaries for normal operation are defined in SPN 8118 (HVES1 Recommended Minimum State Of Charge) and SPN 8119 (HVES1 Recommended Maximum State Of Charge).  The update rate and resolution of this parameter are intended for control purposes within a hybrid control system; for a simple periodic value, SPN 5464 (Hybrid Battery Pack Remaining Charge) may be of use.",
      "bit_length": 16,
      "scaling": 0.0015625,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 345
    },
    "5922": {
      "PGN": 61585,
      "PGN_Name": "High Voltage Energy Storage 1 Data 2",
      "PGN_Description": "HVES1D2",
      "first_bit": 16,
      "SPN": 5922,
      "SPN_Name": "HVES1 Highest Cell Voltage",
      "SPN_Description": "The highest voltage level reported by any cell in the High Voltage Energy Storage 1 pack (or system).  If a single voltage sensor covers more than one cell, the value in this parameter is for the smallest group of cells measured. See HVES1 Highest Cell Voltage Module Number (SPN 8236) and HVES1 Highest Cell Voltage Cell Number (SPN 8237) for cell location information.",
      "bit_length": 16,
      "scaling": 0.001,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 347
    },
    "5923": {
      "PGN": 61585,
      "PGN_Name": "High Voltage Energy Storage 1 Data 2",
      "PGN_Description": "HVES1D2",
      "first_bit": 32,
      "SPN": 5923,
      "SPN_Name": "HVES1 Lowest Cell Voltage",
      "SPN_Description": "The lowest voltage level reported by any cell in the High Voltage Energy Storage 1 pack (or system).   If a single voltage sensor covers more than one cell, the value in this parameter is for the smallest group of cells measured.  See HVES1 Lowest Cell Voltage Module Number (SPN 8238) and HVES1 Lowest Cell Voltage Cell Number (SPN 8239) for cell location information.",
      "bit_length": 16,
      "scaling": 0.001,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 347
    },
    "5924": {
      "PGN": 61585,
      "PGN_Name": "High Voltage Energy Storage 1 Data 2",
      "PGN_Description": "HVES1D2",
      "first_bit": 48,
      "SPN": 5924,
      "SPN_Name": "HVES1 Cell Voltage Differential Status",
      "SPN_Description": "Indicates whether or not the differential between the highest and lowest cell voltages are within acceptable limits, according to the High Voltage Energy Storage 1 pack (or system).   The actual voltage differential can be calculated by subtracting SPN 5923 (HVES1 Lowest Cell Voltage) from SPN 5922 (HVES1 Highest Cell Voltage).\r\n\r\n0000 = Cell-to-cell voltage differential is within acceptable limits\r\n0001 = Cell-to-cell voltage differential exceeds acceptable limits but can be corrected via auto-balancing\r\n0010 = Cell-to-cell voltage differential exceeds acceptable limits to a point where external maintenance balancing is required to restore battery performance\r\n0011 = Cell-to-cell voltage differential exceeds acceptable limits to a point where external maintenance balancing cannot restore battery performance\r\n0100 = Cell-to-cell voltage differential exceeds acceptable limits; it is not known whether balancing can restore battery performance\r\n0101 - 1101 = Reserved\r\n1110 = Error\r\n1111 = Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5925": {
      "PGN": 64776,
      "PGN_Name": "Engine oil message",
      "PGN_Description": "EOM",
      "first_bit": 48,
      "SPN": 5925,
      "SPN_Name": "Engine Oil Temperature 3",
      "SPN_Description": "Temperature of the engine lubricant.\r\n\r\nNote:  If there is only one engine oil temperature measurement, SPN 175 should be used. \r\n\r\nSee also SPNs 175 and 1135 for additional engine oil temperature measurements.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5933": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 28,
      "SPN": 5933,
      "SPN_Name": "Rear Steer Axle Group Weight Available",
      "SPN_Description": "Indicates if a second (or rear) steer axle group weight is available.\r\n\r\n00 = Rear Steer axle group not present\r\n01 = Rear Steer axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable\r\n\r\nNote:  If there is only one steer axle, use SPN 4059.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5934": {
      "PGN": 64875,
      "PGN_Name": "Available Axle Group Weights",
      "PGN_Description": "AAGW",
      "first_bit": 30,
      "SPN": 5934,
      "SPN_Name": "Rear Drive Axle Group Weight Available",
      "SPN_Description": "Indicates if a second (or rear) drive axle group weight is available.\r\n\r\n00 = Rear drive axle group not present\r\n01 = Rear drive axle group present\r\n10 = Reserved\r\n11 = Not available / not applicable\r\n\r\nNote:  If there is only one drive axle, use SPN 4061.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5935": {
      "PGN": 64874,
      "PGN_Name": "Axle Group Weight",
      "PGN_Description": "AGW",
      "first_bit": 4,
      "SPN": 5935,
      "SPN_Name": "Additional Axle Group Location",
      "SPN_Description": "Location of the axle group, listed from front of the vehicle to rear.  If the value of SPN 4073 is 15, then this SPN is used to indicate the axle group referred to by this PGN. Otherwise, this SPN should be broadcast as 15.\r\n\r\n0 = Reserved\r\n1 = Rear Steer axle group\r\n2 = Rear Drive axle group\r\n3-15 = Reserved",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5936": {
      "PGN": 64873,
      "PGN_Name": "Axle Group Calibration Weights",
      "PGN_Description": "AGCW",
      "first_bit": 4,
      "SPN": 5936,
      "SPN_Name": "Additional Axle Group Location",
      "SPN_Description": "Location of the axle group, listed from front of the vehicle to rear.  If the value of SPN 4074 is 15, then this SPN is used to indicate the axle group referred to by this PGN. Otherwise, this SPN should be broadcast as 15.\r\n\r\n0 = Reserved\r\n1 = Rear Steer axle group\r\n2 = Rear Drive axle group\r\n3-15 = Reserved",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "5937": {
      "PGN": 64705,
      "PGN_Name": "Transmission Fluids 3",
      "PGN_Description": "TRF3",
      "first_bit": 0,
      "SPN": 5937,
      "SPN_Name": "Transmission Clutch 2 Pressure",
      "SPN_Description": "Gage pressure of hydraulic actuation fluid of transmission second clutch in a dual clutch application.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 49
    },
    "5938": {
      "PGN": 64705,
      "PGN_Name": "Transmission Fluids 3",
      "PGN_Description": "TRF3",
      "first_bit": 8,
      "SPN": 5938,
      "SPN_Name": "Transmission Oil Transmission Cooler Outlet Temperature",
      "SPN_Description": "Temperature of transmission lubricant after it exits from the transmission cooler.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "5941": {
      "PGN": 64704,
      "PGN_Name": "Electronic Transmission Controller #11",
      "PGN_Description": "ETC11",
      "first_bit": 24,
      "SPN": 5941,
      "SPN_Name": "Transmission Shift Rail 4 Position",
      "SPN_Description": "The current position of transmission shift rail identified as rail #4.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5942": {
      "PGN": 64704,
      "PGN_Name": "Electronic Transmission Controller #11",
      "PGN_Description": "ETC11",
      "first_bit": 32,
      "SPN": 5942,
      "SPN_Name": "Transmission Shift Rail 5 Position",
      "SPN_Description": "The current position of transmission shift rail identified as rail #5.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5943": {
      "PGN": 64704,
      "PGN_Name": "Electronic Transmission Controller #11",
      "PGN_Description": "ETC11",
      "first_bit": 40,
      "SPN": 5943,
      "SPN_Name": "Transmission Shift Rail 6 Position",
      "SPN_Description": "The current position of transmission shift rail identified as rail #6.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5944": {
      "PGN": 64703,
      "PGN_Name": "Electronic Transmission Controller #10",
      "PGN_Description": "ETC10",
      "first_bit": 0,
      "SPN": 5944,
      "SPN_Name": "Transmission Clutch 1 Actuator Percent",
      "SPN_Description": "The current modulated value for the transmission clutch 1 actuator, where 0% = no hydraulic pressure and 100% = full hydraulic pressure.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5945": {
      "PGN": 64703,
      "PGN_Name": "Electronic Transmission Controller #10",
      "PGN_Description": "ETC10",
      "first_bit": 8,
      "SPN": 5945,
      "SPN_Name": "Transmission Clutch 2 Actuator Percent",
      "SPN_Description": "The current modulated value for the transmission clutch 2 actuator, where 0% = no hydraulic pressure and 100% = full hydraulic pressure.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5946": {
      "PGN": 64703,
      "PGN_Name": "Electronic Transmission Controller #10",
      "PGN_Description": "ETC10",
      "first_bit": 16,
      "SPN": 5946,
      "SPN_Name": "Transmission Hydraulic Pump Actuator 1 Percent",
      "SPN_Description": "The current modulated value for the actuator that controls the transmission hydraulic pump, where 0% = no hydraulic pressure and 100% = full hydraulic pressure.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5947": {
      "PGN": 64703,
      "PGN_Name": "Electronic Transmission Controller #10",
      "PGN_Description": "ETC10",
      "first_bit": 24,
      "SPN": 5947,
      "SPN_Name": "Transmission Shift Actuator 1 Percent",
      "SPN_Description": "The current modulated value for the transmission shift 1 actuator, where 0% = no hydraulic pressure and 100% = full hydraulic pressure.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5948": {
      "PGN": 64703,
      "PGN_Name": "Electronic Transmission Controller #10",
      "PGN_Description": "ETC10",
      "first_bit": 32,
      "SPN": 5948,
      "SPN_Name": "Transmission Shift Actuator 2 Percent",
      "SPN_Description": "The current modulated value for the transmission shift 2 actuator, where 0% = no hydraulic pressure and 100% = full hydraulic pressure.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "5949": {
      "PGN": 64703,
      "PGN_Name": "Electronic Transmission Controller #10",
      "PGN_Description": "ETC10",
      "first_bit": 40,
      "SPN": 5949,
      "SPN_Name": "Transmission Clutch 1 Cooling Actuator Status",
      "SPN_Description": "Identifies the status of the actuator that cools transmission clutch 1.\r\n\r\n00 = off\r\n01 = on\r\n10 = error\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5950": {
      "PGN": 64703,
      "PGN_Name": "Electronic Transmission Controller #10",
      "PGN_Description": "ETC10",
      "first_bit": 42,
      "SPN": 5950,
      "SPN_Name": "Transmission Clutch 2 Cooling Actuator Status",
      "SPN_Description": "Identifies the status of the actuator that cools transmission clutch 2.\r\n\r\n00 = off\r\n01 = on\r\n10 = error\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5951": {
      "PGN": 64703,
      "PGN_Name": "Electronic Transmission Controller #10",
      "PGN_Description": "ETC10",
      "first_bit": 44,
      "SPN": 5951,
      "SPN_Name": "Transmission Shift Rail 1 Actuator Status",
      "SPN_Description": "Identifies the status of the actuator that moves the transmission shift rail identified as rail #1.\r\n\r\n00 = off\r\n01 = on\r\n10 = error\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5952": {
      "PGN": 64703,
      "PGN_Name": "Electronic Transmission Controller #10",
      "PGN_Description": "ETC10",
      "first_bit": 46,
      "SPN": 5952,
      "SPN_Name": "Transmission Shift Rail 2 Actuator Status",
      "SPN_Description": "Identifies the status of the actuator that moves the transmission shift rail identified as rail #2.\r\n\r\n00 = off\r\n01 = on\r\n10 = error\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5953": {
      "PGN": 64703,
      "PGN_Name": "Electronic Transmission Controller #10",
      "PGN_Description": "ETC10",
      "first_bit": 48,
      "SPN": 5953,
      "SPN_Name": "Transmission Shift Rail 3 Actuator Status",
      "SPN_Description": "Identifies the status of the actuator that moves the transmission shift rail identified as rail #3.\r\n\r\n00 = off\r\n01 = on\r\n10 = error\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5954": {
      "PGN": 64703,
      "PGN_Name": "Electronic Transmission Controller #10",
      "PGN_Description": "ETC10",
      "first_bit": 50,
      "SPN": 5954,
      "SPN_Name": "Transmission Shift Rail 4 Actuator Status",
      "SPN_Description": "Identifies the status of the actuator that moves the transmission shift rail identified as rail #4.\r\n\r\n00 = off\r\n01 = on\r\n10 = error\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5955": {
      "PGN": 64703,
      "PGN_Name": "Electronic Transmission Controller #10",
      "PGN_Description": "ETC10",
      "first_bit": 52,
      "SPN": 5955,
      "SPN_Name": "Transmission Shift Rail 5 Actuator Status",
      "SPN_Description": "Identifies the status of the actuator that moves the transmission shift rail identified as rail #5.\r\n\r\n00 = off\r\n01 = on\r\n10 = error\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5956": {
      "PGN": 64703,
      "PGN_Name": "Electronic Transmission Controller #10",
      "PGN_Description": "ETC10",
      "first_bit": 54,
      "SPN": 5956,
      "SPN_Name": "Transmission Shift Rail 6 Actuator Status",
      "SPN_Description": "Identifies the status of the actuator that moves the transmission shift rail identified as rail #6.\r\n\r\n00 = off\r\n01 = on\r\n10 = error\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5957": {
      "PGN": 64702,
      "PGN_Name": "Electronic Transmission Controller #9",
      "PGN_Description": "ETC9",
      "first_bit": 32,
      "SPN": 5957,
      "SPN_Name": "Dual Clutch Transmission Selected Pre-selection Gear",
      "SPN_Description": "The gear that the transmission will attempt to achieve during the current pre-selection event (shifting to a new gear on the non-engaged clutch of a dual clutch transmission (DCT)).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "gear value",
      "SLOT_ID": 24
    },
    "5958": {
      "PGN": 64702,
      "PGN_Name": "Electronic Transmission Controller #9",
      "PGN_Description": "ETC9",
      "first_bit": 40,
      "SPN": 5958,
      "SPN_Name": "Dual Clutch Transmission Current Pre-selection Gear",
      "SPN_Description": "The gear currently engaged on the non-engaged clutch of a dual clutch transmission (DCT) or the last gear engaged on the non-engaged clutch while the transmission is in the process of pre-selecting to the new or selected pre-selection gear on the non-engaged clutch. Transitions toward a destination gear will not be indicated. Once the selected pre-selected gear has been engaged then DCT Current Pre-Selection Gear (SPN 5958) will reflect that gear.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "gear value",
      "SLOT_ID": 24
    },
    "5960": {
      "PGN": 64702,
      "PGN_Name": "Electronic Transmission Controller #9",
      "PGN_Description": "ETC9",
      "first_bit": 0,
      "SPN": 5960,
      "SPN_Name": "Dual Clutch Transmission Input Shaft 1 Speed",
      "SPN_Description": "Rotational velocity of the primary shaft transferring power through clutch 1 into the dual clutch transmission (DCT).",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "5961": {
      "PGN": 64702,
      "PGN_Name": "Electronic Transmission Controller #9",
      "PGN_Description": "ETC9",
      "first_bit": 16,
      "SPN": 5961,
      "SPN_Name": "Dual Clutch Transmission Input Shaft 2 Speed",
      "SPN_Description": "Rotational velocity of the primary shaft transferring power through clutch 2 into the dual clutch transmission (DCT).",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "5963": {
      "PGN": 64701,
      "PGN_Name": "Aftertreatment 1 SCR Service Information 2",
      "PGN_Description": "A1SCRSI2",
      "first_bit": 0,
      "SPN": 5963,
      "SPN_Name": "Aftertreatment 1 Total Diesel Exhaust Fluid Used",
      "SPN_Description": "Total amount of DEF used by aftertreatment device 1 over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 75
    },
    "5964": {
      "PGN": 64700,
      "PGN_Name": "Aftertreatment 2 SCR Service Information 2",
      "PGN_Description": "A2SCRSI2",
      "first_bit": 0,
      "SPN": 5964,
      "SPN_Name": "Aftertreatment 2 Total Diesel Exhaust Fluid Used",
      "SPN_Description": "Total amount of DEF used by aftertreatment device 2 over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 75
    },
    "5965": {
      "PGN": 64699,
      "PGN_Name": "Aftertreatment 1 SCR Electronic Control Module Information",
      "PGN_Description": "A1ECMI",
      "first_bit": 0,
      "SPN": 5965,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Control Module 1 Relay Control",
      "SPN_Description": "State signal which indicates when the DEF control module relay of aftertreatment 1 is being energized. On means the ECU is powering the Aftertreatment 1 DEF dosing unit relay. Note that the ECU is external to the relay. \r\n\r\n00 – Off\r\n01 – On: The ECU is powering the DEF dosing unit relay\r\n10 – Error\r\n11 – Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5966": {
      "PGN": 64699,
      "PGN_Name": "Aftertreatment 1 SCR Electronic Control Module Information",
      "PGN_Description": "A1ECMI",
      "first_bit": 2,
      "SPN": 5966,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Control Module 1 Power Supply 1",
      "SPN_Description": "State signal which indicates when the DEF control module power supply of aftertreatment 1 is being driven. On means the ECU is powering the aftertreatment 1 DEF control module power supply. Note that the control module is external to the ECU.\r\n\r\n00 – Off\r\n01 – On: The ECU is powering the DEF dosing unit power supply\r\n10 – Error\r\n11 – Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5967": {
      "PGN": 64698,
      "PGN_Name": "Aftertreatment 2 SCR Electronic Control Module Information",
      "PGN_Description": "A2ECMI",
      "first_bit": 0,
      "SPN": 5967,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Control Module 1 Relay Control",
      "SPN_Description": "State signal which indicates when the DEF control module 1 relay of aftertreatment 2 is being energized. On means the ECU is powering the Aftertreatment 2 DEF dosing unit relay. Note that the ECU is external to the relay. \r\n\r\n00 – Off\r\n01 – On: The ECU is powering the DEF dosing unit relay\r\n10 – Error\r\n11 – Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5968": {
      "PGN": 64698,
      "PGN_Name": "Aftertreatment 2 SCR Electronic Control Module Information",
      "PGN_Description": "A2ECMI",
      "first_bit": 2,
      "SPN": 5968,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Control Module 1 Power Supply 1",
      "SPN_Description": "State signal which indicates when the DEF control module 1 power supply of aftertreatment 2 is being driven. On means the ECU is powering the aftertreatment 2 DEF control module 1 power supply. Note that the control module is external to the ECU.\r\n\r\n00 – Off\r\n01 – On: The ECU is powering the DEF dosing unit power supply\r\n10 – Error\r\n11 – Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5969": {
      "PGN": 65031,
      "PGN_Name": "Exhaust Temperature",
      "PGN_Description": "ET",
      "first_bit": 32,
      "SPN": 5969,
      "SPN_Name": "Engine Exhaust Manifold Bank 2 Temperature 2",
      "SPN_Description": "Temperature of combustion byproducts measured by a second sensor in engine bank 2 (right bank) exhaust manifold. This should be used for the sensor toward the rear of the engine on the bank 2 manifold.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5970": {
      "PGN": 65031,
      "PGN_Name": "Exhaust Temperature",
      "PGN_Description": "ET",
      "first_bit": 48,
      "SPN": 5970,
      "SPN_Name": "Engine Exhaust Manifold Bank 1 Temperature 2",
      "SPN_Description": "Temperature of combustion byproducts measured by a second sensor in engine bank 1 (left bank) exhaust manifold. This should be used for the sensor toward the rear of the engine on the bank 1 manifold.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "5973": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 32,
      "SPN": 5973,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater Relay 1",
      "SPN_Description": "The aftertreatment system 2 diesel exhaust fluid line heater relay 1 is used to energize one or more DEF line heaters.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5978": {
      "PGN": 64697,
      "PGN_Name": "Aftertreatment 1 Service 2",
      "PGN_Description": "AT1S2",
      "first_bit": 0,
      "SPN": 5978,
      "SPN_Name": "Aftertreatment 1 Diesel Particulate Filter Time to Next Active Regeneration",
      "SPN_Description": "Indicates the time to the next active regeneration event of diesel particulate filter 1.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "5979": {
      "PGN": 64696,
      "PGN_Name": "Aftertreatment 2 Service 2",
      "PGN_Description": "AT2S2",
      "first_bit": 0,
      "SPN": 5979,
      "SPN_Name": "Aftertreatment 2 Diesel Particulate Filter Time to Next Active Regeneration",
      "SPN_Description": "Indicates the time to the next active regeneration event of diesel particulate filter 2.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "5980": {
      "PGN": 65245,
      "PGN_Name": "Turbocharger",
      "PGN_Description": "TC",
      "first_bit": 32,
      "SPN": 5980,
      "SPN_Name": "Engine Turbocharger Differential Speed",
      "SPN_Description": "The difference between turbocharger speeds on engine systems with 2 or more turbochargers. If there are are more than 2 turbochargers, it will be the difference between the fastest and the slowest turbocharger speed.",
      "bit_length": 16,
      "scaling": 4,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 77
    },
    "5981": {
      "PGN": 64694,
      "PGN_Name": "Vehicle Electrical Power 5",
      "PGN_Description": "VEP5",
      "first_bit": 0,
      "SPN": 5981,
      "SPN_Name": "SLI Battery Pack State of Charge",
      "SPN_Description": "Indicates the remaining charge of the battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means no charge remaining, 100% means full capacity at the battery pack's current state of health.   See SPN 5464 for hybrid battery pack.\r\n\r\nThis parameter shall be used to report the capacity of the battery pack.  If the state of charge of individual batteries within the battery pack is desired, use SPNs 7903, 7911, 7919, & 7927.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "5982": {
      "PGN": 64694,
      "PGN_Name": "Vehicle Electrical Power 5",
      "PGN_Description": "VEP5",
      "first_bit": 16,
      "SPN": 5982,
      "SPN_Name": "SLI Battery Pack Capacity",
      "SPN_Description": "Original or rated total reserve capacity of the battery pack used for starting the engine, for lighting, and for ignition (SLI).\r\n\r\nThis parameter shall be used to report the capacity of the battery pack.  If the capacity of individual batteries within the battery pack is desired, use SPNs 7902, 7912, 7920, & 7928.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ah",
      "SLOT_ID": 351
    },
    "5983": {
      "PGN": 64694,
      "PGN_Name": "Vehicle Electrical Power 5",
      "PGN_Description": "VEP5",
      "first_bit": 32,
      "SPN": 5983,
      "SPN_Name": "SLI Battery Pack Health",
      "SPN_Description": "Capacity of the battery pack relative to its original specification for the battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means battery pack is not capable of holding any charge, 100% means battery pack is capable of holding its original full capacity.\r\n\r\nThis parameter shall be used to report the health of the battery pack.  If the health of individual batteries within the battery pack is desired, use SPNs 7905, 7913, 7921, & 7929.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "5984": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 0,
      "SPN": 5984,
      "SPN_Name": "Switched Power Output #4 Command",
      "SPN_Description": "Desired state of Switched Power Output #4. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5985": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 2,
      "SPN": 5985,
      "SPN_Name": "Switched Power Output #3 Command",
      "SPN_Description": "Desired state of Switched Power Output #3. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5986": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 4,
      "SPN": 5986,
      "SPN_Name": "Switched Power Output #2 Command",
      "SPN_Description": "Desired state of Switched Power Output #2. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5987": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 6,
      "SPN": 5987,
      "SPN_Name": "Switched Power Output #1 Command",
      "SPN_Description": "Desired state of Switched Power Output #1. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5988": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 8,
      "SPN": 5988,
      "SPN_Name": "Switched Power Output #8 Command",
      "SPN_Description": "Desired state of Switched Power Output #8. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5989": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 10,
      "SPN": 5989,
      "SPN_Name": "Switched Power Output #7 Command",
      "SPN_Description": "Desired state of Switched Power Output #7. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5990": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 12,
      "SPN": 5990,
      "SPN_Name": "Switched Power Output #6 Command",
      "SPN_Description": "Desired state of Switched Power Output #6. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5991": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 14,
      "SPN": 5991,
      "SPN_Name": "Switched Power Output #5 Command",
      "SPN_Description": "Desired state of Switched Power Output #5. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5992": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 16,
      "SPN": 5992,
      "SPN_Name": "Switched Power Output #12 Command",
      "SPN_Description": "Desired state of Switched Power Output #12. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5993": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 18,
      "SPN": 5993,
      "SPN_Name": "Switched Power Output #11 Command",
      "SPN_Description": "Desired state of Switched Power Output #11. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5994": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 20,
      "SPN": 5994,
      "SPN_Name": "Switched Power Output #10 Command",
      "SPN_Description": "Desired state of Switched Power Output #10. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5995": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 22,
      "SPN": 5995,
      "SPN_Name": "Switched Power Output #9 Command",
      "SPN_Description": "Desired state of Switched Power Output #9. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5996": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 24,
      "SPN": 5996,
      "SPN_Name": "Switched Power Output #16 Command",
      "SPN_Description": "Desired state of Switched Power Output #16. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5997": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 26,
      "SPN": 5997,
      "SPN_Name": "Switched Power Output #15 Command",
      "SPN_Description": "Desired state of Switched Power Output #15. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5998": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 28,
      "SPN": 5998,
      "SPN_Name": "Switched Power Output #14 Command",
      "SPN_Description": "Desired state of Switched Power Output #14. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "5999": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 30,
      "SPN": 5999,
      "SPN_Name": "Switched Power Output #13 Command",
      "SPN_Description": "Desired state of Switched Power Output #13. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6000": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 32,
      "SPN": 6000,
      "SPN_Name": "Switched Power Output #20 Command",
      "SPN_Description": "Desired state of Switched Power Output #20. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6001": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 34,
      "SPN": 6001,
      "SPN_Name": "Switched Power Output #19 Command",
      "SPN_Description": "Desired state of Switched Power Output #19. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6002": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 36,
      "SPN": 6002,
      "SPN_Name": "Switched Power Output #18 Command",
      "SPN_Description": "Desired state of Switched Power Output #18. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6003": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 38,
      "SPN": 6003,
      "SPN_Name": "Switched Power Output #17 Command",
      "SPN_Description": "Desired state of Switched Power Output #17. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6004": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 40,
      "SPN": 6004,
      "SPN_Name": "Switched Power Output #24 Command",
      "SPN_Description": "Desired state of Switched Power Output #24. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6005": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 42,
      "SPN": 6005,
      "SPN_Name": "Switched Power Output #23 Command",
      "SPN_Description": "Desired state of Switched Power Output #23. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6006": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 44,
      "SPN": 6006,
      "SPN_Name": "Switched Power Output #22 Command",
      "SPN_Description": "Desired state of Switched Power Output #22. Used to set the desired state.\r\n\r\n00 - Output off\r\n01 - Output on\r\n10 - Reserved\r\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6007": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 46,
      "SPN": 6007,
      "SPN_Name": "Switched Power Output #21 Command",
      "SPN_Description": "Desired state of Switched Power Output #21. Used to set the desired state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6008": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 48,
      "SPN": 6008,
      "SPN_Name": "Switched Power Output #28 Command",
      "SPN_Description": "Desired state of Switched Power Output #28. Used to set the desired state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6009": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 50,
      "SPN": 6009,
      "SPN_Name": "Switched Power Output #27 Command",
      "SPN_Description": "Desired state of Switched Power Output #27. Used to set the desired state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6010": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 52,
      "SPN": 6010,
      "SPN_Name": "Switched Power Output #26 Command",
      "SPN_Description": "Desired state of Switched Power Output #26. Used to set the desired state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6011": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 54,
      "SPN": 6011,
      "SPN_Name": "Switched Power Output #25 Command",
      "SPN_Description": "Desired state of Switched Power Output #25. Used to set the desired state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6012": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 56,
      "SPN": 6012,
      "SPN_Name": "Switched Power Output #32 Command",
      "SPN_Description": "Desired state of Switched Power Output #32. Used to set the desired state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6013": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 58,
      "SPN": 6013,
      "SPN_Name": "Switched Power Output #31 Command",
      "SPN_Description": "Desired state of Switched Power Output #31. Used to set the desired state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6014": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 60,
      "SPN": 6014,
      "SPN_Name": "Switched Power Output #30 Command",
      "SPN_Description": "Desired state of Switched Power Output #30. Used to set the desired state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6015": {
      "PGN": 34304,
      "PGN_Name": "Switched Power Outputs Command",
      "PGN_Description": "SPOC",
      "first_bit": 62,
      "SPN": 6015,
      "SPN_Name": "Switched Power Output #29 Command",
      "SPN_Description": "Desired state of Switched Power Output #29. Used to set the desired state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6016": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 0,
      "SPN": 6016,
      "SPN_Name": "Fused Output #4",
      "SPN_Description": "State of Fused Output #4. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6017": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 2,
      "SPN": 6017,
      "SPN_Name": "Fused Output #3",
      "SPN_Description": "State of Fused Output #3. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6018": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 4,
      "SPN": 6018,
      "SPN_Name": "Fused Output #2",
      "SPN_Description": "State of Fused Output #2. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6019": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 6,
      "SPN": 6019,
      "SPN_Name": "Fused Output #1",
      "SPN_Description": "State of Fused Output #1. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6020": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 8,
      "SPN": 6020,
      "SPN_Name": "Fused Output #8",
      "SPN_Description": "State of Fused Output #8. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6021": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 10,
      "SPN": 6021,
      "SPN_Name": "Fused Output #7",
      "SPN_Description": "State of Fused Output #7. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6022": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 12,
      "SPN": 6022,
      "SPN_Name": "Fused Output #6",
      "SPN_Description": "State of Fused Output #6. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6023": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 14,
      "SPN": 6023,
      "SPN_Name": "Fused Output #5",
      "SPN_Description": "State of Fused Output #5. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6024": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 16,
      "SPN": 6024,
      "SPN_Name": "Fused Output #12",
      "SPN_Description": "State of Fused Output #12. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6025": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 18,
      "SPN": 6025,
      "SPN_Name": "Fused Output #11",
      "SPN_Description": "State of Fused Output #11. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6026": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 20,
      "SPN": 6026,
      "SPN_Name": "Fused Output #10",
      "SPN_Description": "State of Fused Output #10. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6027": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 22,
      "SPN": 6027,
      "SPN_Name": "Fused Output #9",
      "SPN_Description": "State of Fused Output #9. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6028": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 24,
      "SPN": 6028,
      "SPN_Name": "Fused Output #16",
      "SPN_Description": "State of Fused Output #16. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6029": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 26,
      "SPN": 6029,
      "SPN_Name": "Fused Output #15",
      "SPN_Description": "State of Fused Output #15. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6030": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 28,
      "SPN": 6030,
      "SPN_Name": "Fused Output #14",
      "SPN_Description": "State of Fused Output #14. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6031": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 30,
      "SPN": 6031,
      "SPN_Name": "Fused Output #13",
      "SPN_Description": "State of Fused Output #13. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6032": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 32,
      "SPN": 6032,
      "SPN_Name": "Fused Output #20",
      "SPN_Description": "State of Fused Output #20. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6033": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 34,
      "SPN": 6033,
      "SPN_Name": "Fused Output #19",
      "SPN_Description": "State of Fused Output #19. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6034": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 36,
      "SPN": 6034,
      "SPN_Name": "Fused Output #18",
      "SPN_Description": "State of Fused Output #18. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6035": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 38,
      "SPN": 6035,
      "SPN_Name": "Fused Output #17",
      "SPN_Description": "State of Fused Output #17. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6036": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 40,
      "SPN": 6036,
      "SPN_Name": "Fused Output #24",
      "SPN_Description": "State of Fused Output #24. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6037": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 42,
      "SPN": 6037,
      "SPN_Name": "Fused Output #23",
      "SPN_Description": "State of Fused Output #23. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6038": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 44,
      "SPN": 6038,
      "SPN_Name": "Fused Output #22",
      "SPN_Description": "State of Fused Output #22. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6039": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 46,
      "SPN": 6039,
      "SPN_Name": "Fused Output #21",
      "SPN_Description": "State of Fused Output #21. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6040": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 48,
      "SPN": 6040,
      "SPN_Name": "Fused Output #28",
      "SPN_Description": "State of Fused Output #28. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6041": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 50,
      "SPN": 6041,
      "SPN_Name": "Fused Output #27",
      "SPN_Description": "State of Fused Output #27. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6042": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 52,
      "SPN": 6042,
      "SPN_Name": "Fused Output #26",
      "SPN_Description": "State of Fused Output #26. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6043": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 54,
      "SPN": 6043,
      "SPN_Name": "Fused Output #25",
      "SPN_Description": "State of Fused Output #25. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6044": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 56,
      "SPN": 6044,
      "SPN_Name": "Fused Output #32",
      "SPN_Description": "State of Fused Output #32. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6045": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 58,
      "SPN": 6045,
      "SPN_Name": "Fused Output #31",
      "SPN_Description": "State of Fused Output #31. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6046": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 60,
      "SPN": 6046,
      "SPN_Name": "Fused Output #30",
      "SPN_Description": "State of Fused Output #30. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6047": {
      "PGN": 64693,
      "PGN_Name": "Fused Power Output Status",
      "PGN_Description": "FPOS",
      "first_bit": 62,
      "SPN": 6047,
      "SPN_Name": "Fused Output #29",
      "SPN_Description": "State of Fused Output #29. Used to indicate the output state.\n\n00 - Output not powered\n01 - Output powered\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6048": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 0,
      "SPN": 6048,
      "SPN_Name": "Switched Output #4",
      "SPN_Description": "State of Switched Output #4. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6049": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 2,
      "SPN": 6049,
      "SPN_Name": "Switched Output #3",
      "SPN_Description": "State of Switched Output #3. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6050": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 4,
      "SPN": 6050,
      "SPN_Name": "Switched Output #2",
      "SPN_Description": "State of Switched Output #2. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6051": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 6,
      "SPN": 6051,
      "SPN_Name": "Switched Output #1",
      "SPN_Description": "State of Switched Output #1. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6052": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 8,
      "SPN": 6052,
      "SPN_Name": "Switched Output #8",
      "SPN_Description": "State of Switched Output #8. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6053": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 10,
      "SPN": 6053,
      "SPN_Name": "Switched Output #7",
      "SPN_Description": "State of Switched Output #7. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6054": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 12,
      "SPN": 6054,
      "SPN_Name": "Switched Output #6",
      "SPN_Description": "State of Switched Output #6. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6055": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 14,
      "SPN": 6055,
      "SPN_Name": "Switched Output #5",
      "SPN_Description": "State of Switched Output #5. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6056": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 16,
      "SPN": 6056,
      "SPN_Name": "Switched Output #12",
      "SPN_Description": "State of Switched Output #12. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6057": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 18,
      "SPN": 6057,
      "SPN_Name": "Switched Output #11",
      "SPN_Description": "State of Switched Output #11. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6058": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 20,
      "SPN": 6058,
      "SPN_Name": "Switched Output #10",
      "SPN_Description": "State of Switched Output #10. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6059": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 22,
      "SPN": 6059,
      "SPN_Name": "Switched Output #9",
      "SPN_Description": "State of Switched Output #9. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6060": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 24,
      "SPN": 6060,
      "SPN_Name": "Switched Output #16",
      "SPN_Description": "State of Switched Output #16. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6061": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 26,
      "SPN": 6061,
      "SPN_Name": "Switched Output #15",
      "SPN_Description": "State of Switched Output #15. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6062": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 28,
      "SPN": 6062,
      "SPN_Name": "Switched Output #14",
      "SPN_Description": "State of Switched Output #14. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6063": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 30,
      "SPN": 6063,
      "SPN_Name": "Switched Output #13",
      "SPN_Description": "State of Switched Output #13. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6064": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 32,
      "SPN": 6064,
      "SPN_Name": "Switched Output #20",
      "SPN_Description": "State of Switched Output #20. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6065": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 34,
      "SPN": 6065,
      "SPN_Name": "Switched Output #19",
      "SPN_Description": "State of Switched Output #19. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6066": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 36,
      "SPN": 6066,
      "SPN_Name": "Switched Output #18",
      "SPN_Description": "State of Switched Output #18. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6067": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 38,
      "SPN": 6067,
      "SPN_Name": "Switched Output #17",
      "SPN_Description": "State of Switched Output #17. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6068": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 40,
      "SPN": 6068,
      "SPN_Name": "Switched Output #24",
      "SPN_Description": "State of Switched Output #24. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6069": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 42,
      "SPN": 6069,
      "SPN_Name": "Switched Output #23",
      "SPN_Description": "State of Switched Output #23. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6070": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 44,
      "SPN": 6070,
      "SPN_Name": "Switched Output #22",
      "SPN_Description": "State of Switched Output #22. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6071": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 46,
      "SPN": 6071,
      "SPN_Name": "Switched Output #21",
      "SPN_Description": "State of Switched Output #21. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6072": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 48,
      "SPN": 6072,
      "SPN_Name": "Switched Output #28",
      "SPN_Description": "State of Switched Output #28. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6073": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 50,
      "SPN": 6073,
      "SPN_Name": "Switched Output #27",
      "SPN_Description": "State of Switched Output #27. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6074": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 52,
      "SPN": 6074,
      "SPN_Name": "Switched Output #26",
      "SPN_Description": "State of Switched Output #26. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6075": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 54,
      "SPN": 6075,
      "SPN_Name": "Switched Output #25",
      "SPN_Description": "State of Switched Output #25. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6076": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 56,
      "SPN": 6076,
      "SPN_Name": "Switched Output #32",
      "SPN_Description": "State of Switched Output #32. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6077": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 58,
      "SPN": 6077,
      "SPN_Name": "Switched Output #31",
      "SPN_Description": "State of Switched Output #31. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6078": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 60,
      "SPN": 6078,
      "SPN_Name": "Switched Output #30",
      "SPN_Description": "State of Switched Output #30. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6079": {
      "PGN": 64692,
      "PGN_Name": "Switched Power Output Status",
      "PGN_Description": "SPOS",
      "first_bit": 62,
      "SPN": 6079,
      "SPN_Name": "Switched Output #29",
      "SPN_Description": "State of Switched Output #29. Used to indicate the output state.\n\n00 - Output off\n01 - Output on\n10 - Reserved\n11 - Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6080": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 0,
      "SPN": 6080,
      "SPN_Name": "Fused Output #1 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #1.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6081": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 16,
      "SPN": 6081,
      "SPN_Name": "Fused Output #2 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #2.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6082": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 32,
      "SPN": 6082,
      "SPN_Name": "Fused Output #3 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #3.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6083": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 48,
      "SPN": 6083,
      "SPN_Name": "Fused Output #4 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #4.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6084": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 64,
      "SPN": 6084,
      "SPN_Name": "Fused Output #5 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #5.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6085": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 80,
      "SPN": 6085,
      "SPN_Name": "Fused Output #6 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #6.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6086": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 96,
      "SPN": 6086,
      "SPN_Name": "Fused Output #7 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #7.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6087": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 112,
      "SPN": 6087,
      "SPN_Name": "Fused Output #8 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #8.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6088": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 128,
      "SPN": 6088,
      "SPN_Name": "Fused Output #9 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #9.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6089": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 144,
      "SPN": 6089,
      "SPN_Name": "Fused Output #10 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #10.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6090": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 160,
      "SPN": 6090,
      "SPN_Name": "Fused Output #11 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #11.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6091": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 176,
      "SPN": 6091,
      "SPN_Name": "Fused Output #12 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #12.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6092": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 192,
      "SPN": 6092,
      "SPN_Name": "Fused Output #13 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #13.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6093": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 208,
      "SPN": 6093,
      "SPN_Name": "Fused Output #14 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #14.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6094": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 224,
      "SPN": 6094,
      "SPN_Name": "Fused Output #15 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #15.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6095": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 240,
      "SPN": 6095,
      "SPN_Name": "Fused Output #16 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #16.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6096": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 256,
      "SPN": 6096,
      "SPN_Name": "Fused Output #17 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #17.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6097": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 272,
      "SPN": 6097,
      "SPN_Name": "Fused Output #18 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #18.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6098": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 288,
      "SPN": 6098,
      "SPN_Name": "Fused Output #19 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #19.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6099": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 304,
      "SPN": 6099,
      "SPN_Name": "Fused Output #20 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #20.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6100": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 320,
      "SPN": 6100,
      "SPN_Name": "Fused Output #21 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #21.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6101": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 336,
      "SPN": 6101,
      "SPN_Name": "Fused Output #22 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #22.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6102": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 352,
      "SPN": 6102,
      "SPN_Name": "Fused Output #23 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #23.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6103": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 368,
      "SPN": 6103,
      "SPN_Name": "Fused Output #24 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #24.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6104": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 384,
      "SPN": 6104,
      "SPN_Name": "Fused Output #25 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #25.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6105": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 400,
      "SPN": 6105,
      "SPN_Name": "Fused Output #26 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #26.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6106": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 416,
      "SPN": 6106,
      "SPN_Name": "Fused Output #27 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #27.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6107": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 432,
      "SPN": 6107,
      "SPN_Name": "Fused Output #28 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #28.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6108": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 448,
      "SPN": 6108,
      "SPN_Name": "Fused Output #29 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #29.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6109": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 464,
      "SPN": 6109,
      "SPN_Name": "Fused Output #30 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #30.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6110": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 480,
      "SPN": 6110,
      "SPN_Name": "Fused Output #31 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #31.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6111": {
      "PGN": 64691,
      "PGN_Name": "Fused Power Output Current",
      "PGN_Description": "FPOC",
      "first_bit": 496,
      "SPN": 6111,
      "SPN_Name": "Fused Output #32 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #32.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6112": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 0,
      "SPN": 6112,
      "SPN_Name": "Switched Output #1 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #1.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6113": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 16,
      "SPN": 6113,
      "SPN_Name": "Switched Output #2 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #2.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6114": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 32,
      "SPN": 6114,
      "SPN_Name": "Switched Output #3 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #3.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6115": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 48,
      "SPN": 6115,
      "SPN_Name": "Switched Output #4 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #4.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6116": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 64,
      "SPN": 6116,
      "SPN_Name": "Switched Output #5 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #5.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6117": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 80,
      "SPN": 6117,
      "SPN_Name": "Switched Output #6 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #6.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6118": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 96,
      "SPN": 6118,
      "SPN_Name": "Switched Output #7 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #7.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6119": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 112,
      "SPN": 6119,
      "SPN_Name": "Switched Output #8 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #8.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6120": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 128,
      "SPN": 6120,
      "SPN_Name": "Switched Output #9 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #9.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6121": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 144,
      "SPN": 6121,
      "SPN_Name": "Switched Output #10 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #10.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6122": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 160,
      "SPN": 6122,
      "SPN_Name": "Switched Output #11 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #11.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6123": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 176,
      "SPN": 6123,
      "SPN_Name": "Switched Output #12 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #12.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6124": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 192,
      "SPN": 6124,
      "SPN_Name": "Switched Output #13 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #13.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6125": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 208,
      "SPN": 6125,
      "SPN_Name": "Switched Output #14 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #14.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6126": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 224,
      "SPN": 6126,
      "SPN_Name": "Switched Output #15 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #15.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6127": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 240,
      "SPN": 6127,
      "SPN_Name": "Switched Output #16 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #16.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6128": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 256,
      "SPN": 6128,
      "SPN_Name": "Switched Output #17 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #17.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6129": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 272,
      "SPN": 6129,
      "SPN_Name": "Switched Output #18 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #18.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6130": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 288,
      "SPN": 6130,
      "SPN_Name": "Switched Output #19 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #19.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6131": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 304,
      "SPN": 6131,
      "SPN_Name": "Switched Output #20 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #20.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6132": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 320,
      "SPN": 6132,
      "SPN_Name": "Switched Output #21 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #21.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6133": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 336,
      "SPN": 6133,
      "SPN_Name": "Switched Output #22 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #22.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6134": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 352,
      "SPN": 6134,
      "SPN_Name": "Switched Output #23 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #23.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6135": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 368,
      "SPN": 6135,
      "SPN_Name": "Switched Output #24 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #24.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6136": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 384,
      "SPN": 6136,
      "SPN_Name": "Switched Output #25 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #25.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6137": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 400,
      "SPN": 6137,
      "SPN_Name": "Switched Output #26 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #26.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6138": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 416,
      "SPN": 6138,
      "SPN_Name": "Switched Output #27 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #27.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6139": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 432,
      "SPN": 6139,
      "SPN_Name": "Switched Output #28 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #28.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6140": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 448,
      "SPN": 6140,
      "SPN_Name": "Switched Output #29 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #29.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6141": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 464,
      "SPN": 6141,
      "SPN_Name": "Switched Output #30 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #30.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6142": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 480,
      "SPN": 6142,
      "SPN_Name": "Switched Output #31 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #31.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6143": {
      "PGN": 64690,
      "PGN_Name": "Switched Power Output Current",
      "PGN_Description": "SPOC1",
      "first_bit": 496,
      "SPN": 6143,
      "SPN_Name": "Switched Output #32 Current",
      "SPN_Description": "Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #32.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 352
    },
    "6201": {
      "PGN": 61486,
      "PGN_Name": "Engine Turbocharger Control",
      "PGN_Description": "ETCC",
      "first_bit": 48,
      "SPN": 6201,
      "SPN_Name": "Engine Turbocharger Compressor Blowoff Actuator 1 Command",
      "SPN_Description": "The command to blow off actuator 1, normalized to percent, where 0% nominally represents fully closed (No Flow) and 100% represents fully open (Max Flow). The purpose of Blow-off value is similar to that of Compressor bypass valve, however the blow-off valve releases the air at the high pressure compressor outlet to the low pressure turbine outlet.\r\n\r\n0xFB00 - 0xFB64 is sent to calibrate to a specific position.  The LSB specifies the position with a resolution of 1%/bit  (eg, 0xFB32 is sent to calibrate the actuator to 50%).  \r\n\r\n0xFBFF is sent to calibrate the actuator using its own algorithm.  \r\n\r\nCalibration status from the actuator is received on SPN 6316.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "6202": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 24,
      "SPN": 6202,
      "SPN_Name": "Engine Control Module 1 Ready for Use Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Control Module 1 Ready for Use Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6203": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 26,
      "SPN": 6203,
      "SPN_Name": "Engine Control Module 2 Ready for Use Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Control Module 2 Ready for Use Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6204": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 28,
      "SPN": 6204,
      "SPN_Name": "Engine Control Module 3 Ready for Use Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Control Module 3 Ready for Use Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6205": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 24,
      "SPN": 6205,
      "SPN_Name": "Engine Control Module 1 Ready for Use Lamp Command",
      "SPN_Description": "Command signal directly controlling the Engine Control Module 1 Ready for use Lamp. This lamp is used to indicate whether ECM 1 can control the operation of the engine. In case of a failure in ECM 1, lamp will be turned OFF.\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6206": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 26,
      "SPN": 6206,
      "SPN_Name": "Engine Control Module 2 Ready for Use Lamp Command",
      "SPN_Description": "Command signal directly controlling the Engine Control Module 2 Ready for Use Lamp. This lamp is used to indicate whether ECM 2 can control the operation of the engine. In case of a failure in ECM 2, lamp will be turned OFF.\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6207": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 28,
      "SPN": 6207,
      "SPN_Name": "Engine Control Module 3 Ready for Use Lamp Command",
      "SPN_Description": "Command signal directly controlling the Engine Control Module 3 Ready for Use Lamp. This lamp is used to indicate whether ECM 3 can control the operation of the engine. In case of a failure in ECM 3, lamp will be turned OFF.\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6208": {
      "PGN": 64732,
      "PGN_Name": "Cruise Control / Vehicle Speed 3",
      "PGN_Description": "CCVS3",
      "first_bit": 24,
      "SPN": 6208,
      "SPN_Name": "AEBS readiness state",
      "SPN_Description": "Advanced emergency braking systems (AEBS) will limit the engine torque via TSC1 during warning and braking phases. Therefore the engine controller gives a feedback to the AEBS if it is configured and able to obey these limitation commands.\r\n\r\n00 - Off -- engine is not configured to accept commands from an AEBS\r\n01 - On -- engine is configured to accept commands from an AEBS\r\n10 - Condition exists that prevents system from responding to AEBS commands even though it is configured\r\n11 - Not Available/Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6209": {
      "PGN": 64870,
      "PGN_Name": "Engine Temperature 4",
      "PGN_Description": "ET4",
      "first_bit": 56,
      "SPN": 6209,
      "SPN_Name": "Engine Coolant Temperature 3",
      "SPN_Description": "Third temperature of liquid found in the engine cooling system. See also SPNs 110, 4076 and 4193.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "6214": {
      "PGN": 64689,
      "PGN_Name": "Engine Ignition Control Module Status",
      "PGN_Description": "ICMSTS",
      "first_bit": 0,
      "SPN": 6214,
      "SPN_Name": "Engine Ignition Control Module 1 Temperature",
      "SPN_Description": "Measured internal temperature of the Engine Ignition Control Module 1 circuitry.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "6215": {
      "PGN": 64689,
      "PGN_Name": "Engine Ignition Control Module Status",
      "PGN_Description": "ICMSTS",
      "first_bit": 8,
      "SPN": 6215,
      "SPN_Name": "Engine Ignition Control Module 2 Temperature",
      "SPN_Description": "Measured internal temperature of the Engine Ignition Control Module 2 circuitry.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "6216": {
      "PGN": 64689,
      "PGN_Name": "Engine Ignition Control Module Status",
      "PGN_Description": "ICMSTS",
      "first_bit": 16,
      "SPN": 6216,
      "SPN_Name": "Engine Ignition Control Module 1 State",
      "SPN_Description": "This parameter is used to indicate the current state of Engine Ignition Control Module 1.\r\n\r\n000 - Disabled (by user)\r\n001 - Shutdown (due to alarm)\r\n010 - Stalled (waiting for timing signals)\r\n011 - Firing Ignition in Test Mode\r\n100 - Firing Ignition in Normal Mode\r\n101 - Reserved\r\n110 - Error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "6217": {
      "PGN": 64689,
      "PGN_Name": "Engine Ignition Control Module Status",
      "PGN_Description": "ICMSTS",
      "first_bit": 19,
      "SPN": 6217,
      "SPN_Name": "Engine Ignition Control Module 2 State",
      "SPN_Description": "This parameter is used to indicate the current state of Engine Ignition Control Module 2.\r\n\r\n000 - Disabled (by user)\r\n001 - Shutdown (due to alarm)\r\n010 - Stalled (waiting for timing signals)\r\n011 - Firing Ignition in Test Mode\r\n100 - Firing Ignition in Normal Mode\r\n101 - Reserved\r\n110 - Error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "6218": {
      "PGN": 56832,
      "PGN_Name": "Reset",
      "PGN_Description": "RESET",
      "first_bit": 20,
      "SPN": 6218,
      "SPN_Name": "Engine Spark Plug Secondary Voltage Tracking Reset",
      "SPN_Description": "Command signal used to reset the ignition controller average, maximum, and minimum level tracking of the spark plug secondary voltages and to reset the learned misfire rate.  Average secondary voltage tracking is reported in PGNs 64882 - 64887.  Minimum secondary voltage tracking is reported in PGNs 64682 - 64687.  Maximum secondary voltage tracking is reported in PGNs 64676 - 64681.  Misfire rates are reported in PGNs 64673 - 64675.\r\n\r\n00 Do not reset\r\n01 Reset\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6219": {
      "PGN": 56832,
      "PGN_Name": "Reset",
      "PGN_Description": "RESET",
      "first_bit": 22,
      "SPN": 6219,
      "SPN_Name": "Engine Ignition Control Maintenance Hours Reset",
      "SPN_Description": "Used to reset the maintenance hour counter for an engine ignition control module.  The hours remaining until required maintenance is performed are reported in PGN 64688.\r\n\r\n00 Do not reset\r\n01 Reset\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6220": {
      "PGN": 64688,
      "PGN_Name": "Engine Ignition Controller Maintenance Hours",
      "PGN_Description": "EICMH",
      "first_bit": 0,
      "SPN": 6220,
      "SPN_Name": "Engine Ignition Control Module 1 Time Remaining",
      "SPN_Description": "This parameter reports the time remaining before maintenance should be performed on engine ignition control module instance 1.  Upon maintenance, the time is reset to its starting value using Reset PGN 56832, Ignition Control Maintenance Hours Reset, SPN 6219.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "6221": {
      "PGN": 64688,
      "PGN_Name": "Engine Ignition Controller Maintenance Hours",
      "PGN_Description": "EICMH",
      "first_bit": 32,
      "SPN": 6221,
      "SPN_Name": "Engine Ignition Control Module 2 Time Remaining",
      "SPN_Description": "This parameter reports the time remaining before maintenance should be performed on engine ignition control module instance 2.  Upon maintenance, the time is reset to its starting value using Reset PGN 56832, Ignition Control Maintenance Hours Reset, SPN 6219.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "6222": {
      "PGN": 64687,
      "PGN_Name": "Engine Spark Minimum Voltage 1",
      "PGN_Description": "ESVMIN1",
      "first_bit": 0,
      "SPN": 6222,
      "SPN_Name": "Engine Spark Plug 1 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #1 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6223": {
      "PGN": 64687,
      "PGN_Name": "Engine Spark Minimum Voltage 1",
      "PGN_Description": "ESVMIN1",
      "first_bit": 16,
      "SPN": 6223,
      "SPN_Name": "Engine Spark Plug 2 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #2 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6224": {
      "PGN": 64687,
      "PGN_Name": "Engine Spark Minimum Voltage 1",
      "PGN_Description": "ESVMIN1",
      "first_bit": 32,
      "SPN": 6224,
      "SPN_Name": "Engine Spark Plug 3 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #3 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6225": {
      "PGN": 64687,
      "PGN_Name": "Engine Spark Minimum Voltage 1",
      "PGN_Description": "ESVMIN1",
      "first_bit": 48,
      "SPN": 6225,
      "SPN_Name": "Engine Spark Plug 4 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #4 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6226": {
      "PGN": 64686,
      "PGN_Name": "Engine Spark Minimum Voltage 2",
      "PGN_Description": "ESVMIN2",
      "first_bit": 0,
      "SPN": 6226,
      "SPN_Name": "Engine Spark Plug 5 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #5 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6227": {
      "PGN": 64686,
      "PGN_Name": "Engine Spark Minimum Voltage 2",
      "PGN_Description": "ESVMIN2",
      "first_bit": 16,
      "SPN": 6227,
      "SPN_Name": "Engine Spark Plug 6 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #6 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6228": {
      "PGN": 64686,
      "PGN_Name": "Engine Spark Minimum Voltage 2",
      "PGN_Description": "ESVMIN2",
      "first_bit": 32,
      "SPN": 6228,
      "SPN_Name": "Engine Spark Plug 7 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #7 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6229": {
      "PGN": 64686,
      "PGN_Name": "Engine Spark Minimum Voltage 2",
      "PGN_Description": "ESVMIN2",
      "first_bit": 48,
      "SPN": 6229,
      "SPN_Name": "Engine Spark Plug 8 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #8 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6230": {
      "PGN": 64685,
      "PGN_Name": "Engine Spark Minimum Voltage 3",
      "PGN_Description": "ESVMIN3",
      "first_bit": 0,
      "SPN": 6230,
      "SPN_Name": "Engine Spark Plug 9 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #9 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6231": {
      "PGN": 64685,
      "PGN_Name": "Engine Spark Minimum Voltage 3",
      "PGN_Description": "ESVMIN3",
      "first_bit": 16,
      "SPN": 6231,
      "SPN_Name": "Engine Spark Plug 10 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #10 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6232": {
      "PGN": 64685,
      "PGN_Name": "Engine Spark Minimum Voltage 3",
      "PGN_Description": "ESVMIN3",
      "first_bit": 32,
      "SPN": 6232,
      "SPN_Name": "Engine Spark Plug 11 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #11 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6233": {
      "PGN": 64685,
      "PGN_Name": "Engine Spark Minimum Voltage 3",
      "PGN_Description": "ESVMIN3",
      "first_bit": 48,
      "SPN": 6233,
      "SPN_Name": "Engine Spark Plug 12 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #12 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6234": {
      "PGN": 64684,
      "PGN_Name": "Engine Spark Minimum Voltage 4",
      "PGN_Description": "ESVMIN4",
      "first_bit": 0,
      "SPN": 6234,
      "SPN_Name": "Engine Spark Plug 13 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #13 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6235": {
      "PGN": 64684,
      "PGN_Name": "Engine Spark Minimum Voltage 4",
      "PGN_Description": "ESVMIN4",
      "first_bit": 16,
      "SPN": 6235,
      "SPN_Name": "Engine Spark Plug 14 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #14 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6236": {
      "PGN": 64684,
      "PGN_Name": "Engine Spark Minimum Voltage 4",
      "PGN_Description": "ESVMIN4",
      "first_bit": 32,
      "SPN": 6236,
      "SPN_Name": "Engine Spark Plug 15 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #15 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6237": {
      "PGN": 64684,
      "PGN_Name": "Engine Spark Minimum Voltage 4",
      "PGN_Description": "ESVMIN4",
      "first_bit": 48,
      "SPN": 6237,
      "SPN_Name": "Engine Spark Plug 16 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #16 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6238": {
      "PGN": 64683,
      "PGN_Name": "Engine Spark Minimum Voltage 5",
      "PGN_Description": "ESVMIN5",
      "first_bit": 0,
      "SPN": 6238,
      "SPN_Name": "Engine Spark Plug 17 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #17 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6239": {
      "PGN": 64683,
      "PGN_Name": "Engine Spark Minimum Voltage 5",
      "PGN_Description": "ESVMIN5",
      "first_bit": 16,
      "SPN": 6239,
      "SPN_Name": "Engine Spark Plug 18 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #18 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6240": {
      "PGN": 64683,
      "PGN_Name": "Engine Spark Minimum Voltage 5",
      "PGN_Description": "ESVMIN5",
      "first_bit": 32,
      "SPN": 6240,
      "SPN_Name": "Engine Spark Plug 19 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #19 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6241": {
      "PGN": 64683,
      "PGN_Name": "Engine Spark Minimum Voltage 5",
      "PGN_Description": "ESVMIN5",
      "first_bit": 48,
      "SPN": 6241,
      "SPN_Name": "Engine Spark Plug 20 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #20 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6242": {
      "PGN": 64682,
      "PGN_Name": "Engine Spark Minimum Voltage 6",
      "PGN_Description": "ESVMIN6",
      "first_bit": 0,
      "SPN": 6242,
      "SPN_Name": "Engine Spark Plug 21 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #21 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6243": {
      "PGN": 64682,
      "PGN_Name": "Engine Spark Minimum Voltage 6",
      "PGN_Description": "ESVMIN6",
      "first_bit": 16,
      "SPN": 6243,
      "SPN_Name": "Engine Spark Plug 22 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #22 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6244": {
      "PGN": 64682,
      "PGN_Name": "Engine Spark Minimum Voltage 6",
      "PGN_Description": "ESVMIN6",
      "first_bit": 32,
      "SPN": 6244,
      "SPN_Name": "Engine Spark Plug 23 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #23 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6245": {
      "PGN": 64682,
      "PGN_Name": "Engine Spark Minimum Voltage 6",
      "PGN_Description": "ESVMIN6",
      "first_bit": 48,
      "SPN": 6245,
      "SPN_Name": "Engine Spark Plug 24 Minimum Voltage",
      "SPN_Description": "The smallest measured spark voltage of all measured spark events on Cylinder #24 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6246": {
      "PGN": 64681,
      "PGN_Name": "Engine Spark Maximum Voltage 1",
      "PGN_Description": "ESVMAX1",
      "first_bit": 0,
      "SPN": 6246,
      "SPN_Name": "Engine Spark Plug 1 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #1 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6247": {
      "PGN": 64681,
      "PGN_Name": "Engine Spark Maximum Voltage 1",
      "PGN_Description": "ESVMAX1",
      "first_bit": 16,
      "SPN": 6247,
      "SPN_Name": "Engine Spark Plug 2 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #2 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6248": {
      "PGN": 64681,
      "PGN_Name": "Engine Spark Maximum Voltage 1",
      "PGN_Description": "ESVMAX1",
      "first_bit": 32,
      "SPN": 6248,
      "SPN_Name": "Engine Spark Plug 3 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #3 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6249": {
      "PGN": 64681,
      "PGN_Name": "Engine Spark Maximum Voltage 1",
      "PGN_Description": "ESVMAX1",
      "first_bit": 48,
      "SPN": 6249,
      "SPN_Name": "Engine Spark Plug 4 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #4 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6250": {
      "PGN": 64680,
      "PGN_Name": "Engine Spark Maximum Voltage 2",
      "PGN_Description": "ESVMAX2",
      "first_bit": 0,
      "SPN": 6250,
      "SPN_Name": "Engine Spark Plug 5 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #5 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6251": {
      "PGN": 64680,
      "PGN_Name": "Engine Spark Maximum Voltage 2",
      "PGN_Description": "ESVMAX2",
      "first_bit": 16,
      "SPN": 6251,
      "SPN_Name": "Engine Spark Plug 6 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #6 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6252": {
      "PGN": 64680,
      "PGN_Name": "Engine Spark Maximum Voltage 2",
      "PGN_Description": "ESVMAX2",
      "first_bit": 32,
      "SPN": 6252,
      "SPN_Name": "Engine Spark Plug 7 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #7 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6253": {
      "PGN": 64680,
      "PGN_Name": "Engine Spark Maximum Voltage 2",
      "PGN_Description": "ESVMAX2",
      "first_bit": 48,
      "SPN": 6253,
      "SPN_Name": "Engine Spark Plug 8 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #8 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6254": {
      "PGN": 64679,
      "PGN_Name": "Engine Spark Maximum Voltage 3",
      "PGN_Description": "ESVMAX3",
      "first_bit": 0,
      "SPN": 6254,
      "SPN_Name": "Engine Spark Plug 9 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #9 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6255": {
      "PGN": 64679,
      "PGN_Name": "Engine Spark Maximum Voltage 3",
      "PGN_Description": "ESVMAX3",
      "first_bit": 16,
      "SPN": 6255,
      "SPN_Name": "Engine Spark Plug 10 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #10 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6256": {
      "PGN": 64679,
      "PGN_Name": "Engine Spark Maximum Voltage 3",
      "PGN_Description": "ESVMAX3",
      "first_bit": 32,
      "SPN": 6256,
      "SPN_Name": "Engine Spark Plug 11 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #11 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6257": {
      "PGN": 64679,
      "PGN_Name": "Engine Spark Maximum Voltage 3",
      "PGN_Description": "ESVMAX3",
      "first_bit": 48,
      "SPN": 6257,
      "SPN_Name": "Engine Spark Plug 12 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #12 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6258": {
      "PGN": 64678,
      "PGN_Name": "Engine Spark Maximum Voltage 4",
      "PGN_Description": "ESVMAX4",
      "first_bit": 0,
      "SPN": 6258,
      "SPN_Name": "Engine Spark Plug 13 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #13 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6259": {
      "PGN": 64678,
      "PGN_Name": "Engine Spark Maximum Voltage 4",
      "PGN_Description": "ESVMAX4",
      "first_bit": 16,
      "SPN": 6259,
      "SPN_Name": "Engine Spark Plug 14 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #14 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6260": {
      "PGN": 64678,
      "PGN_Name": "Engine Spark Maximum Voltage 4",
      "PGN_Description": "ESVMAX4",
      "first_bit": 32,
      "SPN": 6260,
      "SPN_Name": "Engine Spark Plug 15 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #15 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6261": {
      "PGN": 64678,
      "PGN_Name": "Engine Spark Maximum Voltage 4",
      "PGN_Description": "ESVMAX4",
      "first_bit": 48,
      "SPN": 6261,
      "SPN_Name": "Engine Spark Plug 16 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #16 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6262": {
      "PGN": 64677,
      "PGN_Name": "Engine Spark Maximum Voltage 5",
      "PGN_Description": "ESVMAX5",
      "first_bit": 0,
      "SPN": 6262,
      "SPN_Name": "Engine Spark Plug 17 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #17 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6263": {
      "PGN": 64677,
      "PGN_Name": "Engine Spark Maximum Voltage 5",
      "PGN_Description": "ESVMAX5",
      "first_bit": 16,
      "SPN": 6263,
      "SPN_Name": "Engine Spark Plug 18 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #18 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6264": {
      "PGN": 64677,
      "PGN_Name": "Engine Spark Maximum Voltage 5",
      "PGN_Description": "ESVMAX5",
      "first_bit": 32,
      "SPN": 6264,
      "SPN_Name": "Engine Spark Plug 19 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #19 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6265": {
      "PGN": 64677,
      "PGN_Name": "Engine Spark Maximum Voltage 5",
      "PGN_Description": "ESVMAX5",
      "first_bit": 48,
      "SPN": 6265,
      "SPN_Name": "Engine Spark Plug 20 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #20 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6266": {
      "PGN": 64676,
      "PGN_Name": "Engine Spark Maximum Voltage 6",
      "PGN_Description": "ESVMAX6",
      "first_bit": 0,
      "SPN": 6266,
      "SPN_Name": "Engine Spark Plug 21 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #21 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6267": {
      "PGN": 64676,
      "PGN_Name": "Engine Spark Maximum Voltage 6",
      "PGN_Description": "ESVMAX6",
      "first_bit": 16,
      "SPN": 6267,
      "SPN_Name": "Engine Spark Plug 22 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #22 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6268": {
      "PGN": 64676,
      "PGN_Name": "Engine Spark Maximum Voltage 6",
      "PGN_Description": "ESVMAX6",
      "first_bit": 32,
      "SPN": 6268,
      "SPN_Name": "Engine Spark Plug 23 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #23 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6269": {
      "PGN": 64676,
      "PGN_Name": "Engine Spark Maximum Voltage 6",
      "PGN_Description": "ESVMAX6",
      "first_bit": 48,
      "SPN": 6269,
      "SPN_Name": "Engine Spark Plug 24 Maximum Voltage",
      "SPN_Description": "The largest measured spark voltage of all measured spark events on Cylinder #24 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 145
    },
    "6270": {
      "PGN": 64675,
      "PGN_Name": "Engine Spark Misfire Rate 1",
      "PGN_Description": "ESMR1",
      "first_bit": 0,
      "SPN": 6270,
      "SPN_Name": "Engine Spark Plug 1 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #1. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #1 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6271": {
      "PGN": 64675,
      "PGN_Name": "Engine Spark Misfire Rate 1",
      "PGN_Description": "ESMR1",
      "first_bit": 8,
      "SPN": 6271,
      "SPN_Name": "Engine Spark Plug 2 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #2. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #2 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6272": {
      "PGN": 64675,
      "PGN_Name": "Engine Spark Misfire Rate 1",
      "PGN_Description": "ESMR1",
      "first_bit": 16,
      "SPN": 6272,
      "SPN_Name": "Engine Spark Plug 3 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #3. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #3 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6273": {
      "PGN": 64675,
      "PGN_Name": "Engine Spark Misfire Rate 1",
      "PGN_Description": "ESMR1",
      "first_bit": 24,
      "SPN": 6273,
      "SPN_Name": "Engine Spark Plug 4 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #4. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #4 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6274": {
      "PGN": 64675,
      "PGN_Name": "Engine Spark Misfire Rate 1",
      "PGN_Description": "ESMR1",
      "first_bit": 32,
      "SPN": 6274,
      "SPN_Name": "Engine Spark Plug 5 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #5. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #5 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6275": {
      "PGN": 64675,
      "PGN_Name": "Engine Spark Misfire Rate 1",
      "PGN_Description": "ESMR1",
      "first_bit": 40,
      "SPN": 6275,
      "SPN_Name": "Engine Spark Plug 6 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #6. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #6 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6276": {
      "PGN": 64675,
      "PGN_Name": "Engine Spark Misfire Rate 1",
      "PGN_Description": "ESMR1",
      "first_bit": 48,
      "SPN": 6276,
      "SPN_Name": "Engine Spark Plug 7 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #7. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #7 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6277": {
      "PGN": 64675,
      "PGN_Name": "Engine Spark Misfire Rate 1",
      "PGN_Description": "ESMR1",
      "first_bit": 56,
      "SPN": 6277,
      "SPN_Name": "Engine Spark Plug 8 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #8. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #8 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6278": {
      "PGN": 64674,
      "PGN_Name": "Engine Spark Misfire Rate 2",
      "PGN_Description": "ESMR2",
      "first_bit": 0,
      "SPN": 6278,
      "SPN_Name": "Engine Spark Plug 9 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #9. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #9 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6279": {
      "PGN": 64674,
      "PGN_Name": "Engine Spark Misfire Rate 2",
      "PGN_Description": "ESMR2",
      "first_bit": 8,
      "SPN": 6279,
      "SPN_Name": "Engine Spark Plug 10 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #10. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #10 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6280": {
      "PGN": 64674,
      "PGN_Name": "Engine Spark Misfire Rate 2",
      "PGN_Description": "ESMR2",
      "first_bit": 16,
      "SPN": 6280,
      "SPN_Name": "Engine Spark Plug 11 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #11. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #11 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6281": {
      "PGN": 64674,
      "PGN_Name": "Engine Spark Misfire Rate 2",
      "PGN_Description": "ESMR2",
      "first_bit": 24,
      "SPN": 6281,
      "SPN_Name": "Engine Spark Plug 12 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #12. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #12 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6282": {
      "PGN": 64674,
      "PGN_Name": "Engine Spark Misfire Rate 2",
      "PGN_Description": "ESMR2",
      "first_bit": 32,
      "SPN": 6282,
      "SPN_Name": "Engine Spark Plug 13 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #13. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #13 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6283": {
      "PGN": 64674,
      "PGN_Name": "Engine Spark Misfire Rate 2",
      "PGN_Description": "ESMR2",
      "first_bit": 40,
      "SPN": 6283,
      "SPN_Name": "Engine Spark Plug 14 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #14. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #14 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6284": {
      "PGN": 64674,
      "PGN_Name": "Engine Spark Misfire Rate 2",
      "PGN_Description": "ESMR2",
      "first_bit": 48,
      "SPN": 6284,
      "SPN_Name": "Engine Spark Plug 15 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #15. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #15 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6285": {
      "PGN": 64674,
      "PGN_Name": "Engine Spark Misfire Rate 2",
      "PGN_Description": "ESMR2",
      "first_bit": 56,
      "SPN": 6285,
      "SPN_Name": "Engine Spark Plug 16 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #16. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #16 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6286": {
      "PGN": 64673,
      "PGN_Name": "Engine Spark Misfire Rate 3",
      "PGN_Description": "ESMR3",
      "first_bit": 0,
      "SPN": 6286,
      "SPN_Name": "Engine Spark Plug 17 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #17. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #17 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6287": {
      "PGN": 64673,
      "PGN_Name": "Engine Spark Misfire Rate 3",
      "PGN_Description": "ESMR3",
      "first_bit": 8,
      "SPN": 6287,
      "SPN_Name": "Engine Spark Plug 18 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #18. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #18 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6288": {
      "PGN": 64673,
      "PGN_Name": "Engine Spark Misfire Rate 3",
      "PGN_Description": "ESMR3",
      "first_bit": 16,
      "SPN": 6288,
      "SPN_Name": "Engine Spark Plug 19 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #19. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #19 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6289": {
      "PGN": 64673,
      "PGN_Name": "Engine Spark Misfire Rate 3",
      "PGN_Description": "ESMR3",
      "first_bit": 24,
      "SPN": 6289,
      "SPN_Name": "Engine Spark Plug 20 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #20. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #20 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6290": {
      "PGN": 64673,
      "PGN_Name": "Engine Spark Misfire Rate 3",
      "PGN_Description": "ESMR3",
      "first_bit": 32,
      "SPN": 6290,
      "SPN_Name": "Engine Spark Plug 21 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #21. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #21 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6291": {
      "PGN": 64673,
      "PGN_Name": "Engine Spark Misfire Rate 3",
      "PGN_Description": "ESMR3",
      "first_bit": 40,
      "SPN": 6291,
      "SPN_Name": "Engine Spark Plug 22 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #22. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #22 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6292": {
      "PGN": 64673,
      "PGN_Name": "Engine Spark Misfire Rate 3",
      "PGN_Description": "ESMR3",
      "first_bit": 48,
      "SPN": 6292,
      "SPN_Name": "Engine Spark Plug 23 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #23. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #23 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6293": {
      "PGN": 64673,
      "PGN_Name": "Engine Spark Misfire Rate 3",
      "PGN_Description": "ESMR3",
      "first_bit": 56,
      "SPN": 6293,
      "SPN_Name": "Engine Spark Plug 24 Misfire Rate",
      "SPN_Description": "The spark misfire rate for Cylinder #24. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #24 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6301": {
      "PGN": 65279,
      "PGN_Name": "Operator indicators",
      "PGN_Description": "OI",
      "first_bit": 4,
      "SPN": 6301,
      "SPN_Name": "Water in Fuel Indicator 2",
      "SPN_Description": "A second indicator of the presense of water in the fuel.  See also SPN 97.\r\n\r\n00 - No\r\n01 - Yes\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6305": {
      "PGN": 65198,
      "PGN_Name": "Air Supply Pressure",
      "PGN_Description": "AIR1",
      "first_bit": 56,
      "SPN": 6305,
      "SPN_Name": "Powertrain Circuit Air Supply Pressure",
      "SPN_Description": "Supply pressure to carry the pressure information for the powertrain circuit. This circuit typically would feed powertrain components such as throttles, gearbox actuators and aftertreatment actuators for EGR and SCR systems.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "6306": {
      "PGN": 64994,
      "PGN_Name": "Supply Pressure Demand",
      "PGN_Description": "SPR",
      "first_bit": 48,
      "SPN": 6306,
      "SPN_Name": "Powertrain Circuit Air Supply Pressure Request",
      "SPN_Description": "Command signal to influence the air pressure in the powertrain circuit.  This parameter is the setpoint for the parameter SPN 6305.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "6307": {
      "PGN": 64712,
      "PGN_Name": "Electronic Engine Controller 13",
      "PGN_Description": "EEC13",
      "first_bit": 8,
      "SPN": 6307,
      "SPN_Name": "Source Address of Controlling Device for Fueling State",
      "SPN_Description": "The J1939 source address of the device currently controlling the fueling state via SPN 5793.\r\n\r\n254 (0xFE) is used to indicate that the Source Address of Controlling Device for Fueling State parameter is supported, but no device is currently controlling the fueling state via SPN 5793.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "SA",
      "SLOT_ID": 35
    },
    "6309": {
      "PGN": 64699,
      "PGN_Name": "Aftertreatment 1 SCR Electronic Control Module Information",
      "PGN_Description": "A1ECMI",
      "first_bit": 4,
      "SPN": 6309,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Control Module 1 Power Supply 2",
      "SPN_Description": "State signal which indicates when the DEF control module 1 power supply 2 of aftertreatment 1 is being driven. On means the ECU is powering the aftertreatment 1 DEF control module 1 power supply. Note that the control module is external to the ECU.\r\n\r\n00 – Off\r\n01 – On: The ECU is powering the DEF dosing unit power supply\r\n10 – Error\r\n11 – Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6310": {
      "PGN": 64698,
      "PGN_Name": "Aftertreatment 2 SCR Electronic Control Module Information",
      "PGN_Description": "A2ECMI",
      "first_bit": 4,
      "SPN": 6310,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Control Module 1 Power Supply 2",
      "SPN_Description": "State signal which indicates when the DEF control module 1 power supply 2 of aftertreatment 2 is being driven. On means the ECU is powering the aftertreatment 2 DEF control module 1 power supply. Note that the control module is external to the ECU.\r\n\r\n00 – Off\r\n01 – On: The ECU is powering the DEF dosing unit power supply\r\n10 – Error\r\n11 – Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6311": {
      "PGN": 61495,
      "PGN_Name": "Engine Turbocharger Blowoff Actuator 1",
      "PGN_Description": "ETBA1",
      "first_bit": 0,
      "SPN": 6311,
      "SPN_Name": "Engine Turbocharger Compressor Blowoff Actuator 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Engine Turbocharger Blowoff Actuator 1 by the manufacturer's software.  When there are multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6312": {
      "PGN": 61495,
      "PGN_Name": "Engine Turbocharger Blowoff Actuator 1",
      "PGN_Description": "ETBA1",
      "first_bit": 5,
      "SPN": 6312,
      "SPN_Name": "Engine Turbocharger Compressor Blowoff Actuator 1 Temperature Status",
      "SPN_Description": "Used to identify the status of the Engine Turbocharger Compresssor Blowoff Actuator 1 drive circuitry temperature. Temperature excursions may affect the torque output.\r\n\r\n000 - High Most severe\r\n001 - High Least severe\r\n010 - In Range\r\n011 - Low Least severe\r\n100 - Low Most severe\r\n101 - Not Defined\r\n110 - Error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "6313": {
      "PGN": 61495,
      "PGN_Name": "Engine Turbocharger Blowoff Actuator 1",
      "PGN_Description": "ETBA1",
      "first_bit": 8,
      "SPN": 6313,
      "SPN_Name": "Engine Turbocharger Compressor Blowoff Actuator 1 Temperature",
      "SPN_Description": "Temperature of the Engine Turbocharger Compressor Bypass Actuator 1 drive circuitry. Temperature excursions may affect the torque output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "6314": {
      "PGN": 61495,
      "PGN_Name": "Engine Turbocharger Blowoff Actuator 1",
      "PGN_Description": "ETBA1",
      "first_bit": 16,
      "SPN": 6314,
      "SPN_Name": "Engine Turbocharger Compressor Blowoff Actuator 1 Desired Position",
      "SPN_Description": "The requested position of the Engine Turbocharger Compressor Blowoff actuator by the engine ECU, where 0% represents bypass fully closed and 100% represents fully open.  This is the position that the device is attempting to achieve.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6315": {
      "PGN": 61495,
      "PGN_Name": "Engine Turbocharger Blowoff Actuator 1",
      "PGN_Description": "ETBA1",
      "first_bit": 24,
      "SPN": 6315,
      "SPN_Name": "Engine Turbocharger Compressor Blowoff Actuator 1 Position",
      "SPN_Description": "Actual position of the turbocharger compressor blowoff actuator, where 0% represents fully closed and 100% represents fully open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6316": {
      "PGN": 61495,
      "PGN_Name": "Engine Turbocharger Blowoff Actuator 1",
      "PGN_Description": "ETBA1",
      "first_bit": 32,
      "SPN": 6316,
      "SPN_Name": "Engine Turbocharger Compressor Blowoff Actuator 1 Operation Status",
      "SPN_Description": "Used to identify the status of Engine Turbocharger Compressor Blowoff Actuator 1.\r\n\r\n0000 - Normal\r\n0001 - Alarm (fully operational but needs service)\r\n0010 - Alarm High Severity (functional but transient performance may be reduced)\r\n0011 - Derate Active (torque output reduced due to environmental conditions)\r\n0100 - Controlled Shutdown Active (driving to the default position - usually this means closed)\r\n0101 - Uncontrolled Shutdown Active (no torque is being applied from the actuator)\r\n0110 - Calibration in Progress (must be broadcast at least once per calibration process defined in SPN 6201)\r\n0111 - 1101   Reserved for future assignment\r\n1110 - Error\r\n1111 - Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "6317": {
      "PGN": 34560,
      "PGN_Name": "Engine State Requests",
      "PGN_Description": "ESR",
      "first_bit": 8,
      "SPN": 6317,
      "SPN_Name": "Requested Fuel Type",
      "SPN_Description": "Engine controller receives this request from another control module to select the type of fuel to be used for engine operation.\r\n\r\n0x00 - Not available - NONE\r\n0x01 - Gasoline/petrol - GAS\r\n0x02 - Methanol - METH\r\n0x03 - Ethanol - ETH\r\n0x04 - Diesel - DSL\r\n0x05 - Liquefied Petroleum Gas (LPG) - LPG\r\n0x06 - Compressed Natural Gas (CNG) - CNG\r\n0x07 - Propane - PROP\r\n0x08 - 0x16 - Reserved for use in SPN 5837\r\n0x17 - Natural Gas (NG) - NG\r\n0x18 - Reserved for use in SPN 5837\r\n0x19 - 0xFD - SAE reserved\r\n0xFE - Reserved for use in SPN 5837\r\n0xFF - Not supported\r\n\r\nSee SPN 5837 for fuel type.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "6319": {
      "PGN": 64672,
      "PGN_Name": "Multi-fuel Engine Hours",
      "PGN_Description": "MFEH",
      "first_bit": 0,
      "SPN": 6319,
      "SPN_Name": "Engine Total Hours of Gaseous Fuel Operation",
      "SPN_Description": "Accumulated time of operation of engine when gaseous fuel is used.  This parameter should be used only in multi-fuel engines.  See SPN 247 for single fuel engines and for total hours for multi-fuel engines.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "6320": {
      "PGN": 64672,
      "PGN_Name": "Multi-fuel Engine Hours",
      "PGN_Description": "MFEH",
      "first_bit": 32,
      "SPN": 6320,
      "SPN_Name": "Engine Total Hours of Diesel Fuel Operation",
      "SPN_Description": "Accumulated time of operation of engine when diesel fuel is used.  This parameter should be used only in multi-fuel engines.  See SPN 247 for single fuel engines and for total hours for multi-fuel engines.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "h",
      "SLOT_ID": 58
    },
    "6321": {
      "PGN": 64671,
      "PGN_Name": "Dash Display 2",
      "PGN_Description": "DD2",
      "first_bit": 0,
      "SPN": 6321,
      "SPN_Name": "Engine Oil Filter Differential Pressure (Extended Range)",
      "SPN_Description": "Change in engine oil differential pressure measured across the oil filter element. The differential pressure is the measured as the pressure at the filter intake with respect to the pressure at the filter outlet. This differential pressure measurement is used to assess the filter restriction as it accumulates solid or semisolid material on the filter element.\r\n\r\nThis SPN provides an extended range to the existing SPN 99 which can be used for an alternate range and scaling.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "kPa",
      "SLOT_ID": 52
    },
    "6330": {
      "PGN": 61650,
      "PGN_Name": "Engine Electronic Controller 18",
      "PGN_Description": "EEC18",
      "first_bit": 16,
      "SPN": 6330,
      "SPN_Name": "Engine Intake Air Source Valve",
      "SPN_Description": "Status of the actuator/valve in the airbox used to source engine intake air from either the engine compartment or external to the vehicle.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6333": {
      "PGN": 64712,
      "PGN_Name": "Electronic Engine Controller 13",
      "PGN_Description": "EEC13",
      "first_bit": 24,
      "SPN": 6333,
      "SPN_Name": "Engine Gas Substitution Fuel Percentage",
      "SPN_Description": "Percentage of Gaseous fuel used. 0% means no Gaseous fuel used and 100% means completely gaseous fuel is used.\r\n\r\nGas substitution is the process for a dual fuel engine system of substituting gas, e.g. natural gas, for some fraction of the primary combustion fuel, e.g. diesel fuel, in the engine combustion.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "6334": {
      "PGN": 64670,
      "PGN_Name": "Engine Timing Actuator Position",
      "PGN_Description": "ETAP",
      "first_bit": 8,
      "SPN": 6334,
      "SPN_Name": "Engine Timing Actuator 1 Requested Position",
      "SPN_Description": "The requested position of actuator 1 on the Engine Timing System, as determined by external system such as operator, monitoring, or protection system. Requested position is sent to the Control Module sending the command the Engine Timing System. Engine Timing system has different timing positions and the timing positions may be used to determine intake and outlet valve timings.\r\n\r\n000 - Position Not Requested\r\n001 - Diesel Mode Position\r\n010 - Diesel Part Load Position\r\n011 - Gas Mode Position\r\n100 - Diesel Part Load / Gas Mode Position\r\n101 - 110 - Reserved\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "6335": {
      "PGN": 64670,
      "PGN_Name": "Engine Timing Actuator Position",
      "PGN_Description": "ETAP",
      "first_bit": 11,
      "SPN": 6335,
      "SPN_Name": "Engine Timing Actuator 2 Requested Position",
      "SPN_Description": "The requested position of actuator 2 on the Engine Timing System, as determined by external system such as operator, monitoring or protection system. Requested position is sent to the Control Module sending the command the Engine Timing System. Engine Timing system has different timing positions and the timing positions may be used to determine intake and outlet valve timings.\r\n\r\n000 - Position Not Requested\r\n001 - Diesel Mode Position\r\n010 - Diesel Part Load Position\r\n011 - Gas Mode Position\r\n100 - Diesel Part Load / Gas Mode Position\r\n101 - 110 - Reserved\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "6336": {
      "PGN": 64669,
      "PGN_Name": "Engine Timing Actuator Position Command",
      "PGN_Description": "ETAPC",
      "first_bit": 0,
      "SPN": 6336,
      "SPN_Name": "Engine Timing Actuator 1 Position Command",
      "SPN_Description": "The commanded position of actuator 1 on the engine timing system by Engine Control Module.  The engine timing system has different timing positions and the timing positions may be used to determine intake and outlet valve timings.\r\n\r\n000 - Reserved\r\n001 - Diesel Mode Position\r\n010 - Diesel Part Load Position\r\n011 - Gas Mode Position\r\n100 - Diesel Part Load / Gas Mode Position\r\n101 - 110 - Reserved\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "6337": {
      "PGN": 64669,
      "PGN_Name": "Engine Timing Actuator Position Command",
      "PGN_Description": "ETAPC",
      "first_bit": 3,
      "SPN": 6337,
      "SPN_Name": "Engine Timing Actuator 2 Position Command",
      "SPN_Description": "The commanded position of actuator 2 on the engine timing system by Engine Control Module.  The engine timing system has different timing positions and the timing positions may be used to determine intake and outlet valve timings.\r\n\r\n000 - Reserved\r\n001 - Diesel Mode Position\r\n010 - Diesel Part Load Position\r\n011 - Gas Mode Position\r\n100 - Diesel Part Load / Gas Mode Position\r\n101 - 110 - Reserved\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "6338": {
      "PGN": 64668,
      "PGN_Name": "Joystick 1 Lamp Status",
      "PGN_Description": "JS1LS",
      "first_bit": 0,
      "SPN": 6338,
      "SPN_Name": "Joystick 1 Lamp 1 Status",
      "SPN_Description": "Report the actual value of Joystick 1 Lamp 1\r\n\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6339": {
      "PGN": 64668,
      "PGN_Name": "Joystick 1 Lamp Status",
      "PGN_Description": "JS1LS",
      "first_bit": 2,
      "SPN": 6339,
      "SPN_Name": "Joystick 1 Lamp 2 Status",
      "SPN_Description": "Report the actual value of Joystick 1 Lamp 2\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6340": {
      "PGN": 64668,
      "PGN_Name": "Joystick 1 Lamp Status",
      "PGN_Description": "JS1LS",
      "first_bit": 4,
      "SPN": 6340,
      "SPN_Name": "Joystick 1 Lamp 3 Status",
      "SPN_Description": "Report the actual value of Joystick 1 Lamp 3\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6341": {
      "PGN": 64668,
      "PGN_Name": "Joystick 1 Lamp Status",
      "PGN_Description": "JS1LS",
      "first_bit": 6,
      "SPN": 6341,
      "SPN_Name": "Joystick 1 Lamp 4 Status",
      "SPN_Description": "Report the actual value of Joystick 1 Lamp 4\r\n\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6342": {
      "PGN": 64668,
      "PGN_Name": "Joystick 1 Lamp Status",
      "PGN_Description": "JS1LS",
      "first_bit": 8,
      "SPN": 6342,
      "SPN_Name": "Joystick 1 Lamp 5 Status",
      "SPN_Description": "Report the actual value of Joystick 1 Lamp 5\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6343": {
      "PGN": 64668,
      "PGN_Name": "Joystick 1 Lamp Status",
      "PGN_Description": "JS1LS",
      "first_bit": 10,
      "SPN": 6343,
      "SPN_Name": "Joystick 1 Lamp 6 Status",
      "SPN_Description": "Report the actual value of Joystick 1 Lamp 6\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6344": {
      "PGN": 64668,
      "PGN_Name": "Joystick 1 Lamp Status",
      "PGN_Description": "JS1LS",
      "first_bit": 12,
      "SPN": 6344,
      "SPN_Name": "Joystick 1 Lamp 7 Status",
      "SPN_Description": "Report the actual value of Joystick 1 Lamp 7\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6345": {
      "PGN": 64668,
      "PGN_Name": "Joystick 1 Lamp Status",
      "PGN_Description": "JS1LS",
      "first_bit": 14,
      "SPN": 6345,
      "SPN_Name": "Joystick 1 Lamp 8 Status",
      "SPN_Description": "Report the actual value of Joystick 1 Lamp 8\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6346": {
      "PGN": 64668,
      "PGN_Name": "Joystick 1 Lamp Status",
      "PGN_Description": "JS1LS",
      "first_bit": 16,
      "SPN": 6346,
      "SPN_Name": "Joystick 1 Lamp 9 Status",
      "SPN_Description": "Report the actual value of Joystick 1 Lamp 9\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6347": {
      "PGN": 64668,
      "PGN_Name": "Joystick 1 Lamp Status",
      "PGN_Description": "JS1LS",
      "first_bit": 18,
      "SPN": 6347,
      "SPN_Name": "Joystick 1 Lamp 10 Status",
      "SPN_Description": "Report the actual value of Joystick 1 Lamp 10\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6348": {
      "PGN": 64667,
      "PGN_Name": "Joystick 2 Lamp Status",
      "PGN_Description": "JS2LS",
      "first_bit": 0,
      "SPN": 6348,
      "SPN_Name": "Joystick 2 Lamp 1 Status",
      "SPN_Description": "Report the actual value of Joystick 2 Lamp 1\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6349": {
      "PGN": 64667,
      "PGN_Name": "Joystick 2 Lamp Status",
      "PGN_Description": "JS2LS",
      "first_bit": 2,
      "SPN": 6349,
      "SPN_Name": "Joystick 2 Lamp 2 Status",
      "SPN_Description": "Report the actual value of Joystick 2 Lamp 2\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6350": {
      "PGN": 64667,
      "PGN_Name": "Joystick 2 Lamp Status",
      "PGN_Description": "JS2LS",
      "first_bit": 4,
      "SPN": 6350,
      "SPN_Name": "Joystick 2 Lamp 3 Status",
      "SPN_Description": "Report the actual value of Joystick 2 Lamp 3\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6351": {
      "PGN": 64667,
      "PGN_Name": "Joystick 2 Lamp Status",
      "PGN_Description": "JS2LS",
      "first_bit": 6,
      "SPN": 6351,
      "SPN_Name": "Joystick 2 Lamp 4 Status",
      "SPN_Description": "Report the actual value of Joystick 2 Lamp 4\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6352": {
      "PGN": 64667,
      "PGN_Name": "Joystick 2 Lamp Status",
      "PGN_Description": "JS2LS",
      "first_bit": 8,
      "SPN": 6352,
      "SPN_Name": "Joystick 2 Lamp 5 Status",
      "SPN_Description": "Report the actual value of Joystick 2 Lamp 5\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6353": {
      "PGN": 64667,
      "PGN_Name": "Joystick 2 Lamp Status",
      "PGN_Description": "JS2LS",
      "first_bit": 10,
      "SPN": 6353,
      "SPN_Name": "Joystick 2 Lamp 6 Status",
      "SPN_Description": "Report the actual value of Joystick 2 Lamp 6\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6354": {
      "PGN": 64667,
      "PGN_Name": "Joystick 2 Lamp Status",
      "PGN_Description": "JS2LS",
      "first_bit": 12,
      "SPN": 6354,
      "SPN_Name": "Joystick 2 Lamp 7 Status",
      "SPN_Description": "Report the actual value of Joystick 2 Lamp 7\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6355": {
      "PGN": 64667,
      "PGN_Name": "Joystick 2 Lamp Status",
      "PGN_Description": "JS2LS",
      "first_bit": 14,
      "SPN": 6355,
      "SPN_Name": "Joystick 2 Lamp 8 Status",
      "SPN_Description": "Report the actual value of Joystick 2 Lamp 8\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6356": {
      "PGN": 64667,
      "PGN_Name": "Joystick 2 Lamp Status",
      "PGN_Description": "JS2LS",
      "first_bit": 16,
      "SPN": 6356,
      "SPN_Name": "Joystick 2 Lamp 9 Status",
      "SPN_Description": "Report the actual value of Joystick 2 Lamp 9\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6357": {
      "PGN": 64667,
      "PGN_Name": "Joystick 2 Lamp Status",
      "PGN_Description": "JS2LS",
      "first_bit": 18,
      "SPN": 6357,
      "SPN_Name": "Joystick 2 Lamp 10 Status",
      "SPN_Description": "Report the actual value of Joystick 2 Lamp 10\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6358": {
      "PGN": 64666,
      "PGN_Name": "Joystick 3 Lamp Status",
      "PGN_Description": "JS3LS",
      "first_bit": 0,
      "SPN": 6358,
      "SPN_Name": "Joystick 3 Lamp 1 Status",
      "SPN_Description": "Report the actual value of Joystick 3 Lamp 1\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6359": {
      "PGN": 64666,
      "PGN_Name": "Joystick 3 Lamp Status",
      "PGN_Description": "JS3LS",
      "first_bit": 2,
      "SPN": 6359,
      "SPN_Name": "Joystick 3 Lamp 2 Status",
      "SPN_Description": "Report the actual value of Joystick 3 Lamp 2\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6360": {
      "PGN": 64666,
      "PGN_Name": "Joystick 3 Lamp Status",
      "PGN_Description": "JS3LS",
      "first_bit": 4,
      "SPN": 6360,
      "SPN_Name": "Joystick 3 Lamp 3 Status",
      "SPN_Description": "Report the actual value of Joystick 3 Lamp 3\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6361": {
      "PGN": 64666,
      "PGN_Name": "Joystick 3 Lamp Status",
      "PGN_Description": "JS3LS",
      "first_bit": 6,
      "SPN": 6361,
      "SPN_Name": "Joystick 3 Lamp 4 Status",
      "SPN_Description": "Report the actual value of Joystick 3 Lamp 4\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6362": {
      "PGN": 64666,
      "PGN_Name": "Joystick 3 Lamp Status",
      "PGN_Description": "JS3LS",
      "first_bit": 8,
      "SPN": 6362,
      "SPN_Name": "Joystick 3 Lamp 5 Status",
      "SPN_Description": "Report the actual value of Joystick 3 Lamp 5\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6363": {
      "PGN": 64666,
      "PGN_Name": "Joystick 3 Lamp Status",
      "PGN_Description": "JS3LS",
      "first_bit": 10,
      "SPN": 6363,
      "SPN_Name": "Joystick 3 Lamp 6 Status",
      "SPN_Description": "Report the actual value of Joystick 3 Lamp 6\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6364": {
      "PGN": 64666,
      "PGN_Name": "Joystick 3 Lamp Status",
      "PGN_Description": "JS3LS",
      "first_bit": 12,
      "SPN": 6364,
      "SPN_Name": "Joystick 3 Lamp 7 Status",
      "SPN_Description": "Report the actual value of Joystick 3 Lamp 7\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6365": {
      "PGN": 64666,
      "PGN_Name": "Joystick 3 Lamp Status",
      "PGN_Description": "JS3LS",
      "first_bit": 14,
      "SPN": 6365,
      "SPN_Name": "Joystick 3 Lamp 8 Status",
      "SPN_Description": "Report the actual value of Joystick 3 Lamp 8\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6366": {
      "PGN": 64666,
      "PGN_Name": "Joystick 3 Lamp Status",
      "PGN_Description": "JS3LS",
      "first_bit": 16,
      "SPN": 6366,
      "SPN_Name": "Joystick 3 Lamp 9 Status",
      "SPN_Description": "Report the actual value of Joystick 3 Lamp 9\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6367": {
      "PGN": 64666,
      "PGN_Name": "Joystick 3 Lamp Status",
      "PGN_Description": "JS3LS",
      "first_bit": 18,
      "SPN": 6367,
      "SPN_Name": "Joystick 3 Lamp 10 Status",
      "SPN_Description": "Report the actual value of Joystick 3 Lamp 10\r\n\r\n00 - Off\r\n01 - On\r\n10 - Flashing\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6368": {
      "PGN": 64665,
      "PGN_Name": "Assembly Unit Identification",
      "PGN_Description": "AUI",
      "first_bit": 0,
      "SPN": 6368,
      "SPN_Name": "Number of Assembly Unit Identification Fields",
      "SPN_Description": "Number of Assembly Unit Identification designators represented in the Assembly Unit Identification parameter group.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "6370": {
      "PGN": 64664,
      "PGN_Name": "Vehicle Speed Limiter",
      "PGN_Description": "VSL",
      "first_bit": 0,
      "SPN": 6370,
      "SPN_Name": "Soft Top Speed Limit Active",
      "SPN_Description": "Indicates that the current Maximum Vehicle Speed Limit (SPN 74) has been temporarily increased to the Soft Top Speed Limit. Under certain conditions, the legal speed limit allowed by the Greenhouse Gas Regulations can be increased to a speed referred to as the “Soft Top Speed Limit” for a specified distance.\r\n\r\nSee SPNs 6372, 6373, & 6914 for an explanation of the relevant distance parameters.\r\n\r\n00 – Soft Top Speed Limit is Inactive\r\n01 – Soft Top Speed Limit is Active\r\n10 – Reserved\r\n11 – Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6371": {
      "PGN": 64664,
      "PGN_Name": "Vehicle Speed Limiter",
      "PGN_Description": "VSL",
      "first_bit": 2,
      "SPN": 6371,
      "SPN_Name": "Soft Top Ratio Limit Exceeded",
      "SPN_Description": "Greenhouse Gas Regulations limit the overall distance that Soft Top Speed can be used in relation to the total distance traveled. This parameter indicates the allowable ratio has been exceeded and Soft Top Speed is unavailable. It will become available again when enough distance has been traveled without using Soft Top Speed to bring the ratio back under the limit.\r\n\r\n00 – Soft top ratio limit has not been exceeded\r\n01 – Soft top ratio limit has been exceeded\r\n10 – Reserved\r\n11 – Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6372": {
      "PGN": 64664,
      "PGN_Name": "Vehicle Speed Limiter",
      "PGN_Description": "VSL",
      "first_bit": 8,
      "SPN": 6372,
      "SPN_Name": "Soft Top Speed Limit Remaining Distance",
      "SPN_Description": "Indicates the remaining distance that the vehicle can travel at the Soft Top Speed Limit within the larger reset window. The reset window may be distance (possibly indicated by SPN 6373), time, or something else as determined by the manufacturer.\r\n\r\nThis parameter will decrement while the Soft Top Speed Limit Active (SPN 6370) is 1. When the Soft Top Speed Limit Remaining Distance parameter reaches 0, the Soft Top Speed Limit cannot be activated.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 270
    },
    "6373": {
      "PGN": 64664,
      "PGN_Name": "Vehicle Speed Limiter",
      "PGN_Description": "VSL",
      "first_bit": 24,
      "SPN": 6373,
      "SPN_Name": "Soft Top Speed Limit Reset Distance",
      "SPN_Description": "This parameter will decrement as long as the vehicle is moving. When this parameter reaches 0, it will be reset to its maximum value and continue to decrement.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 270
    },
    "6374": {
      "PGN": 64663,
      "PGN_Name": "Electronic Steering Control 2",
      "PGN_Description": "ESC2",
      "first_bit": 16,
      "SPN": 6374,
      "SPN_Name": "Steering Controller ECU Temperature",
      "SPN_Description": "Temperature of the steering controller ECU",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "6375": {
      "PGN": 64663,
      "PGN_Name": "Electronic Steering Control 2",
      "PGN_Description": "ESC2",
      "first_bit": 0,
      "SPN": 6375,
      "SPN_Name": "Steering Mode Switch",
      "SPN_Description": "Switch used as an input to the electronic steering controller to determine the operator's requested steering mode\r\n\r\n000 - 2 Wheel Steer Mode\r\n001 - Circle Steer Mode\r\n011 - Crab Steer Mode\r\n100-101 - Reserved for future use\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "6376": {
      "PGN": 64663,
      "PGN_Name": "Electronic Steering Control 2",
      "PGN_Description": "ESC2",
      "first_bit": 4,
      "SPN": 6376,
      "SPN_Name": "Front Steering Axle Centered Status",
      "SPN_Description": "The status of the front steering axle being centered. The axle is centered if the axle's centerline is parallel to the vehicle's X-axis, where the vehicle's X-axis is as defined in SAE J670\r\n\r\n00 - Front Axle Centered\r\n01 - Front Axle Not Centered\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6377": {
      "PGN": 64663,
      "PGN_Name": "Electronic Steering Control 2",
      "PGN_Description": "ESC2",
      "first_bit": 6,
      "SPN": 6377,
      "SPN_Name": "Rear Steering Axle Centered Status",
      "SPN_Description": "The status of the rear steering axle being centered. The axle is centered if the axle's centerline is parallel to the vehicle's X-axis, where the vehicle's X-axis is as defined in SAE J670\r\n\r\n00 - Rear Axle Centered\r\n01 - Rear Axle Not Centered\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6378": {
      "PGN": 64663,
      "PGN_Name": "Electronic Steering Control 2",
      "PGN_Description": "ESC2",
      "first_bit": 8,
      "SPN": 6378,
      "SPN_Name": "2 Wheel Steer Actuator State",
      "SPN_Description": "The current state of the actuator that control the 2 wheel steering mode\r\n\r\n00 - 2 Wheel Steer actuator inactive\r\n01 - 2 Wheel Steer actuator active\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6379": {
      "PGN": 64663,
      "PGN_Name": "Electronic Steering Control 2",
      "PGN_Description": "ESC2",
      "first_bit": 10,
      "SPN": 6379,
      "SPN_Name": "4 Wheel Steer Actuator State",
      "SPN_Description": "Signal which indicates the current state of the actuator that control the 4 wheel steering mode\r\n\r\n00 - 4 Wheel Steer actuator inactive\r\n01 - 4 Wheel Steer actuator active\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6380": {
      "PGN": 64663,
      "PGN_Name": "Electronic Steering Control 2",
      "PGN_Description": "ESC2",
      "first_bit": 12,
      "SPN": 6380,
      "SPN_Name": "Circle Steer Mode Actuator State",
      "SPN_Description": "Signal which indicates the current state of the actuator that control the circle steering mode\r\n\r\n00 - Circle Steer Mode actuator inactive\r\n01 - Circle Steer Mode actuator active\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6381": {
      "PGN": 64663,
      "PGN_Name": "Electronic Steering Control 2",
      "PGN_Description": "ESC2",
      "first_bit": 14,
      "SPN": 6381,
      "SPN_Name": "Crab Steer Mode Actuator State",
      "SPN_Description": "Signal which indicates the current state of the actuator that control the crab steering mode\r\n\r\n00 - Crab Steer Mode actuator inactive\r\n01 - Crab Steer Mode actuator active\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6384": {
      "PGN": 64662,
      "PGN_Name": "Engine Information 2",
      "PGN_Description": "EI2",
      "first_bit": 0,
      "SPN": 6384,
      "SPN_Name": "Engine Exhaust Pressure 1 (Extended Range)",
      "SPN_Description": "Gage pressure of the exhaust gasses as measured at the turbine intake of the turbocharger. This SPN to be used for inline engines or exhaust bank 1 of multiple bank engines.  \r\n\r\nSee SPN 1209 for alternate resolution.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 138
    },
    "6385": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 6,
      "SPN": 6385,
      "SPN_Name": "Engine Starter Motor Relay Control",
      "SPN_Description": "Command signal used to energize or de-energize the engine starter motor relay.\r\n\r\n00 Off\r\n01 On\r\n10 Reserved for SAE assignment\r\n11 Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6386": {
      "PGN": 61496,
      "PGN_Name": "Engine Torque / Fuel Request",
      "PGN_Description": "ETFR",
      "first_bit": 0,
      "SPN": 6386,
      "SPN_Name": "Engine Gas Substitution Fuel Percentage Command",
      "SPN_Description": "Percentage of Gaseous fuel used, in terms of % mass of fuel. 0% means no Gaseous fuel used and 100 % means completely gaseous fuel is used.\r\n\r\nGas substitution is the process for a dual fuel engine system of substituting gas, e.g. natural gas, for some fraction of the primary combustion fuel, e.g. diesel fuel, in the engine combustion.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "6387": {
      "PGN": 61496,
      "PGN_Name": "Engine Torque / Fuel Request",
      "PGN_Description": "ETFR",
      "first_bit": 8,
      "SPN": 6387,
      "SPN_Name": "Engine Cylinder Gas Mass Flow Rate Command",
      "SPN_Description": "Commanded Mass Flow rate of gaseous fuel delivered to the engine normalized per cylinder.",
      "bit_length": 16,
      "scaling": 0.00006103515625,
      "offset": 0,
      "unit": "kg/s",
      "SLOT_ID": 369
    },
    "6388": {
      "PGN": 61496,
      "PGN_Name": "Engine Torque / Fuel Request",
      "PGN_Description": "ETFR",
      "first_bit": 24,
      "SPN": 6388,
      "SPN_Name": "Engine Cylinder Diesel Mass Flow Rate Command",
      "SPN_Description": "Commanded Mass Flow rate of diesel fuel delivered to the engine normalized per cylinder.",
      "bit_length": 16,
      "scaling": 0.00006103515625,
      "offset": 0,
      "unit": "kg/s",
      "SLOT_ID": 369
    },
    "6389": {
      "PGN": 61496,
      "PGN_Name": "Engine Torque / Fuel Request",
      "PGN_Description": "ETFR",
      "first_bit": 40,
      "SPN": 6389,
      "SPN_Name": "Engine Cylinder Torque",
      "SPN_Description": "Calculated engine torque output per cylinder.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Nm",
      "SLOT_ID": 70
    },
    "6390": {
      "PGN": 64661,
      "PGN_Name": "Engine Cylinder Pressure Monitor Status Information",
      "PGN_Description": "ECPMSI",
      "first_bit": 0,
      "SPN": 6390,
      "SPN_Name": "Engine Cylinder Pressure Monitor 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Engine Cylinder Pressure Monitor 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6391": {
      "PGN": 64661,
      "PGN_Name": "Engine Cylinder Pressure Monitor Status Information",
      "PGN_Description": "ECPMSI",
      "first_bit": 8,
      "SPN": 6391,
      "SPN_Name": "Engine Cylinder Pressure Monitor 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the Engine Cylinder Pressure Monitor 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6392": {
      "PGN": 61497,
      "PGN_Name": "Engine Air System Information",
      "PGN_Description": "EASI",
      "first_bit": 0,
      "SPN": 6392,
      "SPN_Name": "Engine Desired Air Fuel Ratio",
      "SPN_Description": "Reports the desired Air Fuel ratio for the engine.\r\n\r\nAir Fuel Ratio specifies the amount of air required to completely burn one unit of fuel in the engine to meet the required engine performance and emission standards.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 32
    },
    "6393": {
      "PGN": 61497,
      "PGN_Name": "Engine Air System Information",
      "PGN_Description": "EASI",
      "first_bit": 16,
      "SPN": 6393,
      "SPN_Name": "Engine Fuel System 1 Total Intake Mass Air Flow Rate",
      "SPN_Description": "Mass Flow rate of air entering the engine (or the first fuel system on a configuration with more than 1 fuel system). This also includes the amount of exhaust gas recirculated, if any.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "kg/s",
      "SLOT_ID": 372
    },
    "6394": {
      "PGN": 64895,
      "PGN_Name": "Engine Configuration 2",
      "PGN_Description": "EC2",
      "first_bit": 8,
      "SPN": 6394,
      "SPN_Name": "Number of Combustion Cycles for Averaging",
      "SPN_Description": "Defined number of combustion cycles used for calculating average parameters of combustion in each cylinder.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "6395": {
      "PGN": 64895,
      "PGN_Name": "Engine Configuration 2",
      "PGN_Description": "EC2",
      "first_bit": 16,
      "SPN": 6395,
      "SPN_Name": "Engine Configuration Identification",
      "SPN_Description": "Used to identify the hardware configuration of engine family. Each number will have a reference to set of parameters such as, but not limited to, number of cylinders, piston displacement, bore size and firing angles.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "ID",
      "SLOT_ID": 373
    },
    "6396": {
      "PGN": 61498,
      "PGN_Name": "Engine Cylinder 1 Combustion Information",
      "PGN_Description": "ECCI1",
      "first_bit": 0,
      "SPN": 6396,
      "SPN_Name": "Engine Cylinder 1 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in Engine cylinder 1. The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6397": {
      "PGN": 61498,
      "PGN_Name": "Engine Cylinder 1 Combustion Information",
      "PGN_Description": "ECCI1",
      "first_bit": 16,
      "SPN": 6397,
      "SPN_Name": "Engine Cylinder 1 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 1 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6398": {
      "PGN": 61498,
      "PGN_Name": "Engine Cylinder 1 Combustion Information",
      "PGN_Description": "ECCI1",
      "first_bit": 32,
      "SPN": 6398,
      "SPN_Name": "Engine Cylinder 1 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 1. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1352.  SPN 6398 is combined with other combustion information in PGN 61498, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6399": {
      "PGN": 61498,
      "PGN_Name": "Engine Cylinder 1 Combustion Information",
      "PGN_Description": "ECCI1",
      "first_bit": 40,
      "SPN": 6399,
      "SPN_Name": "Engine Cylinder 1 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 1 pressure sensor. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6400": {
      "PGN": 61499,
      "PGN_Name": "Engine Cylinder 2 Combustion Information",
      "PGN_Description": "ECCI2",
      "first_bit": 0,
      "SPN": 6400,
      "SPN_Name": "Engine Cylinder 2 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 2.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6401": {
      "PGN": 61499,
      "PGN_Name": "Engine Cylinder 2 Combustion Information",
      "PGN_Description": "ECCI2",
      "first_bit": 16,
      "SPN": 6401,
      "SPN_Name": "Engine Cylinder 2 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 2 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6402": {
      "PGN": 61499,
      "PGN_Name": "Engine Cylinder 2 Combustion Information",
      "PGN_Description": "ECCI2",
      "first_bit": 32,
      "SPN": 6402,
      "SPN_Name": "Engine Cylinder 2 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 2. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1353.  SPN 6402 is combined with other combustion information in PGN 61499, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6403": {
      "PGN": 61499,
      "PGN_Name": "Engine Cylinder 2 Combustion Information",
      "PGN_Description": "ECCI2",
      "first_bit": 40,
      "SPN": 6403,
      "SPN_Name": "Engine Cylinder 2 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 2 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6404": {
      "PGN": 61500,
      "PGN_Name": "Engine Cylinder 3 Combustion Information",
      "PGN_Description": "ECCI3",
      "first_bit": 0,
      "SPN": 6404,
      "SPN_Name": "Engine Cylinder 3 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 3.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6405": {
      "PGN": 61500,
      "PGN_Name": "Engine Cylinder 3 Combustion Information",
      "PGN_Description": "ECCI3",
      "first_bit": 16,
      "SPN": 6405,
      "SPN_Name": "Engine Cylinder 3 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 3 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6406": {
      "PGN": 61500,
      "PGN_Name": "Engine Cylinder 3 Combustion Information",
      "PGN_Description": "ECCI3",
      "first_bit": 32,
      "SPN": 6406,
      "SPN_Name": "Engine Cylinder 3 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 3. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1354.  SPN 6406 is combined with other combustion information in PGN 61500, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6407": {
      "PGN": 61500,
      "PGN_Name": "Engine Cylinder 3 Combustion Information",
      "PGN_Description": "ECCI3",
      "first_bit": 40,
      "SPN": 6407,
      "SPN_Name": "Engine Cylinder 3 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 3 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6408": {
      "PGN": 61501,
      "PGN_Name": "Engine Cylinder 4 Combustion Information",
      "PGN_Description": "ECCI4",
      "first_bit": 0,
      "SPN": 6408,
      "SPN_Name": "Engine Cylinder 4 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 4.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6409": {
      "PGN": 61501,
      "PGN_Name": "Engine Cylinder 4 Combustion Information",
      "PGN_Description": "ECCI4",
      "first_bit": 16,
      "SPN": 6409,
      "SPN_Name": "Engine Cylinder 4 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 4 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6410": {
      "PGN": 61501,
      "PGN_Name": "Engine Cylinder 4 Combustion Information",
      "PGN_Description": "ECCI4",
      "first_bit": 32,
      "SPN": 6410,
      "SPN_Name": "Engine Cylinder 4 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 4. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1355.  SPN 6410 is combined with other combustion information in PGN 61501, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6411": {
      "PGN": 61501,
      "PGN_Name": "Engine Cylinder 4 Combustion Information",
      "PGN_Description": "ECCI4",
      "first_bit": 40,
      "SPN": 6411,
      "SPN_Name": "Engine Cylinder 4 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 4 pressure sensor. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6412": {
      "PGN": 61502,
      "PGN_Name": "Engine Cylinder 5 Combustion Information",
      "PGN_Description": "ECCI5",
      "first_bit": 0,
      "SPN": 6412,
      "SPN_Name": "Engine Cylinder 5 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 5.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6413": {
      "PGN": 61502,
      "PGN_Name": "Engine Cylinder 5 Combustion Information",
      "PGN_Description": "ECCI5",
      "first_bit": 16,
      "SPN": 6413,
      "SPN_Name": "Engine Cylinder 5 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 5 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6414": {
      "PGN": 61502,
      "PGN_Name": "Engine Cylinder 5 Combustion Information",
      "PGN_Description": "ECCI5",
      "first_bit": 32,
      "SPN": 6414,
      "SPN_Name": "Engine Cylinder 5 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 6. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1356.  SPN 6414 is combined with other combustion information in PGN 61502, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6415": {
      "PGN": 61502,
      "PGN_Name": "Engine Cylinder 5 Combustion Information",
      "PGN_Description": "ECCI5",
      "first_bit": 40,
      "SPN": 6415,
      "SPN_Name": "Engine Cylinder 5 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 5 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6416": {
      "PGN": 61503,
      "PGN_Name": "Engine Cylinder 6 Combustion Information",
      "PGN_Description": "ECCI6",
      "first_bit": 0,
      "SPN": 6416,
      "SPN_Name": "Engine Cylinder 6 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 6.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6417": {
      "PGN": 61503,
      "PGN_Name": "Engine Cylinder 6 Combustion Information",
      "PGN_Description": "ECCI6",
      "first_bit": 16,
      "SPN": 6417,
      "SPN_Name": "Engine Cylinder 6 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 6 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6418": {
      "PGN": 61503,
      "PGN_Name": "Engine Cylinder 6 Combustion Information",
      "PGN_Description": "ECCI6",
      "first_bit": 32,
      "SPN": 6418,
      "SPN_Name": "Engine Cylinder 6 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 6. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1357.  SPN 6418 is combined with other combustion information in PGN 61503, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6419": {
      "PGN": 61503,
      "PGN_Name": "Engine Cylinder 6 Combustion Information",
      "PGN_Description": "ECCI6",
      "first_bit": 40,
      "SPN": 6419,
      "SPN_Name": "Engine Cylinder 6 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 6 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6420": {
      "PGN": 61504,
      "PGN_Name": "Engine Cylinder 7 Combustion Information",
      "PGN_Description": "ECCI7",
      "first_bit": 0,
      "SPN": 6420,
      "SPN_Name": "Engine Cylinder 7 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 7.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6421": {
      "PGN": 61504,
      "PGN_Name": "Engine Cylinder 7 Combustion Information",
      "PGN_Description": "ECCI7",
      "first_bit": 16,
      "SPN": 6421,
      "SPN_Name": "Engine Cylinder 7 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 7 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6422": {
      "PGN": 61504,
      "PGN_Name": "Engine Cylinder 7 Combustion Information",
      "PGN_Description": "ECCI7",
      "first_bit": 32,
      "SPN": 6422,
      "SPN_Name": "Engine Cylinder 7 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 7. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1358.  SPN 6422 is combined with other combustion information in PGN 61504, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6423": {
      "PGN": 61504,
      "PGN_Name": "Engine Cylinder 7 Combustion Information",
      "PGN_Description": "ECCI7",
      "first_bit": 40,
      "SPN": 6423,
      "SPN_Name": "Engine Cylinder 7 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 7 pressure sensor. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6424": {
      "PGN": 61505,
      "PGN_Name": "Engine Cylinder 8 Combustion Information",
      "PGN_Description": "ECCI8",
      "first_bit": 0,
      "SPN": 6424,
      "SPN_Name": "Engine Cylinder 8 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 8.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6425": {
      "PGN": 61505,
      "PGN_Name": "Engine Cylinder 8 Combustion Information",
      "PGN_Description": "ECCI8",
      "first_bit": 16,
      "SPN": 6425,
      "SPN_Name": "Engine Cylinder 8 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 8 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6426": {
      "PGN": 61505,
      "PGN_Name": "Engine Cylinder 8 Combustion Information",
      "PGN_Description": "ECCI8",
      "first_bit": 32,
      "SPN": 6426,
      "SPN_Name": "Engine Cylinder 8 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 8. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1359.  SPN 6426 is combined with other combustion information in PGN 61505, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6427": {
      "PGN": 61505,
      "PGN_Name": "Engine Cylinder 8 Combustion Information",
      "PGN_Description": "ECCI8",
      "first_bit": 40,
      "SPN": 6427,
      "SPN_Name": "Engine Cylinder 8 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 8 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6428": {
      "PGN": 61506,
      "PGN_Name": "Engine Cylinder 9 Combustion Information",
      "PGN_Description": "ECCI9",
      "first_bit": 0,
      "SPN": 6428,
      "SPN_Name": "Engine Cylinder 9 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 9.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6429": {
      "PGN": 61506,
      "PGN_Name": "Engine Cylinder 9 Combustion Information",
      "PGN_Description": "ECCI9",
      "first_bit": 16,
      "SPN": 6429,
      "SPN_Name": "Engine Cylinder 9 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 9 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6430": {
      "PGN": 61506,
      "PGN_Name": "Engine Cylinder 9 Combustion Information",
      "PGN_Description": "ECCI9",
      "first_bit": 32,
      "SPN": 6430,
      "SPN_Name": "Engine Cylinder 9 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 9. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1360.  SPN 6430 is combined with other combustion information in PGN 61506, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6431": {
      "PGN": 61506,
      "PGN_Name": "Engine Cylinder 9 Combustion Information",
      "PGN_Description": "ECCI9",
      "first_bit": 40,
      "SPN": 6431,
      "SPN_Name": "Engine Cylinder 9 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 9 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6432": {
      "PGN": 61507,
      "PGN_Name": "Engine Cylinder 10 Combustion Information",
      "PGN_Description": "ECCI10",
      "first_bit": 0,
      "SPN": 6432,
      "SPN_Name": "Engine Cylinder 10 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 10.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6433": {
      "PGN": 61507,
      "PGN_Name": "Engine Cylinder 10 Combustion Information",
      "PGN_Description": "ECCI10",
      "first_bit": 16,
      "SPN": 6433,
      "SPN_Name": "Engine Cylinder 10 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 10 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6434": {
      "PGN": 61507,
      "PGN_Name": "Engine Cylinder 10 Combustion Information",
      "PGN_Description": "ECCI10",
      "first_bit": 32,
      "SPN": 6434,
      "SPN_Name": "Engine Cylinder 10 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 10. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1361.  SPN 6434 is combined with other combustion information in PGN 61507, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6435": {
      "PGN": 61507,
      "PGN_Name": "Engine Cylinder 10 Combustion Information",
      "PGN_Description": "ECCI10",
      "first_bit": 40,
      "SPN": 6435,
      "SPN_Name": "Engine Cylinder 10 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 10 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6436": {
      "PGN": 61508,
      "PGN_Name": "Engine Cylinder 11 Combustion Information",
      "PGN_Description": "ECCI11",
      "first_bit": 0,
      "SPN": 6436,
      "SPN_Name": "Engine Cylinder 11 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 11.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6437": {
      "PGN": 61508,
      "PGN_Name": "Engine Cylinder 11 Combustion Information",
      "PGN_Description": "ECCI11",
      "first_bit": 16,
      "SPN": 6437,
      "SPN_Name": "Engine Cylinder 11 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 11 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6438": {
      "PGN": 61508,
      "PGN_Name": "Engine Cylinder 11 Combustion Information",
      "PGN_Description": "ECCI11",
      "first_bit": 32,
      "SPN": 6438,
      "SPN_Name": "Engine Cylinder 11 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 11. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1362.  SPN 6438 is combined with other combustion information in PGN 61508, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6439": {
      "PGN": 61508,
      "PGN_Name": "Engine Cylinder 11 Combustion Information",
      "PGN_Description": "ECCI11",
      "first_bit": 40,
      "SPN": 6439,
      "SPN_Name": "Engine Cylinder 11 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 11 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6440": {
      "PGN": 61509,
      "PGN_Name": "Engine Cylinder 12 Combustion Information",
      "PGN_Description": "ECCI12",
      "first_bit": 0,
      "SPN": 6440,
      "SPN_Name": "Engine Cylinder 12 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 12.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6441": {
      "PGN": 61509,
      "PGN_Name": "Engine Cylinder 12 Combustion Information",
      "PGN_Description": "ECCI12",
      "first_bit": 16,
      "SPN": 6441,
      "SPN_Name": "Engine Cylinder 12 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 12 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6442": {
      "PGN": 61509,
      "PGN_Name": "Engine Cylinder 12 Combustion Information",
      "PGN_Description": "ECCI12",
      "first_bit": 32,
      "SPN": 6442,
      "SPN_Name": "Engine Cylinder 12 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 12. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1363.  SPN 6442 is combined with other combustion information in PGN 61509, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6443": {
      "PGN": 61509,
      "PGN_Name": "Engine Cylinder 12 Combustion Information",
      "PGN_Description": "ECCI12",
      "first_bit": 40,
      "SPN": 6443,
      "SPN_Name": "Engine Cylinder 12 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 12 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6444": {
      "PGN": 61510,
      "PGN_Name": "Engine Cylinder 13 Combustion Information",
      "PGN_Description": "ECCI13",
      "first_bit": 0,
      "SPN": 6444,
      "SPN_Name": "Engine Cylinder 13 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 13.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6445": {
      "PGN": 61510,
      "PGN_Name": "Engine Cylinder 13 Combustion Information",
      "PGN_Description": "ECCI13",
      "first_bit": 16,
      "SPN": 6445,
      "SPN_Name": "Engine Cylinder 13 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 13 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6446": {
      "PGN": 61510,
      "PGN_Name": "Engine Cylinder 13 Combustion Information",
      "PGN_Description": "ECCI13",
      "first_bit": 32,
      "SPN": 6446,
      "SPN_Name": "Engine Cylinder 13 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 13. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1364.  SPN 6446 is combined with other combustion information in PGN 61510, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6447": {
      "PGN": 61510,
      "PGN_Name": "Engine Cylinder 13 Combustion Information",
      "PGN_Description": "ECCI13",
      "first_bit": 40,
      "SPN": 6447,
      "SPN_Name": "Engine Cylinder 13 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 13 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6448": {
      "PGN": 61511,
      "PGN_Name": "Engine Cylinder 14 Combustion Information",
      "PGN_Description": "ECCI14",
      "first_bit": 0,
      "SPN": 6448,
      "SPN_Name": "Engine Cylinder 14 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 14.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6449": {
      "PGN": 61511,
      "PGN_Name": "Engine Cylinder 14 Combustion Information",
      "PGN_Description": "ECCI14",
      "first_bit": 16,
      "SPN": 6449,
      "SPN_Name": "Engine Cylinder 14 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 14 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6450": {
      "PGN": 61511,
      "PGN_Name": "Engine Cylinder 14 Combustion Information",
      "PGN_Description": "ECCI14",
      "first_bit": 32,
      "SPN": 6450,
      "SPN_Name": "Engine Cylinder 14 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 14. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1365.  SPN 6450 is combined with other combustion information in PGN 61511, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6451": {
      "PGN": 61511,
      "PGN_Name": "Engine Cylinder 14 Combustion Information",
      "PGN_Description": "ECCI14",
      "first_bit": 40,
      "SPN": 6451,
      "SPN_Name": "Engine Cylinder 14 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 14 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6452": {
      "PGN": 61512,
      "PGN_Name": "Engine Cylinder 15 Combustion Information",
      "PGN_Description": "ECCI15",
      "first_bit": 0,
      "SPN": 6452,
      "SPN_Name": "Engine Cylinder 15 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 15.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6453": {
      "PGN": 61512,
      "PGN_Name": "Engine Cylinder 15 Combustion Information",
      "PGN_Description": "ECCI15",
      "first_bit": 16,
      "SPN": 6453,
      "SPN_Name": "Engine Cylinder 15 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 15 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6454": {
      "PGN": 61512,
      "PGN_Name": "Engine Cylinder 15 Combustion Information",
      "PGN_Description": "ECCI15",
      "first_bit": 32,
      "SPN": 6454,
      "SPN_Name": "Engine Cylinder 15 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 15. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1366.  SPN 6454 is combined with other combustion information in PGN 61512, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6455": {
      "PGN": 61512,
      "PGN_Name": "Engine Cylinder 15 Combustion Information",
      "PGN_Description": "ECCI15",
      "first_bit": 40,
      "SPN": 6455,
      "SPN_Name": "Engine Cylinder 15 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 15 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6456": {
      "PGN": 61513,
      "PGN_Name": "Engine Cylinder 16 Combustion Information",
      "PGN_Description": "ECCI16",
      "first_bit": 0,
      "SPN": 6456,
      "SPN_Name": "Engine Cylinder 16 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 16.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6457": {
      "PGN": 61513,
      "PGN_Name": "Engine Cylinder 16 Combustion Information",
      "PGN_Description": "ECCI16",
      "first_bit": 16,
      "SPN": 6457,
      "SPN_Name": "Engine Cylinder 16 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 16 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6458": {
      "PGN": 61513,
      "PGN_Name": "Engine Cylinder 16 Combustion Information",
      "PGN_Description": "ECCI16",
      "first_bit": 32,
      "SPN": 6458,
      "SPN_Name": "Engine Cylinder 16 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 16. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1367.  SPN 6458 is combined with other combustion information in PGN 61513, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6459": {
      "PGN": 61513,
      "PGN_Name": "Engine Cylinder 16 Combustion Information",
      "PGN_Description": "ECCI16",
      "first_bit": 40,
      "SPN": 6459,
      "SPN_Name": "Engine Cylinder 16 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 16 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6460": {
      "PGN": 61514,
      "PGN_Name": "Engine Cylinder 17 Combustion Information",
      "PGN_Description": "ECCI17",
      "first_bit": 0,
      "SPN": 6460,
      "SPN_Name": "Engine Cylinder 17 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 17.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6461": {
      "PGN": 61514,
      "PGN_Name": "Engine Cylinder 17 Combustion Information",
      "PGN_Description": "ECCI17",
      "first_bit": 16,
      "SPN": 6461,
      "SPN_Name": "Engine Cylinder 17 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 17 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6462": {
      "PGN": 61514,
      "PGN_Name": "Engine Cylinder 17 Combustion Information",
      "PGN_Description": "ECCI17",
      "first_bit": 32,
      "SPN": 6462,
      "SPN_Name": "Engine Cylinder 17 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 17. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1368.  SPN 6462 is combined with other combustion information in PGN 61514, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6463": {
      "PGN": 61514,
      "PGN_Name": "Engine Cylinder 17 Combustion Information",
      "PGN_Description": "ECCI17",
      "first_bit": 40,
      "SPN": 6463,
      "SPN_Name": "Engine Cylinder 17 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 17 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6464": {
      "PGN": 61515,
      "PGN_Name": "Engine Cylinder 18 Combustion Information",
      "PGN_Description": "ECCI18",
      "first_bit": 0,
      "SPN": 6464,
      "SPN_Name": "Engine Cylinder 18 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 18.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6465": {
      "PGN": 61515,
      "PGN_Name": "Engine Cylinder 18 Combustion Information",
      "PGN_Description": "ECCI18",
      "first_bit": 16,
      "SPN": 6465,
      "SPN_Name": "Engine Cylinder 18 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 18 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6466": {
      "PGN": 61515,
      "PGN_Name": "Engine Cylinder 18 Combustion Information",
      "PGN_Description": "ECCI18",
      "first_bit": 32,
      "SPN": 6466,
      "SPN_Name": "Engine Cylinder 18 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 18. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1369.  SPN 6466 is combined with other combustion information in PGN 61515, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6467": {
      "PGN": 61515,
      "PGN_Name": "Engine Cylinder 18 Combustion Information",
      "PGN_Description": "ECCI18",
      "first_bit": 40,
      "SPN": 6467,
      "SPN_Name": "Engine Cylinder 18 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 18 pressure sensor. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6468": {
      "PGN": 61516,
      "PGN_Name": "Engine Cylinder 19 Combustion Information",
      "PGN_Description": "ECCI19",
      "first_bit": 0,
      "SPN": 6468,
      "SPN_Name": "Engine Cylinder 19 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 19.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6469": {
      "PGN": 61516,
      "PGN_Name": "Engine Cylinder 19 Combustion Information",
      "PGN_Description": "ECCI19",
      "first_bit": 16,
      "SPN": 6469,
      "SPN_Name": "Engine Cylinder 19 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 19 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6470": {
      "PGN": 61516,
      "PGN_Name": "Engine Cylinder 19 Combustion Information",
      "PGN_Description": "ECCI19",
      "first_bit": 32,
      "SPN": 6470,
      "SPN_Name": "Engine Cylinder 19 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 19. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1370.  SPN 6470 is combined with other combustion information in PGN 61516, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6471": {
      "PGN": 61516,
      "PGN_Name": "Engine Cylinder 19 Combustion Information",
      "PGN_Description": "ECCI19",
      "first_bit": 40,
      "SPN": 6471,
      "SPN_Name": "Engine Cylinder 19 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 19 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6472": {
      "PGN": 61517,
      "PGN_Name": "Engine Cylinder 20 Combustion Information",
      "PGN_Description": "ECCI20",
      "first_bit": 0,
      "SPN": 6472,
      "SPN_Name": "Engine Cylinder 20 Heat Release",
      "SPN_Description": "The amount of heat produced during combustion in engine cylinder 20.  The negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "kJ/l",
      "SLOT_ID": 366
    },
    "6473": {
      "PGN": 61517,
      "PGN_Name": "Engine Cylinder 20 Combustion Information",
      "PGN_Description": "ECCI20",
      "first_bit": 16,
      "SPN": 6473,
      "SPN_Name": "Engine Cylinder 20 Peak Pressure",
      "SPN_Description": "Peak pressure in engine cylinder 20 in combustion cycle.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 367
    },
    "6474": {
      "PGN": 61517,
      "PGN_Name": "Engine Cylinder 20 Combustion Information",
      "PGN_Description": "ECCI20",
      "first_bit": 32,
      "SPN": 6474,
      "SPN_Name": "Engine Cylinder 20 Synchronous Knock Level",
      "SPN_Description": "Used to indicate the level of knock for engine cylinder 20. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\r\n\r\nSimilar to SPN 1371.  SPN 6474 is combined with other combustion information in PGN 61517, so that the message is combustion synchronous.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6475": {
      "PGN": 61517,
      "PGN_Name": "Engine Cylinder 20 Combustion Information",
      "PGN_Description": "ECCI20",
      "first_bit": 40,
      "SPN": 6475,
      "SPN_Name": "Engine Cylinder 20 Pressure Sensor Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the engine cylinder 20 pressure sensor.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "6476": {
      "PGN": 64660,
      "PGN_Name": "Aftertreatment System Abuse Information",
      "PGN_Description": "ASAI",
      "first_bit": 0,
      "SPN": 6476,
      "SPN_Name": "Aftertreatment Diesel Exhaust Fluid Doser Cooldown Interrupt Count",
      "SPN_Description": "Non-volatile record of the number of interrupted cooldown routines since the last clear event.  The counter shall be reset by PGN 56832 request.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "6477": {
      "PGN": 64660,
      "PGN_Name": "Aftertreatment System Abuse Information",
      "PGN_Description": "ASAI",
      "first_bit": 16,
      "SPN": 6477,
      "SPN_Name": "Aftertreatment Diesel Exhaust Fluid Doser Purge Interrupt Count",
      "SPN_Description": "Non-volatile record of the number of interrupted purge routines since the last clear event.  The counter shall be reset by PGN 56832 request.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "6478": {
      "PGN": 64660,
      "PGN_Name": "Aftertreatment System Abuse Information",
      "PGN_Description": "ASAI",
      "first_bit": 32,
      "SPN": 6478,
      "SPN_Name": "Aftertreatment Diesel Exhaust Fluid Doser Cooldown Complete This Cycle",
      "SPN_Description": "Indication of cooldown routine completion in the current power cycle.\r\n\r\n\"Complete This Cycle\" parameters are used to indicate to the engine controller that is powering the aftertreatment controller via relay that it is ok to remove power. \r\n\r\n00 - Not complete\r\n01 - Complete\r\n10 - Error\r\n11 - Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6479": {
      "PGN": 64660,
      "PGN_Name": "Aftertreatment System Abuse Information",
      "PGN_Description": "ASAI",
      "first_bit": 34,
      "SPN": 6479,
      "SPN_Name": "Aftertreatment Diesel Exhaust Fluid Doser Cooldown Complete Last Cycle",
      "SPN_Description": "Indication of cooldown routine completion in the previous power cycle.\r\n\r\n00 - Not complete\r\n01 - Complete\r\n10 - Error\r\n11 - Not Supported\r\n\r\nNote:  One purpose for tracking the status of the Diesel Exhaust Fluid doser purge on the previous cycle is related to diagnostics.  For instance, if the Diesel Exhaust Fluid dosing system determines thaw was unsuccessful or took\r\nlonger than expected and the purge was interrupted on the previous cycle, this may be the suspected root cause.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6480": {
      "PGN": 64660,
      "PGN_Name": "Aftertreatment System Abuse Information",
      "PGN_Description": "ASAI",
      "first_bit": 40,
      "SPN": 6480,
      "SPN_Name": "Aftertreatment Diesel Exhaust Fluid Doser Purge Complete This Cycle",
      "SPN_Description": "Indication of purge routine completion in the current power cycle.\r\n\r\n\"Complete This Cycle\" parameters are used to indicate to the engine controller that is powering the aftertreatment controller via relay that it is ok to remove power. \r\n\r\n00 - Not complete\r\n01 - Complete\r\n10 - Error\r\n11 - Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6481": {
      "PGN": 64660,
      "PGN_Name": "Aftertreatment System Abuse Information",
      "PGN_Description": "ASAI",
      "first_bit": 42,
      "SPN": 6481,
      "SPN_Name": "Aftertreatment Diesel Exhaust Fluid Doser Purge Complete Last Cycle",
      "SPN_Description": "Indication of purge routine completion in the previous power cycle\r\n\r\n00 - Not complete\r\n01 - Complete\r\n10 - Error\r\n11 - Not Supported\r\n\r\nNote:  One purpose for tracking the status of the Diesel Exhaust Fluid doser purge on the previous cycle is related to diagnostics.  For instance, if the Diesel Exhaust Fluid dosing system determines thaw was unsuccessful or took\r\nlonger than expected and the purge was interrupted on the previous cycle, this may be the suspected root cause.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6482": {
      "PGN": 64660,
      "PGN_Name": "Aftertreatment System Abuse Information",
      "PGN_Description": "ASAI",
      "first_bit": 48,
      "SPN": 6482,
      "SPN_Name": "After-run Complete This Cycle",
      "SPN_Description": "Indication of after-run routine completion in the current power cycle.\r\n\r\n\"Complete This Cycle\" parameters are used to indicate to the engine controller that is powering the aftertreatment controller via relay that it is ok to remove power. \r\n\r\n00 - Not complete\r\n01 - Complete\r\n10 - Error\r\n11 - Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6483": {
      "PGN": 61518,
      "PGN_Name": "Engine Cylinder 1 Combustion Average Information",
      "PGN_Description": "ECCAI1",
      "first_bit": 0,
      "SPN": 6483,
      "SPN_Name": "Engine Cylinder 1 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 1.   Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6484": {
      "PGN": 61518,
      "PGN_Name": "Engine Cylinder 1 Combustion Average Information",
      "PGN_Description": "ECCAI1",
      "first_bit": 16,
      "SPN": 6484,
      "SPN_Name": "Engine Cylinder 1 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 1 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6485": {
      "PGN": 61518,
      "PGN_Name": "Engine Cylinder 1 Combustion Average Information",
      "PGN_Description": "ECCAI1",
      "first_bit": 32,
      "SPN": 6485,
      "SPN_Name": "Engine Cylinder 1 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 1 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6486": {
      "PGN": 61518,
      "PGN_Name": "Engine Cylinder 1 Combustion Average Information",
      "PGN_Description": "ECCAI1",
      "first_bit": 48,
      "SPN": 6486,
      "SPN_Name": "Engine Cylinder 1 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 1 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6487": {
      "PGN": 61519,
      "PGN_Name": "Engine Cylinder 2 Combustion Average Information",
      "PGN_Description": "ECCAI2",
      "first_bit": 0,
      "SPN": 6487,
      "SPN_Name": "Engine Cylinder 2 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 2.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6488": {
      "PGN": 61519,
      "PGN_Name": "Engine Cylinder 2 Combustion Average Information",
      "PGN_Description": "ECCAI2",
      "first_bit": 16,
      "SPN": 6488,
      "SPN_Name": "Engine Cylinder 2 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 2 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6489": {
      "PGN": 61519,
      "PGN_Name": "Engine Cylinder 2 Combustion Average Information",
      "PGN_Description": "ECCAI2",
      "first_bit": 32,
      "SPN": 6489,
      "SPN_Name": "Engine Cylinder 2 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 2 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6490": {
      "PGN": 61519,
      "PGN_Name": "Engine Cylinder 2 Combustion Average Information",
      "PGN_Description": "ECCAI2",
      "first_bit": 48,
      "SPN": 6490,
      "SPN_Name": "Engine Cylinder 2 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 2 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6491": {
      "PGN": 61520,
      "PGN_Name": "Engine Cylinder 3 Combustion Average Information",
      "PGN_Description": "ECCAI3",
      "first_bit": 0,
      "SPN": 6491,
      "SPN_Name": "Engine Cylinder 3 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 3.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6492": {
      "PGN": 61520,
      "PGN_Name": "Engine Cylinder 3 Combustion Average Information",
      "PGN_Description": "ECCAI3",
      "first_bit": 16,
      "SPN": 6492,
      "SPN_Name": "Engine Cylinder 3 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 3 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6493": {
      "PGN": 61520,
      "PGN_Name": "Engine Cylinder 3 Combustion Average Information",
      "PGN_Description": "ECCAI3",
      "first_bit": 32,
      "SPN": 6493,
      "SPN_Name": "Engine Cylinder 3 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 3 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6494": {
      "PGN": 61520,
      "PGN_Name": "Engine Cylinder 3 Combustion Average Information",
      "PGN_Description": "ECCAI3",
      "first_bit": 48,
      "SPN": 6494,
      "SPN_Name": "Engine Cylinder 3 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 3 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6495": {
      "PGN": 61521,
      "PGN_Name": "Engine Cylinder 4 Combustion Average Information",
      "PGN_Description": "ECCAI4",
      "first_bit": 0,
      "SPN": 6495,
      "SPN_Name": "Engine Cylinder 4 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 4.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6496": {
      "PGN": 61521,
      "PGN_Name": "Engine Cylinder 4 Combustion Average Information",
      "PGN_Description": "ECCAI4",
      "first_bit": 16,
      "SPN": 6496,
      "SPN_Name": "Engine Cylinder 4 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 4 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6497": {
      "PGN": 61521,
      "PGN_Name": "Engine Cylinder 4 Combustion Average Information",
      "PGN_Description": "ECCAI4",
      "first_bit": 32,
      "SPN": 6497,
      "SPN_Name": "Engine Cylinder 4 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 4 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6498": {
      "PGN": 61521,
      "PGN_Name": "Engine Cylinder 4 Combustion Average Information",
      "PGN_Description": "ECCAI4",
      "first_bit": 48,
      "SPN": 6498,
      "SPN_Name": "Engine Cylinder 4 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 4 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6499": {
      "PGN": 61522,
      "PGN_Name": "Engine Cylinder 5 Combustion Average Information",
      "PGN_Description": "ECCAI5",
      "first_bit": 0,
      "SPN": 6499,
      "SPN_Name": "Engine Cylinder 5 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 5.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6500": {
      "PGN": 61522,
      "PGN_Name": "Engine Cylinder 5 Combustion Average Information",
      "PGN_Description": "ECCAI5",
      "first_bit": 16,
      "SPN": 6500,
      "SPN_Name": "Engine Cylinder 5 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 5 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6501": {
      "PGN": 61522,
      "PGN_Name": "Engine Cylinder 5 Combustion Average Information",
      "PGN_Description": "ECCAI5",
      "first_bit": 32,
      "SPN": 6501,
      "SPN_Name": "Engine Cylinder 5 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 5 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6502": {
      "PGN": 61522,
      "PGN_Name": "Engine Cylinder 5 Combustion Average Information",
      "PGN_Description": "ECCAI5",
      "first_bit": 48,
      "SPN": 6502,
      "SPN_Name": "Engine Cylinder 5 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 5 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6503": {
      "PGN": 61523,
      "PGN_Name": "Engine Cylinder 6 Combustion Average Information",
      "PGN_Description": "ECCAI6",
      "first_bit": 0,
      "SPN": 6503,
      "SPN_Name": "Engine Cylinder 6 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 6.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6504": {
      "PGN": 61523,
      "PGN_Name": "Engine Cylinder 6 Combustion Average Information",
      "PGN_Description": "ECCAI6",
      "first_bit": 16,
      "SPN": 6504,
      "SPN_Name": "Engine Cylinder 6 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 6 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6505": {
      "PGN": 61523,
      "PGN_Name": "Engine Cylinder 6 Combustion Average Information",
      "PGN_Description": "ECCAI6",
      "first_bit": 32,
      "SPN": 6505,
      "SPN_Name": "Engine Cylinder 6 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 6 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6506": {
      "PGN": 61523,
      "PGN_Name": "Engine Cylinder 6 Combustion Average Information",
      "PGN_Description": "ECCAI6",
      "first_bit": 48,
      "SPN": 6506,
      "SPN_Name": "Engine Cylinder 6 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 6 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6507": {
      "PGN": 61524,
      "PGN_Name": "Engine Cylinder 7 Combustion Average Information",
      "PGN_Description": "ECCAI7",
      "first_bit": 0,
      "SPN": 6507,
      "SPN_Name": "Engine Cylinder 7 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 7.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6508": {
      "PGN": 61524,
      "PGN_Name": "Engine Cylinder 7 Combustion Average Information",
      "PGN_Description": "ECCAI7",
      "first_bit": 16,
      "SPN": 6508,
      "SPN_Name": "Engine Cylinder 7 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 7 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6509": {
      "PGN": 61524,
      "PGN_Name": "Engine Cylinder 7 Combustion Average Information",
      "PGN_Description": "ECCAI7",
      "first_bit": 32,
      "SPN": 6509,
      "SPN_Name": "Engine Cylinder 7 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 7 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6510": {
      "PGN": 61524,
      "PGN_Name": "Engine Cylinder 7 Combustion Average Information",
      "PGN_Description": "ECCAI7",
      "first_bit": 48,
      "SPN": 6510,
      "SPN_Name": "Engine Cylinder 7 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 7 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6511": {
      "PGN": 61525,
      "PGN_Name": "Engine Cylinder 8 Combustion Average Information",
      "PGN_Description": "ECCAI8",
      "first_bit": 0,
      "SPN": 6511,
      "SPN_Name": "Engine Cylinder 8 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 8.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6512": {
      "PGN": 61525,
      "PGN_Name": "Engine Cylinder 8 Combustion Average Information",
      "PGN_Description": "ECCAI8",
      "first_bit": 16,
      "SPN": 6512,
      "SPN_Name": "Engine Cylinder 8 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 8 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6513": {
      "PGN": 61525,
      "PGN_Name": "Engine Cylinder 8 Combustion Average Information",
      "PGN_Description": "ECCAI8",
      "first_bit": 32,
      "SPN": 6513,
      "SPN_Name": "Engine Cylinder 8 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 8 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6514": {
      "PGN": 61525,
      "PGN_Name": "Engine Cylinder 8 Combustion Average Information",
      "PGN_Description": "ECCAI8",
      "first_bit": 48,
      "SPN": 6514,
      "SPN_Name": "Engine Cylinder 8 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 8 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6515": {
      "PGN": 61526,
      "PGN_Name": "Engine Cylinder 9 Combustion Average Information",
      "PGN_Description": "ECCAI9",
      "first_bit": 0,
      "SPN": 6515,
      "SPN_Name": "Engine Cylinder 9 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 9.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6516": {
      "PGN": 61526,
      "PGN_Name": "Engine Cylinder 9 Combustion Average Information",
      "PGN_Description": "ECCAI9",
      "first_bit": 16,
      "SPN": 6516,
      "SPN_Name": "Engine Cylinder 9 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 9 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6517": {
      "PGN": 61526,
      "PGN_Name": "Engine Cylinder 9 Combustion Average Information",
      "PGN_Description": "ECCAI9",
      "first_bit": 32,
      "SPN": 6517,
      "SPN_Name": "Engine Cylinder 9 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 9 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6518": {
      "PGN": 61526,
      "PGN_Name": "Engine Cylinder 9 Combustion Average Information",
      "PGN_Description": "ECCAI9",
      "first_bit": 48,
      "SPN": 6518,
      "SPN_Name": "Engine Cylinder 9 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 9 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6519": {
      "PGN": 61527,
      "PGN_Name": "Engine Cylinder 10 Combustion Average Information",
      "PGN_Description": "ECCAI10",
      "first_bit": 0,
      "SPN": 6519,
      "SPN_Name": "Engine Cylinder 10 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 10.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6520": {
      "PGN": 61527,
      "PGN_Name": "Engine Cylinder 10 Combustion Average Information",
      "PGN_Description": "ECCAI10",
      "first_bit": 16,
      "SPN": 6520,
      "SPN_Name": "Engine Cylinder 10 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 10 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6521": {
      "PGN": 61527,
      "PGN_Name": "Engine Cylinder 10 Combustion Average Information",
      "PGN_Description": "ECCAI10",
      "first_bit": 32,
      "SPN": 6521,
      "SPN_Name": "Engine Cylinder 10 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 10 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6522": {
      "PGN": 61527,
      "PGN_Name": "Engine Cylinder 10 Combustion Average Information",
      "PGN_Description": "ECCAI10",
      "first_bit": 48,
      "SPN": 6522,
      "SPN_Name": "Engine Cylinder 10 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 10 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6523": {
      "PGN": 61528,
      "PGN_Name": "Engine Cylinder 11 Combustion Average Information",
      "PGN_Description": "ECCAI11",
      "first_bit": 0,
      "SPN": 6523,
      "SPN_Name": "Engine Cylinder 11 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 11.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6524": {
      "PGN": 61528,
      "PGN_Name": "Engine Cylinder 11 Combustion Average Information",
      "PGN_Description": "ECCAI11",
      "first_bit": 16,
      "SPN": 6524,
      "SPN_Name": "Engine Cylinder 11 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 11 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6525": {
      "PGN": 61528,
      "PGN_Name": "Engine Cylinder 11 Combustion Average Information",
      "PGN_Description": "ECCAI11",
      "first_bit": 32,
      "SPN": 6525,
      "SPN_Name": "Engine Cylinder 11 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 11 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6526": {
      "PGN": 61528,
      "PGN_Name": "Engine Cylinder 11 Combustion Average Information",
      "PGN_Description": "ECCAI11",
      "first_bit": 48,
      "SPN": 6526,
      "SPN_Name": "Engine Cylinder 11 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 11 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6527": {
      "PGN": 61529,
      "PGN_Name": "Engine Cylinder 12 Combustion Average Information",
      "PGN_Description": "ECCAI12",
      "first_bit": 0,
      "SPN": 6527,
      "SPN_Name": "Engine Cylinder 12 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 12.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6528": {
      "PGN": 61529,
      "PGN_Name": "Engine Cylinder 12 Combustion Average Information",
      "PGN_Description": "ECCAI12",
      "first_bit": 16,
      "SPN": 6528,
      "SPN_Name": "Engine Cylinder 12 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 12 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6529": {
      "PGN": 61529,
      "PGN_Name": "Engine Cylinder 12 Combustion Average Information",
      "PGN_Description": "ECCAI12",
      "first_bit": 32,
      "SPN": 6529,
      "SPN_Name": "Engine Cylinder 12 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 12 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6530": {
      "PGN": 61529,
      "PGN_Name": "Engine Cylinder 12 Combustion Average Information",
      "PGN_Description": "ECCAI12",
      "first_bit": 48,
      "SPN": 6530,
      "SPN_Name": "Engine Cylinder 12 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 12 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6531": {
      "PGN": 61530,
      "PGN_Name": "Engine Cylinder 13 Combustion Average Information",
      "PGN_Description": "ECCAI13",
      "first_bit": 0,
      "SPN": 6531,
      "SPN_Name": "Engine Cylinder 13 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 13.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6532": {
      "PGN": 61530,
      "PGN_Name": "Engine Cylinder 13 Combustion Average Information",
      "PGN_Description": "ECCAI13",
      "first_bit": 16,
      "SPN": 6532,
      "SPN_Name": "Engine Cylinder 13 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 13 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6533": {
      "PGN": 61530,
      "PGN_Name": "Engine Cylinder 13 Combustion Average Information",
      "PGN_Description": "ECCAI13",
      "first_bit": 32,
      "SPN": 6533,
      "SPN_Name": "Engine Cylinder 13 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 13 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6534": {
      "PGN": 61530,
      "PGN_Name": "Engine Cylinder 13 Combustion Average Information",
      "PGN_Description": "ECCAI13",
      "first_bit": 48,
      "SPN": 6534,
      "SPN_Name": "Engine Cylinder 13 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 13 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6535": {
      "PGN": 61531,
      "PGN_Name": "Engine Cylinder 14 Combustion Average Information",
      "PGN_Description": "ECCAI14",
      "first_bit": 0,
      "SPN": 6535,
      "SPN_Name": "Engine Cylinder 14 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 14.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6536": {
      "PGN": 61531,
      "PGN_Name": "Engine Cylinder 14 Combustion Average Information",
      "PGN_Description": "ECCAI14",
      "first_bit": 16,
      "SPN": 6536,
      "SPN_Name": "Engine Cylinder 14 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 14 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6537": {
      "PGN": 61531,
      "PGN_Name": "Engine Cylinder 14 Combustion Average Information",
      "PGN_Description": "ECCAI14",
      "first_bit": 32,
      "SPN": 6537,
      "SPN_Name": "Engine Cylinder 14 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 14 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6538": {
      "PGN": 61531,
      "PGN_Name": "Engine Cylinder 14 Combustion Average Information",
      "PGN_Description": "ECCAI14",
      "first_bit": 48,
      "SPN": 6538,
      "SPN_Name": "Engine Cylinder 14 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 14 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6539": {
      "PGN": 61532,
      "PGN_Name": "Engine Cylinder 15 Combustion Average Information",
      "PGN_Description": "ECCAI15",
      "first_bit": 0,
      "SPN": 6539,
      "SPN_Name": "Engine Cylinder 15 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 15.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6540": {
      "PGN": 61532,
      "PGN_Name": "Engine Cylinder 15 Combustion Average Information",
      "PGN_Description": "ECCAI15",
      "first_bit": 16,
      "SPN": 6540,
      "SPN_Name": "Engine Cylinder 15 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 15 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6541": {
      "PGN": 61532,
      "PGN_Name": "Engine Cylinder 15 Combustion Average Information",
      "PGN_Description": "ECCAI15",
      "first_bit": 32,
      "SPN": 6541,
      "SPN_Name": "Engine Cylinder 15 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 15 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6542": {
      "PGN": 61532,
      "PGN_Name": "Engine Cylinder 15 Combustion Average Information",
      "PGN_Description": "ECCAI15",
      "first_bit": 48,
      "SPN": 6542,
      "SPN_Name": "Engine Cylinder 15 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 15 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6543": {
      "PGN": 61533,
      "PGN_Name": "Engine Cylinder 16 Combustion Average Information",
      "PGN_Description": "ECCAI16",
      "first_bit": 0,
      "SPN": 6543,
      "SPN_Name": "Engine Cylinder 16 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 16.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6544": {
      "PGN": 61533,
      "PGN_Name": "Engine Cylinder 16 Combustion Average Information",
      "PGN_Description": "ECCAI16",
      "first_bit": 16,
      "SPN": 6544,
      "SPN_Name": "Engine Cylinder 16 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 16 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6545": {
      "PGN": 61533,
      "PGN_Name": "Engine Cylinder 16 Combustion Average Information",
      "PGN_Description": "ECCAI16",
      "first_bit": 32,
      "SPN": 6545,
      "SPN_Name": "Engine Cylinder 16 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 16 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6546": {
      "PGN": 61533,
      "PGN_Name": "Engine Cylinder 16 Combustion Average Information",
      "PGN_Description": "ECCAI16",
      "first_bit": 48,
      "SPN": 6546,
      "SPN_Name": "Engine Cylinder 16 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 16 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6547": {
      "PGN": 61534,
      "PGN_Name": "Engine Cylinder 17 Combustion Average Information",
      "PGN_Description": "ECCAI17",
      "first_bit": 0,
      "SPN": 6547,
      "SPN_Name": "Engine Cylinder 17 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 17.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6548": {
      "PGN": 61534,
      "PGN_Name": "Engine Cylinder 17 Combustion Average Information",
      "PGN_Description": "ECCAI17",
      "first_bit": 16,
      "SPN": 6548,
      "SPN_Name": "Engine Cylinder 17 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 17 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6549": {
      "PGN": 61534,
      "PGN_Name": "Engine Cylinder 17 Combustion Average Information",
      "PGN_Description": "ECCAI17",
      "first_bit": 32,
      "SPN": 6549,
      "SPN_Name": "Engine Cylinder 17 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 17 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6550": {
      "PGN": 61534,
      "PGN_Name": "Engine Cylinder 17 Combustion Average Information",
      "PGN_Description": "ECCAI17",
      "first_bit": 48,
      "SPN": 6550,
      "SPN_Name": "Engine Cylinder 17 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 17 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6551": {
      "PGN": 61535,
      "PGN_Name": "Engine Cylinder 18 Combustion Average Information",
      "PGN_Description": "ECCAI18",
      "first_bit": 0,
      "SPN": 6551,
      "SPN_Name": "Engine Cylinder 18 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 18.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6552": {
      "PGN": 61535,
      "PGN_Name": "Engine Cylinder 18 Combustion Average Information",
      "PGN_Description": "ECCAI18",
      "first_bit": 16,
      "SPN": 6552,
      "SPN_Name": "Engine Cylinder 18 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 18 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6553": {
      "PGN": 61535,
      "PGN_Name": "Engine Cylinder 18 Combustion Average Information",
      "PGN_Description": "ECCAI18",
      "first_bit": 32,
      "SPN": 6553,
      "SPN_Name": "Engine Cylinder 18 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 18 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6554": {
      "PGN": 61535,
      "PGN_Name": "Engine Cylinder 18 Combustion Average Information",
      "PGN_Description": "ECCAI18",
      "first_bit": 48,
      "SPN": 6554,
      "SPN_Name": "Engine Cylinder 18 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 18 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6555": {
      "PGN": 61536,
      "PGN_Name": "Engine Cylinder 19 Combustion Average Information",
      "PGN_Description": "ECCAI19",
      "first_bit": 0,
      "SPN": 6555,
      "SPN_Name": "Engine Cylinder 19 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 19.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6556": {
      "PGN": 61536,
      "PGN_Name": "Engine Cylinder 19 Combustion Average Information",
      "PGN_Description": "ECCAI19",
      "first_bit": 16,
      "SPN": 6556,
      "SPN_Name": "Engine Cylinder 19 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 19 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6557": {
      "PGN": 61536,
      "PGN_Name": "Engine Cylinder 19 Combustion Average Information",
      "PGN_Description": "ECCAI19",
      "first_bit": 32,
      "SPN": 6557,
      "SPN_Name": "Engine Cylinder 19 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 19 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6558": {
      "PGN": 61536,
      "PGN_Name": "Engine Cylinder 19 Combustion Average Information",
      "PGN_Description": "ECCAI19",
      "first_bit": 48,
      "SPN": 6558,
      "SPN_Name": "Engine Cylinder 19 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 19 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6559": {
      "PGN": 61537,
      "PGN_Name": "Engine Cylinder 20 Combustion Average Information",
      "PGN_Description": "ECCAI20",
      "first_bit": 0,
      "SPN": 6559,
      "SPN_Name": "Engine Cylinder 20 Indicated Mean Effective Pressure",
      "SPN_Description": "Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 20.  Negative range is to cover thermodynamic behavior during misfire.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6560": {
      "PGN": 61537,
      "PGN_Name": "Engine Cylinder 20 Combustion Average Information",
      "PGN_Description": "ECCAI20",
      "first_bit": 16,
      "SPN": 6560,
      "SPN_Name": "Engine Cylinder 20 Average Start of Combustion Timing",
      "SPN_Description": "Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 20 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6561": {
      "PGN": 61537,
      "PGN_Name": "Engine Cylinder 20 Combustion Average Information",
      "PGN_Description": "ECCAI20",
      "first_bit": 32,
      "SPN": 6561,
      "SPN_Name": "Engine Cylinder 20 Average Center of Combustion Timing",
      "SPN_Description": "Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 20 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "deg",
      "SLOT_ID": 365
    },
    "6562": {
      "PGN": 61537,
      "PGN_Name": "Engine Cylinder 20 Combustion Average Information",
      "PGN_Description": "ECCAI20",
      "first_bit": 48,
      "SPN": 6562,
      "SPN_Name": "Engine Cylinder 20 Average Combustion Duration",
      "SPN_Description": "Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 20 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "6563": {
      "PGN": 64701,
      "PGN_Name": "Aftertreatment 1 SCR Service Information 2",
      "PGN_Description": "A1SCRSI2",
      "first_bit": 32,
      "SPN": 6563,
      "SPN_Name": "Aftertreatment Trip Diesel Exhaust Fluid",
      "SPN_Description": "DEF consumed during all or part of a journey.",
      "bit_length": 32,
      "scaling": 0.05,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 376
    },
    "6566": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 48,
      "SPN": 6566,
      "SPN_Name": "Transmission Air Supply Pressure Indicator",
      "SPN_Description": "Indicates whether transmission air supply is sufficient\r\n\r\n000   Normal Pressure Range - The transmission supply air pressure is within the normal operational range.\r\n001   Low pressure - The transmission supply air pressure is within a range that may reduce the transmission’s  performance.\r\n010   Very low pressure - The transmission supply air pressure is below a range that will reduce the transmission’s performance.\r\n011   No pressure - The transmission supply air pressure is below a range that will stop the transmission from functioning.\r\n100   Over pressure - The transmission supply air pressure is above a range that may reduce the transmission’s performance.\r\n101   Not defined\r\n110   Error indicator\r\n111   Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "6567": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 44,
      "SPN": 6567,
      "SPN_Name": "Transmission Mode 9 Indicator",
      "SPN_Description": "Indicates that the transmission is operating under transmission mode 9 (SPN 6569) as commanded via the TC2 message (PGN 3328). The definition of the transmission mode is left to the discretion of the transmission manufacturer. \r\n\r\n00 Transmission Mode 9 not active\r\n01 Transmission Mode 9 active\r\n10 Error indicator\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6568": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 46,
      "SPN": 6568,
      "SPN_Name": "Transmission Mode 10 Indicator",
      "SPN_Description": "Indicates that the transmission is operating under transmission mode 10 (SPN 6570) as commanded via the TC2 message (PGN 3328). The definition of the transmission mode is left to the discretion of the transmission manufacturer. \r\n\r\n00 Transmission Mode 10 not active\r\n01 Transmission Mode 10 active\r\n10 Error indicator\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6569": {
      "PGN": 3328,
      "PGN_Name": "Transmission Control 2",
      "PGN_Description": "TC2",
      "first_bit": 0,
      "SPN": 6569,
      "SPN_Name": "Transmission Mode 9",
      "SPN_Description": "Indicates whether transmission mode 9 is enabled. Modes are manufacturer specific and are not necessarily mutually exclusive. See also SPN 6567. \r\n\r\n00 Disable\r\n01 Enable\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6570": {
      "PGN": 3328,
      "PGN_Name": "Transmission Control 2",
      "PGN_Description": "TC2",
      "first_bit": 2,
      "SPN": 6570,
      "SPN_Name": "Transmission Mode 10",
      "SPN_Description": "Indicates whether transmission mode 10 is enabled. Modes are manufacturer specific and are not necessarily mutually exclusive. See also SPN 6568. \r\n\r\n00 Disable\r\n01 Enable\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6571": {
      "PGN": 64659,
      "PGN_Name": "Gaseous Fuel Pressure 2",
      "PGN_Description": "GFP2",
      "first_bit": 0,
      "SPN": 6571,
      "SPN_Name": "Engine Main Chamber Fuel Absolute Pressure",
      "SPN_Description": "Absolute pressure of the gaseous fuel for the main chamber of the cylinder. This parameter is intended for applications, which use a pre and main chamber fuel systems, which report the pressure of more than one type of fuel.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "6572": {
      "PGN": 64659,
      "PGN_Name": "Gaseous Fuel Pressure 2",
      "PGN_Description": "GFP2",
      "first_bit": 16,
      "SPN": 6572,
      "SPN_Name": "Engine Main Chamber Fuel Desired Absolute Pressure",
      "SPN_Description": "Desired absolute pressure of the gaseous fuel for the main chamber of the cylinder. This parameter is intended for applications with pre and main chamber fuel systems, which report the pressure of more than one type of fuel.Engine",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "6573": {
      "PGN": 64659,
      "PGN_Name": "Gaseous Fuel Pressure 2",
      "PGN_Description": "GFP2",
      "first_bit": 32,
      "SPN": 6573,
      "SPN_Name": "Engine Prechamber Fuel Absolute Pressure",
      "SPN_Description": "Absolute pressure of the gaseous fuel for the separate cylinder pre-chamber rail. This parameter is intended for applications, which use a pre and main chamber fuel systems, which report the pressure of more than one type of fuel.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "6574": {
      "PGN": 64659,
      "PGN_Name": "Gaseous Fuel Pressure 2",
      "PGN_Description": "GFP2",
      "first_bit": 48,
      "SPN": 6574,
      "SPN_Name": "Engine Prechamber Fuel Desired Absolute Pressure",
      "SPN_Description": "Desired absolute pressure of the gaseous fuel in the separate cylinder pre-chamber rail. This parameter is intended for applications with pre and main chamber fuel systems, which report the pressure of more than one type of fuel.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "6575": {
      "PGN": 64658,
      "PGN_Name": "Air Fuel Ratio",
      "PGN_Description": "AFR",
      "first_bit": 0,
      "SPN": 6575,
      "SPN_Name": "Engine Main Chamber Air Fuel Ratio",
      "SPN_Description": "Actual air to fuel ratio of the charge entering the cylinder main chamber.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 32
    },
    "6576": {
      "PGN": 64658,
      "PGN_Name": "Air Fuel Ratio",
      "PGN_Description": "AFR",
      "first_bit": 16,
      "SPN": 6576,
      "SPN_Name": "Engine Main Chamber Desired Air Fuel Ratio",
      "SPN_Description": "Desired air to fuel ratio of the charge entering the cylinder main chamber.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 32
    },
    "6577": {
      "PGN": 64658,
      "PGN_Name": "Air Fuel Ratio",
      "PGN_Description": "AFR",
      "first_bit": 32,
      "SPN": 6577,
      "SPN_Name": "Engine Prechamber Air Fuel Ratio",
      "SPN_Description": "Actual air to fuel ratio of the charge entering the cylinder prechamber.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 32
    },
    "6578": {
      "PGN": 64658,
      "PGN_Name": "Air Fuel Ratio",
      "PGN_Description": "AFR",
      "first_bit": 48,
      "SPN": 6578,
      "SPN_Name": "Engine Prechamber Desired Air Fuel Ratio",
      "SPN_Description": "Desired air to fuel ratio of the charge entering the cylinder prechamber.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 32
    },
    "6579": {
      "PGN": 64657,
      "PGN_Name": "Engine Exhaust NOx",
      "PGN_Description": "EEN",
      "first_bit": 0,
      "SPN": 6579,
      "SPN_Name": "Engine Exhaust NOx",
      "SPN_Description": "Calculated NOx concentration for the total engine exhaust, prior to any aftertreatment of the exhaust.  This parameter is primarily intended for engines that have separate NOx sensors in separate exhaust manifolds, but the engine does not have an NOx sensor in an exhaust line after combining the exhaust from the separate manifolds.  This parameter represents the Nox concentration that would be measured by an NOx sensor in an exhaust line after combining the exhaust from the separate manifolds. \r\n\r\nNote:  The individual NOx measurements for the separate exhaust manifolds are reported using the aftertreatment intake NOx parameters, such as SPN 3216 and SPN 3255. This SPN should not be used with engines with only one NOx sensor; instead, engines with only one NOx sensor should use SPN 3216.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "6580": {
      "PGN": 64657,
      "PGN_Name": "Engine Exhaust NOx",
      "PGN_Description": "EEN",
      "first_bit": 16,
      "SPN": 6580,
      "SPN_Name": "Engine Exhaust Desired NOx",
      "SPN_Description": "Desired NOx concentration in the engine exhaust, prior to any aftertreatment of the exhaust.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "6582": {
      "PGN": 64703,
      "PGN_Name": "Electronic Transmission Controller #10",
      "PGN_Description": "ETC10",
      "first_bit": 56,
      "SPN": 6582,
      "SPN_Name": "Transmission Hydraulic Pump Actuator 2 Percent",
      "SPN_Description": "The current modulated value for actuator 2 that controls the transmission hydraulic pump, where 0% = no hydraulic pressure and 100% = full hydraulic pressure.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6583": {
      "PGN": 61538,
      "PGN_Name": "Electronic Transmission Controller #12",
      "PGN_Description": "ETC12",
      "first_bit": 0,
      "SPN": 6583,
      "SPN_Name": "Transmission Hydrostatic Loop 1 Pressure",
      "SPN_Description": "Oil pressure in the transmission hydrostatic loop #1 between the pump and motor.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 377
    },
    "6584": {
      "PGN": 61538,
      "PGN_Name": "Electronic Transmission Controller #12",
      "PGN_Description": "ETC12",
      "first_bit": 16,
      "SPN": 6584,
      "SPN_Name": "Transmission Hydrostatic Loop 2 Pressure",
      "SPN_Description": "Oil pressure in the transmission hydrostatic loop #2 between the pump and motor.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 377
    },
    "6585": {
      "PGN": 61538,
      "PGN_Name": "Electronic Transmission Controller #12",
      "PGN_Description": "ETC12",
      "first_bit": 32,
      "SPN": 6585,
      "SPN_Name": "Transmission Directional Output Shaft Speed",
      "SPN_Description": "The rotational velocity and direction of the output shaft. Positive values are used for forward vehicle motion, negative values for reverse vehicle motion.\r\n\r\nSPN 191 should be used when direction is not used.",
      "bit_length": 16,
      "scaling": 1,
      "offset": -32127,
      "unit": "rpm",
      "SLOT_ID": 378
    },
    "6586": {
      "PGN": 64831,
      "PGN_Name": "Aftertreatment 1 SCR Exhaust Gas Pressures",
      "PGN_Description": "A1SCREGP",
      "first_bit": 24,
      "SPN": 6586,
      "SPN_Name": "Aftertreatment 1 SCR Intake Pressure",
      "SPN_Description": "The gage pressure at the intake of the selective catalytic reduction system of Aftertreatment 1.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3212.7,
      "unit": "kPa",
      "SLOT_ID": 355
    },
    "6587": {
      "PGN": 64825,
      "PGN_Name": "Aftertreatment 2 SCR Exhaust Gas Pressures",
      "PGN_Description": "A2SCREGP",
      "first_bit": 24,
      "SPN": 6587,
      "SPN_Name": "Aftertreatment 2 SCR Intake Pressure",
      "SPN_Description": "The gage pressure at the intake of the selective catalytic reduction system of Aftertreatment 2.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3212.7,
      "unit": "kPa",
      "SLOT_ID": 355
    },
    "6589": {
      "PGN": 64656,
      "PGN_Name": "Engine Fuel Injector Metering Rail Pressure Information 1",
      "PGN_Description": "EFIMRPI1",
      "first_bit": 0,
      "SPN": 6589,
      "SPN_Name": "Engine Fuel 1 Injector Metering Rail 1 Pressure 1",
      "SPN_Description": "The pressure of fuel measured by first rail pressure sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.\r\n\r\nNote:  This is for the rail pressure from the 1st rail pressure sensor.  This may be different than SPN 157 when used in multiple rail pressure sensor configurations.   In an application with only one rail pressure sensor, SPN 157 will be used.  However, in an application with multiple rail pressure sensors, SPN 157 data will be arbitrated from rail pressure sensors 1 and 2 in metering rail 1.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 51
    },
    "6590": {
      "PGN": 64656,
      "PGN_Name": "Engine Fuel Injector Metering Rail Pressure Information 1",
      "PGN_Description": "EFIMRPI1",
      "first_bit": 16,
      "SPN": 6590,
      "SPN_Name": "Engine Fuel 1 Injector Metering Rail 1 Pressure 2",
      "SPN_Description": "The pressure of fuel measured by the second rail pressure sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.\r\n \r\nNote:  This is for the rail pressure from the 2nd rail pressure sensor.  This may be different than SPN 157 when used in multiple rail pressure sensor configurations.  In an application with multiple rail pressure sensors, SPN 157 data will be arbitrated from rail pressure sensors 1 and 2 in metering rail 1.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 51
    },
    "6591": {
      "PGN": 64656,
      "PGN_Name": "Engine Fuel Injector Metering Rail Pressure Information 1",
      "PGN_Description": "EFIMRPI1",
      "first_bit": 32,
      "SPN": 6591,
      "SPN_Name": "Engine Fuel 1 Injector Metering Rail 2 Pressure 1",
      "SPN_Description": "The pressure of fuel measured by first rail pressure sensor in the metering rail 2 as delivered from the supply pump to the injector metering intake.\r\n\r\nNote:  This is for the rail pressure from the 1st rail pressure sensor.  This may be different than SPN 1349 when used in multiple rail pressure sensor configurations.   In an application with only one rail pressure sensor, SPN 1349 will be used.  However, in an application with multiple rail pressure sensors, SPN 1349 data will be arbitrated from rail pressure sensors 1 and 2 in metering rail 2.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 51
    },
    "6592": {
      "PGN": 64656,
      "PGN_Name": "Engine Fuel Injector Metering Rail Pressure Information 1",
      "PGN_Description": "EFIMRPI1",
      "first_bit": 48,
      "SPN": 6592,
      "SPN_Name": "Engine Fuel 1 Injector Metering Rail 2 Pressure 2",
      "SPN_Description": "The pressure of fuel measured by second rail pressure sensor in the metering rail 2 as delivered from the supply pump to the injector metering intake. \r\n\r\nNote:  This is for the rail pressure from the 2nd rail pressure sensor.  This may be different than SPN 1349 when used in multiple rail pressure sensor configurations.  In an application with multiple rail pressure sensors, SPN 1349 data will be arbitrated from rail pressure sensors 1 and 2 in metering rail 2.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 51
    },
    "6593": {
      "PGN": 61476,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 1",
      "PGN_Description": "A1SCRDSR1",
      "first_bit": 40,
      "SPN": 6593,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Dosing Requested Quantity (High Range)",
      "SPN_Description": "Requested dosing quantity of diesel exhaust fluid. This SPN is a high range measurement. See SPN 4348 if high range is not needed.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "g/min",
      "SLOT_ID": 317
    },
    "6594": {
      "PGN": 61479,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 1",
      "PGN_Description": "A2SCRDSR1",
      "first_bit": 40,
      "SPN": 6594,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Dosing Requested Quantity (High Range)",
      "SPN_Description": "Requested dosing quantity of diesel exhaust fluid. This SPN is a high range measurement. See SPN 4401 if high range is not needed.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "g/min",
      "SLOT_ID": 317
    },
    "6595": {
      "PGN": 61475,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 1",
      "PGN_Description": "A1SCRDSI1",
      "first_bit": 48,
      "SPN": 6595,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Actual Dosing Quantity (High Range)",
      "SPN_Description": "Actual dosing quantity of diesel exhaust fluid. See SPN 4331 if high range measurement is not needed.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "g/min",
      "SLOT_ID": 317
    },
    "6596": {
      "PGN": 61478,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 1",
      "PGN_Description": "A2SCRDSI1",
      "first_bit": 48,
      "SPN": 6596,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Actual Dosing Quantity (High Range)",
      "SPN_Description": "Actual dosing quantity of diesel exhaust fluid. See SPN 4384 if high range measurement is not needed.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "g/min",
      "SLOT_ID": 317
    },
    "6610": {
      "PGN": 64655,
      "PGN_Name": "Alternate Fuel 3",
      "PGN_Description": "AF3",
      "first_bit": 16,
      "SPN": 6610,
      "SPN_Name": "Engine Fuel Vaporizer 1 Discharge Temperature",
      "SPN_Description": "The temperature of the fuel in its gaseous state at the outlet of the first fuel vaporizer",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "6642": {
      "PGN": 64671,
      "PGN_Name": "Dash Display 2",
      "PGN_Description": "DD2",
      "first_bit": 16,
      "SPN": 6642,
      "SPN_Name": "Engine Fuel 2 Tank 1 Level",
      "SPN_Description": "Fuel level in tank 1 containing the second fuel type.\r\n.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6643": {
      "PGN": 64671,
      "PGN_Name": "Dash Display 2",
      "PGN_Description": "DD2",
      "first_bit": 24,
      "SPN": 6643,
      "SPN_Name": "Engine Fuel 2 Tank 2 Level",
      "SPN_Description": "Fuel level in tank 2 containing the second fuel type.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6644": {
      "PGN": 64671,
      "PGN_Name": "Dash Display 2",
      "PGN_Description": "DD2",
      "first_bit": 32,
      "SPN": 6644,
      "SPN_Name": "Engine Fuel 2 Tank 3 Level",
      "SPN_Description": "Fuel level in tank 3 containing the second fuel type.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6645": {
      "PGN": 64671,
      "PGN_Name": "Dash Display 2",
      "PGN_Description": "DD2",
      "first_bit": 40,
      "SPN": 6645,
      "SPN_Name": "Engine Fuel 2 Tank 4 Level",
      "SPN_Description": "Fuel level in tank 4 containing the second fuel type.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6646": {
      "PGN": 64655,
      "PGN_Name": "Alternate Fuel 3",
      "PGN_Description": "AF3",
      "first_bit": 0,
      "SPN": 6646,
      "SPN_Name": "Engine Gaseous Fuel Supply Pressure 1 (Extended Range)",
      "SPN_Description": "Pressure of gaseous fuel supply to fuel metering device in systems where the pressure range defined for SPN 159 is not sufficient.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "MPa",
      "SLOT_ID": 51
    },
    "6649": {
      "PGN": 65194,
      "PGN_Name": "Alternate Fuel 2",
      "PGN_Description": "AF2",
      "first_bit": 40,
      "SPN": 6649,
      "SPN_Name": "Gaseous Fuel Injection Pulse Correction Factor",
      "SPN_Description": "A correction to the gaseous fuel injection pulse (expressed in msec) represented as a percentage.  100% means no correction, higher values indicate increased pulse time, lower values indicate decreased pulse time.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -251,
      "unit": "%",
      "SLOT_ID": 256
    },
    "6650": {
      "PGN": 64713,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 2",
      "PGN_Description": "EF/TVI2",
      "first_bit": 48,
      "SPN": 6650,
      "SPN_Name": "Engine Throttle Valve 1 Position 2",
      "SPN_Description": "The position of the valve used to regulate the supply of a fluid, usually air or fuel/air mixture, to an engine. This position is measured by a second sensor.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6656": {
      "PGN": 61539,
      "PGN_Name": "Fuel Information 5 (Gaseous)",
      "PGN_Description": "GFI5",
      "first_bit": 0,
      "SPN": 6656,
      "SPN_Name": "Engine Gaseous Fuel Valve Nominal Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valves are activated.  It's a nominal value used for all the gaseous fuel valves in the engine.\r\n\r\nNote: Please see SPNs 6658 - 6677 for duration command for each gaseous fuel valves",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6657": {
      "PGN": 61539,
      "PGN_Name": "Fuel Information 5 (Gaseous)",
      "PGN_Description": "GFI5",
      "first_bit": 16,
      "SPN": 6657,
      "SPN_Name": "Engine Gaseous Fuel Valve Nominal Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of each cylinder, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valves are activated to open.  It's a nominal value used for all the gaseous fuel valves in the engine.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nNote: Please see SPNs 6678 - 6697 for Start of injection command for each gaseous fuel valves",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6658": {
      "PGN": 61540,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 1",
      "PGN_Description": "EGFVDC1",
      "first_bit": 0,
      "SPN": 6658,
      "SPN_Name": "Engine Gaseous Fuel Valve 1 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 1 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6659": {
      "PGN": 61540,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 1",
      "PGN_Description": "EGFVDC1",
      "first_bit": 16,
      "SPN": 6659,
      "SPN_Name": "Engine Gaseous Fuel Valve 2 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 2 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6660": {
      "PGN": 61540,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 1",
      "PGN_Description": "EGFVDC1",
      "first_bit": 32,
      "SPN": 6660,
      "SPN_Name": "Engine Gaseous Fuel Valve 3 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 3 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6661": {
      "PGN": 61540,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 1",
      "PGN_Description": "EGFVDC1",
      "first_bit": 48,
      "SPN": 6661,
      "SPN_Name": "Engine Gaseous Fuel Valve 4 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 4 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6662": {
      "PGN": 61541,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 2",
      "PGN_Description": "EGFVDC2",
      "first_bit": 0,
      "SPN": 6662,
      "SPN_Name": "Engine Gaseous Fuel Valve 5 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 5 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6663": {
      "PGN": 61541,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 2",
      "PGN_Description": "EGFVDC2",
      "first_bit": 16,
      "SPN": 6663,
      "SPN_Name": "Engine Gaseous Fuel Valve 6 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 6 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6664": {
      "PGN": 61541,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 2",
      "PGN_Description": "EGFVDC2",
      "first_bit": 32,
      "SPN": 6664,
      "SPN_Name": "Engine Gaseous Fuel Valve 7 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 7 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6665": {
      "PGN": 61541,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 2",
      "PGN_Description": "EGFVDC2",
      "first_bit": 48,
      "SPN": 6665,
      "SPN_Name": "Engine Gaseous Fuel Valve 8 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 8 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6666": {
      "PGN": 61542,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 3",
      "PGN_Description": "EGFVDC3",
      "first_bit": 0,
      "SPN": 6666,
      "SPN_Name": "Engine Gaseous Fuel Valve 9 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 9 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6667": {
      "PGN": 61542,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 3",
      "PGN_Description": "EGFVDC3",
      "first_bit": 16,
      "SPN": 6667,
      "SPN_Name": "Engine Gaseous Fuel Valve 10 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 10 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6668": {
      "PGN": 61542,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 3",
      "PGN_Description": "EGFVDC3",
      "first_bit": 32,
      "SPN": 6668,
      "SPN_Name": "Engine Gaseous Fuel Valve 11 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 11 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6669": {
      "PGN": 61542,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 3",
      "PGN_Description": "EGFVDC3",
      "first_bit": 48,
      "SPN": 6669,
      "SPN_Name": "Engine Gaseous Fuel Valve 12 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 12 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6670": {
      "PGN": 61543,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 4",
      "PGN_Description": "EGFVDC4",
      "first_bit": 0,
      "SPN": 6670,
      "SPN_Name": "Engine Gaseous Fuel Valve 13 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 13 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6671": {
      "PGN": 61543,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 4",
      "PGN_Description": "EGFVDC4",
      "first_bit": 16,
      "SPN": 6671,
      "SPN_Name": "Engine Gaseous Fuel Valve 14 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 14 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6672": {
      "PGN": 61543,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 4",
      "PGN_Description": "EGFVDC4",
      "first_bit": 32,
      "SPN": 6672,
      "SPN_Name": "Engine Gaseous Fuel Valve 15 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 15 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6673": {
      "PGN": 61543,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 4",
      "PGN_Description": "EGFVDC4",
      "first_bit": 48,
      "SPN": 6673,
      "SPN_Name": "Engine Gaseous Fuel Valve 16 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 16 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6674": {
      "PGN": 61544,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 5",
      "PGN_Description": "EGFVDC5",
      "first_bit": 0,
      "SPN": 6674,
      "SPN_Name": "Engine Gaseous Fuel Valve 17 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 17 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6675": {
      "PGN": 61544,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 5",
      "PGN_Description": "EGFVDC5",
      "first_bit": 16,
      "SPN": 6675,
      "SPN_Name": "Engine Gaseous Fuel Valve 18 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 18 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6676": {
      "PGN": 61544,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 5",
      "PGN_Description": "EGFVDC5",
      "first_bit": 32,
      "SPN": 6676,
      "SPN_Name": "Engine Gaseous Fuel Valve 19 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 19 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6677": {
      "PGN": 61544,
      "PGN_Name": "Engine Gaseous Fuel Valve Duration Command 5",
      "PGN_Description": "EGFVDC5",
      "first_bit": 48,
      "SPN": 6677,
      "SPN_Name": "Engine Gaseous Fuel Valve 20 Duration Command",
      "SPN_Description": "Amount of time the gaseous fuel valve 20 is activated.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "µs",
      "SLOT_ID": 380
    },
    "6678": {
      "PGN": 61545,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 1",
      "PGN_Description": "EGFVSOAC1",
      "first_bit": 0,
      "SPN": 6678,
      "SPN_Name": "Engine Gaseous Fuel Valve 1 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 1, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 1 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1413 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6679": {
      "PGN": 61545,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 1",
      "PGN_Description": "EGFVSOAC1",
      "first_bit": 16,
      "SPN": 6679,
      "SPN_Name": "Engine Gaseous Fuel Valve 2 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 2, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 2 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1414 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6680": {
      "PGN": 61545,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 1",
      "PGN_Description": "EGFVSOAC1",
      "first_bit": 32,
      "SPN": 6680,
      "SPN_Name": "Engine Gaseous Fuel Valve 3 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 3, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 3 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1415 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6681": {
      "PGN": 61545,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 1",
      "PGN_Description": "EGFVSOAC1",
      "first_bit": 48,
      "SPN": 6681,
      "SPN_Name": "Engine Gaseous Fuel Valve 4 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 4, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 4 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1416 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6682": {
      "PGN": 61546,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 2",
      "PGN_Description": "EGFVSOAC2",
      "first_bit": 0,
      "SPN": 6682,
      "SPN_Name": "Engine Gaseous Fuel Valve 5 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 5, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 5 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1417 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6683": {
      "PGN": 61546,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 2",
      "PGN_Description": "EGFVSOAC2",
      "first_bit": 16,
      "SPN": 6683,
      "SPN_Name": "Engine Gaseous Fuel Valve 6 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 6, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 6 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1418 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6684": {
      "PGN": 61546,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 2",
      "PGN_Description": "EGFVSOAC2",
      "first_bit": 32,
      "SPN": 6684,
      "SPN_Name": "Engine Gaseous Fuel Valve 7 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 7, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 7 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1419 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6685": {
      "PGN": 61546,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 2",
      "PGN_Description": "EGFVSOAC2",
      "first_bit": 48,
      "SPN": 6685,
      "SPN_Name": "Engine Gaseous Fuel Valve 8 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 8, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 8 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1420 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6686": {
      "PGN": 61547,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 3",
      "PGN_Description": "EGFVSOAC3",
      "first_bit": 0,
      "SPN": 6686,
      "SPN_Name": "Engine Gaseous Fuel Valve 9 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 9, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 9 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1421 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6687": {
      "PGN": 61547,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 3",
      "PGN_Description": "EGFVSOAC3",
      "first_bit": 16,
      "SPN": 6687,
      "SPN_Name": "Engine Gaseous Fuel Valve 10 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 10, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 10 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1422 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6688": {
      "PGN": 61547,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 3",
      "PGN_Description": "EGFVSOAC3",
      "first_bit": 32,
      "SPN": 6688,
      "SPN_Name": "Engine Gaseous Fuel Valve 11 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 11, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 11 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1423 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6689": {
      "PGN": 61547,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 3",
      "PGN_Description": "EGFVSOAC3",
      "first_bit": 48,
      "SPN": 6689,
      "SPN_Name": "Engine Gaseous Fuel Valve 12 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 12, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 12 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1424 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6690": {
      "PGN": 61548,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 4",
      "PGN_Description": "EGFVSOAC4",
      "first_bit": 0,
      "SPN": 6690,
      "SPN_Name": "Engine Gaseous Fuel Valve 13 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 13, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 13 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1425 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6691": {
      "PGN": 61548,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 4",
      "PGN_Description": "EGFVSOAC4",
      "first_bit": 16,
      "SPN": 6691,
      "SPN_Name": "Engine Gaseous Fuel Valve 14 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 14, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 14 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1426 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6692": {
      "PGN": 61548,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 4",
      "PGN_Description": "EGFVSOAC4",
      "first_bit": 32,
      "SPN": 6692,
      "SPN_Name": "Engine Gaseous Fuel Valve 15 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 15, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 15 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1427 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6693": {
      "PGN": 61548,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 4",
      "PGN_Description": "EGFVSOAC4",
      "first_bit": 48,
      "SPN": 6693,
      "SPN_Name": "Engine Gaseous Fuel Valve 16 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 16, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 16 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1428 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6694": {
      "PGN": 61549,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 5",
      "PGN_Description": "EGFVSOAC5",
      "first_bit": 0,
      "SPN": 6694,
      "SPN_Name": "Engine Gaseous Fuel Valve 17 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 17, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 17 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1429 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6695": {
      "PGN": 61549,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 5",
      "PGN_Description": "EGFVSOAC5",
      "first_bit": 16,
      "SPN": 6695,
      "SPN_Name": "Engine Gaseous Fuel Valve 18 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 18, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 18 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1420 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6696": {
      "PGN": 61549,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 5",
      "PGN_Description": "EGFVSOAC5",
      "first_bit": 32,
      "SPN": 6696,
      "SPN_Name": "Engine Gaseous Fuel Valve 19 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 19, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 19 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1431 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6697": {
      "PGN": 61549,
      "PGN_Name": "Engine Gaseous Fuel Valve Start of Actuation Command 5",
      "PGN_Description": "EGFVSOAC5",
      "first_bit": 48,
      "SPN": 6697,
      "SPN_Name": "Engine Gaseous Fuel Valve 20 Start of Actuation Command",
      "SPN_Description": "The angle, relative to the TDC of cylinder 20, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 20 is activated to open.\r\n\r\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\r\n\r\nThis is the timing for the secondary fuel injector.  See SPN 1432 for the primary fuel injector timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -400,
      "unit": "deg",
      "SLOT_ID": 379
    },
    "6702": {
      "PGN": 61448,
      "PGN_Name": "Hydraulic Pressure Governor Info",
      "PGN_Description": "HPG",
      "first_bit": 22,
      "SPN": 6702,
      "SPN_Name": "Fire Apparatus Okay To Pump Interlock",
      "SPN_Description": "The measured state of the Okay To Pump interlock of the fire apparatus.\r\n\r\n00 Okay to Pump Interlock Inactive\r\n01 Okay to Pump Interlock Active\r\n10 Error\r\n11 Not Available\r\n\r\nNote: \"Okay to Pump\" is incorporated into the NFPA 1901 Standard for Fire Appartus.  It is a required indicator.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6703": {
      "PGN": 61448,
      "PGN_Name": "Hydraulic Pressure Governor Info",
      "PGN_Description": "HPG",
      "first_bit": 60,
      "SPN": 6703,
      "SPN_Name": "Hydraulic Pressure Governor Increase Switch",
      "SPN_Description": "Switch that commands hydraulic pressure governor to increase engine rpm resulting in expected increase of hydraulic discharge pressure.\r\n\r\n00 Increase Switch Inactive\r\n01 Increase Switch Active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6704": {
      "PGN": 61448,
      "PGN_Name": "Hydraulic Pressure Governor Info",
      "PGN_Description": "HPG",
      "first_bit": 58,
      "SPN": 6704,
      "SPN_Name": "Hydraulic Pressure Governor Decrease Switch",
      "SPN_Description": "Switch that commands hydraulic pressure governor to decrease engine rpm resulting in expected decrease of hydraulic discharge pressure.\r\n\r\n00 Decrease Switch Inactive\r\n01 Decrease Switch Active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6705": {
      "PGN": 61448,
      "PGN_Name": "Hydraulic Pressure Governor Info",
      "PGN_Description": "HPG",
      "first_bit": 56,
      "SPN": 6705,
      "SPN_Name": "Hydraulic Pressure Governor Idle Switch",
      "SPN_Description": "Switch that commands hydraulic pressure governor to decrease engine rpm to its idle position.\r\n\r\n00 Idle Switch Inactive\r\n01 Idle Switch Active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6706": {
      "PGN": 61448,
      "PGN_Name": "Hydraulic Pressure Governor Info",
      "PGN_Description": "HPG",
      "first_bit": 62,
      "SPN": 6706,
      "SPN_Name": "Hydraulic Pressure Governor Preset Switch",
      "SPN_Description": "Switch that commands hydraulic pressure governor to increase or decrease engine rpm to achieve a predefined discharge pressure.\r\n\r\n00 Preset Switch Inactive\r\n01 Preset Switch Active\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6707": {
      "PGN": 61448,
      "PGN_Name": "Hydraulic Pressure Governor Info",
      "PGN_Description": "HPG",
      "first_bit": 24,
      "SPN": 6707,
      "SPN_Name": "Hydraulic Intake Pressure",
      "SPN_Description": "Hydraulic pressure measured at the intake of the hydraulic pump.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": -1,
      "unit": "MPa",
      "SLOT_ID": 364
    },
    "6708": {
      "PGN": 61448,
      "PGN_Name": "Hydraulic Pressure Governor Info",
      "PGN_Description": "HPG",
      "first_bit": 40,
      "SPN": 6708,
      "SPN_Name": "Hydraulic Discharge Pressure Set Point",
      "SPN_Description": "Hydraulic pressure governing system discharge pressure set point.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 106
    },
    "6709": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 30,
      "SPN": 6709,
      "SPN_Name": "Engine Speed High Lamp Command",
      "SPN_Description": "Command signal directly controlling the Engine Speed High Warning lamp.\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6710": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 32,
      "SPN": 6710,
      "SPN_Name": "Engine Speed Very High Lamp Command",
      "SPN_Description": "Command signal directly controlling the Engine Speed Very High Warning lamp.\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6711": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 30,
      "SPN": 6711,
      "SPN_Name": "Engine Speed High Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Speed High Warning Lamp.\r\n\r\n00 - Lamp Deactivated (Off)\r\n01 - Lamp Activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6712": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 32,
      "SPN": 6712,
      "SPN_Name": "Engine Speed Very High Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Engine Speed Very High Warning Lamp.\r\n\r\n00 - Lamp Deactivated (Off)\r\n01 - Lamp Activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6715": {
      "PGN": 34560,
      "PGN_Name": "Engine State Requests",
      "PGN_Description": "ESR",
      "first_bit": 16,
      "SPN": 6715,
      "SPN_Name": "Engine Gaseous Fuel Supply Desired Pressure",
      "SPN_Description": "Desired gage pressure of gaseous fuel supply to the engine.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "6716": {
      "PGN": 64752,
      "PGN_Name": "Engine Fuel/lube systems 2",
      "PGN_Description": "EFS2",
      "first_bit": 8,
      "SPN": 6716,
      "SPN_Name": "Engine Fuel Filter (Suction Side) Degradation",
      "SPN_Description": "The estimated percentage relative to the useful life of the engine fuel filter on the suction side which is located betwee the fuel tank and the fuel supply pump.\r\n\r\nNote:  This is not a calculation of the physical restriction of the filter. 0% is typical of a new filter. 100% is typical of an end of life filter, the filter should be replaced. The filter can operate past 100%.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6719": {
      "PGN": 61550,
      "PGN_Name": "Fuel Pump Actuator Control Command",
      "PGN_Description": "FPAC",
      "first_bit": 0,
      "SPN": 6719,
      "SPN_Name": "Engine Fuel Injection Pump 1 Fuel Control Valve Command",
      "SPN_Description": "The control command to fuel control valve in fuel pump 1, normalized to percent, where 0% represents fully closed and 100% represents fully open.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "6720": {
      "PGN": 61550,
      "PGN_Name": "Fuel Pump Actuator Control Command",
      "PGN_Description": "FPAC",
      "first_bit": 16,
      "SPN": 6720,
      "SPN_Name": "Engine Fuel Injection Pump 2 Fuel Control Valve Command",
      "SPN_Description": "The control command to fuel control valve in fuel pump 2, normalized to percent, where 0% represents fully closed and 100% represents fully open.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "6730": {
      "PGN": 34048,
      "PGN_Name": "Cab Message 2",
      "PGN_Description": "CM2",
      "first_bit": 0,
      "SPN": 6730,
      "SPN_Name": "Engine Fan 2 Requested Percent Speed",
      "SPN_Description": "Fan speed of the second fan in the system as a ratio of the actual fan drive (current speed) to the fully engaged fan drive (maximum fan speed). A two state fan (off/on) will use 0% and 100% respectively.  A three state fan (off/intermediate/on) will use 0%, 50% and 100% respectively. A variable speed fan will use 0% to 100%. Multiple fan systems will use 0 to 100% to indicate the percent cooling capacity being provided. Feedback to this request is provided using the Estimated Percent Fan 2 Speed (see SPN 1550).\r\n\r\nNote that the intermediate fan speed of a three state fan will vary with different fan drives, therefore 50% is being used to indicate that the intermediate speed is required from the fan drive. Typically, the first fan in a system will be the fan closest to the radiator. The second fan will be located farthest from the radiator.\r\n\r\nSPN 986 shall be used for systems that have only one fan.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6731": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 62,
      "SPN": 6731,
      "SPN_Name": "Joystick 1 Button 13 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6732": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 60,
      "SPN": 6732,
      "SPN_Name": "Joystick 1 Button 14 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6733": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 58,
      "SPN": 6733,
      "SPN_Name": "Joystick 1 Button 15 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6734": {
      "PGN": 64983,
      "PGN_Name": "Extended Joystick Message 1",
      "PGN_Description": "EJM1",
      "first_bit": 56,
      "SPN": 6734,
      "SPN_Name": "Joystick 1 Button 16 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6735": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 62,
      "SPN": 6735,
      "SPN_Name": "Joystick 2 Button 13 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6736": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 60,
      "SPN": 6736,
      "SPN_Name": "Joystick 2 Button 14 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6737": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 58,
      "SPN": 6737,
      "SPN_Name": "Joystick 2 Button 15 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6738": {
      "PGN": 64985,
      "PGN_Name": "Extended Joystick Message 2",
      "PGN_Description": "EJM2",
      "first_bit": 56,
      "SPN": 6738,
      "SPN_Name": "Joystick 2 Button 16 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6739": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 62,
      "SPN": 6739,
      "SPN_Name": "Joystick 3 Button 13 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6740": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 60,
      "SPN": 6740,
      "SPN_Name": "Joystick 3 Button 14 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6741": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 58,
      "SPN": 6741,
      "SPN_Name": "Joystick 3 Button 15 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6742": {
      "PGN": 64987,
      "PGN_Name": "Extended Joystick Message 3",
      "PGN_Description": "EJM3",
      "first_bit": 56,
      "SPN": 6742,
      "SPN_Name": "Joystick 3 Button 16 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6743": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 62,
      "SPN": 6743,
      "SPN_Name": "Joystick 4 Button 13 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6744": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 60,
      "SPN": 6744,
      "SPN_Name": "Joystick 4 Button 14 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6745": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 58,
      "SPN": 6745,
      "SPN_Name": "Joystick 4 Button 15 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6746": {
      "PGN": 64815,
      "PGN_Name": "Extended Joystick Message 4",
      "PGN_Description": "EJM4",
      "first_bit": 56,
      "SPN": 6746,
      "SPN_Name": "Joystick 4 Button 16 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6747": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 62,
      "SPN": 6747,
      "SPN_Name": "Joystick 5 Button 13 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6748": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 60,
      "SPN": 6748,
      "SPN_Name": "Joystick 5 Button 14 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6749": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 58,
      "SPN": 6749,
      "SPN_Name": "Joystick 5 Button 15 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6750": {
      "PGN": 64813,
      "PGN_Name": "Extended Joystick Message 5",
      "PGN_Description": "EJM5",
      "first_bit": 56,
      "SPN": 6750,
      "SPN_Name": "Joystick 5 Button 16 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6751": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 62,
      "SPN": 6751,
      "SPN_Name": "Joystick 6 Button 13 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6752": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 60,
      "SPN": 6752,
      "SPN_Name": "Joystick 6 Button 14 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6753": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 58,
      "SPN": 6753,
      "SPN_Name": "Joystick 6 Button 15 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6754": {
      "PGN": 64811,
      "PGN_Name": "Extended Joystick Message 6",
      "PGN_Description": "EJM6",
      "first_bit": 56,
      "SPN": 6754,
      "SPN_Name": "Joystick 6 Button 16 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6755": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 62,
      "SPN": 6755,
      "SPN_Name": "Joystick 7 Button 13 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6756": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 60,
      "SPN": 6756,
      "SPN_Name": "Joystick 7 Button 14 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6757": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 58,
      "SPN": 6757,
      "SPN_Name": "Joystick 7 Button 15 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6758": {
      "PGN": 64809,
      "PGN_Name": "Extended Joystick Message 7",
      "PGN_Description": "EJM7",
      "first_bit": 56,
      "SPN": 6758,
      "SPN_Name": "Joystick 7 Button 16 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6759": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 62,
      "SPN": 6759,
      "SPN_Name": "Joystick 8 Button 13 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6760": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 60,
      "SPN": 6760,
      "SPN_Name": "Joystick 8 Button 14 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6761": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 58,
      "SPN": 6761,
      "SPN_Name": "Joystick 8 Button 15 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6762": {
      "PGN": 64807,
      "PGN_Name": "Extended Joystick Message 8",
      "PGN_Description": "EJM8",
      "first_bit": 56,
      "SPN": 6762,
      "SPN_Name": "Joystick 8 Button 16 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6763": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 62,
      "SPN": 6763,
      "SPN_Name": "Joystick 9 Button 13 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6764": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 60,
      "SPN": 6764,
      "SPN_Name": "Joystick 9 Button 14 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6765": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 58,
      "SPN": 6765,
      "SPN_Name": "Joystick 9 Button 15 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6766": {
      "PGN": 64805,
      "PGN_Name": "Extended Joystick Message 9",
      "PGN_Description": "EJM9",
      "first_bit": 56,
      "SPN": 6766,
      "SPN_Name": "Joystick 9 Button 16 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6767": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 62,
      "SPN": 6767,
      "SPN_Name": "Joystick 10 Button 13 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6768": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 60,
      "SPN": 6768,
      "SPN_Name": "Joystick 10 Button 14 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6769": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 58,
      "SPN": 6769,
      "SPN_Name": "Joystick 10 Button 15 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6770": {
      "PGN": 64803,
      "PGN_Name": "Extended Joystick Message 10",
      "PGN_Description": "EJM10",
      "first_bit": 56,
      "SPN": 6770,
      "SPN_Name": "Joystick 10 Button 16 Pressed Status",
      "SPN_Description": "Reports when the joystick button has been pressed.\r\n\n00 Button not pressed\r\n01 Button pressed\r\n10 Error Indicator\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6771": {
      "PGN": 64652,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 1",
      "PGN_Description": "AFT1PSI1",
      "first_bit": 0,
      "SPN": 6771,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Resistance",
      "SPN_Description": "This sensor is located in the exhaust stream somewhere after the DPF, but not necessarily immediately after the DPF.  It provides a resistance value that can be used to determine particulate matter in the exhaust stream. The value in this parameter is compensated to be the resistance at 200 degC.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "kohm",
      "SLOT_ID": 383
    },
    "6772": {
      "PGN": 64652,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 1",
      "PGN_Description": "AFT1PSI1",
      "first_bit": 16,
      "SPN": 6772,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Heater State",
      "SPN_Description": "The states of the particulate sensor heater.  The heater will change states from 11 to 10, 10 to 01, and 01 to 00 in a typical heating event.\r\n\r\n00 - Heater is in closed loop control\r\n01 - Heater is being held at a specified level\r\n10 - Heater is in ramp up mode\r\n11 - Heater is off",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6773": {
      "PGN": 64652,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 1",
      "PGN_Description": "AFT1PSI1",
      "first_bit": 18,
      "SPN": 6773,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Regeneration Status",
      "SPN_Description": "The status of the most recent attempt of this power cycle to activate the particulate sensor regeneration process. This will not be updated until the regeneration is no longer active, as indicated by SPN 6774.\r\n\r\nPower cycle refers to the time that power has currently been applied to the ECU controlling the particulate sensor.\r\n\r\n00 -  Regeneration has not completed during this power cycle\r\n01 -  Regeneration was successful\r\n10 -  Regeneration failed\r\n11 -  Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6774": {
      "PGN": 64652,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 1",
      "PGN_Description": "AFT1PSI1",
      "first_bit": 20,
      "SPN": 6774,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Regeneration State",
      "SPN_Description": "Indicates if the particulate sensor regeneration is currently active, and if so, the reason for the regeneration.\r\n\r\n0000 - Regeneration is not active\r\n0001 - Regneration is active and has been initiated by request via SPN 6783\r\n0010 - Regeneration is active and has been initiated because of sensor conditions\r\n0011 - Regeneration is active and has been initiated due to time based conditions\r\n0100 to 1110 - SAE Reserved\r\n1111 - Not Available\r\n\r\nWhen the regeneration is no longer active, SPN 6773 will be updated to reflect the status of the regeneration.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "6775": {
      "PGN": 64652,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 1",
      "PGN_Description": "AFT1PSI1",
      "first_bit": 24,
      "SPN": 6775,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Active Accumulation Time",
      "SPN_Description": "This is the amount of time since the last successful regeneration completed.  The sensor has been accumulating particulate matter since that time.",
      "bit_length": 16,
      "scaling": 6,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 384
    },
    "6776": {
      "PGN": 64652,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 1",
      "PGN_Description": "AFT1PSI1",
      "first_bit": 40,
      "SPN": 6776,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Time Between Regenerations",
      "SPN_Description": "This is the time between the last two successful regenerations of the particulate sensor for the current power cycle. This parameter reflects the time when the engine was running, not a duration based on a real time clock. If two successful particulate sensor regenerations have not ever occurred on this sensor during this power cycle, then this value shall be 0.",
      "bit_length": 16,
      "scaling": 6,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 384
    },
    "6777": {
      "PGN": 64651,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 2",
      "PGN_Description": "AFT1PSI2",
      "first_bit": 0,
      "SPN": 6777,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Detection Status",
      "SPN_Description": "Detection status of the particulate sensor\r\n\r\n0000 – Initialization for particulate matter detection\r\n0001 – Waiting for dew point (see SPN 6784)\r\n0010 – Particulate matter detection\r\n0011 – Heater is active for particulate sensor regeneration\r\n0100 – Cooling after particulate sensor regeneration\r\n0101 – Heater diagnostics test\r\n0110 – Relearning particulate sensor resistance after particulate sensor regeneration\r\n0111 – Sensor regeneration did not complete due to system parameters out of range (e.g., exhaust temperature out of range). Regeneration will restart once the values of the appropriate system parameters are conducive to regeneration.\r\n1000 – Halt particulate matter detection. An irrecoverable fault likely occurred. Will remain in this state until a manual fault clear or a new power cycle has started.\r\n1001 to 1110 – SAE Reserved\r\n1111 – Not supported\r\n\r\nPower Cycle refers to the time that power has currently been applied to the ECU controlling the particulate sensor.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "6778": {
      "PGN": 64651,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 2",
      "PGN_Description": "AFT1PSI2",
      "first_bit": 4,
      "SPN": 6778,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Power Supply",
      "SPN_Description": "State signal which indicates when the Aftertreatment 1 particulate sensor has power applied to it. Note that this is referring to the power supplied to the sensor, not the power supplied to the controller connected to the sensor.\r\n\r\n00 – Off\r\n01 – On\r\n10 – Error\r\n11 – Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6779": {
      "PGN": 64651,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 2",
      "PGN_Description": "AFT1PSI2",
      "first_bit": 8,
      "SPN": 6779,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Regeneration Failed Count",
      "SPN_Description": "This is the number of times that the particulate sensor regeneration process has been attempted but failed to complete this power cycle.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "6780": {
      "PGN": 64651,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 2",
      "PGN_Description": "AFT1PSI2",
      "first_bit": 16,
      "SPN": 6780,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Temperature",
      "SPN_Description": "Temperature of the particulate sensor.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "6781": {
      "PGN": 64651,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 2",
      "PGN_Description": "AFT1PSI2",
      "first_bit": 32,
      "SPN": 6781,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Maximum Resistance",
      "SPN_Description": "This is the maximum resistance that the particulate sensor can measure.",
      "bit_length": 8,
      "scaling": 250,
      "offset": 0,
      "unit": "kohm",
      "SLOT_ID": 385
    },
    "6782": {
      "PGN": 33792,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Control",
      "PGN_Description": "AFT1PSC",
      "first_bit": 0,
      "SPN": 6782,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Shutdown Request",
      "SPN_Description": "Aftertreatment 1 particulate sensor shutdown request.\r\n\r\n00 - Shutdown request not active\r\n01 - Shutdown request active\r\n10 - SAE reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6783": {
      "PGN": 33792,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Control",
      "PGN_Description": "AFT1PSC",
      "first_bit": 2,
      "SPN": 6783,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Regeneration Request",
      "SPN_Description": "Another ECU would send this to request that the particulate sensor perform a regeneration of the sensor.  A request would be considered active when this parameter transitions from 00 to 01.\r\n\r\n00 - Regeneration not requested\r\n01 - Regeneration requested\r\n10 - SAE reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6784": {
      "PGN": 33792,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Control",
      "PGN_Description": "AFT1PSC",
      "first_bit": 4,
      "SPN": 6784,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Dewpoint",
      "SPN_Description": "Indicates that the temperature near the particulate sensor has exceeded the dew point.\r\n\r\n00 - Dewpoint has not been reached\r\n01 - Dewpoint has been reached\r\n10 - SAE reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6785": {
      "PGN": 33792,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Control",
      "PGN_Description": "AFT1PSC",
      "first_bit": 8,
      "SPN": 6785,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Exhaust Temperature",
      "SPN_Description": "This is the temperature in the exhaust stream that is closest to the particulate sensor. This could be a calculated value or read from another sensor. The ECU transmitting this message to the particulate sensor controller will be aware of the temperature sensor that is closest to the particulate sensor, whereas the particulate sensor may not be aware of the location.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "6787": {
      "PGN": 64557,
      "PGN_Name": "Alternate Fuel 5",
      "PGN_Description": "AF5",
      "first_bit": 0,
      "SPN": 6787,
      "SPN_Name": "LNG Tank 1 Vapor Pressure",
      "SPN_Description": "Gage pressure of the vapor in the first tank in a multi-tank system (or unique tank if single-tank system).",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "6788": {
      "PGN": 64557,
      "PGN_Name": "Alternate Fuel 5",
      "PGN_Description": "AF5",
      "first_bit": 16,
      "SPN": 6788,
      "SPN_Name": "LNG Tank 2 Vapor Pressure",
      "SPN_Description": "Gage pressure of the vapor in the second tank in a multi-tank system.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "6791": {
      "PGN": 64712,
      "PGN_Name": "Electronic Engine Controller 13",
      "PGN_Description": "EEC13",
      "first_bit": 16,
      "SPN": 6791,
      "SPN_Name": "Engine Dual Fuel Mode",
      "SPN_Description": "Actual dual fuel mode, off or on.\r\n\r\n00 = Actual dual fuel mode off\r\n01 = Actual dual fuel mode on\r\n10 = Reserved\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6792": {
      "PGN": 61496,
      "PGN_Name": "Engine Torque / Fuel Request",
      "PGN_Description": "ETFR",
      "first_bit": 56,
      "SPN": 6792,
      "SPN_Name": "Engine Dual Fuel Mode Command",
      "SPN_Description": "Request to enable dual fuel mode.\r\n\r\n00 = De-activate dual fuel mode\r\n01 = Activate dual fuel mode\r\n10 = Reserved\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6793": {
      "PGN": 64601,
      "PGN_Name": "Engine Load Sharing Information",
      "PGN_Description": "ELS",
      "first_bit": 0,
      "SPN": 6793,
      "SPN_Name": "Engine Unload Status",
      "SPN_Description": "This signal indicates the status of an external request to unload the engine, such as the external unload request switch.\r\n\r\n00 - Not Requested\r\n01 - Requested\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6794": {
      "PGN": 64601,
      "PGN_Name": "Engine Load Sharing Information",
      "PGN_Description": "ELS",
      "first_bit": 2,
      "SPN": 6794,
      "SPN_Name": "Engine Load Share Status",
      "SPN_Description": "This signal indicates that the status of an engine load sharing feature.\r\n\r\n0000 - Offline\r\n0001 - Master\r\n0010 - Slave\r\n0011 - Loading\r\n0100 - Unloading\r\n0101 -1101 - Reserved\r\n1110 - Error\r\n1111 - Unavailable",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "6796": {
      "PGN": 64971,
      "PGN_Name": "Off-Highway Engine Control Selection",
      "PGN_Description": "OHECS",
      "first_bit": 32,
      "SPN": 6796,
      "SPN_Name": "Engine Torque Curve Selection Command",
      "SPN_Description": "This parameter will allow selection of a torque curve that is higher than the base curve.\r\n\r\n0 - Indicates that this parameter is not presently requesting a different torque curve be used\r\n1 - Indicates that Torque Curve 1 is selected\r\n2 - Indicates that Torque Curve 2 is selected\r\n3 to 13 - Indicates that Torque Curve 3 through 13 is selected\r\n14 - SAE reserved\r\n15 - Not supported",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "6797": {
      "PGN": 64831,
      "PGN_Name": "Aftertreatment 1 SCR Exhaust Gas Pressures",
      "PGN_Description": "A1SCREGP",
      "first_bit": 40,
      "SPN": 6797,
      "SPN_Name": "Aftertreatment 1 SCR Intake Absolute Pressure",
      "SPN_Description": "Used to read the pressure at the catalyst intake of the selective catalytic reduction system of aftertreatment 1.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "6798": {
      "PGN": 64825,
      "PGN_Name": "Aftertreatment 2 SCR Exhaust Gas Pressures",
      "PGN_Description": "A2SCREGP",
      "first_bit": 40,
      "SPN": 6798,
      "SPN_Name": "Aftertreatment 2 SCR Intake Absolute Pressure",
      "SPN_Description": "Used to read the pressure at the catalyst intake of the selective catalytic reduction system of aftertreatment 2.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "6802": {
      "PGN": 64514,
      "PGN_Name": "SCR System Information",
      "PGN_Description": "SCRSI",
      "first_bit": 40,
      "SPN": 6802,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Dosing System Frozen",
      "SPN_Description": "All or part of the diesel exhaust fluid system (DEF tank, DEF supply lines, DEF pump, and DEF doser, etc.) in bank 1 is frozen.\r\n\r\nIn situations where it is desired to report the DEF system frozen as a faulted condition, FMI 31 can be used with this SPN in diagnostic messages. A value of 01 for this parameter does not necessarily mean that a faulted condition exists. But if this SPN is included in a DTC to report a faulted condition, such as the system is frozen and can't be thawed, then this parameter would be expected to be 01.\r\n\r\n00 – DEF system is not frozen\r\n01 – DEF system is frozen\r\n10 – Error\r\n11 – Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6803": {
      "PGN": 64514,
      "PGN_Name": "SCR System Information",
      "PGN_Description": "SCRSI",
      "first_bit": 42,
      "SPN": 6803,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Dosing System Frozen",
      "SPN_Description": "All or part of the diesel exhaust fluid system (DEF tank, DEF supply lines, DEF pump, and DEF doser, etc.) in bank 2 is frozen.\r\n\r\nIn situations where it is desired to report the DEF system frozen as a faulted condition, FMI 31 can be used with this SPN in diagnostic messages. A value of 01 for this parameter does not necessarily mean that a faulted condition exists. But if this SPN is included in a DTC to report a faulted condition, such as the system is frozen and can't be thawed, then this parameter would be expected to be 01.\r\n\r\n00 – DEF system is not frozen\r\n01 – DEF system is frozen\r\n10 – Error\r\n11 – Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6807": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 48,
      "SPN": 6807,
      "SPN_Name": "Engine Desired Torque Request",
      "SPN_Description": "This is the torque that the ECM desires to provide. It is a request made from the ECM to an external system. A valid value within the operating range indicates the engine is requesting an external controller to change the operation of the system so the engine can achieve a specific torque. This will most likely be accomplished by managing the load to the engine, but it is not limited to this method. A value of 0xFB indicates that the parameter is supported but there is no specific torque being requested by the engine.\r\n\r\nThis parameter is in indicated torque as a percent of the reference engine torque. See PGN 65251 for the engine configuration message. Any change in torque as a result of this parameter would be reflected in SPN 513.\r\n\r\nIn the event that an ECM transmits a valid value within the operating range for this parameter and a non-zero value for SPN 3644 at the same time, then the receiving controller should honor SPN 3644 and ignore this parameter.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "6808": {
      "PGN": 65261,
      "PGN_Name": "Cruise Control/Vehicle Speed Setup",
      "PGN_Description": "CCSS",
      "first_bit": 24,
      "SPN": 6808,
      "SPN_Name": "Maximum Vehicle Speed Limit (High Resolution)",
      "SPN_Description": "Maximum vehicle velocity allowed. See SPN 74 for an alternate resolution.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 71
    },
    "6809": {
      "PGN": 64732,
      "PGN_Name": "Cruise Control / Vehicle Speed 3",
      "PGN_Description": "CCVS3",
      "first_bit": 32,
      "SPN": 6809,
      "SPN_Name": "Cruise Control Set Speed (High Resolution)",
      "SPN_Description": "Value of set (chosen) velocity of velocity control system. See SPN 86 for an alternate resolution.\r\n\r\nIf an algorithm that can modify the cruise control set point exists in the system, such as Predictive Cruise Control or Adaptive Cruise Control, then Cruise Control Set Speed (SPN 6809) will not include the speed adjustment made by that algorithm. For the parameter that includes the adjustment, see Cruise Control Speed (SPN 7319) for the final speed used by the cruise control algorithm.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 71
    },
    "6810": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 6,
      "SPN": 6810,
      "SPN_Name": "Hybrid System OBD Related DTC Status",
      "SPN_Description": "Signal from hybrid system indicating the status of OBD related DTCs\r\n\r\n00 - Hybrid System does not have an active OBD related DTC\r\n01 - Hybrid System has an active OBD related DTC\r\n10 - SAE Reserved\r\n11 - Not available\r\n\r\nSee \"SPN 6810\" in the supporting documentation tab for a description of the \"Concept of Operation\".",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6811": {
      "PGN": 64600,
      "PGN_Name": "Turbocharger Information 7",
      "PGN_Description": "TCI7",
      "first_bit": 0,
      "SPN": 6811,
      "SPN_Name": "Engine Turbocharger 2 Lube Oil Pressure",
      "SPN_Description": "Gage pressure of oil in the lubrication system for the 2nd turbocharger.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "6812": {
      "PGN": 64600,
      "PGN_Name": "Turbocharger Information 7",
      "PGN_Description": "TCI7",
      "first_bit": 8,
      "SPN": 6812,
      "SPN_Name": "Engine Turbocharger 3 Lube Oil Pressure",
      "SPN_Description": "Gage pressure of oil in the lubrication system for the 3rd turbocharger.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "6813": {
      "PGN": 64600,
      "PGN_Name": "Turbocharger Information 7",
      "PGN_Description": "TCI7",
      "first_bit": 16,
      "SPN": 6813,
      "SPN_Name": "Engine Turbocharger 4 Lube Oil Pressure",
      "SPN_Description": "Gage pressure of oil in the lubrication system for the 4th turbocharger.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "6814": {
      "PGN": 65277,
      "PGN_Name": "Alternate Fuel 1",
      "PGN_Description": "AF1",
      "first_bit": 24,
      "SPN": 6814,
      "SPN_Name": "Engine Gaseous Fuel Vent Pressure",
      "SPN_Description": "Gaseous fuel pressure through a vent pipe.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "6815": {
      "PGN": 64655,
      "PGN_Name": "Alternate Fuel 3",
      "PGN_Description": "AF3",
      "first_bit": 24,
      "SPN": 6815,
      "SPN_Name": "Gaseous Fuel Accumulator Temperature",
      "SPN_Description": "Gaseous fuel temperature at the outlet of the Gas Filter.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "6816": {
      "PGN": 64735,
      "PGN_Name": "Engine Fluid Level/Pressure 12",
      "PGN_Description": "EFL/P12",
      "first_bit": 32,
      "SPN": 6816,
      "SPN_Name": "Engine Fuel Return Pressure",
      "SPN_Description": "Used to read fuel (or gas) pressure passing through the return line.",
      "bit_length": 8,
      "scaling": 1.64,
      "offset": -7,
      "unit": "kPa",
      "SLOT_ID": 246
    },
    "6817": {
      "PGN": 64599,
      "PGN_Name": "SCR Operator Inducement Information 1",
      "PGN_Description": "SCROII1",
      "first_bit": 0,
      "SPN": 6817,
      "SPN_Name": "Diesel Exhaust Fluid Tank 1 Empty Time",
      "SPN_Description": "Indicates the time the Diesel Exhaust Fluid Tank 1 Level is indicated as empty. This will accumulate over the life of the product and will never be reset.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "6818": {
      "PGN": 64599,
      "PGN_Name": "SCR Operator Inducement Information 1",
      "PGN_Description": "SCROII1",
      "first_bit": 32,
      "SPN": 6818,
      "SPN_Name": "Diesel Exhaust Fluid Quality Malfunction Time",
      "SPN_Description": "Indicates the amount of time an error has been active due to detection of low Diesel Exhaust Fluid Quality. This will accumulate over the life of the product and will never be reset.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "6819": {
      "PGN": 64598,
      "PGN_Name": "SCR Operator Inducement Information 2",
      "PGN_Description": "SCROII2",
      "first_bit": 0,
      "SPN": 6819,
      "SPN_Name": "Aftertreatment SCR Malfunction Time",
      "SPN_Description": "Indicates the amount of time an error condition has been active due to a malfunction in the Aftertreatment SCR system.\r\n\r\nThe source of the malfunction condition could be a component failure, detection of tampering, or other reason that prevents normal operation. This will accumulate over the life of the product and will never be reset.\r\n\r\nAlthough frozen DEF may prevent the Aftertreatment SCR system from operating normally, frozen DEF is not considered a malfunction for the purpose of this parameter. Refer to SPN 7938 for DEF frozen time.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "6820": {
      "PGN": 53248,
      "PGN_Name": "Cab Illumination Message",
      "PGN_Description": "CL",
      "first_bit": 16,
      "SPN": 6820,
      "SPN_Name": "Switch Indication Illumination Brightness Percent",
      "SPN_Description": "Commanded switch indication illumination brightness level for all operator control switches. This is separate from the cab display illumination Brightness Percent parameter.\r\n\r\nNote: If a single device is used to control both the indication brightness level of the cab display and switches, see SPN 1487.  For switch backlight control, see SPN 5532.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6821": {
      "PGN": 65133,
      "PGN_Name": "Heater Information",
      "PGN_Description": "HTR",
      "first_bit": 40,
      "SPN": 6821,
      "SPN_Name": "ADR Compliant Heater Installation",
      "SPN_Description": "Indicates that the heater is installed in an ADR compliant vehicle.   \r\n\r\n00 -  Heater installation is not ADR compliant\r\n01 -  Heater installation is ADR compliant\r\n10 -  Error\r\n11 -  Not Available\r\n\r\nNote:  ADR is a European agreement concerning the international carriage of dangerous goods. developed by UN-ECE.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6829": {
      "PGN": 33792,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Control",
      "PGN_Description": "AFT1PSC",
      "first_bit": 24,
      "SPN": 6829,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Exhaust Velocity",
      "SPN_Description": "Velocity of the exhaust gas near the particulate sensor.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 71
    },
    "6830": {
      "PGN": 65180,
      "PGN_Name": "Main Bearing Temperature 3",
      "PGN_Description": "MBT3",
      "first_bit": 48,
      "SPN": 6830,
      "SPN_Name": "Engine Main Bearing 12 Temperature",
      "SPN_Description": "Temperature of the main bearing which supports the crankshaft of the engine.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "6831": {
      "PGN": 65246,
      "PGN_Name": "Engine Air Start Pressure",
      "PGN_Description": "AIR2",
      "first_bit": 8,
      "SPN": 6831,
      "SPN_Name": "Engine Air Start Pressure (Extended Range)",
      "SPN_Description": "Gage pressure of air in an engine starting system that utilizes compressed air to provide the force required to rotate the crankshaft.\r\n\r\nSee SPN 82 for higher resolution.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 49
    },
    "6832": {
      "PGN": 65246,
      "PGN_Name": "Engine Air Start Pressure",
      "PGN_Description": "AIR2",
      "first_bit": 16,
      "SPN": 6832,
      "SPN_Name": "Engine Air Stop Pressure",
      "SPN_Description": "Gage pressure of air in an engine stopping system that utilizes compressed air to provide the force required to stop the crankshaft. Engine stopping air is typically used for emergency engine stopping.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "6833": {
      "PGN": 34560,
      "PGN_Name": "Engine State Requests",
      "PGN_Description": "ESR",
      "first_bit": 2,
      "SPN": 6833,
      "SPN_Name": "Engine Gaseous Fuel Usage Inhibited",
      "SPN_Description": "Used to request that the engine should not be allowed to use gaseous fuel for engine cylinder combustion. This state is relevant for dual fuel systems and would be used when conditions are detected that make it unsafe or not appropriate to use gaseous fuel at that time.\r\n\r\n00 - Gaseous Fuel Usage Not Inhibited\r\n01 - Gaseous Fuel Usage Inhibited\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6834": {
      "PGN": 64595,
      "PGN_Name": "Engine Gaseous Leakage Information",
      "PGN_Description": "EGLI",
      "first_bit": 0,
      "SPN": 6834,
      "SPN_Name": "Gaseous Fuel Leakage 1 Concentration",
      "SPN_Description": "Percentage of detected gaseous fuel leak compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit. 0% means no detected gaseous fuel in measurement point. The measurement point is typically in the engine crankcase.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "6835": {
      "PGN": 64595,
      "PGN_Name": "Engine Gaseous Leakage Information",
      "PGN_Description": "EGLI",
      "first_bit": 8,
      "SPN": 6835,
      "SPN_Name": "Gaseous Fuel Leakage 2 Concentration",
      "SPN_Description": "Percentage of detected gaseous fuel leak compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit. 0% means no detected gaseous fuel in measurement point. The second  measurement point is either another location in the engine crankcase or a separate leak detection point outside the engine.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "6836": {
      "PGN": 64595,
      "PGN_Name": "Engine Gaseous Leakage Information",
      "PGN_Description": "EGLI",
      "first_bit": 16,
      "SPN": 6836,
      "SPN_Name": "Gaseous Fuel Leakage 3 Concentration",
      "SPN_Description": "Percentage of detected gaseous fuel leak compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit. 0% means no detected gaseous fuel in measurement point. The third measurement point is in a separate leak detection point outside the engine.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "6837": {
      "PGN": 64595,
      "PGN_Name": "Engine Gaseous Leakage Information",
      "PGN_Description": "EGLI",
      "first_bit": 24,
      "SPN": 6837,
      "SPN_Name": "Gas Leakage Detection 1 Pressure",
      "SPN_Description": "Pressure measured in gas leakage detection point 1. Measured media is of the gas, meaning it could be air, inert gas, fuel air mixture or charge air mixture, depending on the failure mode detected. The measurement point is typically in the engine crankcase.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "6838": {
      "PGN": 64595,
      "PGN_Name": "Engine Gaseous Leakage Information",
      "PGN_Description": "EGLI",
      "first_bit": 32,
      "SPN": 6838,
      "SPN_Name": "Gas Leakage Detection 2 Pressure",
      "SPN_Description": "Pressure measured in gas leakage detection point 2. Measured media is of the gas, meaning it could be air, inert gas, fuel air mixture or charge air mixture, depending on the failure mode detected. The second measurement point is either another location in the engine crankcase or a separate leak detection point outside the engine.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "6839": {
      "PGN": 64595,
      "PGN_Name": "Engine Gaseous Leakage Information",
      "PGN_Description": "EGLI",
      "first_bit": 40,
      "SPN": 6839,
      "SPN_Name": "Gas Leakage Detection 3 Pressure",
      "SPN_Description": "Pressure measured in gas leakage detection point 3. Measured media is of the gas, meaning it could be air, inert gas, fuel air mixture or charge air mixture, depending on the failure mode detected. The third measurement point is in a separate leak detection point outside the engine.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "6840": {
      "PGN": 64594,
      "PGN_Name": "Bin Weight and Lift Count",
      "PGN_Description": "BWLN",
      "first_bit": 8,
      "SPN": 6840,
      "SPN_Name": "Bin Lift Count",
      "SPN_Description": "Increments with each lift, whether or not net bin weight changes.  The count rolls over at data range limit.\r\n\r\nThe count can be reset using SPN 6898 in PGN 56832.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "6841": {
      "PGN": 64594,
      "PGN_Name": "Bin Weight and Lift Count",
      "PGN_Description": "BWLN",
      "first_bit": 24,
      "SPN": 6841,
      "SPN_Name": "Net Bin Weight",
      "SPN_Description": "Mass of bin contents at most recent unload",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 28
    },
    "6842": {
      "PGN": 64594,
      "PGN_Name": "Bin Weight and Lift Count",
      "PGN_Description": "BWLN",
      "first_bit": 4,
      "SPN": 6842,
      "SPN_Name": "Bin Weighing Error Status",
      "SPN_Description": "Bin weighing error status\r\n\r\n0 = No error\r\n1 = Bad lift cycle\r\n2 = Weighing error: bin lifted, not emptied\r\n3 = Weighing error: empty bin lifted, emptied\r\n4 - 14 = Reserved\r\n15 = Not available / not applicable",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "6843": {
      "PGN": 64593,
      "PGN_Name": "Air Suspension Control 7",
      "PGN_Description": "ASC7",
      "first_bit": 0,
      "SPN": 6843,
      "SPN_Name": "Lift Axle 1 Status",
      "SPN_Description": "Indicates the status of a tag axle 1.  Numbering of lift/tag axles starts at front axle.  SPN 1743 may be used if less detail is acceptable.\r\n\r\n000 - Down (tag axle is laden)\r\n001 - Unloading (load is being transferred from the tag axle)\r\n010 - Lifting (tag axle is moving up)\r\n011 - Up (tag axle is up and stationary)\r\n100 - Lowering (tag axle is moving down)\r\n101 - Loading (load is being transferred to the tag axle)\r\n110 - Error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "6844": {
      "PGN": 64593,
      "PGN_Name": "Air Suspension Control 7",
      "PGN_Description": "ASC7",
      "first_bit": 3,
      "SPN": 6844,
      "SPN_Name": "Lift Axle 2 Status",
      "SPN_Description": "Indicates the status of a tag axle 2.  Numbering of lift/tag axles starts at front axle.  SPN 1822 may be used if less detail is acceptable.\r\n\r\n000 - Down (tag axle is laden)\r\n001 - Unloading (load is being transferred from the tag axle)\r\n010 - Lifting (tag axle is moving up)\r\n011 - Up (tag axle is up and stationary)\r\n100 - Lowering (tag axle is moving down)\r\n101 - Loading (load is being transferred to the tag axle)\r\n110 - Error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "6845": {
      "PGN": 64594,
      "PGN_Name": "Bin Weight and Lift Count",
      "PGN_Description": "BWLN",
      "first_bit": 0,
      "SPN": 6845,
      "SPN_Name": "Bin Instance",
      "SPN_Description": "Gives the instance of the bin on the vehicle whose parameters are transmitted in the remainder of the PGN, with the first or only bin as instance 1.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 220
    },
    "6846": {
      "PGN": 64671,
      "PGN_Name": "Dash Display 2",
      "PGN_Description": "DD2",
      "first_bit": 48,
      "SPN": 6846,
      "SPN_Name": "Display Remain Powered",
      "SPN_Description": "Indicates the ECU needs the display (i.e. monitor device) to continue to remain powered after ignition key off. An ECU would use this when the ECU needs the display to remain powered after key off so the ECU can communicate to the operator while the ECU is performing certain activities after key off, such as an aftertreatment regeneration.\r\n\r\nFunctionally, the display would remain powered after key off if it receives the 'Remain Powered' status prior to the key off event and would continue to remain powered after key off while it continues to receive this parameter with the 'Remain Powered' status or it stops receiving this parameter from the ECU.\r\n\r\nThe 'Remain Powered' state indicates the ECU needs the monitor to remain powered after key off.\r\nThe 'OK to Shutoff' state indicates the ECU does not need the monitor to stay powered after key off.\r\n\r\n00 = OK to Shutoff\r\n01 = Remain Powered\r\n10 = Reserved\r\n11 = Don't care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6847": {
      "PGN": 64592,
      "PGN_Name": "Payload System Status",
      "PGN_Description": "PLSS",
      "first_bit": 0,
      "SPN": 6847,
      "SPN_Name": "Haul Cycle Count",
      "SPN_Description": "A counter incremented by 1 with each instance of a new haul cycle, defined as a dump to dump cycle. The counter shall increment from 0 to 64255, rolling over to 0 on the next increment after 64255.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "6848": {
      "PGN": 64592,
      "PGN_Name": "Payload System Status",
      "PGN_Description": "PLSS",
      "first_bit": 16,
      "SPN": 6848,
      "SPN_Name": "Haul Mode Status",
      "SPN_Description": "The current operating state of the haul cycle.\r\n\r\n0000 - Not in Haul Mode\r\n0001 - Loading -- Payload is being added to the machine\r\n0010 - Approaching Loaded -- Machine is near its maximum capacity\r\n0011 - Loaded -- Loading operation has been completed\r\n0100 - Unloading -- Payload is being removed from the machine\r\n0101 - Unloaded -- Machine is empty\r\n0111 to 1011 - Reserved for Future Assignment by SAE\r\n1110 - Error\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "6849": {
      "PGN": 64592,
      "PGN_Name": "Payload System Status",
      "PGN_Description": "PLSS",
      "first_bit": 24,
      "SPN": 6849,
      "SPN_Name": "Delivered Payload Weight",
      "SPN_Description": "The delivered payload mass during the last haul cycle. This is the amount of material moved and delivered by a machine is a key work cycle parameter.\r\n\r\nDelivered payload weight is defined as the last loaded weight less the carry back weight (material left in the machine after unloading).",
      "bit_length": 24,
      "scaling": 2,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 122
    },
    "6850": {
      "PGN": 64592,
      "PGN_Name": "Payload System Status",
      "PGN_Description": "PLSS",
      "first_bit": 48,
      "SPN": 6850,
      "SPN_Name": "Delivered Payload Confidence",
      "SPN_Description": "The level of confidence of the delivered payload weight measurement. Higher confidence values indicate greater probability the delivered payload weight is the actual weight and providing feedback on the potential for improving system accuracy.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "6851": {
      "PGN": 64996,
      "PGN_Name": "Equipment Performance Data",
      "PGN_Description": "EPD",
      "first_bit": 8,
      "SPN": 6851,
      "SPN_Name": "Payload Weight",
      "SPN_Description": "The current payload weight carried by the machine.",
      "bit_length": 24,
      "scaling": 2,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 122
    },
    "6852": {
      "PGN": 64996,
      "PGN_Name": "Equipment Performance Data",
      "PGN_Description": "EPD",
      "first_bit": 32,
      "SPN": 6852,
      "SPN_Name": "Payload Weight Confidence",
      "SPN_Description": "The level of confidence of the real time payload weight measurement (SPN 6851). Higher confidence values indicate greater probability the real time payload weight is the actual weight and providing feedback on the potential for improving system accuracy.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "6853": {
      "PGN": 64996,
      "PGN_Name": "Equipment Performance Data",
      "PGN_Description": "EPD",
      "first_bit": 40,
      "SPN": 6853,
      "SPN_Name": "Payload Carry Back Weight",
      "SPN_Description": "The payload weight left on the machine after the last payload dump event.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 28
    },
    "6854": {
      "PGN": 64996,
      "PGN_Name": "Equipment Performance Data",
      "PGN_Description": "EPD",
      "first_bit": 56,
      "SPN": 6854,
      "SPN_Name": "Payload Capacity Percentage",
      "SPN_Description": "The current equipment payload plus the weight of any after-factory modifications reported as a percentage of the equipment's maximum payload capacity. The equipment's maximum payload capacity is the maximum capacity of the equipment before the added weight of any after-factory modifications.\r\n\r\nThis differs from Payload Percentage (SPN 2600) as SPN 2600 is the current equipment payload reported as a percentage of the rated payload limit (i.e. payload reduced for added weight of any after-factory modification).\r\n\r\n0% = factory clean unloaded weight, 100% = fully loaded.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "6855": {
      "PGN": 64591,
      "PGN_Name": "Payload Weight Sensor Information",
      "PGN_Description": "PWSI",
      "first_bit": 0,
      "SPN": 6855,
      "SPN_Name": "Payload Weight Sensor 1 Status",
      "SPN_Description": "Status of the payload system sensor 1 measurement.\r\n\r\n00 = Sensor fully functional\r\n01 = Sensor degraded\r\n10 = Error (Sensor failed)\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6856": {
      "PGN": 64591,
      "PGN_Name": "Payload Weight Sensor Information",
      "PGN_Description": "PWSI",
      "first_bit": 2,
      "SPN": 6856,
      "SPN_Name": "Payload Weight Sensor 2 Status",
      "SPN_Description": "Status of the payload system sensor 2 measurement.\r\n\r\n00 = Sensor fully functional\r\n01 = Sensor degraded\r\n10 = Error (Sensor failed)\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6857": {
      "PGN": 64591,
      "PGN_Name": "Payload Weight Sensor Information",
      "PGN_Description": "PWSI",
      "first_bit": 4,
      "SPN": 6857,
      "SPN_Name": "Payload Weight Sensor 3 Status",
      "SPN_Description": "Status of the payload system sensor 3 measurement.\r\n\r\n00 = Sensor fully functional\r\n01 = Sensor degraded\r\n10 = Error (Sensor failed)\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6858": {
      "PGN": 64591,
      "PGN_Name": "Payload Weight Sensor Information",
      "PGN_Description": "PWSI",
      "first_bit": 6,
      "SPN": 6858,
      "SPN_Name": "Payload Weight Sensor 4 Status",
      "SPN_Description": "Status of the payload system sensor 4 measurement.\r\n\r\n00 = Sensor fully functional\r\n01 = Sensor degraded\r\n10 = Error (Sensor failed)\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6859": {
      "PGN": 64591,
      "PGN_Name": "Payload Weight Sensor Information",
      "PGN_Description": "PWSI",
      "first_bit": 8,
      "SPN": 6859,
      "SPN_Name": "Payload Weight Sensor 5 Status",
      "SPN_Description": "Status of the payload system sensor 5 measurement.\r\n\r\n00 = Sensor fully functional\r\n01 = Sensor degraded\r\n10 = Error (Sensor failed)\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6860": {
      "PGN": 64591,
      "PGN_Name": "Payload Weight Sensor Information",
      "PGN_Description": "PWSI",
      "first_bit": 10,
      "SPN": 6860,
      "SPN_Name": "Payload Weight Sensor 6 Status",
      "SPN_Description": "Status of the payload system sensor 6 measurement.\r\n\r\n00 = Sensor fully functional\r\n01 = Sensor degraded\r\n10 = Error (Sensor failed)\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6861": {
      "PGN": 64591,
      "PGN_Name": "Payload Weight Sensor Information",
      "PGN_Description": "PWSI",
      "first_bit": 12,
      "SPN": 6861,
      "SPN_Name": "Payload Weight Sensor 7 Status",
      "SPN_Description": "Status of the payload system sensor 7 measurement.\r\n\r\n00 = Sensor fully functional\r\n01 = Sensor degraded\r\n10 = Error (Sensor failed)\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6862": {
      "PGN": 64591,
      "PGN_Name": "Payload Weight Sensor Information",
      "PGN_Description": "PWSI",
      "first_bit": 14,
      "SPN": 6862,
      "SPN_Name": "Payload Weight Sensor 8 Status",
      "SPN_Description": "Status of the payload system sensor 8 measurement.\r\n\r\n00 = Sensor fully functional\r\n01 = Sensor degraded\r\n10 = Error (Sensor failed)\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6871": {
      "PGN": 33536,
      "PGN_Name": "Payload Calibration Information Command",
      "PGN_Description": "PCIC",
      "first_bit": 0,
      "SPN": 6871,
      "SPN_Name": "Payload Calibration Set Point Command",
      "SPN_Description": "Specifies the current payload point being calibrated. The data specified in the 'Payload Calibration Commanded Weight' SPN (SPN 6872) or 'Payload Correction Factor Command' SPN (SPN 6873) shall be used for calibrating this specified payload point. When used with the 'Payload Calibration Commanded Weight' SPN (SPN 6872), it is possible to calibrate multiple points of the Payload Measurement system by loading the machine with up to 10 known calibration loads. When used with the Payload Correction Factor Command' SPN (SPN 6873), it is possible to adjust the calibrations for multiple points of the Payload Measurement system by specifying the system gain.\r\n\r\nMultipoint calibration of the Payload Measurement system is perfomed by loading the machine with up to 10 known calibration loads. For each calibration load the Payload Calibration Information Command PGN is sent with Payload Calibration Set Point Command SPN identifying the calibration point and the Payload Calibration Commanded Weight SPN holding the value of the load.\r\n\r\nZero Point is used for empty which also sets the empty tare offset. End point identifies the last point.\r\n\r\n0000 = Zero Point\r\n0001 = Calibration Reference Point 1\r\n0010 = Calibration Reference Point 2\r\n0011 = Calibration Reference Point 3\r\n0100 = Calibration Reference Point 4\r\n0101 = Calibration Reference Point 5\r\n0110 = Calibration Reference Point 6\r\n0111 = Calibration Reference Point 7\r\n1000 = Calibration Reference Point 8\r\n1001 = Calibration Reference Point 9\r\n1010 = End Point\r\n1011 = Correction Point\r\n1100 = Reset Calibration\r\n1101 = Reserved\r\n1110 = Error\r\n1111 = Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "6872": {
      "PGN": 33536,
      "PGN_Name": "Payload Calibration Information Command",
      "PGN_Description": "PCIC",
      "first_bit": 8,
      "SPN": 6872,
      "SPN_Name": "Payload Calibration Commanded Weight",
      "SPN_Description": "The true known mass of real load weight applicable for the calibration point specified in SPN 6871 and used for calibrating Payload system.\r\n\r\nMultipoint calibration of the Payload Measurement system is perfomed by loading the machine with up to 10 known calibration loads. For each calibration load the Payload Calibration Information Command PGN is sent with Payload Calibration Set Point Command SPN identifying the calibration point and the Payload Calibration Commanded Weight SPN holding the value of the load.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 28
    },
    "6873": {
      "PGN": 33536,
      "PGN_Name": "Payload Calibration Information Command",
      "PGN_Description": "PCIC",
      "first_bit": 24,
      "SPN": 6873,
      "SPN_Name": "Payload Correction Factor Command",
      "SPN_Description": "The payload correction factor is used to fine tune the sensor gain value.\r\n\r\nCorrection factor calibration of the Payload Measurement system is performed through a Payload Calibration Set Point SPN value of Correction Point and the Payload Correction Factor SPN value set to modify the current gain of the system by the required amount in %.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "6874": {
      "PGN": 34048,
      "PGN_Name": "Cab Message 2",
      "PGN_Description": "CM2",
      "first_bit": 8,
      "SPN": 6874,
      "SPN_Name": "Performance Bias Selection",
      "SPN_Description": "Indicates the operating bias toward performance of the power source.\r\n\r\n0% Functionality is biased toward fuel economy as much as possible.\r\n50% Functionality is biased toward neither fuel economy or performance.\r\n100% Functionality is biased toward performance as much as possible.\r\n\r\nFor values between 0% and 50%, functionality is biased toward fuel economy, with values closer to 0% indicating more bias toward fuel economy.\r\n\r\nFor values between 50% and 100%, functionality is biased toward performance, with values closer to 100% indicating more bias toward performance.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "6875": {
      "PGN": 64590,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 3",
      "PGN_Description": "A1SCRDSI3",
      "first_bit": 0,
      "SPN": 6875,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Doser Pressure",
      "SPN_Description": "The SCR dosing diesel exhaust fluid gage pressure (measured closest to dosing valve) for aftertreatment system 1 (exhaust bank 1). This is the gage equivalent to SPN 4334.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "6876": {
      "PGN": 64589,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 3",
      "PGN_Description": "A2SCRDSI3",
      "first_bit": 0,
      "SPN": 6876,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Doser Pressure",
      "SPN_Description": "The SCR dosing diesel exhaust fluid gage pressure (measured closest to dosing valve) for aftertreatment system 2 (exhaust bank 2). This is the gage equivalent to SPN 4387.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "6877": {
      "PGN": 64588,
      "PGN_Name": "SCR Operator Inducement Information 3",
      "PGN_Description": "SCROII3",
      "first_bit": 0,
      "SPN": 6877,
      "SPN_Name": "SCR Operator Inducement Override Enable",
      "SPN_Description": "Indicates if an operator inducement derate is allowed to be overridden.\r\n\r\nNote: Inducement override is only allowed under certain conditions approved by EPA/ARB.\r\n\r\n00 Override not allowed\r\n01 Override allowed\r\n10 SAE Reserved\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6878": {
      "PGN": 64588,
      "PGN_Name": "SCR Operator Inducement Information 3",
      "PGN_Description": "SCROII3",
      "first_bit": 8,
      "SPN": 6878,
      "SPN_Name": "SCR Operator Inducement Override Time Remaining",
      "SPN_Description": "This parameter is used to indicate the time remaining during an operator inducement override event.  See also SPN 7344 for an alternate SLOT.\r\n\r\nWhen an operator inducement is not active, this parameter indicates the maximum time that an operator inducement may be overridden.  When an operator inducement is active this parameter indicates the remaining time that the currently\r\nactive operator inducement may be overridden.\r\n\r\nSee EU Commission directive 2012/46/EU. Appendix 1 Section 5.5 for more information.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 64
    },
    "6879": {
      "PGN": 64588,
      "PGN_Name": "SCR Operator Inducement Information 3",
      "PGN_Description": "SCROII3",
      "first_bit": 24,
      "SPN": 6879,
      "SPN_Name": "Number of SCR Operator Inducement Override Events Remaining",
      "SPN_Description": "During an operator inducement event, the operator may be able to override the inducement multiple times. This parameter indicates the remaining number of times that the currently active inducement can be overridden during an operator inducement event. When this number has decremented to 0, then the operator can no longer override the current operator inducement event. \r\n\r\nThis value will reset to the maximum number of allowed overrides once the inducement event is no longer active.\r\n\r\nThis parameter shall never increment when an operator inducement is active.\r\n\r\nSee EU Commission directive 2012/46/EU. Appendix 1 Section 5.5 for more information.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "6880": {
      "PGN": 64588,
      "PGN_Name": "SCR Operator Inducement Information 3",
      "PGN_Description": "SCROII3",
      "first_bit": 32,
      "SPN": 6880,
      "SPN_Name": "Total Number of SCR Operator Inducement Override Events",
      "SPN_Description": "Indicates total number of operator inducement override events activated throughout the lifetime of engine operation.\r\n\r\nThis number will remain at the maximum value once it is reached.\r\n\r\nSee EU Commission directive 2012/46/EU. Appendix 1 Section 5.5 for more information.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "6881": {
      "PGN": 34048,
      "PGN_Name": "Cab Message 2",
      "PGN_Description": "CM2",
      "first_bit": 16,
      "SPN": 6881,
      "SPN_Name": "SCR Operator Inducement Override Switch",
      "SPN_Description": "The position of the operator inducement override switch. This switch function allows the operator to override an operator inducement derate.\r\n\r\nSee EU Commission directive 2012/46/EU. Appendix 1 Section 5.5 for more information.\r\n\r\n00 Off\r\n01 On\r\n10 Error\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6884": {
      "PGN": 64914,
      "PGN_Name": "Engine Operating Information",
      "PGN_Description": "EOI",
      "first_bit": 46,
      "SPN": 6884,
      "SPN_Name": "Engine Cold Ambient Elevated Idle Status",
      "SPN_Description": "Indicates that the engine is elevating the idle speed due to cold strategies.\r\n\r\n00 No Idle Elevation Active - standard idle speed\r\n01 Idle Elevation Active\r\n10 Reserved for SAE assignment\r\n11 Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6885": {
      "PGN": 61709,
      "PGN_Name": "Fuel Information 6 (Gaseous)",
      "PGN_Description": "GFI6",
      "first_bit": 0,
      "SPN": 6885,
      "SPN_Name": "Engine Fuel Valve 2 Differential Pressure",
      "SPN_Description": "The differential pressure between the intake and the outlet of the second gaseous fuel valve.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "6893": {
      "PGN": 64587,
      "PGN_Name": "Electronic Engine Controller 17",
      "PGN_Description": "EEC17",
      "first_bit": 0,
      "SPN": 6893,
      "SPN_Name": "PEMS Engine Fuel Mass Flow Rate",
      "SPN_Description": "PEMS Engine Fuel Mass Flow Rate shall indicate the amount of fuel consumed by the engine per unit of time (does not include fuel injected directly into the aftertreatment system, but does include fuel injected into the engine cylinders for the purpose of being used in the aftertreatment system), in grams per second.\r\n\r\nPEMS Engine Fuel Mass Flow Rate shall be calculated as the sum of the fuel consumed over the last one second prior to the time when PEMS Engine Fuel Mass Flow Rate is updated.\r\n\r\nNOTE: PEMS Engine Fuel Mass Flow Rate shall indicate zero g/s when the engine is not running.",
      "bit_length": 16,
      "scaling": 0.02,
      "offset": 0,
      "unit": "g/s",
      "SLOT_ID": 396
    },
    "6894": {
      "PGN": 64587,
      "PGN_Name": "Electronic Engine Controller 17",
      "PGN_Description": "EEC17",
      "first_bit": 16,
      "SPN": 6894,
      "SPN_Name": "Vehicle Fuel Rate",
      "SPN_Description": "Vehicle Fuel Rate shall indicate the amount of fuel consumed by the engine and fuel injected directly into the aftertreatment system per unit of time, in grams per second.\r\n\r\nVehicle Fuel Rate shall be calculated as the sum of the fuel consumed over the last 1 second prior to the time when Vehicle Fuel Rate is updated.\r\n\r\nNOTE: Vehicle Fuel Rate shall indicate zero g/s when the engine is not running.",
      "bit_length": 16,
      "scaling": 0.02,
      "offset": 0,
      "unit": "g/s",
      "SLOT_ID": 396
    },
    "6895": {
      "PGN": 64587,
      "PGN_Name": "Electronic Engine Controller 17",
      "PGN_Description": "EEC17",
      "first_bit": 32,
      "SPN": 6895,
      "SPN_Name": "Engine Exhaust Flow Rate",
      "SPN_Description": "Engine Exhaust Flow Rate shall indicate the measured/calculated exhaust gas mass flow upstream of the aftertreatment system.\r\n\r\nEngine Exhaust Flow Rate shall be calculated as the average exhaust flow rate over the last 1000 milliseconds prior to the time when Engine Exhaust Flow Rate is updated, multiplied by 3600 in order to convert the units from seconds to hours.\r\n\r\nNOTE: Engine Exhaust Flow Rate shall indicate zero kg/h when the engine is not running.\r\n\r\nSee SPN 7852 for alternative range.",
      "bit_length": 16,
      "scaling": 0.2,
      "offset": 0,
      "unit": "kg/h",
      "SLOT_ID": 397
    },
    "6896": {
      "PGN": 64712,
      "PGN_Name": "Electronic Engine Controller 13",
      "PGN_Description": "EEC13",
      "first_bit": 32,
      "SPN": 6896,
      "SPN_Name": "Engine Fueling Inhibit Request Count",
      "SPN_Description": "A signal issued by the engine control system indicating the number of devices from which the engine control system has received a “fueling not desired” request. Requests included in this count are either from an external device via SPN 5793 Desired Engine Fueling State equal to “00 – Fueling not desired” or from internal logic within the engine control system acting similar to an external request.\r\n\r\nMultiple engine internal requests are counted as a single device (the engine control system itself). Internal requests reflected in this parameter are limited to those with the intent of temporarily suspending engine operation.\r\n\r\nPermanent shutdown intent, for example from the key switch or engine protection logic, is not reflected in this signal. Operating states where the engine control system suspends fueling without the intent for temporary shutdown (i.e. motoring above minimum idle speed) are also not reflected in this signal.\r\n\r\n0 to 10    Number of active fueling inhibit requests\r\n11            More than 10 active fueling inhibit requests\r\n12 to 14  SAE Reserved\r\n15            Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "6897": {
      "PGN": 64712,
      "PGN_Name": "Electronic Engine Controller 13",
      "PGN_Description": "EEC13",
      "first_bit": 36,
      "SPN": 6897,
      "SPN_Name": "Engine Fueling Desired Request Count",
      "SPN_Description": "A signal issued by the engine control system indicating the number of devices from which the engine control system has received a “fueling desired” request. Requests included in this count are either from an external device via SPN 5793 Desired Engine Fueling State equal to “01 – Fueling desired” or from internal logic within the engine control system acting similar to an external request.\r\n\r\nMultiple engine internal requests are counted as a single device (the engine control system itself). Internal requests reflected in this parameter are limited to those with the intent of preventing temporary suspension of engine operation.\r\n\r\nEngine internal “fueling desired” requests that lead to the engine broadcasting SPN 5795  Engine Fueling Inhibit Allowed equal to “00 - Engine currently will not stop fueling in response to SPN 5793 Desired Engine Fueling State”, with reason given in SPN 5866 Engine Fueling Inhibit Prevented Reason and/or SPN 8145 Engine Fueling Inhibit Prevented Reason Extension are not reflected in this parameter.\r\n\r\n0 to 10             Number of active fueling desired requests\r\n11                    More than 10 active fueling desired requests\r\n12 to 14          SAE Reserved\r\n15                    Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "6898": {
      "PGN": 56832,
      "PGN_Name": "Reset",
      "PGN_Description": "RESET",
      "first_bit": 24,
      "SPN": 6898,
      "SPN_Name": "Bin Lift Count Reset",
      "SPN_Description": "Used to reset the bin lift count as reported in PGN 64594.\r\n\r\n00 Do not reset\r\n01 Reset\r\n10 Reserved\r\n11 Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6899": {
      "PGN": 64775,
      "PGN_Name": "Direct Lamp Control Command 1",
      "PGN_Description": "DLCC1",
      "first_bit": 34,
      "SPN": 6899,
      "SPN_Name": "Vehicle Acceleration Rate Limit Lamp Command",
      "SPN_Description": "Command signal directly controlling the Vehicle Acceleration Rate Limit Lamp.\r\n\r\n00 - Lamp Off\r\n01 - Lamp On\r\n10 - Reserved\r\n11 - Not available\r\n\r\nNOTE: SPN 2979 is the original parameter used to provide vehicle acceleration rate limit status.  This parameter is intended for vehicle systems in which there is a lamp controller/arbitrator that requires direct lamp control (typically to an instrument cluster).  The effects of emission control limits, such as engine exhaust smoke control, are specifically excluded; they are not considered to be part of a function to limit vehicle acceleration.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6900": {
      "PGN": 64773,
      "PGN_Name": "Direct Lamp Control Data 1",
      "PGN_Description": "DLCD1",
      "first_bit": 34,
      "SPN": 6900,
      "SPN_Name": "Vehicle Acceleration Rate Limit Lamp Data",
      "SPN_Description": "This parameter provides measured data from the Vehicle Acceleration Rate Limit Lamp.\r\n\r\n00 - Lamp deactivated (Off)\r\n01 - Lamp activated (On)\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6914": {
      "PGN": 64664,
      "PGN_Name": "Vehicle Speed Limiter",
      "PGN_Description": "VSL",
      "first_bit": 40,
      "SPN": 6914,
      "SPN_Name": "Soft Top Speed Limit Remaining Continuous Interval Distance",
      "SPN_Description": "Indicates the remaining distance that the vehicle can continuously travel at the Soft Top Speed Limit.  This parameter will decrement while the Soft Top Speed Limit Active (SPN 6370) is 1 and will reset to its maximum allowed value when the Soft Top Speed Limit Active (SPN 6370) changes from inactive to active.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 270
    },
    "6915": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 0,
      "SPN": 6915,
      "SPN_Name": "SCR System Cleaning Lamp Command",
      "SPN_Description": "Command to control the SCR system cleaning lamp.\r\n\r\n000 Off\r\n001 On – solid\r\n010 reserved for SAE assignment \r\n011 reserved for SAE assignment\r\n100 On – fast blink (1 HZ)\r\n101 reserved for SAE assignment\r\n110 reserved for SAE assignment\r\n111 not available\r\n\r\nThis SPN would be “off” when SCR system cleaning lamp is unlit.  The \"on - solid\" should indicate that the SCR system needs to be cleaned at the lowest level of urgency and that operator intervention is required.  The flashing state indicates a more severe condition requiring SCR system cleaning.  \r\n\r\nThis SPN shall not be used to convey information regarding operator switch feedback from SPNs 3695 and 3696.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "6916": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 10,
      "SPN": 6916,
      "SPN_Name": "SCR System Cleaning Status",
      "SPN_Description": "Indicates the state of SCR system cleaning.  This is an aggregate of bank 1 and bank 2.  It is a system status and not individual bank status.\r\n\r\n00 not active\r\n01 active\r\n10 SCR system cleaning is needed - automatically initiated SCR system cleaning imminent\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6917": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 16,
      "SPN": 6917,
      "SPN_Name": "SCR System Cleaning Inhibited Status",
      "SPN_Description": "Indicates the state of SCR system cleaning inhibition.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning or will exit SCR system cleaning.\r\n\r\nIf the reason for inhibiting is not covered by SPNs 6918 thru 6932, a request for a status parameter should be submitted to the SAE Truck and Bus J1939 Request Processing Group to have the reason added.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6918": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 18,
      "SPN": 6918,
      "SPN_Name": "SCR System Cleaning Inhibited Due to Inhibit Switch",
      "SPN_Description": "Indicates the state of SCR system cleaning inhibition due to the SCR system cleaning Inhibit Switch.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6919": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 20,
      "SPN": 6919,
      "SPN_Name": "SCR System Cleaning Inhibited Due to Clutch Disengaged",
      "SPN_Description": "Indicates the state of SCR system cleaning event inhibition due to the clutch being disengaged.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6920": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 22,
      "SPN": 6920,
      "SPN_Name": "SCR System Cleaning Inhibited Due to Service Brake Active",
      "SPN_Description": "Indicates the state of SCR system cleaning inhibition due to the service brake being active.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6921": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 24,
      "SPN": 6921,
      "SPN_Name": "SCR System Cleaning Inhibited Due to PTO Active",
      "SPN_Description": "Indicates the state of SCR system cleaning inhibition due to the PTO being active.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6922": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 26,
      "SPN": 6922,
      "SPN_Name": "SCR System Cleaning Inhibited Due to Accelerator Pedal Off Idle",
      "SPN_Description": "Indicates the state of SCR system cleaning inhibition due to the accelerator pedal being off idle.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6923": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 28,
      "SPN": 6923,
      "SPN_Name": "SCR System Cleaning Inhibited Due to Out of Neutral",
      "SPN_Description": "Indicates the state of SCR system cleaning inhibition due to the accelerator pedal being out of neutral.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6924": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 30,
      "SPN": 6924,
      "SPN_Name": "SCR System Cleaning Inhibited Due to Vehicle Speed Above Allowed Speed",
      "SPN_Description": "Indicates the state of SCR system cleaning inhibition due to the vehicle speed being above an allowed limit.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6925": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 32,
      "SPN": 6925,
      "SPN_Name": "SCR System Cleaning Inhibited Due to Parking Brake Not Set",
      "SPN_Description": "Indicates the state of SCR system cleaning inhibition due to the parking brake being not set.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6926": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 34,
      "SPN": 6926,
      "SPN_Name": "SCR System Cleaning Inhibited Due to Low Exhaust Temperature",
      "SPN_Description": "Indicates the state of SCR system cleaning inhibition due to the exhaust temperature being too low.  This implies that the SCR system is too cold for cleaning.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6927": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 36,
      "SPN": 6927,
      "SPN_Name": "SCR System Cleaning Inhibited Due to System Fault Active",
      "SPN_Description": "Indicates the state of SCR system cleaning inhibition due to a system fault being active.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6928": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 38,
      "SPN": 6928,
      "SPN_Name": "SCR System Cleaning Inhibited Due to System Timeout",
      "SPN_Description": "Indicates the state of SCR system cleaning inhibition due to a system timeout.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6929": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 40,
      "SPN": 6929,
      "SPN_Name": "SCR System Cleaning Inhibited Due to Temporary System Lockout",
      "SPN_Description": "Indicates the state of SCR system cleaning inhibition due to a temporary system lockout.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6930": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 42,
      "SPN": 6930,
      "SPN_Name": "SCR System Cleaning Inhibited Due to Permanent System Lockout",
      "SPN_Description": "Indicates the state of SCR system cleaning inhibition due to a permanent system lockout.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6931": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 44,
      "SPN": 6931,
      "SPN_Name": "SCR System Cleaning Inhibited Due to Engine Not Warmed Up",
      "SPN_Description": "Indicates the state of SCR system cleaning inhibition due to the engine not being warmed up.\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6932": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 46,
      "SPN": 6932,
      "SPN_Name": "SCR System Cleaning Inhibited Due to Vehicle Speed Below Allowed Speed",
      "SPN_Description": "Indicates the state of SCR system cleaning inhibition due to the vehicle speed being less than the allowed vehicle speed.\r\r\n\r\n00 not inhibited\r\n01 inhibited\r\n10 reserved for SAE assignment\r\n11 not available\r\n\r\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6933": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 48,
      "SPN": 6933,
      "SPN_Name": "SCR System Cleaning Automatic Initiation Configuration",
      "SPN_Description": "Indicates the configuration of SCR system cleaning automatic initiation.\r\n\r\n00 not enabled\r\n01 enabled\r\n10 reserved for SAE assignment\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6934": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 53,
      "SPN": 6934,
      "SPN_Name": "SCR System Cleaning Forced Status",
      "SPN_Description": "Indicates the forced execution status of SCR system cleaning.\r\n\r\n000 Not Active\r\n001 Active – Forced by Switch (See SPN 3696)\r\n010 Active – Forced by Service Tool \r\n011 Reserved for SAE Assignment\r\n100 Reserved for SAE Assignment\r\n101 Reserved for SAE Assignment\r\n110 Reserved for SAE Assignment\r\n111 not available\r\n\r\nThis SPN indicates the forced execution status of SCR system cleaning.  The SPN would be “Not Active” when the execution of SCR system cleaning has not been forced.  Either of the states “Active – Forced by Switch” and “Active – Forced by Service Tool” will be active when execution of SCR system cleaning is forced, providing feedback as to which entity forced the execution of SCR system cleaning.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "6935": {
      "PGN": 64585,
      "PGN_Name": "Aftertreatment 1 Historical Information 2",
      "PGN_Description": "AT1HI2",
      "first_bit": 0,
      "SPN": 6935,
      "SPN_Name": "Aftertreatment 1 SCR System Total Cleaning Time",
      "SPN_Description": "Total amount of time that a cleaning event has been active in the SCR system in bank 1 over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "6936": {
      "PGN": 64585,
      "PGN_Name": "Aftertreatment 1 Historical Information 2",
      "PGN_Description": "AT1HI2",
      "first_bit": 32,
      "SPN": 6936,
      "SPN_Name": "Aftertreatment 1 SCR System Total Number of System Cleaning Events",
      "SPN_Description": "Total number of cleaning events that have occurred on the SCR system in bank 1 over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "6937": {
      "PGN": 64585,
      "PGN_Name": "Aftertreatment 1 Historical Information 2",
      "PGN_Description": "AT1HI2",
      "first_bit": 64,
      "SPN": 6937,
      "SPN_Name": "Aftertreatment 1 SCR System Total Number of System Cleaning Inhibit Requests",
      "SPN_Description": "Total number of cleaning inhibit requests on the SCR system in bank 1 by the operator over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "6938": {
      "PGN": 64585,
      "PGN_Name": "Aftertreatment 1 Historical Information 2",
      "PGN_Description": "AT1HI2",
      "first_bit": 96,
      "SPN": 6938,
      "SPN_Name": "Aftertreatment 1 SCR System Total Number of System Cleaning Manual Requests",
      "SPN_Description": "Total number of manual cleaning requests on the SCR system in bank 1 by the operator over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "6939": {
      "PGN": 64585,
      "PGN_Name": "Aftertreatment 1 Historical Information 2",
      "PGN_Description": "AT1HI2",
      "first_bit": 128,
      "SPN": 6939,
      "SPN_Name": "Aftertreatment 1 SCR System Average Time Between System Cleaning Events",
      "SPN_Description": "Indicates the average time since last reset between cleaning events for the SCR system in bank 1.\r\n \r\nIf the manufacturer allows this parameter to be reset, this time is the average since last reset.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "6940": {
      "PGN": 64585,
      "PGN_Name": "Aftertreatment 1 Historical Information 2",
      "PGN_Description": "AT1HI2",
      "first_bit": 160,
      "SPN": 6940,
      "SPN_Name": "Aftertreatment 1 SCR System Average Distance Between System Cleaning Events",
      "SPN_Description": "Indicates the average distance since last reset between cleaning events for the SCR system in bank 1.\r\n\r\nIf the manufacturer allows this parameter to be reset, this distance is the average since last reset.",
      "bit_length": 32,
      "scaling": 0.125,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 36
    },
    "6941": {
      "PGN": 64697,
      "PGN_Name": "Aftertreatment 1 Service 2",
      "PGN_Description": "AT1S2",
      "first_bit": 32,
      "SPN": 6941,
      "SPN_Name": "Aftertreatment 1 SCR System Time Since Last System Cleaning Event",
      "SPN_Description": "Indicates the time since the last cleaning event of the SCR system in bank 1.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "6942": {
      "PGN": 64584,
      "PGN_Name": "Aftertreatment 2 Historical Information 2",
      "PGN_Description": "AT2HI2",
      "first_bit": 0,
      "SPN": 6942,
      "SPN_Name": "Aftertreatment 2 SCR System Total System Cleaning Time",
      "SPN_Description": "Total amount of time that a cleaning event has been active in the SCR system in bank 2 over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "6943": {
      "PGN": 64584,
      "PGN_Name": "Aftertreatment 2 Historical Information 2",
      "PGN_Description": "AT2HI2",
      "first_bit": 32,
      "SPN": 6943,
      "SPN_Name": "Aftertreatment 2 SCR System Total Number of System Cleaning Events",
      "SPN_Description": "Total number of cleaning events that have occurred on the SCR system in bank 2 over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "6944": {
      "PGN": 64584,
      "PGN_Name": "Aftertreatment 2 Historical Information 2",
      "PGN_Description": "AT2HI2",
      "first_bit": 64,
      "SPN": 6944,
      "SPN_Name": "Aftertreatment 2 SCR System Total Number of System Cleaning Inhibit Requests",
      "SPN_Description": "Total number of cleaning inhibit requests on the SCR system in bank 2 by the operator over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "6945": {
      "PGN": 64584,
      "PGN_Name": "Aftertreatment 2 Historical Information 2",
      "PGN_Description": "AT2HI2",
      "first_bit": 96,
      "SPN": 6945,
      "SPN_Name": "Aftertreatment 2 SCR System Total Number of System Cleaning Manual Requests",
      "SPN_Description": "Total number of manual cleaning requests on the SCR system in bank 2 by the operator over the lifetime of the device.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "6946": {
      "PGN": 64584,
      "PGN_Name": "Aftertreatment 2 Historical Information 2",
      "PGN_Description": "AT2HI2",
      "first_bit": 128,
      "SPN": 6946,
      "SPN_Name": "Aftertreatment 2 SCR System Average Time Between System Cleaning Events",
      "SPN_Description": "Indicates the average time since last reset between cleaning events for the SCR system in bank 2.\r\n\r\nIf the manufacturer allows this parameter to be reset, this time is the average since last reset.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "6947": {
      "PGN": 64584,
      "PGN_Name": "Aftertreatment 2 Historical Information 2",
      "PGN_Description": "AT2HI2",
      "first_bit": 160,
      "SPN": 6947,
      "SPN_Name": "Aftertreatment 2 SCR System Average Distance Between System Cleaning Events",
      "SPN_Description": "Indicates the average distance since last reset between cleaning events for the SCR system in bank 2.\r\n\r\nIf the manufacturer allows this parameter to be reset, this distance is the average since last reset.",
      "bit_length": 32,
      "scaling": 0.125,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 36
    },
    "6948": {
      "PGN": 64696,
      "PGN_Name": "Aftertreatment 2 Service 2",
      "PGN_Description": "AT2S2",
      "first_bit": 32,
      "SPN": 6948,
      "SPN_Name": "Aftertreatment 2 SCR System Time Since Last System Cleaning Event",
      "SPN_Description": "Indicates the time since the last cleaning event of the SCR system in bank 2.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "6949": {
      "PGN": 64583,
      "PGN_Name": "Monitored Tire Information",
      "PGN_Description": "MTI",
      "first_bit": 0,
      "SPN": 6949,
      "SPN_Name": "Number of Axles on the Vehicle",
      "SPN_Description": "The number of axles monitored for tire parameters. A maximum of 12 axles is defined.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 395
    },
    "6950": {
      "PGN": 64583,
      "PGN_Name": "Monitored Tire Information",
      "PGN_Description": "MTI",
      "first_bit": 8,
      "SPN": 6950,
      "SPN_Name": "Number of Tires on the Vehicle",
      "SPN_Description": "The total number of tires monitored for tire parameters. A maximum of 250 tires is defined.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "6951": {
      "PGN": 64583,
      "PGN_Name": "Monitored Tire Information",
      "PGN_Description": "MTI",
      "first_bit": 16,
      "SPN": 6951,
      "SPN_Name": "Axle 1 Monitored Tire Count",
      "SPN_Description": "The number of tires on Axle 1 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then ‘Not Available’ value (0xF) should be reported.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 395
    },
    "6952": {
      "PGN": 64583,
      "PGN_Name": "Monitored Tire Information",
      "PGN_Description": "MTI",
      "first_bit": 20,
      "SPN": 6952,
      "SPN_Name": "Axle 2 Monitored Tire Count",
      "SPN_Description": "The number of tires on Axle 2 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then ‘Not Available’ value (0xF) should be reported.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 395
    },
    "6953": {
      "PGN": 64583,
      "PGN_Name": "Monitored Tire Information",
      "PGN_Description": "MTI",
      "first_bit": 24,
      "SPN": 6953,
      "SPN_Name": "Axle 3 Monitored Tire Count",
      "SPN_Description": "The number of tires on Axle 3 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then ‘Not Available’ value (0xF) should be reported.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 395
    },
    "6954": {
      "PGN": 64583,
      "PGN_Name": "Monitored Tire Information",
      "PGN_Description": "MTI",
      "first_bit": 28,
      "SPN": 6954,
      "SPN_Name": "Axle 4 Monitored Tire Count",
      "SPN_Description": "The number of tires on Axle 4 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then ‘Not Available’ value (0xF) should be reported.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 395
    },
    "6955": {
      "PGN": 64583,
      "PGN_Name": "Monitored Tire Information",
      "PGN_Description": "MTI",
      "first_bit": 32,
      "SPN": 6955,
      "SPN_Name": "Axle 5 Monitored Tire Count",
      "SPN_Description": "The number of tires on Axle 5 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then ‘Not Available’ value (0xF) should be reported.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 395
    },
    "6956": {
      "PGN": 64583,
      "PGN_Name": "Monitored Tire Information",
      "PGN_Description": "MTI",
      "first_bit": 36,
      "SPN": 6956,
      "SPN_Name": "Axle 6 Monitored Tire Count",
      "SPN_Description": "The number of tires on Axle 6 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then ‘Not Available’ value (0xF) should be reported.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 395
    },
    "6957": {
      "PGN": 64583,
      "PGN_Name": "Monitored Tire Information",
      "PGN_Description": "MTI",
      "first_bit": 40,
      "SPN": 6957,
      "SPN_Name": "Axle 7 Monitored Tire Count",
      "SPN_Description": "The number of tires on Axle 7 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then ‘Not Available’ value (0xF) should be reported.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 395
    },
    "6958": {
      "PGN": 64583,
      "PGN_Name": "Monitored Tire Information",
      "PGN_Description": "MTI",
      "first_bit": 44,
      "SPN": 6958,
      "SPN_Name": "Axle 8 Monitored Tire Count",
      "SPN_Description": "The number of tires on Axle 8 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then ‘Not Available’ value (0xF) should be reported.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 395
    },
    "6959": {
      "PGN": 64583,
      "PGN_Name": "Monitored Tire Information",
      "PGN_Description": "MTI",
      "first_bit": 48,
      "SPN": 6959,
      "SPN_Name": "Axle 9 Monitored Tire Count",
      "SPN_Description": "The number of tires on Axle 9 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then ‘Not Available’ value (0xF) should be reported.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 395
    },
    "6960": {
      "PGN": 64583,
      "PGN_Name": "Monitored Tire Information",
      "PGN_Description": "MTI",
      "first_bit": 52,
      "SPN": 6960,
      "SPN_Name": "Axle 10 Monitored Tire Count",
      "SPN_Description": "The number of tires on Axle 10 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then ‘Not Available’ value (0xF) should be reported.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 395
    },
    "6961": {
      "PGN": 64583,
      "PGN_Name": "Monitored Tire Information",
      "PGN_Description": "MTI",
      "first_bit": 56,
      "SPN": 6961,
      "SPN_Name": "Axle 11 Monitored Tire Count",
      "SPN_Description": "The number of tires on Axle 11 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then ‘Not Available’ value (0xF) should be reported.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 395
    },
    "6962": {
      "PGN": 64583,
      "PGN_Name": "Monitored Tire Information",
      "PGN_Description": "MTI",
      "first_bit": 60,
      "SPN": 6962,
      "SPN_Name": "Axle 12 Monitored Tire Count",
      "SPN_Description": "The number of tires on Axle 12 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then ‘Not Available’ value (0xF) should be reported.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 395
    },
    "6973": {
      "PGN": 33280,
      "PGN_Name": "Tire Configuration Command Information",
      "PGN_Description": "TCCI",
      "first_bit": 0,
      "SPN": 6973,
      "SPN_Name": "Tire Location",
      "SPN_Description": "The location of monitored tire on the vehicle.\r\n\r\nThe high order 4 bits indicate the vehicle axle position of the tire, counting front to back on the vehicle, with the value 0 representing the front axle on the vehicle. If the upper 4 bits have a value of 0 to 13 it implies axle position, however 14 (0xE) would mean use these settings (other SPNs in tire configuration command information) for all axles.\r\n\r\nThe low order 4 bits indicate the position of the tire along the axle, counting left to right when facing in the direction of normal vehicle travel (forward), with the value 0 representing the left most tire position on the axle. If the lower 4 bits have a value of 0 to 13 it implies tire position along the axle, however 14 (0xE) would mean use these settings (other SPNs in tire configuration command information) for all tires on the specified axle.\r\n \r\nThe value 0xEE indicates configure all tires identically on all axles.\r\n\r\nThe value 0xFF indicates unavailable.\r\n\r\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\r\n\r\nExamples: Tire 1 location of 0x00 indicates Tire 1 is the left front tire. Tire 1 Location of 0x23 indicates Tire 1 is on the 3rd axle, 4th tire from the left.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "bit-mapped",
      "SLOT_ID": 275
    },
    "6974": {
      "PGN": 33280,
      "PGN_Name": "Tire Configuration Command Information",
      "PGN_Description": "TCCI",
      "first_bit": 8,
      "SPN": 6974,
      "SPN_Name": "Cold Inflation Pressure Setting",
      "SPN_Description": "Configurable value of the cold inflation pressure of the tire. Cold inflation pressure is the default/reference inflation pressure suggested by the manufacturer for a specific tire.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 377
    },
    "6975": {
      "PGN": 33280,
      "PGN_Name": "Tire Configuration Command Information",
      "PGN_Description": "TCCI",
      "first_bit": 24,
      "SPN": 6975,
      "SPN_Name": "Under Pressure Percentage Threshold Setting",
      "SPN_Description": "Configurable percent deviation from the set cold inflation pressure, for the under tire pressure alert.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "6976": {
      "PGN": 33280,
      "PGN_Name": "Tire Configuration Command Information",
      "PGN_Description": "TCCI",
      "first_bit": 32,
      "SPN": 6976,
      "SPN_Name": "Extreme Under Pressure Percentage Threshold Setting",
      "SPN_Description": "Configurable percent deviation from the set cold inflation pressure, for the extreme under tire pressure alert.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "6977": {
      "PGN": 33280,
      "PGN_Name": "Tire Configuration Command Information",
      "PGN_Description": "TCCI",
      "first_bit": 40,
      "SPN": 6977,
      "SPN_Name": "Over Pressure Percentage Threshold Setting",
      "SPN_Description": "Configurable percentage deviation from the set cold inflation pressure, for the over tire pressure alert.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "6978": {
      "PGN": 33280,
      "PGN_Name": "Tire Configuration Command Information",
      "PGN_Description": "TCCI",
      "first_bit": 48,
      "SPN": 6978,
      "SPN_Name": "Over Temperature Setting",
      "SPN_Description": "Configurable constant temperature above which an over temperature alert will trigger.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "6979": {
      "PGN": 64579,
      "PGN_Name": "Tire Configuration Status Information",
      "PGN_Description": "TCSI",
      "first_bit": 0,
      "SPN": 6979,
      "SPN_Name": "Tire Location",
      "SPN_Description": "The location of monitored tire on the vehicle.\r\n\r\nThe high order 4 bits indicate the vehicle axle position of the tire sensor, counting front to back on the vehicle, with the value 0 representing the front axle on the vehicle.\r\n\r\nThe low order 4 bits indicate the position of the tire sensor along the axle, counting left to right when facing in the direction of normal vehicle travel (forward), with the value 0 representing the left most tire sensor position on the axle.\r\n\r\nThe value 0xFF indicates not available.\r\n\r\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\r\n\r\nExamples: Tire Sensor 1 location of 0x00 indicates Tire Sensor 1 is the left front tire sensor. Tire 1 Sensor Location of 0x23 indicates Tire Sensor 1 is on the 3rd axle, 4th tire from the left.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "bit-mapped",
      "SLOT_ID": 275
    },
    "6980": {
      "PGN": 64579,
      "PGN_Name": "Tire Configuration Status Information",
      "PGN_Description": "TCSI",
      "first_bit": 8,
      "SPN": 6980,
      "SPN_Name": "Cold Inflation Pressure",
      "SPN_Description": "The cold inflation pressure of the tire. Cold inflation pressure is the default/reference inflation pressure suggested by the manufacturer for a specific tire.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 377
    },
    "6981": {
      "PGN": 64579,
      "PGN_Name": "Tire Configuration Status Information",
      "PGN_Description": "TCSI",
      "first_bit": 24,
      "SPN": 6981,
      "SPN_Name": "Under Pressure Percentage Threshold",
      "SPN_Description": "The percentage deviation from the set cold inflation pressure, for the under tire pressure alert.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "6982": {
      "PGN": 64579,
      "PGN_Name": "Tire Configuration Status Information",
      "PGN_Description": "TCSI",
      "first_bit": 32,
      "SPN": 6982,
      "SPN_Name": "Extreme Under Pressure Percentage Threshold",
      "SPN_Description": "The percentage deviation from the set cold inflation pressure, for the extreme under tire pressure alert.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "6983": {
      "PGN": 64579,
      "PGN_Name": "Tire Configuration Status Information",
      "PGN_Description": "TCSI",
      "first_bit": 40,
      "SPN": 6983,
      "SPN_Name": "Over Pressure Percentage Threshold",
      "SPN_Description": "The percentage deviation from the set cold inflation pressure, for the over tire pressure alert.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "6984": {
      "PGN": 64579,
      "PGN_Name": "Tire Configuration Status Information",
      "PGN_Description": "TCSI",
      "first_bit": 48,
      "SPN": 6984,
      "SPN_Name": "Over Temperature",
      "SPN_Description": "The temperature above which the over temperature alert will trigger.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "6985": {
      "PGN": 56832,
      "PGN_Name": "Reset",
      "PGN_Description": "RESET",
      "first_bit": 26,
      "SPN": 6985,
      "SPN_Name": "Tire Configuration Information",
      "SPN_Description": "Command signal used to initiate change in the tire configuration of the vehicle system. On receipt of this reset, necessary changes will be made in the tire configuration command information.\r\n\r\n00 – Take No Action\r\n01 – Reset\r\n10 – Reserved\r\n11 – Not Applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6986": {
      "PGN": 56832,
      "PGN_Name": "Reset",
      "PGN_Description": "RESET",
      "first_bit": 28,
      "SPN": 6986,
      "SPN_Name": "Tire Sensor Information",
      "SPN_Description": "Command signal used to initiate change in the tire sensor identification information.\r\n\r\n00 Take no action\r\n01 Reset\r\n10 Reserved\r\n11 Not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6987": {
      "PGN": 64578,
      "PGN_Name": "Tire Condition Message 2",
      "PGN_Description": "TIRE2",
      "first_bit": 0,
      "SPN": 6987,
      "SPN_Name": "Tire Location",
      "SPN_Description": "Identifies which tire is associated with the parametric data in PGN 64578. Refer to SPN 929 for further details and examples. The low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward). The high order 4 bits represent a position number, counting front to back on the vehicle. The value 0xFF indicates not available.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "bit-mapped",
      "SLOT_ID": 275
    },
    "6988": {
      "PGN": 64578,
      "PGN_Name": "Tire Condition Message 2",
      "PGN_Description": "TIRE2",
      "first_bit": 8,
      "SPN": 6988,
      "SPN_Name": "Tire Pressure (Extended Range)",
      "SPN_Description": "Pressure at which air is contained in cavity formed by tire and rim. See SPN 241 for alternate tire pressure with a lower range and coarser resolution.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 377
    },
    "6989": {
      "PGN": 64578,
      "PGN_Name": "Tire Condition Message 2",
      "PGN_Description": "TIRE2",
      "first_bit": 24,
      "SPN": 6989,
      "SPN_Name": "Required Tire Pressure",
      "SPN_Description": "The required tire pressure at which air is contained in cavity formed by tire and rim.\r\n\r\nThis pressure of the tire is compensated to meet the specific physical environmental conditions (temperature) of the vehicle.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 377
    },
    "6990": {
      "PGN": 65268,
      "PGN_Name": "Tire Condition Message 1",
      "PGN_Description": "TIRE1",
      "first_bit": 38,
      "SPN": 6990,
      "SPN_Name": "Extended Tire Pressure Support",
      "SPN_Description": "Defines the choice of using the tire pressure (PGN 65268) or Extended Tire Pressure (PGN 64578). The state value '01' indicates the extended tire pressure SPN is used for the pressure data. Any other value indicates the extended tire pressure SPN is not being used.\r\n\r\n00 - Not Using Extended Tire Pressure\r\n01 - Using Extended Tire Pressure\r\n10 - Error\r\n11 - Not Available/Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6991": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 0,
      "SPN": 6991,
      "SPN_Name": "Number of Engine Cylinders to Exclude from Combustion",
      "SPN_Description": "Request to the engine ECU for the number of cylinders to exclude from combustion (cut-out or skip) for a given instance in time.  The engine ECU can decide on the cylinders to exclude from combustion.  One of the use cases would be sending this parameter at low engine loads.  If this parameter is set to 3 for a 6 cylinder engine, the receiving engine ECM would know the request is to exclude 3 of the 6 cylinders.\r\n\r\nIf the sending node is to specify the cylinders to exclude from combustion, use SPN 6992-7015 Engine Cylinder xx Exclude from Combustion Request.  Otherwise, those SPNs can be set to (0b11 - Do not care status).  Alternatively, the application can choose to ignore updating this SPN (0xFF to be sent), if specific cylinders are requested to be cut out.\r\n\r\nShould there be a discrepency between SPNs 6991 and the group of SPNs 6992-7015, the recepient will determine which has priority.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "6992": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 8,
      "SPN": 6992,
      "SPN_Name": "Engine Cylinder 1 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 1 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6993": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 10,
      "SPN": 6993,
      "SPN_Name": "Engine Cylinder 2 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 2 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6994": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 12,
      "SPN": 6994,
      "SPN_Name": "Engine Cylinder 3 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 3 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6995": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 14,
      "SPN": 6995,
      "SPN_Name": "Engine Cylinder 4 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 4 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6996": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 16,
      "SPN": 6996,
      "SPN_Name": "Engine Cylinder 5 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 5 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6997": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 18,
      "SPN": 6997,
      "SPN_Name": "Engine Cylinder 6 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 6 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6998": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 20,
      "SPN": 6998,
      "SPN_Name": "Engine Cylinder 7 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 7 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "6999": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 22,
      "SPN": 6999,
      "SPN_Name": "Engine Cylinder 8 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 8 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7000": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 24,
      "SPN": 7000,
      "SPN_Name": "Engine Cylinder 9 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 9 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7001": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 26,
      "SPN": 7001,
      "SPN_Name": "Engine Cylinder 10 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 10 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7002": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 28,
      "SPN": 7002,
      "SPN_Name": "Engine Cylinder 11 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 11 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7003": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 30,
      "SPN": 7003,
      "SPN_Name": "Engine Cylinder 12 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 12 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7004": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 32,
      "SPN": 7004,
      "SPN_Name": "Engine Cylinder 13 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 13 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7005": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 34,
      "SPN": 7005,
      "SPN_Name": "Engine Cylinder 14 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 14 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7006": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 36,
      "SPN": 7006,
      "SPN_Name": "Engine Cylinder 15 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 15 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7007": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 38,
      "SPN": 7007,
      "SPN_Name": "Engine Cylinder 16 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 16 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7008": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 40,
      "SPN": 7008,
      "SPN_Name": "Engine Cylinder 17 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 17 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7009": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 42,
      "SPN": 7009,
      "SPN_Name": "Engine Cylinder 18 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 18 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7010": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 44,
      "SPN": 7010,
      "SPN_Name": "Engine Cylinder 19 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 19 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7011": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 46,
      "SPN": 7011,
      "SPN_Name": "Engine Cylinder 20 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 20 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7012": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 48,
      "SPN": 7012,
      "SPN_Name": "Engine Cylinder 21 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 21 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7013": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 50,
      "SPN": 7013,
      "SPN_Name": "Engine Cylinder 22 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 22 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7014": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 52,
      "SPN": 7014,
      "SPN_Name": "Engine Cylinder 23 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 23 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7015": {
      "PGN": 61648,
      "PGN_Name": "Engine Cylinder Combustion Request",
      "PGN_Description": "ECCR",
      "first_bit": 54,
      "SPN": 7015,
      "SPN_Name": "Engine Cylinder 24 Exclude from Combustion Request",
      "SPN_Description": "Request to the engine ECU to exclude (skip or cut-out) cylinder 24 from combustion.\r\n\r\n00 Exclude from Combustion\r\n01 Include for Combustion\r\n10 Reserved\r\n11 Not available/Do not care",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7016": {
      "PGN": 64576,
      "PGN_Name": "Engine Hydraulic Fuel 2 Pump Status",
      "PGN_Description": "EHF2PC",
      "first_bit": 0,
      "SPN": 7016,
      "SPN_Name": "Engine Fuel 2 Pump Hydraulic Flow Control Valve",
      "SPN_Description": "Position of hydraulic pump flow control valve opening; 0% = fully closed, 100% = fully open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7017": {
      "PGN": 64576,
      "PGN_Name": "Engine Hydraulic Fuel 2 Pump Status",
      "PGN_Description": "EHF2PC",
      "first_bit": 8,
      "SPN": 7017,
      "SPN_Name": "Engine Fuel 2 Pump Hydraulic Swash Plate Angle",
      "SPN_Description": "Position of hydraulic swash plate angle within hydraulic pump.  0% represents the lowest possible flow, 100% represents the maximum flow.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7018": {
      "PGN": 64576,
      "PGN_Name": "Engine Hydraulic Fuel 2 Pump Status",
      "PGN_Description": "EHF2PC",
      "first_bit": 16,
      "SPN": 7018,
      "SPN_Name": "Engine Fuel 2 Pump Hydraulic Directional Valve",
      "SPN_Description": "Position of hydraulic directional valve to control application of hydraulic oil flow.  0% is no flow to the appliance; 100% is full flow to the appliance.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7019": {
      "PGN": 64576,
      "PGN_Name": "Engine Hydraulic Fuel 2 Pump Status",
      "PGN_Description": "EHF2PC",
      "first_bit": 24,
      "SPN": 7019,
      "SPN_Name": "Engine Fuel 2 Pump Hydraulic Pressure",
      "SPN_Description": "Hydraulic pressure in the lines of the hydraulically driven fuel 2 pump.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 106
    },
    "7020": {
      "PGN": 65277,
      "PGN_Name": "Alternate Fuel 1",
      "PGN_Description": "AF1",
      "first_bit": 40,
      "SPN": 7020,
      "SPN_Name": "LNG Vaporizer Coolant Outlet Temperature",
      "SPN_Description": "Temperature of coolant at outlet of liquified natural gas vaporizer. This parameter is also used to determine if coolant has reached freezing temperature.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7021": {
      "PGN": 64577,
      "PGN_Name": "Alternate Fuel 4",
      "PGN_Description": "AF4",
      "first_bit": 0,
      "SPN": 7021,
      "SPN_Name": "Engine Fuel 2 Injector Metering Rail 1 Pressure",
      "SPN_Description": "The pressure of fuel 2 measured by first rail pressure sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 106
    },
    "7022": {
      "PGN": 64577,
      "PGN_Name": "Alternate Fuel 4",
      "PGN_Description": "AF4",
      "first_bit": 16,
      "SPN": 7022,
      "SPN_Name": "Engine Fuel 2 Injector Metering Rail 2 Pressure",
      "SPN_Description": "The pressure of fuel 2 measured by first rail pressure sensor in the metering rail 2 as delivered from the supply pump to the injector metering intake.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 106
    },
    "7023": {
      "PGN": 64577,
      "PGN_Name": "Alternate Fuel 4",
      "PGN_Description": "AF4",
      "first_bit": 32,
      "SPN": 7023,
      "SPN_Name": "Engine Fuel 2 Injector Metering Rail 1 Temperature",
      "SPN_Description": "The temperature of fuel 2 measured by first rail temperature sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7024": {
      "PGN": 64577,
      "PGN_Name": "Alternate Fuel 4",
      "PGN_Description": "AF4",
      "first_bit": 40,
      "SPN": 7024,
      "SPN_Name": "Engine Fuel 2 Injector Metering Rail 2 Temperature",
      "SPN_Description": "The temperature of fuel 2 measured by first rail temperature sensor in the metering rail 2 as delivered from the supply pump to the injector metering intake.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7025": {
      "PGN": 64575,
      "PGN_Name": "Engine Turbocharger Control 2",
      "PGN_Description": "ETCC2",
      "first_bit": 0,
      "SPN": 7025,
      "SPN_Name": "Engine Staged Turbocharger Solenoid Status",
      "SPN_Description": "Current state of the staged turbocharger solenoid, normalized to percent, 0% represents not actuated and 100% represents fully actuated.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7033": {
      "PGN": 34048,
      "PGN_Name": "Cab Message 2",
      "PGN_Description": "CM2",
      "first_bit": 18,
      "SPN": 7033,
      "SPN_Name": "Heat Exchanger Debris Purge Inhibit Switch",
      "SPN_Description": "Indicates the state of a switch available to the operator that will inhibit the system from purging the debris from the heat exchanger.\r\n\r\n00   not active\r\n01   active\r\n10   error\r\n11   not available\r\n\r\nThis SPN would be “not active” when purging the debris from the heat exchanger is allowed to occur (purging the debris from the heat exchanger is not inhibited).\r\n\r\nThe ECU shall inhibit purging the debris from the heat exchanging when SPN 7033 is in the ON state.\r\n\r\nPurging the debris from the heat exchanger shall be activated by SPN 7034 when it is in the ON state and SPN 7033 is in the OFF state.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7034": {
      "PGN": 34048,
      "PGN_Name": "Cab Message 2",
      "PGN_Description": "CM2",
      "first_bit": 20,
      "SPN": 7034,
      "SPN_Name": "Heat Exchanger Debris Purge Force Switch",
      "SPN_Description": "Indicates the state of a switch available to the operator that forces the system to purge the debris from the heat exchanger.\r\n\r\n00   not active\r\n01   active\r\n10   error\r\n11   not available\r\n\r\nThis SPN would be “not active” when purging the debris from the heat exchanger is requested by another algorithm, such as a time based purge (purging the debris from the heat exchanger is not being forced by the operator).\r\n\r\nThe ECU shall inhibit purging the debris from the heat exchanging when SPN 7033 is in the ON state.\r\n\r\nPurging the debris from the heat exchanger shall be activated by SPN 7034 when it is in the ON state and SPN 7033 is in the OFF state.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7035": {
      "PGN": 64574,
      "PGN_Name": "Heat Exchanger Debris Purge Information",
      "PGN_Description": "HEDPI",
      "first_bit": 0,
      "SPN": 7035,
      "SPN_Name": "Heat Exchanger Debris Purge Status",
      "SPN_Description": "Indicates whether the system is currently purging debris from the heat exchanger.\r\n\r\n00    Inactive\r\n01    Active\r\n10    SAE reserved\r\n11    Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7036": {
      "PGN": 64574,
      "PGN_Name": "Heat Exchanger Debris Purge Information",
      "PGN_Description": "HEDPI",
      "first_bit": 2,
      "SPN": 7036,
      "SPN_Name": "Heat Exchanger Debris Purge Approaching",
      "SPN_Description": "Status signal which indicates that purging the debris from the heat exchanger is imminent.\r\n\r\n00     Not approaching\r\n01     Approaching\r\n10     SAE reserved\r\n11     Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7037": {
      "PGN": 7168,
      "PGN_Name": "Transmission Control 3",
      "PGN_Description": "TC3",
      "first_bit": 0,
      "SPN": 7037,
      "SPN_Name": "Transmission Override Control Mode",
      "SPN_Description": "The override control mode defines the type of control mode used to control transmission operation.\r\n\r\n00 = Override disabled - Disable any existing control commanded by the source of this command.\r\n01 = Speed control - Control speed to the included “desired speed” value.\r\n10 = Torque control - Control torque to the included “desired torque” value.\r\n11 = Speed/torque limit control - Limit speed and/or torque based on the included limit values.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7038": {
      "PGN": 7168,
      "PGN_Name": "Transmission Control 3",
      "PGN_Description": "TC3",
      "first_bit": 2,
      "SPN": 7038,
      "SPN_Name": "Transmission Override Control Mode Priority",
      "SPN_Description": "This field is used as an input to the transmission to determine the priority of the Override Control Mode received in the Torque/Speed Control message.  The default is 11 (Low priority).  It is not required to use the same priority during the entire override function. \r\n\r\nThe four priority levels defined are:\r\n\r\n00 = Highest priority\r\n01 = High priority\r\n10 = Medium priority\r\n11 = Low priority\r\n\r\n00b - Highest Priority = Used for situations that require immediate action by the receiving device in order to provide safe vehicle operation. This level of priority should only be used in safety critical conditions.\r\n01b - High Priority = Used for control situations that require prompt action in order to provide safe vehicle operation.\r\n10b - Medium Priority = Used for powertrain control operations which are related to assuring that the vehicle is in a stable operating condition.\r\n11b - Low Priority = Used to indicate that the associated command desires powertrain control but is needed for function which may be overridden by other devices.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7039": {
      "PGN": 7168,
      "PGN_Name": "Transmission Control 3",
      "PGN_Description": "TC3",
      "first_bit": 8,
      "SPN": 7039,
      "SPN_Name": "Transmission Requested Output Shaft Speed",
      "SPN_Description": "Used to request output shaft speed of the transmission which has a output through a driveline to the wheels of a machine/vehicle.",
      "bit_length": 16,
      "scaling": 0.25,
      "offset": -8031.75,
      "unit": "rpm",
      "SLOT_ID": 398
    },
    "7040": {
      "PGN": 7168,
      "PGN_Name": "Transmission Control 3",
      "PGN_Description": "TC3",
      "first_bit": 24,
      "SPN": 7040,
      "SPN_Name": "Transmission Requested Torque / Torque Limit",
      "SPN_Description": "Requested transmission output torque measured as a percentage of Transmission Reference Torque (SPN 7778). This is the output torque at which the transmission is expected to operate if the torque control mode is active or the output torque which the transmission shall not exceed if the torque limit mode is active.\r\n\r\nNote:  0% to 125% for (positive) powered torque requests, -125% to 0% for (negative) retarding torque requests.  Does not define rotational direction.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "7041": {
      "PGN": 7168,
      "PGN_Name": "Transmission Control 3",
      "PGN_Description": "TC3",
      "first_bit": 4,
      "SPN": 7041,
      "SPN_Name": "Message Counter",
      "SPN_Description": "The message counter is used to detect situations where the transmitting ECU malfunction repeats the same frame all the time.  The receiver of the information may use the counter parameter to detect this situation.  \r\n\r\nNote:  The initial value of the 4 bit message counter for the first message during a driving cycle is arbitrary. In every following message the counter is incremented by 1  (0 follows 15).",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 220
    },
    "7042": {
      "PGN": 7168,
      "PGN_Name": "Transmission Control 3",
      "PGN_Description": "TC3",
      "first_bit": 56,
      "SPN": 7042,
      "SPN_Name": "Message Checksum",
      "SPN_Description": "The message checksum is used to verify the signal path from the transmitting device to the receiving device.\r\n \r\nThe message checksum is calculated using the first 7 data bytes, the message counter and the bytes of the message identifier. It is calculated as follows:\r\n\r\nMessage Checksum =  ((Byte 1 + Byte 2 + Byte 3 + Byte 4 + Byte 5 + Byte 6 + Byte 7 + Message ID low order byte + Message ID mid low byte + Message ID mid high byte + Message ID high order byte) & 0xFF)\r\n\r\nWhere\r\n  \tMessage ID low order byte = Source Address from 29-bit header\r\n  \tMessage ID mid low byte = PDU Specific (PS) from 29-bit header\r\n  \tMessage ID mid high byte = PDU Format (PF) from 29-bit header\r\n  \tMessage ID high order byte = 6 bits of '0' followed by EDP and DP bits from 29-bit header",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "7043": {
      "PGN": 64573,
      "PGN_Name": "Engine End Bearing Temperature 1",
      "PGN_Description": "EEBT1",
      "first_bit": 0,
      "SPN": 7043,
      "SPN_Name": "Engine End Bearing 1 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 1 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7044": {
      "PGN": 64573,
      "PGN_Name": "Engine End Bearing Temperature 1",
      "PGN_Description": "EEBT1",
      "first_bit": 8,
      "SPN": 7044,
      "SPN_Name": "Engine End Bearing 2 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 2 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7045": {
      "PGN": 64573,
      "PGN_Name": "Engine End Bearing Temperature 1",
      "PGN_Description": "EEBT1",
      "first_bit": 16,
      "SPN": 7045,
      "SPN_Name": "Engine End Bearing 3 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 3 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7046": {
      "PGN": 64573,
      "PGN_Name": "Engine End Bearing Temperature 1",
      "PGN_Description": "EEBT1",
      "first_bit": 24,
      "SPN": 7046,
      "SPN_Name": "Engine End Bearing 4 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 4 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7047": {
      "PGN": 64573,
      "PGN_Name": "Engine End Bearing Temperature 1",
      "PGN_Description": "EEBT1",
      "first_bit": 32,
      "SPN": 7047,
      "SPN_Name": "Engine End Bearing 5 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 5 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7048": {
      "PGN": 64573,
      "PGN_Name": "Engine End Bearing Temperature 1",
      "PGN_Description": "EEBT1",
      "first_bit": 40,
      "SPN": 7048,
      "SPN_Name": "Engine End Bearing 6 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 6 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7049": {
      "PGN": 64573,
      "PGN_Name": "Engine End Bearing Temperature 1",
      "PGN_Description": "EEBT1",
      "first_bit": 48,
      "SPN": 7049,
      "SPN_Name": "Engine End Bearing 7 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 7 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7050": {
      "PGN": 64573,
      "PGN_Name": "Engine End Bearing Temperature 1",
      "PGN_Description": "EEBT1",
      "first_bit": 56,
      "SPN": 7050,
      "SPN_Name": "Engine End Bearing 8 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 8 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7051": {
      "PGN": 64572,
      "PGN_Name": "Engine End Bearing Temperature 2",
      "PGN_Description": "EEBT2",
      "first_bit": 0,
      "SPN": 7051,
      "SPN_Name": "Engine End Bearing 9 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 9 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7052": {
      "PGN": 64572,
      "PGN_Name": "Engine End Bearing Temperature 2",
      "PGN_Description": "EEBT2",
      "first_bit": 8,
      "SPN": 7052,
      "SPN_Name": "Engine End Bearing 10 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 10 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7053": {
      "PGN": 64572,
      "PGN_Name": "Engine End Bearing Temperature 2",
      "PGN_Description": "EEBT2",
      "first_bit": 16,
      "SPN": 7053,
      "SPN_Name": "Engine End Bearing 11 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 11 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7054": {
      "PGN": 64572,
      "PGN_Name": "Engine End Bearing Temperature 2",
      "PGN_Description": "EEBT2",
      "first_bit": 24,
      "SPN": 7054,
      "SPN_Name": "Engine End Bearing 12 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 12 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7055": {
      "PGN": 64572,
      "PGN_Name": "Engine End Bearing Temperature 2",
      "PGN_Description": "EEBT2",
      "first_bit": 32,
      "SPN": 7055,
      "SPN_Name": "Engine End Bearing 13 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 13 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7056": {
      "PGN": 64572,
      "PGN_Name": "Engine End Bearing Temperature 2",
      "PGN_Description": "EEBT2",
      "first_bit": 40,
      "SPN": 7056,
      "SPN_Name": "Engine End Bearing 14 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 14 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7057": {
      "PGN": 64572,
      "PGN_Name": "Engine End Bearing Temperature 2",
      "PGN_Description": "EEBT2",
      "first_bit": 48,
      "SPN": 7057,
      "SPN_Name": "Engine End Bearing 15 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 15 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7058": {
      "PGN": 64572,
      "PGN_Name": "Engine End Bearing Temperature 2",
      "PGN_Description": "EEBT2",
      "first_bit": 56,
      "SPN": 7058,
      "SPN_Name": "Engine End Bearing 16 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 16 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7059": {
      "PGN": 64571,
      "PGN_Name": "Engine End Bearing Temperature 3",
      "PGN_Description": "EEBT3",
      "first_bit": 0,
      "SPN": 7059,
      "SPN_Name": "Engine End Bearing 17 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 17 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7060": {
      "PGN": 64571,
      "PGN_Name": "Engine End Bearing Temperature 3",
      "PGN_Description": "EEBT3",
      "first_bit": 8,
      "SPN": 7060,
      "SPN_Name": "Engine End Bearing 18 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 18 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7061": {
      "PGN": 64571,
      "PGN_Name": "Engine End Bearing Temperature 3",
      "PGN_Description": "EEBT3",
      "first_bit": 16,
      "SPN": 7061,
      "SPN_Name": "Engine End Bearing 19 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 19 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7062": {
      "PGN": 64571,
      "PGN_Name": "Engine End Bearing Temperature 3",
      "PGN_Description": "EEBT3",
      "first_bit": 24,
      "SPN": 7062,
      "SPN_Name": "Engine End Bearing 20 Temperature",
      "SPN_Description": "Temperature of end bearing of the connecting rod for cylinder 20 on the engine",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7063": {
      "PGN": 64570,
      "PGN_Name": "Gaseous Fuel Supply Pressure 1",
      "PGN_Description": "GFSP1",
      "first_bit": 0,
      "SPN": 7063,
      "SPN_Name": "Engine Gaseous Fuel Supply Pressure 2",
      "SPN_Description": "Second gage pressure measurement of gaseous fuel supply to fuel metering device. If only one sensor is used for gas supply pressure measurement, use SPN 159 instead.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "7064": {
      "PGN": 64570,
      "PGN_Name": "Gaseous Fuel Supply Pressure 1",
      "PGN_Description": "GFSP1",
      "first_bit": 16,
      "SPN": 7064,
      "SPN_Name": "Engine Gaseous Fuel Supply Unit Intake Pressure",
      "SPN_Description": "Pressure of gaseous fuel supply measured at the intake of gaseous fuel supply unit. Gaseous fuel valve unit contains block and bleed valves to regulate the flow of gaseous fuel from the plant to engine.\r\n\r\nGas Supply Unit Intake Pressure",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "7065": {
      "PGN": 64570,
      "PGN_Name": "Gaseous Fuel Supply Pressure 1",
      "PGN_Description": "GFSP1",
      "first_bit": 32,
      "SPN": 7065,
      "SPN_Name": "Engine Gaseous Fuel Supply Shutoff Valve 1 Intake Pressure",
      "SPN_Description": "Pressure of gaseous fuel supply measured at shutoff valve 1 in gaseous fuel supply unit. Shutoff valves are used to regulate gaseous fuel supply to engine.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "7066": {
      "PGN": 64570,
      "PGN_Name": "Gaseous Fuel Supply Pressure 1",
      "PGN_Description": "GFSP1",
      "first_bit": 48,
      "SPN": 7066,
      "SPN_Name": "Engine Gaseous Fuel Supply Shutoff Valve 2 Intake Pressure",
      "SPN_Description": "Pressure of gaseous fuel supply measured at shutoff valve 2 in gaseous fuel supply unit. Shutoff valves are used to regulate gaseous fuel supply to engine.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "7067": {
      "PGN": 64569,
      "PGN_Name": "Gaseous Fuel Supply Pressure 2",
      "PGN_Description": "GFSP2",
      "first_bit": 0,
      "SPN": 7067,
      "SPN_Name": "Plant Gaseous Fuel Supply Outlet Pressure",
      "SPN_Description": "Pressure of the gaseous fuel supplied from the plant room for one or more engines.  Based on the application, plant room will contain fuel tank for gas, vaporizer and heater and cooler compartments.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "7068": {
      "PGN": 64569,
      "PGN_Name": "Gaseous Fuel Supply Pressure 2",
      "PGN_Description": "GFSP2",
      "first_bit": 16,
      "SPN": 7068,
      "SPN_Name": "Plant Inert Gas Supply Outlet Pressure",
      "SPN_Description": "Pressure of the purge gas supplied to the engine. Inert gas is used to remove gaseous fuel build-up in the engines and in the fuel supply lines when gaseous fuel is not in operation.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 50
    },
    "7069": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 42,
      "SPN": 7069,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater Relay 2",
      "SPN_Description": "The Aftertreatment Diesel Exhaust Fluid Line Heater Relay 2 is used to energize one or more DEF line heaters.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7070": {
      "PGN": 64651,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 2",
      "PGN_Description": "AFT1PSI2",
      "first_bit": 40,
      "SPN": 7070,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Heater Resistance",
      "SPN_Description": "The resistance of the particulate sensor heater.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm",
      "SLOT_ID": 290
    },
    "7071": {
      "PGN": 64568,
      "PGN_Name": "Engine Oil Mist Detection Information 1",
      "PGN_Description": "EOMDI1",
      "first_bit": 0,
      "SPN": 7071,
      "SPN_Name": "Engine Oil Mist 1 Concentration",
      "SPN_Description": "Percentage of detected oil mist in compartment 1 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit, whereas 0% means no detected oil mist in the air. This measurement is typically taken in crankcase compartment. Note. For a V engine, 2 cylinders may share a compartment. Compartment 1 is referred to the one closer to flywheel of the engine.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7072": {
      "PGN": 64568,
      "PGN_Name": "Engine Oil Mist Detection Information 1",
      "PGN_Description": "EOMDI1",
      "first_bit": 8,
      "SPN": 7072,
      "SPN_Name": "Engine Oil Mist 2 Concentration",
      "SPN_Description": "Percentage of detected oil mist in compartment 2 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7073": {
      "PGN": 64568,
      "PGN_Name": "Engine Oil Mist Detection Information 1",
      "PGN_Description": "EOMDI1",
      "first_bit": 16,
      "SPN": 7073,
      "SPN_Name": "Engine Oil Mist 3 Concentration",
      "SPN_Description": "Percentage of detected oil mist in compartment 3 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7074": {
      "PGN": 64568,
      "PGN_Name": "Engine Oil Mist Detection Information 1",
      "PGN_Description": "EOMDI1",
      "first_bit": 24,
      "SPN": 7074,
      "SPN_Name": "Engine Oil Mist 4 Concentration",
      "SPN_Description": "Percentage of detected oil mist in compartment 4 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7075": {
      "PGN": 64568,
      "PGN_Name": "Engine Oil Mist Detection Information 1",
      "PGN_Description": "EOMDI1",
      "first_bit": 32,
      "SPN": 7075,
      "SPN_Name": "Engine Oil Mist 5 Concentration",
      "SPN_Description": "Percentage of detected oil mist in compartment 5 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7076": {
      "PGN": 64568,
      "PGN_Name": "Engine Oil Mist Detection Information 1",
      "PGN_Description": "EOMDI1",
      "first_bit": 40,
      "SPN": 7076,
      "SPN_Name": "Engine Oil Mist 6 Concentration",
      "SPN_Description": "Percentage of detected oil mist in compartment 6 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7077": {
      "PGN": 64568,
      "PGN_Name": "Engine Oil Mist Detection Information 1",
      "PGN_Description": "EOMDI1",
      "first_bit": 48,
      "SPN": 7077,
      "SPN_Name": "Engine Oil Mist 7 Concentration",
      "SPN_Description": "Percentage of detected oil mist in compartment 7 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7078": {
      "PGN": 64568,
      "PGN_Name": "Engine Oil Mist Detection Information 1",
      "PGN_Description": "EOMDI1",
      "first_bit": 56,
      "SPN": 7078,
      "SPN_Name": "Engine Oil Mist 8 Concentration",
      "SPN_Description": "Percentage of detected oil mist in compartment 8 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7079": {
      "PGN": 64567,
      "PGN_Name": "Engine Oil Mist Detection Information 2",
      "PGN_Description": "EOMDI2",
      "first_bit": 0,
      "SPN": 7079,
      "SPN_Name": "Engine Oil Mist 9 Concentration",
      "SPN_Description": "Percentage of detected oil mist in compartment 9 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7080": {
      "PGN": 64567,
      "PGN_Name": "Engine Oil Mist Detection Information 2",
      "PGN_Description": "EOMDI2",
      "first_bit": 8,
      "SPN": 7080,
      "SPN_Name": "Engine Oil Mist 10 Concentration",
      "SPN_Description": "Percentage of detected oil mist in compartment 10 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7081": {
      "PGN": 64566,
      "PGN_Name": "Gaseous Fuel Supply Valve Information",
      "PGN_Description": "GFSVI",
      "first_bit": 0,
      "SPN": 7081,
      "SPN_Name": "Engine Gaseous Fuel Supply Shutoff Valve 1 Position",
      "SPN_Description": "Position of shutoff valve 1, which is used to control the flow of gaseous fuel through the fuel supply unit. 0% represents valve fully closed and 100% represents valve fully open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7082": {
      "PGN": 64566,
      "PGN_Name": "Gaseous Fuel Supply Valve Information",
      "PGN_Description": "GFSVI",
      "first_bit": 8,
      "SPN": 7082,
      "SPN_Name": "Engine Gaseous Fuel Supply Shutoff Valve 2 Position",
      "SPN_Description": "Position of shutoff valve 2, which is used to control the flow of gaseous fuel through the fuel supply unit. 0% represents valve fully closed and 100% represents valve fully open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7083": {
      "PGN": 64566,
      "PGN_Name": "Gaseous Fuel Supply Valve Information",
      "PGN_Description": "GFSVI",
      "first_bit": 16,
      "SPN": 7083,
      "SPN_Name": "Engine Gaseous Fuel Supply Bleed Valve 1 Position",
      "SPN_Description": "Position of bleed valve 1, which is used to control the flow of gaseous fuel through the fuel supply unit. 0% represents valve fully closed and 100% represents valve fully open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7084": {
      "PGN": 64566,
      "PGN_Name": "Gaseous Fuel Supply Valve Information",
      "PGN_Description": "GFSVI",
      "first_bit": 24,
      "SPN": 7084,
      "SPN_Name": "Engine Gaseous Fuel Supply Bleed Valve 2 Position",
      "SPN_Description": "Position of bleed valve 2, which is used to control the flow of gaseous fuel through the fuel supply unit. 0% represents valve fully closed and 100% represents valve fully open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7085": {
      "PGN": 64566,
      "PGN_Name": "Gaseous Fuel Supply Valve Information",
      "PGN_Description": "GFSVI",
      "first_bit": 32,
      "SPN": 7085,
      "SPN_Name": "Engine Gaseous Fuel Supply Bleed Valve 3 Position",
      "SPN_Description": "Position of bleed valve 3, which is used to control the flow of gaseous fuel through the fuel supply unit. 0% represents valve fully closed and 100% represents valve fully open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7086": {
      "PGN": 64565,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Pump 1 Information",
      "PGN_Description": "AT2P1I",
      "first_bit": 0,
      "SPN": 7086,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Pump Heater",
      "SPN_Description": "Percentage of heating applied to the aftertreatment 2 diesel exhaust fluid pump heater.  A value of 0% means no heating applied, a value of 100% means full heating applied. The diesel exhaust fluid pump heater warms the diesel exhaust fluid in the diesel exhaust fluid pump.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7087": {
      "PGN": 61479,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 1",
      "PGN_Description": "A2SCRDSR1",
      "first_bit": 56,
      "SPN": 7087,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Pump Heater Command",
      "SPN_Description": "Command for the Aftertreatment 2 Diesel Exhaust Fluid Pump Heater.  A value of 0% means no heating commanded, a value of 100% means full heating commanded.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7088": {
      "PGN": 61649,
      "PGN_Name": "Engine Cylinder Head Bypass Actuator 1",
      "PGN_Description": "ECBA1",
      "first_bit": 0,
      "SPN": 7088,
      "SPN_Name": "Engine Cylinder Head Bypass Actuator 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in Engine Cylinder Head Bypass Actuator 1 by the manufacturer's software. When there are multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nCylinder Head bypass valve is used to release the air at the high pressure compressor outlet into turbocharger turbine intake when intake pressure exceeds exhaust pressure at lower engine speeds and thereby controlling compressure surge.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7089": {
      "PGN": 61649,
      "PGN_Name": "Engine Cylinder Head Bypass Actuator 1",
      "PGN_Description": "ECBA1",
      "first_bit": 5,
      "SPN": 7089,
      "SPN_Name": "Engine Cylinder Head Bypass Actuator 1 Temperature Status",
      "SPN_Description": "Identifies the status of the Engine Cylinder Head Bypass Blowoff Actuator 1 drive circuitry temperature. Temperature excursions may affect the torque output.\r\n\r\nCylinder Head bypass valve is used to release the air at the high pressure compressor outlet into turbocharger turbine inlet when intake pressure exceeds exhaust pressure at lower engine speeds and thereby controlling compressure surge.\r\n\r\n000 - High Most severe\r\n001 - High Least severe\r\n010 - In Range\r\n011 - Low Least severe\r\n100 - Low Most severe\r\n101 - Not Defined\r\n110 - Error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7090": {
      "PGN": 61649,
      "PGN_Name": "Engine Cylinder Head Bypass Actuator 1",
      "PGN_Description": "ECBA1",
      "first_bit": 8,
      "SPN": 7090,
      "SPN_Name": "Engine Cylinder Head Bypass Actuator 1 Temperature",
      "SPN_Description": "Temperature of the Engine Cylinder Head Bypass Actuator 1 drive circuitry. Temperature excursions may affect the torque output.\r\n\r\nCylinder Head bypass valve is used to release the air at the high pressure compressor outlet into turbocharger turbine inlet when intake pressure exceeds exhaust pressure at lower engine speeds and thereby controlling compressure surge.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7091": {
      "PGN": 61649,
      "PGN_Name": "Engine Cylinder Head Bypass Actuator 1",
      "PGN_Description": "ECBA1",
      "first_bit": 16,
      "SPN": 7091,
      "SPN_Name": "Engine Cylinder Head Bypass Actuator 1 Desired Position",
      "SPN_Description": "Requested position of Engine Cylinder Head Bypass actuator by engine ECM, where 0% represents bypass fully closed and 100% represents fully open. This is the position that the device is attempting to achieve.\r\n\r\nCylinder Head bypass valve is used to release the air at the high pressure compressor outlet into turbocharger turbine inlet when intake pressure exceeds exhaust pressure at lower engine speeds and thereby controlling compressure surge.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7092": {
      "PGN": 61649,
      "PGN_Name": "Engine Cylinder Head Bypass Actuator 1",
      "PGN_Description": "ECBA1",
      "first_bit": 24,
      "SPN": 7092,
      "SPN_Name": "Engine Cylinder Head Bypass Actuator 1 Position",
      "SPN_Description": "Actual position of Engine Cylinder Head Bypass actuator, where 0% represents fully closed and 100% represents fully open.\r\n\r\nCylinder Head bypass valve is used to release the air at the high pressure compressor outlet into turbocharger turbine inlet when intake pressure exceeds exhaust pressure at lower engine speeds and thereby controlling compressure surge.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7093": {
      "PGN": 61649,
      "PGN_Name": "Engine Cylinder Head Bypass Actuator 1",
      "PGN_Description": "ECBA1",
      "first_bit": 32,
      "SPN": 7093,
      "SPN_Name": "Engine Cylinder Head Bypass Actuator 1 Operation Status",
      "SPN_Description": "Identifies the status of Engine Cylinder Head Bypass Actuator 1.\r\n\r\nCylinder head bypass valve is used to release the air at the high pressure compressor outlet into turbocharger turbine inlet when intake pressure exceeds exhaust pressure at lower engine speeds and thereby controlling compressure surge.\r\n\r\n0000 - Normal\r\n0001 - Alarm (fully operational but needs service)\r\n0010 - Alarm High Severity (functional but transient performance may be reduced)\r\n0011 - Derate Active (torque output reduced due to environmental conditions)\r\n0100 - Controlled Shutdown Active (driving to the default position - usually this means closed)\r\n0101 - Uncontrolled Shutdown Active (no torque is being applied from the actuator)\r\n0110 - Calibration in Progress (must be broadcast at least once per calibration process defined in SPN 3464)\r\n0111 - 1101   Reserved for future assignment\r\n1110 - Error\r\n1111 - Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7094": {
      "PGN": 61650,
      "PGN_Name": "Engine Electronic Controller 18",
      "PGN_Description": "EEC18",
      "first_bit": 0,
      "SPN": 7094,
      "SPN_Name": "Engine Cylinder Head Bypass Actuator 1 Command",
      "SPN_Description": "Command to cylinder head bypass actuator 1, normalized to percent, where 0% nominally represents fully closed (No Flow) and 100% represents fully open (Max Flow). The purpose of the cylinder bypass valve is to release the air at the high pressure compressor outlet into turbocharger turbine inlet when intake pressure exceeds exhaust pressure at lower engine speeds and thereby controlling compressure surge.\r\n\r\n0xFB00 - 0xFB64 is sent to calibrate to a specific position.  The LSB specifies the position with a resolution of 1%/bit  (eg, 0xFB32 is sent to calibrate the actuator to 50%).  \r\n\r\n0xFBFF is sent to calibrate the actuator using its own algorithm.  \r\n\r\nCalibration status from the actuator is received on SPN 7093.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "7095": {
      "PGN": 64598,
      "PGN_Name": "SCR Operator Inducement Information 2",
      "PGN_Description": "SCROII2",
      "first_bit": 32,
      "SPN": 7095,
      "SPN_Name": "SCR Operator Inducement Total Time",
      "SPN_Description": "Indicates the time that operator inducement has been active. This will accumulate over the life of the product and will never be reset.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "7096": {
      "PGN": 64564,
      "PGN_Name": "Engine Fuel Injector Metering Rail Pressure Information 2",
      "PGN_Description": "EFIMRPI2",
      "first_bit": 0,
      "SPN": 7096,
      "SPN_Name": "Engine Fuel 1 Injector Metering Rail 1 Pressure 1 (Extended Range)",
      "SPN_Description": "The pressure of fuel measured by first rail pressure sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.",
      "bit_length": 16,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 130
    },
    "7097": {
      "PGN": 64564,
      "PGN_Name": "Engine Fuel Injector Metering Rail Pressure Information 2",
      "PGN_Description": "EFIMRPI2",
      "first_bit": 16,
      "SPN": 7097,
      "SPN_Name": "Engine Fuel 1 Injector Metering Rail 1 Pressure 2 (Extended Range)",
      "SPN_Description": "The pressure of fuel measured by the second rail pressure sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.",
      "bit_length": 16,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 130
    },
    "7098": {
      "PGN": 64564,
      "PGN_Name": "Engine Fuel Injector Metering Rail Pressure Information 2",
      "PGN_Description": "EFIMRPI2",
      "first_bit": 32,
      "SPN": 7098,
      "SPN_Name": "Engine Fuel 1 Injector Metering Rail 2 Pressure 1 (Extended Range)",
      "SPN_Description": "The pressure of fuel measured by first rail pressure sensor in the metering rail 2 as delivered from the supply pump to the injector metering intake.",
      "bit_length": 16,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 130
    },
    "7099": {
      "PGN": 64564,
      "PGN_Name": "Engine Fuel Injector Metering Rail Pressure Information 2",
      "PGN_Description": "EFIMRPI2",
      "first_bit": 48,
      "SPN": 7099,
      "SPN_Name": "Engine Fuel 1 Injector Metering Rail 2 Pressure 2 (Extended Range)",
      "SPN_Description": "The pressure of fuel measured by second rail pressure sensor in the metering rail 2 as delivered from the supply pump to the injector metering intake.",
      "bit_length": 16,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 130
    },
    "7100": {
      "PGN": 64563,
      "PGN_Name": "Engine Fuel Injector Metering Rail Pressure Information 3",
      "PGN_Description": "EFIMRPI3",
      "first_bit": 0,
      "SPN": 7100,
      "SPN_Name": "Engine Fuel 1 Injector Metering Rail 1 Desired Pressure",
      "SPN_Description": "The desired pressure of fuel in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.",
      "bit_length": 16,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 130
    },
    "7101": {
      "PGN": 64563,
      "PGN_Name": "Engine Fuel Injector Metering Rail Pressure Information 3",
      "PGN_Description": "EFIMRPI3",
      "first_bit": 16,
      "SPN": 7101,
      "SPN_Name": "Engine Fuel 1 Injector Metering Rail 2 Desired Pressure",
      "SPN_Description": "The desired pressure of fuel in metering rail 2 as delivered from the supply pump to the injector metering intake.",
      "bit_length": 16,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 130
    },
    "7104": {
      "PGN": 65130,
      "PGN_Name": "Engine Fuel/Lube Systems",
      "PGN_Description": "EFS",
      "first_bit": 56,
      "SPN": 7104,
      "SPN_Name": "Engine Fuel Supply Pump Intake Pressure",
      "SPN_Description": "Gage pressure of fuel at the fuel supply pump intake.  See Figures SPN16_A & SPN16_B.\r\n\r\nSee also SPN 1381.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "7107": {
      "PGN": 64828,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A1DEFSI",
      "first_bit": 44,
      "SPN": 7107,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Pump",
      "SPN_Description": "State of the aftertreatment 1 Diesel Exhaust Fluid dosing pump.  Indicates if the pump is currently active (pumping).  \r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available\r\n\r\nThe aftertreatment 1 Diesel Exhaust Fluid dosing pump is a device that delivers a pressurized DEF to the DEF injector. This can be mixed with or without pressurized air.\r\n\r\nNote:  SPN 5435 provides operational status of the pump.\r\n\r\nSee also SPN 3361 - Aftertreatment 1 Diesel Exhaust Fluid Dosing Unit\r\n\r\nOn a system that does not have an electrically driven valve on the injector, 'DEF Dosing Unit' is the only SPN needed as the pump is directly metering DEF into the exhaust stream. On a DEF system that has an electrically driven injector, the injector is actually metering the dosing quantity and the pump is just supplying pressure to the injector.  In the second case, the \"DEF dosing unit\" SPN would be used for the electrically driven injector and the \"DEF Pump\" SPN would be used for the pump supplying pressure to the injector.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7108": {
      "PGN": 64819,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A2DEFSI",
      "first_bit": 44,
      "SPN": 7108,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Pump",
      "SPN_Description": "State of the Aftertreatment 2 Diesel Exhaust Fluid dosing pump.  Indicates if the pump is currently active (pumping).  \r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available\r\n\r\nThe Aftertreatment 2 Diesel Exhaust Fluid dosing pump is a device that delivers a pressurized DEF to the DEF injector. This can be mixed with or without pressurized air.\r\n\r\nNote:  SPN 5438 provides operational status of the pump.\r\n\r\nSee also SPN 4451 - Aftertreatment 2 Diesel Exhaust Fluid Dosing Unit 1\r\n\r\nOn a system that does not have an electrically driven valve on the injector, 'DEF Dosing Unit' is the only SPN needed as the pump is directly metering DEF into the exhaust stream. On a DEF system that has an electrically driven injector, the injector is actually metering the dosing quantity and the pump is just supplying pressure to the injector.  In the second case, the \"DEF dosing unit\" SPN would be used for the electrically driven injector and the \"DEF Pump\" SPN would be used for the pump supplying pressure to the injector.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7313": {
      "PGN": 65172,
      "PGN_Name": "Engine Auxiliary Coolant",
      "PGN_Description": "EAC",
      "first_bit": 32,
      "SPN": 7313,
      "SPN_Name": "Engine Coolant Pressure 2 (Extended Range)",
      "SPN_Description": "Gage pressure of liquid found in engine coolant system - second instance.\r\n\r\nSee also SPN 5708 for alternate range and resolution.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "7314": {
      "PGN": 64713,
      "PGN_Name": "Engine Fuel/Throttle Valve Information 2",
      "PGN_Description": "EF/TVI2",
      "first_bit": 40,
      "SPN": 7314,
      "SPN_Name": "Engine Fuel Rack Fuel Supply Temperature",
      "SPN_Description": "Temperature of fuel in the engine fuel rack.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7315": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 8,
      "SPN": 7315,
      "SPN_Name": "Propulsion System Active",
      "SPN_Description": "Indicates when the hybrid system is ready to provide or is actively providing propulsion as defined in ARB regulation 13CCR1971.1, which includes the amendments up to the Board hearing date of August 2012. This parameter is called out by the 1971.1 regulation in several areas including, but not limited to: the ignition cycle counter [1971.1 paragraphs (d)(5.5.2)(B) and (d)(5.5.2)(C)], permanent fault code erasure  [(d)(2.3.1)(C)(ii)b.3.v], and denominator incrementing [(d)(4.3.2)(J)(i)] requirements. For example, \"for hybrid vehicles, 'ignition cycle' means a driving cycle that begins when the propulsion system active definition is met for at least two seconds plus or minus one second, and ends when the propulsion system active definition is no longer met.”\r\n\r\nNOTE: The parameter name contains the word “active” so that it matches the naming in the ARB regulation. However, this parameter not only indicates that the hybrid system is actively aiding or retarding vehicle motion (i.e., generating any positive or negative torque on the driveline); it also shall be asserted when the hybrid system is ready to participate in such activities if vehicle conditions or operator input warrant. Therefore, this parameter is asserted when the vehicle is ready to provide propulsion (e.g., vehicle is ready to be driven, ready to be shifted from “park” to “drive”) and doesn’t change state again until the system is neither ready to provide, nor actively providing, propulsion.\r\n\r\nThis parameter is required for hybrid vehicles because there is a difference between a conventional vehicle, where powertrain readiness is equivalent to “Engine Running”, and a hybrid vehicle, where the engine may or may not be running and yet the vehicle could move. However, if the engine is running (engine speed is nonzero), this parameter shall be set to 1. If the engine speed is zero, then this parameter shall be set based on the hybrid system operating state. For heavy duty vehicles, the hybrid system needs to inform the OBD related components of its propulsion active or readiness state to allow the components to perform OBD related functions.\r\n\r\nPropulsion System Active cannot be used as an indication of propulsion availability as it is required to indicate “active” whenever the engine is running.  This is regardless of the hybrid system’s ability to provide propulsion power.  See SPN 8267 for an indication of hybrid system propulsion availability.\r\r\n\r\nThis message is intended to be used by the Hybrid System Controller to communicate to other OBD related components (e.g engine) the status of the overall hybrid system. It should not be sent by individual hybrid system components (e.g. batteries, inverters, etc.)\r\n\r\n00 - Propulsion System is not ready to move vehicle if commanded by operator\r\n01 - Propulsion System is ready to move, or is moving the vehicle as commanded by operator\r\n10 - SAE Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7316": {
      "PGN": 61651,
      "PGN_Name": "Predictive Cruise Control 1",
      "PGN_Description": "PCC1",
      "first_bit": 0,
      "SPN": 7316,
      "SPN_Name": "Predictive Cruise Control Set Speed Offset",
      "SPN_Description": "The amount by which the actual set point used by the cruise control algorithm should be changed as determined by external factors (e.g., anticipated road grade).\r\n\r\nIf SPN 7317 indicates Enabled (0001b) and if the cruise control algorithm determines that the offset will be honored, then the value in SPN 7316 will be added to the Cruise Control Set Speed indicated by SPN 86 (also SPN 6809). This sum will be the present set point used by the cruise control algorithm.\r\n\r\nIf the cruise control algorithm determines that the offset will not be honored, then the cruise control set point is the value in SPN 86 (and SPN 6809).\r\n\r\nSPN 86 and SPN 6809 both reflect the selected cruise control set speed; they do not include the offset in SPN 7316. See Cruise Control Speed (SPN 7319) for a parameter that will include the offset in SPN 7316.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": -125,
      "unit": "km/h",
      "SLOT_ID": 399
    },
    "7317": {
      "PGN": 61651,
      "PGN_Name": "Predictive Cruise Control 1",
      "PGN_Description": "PCC1",
      "first_bit": 16,
      "SPN": 7317,
      "SPN_Name": "Predictive Cruise Control State",
      "SPN_Description": "Indicates the state of the PCC controller.\r\n\r\nIf this parameter is 0001, the cruise control set point may be modified by the Predictive Cruise Control Set Speed Offset (SPN 7316) . For states other than 0001, the value in Predictive Cruise Control Set Speed Offset (SPN 7316) shall be ignored.\r\n\r\nPredictive Cruise Control Set Speed Offset Status (SPN 7318) will indicate of the cruise control algorithm has adjusted its set point by the value specified in Predictive Cruise Control Set Speed Offset (SPN 7316).\r\n\r\nIn the event that more than one reason for not being functional (0010 to 1000) is active at the same time, it is up to the manufacturer to decide which reason is reported. It is expected that 0111 (inhibited by driver) would have priority over the other states that indicate non-functional.\r\n\r\n0000 Disabled\r\n0001 Enabled\r\n0010 Enabled, but not functional due to vehicle position not available\r\n0011 Enabled, but not functional due to map position not available\r\n0100 Enabled, but not functional due to road grade info not available\r\n0101 Enabled, but not functional due to predicted path not available\r\n0110 Enabled, but not functional due to vehicle speed below speed threshold\r\n0111 Enabled, but not functional due to inhibited by driver\r\n1000 Enabled, but not functional due to self test\r\n1001 to 1101 SAE Reserved\r\n1110 Error\r\n1111 Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7318": {
      "PGN": 64732,
      "PGN_Name": "Cruise Control / Vehicle Speed 3",
      "PGN_Description": "CCVS3",
      "first_bit": 5,
      "SPN": 7318,
      "SPN_Name": "Predictive Cruise Control Set Speed Offset Status",
      "SPN_Description": "This parameter indicates if the cruise control algorithm is currently adding the value in Predictive Cruise Control Set Speed Offset (SPN 7316) to the Cruise Control Set Speed (SPN 86 or SPN 6809) for its set point. The final set point will be reported in Cruise Control Speed (SPN 7319).\r\n\r\n00 Cruise Control Speed (SPN 7319) does not include Predictive Cruise Control Set Speed Offset (SPN 7316)\r\n01 Cruise Control Speed (SPN 7319) includes Predictive Cruise Control Set Speed Offset (SPN 7316)\r\n10 SAE Reserved\r\n11 Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7319": {
      "PGN": 64732,
      "PGN_Name": "Cruise Control / Vehicle Speed 3",
      "PGN_Description": "CCVS3",
      "first_bit": 48,
      "SPN": 7319,
      "SPN_Name": "Cruise Control Speed",
      "SPN_Description": "This parameter is the vehicle speed that the cruise control algorithm is currently using as its cruise control set point.\r\n\r\nCruise Control Speed (SPN 7319) will include the effects of other algorithms, such as Predictive Cruise Control, Adaptive Cruise Control, etc., that may adjust the cruise control speed from the Cruise Control Set Speed (SPNs 86 and 6809). If there are no other algorithms currently adjusting the cruise control set speed, then Cruise Control Speed (SPN 7319) will be the same value as Cruise Control Set Speed (SPN 6809).",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 71
    },
    "7321": {
      "PGN": 64562,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 3",
      "PGN_Description": "AFT1PSI3",
      "first_bit": 0,
      "SPN": 7321,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Heater High Side Driver Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment particulate sensor heater high side driver by the manufacturer’s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n \r\nThis parameter is only valid if Aftertreatment 1 Particulate Sensor Heater High Side Driver Diagnostic Status (SPN 7322) is equal to 000b, 010b or 011b.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 90
    },
    "7322": {
      "PGN": 64562,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 3",
      "PGN_Description": "AFT1PSI3",
      "first_bit": 5,
      "SPN": 7322,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Heater High Side Driver Diagnostic Status",
      "SPN_Description": "The value of this parameter is not retained when power is removed from the particulate sensor.\r\n\r\n000 - Tests monitored continuously. There are no enable or pause conditions. See Aftertreatment 1 Particulate Sensor Heater High Side Driver Preliminary FMI (SPN 7321) for result.\r\n\r\n001 - Tests supported but not completed this power cycle. Enable or pause conditions have not been satisfied, which has prevented tests from executing. When tests have completed, this parameter shall change to 010. Aftertreatment 1 Particulate Sensor Heater High Side Driver Preliminary FMI (SPN 7321) is not valid at the present time.\r\n\r\n010 – Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 010, then this parameter shall change to 011. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Heater High Side Driver Preliminary FMI (SPN 7321) for the most recent result.\r\n\r\n011 – Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 011, then this parameter shall change to 010. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Heater High Side Driver Preliminary FMI (SPN 7321) for the most recent result.\r\n\r\n100 to 110 – SAE Reserved\r\n\r\n111 – Not Available. Aftertreatment 1 Particulate Sensor Heater High Side Driver Preliminary FMI (SPN 7321) is not valid.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7323": {
      "PGN": 64562,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 3",
      "PGN_Description": "AFT1PSI3",
      "first_bit": 8,
      "SPN": 7323,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Heater Low Side Driver Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment particulate sensor heater high side driver by the manufacturer’s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n \r\nThis parameter is only valid if Aftertreatment 1 Particulate Sensor Heater Low Side Driver Diagnostic Status (SPN 7324) is equal to 000b, 010b or 011b.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 90
    },
    "7324": {
      "PGN": 64562,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 3",
      "PGN_Description": "AFT1PSI3",
      "first_bit": 13,
      "SPN": 7324,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Heater Low Side Driver Diagnostic Status",
      "SPN_Description": "The value of this parameter is not retained when power is removed from the particulate sensor.\r\n\r\n000 - Tests monitored continuously. There are no enable or pause conditions. See Aftertreatment 1 Particulate Sensor Heater Low Side Driver Preliminary FMI (SPN 7323) for result.\r\n\r\n001 - Tests supported but not completed this power cycle. Enable or pause conditions have not been satisfied, which has prevented tests from executing. When tests have completed, this parameter shall change to 010. Aftertreatment 1 Particulate Sensor Heater Low Side Driver Preliminary FMI (SPN 7323) is not valid at the present time. \r\n\r\n010 – Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 010, then this parameter shall change to 011. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Heater Low Side Driver Preliminary FMI (SPN 7323) for the most recent result.\r\n\r\n011 – Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 011, then this parameter shall change to 010. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Heater Low Side Driver Preliminary FMI (SPN 7323) for the most recent result.\r\n\r\n100 to 110 – SAE Reserved\r\n\r\n111 – Not Available. Aftertreatment 1 Particulate Sensor Heater Low Side Driver Preliminary FMI (SPN 7323) is not valid.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7325": {
      "PGN": 64562,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 3",
      "PGN_Description": "AFT1PSI3",
      "first_bit": 16,
      "SPN": 7325,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Input Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment particulate sensor input by the manufacturer’s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported. \r\n\r\nThis parameter is only valid if Aftertreatment 1 Particulate Sensor Input Diagnostic Status (SPN 7326) is equal to 000b, 010b or 011b.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 90
    },
    "7326": {
      "PGN": 64562,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 3",
      "PGN_Description": "AFT1PSI3",
      "first_bit": 21,
      "SPN": 7326,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Input Diagnostic Status",
      "SPN_Description": "The value of this parameter is not retained when power is removed from the particulate sensor.\r\n\r\n000 - Tests monitored continuously. There are no enable or pause conditions. See Aftertreatment 1 Particulate Sensor Input Preliminary FMI (SPN 7325) for result.\r\n\r\n001 - Tests supported but not completed this power cycle. Enable or pause conditions have not been satisfied, which has prevented tests from executing. When tests have completed, this parameter shall change to 010. Aftertreatment 1 Particulate Sensor Input Preliminary FMI (SPN 7325) is not valid at the present time.\r\n\r\n010 – Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 010, then this parameter shall change to 011. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Input Preliminary FMI (SPN 7325) for the most recent result.\r\n\r\n011 – Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 011, then this parameter shall change to 010. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Input Preliminary FMI (SPN 7325) for the most recent result.\r\n\r\n100 to 110 – SAE Reserved\r\n\r\n111 – Not Available. Aftertreatment 1 Particulate Sensor Input Preliminary FMI (SPN 7325) is not valid.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7327": {
      "PGN": 64562,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 3",
      "PGN_Description": "AFT1PSI3",
      "first_bit": 24,
      "SPN": 7327,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Power Supply Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment particulate sensor power supply by the manufacturer’s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nThis parameter is only valid if Aftertreatment 1 Particulate Sensor Power Supply Diagnostic Status (SPN 7328) is equal to 000b, 010b or 011b.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 90
    },
    "7328": {
      "PGN": 64562,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 3",
      "PGN_Description": "AFT1PSI3",
      "first_bit": 29,
      "SPN": 7328,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Power Supply Diagnostic Status",
      "SPN_Description": "The value of this parameter is not retained when power is removed from the particulate sensor.\r\n\r\n000 - Tests monitored continuously. There are no enable or pause conditions. See Aftertreatment 1 Particulate Sensor Power Supply Preliminary FMI (SPN 7327) for result.\r\n\r\n001 - Tests supported but not completed this power cycle. Enable or pause conditions have not been satisfied, which has prevented tests from executing. When tests have completed, this parameter shall change to 010. Aftertreatment 1 Particulate Sensor Power Supply Preliminary FMI (SPN 7327) is not valid at the present time.\r\n\r\n010 – Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 010, then this parameter shall change to 011. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Power Supply Preliminary FMI (SPN 7327) for the most recent result.\r\n\r\n011 – Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 011, then this parameter shall change to 010. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Power Supply Preliminary FMI (SPN 7327) for the most recent result.\r\n\r\n100 to 110 – SAE Reserved\r\n\r\n111 – Not Available. Aftertreatment 1 Particulate Sensor Power Supply Preliminary FMI (SPN 7327) is not valid.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7329": {
      "PGN": 64562,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 3",
      "PGN_Description": "AFT1PSI3",
      "first_bit": 32,
      "SPN": 7329,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Heater Power Supply Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment particulate sensor heater power supply by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nThis parameter is only valid if Aftertreatment 1 Particulate Sensor Heater Power Supply Diagnostic Status (SPN 7330) is equal to 000b, 010b or 011b.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 90
    },
    "7330": {
      "PGN": 64562,
      "PGN_Name": "Aftertreatment 1 Particulate Sensor Information 3",
      "PGN_Description": "AFT1PSI3",
      "first_bit": 37,
      "SPN": 7330,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Heater Power Supply Diagnostic Status",
      "SPN_Description": "The value of this parameter is not retained when power is removed from the particulate sensor.\r\n\r\n000 - Tests monitored continuously. There are no enable or pause conditions. See Aftertreatment 1 Particulate Sensor Heater Power Supply Preliminary FMI (SPN 7329) for result. \r\n\r\n001 - Tests supported but not completed this power cycle. Enable or pause conditions have not been satisfied, which has prevented tests from executing. When tests have completed, this parameter shall change to 010. Aftertreatment 1 Particulate Sensor Heater Power Supply Preliminary FMI (SPN 7329) is not valid at the present time.\r\n\r\n010 – Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 010, then this parameter shall change to 011. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Heater Power Supply Preliminary FMI (SPN 7329) for the most recent result.\r\n\r\n011 – Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 011, then this parameter shall change to 010. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Heater Power Supply Preliminary FMI (SPN 7329) for the most recent result.\r\n\r\n100 to 110 – SAE Reserved\r\n\r\n111 – Not Available. Aftertreatment 1 Particulate Sensor Heater Power Supply Preliminary FMI (SPN 7329) is not valid.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7331": {
      "PGN": 33024,
      "PGN_Name": "Aftertreatment System Control",
      "PGN_Description": "AFTSC",
      "first_bit": 0,
      "SPN": 7331,
      "SPN_Name": "Aftertreatment Thermal Management Inhibit Request",
      "SPN_Description": "Provides state of inhibit request for Aftertreatment thermal management from external system.\r\n\r\nAftertreatment Thermal Management indicates that the exhaust temperatures have been controlled for expected functioning of the aftertreatment system - This is not just limited to temperature increase for regeneration of DPF or SCR.\r\nInhibit request is active when temperature change in aftertreatment system leads to deviation in the normal functioning of the external system and external system requests thermal management to be suspended for some duration.\r\n\r\nStatus of SPN 7332 indicates whether the inhibit request is accepted.\r\n\r\n00   Do not inhibit\r\n01   Inhibit\r\n10   Reserved for SAE assignment\r\n11   Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7332": {
      "PGN": 64561,
      "PGN_Name": "Aftertreatment System Information 1",
      "PGN_Description": "ASI1",
      "first_bit": 0,
      "SPN": 7332,
      "SPN_Name": "Aftertreatment Thermal Management Status",
      "SPN_Description": "Indicates whether Aftertreatment Thermal Management process is active.\r\n\r\nAftertreatment Thermal Management indicates that the exhaust temperatures have been controlled for the normal functioning of the aftertreatment system - This is not just limited to temperature increase for regeneration of DPF or SCR.\r\n\r\n'00' - Not Active State may also be due to inhibit request in SPN 7331.\r\n\r\n00   Not active\r\n01   Active\r\n10   Reserved for SAE assignment\r\n11   Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7333": {
      "PGN": 64587,
      "PGN_Name": "Electronic Engine Controller 17",
      "PGN_Description": "EEC17",
      "first_bit": 48,
      "SPN": 7333,
      "SPN_Name": "Cylinder Fuel Rate",
      "SPN_Description": "Cylinder fuel rate shall indicate the amount of fuel injected into the cylinder for combustion during the most recent intake stroke of the engine.\r\n\r\nNOTE: Cylinder fuel rate shall indicate zero mg/stroke when the engine is not running.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": 0,
      "unit": "mg/stroke",
      "SLOT_ID": 400
    },
    "7341": {
      "PGN": 64560,
      "PGN_Name": "SCR Operator Inducement Information 4",
      "PGN_Description": "SCROII4",
      "first_bit": 0,
      "SPN": 7341,
      "SPN_Name": "SCR Operator Inducement Emergency Override Total Reset Occurrences",
      "SPN_Description": "The total number of times the feature, which allows the operator to override the inducement strategies (as described in SPN 6880) during emergencies, such as hurricanes, has been reset.\r\n\r\nThis counter can not be reset.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "7342": {
      "PGN": 64560,
      "PGN_Name": "SCR Operator Inducement Information 4",
      "PGN_Description": "SCROII4",
      "first_bit": 16,
      "SPN": 7342,
      "SPN_Name": "SCR Operator Inducement Override Mode",
      "SPN_Description": "Indicates the functional mode of SCR operator inducement override.\r\n\r\n000          Not Available\r\n001          Available - Not Active\r\n010          Active\r\n011          Active Extended\r\n100          Expired\r\n101-110  Not Defined\r\n111          Not Available\r\n\r\nNote:  This is SPN is intended for special emergency situations, such as natural disasters. Check legal implications before using this SPN.",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7343": {
      "PGN": 64560,
      "PGN_Name": "SCR Operator Inducement Information 4",
      "PGN_Description": "SCROII4",
      "first_bit": 19,
      "SPN": 7343,
      "SPN_Name": "SCR Operator Inducement Override Renewal Required",
      "SPN_Description": "Indicates the required operator inducement override renewal state.\r\n\r\n00 = Not Required\r\n01 = Required\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7344": {
      "PGN": 64560,
      "PGN_Name": "SCR Operator Inducement Information 4",
      "PGN_Description": "SCROII4",
      "first_bit": 24,
      "SPN": 7344,
      "SPN_Name": "SCR Operator Inducement Override Time Remaining (Extended Range)",
      "SPN_Description": "Used to indicate the time remaining during an operator inducement override event.  When an operator inducement is active this parameter indicates the remaining time that the currently active operator inducement may be overridden.\r\n\r\nSee also SPN 6878 for an alternate SLOT.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "min",
      "SLOT_ID": 238
    },
    "7346": {
      "PGN": 64923,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Information 1",
      "PGN_Description": "A1DEFI1",
      "first_bit": 48,
      "SPN": 7346,
      "SPN_Name": "Diesel Exhaust Fluid Speed of Sound",
      "SPN_Description": "The speed of sound in the fluid that is in the diesel exhaust fluid tank.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "m/s",
      "SLOT_ID": 401
    },
    "7347": {
      "PGN": 64559,
      "PGN_Name": "Fire Suppression Agent Status",
      "PGN_Description": "FSAS",
      "first_bit": 0,
      "SPN": 7347,
      "SPN_Name": "Fire Suppression Water Tank Level",
      "SPN_Description": "Liquid level of the fire apparatus water tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7348": {
      "PGN": 64559,
      "PGN_Name": "Fire Suppression Agent Status",
      "PGN_Description": "FSAS",
      "first_bit": 8,
      "SPN": 7348,
      "SPN_Name": "Fire Suppression Class-A Foam Tank Level",
      "SPN_Description": "Liquid level of the Class-A foam agent tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7349": {
      "PGN": 64559,
      "PGN_Name": "Fire Suppression Agent Status",
      "PGN_Description": "FSAS",
      "first_bit": 16,
      "SPN": 7349,
      "SPN_Name": "Fire Suppression Class-B Foam Tank Level",
      "SPN_Description": "Liquid level of the Class-B foam agent tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7350": {
      "PGN": 64559,
      "PGN_Name": "Fire Suppression Agent Status",
      "PGN_Description": "FSAS",
      "first_bit": 24,
      "SPN": 7350,
      "SPN_Name": "Fire Suppression Compressed Air Foam System Air Pressure",
      "SPN_Description": "Compressed Air Foam System (CAFS) air compressor pressure.",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "7351": {
      "PGN": 64782,
      "PGN_Name": "Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT1OGC2",
      "first_bit": 40,
      "SPN": 7351,
      "SPN_Name": "Aftertreatment 1 Outlet Corrected NOx",
      "SPN_Description": "The corrected outlet NOx value for aftertreatment 1 shall include all learned adaptions and offsets that are used to adjust the raw signal.\r\n\r\n2016 MY and later engines with NOx sensors may be required to output a ‘corrected’ NOx sensor signal in addition to the raw NOx sensor signal out using SPN 3226.\r\n\r\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "7352": {
      "PGN": 64778,
      "PGN_Name": "Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT2OGC2",
      "first_bit": 40,
      "SPN": 7352,
      "SPN_Name": "Aftertreatment 2 Outlet Corrected NOx",
      "SPN_Description": "The corrected outlet NOx value  for aftertreatment 2 shall include all learned adaptions and offsets that are used to adjust the raw signal.\r\n\r\n2016 MY and later engines with NOx sensors may be required to output a ‘corrected’ NOx sensor signal in addition to the raw NOx sensor signal out using SPN 3265.\r\n\r\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "7353": {
      "PGN": 64784,
      "PGN_Name": "Aftertreatment 1 Intake Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT1IGC2",
      "first_bit": 40,
      "SPN": 7353,
      "SPN_Name": "Aftertreatment 1 SCR Intake Corrected NOx",
      "SPN_Description": "The corrected intake Selective Catalytic Reduction NOx value for aftertreatment 1 shall include all learned adaptions and offsets that are used to adjust the raw signal.\r\n\r\n2016 MY and later engines with NOx sensors may be required to output a ‘corrected’ NOx sensor signal in addition to the raw NOx sensor signal out using SPN 3216.\r\n\r\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "7354": {
      "PGN": 64780,
      "PGN_Name": "Aftertreatment 2 Intake Gas NOx Sensor Correction Data 2",
      "PGN_Description": "AT2IGC2",
      "first_bit": 40,
      "SPN": 7354,
      "SPN_Name": "Aftertreatment 2 SCR Intake Corrected NOx",
      "SPN_Description": "The corrected intake Selective Catalytic Reduction NOx value for aftertreatment 2 shall include all learned adaptions and offsets that are used to adjust the raw signal.\r\n\r\n2016 MY and later engines with NOx sensors may be required to output a ‘corrected’ NOx sensor signal in addition to the raw NOx sensor signal out using SPN 3255.\r\n\r\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "7355": {
      "PGN": 7424,
      "PGN_Name": "Engine Ignition Controller",
      "PGN_Description": "EIC",
      "first_bit": 0,
      "SPN": 7355,
      "SPN_Name": "Engine Timing Advance",
      "SPN_Description": "Ignition timing as a command to the ignition control module.  Positive values command an increasingly advanced timing from TDC. The same timing applies to all cylinders. Use SPN 7356 - SPN 7379 for cylinder specific timing offsets from this timing.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "7356": {
      "PGN": 61669,
      "PGN_Name": "Engine Ignition Timing Offset 1",
      "PGN_Description": "ITO1",
      "first_bit": 0,
      "SPN": 7356,
      "SPN_Name": "Engine Cylinder 1 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 1 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7357": {
      "PGN": 61669,
      "PGN_Name": "Engine Ignition Timing Offset 1",
      "PGN_Description": "ITO1",
      "first_bit": 8,
      "SPN": 7357,
      "SPN_Name": "Engine Cylinder 2 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 2 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7358": {
      "PGN": 61669,
      "PGN_Name": "Engine Ignition Timing Offset 1",
      "PGN_Description": "ITO1",
      "first_bit": 16,
      "SPN": 7358,
      "SPN_Name": "Engine Cylinder 3 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 3 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7359": {
      "PGN": 61669,
      "PGN_Name": "Engine Ignition Timing Offset 1",
      "PGN_Description": "ITO1",
      "first_bit": 24,
      "SPN": 7359,
      "SPN_Name": "Engine Cylinder 4 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 4 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7360": {
      "PGN": 61669,
      "PGN_Name": "Engine Ignition Timing Offset 1",
      "PGN_Description": "ITO1",
      "first_bit": 32,
      "SPN": 7360,
      "SPN_Name": "Engine Cylinder 5 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 5 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7361": {
      "PGN": 61669,
      "PGN_Name": "Engine Ignition Timing Offset 1",
      "PGN_Description": "ITO1",
      "first_bit": 40,
      "SPN": 7361,
      "SPN_Name": "Engine Cylinder 6 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 6 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7362": {
      "PGN": 61669,
      "PGN_Name": "Engine Ignition Timing Offset 1",
      "PGN_Description": "ITO1",
      "first_bit": 48,
      "SPN": 7362,
      "SPN_Name": "Engine Cylinder 7 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 7 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7363": {
      "PGN": 61669,
      "PGN_Name": "Engine Ignition Timing Offset 1",
      "PGN_Description": "ITO1",
      "first_bit": 56,
      "SPN": 7363,
      "SPN_Name": "Engine Cylinder 8 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 8 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7364": {
      "PGN": 61670,
      "PGN_Name": "Engine Ignition Timing Offset 2",
      "PGN_Description": "ITO2",
      "first_bit": 0,
      "SPN": 7364,
      "SPN_Name": "Engine Cylinder 9 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 9 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7365": {
      "PGN": 61670,
      "PGN_Name": "Engine Ignition Timing Offset 2",
      "PGN_Description": "ITO2",
      "first_bit": 8,
      "SPN": 7365,
      "SPN_Name": "Engine Cylinder 10 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 10 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7366": {
      "PGN": 61670,
      "PGN_Name": "Engine Ignition Timing Offset 2",
      "PGN_Description": "ITO2",
      "first_bit": 16,
      "SPN": 7366,
      "SPN_Name": "Engine Cylinder 11 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 11 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7367": {
      "PGN": 61670,
      "PGN_Name": "Engine Ignition Timing Offset 2",
      "PGN_Description": "ITO2",
      "first_bit": 24,
      "SPN": 7367,
      "SPN_Name": "Engine Cylinder 12 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 12 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7368": {
      "PGN": 61670,
      "PGN_Name": "Engine Ignition Timing Offset 2",
      "PGN_Description": "ITO2",
      "first_bit": 32,
      "SPN": 7368,
      "SPN_Name": "Engine Cylinder 13 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 13 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7369": {
      "PGN": 61670,
      "PGN_Name": "Engine Ignition Timing Offset 2",
      "PGN_Description": "ITO2",
      "first_bit": 40,
      "SPN": 7369,
      "SPN_Name": "Engine Cylinder 14 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 14 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7370": {
      "PGN": 61670,
      "PGN_Name": "Engine Ignition Timing Offset 2",
      "PGN_Description": "ITO2",
      "first_bit": 48,
      "SPN": 7370,
      "SPN_Name": "Engine Cylinder 15 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 15 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7371": {
      "PGN": 61670,
      "PGN_Name": "Engine Ignition Timing Offset 2",
      "PGN_Description": "ITO2",
      "first_bit": 56,
      "SPN": 7371,
      "SPN_Name": "Engine Cylinder 16 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 16 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7372": {
      "PGN": 61671,
      "PGN_Name": "Engine Ignition Timing Offset 3",
      "PGN_Description": "ITO3",
      "first_bit": 0,
      "SPN": 7372,
      "SPN_Name": "Engine Cylinder 17 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 17 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7373": {
      "PGN": 61671,
      "PGN_Name": "Engine Ignition Timing Offset 3",
      "PGN_Description": "ITO3",
      "first_bit": 8,
      "SPN": 7373,
      "SPN_Name": "Engine Cylinder 18 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 18 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7374": {
      "PGN": 61671,
      "PGN_Name": "Engine Ignition Timing Offset 3",
      "PGN_Description": "ITO3",
      "first_bit": 16,
      "SPN": 7374,
      "SPN_Name": "Engine Cylinder 19 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 19 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7375": {
      "PGN": 61671,
      "PGN_Name": "Engine Ignition Timing Offset 3",
      "PGN_Description": "ITO3",
      "first_bit": 24,
      "SPN": 7375,
      "SPN_Name": "Engine Cylinder 20 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 20 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7376": {
      "PGN": 61671,
      "PGN_Name": "Engine Ignition Timing Offset 3",
      "PGN_Description": "ITO3",
      "first_bit": 32,
      "SPN": 7376,
      "SPN_Name": "Engine Cylinder 21 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 21 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7377": {
      "PGN": 61671,
      "PGN_Name": "Engine Ignition Timing Offset 3",
      "PGN_Description": "ITO3",
      "first_bit": 40,
      "SPN": 7377,
      "SPN_Name": "Engine Cylinder 22 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 22 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7378": {
      "PGN": 61671,
      "PGN_Name": "Engine Ignition Timing Offset 3",
      "PGN_Description": "ITO3",
      "first_bit": 48,
      "SPN": 7378,
      "SPN_Name": "Engine Cylinder 23 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 23 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7379": {
      "PGN": 61671,
      "PGN_Name": "Engine Ignition Timing Offset 3",
      "PGN_Description": "ITO3",
      "first_bit": 56,
      "SPN": 7379,
      "SPN_Name": "Engine Cylinder 24 Ignition Timing Offset",
      "SPN_Description": "The ignition timing offset for Cylinder 24 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7380": {
      "PGN": 64558,
      "PGN_Name": "Engine Turbocharger Control 3",
      "PGN_Description": "ETCC3",
      "first_bit": 0,
      "SPN": 7380,
      "SPN_Name": "Engine Turbocharger Compressor Blowoff Actuator 1 Motor Current Disable",
      "SPN_Description": "Command to disable power to motor in the actuator to prevent unnecessary load on the component.\r\n\r\n00 - Do Not Disable\r\n01 - Disable\r\n10 - Reserved\r\n11 - Don't Care/Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7381": {
      "PGN": 64558,
      "PGN_Name": "Engine Turbocharger Control 3",
      "PGN_Description": "ETCC3",
      "first_bit": 2,
      "SPN": 7381,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 1 Motor Current Disable",
      "SPN_Description": "Command to disable power to motor in the actuator to prevent unnecessary load on the component.\r\n\r\n00 - Do Not Disable\r\n01 - Disable\r\n10 - Reserved\r\n11 - Don't Care/Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7382": {
      "PGN": 64558,
      "PGN_Name": "Engine Turbocharger Control 3",
      "PGN_Description": "ETCC3",
      "first_bit": 4,
      "SPN": 7382,
      "SPN_Name": "Engine Cylinder Head Bypass Actuator 1 Motor Current Disable",
      "SPN_Description": "Command to disable power to motor in the actuator to prevent unnecessary load on the component.\r\n\r\n00 - Do Not Disable\r\n01 - Disable\r\n10 - Reserved\r\n11 - Don't Care/Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7383": {
      "PGN": 64558,
      "PGN_Name": "Engine Turbocharger Control 3",
      "PGN_Description": "ETCC3",
      "first_bit": 6,
      "SPN": 7383,
      "SPN_Name": "Engine Throttle Valve 1 Motor Current Disable",
      "SPN_Description": "Command to disable power to motor in the actuator to prevent unnecessary load on the component.\r\n\r\n00 - Do Not Disable\r\n01 - Disable\r\n10 - Reserved\r\n11 - Don't Care/Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7393": {
      "PGN": 64720,
      "PGN_Name": "Engine Particulate Sensor Information",
      "PGN_Description": "EPSI",
      "first_bit": 32,
      "SPN": 7393,
      "SPN_Name": "Aftertreatment 1 Particulate Sensor Current",
      "SPN_Description": "Raw aftertreatment 1 PM sensor electrical current reading.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "µA",
      "SLOT_ID": 403
    },
    "7394": {
      "PGN": 64962,
      "PGN_Name": "Electronic Engine Controller 14",
      "PGN_Description": "EEC14",
      "first_bit": 56,
      "SPN": 7394,
      "SPN_Name": "Engine Fuel Isolation Control",
      "SPN_Description": "Control setting for fuel isolation. In a single injector dual fuel system when using just diesel fuel, diesel must not be allowed to migrate into the gaseous fuel system. When the fuel isolation valve is closed the engine uses dual fuel by allowing the mechanical regulator controls the gaseous fuel to a pressure lower than the diesel fuel. When the fuel isolation valve is open the mechanical regulator does not see diesel fuel pressure so the gaseous fuel is off which prevents diesel fuel from migrating to the gaseous fuel system.\r\n\r\n00 = Gaseous Fuel Migration is Prevented\r\n01 = Gaseous Fuel is Used\r\n10 = Reserved\r\n11 = Don't care / take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7395": {
      "PGN": 64752,
      "PGN_Name": "Engine Fuel/lube systems 2",
      "PGN_Description": "EFS2",
      "first_bit": 24,
      "SPN": 7395,
      "SPN_Name": "Fuel Tank Transfer Pump Pressure",
      "SPN_Description": "Gage pressure of the fuel in the system as delivered by the transfer pump.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "7396": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 0,
      "SPN": 7396,
      "SPN_Name": "Tractor Brake Caliper Lining Clearance Axle 1 Left",
      "SPN_Description": "Brake caliper lining clearance for left brake on tractor axle 1.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7397": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 2,
      "SPN": 7397,
      "SPN_Name": "Tractor Brake Caliper Lining Clearance Axle 1 Right",
      "SPN_Description": "Brake caliper lining clearance for right brake on tractor axle 1.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7398": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 4,
      "SPN": 7398,
      "SPN_Name": "Tractor Brake Caliper Lining Clearance Axle 2 Left",
      "SPN_Description": "Brake caliper lining clearance for left brake on tractor axle 2.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7399": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 6,
      "SPN": 7399,
      "SPN_Name": "Tractor Brake Caliper Lining Clearance Axle 2 Right",
      "SPN_Description": "Brake caliper lining clearance for right brake on tractor axle 2.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7400": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 8,
      "SPN": 7400,
      "SPN_Name": "Tractor Brake Caliper Lining Clearance Axle 3 Left",
      "SPN_Description": "Brake caliper lining clearance for left brake on tractor axle 3.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7401": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 10,
      "SPN": 7401,
      "SPN_Name": "Tractor Brake Caliper Lining Clearance Axle 3 Right",
      "SPN_Description": "Brake caliper lining clearance for right brake on tractor axle 3.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7402": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 12,
      "SPN": 7402,
      "SPN_Name": "Tractor Brake Caliper Lining Clearance Axle 4 Left",
      "SPN_Description": "Brake caliper lining clearance for left brake on tractor axle 4.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7403": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 14,
      "SPN": 7403,
      "SPN_Name": "Tractor Brake Caliper Lining Clearance Axle 4 Right",
      "SPN_Description": "Brake caliper lining clearance for right brake on tractor axle 4.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7404": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 16,
      "SPN": 7404,
      "SPN_Name": "Tractor Brake Caliper Lining Clearance Axle 5 Left",
      "SPN_Description": "Brake caliper lining clearance for left brake on tractor axle 5.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7405": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 18,
      "SPN": 7405,
      "SPN_Name": "Tractor Brake Caliper Lining Clearance Axle 5 Right",
      "SPN_Description": "Brake caliper lining clearance for right brake on tractor axle 5.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7406": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 20,
      "SPN": 7406,
      "SPN_Name": "Trailer Brake Caliper Lining Clearance Axle 1 Left",
      "SPN_Description": "Brake caliper lining clearance for left brake on trailer axle 1.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7407": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 22,
      "SPN": 7407,
      "SPN_Name": "Trailer Brake Caliper Lining Clearance Axle 1 Right",
      "SPN_Description": "Brake caliper lining clearance for right brake on trailer axle 1.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7408": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 24,
      "SPN": 7408,
      "SPN_Name": "Trailer Brake Caliper Lining Clearance Axle 2 Left",
      "SPN_Description": "Brake caliper lining clearance for left brake on trailer axle 2.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7409": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 26,
      "SPN": 7409,
      "SPN_Name": "Trailer Brake Caliper Lining Clearance Axle 2 Right",
      "SPN_Description": "Brake caliper lining clearance for right brake on trailer axle 2.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7410": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 28,
      "SPN": 7410,
      "SPN_Name": "Trailer Brake Caliper Lining Clearance Axle 3 Left",
      "SPN_Description": "Brake caliper lining clearance for left brake on trailer axle 3.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7411": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 30,
      "SPN": 7411,
      "SPN_Name": "Trailer Brake Caliper Lining Clearance Axle 3 Right",
      "SPN_Description": "Brake caliper lining clearance for right brake on trailer axle 3.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7412": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 32,
      "SPN": 7412,
      "SPN_Name": "Trailer Brake Caliper Lining Clearance Axle 4 Left",
      "SPN_Description": "Brake caliper lining clearance for left brake on trailer axle 4.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7413": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 34,
      "SPN": 7413,
      "SPN_Name": "Trailer Brake Caliper Lining Clearance Axle 4 Right",
      "SPN_Description": "Brake caliper lining clearance for right brake on trailer axle 4.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7414": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 36,
      "SPN": 7414,
      "SPN_Name": "Trailer Brake Caliper Lining Clearance Axle 5 Left",
      "SPN_Description": "Brake caliper lining clearance for left brake on trailer axle 5.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7415": {
      "PGN": 64556,
      "PGN_Name": "Brake Caliper Lining Clearance",
      "PGN_Description": "BCLC",
      "first_bit": 38,
      "SPN": 7415,
      "SPN_Name": "Trailer Brake Caliper Lining Clearance Axle 5 Right",
      "SPN_Description": "Brake caliper lining clearance for right brake on trailer axle 5.\r\n\r\n00 - Caliper lining clearance is adequate\r\n01 - Caliper lining clearance is low\r\n10 - Error\r\n11 - Not available / not applicable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7416": {
      "PGN": 64828,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A1DEFSI",
      "first_bit": 42,
      "SPN": 7416,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Pump Power Relay",
      "SPN_Description": "The state of the aftertreatment 1 diesel exhaust fluid pump power relay.\r\n\r\n00 not active - no power is being applied to the relay\r\n01 active - power is being applied to the relay\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7417": {
      "PGN": 64699,
      "PGN_Name": "Aftertreatment 1 SCR Electronic Control Module Information",
      "PGN_Description": "A1ECMI",
      "first_bit": 6,
      "SPN": 7417,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Control Module Circuit Breaker",
      "SPN_Description": "The status of the circuit breaker that is used to power the diesel exhaust control module.\r\n\r\n00 off\r\n01 on\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7418": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 10,
      "SPN": 7418,
      "SPN_Name": "Hybrid System Engine Assist Status",
      "SPN_Description": "Provides the engine an indication of when the hybrid system is not mechanically assisting rotation (i.e. not motoring) the engine. When this parameter is in state 00, the engine can perform operations while free of potential hybrid system assistance.\r\n\r\nWhen this parameter is in state 01, the hybrid system may or may not mechanically assist engine rotation. While this parameter is in state 01, the engine should not perform operations that need to be free from hybrid system assistance.\r\n\r\n00 – Hybrid system is not mechanically assisting engine rotation\r\n01 – Hybrid system may or may not mechanically assist engine rotation\r\n10 – Error\r\n11 – Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7420": {
      "PGN": 64555,
      "PGN_Name": "Cruise Control / Vehicle Speed 4",
      "PGN_Description": "CCVS4",
      "first_bit": 0,
      "SPN": 7420,
      "SPN_Name": "Applied Vehicle Speed Limit (High Resolution)",
      "SPN_Description": "The vehicle speed limit in effect.\r\n\r\nSee SPN 2595 for alternate resolution.\r\n\r\nNote:  If a maximum vehicle speed limit is not selected, then the first byte of this parameter will be equal to 0xFB.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 71
    },
    "7421": {
      "PGN": 64849,
      "PGN_Name": "Aftercooler Coolant Control Valve Command",
      "PGN_Description": "ACCVC",
      "first_bit": 24,
      "SPN": 7421,
      "SPN_Name": "Engine Charge Air Cooler Bypass Valve 1 Command",
      "SPN_Description": "Desired percentage of charge air cooler Bypass Valve 1 opening. 0% means no air is bypassed. 100% means full bypass capacity.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "7422": {
      "PGN": 64849,
      "PGN_Name": "Aftercooler Coolant Control Valve Command",
      "PGN_Description": "ACCVC",
      "first_bit": 40,
      "SPN": 7422,
      "SPN_Name": "Engine Charge Air Cooler Bypass Valve 2 Command",
      "SPN_Description": "Desired percentage of charge air cooler Bypass Valve 2 opening. 0% means no air is bypassed. 100% means full bypass capacity.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "7425": {
      "PGN": 64554,
      "PGN_Name": "Operator Inducement Information",
      "PGN_Description": "OII",
      "first_bit": 0,
      "SPN": 7425,
      "SPN_Name": "Operator Inducement Torque Derate Level 1",
      "SPN_Description": "This is the first torque derate that will be applied to the engine operation due to operator inducement.  The torque derate indicated in this parameter will be active when the value in Operator Inducement Time to Torque Derate Level 1 (SPN 7426) has decremented to 0.\r\n\r\nThis parameter is a percentage of how much the engine’s capabilities will be reduced as indicated by the Advertised Engine Torque Curve. 0% represents no torque derate and 100% represents a full torque derate. This parameter will be set to 0% when no operator inducement is active. For systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 000.\r\n\r\nThis parameter is expected to be less than Operator Inducement Torque Derate Level 2 (SPN 7427) if a second level of derate exists.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7426": {
      "PGN": 64554,
      "PGN_Name": "Operator Inducement Information",
      "PGN_Description": "OII",
      "first_bit": 8,
      "SPN": 7426,
      "SPN_Name": "Operator Inducement Time to Torque Derate Level 1",
      "SPN_Description": "This parameter provides the time until Operator Inducement Torque Derate Level 1 (SPN 7425) is activated.\r\n\r\nWhen operator inducement is not active, this parameter will be set to 0xFB00. For systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 000. If SPN 7426 has decremented to 0, it will remain at 0 until the condition that caused it to decrement has been corrected.\r\n\r\nWhen operator inducement is active and there are two levels of torque derate, then Operator Inducement Time to Torque Derate Level 1 (SPN 7426) is expected to be smaller than Operator Inducement Time to Torque Derate Level 2 (SPN 7428) unless both SPN 7426 and SPN 7428 are equal to 0.\r\n\r\nSee SPN 7719 for the time until final inducement action.\r\n\r\nIf the operator inducement has been temporarily overridden, then this parameter will pause and not decrement until the override is removed. For systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 110 - Temporary Override of Inducement.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "min",
      "SLOT_ID": 238
    },
    "7427": {
      "PGN": 64554,
      "PGN_Name": "Operator Inducement Information",
      "PGN_Description": "OII",
      "first_bit": 24,
      "SPN": 7427,
      "SPN_Name": "Operator Inducement Torque Derate Level 2",
      "SPN_Description": "This is the second torque derate that will be applied to the engine operation due to operator inducement. The torque derate level indicated in this parameter will be applied when the value in Operator Inducement Time to Torque Derate Level 2 (SPN 7428) has decremented to 0.\r\n\r\nThis parameter is a percentage of how much the engine’s capabilities will be reduced as indicated by the Advertised Engine Torque Curve. 0% represents no torque derate and 100% represents a full torque derate. This parameter will be set to 0% when no operator inducement is active. For systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 000.\r\n\r\nThis parameter is expected to be a greater than Operator Inducement Torque Derate Level 1 (SPN 7425) unless a second level of derate does not exist, in which case Operator Inducement Torque Derate Level 2 (SPN 7427) will be 0.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7428": {
      "PGN": 64554,
      "PGN_Name": "Operator Inducement Information",
      "PGN_Description": "OII",
      "first_bit": 32,
      "SPN": 7428,
      "SPN_Name": "Operator Inducement Time to Torque Derate Level 2",
      "SPN_Description": "This parameter provides the time until Operator Inducement Torque Derate Level 2 (SPN 7427) is activated.\r\n\r\nWhen operator inducement is not active or if a second level of derate does not exist, then this parameter will be set to 0xFB00. For systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 000. If SPN 7428 has decremented to 0, it will remain at 0 until the condition that caused it to decrement has been corrected.\r\n\r\nThis parameter is expected to be a greater than Operator Inducement Time to Torque Derate Level 1 (SPN 7426) if the current inducement event will impose a second torque derate level.\r\n\r\nSee SPN 7719 for the time until final inducement action.\r\n\r\nIf the operator inducement has been temporarily overridden, then this parameter will pause and not decrement until the override is removed. or systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 110 - Temporary Override of Inducement.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "min",
      "SLOT_ID": 238
    },
    "7429": {
      "PGN": 61651,
      "PGN_Name": "Predictive Cruise Control 1",
      "PGN_Description": "PCC1",
      "first_bit": 20,
      "SPN": 7429,
      "SPN_Name": "Vehicle Speed Control Override Request",
      "SPN_Description": "Speed control override requested. Indicates that the minimum restriction of speed is desired, for instance when travelling downhill towards an impending uphill grade. This is not a request to inhibit engine brakes (or other speed limiting device) but to delay activation or use the highest speed tolerance within limits set for vehicle speed.\r\n\r\n00 = No speed control override requested\r\n01 = Speed control override requested\r\n10 = Reserved\r\n11 = Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7430": {
      "PGN": 61651,
      "PGN_Name": "Predictive Cruise Control 1",
      "PGN_Description": "PCC1",
      "first_bit": 44,
      "SPN": 7430,
      "SPN_Name": "Predictive Cruise Control Driveline Disengage Inhibit Request",
      "SPN_Description": "Request to temporarily inhibit a fuel saving feature that would normally open the driveline. Under certain conditions and with knowledge of the terrain, inhibiting this feature may improve fuel economy.\r\n\r\nSPN 683 Disengage Driveline Request has priority over this parameter. However, the sender of SPN 683 should consider this parameter and not request driveline disengagement if it is for fuel economy purposes.\r\n\r\n00 - No Inhibit Request\r\n01 - Driveline Disengage Inhibit Request\r\n10 - Reserved\r\n11 - Don't care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7431": {
      "PGN": 61651,
      "PGN_Name": "Predictive Cruise Control 1",
      "PGN_Description": "PCC1",
      "first_bit": 22,
      "SPN": 7431,
      "SPN_Name": "Predictive Cruise Control Event in Range",
      "SPN_Description": "Indicates that an event, such as a grade, is detected within the range of the predictive cruise control (PCC) look-ahead distance.\r\n\r\n00 - No PCC event in range\r\n01 - PCC event in range\r\n10 - Error\r\n11 - Not available\r\n\r\nNote:  Intended to be sent regardless of whether or not PCC is active. Can be used to indicate an upcoming event or a missed opportunity.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7432": {
      "PGN": 61651,
      "PGN_Name": "Predictive Cruise Control 1",
      "PGN_Description": "PCC1",
      "first_bit": 24,
      "SPN": 7432,
      "SPN_Name": "Predictive Cruise Control Present Grade",
      "SPN_Description": "Road grade at present vehicle position. Positive numbers indicate uphill grade, negative are downhill for present vehicle direction of travel. For grades beyond the limits of the parameter, the limit value shall be reported.",
      "bit_length": 8,
      "scaling": 0.125,
      "offset": -16,
      "unit": "%",
      "SLOT_ID": 404
    },
    "7433": {
      "PGN": 61651,
      "PGN_Name": "Predictive Cruise Control 1",
      "PGN_Description": "PCC1",
      "first_bit": 32,
      "SPN": 7433,
      "SPN_Name": "Predictive Cruise Control Next Grade",
      "SPN_Description": "Road grade at next predictive cruise control (PCC) event. Positive numbers indicate uphill grade, negative are downhill for vehicle direction of travel. For grades beyond the limits of the parameter, the limit value shall be reported.",
      "bit_length": 8,
      "scaling": 0.125,
      "offset": -16,
      "unit": "%",
      "SLOT_ID": 404
    },
    "7434": {
      "PGN": 61651,
      "PGN_Name": "Predictive Cruise Control 1",
      "PGN_Description": "PCC1",
      "first_bit": 40,
      "SPN": 7434,
      "SPN_Name": "Predictive Cruise Control Speed Event Indicator",
      "SPN_Description": "Indicates to the operator that a predictive cruise control (PCC) speed event is active. Typically, this will correspond to a Predictive Cruise Control Set Speed Offset (SPN 7316) request to increase or decrease vehicle speed from the nominal cruise set point.\r\n\r\n00 - No speed event is active\r\n01 - Increased speed event is active\r\n10 - Decreased speed event is active\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7435": {
      "PGN": 61651,
      "PGN_Name": "Predictive Cruise Control 1",
      "PGN_Description": "PCC1",
      "first_bit": 42,
      "SPN": 7435,
      "SPN_Name": "Vehicle Speed Control Override Event Indicator",
      "SPN_Description": "Indicates to the operator that a Speed Control override event is active.  \"Speed Control\" refers to retarders or methods of automatically limiting vehicle speed, for instance on downhill grades.  An active event indicates that vehicle speed may exceed the nominal set point for speed control.  Typically, this will correspond to a Vehicle Speed Control Override Request (SPN 7429).\r\n\r\n00 - Speed Control event is not active\r\n01 - Speed Control event is active\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7436": {
      "PGN": 34048,
      "PGN_Name": "Cab Message 2",
      "PGN_Description": "CM2",
      "first_bit": 22,
      "SPN": 7436,
      "SPN_Name": "Predictive Cruise Control Enable Switch",
      "SPN_Description": "Indicates whether predictive cruise control (PCC) is enabled. When not enabled, the predictive cruise control does not calculate a speed offset or identify predictive cruise events, and the predictive cruise control state (SPN 7317) shall not be \"enabled\".\r\n\r\n00 - Predictive cruise control is not enabled\r\n01 - Predictive cruise control is enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7437": {
      "PGN": 34048,
      "PGN_Name": "Cab Message 2",
      "PGN_Description": "CM2",
      "first_bit": 24,
      "SPN": 7437,
      "SPN_Name": "Predictive Cruise Control Deactivation Request",
      "SPN_Description": "Indicates that the operator has requested to deactivate the predictive cruise control (PCC) function.\r\n\r\nIf enabled, the PCC device may still provide notification of events in range, road grade, and other information. But if requested to be deactivated by this parameter, the predictive cruise device shall set its state (SPN 7317) to \"Enabled, but not functional due to inhibited by driver\".\r\n\r\n00 - Predictive cruise control is not requested to be deactived\r\n01 - Predictive cruise control is requested to be deactived\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7438": {
      "PGN": 34048,
      "PGN_Name": "Cab Message 2",
      "PGN_Description": "CM2",
      "first_bit": 32,
      "SPN": 7438,
      "SPN_Name": "Predictive Cruise Control Maximum Positive Offset",
      "SPN_Description": "Maximum speed increase that the predictive cruise control (PCC) is allowed to request. This may be adjusted by the operator (either directly or indirectly) to tailor the performance of the PCC system.\r\n\r\nThis parameter is used in conjunction with maximum negative offset (SPN 7439) and cruise set speed (SPN 86 or SPN 6809) to define the operating range of the PCC system.",
      "bit_length": 8,
      "scaling": 0.125,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 405
    },
    "7439": {
      "PGN": 34048,
      "PGN_Name": "Cab Message 2",
      "PGN_Description": "CM2",
      "first_bit": 40,
      "SPN": 7439,
      "SPN_Name": "Predictive Cruise Control Maximum Negative Offset",
      "SPN_Description": "Maximum speed decrease that the predictive cruise control (PCC) is allowed to request. This may be adjusted by the operator (either directly or indirectly) to tailor the performance of the PCC system.\r\n\r\nThis parameter is used in conjunction with maximum positive offset (SPN 7438) and cruise set speed (SPN 86 or SPN 6809) to define the operating range of the PCC system.",
      "bit_length": 8,
      "scaling": 0.125,
      "offset": -31.25,
      "unit": "km/h",
      "SLOT_ID": 406
    },
    "7440": {
      "PGN": 64561,
      "PGN_Name": "Aftertreatment System Information 1",
      "PGN_Description": "ASI1",
      "first_bit": 2,
      "SPN": 7440,
      "SPN_Name": "Aftertreatment Active Regeneration Inhibited Due to Low Exhaust Pressure",
      "SPN_Description": "The state of aftertreatment active regeneration inhibition due to low exhaust pressure.\r\n\r\nAftertreatment Regeneration is a process of increasing the temperature at the exhaust and thereby removing the deposits on aftertreatment components such as DPF or SCR Catalyst and increasing their efficiency.\r\n\r\nThis SPN indicates the reason for the regeneration not being initiated or being exited prior to completion. When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration. The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.\r\n\r\n00 Not Inhibited\r\n01 Inhibited\r\n10 Reserved for SAE assignment\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7441": {
      "PGN": 64561,
      "PGN_Name": "Aftertreatment System Information 1",
      "PGN_Description": "ASI1",
      "first_bit": 8,
      "SPN": 7441,
      "SPN_Name": "Aftertreatment Ambient Air Temperature",
      "SPN_Description": "Temperature of ambient air near the aftertreatment components such as DEF tank and DEF lines.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "7442": {
      "PGN": 64566,
      "PGN_Name": "Gaseous Fuel Supply Valve Information",
      "PGN_Description": "GFSVI",
      "first_bit": 40,
      "SPN": 7442,
      "SPN_Name": "Inert Gas Supply Valve Position",
      "SPN_Description": "Position of inert gas supply valve used to control the flow of inert gas into the engine to purge the system.\r\n\r\n0% represents valve fully closed and 100% represents valve fully open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7448": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 12,
      "SPN": 7448,
      "SPN_Name": "Hybrid System Service Indicator",
      "SPN_Description": "Signal from the hybrid system indicating that the hybrid system or one of its components requires servicing (e.g. oil change, coolant change).\r\n\r\n00 - Hybrid Service Indicator is off\r\n01 - Hybrid Service Indicator is on continously\r\n10 - Hybrid Service Indicator is flashing\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7449": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 14,
      "SPN": 7449,
      "SPN_Name": "Hybrid System Motor Overspeed Indicator",
      "SPN_Description": "Signal from the hybrid system indicating that the hybrid system motor is exceeding maximum speed limit.\r\n\r\n00 - Hybrid System Motor Overspeed Indicator is off\r\n01 - Hybrid System Motor Overspeed Indicator is on continously\r\n10 - Hybrid System Motor Overspeed Indicator is flashing\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7450": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 16,
      "SPN": 7450,
      "SPN_Name": "Hybrid System Motor Overspeed Audible Alarm",
      "SPN_Description": "Signal from the hybrid system indicating that the overspeed audible alarm should be activated.\r\n\r\n00 - Motor Overspeed Audible Alarm is off\r\n01 - Motor Overspeed Audible Alarm is on\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7451": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 18,
      "SPN": 7451,
      "SPN_Name": "Hybrid System Electric Alternator Indicator",
      "SPN_Description": "Signal from the hybrid system indicating that the electric alternator is failed or needs servicing.  The alternator Indicator (e.g. dash lamp) is to be activated.\r\n\r\n00 - Alternator Indicator is off\r\n01 - Alternator Indicator is on\r\n10 - Alternator Indicator is flashing\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7452": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 20,
      "SPN": 7452,
      "SPN_Name": "Hybrid System Regenerative Braking Indicator",
      "SPN_Description": "Signal from the hybrid system indicating when regenerative braking is active.\r\n\r\n00 - Regenerative braking is inactive\r\n01 - Regenerative braking is active\r\n10 - Regenerative braking is disabled or faulted \r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7453": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 22,
      "SPN": 7453,
      "SPN_Name": "Hybrid System Initialization Indicator",
      "SPN_Description": "Signal from the hybrid system that indicates when it is initialized and ready to start the engine or other power source (e.g. fuel cell). The intent is that this would drive an indicator for the vehicle operator. If the operator attempts to start the engine or power source while this indicator is active, it may not start. When indicator is not active, the hybrid initialization is complete and the engine may start.\r\n\r\n00 - Hybrid System Initialization Indicator is not active\r\n01 - Hybrid System Initialization Indicator is active\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7454": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 24,
      "SPN": 7454,
      "SPN_Name": "Hybrid System High Voltage Exposure Indicator",
      "SPN_Description": "This signal indicates the condition and state of the hybrid system high voltage exposure detection system (e.g. High\r\nVoltage Interlock Loop [HVIL]). The high voltage exposure detection system is used to detect situations on a hybrid\r\nvehicle where personnel or property may be exposed to high voltage.\r\n\r\nThe Error state indicates that the detection system may not be operational, and exposure status cannot be determined. For example, the detection system may not be operational due to electrical issues detected within its circuitry (e.g. short to battery, short to ground) or it has been intentionally disabled.\r\n\r\n00 – System is operational and intact; no potential high voltage exposure has been detected\r\n01 – System is operational and has detected a compromise; potential high voltage exposure exists\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7455": {
      "PGN": 64529,
      "PGN_Name": "Total Gaseous Fuel Information",
      "PGN_Description": "TGFI",
      "first_bit": 0,
      "SPN": 7455,
      "SPN_Name": "Engine Total Gaseous Fuel Volume Used",
      "SPN_Description": "Accumulated volume of engine gaseous fuel used during vehicle operation, in standard cubic meters.\r\n\r\nSee SPN 1040 for alternate units.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "m³",
      "SLOT_ID": 413
    },
    "7456": {
      "PGN": 64529,
      "PGN_Name": "Total Gaseous Fuel Information",
      "PGN_Description": "TGFI",
      "first_bit": 32,
      "SPN": 7456,
      "SPN_Name": "Engine Total Gaseous Idle Fuel Volume Used",
      "SPN_Description": "Accumulated volume of engine gaseous fuel used during vehicle operation under idle conditions, in standard cubic meters.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "m³",
      "SLOT_ID": 413
    },
    "7459": {
      "PGN": 64590,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 3",
      "PGN_Description": "A1SCRDSI3",
      "first_bit": 8,
      "SPN": 7459,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Doser 2 Absolute Pressure",
      "SPN_Description": "The SCR doser 2 diesel exhaust fluid absolute pressure (measured closest to dosing valve) for aftertreatment system 1 (exhaust bank 1).",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "7460": {
      "PGN": 64590,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 3",
      "PGN_Description": "A1SCRDSI3",
      "first_bit": 16,
      "SPN": 7460,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Doser 2 Temperature",
      "SPN_Description": "The temperature (measured closest to dosing valve) of the second DEF dosing unit for aftertreatment system 1 (exhaust bank 1).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7461": {
      "PGN": 64725,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Pump 1 Information",
      "PGN_Description": "AT1P1I",
      "first_bit": 8,
      "SPN": 7461,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Pump 2 Motor Speed",
      "SPN_Description": "Rotational speed of the motor driving the second pump for the diesel exhaust fluid used in aftertreatment system 1 (exhaust bank 1).",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "7464": {
      "PGN": 64589,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 3",
      "PGN_Description": "A2SCRDSI3",
      "first_bit": 8,
      "SPN": 7464,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Doser 2 Absolute Pressure",
      "SPN_Description": "The SCR doser 2 diesel exhaust fluid absolute pressure (measured closest to dosing valve) for aftertreatment system 2 (exhaust bank 2).",
      "bit_length": 8,
      "scaling": 8,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 2
    },
    "7465": {
      "PGN": 64589,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 3",
      "PGN_Description": "A2SCRDSI3",
      "first_bit": 16,
      "SPN": 7465,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Doser 2 Temperature",
      "SPN_Description": "The temperature (measured closest to doser valve) of the second DEF doser unit for aftertreatment system 2 (exhaust bank 2).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7466": {
      "PGN": 64565,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Pump 1 Information",
      "PGN_Description": "AT2P1I",
      "first_bit": 8,
      "SPN": 7466,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Pump 2 Motor Speed",
      "SPN_Description": "Rotational speed of the motor driving the second pump for the diesel exhaust fluid used in aftertreatment system 2 (exhaust bank 2).",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "7468": {
      "PGN": 64751,
      "PGN_Name": "Engine Fluid Level/Pressure 11",
      "PGN_Description": "EFL/P11",
      "first_bit": 32,
      "SPN": 7468,
      "SPN_Name": "Engine Oil Pressure (High Resolution/Extended Range)",
      "SPN_Description": "Gage pressure of oil in engine lubrication system as provided by oil pump. See SPN 100 for alternate resolution.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "7469": {
      "PGN": 64751,
      "PGN_Name": "Engine Fluid Level/Pressure 11",
      "PGN_Description": "EFL/P11",
      "first_bit": 48,
      "SPN": 7469,
      "SPN_Name": "Engine Fuel Delivery Pressure (High Resolution/Extended Range)",
      "SPN_Description": "Gage pressure of fuel in system as delivered from supply pump to the injection pump. See SPN 94 for alternate resolution.\r\n\r\nSee also SPN 5578 for Engine Fuel Delivery Absolute Pressure.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "7470": {
      "PGN": 64662,
      "PGN_Name": "Engine Information 2",
      "PGN_Description": "EI2",
      "first_bit": 16,
      "SPN": 7470,
      "SPN_Name": "Engine Oil Filter Intake Pressure (High Resolution/Extended Range)",
      "SPN_Description": "Gage pressure of the engine oil before the oil reaches the oil filter. See SPN 1208 for alternate resolution.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "7471": {
      "PGN": 65276,
      "PGN_Name": "Dash Display 1",
      "PGN_Description": "DD1",
      "first_bit": 56,
      "SPN": 7471,
      "SPN_Name": "Engine Oil Filter Differential Pressure (Extended Range)",
      "SPN_Description": "Change in engine oil pressure, measured across the filter, due to the filter and any accumulation of solid or semisolid material on or in the filter. See SPN 99 for alternate resolution.",
      "bit_length": 8,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 1
    },
    "7472": {
      "PGN": 64735,
      "PGN_Name": "Engine Fluid Level/Pressure 12",
      "PGN_Description": "EFL/P12",
      "first_bit": 56,
      "SPN": 7472,
      "SPN_Name": "Engine Fuel Supply Pump Intake Absolute Pressure (Extended Range)",
      "SPN_Description": "Absolute pressure of fuel at the fuel supply pump intake. See Figures SPN16_A & SPN16_B. See SPN 1381 for alternate resolution.\r\n\r\nEngine Fuel Supply Pump Intake Absolute Pressure (Extended Range)",
      "bit_length": 8,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 1
    },
    "7473": {
      "PGN": 61447,
      "PGN_Name": "Forward Lane Image 1",
      "PGN_Description": "FLI1",
      "first_bit": 8,
      "SPN": 7473,
      "SPN_Name": "Driver Alertness Warning",
      "SPN_Description": "Indicates when a distracted driving condition is detected. This signal can be used independent of the technology and ECU used to estimate the distracted driver condition.\r\n\r\n000 = No distracted driving condition detected\r\n001 = Level 1 - Mild distraction or extended driving condition detected\r\n010 = Level 2 - Degradation in driving behavior detected\r\n011 = Level 3 - Driver alertness warning\r\n100-110 = Reserved\r\n111 = Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7474": {
      "PGN": 65115,
      "PGN_Name": "Forward Lane Image 2",
      "PGN_Description": "FLI2",
      "first_bit": 8,
      "SPN": 7474,
      "SPN_Name": "Driver Alertness Level",
      "SPN_Description": "Indicates the alertness level of the driver measured by the driver alertness warning system. 100 % means driver is fully attentive. This signal can be used independent of the technology and ECU used to estimate the driver alertness condition.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7475": {
      "PGN": 65115,
      "PGN_Name": "Forward Lane Image 2",
      "PGN_Description": "FLI2",
      "first_bit": 16,
      "SPN": 7475,
      "SPN_Name": "Driver Alertness Warning System State",
      "SPN_Description": "Indicates the various system state in the driver alertness warning system. This signal can be used independent of the technology and ECU used to estimate the driver alertness condition.\r\n\r\n000 = System installed but disabled\r\n001 = Initializing\r\n010 = System temporarily not available\r\n011 = System available\r\n100 = System monitoring driver behavior\r\n101-110 = Reserved\r\n111 = Not Available / Not Installed",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7476": {
      "PGN": 64553,
      "PGN_Name": "Forward Lane Image 3",
      "PGN_Description": "FLI3",
      "first_bit": 0,
      "SPN": 7476,
      "SPN_Name": "Left Distance to Lane Mark from Vehicle's Middle",
      "SPN_Description": "Distance between middle of the vehicle front and the inner/right edge of the nearest lane mark on the left side as measured from the Forward Lane Imager. The value represents the lane width at camera position. Measured values greater than 5 m results in value 251.\r\n\r\nNote that the middle of the vehicle is used instead of the position of the optical sensor and this sensor is responsible to add an offset when it is not positioned at the middle of the vehicle (set as a parameter to this sensor for information hiding).\r\n\r\nParameter specific values for this parameter are as follows:\r\n\r\n251 = not in range\r\n252 = not reliable\r\n253 = reserved / not used\r\n254 = error\r\n255 = not available or not installed",
      "bit_length": 8,
      "scaling": 0.02,
      "offset": 0,
      "unit": "m",
      "SLOT_ID": 407
    },
    "7477": {
      "PGN": 64553,
      "PGN_Name": "Forward Lane Image 3",
      "PGN_Description": "FLI3",
      "first_bit": 8,
      "SPN": 7477,
      "SPN_Name": "Right Distance to Lane Mark from Vehicle's Middle",
      "SPN_Description": "Distance between middle of the vehicle front and the inner/left edge of the nearest lane mark on the right side as measured from the Forward Lane Imager. The value represents the lane width at camera position. Measured values greater than 5 m results in value 251.\r\n\r\nNote that the middle of the vehicle is used instead of the position of the optical sensor and this sensor is responsible to add an offset when it is not positioned at the middle of the vehicle (set as a parameter to this sensor for information hiding).\r\n\r\nParameter specific values for this parameter are as follows:\r\n\r\n251 = not in range\r\n252 = not reliable\r\n253 = reserved / not used\r\n254 = error\r\n255 = not available or not installed",
      "bit_length": 8,
      "scaling": 0.02,
      "offset": 0,
      "unit": "m",
      "SLOT_ID": 407
    },
    "7478": {
      "PGN": 64553,
      "PGN_Name": "Forward Lane Image 3",
      "PGN_Description": "FLI3",
      "first_bit": 16,
      "SPN": 7478,
      "SPN_Name": "Road Curvature Based on Lane Marks",
      "SPN_Description": "The road curvature parameter is based on lane marks as measured by the FLI.  It is the mean value of the road curvature of the lane marks on the left and right side of the lane. In case one of the lane mark is not recognized anymore, the value is set to the value of other side. The SPN represents the road curvature computed at the camera position.\r\n\r\nPositive values are used for left curves.  Curvature is the inverst of the radius and is zero for straight roads.\r\n\r\nParameter specific values for this parameter are as follows:\r\n\r\nFB01 (64256dec) =  not in range\r\nFB02 (64257dec) =  not reliable\r\nFB03-FBFF (64258 - 64511dec) = reserved for parameter specific indicator\r\nFC00-FDFF (64512 - 65023dec) = reserved range for future indicator bits\r\nFExx (65024 - 65279dec) = error indicator\r\nFFxx (65280 - 65535dec) = not available or not installed",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "1/km",
      "SLOT_ID": 96
    },
    "7479": {
      "PGN": 64553,
      "PGN_Name": "Forward Lane Image 3",
      "PGN_Description": "FLI3",
      "first_bit": 32,
      "SPN": 7479,
      "SPN_Name": "Lane Departure Angle Left",
      "SPN_Description": "Angle between left lane mark and vehicle driving direction. The angle is positive while vehicle is moving towards the lane marks, and negative if not. Measured values outside the limits are represented by signal value 251.\r\n\r\nParameter specific values for this parameter are as follows:\r\n\r\n251 = not in range\r\n252 = not reliable\r\n253 = reserved / not used\r\n254 = error\r\n255 = not available or not installed",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7480": {
      "PGN": 64553,
      "PGN_Name": "Forward Lane Image 3",
      "PGN_Description": "FLI3",
      "first_bit": 40,
      "SPN": 7480,
      "SPN_Name": "Lane Departure Angle Right",
      "SPN_Description": "Angle between right lane mark and vehicle driving direction. The angle is positive while vehicle is moving towards the lane marks, and negative if not. Measured values outside the limits are represented by signal value 251.\r\n\r\nParameter specific values for this parameter are as follows:\r\n\r\n251 = not in range\r\n252 = not reliable\r\n253 = reserved / not used\r\n254 = error\r\n255 = not available or not installed",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": -12.5,
      "unit": "deg",
      "SLOT_ID": 244
    },
    "7481": {
      "PGN": 64553,
      "PGN_Name": "Forward Lane Image 3",
      "PGN_Description": "FLI3",
      "first_bit": 48,
      "SPN": 7481,
      "SPN_Name": "Lane Mark Quality on the Left Side",
      "SPN_Description": "The quality of the nearest lane mark on the left side of the vehicle.\r\n\r\n000 = no lane marks detected\r\n001 = low reliablity of detected lane marks\r\n010 = good reliablity of detected lane marks\r\n011 = perfect recognition of lane marks\r\n100 - 101 = reserved for future use\r\n110 = error\r\n111 = not available or not installed",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7482": {
      "PGN": 64553,
      "PGN_Name": "Forward Lane Image 3",
      "PGN_Description": "FLI3",
      "first_bit": 51,
      "SPN": 7482,
      "SPN_Name": "Lane Mark Quality on the Right Side",
      "SPN_Description": "The quality of the nearest lane mark on the right side of the vehicle.\r\n\r\n000 = no lane marks detected\r\n001 = low reliablity of detected lane marks\r\n010 = good reliablity of detected lane marks\r\n011 = perfect recognition of lane marks\r\n100 - 101 = reserved for future use\r\n110 = error\r\n111 = not available or not installed",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7495": {
      "PGN": 64555,
      "PGN_Name": "Cruise Control / Vehicle Speed 4",
      "PGN_Description": "CCVS4",
      "first_bit": 16,
      "SPN": 7495,
      "SPN_Name": "Cruise Control Adjusted Maximum Speed",
      "SPN_Description": "Present maximum vehicle velocity at which cruise can be set. This parameter is expected to change during run-time due to functionality that could influence the behavior of the cruise control algorithm. This functionality may include, but is not limited to, a different maximum cruise speed that is dependent on driving conditions, driver performance, etc.\r\n\r\nIf this parameter is supported, then it has priority over SPN 87. Without any adjustments, SPN 87 and this parameter will be the same value. SPN 87 is not expected to change, and if an adjustment is made to reward the driver or penalize the driver, then SPN 87 would not reflect that adjustment. This parameter will reflect that adjustment.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": 0,
      "unit": "km/h",
      "SLOT_ID": 71
    },
    "7496": {
      "PGN": 65218,
      "PGN_Name": "Electronic Retarder Controller 2",
      "PGN_Description": "ERC2",
      "first_bit": 8,
      "SPN": 7496,
      "SPN_Name": "Cruise Control Retarder Active Speed Offset",
      "SPN_Description": "The additional speed above the operator selected cruise control set speed at which the retarder will activate when cruise control is active.",
      "bit_length": 16,
      "scaling": 0.00390625,
      "offset": -125,
      "unit": "km/h",
      "SLOT_ID": 399
    },
    "7497": {
      "PGN": 64694,
      "PGN_Name": "Vehicle Electrical Power 5",
      "PGN_Description": "VEP5",
      "first_bit": 40,
      "SPN": 7497,
      "SPN_Name": "SLI Cranking Predicted Minimum Battery Voltage",
      "SPN_Description": "Prediction of the minimum battery voltage used for starting the engine, for lighting, and for ignition (SLI) during a crank event, under present battery conditions.\r\n\r\nThis parameter shall be used to report the predicted minimum cranking voltage of the battery pack.  If the predicted minimum cranking voltage of individual batteries within the battery pack is desired, use SPNs 7906, 7914, 7922, & 7930.",
      "bit_length": 8,
      "scaling": 0.2,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 409
    },
    "7498": {
      "PGN": 65106,
      "PGN_Name": "Vehicle Electrical Power 3",
      "PGN_Description": "VEP3",
      "first_bit": 32,
      "SPN": 7498,
      "SPN_Name": "SLI Battery 2 Net Current",
      "SPN_Description": "Net flow of electrical current into/out of the second battery or second set of batteries used for starting the engine, for lighting, and for ignition (SLI).",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -1600,
      "unit": "A",
      "SLOT_ID": 104
    },
    "7502": {
      "PGN": 64561,
      "PGN_Name": "Aftertreatment System Information 1",
      "PGN_Description": "ASI1",
      "first_bit": 4,
      "SPN": 7502,
      "SPN_Name": "Aftertreatment Engine Speed Increase request",
      "SPN_Description": "Indicates whether the aftertreatment desires engine speed control in order to increase the engine speed. This is meant to notify the operator that the aftertreatment is requesting an increase in engine speed for thermal purposes.\r\n\r\nThe operator is expected to utilize the engine speed increase allowed switch SPN 7579 in response to this request.\r\n\r\n00 = No Request\r\n01 = Aftertreatment Engine Speed Control Desired\r\n10 = Urgent Aftertreatment Engine Speed Control Desired\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7503": {
      "PGN": 64561,
      "PGN_Name": "Aftertreatment System Information 1",
      "PGN_Description": "ASI1",
      "first_bit": 6,
      "SPN": 7503,
      "SPN_Name": "Aftertreatment Engine Load Request",
      "SPN_Description": "Indicates whether the aftertreatment desires engine load to be applied. This is meant to notify the operator that the aftertreatment is requesting engine load for thermal purposes.\r\n\r\nThe operator is expected to add load to the engine to satisfy this request.\r\n\r\n00 = No Request\r\n01 = Aftertreatment Engine Load Desired\r\n10 = Urgent Aftertreatment Engine Load Desired\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7504": {
      "PGN": 64878,
      "PGN_Name": "Aftertreatment 1 SCR Service Information 1",
      "PGN_Description": "A1SCRSI1",
      "first_bit": 56,
      "SPN": 7504,
      "SPN_Name": "Aftertreatment 1 SCR System Sulfation Level",
      "SPN_Description": "Indicates the sulfur level in the SCR system for aftertreatment 1.\r\n.\r\n100% level could be the regeneration trigger level (and if conditions are not favorable for regeneration, sulfation loading can continue beyond 100%). During normal operation and regeneration a value 0% will indicate a fully regenerated SCR system. Values of 25%, 50% and 75% will indicate the general level of sulfur prior to the 100% level where regeneration could be needed.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7513": {
      "PGN": 64577,
      "PGN_Name": "Alternate Fuel 4",
      "PGN_Description": "AF4",
      "first_bit": 48,
      "SPN": 7513,
      "SPN_Name": "Engine Fuel 2 Injector Metering Rail 1 Pressure 2",
      "SPN_Description": "The second pressure of fuel 2 measured by first rail pressure sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.",
      "bit_length": 16,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 106
    },
    "7514": {
      "PGN": 64557,
      "PGN_Name": "Alternate Fuel 5",
      "PGN_Description": "AF5",
      "first_bit": 32,
      "SPN": 7514,
      "SPN_Name": "Engine Fuel 2 Injector Metering Rail 1 Temperature 2",
      "SPN_Description": "The second temperature of fuel 2 measured by first rail temperature sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7515": {
      "PGN": 33024,
      "PGN_Name": "Aftertreatment System Control",
      "PGN_Description": "AFTSC",
      "first_bit": 2,
      "SPN": 7515,
      "SPN_Name": "Request to Permit DEF Hydraulic Stiffness Check",
      "SPN_Description": "A request to permit the DEF hydraulic stiffness check. The request continues to be broadcast until the stiffness check is finished or the corresponding permission status indicates an error.\r\n\r\n00 = no request\r\n01 = request to permit DEF hydraulic stiffness check or stiffness check is running\r\n10 = reserved\r\n11 = don't care\r\n\r\nThe DEF hydraulic stiffness check is implemented in order to check for malfunctions and wear (damage) of the DEF dosing system and may be required by OBD legislation.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7516": {
      "PGN": 33024,
      "PGN_Name": "Aftertreatment System Control",
      "PGN_Description": "AFTSC",
      "first_bit": 4,
      "SPN": 7516,
      "SPN_Name": "Request to Permit DEF Dosing Test Injection",
      "SPN_Description": "A request to permit the DEF dosing test injection. The request continues to be broadcast until the test injection is finished or the corresponding permission status indicates an error.\r\n\r\n000 = no request\r\n001 = request to permit DEF Dosing Test Injection or test injection is running\r\n010 = urgent request to permit DEF Dosing Test Injection or test injection is running\r\n011-110 = reserved\r\n111 = don't care",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7517": {
      "PGN": 61476,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 1",
      "PGN_Description": "A1SCRDSR1",
      "first_bit": 20,
      "SPN": 7517,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Hydraulic Stiffness Check Permission Status",
      "SPN_Description": "After a request to permit the DEF hydraulic stiffness check has been indicated, this permission status is expected by the DEF control unit for aftertreatment system 1.\r\n\r\n00 = not allowed\r\n01 = DEF hydraulic stiffness check allowed\r\n10 = error\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7518": {
      "PGN": 61476,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 1",
      "PGN_Description": "A1SCRDSR1",
      "first_bit": 22,
      "SPN": 7518,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Dosing Test Injection Permission Status",
      "SPN_Description": "After a request to permit the DEF dosing test injection has been indicated, this permission status is expected by the DEF control unit for aftertreatment system 1.\r\n\r\n00 = not allowed\r\n01 = DEF dosing test injection allowed\r\n10 = error\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7519": {
      "PGN": 61479,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 1",
      "PGN_Description": "A2SCRDSR1",
      "first_bit": 20,
      "SPN": 7519,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Hydraulic Stiffness Check Permission Status",
      "SPN_Description": "After a request to permit the DEF hydraulic stiffness check has been indicated, this permission status is expected by the DEF control unit for aftertreatment system 2.\r\n\r\n00 = not allowed\r\n01 = DEF hydraulic stiffness check allowed\r\n10 = error\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7520": {
      "PGN": 61479,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 1",
      "PGN_Description": "A2SCRDSR1",
      "first_bit": 22,
      "SPN": 7520,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Dosing Test Injection Permission Status",
      "SPN_Description": "After a request to permit the DEF dosing test injection has been indicated, this permission status is expected by the DEF control unit for aftertreatment system 2.\r\n\r\n00 = not allowed\r\n01 = DEF dosing test injection allowed\r\n10 = error\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7521": {
      "PGN": 64699,
      "PGN_Name": "Aftertreatment 1 SCR Electronic Control Module Information",
      "PGN_Description": "A1ECMI",
      "first_bit": 8,
      "SPN": 7521,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Control Module 2 Relay Control",
      "SPN_Description": "State signal which indicates when the DEF control module 2 relay of aftertreatment 1 is being energized. On means the ECU is powering the Aftertreatment 1 DEF dosing unit relay. Note that the ECU is external to the relay.\r\n\r\n00 - Off\r\n01 - On: The ECU is powering the DEF dosing unit relay\r\n10 - Error\r\n11 - Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7522": {
      "PGN": 64699,
      "PGN_Name": "Aftertreatment 1 SCR Electronic Control Module Information",
      "PGN_Description": "A1ECMI",
      "first_bit": 10,
      "SPN": 7522,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Control Module 2 Power Supply 1",
      "SPN_Description": "State signal which indicates when the DEF control module 2 power supply of aftertreatment 1 is being driven. On means the ECU is powering the aftertreatment 1 DEF control module power supply. Note that the control module is external to the ECU.\r\n\r\n00 - Off\r\n01 - On: The ECU is powering the DEF dosing unit power supply\r\n10 - Error\r\n11 - Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7523": {
      "PGN": 64699,
      "PGN_Name": "Aftertreatment 1 SCR Electronic Control Module Information",
      "PGN_Description": "A1ECMI",
      "first_bit": 12,
      "SPN": 7523,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Control Module 2 Power Supply 2",
      "SPN_Description": "State signal which indicates when the DEF control module 2 power supply 2 of aftertreatment 1 is being driven. On means the ECU is powering the aftertreatment 1 DEF control module power supply. Note that the control module is external to the ECU.\r\n\r\n00 - Off\r\n01 - On: The ECU is powering the DEF dosing unit power supply\r\n10 - Error\r\n11 - Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7524": {
      "PGN": 61475,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 1",
      "PGN_Description": "A1SCRDSI1",
      "first_bit": 20,
      "SPN": 7524,
      "SPN_Name": "Aftertreatment 1 SCR System 2 State",
      "SPN_Description": "Actual state of SCR system 2\r\n\r\n0000 = Dormant (sleep mode)\r\n0001 = Preparing dosing readiness (wake up; prepare to operate; wait for start)\r\n0010 = Normal dosing operation\r\n0011 = System error pending\r\n0100 = Purging (SCR dosing system is removing residual DEF from system prior to shutdown)\r\n0101 = Protect mode against heat (pressure buildup)\r\n0110 = Protect mode against cold (defreeze)\r\n0111 = Shutoff (wait for after-run)\r\n1000 = Diagnosis (after-run)\r\n1001 = Service test mode, dosing allowed\r\n1010 = Service test mode, dosing not allowed\r\n1011 = Ok to Power Down (SCR dosing system has complete housekeeping and power may safely be removed.)\r\n1100    Priming (Pressure Buildup)\r\n1101    Reserved for future assignment by SAE\r\n1110 = Error\r\n1111 = Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7525": {
      "PGN": 61478,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 1",
      "PGN_Description": "A2SCRDSI1",
      "first_bit": 20,
      "SPN": 7525,
      "SPN_Name": "Aftertreatment 2 SCR System 2 State",
      "SPN_Description": "Actual state of SCR system 2\r\n\r\n0000 = Dormant (sleep mode)\r\n0001 = Preparing dosing readiness (wake up; prepare to operate; wait for start)\r\n0010 = Normal dosing operation\r\n0011 = System error pending\r\n0100 = Purging (SCR dosing system is removing residual DEF from system prior to shutdown)\r\n0101 = Protect mode against heat (pressure buildup)\r\n0110 = Protect mode against cold (defreeze)\r\n0111 = Shutoff (wait for after-run)\r\n1000 = Diagnosis (after-run)\r\n1001 = Service test mode, dosing allowed\r\n1010 = Service test mode, dosing not allowed\r\n1011 = Ok to Power Down (SCR dosing system has complete housekeeping and power may safely be removed.)\r\n1100    Priming (Pressure Buildup)\r\n1101    Reserved for future assignment by SAE\r\n1110 = Error\r\n1111 = Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7526": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 34,
      "SPN": 7526,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater Relay 2",
      "SPN_Description": "The aftertreatment system 2 diesel exhaust fluid line heater relay 2 is used to energize one or more DEF line heaters.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7527": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 36,
      "SPN": 7527,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater Relay 3",
      "SPN_Description": "The aftertreatment system 2 diesel exhaust fluid line heater relay 3 is used to energize one or more DEF line heaters.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7528": {
      "PGN": 64551,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Information 2",
      "PGN_Description": "A1DEFI2",
      "first_bit": 8,
      "SPN": 7528,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Controller 2 Temperature",
      "SPN_Description": "Temperature of the diesel exhaust fluid at the aftertreatment 1 diesel exhaust fluid controller 2.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7529": {
      "PGN": 64550,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Information 2",
      "PGN_Description": "A2DEFI2",
      "first_bit": 0,
      "SPN": 7529,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Controller Temperature",
      "SPN_Description": "Temperature of the diesel exhaust fluid at the aftertreatment 2 diesel exhaust fluid controller.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7530": {
      "PGN": 64549,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 2",
      "PGN_Description": "AT1T1I2",
      "first_bit": 0,
      "SPN": 7530,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank Volume 2",
      "SPN_Description": "Second measurement of the ratio of volume of diesel exhaust fluid to the total volume of the diesel exhaust fluid storage container for aftertreatment system 1 (exhaust bank 1).  0% is empty and 100% is full.  See SPN 1761 and SPN 3517 for alternate measurements.\r\n\r\nParameter Specific Indicator:\r\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7531": {
      "PGN": 64548,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 2",
      "PGN_Description": "AT2T1I2",
      "first_bit": 0,
      "SPN": 7531,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank Volume 2",
      "SPN_Description": "Second measurement of the ratio of volume of diesel exhaust fluid to the total volume of the diesel exhaust fluid storage container for aftertreatment system 2 (exhaust bank 2).  0% is empty and 100% is full.  See SPN 4426 and SPN 4428 for alternate measurements.\r\n\r\nParameter Specific Indicator:\r\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7532": {
      "PGN": 64698,
      "PGN_Name": "Aftertreatment 2 SCR Electronic Control Module Information",
      "PGN_Description": "A2ECMI",
      "first_bit": 8,
      "SPN": 7532,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Control Module 2 Relay Control",
      "SPN_Description": "State signal which indicates when the DEF control module 2 relay of aftertreatment 2 is being energized. On means the ECU is powering the Aftertreatment 2 DEF dosing unit relay. Note that the ECU is external to the relay.\r\n\r\n00 - Off\r\n01 - On: The ECU is powering the DEF dosing unit relay\r\n10 - Error\r\n11 - Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7533": {
      "PGN": 64698,
      "PGN_Name": "Aftertreatment 2 SCR Electronic Control Module Information",
      "PGN_Description": "A2ECMI",
      "first_bit": 10,
      "SPN": 7533,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Control Module 2 Power Supply 1",
      "SPN_Description": "State signal which indicates when the DEF control module 2 power supply of aftertreatment 2 is being driven. On means the ECU is powering the aftertreatment 2 DEF control module power supply. Note that the control module is external to the ECU.\r\n\r\n00 - Off\r\n01 - On: The ECU is powering the DEF dosing unit relay\r\n10 - Error\r\n11 - Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7534": {
      "PGN": 64698,
      "PGN_Name": "Aftertreatment 2 SCR Electronic Control Module Information",
      "PGN_Description": "A2ECMI",
      "first_bit": 12,
      "SPN": 7534,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Control Module 2 Power Supply 2",
      "SPN_Description": "State signal which indicates when the DEF control module 2 power supply 2 of aftertreatment 2 is being driven. On means the ECU is powering the aftertreatment 2 DEF control module power supply. Note that the control module is external to the ECU.\r\n\r\n00 - Off\r\n01 - On: The ECU is powering the DEF dosing unit relay\r\n10 - Error\r\n11 - Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7535": {
      "PGN": 64550,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Information 2",
      "PGN_Description": "A2DEFI2",
      "first_bit": 8,
      "SPN": 7535,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Controller 2 Temperature",
      "SPN_Description": "Temperature of the diesel exhaust fluid at the aftertreatment 2 diesel exhaust fluid controller 2.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7536": {
      "PGN": 64828,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A1DEFSI",
      "first_bit": 56,
      "SPN": 7536,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Dosing Unit 2 Diverter Valve",
      "SPN_Description": "Command to the valve which determines whether the diesel exhaust fluid on dosing unit 2 is delivered to the injector or is routed back to the diesel exhaust fluid tank. Zero directs all diesel exhaust fluid flow to the injector, 100% sends all diesel exhaust fluid back to the tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7537": {
      "PGN": 64819,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A2DEFSI",
      "first_bit": 56,
      "SPN": 7537,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Dosing Unit 2 Diverter Valve",
      "SPN_Description": "Command to the valve which determines whether the diesel exhaust fluid of dosing unit 2 is delivered to the injector or is routed back to the diesel exhaust fluid tank. Zero directs all diesel exhaust fluid flow to the injector, 100% sends all diesel exhaust fluid back to the tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7540": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 44,
      "SPN": 7540,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater Relay 3",
      "SPN_Description": "The aftertreatment diesel exhaust fluid line heater relay 3 is used to energize one or more DEF line heaters.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7548": {
      "PGN": 65238,
      "PGN_Name": "Hybrid System Inputs 1",
      "PGN_Description": "HSI1",
      "first_bit": 0,
      "SPN": 7548,
      "SPN_Name": "Hybrid System Protection Override Switch",
      "SPN_Description": "Indicates the Protection Override switch position.  This switch allows the operator to override hybrid system protection features and failure modes allowing hybrid system to continue to operate if possible.\r\n\r\n00 = Not Active\r\n01 = Active\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7549": {
      "PGN": 65238,
      "PGN_Name": "Hybrid System Inputs 1",
      "PGN_Description": "HSI1",
      "first_bit": 2,
      "SPN": 7549,
      "SPN_Name": "Hybrid System Propulsion Coolant Level Switch",
      "SPN_Description": "Indicates the coolant level switch position in the hybrid system propulsion (e.g. electric motor, generator) cooling system.\r\n\r\n00 = Coolant Level is not sufficient\r\n01 = Coolant Level is sufficient\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7550": {
      "PGN": 65238,
      "PGN_Name": "Hybrid System Inputs 1",
      "PGN_Description": "HSI1",
      "first_bit": 4,
      "SPN": 7550,
      "SPN_Name": "Hybrid System Power Electronics Coolant Level Switch",
      "SPN_Description": "Indicates the coolant level switch position in the hybrid system power electronics (e.g. Inverters, DC/DC converters) cooling system.\r\n\r\n00 = Coolant Level is not sufficient\r\n01 = Coolant Level is sufficient\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7551": {
      "PGN": 65238,
      "PGN_Name": "Hybrid System Inputs 1",
      "PGN_Description": "HSI1",
      "first_bit": 6,
      "SPN": 7551,
      "SPN_Name": "Hybrid System Off-Board Charger Connection Status",
      "SPN_Description": "Indicates the off-board plug-in charger connection status.  One of the uses of this signal is to protect against vehicle motion while a charger is plugged in.\r\n\n00 = Off-board charger is not connected\r\n01 = Off-board charger is connected\r\n10 = Error\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7552": {
      "PGN": 65238,
      "PGN_Name": "Hybrid System Inputs 1",
      "PGN_Description": "HSI1",
      "first_bit": 8,
      "SPN": 7552,
      "SPN_Name": "Hybrid System Regenerative Braking Disable Switch",
      "SPN_Description": "Indicates the regenerative braking disable switch position.  This switch gives the operator the ability to disable all regenerative braking from all inputs (e.g. such as during slippery road conditions).\r\n\r\n00 = Regenerative Braking Disable Switch is off.  Regenerative braking is allowed.\r\n01 = Regenerative Braking  Disable Switch is on.  Regenerative braking is not allowed.\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7553": {
      "PGN": 65238,
      "PGN_Name": "Hybrid System Inputs 1",
      "PGN_Description": "HSI1",
      "first_bit": 10,
      "SPN": 7553,
      "SPN_Name": "Hybrid System Brake Pedal Regenerative Braking Disable Switch",
      "SPN_Description": "Indicates the brake pedal regenerative braking disable switch position.  This switch allows the operator to disable regenerative braking (e.g. such as during slippery road conditions) that is controlled by brake pedal application.   Regenerative braking is still allowed if requested by other inputs (e.g. coasting regenerative braking level selector (SPN 7556)).\r\n  \r\n00 = Brake pedal regenerative braking disable switch is off.  When this switch is off, regenerative braking may be activated by brake pedal application.\r\n01 = Brake pedal regenerative braking disable switch is on.  When this switch is on, regenerative braking shall not be activated by brake pedal application.\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7554": {
      "PGN": 65238,
      "PGN_Name": "Hybrid System Inputs 1",
      "PGN_Description": "HSI1",
      "first_bit": 12,
      "SPN": 7554,
      "SPN_Name": "Hybrid System Propulsion Disable Switch",
      "SPN_Description": "When the operator enables this switch, the propulsion aspect of hybrid system operation will be disabled.  However, hybrid powered accessories may be on and the engine may still run.  Regenerative braking is allowed unless disabled by SPN 7552 (Hybrid System Regenerative Braking Disable Switch) or SPN 7559 (Hybrid System Regenerative Braking Disable Request).  Engine starting by the hybrid system is allowed.  Movement of the vehicle by the hybrid system is not allowed.  \r\n\r\nThis feature may allow technicians to test the engine independent of hybrid system propulsion (e.g. control engine fueling using the accelerator pedal without Hybrid System assistance).   Another use may be to operate a parallel hybrid system in a conventional engine/transmission mode.  \r\n\r\nNote: This parameter is not related to SPN 7315 (Propulsion System Active).\r\n  \r\n00 – Off; hybrid propulsion is allowed.  \r\n01 – On; hybrid propulsion is not allowed. \r\n10 – Error\r\n11 – Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7555": {
      "PGN": 65238,
      "PGN_Name": "Hybrid System Inputs 1",
      "PGN_Description": "HSI1",
      "first_bit": 14,
      "SPN": 7555,
      "SPN_Name": "Hybrid System Shutdown Switch",
      "SPN_Description": "When the operator enables this switch, all hybrid system functionality is disabled including propulsion, regenerative braking, and hybrid powered accessories.  For electric hybrids, the hybrid system shall be placed in an electrically off state where high voltage is isolated to energy storage devices only (e.g. open contactors, discharge capacitive energy).  One use of this switch is as an emergency stop capability.\r\n   \r\nNote: Engine operation is still allowed.  \r\n\r\n00 – Off; hybrid system may operate normally.\r\n01 – On; hybrid system functionality is not allowed.\r\n10 – Error\r\n11 – Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7556": {
      "PGN": 65238,
      "PGN_Name": "Hybrid System Inputs 1",
      "PGN_Description": "HSI1",
      "first_bit": 16,
      "SPN": 7556,
      "SPN_Name": "Hybrid System Coasting Regenerative Braking Level Selector",
      "SPN_Description": "Indicates the coasting regenerative braking level selector position.  Coasting regenerative braking occurs when neither the accelerator nor the brake pedal are depressed.\r\n\n\nThe coasting regenerative braking level is the position of the driver’s selector, that may be expressed as percent and determined by the ratio of current position to the maximum possible position. The physical device may be a lever, rotary dial, combination of switches, or other device that the driver can use to select the type or amount of coasting regenerative braking needed.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7557": {
      "PGN": 32768,
      "PGN_Name": "Hybrid System Control 1",
      "PGN_Description": "HSC1",
      "first_bit": 0,
      "SPN": 7557,
      "SPN_Name": "Hybrid System Protection Override Request",
      "SPN_Description": "Indicates the hybrid system protection override request state.  This request allows overriding of hybrid system protection \r\nfeatures and failure modes allowing hybrid systems to continue to operate, if possible. This is not the physical switch that performs the protection override.\r\n\r\nSee SPN 7548 for the signal for the physical switch.\r\n\r\n00 = Not active\r\n01 = Active\r\n10 = Reserved\r\n11 = Don't care / take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7558": {
      "PGN": 32768,
      "PGN_Name": "Hybrid System Control 1",
      "PGN_Description": "HSC1",
      "first_bit": 2,
      "SPN": 7558,
      "SPN_Name": "Hybrid System Propulsion Disable Request",
      "SPN_Description": "Indicates the Hybrid System Disable Request state.  The signal gives network controllers the ability to disable the propulsion aspect of hybrid system operation when this request is on.  However, hybrid powered accessories may be on and the engine may still run.  Regenerative braking is allowed unless disabled by SPN 7552 (Hybrid System Regenerative Braking Disable Switch) or SPN 7559 (Hybrid System Regenerative Braking Disable Request).  Engine starting by the hybrid system is allowed.  Movement of the vehicle by the hybrid system is not allowed.  This is not the physical switch that performs the hybrid system propulsion disable.  See SPN 7554 for the physical switch.\r\n\r\nThis feature may allow technicians to test the engine independent of hybrid system propulsion (e.g. control engine fueling using the accelerator pedal without Hybrid System assistance).   Another use may be to operate a parallel hybrid system in a conventional engine/transmission mode.  \r\n\r\nNote: This parameter is not related to SPN 7315 (Propulsion System Active).\r\n  \r\n00 – Off; hybrid propulsion is allowed  \r\n01 – On; hybrid propulsion is not allowed\r\n10 – Reserved\r\n11 – Don't Care / Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7559": {
      "PGN": 32768,
      "PGN_Name": "Hybrid System Control 1",
      "PGN_Description": "HSC1",
      "first_bit": 4,
      "SPN": 7559,
      "SPN_Name": "Hybrid System Regenerative Braking Disable Request",
      "SPN_Description": "Indicates the hybrid system regenerative braking disable request state.  This signal gives network controllers the ability to disable all regenerative braking.  This is not the operator controlled switch that performs regenerative braking disable (See SPN 7552).\r\n\r\n00 = Regenerative braking disable request is not active.  Regenerative braking is allowed.\r\n01 = Regenerative braking disable request is active.  Regenerative braking is not allowed.\r\n10 = Reserved\r\n11 = Don't care / take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7560": {
      "PGN": 32768,
      "PGN_Name": "Hybrid System Control 1",
      "PGN_Description": "HSC1",
      "first_bit": 6,
      "SPN": 7560,
      "SPN_Name": "Hybrid System Shutdown Command",
      "SPN_Description": "Indicates the Hybrid System Shutdown Request state.  The signal gives network controllers the ability to disable all hybrid system functionality including propulsion, regenerative braking, and hybrid powered accessories.  For electric hybrids, the hybrid system shall be placed in an electrically off state where high voltage is isolated to energy storage devices only (e.g. open contactors, discharge capacitive energy).  One use of this request is as an emergency stop capability.\r\n \r\nNote: Engine operation is still allowed.  \r\n\r\nThis is not the physical switch that performs the hybrid system propulsion disable.  See SPN 7555 for the physical switch.  \r\n\r\n00 – Off; hybrid system may operate normally\r\n01 – On; hybrid system functionality is not allowed\r\n10 – Reserved\r\n11 – Don't Care / Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7561": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 46,
      "SPN": 7561,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 5",
      "SPN_Description": "The diesel exhaust fluid line heater 5 request for aftertreatment system 1 (exhaust bank 1).\r\n\r\n00 = request for heater to be inactive\r\n01 = request for heater to be active\r\n10 = reserved for future assignment by SAE\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7562": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 48,
      "SPN": 7562,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 6",
      "SPN_Description": "The diesel exhaust fluid line heater 6 request for aftertreatment system 1 (exhaust bank 1).\r\n\r\n00 = request for heater to be inactive\r\n01 = request for heater to be active\r\n10 = reserved for future assignment by SAE\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7563": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 50,
      "SPN": 7563,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 7",
      "SPN_Description": "The diesel exhaust fluid line heater 7 request for aftertreatment system 1 (exhaust bank 1).\r\n\r\n00 = request for heater to be inactive\r\n01 = request for heater to be active\r\n10 = reserved for future assignment by SAE\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7564": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 52,
      "SPN": 7564,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 8",
      "SPN_Description": "The diesel exhaust fluid line heater 8 request for aftertreatment system 1 (exhaust bank 1).\r\n\r\n00 = request for heater to be inactive\r\n01 = request for heater to be active\r\n10 = reserved for future assignment by SAE\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7565": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 54,
      "SPN": 7565,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 9",
      "SPN_Description": "The diesel exhaust fluid line heater 9 request for aftertreatment system 1 (exhaust bank 1).\r\n\r\n00 = request for heater to be inactive\r\n01 = request for heater to be active\r\n10 = reserved for future assignment by SAE\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7566": {
      "PGN": 64832,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 2",
      "PGN_Description": "A1SCRDSR2",
      "first_bit": 56,
      "SPN": 7566,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Line Heater 10",
      "SPN_Description": "The diesel exhaust fluid line heater 10 request for aftertreatment system 1 (exhaust bank 1).\r\n\r\n00 = request for heater to be inactive\r\n01 = request for heater to be active\r\n10 = reserved for future assignment by SAE\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7567": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 40,
      "SPN": 7567,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 6",
      "SPN_Description": "The diesel exhaust fluid line heater 6 request for aftertreatment system 2 (exhaust bank 2).\r\n\r\n00 = request for heater to be inactive\r\n01 = request for heater to be active\r\n10 = reserved for future assignment by SAE\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7568": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 42,
      "SPN": 7568,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 7",
      "SPN_Description": "The diesel exhaust fluid line heater 7 request for aftertreatment system 2 (exhaust bank 2).\r\n\r\n00 = request for heater to be inactive\r\n01 = request for heater to be active\r\n10 = reserved for future assignment by SAE\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7569": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 44,
      "SPN": 7569,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 8",
      "SPN_Description": "The diesel exhaust fluid line heater 8 request for aftertreatment system 2 (exhaust bank 2).\r\n\r\n00 = request for heater to be inactive\r\n01 = request for heater to be active\r\n10 = reserved for future assignment by SAE\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7570": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 46,
      "SPN": 7570,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 9",
      "SPN_Description": "The diesel exhaust fluid line heater 9 request for aftertreatment system 2 (exhaust bank 2).\r\n\r\n00 = request for heater to be inactive\r\n01 = request for heater to be active\r\n10 = reserved for future assignment by SAE\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7571": {
      "PGN": 64826,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 2",
      "PGN_Description": "A2SCRDSR2",
      "first_bit": 48,
      "SPN": 7571,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Line Heater 10",
      "SPN_Description": "The diesel exhaust fluid line heater 10 request for aftertreatment system 2 (exhaust bank 2).\r\n\r\n00 = request for heater to be inactive\r\n01 = request for heater to be active\r\n10 = reserved for future assignment by SAE\r\n11 = not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7572": {
      "PGN": 64549,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 2",
      "PGN_Description": "AT1T1I2",
      "first_bit": 8,
      "SPN": 7572,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank Temperature 2",
      "SPN_Description": "The second temperature of aftertreatment 1 diesel exhaust fluid in the storage tank.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7573": {
      "PGN": 64549,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 2",
      "PGN_Description": "AT1T1I2",
      "first_bit": 16,
      "SPN": 7573,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Tank Heater 2",
      "SPN_Description": "Percentage of heating applied to the second diesel exhaust fluid tank heater on aftertreatment 1. A value of 0% means no heating applied, a value of 100% means full heating applied. The diesel exhaust fluid tank heater warms the diesel exhaust fluid in the diesel exhaust fluid tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7574": {
      "PGN": 64548,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 2",
      "PGN_Description": "AT2T1I2",
      "first_bit": 8,
      "SPN": 7574,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank Temperature 2",
      "SPN_Description": "The second temperature of aftertreatment 2 diesel exhaust fluid in the storage tank.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7575": {
      "PGN": 64548,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 2",
      "PGN_Description": "AT2T1I2",
      "first_bit": 16,
      "SPN": 7575,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Tank Heater 2",
      "SPN_Description": "Percentage of heating applied to the second diesel exhaust fluid tank heater on aftertreatment 2. A value of 0% means no heating applied, a value of 100% means full heating applied. The diesel exhaust fluid tank heater warms the diesel exhaust fluid in the diesel exhaust fluid tank.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7579": {
      "PGN": 34048,
      "PGN_Name": "Cab Message 2",
      "PGN_Description": "CM2",
      "first_bit": 28,
      "SPN": 7579,
      "SPN_Name": "Elevated Engine Speed Allowed Switch",
      "SPN_Description": "Indicates the state of a switch to indicate the control system is permitted to automatically elevate the engine speed as needed for strategies such as cold mode, aftertreatment regeneration, etc. This is not a direct command to increase the engine speed but rather an acknowledgement by the operator that the speed could be increased automatically, such as in response to an indication to the operator from SPN 7502. However, SPN 7502 is not the only method that could request this behavior. Therefore, SPN 7502 is not required in order to use this SPN.\r\n\r\n00 Not allowed to elevate engine speed\r\n01 Allowed to elevate engine speed\r\n10 Error\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7580": {
      "PGN": 34048,
      "PGN_Name": "Cab Message 2",
      "PGN_Description": "CM2",
      "first_bit": 30,
      "SPN": 7580,
      "SPN_Name": "Aftertreatment Regeneration Engine Speed Allowed Switch",
      "SPN_Description": "If this parameter is 01, then the aftertreatment control system is permitted to perform an aftertreatment regeneration, but the aftertreatment control system is not allowed to take control of the engine speed for the purposes of regeneration. A regeneration will be allowed if the engine speed is high enough due to normal operating conditions, but will not command a regeneration.\r\n\r\nIf this parameter is 00, then an aftertreatment regeneration is not allowed even if engine speed is high\r\nenough for a regeneration.\r\n\r\n00 Aftertreatment regeneration is not allowed when engine speed exceeds regeneration threshold\r\n01 Aftertreatment regeneration is allowed when engine speed exceeds regeneration threshold\r\n10 Error\r\n11 Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7581": {
      "PGN": 65277,
      "PGN_Name": "Alternate Fuel 1",
      "PGN_Description": "AF1",
      "first_bit": 48,
      "SPN": 7581,
      "SPN_Name": "Engine Gaseous Fuel Pressure Regulator Intake Pressure",
      "SPN_Description": "The pressure of the fuel at the intake of the pressure regulator.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 377
    },
    "7587": {
      "PGN": 33280,
      "PGN_Name": "Tire Configuration Command Information",
      "PGN_Description": "TCCI",
      "first_bit": 56,
      "SPN": 7587,
      "SPN_Name": "Tire Sensor Enable Setting",
      "SPN_Description": "Command signal used to enable/disable the tire sensor. On receipt of this command, the tire sensor may either be enabled or disabled.\r\n\r\n00 Off / Isolate / Disable\r\n01 On / Enable\r\n10 Reserved / Not Defined\r\n11 Don’t Care / Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7588": {
      "PGN": 64561,
      "PGN_Name": "Aftertreatment System Information 1",
      "PGN_Description": "ASI1",
      "first_bit": 24,
      "SPN": 7588,
      "SPN_Name": "Aftertreatment Diesel Exhaust Fluid Heater Circuit Breaker",
      "SPN_Description": "The status of the circuit breaker that is used to heat the diesel exhaust fluid.\r\n\r\n00 off\r\n01 on\r\n10 error\r\n11 not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7589": {
      "PGN": 7680,
      "PGN_Name": "Alternator Control",
      "PGN_Description": "ALTC",
      "first_bit": 0,
      "SPN": 7589,
      "SPN_Name": "Alternator Setpoint Voltage Command",
      "SPN_Description": "Setpoint voltage command to alternator. The setpoint voltage is the point that is regulated by the alternator. This may or may not be the output of the alternator.",
      "bit_length": 16,
      "scaling": 0.001,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 347
    },
    "7590": {
      "PGN": 7680,
      "PGN_Name": "Alternator Control",
      "PGN_Description": "ALTC",
      "first_bit": 16,
      "SPN": 7590,
      "SPN_Name": "Alternator Excitation Maximum Current Limit",
      "SPN_Description": "Command sent to alternator to set the maximum excitation current of the alternator.",
      "bit_length": 8,
      "scaling": 0.25,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 410
    },
    "7591": {
      "PGN": 7680,
      "PGN_Name": "Alternator Control",
      "PGN_Description": "ALTC",
      "first_bit": 24,
      "SPN": 7591,
      "SPN_Name": "Alternator Torque Ramp Time Command",
      "SPN_Description": "Sets the torque ramp rate in which the alternator can respond to a change in electrical load. 100% represents the reference engine torque (SPN 544). \r\n\r\nThis value will be applied if the alternator speed is less than Alternator Torque Ramp Maximum Speed Command (SPN 7592). This value is not applied if the alternator speed is greater than Alternator Torque Ramp Maximum Speed Command.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 59
    },
    "7592": {
      "PGN": 7680,
      "PGN_Name": "Alternator Control",
      "PGN_Description": "ALTC",
      "first_bit": 32,
      "SPN": 7592,
      "SPN_Name": "Alternator Torque Ramp Maximum Speed Command",
      "SPN_Description": "The Alternator Torque Ramp Time Command (SPN 7591) is applied if the alternator speed is less than Alternator Torque Ramp Maximum Speed Command (SPN 7592). If the alternator speed is greater than Alternator Torque Ramp Maximum Speed Command, then the alternator's default ramp setting is applied.",
      "bit_length": 8,
      "scaling": 32,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 97
    },
    "7593": {
      "PGN": 61672,
      "PGN_Name": "Engine Throttle / Fuel Actuator Control Command 2",
      "PGN_Description": "TFAC2",
      "first_bit": 32,
      "SPN": 7593,
      "SPN_Name": "Engine Fuel Actuator 3 Control Command",
      "SPN_Description": "The control command to fuel actuator 3, normalized to percent, where 0% represents fully closed and 100% represents fully open.  Typically, this fuel actuator is used to regulate low pressure natural gas flow rate, mixing into the air flow, which together then come into the engine. Using the standard convention for determining the position.  Left/front is #1 (SPN 633), left/rear is #2 (SPN 1244), right/front is #3 (SPN 7593) and right/rear is #4 (SPN 7594).",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "7594": {
      "PGN": 61672,
      "PGN_Name": "Engine Throttle / Fuel Actuator Control Command 2",
      "PGN_Description": "TFAC2",
      "first_bit": 48,
      "SPN": 7594,
      "SPN_Name": "Engine Fuel Actuator 4 Control Command",
      "SPN_Description": "The control command to fuel actuator 4, normalized to percent, where 0% represents fully closed and 100% represents fully open.  Typically, this fuel actuator is used to regulate low pressure natural gas flow rate, mixing into the air flow, which together then come into the engine. Using the standard convention for determining the position.  Left/front is #1 (SPN 633), left/rear is #2 (SPN 1244), right/front is #3 (SPN 7593) and right/rear is #4 (SPN 7594).",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "7595": {
      "PGN": 64735,
      "PGN_Name": "Engine Fluid Level/Pressure 12",
      "PGN_Description": "EFL/P12",
      "first_bit": 40,
      "SPN": 7595,
      "SPN_Name": "Engine Throttle Valve 2 Differential Pressure",
      "SPN_Description": "The differential pressure between the intake and outlet of the throttle valve 2 (SPN 3673). The differential pressure is measured from the intake with respect to the outlet of the throttle valve.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "7596": {
      "PGN": 64737,
      "PGN_Name": "Fuel Economy 2 (Liquid)",
      "PGN_Description": "LFE2",
      "first_bit": 32,
      "SPN": 7596,
      "SPN_Name": "Engine Diesel Fuel Demand Rate",
      "SPN_Description": "Amount of diesel fuel that would be consumed by an engine per unit of time if it were not substituting gaseous fuel.  This parameter is the sum of SPN 183 and the amount of diesel fuel that is being displaced by gaseous fuel.  If the engine is not actually substituting gaseous fuel, then this parameter will be the same as SPN 183.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "l/h",
      "SLOT_ID": 42
    },
    "7597": {
      "PGN": 64547,
      "PGN_Name": "Fuel Consumption (Liquid) 2",
      "PGN_Description": "LFC2",
      "first_bit": 0,
      "SPN": 7597,
      "SPN_Name": "Engine Total Diesel Fuel Demand",
      "SPN_Description": "Accumulated amount of liquid fuel that would have been used during engine operation, including actual diesel fuel used and the diesel fuel that was displaced by gaseous fuel.\r\n\r\nThis is the cumulative value of SPN 7596.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 75
    },
    "7606": {
      "PGN": 64561,
      "PGN_Name": "Aftertreatment System Information 1",
      "PGN_Description": "ASI1",
      "first_bit": 32,
      "SPN": 7606,
      "SPN_Name": "Aftertreatment Diesel Exhaust Fluid Tank Volume",
      "SPN_Description": "The derived diesel exhaust fluid tank volume in applications with multiple level sensors in a single tank. The SPN data will be derived from all level sensors in the tank.\r\n\r\nNote: This SPN can be derived from any of the aftertreatment tank level sensors including SPN 1761, SPN 7530, SPN 4426 or SPN 7531.\r\n\r\n0 % = Empty\r\n100% = Full\r\n\r\nParameter Specific Indicator:\r\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7607": {
      "PGN": 64561,
      "PGN_Name": "Aftertreatment System Information 1",
      "PGN_Description": "ASI1",
      "first_bit": 40,
      "SPN": 7607,
      "SPN_Name": "Aftertreatment Diesel Exhaust Fluid Tank Temperature",
      "SPN_Description": "The derived diesel exhaust fluid tank temperature in applications with multiple temperature sensors in a single tank. The SPN data will be derived from all temperature sensors in the tank.\r\n\r\nNote: This SPN can be derived from any of the aftertreatment tank temperature sensors including SPN 3031, SPN 7572, SPN 4427 or SPN 7574.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7608": {
      "PGN": 64546,
      "PGN_Name": "Electronic Engine Controller 19",
      "PGN_Description": "EEC19",
      "first_bit": 0,
      "SPN": 7608,
      "SPN_Name": "Total Engine Energy",
      "SPN_Description": "The total amount of energy delivered by the engine. It is accumulated over the life of the engine.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "kWh",
      "SLOT_ID": 150
    },
    "7609": {
      "PGN": 61498,
      "PGN_Name": "Engine Cylinder 1 Combustion Information",
      "PGN_Description": "ECCI1",
      "first_bit": 48,
      "SPN": 7609,
      "SPN_Name": "Engine Cylinder 1 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 1. This knock occurs at frequencies below the typical knock level reported on SPNs 1352 & 6398. The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1352 (and 6398).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7610": {
      "PGN": 61499,
      "PGN_Name": "Engine Cylinder 2 Combustion Information",
      "PGN_Description": "ECCI2",
      "first_bit": 48,
      "SPN": 7610,
      "SPN_Name": "Engine Cylinder 2 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 2. This knock occurs at frequencies below the typical knock level reported on SPNs 1353 & 6402.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1353 (and 6402).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7611": {
      "PGN": 61500,
      "PGN_Name": "Engine Cylinder 3 Combustion Information",
      "PGN_Description": "ECCI3",
      "first_bit": 48,
      "SPN": 7611,
      "SPN_Name": "Engine Cylinder 3 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 3. This knock occurs at frequencies below the typical knock level reported on SPNs 1354 & 6406.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1354 (and 6406).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7612": {
      "PGN": 61501,
      "PGN_Name": "Engine Cylinder 4 Combustion Information",
      "PGN_Description": "ECCI4",
      "first_bit": 48,
      "SPN": 7612,
      "SPN_Name": "Engine Cylinder 4 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 4. This knock occurs at frequencies below the typical knock level reported on SPNs 1355 & 6410.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1355 (and 6410).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7613": {
      "PGN": 61502,
      "PGN_Name": "Engine Cylinder 5 Combustion Information",
      "PGN_Description": "ECCI5",
      "first_bit": 48,
      "SPN": 7613,
      "SPN_Name": "Engine Cylinder 5 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 5. This knock occurs at frequencies below the typical knock level reported on SPNs 1356 & 6414.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1356 (and 6414).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7614": {
      "PGN": 61503,
      "PGN_Name": "Engine Cylinder 6 Combustion Information",
      "PGN_Description": "ECCI6",
      "first_bit": 48,
      "SPN": 7614,
      "SPN_Name": "Engine Cylinder 6 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 6. This knock occurs at frequencies below the typical knock level reported on SPNs 1357 & 6418.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1357 (and 6418).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7615": {
      "PGN": 61504,
      "PGN_Name": "Engine Cylinder 7 Combustion Information",
      "PGN_Description": "ECCI7",
      "first_bit": 48,
      "SPN": 7615,
      "SPN_Name": "Engine Cylinder 7 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 7. This knock occurs at frequencies below the typical knock level reported on SPNs 1358 & 6422.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1358 (and 6422).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7616": {
      "PGN": 61505,
      "PGN_Name": "Engine Cylinder 8 Combustion Information",
      "PGN_Description": "ECCI8",
      "first_bit": 48,
      "SPN": 7616,
      "SPN_Name": "Engine Cylinder 8 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 8. This knock occurs at frequencies below the typical knock level reported on SPNs 1359 & 6426.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1359 (and 6426).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7617": {
      "PGN": 61506,
      "PGN_Name": "Engine Cylinder 9 Combustion Information",
      "PGN_Description": "ECCI9",
      "first_bit": 48,
      "SPN": 7617,
      "SPN_Name": "Engine Cylinder 9 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 9. This knock occurs at frequencies below the typical knock level reported on SPNs 1360 & 6430.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1360 (and 6430).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7618": {
      "PGN": 61507,
      "PGN_Name": "Engine Cylinder 10 Combustion Information",
      "PGN_Description": "ECCI10",
      "first_bit": 48,
      "SPN": 7618,
      "SPN_Name": "Engine Cylinder 10 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 10. This knock occurs at frequencies below the typical knock level reported on SPNs 1361 & 6434.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1361 (and 6434).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7619": {
      "PGN": 61508,
      "PGN_Name": "Engine Cylinder 11 Combustion Information",
      "PGN_Description": "ECCI11",
      "first_bit": 48,
      "SPN": 7619,
      "SPN_Name": "Engine Cylinder 11 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 11. This knock occurs at frequencies below the typical knock level reported on SPNs 1362 & 6438.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1362 (and 6438).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7620": {
      "PGN": 61509,
      "PGN_Name": "Engine Cylinder 12 Combustion Information",
      "PGN_Description": "ECCI12",
      "first_bit": 48,
      "SPN": 7620,
      "SPN_Name": "Engine Cylinder 12 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 12. This knock occurs at frequencies below the typical knock level reported on SPNs 1363 & 6442.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1363 (and 6442).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7621": {
      "PGN": 61510,
      "PGN_Name": "Engine Cylinder 13 Combustion Information",
      "PGN_Description": "ECCI13",
      "first_bit": 48,
      "SPN": 7621,
      "SPN_Name": "Engine Cylinder 13 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 13. This knock occurs at frequencies below the typical knock level reported on SPNs 1364 & 6446.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1364 (and 6446).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7622": {
      "PGN": 61511,
      "PGN_Name": "Engine Cylinder 14 Combustion Information",
      "PGN_Description": "ECCI14",
      "first_bit": 48,
      "SPN": 7622,
      "SPN_Name": "Engine Cylinder 14 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 14. This knock occurs at frequencies below the typical knock level reported on SPNs 1365 & 6450.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1365 (and 6450).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7623": {
      "PGN": 61512,
      "PGN_Name": "Engine Cylinder 15 Combustion Information",
      "PGN_Description": "ECCI15",
      "first_bit": 48,
      "SPN": 7623,
      "SPN_Name": "Engine Cylinder 15 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 15. This knock occurs at frequencies below the typical knock level reported on SPNs 1366 & 6454.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1366 (and 6454).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7624": {
      "PGN": 61513,
      "PGN_Name": "Engine Cylinder 16 Combustion Information",
      "PGN_Description": "ECCI16",
      "first_bit": 48,
      "SPN": 7624,
      "SPN_Name": "Engine Cylinder 16 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 16. This knock occurs at frequencies below the typical knock level reported on SPNs 1367 & 6458.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1367 (and 6458).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7625": {
      "PGN": 61514,
      "PGN_Name": "Engine Cylinder 17 Combustion Information",
      "PGN_Description": "ECCI17",
      "first_bit": 48,
      "SPN": 7625,
      "SPN_Name": "Engine Cylinder 17 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 17. This knock occurs at frequencies below the typical knock level reported on SPNs 1368 & 6462.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1368 (and 6462).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7626": {
      "PGN": 61515,
      "PGN_Name": "Engine Cylinder 18 Combustion Information",
      "PGN_Description": "ECCI18",
      "first_bit": 48,
      "SPN": 7626,
      "SPN_Name": "Engine Cylinder 18 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 18. This knock occurs at frequencies below the typical knock level reported on SPNs 1369 & 6466.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1369 (and 6466).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7627": {
      "PGN": 61516,
      "PGN_Name": "Engine Cylinder 19 Combustion Information",
      "PGN_Description": "ECCI19",
      "first_bit": 48,
      "SPN": 7627,
      "SPN_Name": "Engine Cylinder 19 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 19. This knock occurs at frequencies below the typical knock level reported on SPNs 1370 & 6470.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1370 (and 6470).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7628": {
      "PGN": 61517,
      "PGN_Name": "Engine Cylinder 20 Combustion Information",
      "PGN_Description": "ECCI20",
      "first_bit": 48,
      "SPN": 7628,
      "SPN_Name": "Engine Cylinder 20 Low Frequency Knock Level",
      "SPN_Description": "Indicates the level of low frequency knock for engine cylinder 20. This knock occurs at frequencies below the typical knock level reported on SPNs 1371 & 6474.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1371 (and 6474).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7629": {
      "PGN": 61498,
      "PGN_Name": "Engine Cylinder 1 Combustion Information",
      "PGN_Description": "ECCI1",
      "first_bit": 56,
      "SPN": 7629,
      "SPN_Name": "Engine Cylinder 1 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 1 during the combustion cycle.\r\n",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7630": {
      "PGN": 61499,
      "PGN_Name": "Engine Cylinder 2 Combustion Information",
      "PGN_Description": "ECCI2",
      "first_bit": 56,
      "SPN": 7630,
      "SPN_Name": "Engine Cylinder 2 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 2 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7631": {
      "PGN": 61500,
      "PGN_Name": "Engine Cylinder 3 Combustion Information",
      "PGN_Description": "ECCI3",
      "first_bit": 56,
      "SPN": 7631,
      "SPN_Name": "Engine Cylinder 3 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 3 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7632": {
      "PGN": 61501,
      "PGN_Name": "Engine Cylinder 4 Combustion Information",
      "PGN_Description": "ECCI4",
      "first_bit": 56,
      "SPN": 7632,
      "SPN_Name": "Engine Cylinder 4 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 4 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7633": {
      "PGN": 61502,
      "PGN_Name": "Engine Cylinder 5 Combustion Information",
      "PGN_Description": "ECCI5",
      "first_bit": 56,
      "SPN": 7633,
      "SPN_Name": "Engine Cylinder 5 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 5 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7634": {
      "PGN": 61503,
      "PGN_Name": "Engine Cylinder 6 Combustion Information",
      "PGN_Description": "ECCI6",
      "first_bit": 56,
      "SPN": 7634,
      "SPN_Name": "Engine Cylinder 6 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 6 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7635": {
      "PGN": 61504,
      "PGN_Name": "Engine Cylinder 7 Combustion Information",
      "PGN_Description": "ECCI7",
      "first_bit": 56,
      "SPN": 7635,
      "SPN_Name": "Engine Cylinder 7 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 7 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7636": {
      "PGN": 61505,
      "PGN_Name": "Engine Cylinder 8 Combustion Information",
      "PGN_Description": "ECCI8",
      "first_bit": 56,
      "SPN": 7636,
      "SPN_Name": "Engine Cylinder 8 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 8 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7637": {
      "PGN": 61506,
      "PGN_Name": "Engine Cylinder 9 Combustion Information",
      "PGN_Description": "ECCI9",
      "first_bit": 56,
      "SPN": 7637,
      "SPN_Name": "Engine Cylinder 9 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 9 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7638": {
      "PGN": 61507,
      "PGN_Name": "Engine Cylinder 10 Combustion Information",
      "PGN_Description": "ECCI10",
      "first_bit": 56,
      "SPN": 7638,
      "SPN_Name": "Engine Cylinder 10 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 10 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7639": {
      "PGN": 61508,
      "PGN_Name": "Engine Cylinder 11 Combustion Information",
      "PGN_Description": "ECCI11",
      "first_bit": 56,
      "SPN": 7639,
      "SPN_Name": "Engine Cylinder 11 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 11 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7640": {
      "PGN": 61509,
      "PGN_Name": "Engine Cylinder 12 Combustion Information",
      "PGN_Description": "ECCI12",
      "first_bit": 56,
      "SPN": 7640,
      "SPN_Name": "Engine Cylinder 12 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 12 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7641": {
      "PGN": 61510,
      "PGN_Name": "Engine Cylinder 13 Combustion Information",
      "PGN_Description": "ECCI13",
      "first_bit": 56,
      "SPN": 7641,
      "SPN_Name": "Engine Cylinder 13 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 13 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7642": {
      "PGN": 61511,
      "PGN_Name": "Engine Cylinder 14 Combustion Information",
      "PGN_Description": "ECCI14",
      "first_bit": 56,
      "SPN": 7642,
      "SPN_Name": "Engine Cylinder 14 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 14 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7643": {
      "PGN": 61512,
      "PGN_Name": "Engine Cylinder 15 Combustion Information",
      "PGN_Description": "ECCI15",
      "first_bit": 56,
      "SPN": 7643,
      "SPN_Name": "Engine Cylinder 15 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 15 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7644": {
      "PGN": 61513,
      "PGN_Name": "Engine Cylinder 16 Combustion Information",
      "PGN_Description": "ECCI16",
      "first_bit": 56,
      "SPN": 7644,
      "SPN_Name": "Engine Cylinder 16 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 16 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7645": {
      "PGN": 61514,
      "PGN_Name": "Engine Cylinder 17 Combustion Information",
      "PGN_Description": "ECCI17",
      "first_bit": 56,
      "SPN": 7645,
      "SPN_Name": "Engine Cylinder 17 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 17 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7646": {
      "PGN": 61515,
      "PGN_Name": "Engine Cylinder 18 Combustion Information",
      "PGN_Description": "ECCI18",
      "first_bit": 56,
      "SPN": 7646,
      "SPN_Name": "Engine Cylinder 18 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 18 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7647": {
      "PGN": 61516,
      "PGN_Name": "Engine Cylinder 19 Combustion Information",
      "PGN_Description": "ECCI19",
      "first_bit": 56,
      "SPN": 7647,
      "SPN_Name": "Engine Cylinder 19 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 19 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7648": {
      "PGN": 61517,
      "PGN_Name": "Engine Cylinder 20 Combustion Information",
      "PGN_Description": "ECCI20",
      "first_bit": 56,
      "SPN": 7648,
      "SPN_Name": "Engine Cylinder 20 Maximum Pressure Increase Rate",
      "SPN_Description": "The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 20 during the combustion cycle.",
      "bit_length": 8,
      "scaling": 16,
      "offset": 0,
      "unit": "kPa/deg crank angle",
      "SLOT_ID": 411
    },
    "7649": {
      "PGN": 61673,
      "PGN_Name": "Aftertreatment 1 Intake Gas 3",
      "PGN_Description": "AT1IG3",
      "first_bit": 0,
      "SPN": 7649,
      "SPN_Name": "Aftertreatment 1 SCR Intake NOx 2",
      "SPN_Description": "The second measurement of the amount of combined NO and NO2 in the exhaust entering the aftertreatment system measured by a NOx sensor at the aftertreatment intake, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 1 Dosing Unit 1.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "7650": {
      "PGN": 61673,
      "PGN_Name": "Aftertreatment 1 Intake Gas 3",
      "PGN_Description": "AT1IG3",
      "first_bit": 16,
      "SPN": 7650,
      "SPN_Name": "Aftertreatment 1 Intake Percent Oxygen 2",
      "SPN_Description": "The second measurement of the actual oxidation factor (Percent Oxygen) of the gas within the exhaust stream. For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion. For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor. This value is measured by a sensor at the aftertreatment intake in exhaust bank 1.\r\n\r\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \"Rich\" or \"Lean\" in place of the implied %O2 values which would also be acceptable for display.",
      "bit_length": 16,
      "scaling": 0.000514,
      "offset": -12,
      "unit": "%",
      "SLOT_ID": 237
    },
    "7651": {
      "PGN": 61673,
      "PGN_Name": "Aftertreatment 1 Intake Gas 3",
      "PGN_Description": "AT1IG3",
      "first_bit": 32,
      "SPN": 7651,
      "SPN_Name": "Aftertreatment 1 Intake Gas Sensor 2 Power In Range",
      "SPN_Description": "Indicates that the second measurement of power supplied to the aftertreatment intake gas sensor, either NOx or O2, is within the manufacturer’s specification in exhaust bank 1.  This parameter reports the status as reported by the sensor.\r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7652": {
      "PGN": 61673,
      "PGN_Name": "Aftertreatment 1 Intake Gas 3",
      "PGN_Description": "AT1IG3",
      "first_bit": 34,
      "SPN": 7652,
      "SPN_Name": "Aftertreatment 1 Intake Gas Sensor 2 at Temperature",
      "SPN_Description": "Indicates that the heater element of the aftertreatment intake gas second sensor, either NOx or O2, is within the manufacturer’s specified range for accurate measurements in exhaust bank 1.\r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7653": {
      "PGN": 61673,
      "PGN_Name": "Aftertreatment 1 Intake Gas 3",
      "PGN_Description": "AT1IG3",
      "first_bit": 36,
      "SPN": 7653,
      "SPN_Name": "Aftertreatment 1 SCR Intake NOx 2 Reading Stable",
      "SPN_Description": "Indicates that the NOx reading of the aftertreatment intake NOx second sensor is stable as determined by the manufacturer’s control software in exhaust bank 1.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7654": {
      "PGN": 61673,
      "PGN_Name": "Aftertreatment 1 Intake Gas 3",
      "PGN_Description": "AT1IG3",
      "first_bit": 38,
      "SPN": 7654,
      "SPN_Name": "Aftertreatment 1 Intake Wide-Range Percent Oxygen 2 Reading Stable",
      "SPN_Description": "Indicates that the second measurement of the percent oxygen reading of the aftertreatment intake gas sensor, either NOx or O2, is stable as determined by the manufacturer's control software in exhaust bank 1.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7655": {
      "PGN": 61673,
      "PGN_Name": "Aftertreatment 1 Intake Gas 3",
      "PGN_Description": "AT1IG3",
      "first_bit": 40,
      "SPN": 7655,
      "SPN_Name": "Aftertreatment 1 Intake Gas Sensor 2 Heater Preliminary FMI",
      "SPN_Description": "Used to identify the second applicable J1939-73 FMI detected in the heater of the intake exhaust gas sensor, either NOx or O2, by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7656": {
      "PGN": 61673,
      "PGN_Name": "Aftertreatment 1 Intake Gas 3",
      "PGN_Description": "AT1IG3",
      "first_bit": 45,
      "SPN": 7656,
      "SPN_Name": "Aftertreatment 1 Intake Gas Sensor 2 Heater Control",
      "SPN_Description": "Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the second gas sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1.\r\n\r\n00 - Automatic\r\n01 - Preheat 2\r\n10 - Preheat 1\r\n11 - Heater off",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7657": {
      "PGN": 61673,
      "PGN_Name": "Aftertreatment 1 Intake Gas 3",
      "PGN_Description": "AT1IG3",
      "first_bit": 48,
      "SPN": 7657,
      "SPN_Name": "Aftertreatment 1 SCR Intake NOx Sensor 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment intake NOx second sensor by the manufacturer’s sensor control software in exhaust bank 1.   In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7658": {
      "PGN": 61673,
      "PGN_Name": "Aftertreatment 1 Intake Gas 3",
      "PGN_Description": "AT1IG3",
      "first_bit": 53,
      "SPN": 7658,
      "SPN_Name": "Aftertreatment 1 Intake NOx Sensor 2 Self-diagnosis Status",
      "SPN_Description": "Self-diagnosis result status for the second NOx sensor ATI1 (Aftertreatment Intake Bank 1)\r\n\r\n000 Diagnosis not active\r\n001 NOx Sensor ATI1 Self Diagnosis active flag\r\n010 NOx Sensor ATI1 Self Diagnosis Result Complete\r\n011 NOx Sensor ATI1 Self Diagnosis aborted\r\n100 NOx Sensor ATI1 Self Diagnosis not possible\r\n101 - 110 Reserved\r\n111 Not Supported",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7659": {
      "PGN": 61673,
      "PGN_Name": "Aftertreatment 1 Intake Gas 3",
      "PGN_Description": "AT1IG3",
      "first_bit": 56,
      "SPN": 7659,
      "SPN_Name": "Aftertreatment 1 Intake Oxygen Sensor 2 Preliminary FMI",
      "SPN_Description": "Used to identify the second applicable J1939-73 FMI detected in the aftertreatment intake oxygen sensor by the manufacturer’s sensor control software in exhaust bank 1.   In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7660": {
      "PGN": 61674,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 3",
      "PGN_Description": "AT1OG3",
      "first_bit": 0,
      "SPN": 7660,
      "SPN_Name": "Aftertreatment 1 Outlet NOx 2",
      "SPN_Description": "The second measurement of the amount of combined NO and NO2 in the exhaust exiting the aftertreatment system measured by a NOx sensor at the aftertreatment outlet, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "7661": {
      "PGN": 61674,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 3",
      "PGN_Description": "AT1OG3",
      "first_bit": 16,
      "SPN": 7661,
      "SPN_Name": "Aftertreatment 1 Outlet Percent Oxygen 2",
      "SPN_Description": "The second measurement of the actual oxidation factor (percent oxygen) of the gas within the exhaust stream.  For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion.  For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor.  This value is measured by a sensor at the aftertreatment outlet in exhaust bank 1.\r\n\r\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \"Rich\" or \"Lean\" in place of the implied %O2 values which would also be acceptable for display.",
      "bit_length": 16,
      "scaling": 0.000514,
      "offset": -12,
      "unit": "%",
      "SLOT_ID": 237
    },
    "7662": {
      "PGN": 61674,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 3",
      "PGN_Description": "AT1OG3",
      "first_bit": 32,
      "SPN": 7662,
      "SPN_Name": "Aftertreatment 1 Outlet Gas Sensor 2 Power In Range",
      "SPN_Description": "Indicates that the second measurement of power supplied to the aftertreatment outlet gas sensor, either NOx or O2, is within the manufacturer’s specification in exhaust bank 1. This parameter reports the status as reported by the sensor.\r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7663": {
      "PGN": 61674,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 3",
      "PGN_Description": "AT1OG3",
      "first_bit": 34,
      "SPN": 7663,
      "SPN_Name": "Aftertreatment 1 Outlet Gas Sensor 2 at Temperature",
      "SPN_Description": "Indicates that the heater element of the aftertreatment outlet gas second sensor, either NOx or O2, is within the manufacturer’s specified range for accurate measurements in exhaust bank 1.\r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7664": {
      "PGN": 61674,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 3",
      "PGN_Description": "AT1OG3",
      "first_bit": 36,
      "SPN": 7664,
      "SPN_Name": "Aftertreatment 1 Outlet NOx 2 Reading Stable",
      "SPN_Description": "Indicates that the NOx reading of the aftertreatment outlet NOx second sensor is stable as determined by the manufacturer’s control software in exhaust bank 1.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7665": {
      "PGN": 61674,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 3",
      "PGN_Description": "AT1OG3",
      "first_bit": 38,
      "SPN": 7665,
      "SPN_Name": "Aftertreatment 1 Outlet Wide-Range Percent Oxygen 2 Reading Stable",
      "SPN_Description": "Indicates that the percent oxygen reading of the aftertreatment outlet gas second sensor, either NOx or O2, is stable as determined by the manufacturer's control software in exhaust bank 1.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7666": {
      "PGN": 61674,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 3",
      "PGN_Description": "AT1OG3",
      "first_bit": 40,
      "SPN": 7666,
      "SPN_Name": "Aftertreatment 1 Outlet Gas Sensor 2 Heater Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the heater of the outlet exhaust gas second sensor, either NOx or O2, by the manufacturer’s sensor control software in exhaust bank 1.    In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7667": {
      "PGN": 61674,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 3",
      "PGN_Description": "AT1OG3",
      "first_bit": 45,
      "SPN": 7667,
      "SPN_Name": "Aftertreatment 1 Outlet Gas Sensor 2 Heater Control",
      "SPN_Description": "Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the gas second sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1.\r\n\r\n00 - Automatic\r\n01 - Preheat 2\r\n10 - Preheat 1\r\n11 - Heater off",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7668": {
      "PGN": 61674,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 3",
      "PGN_Description": "AT1OG3",
      "first_bit": 48,
      "SPN": 7668,
      "SPN_Name": "Aftertreatment 1 Outlet NOx Sensor 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet NOx second sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7669": {
      "PGN": 61674,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 3",
      "PGN_Description": "AT1OG3",
      "first_bit": 53,
      "SPN": 7669,
      "SPN_Name": "Aftertreatment 1 Outlet NOx Sensor 2 Self-diagnosis Status",
      "SPN_Description": "Self-diagnosis result status for NOx second sensor ATO1 (Aftertreatment Outlet Bank 1)\r\n\r\n000 Diagnosis not active\r\n001 NOx Sensor ATO1 Self Diagnosis active flag\r\n010 NOx Sensor ATO1 Self Diagnosis Result Complete\r\n011 NOx Sensor ATO1 Self Diagnosis aborted\r\n100 NOx Sensor ATO1 Self Diagnosis not possible\r\n101 - 110 Reserved\r\n111 Not Supported",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7670": {
      "PGN": 61674,
      "PGN_Name": "Aftertreatment 1 Outlet Gas 3",
      "PGN_Description": "AT1OG3",
      "first_bit": 56,
      "SPN": 7670,
      "SPN_Name": "Aftertreatment 1 Outlet Oxygen Sensor 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet oxygen second sensor by the manufacturer’s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7671": {
      "PGN": 61675,
      "PGN_Name": "Aftertreatment 2 Intake Gas Sensor 2",
      "PGN_Description": "AT2IGS2",
      "first_bit": 0,
      "SPN": 7671,
      "SPN_Name": "Aftertreatment 2 SCR Intake NOx 2",
      "SPN_Description": "The amount of combined NO and NO2 in the exhaust entering the aftertreatment system measured by the second NOx sensor at the aftertreatment intake, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "7672": {
      "PGN": 61675,
      "PGN_Name": "Aftertreatment 2 Intake Gas Sensor 2",
      "PGN_Description": "AT2IGS2",
      "first_bit": 16,
      "SPN": 7672,
      "SPN_Name": "Aftertreatment 2 Intake Percent Oxygen 2",
      "SPN_Description": "The actual oxidation factor (percent oxygen) of the gas within the exhaust stream.  For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion.  For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor.  This value is measured by the second sensor at the aftertreatment intake in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\r\n\r\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \"Rich\" or \"Lean\" in place of the implied %O2 values which would also be acceptable for display.",
      "bit_length": 16,
      "scaling": 0.000514,
      "offset": -12,
      "unit": "%",
      "SLOT_ID": 237
    },
    "7673": {
      "PGN": 61675,
      "PGN_Name": "Aftertreatment 2 Intake Gas Sensor 2",
      "PGN_Description": "AT2IGS2",
      "first_bit": 32,
      "SPN": 7673,
      "SPN_Name": "Aftertreatment 2 Intake Gas Sensor 2 Power In Range",
      "SPN_Description": "Indicates that the power supplied to the aftertreatment intake gas second sensor, either NOx or O2, is within the manufacturer’s specification in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\r\n\r\nThis parameter reports the status as reported by the sensor.\r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7674": {
      "PGN": 61675,
      "PGN_Name": "Aftertreatment 2 Intake Gas Sensor 2",
      "PGN_Description": "AT2IGS2",
      "first_bit": 34,
      "SPN": 7674,
      "SPN_Name": "Aftertreatment 2 Intake Gas Sensor 2 at Temperature",
      "SPN_Description": "Indicates that the heater element of the aftertreatment intake gas second sensor, either NOx or O2, is within the manufacturer’s specified range for accurate measurements in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7675": {
      "PGN": 61675,
      "PGN_Name": "Aftertreatment 2 Intake Gas Sensor 2",
      "PGN_Description": "AT2IGS2",
      "first_bit": 36,
      "SPN": 7675,
      "SPN_Name": "Aftertreatment 2 SCR Intake NOx 2 Reading Stable",
      "SPN_Description": " Indicates that the NOx reading of the aftertreatment intake NOx second sensor is stable as determined by the manufacturer’s control software in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7676": {
      "PGN": 61675,
      "PGN_Name": "Aftertreatment 2 Intake Gas Sensor 2",
      "PGN_Description": "AT2IGS2",
      "first_bit": 38,
      "SPN": 7676,
      "SPN_Name": "Aftertreatment 2 Intake Wide-Range Percent Oxygen 2 Reading Stable",
      "SPN_Description": "Indicates that the percent oxygen reading of the aftertreatment intake gas second sensor, either NOx or O2, is stable as determined by the manufacturer's control software in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7677": {
      "PGN": 61675,
      "PGN_Name": "Aftertreatment 2 Intake Gas Sensor 2",
      "PGN_Description": "AT2IGS2",
      "first_bit": 40,
      "SPN": 7677,
      "SPN_Name": "Aftertreatment 2 Intake Gas Sensor 2 Heater Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the heater of the intake exhaust gas second sensor, either NOx or O2, by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7678": {
      "PGN": 61675,
      "PGN_Name": "Aftertreatment 2 Intake Gas Sensor 2",
      "PGN_Description": "AT2IGS2",
      "first_bit": 45,
      "SPN": 7678,
      "SPN_Name": "Aftertreatment 2 Intake Gas Sensor 2 Heater Control",
      "SPN_Description": "Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the second gas sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\r\n\r\n00 - Automatic\r\n01 - Preheat 2\r\n10 - Preheat 1\r\n11 - Heater off",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7679": {
      "PGN": 61675,
      "PGN_Name": "Aftertreatment 2 Intake Gas Sensor 2",
      "PGN_Description": "AT2IGS2",
      "first_bit": 48,
      "SPN": 7679,
      "SPN_Name": "Aftertreatment 2 SCR Intake NOx Sensor 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment intake NOx second sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7680": {
      "PGN": 61675,
      "PGN_Name": "Aftertreatment 2 Intake Gas Sensor 2",
      "PGN_Description": "AT2IGS2",
      "first_bit": 53,
      "SPN": 7680,
      "SPN_Name": "Aftertreatment 2 Intake NOx Sensor 2 Self-diagnosis Status",
      "SPN_Description": "Self-diagnosis result status for NOx second sensor ATI2 (Aftertreatment Intake Bank 2)\r\n\r\n000 Diagnosis not active\r\n001 NOx Sensor ATI2 Self Diagnosis active flag\r\n010 NOx Sensor ATI2 Self Diagnosis Result Complete\r\n011 NOx Sensor ATI2 Self Diagnosis aborted\r\n100 NOx Sensor ATI2 Self Diagnosis not possible\r\n101 - 110 Reserved\r\n111 Not Supported",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7681": {
      "PGN": 61675,
      "PGN_Name": "Aftertreatment 2 Intake Gas Sensor 2",
      "PGN_Description": "AT2IGS2",
      "first_bit": 56,
      "SPN": 7681,
      "SPN_Name": "Aftertreatment 2 Intake Oxygen Sensor 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment intake oxygen second sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7682": {
      "PGN": 61676,
      "PGN_Name": "Aftertreatment 2 Outlet Gas Sensor 2",
      "PGN_Description": "AT2OGS2",
      "first_bit": 0,
      "SPN": 7682,
      "SPN_Name": "Aftertreatment 2 Outlet NOx 2",
      "SPN_Description": "The amount of combined NO and NO2 in the exhaust entering the aftertreatment system measured by the second NOx sensor at the aftertreatment outlet, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -200,
      "unit": "ppm",
      "SLOT_ID": 236
    },
    "7683": {
      "PGN": 61676,
      "PGN_Name": "Aftertreatment 2 Outlet Gas Sensor 2",
      "PGN_Description": "AT2OGS2",
      "first_bit": 16,
      "SPN": 7683,
      "SPN_Name": "Aftertreatment 2 Outlet Percent Oxygen 2",
      "SPN_Description": "The actual oxidation factor (percent oxygen) of the gas within the exhaust stream.  For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion.  For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor.  This value is measured by the second sensor at the aftertreatment outlet in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\r\n\r\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \"Rich\" or \"Lean\" in place of the implied %O2 values which would also be acceptable for display.",
      "bit_length": 16,
      "scaling": 0.000514,
      "offset": -12,
      "unit": "%",
      "SLOT_ID": 237
    },
    "7684": {
      "PGN": 61676,
      "PGN_Name": "Aftertreatment 2 Outlet Gas Sensor 2",
      "PGN_Description": "AT2OGS2",
      "first_bit": 32,
      "SPN": 7684,
      "SPN_Name": "Aftertreatment 2 Outlet Gas Sensor 2 Power In Range",
      "SPN_Description": " Indicates that the power supplied to the aftertreatment outlet gas second sensor, either NOx or O2, is within the manufacturer’s specification in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\r\n\r\nThis parameter reports the status as reported by the sensor.\r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7685": {
      "PGN": 61676,
      "PGN_Name": "Aftertreatment 2 Outlet Gas Sensor 2",
      "PGN_Description": "AT2OGS2",
      "first_bit": 34,
      "SPN": 7685,
      "SPN_Name": "Aftertreatment 2 Outlet Gas Sensor 2 at Temperature",
      "SPN_Description": "Indicates that the heater element of the aftertreatment outlet gas second sensor, either NOx or O2, is within the manufacturer’s specified range for accurate measurements in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\r\n\r\n00 - Not in range\r\n01 - In range\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7686": {
      "PGN": 61676,
      "PGN_Name": "Aftertreatment 2 Outlet Gas Sensor 2",
      "PGN_Description": "AT2OGS2",
      "first_bit": 36,
      "SPN": 7686,
      "SPN_Name": "Aftertreatment 2 Outlet NOx  2 Reading Stable",
      "SPN_Description": "Indicates that the NOx reading of the aftertreatment outlet NOx second sensor is stable as determined by the manufacturer’s control software in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7687": {
      "PGN": 61676,
      "PGN_Name": "Aftertreatment 2 Outlet Gas Sensor 2",
      "PGN_Description": "AT2OGS2",
      "first_bit": 38,
      "SPN": 7687,
      "SPN_Name": "Aftertreatment 2 Outlet Wide-Range Percent Oxygen 2 Reading Stable",
      "SPN_Description": "Indicates that the percent oxygen reading of the aftertreatment outlet gas second sensor, either NOx or O2, is stable as determined by the manufacturer's control software in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\r\n\r\n00 - Not stable\r\n01 - Stable\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7688": {
      "PGN": 61676,
      "PGN_Name": "Aftertreatment 2 Outlet Gas Sensor 2",
      "PGN_Description": "AT2OGS2",
      "first_bit": 40,
      "SPN": 7688,
      "SPN_Name": "Aftertreatment 2 Outlet Gas Sensor 2 Heater Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the heater of the outlet exhaust gas second sensor, either NOx or O2, by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7689": {
      "PGN": 61676,
      "PGN_Name": "Aftertreatment 2 Outlet Gas Sensor 2",
      "PGN_Description": "AT2OGS2",
      "first_bit": 45,
      "SPN": 7689,
      "SPN_Name": "Aftertreatment 2 Outlet Gas Sensor 2 Heater Control",
      "SPN_Description": "Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the gas second sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 2.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\r\n\r\n00 - Automatic\r\n01 - Preheat 2\r\n10 - Preheat 1\r\n11 - Heater off",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7690": {
      "PGN": 61676,
      "PGN_Name": "Aftertreatment 2 Outlet Gas Sensor 2",
      "PGN_Description": "AT2OGS2",
      "first_bit": 48,
      "SPN": 7690,
      "SPN_Name": "Aftertreatment 2 Outlet NOx Sensor 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet NOx second sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948 and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7691": {
      "PGN": 61676,
      "PGN_Name": "Aftertreatment 2 Outlet Gas Sensor 2",
      "PGN_Description": "AT2OGS2",
      "first_bit": 53,
      "SPN": 7691,
      "SPN_Name": "Aftertreatment 2 Outlet NOx Sensor 2 Self-diagnosis Status",
      "SPN_Description": "Self-diagnosis result status for second NOx sensor ATO2 (Aftertreatment Outlet Bank 2)\r\n\r\n000 Diagnosis not active\r\n001 NOx Sensor ATO2 Self Diagnosis active flag\r\n010 NOx Sensor ATO2 Self Diagnosis Result Complete\r\n011 NOx Sensor ATO2 Self Diagnosis aborted\r\n100 NOx Sensor ATO2 Self Diagnosis not possible\r\n101 - 110 Reserved\r\n111 Not Supported",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7692": {
      "PGN": 61676,
      "PGN_Name": "Aftertreatment 2 Outlet Gas Sensor 2",
      "PGN_Description": "AT2OGS2",
      "first_bit": 56,
      "SPN": 7692,
      "SPN_Name": "Aftertreatment 2 Outlet Oxygen Sensor 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet oxygen second sensor by the manufacturer’s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948 and 65247.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7694": {
      "PGN": 34048,
      "PGN_Name": "Cab Message 2",
      "PGN_Description": "CM2",
      "first_bit": 48,
      "SPN": 7694,
      "SPN_Name": "Transmission Auto-Neutral (Manual Return) Enable Switch",
      "SPN_Description": "This enable switch is for optional use with interfaces using SPN 7695 [Transmission Auto-Neutral (Manual Return) Request] or another vehicle input configured for Auto-Neutral (Manual Return) functionality. When supported by the vehicle system and transmission manufacturer, this switch allows the operator to prohibit the transmission from responding to temporary Auto-Neutral requests made via SPN 7695 or another designated Auto-Neutral (Manual Return) input.\r\n\r\n00 = Off; transmission will not respond to Auto-Neutral (Manual Return) requests made via SPN 7695 or other\r\ndesignated input.\r\n01 = On; transmission may respond to Auto-Neutral (Manual Return) requests made via SPN 7695 or other\r\ndesignated input.\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7695": {
      "PGN": 256,
      "PGN_Name": "Transmission Control 1",
      "PGN_Description": "TC1",
      "first_bit": 48,
      "SPN": 7695,
      "SPN_Name": "Transmission Auto-Neutral (Manual Return) Request",
      "SPN_Description": "This parameter conveys a vehicle system desire to override the operator’s current shift selector request (e.g. Drive, Reverse) and shift the transmission into Neutral. “Manual Return” indicates this parameter has the ability to initiate a transmission shift to Neutral, but it does not provide any capability for the transmission to automatically return to range after Neutral is achieved, or after the request is revoked. See parameter SPN 7696 for transmission status and response to this request.\r\n\r\nEntry Criteria:\r\nThe transmission shall only respond to this Auto-Neutral request when the shift selector is in a Non-Neutral position. If the vehicle system and transmission both support SPN 7694 [Transmission Auto-Neutral (Manual Return) Enable Switch], the transmission shall only respond to this Auto-Neutral request when SPN 7694 = 01b. When the transmission receives SPN 7695 = 01b, and all other transmission manufacturer-specific criteria are satisfied (e.g. vehicle is stopped), the transmission shall shift to Neutral.\r\n\r\nExit Criteria:\r\nTo exit from the resulting Auto-Neutral state, the vehicle operator must provide shift selector input (i.e. the “Manual Return”) before the vehicle can be driven. The exact shift selector input or sequence required to exit the Auto-Neutral state may be transmission manufacturer specific. In applications where transmission range selection is accomplished through a mechanical linkage, the shift selector will need to be physically moved in order to exit the Auto-Neutral state.\r\n\r\nThe transmission may opt to honor the shift selector input only when this parameter is set to the 00b state, or it may opt to do so for any/all other states. If the shift selector input is honored for states other than 00b, this parameter must return to 00b before the transmission will honor another request to the Auto-Neutral state.\r\n\r\nNote: SPN 683 [Disengage Driveline Request] differs from this parameter in that SPN 683 provides a method to “simply disengage the driveline, e.g., to prevent engine drag torque from causing high wheel slip on slippery surfaces.” SPN 7695 puts the driveline in a Neutral state such that other vehicle activities (e.g. PTO operation) can occur. SPN 7696 provides explicit feedback that Neutral has or has not been achieved in response to SPN 7695.\r\n\r\n00 = No request to shift to Auto-Neutral state\r\n01 = Request to shift to Auto-Neutral state\r\n10 = Reserved\r\n11 = Don’t Care / Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7696": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 51,
      "SPN": 7696,
      "SPN_Name": "Transmission Auto-Neutral (Manual Return) State",
      "SPN_Description": "Indicates the transmission response to a Neutral request from SPN 7695 [Transmission Auto-Neutral (Manual Return) Request] or other vehicle input configured for Auto-Neutral (Manual Return) functionality. The applicability of the states and state transitions depend on transmission manufacturer options and implementation (e.g. function entry and exit criteria) of the Auto-Neutral (Manual Return) function.\r\n\r\nNote: While SPN 523 ETC2 Transmission Current Gear can be used to determine if the transmission has attained a Neutral state; SPN 7696 indicates if that Neutral state resulted from SPN 7695 or another input configured for this functionality.\r\n\r\n000 = No request received; conditions are such that an Auto-Neutral request would be honored.\r\n001 = No request received; conditions are such that an Auto-Neutral request would NOT be honored.\r\n010 = Auto-Neutral request received; shift to Auto-Neutral state is pending.\r\n011 = Auto-Neutral request received; shift to Auto-Neutral state has been achieved.\r\n100 = Auto-Neutral request received; shift to Auto-Neutral state is inhibited.\r\n101 = Reserved\r\n110 = Error\r\n111 = Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7699": {
      "PGN": 64537,
      "PGN_Name": "Payload System Totals 1",
      "PGN_Description": "PLST1",
      "first_bit": 0,
      "SPN": 7699,
      "SPN_Name": "Total Delivered Payload Weight",
      "SPN_Description": "The accumulated delivered payload mass over the life of the product.\r\n\r\nThis should be a monotonically increasing number that sums delivered payload weights (SPN 6849) If transactions are supported (Payload Delivery Transaction Status, SPN 7702) then total delivered payload weight may not be incremented until the transaction is complete in order to account for cancelled or otherwise incomplete transactions.\r\n\r\nIf transactions are not supported, then every delivered payload can be accumulated as the haul cycle completes.",
      "bit_length": 32,
      "scaling": 100,
      "offset": 0,
      "unit": "kg",
      "SLOT_ID": 412
    },
    "7700": {
      "PGN": 64537,
      "PGN_Name": "Payload System Totals 1",
      "PGN_Description": "PLST1",
      "first_bit": 32,
      "SPN": 7700,
      "SPN_Name": "Total Haul Cycle Count",
      "SPN_Description": "The total accumulated number of haul cycles over the life of the product.\r\n\r\nThis should be a monotonically increasing number that sums Haul Cycle Count (SPN 6847). If transactions are supported via Payload Delivery Transaction Status (SPN 7702) then total haul cycle count may not be incremented until the transaction is complete in order to account for cancelled or otherwise incomplete transactions.\r\n\r\nIf transactions are not supported, then every haul cycle count can be accumulated as the haul cycle completes.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "7701": {
      "PGN": 64536,
      "PGN_Name": "Payload System Totals 2",
      "PGN_Description": "PLST2",
      "first_bit": 0,
      "SPN": 7701,
      "SPN_Name": "Total Payload Transaction Count",
      "SPN_Description": "The accumulated number of completed payload delivery transactions over the life of the product.\r\n\r\nIf transaction status monitoring is supported via Payload Delivery Transaction Status (SPN 7702) then total payload transaction count may increment when the transaction status transitions from \"Transaction In Progress\" to \"Transaction Complete\".\r\n\r\nIf transaction status monitoring is not supported then total payload transaction count may be determined by an application specific means.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "7702": {
      "PGN": 64592,
      "PGN_Name": "Payload System Status",
      "PGN_Description": "PLSS",
      "first_bit": 20,
      "SPN": 7702,
      "SPN_Name": "Payload Delivery Transaction Status",
      "SPN_Description": "The current state of the payload delivery transaction.\r\n\r\nWhen a transaction is in progress, a receiving node may monitor Haul Cycle Count (SPN 6847) and Delivered Payload Weight (SPN 6849) in order to track the progress of a transaction, where the haul cycle count represents the number of haul cycles within the transaction and delivered payload weight represents the payload weight delivered within the transaction.\r\n\r\nEach transaction can be comprised of one-to-many haul cycles. Certain equipment may require multiple haul cycles in order to complete a payload transaction. Haul Cycle Count (SPN 6847) and the corresponding Delivered Payload Weight (SPN 6849) may be used in order to determine the number of haul cycles and amount of delivered payload for the active transaction.\r\n\r\nIf transaction status monitoring is available, when the status transitions from \"Transaction In Progress\" to \"Transaction Complete\", the Total Payload Transaction Count (SPN 7701) may increment, accompanied by an increment to the Total Haul Cycle Count (SPN 7700) by the amount represented by Haul Cycle Count (SPN 6847) and and increment to the Total Delivered Payload Weight (SPN 7699) by the amount represented by Delivered Payload Weight (SPN 6849).\r\n\r\n0000 - Transaction Not In Progress\r\n0001 - Transaction In Progress\r\n0010 - Transaction Complete\r\n0011 to 1011 - Reserved for Future Assignment by SAE\r\n1110 - Error\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7703": {
      "PGN": 64535,
      "PGN_Name": "Payload Temperature 1",
      "PGN_Description": "PLT1",
      "first_bit": 0,
      "SPN": 7703,
      "SPN_Name": "Payload Temperature 1",
      "SPN_Description": "Temperature of payload at measurement point 1.\r\n\r\nMeasurement position is manufacturer or regulation specific.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "7704": {
      "PGN": 64535,
      "PGN_Name": "Payload Temperature 1",
      "PGN_Description": "PLT1",
      "first_bit": 16,
      "SPN": 7704,
      "SPN_Name": "Payload Temperature 2",
      "SPN_Description": "Temperature of payload at measurement point 2.\r\n\r\nMeasurement position is manufacturer or regulation specific.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "7705": {
      "PGN": 64535,
      "PGN_Name": "Payload Temperature 1",
      "PGN_Description": "PLT1",
      "first_bit": 32,
      "SPN": 7705,
      "SPN_Name": "Payload Temperature 3",
      "SPN_Description": "Temperature of payload at measurement point 3.\r\n\r\nMeasurement position is manufacturer or regulation specific.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "7706": {
      "PGN": 64535,
      "PGN_Name": "Payload Temperature 1",
      "PGN_Description": "PLT1",
      "first_bit": 48,
      "SPN": 7706,
      "SPN_Name": "Payload Temperature 4",
      "SPN_Description": "Temperature of payload at measurement point 4.\r\n\r\nMeasurement position is manufacturer or regulation specific.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "7707": {
      "PGN": 64534,
      "PGN_Name": "Payload Temperature 2",
      "PGN_Description": "PLT2",
      "first_bit": 0,
      "SPN": 7707,
      "SPN_Name": "Payload Temperature 5",
      "SPN_Description": "Temperature of payload at measurement point 5.\r\n\r\nMeasurement position is manufacturer or regulation specific.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "7708": {
      "PGN": 64558,
      "PGN_Name": "Engine Turbocharger Control 3",
      "PGN_Description": "ETCC3",
      "first_bit": 8,
      "SPN": 7708,
      "SPN_Name": "Engine Turbocharger Compressor Bypass Actuator 1 Motor Current Disable",
      "SPN_Description": "Command to disable power to motor in bypass actuator 1 to prevent unnecessary load on the component.\r\n\r\n00 - Do Not Disable\r\n01 - Disable\r\n10 - Reserved\r\n11 - Don't Care/Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7709": {
      "PGN": 64558,
      "PGN_Name": "Engine Turbocharger Control 3",
      "PGN_Description": "ETCC3",
      "first_bit": 10,
      "SPN": 7709,
      "SPN_Name": "Engine Turbocharger Compressor Bypass Actuator 2 Motor Current Disable",
      "SPN_Description": "Command to disable power to motor in bypass actuator 2 to prevent unnecessary load on the component.\r\n\r\n00 - Do Not Disable\r\n01 - Disable\r\n10 - Reserved\r\n11 - Don't Care/Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7710": {
      "PGN": 64558,
      "PGN_Name": "Engine Turbocharger Control 3",
      "PGN_Description": "ETCC3",
      "first_bit": 12,
      "SPN": 7710,
      "SPN_Name": "Engine Turbocharger Wastegate Actuator 2 Motor Current Disable",
      "SPN_Description": "Command to disable power to motor in wastegate actuator 2 to prevent unnecessary load on the component.\r\n\r\n00 - Do Not Disable\r\n01 - Disable\r\n10 - Reserved\r\n11 - Don't Care/Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7711": {
      "PGN": 64980,
      "PGN_Name": "Cab Message 3",
      "PGN_Description": "CM3",
      "first_bit": 12,
      "SPN": 7711,
      "SPN_Name": "Vehicle Trailer Status",
      "SPN_Description": "Indicates a trailer is connected to the towing mechanism.  This is not intended to indicate that the trailer is latched.\r\n\r\n00 - Trailer is not detected\r\n01 - Trailer is detected\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7712": {
      "PGN": 64533,
      "PGN_Name": "Vehicle Electrical Power 6",
      "PGN_Description": "VEP6",
      "first_bit": 0,
      "SPN": 7712,
      "SPN_Name": "Battery Potential / Power Input 3",
      "SPN_Description": "This parameter measures the third source of battery potential as measured at the input of the ECU/actuator etc. coming from one or more batteries, irrespective of the distance between the component and the battery. This SPN is also used when ECUs are interconnected in a series configuration, where the source of power is coming directly or indirectly from the same battery/batteries.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "7713": {
      "PGN": 64533,
      "PGN_Name": "Vehicle Electrical Power 6",
      "PGN_Description": "VEP6",
      "first_bit": 16,
      "SPN": 7713,
      "SPN_Name": "Battery Potential / Power Input 4",
      "SPN_Description": "This parameter measures the fourth source of battery potential as measured at the input of the ECU/actuator etc. coming from one or more batteries, irrespective of the distance between the component and the battery. This SPN is also used when ECUs are interconnected in a series configuration, where the source of power is coming directly or indirectly from the same battery/batteries.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "7714": {
      "PGN": 64533,
      "PGN_Name": "Vehicle Electrical Power 6",
      "PGN_Description": "VEP6",
      "first_bit": 32,
      "SPN": 7714,
      "SPN_Name": "SLI Battery 3 Net Current",
      "SPN_Description": "Net flow of electrical current into/out of the third battery or third set of batteries used for starting the engine, for lighting, and for ignition (SLI).",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -1600,
      "unit": "A",
      "SLOT_ID": 104
    },
    "7715": {
      "PGN": 64533,
      "PGN_Name": "Vehicle Electrical Power 6",
      "PGN_Description": "VEP6",
      "first_bit": 48,
      "SPN": 7715,
      "SPN_Name": "SLI Battery 4 Net Current",
      "SPN_Description": "Net flow of electrical current into/out of the fourth battery or fourth set of batteries used for starting the engine, for lighting, and for ignition (SLI).",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -1600,
      "unit": "A",
      "SLOT_ID": 104
    },
    "7716": {
      "PGN": 61446,
      "PGN_Name": "Electronic Axle Controller 1",
      "PGN_Description": "EAC1",
      "first_bit": 22,
      "SPN": 7716,
      "SPN_Name": "Differential Lock State - Rear Axle 3",
      "SPN_Description": "State used which indicates the condition of the rear axle 3 differential lock. The differential locks are located as defined in figure SPN 564_A.\r\n\r\n00 - Differential lock disengaged\r\n01 - Differential lock engaged\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7719": {
      "PGN": 64554,
      "PGN_Name": "Operator Inducement Information",
      "PGN_Description": "OII",
      "first_bit": 48,
      "SPN": 7719,
      "SPN_Name": "Operator Inducement Time to Final Inducement Action",
      "SPN_Description": "Indicates the time until the inducement strategy enforces the final level of engine emissions operator inducement. The final level of inducement can include derating the engine, shutting down the engine, or restricting the engine to low idle.\r\n\r\nWhen operator inducement is not active, this parameter will be set to 0xFB00. For systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 000. If SPN 7719 has decremented to 0, it will remain at 0 until the condition that caused it to decrement has been corrected.\r\n\r\nSee also SPNs 7425 and 7428 for other levels of inducement.\r\n\r\nIf the operator inducement has been temporarily overridden, then this parameter will pause and not decrement until the override is removed. For systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 110 - Temporary Override of Inducement.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "min",
      "SLOT_ID": 238
    },
    "7720": {
      "PGN": 64662,
      "PGN_Name": "Engine Information 2",
      "PGN_Description": "EI2",
      "first_bit": 32,
      "SPN": 7720,
      "SPN_Name": "Engine Common Rail Oil Pressure",
      "SPN_Description": "Gage pressure of oil in common rail's lubrication system as provided by oil pump.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "7721": {
      "PGN": 64662,
      "PGN_Name": "Engine Information 2",
      "PGN_Description": "EI2",
      "first_bit": 40,
      "SPN": 7721,
      "SPN_Name": "Engine Common Rail Oil Absolute Pressure",
      "SPN_Description": "Absolute pressure of oil in common rail's lubrication system as provided by oil pump.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "7723": {
      "PGN": 64531,
      "PGN_Name": "Door Latch Status",
      "PGN_Description": "DLS",
      "first_bit": 0,
      "SPN": 7723,
      "SPN_Name": "Left Front Cab Door Latch Position",
      "SPN_Description": "Status of the left front cab door latch (driver door for left-hand steer vehicles). Door latches may have 3 positions indicating fully open, 1st detent or \"ajar\", and 2nd detent or fully closed.\r\n\r\n000 = Door Latch Open\r\n001 = Door Latch Fully Closed/Latched\r\n010 = Door Latch Ajar\r\n011 = Reserved\r\n100 = Reserved\r\n101 = Reserved\r\n110 = Error\r\n111 = Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7724": {
      "PGN": 64531,
      "PGN_Name": "Door Latch Status",
      "PGN_Description": "DLS",
      "first_bit": 8,
      "SPN": 7724,
      "SPN_Name": "Right Front Cab Door Latch Position",
      "SPN_Description": "Status of the right front cab door latch (passenger door for left-hand steer vehicles). Door latches may have 3 positions indicating fully open, 1st detent or \"ajar\", and 2nd detent or fully closed.\r\n\r\n000 = Door Latch Open\r\n001 = Door Latch Fully Closed/Latched\r\n010 = Door Latch Ajar\r\n011 = Reserved\r\n100 = Reserved\r\n101 = Reserved\r\n110 = Error\r\n111 = Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7725": {
      "PGN": 64531,
      "PGN_Name": "Door Latch Status",
      "PGN_Description": "DLS",
      "first_bit": 16,
      "SPN": 7725,
      "SPN_Name": "Left Rear Cab Door Latch Position",
      "SPN_Description": "Status of the left rear cab door latch. Door latches may have 3 positions indicating fully open, 1st detent or \"ajar\", and 2nd detent or fully closed.\r\n\r\n000 = Door Latch Open\r\n001 = Door Latch Fully Closed/Latched\r\n010 = Door Latch Ajar\r\n011 = Reserved\r\n100 = Reserved\r\n101 = Reserved\r\n110 = Error\r\n111 = Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7726": {
      "PGN": 64531,
      "PGN_Name": "Door Latch Status",
      "PGN_Description": "DLS",
      "first_bit": 24,
      "SPN": 7726,
      "SPN_Name": "Right Rear Cab Door Latch Position",
      "SPN_Description": "Status of the right rear cab door latch. Door latches may have 3 positions indicating fully open, 1st detent or \"ajar\", and 2nd detent or fully closed.\r\n\r\n000 = Door Latch Open\r\n001 = Door Latch Fully Closed/Latched\r\n010 = Door Latch Ajar\r\n011 = Reserved\r\n100 = Reserved\r\n101 = Reserved\r\n110 = Error\r\n111 = Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7727": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 0,
      "SPN": 7727,
      "SPN_Name": "Cab Doors Lock Actuation Command",
      "SPN_Description": "Commands cab door latch state change: lock or unlock.\r\n\r\n000 = Unlock left front cab door latch (driver door on LH steer vehicles)\r\n001 = Unlock right front cab door latch (front passenger door for LH steer vehicles)\r\n010 = Unlock left rear cab door latch\r\n011 = Unlock right rear cab door latch\r\n100 = Unlock all cab door latches\r\n101 = Lock all cab door latches\r\n110 = Reserved\r\n111 = Take no action",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7728": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 8,
      "SPN": 7728,
      "SPN_Name": "Remote Cab Door Lock Request",
      "SPN_Description": "Request to the cab door lock controller from Remote Keyless Entry or or other external device to lock or unlock doors.\r\n\r\nThis parameter is different from Cab Doors Lock Actuation Command (SPN 7727) because this is a request to actuate door locks. Based on security or interlocks, a controller can decide to command the latches with the Actuation Command Message.\r\n\r\n000 = Request unlock left front cab door latch (driver door on LH steer vehicles)\r\n001 = Request unlock right front cab door latch (front passenger door for LH steer vehicles)\r\n010 = Request unlock left rear cab door latch\r\n011 = Request unlock right rear cab door latch\r\n100 = Request unlock all cab door latches\r\n101 = Request lock all cab door latches\r\n110 = Reserved\r\n111 = Take no action",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7729": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 16,
      "SPN": 7729,
      "SPN_Name": "Left Front Window Position Command",
      "SPN_Description": "Commands position change of left front window (driver door window on left-hand steer vehicles).\r\n\r\n000 = Window move up\r\n001 = Window move down\r\n010 = Window auto up\r\n011 = Window auto down\r\n100 = Reserved\r\n101 = Reserved\r\n110 = Reserved\r\n111 = Take no action",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7730": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 19,
      "SPN": 7730,
      "SPN_Name": "Right Front Window Position Command",
      "SPN_Description": "Commands position change of right front window (passenger door window on left-hand steer vehicles).\r\n\r\n000 = Window move up\r\n001 = Window move down\r\n010 = Window auto up\r\n011 = Window auto down\r\n100 = Reserved\r\n101 = Reserved\r\n110 = Reserved\r\n111 = Take no action",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7731": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 24,
      "SPN": 7731,
      "SPN_Name": "Left Rear Window Position Command",
      "SPN_Description": "Commands position change of left rear window.\r\n\r\n000 = Window move up\r\n001 = Window move down\r\n010 = Window auto up\r\n011 = Window auto down\r\n100 = Reserved\r\n101 = Reserved\r\n110 = Reserved\r\n111 = Take no action",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7732": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 27,
      "SPN": 7732,
      "SPN_Name": "Right Rear Window Position Command",
      "SPN_Description": "Commands position change of the right rear window.\r\n\r\n000 = Window move up\r\n001 = Window move down\r\n010 = Window auto up\r\n011 = Window auto down\r\n100 = Reserved\r\n101 = Reserved\r\n110 = Reserved\r\n111 = Take no action",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7733": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 32,
      "SPN": 7733,
      "SPN_Name": "Mirror Left 1 Horizontal Command",
      "SPN_Description": "Commands horizontal position change of the primary mirror on the left side (driver side for left-hand steer vehicles).\r\n\r\n00 = Move left\r\n01 = Move right\r\n10 = Reserved\r\n11 = Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7734": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 34,
      "SPN": 7734,
      "SPN_Name": "Mirror Left 1 Vertical Command",
      "SPN_Description": "Commands vertical position change of the primary mirror on the left side (driver side for left-hand steer vehicles).\r\n\r\n00 = Move up\r\n01 = Move down\r\n10 = Reserved\r\n11 = Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7735": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 36,
      "SPN": 7735,
      "SPN_Name": "Mirror Right 1 Horizontal Command",
      "SPN_Description": "Commands horizontal position change of the primary mirror on the right side (passenger side for lefthand steer vehicles).\r\n\r\n00 = Move left\r\n01 = Move right\r\n10 = Reserved\r\n11 = Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7736": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 38,
      "SPN": 7736,
      "SPN_Name": "Mirror Right 1 Vertical Command",
      "SPN_Description": "Commands vertical position change of the primary mirror on the right side (passenger side for lefthand steer vehicles).\r\n\r\n00 = Move up\r\n01 = Move down\r\n10 = Reserved\r\n11 = Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7737": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 40,
      "SPN": 7737,
      "SPN_Name": "Mirror Left 2 Horizontal Command",
      "SPN_Description": "Commands horizontal position change of the second mirror on the left side (driver side for left-hand steer vehicles).\r\n\r\n00 = Move left\r\n01 = Move right\r\n10 = Reserved\r\n11 = Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7738": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 42,
      "SPN": 7738,
      "SPN_Name": "Mirror Left 2 Vertical Command",
      "SPN_Description": "Commands vertical position change of the second mirror on the left side (driver side for left-hand steer vehicles). \r\n\r\n00 = Move up\r\n01 = Move down\r\n10 = Reserved\r\n11 = Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7739": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 44,
      "SPN": 7739,
      "SPN_Name": "Mirror Right 2 Horizontal Command",
      "SPN_Description": "Commands horizontal position change of the second mirror on the right side (passenger side for lefthand steer vehicles).\r\n\r\n00 = Move left\r\n01 = Move right\r\n10 = Reserved\r\n11 = Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7740": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 46,
      "SPN": 7740,
      "SPN_Name": "Mirror Right 2 Vertical Command",
      "SPN_Description": "Commands vertical position change of the second mirror on the right side (passenger side for lefthand steer vehicles).\r\n\r\n00 = Move up\r\n01 = Move down\r\n10 = Reserved\r\n11 = Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7741": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 48,
      "SPN": 7741,
      "SPN_Name": "Mirror Left 1 Heat Command",
      "SPN_Description": "Command to activate heater for primary mirror on the left side (driver side for left-hand steer vehicle).  Mirror heat may be expected to latch in the \"on\" state upon receipt of the command, stay on while the command is \"take no action\" and turn off upon receipt of the \"off\" command.\r\n\r\n00 = Mirror heat off\r\n01 = Mirror heat on\r\n10 = Reserved\r\n11 = Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7742": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 50,
      "SPN": 7742,
      "SPN_Name": "Mirror Right 1 Heat Command",
      "SPN_Description": "Command to activate heater for primary mirror on the right side (passenger side for left-hand steer vehicle).  Mirror heat may be expected to latch in the \"on\" state upon receipt of the command, stay on while the command is \"take no action\" and turn off upon receipt of the \"off\" command.\r\n\r\n00 = Mirror heat off\r\n01 = Mirror heat on\r\n10 = Reserved\r\n11 = Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7743": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 52,
      "SPN": 7743,
      "SPN_Name": "Mirror Left 2 Heat Command",
      "SPN_Description": "Command to activate heater for second mirror on the left side (driver side for left-hand steer vehicle).  Mirror heat may be expected to latch in the \"on\" state upon receipt of the command, stay on while the command is \"take no action\" and turn off upon receipt of the \"off\" command.\r\n\r\n00 = Mirror heat off\r\n01 = Mirror heat on\r\n10 = Reserved\r\n11 = Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7744": {
      "PGN": 64530,
      "PGN_Name": "Cab Door Control",
      "PGN_Description": "CDC",
      "first_bit": 54,
      "SPN": 7744,
      "SPN_Name": "Mirror Right 2 Heat Command",
      "SPN_Description": "Command to activate heater for second mirror on the right side (passenger side for left-hand steer vehicle).  Mirror heat may be expected to latch in the \"on\" state upon receipt of the command, stay on while the command is \"take no action\" and turn off upon receipt of the \"off\" command.\r\n\r\n00 = Mirror heat off\r\n01 = Mirror heat on\r\n10 = Reserved\r\n11 = Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7745": {
      "PGN": 61677,
      "PGN_Name": "Engine Start Control",
      "PGN_Description": "ENGSC",
      "first_bit": 0,
      "SPN": 7745,
      "SPN_Name": "Engine Start Request",
      "SPN_Description": "Indicates the sender’s desire to start the engine. The engine start arbitrator latches this signal and, if possible, completes the engine start regardless of a change of state of this signal. Use Engine Start Abort Request (SPN 7747) to un-latch the start request and cancel an engine start that is in progress.\r\n\r\nThe sender of this signal may increase the broadcast rate temporarily to once every 20 ms during an active request. It may also monitor Engine Start Request Latch Status (SPN 7754) from the arbitrator to determine when the request is latched. Once latched the sender may return to sending 00 – Start not requested.\r\n\r\n00 = Start not requested\r\n01 = Start requested, operator type\r\n10 = Start requested, automatic type\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7746": {
      "PGN": 61677,
      "PGN_Name": "Engine Start Control",
      "PGN_Description": "ENGSC",
      "first_bit": 2,
      "SPN": 7746,
      "SPN_Name": "Engine Start Consent",
      "SPN_Description": "Indicates the sender’s consent to start the engine for different start types. An operator-requested engine start is a start that is initiated directly by the operator (i.e. via the key switch). An automatic engine start is one that is initiated by a vehicle system without direct operator interaction (i.e. as part of engine off at stop operation, etc).\r\n\r\nThis parameter has no error state. In case of an error condition (for example, a switch input state cannot be determined) the consenter is forced to choose one of the valid consent states. The “not available” state is not to be used to indicate an error condition.\r\n\r\nUse Engine Start Abort Request (SPN 7747) to cancel an engine start that is in progress. An Engine Start Consent value of “No Consent” does not abort an ongoing start as the consent signal can only prevent a start before it is initiated.\r\n\r\n000 = No consent\r\n001 = Consent to operator-requested start only\r\n010 = Consent to automatic start only\r\n011 = Consent to both, operator-requested and automatic start\r\n100-110 = Reserved\r\n111 = Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7747": {
      "PGN": 61677,
      "PGN_Name": "Engine Start Control",
      "PGN_Description": "ENGSC",
      "first_bit": 8,
      "SPN": 7747,
      "SPN_Name": "Engine Start Abort Request",
      "SPN_Description": "Indicates the sender’s desire to abort an engine start. This signal is used by requesters and consenters to request that the arbitrator cancel an engine start that is in progress.\r\n\r\nThe sender of this signal may increase the broadcast rate temporarily to once every 20 ms during an active request. It may monitor Engine Start Request Latch Status (SPN 7754) from the arbitrator to determine when the request is un-latched. Once un-latched the sender can return to sending 00 – Abort not requested.\r\n\r\n00 = Abort not requested\r\n01 = Abort requested\r\n10 = Reserved\r\n11 = Don’t care / Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7748": {
      "PGN": 61677,
      "PGN_Name": "Engine Start Control",
      "PGN_Description": "ENGSC",
      "first_bit": 10,
      "SPN": 7748,
      "SPN_Name": "Engine Starter 1 Feedback",
      "SPN_Description": "Feedback of the current state of first engine starter. This signal is intended to be used by the arbitrator as feedback to its command signal (SPN 7753).\r\n\r\nAdditional details regarding the starter state may be available in SPN 1675.\r\n\r\n000 = Starter not commanded\r\n001 = Starter command latched, starter active\r\n010 = Starter command unlatched, start completed (returns to 0 – Starter not commanded after 1000 ms)\r\n011 = Starter command unlatched, start abort command received from arbitrator (returns to 0 – Starter not commanded after 1000 ms)\r\n100 = Starter command unlatched, start aborted by starter controller (returns to 0 – Starter not commanded after 1000 ms).\r\n101-110 = Reserved\r\n111 = Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7749": {
      "PGN": 61677,
      "PGN_Name": "Engine Start Control",
      "PGN_Description": "ENGSC",
      "first_bit": 13,
      "SPN": 7749,
      "SPN_Name": "Engine Starter 2 Feedback",
      "SPN_Description": "Feedback of the current state of second engine starter. This signal is intended to be used by the arbitrator as feedback to its command signal (SPN 7753).\r\n\r\nAdditional details regarding the starter state may be available in SPN 1675.\r\n\r\n000 = Starter not commanded\r\n001 = Starter command latched, starter active\r\n010 = Starter command unlatched, start completed (returns to 0 – Starter not commanded after 1000 ms)\r\n011 = Starter command unlatched, start abort command received from arbitrator (returns to 0 – Starter not commanded after 1000 ms)\r\n100 = Starter command unlatched, start aborted by starter controller (returns to 0 – Starter not commanded after 1000 ms).\r\n101-110 = Reserved\r\n111 = Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7750": {
      "PGN": 61677,
      "PGN_Name": "Engine Start Control",
      "PGN_Description": "ENGSC",
      "first_bit": 52,
      "SPN": 7750,
      "SPN_Name": "Engine Start Control Message Counter",
      "SPN_Description": "Message counter to allow detection of data integrity issues. The counter is incremented every time a device sends out the Engine Start Control message. When the counter has reached a value of 15 it starts over at 0 for the next message cycle. Receiving devices shall treat the message content as invalid when two consecutive messages from the same source address contain non-sequential counter values.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7751": {
      "PGN": 61677,
      "PGN_Name": "Engine Start Control",
      "PGN_Description": "ENGSC",
      "first_bit": 56,
      "SPN": 7751,
      "SPN_Name": "Engine Start Control Checksum",
      "SPN_Description": "Checksum to allow detection of data integrity issues. The receiving node shall calculate the checksum and compare its calculated value with the received checksum. In case of a mismatch the message shall be discarded.\r\n\r\nThe message checksum is calculated using the first 7 data bytes, including the message counter, and the bytes of the message identifier. It is calculated as follows:\r\n\r\nChecksum = (Byte1 + Byte2 + Byte3 + Byte4 + Byte5 + Byte6 + Byte7 + message ID low byte + message ID mid low byte + message ID mid high byte + message ID high byte)",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "7752": {
      "PGN": 61685,
      "PGN_Name": "Engine Start Arbitrator",
      "PGN_Description": "ENGSA",
      "first_bit": 0,
      "SPN": 7752,
      "SPN_Name": "Engine Start Control Message Rate",
      "SPN_Description": "This signal is sent by the arbitrator to control the rate at which other participants send the Engine Start Control Message (ENGSC). The arbitrator sets this signal to the slower rate after the first engine start attempt after initial power-up is completed (either successful or not). After the initial start attempt the arbitrator returns to the faster rate from the time it latches another start request to the time this request is completed (successful or not).\r\n\r\nSenders of the ENGSC message shall broadcast at a rate of once every 20 ms when this signal is not available from the arbitrator, for example during initial system initialization. When this signal is available, senders shall follow the rate instructed by the arbitrator unless the sending device has a need to broadcast at the 20 ms rate, which it may do.\r\n\r\n00 = Once every 20 ms\r\n01 = Once every 250 ms or on change but no faster than 20 ms\r\n10 = Reserved\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7753": {
      "PGN": 61685,
      "PGN_Name": "Engine Start Arbitrator",
      "PGN_Description": "ENGSA",
      "first_bit": 2,
      "SPN": 7753,
      "SPN_Name": "Engine Starter Command",
      "SPN_Description": "Command from the arbitrator to the engine starter controller(s).\r\n\r\nThe arbitrator takes input from consenters and requesters to initiate an engine start. This signal is used by the arbitrator to command the first or second starter instance.\r\n\r\nStarter controllers shall be configured to act as either starter controller 1 or starter controller 2. This assignment is the responsibility of the system integrator.\r\n\r\nEach starter controller shall crank the engine only when this signal is active for that starter instance. The starter controller shall latch the start request signal and crank the engine until the starter controller has determined that either:\r\n\r\n  a) The engine is running \r\n  b) The starter command from the arbitrator indicates “3 – Command withdrawn – abort engine start”\r\n  c) The starter controller has determined that an engine start is not possible due to other considerations (i.e. electrical, thermal, mechanical, etc).\r\n\r\nThe arbitrator shall send “3 – Command withdrawn – abort engine start” to cancel a start that is already in progress. “0 – Command not active” does not cancel an engine start that has already begun.\r\n\r\nBoth starter instances operate on the same engine.\r\n\r\n000 = Command not active\r\n001 = Command active for starter 1\r\n010 = Command active for starter 2\r\n011 = Command withdrawn – abort engine start\r\n100-110 = Reserved\r\n111 = Don’t care / Take no action",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7754": {
      "PGN": 61685,
      "PGN_Name": "Engine Start Arbitrator",
      "PGN_Description": "ENGSA",
      "first_bit": 8,
      "SPN": 7754,
      "SPN_Name": "Engine Start Request Latch Status",
      "SPN_Description": "Indicates the arbitrator’s latch status for engine start requests. All “unlatched” states shall transition to state “0 – Start Request not received” after 1000 ms unless a different state becomes more appropriate in the meantime. While this time may appear long, it is intended to bridge the time it may take a receiving controller to recover from a reset due to a temporary drop of voltage during the crank event.\r\n\r\n0000 = Start request not received - waiting for start request\r\n0001 = Start request latched – waiting for consent (the arbitrator will wait for a manufacturer-defined amount of time before timing out)\r\n0010 = Start request latched – consent confirmed, starter commanded\r\n0011 = Start request unlatched – start completed\r\n0100 = Start request unlatched – consent not established within allowed time\r\n0101 = Start request unlatched – start aborted due to abort request\r\n0110 = Start request unlatched – start could not be completed because the starter command was not successful\r\n0111-1110 = Reserved\r\n1111 = Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7755": {
      "PGN": 61685,
      "PGN_Name": "Engine Start Arbitrator",
      "PGN_Description": "ENGSA",
      "first_bit": 48,
      "SPN": 7755,
      "SPN_Name": "Operator Engine Start Consent Summary",
      "SPN_Description": "Arbitrator’s summary of the consent statuses of all devices which the arbitrator considers for operator start requests. The purpose of this parameter is for requesters to determine if an operator start request would be honored at the current time.\r\n\r\n00 = No consent – At least one participating device does not consent\r\n01 = Consent – All participating devices consent\r\n10 = Error – Consent signal from at least one required consenter is missing\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7756": {
      "PGN": 61685,
      "PGN_Name": "Engine Start Arbitrator",
      "PGN_Description": "ENGSA",
      "first_bit": 50,
      "SPN": 7756,
      "SPN_Name": "Automatic Engine Start Consent Summary",
      "SPN_Description": "Arbitrator’s summary of the consent statuses of all devices which the arbitrator considers for automatic start requests. The purpose of this parameter is for requesters to determine if an automatic start request would be honored at the current time.\r\n\r\n00 = No consent – At least one participating device does not consent\r\n01 = Consent – All participating devices consent\r\n10 = Error – Consent signal from at least one required consenter is missing\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7757": {
      "PGN": 61685,
      "PGN_Name": "Engine Start Arbitrator",
      "PGN_Description": "ENGSA",
      "first_bit": 52,
      "SPN": 7757,
      "SPN_Name": "Engine Start Arbitrator Message Counter",
      "SPN_Description": "Message counter to allow detection of data integrity issues. The counter is incremented every time a device sends out the Engine Start Control message. When the counter has reached a value of 15 it starts over at 0 for the next message cycle. Receiving devices shall treat the message content as invalid when two consecutive messages from the same source address contain non-sequential counter values.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7758": {
      "PGN": 61685,
      "PGN_Name": "Engine Start Arbitrator",
      "PGN_Description": "ENGSA",
      "first_bit": 56,
      "SPN": 7758,
      "SPN_Name": "Engine Start Arbitrator Checksum",
      "SPN_Description": "Checksum to allow detection of data integrity issues. The receiving node shall calculate the checksum and compare its calculated value with the received checksum. In case of a mismatch the message shall be discarded.\r\n\r\nThe message checksum is calculated using the first 7 data bytes, including the message counter, and the bytes of the message identifier. It is calculated as follows:\r\n\r\nChecksum = (Byte1 + Byte2 + Byte3 + Byte4 + Byte5 + Byte6 + Byte7 + message ID low byte + message ID mid low byte + message ID mid high byte + message ID high byte)",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "7759": {
      "PGN": 34048,
      "PGN_Name": "Cab Message 2",
      "PGN_Description": "CM2",
      "first_bit": 26,
      "SPN": 7759,
      "SPN_Name": "Engine Stop-Start Disable Command",
      "SPN_Description": "Engine Stop-Start Disable Command indicates the desire to disable the engine stop-start functionality during propulsion modes. For momentary switches, this parameter does not indicate the state of the switch contacts, but the operator desired state. \r\n\r\nIf defueling requests (SPN 5793) are used, this command is not intended to disable all defueling requests to the engine, but only those related to engine stop-start during vehicle propulsion modes.  For example, defueling due to idle shutdown features or non-propulsion hybrid modes would not be disabled due to this parameter.\r\n\r\nAn example of where this command would be used is on an emergency response vehicle that may want to disable engine stop-start while responding to an emergency.\r\n\r\n00 - Automatic engine stop-start may be allowed\r\n01 - Automatic engine stop-start shall be disabled\r\n10 - Reserved\r\n11 - Don’t care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7760": {
      "PGN": 32256,
      "PGN_Name": "Engine Speed Ramp Rate Boundary Request",
      "PGN_Description": "ESRRBR",
      "first_bit": 0,
      "SPN": 7760,
      "SPN_Name": "Requested Engine Speed Acceleration Rate Limit",
      "SPN_Description": "This parameter is intended to be received by a device sending speed commands to an engine (e.g. TSC1 or proprietary command). The sending device should issue speed commands such that this acceleration rate is not exceeded.\r\n\r\nA value of 0xFB00 indicates no request for an acceleration rate limit.\r\n\r\nFor Example: If acceleration rate limit is 50 RPM/sec, the actual speed acceleration cannot be numerically greater than 50.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "rpm/s",
      "SLOT_ID": 414
    },
    "7761": {
      "PGN": 32256,
      "PGN_Name": "Engine Speed Ramp Rate Boundary Request",
      "PGN_Description": "ESRRBR",
      "first_bit": 16,
      "SPN": 7761,
      "SPN_Name": "Requested Engine Speed Deceleration Rate Limit",
      "SPN_Description": "This parameter is intended to be received by a device sending speed commands to an engine (e.g. TSC1 or proprietary command). The sending device should issue speed commands such that this deceleration rate is not exceeded.\r\n\r\nA value of 0xFB00 indicates no request for a deceleration rate limit.\r\n\r\nFor Example: If deceleration rate limit is 50 RPM/sec, the actual speed deceleration cannot be numerically greater than 50.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "rpm/s",
      "SLOT_ID": 414
    },
    "7770": {
      "PGN": 61689,
      "PGN_Name": "Engine Valve Controller",
      "PGN_Description": "EVC",
      "first_bit": 0,
      "SPN": 7770,
      "SPN_Name": "Engine Valve Control Module 1 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 1 by the manufacturer's software.  When there are multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nEngine Valve Control Module 1 is the first module used to control the valves on the engine.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7771": {
      "PGN": 61689,
      "PGN_Name": "Engine Valve Controller",
      "PGN_Description": "EVC",
      "first_bit": 8,
      "SPN": 7771,
      "SPN_Name": "Engine Valve Control Module 2 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 2 by the manufacturer's software.  When there are multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nEngine Valve Control Module 2 is the second module used to control the valves on the engine.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7772": {
      "PGN": 61689,
      "PGN_Name": "Engine Valve Controller",
      "PGN_Description": "EVC",
      "first_bit": 16,
      "SPN": 7772,
      "SPN_Name": "Engine Valve Control Module 3 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 3 by the manufacturer's software.  When there are multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nEngine Valve Control Module 3 is the third module used to control the valves on the engine.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7773": {
      "PGN": 61689,
      "PGN_Name": "Engine Valve Controller",
      "PGN_Description": "EVC",
      "first_bit": 24,
      "SPN": 7773,
      "SPN_Name": "Engine Valve Control Module 4 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 4 by the manufacturer's software.  When there are multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nEngine Valve Control Module 4 is the fourth module used to control the valves on the engine.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7774": {
      "PGN": 61689,
      "PGN_Name": "Engine Valve Controller",
      "PGN_Description": "EVC",
      "first_bit": 32,
      "SPN": 7774,
      "SPN_Name": "Engine Valve Control Module 5 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 5 by the manufacturer's software.  When there are multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nEngine Valve Control Module 5 is the fifth module used to control the valves on the engine.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7775": {
      "PGN": 61689,
      "PGN_Name": "Engine Valve Controller",
      "PGN_Description": "EVC",
      "first_bit": 40,
      "SPN": 7775,
      "SPN_Name": "Engine Valve Control Module 6 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 6 by the manufacturer's software.  When there are multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nEngine Valve Control Module 6 is the sixth module used to control the valves on the engine.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7776": {
      "PGN": 61689,
      "PGN_Name": "Engine Valve Controller",
      "PGN_Description": "EVC",
      "first_bit": 48,
      "SPN": 7776,
      "SPN_Name": "Engine Valve Control Module 7 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 7 by the manufacturer's software. When there are multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nEngine Valve Control Module 7 is the seventh module used to control the valves on the engine.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7777": {
      "PGN": 61689,
      "PGN_Name": "Engine Valve Controller",
      "PGN_Description": "EVC",
      "first_bit": 56,
      "SPN": 7777,
      "SPN_Name": "Engine Valve Control Module 8 Preliminary FMI",
      "SPN_Description": "Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 8 by the manufacturer's software.  When there are multiple failures, the most severe is transmitted.\r\n\r\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\r\n\r\nEngine Valve Control Module 8 is the eighth module used to control the valves on the engine.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 215
    },
    "7778": {
      "PGN": 65099,
      "PGN_Name": "Transmission Configuration 2",
      "PGN_Description": "TCFG2",
      "first_bit": 16,
      "SPN": 7778,
      "SPN_Name": "Transmission Reference Torque",
      "SPN_Description": "This parameter is the 100% reference value for all defined transmission output torque parameters.  For a given vehicle application, it is only defined once and doesn't change.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Nm",
      "SLOT_ID": 70
    },
    "7779": {
      "PGN": 61690,
      "PGN_Name": "Electronic Transmission Controller 13",
      "PGN_Description": "ETC13",
      "first_bit": 0,
      "SPN": 7779,
      "SPN_Name": "Maximum Forward Transmission Output Shaft Speed",
      "SPN_Description": "Maximum transmission output shaft speed that can be achieved in the forward direction, based on current operating conditions.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "7780": {
      "PGN": 61690,
      "PGN_Name": "Electronic Transmission Controller 13",
      "PGN_Description": "ETC13",
      "first_bit": 16,
      "SPN": 7780,
      "SPN_Name": "Maximum Reverse Transmission Output Shaft Speed",
      "SPN_Description": "Maximum transmission output shaft speed that can be achieved in the reverse direction, based on current operating conditions.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "7781": {
      "PGN": 64528,
      "PGN_Name": "Ambient Conditions 3",
      "PGN_Description": "AMB3",
      "first_bit": 0,
      "SPN": 7781,
      "SPN_Name": "Barometric Absolute Pressure 2",
      "SPN_Description": "Second absolute air pressure measurement of the atmosphere.\r\n\r\nSee SPN 108 or SPN 5685 as the primary barometric pressure measurement.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "7783": {
      "PGN": 61691,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 3",
      "PGN_Description": "A1SCRDSR3",
      "first_bit": 0,
      "SPN": 7783,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Requested Quantity of Integrator (High Resolution)",
      "SPN_Description": "Represents the command for the diesel exhaust fluid quantity integrator in the dosing control unit. See SPN 4350 for alternate resolution.",
      "bit_length": 16,
      "scaling": 0.001,
      "offset": 0,
      "unit": "g",
      "SLOT_ID": 415
    },
    "7784": {
      "PGN": 61692,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Requests 3",
      "PGN_Description": "A2SCRDSR3",
      "first_bit": 0,
      "SPN": 7784,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Requested Quantity of Integrator (High Resolution)",
      "SPN_Description": "Represents the command for the diesel exhaust fluid quantity integrator in the dosing control unit. See SPN 4403 for alternate resolution.",
      "bit_length": 16,
      "scaling": 0.001,
      "offset": 0,
      "unit": "g",
      "SLOT_ID": 415
    },
    "7785": {
      "PGN": 65169,
      "PGN_Name": "Fuel Leakage",
      "PGN_Description": "FL",
      "first_bit": 8,
      "SPN": 7785,
      "SPN_Name": "Engine Fluid Bund Level",
      "SPN_Description": "Ratio of the volume of engine fluid within the bund containment frame to the maximum capacity of the bund containment frame. The bund containment frame is used to contain engine fluid leaks including, but not limited to, engine fuel tank leaks.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7786": {
      "PGN": 61693,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 4",
      "PGN_Description": "A1SCRDSI4",
      "first_bit": 0,
      "SPN": 7786,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Actual Quantity of Integrator (High Resolution)",
      "SPN_Description": "The SCR requested diesel exhaust fluid integrator total quantity for aftertreatment system 1 (exhaust bank 1).  See SPN 4333 for alternate resolution.",
      "bit_length": 16,
      "scaling": 0.001,
      "offset": 0,
      "unit": "g",
      "SLOT_ID": 415
    },
    "7787": {
      "PGN": 61694,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 4",
      "PGN_Description": "A2SCRDSI4",
      "first_bit": 0,
      "SPN": 7787,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Actual Quantity of Integrator (High Resolution)",
      "SPN_Description": "The SCR requested diesel exhaust fluid integrator total quantity for aftertreatment system 2 (exhaust bank 2).  See SPN 4386 for alternate resolution.",
      "bit_length": 16,
      "scaling": 0.001,
      "offset": 0,
      "unit": "g",
      "SLOT_ID": 415
    },
    "7788": {
      "PGN": 61677,
      "PGN_Name": "Engine Start Control",
      "PGN_Description": "ENGSC",
      "first_bit": 5,
      "SPN": 7788,
      "SPN_Name": "Transmission Shift Selector Requested Vehicle Direction",
      "SPN_Description": "This parameter indicates the direction selected by the operator via the active transmission shift selector.\r\n\r\nSome regulations (e.g., Federal Motor Vehicle Safety Standards 102) require specific Engine Stop-Start behavior based on operator selected direction. This parameter provides the necessary direction information for this purpose. Neutral or range commands made by other vehicle functions (e.g., automatic neutral functions) will not be reflected in this parameter.\r\n\r\nFor selectors that use momentary contacts, this parameter would not reflect the current state of the physical contacts, but rather the direction that the operator has selected. Where applicable, it conveys the transmission’s de-bounced interpretation of the selector inputs.\r\n\r\n000 = No direction selected – Park\r\n001 = No direction selected – Neutral\r\n010 = Forward direction selected\r\n011 = Reverse direction selected\r\n100-101 = 4 SAE Reserved\r\n110 = Error\r\n111 = Not supported",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7789": {
      "PGN": 34560,
      "PGN_Name": "Engine State Requests",
      "PGN_Description": "ESR",
      "first_bit": 32,
      "SPN": 7789,
      "SPN_Name": "Engine Fueling Desired Reason",
      "SPN_Description": "This parameter conveys the reason a device wants the engine running.\r\n\r\nThis SPN is intended to be used in conjunction with Desired Engine Fueling State (SPN 5793). When a device sends Desired Engine Fueling State = “Fueling Desired” either alone or in combination with Engine Start Request = “Start requested, automatic type”, then SPN 7789 may be used to convey a reason for why the device desires the engine to run.\r\n\r\nIf more than one reason exists at the same time, the reason with highest importance (as defined by the device sending this parameter) is indicated.\r\n\r\n0 = Desired Engine Fueling State (SPN 5793) from this device does not equal 01\r\n1 = Lubrication distribution in device is incomplete\r\n2 = Engine exhaust is needed as a heat source (i.e. regeneration)\r\n3 = Engine coolant is needed as a heat source\r\n4 = Engine is needed for cooling system operation\r\n5 = Engine is needed for charging the SLI batteries\r\n6 = Engine is needed for charging the hybrid stored energy source\r\n7 = Device protection (no fault condition present) is active\r\n8 = Device preparation for engine shutdown is in progress\r\n9 = Service Override is active\r\n10 = Device has detected one or more fault conditions\r\n11 = Engine is needed for engine driven accessory operation\r\n12 = Engine is needed for PTO operation\r\n13 = Engine is needed for DEF dosing system operation\r\n14 = Engine is needed for DEF dosing system component protection\r\n15 = Engine is needed for DEF dosing system diagnosis\r\n16 = Engine is needed for the Diesel Particulate Filter diagnosis\r\n17 to 249 = SAE Reserved (for future reasons)\r\n250 = Engine operation is needed to perform normal device functions not specifically listed\r\n251 to 254 = SAE Reserved\r\n255 = Not supported",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "7790": {
      "PGN": 61695,
      "PGN_Name": "Secondary or Front Hitch Roll and Pitch",
      "PGN_Description": "SHRP",
      "first_bit": 0,
      "SPN": 7790,
      "SPN_Name": "Front Hitch Roll Angle",
      "SPN_Description": "Measured roll angle of the front three-point hitch expressed in degrees from horizontal alignment with the rear axle of the tractor. Facing the direction of travel, an anti-clockwise rotation would be indicated by a negative number and a clockwise rotation would be indicated by a positive number.",
      "bit_length": 16,
      "scaling": 0.002,
      "offset": -64,
      "unit": "deg",
      "SLOT_ID": 242
    },
    "7791": {
      "PGN": 61695,
      "PGN_Name": "Secondary or Front Hitch Roll and Pitch",
      "PGN_Description": "SHRP",
      "first_bit": 21,
      "SPN": 7791,
      "SPN_Name": "Front Hitch Roll Limit State",
      "SPN_Description": "Used to report the Tractor ECU's present limit status associated with the front hitch roll commands.\r\n\r\n000 = Not limited\r\n001 = Operator limited/controlled (request cannot be implemented)\r\n010 = Limited High (only lower command values result in a change)\r\n011 = Limited Low (only higher command values result in a change)\r\n100 = Reserved\r\n101 = Reserved\r\n110 = Non recoverable fault\r\n111 = Not available (parameter not supported)",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7792": {
      "PGN": 61695,
      "PGN_Name": "Secondary or Front Hitch Roll and Pitch",
      "PGN_Description": "SHRP",
      "first_bit": 24,
      "SPN": 7792,
      "SPN_Name": "Front Hitch Roll Exit/Reason Code",
      "SPN_Description": "Used to indicate why the front hitch cannot accept remote roll commands or has most recently stopped accepting remote commands.\r\n\r\n000000 = No reason/all clear\r\n000001 = Required level of operator presence/awareness not detected\r\n000010 = Implement released control of function\r\n000011 = Operator override of function\r\n000100 = Operator control not in valid position\r\n000101 = Remote command timeout\r\n000110 = Remote command out of range/invalid\r\n000111 = Function not calibrated\r\n001000 = Operator control fault\r\n001001 = Function fault\r\n001010 to 010011 = Reserved\r\n010100 = Hydraulic oil level too low\r\n010101 = Hitch locked out\r\n010110 to 110000 = Reserved\r\n110001 to 111101 = Manufacturer specific\r\n111110 = Error\r\n111111 = Not available (parameter not supported)",
      "bit_length": 6,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 91
    },
    "7793": {
      "PGN": 61695,
      "PGN_Name": "Secondary or Front Hitch Roll and Pitch",
      "PGN_Description": "SHRP",
      "first_bit": 32,
      "SPN": 7793,
      "SPN_Name": "Front Hitch Pitch Angle",
      "SPN_Description": "Measured pitch angle of the front three-point hitch expressed in degrees from vertical alignment of the upper and lower attachment points. Positive is in the anti-clockwise direction when viewed from the left-hand side of the tractor.",
      "bit_length": 16,
      "scaling": 0.002,
      "offset": -64,
      "unit": "deg",
      "SLOT_ID": 242
    },
    "7794": {
      "PGN": 61695,
      "PGN_Name": "Secondary or Front Hitch Roll and Pitch",
      "PGN_Description": "SHRP",
      "first_bit": 53,
      "SPN": 7794,
      "SPN_Name": "Front Hitch Pitch Limit State",
      "SPN_Description": "Used to report the Tractor ECU's present limit status associated with the front hitch pitch commands.\r\n\r\n000 = Not limited\r\n001 = Operator limited/controlled (request cannot be implemented)\r\n010 = Limited High (only lower command values result in a change)\r\n011 = Limited Low (only higher command values result in a change)\r\n100 = Reserved\r\n101 = Reserved\r\n110 = Non recoverable fault\r\n111 = Not available (parameter not supported)",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7795": {
      "PGN": 61695,
      "PGN_Name": "Secondary or Front Hitch Roll and Pitch",
      "PGN_Description": "SHRP",
      "first_bit": 56,
      "SPN": 7795,
      "SPN_Name": "Front Hitch Pitch Exit/Reason Code",
      "SPN_Description": "Used to indicate why the front hitch cannot accept remote pitch commands or has most recently stopped accepting remote commands.\r\n\r\n000000 = No reason/all clear\r\n000001 = Required level of operator presence/awareness not detected\r\n000010 = Implement released control of function\r\n000011 = Operator override of function\r\n000100 = Operator control not in valid position\r\n000101 = Remote command timeout\r\n000110 = Remote command out of range/invalid\r\n000111 = Function not calibrated\r\n001000 = Operator control fault\r\n001001 = Function fault\r\n001010 to 010011 = Reserved\r\n010100 = Hydraulic oil level too low\r\n010101 = Hitch locked out\r\n010110 to 110000 = Reserved\r\n110001 to 111101 = Manufacturer specific\r\n111110 = Error\r\n111111 = Not available (parameter not supported)",
      "bit_length": 6,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 91
    },
    "7796": {
      "PGN": 61696,
      "PGN_Name": "Secondary or Front Hitch Roll and Pitch Command",
      "PGN_Description": "SHRPC",
      "first_bit": 0,
      "SPN": 7796,
      "SPN_Name": "Front Hitch Roll Command",
      "SPN_Description": "Command for setting the roll angle of the front three-point hitch expressed in degrees with 0 being horizontally aligned with the rear axle of the tractor. Facing the direction of travel, an anti-clockwise rotation would be indicated by a negative number and a clockwise rotation would be indicated by a positive number.",
      "bit_length": 16,
      "scaling": 0.002,
      "offset": -64,
      "unit": "deg",
      "SLOT_ID": 242
    },
    "7797": {
      "PGN": 61696,
      "PGN_Name": "Secondary or Front Hitch Roll and Pitch Command",
      "PGN_Description": "SHRPC",
      "first_bit": 16,
      "SPN": 7797,
      "SPN_Name": "Front Hitch Roll Sensitivity Command",
      "SPN_Description": "Command for setting the sensitivity of the front hitch roll control expressed as a percentage of the maximum gain. 0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7798": {
      "PGN": 61696,
      "PGN_Name": "Secondary or Front Hitch Roll and Pitch Command",
      "PGN_Description": "SHRPC",
      "first_bit": 24,
      "SPN": 7798,
      "SPN_Name": "Front Hitch Pitch Command",
      "SPN_Description": "Command for setting the pitch angle of the front three-point hitch expressed in degrees from vertical alignment of the upper and lower attachment points. Positive is in the anti-clockwise direction when viewed from the left-hand side of the tractor.",
      "bit_length": 16,
      "scaling": 0.002,
      "offset": -64,
      "unit": "deg",
      "SLOT_ID": 242
    },
    "7799": {
      "PGN": 61696,
      "PGN_Name": "Secondary or Front Hitch Roll and Pitch Command",
      "PGN_Description": "SHRPC",
      "first_bit": 40,
      "SPN": 7799,
      "SPN_Name": "Front Hitch Pitch Sensitivity Command",
      "SPN_Description": "Command for setting the sensitivity of the front hitch pitch control expressed as a percentage of the maximum gain. 0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7800": {
      "PGN": 64527,
      "PGN_Name": "Secondary or Front Hitch Roll and Pitch Sensitivity",
      "PGN_Description": "SHRPS",
      "first_bit": 0,
      "SPN": 7800,
      "SPN_Name": "Front Hitch Roll Sensitivity",
      "SPN_Description": "The current sensitivity of the front hitch roll control expressed as a percentage of the maximum gain.  0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7801": {
      "PGN": 64527,
      "PGN_Name": "Secondary or Front Hitch Roll and Pitch Sensitivity",
      "PGN_Description": "SHRPS",
      "first_bit": 8,
      "SPN": 7801,
      "SPN_Name": "Front Hitch Pitch Sensitivity",
      "SPN_Description": "The current sensitivity of the front hitch pitch control expressed as a percentage of the maximum gain.  0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7802": {
      "PGN": 61697,
      "PGN_Name": "Primary or Rear Hitch Roll and Pitch",
      "PGN_Description": "PHRP",
      "first_bit": 0,
      "SPN": 7802,
      "SPN_Name": "Rear Hitch Roll Angle",
      "SPN_Description": "Measured roll angle of the rear three-point hitch expressed in degrees from horizontal alignment with the rear axle of the tractor. Facing the direction of travel, an anti-clockwise rotation would be indicated by a negative number and a clockwise rotation would be indicated by a positive number.",
      "bit_length": 16,
      "scaling": 0.002,
      "offset": -64,
      "unit": "deg",
      "SLOT_ID": 242
    },
    "7803": {
      "PGN": 61697,
      "PGN_Name": "Primary or Rear Hitch Roll and Pitch",
      "PGN_Description": "PHRP",
      "first_bit": 21,
      "SPN": 7803,
      "SPN_Name": "Rear Hitch Roll Limit State",
      "SPN_Description": "Used to report the Tractor ECU's present limit status associated with the rear hitch roll commands.\r\n\r\n000 = Not limited\r\n001 = Operator limited/controlled (request cannot be implemented)\r\n010 = Limited High (only lower command values result in a change)\r\n011 = Limited Low (only higher command values result in a change)\r\n100 = Reserved\r\n101 = Reserved\r\n110 = Non recoverable fault\r\n111 = Not available (parameter not supported)",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7804": {
      "PGN": 61697,
      "PGN_Name": "Primary or Rear Hitch Roll and Pitch",
      "PGN_Description": "PHRP",
      "first_bit": 24,
      "SPN": 7804,
      "SPN_Name": "Rear Hitch Roll Exit/Reason Code",
      "SPN_Description": "Used to indicate why the rear hitch cannot accept remote roll commands or has most recently stopped accepting remote commands.\r\n\r\n000000 = No reason/all clear\r\n000001 = Required level of operator presence/awareness not detected\r\n000010 = Implement released control of function\r\n000011 = Operator override of function\r\n000100 = Operator control not in valid position\r\n000101 = Remote command timeout\r\n000110 = Remote command out of range/invalid\r\n000111 = Function not calibrated\r\n001000 = Operator control fault\r\n001001 = Function fault\r\n001010 to 010011 = Reserved\r\n010100 = Hydraulic oil level too low\r\n010101 = Hitch locked out\r\n010110 to 110000 = Reserved\r\n110001 to 111101 = Manufacturer specific\r\n111110 = Error\r\n111111 = Not available (parameter not supported)",
      "bit_length": 6,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 91
    },
    "7805": {
      "PGN": 61697,
      "PGN_Name": "Primary or Rear Hitch Roll and Pitch",
      "PGN_Description": "PHRP",
      "first_bit": 32,
      "SPN": 7805,
      "SPN_Name": "Rear Hitch Pitch Angle",
      "SPN_Description": "Measured pitch angle of the rear three-point hitch expressed in degrees from vertical alignment of the upper and lower attachment points. Positive is in the anti-clockwise direction when viewed from the left-hand side of the tractor.",
      "bit_length": 16,
      "scaling": 0.002,
      "offset": -64,
      "unit": "deg",
      "SLOT_ID": 242
    },
    "7806": {
      "PGN": 61697,
      "PGN_Name": "Primary or Rear Hitch Roll and Pitch",
      "PGN_Description": "PHRP",
      "first_bit": 53,
      "SPN": 7806,
      "SPN_Name": "Rear Hitch Pitch Limit State",
      "SPN_Description": "Used to report the Tractor ECU's present limit status associated with the rear hitch pitch commands.\r\n\r\n000 = Not limited\r\n001 = Operator limited/controlled (request cannot be implemented)\r\n010 = Limited High (only lower command values result in a change)\r\n011 = Limited Low (only higher command values result in a change)\r\n100 = Reserved\r\n101 = Reserved\r\n110 = Non recoverable fault\r\n111 = Not available (parameter not supported)",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7807": {
      "PGN": 61697,
      "PGN_Name": "Primary or Rear Hitch Roll and Pitch",
      "PGN_Description": "PHRP",
      "first_bit": 56,
      "SPN": 7807,
      "SPN_Name": "Rear Hitch Pitch Exit/Reason Code",
      "SPN_Description": "Used to indicate why the rear hitch cannot accept remote pitch commands or has most recently stopped accepting remote commands.\r\n\r\n000000 = No reason/all clear\r\n000001 = Required level of operator presence/awareness not detected\r\n000010 = Implement released control of function\r\n000011 = Operator override of function\r\n000100 = Operator control not in valid position\r\n000101 = Remote command timeout\r\n000110 = Remote command out of range/invalid\r\n000111 = Function not calibrated\r\n001000 = Operator control fault\r\n001001 = Function fault\r\n001010 to 010011 = Reserved\r\n010100 = Hydraulic oil level too low\r\n010101 = Hitch locked out\r\n010110 to 110000 = Reserved\r\n110001 to 111101 = Manufacturer specific\r\n111110 = Error\r\n111111 = Not available (parameter not supported)",
      "bit_length": 6,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 91
    },
    "7808": {
      "PGN": 61698,
      "PGN_Name": "Primary or Rear Hitch Roll and Pitch Command",
      "PGN_Description": "PHRPC",
      "first_bit": 0,
      "SPN": 7808,
      "SPN_Name": "Rear Hitch Roll Command",
      "SPN_Description": "Command for setting the roll angle of the rear three-point hitch expressed in degrees with 0 being horizontally aligned with the rear axle of the tractor. Facing the direction of travel, an anti-clockwise rotation would be indicated by a negative number and a clockwise rotation would be indicated by a positive number.",
      "bit_length": 16,
      "scaling": 0.002,
      "offset": -64,
      "unit": "deg",
      "SLOT_ID": 242
    },
    "7809": {
      "PGN": 61698,
      "PGN_Name": "Primary or Rear Hitch Roll and Pitch Command",
      "PGN_Description": "PHRPC",
      "first_bit": 16,
      "SPN": 7809,
      "SPN_Name": "Rear Hitch Roll Sensitivity Command",
      "SPN_Description": "Command for setting the sensitivity of the rear hitch roll control expressed as a percentage of the maximum gain. 0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7810": {
      "PGN": 61698,
      "PGN_Name": "Primary or Rear Hitch Roll and Pitch Command",
      "PGN_Description": "PHRPC",
      "first_bit": 24,
      "SPN": 7810,
      "SPN_Name": "Rear Hitch Pitch Command",
      "SPN_Description": "Command for setting the pitch angle of the rear three-point hitch expressed in degrees from vertical alignment of the upper and lower attachment points. Positive is in the anti-clockwise direction when viewed from the left-hand side of the tractor.",
      "bit_length": 16,
      "scaling": 0.002,
      "offset": -64,
      "unit": "deg",
      "SLOT_ID": 242
    },
    "7811": {
      "PGN": 61698,
      "PGN_Name": "Primary or Rear Hitch Roll and Pitch Command",
      "PGN_Description": "PHRPC",
      "first_bit": 40,
      "SPN": 7811,
      "SPN_Name": "Rear Hitch Pitch Sensitivity Command",
      "SPN_Description": "Command for setting the sensitivity of the rear hitch pitch control expressed as a percentage of the maximum gain. 0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7812": {
      "PGN": 64526,
      "PGN_Name": "Primary or Rear Hitch Roll and Pitch Sensitivity",
      "PGN_Description": "PHRPS",
      "first_bit": 0,
      "SPN": 7812,
      "SPN_Name": "Rear Hitch Roll Sensitivity",
      "SPN_Description": "The current sensitivity of the rear hitch roll control expressed as a percentage of the maximum gain.  0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7813": {
      "PGN": 64526,
      "PGN_Name": "Primary or Rear Hitch Roll and Pitch Sensitivity",
      "PGN_Description": "PHRPS",
      "first_bit": 8,
      "SPN": 7813,
      "SPN_Name": "Rear Hitch Pitch Sensitivity",
      "SPN_Description": "The current sensitivity of the rear hitch pitch control expressed as a percentage of the maximum gain.  0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7825": {
      "PGN": 64525,
      "PGN_Name": "Fire Pump Statistics 1",
      "PGN_Description": "FPS1",
      "first_bit": 0,
      "SPN": 7825,
      "SPN_Name": "Fire Pump Operation Time",
      "SPN_Description": "Accumulated time that the fire pump is enaged.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "7826": {
      "PGN": 64525,
      "PGN_Name": "Fire Pump Statistics 1",
      "PGN_Description": "FPS1",
      "first_bit": 32,
      "SPN": 7826,
      "SPN_Name": "Fire Pump Engagement Cycles",
      "SPN_Description": "Accumulated number of times the fire pump has been engaged.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "7827": {
      "PGN": 65099,
      "PGN_Name": "Transmission Configuration 2",
      "PGN_Description": "TCFG2",
      "first_bit": 32,
      "SPN": 7827,
      "SPN_Name": "Transmission Communications Failure Idle Torque Limit",
      "SPN_Description": "This parameter is provided to the engine from the transmission as an idle governor torque limit to be invoked by the engine in the event that CAN communication with the transmission is lost.\r\n\r\nThe data is transmitted in indicated torque as a percent of reference engine torque (see the engine configuration message, PGN 65251). The percent torque value will not be less than zero and it includes the torque developed in the cylinders required to overcome friction.\r\n\r\nPlease note that the “Transmission Communications Failure Idle Torque Limit” only applies to the engine’s idle governor. It does not alter the engine's torque map. Full accelerator torque and other similar torque requests are still allowed to access the full torque map.\r\n\r\nIt is recommended that engines use reception of the ETC#1 message as a transmission “heartbeat”.  In the event that the ETC#1 message is not received in a time period of 5 times its’ broadcast rate (5 x 10 ms = 50 ms), the engine should invoke the last received idle torque limit in the current ignition cycle, holding the engine idle torque to less than or equal to the value of the “Transmission Failure Mode Idle Torque Limit” parameter. The engine may release the limit when transmission-to-engine communication is re-established.\r\n\r\nA value of 0xFB indicates that no “Transmission Communications Failure Idle Torque Limit” is currently desired, but the transmission supports the parameter. A value of 0xFF indicates that the “Transmission Communications Failure Idle Torque Limit” is not supported by the transmission.\r\n\r\nIt is expected that the engine will include that last received “Transmission Communications Failure Idle Torque Limit” in the engine configuration PGN-65251 as parameter SPN 7828 “Engine Default Idle Torque Limit”.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "7828": {
      "PGN": 65251,
      "PGN_Name": "Engine Configuration 1",
      "PGN_Description": "EC1",
      "first_bit": 312,
      "SPN": 7828,
      "SPN_Name": "Engine Default Idle Torque Limit",
      "SPN_Description": "Companion parameter to “Transmission Communications Failure Idle Torque Limit” (SPN 7827).  This “echo” parameter provides confirmation to the transmission that the engine has received and will invoke the requested SPN 7827 “Transmission Communications Failure Idle Torque Limit” in the event that CAN communication is lost between the two devices.\r\n\r\nThe data is transmitted in indicated torque as a percent of reference engine torque (see the engine configuration message, PGN 65251). The percent torque value will not be less than zero and it includes the torque developed in the cylinders required to overcome friction.\r\n\r\nPlease note that the “Engine Default Idle Torque Limit” only applies to the Engine’s idle governor. It does not alter the engine's torque map. Full accelerator torque and other similar torque requests are still allowed to access the full torque map.\r\n\r\nIt is recommended that engines use reception of the ETC#1 message as a transmission “heartbeat”. In the event that the ETC#1 message is not received in a time period of 5 times its’ broadcast rate (5 x 10 ms = 50 ms), the engine should invoke the last received idle torque limit in the current ignition cycle, holding the engine idle torque to less than or equal to the value of the “Transmission Communications Failure Idle Torque Limit” parameter. The engine may release the limit when transmission-to-engine communication is re-established.\r\n\r\nIf the engine supports this protection logic, the “Engine Default Idle Torque Limit” parameter should be set equal to the “Transmission Communications Failure Idle Torque Limit” parameter last received in the Transmission Configuration 2 message (PGN 65099). Otherwise, an “Engine Default Idle Torque Limit” value of 0xFB indicates that no “Transmission Communications Failure Idle Torque Limit” has been received or set in this ignition cycle. If the engine does not support this logic, an “Engine Default Idle Torque Limit” value of 0xFF should be set.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "%",
      "SLOT_ID": 45
    },
    "7829": {
      "PGN": 34560,
      "PGN_Name": "Engine State Requests",
      "PGN_Description": "ESR",
      "first_bit": 40,
      "SPN": 7829,
      "SPN_Name": "Transmission Idle Governor Fueling Inhibit",
      "SPN_Description": "This parameter is a command provided to the Engine Control Module (ECM) from the Transmission Control Module (TCM) to inhibit idle governor fueling in the unlikely event that transmission has detected a failure preventing driveline disengagement. This parameter is not intended for engine stop-start functionality or other normal (non-failure mode) operation.\r\n\r\nPlease note that the “Transmission Idle Governor Fueling Inhibit” only applies to the Engine’s idle governor. It does not alter the engine's torque map. Full accelerator pedal torque and other similar torque requests are still allowed to access the full torque map when the \"Transmission Idle Governor Fueling Inhibit\" is active.\r\n \r\n00 - “Transmission Idle Governor Fueling Inhibit” is not currently desired.\r\n01 - Transmission is currently commanding the Engine to inhibit idle governor fueling.\r\n10 - Reserved for future SAE use.\r\n11 - Don't care/take no action.\r\n\r\nIt is expected that the engine will include the “Transmission Idle Governor Fueling Inhibit Support” in the EC2 PGN 64895 as parameter SPN 7830.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7830": {
      "PGN": 64895,
      "PGN_Name": "Engine Configuration 2",
      "PGN_Description": "EC2",
      "first_bit": 32,
      "SPN": 7830,
      "SPN_Name": "Transmission Idle Governor Fueling Inhibit Support",
      "SPN_Description": "Companion parameter to “Transmission Idle Governor Fueling Inhibit” (SPN 7829). This “configuration” parameter provides confirmation to the Transmission that the engine supports the “Transmission Idle Governor Fueling Inhibit” feature.\r\n\r\n00 - Indicates that the engine does not support the “Transmission Idle Governor Fueling Inhibit” feature\r\n01 - Indicates that the engine will respond to a “Transmission Idle Governor Fueling Inhibit” command from the Transmission, should it be received\r\n10 - Reserved for future SAE use\r\n11 - Not supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7831": {
      "PGN": 61699,
      "PGN_Name": "Generator Trip Energy",
      "PGN_Description": "GTRACE",
      "first_bit": 0,
      "SPN": 7831,
      "SPN_Name": "Generator Trip kW Hours Export",
      "SPN_Description": "The total kilowatt-hours that have been exported by the generator since the last reset of the trip kWh meter.\r\n\r\nThis value will be reset by the user at will.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "kWh",
      "SLOT_ID": 150
    },
    "7832": {
      "PGN": 61699,
      "PGN_Name": "Generator Trip Energy",
      "PGN_Description": "GTRACE",
      "first_bit": 32,
      "SPN": 7832,
      "SPN_Name": "Generator Trip kVAr Hours Export",
      "SPN_Description": "The trip AC reactive energy exported by the generstor since the last reset of the trip kVArh meter.\r\n\r\nThis value will be reset by the user at will.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "kVArh",
      "SLOT_ID": 257
    },
    "7833": {
      "PGN": 64524,
      "PGN_Name": "Evaporative Systems",
      "PGN_Description": "EVAP",
      "first_bit": 0,
      "SPN": 7833,
      "SPN_Name": "Canister Vent Valve",
      "SPN_Description": "The state of the canister vent value used to allow fresh air into the charcoal vapor canister.\r\n\r\n00 - Vent Valve is Closed\r\n01 - Vent Valve is Open\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7834": {
      "PGN": 64524,
      "PGN_Name": "Evaporative Systems",
      "PGN_Description": "EVAP",
      "first_bit": 8,
      "SPN": 7834,
      "SPN_Name": "Canister Purge Valve Command",
      "SPN_Description": "The commanded positon of the canister purge valve used to allow fuel vapors from the charcoal canister into the intake manifold.\r\n\r\nA value of 0 % indicates fully closed, a value of 100 % indicates fully open.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7835": {
      "PGN": 64524,
      "PGN_Name": "Evaporative Systems",
      "PGN_Description": "EVAP",
      "first_bit": 16,
      "SPN": 7835,
      "SPN_Name": "Gasoline Fuel Tank Pressure",
      "SPN_Description": "The gage pressure of the vapor in the gasoline fuel tank.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3212.7,
      "unit": "kPa",
      "SLOT_ID": 355
    },
    "7836": {
      "PGN": 64732,
      "PGN_Name": "Cruise Control / Vehicle Speed 3",
      "PGN_Description": "CCVS3",
      "first_bit": 26,
      "SPN": 7836,
      "SPN_Name": "Cruise Control Driver Cancellation Status",
      "SPN_Description": "State signal which indicates that the cruise control is cancelled by driver action.  Driver actions could include switch off, brake pedal activation, clutch pedal actuation, cancel switch, or other reasons determined by the cruise control application.\r\n\r\nThis parameter will be set to 01b if Cruise Control States (SPN 527) goes to 00b (Off/disabled) due to a driver action\r\n\r\nThis parameter will be set to 00b if Cruise Control States (SPN 527) leaves the state 00b (Off/disabled) OR if there are conditions, not initiated by the driver, that also cancelled cruise control. E.g. low vehicle speed.\r\n\r\nInitial state of Cruise control cancelled by driver action after ignition on is 00b.\r\n\r\n00 - Driver action has not cancelled cruise control\r\n01 - Cruise control cancelled by driver action\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7837": {
      "PGN": 64523,
      "PGN_Name": "Electronic Engine Controller 20",
      "PGN_Description": "EEC20",
      "first_bit": 0,
      "SPN": 7837,
      "SPN_Name": "Estimated Engine Parasitic Losses - Percent Torque (High Resolution)",
      "SPN_Description": "Indicates the estimated amount of torque loss due to engine parasitics, such as cooling fan, air compressor, air conditioning, etc. It is expressed as a percent of Engine Reference Torque.   \r\n \r\nIf there are multiple devices on a network that provide this parameter, then users of this data shall add each of these values to determine the total torque loss due to engine parasitics.  Devices that provide this parameter shall use the value of Engine Reference Torque transmitted by the engine during the current key cycle to determine the percent torque loss as seen by the engine. \r\n\r\nSee SPN 2978 for alternate resolution.   If both SPN 2978 and SPN 7837 are supported by a single source address, consumers of the parasitic data should only use one of these values.\r\n\r\nNote:  Refer to section 5.2.1 in SAE J1939-71.",
      "bit_length": 16,
      "scaling": 0.0015625,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 345
    },
    "7840": {
      "PGN": 64913,
      "PGN_Name": "AC Switching Device Status",
      "PGN_Description": "ACS",
      "first_bit": 11,
      "SPN": 7840,
      "SPN_Name": "Engine Speed Governor Mode",
      "SPN_Description": "Indicates the engine speed governor operating mode.\r\n\r\n00 - Isochronous Mode\r\n01 - Droop Mode\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7841": {
      "PGN": 64913,
      "PGN_Name": "AC Switching Device Status",
      "PGN_Description": "ACS",
      "first_bit": 13,
      "SPN": 7841,
      "SPN_Name": "Bus Tie Breaker 1",
      "SPN_Description": "The measured state of first tie breaker on the electrical power bus.\r\n\r\n000 - Open\r\n001 - Closed\r\n010 - Locked Out\r\n011 - Transitioning to Open state\r\n100 - Transitioning to Closed state\r\n101 - Available for SAE assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7842": {
      "PGN": 64913,
      "PGN_Name": "AC Switching Device Status",
      "PGN_Description": "ACS",
      "first_bit": 16,
      "SPN": 7842,
      "SPN_Name": "Bus Tie Breaker 2",
      "SPN_Description": "The measured state of second tie breaker on the electrical power bus.\r\n\r\n000 - Open\r\n001 - Closed\r\n010 - Locked Out\r\n011 - Transitioning to Open state\r\n100 - Transitioning to Closed state\r\n101 - Available for SAE assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7843": {
      "PGN": 64913,
      "PGN_Name": "AC Switching Device Status",
      "PGN_Description": "ACS",
      "first_bit": 19,
      "SPN": 7843,
      "SPN_Name": "Engine Load Group",
      "SPN_Description": "The engine load group for the reporting engine. An Engine Load Group is a set of engines tied together for sharing the electrical power bus load. Load Group assignments are manufacturer specific.",
      "bit_length": 5,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 232
    },
    "7844": {
      "PGN": 3072,
      "PGN_Name": "Electronic Engine Controller 16",
      "PGN_Description": "EEC16",
      "first_bit": 10,
      "SPN": 7844,
      "SPN_Name": "Engine Clutch Engage Request Status",
      "SPN_Description": "Indicates if the engine has an external request to establish its operating conditions to be appropriate for engagement of the transmission or gearbox.\r\n\r\n00 - Engine does not have an external request\r\n01 - Engine has an external request\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7845": {
      "PGN": 64988,
      "PGN_Name": "Marine Control Information",
      "PGN_Description": "MCI",
      "first_bit": 8,
      "SPN": 7845,
      "SPN_Name": "Engine Marine Operating Mode Status",
      "SPN_Description": "The operating mode of the engine for marine functions.\r\n\r\n000 - Maintenance Mode\r\n001 - Electrical Power Generation (EPG) mode\r\n010 - Propulsion Constant Speed Mode\r\n011 - Propulsion Variable Speed Mode\r\n100 to 101 - Reserved\r\n110 - Error\r\n111 - Not available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "7846": {
      "PGN": 61700,
      "PGN_Name": "Engine Speed Sensor Information 2",
      "PGN_Description": "ESSI2",
      "first_bit": 0,
      "SPN": 7846,
      "SPN_Name": "Engine Speed 4",
      "SPN_Description": "The engine speed as measured by speed sensor 4.\r\n\r\nNotes: This is for the engine speed from the 4th engine speed sensor. This may be different than SPN 190 when used in multiple engine speed sensor configurations. In an application with multiple engine speed sensors, SPN 190 data can be derived from any of the speed sensors.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "7847": {
      "PGN": 3072,
      "PGN_Name": "Electronic Engine Controller 16",
      "PGN_Description": "EEC16",
      "first_bit": 8,
      "SPN": 7847,
      "SPN_Name": "Ready For Clutch Engagement Status",
      "SPN_Description": "Indicates the engine operating conditions are appropriate for engagement of the transmission or gearbox clutch.\r\n\r\n00 - Engine Not Ready For Clutch Engagement\r\n01 - Engine is Ready For Clutch Engagement\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7848": {
      "PGN": 64586,
      "PGN_Name": "SCR System Cleaning",
      "PGN_Description": "SCRSC",
      "first_bit": 60,
      "SPN": 7848,
      "SPN_Name": "Aftertreatment 1 SCR System Conditions Not Met for Active Cleaning",
      "SPN_Description": "Indicates that SCR System 1 is not able to begin or continue an active cleaning event at the current engine operating conditions.\r\n\r\n00 - SCR System Cleaning not Inhibited\r\n01 - SCR System Cleaning Inhibited\r\n10 - Reserved for SAE Assignment\r\n11 - Not available\r\n\r\nThis SPN would indicate that the SCR system (bank 1) is not able to begin or continue an active cleaning event due to current engine operating conditions.\r\n\r\nThe conditions on these SPNs are exclusive to the conditions in the PGN 64586.\r\n\r\nExamples of these other conditions are:\r\n  - Engine Speed/Load Conditions not met\r\n  - Engine is a working mode scenario\r\n\r\nSPN 6917 should be set to inhibited when SPN 7848 goes to inhibited status.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7849": {
      "PGN": 64823,
      "PGN_Name": "Aftertreatment 2 SCR Service Information 1",
      "PGN_Description": "A2SCRSI1",
      "first_bit": 40,
      "SPN": 7849,
      "SPN_Name": "Aftertreatment 2 SCR System Sulfation Level",
      "SPN_Description": "Indicates the sulfur level in the SCR system for aftertreatment 2.\r\n\r\n100% level could be the regeneration trigger level (and if conditions are not favorable for regeneration, sulfation loading can continue beyond 100%). During normal operation and regeneration a value 0% will indicate a fully regenerated SCR system. Values of 25%, 50% and 75% will indicate the general level of sulfur prior to the 100% level where regeneration could be needed.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7850": {
      "PGN": 64528,
      "PGN_Name": "Ambient Conditions 3",
      "PGN_Description": "AMB3",
      "first_bit": 16,
      "SPN": 7850,
      "SPN_Name": "Engine Intake 2 Air Temperature",
      "SPN_Description": "Temperature of air entering through a second vehicle air induction system.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7851": {
      "PGN": 33024,
      "PGN_Name": "Aftertreatment System Control",
      "PGN_Description": "AFTSC",
      "first_bit": 8,
      "SPN": 7851,
      "SPN_Name": "Aftertreatment System Enable Status",
      "SPN_Description": "Indicates that the aftertreatment system is enabled or disabled.  Enabled indicates the system will dose at regular intervals.\r\n\r\n00 - Aftertreatment System is Disabled\r\n01 - Aftertreatment System is Enabled\r\n10 - Error\r\n11 - Not available\r\n\r\nNote:  In some marine applications it may be desireable to enable or disable the aftretreatment system.  To disable the system the user will need to get a migratory exemption from EPA 1042.915.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7852": {
      "PGN": 64546,
      "PGN_Name": "Electronic Engine Controller 19",
      "PGN_Description": "EEC19",
      "first_bit": 32,
      "SPN": 7852,
      "SPN_Name": "Engine Exhaust Flow Rate (Extended Range)",
      "SPN_Description": "Engine Exhaust Flow Rate shall indicate the measured/calculated exhaust gas mass flow upstream of the aftertreatment system.\r\n\r\nSee SPN 6895 for alternative range.",
      "bit_length": 32,
      "scaling": 0.001,
      "offset": 0,
      "unit": "kg/h",
      "SLOT_ID": 419
    },
    "7853": {
      "PGN": 64993,
      "PGN_Name": "Cab A/C Climate System Information",
      "PGN_Description": "CACI",
      "first_bit": 8,
      "SPN": 7853,
      "SPN_Name": "Air Conditioner Compressor Status",
      "SPN_Description": "Signal which indicates if the Air Conditioner compressor is on or off.\r\n\r\n00 - Air Conditioner Compressor is OFF\r\n01 - Air Conditioner Compressor is ON\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7855": {
      "PGN": 34560,
      "PGN_Name": "Engine State Requests",
      "PGN_Description": "ESR",
      "first_bit": 48,
      "SPN": 7855,
      "SPN_Name": "Engine Fueling Not Desired Reason",
      "SPN_Description": "This parameter conveys the reason a device wants the engine to inhibit fuelling.\r\n \r\nThis SPN is intended to be used in conjunction with Desired Engine Fueling State (SPN 5793). When a device sends Desired Engine Fueling State = “Fueling Not Desired”, this SPN may be used to convey a reason for why the device desires the engine inhibit fuelling\r\n\r\nIf more than one reason exists at the same time, the reason with highest importance (as defined by the device sending this parameter) is indicated. \r\n \r\n0 = Desired Engine Fueling State (SPN 5793) from this device does not equal 00 \r\n1 = Idle Shutdown Timer has expired\r\n2 = External power source has been connected (shore power)\r\n3 = Body builder - unspecified reason\r\n4 = Engine Stop-Start\r\n5 to 249 = SAE Reserved (for future reasons)\r\n250 = Fueling is not desired due to unspecified reason\r\n251 to 254 = SAE reserved\r\n255 = Not supported",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 93
    },
    "7888": {
      "PGN": 32768,
      "PGN_Name": "Hybrid System Control 1",
      "PGN_Description": "HSC1",
      "first_bit": 8,
      "SPN": 7888,
      "SPN_Name": "Operator Vehicle Mode Request ",
      "SPN_Description": "Operator Vehicle Mode Request is the operator intended vehicle mode.  This parameter can be from only one source on the vehicle.  In the case of a Diesel-Electric Hybrid, the source of this parameter may be a vehicle controller that monitors the operator interface for commands.\r\n\r\nOff is entered following key off.\r\n\r\nLow Voltage Accessory mode is when low voltage accessories may be powered from the SLI battery.  The Stored Energy Source is disconnected.   No propulsion is available in this mode.  In this mode, gear selector requests to exit neutral or park are not honored.\r\n\r\nStored Energy Source Active mode is when both the low voltage accessories and the Stored Energy Source are online.  No propulsion is allowed.  In this mode, gear selector requests to exit neutral or park are not honored.  In a Diesel-Electric hybrid, the high voltage accessories will be available in this mode.\r\n\r\nPropulsion Active mode is when both the low voltage accessories and the Stored Energy Source are online.  Propulsion is allowed.   In this mode, gear selector requests may be honored.  In a Diesel-Electric hybrid, the high voltage accessories will be available in this mode.\r\n\r\n0 - Off\r\n1 - Low Voltage Accessory\r\n2 - Stored Energy Source Active\r\n3 - Propulsion Active\r\n4 to13 - Reserved\r\n14 - Error\r\n15 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7889": {
      "PGN": 32768,
      "PGN_Name": "Hybrid System Control 1",
      "PGN_Description": "HSC1",
      "first_bit": 12,
      "SPN": 7889,
      "SPN_Name": "Hybrid Propulsion Mode Request ",
      "SPN_Description": "Hybrid Propulsion Mode Request is the operator intended propulsion mode.  This parameter can be from only one source on the vehicle.  Response to this request can be found in the Hybrid Propulsion Mode Status (SPN 7896) and Hybrid Propulsion Mode Transition Status (SPN 7897) parameters.  In the case of a Diesel-Electric Hybrid, the source of this parameter may be a vehicle controller that monitors the operator interface for commands.  Vehicle Performance may be reduced using Performance Bias Selection (SPN 6874) in any of these modes.\r\n\r\nStored Energy Source Sustaining: In this mode, normal hybrid operation is desired.  This state is characterized by the Stored Energy Source being online.   In a Diesel-Electric hybrid, this operating mode is characterized as HVES charge sustaining where the energy for the vehicle is supplied by the combination of engine and HVES.  The Stored Energy Source Set Point Request (SPN 7892) may be used to set an operating charge level for the HVES.  Engine stop-start is available in this mode unless specifically disabled, however, engine off is still considered charge sustaining while operating in Engine stop-start.\r\n\r\nStored Energy Source Increasing: In this mode the Stored Energy Source is online and the system is requested to increase the stored energy level to the Stored Energy Source Set Point Request (SPN 7892).   Progress towards the set point can be monitored using the Stored Energy Source Level (SPN 7895) parameter.   When the set point is achieved, the system will hold the set point.  The rate at which energy is increased is set based on the Stored Energy Charge/Discharge Rate Request (SPN 7891).  In a Diesel-Electric Hybrid, this mode would be characterized by the HVES being charged by an onboard engine (fuel cell etc.) or external source.   This may be used to pre-condition the HVES in anticipation of a hybrid Stored Energy Source Only mode of operation.\r\n\r\n \nStore Energy Source Depleting: In this mode the Stored Energy Source is online.  This state prioritizes use of the Stored Energy Source with the intent to reduce the energy stored.  The requested Stored Energy Source Set Point Request (SPN 7892) may be used.   Progress towards the set point can be monitor using the Stored Energy Source Level (SPN 7895).   When the set point is achieved, the system will attempt to hold the set point.  In a Diesel-Electric hybrid, this mode would be characterized by the HVES being discharged in general.  The engine may be operational.\r\n\r\nStored Energy Source Offline: In this mode the Stored Energy Source is offline and is not used as a source of propulsion and/or accessory power.  In a Diesel-Electric hybrid, this mode would be characterized by engine (fuel cell, etc.) only operation.\r\n\r\nStored Energy Source Only: In this mode the Stored Energy Source is online and is the only source of propulsion and/or accessory power.  In a Diesel-Electric hybrid, this mode is characterized as “HVES only” operation.  The engine is not operational.\r\n\r\n0 - No mode requested\r\n1 - Stored Energy Source Sustaining\r\n2 - Stored Energy Source Increasing\r\n3 - Stored Energy Source Depleting\r\n4 - Stored Energy Source Offline\r\n5 - Stored Energy Source Only\r\n6 to 13 - Reserved\r\n14 - Error\r\n15 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7890": {
      "PGN": 32768,
      "PGN_Name": "Hybrid System Control 1",
      "PGN_Description": "HSC1",
      "first_bit": 16,
      "SPN": 7890,
      "SPN_Name": "External Energy Source Connection Demand ",
      "SPN_Description": "External Energy Source Connection Demand indicates how the hybrid system should engage with the external energy source that is temporarily connected to the vehicle.\r\n\r\nThis parameter allows for two external energy source connections.  Propulsion may or may not be allowed as defined by the Operator Vehicle Mode Request (SPN 7888).  The state of the engine (fuel cell etc.) is dictated by the Hybrid Propulsion Mode Request (SPN 7889).  This parameter can be from only one source.  In the case of a Diesel-Electric Hybrid, the source of this parameter may be a vehicle controller or the connected charger.   Status of the connection can be found in the External Energy Source Connection Status (SPN 7898) parameter.\r\n\r\nPerform Connection Verification is requested to connect and ensure a proper connection between an external energy source and the onboard stored energy source.  If the connection is not verified, the External Energy Source Connection Status (SPN 7898) will indicate state 1 Connection – Error (Verification failed).\r\n\r\nEnergy Source and Drain:  An external source of power is connected to the vehicle that may be used to assist the onboard systems in managing the Stored Energy Source level (SPN 7895) to the Stored Energy Source Set Point Request (SPN 7892).  In a Diesel-Electric hybrid, this type of External Energy Source may be energy depleting or increasing from an HVES point of view depending on the operation of the vehicle and controls.  This option may be used in the case of a trolley bus where energy can be sourced from, or drain to, the utility grid.\r\n\r\nEnergy Source: An external source of power is connected to increase stored energy.  In the case of a plug-in hybrid or electric vehicle, this could be the Electric Vehicle Supply Equipment (EVSE) as defined in SAE J1772.  It is intended to increase the state of charge of the HVES.\r\n\r\nEnergy Drain: An external power drain is connected that decreases stored energy.  In the case of a plug-in hybrid, this device will reduce the HVES state of charge.  This device may also be used to drain a capacitor-based stored energy source prior to maintenance.\r\n\r\nDisconnect Request: The external energy device is requesting the hybrid system to disconnect due to a normal shutdown or failure mode.\r\n\r\n0 - No Connection\r\n1 - Perform Connection 1 Verification\r\n2 - Energy Drain or Source Connection 1\r\n3 - Energy Source Connection 1\r\n4 - Energy Drain Connection 1\r\n5 - Perform Connection 2 Verification\r\n6 - Energy Drain or Source Connection 2\r\n7 - Energy Source Connection 2\r\n8 - Energy Drain Connection 2\r\n9 to 13 - Reserved\r\n14 - Disconnect Request\r\n15 - No Request/Take no action",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7891": {
      "PGN": 32768,
      "PGN_Name": "Hybrid System Control 1",
      "PGN_Description": "HSC1",
      "first_bit": 24,
      "SPN": 7891,
      "SPN_Name": "Stored Energy Source Charge/Discharge Rate Request",
      "SPN_Description": "Stored Energy Source Charge/Discharge Rate Request is used to control the rate at which the stored energy is changed in Energy Increasing or Energy Depleting modes.\r\n\r\nA value of 0xFB indicates a request for the default charge/discharge rate.  In a Diesel-Electric Hybrid, it is the percentage of the maximum charging rate allowed by the system.  The system will control the charging rate to its maximum allowed when at 100%.  This parameter provides the ability to charge the HVES at different rates.  If there are multiple sources of this parameter the greatest charge/discharge rate is used.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7892": {
      "PGN": 32768,
      "PGN_Name": "Hybrid System Control 1",
      "PGN_Description": "HSC1",
      "first_bit": 32,
      "SPN": 7892,
      "SPN_Name": "Stored Energy Source Set Point Request ",
      "SPN_Description": "Stored Energy Source Set Point Request is used to set the percentage that the Stored Energy Source should be managed to by the system.\r\n\r\nA value of 0xFB indicates a request for the default set point.  In the case of a Diesel-Electric Hybrid, the percentage (0-100%) is the percentage of HVES capacity available for use. This is a percentage of the useable HVES capacity (i.e., not the actual capacity, or State of Charge).  If there are multiple sources of this parameter the level closest to 100% is used.  Stored Energy Source Level (SPN 7895) provides a status of the actual level versus this set point.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7893": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 26,
      "SPN": 7893,
      "SPN_Name": "Stored Energy Source Only Mode Allowed",
      "SPN_Description": "Stored Energy Source Only Mode Allowed is sent by the Hybrid System controller to indicate when Stored Energy Source Only Mode is available for use and/or allowed to be used.\r\n\r\nIn a Diesel-Electric Hybrid, Stored Energy Source Only mode is characterized as “HVES only” operation.  The engine is not operational.  This parameter may be set to 00b when operating conditions such as high vehicle speeds, low HVES state of charge, or degraded HVES would inhibit use of this mode.\r\n\r\n00 - Mode NOT allowed\r\n01 - Mode allowed\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7894": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 28,
      "SPN": 7894,
      "SPN_Name": "Stored Energy Source Increasing Mode Allowed ",
      "SPN_Description": "Stored Energy Source Increasing Mode Allowed is sent by the Hybrid System controller to indicate when the Stored Energy Source Increasing Mode is available for use and/or allowed to be used.\r\n\r\nIn a Diesel-Electric hybrid, this parameter may be set to 00b when operating conditions such as high vehicle speeds, high HVES state of charge, or degraded HVES would inhibit use of this mode.\r\n\r\n00 - Mode NOT allowed\r\n01 - Mode allowed\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7895": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 32,
      "SPN": 7895,
      "SPN_Name": "Stored Energy Source Level",
      "SPN_Description": "Stored Energy Source Level is sent by the Hybrid System controller to indicate the current operating stored energy source capacity.\r\n\r\nIn a Diesel-Electric Hybrid, this is the current percentage of the HVES useable capacity.  When the state of charge is below the minimum HVES useable capacity, this parameter shall be set to 0 percent.  When the state of charge of the HVES is above the maximum HVES useable capacity, this parameter shall be set to 100%.  When charging the HVES, this parameter may be used to determine the progress towards the Stored Energy Source Set Point Request (SPN 7892). This parameter may also be used as a “fuel level” indicator for the vehicle operator.\r\n\r\nFor example, a HVES manufacturer may define the HVES useable capacity to be between a notional 30% to 70% state of charge (SOC).  In this example, the 0% stored energy level would be the equivalent of 30% or lower SOC and the 100% stored energy source level would be the equivalent of 70% or higher SOC.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "7896": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 40,
      "SPN": 7896,
      "SPN_Name": "Hybrid Propulsion Mode Status ",
      "SPN_Description": "Hybrid Propulsion Mode Status is the current Hybrid System Controller propulsion mode.  This parameter would typically echo the Hybrid Propulsion Mode Request (SPN 7889) assuming the request was honored and the Hybrid System controller successfully transitioned to the requested mode.  See Hybrid Propulsion Mode Request (SPN 7889) for the detailed state definitions.  This parameter will also communicate a change in mode status that occurred due to exceeding operational limits for a mode as reported in Hybrid Propulsion Mode Transition Status (SPN 7897).\r\n\r\n0 - No mode requested\r\n1 - Stored Energy Source Sustaining\r\n2 - Stored Energy Source Increasing\r\n3 - Stored Energy Source Depleting\r\n4 - Stored Energy Source Offline\r\n5 - Stored Energy Source Only\r\n6 to 13 - Reserved\r\n14 - Error\r\n15 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7897": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 44,
      "SPN": 7897,
      "SPN_Name": "Hybrid Propulsion Mode Transition Status ",
      "SPN_Description": "Hybrid Propulsion Mode Transition Status is sent by the Hybrid System controller to indicate the reason for a mode transition occurring or being denied.  This parameter provides confirmation of any mode transition requested via the Hybrid Propulsion Mode Request (SPN 7889) parameter, or conveys why the transition has been denied.\r\n\n0 - No transition requested\r\n1 - Transition requested and in process\r\n2 - Requested mode denied – Requested mode not available\r\n3 - Requested mode denied – Vehicle Speed unacceptable for requested mode\r\n4 - Requested mode denied – HVES State of Charge unacceptable for requested mode\r\n5 - Requested mode denied – Temporary limit exceeded. The temporary limit may be bounded by elapsed time, distance travelled, driving conditions, or something else that the manufacturer has specified.\r\n6 - Requested mode denied – HVES temporary limit threshold exceeded for one or more HVES\r\n7 to 12 -  Reserved\r\n13 - Requested mode denied- reason not specified\r\n14 - Error\r\n15 - Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7898": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 48,
      "SPN": 7898,
      "SPN_Name": "External Energy Source Connection Status ",
      "SPN_Description": "External Energy Source Connection Status provides feedback to the External Energy Source Connection Demand (SPN 7890).  This parameter allows for status of two external energy source connections.  See External Energy Source Connection Demand (SPN 7890) for the detailed state definitions.  In the case of a Diesel-Electric Hybrid, this parameter is sent by the hybrid system or Power System manager.\r\n\r\n\n0 - No Connection\r\n1 - Connection 1 – Error (Verification failed)\r\n2 - Connection 1 – Verification in Process\r\n3 - Connection 1 – Energy Source and Drain\r\n4 - Connection 1 – Energy Source\r\n5 - Connection 1 – Energy Drain\r\n6 - Connection 2 – Error (Verification failed)\r\n7 - Connection 2 – Verification in Process\r\n8 - Connection 2 – Energy Source and Drain\r\n9 - Connection 2 – Energy Source\r\n10 - Connection 2 – Energy Drain\r\n11 to 13 - Reserved\r\n14 - Error\r\n15 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7899": {
      "PGN": 64561,
      "PGN_Name": "Aftertreatment System Information 1",
      "PGN_Description": "ASI1",
      "first_bit": 26,
      "SPN": 7899,
      "SPN_Name": "Diesel Exhaust Fluid Quality Malfunction Evaluation Period Active",
      "SPN_Description": "This parameter is used to notify the operator that a DEF Quality and DEF Level evaluation period, also known as a judgement period, is currently active.\r\n\r\nThe judgement period is required by the Japanese Ministry of Land, Interior, and Transport (JMLIT) when an indirect method is used to judge the quality of the DEF in the DEF tank. The judgement period would be activated only after the operator has filled the DEF to a level as specified in the Japanese legislation. See \"Technical Guideline for Urea Selective Catalytic Reduction System\" (JMLIT Kokijikan No. 91 of August 26, 2008).\r\n\r\n00 - Not active\r\n01 - Active\r\n10 - SAE reserved\r\n11 - Not supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7900": {
      "PGN": 64522,
      "PGN_Name": "Vehicle Electrical Power 7",
      "PGN_Description": "VEP7",
      "first_bit": 0,
      "SPN": 7900,
      "SPN_Name": "SLI Battery Pack 1 Battery 1 Net Current",
      "SPN_Description": "Net flow of electrical current into/out of the first battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). ",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -1600,
      "unit": "A",
      "SLOT_ID": 104
    },
    "7901": {
      "PGN": 64522,
      "PGN_Name": "Vehicle Electrical Power 7",
      "PGN_Description": "VEP7",
      "first_bit": 16,
      "SPN": 7901,
      "SPN_Name": "SLI Battery Pack 1 Battery 1 Temperature",
      "SPN_Description": "Temperature of the first battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \n\nThe relation to physical location is determined by the equipment manufacturer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7902": {
      "PGN": 64522,
      "PGN_Name": "Vehicle Electrical Power 7",
      "PGN_Description": "VEP7",
      "first_bit": 24,
      "SPN": 7902,
      "SPN_Name": "SLI Battery Pack 1 Battery 1 Voltage",
      "SPN_Description": "Voltage of the first battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \n\nThe relation to physical location is determined by the equipment manufacturer.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "7903": {
      "PGN": 64521,
      "PGN_Name": "Vehicle Electrical Power 8",
      "PGN_Description": "VEP8",
      "first_bit": 0,
      "SPN": 7903,
      "SPN_Name": "SLI Battery Pack 1 Battery 1 State of Charge",
      "SPN_Description": "Indicates the remaining charge of the first battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means no charge remaining, 100% means full capacity at the battery's current state of health.\r\n\r\nParameter Specific Indicator: \nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "7904": {
      "PGN": 64521,
      "PGN_Name": "Vehicle Electrical Power 8",
      "PGN_Description": "VEP8",
      "first_bit": 16,
      "SPN": 7904,
      "SPN_Name": "SLI Battery Pack 1 Battery 1 Capacity",
      "SPN_Description": "Original or rated total reserve capacity of the first battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI).",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ah",
      "SLOT_ID": 351
    },
    "7905": {
      "PGN": 64521,
      "PGN_Name": "Vehicle Electrical Power 8",
      "PGN_Description": "VEP8",
      "first_bit": 32,
      "SPN": 7905,
      "SPN_Name": "SLI Battery Pack 1 Battery 1 Health",
      "SPN_Description": "Capacity of the first battery in the first battery pack relative to its original specification for the battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means battery pack is not capable of holding any charge, 100% means battery pack is capable of holding its original full capacity.\r\n\n\nParameter Specific Indicator: \nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "7906": {
      "PGN": 64521,
      "PGN_Name": "Vehicle Electrical Power 8",
      "PGN_Description": "VEP8",
      "first_bit": 40,
      "SPN": 7906,
      "SPN_Name": "SLI Battery Pack 1 Battery 1 Predicted Minimum Cranking Voltage",
      "SPN_Description": "Prediction of the minimum battery voltage of the first battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI) during a crank event, under present battery conditions.\r\n\n\nParameter Specific Indicator: \nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.2,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 409
    },
    "7907": {
      "PGN": 64521,
      "PGN_Name": "Vehicle Electrical Power 8",
      "PGN_Description": "VEP8",
      "first_bit": 48,
      "SPN": 7907,
      "SPN_Name": "SLI Battery Pack 1 Sensor 1 Initialization Status",
      "SPN_Description": "The battery sensor may go through an initialization process when it is first connected to a battery.  This parameter reports the battery sensor's progress through the initialization process.\r\n\r\n0:                          Initialization process has not started. \r\n1 through 9:        Initialization process is in progress.  1 represents the beginning of the process and 9 represents the initialization process is almost complete.  \r\n10:                        Initialization process is complete. \r\n  \r\nThe initialization process is determined by the manufacturer.  This parameter is never expected to change to a lower value as long as the sensor remains connected to the battery.  If the sensor is disconnected from the battery, then the battery sensor's initialization process may be restarted once the sensor is reconnected to the battery. \r\n\r\nManufacturers may not support all 11 steps.  For example, one manufacturer may support 0, 1, & 10.  Another may support 0, 2, 6, 10.\r\n  \r\nNote:  SPNs SPNs 7903, 7905, or 7906 may be equal to 0xFB while this parameter is less than 10.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7908": {
      "PGN": 64520,
      "PGN_Name": "Vehicle Electrical Power 9",
      "PGN_Description": "VEP9",
      "first_bit": 0,
      "SPN": 7908,
      "SPN_Name": "SLI Battery Pack 1 Battery 2 Net Current",
      "SPN_Description": "Net flow of electrical current into/out of the second battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). ",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -1600,
      "unit": "A",
      "SLOT_ID": 104
    },
    "7909": {
      "PGN": 64520,
      "PGN_Name": "Vehicle Electrical Power 9",
      "PGN_Description": "VEP9",
      "first_bit": 16,
      "SPN": 7909,
      "SPN_Name": "SLI Battery Pack 1 Battery 2 Temperature",
      "SPN_Description": "Temperature of the second battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \n\nThe relation to physical location is determined by the equipment manufacturer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7910": {
      "PGN": 64520,
      "PGN_Name": "Vehicle Electrical Power 9",
      "PGN_Description": "VEP9",
      "first_bit": 24,
      "SPN": 7910,
      "SPN_Name": "SLI Battery Pack 1 Battery 2 Voltage",
      "SPN_Description": "Voltage of the second battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \n\nThe relation to physical location is determined by the equipment manufacturer.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "7911": {
      "PGN": 64519,
      "PGN_Name": "Vehicle Electrical Power 10",
      "PGN_Description": "VEP10",
      "first_bit": 0,
      "SPN": 7911,
      "SPN_Name": "SLI Battery Pack 1 Battery 2 State of Charge",
      "SPN_Description": "Indicates the remaining charge of the second battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means no charge remaining, 100% means full capacity at the battery's current state of health.\r\n\n\nParameter Specific Indicator:\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "7912": {
      "PGN": 64519,
      "PGN_Name": "Vehicle Electrical Power 10",
      "PGN_Description": "VEP10",
      "first_bit": 16,
      "SPN": 7912,
      "SPN_Name": "SLI Battery Pack 1 Battery 2 Capacity",
      "SPN_Description": "Original or rated total reserve capacity of the second battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI).",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ah",
      "SLOT_ID": 351
    },
    "7913": {
      "PGN": 64519,
      "PGN_Name": "Vehicle Electrical Power 10",
      "PGN_Description": "VEP10",
      "first_bit": 32,
      "SPN": 7913,
      "SPN_Name": "SLI Battery Pack 1 Battery 2 Health",
      "SPN_Description": "Capacity of the second battery in the first battery pack relative to its original specification for the battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means battery pack is not capable of holding any charge, 100% means battery pack is capable of holding its original full capacity.\r\n\n\nParameter Specific Indicator: \nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "7914": {
      "PGN": 64519,
      "PGN_Name": "Vehicle Electrical Power 10",
      "PGN_Description": "VEP10",
      "first_bit": 40,
      "SPN": 7914,
      "SPN_Name": "SLI Battery Pack 1 Battery 2 Predicted Minimum Cranking Voltage",
      "SPN_Description": "Prediction of the minimum battery voltage of the second battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI) during a crank event, under present battery conditions.\r\n\n\nParameter Specific Indicator: \nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.2,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 409
    },
    "7915": {
      "PGN": 64519,
      "PGN_Name": "Vehicle Electrical Power 10",
      "PGN_Description": "VEP10",
      "first_bit": 48,
      "SPN": 7915,
      "SPN_Name": "SLI Battery Pack 1 Sensor 2 Initialization Status",
      "SPN_Description": "The battery sensor may go through an initialization process when it is first connected to a battery.  This parameter reports the battery sensor's progress through the initialization process.\r\n\r\n0:                          Initialization process has not started. \r\n1 through 9:        Initialization process is in progress.  1 represents the beginning of the process and 9 represents the initialization process is almost complete.  \r\n10:                        Initialization process is complete. \r\n  \r\nThe initialization process is determined by the manufacturer.  This parameter is never expected to change to a lower value as long as the sensor remains connected to the battery.  If the sensor is disconnected from the battery, then the battery sensor's initialization process may be restarted once the sensor is reconnected to the battery. \r\n\r\nManufacturers may not support all 11 steps.  For example, one manufacturer may support 0, 1, & 10.  Another may support 0, 2, 6, 10.\r\n  \r\nNote:  SPNs 7911, 7913, or 7914 may be equal to 0xFB while this parameter is less than 10.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7916": {
      "PGN": 64518,
      "PGN_Name": "Vehicle Electrical Power 11",
      "PGN_Description": "VEP11",
      "first_bit": 0,
      "SPN": 7916,
      "SPN_Name": "SLI Battery Pack 1 Battery 3 Net Current",
      "SPN_Description": "Net flow of electrical current into/out of the third battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). ",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -1600,
      "unit": "A",
      "SLOT_ID": 104
    },
    "7917": {
      "PGN": 64518,
      "PGN_Name": "Vehicle Electrical Power 11",
      "PGN_Description": "VEP11",
      "first_bit": 16,
      "SPN": 7917,
      "SPN_Name": "SLI Battery Pack 1 Battery 3 Temperature",
      "SPN_Description": "Temperature of the third battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \n\nThe relation to physical location is determined by the equipment manufacturer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7918": {
      "PGN": 64518,
      "PGN_Name": "Vehicle Electrical Power 11",
      "PGN_Description": "VEP11",
      "first_bit": 24,
      "SPN": 7918,
      "SPN_Name": "SLI Battery Pack 1 Battery 3 Voltage",
      "SPN_Description": "Voltage of the third battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \n\nThe relation to physical location is determined by the equipment manufacturer.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "7919": {
      "PGN": 64517,
      "PGN_Name": "Vehicle Electrical Power 12",
      "PGN_Description": "VEP12",
      "first_bit": 0,
      "SPN": 7919,
      "SPN_Name": "SLI Battery Pack 1 Battery 3 State of Charge",
      "SPN_Description": "Indicates the remaining charge of the third battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means no charge remaining, 100% means full capacity at the battery's current state of health.\r\n\n\nParameter Specific Indicator: \nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "7920": {
      "PGN": 64517,
      "PGN_Name": "Vehicle Electrical Power 12",
      "PGN_Description": "VEP12",
      "first_bit": 16,
      "SPN": 7920,
      "SPN_Name": "SLI Battery Pack 1 Battery 3 Capacity",
      "SPN_Description": "Original or rated total reserve capacity of the third battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI).",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ah",
      "SLOT_ID": 351
    },
    "7921": {
      "PGN": 64517,
      "PGN_Name": "Vehicle Electrical Power 12",
      "PGN_Description": "VEP12",
      "first_bit": 32,
      "SPN": 7921,
      "SPN_Name": "SLI Battery Pack 1 Battery 3 Health",
      "SPN_Description": "Capacity of the third battery in the first battery pack relative to its original specification for the battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means battery pack is not capable of holding any charge, 100% means battery pack is capable of holding its original full capacity.\r\n\n\nParameter Specific Indicator: \nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "7922": {
      "PGN": 64517,
      "PGN_Name": "Vehicle Electrical Power 12",
      "PGN_Description": "VEP12",
      "first_bit": 40,
      "SPN": 7922,
      "SPN_Name": "SLI Battery Pack 1 Battery 3 Predicted Minimum Cranking Voltage",
      "SPN_Description": "Prediction of the minimum battery voltage of the third battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI) during a crank event, under present battery conditions.\r\n\n\nParameter Specific Indicator: \nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.2,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 409
    },
    "7923": {
      "PGN": 64517,
      "PGN_Name": "Vehicle Electrical Power 12",
      "PGN_Description": "VEP12",
      "first_bit": 48,
      "SPN": 7923,
      "SPN_Name": "SLI Battery Pack 1 Sensor 3 Initialization Status",
      "SPN_Description": "The battery sensor may go through an initialization process when it is first connected to a battery.  This parameter reports the battery sensor's progress through the initialization process.\r\n\r\n0:                          Initialization process has not started. \r\n1 through 9:        Initialization process is in progress.  1 represents the beginning of the process and 9 represents the initialization process is almost complete.  \r\n10:                        Initialization process is complete. \r\n  \r\nThe initialization process is determined by the manufacturer.  This parameter is never expected to change to a lower value as long as the sensor remains connected to the battery.  If the sensor is disconnected from the battery, then the battery sensor's initialization process may be restarted once the sensor is reconnected to the battery. \r\n\r\nManufacturers may not support all 11 steps.  For example, one manufacturer may support 0, 1, & 10.  Another may support 0, 2, 6, 10.\r\n  \r\nNote:  SPNs 7919, 7921, or 7922 may be equal to 0xFB while this parameter is less than 10.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7924": {
      "PGN": 64516,
      "PGN_Name": "Vehicle Electrical Power 13",
      "PGN_Description": "VEP13",
      "first_bit": 0,
      "SPN": 7924,
      "SPN_Name": "SLI Battery Pack 1 Battery 4 Net Current",
      "SPN_Description": "Net flow of electrical current into/out of the fourth battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). ",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -1600,
      "unit": "A",
      "SLOT_ID": 104
    },
    "7925": {
      "PGN": 64516,
      "PGN_Name": "Vehicle Electrical Power 13",
      "PGN_Description": "VEP13",
      "first_bit": 16,
      "SPN": 7925,
      "SPN_Name": "SLI Battery Pack 1 Battery 4 Temperature",
      "SPN_Description": "Temperature of the fourth battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \n\nThe relation to physical location is determined by the equipment manufacturer.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "7926": {
      "PGN": 64516,
      "PGN_Name": "Vehicle Electrical Power 13",
      "PGN_Description": "VEP13",
      "first_bit": 24,
      "SPN": 7926,
      "SPN_Name": "SLI Battery Pack 1 Battery 4 Voltage",
      "SPN_Description": "Voltage of the fourth battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \n\nThe relation to physical location is determined by the equipment manufacturer.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "7927": {
      "PGN": 64515,
      "PGN_Name": "Vehicle Electrical Power 14",
      "PGN_Description": "VEP14",
      "first_bit": 0,
      "SPN": 7927,
      "SPN_Name": "SLI Battery Pack 1 Battery 4 State of Charge",
      "SPN_Description": "Indicates the remaining charge of the fourth battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means no charge remaining, 100% means full capacity at the battery's current state of health.\r\n\n\nParameter Specific Indicator: \nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "7928": {
      "PGN": 64515,
      "PGN_Name": "Vehicle Electrical Power 14",
      "PGN_Description": "VEP14",
      "first_bit": 16,
      "SPN": 7928,
      "SPN_Name": "SLI Battery Pack 1 Battery 4 Capacity",
      "SPN_Description": "Original or rated total reserve capacity of the fourth battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI).",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ah",
      "SLOT_ID": 351
    },
    "7929": {
      "PGN": 64515,
      "PGN_Name": "Vehicle Electrical Power 14",
      "PGN_Description": "VEP14",
      "first_bit": 32,
      "SPN": 7929,
      "SPN_Name": "SLI Battery Pack 1 Battery 4 Health",
      "SPN_Description": "Capacity of the fourth battery in the first battery pack relative to its original specification for the battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means battery pack is not capable of holding any charge, 100% means battery pack is capable of holding its original full capacity.\r\n\n\nParameter Specific Indicator: \nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "7930": {
      "PGN": 64515,
      "PGN_Name": "Vehicle Electrical Power 14",
      "PGN_Description": "VEP14",
      "first_bit": 40,
      "SPN": 7930,
      "SPN_Name": "SLI Battery Pack 1 Battery 4 Predicted Minimum Cranking Voltage",
      "SPN_Description": "Prediction of the minimum battery voltage of the fourth battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI) during a crank event, under present battery conditions.\r\n\n\nParameter Specific Indicator: \nA value of 0xFB indicates conditions are not acceptable for a valid measurement.",
      "bit_length": 8,
      "scaling": 0.2,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 409
    },
    "7931": {
      "PGN": 64515,
      "PGN_Name": "Vehicle Electrical Power 14",
      "PGN_Description": "VEP14",
      "first_bit": 48,
      "SPN": 7931,
      "SPN_Name": "SLI Battery Pack 1 Sensor 4 Initialization Status",
      "SPN_Description": "The battery sensor may go through an initialization process when it is first connected to a battery.  This parameter reports the battery sensor's progress through the initialization process.\r\n\r\n0:                          Initialization process has not started. \r\n1 through 9:        Initialization process is in progress.  1 represents the beginning of the process and 9 represents the initialization process is almost complete.  \r\n10:                        Initialization process is complete. \r\n  \r\nThe initialization process is determined by the manufacturer.  This parameter is never expected to change to a lower value as long as the sensor remains connected to the battery.  If the sensor is disconnected from the battery, then the battery sensor's initialization process may be restarted once the sensor is reconnected to the battery. \r\n\r\nManufacturers may not support all 11 steps.  For example, one manufacturer may support 0, 1, & 10.  Another may support 0, 2, 6, 10.\r\n  \r\nNote:  SPNs 7927, 7929, or 7930 may be equal to 0xFB while this parameter is less than 10.",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7934": {
      "PGN": 64514,
      "PGN_Name": "SCR System Information",
      "PGN_Description": "SCRSI",
      "first_bit": 32,
      "SPN": 7934,
      "SPN_Name": "Aftertreatment 1 SCR System Hydrocarbon",
      "SPN_Description": "The ratio of the mass of hydrocarbon present in the aftertreatment system compared to the maximum allowable mass of hydrocarbon for the aftertreatment system. 100% represents the maximum percentage of hydrocarbon loading that can safely be handled by the aftertreatment system, but hydrocarbon loading can continue beyond 100%.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 46
    },
    "7938": {
      "PGN": 64514,
      "PGN_Name": "SCR System Information",
      "PGN_Description": "SCRSI",
      "first_bit": 0,
      "SPN": 7938,
      "SPN_Name": "Diesel Exhaust Fluid Frozen Time",
      "SPN_Description": "Indicates the amount of time the diesel exhaust fluid is frozen while key switch is on. This will accumulate over the life of the product, and will never be reset.\r\n\r\nThis parameter is not for engine applications that are capable of being derated.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "7939": {
      "PGN": 61701,
      "PGN_Name": "Hydraulic Pressure Displacement",
      "PGN_Description": "HPD",
      "first_bit": 0,
      "SPN": 7939,
      "SPN_Name": "Hydraulic Line Pressure",
      "SPN_Description": "The pressure of the hydraulic fluid, measured in the hydraulic line.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 377
    },
    "7940": {
      "PGN": 61701,
      "PGN_Name": "Hydraulic Pressure Displacement",
      "PGN_Description": "HPD",
      "first_bit": 16,
      "SPN": 7940,
      "SPN_Name": "Mechanical Movement Angle",
      "SPN_Description": "The angle of rotation of the mechanical component.\r\n\r\nThe increase and decrease of the value (i.e. rotation about the X-axis) is in accordance to the right-hand rule, as specified in SAE J670, with the positive X axis directed inward along the center line of the rotating shaft of the sensor.  \r\nThe angle value increases when the sensor shaft is rotated clockwise (as observed facing the rotating shaft toward the sensor) and the angle value decreases when the sensor shaft is rotated counterclockwise. The reported angle will wrap around if the sensor is capable of making more than a single rotation.  When rotating clockwise the angle will go from 359.99 to 0.00, and when rotating counterclockwise the angle will go from 0.00 to 359.99.\r\n\r\nThe 0 degree position is relative to the mounting of the sensor in the system and may require calibration to associate the raw angle to the specific system context.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": 0,
      "unit": "deg",
      "SLOT_ID": 9
    },
    "7941": {
      "PGN": 61441,
      "PGN_Name": "Electronic Brake Controller 1",
      "PGN_Description": "EBC1",
      "first_bit": 56,
      "SPN": 7941,
      "SPN_Name": "Railroad Mode Switch",
      "SPN_Description": "Switch signal which indicates the position of the Railroad mode switch.\r\n\r\n00 - Railroad mode switch passive (City/Highway mode)\r\n01 - Railroad mode switch active (Railroad mode)\r\n10 - Error\r\n11 - Not available\r\n\r\nNote:  This switch signal to be used to inform the ABS/ASR ECU or other ECUs that the vehicle is operating in a railroad mode vs. a normal driving mode. Railroad mode is when a vehicle (i.e. vocational truck) has deployed the railroad gear such that the vehicle can be driven on a railroad track. This switch signal may originate from an operator switch, or within the railroad operation system installed on the vehicle.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7942": {
      "PGN": 64964,
      "PGN_Name": "Electronic Brake Controller 5",
      "PGN_Description": "EBC5",
      "first_bit": 28,
      "SPN": 7942,
      "SPN_Name": "Railroad Mode",
      "SPN_Description": "Signal which indicates the current state of the Railroad Mode / Function.\r\n\r\n00 - Inactive (Driving mode: Steer Axle on ground)\r\n01 - Active (Railroad mode: Steer Axle lifted off ground)\r\n10 - Error\r\n11 - Not available\r\n\r\nNote: This status signal may be used to indicate which mode the ECU (e.g., ASR/ABS) is operating (railroad mode vs. a normal driving mode). Railroad mode is when a vehicle (i.e. vocational truck) has deployed the railroad gear such that the vehicle can be driven on a railroad track.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7943": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 0,
      "SPN": 7943,
      "SPN_Name": "Electrified Accessory Motor Enable Command",
      "SPN_Description": "Enable and direction command to this electrified Accessory Motor.\r\n\r\n00 - Accessory Motor Off\r\n01 - Accessory Motor On Normal/Default Direction\r\n10 - Accessory Motor On Reverse Direction\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7944": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 2,
      "SPN": 7944,
      "SPN_Name": "Electrified Accessory Motor Power Hold",
      "SPN_Description": "Command to allow this Electrified Accessory Motor to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\r\n\r\n00 - Power Hold Disabled\r\n01 - Power Hold Enabled\r\n10 - Reserved\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7945": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 8,
      "SPN": 7945,
      "SPN_Name": "Electrified Accessory Motor Speed Command",
      "SPN_Description": "Speed command to this Electrified Accessory Motor.  Note: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.\r\n\r\nIf both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "7946": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 24,
      "SPN": 7946,
      "SPN_Name": "Electrified Accessory Motor Percent Speed Command",
      "SPN_Description": "Speed command to this Electrified Accessory Motor in percentage of maximum speed.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.\r\n\r\nIf both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "7947": {
      "PGN": 64513,
      "PGN_Name": "Electrified Accessory Motor Status",
      "PGN_Description": "EAMS",
      "first_bit": 0,
      "SPN": 7947,
      "SPN_Name": "Electrified Accessory Motor Enable Status",
      "SPN_Description": "Enable and direction status of this Electrified Accessory Motor system or component.\r\n\r\n00 - Accessory Motor Off\r\n01 - Accessory Motor On - Normal, Forward, or Default Direction\r\n10 - Accessory Motor On - Reverse Direction\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7948": {
      "PGN": 64513,
      "PGN_Name": "Electrified Accessory Motor Status",
      "PGN_Description": "EAMS",
      "first_bit": 2,
      "SPN": 7948,
      "SPN_Name": "Electrified Accessory Motor Controller Status Reason Code",
      "SPN_Description": "Provides the reason code describing the unique failure of this Electrified Accessory Motor system or component.\r\n\r\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Electrified Accessory Motor Service Indicator (SPN 7953) and Electrified Accessory Motor Operating Status (SPN 7954) may be used to determine functional status of this Electrified Accessory motor system or component.\r\n\r\n0000 - Normal Operation\r\n0001 - Unable to Start\r\n0010 - Over-Voltage Protection Shutdown\r\n0011 - Under-Voltage Protection Shutdown\r\n0100 - Over-Temperature Protection Shutdown\r\n0101 - Speed Limited due to current (i.e. amperage) protection limit\r\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\r\n0111 - Speed limited due to torque limit\r\n1000 - Speed limited due to over-temperature protection\r\n1001 - Reserved\r\n1010 - Reserved\r\n1011 - Reserved\r\n1100 - Reserved\r\n1101 - Reserved\r\n1110 - Reserved\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7949": {
      "PGN": 64513,
      "PGN_Name": "Electrified Accessory Motor Status",
      "PGN_Description": "EAMS",
      "first_bit": 6,
      "SPN": 7949,
      "SPN_Name": "Electrified Accessory Motor Controller Command Status",
      "SPN_Description": "Indicates the source of the speed command to this Electrified Accessory Motor system or component.\r\n\r\n00b is communicated when the controller is self-controlled (e.g. based on a temperature sensor).\r\n01b is communicated when responding to the Electrified Accessory Motor Speed Command (SPN 7945) or Electrified Accessory Motor Percent Speed Command (SPN 7946).\r\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\r\n\n00 - Internal Command\r\n01 - External Command\r\n10 - Default Command\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7950": {
      "PGN": 64513,
      "PGN_Name": "Electrified Accessory Motor Status",
      "PGN_Description": "EAMS",
      "first_bit": 8,
      "SPN": 7950,
      "SPN_Name": "Electrified Accessory Motor Speed",
      "SPN_Description": "Speed of this Electrified Accessory Motor. ",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "7951": {
      "PGN": 64513,
      "PGN_Name": "Electrified Accessory Motor Status",
      "PGN_Description": "EAMS",
      "first_bit": 24,
      "SPN": 7951,
      "SPN_Name": "Electrified Accessory Motor Medium Temperature",
      "SPN_Description": "A temperature measured and reported by the device.  It may be used for direct or remote (e.g. by another controller) control of the pump.  For example, this may be the temperature of the fluid flowing through the pump, or some other temperature relating to the pump or controller. ",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "7952": {
      "PGN": 64513,
      "PGN_Name": "Electrified Accessory Motor Status",
      "PGN_Description": "EAMS",
      "first_bit": 40,
      "SPN": 7952,
      "SPN_Name": "Electrified Accessory Motor Power",
      "SPN_Description": "Calculated electrical power consumed by this Electrified Accessory Motor.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "W",
      "SLOT_ID": 305
    },
    "7953": {
      "PGN": 64513,
      "PGN_Name": "Electrified Accessory Motor Status",
      "PGN_Description": "EAMS",
      "first_bit": 56,
      "SPN": 7953,
      "SPN_Name": "Electrified Accessory Motor Service Indicator",
      "SPN_Description": "Indicates that service is required for this Electrified Accessory Motor system or component.  An active indication may convey a need for component replacement or periodic service.  The Electrified Accessory Motor Controller Status Reason Code (SPN 7948) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Service Not Required\r\n01 - Service Required\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7954": {
      "PGN": 64513,
      "PGN_Name": "Electrified Accessory Motor Status",
      "PGN_Description": "EAMS",
      "first_bit": 58,
      "SPN": 7954,
      "SPN_Name": "Electrified Accessory Motor Operating Status",
      "SPN_Description": "Indicates the operating status of this Electrified Accessory Motor system or component.  This parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow of the medium (e.g. coolant, oil, air, etc.) can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.\r\n\r\nThe Electrified Accessory Motor Controller Status Reason Code (SPN 7949) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Normal Operation\r\n01 - Derated Operation\r\n10 - Not Operable\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7967": {
      "PGN": 31488,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Pump Command",
      "PGN_Description": "EAPECPC",
      "first_bit": 0,
      "SPN": 7967,
      "SPN_Name": "Power Electronics Coolant Pump Enable Command",
      "SPN_Description": "Enable and direction command to the Power Electonics Coolant Pump.\r\n\r\n00 - Accessory Motor Off\r\n01 - Accessory Motor On Normal/Default Direction\r\n10 - Accessory Motor On Reverse Direction\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7968": {
      "PGN": 31488,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Pump Command",
      "PGN_Description": "EAPECPC",
      "first_bit": 2,
      "SPN": 7968,
      "SPN_Name": "Power Electronics Coolant Pump Power Hold",
      "SPN_Description": "Command to allow the Power Electronics Coolant Pump to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\r\n\r\n00 - Power Hold Disabled\r\n01 - Power Hold Enabled\r\n10 - Reserved\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7969": {
      "PGN": 31488,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Pump Command",
      "PGN_Description": "EAPECPC",
      "first_bit": 8,
      "SPN": 7969,
      "SPN_Name": "Power Electronics Coolant Pump Speed Command",
      "SPN_Description": "Speed command to the Power Electronics Coolant Pump.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "7970": {
      "PGN": 31488,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Pump Command",
      "PGN_Description": "EAPECPC",
      "first_bit": 24,
      "SPN": 7970,
      "SPN_Name": "Power Electronics Coolant Pump Percent Speed Command",
      "SPN_Description": "Speed command to the Power Electronics Coolant Pump in percentage of maximum speed.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "7971": {
      "PGN": 64511,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Pump Status",
      "PGN_Description": "EAPECPS",
      "first_bit": 0,
      "SPN": 7971,
      "SPN_Name": "Power Electronics Coolant Pump Enable Status",
      "SPN_Description": "Enable and direction status of the Power Electronics Coolant Pump system or component.\r\n\r\n00 - Accessory Motor Off\r\n01 - Accessory Motor On - Normal, Forward, or Default Direction\r\n10 - Accessory Motor On - Reverse Direction\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7972": {
      "PGN": 64511,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Pump Status",
      "PGN_Description": "EAPECPS",
      "first_bit": 2,
      "SPN": 7972,
      "SPN_Name": "Power Electronics Coolant Pump Controller Status Reason Code",
      "SPN_Description": "Provides the reason code describing the unique failure of the Power Electronics Coolant Pump system or component.\r\n\r\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Power Electronics Coolant Pump Service Indicator (SPN 7977) and Power Electronics Coolant Pump Operating Status (SPN 7978) may be used to determine functional status of the Power Electronics Coolant Pump system or component.\r\n\r\n0000 - Normal Operation\r\n0001 - Unable to Start\r\n0010 - Over-Voltage Protection Shutdown\r\n0011 - Under-Voltage Protection Shutdown\r\n0100 - Over-Temperature Protection Shutdown\r\n0101 - Speed Limited due to current (i.e. amperage) protection limit\r\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\r\n0111 - Speed limited due to torque limit\r\n1000 - Speed limited due to over-temperature protection\r\n1001 - Reserved\r\n1010 - Reserved\r\n1011 - Reserved\r\n1100 - Reserved\r\n1101 - Reserved\r\n1110 - Reserved\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7973": {
      "PGN": 64511,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Pump Status",
      "PGN_Description": "EAPECPS",
      "first_bit": 6,
      "SPN": 7973,
      "SPN_Name": "Power Electronics Coolant Pump Controller Command Status",
      "SPN_Description": "Indicates the source of the speed command to the Power Electronics Coolant Pump system or component.\r\n\r\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\r\n01b is communicated when responding to the Power Electronics Coolant Pump Speed Command (SPN 7969) or Power Electronics Coolant Pump Percent Speed Command (SPN 7970).\r\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\r\n\r\n00 - Internal Command\r\n01 - External Command\r\n10 - Default Command\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7974": {
      "PGN": 64511,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Pump Status",
      "PGN_Description": "EAPECPS",
      "first_bit": 8,
      "SPN": 7974,
      "SPN_Name": "Power Electronics Coolant Pump Motor Speed",
      "SPN_Description": "Motor Speed of the Power Electronics Coolant Pump. ",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "7975": {
      "PGN": 64511,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Pump Status",
      "PGN_Description": "EAPECPS",
      "first_bit": 24,
      "SPN": 7975,
      "SPN_Name": "Power Electronics Coolant Pump Control Temperature",
      "SPN_Description": "A temperature measured and reported by the device.  It may be used for direct or remote (e.g. by another controller) control of the pump.  For example, this may be the temperature of the fluid flowing through the pump, or some other temperature relating to the pump or controller. ",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "7976": {
      "PGN": 64511,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Pump Status",
      "PGN_Description": "EAPECPS",
      "first_bit": 40,
      "SPN": 7976,
      "SPN_Name": "Power Electronics Coolant Pump Power",
      "SPN_Description": "Calculated electrical power consumed by the Power Electronics Coolant Pump.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "W",
      "SLOT_ID": 305
    },
    "7977": {
      "PGN": 64511,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Pump Status",
      "PGN_Description": "EAPECPS",
      "first_bit": 56,
      "SPN": 7977,
      "SPN_Name": "Power Electronics Coolant Pump Service Indicator",
      "SPN_Description": "Indicates that service is required for the Power Electronics Coolant Pump system or component.\r\n\r\nAn active indication may convey a need for component replacement or periodic service.  The Power Electronics Coolant Pump Controller Status Reason Code (SPN 7972) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Service Not Required\r\n01 - Service Required\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7978": {
      "PGN": 64511,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Pump Status",
      "PGN_Description": "EAPECPS",
      "first_bit": 58,
      "SPN": 7978,
      "SPN_Name": "Power Electronics Coolant Pump Operating Status",
      "SPN_Description": "Indicates the operating status of the Power Electronics Coolant Pump system or component.\r\n\r\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Power Electronics Coolant Pump Controller Status Reason Code (SPN 7972) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Normal Operation\r\n01 - Derated Operation\r\n10 - Not Operable\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7979": {
      "PGN": 31232,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Pump Command",
      "PGN_Description": "EAPMCPC",
      "first_bit": 0,
      "SPN": 7979,
      "SPN_Name": "Propulsion Motor Coolant Pump Enable Command",
      "SPN_Description": "Enable and direction command to the Propulsion Motor Coolant Pump.\r\n\r\n00 - Accessory Motor Off\r\n01 - Accessory Motor On Normal/Default Direction\r\n10 - Accessory Motor On Reverse Direction\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7980": {
      "PGN": 31232,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Pump Command",
      "PGN_Description": "EAPMCPC",
      "first_bit": 2,
      "SPN": 7980,
      "SPN_Name": "Propulsion Motor Coolant Pump Power Hold",
      "SPN_Description": "Command to allow the Propulsion Motor Coolant Pump to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\r\n\r\n00 - Power Hold Disabled\r\n01 - Power Hold Enabled\r\n10 - Reserved\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7981": {
      "PGN": 31232,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Pump Command",
      "PGN_Description": "EAPMCPC",
      "first_bit": 8,
      "SPN": 7981,
      "SPN_Name": "Propulsion Motor Coolant Pump Speed Command",
      "SPN_Description": "Speed command to the Propulsion Motor Coolant Pump. \r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "7982": {
      "PGN": 31232,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Pump Command",
      "PGN_Description": "EAPMCPC",
      "first_bit": 24,
      "SPN": 7982,
      "SPN_Name": "Propulsion Motor Coolant Pump Percent Speed Command",
      "SPN_Description": "Speed command to the Propulsion Motor Coolant Pump in percentage of maximum speed.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "7983": {
      "PGN": 64510,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Pump Status",
      "PGN_Description": "EAPMCPS",
      "first_bit": 0,
      "SPN": 7983,
      "SPN_Name": "Propulsion Motor Coolant Pump Enable Status",
      "SPN_Description": "Enable and direction status of the Propulsion Motor Coolant Pump system or component.\r\n\r\n00 - Accessory Motor Off\r\n01 - Accessory Motor On - Normal, Forward, or Default Direction\r\n10 - Accessory Motor On - Reverse Direction\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7984": {
      "PGN": 64510,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Pump Status",
      "PGN_Description": "EAPMCPS",
      "first_bit": 2,
      "SPN": 7984,
      "SPN_Name": "Propulsion Motor Coolant Pump Controller Status Reason Code",
      "SPN_Description": "Provides the reason code describing the unique failure of the Propulsion Motor Coolant Pump system or component.\r\n\r\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Propulsion Motor Coolant Pump Service Indicator (SPN 7989) and Propulsion Motor Coolant Pump Operating Status (SPN 7990) may be used to determine functional status of the Propulsion Motor Coolant Pump system or component.\r\n\r\n0000 - Normal Operation\r\n0001 - Unable to Start\r\n0010 - Over-Voltage Protection Shutdown\r\n0011 - Under-Voltage Protection Shutdown\r\n0100 - Over-Temperature Protection Shutdown\r\n0101 - Speed Limited due to current (i.e. amperage) protection limit\r\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\r\n0111 - Speed limited due to torque limit\r\n1000 - Speed limited due to over-temperature protection\r\n1001 - Reserved\r\n1010 - Reserved\r\n1011 - Reserved\r\n1100 - Reserved\r\n1101 - Reserved\r\n1110 - Reserved\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7985": {
      "PGN": 64510,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Pump Status",
      "PGN_Description": "EAPMCPS",
      "first_bit": 6,
      "SPN": 7985,
      "SPN_Name": "Propulsion Motor Coolant Pump Controller Command Status",
      "SPN_Description": "Indicates the source of the speed command to the Propulsion Motor Coolant Pump system or component.\r\n\r\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\r\n01b is communicated when responding to the Propulsion Motor Coolant Pump Speed Command (SPN 7981) or Propulsion Motor Coolant Pump Percent Speed Command (SPN 7982).\r\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\r\n\r\n00 - Internal Command\r\n01 - External Command\r\n10 - Default Command\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7986": {
      "PGN": 64510,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Pump Status",
      "PGN_Description": "EAPMCPS",
      "first_bit": 8,
      "SPN": 7986,
      "SPN_Name": "Propulsion Motor Coolant Pump Motor Speed",
      "SPN_Description": "Motor Speed of the Propulsion Motor Coolant Pump. ",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "7987": {
      "PGN": 64510,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Pump Status",
      "PGN_Description": "EAPMCPS",
      "first_bit": 24,
      "SPN": 7987,
      "SPN_Name": "Propulsion Motor Coolant Pump Control Temperature",
      "SPN_Description": "A temperature measured and reported by the device.  It may be used for direct or remote (e.g. by another controller) control of the pump.  For example, this may be the temperature of the fluid flowing through the pump, or some other temperature relating to the pump or controller. ",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "7988": {
      "PGN": 64510,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Pump Status",
      "PGN_Description": "EAPMCPS",
      "first_bit": 40,
      "SPN": 7988,
      "SPN_Name": "Propulsion Motor Coolant Pump Power",
      "SPN_Description": "Calculated electrical power consumed by the Propulsion Motor Coolant Pump.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "W",
      "SLOT_ID": 305
    },
    "7989": {
      "PGN": 64510,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Pump Status",
      "PGN_Description": "EAPMCPS",
      "first_bit": 56,
      "SPN": 7989,
      "SPN_Name": "Propulsion Motor Coolant Pump Service Indicator",
      "SPN_Description": "Indicates that service is required for the Propulsion Motor Coolant Pump system or component.\r\n\r\nAn active indication may convey a need for component replacement or periodic service.  The Propulsion Motor Coolant Pump Controller Status Reason Code (SPN 7984) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Service Not Required\r\n01 - Service Required\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7990": {
      "PGN": 64510,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Pump Status",
      "PGN_Description": "EAPMCPS",
      "first_bit": 58,
      "SPN": 7990,
      "SPN_Name": "Propulsion Motor Coolant Pump Operating Status",
      "SPN_Description": "Indicates the operating status of the Propulsion Motor Coolant Pump system or component.\r\n\r\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Propulsion Motor Coolant Pump Controller Status Reason Code (SPN 7984) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Normal Operation\r\n01 - Derated Operation\r\n10 - Not Operable\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7991": {
      "PGN": 30976,
      "PGN_Name": "Electrified Accessory Propulsion Motor Oil Pump Command",
      "PGN_Description": "EAPMOPC",
      "first_bit": 0,
      "SPN": 7991,
      "SPN_Name": "Propulsion Motor Oil Pump Enable Command",
      "SPN_Description": "Enable and direction command to the Propulsion Motor Oil Pump.\r\n\n00 - Accessory Motor Off\r\n01 - Accessory Motor On Normal/Default Direction\r\n10 - Accessory Motor On Reverse Direction\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7992": {
      "PGN": 30976,
      "PGN_Name": "Electrified Accessory Propulsion Motor Oil Pump Command",
      "PGN_Description": "EAPMOPC",
      "first_bit": 2,
      "SPN": 7992,
      "SPN_Name": "Propulsion Motor Oil Pump Power Hold",
      "SPN_Description": "Command to allow the Propulsion Motor Oil Pump to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\r\n\r\n00 - Power Hold Disabled\r\n01 - Power Hold Enabled\r\n10 - Reserved\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7993": {
      "PGN": 30976,
      "PGN_Name": "Electrified Accessory Propulsion Motor Oil Pump Command",
      "PGN_Description": "EAPMOPC",
      "first_bit": 8,
      "SPN": 7993,
      "SPN_Name": "Propulsion Motor Oil Pump Speed Command",
      "SPN_Description": "Speed command to the Propulsion Motor Oil Pump. \r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "7994": {
      "PGN": 30976,
      "PGN_Name": "Electrified Accessory Propulsion Motor Oil Pump Command",
      "PGN_Description": "EAPMOPC",
      "first_bit": 24,
      "SPN": 7994,
      "SPN_Name": "Propulsion Motor Oil Pump Percent Speed Command",
      "SPN_Description": "Speed command to the Propulsion Motor Oil Pump in percentage of maximum speed.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "7995": {
      "PGN": 64509,
      "PGN_Name": "Electrified Accessory Propulsion Motor Oil Pump Status",
      "PGN_Description": "EAPMOPS",
      "first_bit": 0,
      "SPN": 7995,
      "SPN_Name": "Propulsion Motor Oil Pump Enable Status",
      "SPN_Description": "Enable and direction status of the Propulsion Motor Oil Pump system or component.\r\n\r\n00 - Accessory Motor Off\r\n01 - Accessory Motor On - Normal, Forward, or Default Direction\r\n10 - Accessory Motor On - Reverse Direction\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7996": {
      "PGN": 64509,
      "PGN_Name": "Electrified Accessory Propulsion Motor Oil Pump Status",
      "PGN_Description": "EAPMOPS",
      "first_bit": 2,
      "SPN": 7996,
      "SPN_Name": "Propulsion Motor Oil Pump Controller Status Reason Code",
      "SPN_Description": "Provides the reason code describing the unique failure of the Propulsion Motor Oil Pump system or component.\r\n\r\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Propulsion Motor Oil Pump Service Indicator (SPN 8001) and Propulsion Motor Oil Pump Operating Status (SPN 8002) may be used to determine functional status of the Propulsion Motor Oil Pump system or component.\r\n\r\n0000 - Normal Operation\r\n0001 - Unable to Start\r\n0010 - Over-Voltage Protection Shutdown\r\n0011 - Under-Voltage Protection Shutdown\r\n0100 - Over-Temperature Protection Shutdown\r\n0101 - Speed Limited due to current (i.e. amperage) protection limit\r\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\r\n0111 - Speed limited due to torque limit\r\n1000 - Speed limited due to over-temperature protection\r\n1001 - Reserved\r\n1010 - Reserved\r\n1011 - Reserved\r\n1100 - Reserved\r\n1101 - Reserved\r\n1110 - Reserved\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "7997": {
      "PGN": 64509,
      "PGN_Name": "Electrified Accessory Propulsion Motor Oil Pump Status",
      "PGN_Description": "EAPMOPS",
      "first_bit": 6,
      "SPN": 7997,
      "SPN_Name": "Propulsion Motor Oil Pump Controller Command Status",
      "SPN_Description": "Indicates the source of the speed command to the Propulsion Motor Oil Pump system or component.\r\n\r\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\r\n01b is communicated when responding to the Propulsion Motor Oil Pump Speed Command (SPN 7993) or Propulsion Motor Oil Pump Percent Speed Command (SPN 7994). \r\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\r\n\r\n00 - Internal Command\r\n01 - External Command\r\n10 - Default Command\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "7998": {
      "PGN": 64509,
      "PGN_Name": "Electrified Accessory Propulsion Motor Oil Pump Status",
      "PGN_Description": "EAPMOPS",
      "first_bit": 8,
      "SPN": 7998,
      "SPN_Name": "Propulsion Motor Oil Pump Motor Speed",
      "SPN_Description": "Motor Speed of the Propulsion Motor Oil Pump. ",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "7999": {
      "PGN": 64509,
      "PGN_Name": "Electrified Accessory Propulsion Motor Oil Pump Status",
      "PGN_Description": "EAPMOPS",
      "first_bit": 24,
      "SPN": 7999,
      "SPN_Name": "Propulsion Motor Oil Pump Control Temperature",
      "SPN_Description": "A temperature measured and reported by the device.  It may be used for direct or remote (e.g. by another controller) control of the pump.  For example, this may be the temperature of the fluid flowing through the pump, or some other temperature relating to the pump or controller. ",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8000": {
      "PGN": 64509,
      "PGN_Name": "Electrified Accessory Propulsion Motor Oil Pump Status",
      "PGN_Description": "EAPMOPS",
      "first_bit": 40,
      "SPN": 8000,
      "SPN_Name": "Propulsion Motor Oil Pump Power",
      "SPN_Description": "Calculated electrical power consumed by the Propulsion Motor Oil Pump.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "W",
      "SLOT_ID": 305
    },
    "8001": {
      "PGN": 64509,
      "PGN_Name": "Electrified Accessory Propulsion Motor Oil Pump Status",
      "PGN_Description": "EAPMOPS",
      "first_bit": 56,
      "SPN": 8001,
      "SPN_Name": "Propulsion Motor Oil Pump Service Indicator",
      "SPN_Description": "Indicates that service is required for the Propulsion Motor Oil Pump system or component.\r\n\r\nAn active indication may convey a need for component replacement or periodic service.  The Propulsion Motor Oil Pump Controller Status Reason Code (SPN 7996) may provide additional detail as to the nature of the system status.\r\n\n\n00 - Service Not Required\r\n01 - Service Required\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8002": {
      "PGN": 64509,
      "PGN_Name": "Electrified Accessory Propulsion Motor Oil Pump Status",
      "PGN_Description": "EAPMOPS",
      "first_bit": 58,
      "SPN": 8002,
      "SPN_Name": "Propulsion Motor Oil Pump Operating Status",
      "SPN_Description": "Indicates the operating status of the Propulsion Motor Oil Pump system or component.\r\n\r\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Propulsion Motor Oil Pump Controller Status Reason Code (SPN 7996) may provide additional detail as to the nature of the system status.\r\n\n\n00 - Normal Operation\r\n01 - Derated Operation\r\n10 - Not Operable\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8003": {
      "PGN": 30720,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 1 Command",
      "PGN_Description": "EAPECF1C",
      "first_bit": 0,
      "SPN": 8003,
      "SPN_Name": "Power Electronics Coolant Fan 1 Enable Command",
      "SPN_Description": "Enable and direction command to the Power Electonics Coolant Fan 1.\r\n\n00 - Accessory Motor Off\r\n01 - Accessory Motor On Normal/Default Direction\r\n10 - Accessory Motor On Reverse Direction\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8004": {
      "PGN": 30720,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 1 Command",
      "PGN_Description": "EAPECF1C",
      "first_bit": 2,
      "SPN": 8004,
      "SPN_Name": "Power Electronics Coolant Fan 1 Power Hold",
      "SPN_Description": "Command to allow the Power Electronics Coolant Fan 1 to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\r\n\r\n00 - Power Hold Disabled\r\n01 - Power Hold Enabled\r\n10 - Reserved\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8005": {
      "PGN": 30720,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 1 Command",
      "PGN_Description": "EAPECF1C",
      "first_bit": 8,
      "SPN": 8005,
      "SPN_Name": "Power Electronics Coolant Fan 1 Speed Command",
      "SPN_Description": "Speed command to the Power Electronics Coolant Fan 1.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "8006": {
      "PGN": 30720,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 1 Command",
      "PGN_Description": "EAPECF1C",
      "first_bit": 24,
      "SPN": 8006,
      "SPN_Name": "Power Electronics Coolant Fan 1 Percent Speed Command",
      "SPN_Description": "Speed command to the Power Electronics Coolant Fan 1 in percentage of maximum speed.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "8007": {
      "PGN": 64508,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 1 Status",
      "PGN_Description": "EAPECF1S",
      "first_bit": 0,
      "SPN": 8007,
      "SPN_Name": "Power Electronics Coolant Fan 1 Enable Status",
      "SPN_Description": "Enable and direction status of the Power Electronics Coolant Fan 1 system or component.\r\n\r\n00 - Accessory Motor Off\r\n01 - Accessory Motor On - Normal, Forward, or Default Direction\r\n10 - Accessory Motor On - Reverse Direction\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8008": {
      "PGN": 64508,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 1 Status",
      "PGN_Description": "EAPECF1S",
      "first_bit": 2,
      "SPN": 8008,
      "SPN_Name": "Power Electronics Coolant Fan 1 Controller Status Reason Code",
      "SPN_Description": "Provides the reason code describing the unique failure of the Power Electronics Coolant Fan 1 system or component.\r\n\r\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Power Electronics Coolant Fan 1 Service Indicator (SPN 8013) and Power Electronics Coolant Fan 1 Operating Status (SPN 8014) may be used to determine functional status of the Power Electronics Coolant Fan 1 system or component.\r\n\r\n0000 - Normal Operation\r\n0001 - Unable to Start\r\n0010 - Over-Voltage Protection Shutdown\r\n0011 - Under-Voltage Protection Shutdown\r\n0100 - Over-Temperature Protection Shutdown\r\n0101 - Speed Limited due to current (i.e. amperage) protection limit\r\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\r\n0111 - Speed limited due to torque limit\r\n1000 - Speed limited due to over-temperature protection\r\n1001 - Reserved\r\n1010 - Reserved\r\n1011 - Reserved\r\n1100 - Reserved\r\n1101 - Reserved\r\n1110 - Reserved\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8009": {
      "PGN": 64508,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 1 Status",
      "PGN_Description": "EAPECF1S",
      "first_bit": 6,
      "SPN": 8009,
      "SPN_Name": "Power Electronics Coolant Fan 1 Controller Command Status",
      "SPN_Description": "Indicates the source of the speed command to the Power Electronics Coolant Fan 1 system or component.\r\n\r\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\r\n01b is communicated when responding to the Power Electronics Coolant Fan 1 Speed Command (SPN 8005) or Power Electronics Coolant Fan 1 Percent Speed Command (SPN 8006).\r\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\r\n\r\n00 - Internal Command\r\n01 - External Command\r\n10 - Default Command\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8010": {
      "PGN": 64508,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 1 Status",
      "PGN_Description": "EAPECF1S",
      "first_bit": 8,
      "SPN": 8010,
      "SPN_Name": "Power Electronics Coolant Fan 1 Motor Speed",
      "SPN_Description": "Motor Speed of the Power Electronics Coolant Fan 1. ",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "8011": {
      "PGN": 64508,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 1 Status",
      "PGN_Description": "EAPECF1S",
      "first_bit": 24,
      "SPN": 8011,
      "SPN_Name": "Power Electronics Coolant Fan 1 Control Temperature",
      "SPN_Description": "A temperature measured and reported by the device.  It may be used for direct or remote (by another controller) control of the Fan 1.  For example, this may be the temperature of the fluid flowing through the Fan 1, or some other temperature relating to the Fan 1 or controller. ",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8012": {
      "PGN": 64508,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 1 Status",
      "PGN_Description": "EAPECF1S",
      "first_bit": 40,
      "SPN": 8012,
      "SPN_Name": "Power Electronics Coolant Fan 1 Power",
      "SPN_Description": "Calculated electrical power consumed by the Power Electronics Coolant Fan 1.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "W",
      "SLOT_ID": 305
    },
    "8013": {
      "PGN": 64508,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 1 Status",
      "PGN_Description": "EAPECF1S",
      "first_bit": 56,
      "SPN": 8013,
      "SPN_Name": "Power Electronics Coolant Fan 1 Service Indicator",
      "SPN_Description": "Indicates that service is required for the Power Electronics Coolant Fan 1 system or component.\r\n\r\nAn active indication may convey a need for component replacement or periodic service.  The Power Electronics Coolant Fan 1 Controller Status Reason Code (SPN 8008) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Service Not Required\r\n01 - Service Required\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8014": {
      "PGN": 64508,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 1 Status",
      "PGN_Description": "EAPECF1S",
      "first_bit": 58,
      "SPN": 8014,
      "SPN_Name": "Power Electronics Coolant Fan 1 Operating Status",
      "SPN_Description": "Indicates the operating status of the Power Electronics Coolant Fan 1 system or component.\r\n\r\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Power Electronics Coolant Fan 1 Controller Status Reason Code (SPN 8008) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Normal Operation\r\n01 - Derated Operation\r\n10 - Not Operable\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8015": {
      "PGN": 30464,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 2 Command",
      "PGN_Description": "EAPECF2C",
      "first_bit": 0,
      "SPN": 8015,
      "SPN_Name": "Power Electronics Coolant Fan 2 Enable Command",
      "SPN_Description": "Enable and direction command to the Power Electonics Coolant Fan 2.\r\n\n00 - Accessory Motor Off\r\n01 - Accessory Motor On Normal/Default Direction\r\n10 - Accessory Motor On Reverse Direction\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8016": {
      "PGN": 30464,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 2 Command",
      "PGN_Description": "EAPECF2C",
      "first_bit": 2,
      "SPN": 8016,
      "SPN_Name": "Power Electronics Coolant Fan 2 Power Hold",
      "SPN_Description": "Command to allow the Power Electronics Coolant Fan 2 to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\r\n\r\n00 - Power Hold Disabled\r\n01 - Power Hold Enabled\r\n10 - Reserved\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8017": {
      "PGN": 30464,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 2 Command",
      "PGN_Description": "EAPECF2C",
      "first_bit": 8,
      "SPN": 8017,
      "SPN_Name": "Power Electronics Coolant Fan 2 Speed Command",
      "SPN_Description": "Speed command to the Power Electronics Coolant Fan 2.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "8018": {
      "PGN": 30464,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 2 Command",
      "PGN_Description": "EAPECF2C",
      "first_bit": 24,
      "SPN": 8018,
      "SPN_Name": "Power Electronics Coolant Fan 2 Percent Speed Command",
      "SPN_Description": "Speed command to the Power Electronics Coolant Fan 2 in percentage of maximum speed.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "8019": {
      "PGN": 64507,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 2 Status",
      "PGN_Description": "EAPECF2S",
      "first_bit": 0,
      "SPN": 8019,
      "SPN_Name": "Power Electronics Coolant Fan 2 Enable Status",
      "SPN_Description": "Enable and direction status of the Power Electronics Coolant Fan 2 system or component.\r\n\r\n00 - Accessory Motor Off\r\n01 - Accessory Motor On - Normal, Forward, or Default Direction\r\n10 - Accessory Motor On - Reverse Direction\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8020": {
      "PGN": 64507,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 2 Status",
      "PGN_Description": "EAPECF2S",
      "first_bit": 2,
      "SPN": 8020,
      "SPN_Name": "Power Electronics Coolant Fan 2 Controller Status Reason Code",
      "SPN_Description": "Provides the reason code describing the unique failure of the Power Electronics Coolant Fan 2 system or component.\r\n\r\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Power Electronics Coolant Fan 2 Service Indicator (SPN 8025) and Power Electronics Coolant Fan 2 Operating Status (SPN 8026) may be used to determine functional status of the Power Electronics Coolant Fan 2 system or component.\r\n\r\n0000 - Normal Operation\r\n0001 - Unable to Start\r\n0010 - Over-Voltage Protection Shutdown\r\n0011 - Under-Voltage Protection Shutdown\r\n0100 - Over-Temperature Protection Shutdown\r\n0101 - Speed Limited due to current (i.e. amperage) protection limit\r\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\r\n0111 - Speed limited due to torque limit\r\n1000 - Speed limited due to over-temperature protection\r\n1001 - Reserved\r\n1010 - Reserved\r\n1011 - Reserved\r\n1100 - Reserved\r\n1101 - Reserved\r\n1110 - Reserved\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8021": {
      "PGN": 64507,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 2 Status",
      "PGN_Description": "EAPECF2S",
      "first_bit": 6,
      "SPN": 8021,
      "SPN_Name": "Power Electronics Coolant Fan 2 Controller Command Status",
      "SPN_Description": "Indicates the source of the speed command to the Power Electronics Coolant Fan 2 system or component.\r\n\r\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\r\n01b is communicated when responding to the Power Electronics Coolant Fan 2 Speed Command (SPN 8017) or Power Electronics Coolant Fan 2 Percent Speed Command (SPN 8018).\r\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\r\n\r\n00 - Internal Command\r\n01 - External Command\r\n10 - Default Command\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8022": {
      "PGN": 64507,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 2 Status",
      "PGN_Description": "EAPECF2S",
      "first_bit": 8,
      "SPN": 8022,
      "SPN_Name": "Power Electronics Coolant Fan 2 Motor Speed",
      "SPN_Description": "Motor Speed of the Power Electronics Coolant Fan 2. ",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "8023": {
      "PGN": 64507,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 2 Status",
      "PGN_Description": "EAPECF2S",
      "first_bit": 24,
      "SPN": 8023,
      "SPN_Name": "Power Electronics Coolant Fan 2 Control Temperature",
      "SPN_Description": "A temperature measured and reported by the device.  It may be used for direct or remote (by another controller) control of the Fan 2.  For example, this may be the temperature of the fluid flowing through the Fan 2, or some other temperature relating to the Fan 2 or controller. ",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8024": {
      "PGN": 64507,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 2 Status",
      "PGN_Description": "EAPECF2S",
      "first_bit": 40,
      "SPN": 8024,
      "SPN_Name": "Power Electronics Coolant Fan 2 Power",
      "SPN_Description": "Calculated electrical power consumed by the Power Electronics Coolant Fan 2.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "W",
      "SLOT_ID": 305
    },
    "8025": {
      "PGN": 64507,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 2 Status",
      "PGN_Description": "EAPECF2S",
      "first_bit": 56,
      "SPN": 8025,
      "SPN_Name": "Power Electronics Coolant Fan 2 Service Indicator",
      "SPN_Description": "Indicates that service is required for the Power Electronics Coolant Fan 2 system or component.\r\n\r\nAn active indication may convey a need for component replacement or periodic service.  The Power Electronics Coolant Fan 2 Controller Status Reason Code (SPN 8020) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Service Not Required\r\n01 - Service Required\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8026": {
      "PGN": 64507,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 2 Status",
      "PGN_Description": "EAPECF2S",
      "first_bit": 58,
      "SPN": 8026,
      "SPN_Name": "Power Electronics Coolant Fan 2 Operating Status",
      "SPN_Description": "Indicates the operating status of the Power Electronics Coolant Fan 2 system or component.\r\n\r\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Power Electronics Coolant Fan 2 Controller Status Reason Code (SPN 8020) may provide additional detail as to the nature of the system status.\r\n\n00 - Normal Operation\r\n01 - Derated Operation\r\n10 - Not Operable\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8027": {
      "PGN": 30208,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 3 Command",
      "PGN_Description": "EAPECF3C",
      "first_bit": 0,
      "SPN": 8027,
      "SPN_Name": "Power Electronics Coolant Fan 3 Enable Command",
      "SPN_Description": "Enable and direction command to the Power Electonics Coolant Fan 3.\r\n\r\n00 - Accessory Motor Off\r\n01 - Accessory Motor On Normal/Default Direction\r\n10 - Accessory Motor On Reverse Direction\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8028": {
      "PGN": 30208,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 3 Command",
      "PGN_Description": "EAPECF3C",
      "first_bit": 2,
      "SPN": 8028,
      "SPN_Name": "Power Electronics Coolant Fan 3 Power Hold",
      "SPN_Description": "Command to allow the Power Electronics Coolant Fan 3 to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\r\n\r\n00 - Power Hold Disabled\r\n01 - Power Hold Enabled\r\n10 - Reserved\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8029": {
      "PGN": 30208,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 3 Command",
      "PGN_Description": "EAPECF3C",
      "first_bit": 8,
      "SPN": 8029,
      "SPN_Name": "Power Electronics Coolant Fan 3 Speed Command",
      "SPN_Description": "Speed command to the Power Electronics Coolant Fan 3.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "8030": {
      "PGN": 30208,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 3 Command",
      "PGN_Description": "EAPECF3C",
      "first_bit": 24,
      "SPN": 8030,
      "SPN_Name": "Power Electronics Coolant Fan 3 Percent Speed Command",
      "SPN_Description": "Speed command to the Power Electronics Coolant Fan 3 in percentage of maximum speed.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "8031": {
      "PGN": 64506,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 3 Status",
      "PGN_Description": "EAPECF3S",
      "first_bit": 0,
      "SPN": 8031,
      "SPN_Name": "Power Electronics Coolant Fan 3 Enable Status",
      "SPN_Description": "Enable and direction status of the Power Electronics Coolant Fan 3 system or component.\r\n\r\n00 - Accessory Motor Off\r\n01 - Accessory Motor On - Normal, Forward, or Default Direction\r\n10 - Accessory Motor On - Reverse Direction\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8032": {
      "PGN": 64506,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 3 Status",
      "PGN_Description": "EAPECF3S",
      "first_bit": 2,
      "SPN": 8032,
      "SPN_Name": "Power Electronics Coolant Fan 3 Controller Status Reason Code",
      "SPN_Description": "Provides the reason code describing the unique failure of the Power Electronics Coolant Fan 3 system or component.  If a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Power Electronics Coolant Fan 3 Service Indicator (SPN 8037) and Power Electronics Coolant Fan 3 Operating Status (SPN 8038) may be used to determine functional status of the Power Electronics Coolant Fan 3 system or component.\r\n\r\n0000 - Normal Operation\r\n0001 - Unable to Start\r\n0010 - Over-Voltage Protection Shutdown\r\n0011 - Under-Voltage Protection Shutdown\r\n0100 - Over-Temperature Protection Shutdown\r\n0101 - Speed Limited due to current (i.e. amperage) protection limit\r\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\r\n0111 - Speed limited due to torque limit\r\n1000 - Speed limited due to over-temperature protection\r\n1001 - Reserved\r\n1010 - Reserved\r\n1011 - Reserved\r\n1100 - Reserved\r\n1101 - Reserved\r\n1110 - Reserved\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8033": {
      "PGN": 64506,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 3 Status",
      "PGN_Description": "EAPECF3S",
      "first_bit": 6,
      "SPN": 8033,
      "SPN_Name": "Power Electronics Coolant Fan 3 Controller Command Status",
      "SPN_Description": "Indicates the source of the speed command to the Power Electronics Coolant Fan 3 system or component.\r\n\r\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\r\n01b is communicated when responding to the Power Electronics Coolant Fan 3 Speed Command (SPN 8029) or Power Electronics Coolant Fan 3 Percent Speed Command (SPN 8030).\r\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\r\n\r\n00 - Internal Command\r\n01 - External Command\r\n10 - Default Command\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8034": {
      "PGN": 64506,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 3 Status",
      "PGN_Description": "EAPECF3S",
      "first_bit": 8,
      "SPN": 8034,
      "SPN_Name": "Power Electronics Coolant Fan 3 Motor Speed",
      "SPN_Description": "Motor Speed of the Power Electronics Coolant Fan 3. ",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "8035": {
      "PGN": 64506,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 3 Status",
      "PGN_Description": "EAPECF3S",
      "first_bit": 24,
      "SPN": 8035,
      "SPN_Name": "Power Electronics Coolant Fan 3 Control Temperature",
      "SPN_Description": "A temperature measured and reported by the device.  It may be used for direct or remote (by another controller) control of the Fan 3.  For example, this may be the temperature of the fluid flowing through the Fan 3, or some other temperature relating to the Fan 3 or controller. ",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8036": {
      "PGN": 64506,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 3 Status",
      "PGN_Description": "EAPECF3S",
      "first_bit": 40,
      "SPN": 8036,
      "SPN_Name": "Power Electronics Coolant Fan 3 Power",
      "SPN_Description": "Calculated electrical power consumed by the Power Electronics Coolant Fan 3.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "W",
      "SLOT_ID": 305
    },
    "8037": {
      "PGN": 64506,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 3 Status",
      "PGN_Description": "EAPECF3S",
      "first_bit": 56,
      "SPN": 8037,
      "SPN_Name": "Power Electronics Coolant Fan 3 Service Indicator",
      "SPN_Description": "Indicates that service is required for the Power Electronics Coolant Fan 3 system or component.\r\n\r\nAn active indication may convey a need for component replacement or periodic service.  The Power Electronics Coolant Fan 3 Controller Status Reason Code (SPN 8032) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Service Not Required\r\n01 - Service Required\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8038": {
      "PGN": 64506,
      "PGN_Name": "Electrified Accessory Power Electronics Coolant Fan 3 Status",
      "PGN_Description": "EAPECF3S",
      "first_bit": 58,
      "SPN": 8038,
      "SPN_Name": "Power Electronics Coolant Fan 3 Operating Status",
      "SPN_Description": "Indicates the operating status of the Power Electronics Coolant Fan 3 system or component.\r\n\r\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Power Electronics Coolant Fan 3 Controller Status Reason Code (SPN 8032) may provide additional detail as to the nature of the system status.\r\n\n\n00 - Normal Operation\r\n01 - Derated Operation\r\n10 - Not Operable\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8039": {
      "PGN": 29952,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 1 Command",
      "PGN_Description": "EAPMCF1C",
      "first_bit": 0,
      "SPN": 8039,
      "SPN_Name": "Propulsion Motor Coolant Fan 1 Enable Command",
      "SPN_Description": "Enable and direction command to the Propulsion Motor Coolant Fan 1.\r\n\n00 - Accessory Motor Off\r\n01 - Accessory Motor On Normal/Default Direction\r\n10 - Accessory Motor On Reverse Direction\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8040": {
      "PGN": 29952,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 1 Command",
      "PGN_Description": "EAPMCF1C",
      "first_bit": 2,
      "SPN": 8040,
      "SPN_Name": "Propulsion Motor Coolant Fan 1 Power Hold",
      "SPN_Description": "Command to allow the Propulsion Motor Coolant Fan 1 to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\r\n\r\n00 - Power Hold Disabled\r\n01 - Power Hold Enabled\r\n10 - Reserved\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8041": {
      "PGN": 29952,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 1 Command",
      "PGN_Description": "EAPMCF1C",
      "first_bit": 8,
      "SPN": 8041,
      "SPN_Name": "Propulsion Motor Coolant Fan 1 Speed Command",
      "SPN_Description": "Speed command to the Propulsion Motor Coolant Fan 1.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "8042": {
      "PGN": 29952,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 1 Command",
      "PGN_Description": "EAPMCF1C",
      "first_bit": 24,
      "SPN": 8042,
      "SPN_Name": "Propulsion Motor Coolant Fan 1 Percent Speed Command",
      "SPN_Description": "Speed command to the Propulsion Motor Coolant Fan 1 in percentage of maximum speed.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "8043": {
      "PGN": 64505,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 1 Status",
      "PGN_Description": "EAPMCF1S",
      "first_bit": 0,
      "SPN": 8043,
      "SPN_Name": "Propulsion Motor Coolant Fan 1 Enable Status",
      "SPN_Description": "Enable and direction status of the Propulsion Motor Coolant Fan 1 system or component.\r\n\n\n00 - Accessory Motor Off\r\n01 - Accessory Motor On - Normal, Forward, or Default Direction\r\n10 - Accessory Motor On - Reverse Direction\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8044": {
      "PGN": 64505,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 1 Status",
      "PGN_Description": "EAPMCF1S",
      "first_bit": 2,
      "SPN": 8044,
      "SPN_Name": "Propulsion Motor Coolant Fan 1 Controller Status Reason Code",
      "SPN_Description": "Provides the reason code describing the unique failure of the Propulsion Motor Coolant Fan 1 system or component.\r\n\r\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Propulsion Motor Coolant Fan 1 Service Indicator (SPN 8049) and Propulsion Motor Coolant Fan 1 Operating Status (SPN 8050) may be used to determine functional status of the Propulsion Motor Coolant Fan 1 system or component.\r\n\r\n0000 - Normal Operation\r\n0001 - Unable to Start\r\n0010 - Over-Voltage Protection Shutdown\r\n0011 - Under-Voltage Protection Shutdown\r\n0100 - Over-Temperature Protection Shutdown\r\n0101 - Speed Limited due to current (i.e. amperage) protection limit\r\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\r\n0111 - Speed limited due to torque limit\r\n1000 - Speed limited due to over-temperature protection\r\n1001 - Reserved\r\n1010 - Reserved\r\n1011 - Reserved\r\n1100 - Reserved\r\n1101 - Reserved\r\n1110 - Reserved\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8045": {
      "PGN": 64505,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 1 Status",
      "PGN_Description": "EAPMCF1S",
      "first_bit": 6,
      "SPN": 8045,
      "SPN_Name": "Propulsion Motor Coolant Fan 1 Controller Command Status",
      "SPN_Description": "Indicates the source of the speed command to the Propulsion Motor Coolant Fan 1 system or component.\r\n\r\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\r\n01b is communicated when responding to the Propulsion Motor Coolant Fan 1 Speed Command (SPN 8041) or Propulsion Motor Coolant Fan 1 Percent Speed Command (SPN 8042).\r\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\r\n\r\n00 - Internal Command\r\n01 - External Command\r\n10 - Default Command\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8046": {
      "PGN": 64505,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 1 Status",
      "PGN_Description": "EAPMCF1S",
      "first_bit": 8,
      "SPN": 8046,
      "SPN_Name": "Propulsion Motor Coolant Fan 1 Motor Speed",
      "SPN_Description": "Motor Speed of the Propulsion Motor Coolant Fan 1. ",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "8047": {
      "PGN": 64505,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 1 Status",
      "PGN_Description": "EAPMCF1S",
      "first_bit": 24,
      "SPN": 8047,
      "SPN_Name": "Propulsion Motor Coolant Fan 1 Control Temperature",
      "SPN_Description": "A temperature measured and reported by the device.  It may be used for direct or remote (by another controller) control of the Fan 1.  For example, this may be the temperature of the fluid flowing through the Fan 1, or some other temperature relating to the Fan 1 or controller. ",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8048": {
      "PGN": 64505,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 1 Status",
      "PGN_Description": "EAPMCF1S",
      "first_bit": 40,
      "SPN": 8048,
      "SPN_Name": "Propulsion Motor Coolant Fan 1 Power",
      "SPN_Description": "Calculated electrical power consumed by the Propulsion Motor Coolant Fan 1.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "W",
      "SLOT_ID": 305
    },
    "8049": {
      "PGN": 64505,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 1 Status",
      "PGN_Description": "EAPMCF1S",
      "first_bit": 56,
      "SPN": 8049,
      "SPN_Name": "Propulsion Motor Coolant Fan 1 Service Indicator",
      "SPN_Description": "Indicates that service is required for the Propulsion Motor Coolant Fan 1 system or component.\r\n\r\nAn active indication may convey a need for component replacement or periodic service.  The Propulsion Motor Coolant Fan 1 Controller Status Reason Code (SPN 8044) may provide additional detail as to the nature of the system status.\r\n\n\n00 - Service Not Required\r\n01 - Service Required\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8050": {
      "PGN": 64505,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 1 Status",
      "PGN_Description": "EAPMCF1S",
      "first_bit": 58,
      "SPN": 8050,
      "SPN_Name": "Propulsion Motor Coolant Fan 1 Operating Status",
      "SPN_Description": "Indicates the operating status of the Propulsion Motor Coolant Fan 1 system or component.\r\n\r\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Propulsion Motor Coolant Fan 1 Controller Status Reason Code (SPN 8044) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Normal Operation\r\n01 - Derated Operation\r\n10 - Not Operable\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8051": {
      "PGN": 29696,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 2 Command",
      "PGN_Description": "EAPMCF2C",
      "first_bit": 0,
      "SPN": 8051,
      "SPN_Name": "Propulsion Motor Coolant Fan 2 Enable Command",
      "SPN_Description": "Enable and direction command to the Power Motor Coolant Fan 2.\r\n\n00 - Accessory Motor Off\r\n01 - Accessory Motor On Normal/Default Direction\r\n10 - Accessory Motor On Reverse Direction\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8052": {
      "PGN": 29696,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 2 Command",
      "PGN_Description": "EAPMCF2C",
      "first_bit": 2,
      "SPN": 8052,
      "SPN_Name": "Propulsion Motor Coolant Fan 2 Power Hold",
      "SPN_Description": "Command to allow the Propulsion Motor Coolant Fan 2 to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\r\n\r\n00 - Power Hold Disabled\r\n01 - Power Hold Enabled\r\n10 - Reserved\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8053": {
      "PGN": 29696,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 2 Command",
      "PGN_Description": "EAPMCF2C",
      "first_bit": 8,
      "SPN": 8053,
      "SPN_Name": "Propulsion Motor Coolant Fan 2 Speed Command",
      "SPN_Description": "Speed command to the Propulsion Motor Coolant Fan 2.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "8054": {
      "PGN": 29696,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 2 Command",
      "PGN_Description": "EAPMCF2C",
      "first_bit": 24,
      "SPN": 8054,
      "SPN_Name": "Propulsion Motor Coolant Fan 2 Percent Speed Command",
      "SPN_Description": "Speed command to the Propulsion Motor Coolant Fan 2 in percentage of maximum speed.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "8055": {
      "PGN": 64504,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 2 Status",
      "PGN_Description": "EAPMCF2S",
      "first_bit": 0,
      "SPN": 8055,
      "SPN_Name": "Propulsion Motor Coolant Fan 2 Enable Status",
      "SPN_Description": "Enable and direction status of the Propulsion Motor Coolant Fan 2 system or component.\r\n\r\n00 - Accessory Motor Off\r\n01 - Accessory Motor On - Normal, Forward, or Default Direction\r\n10 - Accessory Motor On - Reverse Direction\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8056": {
      "PGN": 64504,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 2 Status",
      "PGN_Description": "EAPMCF2S",
      "first_bit": 2,
      "SPN": 8056,
      "SPN_Name": "Propulsion Motor Coolant Fan 2 Controller Status Reason Code",
      "SPN_Description": "Provides the reason code describing the unique failure of the Propulsion Motor Coolant Fan 2 system or component.\r\n\r\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Propulsion Motor Coolant Fan 2 Service Indicator (SPN 8061) and Propulsion Motor Coolant Fan 2 Operating Status (SPN 8062) may be used to determine functional status of the Propulsion Motor Coolant Fan 2 system or component.\r\n\r\n0000 - Normal Operation\r\n0001 - Unable to Start\r\n0010 - Over-Voltage Protection Shutdown\r\n0011 - Under-Voltage Protection Shutdown\r\n0100 - Over-Temperature Protection Shutdown\r\n0101 - Speed Limited due to current (i.e. amperage) protection limit\r\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\r\n0111 - Speed limited due to torque limit\r\n1000 - Speed limited due to over-temperature protection\r\n1001 - Reserved\r\n1010 - Reserved\r\n1011 - Reserved\r\n1100 - Reserved\r\n1101 - Reserved\r\n1110 - Reserved\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8057": {
      "PGN": 64504,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 2 Status",
      "PGN_Description": "EAPMCF2S",
      "first_bit": 6,
      "SPN": 8057,
      "SPN_Name": "Propulsion Motor Coolant Fan 2 Controller Command Status",
      "SPN_Description": "Indicates the source of the speed command to the Propulsion Motor Coolant Fan 2 system or component.\r\n\r\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\r\n01b is communicated when responding to the Propulsion Motor Coolant Fan 2 Speed Command (SPN 8053) or Propulsion Motor Coolant Fan 2 Percent Speed Command (SPN 8054).\r\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\r\n\r\n00 - Internal Command\r\n01 - External Command\r\n10 - Default Command\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8058": {
      "PGN": 64504,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 2 Status",
      "PGN_Description": "EAPMCF2S",
      "first_bit": 8,
      "SPN": 8058,
      "SPN_Name": "Propulsion Motor Coolant Fan 2 Motor Speed",
      "SPN_Description": "Motor Speed of the Propulsion Motor Coolant Fan 2. ",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "8059": {
      "PGN": 64504,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 2 Status",
      "PGN_Description": "EAPMCF2S",
      "first_bit": 24,
      "SPN": 8059,
      "SPN_Name": "Propulsion Motor Coolant Fan 2 Control Temperature",
      "SPN_Description": "A temperature measured and reported by the device.  It may be used for direct or remote (by another controller) control of the Fan 2.  For example, this may be the temperature of the fluid flowing through the Fan 2, or some other temperature relating to the Fan 2 or controller. ",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8060": {
      "PGN": 64504,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 2 Status",
      "PGN_Description": "EAPMCF2S",
      "first_bit": 40,
      "SPN": 8060,
      "SPN_Name": "Propulsion Motor Coolant Fan 2 Power",
      "SPN_Description": "Calculated electrical power consumed by the Propulsion Motor Coolant Fan 2.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "W",
      "SLOT_ID": 305
    },
    "8061": {
      "PGN": 64504,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 2 Status",
      "PGN_Description": "EAPMCF2S",
      "first_bit": 56,
      "SPN": 8061,
      "SPN_Name": "Propulsion Motor Coolant Fan 2 Service Indicator",
      "SPN_Description": "Indicates that service is required for the Propulsion Motor Coolant Fan 2 system or component.\r\n\r\nAn active indication may convey a need for component replacement or periodic service.  The Propulsion Motor Coolant Fan 2 Controller Status Reason Code (SPN 8056) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Service Not Required\r\n01 - Service Required\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8062": {
      "PGN": 64504,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 2 Status",
      "PGN_Description": "EAPMCF2S",
      "first_bit": 58,
      "SPN": 8062,
      "SPN_Name": "Propulsion Motor Coolant Fan 2 Operating Status",
      "SPN_Description": "Indicates the operating status of the Propulsion Motor Coolant Fan 2 system or component.\r\n\r\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Propulsion Motor Coolant Fan 2 Controller Status Reason Code (SPN 8056) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Normal Operation\r\n01 - Derated Operation\r\n10 - Not Operable\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8063": {
      "PGN": 29440,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 3 Command",
      "PGN_Description": "EAPMCF3C",
      "first_bit": 0,
      "SPN": 8063,
      "SPN_Name": "Propulsion Motor Coolant Fan 3 Enable Command",
      "SPN_Description": "Enable and direction command to the Power Motor Coolant Fan 3.\r\n\r\n00 - Accessory Motor Off\r\n01 - Accessory Motor On Normal/Default Direction\r\n10 - Accessory Motor On Reverse Direction\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8064": {
      "PGN": 29440,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 3 Command",
      "PGN_Description": "EAPMCF3C",
      "first_bit": 2,
      "SPN": 8064,
      "SPN_Name": "Propulsion Motor Coolant Fan 3 Power Hold",
      "SPN_Description": "Command to allow the Propulsion Motor Coolant Fan 3 to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\r\n\r\n00 - Power Hold Disabled\r\n01 - Power Hold Enabled\r\n10 - Reserved\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8065": {
      "PGN": 29440,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 3 Command",
      "PGN_Description": "EAPMCF3C",
      "first_bit": 8,
      "SPN": 8065,
      "SPN_Name": "Propulsion Motor Coolant Fan 3 Speed Command",
      "SPN_Description": "Speed command to the Propulsion Motor Coolant Fan 3.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "8066": {
      "PGN": 29440,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 3 Command",
      "PGN_Description": "EAPMCF3C",
      "first_bit": 24,
      "SPN": 8066,
      "SPN_Name": "Propulsion Motor Coolant Fan 3 Percent Speed Command",
      "SPN_Description": "Speed command to the Propulsion Motor Coolant Fan 3 in percentage of maximum speed.\r\n\r\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 8,
      "scaling": 0.5,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 299
    },
    "8067": {
      "PGN": 64503,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 3 Status",
      "PGN_Description": "EAPMCF3S",
      "first_bit": 0,
      "SPN": 8067,
      "SPN_Name": "Propulsion Motor Coolant Fan 3 Enable Status",
      "SPN_Description": "Enable and direction status of the Propulsion Motor Coolant Fan 3 system or component.\r\n\r\n00 - Accessory Motor Off\r\n01 - Accessory Motor On - Normal, Forward, or Default Direction\r\n10 - Accessory Motor On - Reverse Direction\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8068": {
      "PGN": 64503,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 3 Status",
      "PGN_Description": "EAPMCF3S",
      "first_bit": 2,
      "SPN": 8068,
      "SPN_Name": "Propulsion Motor Coolant Fan 3 Controller Status Reason Code",
      "SPN_Description": "Provides the reason code describing the unique failure of the Propulsion Motor Coolant Fan 3 system or component.\r\n\r\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Propulsion Motor Coolant Fan 3 Service Indicator (SPN 8073) and Propulsion Motor Coolant Fan 3 Operating Status (SPN 8074) may be used to determine functional status of the Propulsion Motor Coolant Fan 3 system or component.\r\n\r\n0000 - Normal Operation\r\n0001 - Unable to Start\r\n0010 - Over-Voltage Protection Shutdown\r\n0011 - Under-Voltage Protection Shutdown\r\n0100 - Over-Temperature Protection Shutdown\r\n0101 - Speed Limited due to current (i.e. amperage) protection limit\r\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\r\n0111 - Speed limited due to torque limit\r\n1000 - Speed limited due to over-temperature protection\r\n1001 - Reserved\r\n1010 - Reserved\r\n1011 - Reserved\r\n1100 - Reserved\r\n1101 - Reserved\r\n1110 - Reserved\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8069": {
      "PGN": 64503,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 3 Status",
      "PGN_Description": "EAPMCF3S",
      "first_bit": 6,
      "SPN": 8069,
      "SPN_Name": "Propulsion Motor Coolant Fan 3 Controller Command Status",
      "SPN_Description": "Indicates the source of the speed command to the Propulsion Motor Coolant Fan 3 system or component.\r\n\r\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\r\n01b is communicated when responding to the Propulsion Motor Coolant Fan 3 Speed Command (SPN 8065) or Propulsion Motor Coolant Fan 3 Percent Speed Command (SPN 8066).\r\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\r\n\r\n00 - Internal Command\r\n01 - External Command\r\n10 - Default Command\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8070": {
      "PGN": 64503,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 3 Status",
      "PGN_Description": "EAPMCF3S",
      "first_bit": 8,
      "SPN": 8070,
      "SPN_Name": "Propulsion Motor Coolant Fan 3 Motor Speed",
      "SPN_Description": "Motor Speed of the Propulsion Motor Coolant Fan 3. ",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "8071": {
      "PGN": 64503,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 3 Status",
      "PGN_Description": "EAPMCF3S",
      "first_bit": 24,
      "SPN": 8071,
      "SPN_Name": "Propulsion Motor Coolant Fan 3 Control Temperature",
      "SPN_Description": "A temperature measured and reported by the device.  It may be used for direct or remote (by another controller) control of the Fan 3.  For example, this may be the temperature of the fluid flowing through the Fan 3, or some other temperature relating to the Fan 3 or controller. ",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8072": {
      "PGN": 64503,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 3 Status",
      "PGN_Description": "EAPMCF3S",
      "first_bit": 40,
      "SPN": 8072,
      "SPN_Name": "Propulsion Motor Coolant Fan 3 Power",
      "SPN_Description": "Calculated electrical power consumed by the Propulsion Motor Coolant Fan 3.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "W",
      "SLOT_ID": 305
    },
    "8073": {
      "PGN": 64503,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 3 Status",
      "PGN_Description": "EAPMCF3S",
      "first_bit": 56,
      "SPN": 8073,
      "SPN_Name": "Propulsion Motor Coolant Fan 3 Service Indicator",
      "SPN_Description": "Indicates that service is required for the Propulsion Motor Coolant Fan 3 system or component.\r\n\r\nAn active indication may convey a need for component replacement or periodic service.  The Propulsion Motor Coolant Fan 3 Controller Status Reason Code (SPN 8068) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Service Not Required\r\n01 - Service Required\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8074": {
      "PGN": 64503,
      "PGN_Name": "Electrified Accessory Propulsion Motor Coolant Fan 3 Status",
      "PGN_Description": "EAPMCF3S",
      "first_bit": 58,
      "SPN": 8074,
      "SPN_Name": "Propulsion Motor Coolant Fan 3 Operating Status",
      "SPN_Description": "Indicates the operating status of the Propulsion Motor Coolant Fan 3 system or component.\r\n\r\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Propulsion Motor Coolant Fan 3 Controller Status Reason Code (SPN 8068) may provide additional detail as to the nature of the system status.\r\n\r\n\n00 - Normal Operation\r\n01 - Derated Operation\r\n10 - Not Operable\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8075": {
      "PGN": 61586,
      "PGN_Name": "High Voltage Energy Storage 1 Data 3",
      "PGN_Description": "HVES1D3",
      "first_bit": 0,
      "SPN": 8075,
      "SPN_Name": "HVES1 Highest Cell Temperature",
      "SPN_Description": "The highest temperature level reported by any cell in the High Voltage Energy Storage 1 pack (or system).  If a single temperature sensor covers more than one cell, the value in this parameter is for the smallest group of cells measured.   See HVES1 Highest Cell Temperature Module Number (SPN 8241) and HVES1 Highest Cell Temperature Cell Number (SPN 8242) for cell location information.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8076": {
      "PGN": 61586,
      "PGN_Name": "High Voltage Energy Storage 1 Data 3",
      "PGN_Description": "HVES1D3",
      "first_bit": 16,
      "SPN": 8076,
      "SPN_Name": "HVES1 Lowest Cell Temperature ",
      "SPN_Description": "The lowest temperature level reported by any cell in the High Voltage Energy Storage 1 pack (or system).  If a single temperature sensor covers more than one cell, the value in this parameter is for the smallest group of cells measured.  See HVES1 Lowest Cell Temperature Module Number (SPN 8243) and HVES1 Lowest Cell Temperature Cell Number (SPN 8244) for cell location information.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8077": {
      "PGN": 61586,
      "PGN_Name": "High Voltage Energy Storage 1 Data 3",
      "PGN_Description": "HVES1D3",
      "first_bit": 32,
      "SPN": 8077,
      "SPN_Name": "HVES1 Average Cell Temperature",
      "SPN_Description": "The average temperature level of all cells in the High Voltage Energy Storage 1 pack (or system).",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8078": {
      "PGN": 61586,
      "PGN_Name": "High Voltage Energy Storage 1 Data 3",
      "PGN_Description": "HVES1D3",
      "first_bit": 48,
      "SPN": 8078,
      "SPN_Name": "HVES1 Cell Temperature Differential Status",
      "SPN_Description": "Indicates whether or not the differential between the highest and lowest cell temperatures are within acceptable limits per the High Voltage Energy Storage 1 pack (or system).   The actual temperature differential can be calculated by subtracting SPN 8076 (HVES1 Lowest Cell Temperature) from SPN 8075 (HVES1 Highest Cell Temperature).\r\n\r\n00 = Cell-to-cell temperature differential is within acceptable limits\r\n01 = Cell-to-cell temperature differential exceeds acceptable limits\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8079": {
      "PGN": 61587,
      "PGN_Name": "High Voltage Energy Storage 1 Data 4",
      "PGN_Description": "HVES1D4",
      "first_bit": 0,
      "SPN": 8079,
      "SPN_Name": "HVES1 Discharge Capacity",
      "SPN_Description": "The amount of stored electrical charge in the High Voltage Energy Storage 1 pack (or system) that is available for use by the hybrid system, i.e. “how full is the tank”.  See HVES1 Discharge Energy Capacity (SPN 8205) for kilowatt-hours (kWh).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "Ah",
      "SLOT_ID": 342
    },
    "8080": {
      "PGN": 61587,
      "PGN_Name": "High Voltage Energy Storage 1 Data 4",
      "PGN_Description": "HVES1D4",
      "first_bit": 16,
      "SPN": 8080,
      "SPN_Name": "HVES1 Charge Capacity",
      "SPN_Description": "The amount of unused electrical charge storage in the High Voltage Energy Storage 1 pack (or system) that is available to be filled by charging, i.e. “how much empty space is remaining in the tank”.  See HVES1 Charge Energy Capacity (SPN 8206) for kilowatt-hours (kWh).",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "Ah",
      "SLOT_ID": 342
    },
    "8081": {
      "PGN": 61587,
      "PGN_Name": "High Voltage Energy Storage 1 Data 4",
      "PGN_Description": "HVES1D4",
      "first_bit": 32,
      "SPN": 8081,
      "SPN_Name": "HVES1 Cell Balancing Count",
      "SPN_Description": "The number of cells that are currently being balanced in the High Voltage Energy Storage 1 pack (or system).",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "8082": {
      "PGN": 61588,
      "PGN_Name": "High Voltage Energy Storage 1 Data 5",
      "PGN_Description": "HVES1D5",
      "first_bit": 0,
      "SPN": 8082,
      "SPN_Name": "HVES1 Discharge Current Limit",
      "SPN_Description": "The maximum permissible current flow out of the High Voltage Energy Storage 1 pack (or system).  This parameter is defined from the high voltage energy storage system's point of view.\r\n\r\nA negative value represents current flowing out of the energy storage system (discharging the system); as such, the current limit value must be between -1600 and 0 Volts.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -1600,
      "unit": "A",
      "SLOT_ID": 104
    },
    "8083": {
      "PGN": 61588,
      "PGN_Name": "High Voltage Energy Storage 1 Data 5",
      "PGN_Description": "HVES1D5",
      "first_bit": 16,
      "SPN": 8083,
      "SPN_Name": "HVES1 Charge Current Limit",
      "SPN_Description": "The maximum permissible current flow into the High Voltage Energy Storage 1 pack (or system).  This parameter is defined from the high voltage energy storage system's point of view.\r\n\r\nA positive value represents current flowing into the energy storage system (charging the system); as such current limit value must be between 0 and +1612.75 Volts.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": -1600,
      "unit": "A",
      "SLOT_ID": 104
    },
    "8084": {
      "PGN": 61588,
      "PGN_Name": "High Voltage Energy Storage 1 Data 5",
      "PGN_Description": "HVES1D5",
      "first_bit": 32,
      "SPN": 8084,
      "SPN_Name": "HVES1 Minimum Cell State of Charge",
      "SPN_Description": "Indicates the state of charge of the lowest-charged cell in the High Voltage Energy Storage 1 pack (or system).  0% means no charge remaining, 100% means the cell is fully charged.   If a single state of charge value covers more than one cell, the value in this parameter is for the smallest group of cells measured.   See HVES1 Lowest Cell State of Charge Module Number (SPN 8247) and HVES1 Lowest Cell State of Charge Cell Number (SPN 8248) for cell location information.",
      "bit_length": 16,
      "scaling": 0.0015625,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 345
    },
    "8085": {
      "PGN": 61588,
      "PGN_Name": "High Voltage Energy Storage 1 Data 5",
      "PGN_Description": "HVES1D5",
      "first_bit": 48,
      "SPN": 8085,
      "SPN_Name": "HVES1 Maximum Cell State of Charge",
      "SPN_Description": "Indicates the state of charge of the highest-charged cell in the High Voltage Energy Storage 1 pack (or system).  0% means no charge remaining, 100% means the cell is fully charged.  If a single state of charge value covers more than one cell, the value in this parameter is for the smallest group of cells measured.  See HVES1 Highest Cell State of Charge Module Number (SPN 8245) and HVES1 Highest Cell State of Charge Cell Number (SPN 8246) for cell location information.",
      "bit_length": 16,
      "scaling": 0.0015625,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 345
    },
    "8086": {
      "PGN": 61589,
      "PGN_Name": "High Voltage Energy Storage 1 Data 6",
      "PGN_Description": "HVES1D6",
      "first_bit": 0,
      "SPN": 8086,
      "SPN_Name": "HVES1 Bus Voltage",
      "SPN_Description": "The voltage level of the high voltage bus, as measured by the High Voltage Energy Storage 1 pack (or system) on the bus side (not the battery side) of its contactors.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "8087": {
      "PGN": 61589,
      "PGN_Name": "High Voltage Energy Storage 1 Data 6",
      "PGN_Description": "HVES1D6",
      "first_bit": 16,
      "SPN": 8087,
      "SPN_Name": "HVES1 Ignition Voltage",
      "SPN_Description": "The voltage level at the ignition input of the High Voltage Energy Storage 1 pack (or system) controller.",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 221
    },
    "8088": {
      "PGN": 61589,
      "PGN_Name": "High Voltage Energy Storage 1 Data 6",
      "PGN_Description": "HVES1D6",
      "first_bit": 32,
      "SPN": 8088,
      "SPN_Name": "HVES1 Intake Coolant Temperature",
      "SPN_Description": "The temperature of liquid coolant as it enters the High Voltage Energy Storage 1 pack (or system).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8089": {
      "PGN": 61589,
      "PGN_Name": "High Voltage Energy Storage 1 Data 6",
      "PGN_Description": "HVES1D6",
      "first_bit": 40,
      "SPN": 8089,
      "SPN_Name": "HVES1 Outlet Coolant Temperature",
      "SPN_Description": "The temperature of liquid coolant as it exits the High Voltage Energy Storage 1 pack (or system).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8090": {
      "PGN": 61600,
      "PGN_Name": "High Voltage Energy Storage 1 Data 7",
      "PGN_Description": "HVES1D7",
      "first_bit": 48,
      "SPN": 8090,
      "SPN_Name": "HVES1 Maximum Charge Voltage Limit",
      "SPN_Description": "The maximum voltage level not to be exceeded while charging the High Voltage Energy Storage 1 pack (or system).  If this parameter is not supported, the maximum charge voltage should be limited to SPN 8117 (HVES1 Recommended Maximum Operating Voltage).",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "8091": {
      "PGN": 61590,
      "PGN_Name": "High Voltage Energy Storage 1 Status 1",
      "PGN_Description": "HVES1S1",
      "first_bit": 0,
      "SPN": 8091,
      "SPN_Name": "HVES1 High-Voltage Bus (Positive) Contactor State",
      "SPN_Description": "Position of the High Voltage Energy Storage 1 pack (or system) positive side bus contactor.  When this contactor is closed, the positive side of HVES1 is connected to the positive side of the high-voltage bus.  In systems where all contactors are controlled as a single unit (i.e. all contactors can only be either all open or all closed), this parameter may be used to convey the overall contactor status.\r\n\r\n00 = Contactor Open\r\n01 = Contactor Closed\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8092": {
      "PGN": 61590,
      "PGN_Name": "High Voltage Energy Storage 1 Status 1",
      "PGN_Description": "HVES1S1",
      "first_bit": 2,
      "SPN": 8092,
      "SPN_Name": "HVES1 High-Voltage Bus (Negative) Contactor State",
      "SPN_Description": "Position of the High Voltage Energy Storage 1 pack (or system) negative side bus contactor.  When this contactor is closed, the negative side of HVES1 is connected to the negative side of the high-voltage bus.  If a system controls the positive, negative, and center contactors as a single unit (i.e. all contactors can only be either all open or all closed), then SPN 8091 (HVES1 High-Voltage Bus (Positive) Contactor State) should be used to convey overall contactor status.\r\n\r\n00 = Contactor Open\r\n01 = Contactor Closed\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8093": {
      "PGN": 61590,
      "PGN_Name": "High Voltage Energy Storage 1 Status 1",
      "PGN_Description": "HVES1S1",
      "first_bit": 4,
      "SPN": 8093,
      "SPN_Name": "HVES1 High-Voltage Bus Disconnect Forewarning",
      "SPN_Description": "Indicates that the High Voltage Energy Storage 1 pack (or system) is about to disconnect from the high voltage bus due to unacceptable conditions.\r\n\r\n0000 = Disconnect not pending\r\n0001 = Disconnect imminent due to battery pack voltage approaching minimum acceptable level\r\n0010 = Disconnect imminent due to battery pack voltage approaching maximum acceptable level\r\n0011 = Disconnect imminent due to module voltage approaching minimum acceptable level\r\n0100 = Disconnect imminent due to module voltage approaching maximum acceptable level\r\n0101 = Disconnect imminent due to cell voltage approaching minimum acceptable level\r\n0110 = Disconnect imminent due to cell voltage approaching maximum acceptable level\r\n0111 = Disconnect imminent due to battery pack current approaching maximum acceptable level\r\n1000 - 1100 = Reserved\r\n1101 = Disconnect imminent - no reason given\r\n1110 = Error\r\n1111 = Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8094": {
      "PGN": 61590,
      "PGN_Name": "High Voltage Energy Storage 1 Status 1",
      "PGN_Description": "HVES1S1",
      "first_bit": 8,
      "SPN": 8094,
      "SPN_Name": "HVES1 High-Voltage Bus Pre-Charge Relay State",
      "SPN_Description": "Position of the high-voltage bus contactor pre-charge relay.  When this relay is closed, the High Voltage Energy Storage 1 pack (or system) is bringing the high-voltage bus up to its operating level.\r\n\r\n00 = Relay Open\r\n01 = Relay Closed\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8095": {
      "PGN": 61590,
      "PGN_Name": "High Voltage Energy Storage 1 Status 1",
      "PGN_Description": "HVES1S1",
      "first_bit": 10,
      "SPN": 8095,
      "SPN_Name": "HVES1 Center of Pack Contactor State",
      "SPN_Description": "Position of the center high-voltage contactor.  When this contactor is closed, the positive half of the High Voltage Energy Storage 1 pack (or system) is connected to the negative half.  If a system controls the positive, negative, and center contactors as a single unit (i.e. all contactors can only be either all open or all closed), then SPN 8091 (HVES1 High-Voltage Bus (Positive) Contactor State) should be used.\r\n\r\n00 = Contactor Open\r\n01 = Contactor Closed\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8096": {
      "PGN": 61590,
      "PGN_Name": "High Voltage Energy Storage 1 Status 1",
      "PGN_Description": "HVES1S1",
      "first_bit": 12,
      "SPN": 8096,
      "SPN_Name": "HVES1 High-Voltage Bus Active Isolation Test Status",
      "SPN_Description": "Status of the high-voltage bus electrical active isolation test as performed by the High Voltage Energy Storage 1 pack (or system).\r\n\r\n0000 = No test requested / No test in process\r\n0001 = Test requested but not yet in process\r\n0010 = Test in process\r\n0011 = Test complete; isolation acceptable\r\n0100 = Test complete; isolation marginal\r\n0101 = Test complete; isolation fault\r\n0110 - 1101 = Reserved\r\n1110 = Error\r\n1111 = Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8097": {
      "PGN": 61590,
      "PGN_Name": "High Voltage Energy Storage 1 Status 1",
      "PGN_Description": "HVES1S1",
      "first_bit": 16,
      "SPN": 8097,
      "SPN_Name": "HVES1 High-Voltage Bus Passive Isolation Test Status",
      "SPN_Description": "Status of the high-voltage bus electrical passive isolation test as performed by the High Voltage Energy Storage 1 pack (or system).\r\n\r\n0000 = No test requested / No test in process\r\n0001 = Test requested but not yet in process\r\n0010 = Test in process\r\n0011 = Test complete; isolation acceptable\r\n0100 = Test complete; isolation marginal\r\n0101 = Test complete; isolation fault\r\n0110 - 1101 = Reserved\r\n1110 = Error\r\n1111 = Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8098": {
      "PGN": 61590,
      "PGN_Name": "High Voltage Energy Storage 1 Status 1",
      "PGN_Description": "HVES1S1",
      "first_bit": 20,
      "SPN": 8098,
      "SPN_Name": "HVES1 HVIL Status",
      "SPN_Description": "Status of the High Voltage Interlock Loop from the viewpoint of the High Voltage Energy Storage 1 pack (or system).\r\n\r\n00 = HVIL Closed\r\n01 = HVIL Open\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8099": {
      "PGN": 61590,
      "PGN_Name": "High Voltage Energy Storage 1 Status 1",
      "PGN_Description": "HVES1S1",
      "first_bit": 22,
      "SPN": 8099,
      "SPN_Name": "HVES1 Inertia Switch Status",
      "SPN_Description": "Switch indicating that an impact has been sensed by the High Voltage Energy Storage 1 pack (or system).   The impact indication may require action by another controller, or by the HVES1 control module itself.  For example, a controller may elect to take HVES1 off-line to reduce an electrocution hazard during or after a vehicle crash.\r\n\r\n00 = No impact sensed\r\n01 = Impact sensed\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8100": {
      "PGN": 61590,
      "PGN_Name": "High Voltage Energy Storage 1 Status 1",
      "PGN_Description": "HVES1S1",
      "first_bit": 24,
      "SPN": 8100,
      "SPN_Name": "HVES1 State of Charge Status",
      "SPN_Description": "Status of the High Voltage Energy Storage 1 pack (or system) State of Charge (SOC).  Note:  A given HVES controller may not support all of the states.\r\n\r\n0000 = SOC level is acceptable.\r\n0001 = SOC is approaching its recommended lower limit\r\n0010 = SOC is at its recommended lower limit\r\n0011 = SOC is below its recommended lower limit\r\n0100 = SOC is approaching its recommended upper limit\r\n0101 = SOC is at its recommended upper limit\r\n0110 = SOC is above its recommended upper limit\r\n0111 - 1101 = Reserved\r\n1110 = Error\r\n1111 = Not  Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8101": {
      "PGN": 61590,
      "PGN_Name": "High Voltage Energy Storage 1 Status 1",
      "PGN_Description": "HVES1S1",
      "first_bit": 28,
      "SPN": 8101,
      "SPN_Name": "HVES1 Cell Balance Status",
      "SPN_Description": "Indicates whether or not the cells in the High Voltage Energy Storage 1 pack (or system) are balanced.\r\n\r\n00 = Cells are balanced\r\n01 = Cells are unbalanced\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8102": {
      "PGN": 61590,
      "PGN_Name": "High Voltage Energy Storage 1 Status 1",
      "PGN_Description": "HVES1S1",
      "first_bit": 30,
      "SPN": 8102,
      "SPN_Name": "HVES1 Cell Balancing Active",
      "SPN_Description": "Indicates whether or not the cells in the High Voltage Energy Storage 1 pack (or system) are currently being balanced.\r\n\r\n00 = Cell balancing is not active\r\n01 = Cell balancing is active\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8103": {
      "PGN": 61494,
      "PGN_Name": "High Voltage Energy Storage 1 Status 2",
      "PGN_Description": "HVES1S2",
      "first_bit": 0,
      "SPN": 8103,
      "SPN_Name": "HVES1 Discharge Power Limit Due to State of Charge",
      "SPN_Description": "Indicates whether or not HVES1 discharge power is being limited due to state of charge.\r\n\r\n00 = No power limit for this reason\r\n01 = Power limited for this reason\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8104": {
      "PGN": 61494,
      "PGN_Name": "High Voltage Energy Storage 1 Status 2",
      "PGN_Description": "HVES1S2",
      "first_bit": 2,
      "SPN": 8104,
      "SPN_Name": "HVES1 Discharge Power Limit Due to Battery Temperature",
      "SPN_Description": "Indicates whether or not HVES1 discharge power is being limited due to battery temperature.\r\n\r\n00 = No power limit for this reason\r\n01 = Power limited for this reason\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8105": {
      "PGN": 61494,
      "PGN_Name": "High Voltage Energy Storage 1 Status 2",
      "PGN_Description": "HVES1S2",
      "first_bit": 4,
      "SPN": 8105,
      "SPN_Name": "HVES1 Discharge Power Limit Due to Battery Diagnostic Condition",
      "SPN_Description": "Indicates whether or not HVES1 discharge power is being limited due to a battery diagnostic condition.\r\n\r\n00 = No power limit for this reason\r\n01 = Power limited for this reason\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8106": {
      "PGN": 61494,
      "PGN_Name": "High Voltage Energy Storage 1 Status 2",
      "PGN_Description": "HVES1S2",
      "first_bit": 6,
      "SPN": 8106,
      "SPN_Name": "HVES1 Discharge Power Limit Due to Battery or Cell Voltage",
      "SPN_Description": "Indicates whether or not HVES1 discharge power is being limited due to a battery or cell voltage level.\r\n\r\n00 = No power limit for this reason\r\n01 = Power limited for this reason\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8107": {
      "PGN": 61494,
      "PGN_Name": "High Voltage Energy Storage 1 Status 2",
      "PGN_Description": "HVES1S2",
      "first_bit": 8,
      "SPN": 8107,
      "SPN_Name": "HVES1 Discharge Power Limit Due to Battery Current",
      "SPN_Description": "Indicates whether or not HVES1 discharge power is being limited due to battery current.\r\n\r\n00 = No power limit for this reason\r\n01 = Power limited for this reason\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8108": {
      "PGN": 61494,
      "PGN_Name": "High Voltage Energy Storage 1 Status 2",
      "PGN_Description": "HVES1S2",
      "first_bit": 10,
      "SPN": 8108,
      "SPN_Name": "HVES1 Discharge Power Limit Due to an Undefined Cause",
      "SPN_Description": "Indicates whether or not HVES1 discharge power is being limited due to an undefined cause.\r\n\r\n00 = No power limit for this reason\r\n01 = Power limited for this reason\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8109": {
      "PGN": 61494,
      "PGN_Name": "High Voltage Energy Storage 1 Status 2",
      "PGN_Description": "HVES1S2",
      "first_bit": 32,
      "SPN": 8109,
      "SPN_Name": "HVES1 Charge Power Limit Due to State of Charge",
      "SPN_Description": "Indicates whether or not HVES1 charge power is being limited due to state of charge.\r\n\r\n00 = No power limit for this reason\r\n01 = Power limited for this reason\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8110": {
      "PGN": 61494,
      "PGN_Name": "High Voltage Energy Storage 1 Status 2",
      "PGN_Description": "HVES1S2",
      "first_bit": 34,
      "SPN": 8110,
      "SPN_Name": "HVES1 Charge Power Limit Due to Battery Temperature",
      "SPN_Description": "Indicates whether or not HVES1 charge power is being limited due to battery temperature.\r\n\r\n00 = No power limit for this reason\r\n01 = Power limited for this reason\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8111": {
      "PGN": 61494,
      "PGN_Name": "High Voltage Energy Storage 1 Status 2",
      "PGN_Description": "HVES1S2",
      "first_bit": 36,
      "SPN": 8111,
      "SPN_Name": "HVES1 Charge Power Limit Due to Battery Diagnostic Condition",
      "SPN_Description": "Indicates whether or not HVES1 charge power is being limited due to a battery diagnostic condition.\r\n\r\n00 = No power limit for this reason\r\n01 = Power limited for this reason\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8112": {
      "PGN": 61494,
      "PGN_Name": "High Voltage Energy Storage 1 Status 2",
      "PGN_Description": "HVES1S2",
      "first_bit": 38,
      "SPN": 8112,
      "SPN_Name": "HVES1 Charge Power Limit Due to Battery or Cell Voltage",
      "SPN_Description": "Indicates whether or not HVES1 charge power is being limited due to a battery or cell voltage level.\r\n\r\n00 = No power limit for this reason\r\n01 = Power limited for this reason\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8113": {
      "PGN": 61494,
      "PGN_Name": "High Voltage Energy Storage 1 Status 2",
      "PGN_Description": "HVES1S2",
      "first_bit": 40,
      "SPN": 8113,
      "SPN_Name": "HVES1 Charge Power Limit Due to Battery Current",
      "SPN_Description": "Indicates whether or not HVES1 charge power is being limited due to battery current.\r\n\r\n00 = No power limit for this reason\r\n01 = Power limited for this reason\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8114": {
      "PGN": 61494,
      "PGN_Name": "High Voltage Energy Storage 1 Status 2",
      "PGN_Description": "HVES1S2",
      "first_bit": 42,
      "SPN": 8114,
      "SPN_Name": "HVES1 Charge Power Limit Due to an Undefined Cause",
      "SPN_Description": "Indicates whether or not HVES1 charge power is being limited due to an undefined cause.\r\n\r\n00 = No power limit for this reason\r\n01 = Power limited for this reason\r\n10 = Error\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8115": {
      "PGN": 64605,
      "PGN_Name": "High Voltage Energy Storage 1 Configuration",
      "PGN_Description": "HVES1CFG",
      "first_bit": 0,
      "SPN": 8115,
      "SPN_Name": "HVES1 Nominal Voltage",
      "SPN_Description": "Per the HVES manufacturer, this is the nominal operating voltage of the High Voltage Energy Storage 1 pack (or system), e.g. “300V” or “600V”.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "8116": {
      "PGN": 64605,
      "PGN_Name": "High Voltage Energy Storage 1 Configuration",
      "PGN_Description": "HVES1CFG",
      "first_bit": 16,
      "SPN": 8116,
      "SPN_Name": "HVES1 Recommended Minimum Operating Voltage",
      "SPN_Description": "Per the HVES manufacturer, this is the minimum recommended voltage level for High Voltage Energy Storage 1 pack (or system) operation.  Operating below this value may compromise HVES life.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "8117": {
      "PGN": 64605,
      "PGN_Name": "High Voltage Energy Storage 1 Configuration",
      "PGN_Description": "HVES1CFG",
      "first_bit": 32,
      "SPN": 8117,
      "SPN_Name": "HVES1 Recommended Maximum Operating Voltage",
      "SPN_Description": "Per the HVES manufacturer, this is the maximum recommended voltage level for High Voltage Energy Storage 1 pack (or system) operation.  Operating above this value may compromise HVES life.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "8118": {
      "PGN": 64605,
      "PGN_Name": "High Voltage Energy Storage 1 Configuration",
      "PGN_Description": "HVES1CFG",
      "first_bit": 48,
      "SPN": 8118,
      "SPN_Name": "HVES1 Recommended Minimum State Of Charge",
      "SPN_Description": "Per the HVES manufacturer, this is the recommended minimum state of charge for High Voltage Energy Storage 1 pack (or system) operation.  Operating below this value may compromise HVES life.",
      "bit_length": 16,
      "scaling": 0.0015625,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 345
    },
    "8119": {
      "PGN": 64605,
      "PGN_Name": "High Voltage Energy Storage 1 Configuration",
      "PGN_Description": "HVES1CFG",
      "first_bit": 64,
      "SPN": 8119,
      "SPN_Name": "HVES1 Recommended Maximum State Of Charge ",
      "SPN_Description": "Per the HVES manufacturer, this is the recommended maximum state of charge for High Voltage Energy Storage 1 pack (or system) operation.  Operating above this value may compromise HVES life.",
      "bit_length": 16,
      "scaling": 0.0015625,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 345
    },
    "8120": {
      "PGN": 64605,
      "PGN_Name": "High Voltage Energy Storage 1 Configuration",
      "PGN_Description": "HVES1CFG",
      "first_bit": 80,
      "SPN": 8120,
      "SPN_Name": "HVES1 Recommended Maximum Operating Temperature",
      "SPN_Description": "Per the HVES manufacturer, this is the recommended maximum temperature for High Voltage Energy Storage 1 pack (or system) operation.  Operating above this value may damage HVES hardware, or compromise HVES life.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8121": {
      "PGN": 64606,
      "PGN_Name": "High Voltage Energy Storage 1 History",
      "PGN_Description": "HVES1HIST",
      "first_bit": 0,
      "SPN": 8121,
      "SPN_Name": "HVES1 State of Health",
      "SPN_Description": "This signal represents the expected remaining \"Life\" of the High Voltage Energy Storage 1 pack (or system), in percent.  This value should begin at 100%, and end at 0% when “no” energy is able to be put in or taken out.  “No” could be absolute zero, or it could be some rated value of the pack.\r\n\r\nThe pack supplier can develop their own algorithm to calculate this parameter, but in general it is a reverse Amp Hour Counter, reflecting the expected Amp Hours of energy throughput remaining in the Hybrid Battery.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "8122": {
      "PGN": 64606,
      "PGN_Name": "High Voltage Energy Storage 1 History",
      "PGN_Description": "HVES1HIST",
      "first_bit": 8,
      "SPN": 8122,
      "SPN_Name": "HVES1 Contactor Open Under Load Count",
      "SPN_Description": "This signal represents the number of times the contactors inside the High Voltage Energy Storage 1 pack (or system) have opened while current is flowing through them.  The current level (that determines if an opening event will be counted) shall be defined by the HVES manufacturer, but in general should be a current level at which the contactor life may be reduced if repeated cycles occur.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 12
    },
    "8123": {
      "PGN": 6912,
      "PGN_Name": "High Voltage Energy Storage 1 Control 1",
      "PGN_Description": "HVES1C1",
      "first_bit": 0,
      "SPN": 8123,
      "SPN_Name": "HVES1 High-Voltage Bus Connect Command",
      "SPN_Description": "Command to connect the High Voltage Energy Storage 1 pack (or system) to the high-voltage bus.  The emergency contactor closure request may be used in situations where one or more faults in the hybrid powertrain prevent normal operation, but the vehicle operator desires operation due to a perceived emergency situation.  Receivers of this command should always support state 10b (Emergency contactor closure request), even if the criteria for closing the contactor are the same as used in response to state 01b.\r\n\r\n00 = Open Contactor; Disconnect HVES from high-voltage bus\r\n01 = Close Contactor; Connect HVES to high-voltage bus\r\n10 = Emergency contactor closure request\r\n11 = Don't care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8124": {
      "PGN": 6912,
      "PGN_Name": "High Voltage Energy Storage 1 Control 1",
      "PGN_Description": "HVES1C1",
      "first_bit": 2,
      "SPN": 8124,
      "SPN_Name": "HVES1 Power-Down Command",
      "SPN_Description": "Command to shut down the High Voltage Energy Storage 1 pack (or system).  A normal power-down may involve steps that take some period of time (tests, writing of data, etc.).  However, an emergency power-down should shut down the storage system as quickly as possible, such as in the event of a vehicle accident.   Receivers of this command should always support state 10b (Execute emergency power-down), even if the actual power-down process is the same as that used during a \"normal\" power-down.\r\n\r\n00 = Power-down not requested\r\n01 = Execute normal power-down\r\n10 = Execute emergency power-down\r\n11 = Don't care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8125": {
      "PGN": 6912,
      "PGN_Name": "High Voltage Energy Storage 1 Control 1",
      "PGN_Description": "HVES1C1",
      "first_bit": 4,
      "SPN": 8125,
      "SPN_Name": "HVES1 High-Voltage Bus Active Isolation Test Command",
      "SPN_Description": "Command for the High Voltage Energy Storage 1 pack (or system) to perform an active electrical isolation test on the high voltage bus.\r\n\r\nAn active isolation test might use a generated signal (e.g. an injected AC signal) and then monitor changes in the measurements of the isolated circuits.\r\n\r\n00 = Active Isolation Test not requested\r\n01 = Active Isolation Test request\r\n10 = Reserved\r\n11 = Don't care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8126": {
      "PGN": 6912,
      "PGN_Name": "High Voltage Energy Storage 1 Control 1",
      "PGN_Description": "HVES1C1",
      "first_bit": 6,
      "SPN": 8126,
      "SPN_Name": "HVES1 High-Voltage Bus Passive Isolation Test Command",
      "SPN_Description": "Command for the High Voltage Energy Storage 1 pack (or system) to perform a passive electrical isolation test on the high voltage bus.\r\n\r\nA passive isolation test uses additional circuitry (e.g. a high impedance network) to monitor the delta between the high voltage connections (e.g. positive and negative buses).  \r\n\r\n00 = Passive Isolation Test not requested\r\n01 = Passive Isolation Test request\r\n10 = Reserved\r\n11 = Don't care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8127": {
      "PGN": 6912,
      "PGN_Name": "High Voltage Energy Storage 1 Control 1",
      "PGN_Description": "HVES1C1",
      "first_bit": 8,
      "SPN": 8127,
      "SPN_Name": "HVES1 Cell Balancing Command",
      "SPN_Description": "Command for the High Voltage Energy Storage 1 pack (or system) to perform cell balancing.\r\n\r\n00 = Cell Balancing not requested\r\n01 = Cell Balancing requested\r\n10 = Reserved\r\n11 = Don't care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8128": {
      "PGN": 64502,
      "PGN_Name": "Vehicle Position 2",
      "PGN_Description": "VP2",
      "first_bit": 0,
      "SPN": 8128,
      "SPN_Name": "Total Number of Satellites in View",
      "SPN_Description": "Indicates the number of satellites in view of the positioning and locating system receiver.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8129": {
      "PGN": 64502,
      "PGN_Name": "Vehicle Position 2",
      "PGN_Description": "VP2",
      "first_bit": 8,
      "SPN": 8129,
      "SPN_Name": "Horizontal Dilution of Precision",
      "SPN_Description": "Provides the dilution of precision in the horizontal (X-Y plane axis) direction as calculated by the positioning and locating system receiver. The dilution of precision factor is calculated from the observed positions of the observed satellites (at least 4 must be tracked for this data to be valid) and the measured position of the receiver. Lower values mean more accurate position data.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 31
    },
    "8130": {
      "PGN": 64502,
      "PGN_Name": "Vehicle Position 2",
      "PGN_Description": "VP2",
      "first_bit": 16,
      "SPN": 8130,
      "SPN_Name": "Vertical Dilution of Precision",
      "SPN_Description": "Provides the dilution of precision in the vertical (Z axis) direction as calculated by the positioning and locating system receiver. The dilution of precision factor is calculated from the observed positions of the observed satellites (at least 4 must be tracked for this data to be valid) and the measured position of the receiver. Lower values mean more accurate positioning information.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 31
    },
    "8131": {
      "PGN": 64502,
      "PGN_Name": "Vehicle Position 2",
      "PGN_Description": "VP2",
      "first_bit": 24,
      "SPN": 8131,
      "SPN_Name": "Position Dilution of Precision",
      "SPN_Description": "Provides the dilution of precision for the overall position (X-Y-Z coordinate system) as calculated by the positioning and locating system receiver. The dilution of precision factor is calculated from the observed satellites (at least 4 must be tracked for this data to be valid) and the measured position of the receiver. Lower values mean more accurate positioning information.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 31
    },
    "8132": {
      "PGN": 64502,
      "PGN_Name": "Vehicle Position 2",
      "PGN_Description": "VP2",
      "first_bit": 32,
      "SPN": 8132,
      "SPN_Name": "Time Dilution of Precision",
      "SPN_Description": "Provides the estimated receiver clock error as calculated by the positioning and locating system receiver from the satellites’ clock data. The dilution of precision factor is calculated from the observed satellites (at least 4 must be tracked for this data to be valid). Lower values mean that the positioning and locating system’s receiver will provide a more accurate position calculation.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 31
    },
    "8133": {
      "PGN": 43264,
      "PGN_Name": "Forward Lane Image Command",
      "PGN_Description": "FLIC",
      "first_bit": 8,
      "SPN": 8133,
      "SPN_Name": "Current Region",
      "SPN_Description": "Command sent to forward imager which specifies the operator’s desired region to assist with object recognition.\r\n\r\nMessage shall use the 2-character string country codes in ISO 3166-1 alpha-2.\r\n\r\nTypical examples from ISO 3166-1 alpha-2 are:\r\n\r\nFrance: FR\r\nUnited States: US\r\nGermany: DE\r\n\r\nNote: \r\n\r\n2 ASCII space characters (0x2020) indicate the region is not detected/selected\r\n0xFFFF - Not available",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "ASCII",
      "SLOT_ID": 131
    },
    "8134": {
      "PGN": 43264,
      "PGN_Name": "Forward Lane Image Command",
      "PGN_Description": "FLIC",
      "first_bit": 24,
      "SPN": 8134,
      "SPN_Name": "Current Sub-Region",
      "SPN_Description": "Command sent to all Forward Imager which specifies the operator’s desired sub-region to assist with object recognition.\r\n\r\nThis signal will be dependent on Current Region and shall use the 3-character string subdivision codes in ISO 3166-2 standard.\r\n\r\nTypical examples from ISO 3166-2 are:\r\n  CA - California\r\n  NY - New York\r\n  BY - Bavaria\r\n  13 - Tokyo\r\n\r\nNote: \r\n\r\n3 ASCII space characters (0x202020) indicate the sub-region is not detected/selected\r\n0xFFFFFF Not available",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "ASCII",
      "SLOT_ID": 421
    },
    "8135": {
      "PGN": 61447,
      "PGN_Name": "Forward Lane Image 1",
      "PGN_Description": "FLI1",
      "first_bit": 16,
      "SPN": 8135,
      "SPN_Name": "Right Side Lane Departure Optical Warning Command",
      "SPN_Description": "Indicates that the forward lane imaging system is commanding an optical warning for the lane departure on the right side of the vehicle.\r\n\r\nUsed for driving optical alert devices with minimal internal logic (ie. Those that do not support SPNs 1700 and 1701).\r\n\r\n00 - No optical warning on the right side\r\n01 - Active optical warning on the right side\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8136": {
      "PGN": 61447,
      "PGN_Name": "Forward Lane Image 1",
      "PGN_Description": "FLI1",
      "first_bit": 18,
      "SPN": 8136,
      "SPN_Name": "Left Side Lane Departure Optical Warning Command",
      "SPN_Description": "Indicates that the forward lane imaging system is commanding an optical warning for the lane departure on the left side of the vehicle.\r\n\r\nUsed for driving optical alert devices with minimal internal logic (ie. Those that do not support SPNs 1700 and 1701).\r\n\r\n00 - No optical warning on the left side\r\n01 - Active optical warning on the left side\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8137": {
      "PGN": 61447,
      "PGN_Name": "Forward Lane Image 1",
      "PGN_Description": "FLI1",
      "first_bit": 20,
      "SPN": 8137,
      "SPN_Name": "Right Side Lane Departure Acoustical Warning Command",
      "SPN_Description": "Indicates that the forward lane imaging system is commanding an acoustical warning for the lane departure on the right side of the vehicle.\r\n\r\nUsed for driving acoustical alert devices with minimal internal logic (ie. Those that do not support SPNs 1700 and 1701).\r\n\r\n00 - No acoustical warning on the right side\r\n01 - Active acoustical warning on the right side\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8138": {
      "PGN": 61447,
      "PGN_Name": "Forward Lane Image 1",
      "PGN_Description": "FLI1",
      "first_bit": 22,
      "SPN": 8138,
      "SPN_Name": "Left Side Lane Departure Acoustical Warning Command",
      "SPN_Description": "Indicates that the forward lane imaging system is commanding an acoustical warning for the lane departure on the left side of the vehicle.\r\n\r\nUsed for driving acoustical alert devices with minimal internal logic (ie. Those that do not support SPNs 1700 and 1701).\r\n\r\n00 - No acoustical warning on the left side\r\n01 - Active acoustical warning on the left side\r\n10 - Reserved\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8139": {
      "PGN": 65115,
      "PGN_Name": "Forward Lane Image 2",
      "PGN_Description": "FLI2",
      "first_bit": 24,
      "SPN": 8139,
      "SPN_Name": "Left Wheel Lane Departure Distance",
      "SPN_Description": "The measured distance of departure of the left wheel on the left side of the lane, as measured from the left edge of the left tire to the right edge of the current lane's left marker.\r\n\r\nA distance of 0 indicates the left edge of the left tire is aligned with the right edge of the lane's left marker.\r\nPositive distance values indicate the left tire has departed the left side of the lane by the reported distance.\r\nNegative distance values indicate the left tire is within the lane at the reported distance from the lane's left edge.\r\nMeasured values greater than 125 cm results in value 251.\r\n\r\n251 Greater than 125 cm / Not in range\r\n252 Lane marker not reliable\r\n253 Reserved\r\n254 Error\r\n255 Not available",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "cm",
      "SLOT_ID": 420
    },
    "8140": {
      "PGN": 65115,
      "PGN_Name": "Forward Lane Image 2",
      "PGN_Description": "FLI2",
      "first_bit": 32,
      "SPN": 8140,
      "SPN_Name": "Right Wheel Lane Departure Distance",
      "SPN_Description": "The measured distance of departure of the right wheel on the right side of the lane, as measured from the right edge of the right tire to the left edge of the current lane's right marker.\r\n\r\nA distance of 0 indicates the right edge of the right tire is aligned with the left edge of the lane's right marker.\r\nPositive distance values indicate the right tire is within the lane at the reported distance from the lane's right edge.\r\nNegative distance values indicate the right tire has departed the right side of the lane by the reported distance.\r\nMeasured values greater than 125 cm results in value 251.\r\n\r\n251 = not in range\r\n252 = not reliable\r\n253 = reserved / not used\r\n254 = error\r\n255 = not available or not installed",
      "bit_length": 8,
      "scaling": 1,
      "offset": -125,
      "unit": "cm",
      "SLOT_ID": 420
    },
    "8141": {
      "PGN": 65115,
      "PGN_Name": "Forward Lane Image 2",
      "PGN_Description": "FLI2",
      "first_bit": 48,
      "SPN": 8141,
      "SPN_Name": "Lane Departure Warning System State",
      "SPN_Description": "Indicates the status of Lane Departure Warning system.\r\n\r\n0000 - System is not ready (initialization not finished)\r\n0001 - System is temporarily not available (not all activation conditions fulfulled)\r\n0010 - System is deactivated by driver\r\n0011 - System is ready (no warnings active)\r\n0100 - Active warning suppressed by operator behavior (e.g. turn signal)\r\n0101 - System is warning lane departure\r\n0110 to 1101 - Reserved\r\n1110 - Error\r\n1111 - Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8142": {
      "PGN": 65115,
      "PGN_Name": "Forward Lane Image 2",
      "PGN_Description": "FLI2",
      "first_bit": 52,
      "SPN": 8142,
      "SPN_Name": "Forward Lane Imager Status",
      "SPN_Description": "Indicates the status of the Forward Looking Imager.\r\n\r\n0000 -  Imager fully operational\r\n0001 -  Imager warming up / initializing\r\n0010 -  Imager partially blocked / partially blind\r\n0011 -  Imager fully blocked / fully blind\r\n0100 -  Imager misaligned\r\n0101 to 1101 -  Reserved\r\n1110 -  Error\r\n1111 -  Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8143": {
      "PGN": 64553,
      "PGN_Name": "Forward Lane Image 3",
      "PGN_Description": "FLI3",
      "first_bit": 56,
      "SPN": 8143,
      "SPN_Name": "Right Lane Marker Type",
      "SPN_Description": "Indicates the type of lane marker detected by the Forward Lane Imager on the right side. \r\n\r\n0000 -  Processing or not identified\r\n0001 -  Solid\r\n0010 -  Road edge\r\n0011 -  Dashed\r\n0100 -  Double lane marker\r\n0101 -  Raised lane marker (e.g. Bott's dots)\r\n0110 to 1101 -  Reserved\r\n1110 -  Error\r\n1111 -  Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8144": {
      "PGN": 64553,
      "PGN_Name": "Forward Lane Image 3",
      "PGN_Description": "FLI3",
      "first_bit": 60,
      "SPN": 8144,
      "SPN_Name": "Left Lane Marker Type",
      "SPN_Description": "Indicates the type of lane marker detected by the Forward Lane Imager on the left side. \r\n\r\n0000 -  Processing or not identified\r\n0001 -  Solid\r\n0010 -  Road edge\r\n0011 -  Dashed\r\n0100 -  Double lane marker\r\n0101 -  Raised lane marker (e.g. Bott's dots)\r\n0110 to 1101 -  Reserved\r\n1110 -  Error\r\n1111 -  Not available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8145": {
      "PGN": 64712,
      "PGN_Name": "Electronic Engine Controller 13",
      "PGN_Description": "EEC13",
      "first_bit": 18,
      "SPN": 8145,
      "SPN_Name": "Engine Fueling Inhibit Prevented Reason Extension",
      "SPN_Description": "If Engine Fueling Inhibit Allowed (SPN 5795) indicates that the engine will inhibit fueling, then this parameter indicate the reason.  If more than one reason exists at the same time, then it is up to the manufacturer to decide which one\r\nto select.\r\n\r\nSee SPN 5866 for an earlier version of this parameter. If this parameter and SPN 5866 are not in agreement, then this parameter shall be considered the primary reason.\r\n\r\n0 – Fueling inhibit allowed (SPN 5795 = 01)\r\n1 – Aftertreatment regeneration is active or preparing to be active\r\n2 – Oil Distribution in engine is incomplete\r\n3 – Engine is cold\r\n4 – Service Override\r\n5 – Aftertreatment system is cold\r\n6 – Aftertreatment Protection\r\n7 – Engine load too high\r\n8 – Engine protection. Use other engine protection enumerations in this parameter when applicable. If the method of engine protection is not defined in other states, then use this state.\r\n9 – Insufficient SLI battery charge\r\n10 – Maximum number of engine fueling inhibit requests (SPN 5793 = 0) temporary limit exceeded. The temporary limit may be bounded by elapsed time, distance travelled, driving conditions, or something else that the manufacturer has specified.\r\n11 – Engine driven fan request\r\n12 – Low idle governor operation required\r\n13 – Vehicle speed is greater than zero\r\n14 – Service brake pedal is not depressed\r\n15 – Parking brake is not applied\r\n16 – Transmission is in Reverse\r\n17 – Clutch pedal is not depressed\r\n18 – PTO is active\r\r\n19 – Stability/Slip Control event is active\r\r\n20 – Stability/Slip Control system has a fault\r\r\n21 – Interlock is active (e.g., door interlock, hood interlock, etc.)\r\r\n22 to 62 – SAE Reserved\r\n63 – Not Supported",
      "bit_length": 6,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 91
    },
    "8146": {
      "PGN": 64716,
      "PGN_Name": "Electronic Engine Controller 12",
      "PGN_Description": "EEC12",
      "first_bit": 8,
      "SPN": 8146,
      "SPN_Name": "Aftertreatment 1 Intake 2 Gas Sensor Power Supply",
      "SPN_Description": "State signal which indicates when the Aftertreatment 1 Intake 2 Gas Sensor driver output is being driven.\r\n\r\n00 - Off\r\n01 - On: The ECU is powering the Aftertreatment 1 Intake 2 Gas Sensor\r\n10 - Error\r\n11 - Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8147": {
      "PGN": 64716,
      "PGN_Name": "Electronic Engine Controller 12",
      "PGN_Description": "EEC12",
      "first_bit": 10,
      "SPN": 8147,
      "SPN_Name": "Aftertreatment 1 Outlet 2 Gas Sensor Power Supply",
      "SPN_Description": "State signal which indicates when the Aftertreatment 1 Outlet 2 Gas Sensor driver output is being driven.\r\n\r\n00 - Off\r\n01 - On: The ECU is powering the Aftertreatment 1 Outlet 2 Gas Sensor\r\n10 - Error\r\n11 - Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8148": {
      "PGN": 34048,
      "PGN_Name": "Cab Message 2",
      "PGN_Description": "CM2",
      "first_bit": 50,
      "SPN": 8148,
      "SPN_Name": "Aftertreatment System Enable Command",
      "SPN_Description": "Request to enable Aftertreatment system.\r\n\r\n00 = De-activate Aftertreatment System\r\n01 = Activate Aftertreatment System\r\n10 = Reserved\r\n11 = Don't care/Take no Action\r\n\r\nNote: In some marine applications it may be desireable to enable or disable the aftretreatment system.  SPN 7851  indicates the status of the aftertreatment system.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8149": {
      "PGN": 33024,
      "PGN_Name": "Aftertreatment System Control",
      "PGN_Description": "AFTSC",
      "first_bit": 10,
      "SPN": 8149,
      "SPN_Name": "Aftertreatment Diesel Exhaust Fluid Doser Ready Status",
      "SPN_Description": "Indicates the aftertreatment systems operating conditions are appropriate for dosing.\r\n\r\nNote: Operating conditions may include but not limited to Diesel Exhaust Fluid tank level and Diesel Exhaust Fluid tank temperature are within the operating threshold.\r\n\r\n00 = Aftertreatment Not Ready to Dose\r\n01 = Aftertreatment Ready to Dose\r\n10 = Error\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8150": {
      "PGN": 64963,
      "PGN_Name": "Electronic Engine Controller 15",
      "PGN_Description": "EEC15",
      "first_bit": 32,
      "SPN": 8150,
      "SPN_Name": "Engine Exhaust Gas Restriction Valve Control",
      "SPN_Description": "Desired percentage of maximum Exhaust Gas Restriction opening for valve. 0% means valve is closed. 100% means maximum valve opening (full gas flow).",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "8151": {
      "PGN": 61650,
      "PGN_Name": "Engine Electronic Controller 18",
      "PGN_Description": "EEC18",
      "first_bit": 32,
      "SPN": 8151,
      "SPN_Name": "Engine Exhaust Gas Restriction Valve Position",
      "SPN_Description": "The position of the exhaust gas restriction valve expressed as a percentage of full travel. 0% means the valve is closed and no exhaust gas is flowing into the intake air stream. 100% means the valve is fully opened.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "8152": {
      "PGN": 64590,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Information 3",
      "PGN_Description": "A1SCRDSI3",
      "first_bit": 24,
      "SPN": 8152,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Doser 2 Pressure",
      "SPN_Description": "The SCR doser 2 diesel exhaust fluid gage pressure (measured closest to dosing valve) for aftertreatment system 1 (exhaust bank 1). This is the gage equivalent to SPN 7459 .",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "8153": {
      "PGN": 64589,
      "PGN_Name": "Aftertreatment 2 SCR Dosing System Information 3",
      "PGN_Description": "A2SCRDSI3",
      "first_bit": 24,
      "SPN": 8153,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Doser 2 Pressure",
      "SPN_Description": "The SCR doser 2 diesel exhaust fluid gage pressure (measured closest to dosing valve) for aftertreatment system 2 (exhaust bank ). This is the gage equivalent to SPN 7464 .",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "8154": {
      "PGN": 61702,
      "PGN_Name": "Well Stimulation Pump System 1",
      "PGN_Description": "WSP1",
      "first_bit": 0,
      "SPN": 8154,
      "SPN_Name": "Well Stimulation Pump Suction Pressure",
      "SPN_Description": "The pressure on the suction side of the well stimulation pump.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3212.7,
      "unit": "kPa",
      "SLOT_ID": 355
    },
    "8155": {
      "PGN": 61702,
      "PGN_Name": "Well Stimulation Pump System 1",
      "PGN_Description": "WSP1",
      "first_bit": 16,
      "SPN": 8155,
      "SPN_Name": "Well Stimulation Pump Discharge Pressure",
      "SPN_Description": "The pressure on the discharge side of the well stimulation pump.",
      "bit_length": 16,
      "scaling": 5,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 130
    },
    "8156": {
      "PGN": 61703,
      "PGN_Name": "Well Stimulation Pump System 2",
      "PGN_Description": "WSP2",
      "first_bit": 0,
      "SPN": 8156,
      "SPN_Name": "Well Stimulation Pump Gear Box Oil Pressure",
      "SPN_Description": "The oil pressure measured in the well stimulation pump gear box.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "8157": {
      "PGN": 61703,
      "PGN_Name": "Well Stimulation Pump System 2",
      "PGN_Description": "WSP2",
      "first_bit": 16,
      "SPN": 8157,
      "SPN_Name": "Well Stimulation Pump Gear Box Oil Temperature",
      "SPN_Description": "Temperature of the oil in the well stimulation pump gear box.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8158": {
      "PGN": 61703,
      "PGN_Name": "Well Stimulation Pump System 2",
      "PGN_Description": "WSP2",
      "first_bit": 24,
      "SPN": 8158,
      "SPN_Name": "Well Stimulation Pump Speed",
      "SPN_Description": "The operating speed of the well stimulation pump.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "8159": {
      "PGN": 65252,
      "PGN_Name": "Shutdown",
      "PGN_Description": "SHUTDN",
      "first_bit": 62,
      "SPN": 8159,
      "SPN_Name": "Engine Oil Pressure Switch",
      "SPN_Description": "Measured engine oil pressure with respect to the pre-set threshold.\r\n\r\n00 = OK (Engine Oil Pressure Above Min Threshold)\r\n01 = Not OK (Engine Oil Pressure Below Min Threshold)\r\n10 = Error (Switch State Cannot Be Determined)\r\n11 = Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8160": {
      "PGN": 64501,
      "PGN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst 2",
      "PGN_Description": "A1DOC2",
      "first_bit": 0,
      "SPN": 8160,
      "SPN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst Intake Pressure",
      "SPN_Description": "Aftertreatment 1 Diesel Oxidation Catalyst absolute pressure measured at the DOC intake in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "8161": {
      "PGN": 64501,
      "PGN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst 2",
      "PGN_Description": "A1DOC2",
      "first_bit": 16,
      "SPN": 8161,
      "SPN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst Outlet Pressure",
      "SPN_Description": "Aftertreatment 1 Diesel Oxidation Catalyst absolute pressure measured at the DOC outlet in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "8162": {
      "PGN": 64501,
      "PGN_Name": "Aftertreatment 1 Diesel Oxidation Catalyst 2",
      "PGN_Description": "A1DOC2",
      "first_bit": 32,
      "SPN": 8162,
      "SPN_Name": "Aftertreatment 1 DOC Intake to DPF Outlet Delta Pressure",
      "SPN_Description": "Aftertreatment 1 Diesel Oxidation Catalyst intake to Diesel Particulate Filter outlet differential pressure in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "8163": {
      "PGN": 64500,
      "PGN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst 2",
      "PGN_Description": "A2DOC2",
      "first_bit": 0,
      "SPN": 8163,
      "SPN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst Intake Pressure",
      "SPN_Description": "Aftertreatment 2 Diesel Oxidation Catalyst absolute pressure measured at the DOC intake in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "8164": {
      "PGN": 64500,
      "PGN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst 2",
      "PGN_Description": "A2DOC2",
      "first_bit": 16,
      "SPN": 8164,
      "SPN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst Outlet Pressure",
      "SPN_Description": "Aftertreatment 2 Diesel Oxidation Catalyst absolute pressure measured at the DOC outlet in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "8165": {
      "PGN": 64500,
      "PGN_Name": "Aftertreatment 2 Diesel Oxidation Catalyst 2",
      "PGN_Description": "A2DOC2",
      "first_bit": 32,
      "SPN": 8165,
      "SPN_Name": "Aftertreatment 2 DOC Intake to DPF Outlet Delta Pressure",
      "SPN_Description": "Aftertreatment 2 Diesel Oxidation Catalyst intake to Diesel Particulate Filter outlet differential pressure in exhaust bank 1.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "8166": {
      "PGN": 64499,
      "PGN_Name": "Cruise Control / Vehicle Speed 5",
      "PGN_Description": "CCVS5",
      "first_bit": 0,
      "SPN": 8166,
      "SPN_Name": "Directional Vehicle Speed",
      "SPN_Description": "The velocity and direction of the vehicle. Positive values are used for forward vehicle motion, negative values for reverse vehicle motion.  This SPN is intended for control purposes where vehicle direction is required.  It is not intended to replace SPN 84.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -250,
      "unit": "km/h",
      "SLOT_ID": 72
    },
    "8167": {
      "PGN": 64491,
      "PGN_Name": "Oil Debris Monitor Counts Ferrous Bins 1 & 2",
      "PGN_Description": "ODMCF1_2",
      "first_bit": 0,
      "SPN": 8167,
      "SPN_Name": "Oil Debris Monitor Ferrous Bins 1 and 2 Identification Number",
      "SPN_Description": "Identification number of the Oil Debris Monitoring (ODM) sensor being reported for Ferrous bins 1 and 2. Identification numbers are application specific.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8168": {
      "PGN": 64491,
      "PGN_Name": "Oil Debris Monitor Counts Ferrous Bins 1 & 2",
      "PGN_Description": "ODMCF1_2",
      "first_bit": 8,
      "SPN": 8168,
      "SPN_Name": "Oil Debris Monitor Ferrous Bin 1 Count",
      "SPN_Description": "Total number of particles detected in Ferrous bin 1. Bin sizes are application specific.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8169": {
      "PGN": 64491,
      "PGN_Name": "Oil Debris Monitor Counts Ferrous Bins 1 & 2",
      "PGN_Description": "ODMCF1_2",
      "first_bit": 32,
      "SPN": 8169,
      "SPN_Name": "Oil Debris Monitor Ferrous Bin 2 Count",
      "SPN_Description": "Total number of particles detected in Ferrous bin 2. Bin sizes are application specific.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8170": {
      "PGN": 64492,
      "PGN_Name": "Oil Debris Monitor Counts Ferrous Bins 3 & 4",
      "PGN_Description": "ODMCF3_4",
      "first_bit": 0,
      "SPN": 8170,
      "SPN_Name": "Oil Debris Monitor Ferrous Bins 3 and 4 Identification Number",
      "SPN_Description": "Identification number of the Oil Debris Monitoring (ODM) sensor being reported for Ferrous bins 3 and 4. Identification numbers are application specific.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8171": {
      "PGN": 64492,
      "PGN_Name": "Oil Debris Monitor Counts Ferrous Bins 3 & 4",
      "PGN_Description": "ODMCF3_4",
      "first_bit": 8,
      "SPN": 8171,
      "SPN_Name": "Oil Debris Monitor Ferrous Bin 3 Count",
      "SPN_Description": "Total number of particles detected in Ferrous bin 3. Bin sizes are application specific.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8172": {
      "PGN": 64492,
      "PGN_Name": "Oil Debris Monitor Counts Ferrous Bins 3 & 4",
      "PGN_Description": "ODMCF3_4",
      "first_bit": 32,
      "SPN": 8172,
      "SPN_Name": "Oil Debris Monitor Ferrous Bin 4 Count",
      "SPN_Description": "Total number of particles detected in Ferrous bin 4. Bin sizes are application specific.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8173": {
      "PGN": 64493,
      "PGN_Name": "Oil Debris Monitor Counts Ferrous Bins 5 & 6",
      "PGN_Description": "ODMCF5_6",
      "first_bit": 0,
      "SPN": 8173,
      "SPN_Name": "Oil Debris Monitor Ferrous Bins 5 and 6 Identification Number",
      "SPN_Description": "Identification number of the Oil Debris Monitoring (ODM) sensor being reported for Ferrous bins 5 and 6. Identification numbers are application specific.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8174": {
      "PGN": 64493,
      "PGN_Name": "Oil Debris Monitor Counts Ferrous Bins 5 & 6",
      "PGN_Description": "ODMCF5_6",
      "first_bit": 8,
      "SPN": 8174,
      "SPN_Name": "Oil Debris Monitor Ferrous Bin 5 Count",
      "SPN_Description": "Total number of particles detected in Ferrous bin 5. Bin sizes are application specific.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8175": {
      "PGN": 64493,
      "PGN_Name": "Oil Debris Monitor Counts Ferrous Bins 5 & 6",
      "PGN_Description": "ODMCF5_6",
      "first_bit": 32,
      "SPN": 8175,
      "SPN_Name": "Oil Debris Monitor Ferrous Bin 6 Count",
      "SPN_Description": "Total number of particles detected in Ferrous bin 6. Bin sizes are application specific.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8176": {
      "PGN": 64494,
      "PGN_Name": "Oil Debris Monitor Counts Non-Ferrous Bins 1 & 2",
      "PGN_Description": "ODMCNF1_2",
      "first_bit": 0,
      "SPN": 8176,
      "SPN_Name": "Oil Debris Monitor Non-Ferrous Bins 1 and 2 Identification Number",
      "SPN_Description": "Identification number of the Oil Debris Monitoring (ODM) sensor being reported for Non-Ferrous bins 1 and 2.  Identification numbers are application specific.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8177": {
      "PGN": 64494,
      "PGN_Name": "Oil Debris Monitor Counts Non-Ferrous Bins 1 & 2",
      "PGN_Description": "ODMCNF1_2",
      "first_bit": 8,
      "SPN": 8177,
      "SPN_Name": "Oil Debris Monitor Non-Ferrous Bin 1 Count",
      "SPN_Description": "Total number of particles detected in Non-Ferrous bin 1. Bin sizes are application specific.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8178": {
      "PGN": 64494,
      "PGN_Name": "Oil Debris Monitor Counts Non-Ferrous Bins 1 & 2",
      "PGN_Description": "ODMCNF1_2",
      "first_bit": 32,
      "SPN": 8178,
      "SPN_Name": "Oil Debris Monitor Non-Ferrous Bin 2 Count",
      "SPN_Description": "Total number of particles detected in Non-Ferrous bin 2. Bin sizes are application specific.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8179": {
      "PGN": 64495,
      "PGN_Name": "Oil Debris Monitor Counts Non-Ferrous Bins 3 & 4",
      "PGN_Description": "ODMCNF3_4",
      "first_bit": 0,
      "SPN": 8179,
      "SPN_Name": "Oil Debris Monitor Non-Ferrous Bins 3 and 4 Identification Number",
      "SPN_Description": "Identification number of the Oil Debris Monitoring (ODM) sensor being reported for Non-Ferrous bins 3 and 4. Identification numbers are application specific.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8180": {
      "PGN": 64495,
      "PGN_Name": "Oil Debris Monitor Counts Non-Ferrous Bins 3 & 4",
      "PGN_Description": "ODMCNF3_4",
      "first_bit": 8,
      "SPN": 8180,
      "SPN_Name": "Oil Debris Monitor Non-Ferrous Bin 3 Count",
      "SPN_Description": "Total number of particles detected in Non-Ferrous bin 3. Bin sizes are application specific.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8181": {
      "PGN": 64495,
      "PGN_Name": "Oil Debris Monitor Counts Non-Ferrous Bins 3 & 4",
      "PGN_Description": "ODMCNF3_4",
      "first_bit": 32,
      "SPN": 8181,
      "SPN_Name": "Oil Debris Monitor Non-Ferrous Bin 4 Count",
      "SPN_Description": "Total number of particles detected in Non-Ferrous bin 4. Bin sizes are application specific.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8182": {
      "PGN": 64496,
      "PGN_Name": "Oil Debris Monitor Counts Non-Ferrous Bins 5 & 6",
      "PGN_Description": "ODMCNF5_6",
      "first_bit": 0,
      "SPN": 8182,
      "SPN_Name": "Oil Debris Monitor Non-Ferrous Bins 5 and 6 Identification Number",
      "SPN_Description": "Identification number of the Oil Debris Monitoring (ODM) sensor being reported for Non-Ferrous bins 5 and 6. Identification numbers are application specific.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8183": {
      "PGN": 64496,
      "PGN_Name": "Oil Debris Monitor Counts Non-Ferrous Bins 5 & 6",
      "PGN_Description": "ODMCNF5_6",
      "first_bit": 8,
      "SPN": 8183,
      "SPN_Name": "Oil Debris Monitor Non-Ferrous Bin 5 Count",
      "SPN_Description": "Total number of particles detected in Non-Ferrous bin 5. Bin sizes are application specific.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8184": {
      "PGN": 64496,
      "PGN_Name": "Oil Debris Monitor Counts Non-Ferrous Bins 5 & 6",
      "PGN_Description": "ODMCNF5_6",
      "first_bit": 32,
      "SPN": 8184,
      "SPN_Name": "Oil Debris Monitor Non-Ferrous Bin 6 Count",
      "SPN_Description": "Total number of particles detected in Non-Ferrous bin 6. Bin sizes are application specific.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8185": {
      "PGN": 64497,
      "PGN_Name": "Oil Debris Monitoring System Status",
      "PGN_Description": "ODMSS",
      "first_bit": 0,
      "SPN": 8185,
      "SPN_Name": "Oil Debris Monitor Status Identification Number",
      "SPN_Description": "Identification number of the Oil Debris Monitoring (ODM) sensor being reported. Identification numbers are application specific.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8186": {
      "PGN": 64497,
      "PGN_Name": "Oil Debris Monitoring System Status",
      "PGN_Description": "ODMSS",
      "first_bit": 8,
      "SPN": 8186,
      "SPN_Name": "Oil Debris Monitor Total number of Sensors",
      "SPN_Description": "Total number of Oil Debris Monitoring (ODM) sensors configured for this application.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8187": {
      "PGN": 64497,
      "PGN_Name": "Oil Debris Monitoring System Status",
      "PGN_Description": "ODMSS",
      "first_bit": 16,
      "SPN": 8187,
      "SPN_Name": "Oil Debris Monitor Environment Status",
      "SPN_Description": "Status of the electrical and mechanical environment surrounding the Oil Debris Monitor (ODM) Sensor.\r\n\r\n00 = Acceptable environment\r\n01 = Excessive noise in signal\r\n10 = Reserved\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8188": {
      "PGN": 64497,
      "PGN_Name": "Oil Debris Monitoring System Status",
      "PGN_Description": "ODMSS",
      "first_bit": 18,
      "SPN": 8188,
      "SPN_Name": "Oil Debris Monitor Sensing Element Status",
      "SPN_Description": "Status of the Oil Debris Monitor (ODM) sensing element.\r\n\r\n00 = Sensing element OK\r\n01 = Fault with sensing element\r\n10 = Reserved\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8189": {
      "PGN": 64497,
      "PGN_Name": "Oil Debris Monitoring System Status",
      "PGN_Description": "ODMSS",
      "first_bit": 20,
      "SPN": 8189,
      "SPN_Name": "Oil Debris Monitor Signal Processing Electronics Status",
      "SPN_Description": "Status of the Oil Debris Monitor (ODM) signal processing electronics.\r\n\r\n00 = Electronics functioning normally\r\n01 = Fault in electronics\r\n10 = Reserved\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8190": {
      "PGN": 64497,
      "PGN_Name": "Oil Debris Monitoring System Status",
      "PGN_Description": "ODMSS",
      "first_bit": 22,
      "SPN": 8190,
      "SPN_Name": "Oil Debris Monitor Electronics Temperature Status",
      "SPN_Description": "Temperature indicator for the Oil Debris Monitor (ODM) Electronics.\r\n\r\n00 = Acceptable temperature\r\n01 = Temperature is outside of limits\r\n10 = Reserved\r\n11 = Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8191": {
      "PGN": 29184,
      "PGN_Name": "Oil Debris Monitor Configuration Command",
      "PGN_Description": "ODMCC",
      "first_bit": 0,
      "SPN": 8191,
      "SPN_Name": "Oil Debris Monitor Configuration Identification Number",
      "SPN_Description": "Identification number of the Oil Debris Monitoring (ODM) sensor being configured. Identification numbers are application specific.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8192": {
      "PGN": 29184,
      "PGN_Name": "Oil Debris Monitor Configuration Command",
      "PGN_Description": "ODMCC",
      "first_bit": 8,
      "SPN": 8192,
      "SPN_Name": "Oil Debris Monitor Ferrous Bin 1 Count Command",
      "SPN_Description": "New starting value for total count of particles detected in Ferrous bin 1.\r\n\r\nNOTE: The value 0xFFFFFF indicates \"Do Not Change\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8193": {
      "PGN": 29184,
      "PGN_Name": "Oil Debris Monitor Configuration Command",
      "PGN_Description": "ODMCC",
      "first_bit": 32,
      "SPN": 8193,
      "SPN_Name": "Oil Debris Monitor Ferrous Bin 2 Count Command",
      "SPN_Description": "New starting value for total count of particles detected in Ferrous bin 2.\r\n\r\nNOTE: The value 0xFFFFFF indicates \"Do Not Change\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8194": {
      "PGN": 29184,
      "PGN_Name": "Oil Debris Monitor Configuration Command",
      "PGN_Description": "ODMCC",
      "first_bit": 56,
      "SPN": 8194,
      "SPN_Name": "Oil Debris Monitor Ferrous Bin 3 Count Command",
      "SPN_Description": "New starting value for total count of particles detected in Ferrous bin 3.\r\n\r\nNOTE: The value 0xFFFFFF indicates \"Do Not Change\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8195": {
      "PGN": 29184,
      "PGN_Name": "Oil Debris Monitor Configuration Command",
      "PGN_Description": "ODMCC",
      "first_bit": 80,
      "SPN": 8195,
      "SPN_Name": "Oil Debris Monitor Ferrous Bin 4 Count Command",
      "SPN_Description": "New starting value for total count of particles detected in Ferrous bin 4.\r\n\r\nNOTE: The value 0xFFFFFF indicates \"Do Not Change\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8196": {
      "PGN": 29184,
      "PGN_Name": "Oil Debris Monitor Configuration Command",
      "PGN_Description": "ODMCC",
      "first_bit": 104,
      "SPN": 8196,
      "SPN_Name": "Oil Debris Monitor Ferrous Bin 5 Count Command",
      "SPN_Description": "New starting value for total count of particles detected in Ferrous bin 5.\r\n\r\nNOTE: The value 0xFFFFFF indicates \"Do Not Change\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8197": {
      "PGN": 29184,
      "PGN_Name": "Oil Debris Monitor Configuration Command",
      "PGN_Description": "ODMCC",
      "first_bit": 128,
      "SPN": 8197,
      "SPN_Name": "Oil Debris Monitor Ferrous Bin 6 Count Command",
      "SPN_Description": "New starting value for total count of particles detected in Ferrous bin 6.\r\n\r\nNOTE: The value 0xFFFFFF indicates \"Do Not Change\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8198": {
      "PGN": 29184,
      "PGN_Name": "Oil Debris Monitor Configuration Command",
      "PGN_Description": "ODMCC",
      "first_bit": 152,
      "SPN": 8198,
      "SPN_Name": "Oil Debris Monitor Non-Ferrous Bin 1 Count Command",
      "SPN_Description": "New starting value for total count of particles detected in Non-Ferrous bin 1.\r\n\r\nNOTE: The value 0xFFFFFF indicates \"Do Not Change\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8199": {
      "PGN": 29184,
      "PGN_Name": "Oil Debris Monitor Configuration Command",
      "PGN_Description": "ODMCC",
      "first_bit": 176,
      "SPN": 8199,
      "SPN_Name": "Oil Debris Monitor Non-Ferrous Bin 2 Count Command",
      "SPN_Description": "New starting value for total count of particles detected in Non-Ferrous bin 2.\r\n\r\nNOTE: The value 0xFFFFFF indicates \"Do Not Change\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8200": {
      "PGN": 29184,
      "PGN_Name": "Oil Debris Monitor Configuration Command",
      "PGN_Description": "ODMCC",
      "first_bit": 200,
      "SPN": 8200,
      "SPN_Name": "Oil Debris Monitor Non-Ferrous Bin 3 Count Command",
      "SPN_Description": "New starting value for total count of particles detected in Non-Ferrous bin 3.\r\n\r\nNOTE: The value 0xFFFFFF indicates \"Do Not Change\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8201": {
      "PGN": 29184,
      "PGN_Name": "Oil Debris Monitor Configuration Command",
      "PGN_Description": "ODMCC",
      "first_bit": 224,
      "SPN": 8201,
      "SPN_Name": "Oil Debris Monitor Non-Ferrous Bin 4 Count Command",
      "SPN_Description": "New starting value for total count of particles detected in Non-Ferrous bin 4.\r\n\r\nNOTE: The value 0xFFFFFF indicates \"Do Not Change\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8202": {
      "PGN": 29184,
      "PGN_Name": "Oil Debris Monitor Configuration Command",
      "PGN_Description": "ODMCC",
      "first_bit": 248,
      "SPN": 8202,
      "SPN_Name": "Oil Debris Monitor Non-Ferrous Bin 5 Count Command",
      "SPN_Description": "New starting value for total count of particles detected in Non-Ferrous bin 5.\r\n\r\nNOTE: The value 0xFFFFFF indicates \"Do Not Change\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8203": {
      "PGN": 29184,
      "PGN_Name": "Oil Debris Monitor Configuration Command",
      "PGN_Description": "ODMCC",
      "first_bit": 272,
      "SPN": 8203,
      "SPN_Name": "Oil Debris Monitor Non-Ferrous Bin 6 Count Command",
      "SPN_Description": "New starting value for total count of particles detected in Non-Ferrous bin 6.\r\n\r\nNOTE: The value 0xFFFFFF indicates \"Do Not Change\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 422
    },
    "8204": {
      "PGN": 61589,
      "PGN_Name": "High Voltage Energy Storage 1 Data 6",
      "PGN_Description": "HVES1D6",
      "first_bit": 48,
      "SPN": 8204,
      "SPN_Name": "HVES1 Electronics Temperature",
      "SPN_Description": "The temperature of the electronics or control modules in the High Voltage Energy Storage 1 pack (or system).  If there are mulitple temperature sensors then this parameter would be set to the maximum sensor reading.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8205": {
      "PGN": 61600,
      "PGN_Name": "High Voltage Energy Storage 1 Data 7",
      "PGN_Description": "HVES1D7",
      "first_bit": 0,
      "SPN": 8205,
      "SPN_Name": "HVES1 Discharge Energy Capacity",
      "SPN_Description": "The amount of stored electrical energy in High Voltage Energy Storage 1 pack (or system) that is available for use by the hybrid system, i.e. “how full is the tank”.  See HVES1 Discharge Capacity (SPN 8079) for Ampere-hours (Ah).",
      "bit_length": 24,
      "scaling": 0.001,
      "offset": 0,
      "unit": "kWh",
      "SLOT_ID": 418
    },
    "8206": {
      "PGN": 61600,
      "PGN_Name": "High Voltage Energy Storage 1 Data 7",
      "PGN_Description": "HVES1D7",
      "first_bit": 24,
      "SPN": 8206,
      "SPN_Name": "HVES1 Charge Energy Capacity",
      "SPN_Description": "The amount of unused electrical energy storage available to be filled by charging High Voltage Energy Storage 1 pack (or system), i.e. “how much empty space is remaining in the tank”.  See HVES1 Charge Capacity (SPN 8080) for Ampere-hours (Ah).",
      "bit_length": 24,
      "scaling": 0.001,
      "offset": 0,
      "unit": "kWh",
      "SLOT_ID": 418
    },
    "8207": {
      "PGN": 61590,
      "PGN_Name": "High Voltage Energy Storage 1 Status 1",
      "PGN_Description": "HVES1S1",
      "first_bit": 32,
      "SPN": 8207,
      "SPN_Name": "HVES1 Internal Charger Status",
      "SPN_Description": "Indicates that the charger in the HVES1 is on.  External chargers may use the External Energy Source Connection Status (SPN 7898) and related SPNs.\r\n\r\n00 - Charging off\r\n01 - Charging on\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8208": {
      "PGN": 64605,
      "PGN_Name": "High Voltage Energy Storage 1 Configuration",
      "PGN_Description": "HVES1CFG",
      "first_bit": 96,
      "SPN": 8208,
      "SPN_Name": "HVES1 Recommended Minimum Operating Temperature",
      "SPN_Description": "Per the HVES manufacturer, this is the recommended minimum temperature for High Voltage Energy Storage 1 pack (or system) operation.  Operating below this value may damage HVES hardware, or compromise HVES life.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8209": {
      "PGN": 64605,
      "PGN_Name": "High Voltage Energy Storage 1 Configuration",
      "PGN_Description": "HVES1CFG",
      "first_bit": 112,
      "SPN": 8209,
      "SPN_Name": "HVES1 Cell Maximum Voltage Limit",
      "SPN_Description": "Per the HVES manufacturer, this is the maximum cell voltage for High Voltage Energy Storage 1 pack (or system) operation.  Operating above this value may damage HVES hardware, or compromise HVES life.",
      "bit_length": 8,
      "scaling": 0.02044,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 423
    },
    "8210": {
      "PGN": 64605,
      "PGN_Name": "High Voltage Energy Storage 1 Configuration",
      "PGN_Description": "HVES1CFG",
      "first_bit": 120,
      "SPN": 8210,
      "SPN_Name": "HVES1 Cell Minimum Voltage Limit",
      "SPN_Description": "Per the HVES manufacturer, this is the minimum cell voltage for High Voltage Energy Storage 1 pack (or system) operation.  Operating below this value may damage HVES hardware, or compromise HVES life.",
      "bit_length": 8,
      "scaling": 0.02044,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 423
    },
    "8211": {
      "PGN": 64606,
      "PGN_Name": "High Voltage Energy Storage 1 History",
      "PGN_Description": "HVES1HIST",
      "first_bit": 24,
      "SPN": 8211,
      "SPN_Name": "HVES1 Total Energy Throughput",
      "SPN_Description": "The total energy throughput which has flowed through High Voltage Energy Storage 1 pack (or system).  This parameter is the sum of the absolute values of the Energy into and out of HVES1.  \n",
      "bit_length": 32,
      "scaling": 100,
      "offset": 0,
      "unit": "Watt-hour",
      "SLOT_ID": 424
    },
    "8212": {
      "PGN": 64606,
      "PGN_Name": "High Voltage Energy Storage 1 History",
      "PGN_Description": "HVES1HIST",
      "first_bit": 56,
      "SPN": 8212,
      "SPN_Name": "HVES1 Total Accumulated Charge",
      "SPN_Description": "The total accumulated amp hours which have flowed through High Voltage Energy Storage 1 pack (or system).  This parameter is the sum of the absolute values of the Ampere hours into and out of HVES1.  \n",
      "bit_length": 32,
      "scaling": 100,
      "offset": 0,
      "unit": "Ah",
      "SLOT_ID": 343
    },
    "8213": {
      "PGN": 6912,
      "PGN_Name": "High Voltage Energy Storage 1 Control 1",
      "PGN_Description": "HVES1C1",
      "first_bit": 10,
      "SPN": 8213,
      "SPN_Name": "HVES1 Enable Internal Charger Command",
      "SPN_Description": "When the HVES has an internal charger this parameter will enable it.   External chargers may use the External Energy Source Connection Demand (SPN 7890) and related SPNs.\r\n\r\n00 Disable charging\r\n01 Enable charging\r\n10 Reserved\r\n11 Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8214": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 0,
      "SPN": 8214,
      "SPN_Name": "HVES1 Module 1 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 1.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8215": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 2,
      "SPN": 8215,
      "SPN_Name": "HVES1 Module 2 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 2.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8216": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 4,
      "SPN": 8216,
      "SPN_Name": "HVES1 Module 3 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 3.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8217": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 6,
      "SPN": 8217,
      "SPN_Name": "HVES1 Module 4 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 4.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8218": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 8,
      "SPN": 8218,
      "SPN_Name": "HVES1 Module 5 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 5.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8219": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 10,
      "SPN": 8219,
      "SPN_Name": "HVES1 Module 6 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 6.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8220": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 12,
      "SPN": 8220,
      "SPN_Name": "HVES1 Module 7 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 7.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8221": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 14,
      "SPN": 8221,
      "SPN_Name": "HVES1 Module 8 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 8.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8222": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 16,
      "SPN": 8222,
      "SPN_Name": "HVES1 Module 9 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 9.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8223": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 18,
      "SPN": 8223,
      "SPN_Name": "HVES1 Module 10 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 10.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8224": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 20,
      "SPN": 8224,
      "SPN_Name": "HVES1 Module 11 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 11.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8225": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 22,
      "SPN": 8225,
      "SPN_Name": "HVES1 Module 12 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 12.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8226": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 24,
      "SPN": 8226,
      "SPN_Name": "HVES1 Module 13 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 13.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8227": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 26,
      "SPN": 8227,
      "SPN_Name": "HVES1 Module 14 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 14.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8228": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 28,
      "SPN": 8228,
      "SPN_Name": "HVES1 Module 15 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 15.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8229": {
      "PGN": 61704,
      "PGN_Name": "High Voltage Energy Storage 1 Module Status 1",
      "PGN_Description": "HVES1MS1",
      "first_bit": 30,
      "SPN": 8229,
      "SPN_Name": "HVES1 Module 16 Operational Status",
      "SPN_Description": "Operational Status of the High Voltage Energy Storage 1 Module 16.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\r\n\r\n00 - Not Operational\r\n01 - Operational\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8230": {
      "PGN": 61705,
      "PGN_Name": "High Voltage Energy Storage 1 Thermal Management System Status 1",
      "PGN_Description": "HVES1TS1",
      "first_bit": 0,
      "SPN": 8230,
      "SPN_Name": "HVES1 Thermal Management System SLI Input Power",
      "SPN_Description": "In multiple HVES configurations, this is the low-voltage power consumed by the HVES1 Thermal Management System (TMS).   If there is only one HVES, or a single TMS for all HVES, then this represents the total low-voltage power consumed.  ",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "W",
      "SLOT_ID": 305
    },
    "8231": {
      "PGN": 61705,
      "PGN_Name": "High Voltage Energy Storage 1 Thermal Management System Status 1",
      "PGN_Description": "HVES1TS1",
      "first_bit": 16,
      "SPN": 8231,
      "SPN_Name": "HVES1 Thermal Management System High-Voltage Input Power",
      "SPN_Description": "In multiple HVES configurations, this is the high-voltage power consumed by the HVES1 Thermal Management System (TMS).   If there is only one HVES, or a single TMS for all HVES, then this represents the total high voltage power consumed.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "W",
      "SLOT_ID": 305
    },
    "8232": {
      "PGN": 61705,
      "PGN_Name": "High Voltage Energy Storage 1 Thermal Management System Status 1",
      "PGN_Description": "HVES1TS1",
      "first_bit": 32,
      "SPN": 8232,
      "SPN_Name": "HVES1 Thermal Management System Compressor Speed",
      "SPN_Description": "When the High Voltage Energy Storage 1 Thermal Management System is equipped with an active cooling system (e.g. air conditioner), this is the Compressor Speed.",
      "bit_length": 8,
      "scaling": 32,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 97
    },
    "8233": {
      "PGN": 61705,
      "PGN_Name": "High Voltage Energy Storage 1 Thermal Management System Status 1",
      "PGN_Description": "HVES1TS1",
      "first_bit": 40,
      "SPN": 8233,
      "SPN_Name": "HVES1 Thermal Management System Relative Humidty",
      "SPN_Description": "When the High Voltage Energy Storage 1 Thermal Management System is equipped with a relative humidity sensor, this is the  measured Relative Humidity.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "8234": {
      "PGN": 61705,
      "PGN_Name": "High Voltage Energy Storage 1 Thermal Management System Status 1",
      "PGN_Description": "HVES1TS1",
      "first_bit": 48,
      "SPN": 8234,
      "SPN_Name": "HVES1 Thermal Management System Heater Status",
      "SPN_Description": "This is the state of the High Voltage Energy Storage 1 heater\r\n\r\n00 - Heater Off\r\n01 - Heater On\r\n10 - Error \r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8235": {
      "PGN": 61705,
      "PGN_Name": "High Voltage Energy Storage 1 Thermal Management System Status 1",
      "PGN_Description": "HVES1TS1",
      "first_bit": 52,
      "SPN": 8235,
      "SPN_Name": "HVES1 Thermal Management System Mode",
      "SPN_Description": "Indicates the operating mode of the Thermal Management System.  The heat transfer medium may be (e.g. liquid or air).  The cooling system may be fans, liquid coolant, or a combination of mediums.  The system may include an air and/or liquid conditioning system with active Cooling, Heating, and/or Drying capabilities.  \r\n\r\n0000 = Off\r\n0001 = Circulating\r\n0010 = Cooling\r\n0011 = Heating\r\n0100 = Drying\r\n0101 - 1101 = Reserved\r\n1110 = Faulted\r\n1111 = Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8236": {
      "PGN": 61706,
      "PGN_Name": "High Voltage Energy Storage 1 Data 8",
      "PGN_Description": "HVES1D8",
      "first_bit": 0,
      "SPN": 8236,
      "SPN_Name": "HVES1 Highest Cell Voltage Module Number ",
      "SPN_Description": "Identifies the location of the module containing the HVES1 Highest Cell Voltage (SPN 5922).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8237": {
      "PGN": 61706,
      "PGN_Name": "High Voltage Energy Storage 1 Data 8",
      "PGN_Description": "HVES1D8",
      "first_bit": 8,
      "SPN": 8237,
      "SPN_Name": "HVES1 Highest Cell Voltage Cell Number ",
      "SPN_Description": "Identifies the location of HVES1 Highest Cell Voltage (SPN 5922) within the HVES1 Highest Cell Voltage Module Number (SPN 8236).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8238": {
      "PGN": 61706,
      "PGN_Name": "High Voltage Energy Storage 1 Data 8",
      "PGN_Description": "HVES1D8",
      "first_bit": 16,
      "SPN": 8238,
      "SPN_Name": "HVES1 Lowest Cell Voltage Module Number ",
      "SPN_Description": "Identifies the location of the module containing the HVES1 Lowest Cell Voltage (SPN 5923).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8239": {
      "PGN": 61706,
      "PGN_Name": "High Voltage Energy Storage 1 Data 8",
      "PGN_Description": "HVES1D8",
      "first_bit": 24,
      "SPN": 8239,
      "SPN_Name": "HVES1 Lowest Cell Voltage Cell Number ",
      "SPN_Description": "Identifies the location of the HVES1 Lowest Cell Voltage (SPN 5923) within the HVES1 Lowest Cell Voltage Module Number (SPN 8238).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8240": {
      "PGN": 61706,
      "PGN_Name": "High Voltage Energy Storage 1 Data 8",
      "PGN_Description": "HVES1D8",
      "first_bit": 32,
      "SPN": 8240,
      "SPN_Name": "HVES1 Average Cell Voltage",
      "SPN_Description": "The average cell voltage in the High Voltage Energy Storage 1 pack (or system).",
      "bit_length": 16,
      "scaling": 0.001,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 347
    },
    "8241": {
      "PGN": 61707,
      "PGN_Name": "High Voltage Energy Storage 1 Data 9",
      "PGN_Description": "HVES1D9",
      "first_bit": 0,
      "SPN": 8241,
      "SPN_Name": "HVES1 Highest Cell Temperature Module Number ",
      "SPN_Description": "Identifies the location of the module containing the HVES1 Highest Cell Temperature (SPN 8075).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8242": {
      "PGN": 61707,
      "PGN_Name": "High Voltage Energy Storage 1 Data 9",
      "PGN_Description": "HVES1D9",
      "first_bit": 8,
      "SPN": 8242,
      "SPN_Name": "HVES1 Highest Cell Temperature Cell Number ",
      "SPN_Description": "Identifies the location of the HVES1 Highest Cell Temperature (SPN 8075) within the HVES1 Highest Cell Temperature Module Number (SPN 8241).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8243": {
      "PGN": 61707,
      "PGN_Name": "High Voltage Energy Storage 1 Data 9",
      "PGN_Description": "HVES1D9",
      "first_bit": 16,
      "SPN": 8243,
      "SPN_Name": "HVES1 Lowest Cell Temperature Module Number ",
      "SPN_Description": "Identifies the location of the module containing the HVES1 Lowest Cell Temperature (SPN 8076).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8244": {
      "PGN": 61707,
      "PGN_Name": "High Voltage Energy Storage 1 Data 9",
      "PGN_Description": "HVES1D9",
      "first_bit": 24,
      "SPN": 8244,
      "SPN_Name": "HVES1 Lowest Cell Temperature Cell Number ",
      "SPN_Description": "Identifies the location of the HVES1 Lowest Cell Temperature (SPN 8076) within the HVES1 Lowest Cell Temperature Module Number (SPN 8243).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8245": {
      "PGN": 61708,
      "PGN_Name": "High Voltage Energy Storage 1 Data 10",
      "PGN_Description": "HVES1D10",
      "first_bit": 0,
      "SPN": 8245,
      "SPN_Name": "HVES1 Highest Cell State of Charge Module Number ",
      "SPN_Description": "Identifies the location of the module containing the HVES1 Highest Cell State of Charge (SPN 8085).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8246": {
      "PGN": 61708,
      "PGN_Name": "High Voltage Energy Storage 1 Data 10",
      "PGN_Description": "HVES1D10",
      "first_bit": 8,
      "SPN": 8246,
      "SPN_Name": "HVES1 Highest Cell State of Charge Cell Number ",
      "SPN_Description": "Identifies the location of the HVES1 Highest Cell State of Charge (SPN 8085) within the HVES1 Highest Cell State of Charge Module Number (SPN 8245).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8247": {
      "PGN": 61708,
      "PGN_Name": "High Voltage Energy Storage 1 Data 10",
      "PGN_Description": "HVES1D10",
      "first_bit": 16,
      "SPN": 8247,
      "SPN_Name": "HVES1 Lowest Cell State of Charge Module Number ",
      "SPN_Description": "Identifies the location of the module containing the HVES1 Lowest Cell State of Charge (SPN 8084).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8248": {
      "PGN": 61708,
      "PGN_Name": "High Voltage Energy Storage 1 Data 10",
      "PGN_Description": "HVES1D10",
      "first_bit": 24,
      "SPN": 8248,
      "SPN_Name": "HVES1 Lowest Cell State of Charge Cell Number ",
      "SPN_Description": "Identifies the location of the HVES1 Lowest Cell State of Charge (SPN 8084) within the HVES1 Lowest Cell State of Charge Module Number (SPN 8247).",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 129
    },
    "8267": {
      "PGN": 64706,
      "PGN_Name": "Hybrid System Status 1",
      "PGN_Description": "HSS1",
      "first_bit": 52,
      "SPN": 8267,
      "SPN_Name": "Hybrid System Propulsion Disable Status",
      "SPN_Description": "Indicates if the hybrid system is in a state where propulsion is not available. This may be due to Hybrid System Propulsion Disable Request (SPN 7558), Hybrid System Propulsion Disable Switch (SPN 7554), or Hybrid System Off-Board Charger Connection Status (SPN 7551) being active. It may also be due to other internal hybrid reasons for propulsion being disabled (e.g. charging, pre-charge not complete, warm-up modes).\r\n\r\n00 = Propulsion not disabled\r\n01 = Propulsion is disabled\r\n10 = Error\r\n11 = Not Available\r\n\r\nNote: Propulsion System Active (SPN 7315) should not be used as an indication of propulsion being disabled as it is required to indicate that the propulsion system is active whenever the engine is running regardless of the state of the hybrid systems ability to provide propulsion power.",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8268": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 0,
      "SPN": 8268,
      "SPN_Name": "DHCP Status",
      "SPN_Description": "DHCP Client Status. This parameter is intended to provide feedback on the status of obtaining an IP address. When no physical link is available and DHCP is enabled, an Error response is appropriate.\r\n\r\n0000 - Not Configured (static IP)\r\n0001 - Obtaining IP\r\n0010 - IP Leased\r\n0011 - Contacting DHCP Server\r\n0100 - SAE Reserved\r\n0101 - SAE Reserved\r\n0110 - SAE Reserved\r\n0111 - SAE Reserved\r\n1000 - SAE Reserved\r\n1001 - SAE Reserved\r\n1010 - SAE Reserved\r\n1011 - SAE Reserved\r\n1100 - SAE Reserved\r\n1101 - SAE Reserved\r\n1110 - Error\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8269": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 4,
      "SPN": 8269,
      "SPN_Name": "Ethernet Link Status",
      "SPN_Description": "Ethernet Link Status. When there is no physical connection, the status shall report 00. \r\n\r\n00 - Ethernet Link Down\r\n01 - Ethernet Link Up\r\n10 - Error\r\n11 - Not Supported",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8270": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 8,
      "SPN": 8270,
      "SPN_Name": "IPv4 Address Octet 1",
      "SPN_Description": "This value is the first of 4 octets in the ECU's assigned Internet Protocol (IP) address. The address is separated into 4 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the IP address is not configured or not assigned, the byte positions shall be filled with FF.\r\n\r\nExample:\r\nOctet1.Octet2.Octet3.Octet4\r\nByte1.Byte2.Byte3.Byte4\r\nSPN 8270.SPN 8271.SPN 8272.SPN 8273",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8271": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 16,
      "SPN": 8271,
      "SPN_Name": "IPv4 Address Octet 2",
      "SPN_Description": "This value is the second of 4 octets in the ECU's assigned Internet Protocol (IP) address. The address is separated into 4 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the IP address is not configured or not assigned, the byte positions shall be filled with FF.\r\n\r\nExample:\r\nOctet1.Octet2.Octet3.Octet4\r\nByte1.Byte2.Byte3.Byte4\r\nSPN 8270.SPN 8271.SPN 8272.SPN 8273",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8272": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 24,
      "SPN": 8272,
      "SPN_Name": "IPv4 Address Octet 3",
      "SPN_Description": "This value is the third of 4 octets in the ECU's assigned Internet Protocol (IP) address. The address is separated into 4 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the IP address is not configured or not assigned, the byte positions shall be filled with FF.\r\n\r\nExample:\r\nOctet1.Octet2.Octet3.Octet4\r\nByte1.Byte2.Byte3.Byte4\r\nSPN 8270.SPN 8271.SPN 8272.SPN 8273",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8273": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 32,
      "SPN": 8273,
      "SPN_Name": "IPv4 Address Octet 4",
      "SPN_Description": "This value is the fourth of 4 octets in the ECU's assigned Internet Protocol (IP) address. The address is separated into 4 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the IP address is not configured or not assigned, the byte positions shall be filled with FF.\r\n\r\nExample:\r\nOctet1.Octet2.Octet3.Octet4\r\nByte1.Byte2.Byte3.Byte4\r\nSPN 8270.SPN 8271.SPN 8272.SPN 8273",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8274": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 40,
      "SPN": 8274,
      "SPN_Name": "Subnet Mask Octet 1",
      "SPN_Description": "This value is the first of 4 octets in the ECU's configured Subnet mask. The subnet mask is separated into 4 bytes, 1 per octet of the mask. Byte 1 is the first octet of the mask. Byte 2 is the second and so forth. If the Subnet mask is not configured, the byte positions shall be filled with 0xFF.\r\n\r\nExample:\r\nOctet1.Octet2.Octet3.Octet4\r\nByte1.Byte2.Byte3.Byte4\r\nSPN 8274.SPN 8275.SPN 8276.SPN 8277",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8275": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 48,
      "SPN": 8275,
      "SPN_Name": "Subnet Mask Octet 2",
      "SPN_Description": "This value is the second of 4 octets in the ECU's configured Subnet mask. The subnet mask is separated into 4 bytes, 1 per octet of the mask. Byte 1 is the first octet of the mask. Byte 2 is the second and so forth. If the Subnet mask is not configured, the byte positions shall be filled with 0xFF.\r\n\r\nExample:\r\nOctet1.Octet2.Octet3.Octet4\r\nByte1.Byte2.Byte3.Byte4\r\nSPN 8274.SPN 8275.SPN 8276.SPN 8277",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8276": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 56,
      "SPN": 8276,
      "SPN_Name": "Subnet Mask Octet 3",
      "SPN_Description": "This value is the third of 4 octets in the ECU's configured Subnet mask. The subnet mask is separated into 4 bytes, 1 per octet of the mask. Byte 1 is the first octet of the mask. Byte 2 is the second and so forth. If the Subnet mask is not configured, the byte positions shall be filled with 0xFF.\r\n\r\nExample:\r\nOctet1.Octet2.Octet3.Octet4\r\nByte1.Byte2.Byte3.Byte4\r\nSPN 8274.SPN 8275.SPN 8276.SPN 8277",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8277": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 64,
      "SPN": 8277,
      "SPN_Name": "Subnet Mask Octet 4",
      "SPN_Description": "This value is the fourth of 4 octets in the ECU's configured Subnet mask. The subnet mask is separated into 4 bytes, 1 per octet of the mask. Byte 1 is the first octet of the mask. Byte 2 is the second and so forth. If the Subnet mask is not configured, the byte positions shall be filled with 0xFF.\r\n\r\nExample:\r\nOctet1.Octet2.Octet3.Octet4\r\nByte1.Byte2.Byte3.Byte4\r\nSPN 8274.SPN 8275.SPN 8276.SPN 8277",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8278": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 72,
      "SPN": 8278,
      "SPN_Name": "Default Gateway Octet 1",
      "SPN_Description": "This value is the first of 4 octets in the ECU's configured or assigned Default Gateway IP address.  The Default Gateway IP address is separated into 4 bytes, 1 per octet of the address Byte 1 is the first octet of the address Byte 2 is the second and so forth. If the Default Gateway IP address is not configured or assigned, the byte positions shall be filled with 0xFF.\r\n\r\nExample:\r\nOctet1.Octet2.Octet3.Octet4\r\nByte1.Byte2.Byte3.Byte4\r\nSPN 8278.SPN 8279.SPN 8280.SPN 8281",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8279": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 80,
      "SPN": 8279,
      "SPN_Name": "Default Gateway Octet 2",
      "SPN_Description": "This value is the second of 4 octets in the ECU's configured or assigned Default Gateway IP address.  The Default Gateway IP address is separated into 4 bytes, 1 per octet of the address Byte 1 is the first octet of the address Byte 2 is the second and so forth. If the Default Gateway IP address is not configured or assigned, the byte positions shall be filled with 0xFF.\r\n\r\nExample:\r\nOctet1.Octet2.Octet3.Octet4\r\nByte1.Byte2.Byte3.Byte4\r\nSPN 8278.SPN 8279.SPN 8280.SPN 8281",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8280": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 88,
      "SPN": 8280,
      "SPN_Name": "Default Gateway Octet 3",
      "SPN_Description": "This value is the third of 4 octets in the ECU's configured or assigned Default Gateway IP address.  The Default Gateway IP address is separated into 4 bytes, 1 per octet of the address Byte 1 is the first octet of the address Byte 2 is the second and so forth. If the Default Gateway IP address is not configured or assigned, the byte positions shall be filled with 0xFF.\r\n\r\nExample:\r\nOctet1.Octet2.Octet3.Octet4\r\nByte1.Byte2.Byte3.Byte4\r\nSPN 8278.SPN 8279.SPN 8280.SPN 8281",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8281": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 96,
      "SPN": 8281,
      "SPN_Name": "Default Gateway Octet 4",
      "SPN_Description": "This value is the fourth of 4 octets in the ECU's configured or assigned Default Gateway IP address.  The Default Gateway IP address is separated into 4 bytes, 1 per octet of the address Byte 1 is the first octet of the address Byte 2 is the second and so forth. If the Default Gateway IP address is not configured or assigned, the byte positions shall be filled with 0xFF.\r\n\r\nExample:\r\nOctet1.Octet2.Octet3.Octet4\r\nByte1.Byte2.Byte3.Byte4\r\nSPN 8278.SPN 8279.SPN 8280.SPN 8281",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8282": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 104,
      "SPN": 8282,
      "SPN_Name": "MAC Address Octet 1",
      "SPN_Description": "This value is the first of 6 octets in the ECU's assigned MAC address. The address is separated into 6 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the MAC address is not configured or not assigned, the byte positions shall be filled with FF.\r\n\r\nExample:\r\nOctet1:Octet2:Octet3:Octet4:Octet5:Octet6\r\nByte1:Byte2:Byte3:Byte4:Byte5:Byte6\r\nSPN 8282:SPN 8283:SPN 8284:SPN 8285:SPN 8286:SPN 8287",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8283": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 112,
      "SPN": 8283,
      "SPN_Name": "MAC Address Octet 2",
      "SPN_Description": "This value is the second of 6 octets in the ECU's assigned MAC address. The address is separated into 6 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the MAC address is not configured or not assigned, the byte positions shall be filled with FF.\r\n\r\nExample:\r\nOctet1:Octet2:Octet3:Octet4:Octet5:Octet6\r\nByte1:Byte2:Byte3:Byte4:Byte5:Byte6\r\nSPN 8282:SPN 8283:SPN 8284:SPN 8285:SPN 8286:SPN 8287",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8284": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 120,
      "SPN": 8284,
      "SPN_Name": "MAC Address Octet 3",
      "SPN_Description": "This value is the third of 6 octets in the ECU's assigned MAC address. The address is separated into 6 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the MAC address is not configured or not assigned, the byte positions shall be filled with FF.\r\n\r\nExample:\r\nOctet1:Octet2:Octet3:Octet4:Octet5:Octet6\r\nByte1:Byte2:Byte3:Byte4:Byte5:Byte6\r\nSPN 8282:SPN 8283:SPN 8284:SPN 8285:SPN 8286:SPN 8287",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8285": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 128,
      "SPN": 8285,
      "SPN_Name": "MAC Address Octet 4",
      "SPN_Description": "This value is the fourth of 6 octets in the ECU's assigned MAC address. The address is separated into 6 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the MAC address is not configured or not assigned, the byte positions shall be filled with FF.\r\n\r\nExample:\r\nOctet1:Octet2:Octet3:Octet4:Octet5:Octet6\r\nByte1:Byte2:Byte3:Byte4:Byte5:Byte6\r\nSPN 8282:SPN 8283:SPN 8284:SPN 8285:SPN 8286:SPN 8287",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8286": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 136,
      "SPN": 8286,
      "SPN_Name": "MAC Address Octet 5",
      "SPN_Description": "This value is the fifth of 6 octets in the ECU's assigned MAC address. The address is separated into 6 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the MAC address is not configured or not assigned, the byte positions shall be filled with FF.\r\n\r\nExample:\r\nOctet1:Octet2:Octet3:Octet4:Octet5:Octet6\r\nByte1:Byte2:Byte3:Byte4:Byte5:Byte6\r\nSPN 8282:SPN 8283:SPN 8284:SPN 8285:SPN 8286:SPN 8287",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8287": {
      "PGN": 64490,
      "PGN_Name": "Ethernet 1 Connection Information 1",
      "PGN_Description": "E1NET1",
      "first_bit": 144,
      "SPN": 8287,
      "SPN_Name": "MAC Address Octet 6",
      "SPN_Description": "This value is the sixth of 6 octets in the ECU's assigned MAC address. The address is separated into 6 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the MAC address is not configured or not assigned, the byte positions shall be filled with FF.\r\n\r\nExample:\r\nOctet1:Octet2:Octet3:Octet4:Octet5:Octet6\r\nByte1:Byte2:Byte3:Byte4:Byte5:Byte6\r\nSPN 8282:SPN 8283:SPN 8284:SPN 8285:SPN 8286:SPN 8287",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 133
    },
    "8291": {
      "PGN": 65098,
      "PGN_Name": "Electronic Transmission Controller 7",
      "PGN_Description": "ETC7",
      "first_bit": 54,
      "SPN": 8291,
      "SPN_Name": "Transmission Manual Mode Indicator",
      "SPN_Description": "This parameter indicates if the operator has selected a Manual Mode of the transmission. When a Manual Mode is active, the operator has directly and intentionally restricted the available transmission ranges for the given vehicle direction. A Manual Mode may require direct operator input before any shifts are initiated (e.g. “Upshift” or “Downshift” inputs), or may just prevent the transmission from achieving its maximum range in that direction (e.g. via selection of “Low” or another range below the maximum). When not in Manual Mode, the transmission always selects the optimum range for current operating conditions, and initiates any shifts as needed.\r\n\r\nManual Modes are typically associated with forward ranges. However, Manual Modes may also be available in applications where the transmission supports multiple reverse ranges.\r\n\r\nManual Mode should not be indicated when the transmission is in Park or Neutral, nor when another vehicle function (e.g. engine braking, adaptive cruise control) modifies the shift schedule or available transmission ranges.\r\n\r\n00 – Transmission is not in a Manual Mode\r\n01 – Transmission is in a Manual Mode\r\n10 – Reserved\r\n11 – Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8292": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 32,
      "SPN": 8292,
      "SPN_Name": "Electrified Accessory Motor Instance 1",
      "SPN_Description": "Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Accessory Motor Instance\r\n1 - No Command applied to this Accessory Motor Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8293": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 33,
      "SPN": 8293,
      "SPN_Name": "Electrified Accessory Motor Instance 2",
      "SPN_Description": "Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Accessory Motor Instance\r\n1 - No Command applied to this Accessory Motor Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8294": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 34,
      "SPN": 8294,
      "SPN_Name": "Electrified Accessory Motor Instance 3",
      "SPN_Description": "Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Accessory Motor Instance\r\n1 - No Command applied to this Accessory Motor Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8295": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 35,
      "SPN": 8295,
      "SPN_Name": "Electrified Accessory Motor Instance 4",
      "SPN_Description": "Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Accessory Motor Instance\r\n1 - No Command applied to this Accessory Motor Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8296": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 36,
      "SPN": 8296,
      "SPN_Name": "Electrified Accessory Motor Instance 5",
      "SPN_Description": "Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Accessory Motor Instance\r\n1 - No Command applied to this Accessory Motor Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8297": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 37,
      "SPN": 8297,
      "SPN_Name": "Electrified Accessory Motor Instance 6",
      "SPN_Description": "Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Accessory Motor Instance\r\n1 - No Command applied to this Accessory Motor Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8298": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 38,
      "SPN": 8298,
      "SPN_Name": "Electrified Accessory Motor Instance 7",
      "SPN_Description": "Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Accessory Motor Instance\r\n1 - No Command applied to this Accessory Motor Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8299": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 39,
      "SPN": 8299,
      "SPN_Name": "Electrified Accessory Motor Instance 8",
      "SPN_Description": "Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Accessory Motor Instance\r\n1 - No Command applied to this Accessory Motor Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8300": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 40,
      "SPN": 8300,
      "SPN_Name": "Electrified Accessory Motor Instance 9",
      "SPN_Description": "Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Accessory Motor Instance\r\n1 - No Command applied to this Accessory Motor Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8301": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 41,
      "SPN": 8301,
      "SPN_Name": "Electrified Accessory Motor Instance 10",
      "SPN_Description": "Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Accessory Motor Instance\r\n1 - No Command applied to this Accessory Motor Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8302": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 42,
      "SPN": 8302,
      "SPN_Name": "Electrified Accessory Motor Instance 11",
      "SPN_Description": "Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Accessory Motor Instance\r\n1 - No Command applied to this Accessory Motor Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8303": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 43,
      "SPN": 8303,
      "SPN_Name": "Electrified Accessory Motor Instance 12",
      "SPN_Description": "Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Accessory Motor Instance\r\n1 - No Command applied to this Accessory Motor Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8304": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 44,
      "SPN": 8304,
      "SPN_Name": "Electrified Accessory Motor Instance 13",
      "SPN_Description": "Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Accessory Motor Instance\r\n1 - No Command applied to this Accessory Motor Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8305": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 45,
      "SPN": 8305,
      "SPN_Name": "Electrified Accessory Motor Instance 14",
      "SPN_Description": "Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Accessory Motor Instance\r\n1 - No Command applied to this Accessory Motor Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8306": {
      "PGN": 32000,
      "PGN_Name": "Electrified Accessory Motor Command",
      "PGN_Description": "EAMC",
      "first_bit": 46,
      "SPN": 8306,
      "SPN_Name": "Electrified Accessory Motor Instance 15",
      "SPN_Description": "Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Accessory Motor Instance\r\n1 - No Command applied to this Accessory Motor Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8308": {
      "PGN": 64513,
      "PGN_Name": "Electrified Accessory Motor Status",
      "PGN_Description": "EAMS",
      "first_bit": 60,
      "SPN": 8308,
      "SPN_Name": "Electrified Accessory Motor Instance",
      "SPN_Description": "Indicates the electrified accessory instance that is providing status.\r\n\r\n0000 - Instance 1\r\n0001 - Instance 2\r\n0010 - Instance 3\r\n0011 - Instance 4\r\n0100 - Instance 5\r\n0101 - Instance 6\r\n0110 - Instance 7\r\n0111 - Instance 8\r\n1000 - Instance 9\r\n1001 - Instance 10\r\n1010 - Instance 11\r\n1011 - Instance 12\r\n1100 - Instance 13\r\n1101 - Instance 14\r\n1110 - Instance 15\r\n1111 - Not available / Instance not specified",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8310": {
      "PGN": 61497,
      "PGN_Name": "Engine Air System Information",
      "PGN_Description": "EASI",
      "first_bit": 32,
      "SPN": 8310,
      "SPN_Name": "Engine Fuel System 2 Total Intake Mass Air Flow Rate",
      "SPN_Description": "Mass Flow rate of air entering the second fuel system of the engine. This also includes the amount of exhaust gas recirculated, if any.",
      "bit_length": 16,
      "scaling": 0.0009765625,
      "offset": 0,
      "unit": "kg/s",
      "SLOT_ID": 372
    },
    "8312": {
      "PGN": 61710,
      "PGN_Name": "Dump Truck Body Information",
      "PGN_Description": "DTBI1",
      "first_bit": 0,
      "SPN": 8312,
      "SPN_Name": "Dump Body Roll Angle",
      "SPN_Description": "The angle between the dump body y-axis and the ground plane (i.e. rotation about the X-axis). The roll angle for a roll to the right is reported with a positive value. Roll angle is the same for both Z-Down and Z-Up axis systems, since both systems have positive X-axis directed forward. The sign of the value is in accordance to the right-hand rule, as specified in SAE J670.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "8313": {
      "PGN": 61710,
      "PGN_Name": "Dump Truck Body Information",
      "PGN_Description": "DTBI1",
      "first_bit": 16,
      "SPN": 8313,
      "SPN_Name": "Dump Body Raise Angle",
      "SPN_Description": "The angular position of the dump body referenced to the vehicle chassis. 0 degrees represents the body in its resting position.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -200,
      "unit": "deg",
      "SLOT_ID": 8
    },
    "8314": {
      "PGN": 61710,
      "PGN_Name": "Dump Truck Body Information",
      "PGN_Description": "DTBI1",
      "first_bit": 32,
      "SPN": 8314,
      "SPN_Name": "Dump Body Raise Position Relative to Recommended Maximum",
      "SPN_Description": "The angular position of the dump body expressed as a percentage of the maximum recommended body raised position. 100% represents the maximum default raised position of the dump body and is measured related to level ground.\r\n\r\nNote:  Depending on the machine orientation it may be possible to raise body above recommended maximum position, equally it may not be possible to reach maximum recommended position.",
      "bit_length": 16,
      "scaling": 0.005,
      "offset": -150,
      "unit": "%",
      "SLOT_ID": 430
    },
    "8315": {
      "PGN": 61710,
      "PGN_Name": "Dump Truck Body Information",
      "PGN_Description": "DTBI1",
      "first_bit": 48,
      "SPN": 8315,
      "SPN_Name": "Dump Body Ejector Blade Position",
      "SPN_Description": "The dump body ejector blade is used to push material out of the dump body of a dump truck. 0% represents the fully retracted position and 100% represents the fully extended position.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "8326": {
      "PGN": 64488,
      "PGN_Name": "Aftertreatment System Information 2",
      "PGN_Description": "ASI2",
      "first_bit": 0,
      "SPN": 8326,
      "SPN_Name": "Aftertreatment Total Diesel Exhaust Fluid Used",
      "SPN_Description": "Total amount of DEF used by aftertreatment device 1 and aftertreatment device 2 over the lifetime of the system.\r\n\r\nSee SPNs 5963 and 5964 for individual device accumulation.",
      "bit_length": 32,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l",
      "SLOT_ID": 75
    },
    "8327": {
      "PGN": 64487,
      "PGN_Name": "SCR Operator Inducement Information 5",
      "PGN_Description": "SCROII5",
      "first_bit": 0,
      "SPN": 8327,
      "SPN_Name": "Aftertreatment 1 SCR Intake High Temperature Time",
      "SPN_Description": "Indicates the time the aftertreatment 1 SCR intake temperature is above a manufacturer specified threshold. This is the temperature of engine combustion byproducts entering the SCR in exhaust bank 1. This will accumulate over the life of the product and will never be reset.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "8328": {
      "PGN": 61654,
      "PGN_Name": "API 1 Output 1 Energy Consumer Command",
      "PGN_Description": "API1_O1_CMD",
      "first_bit": 0,
      "SPN": 8328,
      "SPN_Name": "API 1 Output 1 Device Maximum Frequency",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the maximum frequency of the devices(s) attached to the inverter output. The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8329": {
      "PGN": 61654,
      "PGN_Name": "API 1 Output 1 Energy Consumer Command",
      "PGN_Description": "API1_O1_CMD",
      "first_bit": 8,
      "SPN": 8329,
      "SPN_Name": "API 1 Output 1 Device Minimum Frequency",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the minimum frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8330": {
      "PGN": 61654,
      "PGN_Name": "API 1 Output 1 Energy Consumer Command",
      "PGN_Description": "API1_O1_CMD",
      "first_bit": 16,
      "SPN": 8330,
      "SPN_Name": "API 1 Output 1 Device Rated Frequency",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the rated frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8331": {
      "PGN": 61654,
      "PGN_Name": "API 1 Output 1 Energy Consumer Command",
      "PGN_Description": "API1_O1_CMD",
      "first_bit": 24,
      "SPN": 8331,
      "SPN_Name": "API 1 Output 1 Device Rated Voltage",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the rated voltage of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "Vrms",
      "SLOT_ID": 427
    },
    "8332": {
      "PGN": 61654,
      "PGN_Name": "API 1 Output 1 Energy Consumer Command",
      "PGN_Description": "API1_O1_CMD",
      "first_bit": 32,
      "SPN": 8332,
      "SPN_Name": "API 1 Output 1 Device Frequency Rate of Change Limit",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the frequency rate of change limit of the device(s) attached to the inverter output.   (Note: Increasing and decreasing rates can be controlled by the same signal)  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "Hz/s",
      "SLOT_ID": 426
    },
    "8333": {
      "PGN": 61654,
      "PGN_Name": "API 1 Output 1 Energy Consumer Command",
      "PGN_Description": "API1_O1_CMD",
      "first_bit": 40,
      "SPN": 8333,
      "SPN_Name": "API 1 Output 1 Frequency Command",
      "SPN_Description": "Command to the Accessory Power Inverter indicating the Inverter frequency desired for the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8334": {
      "PGN": 61654,
      "PGN_Name": "API 1 Output 1 Energy Consumer Command",
      "PGN_Description": "API1_O1_CMD",
      "first_bit": 48,
      "SPN": 8334,
      "SPN_Name": "API 1 Output 1 Device 1 Status",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the state of device 1 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\r\n\r\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\r\n\r\n000 - On\r\n001 - Off\r\n010 - Faulted On\r\n011 - Faulted Off\r\n100 - Reserved for SAE Assignment\r\n101 - Reserved for SAE Assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "8335": {
      "PGN": 61654,
      "PGN_Name": "API 1 Output 1 Energy Consumer Command",
      "PGN_Description": "API1_O1_CMD",
      "first_bit": 51,
      "SPN": 8335,
      "SPN_Name": "API 1 Output 1 Device 2 Status",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the state of device 2 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\r\n\r\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\r\n\r\n000 - On\r\n001 - Off\r\n010 - Faulted On\r\n011 - Faulted Off\r\n100 - Reserved for SAE Assignment\r\n101 - Reserved for SAE Assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "8336": {
      "PGN": 61654,
      "PGN_Name": "API 1 Output 1 Energy Consumer Command",
      "PGN_Description": "API1_O1_CMD",
      "first_bit": 54,
      "SPN": 8336,
      "SPN_Name": "API 1 Output 1 Enable Command",
      "SPN_Description": "Command to the Accessory Power Inverter to enable this output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\r\n\r\n00 - Turn API Output Off\r\n01 - Turn API Output On\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8337": {
      "PGN": 61655,
      "PGN_Name": "API 1 Output 1 Energy Consumer Feedback",
      "PGN_Description": "API1_O1_FDBK",
      "first_bit": 0,
      "SPN": 8337,
      "SPN_Name": "API 1 Output 1 Frequency Feedback",
      "SPN_Description": "Present operating frequency of this Accessory Power Inverter output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8338": {
      "PGN": 61655,
      "PGN_Name": "API 1 Output 1 Energy Consumer Feedback",
      "PGN_Description": "API1_O1_FDBK",
      "first_bit": 8,
      "SPN": 8338,
      "SPN_Name": "API 1 Output 1 Voltage Feedback",
      "SPN_Description": "Present operating voltage of this Accessory Power Inverter output.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "Vrms",
      "SLOT_ID": 427
    },
    "8339": {
      "PGN": 61655,
      "PGN_Name": "API 1 Output 1 Energy Consumer Feedback",
      "PGN_Description": "API1_O1_FDBK",
      "first_bit": 16,
      "SPN": 8339,
      "SPN_Name": "API 1 Output 1 Power Feedback",
      "SPN_Description": "Present operating power of this Accessory Power Inverter output.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kW",
      "SLOT_ID": 428
    },
    "8340": {
      "PGN": 61655,
      "PGN_Name": "API 1 Output 1 Energy Consumer Feedback",
      "PGN_Description": "API1_O1_FDBK",
      "first_bit": 48,
      "SPN": 8340,
      "SPN_Name": "API 1 Output 1 Status Feedback",
      "SPN_Description": "Operating Status of this Accessory Power Inverter output. The Inverter Output Faulted state will be communicated when the inverter output has shutdown due to an overload condition or other fault.\r\n\r\n000 - Output Off\r\n001 - Output On\r\n010 - Output Faulted On\r\n011 - Output Faulted Off\r\n100 - Reserved for SAE Assignment\r\n101 - Reserved for SAE Assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "8341": {
      "PGN": 61655,
      "PGN_Name": "API 1 Output 1 Energy Consumer Feedback",
      "PGN_Description": "API1_O1_FDBK",
      "first_bit": 51,
      "SPN": 8341,
      "SPN_Name": "API 1 Output 1 Loadshed Request",
      "SPN_Description": "Loadshed Request from this Accessory Power Inverter output.  The Loadshed Requested state is an indication that the inverter output powering this device has a malfunction and is in a limit condition and if the load of the output is not reduced, the inverter will take steps to protect itself.  The Loadshed Requested, Shutdown Imminent state is an indication that the loadshed needs have not been met and the output will be shutdown in a limited amount of time.\r\n\r\n00 - No Loadshed Requested\r\n01 - Loadshed Requested\r\n10 - Loadshed Requested, Shutdown Imminent\r\n11 - Don't Care/Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8342": {
      "PGN": 61658,
      "PGN_Name": "API 1 Output 2 Energy Consumer Command",
      "PGN_Description": "API1_O2_CMD",
      "first_bit": 0,
      "SPN": 8342,
      "SPN_Name": "API 1 Output 2 Device Maximum Frequency",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the maximum frequency of the devices(s) attached to the inverter output. The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8343": {
      "PGN": 61658,
      "PGN_Name": "API 1 Output 2 Energy Consumer Command",
      "PGN_Description": "API1_O2_CMD",
      "first_bit": 8,
      "SPN": 8343,
      "SPN_Name": "API 1 Output 2 Device Minimum Frequency",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the minimum frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8344": {
      "PGN": 61658,
      "PGN_Name": "API 1 Output 2 Energy Consumer Command",
      "PGN_Description": "API1_O2_CMD",
      "first_bit": 16,
      "SPN": 8344,
      "SPN_Name": "API 1 Output 2 Device Rated Frequency",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the rated frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8345": {
      "PGN": 61658,
      "PGN_Name": "API 1 Output 2 Energy Consumer Command",
      "PGN_Description": "API1_O2_CMD",
      "first_bit": 24,
      "SPN": 8345,
      "SPN_Name": "API 1 Output 2 Device Rated Voltage",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the rated voltage of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "Vrms",
      "SLOT_ID": 427
    },
    "8346": {
      "PGN": 61658,
      "PGN_Name": "API 1 Output 2 Energy Consumer Command",
      "PGN_Description": "API1_O2_CMD",
      "first_bit": 32,
      "SPN": 8346,
      "SPN_Name": "API 1 Output 2 Device Frequency Rate of Change Limit",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the frequency rate of change limit of the device(s) attached to the inverter output. (Note: Increasing and decreasing rates can be controlled by the same signal).  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "Hz/s",
      "SLOT_ID": 426
    },
    "8347": {
      "PGN": 61658,
      "PGN_Name": "API 1 Output 2 Energy Consumer Command",
      "PGN_Description": "API1_O2_CMD",
      "first_bit": 40,
      "SPN": 8347,
      "SPN_Name": "API 1 Output 2 Frequency Command",
      "SPN_Description": "Command to the Accessory Power Inverter indicating the Inverter frequency desired for the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8348": {
      "PGN": 61658,
      "PGN_Name": "API 1 Output 2 Energy Consumer Command",
      "PGN_Description": "API1_O2_CMD",
      "first_bit": 48,
      "SPN": 8348,
      "SPN_Name": "API 1 Output 2 Device 1 Status",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the state of device 1 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\r\n\r\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\r\n\r\n000 - On\r\n001 - Off\r\n010 - Faulted On\r\n011 - Faulted Off\r\n100 - Reserved for SAE Assignment\r\n101 - Reserved for SAE Assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "8349": {
      "PGN": 61658,
      "PGN_Name": "API 1 Output 2 Energy Consumer Command",
      "PGN_Description": "API1_O2_CMD",
      "first_bit": 51,
      "SPN": 8349,
      "SPN_Name": "API 1 Output 2 Device 2 Status",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the state of device 2 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\r\n\r\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\r\n\r\n000 - On\r\n001 - Off\r\n010 - Faulted On\r\n011 - Faulted Off\r\n100 - Reserved for SAE Assignment\r\n101 - Reserved for SAE Assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "8350": {
      "PGN": 61658,
      "PGN_Name": "API 1 Output 2 Energy Consumer Command",
      "PGN_Description": "API1_O2_CMD",
      "first_bit": 54,
      "SPN": 8350,
      "SPN_Name": "API 1 Output 2 Enable Command",
      "SPN_Description": "Command to the Accessory Power Inverter to enable this output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\r\n\r\n00 - Turn API Output Off\r\n01 - Turn API Output On\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8351": {
      "PGN": 61659,
      "PGN_Name": "API 1 Output 2 Energy Consumer Feedback",
      "PGN_Description": "API1_O2_FDBK",
      "first_bit": 0,
      "SPN": 8351,
      "SPN_Name": "API 1 Output 2 Frequency Feedback",
      "SPN_Description": "Present operating frequency of this Accessory Power Inverter output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8352": {
      "PGN": 61659,
      "PGN_Name": "API 1 Output 2 Energy Consumer Feedback",
      "PGN_Description": "API1_O2_FDBK",
      "first_bit": 8,
      "SPN": 8352,
      "SPN_Name": "API 1 Output 2 Voltage Feedback",
      "SPN_Description": "Present operating voltage of this Accessory Power Inverter output.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "Vrms",
      "SLOT_ID": 427
    },
    "8353": {
      "PGN": 61659,
      "PGN_Name": "API 1 Output 2 Energy Consumer Feedback",
      "PGN_Description": "API1_O2_FDBK",
      "first_bit": 16,
      "SPN": 8353,
      "SPN_Name": "API 1 Output 2 Power Feedback",
      "SPN_Description": "Present operating power of this Accessory Power Inverter output.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kW",
      "SLOT_ID": 428
    },
    "8354": {
      "PGN": 61659,
      "PGN_Name": "API 1 Output 2 Energy Consumer Feedback",
      "PGN_Description": "API1_O2_FDBK",
      "first_bit": 48,
      "SPN": 8354,
      "SPN_Name": "API 1 Output 2 Status Feedback",
      "SPN_Description": "Operating Status of this Accessory Power Inverter output. The Inverter Output Faulted state will be communicated when the inverter output has shutdown due to an overload condition or other fault.\r\n\r\n000 - Output Off\r\n001 - Output On\r\n010 - Output Faulted On\r\n011 - Output Faulted Off\r\n100 - Reserved for SAE Assignment\r\n101 - Reserved for SAE Assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "8355": {
      "PGN": 61659,
      "PGN_Name": "API 1 Output 2 Energy Consumer Feedback",
      "PGN_Description": "API1_O2_FDBK",
      "first_bit": 51,
      "SPN": 8355,
      "SPN_Name": "API 1 Output 2 Loadshed Request",
      "SPN_Description": "Loadshed Request from this Accessory Power Inverter output.  The Loadshed Requested state is an indication that the inverter output powering this device has a malfunction and is in a limit condition and if the load of the output is not reduced, the inverter will take steps to protect itself.  The Loadshed Requested, Shutdown Imminent state is an indication that the loadshed needs have not been met and the output will be shutdown in a limited amount of time.\r\n\r\n00 - No Loadshed Requested\r\n01 - Loadshed Requested\r\n10 - Loadshed Requested, Shutdown Imminent\r\n11 - Don't Care/Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8356": {
      "PGN": 61662,
      "PGN_Name": "API 1 Output 3 Energy Consumer Command",
      "PGN_Description": "API1_O3_CMD",
      "first_bit": 0,
      "SPN": 8356,
      "SPN_Name": "API 1 Output 3 Device Maximum Frequency",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the maximum frequency of the devices(s) attached to the inverter output. The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8357": {
      "PGN": 61662,
      "PGN_Name": "API 1 Output 3 Energy Consumer Command",
      "PGN_Description": "API1_O3_CMD",
      "first_bit": 8,
      "SPN": 8357,
      "SPN_Name": "API 1 Output 3 Device Minimum Frequency",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the minimum frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8358": {
      "PGN": 61662,
      "PGN_Name": "API 1 Output 3 Energy Consumer Command",
      "PGN_Description": "API1_O3_CMD",
      "first_bit": 16,
      "SPN": 8358,
      "SPN_Name": "API 1 Output 3 Device Rated Frequency",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the rated frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8359": {
      "PGN": 61662,
      "PGN_Name": "API 1 Output 3 Energy Consumer Command",
      "PGN_Description": "API1_O3_CMD",
      "first_bit": 24,
      "SPN": 8359,
      "SPN_Name": "API 1 Output 3 Device Rated Voltage",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the rated voltage of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "Vrms",
      "SLOT_ID": 427
    },
    "8360": {
      "PGN": 61662,
      "PGN_Name": "API 1 Output 3 Energy Consumer Command",
      "PGN_Description": "API1_O3_CMD",
      "first_bit": 32,
      "SPN": 8360,
      "SPN_Name": "API 1 Output 3 Device Frequency Rate of Change Limit",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the frequency rate of change limit of the device(s) attached to the inverter output. (Note: Increasing and decreasing rates can be controlled by the same signal). The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "Hz/s",
      "SLOT_ID": 426
    },
    "8361": {
      "PGN": 61662,
      "PGN_Name": "API 1 Output 3 Energy Consumer Command",
      "PGN_Description": "API1_O3_CMD",
      "first_bit": 40,
      "SPN": 8361,
      "SPN_Name": "API 1 Output 3 Frequency Command",
      "SPN_Description": "Command to the Accessory Power Inverter indicating the Inverter frequency desired for the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8362": {
      "PGN": 61662,
      "PGN_Name": "API 1 Output 3 Energy Consumer Command",
      "PGN_Description": "API1_O3_CMD",
      "first_bit": 48,
      "SPN": 8362,
      "SPN_Name": "API 1 Output 3 Device 1 Status",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the state of device 1 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\r\n\r\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\r\n\r\n000 - On\r\n001 - Off\r\n010 - Faulted On\r\n011 - Faulted Off\r\n100 - Reserved for SAE Assignment\r\n101 - Reserved for SAE Assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "8363": {
      "PGN": 61662,
      "PGN_Name": "API 1 Output 3 Energy Consumer Command",
      "PGN_Description": "API1_O3_CMD",
      "first_bit": 51,
      "SPN": 8363,
      "SPN_Name": "API 1 Output 3 Device 2 Status",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the state of device 2 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\r\n\r\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\r\n\r\n000 - On\r\n001 - Off\r\n010 - Faulted On\r\n011 - Faulted Off\r\n100 - Reserved for SAE Assignment\r\n101 - Reserved for SAE Assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "8364": {
      "PGN": 61662,
      "PGN_Name": "API 1 Output 3 Energy Consumer Command",
      "PGN_Description": "API1_O3_CMD",
      "first_bit": 54,
      "SPN": 8364,
      "SPN_Name": "API 1 Output 3 Enable Command",
      "SPN_Description": "Command to the Accessory Power Inverter to enable this output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\r\n\r\n00 - Turn API Output Off\r\n01 - Turn API Output On\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8365": {
      "PGN": 61663,
      "PGN_Name": "API 1 Output 3 Energy Consumer Feedback",
      "PGN_Description": "API1_O3_FDBK",
      "first_bit": 0,
      "SPN": 8365,
      "SPN_Name": "API 1 Output 3 Frequency Feedback",
      "SPN_Description": "Present operating frequency of this Accessory Power Inverter output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8366": {
      "PGN": 61663,
      "PGN_Name": "API 1 Output 3 Energy Consumer Feedback",
      "PGN_Description": "API1_O3_FDBK",
      "first_bit": 8,
      "SPN": 8366,
      "SPN_Name": "API 1 Output 3 Voltage Feedback",
      "SPN_Description": "Present operating voltage of this Accessory Power Inverter output.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "Vrms",
      "SLOT_ID": 427
    },
    "8367": {
      "PGN": 61663,
      "PGN_Name": "API 1 Output 3 Energy Consumer Feedback",
      "PGN_Description": "API1_O3_FDBK",
      "first_bit": 16,
      "SPN": 8367,
      "SPN_Name": "API 1 Output 3 Power Feedback",
      "SPN_Description": "Present operating power of this Accessory Power Inverter output.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kW",
      "SLOT_ID": 428
    },
    "8368": {
      "PGN": 61663,
      "PGN_Name": "API 1 Output 3 Energy Consumer Feedback",
      "PGN_Description": "API1_O3_FDBK",
      "first_bit": 48,
      "SPN": 8368,
      "SPN_Name": "API 1 Output 3 Status Feedback",
      "SPN_Description": "Operating Status of this Accessory Power Inverter output. The Inverter Output Faulted state will be communicated when the inverter output has shutdown due to an overload condition or other fault.\r\n\n000 - Output Off\r\n001 - Output On\r\n010 - Output Faulted On\r\n011 - Output Faulted Off\r\n100 - Reserved for SAE Assignment\r\n101 - Reserved for SAE Assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "8369": {
      "PGN": 61663,
      "PGN_Name": "API 1 Output 3 Energy Consumer Feedback",
      "PGN_Description": "API1_O3_FDBK",
      "first_bit": 51,
      "SPN": 8369,
      "SPN_Name": "API 1 Output 3 Loadshed Request",
      "SPN_Description": "Loadshed Request from this Accessory Power Inverter output.  The Loadshed Requested  state is an indication that the inverter output powering this device has a malfunction and is in a limit condition and if the load of the output is not reduced, the inverter will take steps to protect itself.  The Loadshed Requested, Shutdown Imminent state is an indication that the loadshed needs have not been met and the output will be shutdown in a limited amount of time.\r\n\r\n00 - No Loadshed Requested\r\n01 - Loadshed Requested\r\n10 - Loadshed Requested, Shutdown Imminent\r\n11 - Don't Care/Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8370": {
      "PGN": 61666,
      "PGN_Name": "API 1 Output 4 Energy Consumer Command",
      "PGN_Description": "API1_O4_CMD",
      "first_bit": 0,
      "SPN": 8370,
      "SPN_Name": "API 1 Output 4 Device Maximum Frequency",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the maximum frequency of the devices(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8371": {
      "PGN": 61666,
      "PGN_Name": "API 1 Output 4 Energy Consumer Command",
      "PGN_Description": "API1_O4_CMD",
      "first_bit": 8,
      "SPN": 8371,
      "SPN_Name": "API 1 Output 4 Device Minimum Frequency",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the minimum frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8372": {
      "PGN": 61666,
      "PGN_Name": "API 1 Output 4 Energy Consumer Command",
      "PGN_Description": "API1_O4_CMD",
      "first_bit": 16,
      "SPN": 8372,
      "SPN_Name": "API 1 Output 4 Device Rated Frequency",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the rated frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8373": {
      "PGN": 61666,
      "PGN_Name": "API 1 Output 4 Energy Consumer Command",
      "PGN_Description": "API1_O4_CMD",
      "first_bit": 24,
      "SPN": 8373,
      "SPN_Name": "API 1 Output 4 Device Rated Voltage",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the rated voltage of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "Vrms",
      "SLOT_ID": 427
    },
    "8374": {
      "PGN": 61666,
      "PGN_Name": "API 1 Output 4 Energy Consumer Command",
      "PGN_Description": "API1_O4_CMD",
      "first_bit": 32,
      "SPN": 8374,
      "SPN_Name": "API 1 Output 4 Device Frequency Rate of Change Limit",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the frequency rate of change limit of the device(s) attached to the inverter output.  (Note: Increasing and decreasing rates can be controlled by the same signal).  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "Hz/s",
      "SLOT_ID": 426
    },
    "8375": {
      "PGN": 61666,
      "PGN_Name": "API 1 Output 4 Energy Consumer Command",
      "PGN_Description": "API1_O4_CMD",
      "first_bit": 40,
      "SPN": 8375,
      "SPN_Name": "API 1 Output 4 Frequency Command",
      "SPN_Description": "Command to the Accessory Power Inverter indicating the Inverter frequency desired for the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8376": {
      "PGN": 61666,
      "PGN_Name": "API 1 Output 4 Energy Consumer Command",
      "PGN_Description": "API1_O4_CMD",
      "first_bit": 48,
      "SPN": 8376,
      "SPN_Name": "API 1 Output 4 Device 1 Status",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the state of device 1 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\r\n\r\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\r\n\r\n000 - On\r\n001 - Off\r\n010 - Faulted On\r\n011 - Faulted Off\r\n100 - Reserved for SAE Assignment\r\n101 - Reserved for SAE Assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "8377": {
      "PGN": 61666,
      "PGN_Name": "API 1 Output 4 Energy Consumer Command",
      "PGN_Description": "API1_O4_CMD",
      "first_bit": 51,
      "SPN": 8377,
      "SPN_Name": "API 1 Output 4 Device 2 Status",
      "SPN_Description": "Signal to the Accessory Power Inverter indicating the state of device 2 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\r\n\r\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\r\n\r\n000 - On\r\n001 - Off\r\n010 - Faulted On\r\n011 - Faulted Off\r\n100 - Reserved for SAE Assignment\r\n101 - Reserved for SAE Assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "8378": {
      "PGN": 61666,
      "PGN_Name": "API 1 Output 4 Energy Consumer Command",
      "PGN_Description": "API1_O4_CMD",
      "first_bit": 54,
      "SPN": 8378,
      "SPN_Name": "API 1 Output 4 Enable Command",
      "SPN_Description": "Command to the Accessory Power Inverter to enable this output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\r\n\r\n00 - Turn API Output Off\r\n01 - Turn API Output On\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8379": {
      "PGN": 61667,
      "PGN_Name": "API 1 Output 4 Energy Consumer Feedback",
      "PGN_Description": "API1_O4_FDBK",
      "first_bit": 0,
      "SPN": 8379,
      "SPN_Name": "API 1 Output 4 Frequency Feedback",
      "SPN_Description": "Present operating frequency of this Accessory Power Inverter output.",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "Hz",
      "SLOT_ID": 425
    },
    "8380": {
      "PGN": 61667,
      "PGN_Name": "API 1 Output 4 Energy Consumer Feedback",
      "PGN_Description": "API1_O4_FDBK",
      "first_bit": 8,
      "SPN": 8380,
      "SPN_Name": "API 1 Output 4 Voltage Feedback",
      "SPN_Description": "Present operating voltage of this Accessory Power Inverter output.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "Vrms",
      "SLOT_ID": 427
    },
    "8381": {
      "PGN": 61667,
      "PGN_Name": "API 1 Output 4 Energy Consumer Feedback",
      "PGN_Description": "API1_O4_FDBK",
      "first_bit": 16,
      "SPN": 8381,
      "SPN_Name": "API 1 Output 4 Power Feedback",
      "SPN_Description": "Present operating power of this Accessory Power Inverter output.",
      "bit_length": 8,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kW",
      "SLOT_ID": 428
    },
    "8382": {
      "PGN": 61667,
      "PGN_Name": "API 1 Output 4 Energy Consumer Feedback",
      "PGN_Description": "API1_O4_FDBK",
      "first_bit": 48,
      "SPN": 8382,
      "SPN_Name": "API 1 Output 4 Status Feedback",
      "SPN_Description": "Operating Status of this Accessory Power Inverter output. The Inverter Output Faulted state will be communicated when the inverter output has shutdown due to an overload condition or other fault.\r\n\r\n000 - Output Off\r\n001 - Output On\r\n010 - Output Faulted On\r\n011 - Output Faulted Off\r\n100 - Reserved for SAE Assignment\r\n101 - Reserved for SAE Assignment\r\n110 - Error\r\n111 - Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "8383": {
      "PGN": 61667,
      "PGN_Name": "API 1 Output 4 Energy Consumer Feedback",
      "PGN_Description": "API1_O4_FDBK",
      "first_bit": 51,
      "SPN": 8383,
      "SPN_Name": "API 1 Output 4 Loadshed Request",
      "SPN_Description": "Loadshed Request from this Accessory Power Inverter output.  The Loadshed Requested state is an indication that the inverter output powering this device has a malfunction and is in a limit condition and if the load of the output is not reduced, the inverter will take steps to protect itself.  The Loadshed Requested, Shutdown Imminent state is an indication that the loadshed needs have not been met and the output will be shutdown in a limited amount of time.\r\n\r\n00 - No Loadshed Requested\r\n01 - Loadshed Requested\r\n10 - Loadshed Requested, Shutdown Imminent\r\n11 - Don't Care/Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8384": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 0,
      "SPN": 8384,
      "SPN_Name": "HVES Fan Enable Command",
      "SPN_Description": "Enable and direction command to this HVES fan.\r\n\r\n00 - Fan Off\r\n01 - Fan On Normal/Default Direction\r\n10 - Fan On Reverse Direction\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8385": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 2,
      "SPN": 8385,
      "SPN_Name": "HVES Fan Power Hold",
      "SPN_Description": "Command to allow this HVES fan to remain alive independently of the electrical enable input to the fan.  For example, this could allow continued device operation after the keyswitch has turned off.\r\n\r\n00 - Power Hold Disabled\r\n01 - Power Hold Enabled\r\n10 - Reserved\r\n11 - Don't Care/Take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8386": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 8,
      "SPN": 8386,
      "SPN_Name": "HVES Fan Speed Command",
      "SPN_Description": "Speed command to this HVES fan.\r\n\r\nNote: Both Speed Command and Percent Speed Command (SPN 8387) cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "8387": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 24,
      "SPN": 8387,
      "SPN_Name": "HVES Fan Percent Speed Command",
      "SPN_Description": "Speed command to this HVES fan in percentage of maximum speed.\r\n\r\nNote: Both Speed Command (SPN 8386) and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "8388": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 32,
      "SPN": 8388,
      "SPN_Name": "HVES Fan Instance 1",
      "SPN_Description": "Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Fan Instance\r\n1 - No Command applied to this Fan Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8389": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 33,
      "SPN": 8389,
      "SPN_Name": "HVES Fan Instance 2",
      "SPN_Description": "Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Fan Instance\r\n1 - No Command applied to this Fan Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8390": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 34,
      "SPN": 8390,
      "SPN_Name": "HVES Fan Instance 3",
      "SPN_Description": "Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Fan Instance\r\n1 - No Command applied to this Fan Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8391": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 35,
      "SPN": 8391,
      "SPN_Name": "HVES Fan Instance 4",
      "SPN_Description": "Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Fan Instance\r\n1 - No Command applied to this Fan Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8392": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 36,
      "SPN": 8392,
      "SPN_Name": "HVES Fan Instance 5",
      "SPN_Description": "Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Fan Instance\r\n1 - No Command applied to this Fan Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8393": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 37,
      "SPN": 8393,
      "SPN_Name": "HVES Fan Instance 6",
      "SPN_Description": "Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Fan Instance\r\n1 - No Command applied to this Fan Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8394": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 38,
      "SPN": 8394,
      "SPN_Name": "HVES Fan Instance 7",
      "SPN_Description": "Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Fan Instance\r\n1 - No Command applied to this Fan Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8395": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 39,
      "SPN": 8395,
      "SPN_Name": "HVES Fan Instance 8",
      "SPN_Description": "Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Fan Instance\r\n1 - No Command applied to this Fan Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8396": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 40,
      "SPN": 8396,
      "SPN_Name": "HVES Fan Instance 9",
      "SPN_Description": "Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Fan Instance\r\n1 - No Command applied to this Fan Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8397": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 41,
      "SPN": 8397,
      "SPN_Name": "HVES Fan Instance 10",
      "SPN_Description": "Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Fan Instance\r\n1 - No Command applied to this Fan Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8398": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 42,
      "SPN": 8398,
      "SPN_Name": "HVES Fan Instance 11",
      "SPN_Description": "Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Fan Instance\r\n1 - No Command applied to this Fan Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8399": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 43,
      "SPN": 8399,
      "SPN_Name": "HVES Fan Instance 12",
      "SPN_Description": "Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Fan Instance\r\n1 - No Command applied to this Fan Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8400": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 44,
      "SPN": 8400,
      "SPN_Name": "HVES Fan Instance 13",
      "SPN_Description": "Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Fan Instance\r\n1 - No Command applied to this Fan Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8401": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 45,
      "SPN": 8401,
      "SPN_Name": "HVES Fan Instance 14",
      "SPN_Description": "Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Fan Instance\r\n1 - No Command applied to this Fan Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8402": {
      "PGN": 64486,
      "PGN_Name": "High Voltage Energy Storage Fan Commands",
      "PGN_Description": "HVESFC",
      "first_bit": 46,
      "SPN": 8402,
      "SPN_Name": "HVES Fan Instance 15",
      "SPN_Description": "Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\r\n\r\n0 - Command applied to this Fan Instance\r\n1 - No Command applied to this Fan Instance",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8403": {
      "PGN": 64485,
      "PGN_Name": "High Voltage Energy Storage Fan Status",
      "PGN_Description": "HVESFS",
      "first_bit": 0,
      "SPN": 8403,
      "SPN_Name": "HVES Fan Enable Status",
      "SPN_Description": "Enable and direction status of this HVES fan.\r\n\r\n00 - Fan Off\r\n01 - Fan On - Normal, Forward, or Default Direction\r\n10 - Fan On - Reverse Direction\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8404": {
      "PGN": 64485,
      "PGN_Name": "High Voltage Energy Storage Fan Status",
      "PGN_Description": "HVESFS",
      "first_bit": 2,
      "SPN": 8404,
      "SPN_Name": "HVES Fan Status Reason Code",
      "SPN_Description": "Provides the reason code describing the unique failure of this HVES fan.  If a detailed reason code is not used by the supporting application, or this reason code is Not Available, the HVES Fan Service Indicator (SPN 8409) and HVES fan Operating Status (SPN 8410) may be used to determine functional status of this HVES fan.\r\n\r\n0000 - Normal Operation\r\n0001 - Unable to Start\r\n0010 - Over-Voltage Protection Shutdown\r\n0011 - Under-Voltage Protection Shutdown\r\n0100 - Over-Temperature Protection Shutdown\r\n0101 - Speed Limited due to current (i.e. amperage) protection limit\r\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\r\n0111 - Reserved\r\n1000 - Reserved\r\n1001 - Reserved\r\n1010 - Reserved\r\n1011 - Reserved\r\n1100 - Reserved\r\n1101 - Reserved\r\n1110 - Reserved\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8405": {
      "PGN": 64485,
      "PGN_Name": "High Voltage Energy Storage Fan Status",
      "PGN_Description": "HVESFS",
      "first_bit": 6,
      "SPN": 8405,
      "SPN_Name": "HVES Fan Command Status",
      "SPN_Description": "Indicates the source of the speed command to this HVES fan.\r\n\r\n00 is communicated when the fan is self-controlled (e.g. based on a temperature sensor).  01 is communicated when responding to the HVES Fan Speed Command (SPN 8386) or HVES Fan Percent Speed Command (SPN 8487).  10 is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\r\n\r\n00 - Internal Command\r\n01 - External Command\r\n10 - Default Command\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8406": {
      "PGN": 64485,
      "PGN_Name": "High Voltage Energy Storage Fan Status",
      "PGN_Description": "HVESFS",
      "first_bit": 8,
      "SPN": 8406,
      "SPN_Name": "HVES Fan Speed",
      "SPN_Description": "Speed of this HVES fan. ",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 78
    },
    "8407": {
      "PGN": 64485,
      "PGN_Name": "High Voltage Energy Storage Fan Status",
      "PGN_Description": "HVESFS",
      "first_bit": 24,
      "SPN": 8407,
      "SPN_Name": "HVES Fan Medium Temperature",
      "SPN_Description": "A temperature measured and reported by the device.  It may be used for direct or remote (e.g. by another controller) control of the pump.  For example, this may be the temperature of the fluid flowing through the pump, or some other temperature relating to the pump or controller. ",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8408": {
      "PGN": 64485,
      "PGN_Name": "High Voltage Energy Storage Fan Status",
      "PGN_Description": "HVESFS",
      "first_bit": 40,
      "SPN": 8408,
      "SPN_Name": "HVES Fan Power",
      "SPN_Description": "Calculated electrical power consumed by this HVES fan.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "W",
      "SLOT_ID": 305
    },
    "8409": {
      "PGN": 64485,
      "PGN_Name": "High Voltage Energy Storage Fan Status",
      "PGN_Description": "HVESFS",
      "first_bit": 56,
      "SPN": 8409,
      "SPN_Name": "HVES Fan Service Indicator",
      "SPN_Description": "Indicates that service is required for this HVES fan.  An active indication may convey a need for component replacement or periodic service.  The HVES Fan Status Reason Code (SPN 8404) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Service Not Required\r\n01 - Service Required\r\n10 - Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8410": {
      "PGN": 64485,
      "PGN_Name": "High Voltage Energy Storage Fan Status",
      "PGN_Description": "HVESFS",
      "first_bit": 58,
      "SPN": 8410,
      "SPN_Name": "HVES Fan Operating Status",
      "SPN_Description": "Indicates the operating status of this HVES fan.  This parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow of the medium (e.g. coolant, oil, air, etc.) can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.\r\n\r\nThe HVES Fan Status Reason Code (SPN 8404) may provide additional detail as to the nature of the system status.\r\n\r\n00 - Normal Operation\r\n01 - Derated Operation\r\n10 - Not Operable\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8411": {
      "PGN": 64485,
      "PGN_Name": "High Voltage Energy Storage Fan Status",
      "PGN_Description": "HVESFS",
      "first_bit": 60,
      "SPN": 8411,
      "SPN_Name": "HVES Fan Instance",
      "SPN_Description": "Indicates the instance of the HVES fan that is providing status in systems controlled by a master ECU.\r\n\r\n0000 - Instance 1\r\n0001 - Instance 2\r\n0010 - Instance 3\r\n0011 - Instance 4\r\n0100 - Instance 5\r\n0101 - Instance 6\r\n0110 - Instance 7\r\n0111 - Instance 8\r\n1000 - Instance 9\r\n1001 - Instance 10\r\n1010 - Instance 11\r\n1011 - Instance 12\r\n1100 - Instance 13\r\n1101 - Instance 14\r\n1110 - Instance 15\r\n1111 - Not available / Instance not specified",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8412": {
      "PGN": 6912,
      "PGN_Name": "High Voltage Energy Storage 1 Control 1",
      "PGN_Description": "HVES1C1",
      "first_bit": 12,
      "SPN": 8412,
      "SPN_Name": "HVES1 Operation Consent",
      "SPN_Description": "This parameter provides an indication to the HVES1 pack (or system) that an external device is ready for HVES1 to proceed with normal operation.  In applications which support this parameter, the HVES1 (or system) may only proceed with normal operation if consent is given.  The HVES1 operation that is allowed based on this consent is manufacturer dependent.\r\n\r\n00 - Consent revoked; system component does not consent to HVES1 operation\r\n01 - Consent given; system component consents to HVES1 operation\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8413": {
      "PGN": 61590,
      "PGN_Name": "High Voltage Energy Storage 1 Status 1",
      "PGN_Description": "HVES1S1",
      "first_bit": 40,
      "SPN": 8413,
      "SPN_Name": "HVES1 High-Voltage Bus Connection Status",
      "SPN_Description": "This parameter provides high level feedback on the HVES1 pack (or system) high voltage bus connection.  For specific contactor information, see HVES1 High-Voltage Bus (Positive) Contactor State (SPN 8091), HVES1 High-Voltage Bus (Negative) Contactor State (SPN 8092), HVES1 Center of Pack Contactor State (SPN 8095), and HVES1 High-Voltage Bus Pre-Charge Relay State (SPN 8094).\r\n\r\n0000 - Disconnected.  One or more contactors are open.  State may result from the HVES1 High-Voltage Bus Connect Command (SPN 8123) or due to a limit being exceeded.\r\n\r\n0001 - Connected.  All contactors are closed and the precharge relay is open.  Typically results from the HVES1 High-Voltage Bus Connect Command (SPN 8123).\r\n\r\n0010 - Connection in Process.  May be rapidly transitioned through depending on HVES design, but indicates that the precharge relay is closed and/or one or more contactors may also be closed or in the process of being closed.\r\n\r\n0011 - Disconnection in Process.   May be rapidly transitioned through depending on HVES design, but indicates that HVES1 is in the process of disconnecting itself from the high voltage bus.\r\n\r\n0100 - Disconnected; Precharge Failed.  Indicates that the pre-charge function status cannot be determined or did not complete (e.g. Relay failure, insufficient HVES voltage, etc.).\r\n\r\n0101 - Reserved\r\n0110 - Reserved\r\n0111 - Reserved\r\n1000 - Reserved\r\n1001 - Reserved\r\n1010 - Reserved\r\n1011 - Reserved\r\n1100 - Reserved\r\n1101 - Reserved\r\n1110 - Error\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8414": {
      "PGN": 61590,
      "PGN_Name": "High Voltage Energy Storage 1 Status 1",
      "PGN_Description": "HVES1S1",
      "first_bit": 44,
      "SPN": 8414,
      "SPN_Name": "HVES1 Operational Status",
      "SPN_Description": "Provides feedback on where the HVES1 pack (or system) is in its operating spectrum, and includes feedback in response to the Operation Consent [i.e. HVES1 Operation Consent (SPN 8412)] and Power Down Command [i.e. HVES1 Power Down Command (SPN 8124)] parameters.\r\n\r\n0000 - Initialization in process.  The HVES controller is powering up.  This process may include both internal HVES controller checks, as well as system checks being run by the HVES controller.\r\n\r\n0001 - Initialization Complete, awaiting Operation Consent.  HVES controller is ready from its perspective, but requires one or more positive Operation Consent indications before becoming fully operational.  Some applications may not support this state.\r\n\r\n0010 - Operational.\r\n\r\n0011 - Normal Power-Down in Process.  This state is a response to Power Down Command state 01.\r\n\r\n0100 - Emergency Power-Down In Process.  This state is a response to Power Down Command state 10.\r\n\r\n0101 - Disabled by external command.  The HVES is in a non-operational state due to a Power Down Command, or the result of Operation Consent being revoked.\r\n\r\n0110 - Disabled by internal decision of HVES controller (e.g. malfunction, protection)\r\n\r\n0111 - Reserved\r\n1000 - Reserved\r\n1001 - Reserved\r\n1010 - Reserved\r\n1011 - Reserved\r\n1100 - Reserved\r\n1101 - Reserved\r\n1110 - Error\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8415": {
      "PGN": 64484,
      "PGN_Name": "Fuel Information 7 (Gaseous)",
      "PGN_Description": "GFI7",
      "first_bit": 0,
      "SPN": 8415,
      "SPN_Name": "Driver Side Fuel Receptacle 1 Cover Status",
      "SPN_Description": "Indicates if the cover for the first fuel receptacle on the driver side is attached or detached.\r\n\r\n00 - Receptacle cover is detached\r\n01 - Receptacle cover is attached\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8416": {
      "PGN": 64484,
      "PGN_Name": "Fuel Information 7 (Gaseous)",
      "PGN_Description": "GFI7",
      "first_bit": 2,
      "SPN": 8416,
      "SPN_Name": "Driver Side Fuel Receptacle 2 Cover Status",
      "SPN_Description": "Indicates if the cover for the second fuel receptacle on the driver side is attached or detached.\r\n\r\n00 - Receptacle cover is detached\r\n01 - Receptacle cover is attached\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8417": {
      "PGN": 64484,
      "PGN_Name": "Fuel Information 7 (Gaseous)",
      "PGN_Description": "GFI7",
      "first_bit": 4,
      "SPN": 8417,
      "SPN_Name": "Passenger Side Fuel Receptacle 1 Cover Status",
      "SPN_Description": "Indicates if the cover for the first fuel receptacle on the passenger side is attached or detached.\r\n\r\n00 - Receptacle cover is detached\r\n01 - Receptacle cover is attached\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8418": {
      "PGN": 64484,
      "PGN_Name": "Fuel Information 7 (Gaseous)",
      "PGN_Description": "GFI7",
      "first_bit": 6,
      "SPN": 8418,
      "SPN_Name": "Passenger Side Fuel Receptacle 2 Cover Status",
      "SPN_Description": "Indicates if the cover for the second fuel receptacle on the passenger side is attached or detached.\r\n\r\n00 - Receptacle cover is detached\r\n01 - Receptacle cover is attached\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8419": {
      "PGN": 64484,
      "PGN_Name": "Fuel Information 7 (Gaseous)",
      "PGN_Description": "GFI7",
      "first_bit": 8,
      "SPN": 8419,
      "SPN_Name": "Front Fuel Receptacle Cover Status",
      "SPN_Description": "Indicates if the cover for the fuel receptacle at the front of the vehicle is attached or detached.\r\n\r\n00 - Receptacle cover is detached\r\n01 - Receptacle cover is attached\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8420": {
      "PGN": 64484,
      "PGN_Name": "Fuel Information 7 (Gaseous)",
      "PGN_Description": "GFI7",
      "first_bit": 16,
      "SPN": 8420,
      "SPN_Name": "Fuel Storage Compartment 1 Temperature 1",
      "SPN_Description": "The ambient temperature in the first fuel storage compartment.  If there is more than 1 sensor, then this is the first sensor. Note that this is not the temperature of the fuel in the fuel tank.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8421": {
      "PGN": 64484,
      "PGN_Name": "Fuel Information 7 (Gaseous)",
      "PGN_Description": "GFI7",
      "first_bit": 24,
      "SPN": 8421,
      "SPN_Name": "Fuel Storage Compartment 1 Temperature 2",
      "SPN_Description": "The ambient temperature as measured by the second temperature sensor in the first fuel storage compartment. Note that this is not the temperature of the fuel in the fuel tank.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8422": {
      "PGN": 64484,
      "PGN_Name": "Fuel Information 7 (Gaseous)",
      "PGN_Description": "GFI7",
      "first_bit": 32,
      "SPN": 8422,
      "SPN_Name": "Fuel Storage Compartment 2 Temperature 1",
      "SPN_Description": "The ambient temperature in the second fuel storage compartment.  If there is more than 1 sensor, then this is the first sensor. Note that this is not the temperature of the fuel in the fuel tank.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8423": {
      "PGN": 64484,
      "PGN_Name": "Fuel Information 7 (Gaseous)",
      "PGN_Description": "GFI7",
      "first_bit": 40,
      "SPN": 8423,
      "SPN_Name": "Fuel Storage Compartment 2 Temperature 2",
      "SPN_Description": "The ambient temperature as measured by the second temperature sensor in the second fuel storage compartment. Note that this is not the temperature of the fuel in the fuel tank.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8424": {
      "PGN": 64484,
      "PGN_Name": "Fuel Information 7 (Gaseous)",
      "PGN_Description": "GFI7",
      "first_bit": 48,
      "SPN": 8424,
      "SPN_Name": "Fuel Storage Compartment 3 Temperature 1",
      "SPN_Description": "The ambient temperature in the third fuel storage compartment.  If there is more than 1 sensor, then this is the first sensor. Note that this is not the temperature of the fuel in the fuel tank.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8425": {
      "PGN": 64484,
      "PGN_Name": "Fuel Information 7 (Gaseous)",
      "PGN_Description": "GFI7",
      "first_bit": 56,
      "SPN": 8425,
      "SPN_Name": "Fuel Storage Compartment 3 Temperature 2",
      "SPN_Description": "The ambient temperature as measured by the second temperature sensor in the third fuel storage compartment. Note that this is not the temperature of the fuel in the fuel tank.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8428": {
      "PGN": 65279,
      "PGN_Name": "Operator indicators",
      "PGN_Description": "OI",
      "first_bit": 16,
      "SPN": 8428,
      "SPN_Name": "Fuel Supply Estimated Remaining Distance",
      "SPN_Description": "Estimated remaining distance based on existing fuel supply.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "km",
      "SLOT_ID": 270
    },
    "8429": {
      "PGN": 61470,
      "PGN_Name": "Generator Control 2",
      "PGN_Description": "GC2",
      "first_bit": 16,
      "SPN": 8429,
      "SPN_Name": "Engine Self-Induced Derate Inhibit",
      "SPN_Description": "Parameter to indicate if the genset control system allows the Engine Control Module to impose its own induced derate.\r\n\r\n00 - Engine is allowed to impose a self-induced derate\r\n01 - Engine is inhibited from imposing a self-induced derate\r\n10 - SAE Reserved\r\n11 - Don't care / take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8430": {
      "PGN": 61470,
      "PGN_Name": "Generator Control 2",
      "PGN_Description": "GC2",
      "first_bit": 24,
      "SPN": 8430,
      "SPN_Name": "Engine Load Setpoint Request",
      "SPN_Description": "Setpoint request (in kW) sent to the engine by a genset control system.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kW",
      "SLOT_ID": 55
    },
    "8431": {
      "PGN": 61708,
      "PGN_Name": "High Voltage Energy Storage 1 Data 10",
      "PGN_Description": "HVES1D10",
      "first_bit": 32,
      "SPN": 8431,
      "SPN_Name": "HVES1 High-Voltage Bus Active Isolation Test Results",
      "SPN_Description": "The isolation resistance expressed in Ohms per Volt that resulted from the High-Voltage Bus Active Isolation Test.\r\n\r\nSee HVES1 High-Voltage Bus Active Isolation Test Status (SPN 8096) for test status and HVES1 High-Voltage Bus Active Isolation Test Command (SPN 8125) for the command to run the test.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm/V",
      "SLOT_ID": 429
    },
    "8432": {
      "PGN": 61708,
      "PGN_Name": "High Voltage Energy Storage 1 Data 10",
      "PGN_Description": "HVES1D10",
      "first_bit": 48,
      "SPN": 8432,
      "SPN_Name": "HVES1 High-Voltage Bus Passive Isolation Test Results",
      "SPN_Description": "The isolation resistance expressed in Ohms per Volt that resulted from the High-Voltage Bus Passive Isolation Test.\r\n\r\nSee HVES1 High-Voltage Bus Passive Isolation Test Status (SPN 8097) for test status and HVES1 High-Voltage Bus Active Isolation Test Command (SPN 8126) for the command to run the test.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "ohm/V",
      "SLOT_ID": 429
    },
    "8433": {
      "PGN": 6912,
      "PGN_Name": "High Voltage Energy Storage 1 Control 1",
      "PGN_Description": "HVES1C1",
      "first_bit": 14,
      "SPN": 8433,
      "SPN_Name": "HVES1 High-Voltage Bus High Side Resistor Connect Request",
      "SPN_Description": "This parameter is used to request connection of the HVES1 High-Voltage bus high side resistor in order to perform an isolation test.  See also HVES1 High-Voltage Bus Low Side Resistor Connect Request (SPN 8434).\r\n\r\n00 - Connection not Requested\r\n01 - Connection Requested\r\n10 - Reserved\r\n11 - Don’t care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8434": {
      "PGN": 6912,
      "PGN_Name": "High Voltage Energy Storage 1 Control 1",
      "PGN_Description": "HVES1C1",
      "first_bit": 16,
      "SPN": 8434,
      "SPN_Name": "HVES1 High-Voltage Bus Low Side Resistor Connect Request",
      "SPN_Description": "This parameter is used to request connection of the HVES1 High-Voltage bus low side resistor in order to perform an isolation test.  See also HVES1 High-Voltage Bus High Side Resistor Connect Request (SPN 8433).\r\n\r\n00 - Connection not Requested\r\n01 - Connection Requested\r\n10 - Reserved\r\n11 - Don’t care/take no action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8435": {
      "PGN": 61711,
      "PGN_Name": "Engine Operating Information 2",
      "PGN_Description": "EOI2",
      "first_bit": 0,
      "SPN": 8435,
      "SPN_Name": "Engine Self-Induced Derate Load",
      "SPN_Description": "The self-induced derate load that the Engine Control Module is trying to achieve.  A value of 0% means there is no active derate.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kW",
      "SLOT_ID": 55
    },
    "8436": {
      "PGN": 61711,
      "PGN_Name": "Engine Operating Information 2",
      "PGN_Description": "EOI2",
      "first_bit": 16,
      "SPN": 8436,
      "SPN_Name": "Engine Power Derate Request",
      "SPN_Description": "Derate request made from the engine control system to an external system, where the engine is requesting an external device to reduce the load being applied. A zero value indicates no derate, while any other value indicates the amount of load (in kW) to be reduced.\r\n\r\nSee also SPN 3644 for a Derate Request in percent.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "kW",
      "SLOT_ID": 55
    },
    "8438": {
      "PGN": 2560,
      "PGN_Name": "Cruise Control / Vehicle Speed 2",
      "PGN_Description": "CCVS2",
      "first_bit": 8,
      "SPN": 8438,
      "SPN_Name": "Idle Speed Request",
      "SPN_Description": "Requested idle speed. Allows an operator or ECU to modify the engine idle setpoint within a range supported by the engine. Requests above or below the supported range should result in a speed at the limit of the supported range. Should be 0 when the idle control state (SPN 8439) is not active. A value of 0xFB indicates the desired speed is pre-programmed in the engine. This setting impacts Point 1 on the Engine Configuration.\r\n\r\nIntended for the vehicle controller to modify engine idle speed to match vehicle operating conditions and modes (cab temperature, air supply, battery state, operator selection, etc.)",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "8439": {
      "PGN": 2560,
      "PGN_Name": "Cruise Control / Vehicle Speed 2",
      "PGN_Description": "CCVS2",
      "first_bit": 24,
      "SPN": 8439,
      "SPN_Name": "Idle Control Enable State",
      "SPN_Description": "Indicates whether enabling conditions (switch position, park brake, transmission neutral status, etc.) have been met for an idle speed request. Similar to a cruise control enable switch, this parameter does not activate the request, but may be used to provide indication of availability. This parameter does not inhibit or apply to Engine Operator Primary Intermediate Speed Select (SPN 2880).\r\n\r\n00 - Conditions are not met for idle speed request\r\n01 - Conditions for idle speed request have been met\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8440": {
      "PGN": 2560,
      "PGN_Name": "Cruise Control / Vehicle Speed 2",
      "PGN_Description": "CCVS2",
      "first_bit": 26,
      "SPN": 8440,
      "SPN_Name": "Idle Control Request Activation",
      "SPN_Description": "Indicates whether the idle speed request (SPN 8438) should be honored. This parameter does not inhibit or apply to Engine Operator Primary Intermediate Speed Select (SPN 2880).\r\n\r\n00 - Idle speed request is not active\r\n01 - Idle speed request is active\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8441": {
      "PGN": 64555,
      "PGN_Name": "Cruise Control / Vehicle Speed 4",
      "PGN_Description": "CCVS4",
      "first_bit": 32,
      "SPN": 8441,
      "SPN_Name": "Engine External Idle Request  Feedback",
      "SPN_Description": "Indicates that the engine is altering the idle speed due to a request from an external source. \r\n\r\n00 - No Idle Alteration Active - standard idle speed\r\n01 - Idle Alteration Active\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8442": {
      "PGN": 61691,
      "PGN_Name": "Aftertreatment 1 SCR Dosing System Requests 3",
      "PGN_Description": "A1SCRDSR3",
      "first_bit": 16,
      "SPN": 8442,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Doser Valve 1 Command",
      "SPN_Description": "Command (in percent) sent to the diesel exhaust fluid (DEF) injector to control the amount of DEF being injected into the aftreatment exhaust stream.\r\n\r\n0% closes the valve; 100% fully opens the valve.",
      "bit_length": 16,
      "scaling": 0.0025,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 30
    },
    "8443": {
      "PGN": 64483,
      "PGN_Name": "Alternator Temperature 2",
      "PGN_Description": "AT2",
      "first_bit": 0,
      "SPN": 8443,
      "SPN_Name": "Engine Alternator Winding 7 Temperature",
      "SPN_Description": "Temperature of this winding inside the alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8444": {
      "PGN": 64483,
      "PGN_Name": "Alternator Temperature 2",
      "PGN_Description": "AT2",
      "first_bit": 8,
      "SPN": 8444,
      "SPN_Name": "Engine Alternator Winding 8 Temperature",
      "SPN_Description": "Temperature of this winding inside the alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8445": {
      "PGN": 64483,
      "PGN_Name": "Alternator Temperature 2",
      "PGN_Description": "AT2",
      "first_bit": 16,
      "SPN": 8445,
      "SPN_Name": "Engine Alternator Winding 9 Temperature",
      "SPN_Description": "Temperature of this winding inside the alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8446": {
      "PGN": 64483,
      "PGN_Name": "Alternator Temperature 2",
      "PGN_Description": "AT2",
      "first_bit": 24,
      "SPN": 8446,
      "SPN_Name": "Engine Alternator Winding 10 Temperature",
      "SPN_Description": "Temperature of this winding inside the alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8447": {
      "PGN": 64483,
      "PGN_Name": "Alternator Temperature 2",
      "PGN_Description": "AT2",
      "first_bit": 32,
      "SPN": 8447,
      "SPN_Name": "Engine Alternator Winding 11 Temperature",
      "SPN_Description": "Temperature of this winding inside the alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8448": {
      "PGN": 64483,
      "PGN_Name": "Alternator Temperature 2",
      "PGN_Description": "AT2",
      "first_bit": 40,
      "SPN": 8448,
      "SPN_Name": "Engine Alternator Winding 12 Temperature",
      "SPN_Description": "Temperature of this winding inside the alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8449": {
      "PGN": 64483,
      "PGN_Name": "Alternator Temperature 2",
      "PGN_Description": "AT2",
      "first_bit": 48,
      "SPN": 8449,
      "SPN_Name": "Alternator Air Cooler Air Intake Temperature",
      "SPN_Description": "Temperature of air entering the air cooler in an alternator",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8450": {
      "PGN": 64483,
      "PGN_Name": "Alternator Temperature 2",
      "PGN_Description": "AT2",
      "first_bit": 56,
      "SPN": 8450,
      "SPN_Name": "Alternator Air Cooler Air Outlet Temperature",
      "SPN_Description": "Temperature of air after it exits from the air cooler in an alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8451": {
      "PGN": 64482,
      "PGN_Name": "Diode Temperature 1",
      "PGN_Description": "DT1",
      "first_bit": 0,
      "SPN": 8451,
      "SPN_Name": "Power Rectifier Diode 1 Temperature",
      "SPN_Description": "Temperature of this diode used in power rectifier.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8452": {
      "PGN": 64482,
      "PGN_Name": "Diode Temperature 1",
      "PGN_Description": "DT1",
      "first_bit": 8,
      "SPN": 8452,
      "SPN_Name": "Power Rectifier Diode 2 Temperature",
      "SPN_Description": "Temperature of this diode used in power rectifier.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8453": {
      "PGN": 64482,
      "PGN_Name": "Diode Temperature 1",
      "PGN_Description": "DT1",
      "first_bit": 16,
      "SPN": 8453,
      "SPN_Name": "Power Rectifier Diode 3 Temperature",
      "SPN_Description": "Temperature of this diode used in power rectifier.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8454": {
      "PGN": 64482,
      "PGN_Name": "Diode Temperature 1",
      "PGN_Description": "DT1",
      "first_bit": 24,
      "SPN": 8454,
      "SPN_Name": "Power Rectifier Diode 4 Temperature",
      "SPN_Description": "Temperature of this diode used in power rectifier.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8455": {
      "PGN": 64482,
      "PGN_Name": "Diode Temperature 1",
      "PGN_Description": "DT1",
      "first_bit": 32,
      "SPN": 8455,
      "SPN_Name": "Power Rectifier Diode 5 Temperature",
      "SPN_Description": "Temperature of this diode used in power rectifier.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8456": {
      "PGN": 64482,
      "PGN_Name": "Diode Temperature 1",
      "PGN_Description": "DT1",
      "first_bit": 40,
      "SPN": 8456,
      "SPN_Name": "Power Rectifier Diode 6 Temperature",
      "SPN_Description": "Temperature of this diode used in power rectifier.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8457": {
      "PGN": 64482,
      "PGN_Name": "Diode Temperature 1",
      "PGN_Description": "DT1",
      "first_bit": 48,
      "SPN": 8457,
      "SPN_Name": "Power Rectifier Diode 7 Temperature",
      "SPN_Description": "Temperature of this diode used in power rectifier.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8458": {
      "PGN": 64482,
      "PGN_Name": "Diode Temperature 1",
      "PGN_Description": "DT1",
      "first_bit": 56,
      "SPN": 8458,
      "SPN_Name": "Power Rectifier Diode 8 Temperature",
      "SPN_Description": "Temperature of this diode used in power rectifier.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8459": {
      "PGN": 64481,
      "PGN_Name": "Diode Temperature 2",
      "PGN_Description": "DT2",
      "first_bit": 0,
      "SPN": 8459,
      "SPN_Name": "Power Rectifier Diode 9 Temperature",
      "SPN_Description": "Temperature of this diode used in power rectifier.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8460": {
      "PGN": 64481,
      "PGN_Name": "Diode Temperature 2",
      "PGN_Description": "DT2",
      "first_bit": 8,
      "SPN": 8460,
      "SPN_Name": "Power Rectifier Diode 10 Temperature",
      "SPN_Description": "Temperature of this diode used in power rectifier.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8461": {
      "PGN": 64481,
      "PGN_Name": "Diode Temperature 2",
      "PGN_Description": "DT2",
      "first_bit": 16,
      "SPN": 8461,
      "SPN_Name": "Power Rectifier Diode 11 Temperature",
      "SPN_Description": "Temperature of this diode used in power rectifier.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8462": {
      "PGN": 64481,
      "PGN_Name": "Diode Temperature 2",
      "PGN_Description": "DT2",
      "first_bit": 24,
      "SPN": 8462,
      "SPN_Name": "Power Rectifier Diode 12 Temperature",
      "SPN_Description": "Temperature of this diode used in power rectifier.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8463": {
      "PGN": 65191,
      "PGN_Name": "Alternator Temperature 1",
      "PGN_Description": "AT1",
      "first_bit": 40,
      "SPN": 8463,
      "SPN_Name": "Engine Alternator Winding 4 Temperature",
      "SPN_Description": "Temperature of this winding inside the alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8464": {
      "PGN": 65191,
      "PGN_Name": "Alternator Temperature 1",
      "PGN_Description": "AT1",
      "first_bit": 48,
      "SPN": 8464,
      "SPN_Name": "Engine Alternator Winding 5 Temperature",
      "SPN_Description": "Temperature of this winding inside the alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8465": {
      "PGN": 65191,
      "PGN_Name": "Alternator Temperature 1",
      "PGN_Description": "AT1",
      "first_bit": 56,
      "SPN": 8465,
      "SPN_Name": "Engine Alternator Winding 6 Temperature",
      "SPN_Description": "Temperature of this winding inside the alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8466": {
      "PGN": 64480,
      "PGN_Name": "Aftercooler and Oil Cooler Fluids 1",
      "PGN_Description": "ACOCF1",
      "first_bit": 0,
      "SPN": 8466,
      "SPN_Name": "Alternator Oil Cooler Oil Intake Temperature",
      "SPN_Description": "Temperature of lubricant as it enters the oil cooler of an alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8467": {
      "PGN": 64480,
      "PGN_Name": "Aftercooler and Oil Cooler Fluids 1",
      "PGN_Description": "ACOCF1",
      "first_bit": 8,
      "SPN": 8467,
      "SPN_Name": "Alternator Oil Cooler Oil Outlet Temperature",
      "SPN_Description": "Temperature of lubricant after it exits the oil cooler of an alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8468": {
      "PGN": 64480,
      "PGN_Name": "Aftercooler and Oil Cooler Fluids 1",
      "PGN_Description": "ACOCF1",
      "first_bit": 16,
      "SPN": 8468,
      "SPN_Name": "Alternator Oil Cooler Coolant Intake Temperature",
      "SPN_Description": "Temperature of liquid as it enters the oil cooler of an alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8469": {
      "PGN": 64480,
      "PGN_Name": "Aftercooler and Oil Cooler Fluids 1",
      "PGN_Description": "ACOCF1",
      "first_bit": 24,
      "SPN": 8469,
      "SPN_Name": "Alternator Oil Cooler Coolant Outlet Temperature",
      "SPN_Description": "Temperature of liquid after it exits the oil cooler of an alternator.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8470": {
      "PGN": 64480,
      "PGN_Name": "Aftercooler and Oil Cooler Fluids 1",
      "PGN_Description": "ACOCF1",
      "first_bit": 40,
      "SPN": 8470,
      "SPN_Name": "Alternator Aftercooler Coolant Pump Outlet Temperature",
      "SPN_Description": "Temperature of liquid at the aftercooler coolant pump outlet.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8471": {
      "PGN": 64480,
      "PGN_Name": "Aftercooler and Oil Cooler Fluids 1",
      "PGN_Description": "ACOCF1",
      "first_bit": 48,
      "SPN": 8471,
      "SPN_Name": "Alternator Aftercooler Coolant Outlet Temperature",
      "SPN_Description": "Temperature of liquid at the aftercooler outlet.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8472": {
      "PGN": 64480,
      "PGN_Name": "Aftercooler and Oil Cooler Fluids 1",
      "PGN_Description": "ACOCF1",
      "first_bit": 56,
      "SPN": 8472,
      "SPN_Name": "Alternator Aftercooler Coolant Pump Outlet Pressure",
      "SPN_Description": "Pressure of liquid at the aftercooler pump outlet",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "8473": {
      "PGN": 65172,
      "PGN_Name": "Engine Auxiliary Coolant",
      "PGN_Description": "EAC",
      "first_bit": 40,
      "SPN": 8473,
      "SPN_Name": "Engine Coolant Pump Coolant Outlet Pressure",
      "SPN_Description": "Engine coolant pressure at the coolant pump outlet.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "8474": {
      "PGN": 64725,
      "PGN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Pump 1 Information",
      "PGN_Description": "AT1P1I",
      "first_bit": 26,
      "SPN": 8474,
      "SPN_Name": "Aftertreatment 1 Diesel Exhaust Fluid Pump Power Supply",
      "SPN_Description": "State signal which indicates when the aftertreatment 1 Diesel Exhaust Fluid (DEF) pump power output is being driven.  On means the ECU is powering the aftertreatment 1 DEF pump power output.  Note that the ECU is external to the DEF pump.\r\n\r\n00 – Off\r\n01 – On: The ECU is powering the aftertreatment 1 DEF pump power output\r\n10 – Error\r\n11 – Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8475": {
      "PGN": 65238,
      "PGN_Name": "Hybrid System Inputs 1",
      "PGN_Description": "HSI1",
      "first_bit": 24,
      "SPN": 8475,
      "SPN_Name": "Power Electronics Coolant Fill Switch",
      "SPN_Description": "Indicates the coolant fill switch position for the power electronics cooling system.  This switch is used to enable the pump for filling the cooling system.  When the switch is in the On state, the pump is to be running.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8476": {
      "PGN": 65238,
      "PGN_Name": "Hybrid System Inputs 1",
      "PGN_Description": "HSI1",
      "first_bit": 26,
      "SPN": 8476,
      "SPN_Name": "Propulsion Motor Coolant Fill Switch",
      "SPN_Description": "Indicates the coolant fill switch position for the propulsion motor cooling system.  This switch is used to enable the pump for filling the cooling system.  When the switch is in the On state, the pump is to be running.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8477": {
      "PGN": 64479,
      "PGN_Name": "Intake/Exhaust Conditions 3",
      "PGN_Description": "IC3",
      "first_bit": 0,
      "SPN": 8477,
      "SPN_Name": "Engine Mixer 1 Intake Pressure",
      "SPN_Description": "The pressure at the intake of the air and fuel mixer.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "8481": {
      "PGN": 64819,
      "PGN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Supply Information",
      "PGN_Description": "A2DEFSI",
      "first_bit": 42,
      "SPN": 8481,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Pump Power Relay",
      "SPN_Description": "The state of the aftertreatment 2 diesel exhaust fluid pump power relay.\r\n\r\n00 - Not active - No power is being applied to the relay\r\n01 - Active - Power is being applied to the relay\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8483": {
      "PGN": 64698,
      "PGN_Name": "Aftertreatment 2 SCR Electronic Control Module Information",
      "PGN_Description": "A2ECMI",
      "first_bit": 6,
      "SPN": 8483,
      "SPN_Name": "Aftertreatment 2 Diesel Exhaust Fluid Control Module Circuit Breaker",
      "SPN_Description": "The status of the circuit breaker that is used to power the Diesel Exhaust Fluid control module.\r\n\r\n00 - Off\r\n01 - On\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8484": {
      "PGN": 61712,
      "PGN_Name": "Brakes 2",
      "PGN_Description": "B2",
      "first_bit": 0,
      "SPN": 8484,
      "SPN_Name": "Demanded Brake Application Pressure",
      "SPN_Description": "Gage pressure of the compressed air or fluid in the vehicle braking system that is used to apply brake shoes (or pads) against the brake drums (or discs). This is the brake application pressure demanded by the vehicle operator and / or another vehicle system.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "8485": {
      "PGN": 61456,
      "PGN_Name": "Aftertreatment 2 Intake Gas 1",
      "PGN_Description": "AT2IG1",
      "first_bit": 61,
      "SPN": 8485,
      "SPN_Name": "Aftertreatment 2 Intake 2 Gas Sensor Power Supply",
      "SPN_Description": "State signal which indicates when the Aftertreatment 2 Intake 2 Gas Sensor driver output is being driven.  On means the ECU is powering the Aftertreatment 2 Intake 2 Gas Sensor.  Note that the ECU is external to the sensor.\r\n\r\n00 – Off\r\n01 – On: The ECU is powering the Aftertreatment 2 Intake 2 Gas Sensor\r\n10 – Error\r\n11 – Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8486": {
      "PGN": 61457,
      "PGN_Name": "Aftertreatment 2 Outlet Gas 1",
      "PGN_Description": "AT2OG1",
      "first_bit": 61,
      "SPN": 8486,
      "SPN_Name": "Aftertreatment 2 Outlet 2 Gas Sensor Power Supply",
      "SPN_Description": "State signal which indicates when the Aftertreatment 2 Outlet 2 Gas Sensor driver output is being driven.  On means the ECU is powering the Aftertreatment 2 Outlet 2 Gas Sensor.  Note that the ECU is external to the sensor.\r\n\r\n00 – Off\r\n01 – On: The ECU is powering the Aftertreatment 2 Outlet 2 Gas Sensor\r\n10 – Error\r\n11 – Unavailable",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8487": {
      "PGN": 64478,
      "PGN_Name": "Engine Temperature 6",
      "PGN_Description": "ET6",
      "first_bit": 0,
      "SPN": 8487,
      "SPN_Name": "Engine Charge Air Cooler Intake Coolant Temperature",
      "SPN_Description": "Temperature of the fluid in the low temperature circuit measured at the fluid intake of the charge air cooler.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8488": {
      "PGN": 64478,
      "PGN_Name": "Engine Temperature 6",
      "PGN_Description": "ET6",
      "first_bit": 16,
      "SPN": 8488,
      "SPN_Name": "Engine Charge Air Cooler Outlet Coolant Temperature",
      "SPN_Description": "Temperature of the fluid in the low temperature circuit measured at the fluid outlet of the charge air cooler.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8489": {
      "PGN": 64478,
      "PGN_Name": "Engine Temperature 6",
      "PGN_Description": "ET6",
      "first_bit": 32,
      "SPN": 8489,
      "SPN_Name": "Engine Intake Coolant Temperature",
      "SPN_Description": "Temperature of the coolant at the intake of the engine block.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8494": {
      "PGN": 61713,
      "PGN_Name": "Gaseous Fuel Pressure 3",
      "PGN_Description": "GFP3",
      "first_bit": 0,
      "SPN": 8494,
      "SPN_Name": "Engine Fuel Valve 1 Differential Pressure (High Resolution)",
      "SPN_Description": "The differential pressure between the intake and the outlet of the first or only gaseous fuel valve.\r\n\r\nSee SPN 1391 for alternate range and resolution.",
      "bit_length": 16,
      "scaling": 0.0078125,
      "offset": -100,
      "unit": "kPa",
      "SLOT_ID": 431
    },
    "8495": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 0,
      "SPN": 8495,
      "SPN_Name": "Lock Status of Door 11",
      "SPN_Description": "Lock status of bus door 11\r\n\r\n00 - Unlocked \r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8496": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 2,
      "SPN": 8496,
      "SPN_Name": "Open Status of Door 11",
      "SPN_Description": "Open status of bus door 11\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8497": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 4,
      "SPN": 8497,
      "SPN_Name": "Enable Status of Door 11",
      "SPN_Description": "Enable status of bus door 11.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8498": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 6,
      "SPN": 8498,
      "SPN_Name": "Lock Status of Door 12",
      "SPN_Description": "Lock status of bus door 12\r\n\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8499": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 8,
      "SPN": 8499,
      "SPN_Name": "Open Status of Door 12",
      "SPN_Description": "Open status of bus door 12\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8500": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 10,
      "SPN": 8500,
      "SPN_Name": "Enable Status of Door 12",
      "SPN_Description": "Enable status of bus door 12.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8501": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 12,
      "SPN": 8501,
      "SPN_Name": "Lock Status of Door 13",
      "SPN_Description": "Lock status of bus door 13\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8502": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 14,
      "SPN": 8502,
      "SPN_Name": "Open Status of Door 13",
      "SPN_Description": "Open status of bus door 13\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8503": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 16,
      "SPN": 8503,
      "SPN_Name": "Enable Status of Door 13",
      "SPN_Description": "Enable status of bus door 13.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8504": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 18,
      "SPN": 8504,
      "SPN_Name": "Lock Status of Door 14",
      "SPN_Description": "Lock status of bus door 14\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8505": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 20,
      "SPN": 8505,
      "SPN_Name": "Open Status of Door 14",
      "SPN_Description": "Open status of bus door 14\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8506": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 22,
      "SPN": 8506,
      "SPN_Name": "Enable Status of Door 14",
      "SPN_Description": "Enable status of bus door 14.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8507": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 24,
      "SPN": 8507,
      "SPN_Name": "Lock Status of Door 15",
      "SPN_Description": "Lock status of bus door 15\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8508": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 26,
      "SPN": 8508,
      "SPN_Name": "Open Status of Door 15",
      "SPN_Description": "Open status of bus door 15\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8509": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 28,
      "SPN": 8509,
      "SPN_Name": "Enable Status of Door 15",
      "SPN_Description": "Enable status of bus door 15.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8510": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 30,
      "SPN": 8510,
      "SPN_Name": "Lock Status of Door 16",
      "SPN_Description": "Lock status of bus door 16\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8511": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 32,
      "SPN": 8511,
      "SPN_Name": "Open Status of Door 16",
      "SPN_Description": "Open status of bus door 16\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8512": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 34,
      "SPN": 8512,
      "SPN_Name": "Enable Status of Door 16",
      "SPN_Description": "Enable status of bus door 16.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8513": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 36,
      "SPN": 8513,
      "SPN_Name": "Lock Status of Door 17",
      "SPN_Description": "Lock status of bus door 17\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8514": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 38,
      "SPN": 8514,
      "SPN_Name": "Open Status of Door 17",
      "SPN_Description": "Open status of bus door 17\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8515": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 40,
      "SPN": 8515,
      "SPN_Name": "Enable Status of Door 17",
      "SPN_Description": "Enable status of bus door 17.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8516": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 42,
      "SPN": 8516,
      "SPN_Name": "Lock Status of Door 18",
      "SPN_Description": "Lock status of bus door 18\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8517": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 44,
      "SPN": 8517,
      "SPN_Name": "Open Status of Door 18",
      "SPN_Description": "Open status of bus door 18\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8518": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 46,
      "SPN": 8518,
      "SPN_Name": "Enable Status of Door 18",
      "SPN_Description": "Enable status of bus door 18.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8519": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 48,
      "SPN": 8519,
      "SPN_Name": "Lock Status of Door 19",
      "SPN_Description": "Lock status of bus door 19\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8520": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 50,
      "SPN": 8520,
      "SPN_Name": "Open Status of Door 19",
      "SPN_Description": "Open status of bus door 19\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8521": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 52,
      "SPN": 8521,
      "SPN_Name": "Enable Status of Door 19",
      "SPN_Description": "Enable status of bus door 19.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8522": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 54,
      "SPN": 8522,
      "SPN_Name": "Lock Status of Door 20",
      "SPN_Description": "Lock status of bus door 20\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8523": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 56,
      "SPN": 8523,
      "SPN_Name": "Open Status of Door 20",
      "SPN_Description": "Open status of bus door 20\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8524": {
      "PGN": 64477,
      "PGN_Name": "Door Control 3",
      "PGN_Description": "DC3",
      "first_bit": 58,
      "SPN": 8524,
      "SPN_Name": "Enable Status of Door 20",
      "SPN_Description": "Enable status of bus door 20.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8525": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 0,
      "SPN": 8525,
      "SPN_Name": "Lock Status of Door 21",
      "SPN_Description": "Lock status of bus door 21\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8526": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 2,
      "SPN": 8526,
      "SPN_Name": "Open Status of Door 21",
      "SPN_Description": "Open status of bus door 21\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8527": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 4,
      "SPN": 8527,
      "SPN_Name": "Enable Status of Door 21",
      "SPN_Description": "Enable status of bus door 21.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8528": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 6,
      "SPN": 8528,
      "SPN_Name": "Lock Status of Door 22",
      "SPN_Description": "Lock status of bus door 22\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8529": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 8,
      "SPN": 8529,
      "SPN_Name": "Open Status of Door 22",
      "SPN_Description": "Open status of bus door 22\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8530": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 10,
      "SPN": 8530,
      "SPN_Name": "Enable Status of Door 22",
      "SPN_Description": "Enable status of bus door 22.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8531": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 12,
      "SPN": 8531,
      "SPN_Name": "Lock Status of Door 23",
      "SPN_Description": "Lock status of bus door 23\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8532": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 14,
      "SPN": 8532,
      "SPN_Name": "Open Status of Door 23",
      "SPN_Description": "Open status of bus door 23\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8533": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 16,
      "SPN": 8533,
      "SPN_Name": "Enable Status of Door 23",
      "SPN_Description": "Enable status of bus door 23.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8534": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 18,
      "SPN": 8534,
      "SPN_Name": "Lock Status of Door 24",
      "SPN_Description": "Lock status of bus door 24\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8535": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 20,
      "SPN": 8535,
      "SPN_Name": "Open Status of Door 24",
      "SPN_Description": "Open status of bus door 24\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8536": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 22,
      "SPN": 8536,
      "SPN_Name": "Enable Status of Door 24",
      "SPN_Description": "Enable status of bus door 24.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8537": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 24,
      "SPN": 8537,
      "SPN_Name": "Lock Status of Door 25",
      "SPN_Description": "Lock status of bus door 25\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8538": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 26,
      "SPN": 8538,
      "SPN_Name": "Open Status of Door 25",
      "SPN_Description": "Open status of bus door 25\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8539": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 28,
      "SPN": 8539,
      "SPN_Name": "Enable Status of Door 25",
      "SPN_Description": "Enable status of bus door 25.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8540": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 30,
      "SPN": 8540,
      "SPN_Name": "Lock Status of Door 26",
      "SPN_Description": "Lock status of bus door 26\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8541": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 32,
      "SPN": 8541,
      "SPN_Name": "Open Status of Door 26",
      "SPN_Description": "Open status of bus door 26\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8542": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 34,
      "SPN": 8542,
      "SPN_Name": "Enable Status of Door 26",
      "SPN_Description": "Enable status of bus door 26.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8543": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 36,
      "SPN": 8543,
      "SPN_Name": "Lock Status of Door 27",
      "SPN_Description": "Lock status of bus door 27\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8544": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 38,
      "SPN": 8544,
      "SPN_Name": "Open Status of Door 27",
      "SPN_Description": "Open status of bus door 27\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8545": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 40,
      "SPN": 8545,
      "SPN_Name": "Enable Status of Door 27",
      "SPN_Description": "Enable status of bus door 27.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8546": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 42,
      "SPN": 8546,
      "SPN_Name": "Lock Status of Door 28",
      "SPN_Description": "Lock status of bus door 28\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8547": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 44,
      "SPN": 8547,
      "SPN_Name": "Open Status of Door 28",
      "SPN_Description": "Open status of bus door 28\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8548": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 46,
      "SPN": 8548,
      "SPN_Name": "Enable Status of Door 28",
      "SPN_Description": "Enable status of bus door 28.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8549": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 48,
      "SPN": 8549,
      "SPN_Name": "Lock Status of Door 29",
      "SPN_Description": "Lock status of bus door 29\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8550": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 50,
      "SPN": 8550,
      "SPN_Name": "Open Status of Door 29",
      "SPN_Description": "Open status of bus door 29\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8551": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 52,
      "SPN": 8551,
      "SPN_Name": "Enable Status of Door 29",
      "SPN_Description": "Enable status of bus door 29.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8552": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 54,
      "SPN": 8552,
      "SPN_Name": "Lock Status of Door 30",
      "SPN_Description": "Lock status of bus door 30\r\n\n00 - Unlocked\r\n01 - Locked\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8553": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 56,
      "SPN": 8553,
      "SPN_Name": "Open Status of Door 30",
      "SPN_Description": "Open status of bus door 30\r\n\r\n00 - Door closed\r\n01 - Door opened\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8554": {
      "PGN": 64476,
      "PGN_Name": "Door Control 4",
      "PGN_Description": "DC4",
      "first_bit": 58,
      "SPN": 8554,
      "SPN_Name": "Enable Status of Door 30",
      "SPN_Description": "Enable status of bus door 30.  Enabled means the bus doors are able to be automatically opened or closed.\r\n\r\n00 - Door disabled\r\n01 - Door enabled\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8558": {
      "PGN": 64695,
      "PGN_Name": "Hybrid System Status 2",
      "PGN_Description": "HSS2",
      "first_bit": 16,
      "SPN": 8558,
      "SPN_Name": "Hybrid System Engine Stop-Start Remaining Percentage",
      "SPN_Description": "Indicates the remaining percentage of engine stop-start operation allowed by the hybrid system.\r\n\r\nThe calculation of the percentage is manufacturer specific.  It is an operational limitation, not a functional one, meaning the hybrid system could provide additional stop-start as there is no failure, but it is operationally restricted at this point in time to protect the long term life of the hybrid components supporting stop-start operation (e.g. Hybrid  Battery).  100% means that the maximum stop-start operation is available.  0% means no stop-start operation is available.\r\n\r\nPossible uses of this parameter may include optimizing when engine stop should occur (e.g. stopping engine at a longer stop versus a short stop light).",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "8560": {
      "PGN": 61714,
      "PGN_Name": "DC/DC Converter Control ",
      "PGN_Description": "DCDCC",
      "first_bit": 0,
      "SPN": 8560,
      "SPN_Name": "DC/DC Operational Command",
      "SPN_Description": "Command to enable or disable operation.\r\n \r\n0000 - Disable - in this mode all high voltage switching is disabled\r\n0001 - Operate in standby mode; system is waiting for command to enter buck or boost mode\r\n0010 - Operate in buck mode; energy flows from high voltage side to low side\r\n0011 - Operate in boost mode; energy flows from low voltage side to high side\r\n0100 - Reserved\r\n0101 - Reserved\r\n0110 - Reserved\r\n0111 - Reserved\r\n1000 - Reserved\r\n1001 - Reserved\r\n1010 - Reserved\r\n1011 - Reserved\r\n1100 - Reserved\r\n1101 - Reserved\r\n1111 - Don't care/ Take No Action",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8561": {
      "PGN": 61714,
      "PGN_Name": "DC/DC Converter Control ",
      "PGN_Description": "DCDCC",
      "first_bit": 8,
      "SPN": 8561,
      "SPN_Name": "DC/DC Low Side Voltage Buck Setpoint",
      "SPN_Description": "The set point for regulating the low side voltage during buck mode.",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 221
    },
    "8562": {
      "PGN": 61714,
      "PGN_Name": "DC/DC Converter Control ",
      "PGN_Description": "DCDCC",
      "first_bit": 24,
      "SPN": 8562,
      "SPN_Name": "DC/DC High Side Voltage Boost Setpoint",
      "SPN_Description": "The set point for regulating the high side voltage during boost mode.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "8563": {
      "PGN": 64474,
      "PGN_Name": "DC/DC Converter High Side Limits ",
      "PGN_Description": "DCDCHL",
      "first_bit": 0,
      "SPN": 8563,
      "SPN_Name": "DC/DC High Side Voltage Minimum Limit",
      "SPN_Description": "The minimum high side voltage allowed.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "8564": {
      "PGN": 64474,
      "PGN_Name": "DC/DC Converter High Side Limits ",
      "PGN_Description": "DCDCHL",
      "first_bit": 16,
      "SPN": 8564,
      "SPN_Name": "DC/DC High Side Voltage Maximum Limit",
      "SPN_Description": "The maximum high side voltage allowed.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "8565": {
      "PGN": 64474,
      "PGN_Name": "DC/DC Converter High Side Limits ",
      "PGN_Description": "DCDCHL",
      "first_bit": 32,
      "SPN": 8565,
      "SPN_Name": "DC/DC High Side Current Maximum Limit",
      "SPN_Description": "The maximum high side current allowed in or out of the DC/DC Converter.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 250
    },
    "8566": {
      "PGN": 64473,
      "PGN_Name": "DC/DC Converter Low Side Limits ",
      "PGN_Description": "DCDCLL",
      "first_bit": 0,
      "SPN": 8566,
      "SPN_Name": "DC/DC Low Side Voltage Minimum Limit",
      "SPN_Description": "The minimum low side voltage allowed.",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 221
    },
    "8567": {
      "PGN": 64473,
      "PGN_Name": "DC/DC Converter Low Side Limits ",
      "PGN_Description": "DCDCLL",
      "first_bit": 16,
      "SPN": 8567,
      "SPN_Name": "DC/DC Low Side Voltage Maximum Limit",
      "SPN_Description": "The maximum low side voltage allowed.",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 221
    },
    "8568": {
      "PGN": 64473,
      "PGN_Name": "DC/DC Converter Low Side Limits ",
      "PGN_Description": "DCDCLL",
      "first_bit": 32,
      "SPN": 8568,
      "SPN_Name": "DC/DC Low Side Current Maximum Limit",
      "SPN_Description": "The maximum low side current allowed in or out of the DC/DC Converter.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "A",
      "SLOT_ID": 250
    },
    "8569": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 0,
      "SPN": 8569,
      "SPN_Name": "DC/DC Operational Status",
      "SPN_Description": "Operating state of the DC/DC Converter\r\n\r\r\n0000 - Disabled \r\n0001 - Initialization in process.  The device is powering up.  This process may include both internal checks, as well as system checks being run by the DC/DC Converter.\r\n0010 - Operational - Standby\r\n0011 - Operational - Buck mode\r\n0100 - Operational - Boost mode\r\n0101 - Normal power down in process  \r\n0110 - Disabled due to malfunction or protection\r\n0111 - Reserved\r\n1000 - Reserved\r\n1001 - Reserved\r\n1010 - Reserved\r\n1011 - Reserved\r\n1100 - Reserved\r\n1101 - Manufacturer assignable state (only applicable if none of the above apply)\r\n1110 - Error\r\n1111 - Not Available",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8570": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 4,
      "SPN": 8570,
      "SPN_Name": "DC/DC HVIL Status",
      "SPN_Description": "High Voltage Interlock Loop (HVIL) state of the DC/DC Converter.\r\n\r\n00 - HVIL Closed\r\n01 - HVIL Open\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8571": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 6,
      "SPN": 8571,
      "SPN_Name": "DC/DC Loadshed Request",
      "SPN_Description": "The loadshed request is a request to the controlling device to reduce the DC/DC Converter loads.  The Loadshed Requested state is an indication that this DC/DC Converter has a malfunction or is in a limit condition and if the load of the output is not reduced, the DC/DC Converter may take steps to protect itself.  The Loadshed Requested, Shutdown Imminent state is an indication that the loadshed request has not been met and the output may be shutdown in a limited amount of time.\r\r\n\r\n00 - No Loadshed Requested\r\n01 - Loadshed Requested\r\n10 - Loadshed Requested, Shutdown Imminent\r\r\n11 - Don't Care/Take No Action",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8572": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 8,
      "SPN": 8572,
      "SPN_Name": "DC/DC Power Limit due to High Side Current",
      "SPN_Description": "Indicates whether or not output power is being limited due to high side current (see SPN 8588) approaching or exceeding the maximum limit (see SPN 8565).\r\n\r\n00 - No power limit for this reason\r\n01 - Power limited for this reason\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8573": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 10,
      "SPN": 8573,
      "SPN_Name": "DC/DC Power Limit due to Low Side Current",
      "SPN_Description": "Indicates whether or not output power is being limited due to Low side current (see SPN 8586) approaching or exceeding the maximum limit (see SPN 8568).\r\n\r\n00 - No power limit for this reason\r\n01 - Power limited for this reason\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8574": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 12,
      "SPN": 8574,
      "SPN_Name": "DC/DC Power Limit due to High Side Voltage Minimum",
      "SPN_Description": "Indicates whether or not output power is being limited due to High side voltage (see SPN 8587) approaching or falling below the minimum limit (see SPN 8563).\r\n\r\n00 - No power limit for this reason\r\n01 - Power limited for this reason\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8575": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 14,
      "SPN": 8575,
      "SPN_Name": "DC/DC Power Limit due to High Side Voltage Maximum",
      "SPN_Description": "Indicates whether or not output power is being limited due to High side voltage (see SPN 8587) approaching or exceeding the maximum limit (see SPN 8564).\r\n\r\n00 - No power limit for this reason\r\n01 - Power limited for this reason\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8576": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 16,
      "SPN": 8576,
      "SPN_Name": "DC/DC Power Limit due to Low Side Voltage Minimum",
      "SPN_Description": "Indicates whether or not output power is being limited due to Low side voltage (see SPN 8585) approaching or falling below the minimum limit (see SPN 8566).\r\n\r\n00 - No power limit for this reason\r\n01 - Power limited for this reason\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8577": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 18,
      "SPN": 8577,
      "SPN_Name": "DC/DC Power Limit due to Low Side Voltage Maximum",
      "SPN_Description": "Indicates whether or not output power is being limited due to Low side voltage (see SPN 8585) approaching or exceeding the maximum limit (see SPN 8567).\r\n\r\n00 - No power limit for this reason\r\n01 - Power limited for this reason\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8578": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 20,
      "SPN": 8578,
      "SPN_Name": "DC/DC Power Limit due to Controller Temperature",
      "SPN_Description": "Indicates whether or not output power is being limited due to Converter Temperature (see SPN 8592) approaching or exceeding the maximum limit.\r\n\r\n00 - No power limit for this reason\r\n01 - Power limited for this reason\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8579": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 22,
      "SPN": 8579,
      "SPN_Name": "DC/DC Power Limit due to Electronic Filter Temperature",
      "SPN_Description": "Indicates whether or not output power is being limited due to Output Electronic Filter Temperature (see SPN 8693) approaching or exceeding the maximum limit.\r\n\r\n00 - No power limit for this reason\r\n01 - Power limited for this reason\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8580": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 24,
      "SPN": 8580,
      "SPN_Name": "DC/DC Power Limit due to Power Electronics Temperature",
      "SPN_Description": "Indicates whether or not output power is being limited due to Power Electronics Temperature (see SPN 8594) approaching or exceeding the maximum limit.\r\n\r\n00 - No power limit for this reason\r\n01 - Power limited for this reason\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8581": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 26,
      "SPN": 8581,
      "SPN_Name": "DC/DC Power Limit due to SLI Battery Terminal Voltage",
      "SPN_Description": "Indicates whether or not output power is being limited due to the SLI battery terminal voltage (see SPN 8589) approaching or exceeding limits.\r\n\r\n00 - No power limit for this reason\r\n01 - Power limited for this reason\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8582": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 30,
      "SPN": 8582,
      "SPN_Name": "DC/DC Power Limit due to SLI Battery Terminal Temperature",
      "SPN_Description": "Indicates whether or not output power is being limited due to the SLI battery terminal temperature (see SPN 8591) approaching or exceeding limits.\r\n\r\n00 - No power limit for this reason\r\n01 - Power limited for this reason\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8583": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 28,
      "SPN": 8583,
      "SPN_Name": "DC/DC Power Limit due to SLI Battery Terminal Current",
      "SPN_Description": "Indicates whether or not output power is being limited due to the SLI battery terminal current (see SPN 8590) approaching or exceeding limits.\r\n\r\n00 - No power limit for this reason\r\n01 - Power limited for this reason\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8584": {
      "PGN": 61715,
      "PGN_Name": "DC/DC Converter Operating Status ",
      "PGN_Description": "DCDCOS",
      "first_bit": 32,
      "SPN": 8584,
      "SPN_Name": "DC/DC Power Limit due to Undefined Reason",
      "SPN_Description": "Indicates whether or not output power is being limited due to an undefined reason.\r\n\r\n00 - No power limit for this reason\r\n01 - Power limited for this reason\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8585": {
      "PGN": 61716,
      "PGN_Name": "DC/DC Converter Status 1",
      "PGN_Description": "DCDCS1",
      "first_bit": 0,
      "SPN": 8585,
      "SPN_Name": "DC/DC Low Side Voltage",
      "SPN_Description": "Indicates the measured SLI battery or low side voltage measured at the point of control inside the DC/DC Converter.",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 221
    },
    "8586": {
      "PGN": 61716,
      "PGN_Name": "DC/DC Converter Status 1",
      "PGN_Description": "DCDCS1",
      "first_bit": 16,
      "SPN": 8586,
      "SPN_Name": "DC/DC Low Side Current",
      "SPN_Description": "Indicates the measured SLI battery or low side current measured at the point of control inside the DC/DC Converter.  The current is positive if the converter is charging the SLI battery from the hybrid battery.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3212.7,
      "unit": "A",
      "SLOT_ID": 436
    },
    "8587": {
      "PGN": 61716,
      "PGN_Name": "DC/DC Converter Status 1",
      "PGN_Description": "DCDCS1",
      "first_bit": 32,
      "SPN": 8587,
      "SPN_Name": "DC/DC High Side Voltage",
      "SPN_Description": "Indicates the measured HVES or high side voltage measured at the point of control inside the DC/DC Converter.",
      "bit_length": 16,
      "scaling": 0.05,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 80
    },
    "8588": {
      "PGN": 61716,
      "PGN_Name": "DC/DC Converter Status 1",
      "PGN_Description": "DCDCS1",
      "first_bit": 48,
      "SPN": 8588,
      "SPN_Name": "DC/DC High Side Current",
      "SPN_Description": "Indicates the measured HVES or high side current measured at the point of control inside the DC/DC Converter.  The current is negative if the converter is charging the SLI battery from the hybrid battery.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3212.7,
      "unit": "A",
      "SLOT_ID": 436
    },
    "8589": {
      "PGN": 61717,
      "PGN_Name": "DC/DC Converter SLI Battery Status",
      "PGN_Description": "DCDCSBS",
      "first_bit": 0,
      "SPN": 8589,
      "SPN_Name": "DC/DC SLI Battery Terminal Voltage ",
      "SPN_Description": "Parameter indicating the voltage of the SLI battery as measured at the SLI battery terminals.  ",
      "bit_length": 16,
      "scaling": 0.01,
      "offset": 0,
      "unit": "V",
      "SLOT_ID": 221
    },
    "8590": {
      "PGN": 61717,
      "PGN_Name": "DC/DC Converter SLI Battery Status",
      "PGN_Description": "DCDCSBS",
      "first_bit": 16,
      "SPN": 8590,
      "SPN_Name": "DC/DC SLI Battery Terminal Current",
      "SPN_Description": "Parameter indicating the current of the SLI battery as measured at the SLI battery terminals.  \nThe current is positive if the SLI battery or low side voltage source is being charged from the hybrid battery.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": -3212.7,
      "unit": "A",
      "SLOT_ID": 436
    },
    "8591": {
      "PGN": 61717,
      "PGN_Name": "DC/DC Converter SLI Battery Status",
      "PGN_Description": "DCDCSBS",
      "first_bit": 32,
      "SPN": 8591,
      "SPN_Name": "DC/DC SLI Battery Terminal Temperature",
      "SPN_Description": "Parameter indicating the temperature of the SLI battery as measured at the SLI battery.  ",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8592": {
      "PGN": 64472,
      "PGN_Name": "DC/DC Converter Status 3",
      "PGN_Description": "DCDCS3",
      "first_bit": 0,
      "SPN": 8592,
      "SPN_Name": "DC/DC Converter Temperature",
      "SPN_Description": "Parameter indicating the temperature of the DC/DC Converter (e.g, controller, circuit board, enclosure).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8593": {
      "PGN": 64472,
      "PGN_Name": "DC/DC Converter Status 3",
      "PGN_Description": "DCDCS3",
      "first_bit": 8,
      "SPN": 8593,
      "SPN_Name": "DC/DC Converter Electronic Filter Temperature",
      "SPN_Description": "Parameter indicating the temperature of the electronic components that make up the DC/DC Converter filter.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8594": {
      "PGN": 64472,
      "PGN_Name": "DC/DC Converter Status 3",
      "PGN_Description": "DCDCS3",
      "first_bit": 16,
      "SPN": 8594,
      "SPN_Name": "DC/DC Power Electronics Temperature",
      "SPN_Description": "Parameter indicating the temperature of the DC/DC Converter power electronics components (e.g, switch or heatsink).",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8595": {
      "PGN": 28928,
      "PGN_Name": "Configurable Transmit PGNs Command",
      "PGN_Description": "CTPC",
      "first_bit": 0,
      "SPN": 8595,
      "SPN_Name": "Transmit PGNs Commanded Port",
      "SPN_Description": "Identifies the ECU communication port of the target Configurable ECU for this instance of PGN 28928.  The identification of each ECU communication port is ECU specific.  The correlation of ECU communication port to a physical network connection is also ECU specific.  Users of this message need to work with the manufacturer of each target Configurable ECU to understand the communication port assignment for each ECU physical port.\r\n\r\n0000 – Current port (Indicates the ECU communication port through which PGN 28928 is received)\r\n0001 – Port 1\r\n0010 – Port 2\r\n0011 – Port 3\r\n0100 – Port 4\r\n0101 – Port 5\r\n0110 – Port 6\r\n0111 – Port 7\r\n1000 – Port 8\r\n1001 – Port 9\r\n1010 – Port 10\r\n1011 – SAE Reserved\r\n1100 – SAE Reserved\r\n1101 – SAE Reserved\r\n1110 – SAE Reserved\r\n1111 – SAE Reserved",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8596": {
      "PGN": 28928,
      "PGN_Name": "Configurable Transmit PGNs Command",
      "PGN_Description": "CTPC",
      "first_bit": 4,
      "SPN": 8596,
      "SPN_Name": "Transmit PGNs Transaction Mode",
      "SPN_Description": "Identifies the command or action being commanded to the target Configurable ECU of this instance of PGN 28928.\r\n\r\n0000 – Request Port Transmit Status – Identifies the message as a request for the list of configurable transmit PGNs on port the identified in SPN 8595 and their current transmit status.  All bits in SPN 8597 and SPN 8598 shall be set to 1 by the sender and will be ignored by the receiver.\r\n\r\n0001 – Configure Port Transmit State - Identifies the message as a request to configure the transmit behaviors of one or more PGNs on port identified in SPN 8595.  SPN 8597 and SPN 8598 are used to specify the PGN and the desired transmit capability of each PGN.  The sender of this message only needs to include PGNs that are to have their transmit capability changed.  PGNs that are not to have their transmit capability changed do not need to be included in this message.\r\n\r\n0010 – Cancel Pending Changes – Identifies the message as a request to cancel all pending PGN transmit changes for any PGNs on port identified in SPN 8595.   All pending changes shall be cleared and no changes will be made.  All bits in SPN 8597 and SPN 8598 shall be set to 1 by the sender and will be ignored by the receiver.\r\n\r\n0011 – Global Revert to Default –  Identifies the message as a request to reset the transmit behaviors of all PGNs on the port identified in SPN 8595 to their default settings.    All bits in SPN 8597 and SPN 8598 shall be set to 1 by the sender and will be ignored by the receiver.\r\n\r\n0100 –  Partial Revert to Default –  Identifies the message as a request to reset the transmit behaviors to their default settings for the specified list of PGNs on the port identified in SPN 8595.   SPN 8598 for these Configurable Transmit PGNs shall be set to 1 and ignored by the receiver.\r\n  \r\n1011 – SAE Reserved\r\n0101 – SAE Reserved\r\n0110 – SAE Reserved\r\n0111 – SAE Reserved\r\n1000 – SAE Reserved\r\n1001 – SAE Reserved\r\n1010 – SAE Reserved\r\n1011 – SAE Reserved\r\n1100 – SAE Reserved\r\n1101 – SAE Reserved\r\n1110 – SAE Reserved\r\n1111 – SAE Reserved",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8597": {
      "PGN": 28928,
      "PGN_Name": "Configurable Transmit PGNs Command",
      "PGN_Description": "CTPC",
      "first_bit": 16,
      "SPN": 8597,
      "SPN_Name": "Commanded Transmit PGN",
      "SPN_Description": "Identifies the PGN to be acted on by the associated SPN 8598.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 116
    },
    "8598": {
      "PGN": 28928,
      "PGN_Name": "Configurable Transmit PGNs Command",
      "PGN_Description": "CTPC",
      "first_bit": 40,
      "SPN": 8598,
      "SPN_Name": "Commanded Transmit PGN Requested State",
      "SPN_Description": "Identifies the transmit enable state being commanded for the specified PGN on the port identified in SPN 8595.  This parameter is only valid when SPN 8596 is set to ‘Configure Port Transmit State’ (1).  For transaction modes where this parameter is not applicable, this parameter shall be set to 1.\r\n\r\n00 – PGN shall be disabled for transmit\r\n01 – PGN shall be enabled for transmit\r\n10 – SAE Reserved\r\n11 – Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8599": {
      "PGN": 64471,
      "PGN_Name": "Configurable Transmit PGNs Status",
      "PGN_Description": "CTPS",
      "first_bit": 0,
      "SPN": 8599,
      "SPN_Name": "Transmit PGNs Port",
      "SPN_Description": "Identifies the ECU communications port of the responding Configurable ECU that is in context for this instance of PGN 64471.  If changes are accepted by the Configurable ECU, then this is the port affected.  The identification of each ECU communication port is ECU specific.  The correlation of ECU communication port to a physical network connection is ECU specific.  Users of this message need to work with the manufacturer of the transmitting Configurable ECU to understand the port assignment for each physical port.  Port numbering must be the same between this parameter and SPN 8595 in PGN 28928.\r\n\r\n0000 – Current port (Indicates the ECU communication port through which PGN 64471 is transmitted)\r\n0001 – Port 1\r\n0010 – Port 2\r\n0011 – Port 3\r\n0100 – Port 4\r\n0101 – Port 5\r\n0110 – Port 6\r\n0111 – Port 7\r\n1000 – Port 8\r\n1001 – Port 9\r\n1010 – Port 10\r\n1011 – SAE Reserved\r\n1100 – SAE Reserved\r\n1101 – SAE Reserved\r\n1110 – SAE Reserved\r\n1111 – SAE Reserved",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8600": {
      "PGN": 64471,
      "PGN_Name": "Configurable Transmit PGNs Status",
      "PGN_Description": "CTPS",
      "first_bit": 4,
      "SPN": 8600,
      "SPN_Name": "Transmit PGNs Port Pending Changes Status",
      "SPN_Description": "Indicates if there are any pending transmit changes for the specified ECU communication port. \r\n\r\n0 – No pending changes to the transmit status for any supported PGNs for the port identified in SPN 8599.\r\n1 – Transmit changes are pending for one or more supported PGNs on the port identified in SPN 8599.",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8601": {
      "PGN": 64471,
      "PGN_Name": "Configurable Transmit PGNs Status",
      "PGN_Description": "CTPS",
      "first_bit": 5,
      "SPN": 8601,
      "SPN_Name": "Transmit PGNs Port Command Status",
      "SPN_Description": "Indicates the overall success in performing the commanded transaction in PGN 28928.  \r\n\r\n000 – Positive Acknowledgment – PGN 28928 commanded transaction was processed without issue.\r\n001 – \tNegative Acknowledgment – PGN 28928 command was received but one or more transactions were rejected.\r\n010 – No Configurable PGNs exist for the port identified in  SPN 8599.\r\n011 – SAE Reserved\r\n100 – SAE Reserved\r\n101 – SAE Reserved\r\n110 – SAE Reserved\r\n111 – Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "8602": {
      "PGN": 64471,
      "PGN_Name": "Configurable Transmit PGNs Status",
      "PGN_Description": "CTPS",
      "first_bit": 16,
      "SPN": 8602,
      "SPN_Name": "Configurable Transmit PGN",
      "SPN_Description": "Identifies the PGN for which the associated SPNs 8603, 8604, & 8605 apply.",
      "bit_length": 24,
      "scaling": 1,
      "offset": 0,
      "unit": "binary",
      "SLOT_ID": 116
    },
    "8603": {
      "PGN": 64471,
      "PGN_Name": "Configurable Transmit PGNs Status",
      "PGN_Description": "CTPS",
      "first_bit": 40,
      "SPN": 8603,
      "SPN_Name": "Configurable Transmit PGN Current Transmit Status",
      "SPN_Description": "Indicates the current transmit status of the associated PGN on the port identified in SPN 8599.\r\n\r\n00 – PGN is currently configured for transmit on the port identified in SPN 8599.\r\n01 – PGN is not currently configured for transmit on the port identified in SPN 8599.\r\n10 – The PGN transmit capability cannot be modified.\r\n11 – Not Available",
      "bit_length": 1,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 86
    },
    "8604": {
      "PGN": 64471,
      "PGN_Name": "Configurable Transmit PGNs Status",
      "PGN_Description": "CTPS",
      "first_bit": 42,
      "SPN": 8604,
      "SPN_Name": "Configurable Transmit PGN Pending Change Status",
      "SPN_Description": "Indicates if there is a pending change to the transmit capability of the associated PGN on the port identified in SPN 8599.\r\n\r\n00 – Pending transmit change to disable for the port identified in SPN 8599.\r\n01 – Pending transmit change to enable for the port identified in SPN 8599.\r\n10 – No pending transmit change for the port identified in SPN 8599.\r\n11 – Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8605": {
      "PGN": 64471,
      "PGN_Name": "Configurable Transmit PGNs Status",
      "PGN_Description": "CTPS",
      "first_bit": 44,
      "SPN": 8605,
      "SPN_Name": "Configurable Transmit PGN Modified Status",
      "SPN_Description": "Indicates if able to honor the transmit status change request issued in the triggering PGN 28928 message for the associated PGN on the port identified in SPN 8595.  This parameter is reported as '0' only if the received PGN 28928 requested a transmit behavior change to this PGN and the change could not be honored.\r\n\r\n00 – PGN’s transmit status could not be modified\r\n01 – PGN’s transmit status was not requested to be modified\r\n10 – PGN’s transmit status could be modified as requested\r\n11 – Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8607": {
      "PGN": 64479,
      "PGN_Name": "Intake/Exhaust Conditions 3",
      "PGN_Description": "IC3",
      "first_bit": 16,
      "SPN": 8607,
      "SPN_Name": "Engine Mixer 2 Intake Pressure",
      "SPN_Description": "The pressure at the intake of the second air and fuel mixer.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "8608": {
      "PGN": 64971,
      "PGN_Name": "Off-Highway Engine Control Selection",
      "PGN_Description": "OHECS",
      "first_bit": 36,
      "SPN": 8608,
      "SPN_Name": "Engine Operating Mode Command",
      "SPN_Description": "Command signal identifying the desired preconfigured engine operating mode. In some off-highway applications it may be desirable to have multiple preconfigured operating modes available for selection by the operator. Examples would be an economy mode, a ploughing mode or a PTO mode.\r\n\r\n0000 - Not presently requesting a specific Engine Operating Mode be used\r\n0001 - Engine Operating Mode 1 is requested\r\n0010 - Engine Operating Mode 2 is requested\r\n0011 - Engine Operating Mode 3 is requested\r\n0100 - Engine Operating Mode 4 is requested\r\n0101 - Engine Operating Mode 5 is requested\r\n0110 - Engine Operating Mode 6 is requested\r\n0111 - Engine Operating Mode 7 is requested\r\n1000 - Engine Operating Mode 8 is requested\r\n1001 - Engine Operating Mode 9 is requested\r\n1010 - Engine Operating Mode 10 is requested\r\n1011 - Engine Operating Mode 11 is requested\r\n1100 - Engine Operating Mode 12 is requested\r\n1101 - Engine Operating Mode 13 is requested\r\n1110 - SAE Reserved\r\n1111 - Not available / Take no action",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    },
    "8611": {
      "PGN": 65279,
      "PGN_Name": "Operator indicators",
      "PGN_Description": "OI",
      "first_bit": 14,
      "SPN": 8611,
      "SPN_Name": "Water In Charge Air Duct After Charge Air Cooler Indicator",
      "SPN_Description": "Signal which indicates the presence of water in charge air duct after charge air cooler.\r\n\r\n00 - No\r\n01 - Yes\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8612": {
      "PGN": 65279,
      "PGN_Name": "Operator indicators",
      "PGN_Description": "OI",
      "first_bit": 6,
      "SPN": 8612,
      "SPN_Name": "Engine Overloaded Indicator",
      "SPN_Description": "Signal which indicates that the engine is overloaded.\r\n\r\n00 - No\r\n01 - Yes\r\n10 - Error\r\n11 - Not available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8613": {
      "PGN": 61690,
      "PGN_Name": "Electronic Transmission Controller 13",
      "PGN_Description": "ETC13",
      "first_bit": 32,
      "SPN": 8613,
      "SPN_Name": "Source Address of Active or Pending Transmission Requested Gear",
      "SPN_Description": "This parameter indicates the source address of the device whose SPN 525 [Transmission Requested Gear] request is currently being acted upon by the transmission. If transmission response to a device’s SPN 525 request is pending, that device’s source address should be reflected here, even though the pending request may or may not be achieved immediately due to operating conditions. If the transmission does not intend to honor a device’s SPN 525 request, this parameter should not reflect that device’s source address.\r\n\r\nThis parameter is applicable to specific (e.g. “4’) SPN 525 requests, relative (e.g. “Downshift One Gear”) SPN 525  requests, and other parameter specific indicators defined in SPN 525. For example, if a device has requested the transmission to “downshift one gear”, and that shift is pending or the downshift target gear is being actively maintained, this parameter should reflect that device’s source address.\r\n\r\nWhen there is no active SPN 525 request or the transmission does not intend to honor a device’s SPN 525 request, this parameter may be the source address of the ECU transmitting the message [e.g. SA 03 – Transmission #1]. For example, this value would be appropriate in an application that has a mechanical shift selector mechanism, and there are currently no active SPN 525 requests to modify the range being specified via the shift linkage. Note that in vehicles with a J1939-based shift selector, this parameter will most often indicate the source address of the active shift selector [e.g. SA 05 – Primary Shift Console].",
      "bit_length": 8,
      "scaling": 1,
      "offset": 0,
      "unit": "SA",
      "SLOT_ID": 35
    },
    "8614": {
      "PGN": 34560,
      "PGN_Name": "Engine State Requests",
      "PGN_Description": "ESR",
      "first_bit": 42,
      "SPN": 8614,
      "SPN_Name": "Engine Shutdown Command",
      "SPN_Description": "Command to shut down the engine. If this parameter is received as 01, then the engine should behave as if the key switch was turned off. An example of how this parameter could be used is an ECU would send 01 for this parameter if the operator depressed a start/stop pushbutton switch to shut down the engine.\r\n\r\nThis parameter is different from Desired Engine Fueling State (SPN 5793), which is typically associated with automatic engine stop-start functionality that operates during a drive cycle. SPN 8614 would override such functionality, just like turning off the vehicle key switch.\r\n\r\nThis parameter is also different from Engine Auxiliary Shutdown Switch (SPN 970), which is typically associated with secondary or remote shutdown methods, such as might be used in emergency situations. It is possible that applications would use SPN <NEW> as the primary way of shutting down the engine and use SPN 970 as an alternative way of shutting down the engine.\r\n\r\n00 - No command to shut down the engine\r\n01 - Shut down the engine\r\n10 - SAE Reserved\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8619": {
      "PGN": 64470,
      "PGN_Name": "Electronic Engine Controller 21",
      "PGN_Description": "EEC21",
      "first_bit": 0,
      "SPN": 8619,
      "SPN_Name": "Engine Exhaust Manifold Pressure 1",
      "SPN_Description": "Absolute pressure of the exhaust gasses as measured at the engine exhaust manifold, location 1.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "8620": {
      "PGN": 64470,
      "PGN_Name": "Electronic Engine Controller 21",
      "PGN_Description": "EEC21",
      "first_bit": 16,
      "SPN": 8620,
      "SPN_Name": "Engine Exhaust Manifold Pressure 2",
      "SPN_Description": "Absolute pressure of the exhaust gasses as measured at the engine exhaust manifold, location 2.",
      "bit_length": 16,
      "scaling": 0.1,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 85
    },
    "8622": {
      "PGN": 65214,
      "PGN_Name": "Electronic Engine Controller 4",
      "PGN_Description": "EEC4",
      "first_bit": 48,
      "SPN": 8622,
      "SPN_Name": "Engine Prelube Oil Low Pressure Threshold",
      "SPN_Description": "The minimum value that the engine oil pressure (SPN 100 and SPN 7468) must exceed in order to start the engine.\r\n\r\nThis parameter is intended for applications that have an external means of lubricating the engine before starting the engine.",
      "bit_length": 8,
      "scaling": 4,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 47
    },
    "8629": {
      "PGN": 64585,
      "PGN_Name": "Aftertreatment 1 Historical Information 2",
      "PGN_Description": "AT1HI2",
      "first_bit": 192,
      "SPN": 8629,
      "SPN_Name": "Total Aftertreatment Operating Hours",
      "SPN_Description": "Accumulated time of operation of aftertreatment system.  Operating hours are accumulated only when there is air flowing thru the aftertreatment system.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "8630": {
      "PGN": 64523,
      "PGN_Name": "Electronic Engine Controller 20",
      "PGN_Description": "EEC20",
      "first_bit": 16,
      "SPN": 8630,
      "SPN_Name": "Actual Maximum Available Engine - Percent Fuel",
      "SPN_Description": "The percent of torque limited fuel relative to the engine standard torque fuel.  The torque limited fuel in the Actual Maximum Available Engine - Percent Fuel shall take into consideration all engine torque derates (e.g. fault / event derates, various temperature derates, altitude derates, etc.) that are active in the system and number of known inactive cylinders. This does not take into account the air fuel ratio control (AFC) as it is a smoke limiting device that will naturally increase above the torque limits as the boost increases with engine load.\r\n\r\nIf there are no active torque derates, this parameter will be transmitted at 100%.",
      "bit_length": 8,
      "scaling": 0.4,
      "offset": 0,
      "unit": "%",
      "SLOT_ID": 44
    },
    "8635": {
      "PGN": 64469,
      "PGN_Name": "Aftercooler and Oil Cooler Fluids 2",
      "PGN_Description": "ACOCF2",
      "first_bit": 0,
      "SPN": 8635,
      "SPN_Name": "Alternator Bearing Header Intake Pressure",
      "SPN_Description": "Pressure of the lube oil at the intake of alternator bearing header.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "8636": {
      "PGN": 64469,
      "PGN_Name": "Aftercooler and Oil Cooler Fluids 2",
      "PGN_Description": "ACOCF2",
      "first_bit": 8,
      "SPN": 8636,
      "SPN_Name": "Alternator Oil Cooler Discharge Pump Pressure",
      "SPN_Description": "Pressure of the lube oil at the alternator oil cooler discharge pump.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "8637": {
      "PGN": 64469,
      "PGN_Name": "Aftercooler and Oil Cooler Fluids 2",
      "PGN_Description": "ACOCF2",
      "first_bit": 16,
      "SPN": 8637,
      "SPN_Name": "Engine Oil Cooler Discharge Pump Pressure",
      "SPN_Description": "Pressure of the lube oil at engine oil cooler discharge pump.",
      "bit_length": 8,
      "scaling": 2,
      "offset": 0,
      "unit": "kPa",
      "SLOT_ID": 53
    },
    "8638": {
      "PGN": 64469,
      "PGN_Name": "Aftercooler and Oil Cooler Fluids 2",
      "PGN_Description": "ACOCF2",
      "first_bit": 24,
      "SPN": 8638,
      "SPN_Name": "Engine Oil Cooler Intake Temperature",
      "SPN_Description": "Temperature of lube oil at engine cooler intake.",
      "bit_length": 8,
      "scaling": 1,
      "offset": -40,
      "unit": "°C",
      "SLOT_ID": 67
    },
    "8639": {
      "PGN": 65264,
      "PGN_Name": "Power Takeoff Information",
      "PGN_Description": "PTO",
      "first_bit": 62,
      "SPN": 8639,
      "SPN_Name": "Engine PTO Governor Disable Switch",
      "SPN_Description": "Customer or body builder installed switch to prevent operation of engine in PTO mode.\r\n\r\n00 - Off (PTO mode allowed)\r\n01 - On (PTO mode is not allowed)\r\n10 - Error\r\n11 - Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8648": {
      "PGN": 61718,
      "PGN_Name": "Well Stimulation Pump System 3",
      "PGN_Description": "WSP3",
      "first_bit": 0,
      "SPN": 8648,
      "SPN_Name": "Well Stimulation Pump Rod Load",
      "SPN_Description": "The load on the plungers of the well stimulation pump.",
      "bit_length": 16,
      "scaling": 5,
      "offset": 0,
      "unit": "kN",
      "SLOT_ID": 433
    },
    "8649": {
      "PGN": 61718,
      "PGN_Name": "Well Stimulation Pump System 3",
      "PGN_Description": "WSP3",
      "first_bit": 16,
      "SPN": 8649,
      "SPN_Name": "Well Stimulation Pump Cavitation Status",
      "SPN_Description": "Indicates the level of cavitation detected on the well stimulation pump.\r\n\r\n000 – No Cavitation\r\n001 – Low\r\n010 – Medium\r\n011 – High\r\n100 – Reserved\r\n101 – Reserved\r\n110 – Error\r\n111 – Not Available",
      "bit_length": 3,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 88
    },
    "8650": {
      "PGN": 61718,
      "PGN_Name": "Well Stimulation Pump System 3",
      "PGN_Description": "WSP3",
      "first_bit": 24,
      "SPN": 8650,
      "SPN_Name": "Well Stimulation Pump Flow Rate",
      "SPN_Description": "The amount of fluid that is being pumped by the well stimulation pump.",
      "bit_length": 16,
      "scaling": 0.5,
      "offset": 0,
      "unit": "l/min",
      "SLOT_ID": 434
    },
    "8651": {
      "PGN": 61718,
      "PGN_Name": "Well Stimulation Pump System 3",
      "PGN_Description": "WSP3",
      "first_bit": 20,
      "SPN": 8651,
      "SPN_Name": "Well Stimulation Pump Fluid End Valve Leak",
      "SPN_Description": "Indicates the leakage detected in the well stimulation pump fluid end.\r\n\r\n00 – No Leak Detected\r\n01 – Leak Detected\r\n10 – Error\r\n11 – Not Available",
      "bit_length": 2,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 87
    },
    "8652": {
      "PGN": 64468,
      "PGN_Name": "Well Stimulation Pump System Configuration",
      "PGN_Description": "WSPC",
      "first_bit": 0,
      "SPN": 8652,
      "SPN_Name": "Well Stimulation Pump Plunger Diameter",
      "SPN_Description": "The diameter of the well stimulation pump plungers",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "mm",
      "SLOT_ID": 231
    },
    "8653": {
      "PGN": 64468,
      "PGN_Name": "Well Stimulation Pump System Configuration",
      "PGN_Description": "WSPC",
      "first_bit": 16,
      "SPN": 8653,
      "SPN_Name": "Well Stimulation Pump Stroke Length",
      "SPN_Description": "The stroke length of the plunger in a well stimulation pump.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "mm",
      "SLOT_ID": 231
    },
    "8654": {
      "PGN": 64468,
      "PGN_Name": "Well Stimulation Pump System Configuration",
      "PGN_Description": "WSPC",
      "first_bit": 32,
      "SPN": 8654,
      "SPN_Name": "Well Stimulation Pump Gear Ratio",
      "SPN_Description": "Actual ratio of input shaft speed to output shaft speed.",
      "bit_length": 16,
      "scaling": 1,
      "offset": 0,
      "unit": "Ratio",
      "SLOT_ID": 32
    },
    "8655": {
      "PGN": 64468,
      "PGN_Name": "Well Stimulation Pump System Configuration",
      "PGN_Description": "WSPC",
      "first_bit": 48,
      "SPN": 8655,
      "SPN_Name": "Well Stimulation Pump Rated Speed",
      "SPN_Description": "The rated speed of the well stimulation pump.",
      "bit_length": 16,
      "scaling": 0.125,
      "offset": 0,
      "unit": "rpm",
      "SLOT_ID": 76
    },
    "8656": {
      "PGN": 64467,
      "PGN_Name": "Well Stimulation Pump System Lifetime Totals",
      "PGN_Description": "WSPT",
      "first_bit": 0,
      "SPN": 8656,
      "SPN_Name": "Well Stimulation Pump Fluid End Working Hours",
      "SPN_Description": "The accumulated time of operation of the fluid end of the pump while under operating conditions.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "8657": {
      "PGN": 64467,
      "PGN_Name": "Well Stimulation Pump System Lifetime Totals",
      "PGN_Description": "WSPT",
      "first_bit": 32,
      "SPN": 8657,
      "SPN_Name": "Well Stimulation Pump Power End Working Hours",
      "SPN_Description": "The accumulated time of operation of the power end of the pump while under operating conditions.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "8658": {
      "PGN": 64467,
      "PGN_Name": "Well Stimulation Pump System Lifetime Totals",
      "PGN_Description": "WSPT",
      "first_bit": 64,
      "SPN": 8658,
      "SPN_Name": "Well Stimulation Pump Working Hours",
      "SPN_Description": "The accumulated amount of time the Well Stimulation Pump has spent working.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "s",
      "SLOT_ID": 6
    },
    "8659": {
      "PGN": 64467,
      "PGN_Name": "Well Stimulation Pump System Lifetime Totals",
      "PGN_Description": "WSPT",
      "first_bit": 96,
      "SPN": 8659,
      "SPN_Name": "Well Stimulation Pump Cycle Count",
      "SPN_Description": "The total number of cycles on the well stimulation pump. A cycle is defined as a working stage from start to finish.",
      "bit_length": 32,
      "scaling": 1,
      "offset": 0,
      "unit": "count",
      "SLOT_ID": 340
    },
    "8660": {
      "PGN": 64466,
      "PGN_Name": "Pump Oil Message",
      "PGN_Description": "POM",
      "first_bit": 0,
      "SPN": 8660,
      "SPN_Name": "Well Stimulation Pump Oil Viscosity",
      "SPN_Description": "Dynamic viscosity of the well stimulation pump oil.",
      "bit_length": 16,
      "scaling": 0.015625,
      "offset": 0,
      "unit": "Cp",
      "SLOT_ID": 301
    },
    "8661": {
      "PGN": 64466,
      "PGN_Name": "Pump Oil Message",
      "PGN_Description": "POM",
      "first_bit": 16,
      "SPN": 8661,
      "SPN_Name": "Well Stimulation Pump Oil Density",
      "SPN_Description": "Density of the well stimulation pump oil.",
      "bit_length": 16,
      "scaling": 0.00003052,
      "offset": 0,
      "unit": "g/cc",
      "SLOT_ID": 302
    },
    "8662": {
      "PGN": 64466,
      "PGN_Name": "Pump Oil Message",
      "PGN_Description": "POM",
      "first_bit": 32,
      "SPN": 8662,
      "SPN_Name": "Well Stimulation Pump Oil Relative Dielectricity",
      "SPN_Description": "Well stimulation pump oil relative dielectricity used to describe the well stimulation pump oil quality.",
      "bit_length": 16,
      "scaling": 0.0001220703125,
      "offset": 0,
      "unit": null,
      "SLOT_ID": 307
    },
    "8663": {
      "PGN": 64466,
      "PGN_Name": "Pump Oil Message",
      "PGN_Description": "POM",
      "first_bit": 48,
      "SPN": 8663,
      "SPN_Name": "Well Stimulation Pump Oil Temperature",
      "SPN_Description": "Temperature of the well stimulation pump lubricant.",
      "bit_length": 16,
      "scaling": 0.03125,
      "offset": -273,
      "unit": "°C",
      "SLOT_ID": 68
    },
    "8664": {
      "PGN": 64967,
      "PGN_Name": "Off-Highway Engine Control Selection States",
      "PGN_Description": "OHCSS",
      "first_bit": 36,
      "SPN": 8664,
      "SPN_Name": "Engine Operating Mode Selection",
      "SPN_Description": "Identifies the current engine operating mode. In some off-highway applications it may be desirable to have multiple preconfigured operating modes available for selection by the operator. Examples would be an economy mode, a plowing mode or a PTO mode. \r\n\r\n0000 - Engine not operating in a specific Engine Operating Mode\r\n0001 - Engine Operating Mode 1 is selected\r\n0010 - Engine Operating Mode 2 is selected\r\n0011 - Engine Operating Mode 3 is selected\r\n0100 - Engine Operating Mode 4 is selected\r\n0101 - Engine Operating Mode 5 is selected\r\n0110 - Engine Operating Mode 6 is selected\r\n0111 - Engine Operating Mode 7 is selected\r\n1000 - Engine Operating Mode 8 is selected\r\n1001 - Engine Operating Mode 9 is selected\r\n1010 - Engine Operating Mode 10 is selected\r\n1011 - Engine Operating Mode 11 is selected\r\n1100 - Engine Operating Mode 12 is selected\r\n1101 - Engine Operating Mode 13 is selected\r\n1110 - Error\r\n1111 - Not available / Take no action",
      "bit_length": 4,
      "scaling": 1,
      "offset": 0,
      "unit": "bit",
      "SLOT_ID": 89
    }
  }